/*! buildTime: 2023-11-15T06:17:34.796Z */
;(function(){
(function () {
    // 深冻结函数.
    function deepFreeze(obj) {
        // 取回定义在obj上的属性名
        var propNames = Object.getOwnPropertyNames(obj);

        // 在冻结自身之前冻结属性
        propNames.forEach(function (name) {
            var prop = obj[name];

            // 如果prop是个对象，冻结它
            if (typeof prop === 'object' && prop !== null) deepFreeze(prop);
        });

        // 冻结自身(no-op if already frozen)
        return Object.freeze(obj);
    }
    if (typeof window.epoint_local === 'object') {
        return;
    }

    window.epoint_local = deepFreeze({
        locale: 'zh_CN',
        epoint: '国泰新点软件股份有限公司',
        search_trigger: '高级搜索',
        search_text: '搜索',
        search_title: '展开更多条件',
        reset_text: '重置',
        close_text: '关闭',
        selected_text: '已选条件',
        upload_text: '上传',
        delete_text: '删除',
        more_text: '更多',
        retry_text: '重试',
        preview_text: '预览',
        edit_text: '编辑',
        remove_text: '移除',
        error_tip: '错误提示',
        warning_tip: '警告提示',
        validate_failed: '验证失败',
        default_error_message: '有字段验证未通过，请再检查一下！',
        empty_beginning_text: '请输入',
        no_longer_tips: '不再提示',
        back_to_top_text: '返回顶部',
        remove_all_text: '移除全部',
        helper_text: '帮助提醒',
        ajax_error_text: '请求出现异常，请联系管理员',
        detail_text: '详情',
        service_error_text: '服务不可用',
        success_text: '成功',
        failed_text: '失败',
        operate_text: '操作',
        click_to_sort_text: '点击排序',
        click_to_filter_text: '点击过滤',
        all_text: '全部',
        save_text: '保存',
        order_text: '序',
        select_text: '选择',
        loadingMsg: '数据加载中，请稍后...',
        dateInfo: {
            monthsLong: [
                '一月',
                '二月',
                '三月',
                '四月',
                '五月',
                '六月',
                '七月',
                '八月',
                '九月',
                '十月',
                '十一月',
                '十二月'
            ],
            monthsShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
            daysLong: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
            daysShort: ['日', '一', '二', '三', '四', '五', '六'],
            quarterLong: ['一季度', '二季度', '三季度', '四季度'],
            quarterShort: ['Q1', 'Q2', 'Q2', 'Q4'],
            halfYearLong: ['上半年', '下半年'],
            patterns: {
                d: 'yyyy-M-d',
                D: 'yyyy年M月d日',
                f: 'yyyy年M月d日 H:mm',
                F: 'yyyy年M月d日 H:mm:ss',
                g: 'yyyy-M-d H:mm',
                G: 'yyyy-M-d H:mm:ss',
                m: 'MMMd日',
                o: 'yyyy-MM-ddTHH:mm:ss.fff',
                s: 'yyyy-MM-ddTHH:mm:ss',
                t: 'H:mm',
                T: 'H:mm:ss',
                U: 'yyyy年M月d日 HH:mm:ss',
                y: 'yyyy年MM月'
            },
            tt: {
                AM: '上午',
                PM: '下午'
            },
            ten: {
                Early: '上旬',
                Mid: '中旬',
                Late: '下旬'
            },
            today: '今天',
            clockType: 24
        },
        culture: {
            name: 'zh-CN',
            numberFormat: {
                number: {
                    pattern: ['n', '-n'],
                    decimals: 2,
                    decimalsSeparator: '.',
                    groupSeparator: ',',
                    groupSize: [3]
                },
                percent: {
                    pattern: ['n%', '-n%'],
                    decimals: 2,
                    decimalsSeparator: '.',
                    groupSeparator: ',',
                    groupSize: [3],
                    symbol: '%'
                },
                currency: {
                    pattern: ['$n', '$-n'],
                    decimals: 2,
                    decimalsSeparator: '.',
                    groupSeparator: ',',
                    groupSize: [3],
                    symbol: '¥'
                }
            }
        },
        VTypes: {
            minDateErrorText: '不能小于日期 {0}',
            maxDateErrorText: '不能大于日期 {0}',

            uniqueErrorText: '字段不能重复',
            requiredErrorText: '不能为空',
            emailErrorText: '请输入邮件格式',
            urlErrorText: '请输入URL格式',
            floatErrorText: '请输入数字',
            intErrorText: '请输入整数',
            dateErrorText: '请输入日期格式 {0}',
            maxLengthErrorText: '不能超过 {0} 个字符',
            minLengthErrorText: '不能少于 {0} 个字符',
            maxErrorText: '数字不能大于 {0} ',
            minErrorText: '数字不能小于 {0} ',
            rangeLengthErrorText: '字符长度必须在 {0} 到 {1} 之间',
            rangeCharErrorText: '字符数必须在 {0} 到 {1} 之间',
            rangeErrorText: '数字必须在 {0} 到 {1} 之间',

            mobileErrorText: '输入的手机号码格式不正确',
            telErrorText: '输入的固定电话号码格式不正确',
            phoneErrorText: '输入的电话号码格式不正确',
            phoneWithShortNumErrorText: '输入的电话号码格式不正确',
            postCodeErrorText: '输入的邮政编码格式不正确',
            orgCodeErrorText: '输入的组织机构代码格式不正确',
            creditCodeErrorText: '输入的统一社会信用代码格式不正确',
            idCardErrorText: '输入的身份证号码格式不正确，若最后一位为“X”则只允许输入大写的“X”',
            decimalLengthErrorText: '请输入数字，且最多只能输入{0}位小数',
            projectCodeErrorText: '输入的投资项目统一代码格式不正确',

            positiveNumberErrorText: '数字不能小于等于0'
        },
        Notice: {
            buttonText: {
                ok: '确定',
                cancel: '取消',
                yes: '是',
                no: '否'
            }
        },
        WebUploaderUI: {
            uploadErrorText: '上传出错!',
            cantPreviewAlert: '此文件不能预览！',
            filePreviewTitle: '文件预览',
            cantEditAlert: '文件还未上传，不能编辑！',
            fileEditTitle: '文件编辑'
        },
        MessageBox: {
            alertTitle: '提醒',
            confirmTitle: '确认',
            deleteConfirmTitle: '删除确认',
            deleteConfirmTpl: '删除后不可恢复，请输入%s确认',
            confirmErrorText: '输入内容不匹配',
            prompTitle: '输入',
            prompMessage: '请输入内容：',
            buttonText: {
                ok: '确定', //'OK',
                cancel: '取消', //'Cancel',
                yes: '是', //'Yes',
                no: '否', //'No'
                confirmDelete: '确定删除'
            }
        },
        ValidatorBase: {
            requiredErrorText: '不能为空'
        },
        Calendar: {
            firstDayOfWeek: 0,
            yesterdayText: '昨天',
            todayText: '今天',
            clearText: '清除',
            okText: '确定',
            cancelText: '取消',
            daysShort: ['日', '一', '二', '三', '四', '五', '六'],
            format: 'yyyy年MM月',

            timeFormat: 'H:mm'
        },
        Pager: {
            firstText: '首页',
            prevText: '上一页',
            nextText: '下一页',
            lastText: '尾页',
            reloadText: '刷新',
            pageInfoText: '每页 {0} 条, 共 {1} 条'
        },
        Pagination: {
            pageInfoText: '共{0}条',
            jumpText: '跳至<input class="pagination-number"  value="{0}"/>页',
            sizeText: '条/页'
        },
        DataGrid: {
            emptyText: '没有数据',
            notSelectedTip: '请选择一条记录！',
            confirmDeleteTip: '确定删除选中记录？',
            confirmTitle: '系统提示',
            waitingText: '操作中，请稍后......',
            deleteSuccessfulText: '删除成功',
            deleteFailedText: '删除失败'
        },
        WebUploader: {
            pickerText: '选择文件',
            startText: '开始上传',
            pauseText: '暂停上传',
            batchDownloadText: '下载全部',
            numLimitErrorText: '选择的文件过多！</br>最多可上传{0}个文件',
            sizeLimitErrorText: '选择的文件过大！</br>最多可上传{0}KB文件',
            typeDeniedErrorText: '选择的文件类型错误！</br>可上传的文件类型为：{0}',
            sizeErrorText: '选择的文件过大！</br>可上传的单文件最大为{0}KB',
            emptyFileErrorText: '不能上传空文件！',
            duplicateErrorText: '不能上传重复的文件！',
            uploadErrorText: '上传失败！请重新上传！',
            secrecyLevelSaveErrorText: '保密等级保存失败！请重试',
            dndPlaceholderText: '此区域可拖拽放置上传',
            noflashInnerHTML:
                '<a class="noflash" title="要使用上传功能，请下载安装Falsh后，刷新页面" href="http://get.adobe.com/flashplayer/" target="_blank">初始化错误</a>',
            noflashPageWarning:
                '检测到您的系统未安装Flash，上传功能不可用。请<a href="http://get.adobe.com/flashplayer/" target="_blank">下载安装Falsh</a>后，刷新页面'
        },
        DataExport: {
            expandText: '导出',
            collapseText: '导出',
            exportText: '导 出',
            panelTitle: '导出列配置',
            leftListTitle: '待选列',
            rightListTitle: '已选列',
            tipInfo: '不填页码即导出当前页',
            fromText: '从第',
            pageNumInfo: '页导出到第',
            pageText: '页',
            exportModelText: '导出为模板',
            selectExportText: '仅导出选中行',
            allExportText: '导出全部',
            curPageExportText: '导出当前页'
        },
        AutoComplete: {
            popupEmptyText: '无搜索结果',
            loadingText: '加载中...',
            errorText: '错误'
        },
        HtmlFile: {
            buttonText: '浏览...',
            limitTypeErrorText: '上传文件格式为:'
        },
        CatalogImport: {
            pickerText: '导入文件',
            deleteText: '删除',
            uploadingText: '正在上传',
            validateText: '校验结果',
            resultTpl: '总计：{{0}}条，成功：{{1}}，失败：{{2}}条。',
            expandText: '展开详情',
            importResultText: '导入结果',
            importErrorText: '数据导入失败，请重试！',
            importSuccessText: '导入已完成',
            exportText: '校验结果导出'
        },
        Cropper: {
            title: '裁剪',
            imageSizeText: '图片尺寸',
            selectImgText: '选择图片',
            onlinePhotoText: '在线拍照',
            previewText: '预览',
            reselectText: '重新选择',
            finishText: '完成',
            cancelText: '取消',
            validateText: '请选择有效的图片文件',
            imageSizeAlertText: '图片不能超过 ',
            noImageAlert: '请选择图片或在线拍照'
        },
        DataImport: {
            pickerText: '导入文件',
            expandText: '展开详情',
            collapseText: '收起详情',
            continueImportTip: '上次导入中断，修改完后继续导入',
            continueText: '继续导入',
            retryText: '重新导入',
            retryTip: '重新尝试导入这个文件',
            viewDetailText: '查看详情',
            validateText: '校验结果',
            resultTpl: '总计：{{0}}条，成功：{{1}}，失败：{{2}}条。',
            importResultText: '导入结果',
            importFailAlert: '数据导入失败，请重试！',
            importSuccessText: '导入已完成'
        },
        DistrictPicker: {
            emptyText: '请输入或选择地区',
            selectText: '请选择'
        },
        FilterTree: {
            emptyText: '请输入内容查询'
        },
        ImageUploader: {
            deleteAlert: '确定移除此图片？',
            deleteAlertTitle: '删除提醒',
            typeErrorAlert: '选择的文件类型错误',
            typeAcceptedText: '可上传的文件类型为',
            imageCountAlert: '你选择的图片文件过多，只能选择一个',
            imageNameLengthAlert: '选中的图片文件名不能超过{{0}}个字符',
            imageSizeAlert: '选中的图片文件过大，最大允许上传{{0}}KB的图片',
            imageWidthAlert: '宽度为{{0}}px',
            imageHeightAlert: '高度为{{0}}px',
            imageMeasureAlert: '图片宽高校验失败，只允许上传{{0}}的图片',
            fileCountAlert: '您选择的图片过多，最多上传 {{0}} 张图片'
        },
        LargeFileUploader: {
            pickerText: '选择文件',
            startText: '开始上传',
            pauseText: '暂停上传',
            numLimitErrorText: '选择的文件过多！</br>最多可上传{0}个文件',
            sizeLimitErrorText: '选择的文件过大！</br>最多可上传{0}KB文件',
            typeDeniedErrorText: '选择的文件类型错误！</br>可上传的文件类型为：{0}',
            sizeErrorText: '选择的文件过大！</br>可上传的单文件最大为{0}KB',
            emptyFileErrorText: '不能上传空文件！',
            epointUserText: '国泰新点用户',
            ntkoLoadErrorText: '不能装载NTKO大文件上传控件',
            deleteFileConfirmText: '确定删除文件？',
            systemTipText: '系统提示',
            ntkoInitErrorTitle: '不能装载NTKO大文件上传控件。请确保使用IE浏览器，并检查浏览器的安全设置。',
            ntkoInitErrorText: '初始化错误',
            ntkoErrorCheckBrowserText: '不能装载NTKO大文件上传控件。请确保使用IE浏览器，并检查浏览器的安全设置',
            analyzingText: '正在分析文件',
            uploadedText: '已上传',
            uploadFailedText: '上传失败！请重新上传！',
            uploadErrorText: '上传出错！'
        },
        DateRangePicker: {
            footTipText: '注：点击某日期两次代表选择某一天',
            quickSelectText: {
                thisWeek: '本周',
                thisMonth: '本月',
                thisQuarter: '本季度',
                thisYear: '本年'
            }
        },
        MonthRangePicker: {
            footTipText: '注：点击某月份两次代表选择某一月',
            quickSelectText: {
                thisMonth: '本月',
                thisQuarter: '本季度',
                thisYear: '本年'
            }
        },
        QuarterPicker: {
            itemText: ['第1季度', '第2季度', '第3季度', '第4季度'],
            yearText: '年',
            clearText: '清除',
            okText: '确定'
        },
        QuarterRangePicker: {
            footTipText: '注：点击某季度两次代表选择某一季度'
        },
        TabsTreeSelect: {
            selectedPanelTitle: '已选人员',
            actionTitles: {
                sort: '一键排序',
                top: '置顶',
                bottom: '置底',
                remove: '删除',
                removeall: '删除全部',
                recover: '回到初始状态'
            },

            sortTitles: {
                none: '一键排序',
                asc: '正序',
                desc: '倒序'
            }
        },
        VerifyCode: {
            changeAnotherText: '看不清楚，换一个？'
        }
    });
})();

if (!('previousElementSibling' in Element.prototype)) {
    Object.defineProperty(Element.prototype, 'previousElementSibling', {
        get: function () {
            var el = this.previousSibling;
            while (el && el.nodeType !== 1) {
                el = el.previousSibling;
            }
            return el;
        }
    });
}
if (!('nextElementSibling' in Element.prototype)) {
    Object.defineProperty(Element.prototype, 'nextElementSibling', {
        get: function () {
            var el = this.nextSibling;
            while (el && el.nodeType !== 1) {
                el = el.nextSibling;
            }
            return el;
        }
    });
}

/**
 * jQuery MiniUI v3.0
 *
 * Copyright(c) 2012 All Rights Reserved. Shanghai PusSoft Co., Ltd (上海普加软件有限公司) [ services@plusoft.com.cn ].
 *
 */

mini = {
    components: {},
    uids: {},
    ux: {},
    doc: document,
    window: window,

    isReady: false,

    locale: epoint_local.locale,

    createTime: new Date(),

    byClass: function (cls, el) {
        //getElementsByClassName
        if (typeof el == 'string') el = mini.byId(el);
        return jQuery('.' + cls, el)[0];
    },
    getComponents: function () {
        var cs = [];
        for (var id in mini.components) {
            var c = mini.components[id];
            if (c.isControl) {
                cs.push(c);
            }
        }
        return cs;
    },
    get: function (id) {
        if (!id) return null;
        if (mini.isControl(id)) return id;
        if (typeof id == 'string') {
            if (id.charAt(0) == '#') id = id.substr(1);
        }
        if (typeof id == 'string') return mini.components[id];
        else {
            var control = mini.uids[id.uid];
            if (control && control.el == id) return control;
        }
        return null;
    },
    getbyUID: function (uid) {
        return mini.uids[uid];
    },
    findControls: function (fn, scope) {
        if (!fn) return [];
        scope = scope || mini;
        var controls = [];
        var uids = mini.uids;
        for (var uid in uids) {
            var control = uids[uid];
            var ret = fn.call(scope, control);
            if (ret === true || ret === 1) {
                controls.push(control);
                if (ret === 1) break;
            }
        }
        return controls;
    },
    getChildControls: function (parent) {
        var pel = parent.el ? parent.el : parent;
        var controls = mini.findControls(function (control) {
            if (!control.el || parent == control) return false;
            if (mini.isAncestor(pel, control.el) && control.within) return true;
            return false;
        });
        return controls;
    },
    emptyFn: function () {},
    //遍历控件内部，将所有子控件，通过this._name的方式映射到控件对象上
    //pre为true，表示首字母大写
    createNameControls: function (obj, pre) {
        if (!obj || !obj.el) return;
        if (!pre) pre = '_';
        var el = obj.el;
        var controls = mini.findControls(function (control) {
            if (!control.el || !control.name) return false;
            if (mini.isAncestor(el, control.el)) return true;
            return false;
        });

        for (var i = 0, l = controls.length; i < l; i++) {
            var c = controls[i];
            var name = pre + c.name;
            if (pre === true) {
                name = c.name[0].toUpperCase() + c.name.substring(1, c.name.length);
            }
            obj[name] = c;
        }
    },

    getsByName: function (name, parentNode) {
        return mini.getsbyName(name, parentNode);
    },

    getsbyName: function (name, parentNode) {
        var isControl = mini.isControl(parentNode);
        var parentControl = parentNode;
        if (parentNode && isControl) {
            parentNode = parentNode.el;
        }
        parentNode = mini.byId(parentNode);
        parentNode = parentNode || document.body;
        var controls = mini.findControls(function (control) {
            if (!control.el) return false;
            if (control.name == name && mini.isAncestor(parentNode, control.el)) return true;
            return false;
        }, this);

        if (isControl && controls.length == 0 && parentControl && parentControl.getbyName) {
            var obj = parentControl.getbyName(name);
            if (obj) controls.push(obj);
        }

        return controls;
    },
    getbyName: function (name, parentNode) {
        return mini.getsbyName(name, parentNode)[0];
    },

    getByName: function (name, parentNode) {
        return mini.getbyName(name, parentNode);
    },

    getParams: function (url) {
        if (!url) url = location.href;
        url = url.split('?')[1];
        var params = {};
        if (url) {
            var us = url.split('&');
            for (var i = 0, l = us.length; i < l; i++) {
                var ps = us[i].split('=');
                //params[ps[0]] = decodeURIComponent(ps[1]);
                try {
                    params[ps[0]] = decodeURIComponent(unescape(ps[1]));
                } catch (ex) {}
            }
        }
        return params;
    },

    reg: function (cmp) {
        this.components[cmp.id] = cmp;
        this.uids[cmp.uid] = cmp;
        //cmp.type = cmp.constructor
    },
    unreg: function (cmp) {
        delete mini.components[cmp.id];
        delete mini.uids[cmp.uid];

        //        mini.components[cmp.id] = null;
        //        mini.uids[cmp.uid] = null;
    },

    classes: {},
    uiClasses: {},
    getClass: function (className) {
        if (!className) return null;
        return this.classes[className.toLowerCase()];
    },
    getClassByUICls: function (uiCls) {
        return this.uiClasses[uiCls.toLowerCase()];
    },

    idPre: 'mini-',
    idIndex: 1,
    newId: function (idPre) {
        return (idPre || this.idPre) + this.idIndex++;
    },

    copyTo: function (to, from) {
        if (to && from) {
            for (var p in from) {
                to[p] = from[p];
            }
        }
        return to;
    },
    copyIf: function (to, from) {
        if (to && from) {
            for (var p in from) {
                if (mini.isNull(to[p])) {
                    to[p] = from[p];
                }
            }
        }
        return to;
    },
    createDelegate: function (fn, scope) {
        if (!fn) return function () {};
        return function () {
            return fn.apply(scope, arguments);
        };
    },

    isControl: function (obj) {
        return !!(obj && obj.isControl);
    },
    isElement: function (obj) {
        return obj && obj.appendChild;
    },
    isDate: function (value) {
        return !!(value && value.getFullYear);
    },
    isArray: function (value) {
        return !!(value && !!value.unshift);
    },
    isNull: function (value) {
        return value === null || value === undefined;
    },

    isNumber: function (value) {
        return !isNaN(value) && typeof value == 'number';
    },
    isEquals: function (a, b) {
        //null, undefined
        if (a !== 0 && b !== 0) {
            if ((mini.isNull(a) || a == '') && (mini.isNull(b) || b == '')) return true;
        }
        //date
        if (a && b && a.getFullYear && b.getFullYear) return a.getTime() === b.getTime();
        //Object
        if (typeof a == 'object' && typeof b == 'object') {
            return a === b;
        }
        //common
        return String(a) === String(b);
    },
    forEach: function (array, method, scope) {
        var list = array.clone();
        for (var i = 0, l = list.length; i < l; i++) {
            var o = list[i];
            if (method.call(scope, o, i, array) === false) break;
        }
    },
    sort: function (array, fn, scope) {
        scope = scope || array;
        //array.sort(fn);           //chrome sort超过20个数字有bug
        //alert(1);
        // 冒泡排序

        function sort(array, func) {
            var i = 0,
                len = array.length,
                j,
                d;
            for (; i < len; i++) {
                for (j = i; j < len; j++) {
                    var a = array[i],
                        b = array[j];
                    var r = func(a, b);
                    if (r > 0) {
                        //对象排序，保持原始顺序，必须要Insert, remove
                        array.removeAt(j);
                        array.insert(i, b);

                        // 这个适合数字排序
                        //                        d = array[j];
                        //                        array[j] = array[i];
                        //                        array[i] = d;
                    }
                }
            }
            return array;
        }

        sort(array, fn);
    },
    ////////////////////////////

    elWarp: document.createElement('div')
    //    ,
    //    createElement: function (html) {
    //        html = html.trim();
    //        this.elWarp.innerHTML = html;
    //        var el = this.elWarp.firstChild;
    //        this.elWarp.removeChild(el);
    //        return el;
    //    }
};

if (typeof mini_debugger == 'undefined') {
    mini_debugger = true;
}
if (typeof mini_useShims == 'undefined') {
    mini_useShims = false;
}
if (typeof mini_ajaxAsyncInvoke == 'undefined') {
    mini_ajaxAsyncInvoke = true; //ie11下，如果post + data + setTimeout 异步调用，会有诡异问题
}

//mini.getbyDom = function (dom) {
//    var controls = mini.getComponents();
//    for (var i = 0, l = controls.length; i < l; i++) {
//        var c = controls[i];
//        if(e.el && mini.isAn
//    }
//}

mini_regClass = function (clazz, className) {
    className = className.toLowerCase();
    if (!mini.classes[className]) {
        mini.classes[className] = clazz;
        clazz.prototype.type = className;
    }
    var uiCls = clazz.prototype.uiCls;
    if (!mini.isNull(uiCls) && !mini.uiClasses[uiCls]) {
        mini.uiClasses[uiCls] = clazz;
    }
};
mini_extend = function (newClass, sp, overrides) {
    if (typeof sp != 'function') return this;

    var sb = newClass,
        sbp = sb.prototype,
        spp = sp.prototype;
    if (sb.superclass == spp) return;
    sb.superclass = spp;
    sb.superclass.constructor = sp;

    for (var p in spp) {
        sbp[p] = spp[p];
    }
    if (overrides) {
        for (var p in overrides) {
            sbp[p] = overrides[p];
        }
    }
    return sb;
};
mini_isInstanceOf = function (instance, constructor) {
    if (!mini.isControl(instance) || !(constructor && mini.isControl(constructor.prototype))) {
        return instance instanceof constructor;
    }

    if (instance.constructor === constructor) {
        return true;
    }

    var superclass = instance.constructor.superclass;
    if (superclass === undefined) {
        return false;
    }

    return mini_isInstanceOf(superclass, constructor);
};
//mini_extend = function (subClass, superClass, overrides) {

//    var F = function () { };
//    F.prototype = superClass.prototype;
//    var fn = subClass.prototype = new F();

//    if (overrides) {
//        for (var prop in overrides) {
//            fn[prop] = overrides[prop];
//        }
//    }

//    subClass.superclass = superClass.prototype;
//    subClass.superclass.constructor = superClass;

//    return subClass;
//}
mini.copyTo(mini, {
    extend: mini_extend,
    regClass: mini_regClass,
    isInstanceOf: mini_isInstanceOf,
    debug: false
});

mini.namespace = function (names) {
    if (typeof names != 'string') return;
    names = names.split('.');
    var parent = window;
    for (var i = 0, l = names.length; i < l; i++) {
        var name = names[i];
        var obj = parent[name];
        if (!obj) {
            obj = parent[name] = {};
        }
        parent = obj;
    }
};

mini._BindCallbacks = [];
mini._BindEvents = function (fn, scope) {
    mini._BindCallbacks.push([fn, scope]);
    if (!mini._EventTimer) {
        mini._EventTimer = setTimeout(function () {
            mini._FireBindEvents();
        }, 50);
    }
};
mini._FireBindEvents = function () {
    for (var i = 0, l = mini._BindCallbacks.length; i < l; i++) {
        var e = mini._BindCallbacks[i];
        e[0].call(e[1]);
    }
    mini._BindCallbacks = [];
    mini._EventTimer = null;
};

mini._getFunctoin = function (fnName) {
    if (typeof fnName != 'string') return null;
    var names = fnName.split('.');
    var fn = null;
    for (var i = 0, l = names.length; i < l; i++) {
        var name = names[i];
        if (!fn) fn = window[name];
        else fn = fn[name];
        if (!fn) break;
    }
    return fn;
};

//var _eval = eval;       //window["ev" + "al"]

//计算表达式的值
//function evalFn(fn) {
//    var Fn = Function;  //一个变量指向Function，防止有些前端编译工具报错
//    return new Fn('return ' + fn)();
//}

//var aaeval = eval;

var cacheParts = {};

function createPathParts(path) {
    var parts = cacheParts[path];
    if (!parts) {
        parts = path.split('.');
        for (var i = 0, l = parts.length; i < l; i++) {
            var field = parts[i];
            var index = field.indexOf('[');
            if (index > -1) {
                parts[i] = field.substr(0, index);
                parts.splice(++i, 0, parseInt(field.substr(index + 1)));
            }
        }
        cacheParts[path] = parts;
    }
    return parts;
}

// getBindingValue
function getValueByPath(obj, path) {
    if (!obj || !path) return;

    if (path in obj) return obj[path];

    var parts = createPathParts(path);

    for (var i = 0, l = parts.length; i < l && obj; i++) {
        obj = obj[parts[i]];
    }

    return obj;
}

mini._getMap = function (name, obj) {
    if (!name || !obj) return undefined;
    var v = obj[name];
    if (v !== undefined) return v;

    var index = name.indexOf('.');
    if (index == -1 && name.indexOf('[') == -1) return obj[name];
    if (index == name.length - 1) return obj[name];
    var s = 'obj.' + name;
    try {
        v = getValueByPath(obj, name);
    } catch (e) {
        return undefined;
    }
    return v;
};
mini._setMap = function (name, value, obj) {
    if (!obj) return;
    if (typeof name != 'string') return;

    var names = name.split('.');

    function createArray(obj, name, num, defaultValue) {
        var arr = obj[name];
        if (!arr) {
            arr = obj[name] = [];
        }
        for (var i = 0; i <= num; i++) {
            var arrObj = arr[i];
            if (!arrObj) {
                if (defaultValue === null || defaultValue === undefined) {
                    arrObj = arr[i] = {};
                } else {
                    arrObj = arr[i] = defaultValue;
                }
            }
        }
        return obj[name][num];
    }

    var obj2 = null;
    for (var i = 0, l = names.length; i <= l - 1; i++) {
        var name = names[i];

        if (i == l - 1) {
            if (name.indexOf(']') == -1) {
                obj[name] = value;
            } else {
                //array
                var as = name.split('[');
                var n1 = as[0],
                    n2 = parseInt(as[1]);
                createArray(obj, n1, n2, '');
                obj[n1][n2] = value;
            }

            break;
        }

        if (name.indexOf(']') == -1) {
            //obj
            obj2 = obj[name];
            if (i <= l - 2 && obj2 == null) {
                obj[name] = obj2 = {};
            }
            obj = obj2;
        } else {
            //array
            var as = name.split('[');
            var n1 = as[0],
                n2 = parseInt(as[1]);
            obj = createArray(obj, n1, n2);
            //var n3 = parseInt(as[2]), n4 = parseInt(as[3]), n5 = parseInt(as[4]);
        }
    }
    return value;
};

//mini._setMap = function (name, value, obj) {
//    if (!obj) return;
//    if (typeof name != "string") return;

//    var names = name.split(".");

//    function createArray(obj, name, num) {
//        var arr = obj[name];
//        if (!arr) {
//            arr = obj[name] = [];
//        }
//        for (var i = 0; i <= num; i++) {
//            var arrObj = arr[i];
//            if (!arrObj) arrObj = arr[i] = {};
//        }
//        return obj[name][num];
//    }

//    var obj2 = null;
//    for (var i = 0, l = names.length; i <= l - 1; i++) {
//        var name = names[i];

//        if (i == l - 1) {
//            obj[name] = value;
//            break;
//        }

//        if (name.indexOf(']') == -1) {
//            //obj
//            obj2 = obj[name];
//            if (i <= l - 2 && obj2 == null) {
//                obj[name] = obj2 = {};
//            }
//            obj = obj2;
//        } else {
//            //array
//            var as = name.split("[");
//            var n1 = as[0], n2 = parseInt(as[1]);
//            obj = createArray(obj, n1, n2);

//            //var n3 = parseInt(as[2]), n4 = parseInt(as[3]), n5 = parseInt(as[4]);
//        }

//    }
//    return value;
//}

mini.getAndCreate = function (id) {
    if (!id) return null;
    if (typeof id == 'string') return mini.components[id];

    if (typeof id == 'object') {
        if (mini.isControl(id)) {
            return id;
        } else if (mini.isElement(id)) {
            return mini.uids[id.uid];
        } else {
            return mini.create(id);
        }
    }
    return null;
};
mini.create = function (uiConfig) {
    if (!uiConfig) return null;
    if (mini.get(uiConfig.id) === uiConfig) return uiConfig;
    var clazz = this.getClass(uiConfig.type);
    if (!clazz) return null;
    var ui = new clazz();
    ui.set(uiConfig);
    return ui;
};

/* Component 
-----------------------------------------------------------------------------*/
mini.Component = function () {
    this._events = {};

    this.uid = mini.newId(this._idPre);
    this._id = this.uid;
    if (!this.id) {
        this.id = this.uid;
    }
    mini.reg(this);

    //this._doInit();
};
mini.Component.prototype = {
    isControl: true,
    id: null,
    _idPre: 'mini-',
    _idSet: false,
    _canFire: true,

    //    inited: false,
    //    _doInit: function () {
    //        if (this.inited == false) {
    //            this.inited = true;
    //            this.fire("init");
    //        }
    //    },

    set: function (kv) {
        if (typeof kv == 'string') {
            return this;
        }
        var _allowLayout = this._allowLayout;
        this._allowLayout = false;

        var renderTo = kv.renderTo || kv.render;
        delete kv.renderTo;
        delete kv.render;
        //bind events
        for (var key in kv) {
            if (key.toLowerCase().indexOf('on') == 0) {
                if (this['_$' + key]) continue;
                var fn = kv[key];
                this.on(key.substring(2, key.length).toLowerCase(), fn);
                delete kv[key];
            }
        }

        //set property
        for (var key in kv) {
            var v = kv[key];
            var n = 'set' + key.charAt(0).toUpperCase() + key.substring(1, key.length);
            var setter = this[n];

            if (setter) {
                setter.call(this, v);
            } else {
                this[key] = v;
            }
        }

        if (renderTo && this.render) {
            this.render(renderTo);
        }

        this._allowLayout = _allowLayout;
        if (this.doLayout) this.doLayout();

        return this;
    },

    fire: function (type, event) {
        if (this._canFire == false) return;
        type = type.toLowerCase();
        var handlers = this._events[type];
        if (handlers) {
            if (!event) event = {};
            if (event && event != this) {
                event.source = event.sender = this;
                if (!event.type) {
                    event.type = type;
                }
            }

            for (var i = 0, l = handlers.length; i < l; i++) {
                var listener = handlers[i];
                if (listener) {
                    // if (typeof listener[0] == "string") {
                    //     listener[0] = mini._getFunctoin(listener[0]);
                    // }
                    listener[0].apply(listener[1], [event]);
                }
            }
        }
    },
    on: function (type, fn, scope) {
        if (typeof fn == 'string') {
            var f = mini._getFunctoin(fn);
            if (!f) {
                //eval("fn = function(e){   " + fn + ".call(this,e)}");
                var id = mini.newId('__str_');
                window[id] = fn;

                //window["ev" + "al"].call(window, "fn = function(e){var s = " + id + ";var fn = mini._getFunctoin(s); if(fn) {fn.call(this, e)}else{eval(s);}}");
                //fn = new Function('e', 'var s = ' + id + ';var fn = mini._getFunctoin(s); if(fn) {fn.call(this, e)}else{window["ev" + "al"](s);}');

                fn = new Function(
                    'e',
                    'var s = ' + id + ';var fn = mini._getFunctoin(s); if(fn) {fn.call(this, e)}else{eval(s);}'
                );
            } else {
                fn = f;
            }
        }

        if (typeof fn != 'function' || !type) return false;
        // if(!type || !fn) return false;
        type = type.toLowerCase();
        var event = this._events[type];
        if (!event) {
            event = this._events[type] = [];
        }
        scope = scope || this;
        if (!this.findListener(type, fn, scope)) {
            event.push([fn, scope]);
        }
        return this;
    },
    un: function (type, fn, scope) {
        //if (typeof fn != 'function') return false;
        type = type.toLowerCase();
        var event = this._events[type];
        if (event) {
            if (fn) {
                scope = scope || this;
                var listener = this.findListener(type, fn, scope);
                if (listener) {
                    event.remove(listener);
                }
            } else {
                delete this._events[type];
            }
        }
        return this;
    },
    findListener: function (type, fn, scope) {
        type = type.toLowerCase();
        scope = scope || this;
        var handlers = this._events[type];
        if (handlers) {
            for (var i = 0, l = handlers.length; i < l; i++) {
                var listener = handlers[i];
                if (listener[0] === fn && listener[1] === scope) return listener;
            }
        }
    },
    //    removeAllListener: function () {
    //
    //    },
    setId: function (id) {
        if (!id) throw new Error('id not null');
        if (this._idSet) throw new Error('id just set only one');
        mini['unreg'](this);
        this.id = id;
        if (this.el) this.el.id = id;
        if (this._valueEl) this._valueEl.id = id + '$value';
        if (this._textEl) this._textEl.id = id + '$text';
        this._idSet = true;
        mini.reg(this);
    },
    getId: function () {
        return this.id;
    },
    destroy: function () {
        mini['unreg'](this);
        this.fire('destroy');
        //this._events = null;

        this._events = {};
    }
};

/* Control 
-----------------------------------------------------------------------------*/

mini.Control = function (el) {
    //mini.Control.superclass.constructor.apply(this, arguments);
    mini.Control.superclass.constructor.apply(this, arguments);

    this._create();
    this.el.uid = this.uid;

    //this.init();

    this._initEvents();

    //this._doInit();

    if (this._clearBorder) {
        this.el.style.borderWidth = '0';
    }
    this.addCls(this.uiCls);
    this.setWidth(this.width);
    this.setHeight(this.height);

    this.el.style.display = this.visible ? this._displayStyle : 'none';

    if (el) mini.applyTo.call(this, el);
};
mini.extend(mini.Control, mini.Component, {
    jsName: null,

    width: '',
    height: '',

    visible: true,
    readOnly: false,
    enabled: true,
    //rendered: false,
    tooltip: '',

    _readOnlyCls: 'mini-readonly',
    _disabledCls: 'mini-disabled',

    _create: function () {
        this.el = document.createElement('div');
    },
    _initEvents: function () {},
    //    init: function () {

    //    },
    within: function (e) {
        if (mini.isAncestor(this.el, e.target)) return true;
        return false;
    },

    name: '',
    setName: function (value) {
        this.name = value;
        //if (this._valueEl) mini.setAttr(this._valueEl, "name", this.name);
    },
    getName: function () {
        return this.name;
    },

    isAutoHeight: function () {
        var v = this.el.style.height;
        return v == 'auto' || v == '';
    },
    isAutoWidth: function () {
        var v = this.el.style.width;
        return v == 'auto' || v == '';
    },
    isFixedSize: function () {
        //        var el = this.el;
        //        var width = String(el.style.width);
        //        var height = String(el.style.height);

        var width = this.width;
        var height = this.height;
        if (parseInt(width) + 'px' == width && parseInt(height) + 'px' == height) return true;
        return false;
    },

    isRender: function (parentNode) {
        return !!(this.el && this.el.parentNode && this.el.parentNode.tagName);
    },
    render: function (parent, position) {
        if (typeof parent === 'string') {
            if (parent == '#body') parent = document.body;
            else parent = mini.byId(parent);
        }
        if (!parent) return;
        if (!position) position = 'append';
        position = position.toLowerCase();

        if (position == 'before') {
            jQuery(parent).before(this.el);
        } else if (position == 'prepend') {
            jQuery(parent).prepend(this.el);
        } else if (position == 'after') {
            jQuery(parent).after(this.el);
        } else {
            parent.appendChild(this.el);
        }

        //this.rendered = true;
        this.el.id = this.id;

        this.doLayout();
        this.fire('render');
    },
    //    isTopControl: function () {
    //        var doc = document;
    //        var p = this.el.parentNode;
    //        while (p != doc && p != null) {
    //            var pcontrol = mini.get(p);
    //            if (pcontrol) {
    //                if (mini.isControl(pcontrol)) return true;
    //            }
    //            p = p.parentNode;
    //        }
    //        return true;
    //    },

    getEl: function () {
        return this.el;
    },
    setJsName: function (value) {
        this.jsName = value;
        window[value] = this;
    },
    getJsName: function () {
        return this.jsName;
    },
    //tooltipPlacement: "bottom",
    setTooltip: function (value) {
        this.tooltip = value;
        this.el.title = value;

        if (this.tooltipPlacement) jQuery(this.el).attr('data-placement', this.tooltipPlacement);
    },
    getTooltip: function () {
        return this.tooltip;
    },
    _sizeChanged: function () {
        this.doLayout();
    },
    setWidth: function (value) {
        if (parseFloat(value) == value) value += 'px';
        this.width = value;
        this.el.style.width = value;
        this._sizeChanged();
    },
    getWidth: function (content) {
        //var el = this._borderEl || this.el;
        var el = this.el;
        var w = content ? jQuery(el).width() : jQuery(el).outerWidth();
        if (content && this._borderEl) {
            var b2 = mini.getBorders(this._borderEl);
            w = w - b2.left - b2.right;
        }
        return w;
    },
    setHeight: function (value) {
        if (parseFloat(value) == value) value += 'px';
        this.height = value;
        this.el.style.height = value;
        this._sizeChanged();
    },
    getHeight: function (content) {
        var h = content ? jQuery(this.el).height() : jQuery(this.el).outerHeight();
        //alert(jQuery(this.el).height());

        if (content && this._borderEl) {
            var b2 = mini.getBorders(this._borderEl);
            h = h - b2.top - b2.bottom;
        }
        return h;
    },
    getBox: function () {
        return mini.getBox(this.el);
    },
    setBorderStyle: function (value) {
        var el = this._borderEl || this.el;
        mini.setStyle(el, value);
        this.doLayout();
    },
    getBorderStyle: function () {
        return this.borderStyle;
    },
    _clearBorder: true,
    setStyle: function (value) {
        this.style = value;
        mini.setStyle(this.el, value);
        if (this._clearBorder) {
            this.el.style.borderWidth = '0';
            this.el.style.padding = '0px';
        }
        //        this.width = mini.getWidth(this.el);
        //        this.height = mini.getHeight(this.el);
        this.width = this.el.style.width;
        this.height = this.el.style.height;
        this._sizeChanged();
    },
    getStyle: function () {
        return this.style;
    },
    setCls: function (cls) {
        this.addCls(cls);
    },
    getCls: function () {
        return this.cls;
    },
    addCls: function (cls) {
        mini.addClass(this.el, cls);
    },
    removeCls: function (cls) {
        mini.removeClass(this.el, cls);
    },
    _doReadOnly: function () {
        if (this.readOnly) {
            this.addCls(this._readOnlyCls);
        } else {
            this.removeCls(this._readOnlyCls);
        }
    },
    setReadOnly: function (value) {
        this.readOnly = value;
        this._doReadOnly();
    },
    getReadOnly: function () {
        return this.readOnly;
    },
    getParent: function (uiCls) {
        var doc = document;
        var p = this.el.parentNode;
        while (p != doc && p != null) {
            var pcontrol = mini.get(p);
            if (pcontrol) {
                if (!mini.isControl(pcontrol)) return null;
                if (!uiCls || pcontrol.uiCls == uiCls) return pcontrol;
            }
            p = p.parentNode;
        }
        return null;
    },
    isReadOnly: function () {
        if (this.readOnly || !this.enabled) return true;
        var p = this.getParent();
        if (p) return p.isReadOnly();
        return false;
    },
    setEnabled: function (value) {
        this.enabled = value;
        if (this.enabled) {
            this.removeCls(this._disabledCls);
        } else {
            this.addCls(this._disabledCls);
        }
        this._doReadOnly();
    },
    getEnabled: function () {
        return this.enabled;
    },
    enable: function () {
        this.setEnabled(true);
    },
    disable: function () {
        this.setEnabled(false);
    },
    _displayStyle: '',
    setVisible: function (value) {
        this.visible = value;
        if (this.el) {
            this.el.style.display = value ? this._displayStyle : 'none';
            this.doLayout();
        }
    },
    getVisible: function () {
        return this.visible;
    },
    show: function () {
        this.setVisible(true);
    },
    hide: function () {
        this.setVisible(false);
    },
    isDisplay: function (ignoresFn) {
        if (mini.WindowVisible == false || !this.el) return false;
        //

        var doc = document.body;
        var p = this.el;
        while (1) {
            if (p == null || !p.style) return false;
            if (p && p.style && p.style.display == 'none') {
                //return false;
                if (ignoresFn) {
                    if (ignoresFn(p) !== true) return false;
                } else return false;
            }
            if (p == doc) return true;

            p = p.parentNode;
        }
        return true;
    },

    _allowUpdate: true,
    beginUpdate: function () {
        this._allowUpdate = false;
    },
    endUpdate: function () {
        this._allowUpdate = true;
        this.doUpdate();
    },
    doUpdate: function () {},
    canLayout: function () {
        //return false;
        if (!mini.enableLayout) return false;
        if (this._allowLayout == false) return false;
        return this.isDisplay();
    },
    doLayout: function () {},
    layoutChanged: function () {
        if (this.canLayout() == false) return;
        this.doLayout();
    },
    _destroyChildren: function (removeEl) {
        if (this.el) {
            //            if (!mini.aaa) {
            //                alert(1);
            //                mini.aaa = 1;
            //            }

            var cs = mini.getChildControls(this);
            for (var i = 0, l = cs.length; i < l; i++) {
                var control = cs[i];
                if (control.destroyed !== true) {
                    control.destroy(removeEl);
                }
            }
        }
    },
    destroy: function (removeEl) {
        if (this.destroyed !== true) {
            if (!mini._destroying) {
                this._destroyChildren(removeEl);
            }
        }

        if (this.el) {
            var el = this.el;
            el.onclick =
                el.ondblclick =
                el.onmousedown =
                el.onmouseup =
                el.onmousemove =
                el.onmouseover =
                el.onmouseout =
                el.onkeydown =
                el.onkeyup =
                el.oncontextmenu =
                    null;

            mini.clearEvent(el);

            if (removeEl !== false) {
                //alert(2);
                mini.removeNode(el);
                //                var p = this.el.parentNode;
                //                if (p) p.removeChild(this.el);
            }

            //                var p = this.el.parentNode;
            //                if (p) p.removeChild(this.el);
        }
        this._borderEl = this._contentEl = this._valueEl = this._textEl = this._errorIconEl = null;
        this.el = null;
        mini['unreg'](this);
        this.destroyed = true;
        this.fire('destroy');
    },

    focus: function () {
        try {
            var me = this;
            //setTimeout(function () {
            me.el.focus();
            //}, 1);
        } catch (e) {}
    },
    blur: function () {
        try {
            var me = this;
            //setTimeout(function () {
            me.el.blur();
            //}, 1);
        } catch (e) {}
    },

    allowAnim: true,
    setAllowAnim: function (value) {
        this.allowAnim = value;
    },
    getAllowAnim: function () {
        return this.allowAnim;
    },
    //////////////////////
    /////////////////////////////////////////////////////////////////////////
    _getMaskWrapEl: function () {
        return this.el;
    },
    mask: function (options) {
        if (typeof options == 'string') options = { html: options };
        options = options || {};
        options.el = this._getMaskWrapEl();
        if (!options.cls) options.cls = this._maskCls;

        mini.mask(options);
    },
    unmask: function () {
        mini.unmask(this._getMaskWrapEl());

        this.isLoading = false;
    },
    _maskCls: 'mini-mask-loading',
    loadingMsg: epoint_local.loadingMsg,
    loading: function (msg) {
        //this.isLoading = true;
        this.mask(msg || this.loadingMsg);
    },
    setLoadingMsg: function (value) {
        this.loadingMsg = value;
    },
    getLoadingMsg: function () {
        return this.loadingMsg;
    },
    //////////////////////
    _getContextMenu: function (value) {
        var ui = value;
        if (typeof value == 'string') {
            ui = mini.get(value);
            if (!ui) {
                mini.parse(value);
                ui = mini.get(value);
            }
        } else if (mini.isArray(value)) {
            ui = {
                type: 'menu',
                items: value
            };
        } else if (!mini.isControl(value)) {
            ui = mini.create(value);
        }
        return ui;
    },
    __OnHtmlContextMenu: function (e) {
        var ev = {
            popupEl: this.el,
            htmlEvent: e,
            cancel: false
        };
        this.contextMenu.fire('BeforeOpen', ev);
        if (ev.cancel == true) return;
        this.contextMenu.fire('opening', ev);
        if (ev.cancel == true) return;

        this.contextMenu.showAtPos(e.pageX, e.pageY);
        this.contextMenu.fire('Open', ev);
        return false;
    },
    contextMenu: null,
    setContextMenu: function (value) {
        var ui = this._getContextMenu(value);
        if (!ui) return;
        if (this.contextMenu !== ui) {
            this.contextMenu = ui;
            mini.addClass(ui.el, 'mini-menu-open');
            this.contextMenu.owner = this;
            mini.on(this.el, 'contextmenu', this.__OnHtmlContextMenu, this);
        }
    },
    getContextMenu: function () {
        return this.contextMenu;
    },
    setDefaultValue: function (value) {
        this.defaultValue = value;
    },
    getDefaultValue: function () {
        return this.defaultValue;
    },
    setValue: function (value) {
        this.value = value;
    },
    getValue: function () {
        return this.value;
    },
    //////////////////////
    ajaxData: null,
    ajaxType: '',
    ajaxOptions: null,
    setAjaxOptions: function (value) {
        this.ajaxOptions = value;
    },
    getAjaxOptions: function () {
        return this.ajaxOptions;
    },
    setAjaxData: function (value) {
        this.ajaxData = value;
    },
    getAjaxData: function () {
        return this.ajaxData;
    },
    setAjaxType: function (value) {
        this.ajaxType = value;
    },
    getAjaxType: function () {
        return this.ajaxType;
    },
    //    setApplyTo: function (el) {
    //        this.applyTo(el);
    //    },

    _afterApply: function (el) {
        //        var cs = mini.getChildNodes(el, true);
        //        for (var i = 0, l = cs.length; i < l; i++) {
        //            var nodeEl = cs[i];
        //            this._contentEl.appendChild(nodeEl);
        //        }
    },
    //_tagName: "",
    dataField: '',
    setDataField: function (value) {
        this.dataField = value;
    },
    getDataField: function () {
        return this.dataField;
    },
    tabIndex: 0,
    setTabIndex: function (value) {
        var el = this._textEl || this.el;
        el.tabIndex = value;
        this.tabIndex = value;
    },
    getTabIndex: function () {
        return this.tabIndex;
    },
    getAttrs: function (el) {
        //        if (el.tagName.toLowerCase() != this._tagName) {
        //            throw new Error(this.type + " must be Tag \"" + this._tagName+"\"");
        //        }

        var attrs = {};

        var cls = el.className;
        if (cls) attrs.cls = cls;

        if (el.value) attrs.value = el.value;
        mini._ParseString(el, attrs, [
            'id',
            'name',
            'width',
            'height',
            'borderStyle',
            'value',
            'defaultValue',
            'tabIndex',
            'contextMenu',
            'tooltip',
            'ondestroy',
            'data-options',
            'ajaxData',
            'ajaxType',
            'dataField',
            'ajaxOptions',
            'data-placement'
        ]);
        if (attrs['data-placement']) this.tooltipPlacement = attrs['data-placement'];

        //        if (this.type == "textbox") {
        //            alert(attrs.height);
        //        }

        mini._ParseBool(el, attrs, ['visible', 'enabled', 'readOnly']);

        // if (el.readOnly && el.readOnly != "false") attrs.readOnly = true;

        var style = el.style.cssText;
        if (style) {
            attrs.style = style;
        }
        //ie9 background bug
        if (isIE9) {
            var bg = el.style.background;
            if (bg) {
                if (!attrs.style) attrs.style = '';
                attrs.style += ';background:' + bg;
            }
        }
        if (this.style) {
            if (attrs.style) attrs.style = this.style + ';' + attrs.style;
            else attrs.style = this.style;
        }
        if (this.borderStyle) {
            if (attrs.borderStyle) attrs.borderStyle = this.borderStyle + ';' + attrs.borderStyle;
            else attrs.borderStyle = this.borderStyle;
        }

        if (typeof attrs.ajaxOptions == 'string') {
            attrs.ajaxOptions = window['ev' + 'al']('(' + attrs.ajaxOptions + ')');
        }

        //if (this.type == "menu") debugger
        //if(attrs.id == "folderTree") debugger

        //用户自定义标签参数
        var ts = mini._attrs;
        if (ts) {
            for (var i = 0, l = ts.length; i < l; i++) {
                var t = ts[i];
                var name = t[0];
                var type = t[1];
                if (!type) type = 'string';
                if (type == 'string') mini._ParseString(el, attrs, [name]);
                else if (type == 'bool') mini._ParseBool(el, attrs, [name]);
                else if (type == 'int') mini._ParseInt(el, attrs, [name]);
            }
        }

        //data-options
        var options = attrs['data-options'];
        if (options) {
            options = window['ev' + 'al']('(' + options + ')');
            if (options) {
                //attrs["data-options"] = options;
                mini.copyTo(attrs, options);
            }
        }

        return attrs;
    }
});

mini._attrs = null;
mini.regHtmlAttr = function (attr, type) {
    if (!attr) return;
    if (!type) type = 'string';
    if (!mini._attrs) mini._attrs = [];
    mini._attrs.push([attr, type]);
};

/* Container
-----------------------------------------------------------------------------*/

__mini_setControls = function (controls, contentEl, scope) {
    contentEl = contentEl || this._contentEl;
    scope = scope || this;
    if (!controls) controls = [];
    if (!mini.isArray(controls)) controls = [controls];
    //controls = controls.clone();

    for (var i = 0, l = controls.length; i < l; i++) {
        var c = controls[i];
        if (typeof c == 'string') {
            //string
            if (c.indexOf('#') == 0) c = mini.byId(c);
        } else if (mini.isElement(c)) {
            //dom
        } else {
            //object
            c = mini.getAndCreate(c);
            c = c.el;
        }
        if (!c) continue;
        //mini.innerHTML
        mini.append(contentEl, c);
    }

    mini.parse(contentEl);
    scope.doLayout();
    return scope;
};

mini.Container = function () {
    mini.Container.superclass.constructor.apply(this, arguments);
    if (!this._contentEl) this._contentEl = this.el;
};
mini.extend(mini.Container, mini.Control, {
    //    destroy: function(){
    //    },

    setControls: __mini_setControls,
    getContentEl: function () {
        return this._contentEl;
    },
    getBodyEl: function () {
        return this._contentEl;
    },
    within: function (e) {
        if (mini.isAncestor(this.el, e.target)) return true;
        var controls = mini.getChildControls(this);

        //if (this.id == 'gridPanel') debugger

        for (var i = 0, l = controls.length; i < l; i++) {
            var c = controls[i];
            //if (mini.isAncestor(c.el, e.target)) return true;
            if (c.within(e)) return true;
        }

        return false;
    }
});

/* ValidatorBase 
-----------------------------------------------------------------------------*/

mini.ValidatorBase = function () {
    mini.ValidatorBase.superclass.constructor.apply(this, arguments);
};
mini.extend(mini.ValidatorBase, mini.Control, {
    required: false,
    requiredErrorText: epoint_local.ValidatorBase.requiredErrorText,
    _requiredCls: 'mini-required',

    errorText: '',
    _errorCls: 'mini-error',
    _invalidCls: 'mini-invalid', //当none时，加上_errorCls，比如红色边框，黄色背景

    errorMode: 'icon', //icon、border、none
    validateOnChanged: true, //值改变时验证
    validateOnLeave: true, //离开失去焦点时验证
    validateOnInput: false, // 输入时验证
    resetOnFocus: true, // 得到焦点时重置校验
    _IsValid: true,

    forceValidate: false,
    _afterApply: function () {
        mini.ValidatorBase.superclass._afterApply.call(this);
        var that = this;

        $(this.el).on('click', 'input, textarea', function () {
            if (that.resetOnFocus) {
                setTimeout(function () {
                    that.setIsValid(true);
                }, 10);
            }
        });
    },
    setForceValidate: function (value) {
        this.forceValidate = value;
    },
    getForceValidate: function () {
        return this.forceValidate;
    },

    keyNavEnabled: true,
    setKeyNavEnabled: function (value) {
        this.keyNavEnabled = value;
    },
    getKeyNavEnabled: function () {
        return this.keyNavEnabled;
    },

    indentSpace: false, //  错误缩进
    _indentCls: 'mini-indent',

    setIndentSpace: function (value) {
        if (value) {
            this.addCls(this._indentCls);
        } else {
            this.removeCls(this._indentCls);
        }
        this.indentSpace = value;
    },
    getIndentSpace: function () {
        return this.indentSpace;
    },

    isEditable: function () {
        if (this.readOnly || !this.allowInput || !this.enabled) return false;
        return true;
    },

    _tryValidate: function () {
        if (this._tryValidateTimer) clearTimeout(this._tryValidateTimer);
        var me = this;
        this._tryValidateTimer = setTimeout(function () {
            me.validate();
        }, 30);
    },
    validate: function () {
        //if (this.isReadOnly() || this.enabled == false) return true;
        //        if (this.enabled == false) {
        //            this.setIsValid(true);
        //            return true;
        //        }

        var e = {
            value: this.getValue(),
            errorText: '',
            isValid: true
        };

        if (this.required) {
            if (mini.isNull(e.value) || String(e.value).trim() === '') {
                e.isValid = false;
                e.errorText = this.requiredErrorText;
            }
        }

        this.fire('validation', e);

        this.errorText = e.errorText;
        this.setIsValid(e.isValid);
        return this.isValid();
    },
    isValid: function () {
        return this._IsValid;
    },
    setIsValid: function (value) {
        //if (this._IsValid != value) {
        this._IsValid = value;
        this.doUpdateValid();
        //}
    },
    getIsValid: function () {
        return this._IsValid;
    },
    setValidateOnChanged: function (value) {
        this.validateOnChanged = value;
    },
    getValidateOnChanged: function (value) {
        return this.validateOnChanged;
    },
    setValidateOnLeave: function (value) {
        this.validateOnLeave = value;
    },
    getValidateOnLeave: function (value) {
        return this.validateOnLeave;
    },
    setValidateOnInput: function (value) {
        this.validateOnInput = value;
    },
    getValidateOnInput: function (value) {
        return this.validateOnInput;
    },
    setResetOnFocus: function (value) {
        this.resetOnFocus = value;
    },
    getResetOnFocus: function () {
        return this.resetOnFocus;
    },

    setErrorMode: function (value) {
        if (!value) value = 'none';
        this.errorMode = value.toLowerCase();
        if (this._IsValid == false) this.doUpdateValid();
    },
    getErrorMode: function () {
        return this.errorMode;
    },
    setErrorText: function (value) {
        this.errorText = value;
        if (this._IsValid == false) this.doUpdateValid();
    },
    getErrorText: function () {
        return this.errorText;
    },
    setRequired: function (value) {
        this.required = value;
        if (this.required) {
            this.addCls(this._requiredCls);
        } else {
            this.removeCls(this._requiredCls);
        }
    },
    getRequired: function () {
        return this.required;
    },
    setRequiredErrorText: function (value) {
        this.requiredErrorText = value;
    },
    getRequiredErrorText: function () {
        return this.requiredErrorText;
    },
    errorIconEl: null,
    getErrorIconEl: function () {
        return this._errorIconEl;
    },
    _RemoveErrorIcon: function () {},
    doUpdateValid: function () {
        var me = this;
        me.__doUpdateValid();
        //        if (this._IsValid) {
        //            me.__doUpdateValid();
        //        } else {
        //            this._doUpdateValidTimer = setTimeout(function () {
        //                me.__doUpdateValid();
        //            }, 1);
        //        }
    },
    errorTooltipPlacement: 'right',
    __doUpdateValid: function () {
        if (!this.el) return;
        this.removeCls(this._errorCls);
        this.removeCls(this._invalidCls);

        if (this.errorMode == 'border') {
            this.el.title = '';
        }

        if (this._IsValid == false) {
            switch (this.errorMode) {
                case 'icon':
                    this.addCls(this._errorCls);
                    var icon = this.getErrorIconEl();
                    if (icon) {
                        icon.title = this.errorText;
                        jQuery(icon).attr('data-placement', this.errorTooltipPlacement);
                    }
                    break;
                case 'border':
                    this.addCls(this._invalidCls);
                    this.el.title = this.errorText;
                default:
                    this._RemoveErrorIcon();
                    break;
            }
        } else {
            this._RemoveErrorIcon();
        }
        this.doLayout();
    },
    doValueChanged: function () {
        this._OnValueChanged();
    },
    _OnValueChanged: function () {
        if (this.validateOnChanged) {
            this._tryValidate();
        }
        this.fire('valuechanged', { value: this.getValue(), oldValue: this._oldValue });

        this._oldValue = this.getValue();
    },
    onValueChanged: function (fn, scope) {
        this.on('valuechanged', fn, scope);
    },
    onValidation: function (fn, scope) {
        this.on('validation', fn, scope);
    },
    getAttrs: function (el) {
        var attrs = mini.ValidatorBase.superclass.getAttrs.call(this, el);

        mini._ParseString(el, attrs, [
            'onvaluechanged',
            'onvalidation',
            'label',
            'labelStyle',
            'requiredErrorText',
            'errorMode',
            'errorTooltipPlacement'
        ]);

        mini._ParseBool(el, attrs, [
            'validateOnChanged',
            'validateOnLeave',
            'validateOnInput',
            'labelField',
            'indentSpace',
            'keyNavEnabled',
            'forceValidate',
            'resetOnFocus'
        ]);

        var required = el.getAttribute('required');
        if (!required) required = el.required;
        if (!required) {
            var o = el.attributes['required'];
            if (o) {
                //fix ie10
                required = o.value == 'null' ? null : 'true';
            }
        }
        if (required) {
            attrs.required = required != 'false' ? true : false;
        }

        return attrs;
    },

    /////////////////////////////////////////////////////////////////
    _labelLayout: function () {
        var border = this._borderEl;
        if (!border) return;

        this._labelLayouted = true;
        if (this.labelField) {
            var w = this._labelEl.offsetWidth;
            border.style['marginLeft'] = w + 'px';
            this._doLabelLayout = w === 0;
        } else {
            border.style['marginLeft'] = 0;
        }
    },
    _labelFieldCls: 'mini-labelfield',
    labelField: false,
    label: '',
    labelStyle: '',
    setLabelField: function (value) {
        if (this.labelField != value) {
            this.labelField = value;
            if (!this._borderEl) return;
            if (!this._labelEl) {
                this._labelEl = mini.append(this.el, '<label class="mini-labelfield-label"></label>');
                this._labelEl.innerHTML = this.label;
                mini.setStyle(this._labelEl, this.labelStyle);
            }
            this._labelEl.style.display = value ? 'block' : 'none';
            if (value) {
                mini.addClass(this.el, this._labelFieldCls);
            } else {
                mini.removeClass(this.el, this._labelFieldCls);
            }
            this._labelLayout();
            //this.doLayout();
        }
    },
    getLabelField: function () {
        this.labelField;
    },
    setLabel: function (value) {
        if (this.label != value) {
            this.label = value;
            if (this._labelEl) this._labelEl.innerHTML = value;
            this._labelLayout();
        }
    },
    getLabel: function () {
        this.label;
    },
    setLabelStyle: function (value) {
        if (this.labelStyle != value) {
            this.labelStyle = value;
            if (this._labelEl) mini.setStyle(this._labelEl, value);
            this._labelLayout();
        }
    },
    getLabelStyle: function () {
        this.labelStyle;
    }
});

/* ListControl 
-----------------------------------------------------------------------------*/

mini.ListControl = function (el) {
    this.data = [];
    this._selecteds = [];
    mini.ListControl.superclass.constructor.call(this, null);
    this.doUpdate();

    if (el) mini.applyTo.call(this, el);
};
mini.ListControl.ajaxType = 'get';
mini.extend(mini.ListControl, mini.ValidatorBase, {
    defaultValue: '',
    value: '',
    valueField: 'id',
    textField: 'text',
    dataField: '',
    delimiter: ',',

    setDelimiter: function (value) {
        this.delimiter = value;
    },
    getDelimiter: function () {
        return this.delimiter;
    },

    data: null,
    url: '',

    valueInCheckOrder: true,
    setValueInCheckOrder: function (value) {
        this.valueInCheckOrder = value;
    },
    getValueInCheckOrder: function () {
        return this.valueInCheckOrder;
    },

    _itemCls: 'mini-list-item',
    _itemHoverCls: 'mini-list-item-hover',
    _itemSelectedCls: 'mini-list-item-selected',

    doLayout: function () {
        if (this._doLabelLayout) {
            this._labelLayout();
        }
    },

    set: function (kv) {
        if (typeof kv == 'string') {
            return this;
        }

        var value = kv.value;
        delete kv.value;
        var url = kv.url;
        delete kv.url;
        var data = kv.data;
        delete kv.data;

        mini.ListControl.superclass.set.call(this, kv);

        if (!mini.isNull(data)) {
            this.setData(data);
        }
        if (!mini.isNull(url)) {
            this.setUrl(url);
        }
        if (!mini.isNull(value)) {
            this.setValue(value);
        }

        return this;
    },

    uiCls: 'mini-list',
    _create: function () {},
    _initEvents: function () {
        mini._BindEvents(function () {
            mini_onOne(this.el, 'click', this.__OnClick, this);
            mini_onOne(this.el, 'dblclick', this.__OnDblClick, this);

            mini_onOne(this.el, 'mousedown', this.__OnMouseDown, this);
            mini_onOne(this.el, 'mouseup', this.__OnMouseUp, this);
            mini_onOne(this.el, 'mousemove', this.__OnMouseMove, this);
            mini_onOne(this.el, 'mouseover', this.__OnMouseOver, this);
            mini_onOne(this.el, 'mouseout', this.__OnMouseOut, this);

            mini_onOne(this.el, 'keydown', this.__OnKeyDown, this);
            mini_onOne(this.el, 'keyup', this.__OnKeyUp, this);

            mini_onOne(this.el, 'contextmenu', this.__OnContextMenu, this);

            //            mini.on(this.el, 'click', this.__OnClick, this);
            //            mini.on(this.el, 'dblclick', this.__OnDblClick, this);

            //            mini.on(this.el, 'mousedown', this.__OnMouseDown, this);
            //            mini.on(this.el, 'mouseup', this.__OnMouseUp, this);
            //            mini.on(this.el, 'mousemove', this.__OnMouseMove, this);
            //            mini.on(this.el, 'mouseover', this.__OnMouseOver, this);
            //            mini.on(this.el, 'mouseout', this.__OnMouseOut, this);

            //            mini.on(this.el, 'keydown', this.__OnKeyDown, this);
            //            mini.on(this.el, 'keyup', this.__OnKeyUp, this);

            //            mini.on(this.el, 'contextmenu', this.__OnContextMenu, this);
        }, this);
    },
    destroy: function (removeEl) {
        mini.ListControl.superclass.destroy.call(this, removeEl);
    },

    name: '',
    setName: function (value) {
        this.name = value;
        if (this._valueEl) mini.setAttr(this._valueEl, 'name', this.name);
    },

    getItemByEvent: function (event) {
        var domItem = mini.findParent(event.target, this._itemCls);
        if (domItem) {
            var index = parseInt(mini.getAttr(domItem, 'index'));

            return this.data[index];
        }
    },
    addItemCls: function (item, cls) {
        var itemEl = this.getItemEl(item);
        if (itemEl) mini.addClass(itemEl, cls);
    },
    removeItemCls: function (item, cls) {
        var itemEl = this.getItemEl(item);
        if (itemEl) mini.removeClass(itemEl, cls);
    },
    getItemEl: function (item) {
        item = this.getItem(item);
        var index = this.data.indexOf(item);
        var id = this._createItemId(index);
        return document.getElementById(id);
    },
    _focusItem: function (item, view) {
        item = this.getItem(item);
        if (!item) return;
        var dom = this.getItemEl(item);
        if (view && dom) {
            this.scrollIntoView(item);
        }
        if (this._focusedItem == item) {
            if (dom) mini.addClass(dom, this._itemHoverCls);
            return;
        }
        this._blurItem();
        this._focusedItem = item;
        if (dom) mini.addClass(dom, this._itemHoverCls);
    },
    _blurItem: function () {
        if (!this._focusedItem) return;

        var dom = this.getItemEl(this._focusedItem);
        if (dom) {
            mini.removeClass(dom, this._itemHoverCls);
        }
        this._focusedItem = null;
    },
    getFocusedItem: function () {
        var row = this._focusedItem;
        return this.indexOf(row) == -1 ? null : row;
    },
    getFocusedIndex: function () {
        return this.data.indexOf(this._focusedItem);
    },
    _scrollViewEl: null,
    scrollIntoView: function (item) {
        try {
            var itemEl = this.getItemEl(item);
            var _scrollViewEl = this._scrollViewEl || this.el;
            mini.scrollIntoView(itemEl, _scrollViewEl, false);
        } catch (e) {}
    },
    ////////////////////////////////////////////
    getItem: function (item) {
        if (typeof item == 'object') return item;
        if (typeof item == 'number') return this.data[item];
        return this.findItems(item)[0];
    },
    getCount: function () {
        return this.data.length;
    },
    indexOf: function (item) {
        return this.data.indexOf(item);
    },
    getAt: function (index) {
        return this.data[index];
    },
    updateItem: function (item, options) {
        item = this.getItem(item);
        if (!item) return;
        mini.copyTo(item, options);
        this.doUpdate();
    },
    load: function (data) {
        if (typeof data == 'string') this.setUrl(data);
        else this.setData(data);
    },
    loadData: function (data) {
        this.setData(data);
    },
    setData: function (data) {
        if (typeof data == 'string') {
            data = window['ev' + 'al'](data);
        }
        if (!mini.isArray(data)) data = [];
        this.data = data;

        //        this._checkSelecteds();

        this.doUpdate();

        if (this.value != '') {
            this.deselectAll();
            var records = this.findItems(this.value);
            this.selects(records);
        }
    },
    getData: function () {
        return this.data.clone();
    },
    setUrl: function (url) {
        //if (this.url != url) {
        this.url = url;
        this._doLoad({});
        //}
    },
    getUrl: function () {
        return this.url;
    },

    ajaxData: null,
    _doLoad: function (params) {
        try {
            var url = window['ev' + 'al'](this.url);
            if (url != undefined) {
                this.url = url;
            }
        } catch (e) {}
        var url = this.url;

        var ajaxMethod = mini.ListControl.ajaxType;
        if (url) {
            if (url.indexOf('.txt') != -1 || url.indexOf('.json') != -1) {
                ajaxMethod = 'get';
            }
        }

        var obj = mini._evalAjaxData(this.ajaxData, this);
        mini.copyTo(params, obj);

        var e = {
            url: this.url,
            async: false,
            type: this.ajaxType ? this.ajaxType : ajaxMethod,
            data: params,
            params: params,
            cache: false,
            cancel: false
        };

        //alert(this.ajaxOptions);
        jQuery.extend(true, e, this.ajaxOptions);

        this.fire('beforeload', e);
        if (e.data != e.params && e.params != params) {
            e.data = e.params;
        }
        if (e.cancel == true) return;

        var sf = (me = this);
        var url = e.url;
        mini.copyTo(e, {
            success: function (text, textStatus, xhr) {
                delete e.params;
                var obj = { text: text, result: null, sender: me, options: e, xhr: xhr };
                var result = null;
                try {
                    mini_doload(obj);
                    result = obj.result;
                    if (!result) {
                        result = mini.decode(text);
                    }
                } catch (ex) {
                    if (mini_debugger == true) {
                        alert(url + '\njson is error.');
                    }
                }
                if (mini.isArray(result)) result = { data: result };
                if (sf.dataField) {
                    result.data = mini._getMap(sf.dataField, result);
                }
                if (!result.data) result.data = [];

                var ex = { data: result.data, cancel: false, result: result };
                sf.fire('preload', ex);
                if (ex.cancel == true) return;

                sf.setData(ex.data);

                delete ex.cancel;
                sf.fire('load', ex);

                setTimeout(function () {
                    sf.doLayout();
                }, 100);
            },
            error: function (xhr, textStatus, errorThrown) {
                var e = {
                    xhr: xhr,
                    text: xhr.responseText,
                    textStatus: textStatus,
                    errorMsg: xhr.responseText,
                    errorCode: xhr.status
                };
                if (mini_debugger == true) {
                    alert(url + '\n' + e.errorCode + '\n' + e.errorMsg);
                }
                sf.fire('loaderror', e);
            }
        });

        this._ajaxer = mini.ajax(e);
    },
    setValue: function (value) {
        if (mini.isNull(value)) value = '';
        //if (this.value !== value) {
        //var records = this.findItems(this.value);
        this.deselectAll();

        this.value = value;
        if (this._valueEl) this._valueEl.value = value;

        var records = this.findItems(this.value);
        this.selects(records);

        this.setSelected(records[0]);
        //}
    },
    getValue: function () {
        return this.value;
    },
    getFormValue: function () {
        return this.value;
    },
    setValueField: function (valueField) {
        this.valueField = valueField;
    },
    getValueField: function () {
        return this.valueField;
    },
    setTextField: function (value) {
        this.textField = value;
    },
    getTextField: function () {
        return this.textField;
    },

    ////////////////////////////////////////////////////////
    getItemValue: function (item) {
        return String(mini._getMap(this.valueField, item));
    },
    getItemText: function (item) {
        var t = mini._getMap(this.textField, item);
        return mini.isNull(t) ? '' : String(t);
    },
    getValueAndText: function (records) {
        if (mini.isNull(records)) records = [];
        if (!mini.isArray(records)) {
            records = this.findItems(records);
        }

        //按序号排序
        if (this.valueInCheckOrder) {
            var data = this.getData();
            mini.sort(records, function (a, b) {
                var index1 = data.indexOf(a);
                var index2 = data.indexOf(b);
                if (index1 > index2) return 1;
                if (index1 < index2) return -1;
                return 0;
            });
        }

        var values = [];
        var texts = [];
        for (var i = 0, l = records.length; i < l; i++) {
            var record = records[i];
            if (record) {
                values.push(this.getItemValue(record));
                texts.push(this.getItemText(record));
            }
        }
        return [values.join(this.delimiter), texts.join(this.delimiter)];
    },
    findItems: function (value) {
        if (mini.isNull(value) || value === '') return [];
        if (typeof value == 'function') {
            var fn = value;
            var items = [];
            var data = this.data;
            for (var j = 0, k = data.length; j < k; j++) {
                var record = data[j];
                if (fn(record, j) === true) {
                    items.push(record);
                }
            }
            return items;
        }

        var values = String(value).split(this.delimiter);

        var data = this.data;
        var valueRecords = {};
        for (var j = 0, k = data.length; j < k; j++) {
            var record = data[j];
            //var v = record[this.valueField];
            var v = mini._getMap(this.valueField, record);
            valueRecords[v] = record;
        }

        var records = [];
        for (var i = 0, l = values.length; i < l; i++) {
            var v = values[i];
            var record = valueRecords[v];
            if (record) {
                records.push(record);
            }
        }

        return records;
    },

    /////////////////////////////////////////////
    removeAll: function () {
        var items = this.getData();
        this.removeItems(items);
    },
    addItems: function (items, index) {
        if (!mini.isArray(items)) return;
        if (mini.isNull(index)) index = this.data.length;
        this.data.insertRange(index, items);
        this.doUpdate();
    },
    addItem: function (item, index) {
        if (!item) return;
        if (this.data.indexOf(item) != -1) return;
        if (mini.isNull(index)) index = this.data.length;
        this.data.insert(index, item);
        this.doUpdate();
    },
    removeItems: function (items) {
        if (!mini.isArray(items)) return;
        this.data.removeRange(items);

        this._checkSelecteds();
        this.doUpdate();
    },
    removeItem: function (item) {
        var index = this.data.indexOf(item);
        if (index != -1) {
            this.data.removeAt(index);
            this._checkSelecteds();
            this.doUpdate();
        }
    },
    moveItem: function (item, index) {
        if (!item || !mini.isNumber(index)) return;
        //        var target = this.data[index];
        //        if (target == item) return;
        if (index < 0) index = 0;
        if (index > this.data.length) index = this.data.length;
        this.data.remove(item);
        //index = this.data.indexOf(target);
        this.data.insert(index, item);
        this.doUpdate();
    },
    /////////////////////////////////////////////

    _isSelectedAll: function () {
        var me = this,
            data = this.getData();
        //for(var

        for (var i = 0, l = data.length; i < l; i++) {
            var item = data[i];
            if (item.enabled !== false) {
                if (!me.isSelected(item)) return false;
            }
        }
        return true;
    },

    _selected: null,
    _selecteds: [],
    multiSelect: false,
    _checkSelecteds: function () {
        for (var i = this._selecteds.length - 1; i >= 0; i--) {
            var record = this._selecteds[i];
            if (this.data.indexOf(record) == -1) {
                this._selecteds.removeAt(i);
            }
        }

        if (this._selected && this.data.indexOf(this._selected) == -1) this._selected = null;

        var vts = this.getValueAndText(this._selecteds);
        this.value = vts[0];
        if (this._valueEl) this._valueEl.value = this.value;
    },
    setMultiSelect: function (value) {
        this.multiSelect = value;
    },
    getMultiSelect: function () {
        return this.multiSelect;
    },
    isSelected: function (record) {
        if (!record) return false;
        return this._selecteds.indexOf(record) != -1;
    },
    getSelecteds: function () {
        var arr = this._selecteds.clone();
        var me = this;

        //按序号排序
        if (this.valueInCheckOrder) {
            mini.sort(arr, function (a, b) {
                var index1 = me.indexOf(a);
                var index2 = me.indexOf(b);
                if (index1 > index2) return 1;
                if (index1 < index2) return -1;
                return 0;
            });
        }

        //        mini.sort(arr, function (a, b) {
        //            var index1 = me.indexOf(a);
        //            var index2 = me.indexOf(b);
        //            if (index1 < index2) return 1;
        //            //if (index1 < index2) return -1;
        //            return 0;
        //        });
        return arr;
    },
    setSelected: function (record) {
        if (record) {
            this._selected = record;
            this.select(record);
        }
    },
    getSelected: function () {
        return this._selected;
    },
    select: function (record) {
        record = this.getItem(record);
        if (!record) return;
        if (this.isSelected(record)) return;
        this._selected = record;
        this.selects([record]);
    },
    deselect: function (record) {
        record = this.getItem(record);
        if (!record) return;
        if (!this.isSelected(record)) return;
        this.deselects([record]);
    },
    selectAll: function () {
        var data = this.data.clone();
        this.selects(data);
    },
    deselectAll: function () {
        this.deselects(this._selecteds);
    },
    clearSelect: function () {
        this.deselectAll();
    },
    selects: function (records) {
        if (!records || records.length == 0) return;
        records = records.clone();
        if (this.multiSelect == false && records.length > 1) {
            records.length = 1;
        }
        for (var i = 0, l = records.length; i < l; i++) {
            var record = records[i];
            //if (record.enabled === false) continue;
            if (!this.isSelected(record)) {
                this._selecteds.push(record);
            }
        }
        var me = this;
        //setTimeout(function () {
        me._doSelects();
        //}, 1);
    },
    deselects: function (records) {
        if (!records || records.length == 0) return;
        records = records.clone();
        for (var i = records.length - 1; i >= 0; i--) {
            var record = records[i];
            if (this.isSelected(record)) {
                this._selecteds.remove(record);
            }
        }

        var me = this;
        //setTimeout(function () {
        me._doSelects();
        //}, 1);
    },
    _doSelects: function () {
        var vts = this.getValueAndText(this._selecteds);
        this.value = vts[0];
        if (this._valueEl) this._valueEl.value = this.value;
        // 仅当dom已经挂载才需要同步
        if (!jQuery.contains(document.body, this.el)) {
            return;
        }
        for (var i = 0, l = this.data.length; i < l; i++) {
            var record = this.data[i];
            var select = this.isSelected(record);
            if (select) {
                this.addItemCls(record, this._itemSelectedCls);
            } else {
                this.removeItemCls(record, this._itemSelectedCls);
            }

            // 仅当开启checkbox 才需要做checkbox的状态同步
            if (this.showCheckBox) {
                var index = this.data.indexOf(record);
                var id = this._createCheckId(index);
                //var checkbox = document.getElementById(id);
                var checkbox = mini.byId(id, this.el);
                if (checkbox) checkbox.checked = !!select;
            }
        }
    },
    _OnSelectionChanged: function (records, select) {
        var vts = this.getValueAndText(this._selecteds);
        this.value = vts[0];
        if (this._valueEl) this._valueEl.value = this.value;

        var e = {
            selecteds: this.getSelecteds(),
            selected: this.getSelected(),
            value: this.getValue()
        };
        this.fire('SelectionChanged', e);

        //if (this._doCheckState) this._doCheckState();
    },
    _createCheckId: function (index) {
        return this.uid + '$ck$' + index;
    },
    _createItemId: function (index) {
        return this.uid + '$' + index;
    },

    /////////////////////////////////////////////
    __OnClick: function (e) {
        if (this._clickTime) {
            if (new Date() - this._clickTime < 100) return;
        }
        this._clickTime = new Date();

        this._fireEvent(e, 'Click');
    },
    __OnDblClick: function (e) {
        this._fireEvent(e, 'Dblclick');
    },
    __OnMouseDown: function (e) {
        this._fireEvent(e, 'MouseDown');
    },
    __OnMouseUp: function (e) {
        this._fireEvent(e, 'MouseUp');
    },
    __OnMouseMove: function (e) {
        this._fireEvent(e, 'MouseMove');
    },
    __OnMouseOver: function (e) {
        this._fireEvent(e, 'MouseOver');
    },
    __OnMouseOut: function (e) {
        this._fireEvent(e, 'MouseOut');
    },
    __OnKeyDown: function (e) {
        this._fireEvent(e, 'KeyDown');
    },
    __OnKeyUp: function (e) {
        this._fireEvent(e, 'KeyUp');
    },
    __OnContextMenu: function (e) {
        this._fireEvent(e, 'ContextMenu');
    },
    _fireEvent: function (e, name) {
        if (!this.enabled) return;
        //this.focus();

        var item = this.getItemByEvent(e);
        if (!item) return;
        var fn = this['_OnItem' + name];
        if (fn) {
            fn.call(this, item, e);
        } else {
            var eve = {
                item: item,
                htmlEvent: e
            };
            this.fire('item' + name, eve);
        }
    },

    allowDeselect: false,
    setAllowDeselect: function (value) {
        this.allowDeselect = value;
    },
    getAllowDeselect: function () {
        return this.allowDeselect;
    },

    _OnItemClick: function (item, e) {
        if (this.isReadOnly() || this.enabled == false || item.enabled === false) {
            e.preventDefault();
            return;
        }

        var value = this.getValue();

        var ev = {
            item: item,
            htmlEvent: e,
            cancel: false
        };

        this.fire('beforeselect', ev);

        var e = {
            item: item,
            htmlEvent: e,
            cancel: false
        };
        this.fire('beforeitemclick', e);
        if (e.cancel) return;

        if (ev.cancel == false) {
            this._oldValue = value;

            if (this.multiSelect) {
                if (this.isSelected(item)) {
                    this.deselect(item);
                    if (this._selected == item) {
                        this._selected = null;
                    }
                } else {
                    this.select(item);
                    this._selected = item;
                }

                if (item.__NullItem) {
                    this.deselectAll();
                    this._selected = null;
                }

                this._OnSelectionChanged();
            } else {
                //                if (!this.isSelected(item)) {
                //                    this.deselectAll();
                //                    this.select(item);
                //                    this._selected = item;
                //                    this._OnSelectionChanged();
                //                }

                if (!this.isSelected(item)) {
                    this.deselectAll();
                    this.select(item);
                    this._selected = item;
                    this._OnSelectionChanged();
                } else {
                    if (this.allowDeselect && this.multiSelect == false) {
                        this.deselectAll();
                        this._OnSelectionChanged();
                    }
                }
            }

            if (value != this.getValue()) {
                this._OnValueChanged();
            }
        }

        var e = {
            item: item,
            htmlEvent: e
        };
        this.fire('itemclick', e);
    },
    _blurOnOut: true,
    _OnItemMouseOut: function (item, e) {
        //mini.repaint(this.el);
        if (!this.enabled) return;
        if (this._blurOnOut) {
            this._blurItem();
        }
        var e = {
            item: item,
            htmlEvent: e
        };
        this.fire('itemmouseout', e);
    },
    _OnItemMouseMove: function (item, e) {
        //mini.repaint(this.el);
        if (!this.enabled || item.enabled === false) return;

        this._focusItem(item);
        var e = {
            item: item,
            htmlEvent: e
        };
        this.fire('itemmousemove', e);
    },
    onItemClick: function (fn, scope) {
        this.on('itemclick', fn, scope);
    },
    onItemMouseDown: function (fn, scope) {
        this.on('itemmousedown', fn, scope);
    },
    onBeforeLoad: function (fn, scope) {
        this.on('beforeload', fn, scope);
    },
    onLoad: function (fn, scope) {
        this.on('load', fn, scope);
    },
    onLoadError: function (fn, scope) {
        this.on('loaderror', fn, scope);
    },
    onPreLoad: function (fn, scope) {
        this.on('preload', fn, scope);
    },

    getText: function () {
        var selecteds = this.getSelecteds();
        if (selecteds.length == 0) return '';
        var text = [];
        for (var i = 0, l = selecteds.length; i < l; i++) {
            var item = selecteds[i];
            var textField = this.getTextField();
            text.push(item[textField]);
        }
        return text.join(',');
    },

    ////////////////////////////////////
    getAttrs: function (el) {
        var attrs = mini.ListControl.superclass.getAttrs.call(this, el);

        mini._ParseString(el, attrs, [
            'url',
            'data',
            'value',
            'textField',
            'valueField',
            'onitemclick',
            'onitemmousemove',
            'onselectionchanged',
            'onitemdblclick',
            'onbeforeload',
            'onload',
            'onloaderror',
            'ondataload',
            'onbeforeselect',
            'delimiter'
        ]);
        mini._ParseBool(el, attrs, ['multiSelect', 'valueInCheckOrder', 'allowDeselect']);

        var valueField = attrs.valueField || this.valueField;
        var textField = attrs.textField || this.textField;
        if (el.nodeName.toLowerCase() == 'select') {
            var data = [];
            for (var i = 0, l = el.length; i < l; i++) {
                var op = el.options[i];
                var o = {};
                o[textField] = op.text;
                o[valueField] = op.value;

                data.push(o);
            }
            if (data.length > 0) {
                attrs.data = data;
            }
        }

        return attrs;
    }
});

//__getText = function () {
//    var selecteds = this.getSelecteds();
//    if (selecteds.length == 0) return "";
//    var text = [];
//    for (var i = 0, l = selecteds.length; i < l; i++) {
//        var item = selecteds[i];
//        var textField = this.getTextField();
//        text.push(item[textField]);
//    }
//    return text.join(",")

//}

//mini.ListControl.prototype.getText = __getText

//mini.ListBox.prototype.getText = __getText

//mini.CheckBoxList.prototype.getText = __getText

//mini.RadioButtonList.prototype.getText = __getText

////////////////////////////////////////////////////////////////////////////////////////////////////
mini._Layouts = {};
mini.layout = function (el, mustLayout) {
    if (!mini.enableLayout) return;

    //if (!el || el == document || el == document.body) alert("layout");

    if (!document.body) return;

    //return;

    function doLayout(el) {
        if (!el) return;
        var control = mini.get(el);
        if (control) {
            //判断control的width和height，是否是绝对值。如果都是绝对值，则不doLayout
            if (control.doLayout) {
                if (!mini._Layouts[control.uid]) {
                    mini._Layouts[control.uid] = control;

                    //                    var el = control.getEl();
                    //                    var width = String(el.style.width);
                    //                    var height = String(el.style.height);
                    //                    if (!mini.isNumber(width) || !mini.isNumber(height)) {
                    //                        control.doLayout(false);
                    //                    }
                    if (mustLayout !== false || control.isFixedSize() == false) {
                        control.doLayout(false);
                    }

                    delete mini._Layouts[control.uid];
                }
            }
        } else {
            var cs = el.childNodes;
            if (cs) {
                for (var i = 0, l = cs.length; i < l; i++) {
                    var cel = cs[i];

                    //fix NPObject
                    try {
                        cel.toString();
                    } catch (ex) {
                        continue;
                    }

                    doLayout(cel);
                }
            }
        }
    }

    if (!el) el = document.body;

    //    if (el == document.body) {
    //
    //        alert("layout");
    //    }

    doLayout(el);

    if (el == document.body) {
        mini.layoutIFrames();

        //alert("layout");
    }
};

////////////////////////////////////////////////////////////////////////
//mini.applyTo = function (el) {
//    el = mini.byId(el);
//    if (!el) return this;
//    if (mini.get(el)) throw new Error("not applyTo a mini control");
//    //mini.setAttr(el, "parse", 1);

//    var temp = null;
//    if (el && el != this.el) {
//        temp = document.createTextNode("");
//        jQuery(el).before(temp).remove();
//    }

//    var config = this.getAttrs(el);
//    delete config._applyTo;

//    if (mini.isNull(config.defaultValue) && !mini.isNull(config.value)) {
//        config.defaultValue = config.value;
//    }

//    if (mini.isNull(config.defaultText) && !mini.isNull(config.text)) {
//        config.defaultText = config.text;
//    }

//    if (temp) {
//        jQuery(temp).before(this.el).remove();
//    }
//    //    var p = el.parentNode;
//    //    if (p && this.el != el) {    //
//    //        //            var script1 = document.getElementById("script1");
//    //        //            alert(script1);
//    //        //            document.body.appendChild(script1);

//    //        p.replaceChild(this.el, el);

//    //        //                        p.insertBefore(this.el, el);
//    //        //                        p.removeChild(el);

//    //    }

//    this.set(config);

//    //this.doLayout();

//    this._afterApply(el);

//    return this;
//}

//_mini_set = function (config, control) {
//
//}

mini.applyTo = function (el) {
    el = mini.byId(el);
    if (!el) return this;
    if (mini.get(el)) throw new Error('not applyTo a mini control');
    //mini.setAttr(el, "parse", 1);

    var config = this.getAttrs(el);
    delete config._applyTo;

    if (mini.isNull(config.defaultValue) && !mini.isNull(config.value)) {
        config.defaultValue = config.value;
    }

    if (mini.isNull(config.defaultText) && !mini.isNull(config.text)) {
        config.defaultText = config.text;
    }

    var p = el.parentNode;
    if (p && this.el != el) {
        //
        //            var script1 = document.getElementById("script1");
        //            alert(script1);
        //            document.body.appendChild(script1);

        p.replaceChild(this.el, el);

        //                        p.insertBefore(this.el, el);
        //                        p.removeChild(el);
    }

    if (window._mini_set) _mini_set(config, this); //预处理属性设置

    this.set(config);

    //this.doLayout();

    this._afterApply(el);

    return this;
};
mini._doParse = function (el) {
    if (!el) return;

    //if (el == document.body) alert("parse");

    var nodeName = el.nodeName.toLowerCase();
    if (!nodeName) return;

    if (jQuery(el).attr('noparser') != null) return;

    //if(el.id == "twin_constrainttype") debugger
    var className = String(el.className);
    if (className) {
        var control = mini.get(el);
        if (!control) {
            var classes = className.split(' ');
            for (var i = 0, l = classes.length; i < l; i++) {
                var cls = classes[i];
                var clazz = mini.getClassByUICls(cls);
                if (clazz) {
                    mini.removeClass(el, cls);
                    var ui = new clazz();

                    mini.applyTo.call(ui, el);
                    el = ui.el;
                    break;
                }
            }
        }
    }

    if (
        nodeName == 'select' ||
        mini.hasClass(el, 'mini-menu') ||
        mini.hasClass(el, 'mini-datagrid') ||
        mini.hasClass(el, 'mini-treegrid') ||
        mini.hasClass(el, 'mini-tree') ||
        mini.hasClass(el, 'mini-button') ||
        mini.hasClass(el, 'mini-textbox') ||
        mini.hasClass(el, 'mini-buttonedit')
    ) {
        return;
    }

    var children = mini.getChildNodes(el, true);
    for (var i = 0, l = children.length; i < l; i++) {
        var node = children[i];
        if (node.nodeType == 1) {
            if (node.parentNode == el) {
                mini._doParse(node);
            }
        }
    }
};
mini._Removes = [];
mini._firstParse = true;
//mini._rootParsing = false;

mini.parse = function (el, layout) {
    //if (el == document.body) alert("parse");

    mini.parsed = true;

    //    if (mini._rootParsing) return;
    //    if (!el || el == document || el == document.body) mini._rootParsing = true;
    if (mini._firstParse) {
        mini._firstParse = false;
        //alert(2);
        var _doms = document.getElementsByTagName('iframe');
        var doms = [];
        for (var i = 0, l = _doms.length; i < l; i++) {
            var d = _doms[i];
            doms.push(d);
        }

        for (var i = 0, l = doms.length; i < l; i++) {
            var d = doms[i];
            var src = jQuery(d).attr('src');
            if (!src) continue;
            //jQuery(d).unbind("load");
            //d.parentNode.removeChild(d);

            //alert(jQuery(d).attr("src"));

            d.loaded = false;

            d._onload = d.onload;
            d._src = src;
            d.onload = function () {};
            d.src = '';

            //d.style.display = "none";
            //            var t = document.createElement("div");
            //            t.innerHTML = 't';
            //            jQuery(d).before(t);

            //d._t = t;
            //d.src = "about:blank";
            //d.src = false;
        }
        setTimeout(function () {
            for (var i = 0, l = doms.length; i < l; i++) {
                var d = doms[i];

                if (d._src && jQuery(d).attr('src') == '') {
                    d.loaded = true;
                    d.onload = d._onload;
                    d.src = d._src;
                    d._src = d._onload = null;

                    //jQuery(d._t).before(d);
                    //d._t.parentNode.replaceChild(d, d._t);
                }
            }
        }, 20);

        setTimeout(function () {
            for (var i = 0, l = doms.length; i < l; i++) {
                var d = doms[i];
                var src = jQuery(d).attr('data-src');
                if (src) {
                    d.src = src;
                }
            }
        }, 30);
    }
    //document.body.style.display = "block";
    if (typeof el == 'string') {
        var id = el;
        el = mini.byId(id);
        if (!el) el = document.body;
        //        if (!el) {
        //            var context = mini._getParseContext();
        //            if (context && context != document.body) {
        //                el = jQuery("#" + id, context)[0];
        //            }
        //            if (!el) return;
        //        }
    }
    if (el && !mini.isElement(el)) el = el.el;
    if (!el) el = document.body;
    //if (!context) context = el;

    var visible = mini.WindowVisible;
    if (isIE) {
        mini.WindowVisible = false;
    }

    //var sss = new Date();

    mini._doParse(el);
    //  alert(new Date() - sss);
    mini.WindowVisible = visible;

    //    for (var i = mini._Removes.length - 1; i >= 0; i--) {
    //        var el = mini._Removes[i];
    //        var p = el.parentNode;
    //        if (p) p.removeChild(el);
    //        mini._Removes.removeAt(i);
    //    }
    if (layout !== false) {
        mini.layout(el);
        //alert(1);
    }

    //    mini._rootParsing = false;
};

mini._ParseString = function (el, config, attrs) {
    for (var i = 0, l = attrs.length; i < l; i++) {
        var property = attrs[i];
        //if(property == "onclick") debugger
        var value = mini.getAttr(el, property);
        if (value) {
            config[property] = value;
        }
    }
};
mini._ParseBool = function (el, config, attrs) {
    for (var i = 0, l = attrs.length; i < l; i++) {
        var property = attrs[i];
        var value = mini.getAttr(el, property);
        if (value) {
            config[property] = value == 'true' ? true : false;
        } else if (value === '') {
            config[property] = true;
        }
    }
};
mini._ParseInt = function (el, config, attrs) {
    for (var i = 0, l = attrs.length; i < l; i++) {
        var property = attrs[i];
        //if(property == "maxLength") debugger
        var value = parseInt(mini.getAttr(el, property));
        if (!isNaN(value)) {
            config[property] = value;
        }
    }
};

//暂时不特殊处理IE：在IE7下，width/height/style等属性需要特殊处理。这个也节省不了多少时间。
//轻易不要修改，关联影响的东西挺多的
//if (jQuery.browser.msie) {
//    //getAttribute 方法确实提高了一些. IE专用
//    mini._ParseString = function (el, config, attrs) {
//        for (var i = 0, l = attrs.length; i < l; i++) {
//            var property = attrs[i];
//            var value = null;
//            var a = el.attributes[property];
//            if (a) value = a.value;
//            //if(
//            if (value) {
//                config[property] = value;
//            }
//        }
//    }
//    mini._ParseBool = function (el, config, attrs) {
//        for (var i = 0, l = attrs.length; i < l; i++) {
//            var property = attrs[i];
//            var value = null;
//            var a = el.attributes[property];
//            if (a) value = a.value;
//            if (value) {
//                config[property] = value == "true" ? true : false;
//            }
//        }
//    }
//    mini._ParseInt = function (el, config, attrs) {
//        for (var i = 0, l = attrs.length; i < l; i++) {
//            var property = attrs[i];
//            var value = null;
//            var a = el.attributes[property];
//            if (a) value = a.value;
//            value = parseInt(value);
//            if (!isNaN(value)) {
//                config[property] = value;
//            }
//        }
//    }
//}
mini._ParseColumns = function (el) {
    var columns = [];
    var cs = mini.getChildNodes(el);
    for (var i = 0, l = cs.length; i < l; i++) {
        var node = cs[i];
        //var jq = jQuery(node);

        var column = {};

        var editor = null,
            filter = null;

        //sub columns
        var subCs = mini.getChildNodes(node);
        if (subCs) {
            for (var ii = 0, li = subCs.length; ii < li; ii++) {
                var subNode = subCs[ii];
                //var property = jQuery(subNode).attr("property");
                var property = mini.getAttr(subNode, 'property');
                if (!property) continue;
                property = property.toLowerCase();
                if (property == 'columns') {
                    column.columns = mini._ParseColumns(subNode);
                    //jQuery(subNode).remove();
                    if (subNode.parentNode) subNode.parentNode.removeChild(subNode);
                }
                if (property == 'editor' || property == 'filter') {
                    var className = subNode.className;
                    var classes = className.split(' ');
                    for (var i3 = 0, l3 = classes.length; i3 < l3; i3++) {
                        var cls = classes[i3];
                        var clazz = mini.getClassByUICls(cls);
                        if (clazz) {
                            var ui = new clazz();

                            if (property == 'filter') {
                                filter = ui.getAttrs(subNode);
                                filter.type = ui.type;
                            } else {
                                editor = ui.getAttrs(subNode);
                                editor.type = ui.type;
                            }
                            break;
                        }
                    }

                    //jQuery(subNode).remove();
                    if (subNode.parentNode) subNode.parentNode.removeChild(subNode);
                }
            }
        }

        column.header = node.innerHTML;

        //if (column.header == "资源名称") debugger

        mini._ParseString(node, column, [
            'name',
            'header',
            'field',
            'editor',
            'filter',
            'renderer',
            'width',
            'type',
            'renderer',
            'headerAlign',
            'align',
            'headerCls',
            'cellCls',
            'headerStyle',
            'cellStyle',
            'displayField',
            'dateFormat',
            'listFormat',
            'mapFormat',
            'numberFormat',
            'trueValue',
            'falseValue',
            'dataType',
            'vtype',
            'requiredErrorText',
            'currencyUnit',
            'summaryType',
            'summaryRenderer',
            'groupSummaryType',
            'groupSummaryRenderer',
            'defaultValue',
            'defaultText',
            'decimalPlaces',
            'data-options',
            'sortField',
            'sortType'
        ]);
        mini._ParseBool(node, column, [
            'allowCellWrap',
            'visible',
            'readOnly',
            'allowSort',
            'allowResize',
            'allowMove',
            'allowDrag',
            'autoShowPopup',
            'unique',
            'autoEscape',
            'enabled',
            'hideable',
            'showCellTip',
            'valueFromSelect',
            'navUpdown'
        ]);
        mini._ParseInt(node, column, ['minWidth']);
        //if(column.field == "loginname") debugger
        if (editor) column.editor = editor;
        if (filter) column.filter = filter;

        if (typeof column.editor == 'string') {
            try {
                column.editor = window['ev' + 'al']('(' + column.editor + ')');
            } catch (e) {}
        }

        if (column.dataType) column.dataType = column.dataType.toLowerCase();

        if (column.defaultValue === 'true') column.defaultValue = true;
        if (column.defaultValue === 'false') column.defaultValue = false;

        columns.push(column);

        //data-options
        var options = column['data-options'];
        if (options) {
            options = window['ev' + 'al']('(' + options + ')');
            if (options) {
                //attrs["data-options"] = options;
                mini.copyTo(column, options);
            }
        }
    }

    return columns;
};

/* Grid Columns
-----------------------------------------------------------------------------*/

mini._Columns = {};
mini._getColumn = function (columnType) {
    var columnFn = mini._Columns[columnType.toLowerCase()];
    if (!columnFn) return {};
    return columnFn();
};

//IndexColumn
mini.IndexColumn = function (config) {
    return mini.copyTo(
        {
            ignoreCollapseIndex: false,
            width: 30,
            cellCls: '',
            align: 'center',
            draggable: false,
            allowDrag: true,
            hideable: true,
            init: function (grid) {
                grid.on('addrow', this.__OnIndexChanged, this);
                grid.on('removerow', this.__OnIndexChanged, this);
                grid.on('moverow', this.__OnIndexChanged, this);

                //treegrid
                if (grid.isTree) {
                    grid.on('addnode', this.__OnIndexChanged, this);
                    grid.on('removenode', this.__OnIndexChanged, this);
                    grid.on('movenode', this.__OnIndexChanged, this);

                    grid.on('loadnode', this.__OnIndexChanged, this);
                    this._gridUID = grid.uid;
                    this._rowIdField = '_id';
                }
            },
            getNumberId: function (record) {
                return this._gridUID + '$number$' + record[this._rowIdField];
            },
            createNumber: function (grid, rowIndex) {
                if (mini.isNull(grid.pageIndex)) {
                    return rowIndex + 1;
                } else return grid.pageIndex * grid.pageSize + rowIndex + 1;
            },
            renderer: function (e) {
                var grid = e.sender;
                if (this.draggable) {
                    if (!e.cellStyle) e.cellStyle = '';
                    e.cellStyle += ';cursor:move;';
                }
                var s = '<div id="' + this.getNumberId(e.record) + '">';
                var rowIndex = e.rowIndex;

                if (this.ignoreCollapseIndex) {
                    //rowIndex =
                }

                if (mini.isNull(grid.getPageIndex)) s += rowIndex + 1;
                else s += grid.getPageIndex() * grid.getPageSize() + rowIndex + 1;

                s += '</div>';
                return s;
            },

            __updateRowNumbers: function (grid) {
                var records = grid.getDataView();

                for (var i = 0, l = records.length; i < l; i++) {
                    var record = records[i];
                    var id = this.getNumberId(record);
                    var ck = document.getElementById(id);
                    if (ck) ck.innerHTML = this.createNumber(grid, i);
                }
                //alert(1);
            },
            __OnIndexChanged: function (e) {
                var grid = e.sender;

                //            this.__updateRowNumbers(grid);
                //            return;
                var me = this;
                if (me._toIndex) return;
                me._toIndex = setTimeout(function () {
                    me._toIndex = null;
                    me.__updateRowNumbers(grid);
                }, 10);
            }
        },
        config
    );
};
mini._Columns['indexcolumn'] = mini.IndexColumn;

//CheckColumn
mini.CheckColumn = function (config) {
    return mini.copyTo(
        {
            width: 30,
            cellCls: 'mini-checkcolumn',
            headerCls: 'mini-checkcolumn',
            hideable: true,
            _multiRowSelect: true, //
            header: function (column) {
                //if(this.multiSelect == false) debugger
                //                var id = this.uid + "checkall";
                //                var s = '<input type="checkbox" id="' + id + '" ' + (column._checkedAll ? 'checked' : '') + '/>';
                //                if (this.multiSelect == false) s = "";
                //                return s;

                var id = this.uid + 'checkall';
                var cls = column._checkedAll ? 'mini-grid-checkbox-checked' : '';
                var s = '<span class="mini-grid-checkbox mini-icon ' + cls + '" id="' + id + '"></span>';
                if (this.multiSelect == false) s = '';
                return s;
            },
            getCheckId: function (record, column) {
                return this._gridUID + '$checkcolumn$' + record[this._rowIdField] + '$' + column._id;
            },
            init: function (grid) {
                grid.on('_selectchange', this.__OnSelectionChanged, this);
                grid.on('HeaderCellClick', this.__OnHeaderCellClick, this);

                var me = this;
                grid.on('removerow', function () {
                    if (grid.data && grid.data.length == 0) {
                        me._doCheckState(grid);
                    }
                });

                var me = this;
                grid.on(
                    'load',
                    function () {
                        var id = grid.uid + 'checkall';
                        //$("#" + id).removeClass('mini-grid-checkbox-checked');
                        me._doCheckState(grid);
                    },
                    this
                );
            },
            renderer: function (e) {
                var id = this.getCheckId(e.record, e.column);
                var selected = e.sender.isSelected ? e.sender.isSelected(e.record) : false;

                var type = 'checkbox';

                //                var grid = e.sender;
                //                if (grid.getMultiSelect() == false) type = "radio";

                //                var html = '<input type="' + type + '" id="' + id + '" ' + (selected ? "checked" : "") + ' hidefocus style="outline:none;" onclick="return false"/>';
                //                html += '<div class="mini-grid-radio-mask"></div>';
                //                return html;

                var grid = e.sender;
                var html =
                    '<span class="mini-grid-' +
                    (grid.getMultiSelect() ? 'checkbox' : 'radio') +
                    ' mini-icon" id="' +
                    id +
                    '"></span>';
                return html;
            },
            __OnHeaderCellClick: function (e) {
                var grid = e.sender;
                if (e.column != this) return;
                var id = grid.uid + 'checkall';
                var ck = document.getElementById(id);
                if (ck) {
                    var checkedCls = 'mini-grid-checkbox-checked';
                    var checked = !mini.hasClass(ck, checkedCls);
                    this._checkedAll = checked;

                    if (grid.getMultiSelect()) {
                        if (checked) {
                            var list = grid.getDataView();
                            grid.selects(list);
                            mini.addClass(ck, checkedCls);
                            setTimeout(function () {
                                mini.addClass(ck, checkedCls);
                            }, 30);
                        } else {
                            var list = grid.getDataView();
                            grid.deselects(list);
                            mini.removeClass(ck, checkedCls);
                        }
                    } else {
                        grid.deselectAll();
                        if (checked) {
                            grid.select(0);
                            mini.addClass(ck, checkedCls);
                        }
                    }
                    grid.fire('checkall');
                }
            },
            __OnSelectionChanged: function (e) {
                var grid = e.sender;
                var records = grid.toArray();
                var me = this;

                var virtual = grid.isVirtualScroll(),
                    region = grid._viewRegion,
                    start = virtual && region ? region.start : -1,
                    end = region ? region.end : -1,
                    map = {};

                if (start != -1) {
                    var data = grid.getVisibleRows();
                    for (var i = start, l = end; i < l; i++) {
                        var row = data[i];
                        if (row) map[row._id] = true;
                    }
                }

                for (var i = 0, l = records.length; i < l; i++) {
                    var record = records[i];

                    //continue;
                    if (start != -1) {
                        if (!map[record._id]) continue;
                    }

                    //                    var select = grid.isSelected(record);
                    //                    var id = me.getCheckId(record, me); //grid.uid + "$checkcolumn$" + record[grid._rowIdField];
                    //                    var ck = document.getElementById(id);

                    //                    if (ck) ck.checked = select;
                }

                if (!this._timer) {
                    this._timer = setTimeout(function () {
                        me._doCheckState(grid);
                        me._timer = null;
                    }, 10);
                }
            },
            _doCheckState: function (grid) {
                //处理顶部的checkbox
                var id = grid.uid + 'checkall';
                var ck = document.getElementById(id);

                if (ck) {
                    var sels = grid.getSelecteds();
                    //if (sels.length == grid.getData().length) {

                    var len = grid.isTree ? grid.getList().length : grid.getData().length;

                    if (sels.length == len && len != 0) {
                        //if (sels.length == len){
                        //ck.checked = true;
                        jQuery(ck).addClass('mini-grid-checkbox-checked');
                    } else {
                        //ck.checked = false;
                        jQuery(ck).removeClass('mini-grid-checkbox-checked');
                    }
                }

                //                if (ck && grid._getSelectAllCheckState) {

                //                    var state = grid._getSelectAllCheckState();
                //                    if (state == "has") {
                //                        ck.indeterminate = true;
                //                        ck.checked = true;
                //                    } else {
                //                        ck.indeterminate = false;
                //                        ck.checked = state;
                //                    }
                //                }
            }
        },
        config
    );
};
mini._Columns['checkcolumn'] = mini.CheckColumn;

//ExpandColumn
mini.ExpandColumn = function (config) {
    return mini.copyTo(
        {
            width: 30,
            headerAlign: 'center',
            align: 'center',
            draggable: false,
            cellStyle: 'padding:0',
            cellCls: 'mini-grid-expandCell',
            hideable: true,
            renderer: function (e) {
                return '<a class="mini-grid-ecIcon mini-icon" href="javascript:#" onclick="return false"></a>';
            },
            init: function (grid) {
                grid.on('cellclick', this.__OnCellClick, this);
            },
            __OnCellClick: function (e) {
                var grid = e.sender;
                if (e.column == this && grid.isShowRowDetail) {
                    if (mini.findParent(e.htmlEvent.target, 'mini-grid-ecIcon')) {
                        var isShow = grid.isShowRowDetail(e.record);

                        if (!isShow) {
                            e.cancel = false;
                            grid.fire('beforeshowrowdetail', e);
                            if (e.cancel === true) return;
                        } else {
                            e.cancel = false;
                            grid.fire('beforehiderowdetail', e);
                            if (e.cancel === true) return;
                        }

                        if (grid.autoHideRowDetail) {
                            grid.hideAllRowDetail();
                        }
                        if (isShow) {
                            grid.hideRowDetail(e.record);
                        } else {
                            grid.showRowDetail(e.record);
                        }
                    }
                }
            }
        },
        config
    );
};
mini._Columns['expandcolumn'] = mini.ExpandColumn;

//checkboxcolumn
mini.CheckBoxColumn = function (config) {
    return mini.copyTo(
        {
            _type: 'checkboxcolumn',
            editMode: 'inline', //inlineEdit: true?
            header: '',
            headerAlign: 'center',
            //cellCls: "mini-checkcolumn",
            trueValue: true,
            falseValue: false,
            readOnly: false,
            getCheckId: function (record, column) {
                return this._gridUID + '$checkbox$' + record[this._rowIdField] + '$' + column._id;
            },
            getCheckBoxEl: function (record, column) {
                return document.getElementById(this.getCheckId(record, column));
            },
            isChecked: function (record, column) {
                var ck = this.getCheckBoxEl(record, column);
                return jQuery(ck).hasClass('mini-grid-checkbox-checked');
            },
            renderer: function (e) {
                var id = this.getCheckId(e.record, e.column);
                //var v = e.record[e.field];
                var v = mini._getMap(e.field, e.record);
                if (typeof v === 'string') {
                    v = v === 'true' ? true : v === 'false' ? false : v;
                }
                var checked = v == this.trueValue ? true : false;
                //var type = "checkbox";

                //if (this.grid.multiSelect == false) type = "radio";
                //return '<input type="' + type + '" id="' + id + '" ' + (checked ? "checked" : "") + ' hidefocus style="outline:none;" onclick="return false;"/>';

                return (
                    '<span  id="' +
                    id +
                    '" class="mini-grid-checkbox mini-icon ' +
                    (checked ? 'mini-grid-checkbox-checked' : '') +
                    '"></span>'
                );
            },
            //        __getValue: function (v) {
            //            var value = v == this.trueValue ? this.falseValue : this.trueValue;
            //            return value;
            //        },
            init: function (grid) {
                this.grid = grid;
                function oneditchange(e) {
                    if (grid.isReadOnly() || this.readOnly) return;
                    var v = mini._getMap(e.field, e.record); //e.record[e.field];
                    if (typeof v === 'string') {
                        v = v === 'true' ? true : v === 'false' ? false : v;
                    }
                    e.value = v;
                    grid.fire('cellbeginedit', e);

                    if (e.cancel !== true) {
                        //                    var v = mini._getMap(e.column.field, e.record);
                        //                    var value = v == this.trueValue ? this.falseValue : this.trueValue;
                        //alert(value);
                        var value = v == this.trueValue ? this.falseValue : this.trueValue;

                        if (grid._OnCellCommitEdit) {
                            grid._OnCellCommitEdit(e.record, e.column, value);
                            grid._OnCellEndEdit(e.record, e.column);
                            //                                var checked = value == this.trueValue;
                            //                                setTimeout(function () {
                            //                                    ck.checked = checked;
                            //                                    alert(checked);
                            //                                }, 1);
                        }
                    }
                }
                function onEdit(e) {
                    if (e.column == this) {
                        var id = this.getCheckId(e.record, e.column);
                        var ck = e.htmlEvent.target;
                        if (ck.id == id) {
                            if (grid.allowCellEdit) {
                                e.cancel = false;
                                oneditchange.call(this, e);
                            } else {
                                if (this.readOnly) return;
                                e.value = mini._getMap(e.column.field, e.record); //e.record[e.field];
                                grid.fire('cellbeginedit', e);
                                if (e.cancel == true) return;
                                if (grid.isEditingRow && grid.isEditingRow(e.record)) {
                                    setTimeout(function () {
                                        //ck.checked = !ck.checked;

                                        jQuery(ck).toggleClass('mini-grid-checkbox-checked');
                                    }, 1);
                                }
                            }
                        }
                    }
                }
                grid.on('cellclick', onEdit, this);
                mini.on(
                    this.grid.el,
                    'keydown',
                    function (e) {
                        if (e.keyCode == 32 && grid.allowCellEdit) {
                            var currentCell = grid.getCurrentCell();
                            if (!currentCell) return;
                            if (currentCell[1] != this) return;

                            var ex = { record: currentCell[0], column: currentCell[1] };
                            ex.field = ex.column.field;

                            oneditchange.call(this, ex);
                            e.preventDefault();
                        }
                    },
                    this
                );

                var tv = parseInt(this.trueValue),
                    fv = parseInt(this.falseValue);
                if (!isNaN(tv)) this.trueValue = tv;
                if (!isNaN(fv)) this.falseValue = fv;

                if (this.trueValue == 'true') this.trueValue = true;
                if (this.falseValue == 'false') this.falseValue = false;
            }
        },
        config
    );
};
mini._Columns['checkboxcolumn'] = mini.CheckBoxColumn;

//radiobuttoncolumn
mini.RadioButtonColumn = function (config) {
    return mini.copyTo(
        {
            _type: 'radiobuttoncolumn',
            editMode: 'inline',
            header: '',
            headerAlign: 'center',
            //cellCls: "mini-checkcolumn",
            trueValue: true,
            falseValue: false,
            readOnly: false,
            getCheckId: function (record, column) {
                return this._gridUID + '$radio$' + record[this._rowIdField] + '$' + column._id;
            },
            getCheckBoxEl: function (record, column) {
                return document.getElementById(this.getCheckId(record, column));
            },
            renderer: function (e) {
                var grid = e.sender;
                var id = this.getCheckId(e.record, e.column);
                var v = mini._getMap(e.field, e.record);
                var checked = v == this.trueValue ? true : false;
                var type = 'radio';
                var name = grid._id + e.column.field;

                var disabled = '';
                //            if (!grid.allowCellEdit) {
                //                disabled = ' disabled ';
                //            }
                //            var s = '<div style="position:relative;">';
                //            s += '<input name="' + name + '" type="' + type + '" id="' + id + '" ' + (checked ? "checked" : "") + ' hidefocus style="outline:none;" onclick="return false;" style="position:relative;z-index:1;"/>';
                //            if (!grid.allowCellEdit) {
                //                if (!grid.isEditingRow(e.record)) {
                //                    s += '<div class="mini-grid-radio-mask"></div>';
                //                }
                //            }
                //            s += '</div>';
                //            return s;

                return (
                    '<span id="' +
                    id +
                    '" class="mini-icon mini-grid-radio ' +
                    (checked ? 'mini-grid-radio-checked' : '') +
                    '"></span>'
                );
            },
            //        __getValue: function (v) {
            //            var value = v == this.trueValue ? this.falseValue : this.trueValue;
            //            return value;
            //        },
            init: function (grid) {
                this.grid = grid;

                function oneditchange(e) {
                    if (grid.isReadOnly() || this.readOnly) return;
                    e.value = mini._getMap(e.field, e.record); //e.record[e.field];
                    grid.fire('cellbeginedit', e);

                    if (e.cancel !== true) {
                        var v = mini._getMap(e.column.field, e.record);
                        if (v == this.trueValue) return;
                        var value = v == this.trueValue ? this.falseValue : this.trueValue;

                        //将其他行设置false
                        var data = grid.getData();

                        for (var i = 0, l = data.length; i < l; i++) {
                            var row = data[i];
                            if (row == e.record) continue;
                            var v = mini._getMap(e.column.field, row);
                            if (v != this.falseValue) {
                                //var o = {};
                                //mini._setMap(e.column.field, this.falseValue, o);

                                grid.updateRow(row, e.column.field, this.falseValue);
                            }
                        }

                        if (grid._OnCellCommitEdit) {
                            grid._OnCellCommitEdit(e.record, e.column, value);

                            grid._OnCellEndEdit(e.record, e.column);
                        }
                    }
                }
                function onEdit(e) {
                    if (e.column == this) {
                        var id = this.getCheckId(e.record, e.column);
                        var ck = e.htmlEvent.target;
                        if (ck.id == id) {
                            if (grid.allowCellEdit) {
                                e.cancel = false;
                                oneditchange.call(this, e);
                            } else {
                                if (grid.isEditingRow && grid.isEditingRow(e.record)) {
                                    var that = this;
                                    setTimeout(function () {
                                        ck.checked = true;

                                        //将其他行设置false
                                        var data = grid.getData();
                                        for (var i = 0, l = data.length; i < l; i++) {
                                            var row = data[i];
                                            if (row == e.record) continue;
                                            var field = e.column.field;
                                            var v = mini._getMap(field, row);
                                            if (v != that.falseValue) {
                                                if (row != e.record) {
                                                    if (grid._dataSource) {
                                                        mini._setMap(e.column.field, that.falseValue, row);
                                                        grid._dataSource._setModified(row, field, v);
                                                    } else {
                                                        var o = {};
                                                        mini._setMap(field, that.falseValue, o);
                                                        grid._doUpdateRow(row, o);
                                                    }
                                                }
                                            }
                                        }
                                    }, 1);
                                }
                            }
                        }
                    }
                }
                grid.on('cellclick', onEdit, this);

                mini.on(
                    this.grid.el,
                    'keydown',
                    function (e) {
                        if (e.keyCode == 32 && grid.allowCellEdit) {
                            var currentCell = grid.getCurrentCell();
                            if (!currentCell) return;
                            if (currentCell[1] != this) return;
                            var ex = { record: currentCell[0], column: currentCell[1] };
                            ex.field = ex.column.field;
                            oneditchange.call(this, ex);
                            e.preventDefault();
                        }
                    },
                    this
                );

                var tv = parseInt(this.trueValue),
                    fv = parseInt(this.falseValue);
                if (!isNaN(tv)) this.trueValue = tv;
                if (!isNaN(fv)) this.falseValue = fv;
            }
        },
        config
    );
};
mini._Columns['radiobuttoncolumn'] = mini.RadioButtonColumn;

function listColumnRenderer(e) {
    var column = e.column,
        record = e.record,
        displayField = column.displayField,
        value = !mini.isNull(e.value) ? String(e.value) : '',
        values = value.split(','),
        valueField = 'id',
        textField = 'text',
        valueMaps = {},
        editor = column.editor,
        editorEl = column.editorEl,
        _editor = column.__editor;

    if (!_editor) {
        // 懒加载型的 editor
        if (!editor && editorEl) {
            var className = editorEl.className;
            var classes = className.split(' ');
            classes.some(function (cls) {
                var clazz = mini.getClassByUICls(cls);
                if (!clazz) return;

                var ui = new clazz();
                editor = ui.getAttrs(editorEl);
                editor.type = ui.type;
                return true;
            });
        }

        if (editor) {
            if (mini.isControl(editor)) {
                _editor = editor;
            } else {
                editor = mini.clone(editor);
                editor.autoLoad = true;  // autoLoad 必须为 true，否则无法加载数据
                _editor = mini.create(editor);          //如果没有editor控件对象，则马上创建，并同步加载数据

                if(window.epoint && window.epoint.getCache 
                    && window.Util && window.Util.getRightUrl 
                    && window.DtoUtils && window.DtoUtils.bindBeforeLoad
                    && !_editor.url && _editor.action) {
                    var index = _editor.action.indexOf('.'),
                        pageAction = index > -1 ? _editor.action.substring(0, index) : epoint.getCache('action'),
                        controlAction = _editor.action.substring(index + 1);

                    if(pageAction) {
                        DtoUtils.bindBeforeLoad(_editor.el);
                        _editor.setUrl(Util.addUrlParams(Util.getRightUrl('rest/' + pageAction + '/' + controlAction), Util.getUrlParams()));
                    }
                }
            }
        }

        // 下拉列必须是 combobbox，treeselect 或子类
        if (mini.isInstanceOf(_editor, mini.ComboBox) || mini.isInstanceOf(_editor, mini.TreeSelect)) {
            e.column.__editor = _editor;
        } else {
            _editor = null;
        }
    }

    if (_editor) {
        valueField = _editor.getValueField();
        textField = _editor.getTextField();

        var data = _editor.getData();

        valueMaps = column._valueMaps;
        if (!valueMaps || data !== column._data) {
            var list = _editor.getList ? _editor.getList() : data; //如果是tree则用list生成valueMaps

            valueMaps = {};
            for (var i = 0, l = list.length; i < l; i++) {
                var o = list[i];
                valueMaps[o[valueField]] = o;
            }

            column._valueMaps = valueMaps;
            column._data = data;
        }
    }

    if (displayField) {
        return record[displayField];
    }
    var texts = [];
    for (var i = 0, l = values.length; i < l; i++) {
        // 由于record里面的数据都是对html编码的，但是combobox的data或者tree的list数据是不会编码的，所以这里需要还原record来进行查找
        var id = mini.htmlDecode(values[i]);
        var o = valueMaps[id];
        if (o) {
            var text = o[textField];
            if (text === null || text === undefined) {
                text = '';
            }
            texts.push(text);
        }
    }
    //if (texts.length == 0) debugger
    if (texts.length == 0 && column.valueFromSelect === false) {
        return value;
    }
    return texts.join(',');
}

//ComboBoxColumn
mini.ComboBoxColumn = function (config) {
    return mini.copyTo(
        {
            renderer: listColumnRenderer
        },
        config
    );
};
mini._Columns['comboboxcolumn'] = mini.ComboBoxColumn;

///////////////treeselectColumn/////////////////////////////////////////////////////////////
mini.TreeSelectColumn = function (config) {
    return mini.copyTo(
        {
            renderer: listColumnRenderer
        },
        config
    );
};
mini._Columns['treeselectcolumn'] = mini.TreeSelectColumn;

////ComboBoxColumn
//mini.ComboBoxColumn = function (config) {
//    return mini.copyTo(
//        {
//            renderer: function (e) {
//                var value = !mini.isNull(e.value) ? String(e.value) : "";
//                var values = value.split(",");

//                var valueField = "id", textField = "text";
//                var valueMaps = {};

//                var editor = e.column.editor;
//                if (editor && editor.type == "combobox") {
//                    var combo = this.__editor;
//                    if (!combo) {

//                        if (mini.isControl(editor)) {
//                            combo = editor;
//                        } else {
//                            editor = mini.clone(editor);
//                            combo = mini.create(editor); //必须同步加载combobox
//                        }
//                        this.__editor = combo;
//                    }

//                    valueField = combo.getValueField();
//                    textField = combo.getTextField();

//                    var data = combo.getData();
//                    valueMaps = this._valueMaps;
//                    if (!valueMaps || data !== this._data) {
//
//                        valueMaps = {};
//                        for (var i = 0, l = data.length; i < l; i++) {
//                            var o = data[i];
//                            valueMaps[o[valueField]] = o;
//                        }
//                        this._valueMaps = valueMaps;
//                        this._data = data;
//                    }
//                }

//                var texts = [];
//                for (var i = 0, l = values.length; i < l; i++) {
//                    var id = values[i];
//                    var o = valueMaps[id];
//                    if (o) {
//                        var text = o[textField];
//                        if (text === null || text === undefined) {
//                            text = "";
//                        }
//                        texts.push(text);
//                    }
//                }
//                return texts.join(',');
//            }
//        }, config);
//};
//mini._Columns["comboboxcolumn"] = mini.ComboBoxColumn;

/* Resizer
-----------------------------------------------------------------------------*/
mini._Resizer = function (grid) {
    this.owner = grid;
    mini.on(this.owner.el, 'mousedown', this.__OnMouseDown, this);
};
mini._Resizer.prototype = {
    __OnMouseDown: function (e) {
        var has = mini.hasClass(e.target, 'mini-resizer-trigger');
        if (has && this.owner.allowResize) {
            var drag = this._getResizeDrag();
            drag.start(e);
        }
    },
    _getResizeDrag: function () {
        if (!this._resizeDragger) {
            this._resizeDragger = new mini.Drag({
                capture: true,
                onStart: mini.createDelegate(this._OnDragStart, this),
                onMove: mini.createDelegate(this._OnDragMove, this),
                onStop: mini.createDelegate(this._OnDragStop, this)
            });
        }
        return this._resizeDragger;
    },
    _OnDragStart: function (drag) {
        this.mask = mini.append(document.body, '<div class="mini-resizer-mask mini-fixed"></div>');

        this.proxy = mini.append(document.body, '<div class="mini-resizer-proxy"></div>');
        this.proxy.style.cursor = 'se-resize';

        var el = this.owner.el;
        el.offsetWidth; //reflow

        this.elBox = mini.getBox(el);
        mini.setBox(this.proxy, this.elBox);
    },
    _OnDragMove: function (drag) {
        var grid = this.owner;
        var xOffset = drag.now[0] - drag.init[0];
        var yOffset = drag.now[1] - drag.init[1];

        var w = this.elBox.width + xOffset;
        var h = this.elBox.height + yOffset;
        if (w < grid.minWidth) w = grid.minWidth;
        if (h < grid.minHeight) h = grid.minHeight;
        if (w > grid.maxWidth) w = grid.maxWidth;
        if (h > grid.maxHeight) h = grid.maxHeight;

        mini.setSize(this.proxy, w, h);
    },
    _OnDragStop: function (drag, success) {
        if (!this.proxy) return;
        var box = mini.getBox(this.proxy);

        jQuery(this.mask).remove();
        jQuery(this.proxy).remove();
        this.proxy = null;
        this.elBox = null;

        if (success) {
            this.owner.setWidth(box.width);
            this.owner.setHeight(box.height);
            this.owner.fire('resize');
        }
    }
};

/////////////////////////////////////////
//function __UnLoadIFrame() {
//
//}
mini._topWindow = null;
mini._getTopWindow = function (hasMini) {
    if (mini._topWindow) return mini._topWindow;
    var ps = [];
    function getParents(me) {
        try {
            me['___try'] = 1; //chrome下设置不会异常
            if (me['___try'] == 1) ps.push(me); //取值时会有异常（这个技术是客户反馈的）
        } catch (ex) {}
        if (me.parent && me.parent != me) {
            getParents(me.parent);
        }
    }
    getParents(window);
    mini._topWindow = ps[ps.length - 1];
    return mini._topWindow;
};

var __ps = mini.getParams();

if (__ps._winid) {
    try {
        window.Owner = mini._getTopWindow()[__ps._winid];
    } catch (ex) {}
}

//if (window.Owner) {
//    setTimeout(function () {
//        alert(window.Owner.location);
//    }, 100);
//}

mini._WindowID = (function () {
    var num = '0000' + String(Math.floor(Math.random() * 10000));
    num = num.substring(num.length - 4);
    return 'w' + num;
})();
mini._getTopWindow()[mini._WindowID] = window;

mini.iframeParams = {}; //mini.iframeParams.MenuNo=52;

mini.createIFrame = function (url, onIFrameLoad, cache, method, params) {
    //alert(method + ":" + params);

    /*var iframe = document.createElement('iframe');
    iframe.src = url;
        
    function onload () {
    alert("aaa111");
    }

    if (iframe.attachEvent) {
    iframe.attachEvent('onload', onload);
    } else {
    iframe.onload = onload;
    }
    return iframe;*/

    if (!url) url = '';
    var urls = url.split('#');
    url = urls[0];

    //修改url
    var t = '';
    if (cache !== true) {
        //_t
        t = '000000' + String(Math.floor(Math.random() * 1000000));
        t = t.substring(t.length - 6);
        t = '_t=' + t;

        if (url.indexOf('?') == -1) {
            url += '?' + t;
        } else {
            url += '&' + t;
        }
    }

    //_winid
    if (url && url.indexOf('_winid') == -1) {
        var t = '_winid=' + mini._WindowID;
        if (url.indexOf('?') == -1) {
            url += '?' + t;
        } else {
            url += '&' + t;
        }
    }

    if (mini.iframeParams) {
        for (var name in mini.iframeParams) {
            url += '&' + name + '=' + mini.iframeParams[name];
        }
    }

    if (urls[1]) {
        url = url + '#' + urls[1];
    }

    var isMHT = url.indexOf('.mht') != -1;
    var src = isMHT ? url : '';

    var iframeName = mini.newId('mini-iframe-');

    //window server版本下，是否用js绑定onload事件会比较好
    var s =
        '<iframe name="' +
        iframeName +
        '" src="' +
        (method == 'post' ? '' : src) +
        '" style="width:100%;height:100%;"  frameborder="0"></iframe>';
    //alert(method == 'post');

    var div = document.createElement('div');
    var iframe = mini.append(div, s);
    //iframe.src = "";
    var canFireLoad = false;
    if (isMHT) {
        canFireLoad = true;
    } else {
        setTimeout(function () {
            if (iframe) {
                if (method != 'post') {
                    iframe.src = url;
                }
                canFireLoad = true;
            }
        }, 5);
    }

    //iframe.onload = __OnLoad;
    if (iframe.attachEvent) {
        iframe.attachEvent('onload', __OnLoad);
    } else {
        iframe.onload = __OnLoad;
    }

    var destroyed = false;

    //load
    var firstLoad = true;
    function __OnLoad() {
        if (canFireLoad == false || destroyed) return;
        //alert("onload");
        setTimeout(function () {
            if (onIFrameLoad) onIFrameLoad(iframe, firstLoad);
            firstLoad = false;
            //onload = null;
            //iframe.onload = null;
            //
        }, 1);
    }

    //destroy
    iframe._ondestroy = function () {
        //window[fnName] = mini.emptyFn;
        destroyed = true;

        iframe.src = '';
        if (mini.isIE) {
            try {
                iframe.contentWindow.document.write('');
                iframe.contentWindow.document.close();
            } catch (ex) {}
        }
        iframe._ondestroy = null;
        iframe = null;
    };

    //////////////////////////////////////////////////////////////////////

    var form;
    if (method == 'post') {
        function createForm() {
            return jQuery('<form />')
                .attr({
                    method: 'post',
                    action: url,
                    enctype: 'multipart/form-data',
                    target: iframe.name
                })
                .hide()
                .appendTo('body');
        }

        form = createForm();

        setTimeout(function () {
            form.submit();
        }, 10);
    }

    return iframe;
};

//mini.__IFrameCreateCount = 1;
//mini.createIFrame = function (url, onIFrameLoad, cache) {
//    //    var iframe = document.createElement('iframe');
//    //    iframe.src = '1.mht';
//    //    //document.body.appendChild(iframe);
//    //    return iframe;
//    //    return;

//    var fnName = "__iframe_onload" + mini.__IFrameCreateCount++;
//    window[fnName] = __OnLoad;

//    if (!url) url = "";
//    var urls = url.split("#");
//    url = urls[0];

//    //修改url
//    var t = "";
//    if (cache !== true) {
//        //_t
//        t = '_t=' + Math.floor(Math.random() * 1000000); // "&_winid=" + mini._WindowID;

//        if (url.indexOf("?") == -1) {
//            url += "?" + t;
//        } else {
//            url += "&" + t;
//        }
//    }

//    //_winid
//    if (url && url.indexOf("_winid") == -1) {
//        var t = "_winid=" + mini._WindowID;
//        if (url.indexOf("?") == -1) {
//            url += "?" + t;
//        } else {
//            url += "&" + t;
//        }
//    }

//    if (urls[1]) {
//        url = url + "#" + urls[1];
//    }

//    var isMHT = url.indexOf(".mht") != -1;
//    var src = isMHT ? url : '';

//    //window server版本下，是否用js绑定onload事件会比较好
//    var s = '<iframe src="' + src + '" style="width:100%;height:100%;" onload="' + fnName + '()"  frameborder="0"></iframe>';

//    var div = document.createElement("div");
//    var iframe = mini.append(div, s);
//    //iframe.src = "";
//    var canFireLoad = false;
//    if (isMHT) {
//        canFireLoad = true;
//    } else {
//        setTimeout(function () {
//            if (iframe) {
//                iframe.src = url;
//                canFireLoad = true;
//            }
//        }, 5);
//    }

//    //load
//    var firstLoad = true;
//    function __OnLoad() {

//        if (canFireLoad == false) return;

//        setTimeout(function () {
//            if (onIFrameLoad) onIFrameLoad(iframe, firstLoad);
//            firstLoad = false;
//            //onload = null;
//            //iframe.onload = null;
//            //
//        }, 1);
//    }

//    //destroy
//    iframe._ondestroy = function () {

//        window[fnName] = mini.emptyFn;

//        iframe.src = "";
//        try {
//            iframe.contentWindow.document.write("");
//            iframe.contentWindow.document.close();
//        } catch (ex) { }
//        iframe._ondestroy = null;
//        iframe = null;

//    }

//    //    iframe.onunload = function () {

//    //        if (ondestroy) ondestroy(iframe);
//    //        iframe.src = "";
//    //        iframe = null;
//    //        iframe.onunload = null;
//    //    }
//    //    iframe._ondestroy = function () {
//    //        var ret = true;
//    //        if (ondestroy) ret = ondestroy(iframe);

//    //        if (ret !== false) {
//    //            window[fnName] = mini.emptyFn;

//    //            iframe.src = "";
//    //            iframe._ondestroy = null;
//    //            iframe = null;
//    //        }
//    //        return ret;
//    //    }

//    return iframe;
//}

mini._doOpen = function (options) {
    if (typeof options == 'string') {
        options = { url: options };
    }

    options = mini.copyTo(
        {
            width: 700,
            height: 400,
            allowResize: true,
            allowModal: true,
            closeAction: 'destroy',

            title: '',
            titleIcon: '',
            iconCls: '',
            iconStyle: '',
            bodyStyle: 'padding: 0',

            url: '',

            showCloseButton: true,
            showFooter: false
        },
        options
    );

    options.closeAction = 'destroy';

    var onload = options.onload;
    delete options.onload;
    var ondestroy = options.ondestroy;
    delete options.ondestroy;
    var url = options.url;
    delete options.url;

    var box = mini.getViewportBox();
    if (options.width && String(options.width).indexOf('%') != -1) {
        var w = parseInt(options.width);
        options.width = parseInt(box.width * (w / 100));
    }
    if (options.height && String(options.height).indexOf('%') != -1) {
        var h = parseInt(options.height);
        options.height = parseInt(box.height * (h / 100));
    }

    var win = new mini.Window();
    win.set(options);

    win.load(url, onload, ondestroy);
    win.show();

    if (mini.isIE) {
        setTimeout(function () {
            fixIEFocus();
        }, 100);
    }

    return win;
};

//ie11下，弹出后关闭，主页面会失去焦点，无法选中文本和输入框，需要特殊处理下。
function fixIEFocus() {
    var vbox = mini.getViewportBox();
    var input = document.createElement('input');
    //input.style.cssText = "position:absolute;left:-1000px;top:-1000px;";
    input.style.cssText = 'position:absolute;left:' + vbox.left + 'px;top:' + vbox.top + 'px;';
    document.body.appendChild(input);
    input.focus();
    input.parentNode.removeChild(input);
}

mini.getTopWindow = function () {
    var ps = [];
    function getParents(me) {
        try {
            if (me.mini) ps.push(me);
            if (me.parent && me.parent != me) {
                getParents(me.parent);
            }
        } catch (ex) {}
    }
    getParents(window);

    var win = ps[ps.length - 1];
    return win;
};

mini.open = function (options) {
    if (!options) return;

    var url = options.url;
    if (!url) url = '';
    var urls = url.split('#');
    var url = urls[0];

    if (url && url.indexOf('_winid') == -1) {
        var t = '_winid=' + mini._WindowID;
        if (url.indexOf('?') == -1) {
            url += '?' + t;
        } else {
            url += '&' + t;
        }
        if (urls[1]) {
            url = url + '#' + urls[1];
        }
    }

    options.url = url;

    options.Owner = window;
    var ps = [];
    function getParents(me) {
        try {
            if (me.mini) ps.push(me);
            if (me.parent && me.parent != me) {
                getParents(me.parent);
            }
        } catch (ex) {}
    }
    getParents(window);

    var win = ps[ps.length - 1];
    if (options.targetWindow) win = options.targetWindow;
    return win['mini']._doOpen(options);
};
mini.openTop = mini.open;

//////////////////////////////

mini._getResult = function (url, params, success, error, type, dataField) {
    var xhr = null;
    var text = mini.getText(
        url,
        params,
        function (text, o) {
            xhr = o;
            if (success) if (success) success(text, o);
        },
        error,
        type
    );

    var obj = {
        text: text,
        result: null,
        sender: { type: '' },
        options: { url: url, data: params, type: type },
        xhr: xhr
    };
    var result = null;
    try {
        mini_doload(obj);
        result = obj.result;
        if (!result) {
            result = mini.decode(text);
        }
    } catch (ex) {
        if (mini_debugger == true) {
            alert(url + '\njson is error');
        }
    }

    if (!mini.isArray(result) && dataField) result = mini._getMap(dataField, result);

    if (mini.isArray(result)) {
        result = { data: result };
    }

    return result ? result.data : null;
};
mini.getData = function (url, params, success, error, type) {
    var text = mini.getText(url, params, success, error, type);
    var data = mini.decode(text);
    return data;
};
mini.getText = function (url, params, success, error, type) {
    var returnText = null;
    mini.ajax({
        url: url,
        data: params,
        async: false,
        type: type ? type : 'get',
        cache: false,
        dataType: 'text',
        success: function (text, textStatus, xhr) {
            returnText = text;
            if (success) success(text, xhr);
        },
        error: error
    });
    return returnText;
};

////////////////////////////////////
//JSPath, RootPath
if (!window.mini_RootPath) {
    mini_RootPath = '/';
}
mini_CreateJSPath = function (js) {
    var scripts = document.getElementsByTagName('script');
    var path = '';
    for (var i = 0, l = scripts.length; i < l; i++) {
        var src = scripts[i].src;
        if (src.indexOf(js) != -1) {
            var ss = src.split(js);
            path = ss[0];
            break;
        }
    }
    var href = location.href;
    href = href.split('#')[0];
    href = href.split('?')[0];
    var ss = href.split('/');
    ss.length = ss.length - 1;
    href = ss.join('/');

    if (path.indexOf('http:') == -1 && path.indexOf('file:') == -1) {
        path = href + '/' + path;
    }
    return path;
};
if (!window.mini_JSPath) {
    mini_JSPath = mini_CreateJSPath('miniui.js');
}

/////////////////////////////////////
//加载页面片段HTML：是否处理css，javascipt？
//内部，销毁元素内部的所有组件对象，保持低内存。
mini.update = function (options, el) {
    if (typeof options == 'string') options = { url: options };
    if (el) options.el = el;
    var html = mini.loadText(options.url);
    mini.innerHTML(options.el, html);
    mini.parse(options.el);
};
//mini.update = function (options, el) {
//    if (typeof options == "string") options = { url: options };
//    if (el) options.el = el;
//    options = mini.copyTo({
//        el: null,
//        url: "",
//        async: false,
//        type: "get",
//        cache: false,
//        dataType: "text",
//        success: function (text) {
//            var el = options.el;
//            if (el) {
//                //处理CSS、js后。。。

//                //el.innerHTML = text;
//                jQuery(el).html(text);
//                mini.parse(el);
//            }
//        },
//        error: function (jqXHR, textStatus, errorThrown) {

//        }
//    }, options);

//    jQuery.ajax(options);
//}

///////////////////////////////////////////////////
mini.createSingle = function (Type) {
    if (typeof Type == 'string') {
        Type = mini.getClass(Type);
    }
    if (typeof Type != 'function') return;
    var obj = Type.single;
    if (!obj) {
        obj = Type.single = new Type();
    }
    return obj;
};
mini.createTopSingle = function (Type) {
    if (typeof Type != 'function') return;

    var typeName = Type.prototype.type;
    if (top && top != window && top.mini && top.mini.getClass(typeName)) {
        return top.mini.createSingle(typeName);
    } else {
        return mini.createSingle(Type);
    }
};

////////////////////////////////////////////////////////
mini.sortTypes = {
    //    "chinese": function (s) {
    //
    //    },
    string: function (s) {
        return String(s).toUpperCase();
    },
    date: function (s) {
        if (!s) {
            return 0;
        }
        if (mini.isDate(s)) {
            return s.getTime();
        }
        return mini.parseDate(String(s));
    },
    float: function (s) {
        var val = parseFloat(String(s).replace(/,/g, ''));
        return isNaN(val) ? 0 : val;
    },
    int: function (s) {
        var val = parseInt(String(s).replace(/,/g, ''), 10);
        return isNaN(val) ? 0 : val;
    },
    currency: function (s) {
        var val = parseFloat(String(s).replace(/,/g, ''));
        return isNaN(val) ? 0 : val;
    }
};

////////////////////////////////////////////////
mini._ValidateVType = function (vtype, value, e, scope) {
    var vtypes = vtype.split(';');

    for (var i = 0, l = vtypes.length; i < l; i++) {
        var vtype = vtypes[i].trim();
        var vv = vtype.split(':');
        var vt = vv[0];

        var args = vtype.substr(vt.length + 1, 1000); //vv[1];
        if (args) args = args.split(',');
        else args = [];

        var fn = mini.VTypes[vt];
        if (fn) {
            value = value && value.trim ? value.trim() : value;
            var isValid = fn(value, args);
            if (isValid !== true) {
                e.isValid = false;
                var vtext = vv[0] + 'ErrorText';
                e.errorText = scope[vtext] || mini.VTypes[vtext] || '';
                e.errorText = String.format(e.errorText, args[0], args[1], args[2], args[3], args[4]);
                break;
            }
        }
    }
};
mini._getErrorText = function (obj, field) {
    if (obj && obj[field]) {
        return obj[field];
    } else {
        return mini.VTypes[field];
    }
};
mini.VTypes = jQuery.extend({}, epoint_local.VTypes, {
    required: function (v, args) {
        if (mini.isNull(v) || v === '') return false;
        return true;
    },
    email: function (v, args) {
        if (mini.isNull(v) || v === '') return true;
        if (v.search(/^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/) != -1) return true;
        else return false;
    },
    int: function (v, args) {
        if (mini.isNull(v) || v === '') return true;
        //if (String(v).indexOf(0) == 0) return false;
        function isInteger(s) {
            if (s < 0) {
                s = -s;
            }
            var n = String(s);
            return n.length > 0 && !/[^0-9]/.test(n);
        }
        return isInteger(v);
        //        var v2 = parseInt(v);
        //        if (isNaN(v2)) return false;
        //        return typeof v2 == 'number' && String(v) == String(v2);
    },
    float: function (v, args) {
        if (mini.isNull(v) || v === '') return true;
        //if (v.indexOf(0) == 0) return false;
        function isFloat(s) {
            //debugger

            //            if (typeof s == 'string') {
            //
            //                return;
            //            }

            //            if (typeof s == 'number') {
            //                if (s < 0) {
            //                    s = -s;
            //                }
            //            }
            var n = String(s);

            //if (n == '-') return false;
            if (n.indexOf('-') != -1 && n.indexOf('-') != 0) return false;

            n = n.replace('-', '');

            if (n.split('.').length > 2) return false;
            //return n.length > 0 && !(/[^0-9.]/).test(n); // && (/\.\d/).test(n);

            return n.length > 0 && !/[^0-9.]/.test(n) && !(n.charAt(n.length - 1) == '.');
        }
        return isFloat(v);
        //        var v2 = parseFloat(v);
        //        if (isNaN(v2)) return false;
        //        return typeof v2 == 'number' && v == v2;
    },
    date: function (v, args) {
        if (mini.isNull(v) || v === '') return true;
        if (!v) return false;
        var d = null;
        var format = args[0];

        if (format) {
            d = mini.parseDate(v, format);
            if (d && d.getFullYear) {
                if (mini.formatDate(d, format) == v) return true;
            }
        } else {
            d = mini.parseDate(v, 'yyyy-MM-dd');
            if (!d) d = mini.parseDate(v, 'yyyy/MM/dd');
            if (!d) d = mini.parseDate(v, 'MM/dd/yyyy');
            if (d && d.getFullYear) return true;
        }

        return false;
    },
    maxLength: function (v, args) {
        if (mini.isNull(v) || v === '') return true;
        var n = parseInt(args);
        if (!v || isNaN(n)) return true;
        if (mini.getStrLength(v) <= n) return true;
        else return false;
    },
    minLength: function (v, args) {
        if (mini.isNull(v) || v === '') return true;
        var n = parseInt(args);
        if (isNaN(n)) return true;
        if (v.length >= n) return true;
        else return false;
    },
    rangeLength: function (v, args) {
        if (mini.isNull(v) || v === '') return true;
        if (!v) return false;
        var min = parseFloat(args[0]),
            max = parseFloat(args[1]);
        if (isNaN(min) || isNaN(max)) return true;
        if (min <= v.length && v.length <= max) return true;
        return false;
    },
    rangeChar: function (v, args) {
        if (mini.isNull(v) || v === '') return true;
        //if (!v) return false;
        var min = parseFloat(args[0]),
            max = parseFloat(args[1]);
        if (isNaN(min) || isNaN(max)) return true;

        function isChinese(v) {
            var re = new RegExp('^[\u4e00-\u9fa5]+$');
            if (re.test(v)) return true;
            return false;
        }

        var len = 0;
        var ss = String(v).split('');
        for (var i = 0, l = ss.length; i < l; i++) {
            if (isChinese(ss[i])) {
                len += 2;
            } else {
                len += 1;
            }
        }

        if (min <= len && len <= max) return true;
        return false;
    },
    range: function (v, args) {
        if (mini.VTypes['float'](v, args) == false) return false;
        if (mini.isNull(v) || v === '') return true;
        v = parseFloat(v);
        if (isNaN(v)) return false;
        var min = parseFloat(args[0]),
            max = parseFloat(args[1]);
        if (isNaN(min) || isNaN(max)) return true;
        if (min <= v && v <= max) return true;
        return false;
    },
    min: function (v, args) {
        if (mini.VTypes['float'](v, args) == false) return false;
        if (mini.isNull(v) || v === '') return true;
        v = parseFloat(v);
        if (isNaN(v)) return false;
        var min = parseFloat(args[0]);
        if (isNaN(min)) return true;
        if (min <= v) return true;
        return false;
    },
    max: function (v, args) {
        if (mini.VTypes['float'](v, args) == false) return false;
        if (mini.isNull(v) || v === '') return true;
        v = parseFloat(v);
        if (isNaN(v)) return false;
        var max = parseFloat(args[0]);
        if (isNaN(max)) return true;
        if (v <= max) return true;
        return false;
    }
});

mini.summaryTypes = {
    count: function (data) {
        if (!data) data = [];
        return data.length;
    },
    max: function (data, field) {
        if (!data) data = [];
        var max = null;
        for (var i = 0, l = data.length; i < l; i++) {
            var o = data[i];
            //var value = parseFloat(o[field]);
            var value = parseFloat(mini._getMap(field, o));
            if (value === null || value === undefined || isNaN(value)) continue;
            if (max == null || max < value) {
                max = value;
            }
        }
        return max;
    },
    min: function (data, field) {
        if (!data) data = [];
        var min = null;
        for (var i = 0, l = data.length; i < l; i++) {
            var o = data[i];
            //var value = parseFloat(o[field]);
            var value = parseFloat(mini._getMap(field, o));
            if (value === null || value === undefined || isNaN(value)) continue;
            if (min == null || min > value) {
                min = value;
            }
        }
        return min;
    },
    avg: function (data, field) {
        if (!data) data = [];
        if (data.length == 0) return 0;
        var total = 0;
        for (var i = 0, l = data.length; i < l; i++) {
            var o = data[i];
            //var value = parseFloat(o[field]);
            var value = parseFloat(mini._getMap(field, o));
            if (value === null || value === undefined || isNaN(value)) continue;
            total += value;
        }
        var v = total / data.length;
        return v;
    },
    sum: function (data, field) {
        if (!data) data = [];
        var total = 0;
        for (var i = 0, l = data.length; i < l; i++) {
            var o = data[i];
            //var value = parseFloat(o[field]);
            var value = parseFloat(mini._getMap(field, o));
            if (value === null || value === undefined || isNaN(value)) continue;
            total += value;
        }
        return total;
    }
};

mini.formatCurrency = function (num, prefix) {
    if (num === null || num === undefined) null == '';
    num = String(num).replace(/\$|\,/g, '');
    if (isNaN(num)) {
        num = '0';
    }
    sign = num == (num = Math.abs(num));
    num = Math.floor(num * 100 + 0.50000000001);
    cents = num % 100;
    num = Math.floor(num / 100).toString();
    if (cents < 10) {
        cents = '0' + cents;
    }
    for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
        num = num.substring(0, num.length - (4 * i + 3)) + ',' + num.substring(num.length - (4 * i + 3));
    }
    prefix = prefix || '';
    return prefix + ((sign ? '' : '-') + num + '.' + cents);
};

//var num = 9988812345.123;
//alert(formatCurrency(num, "￥"));

mini.getByUid = mini.getbyUID;

/**
 * 旧格式向新格式的转换
 * @param {*} format
 */
mini._oldFormatTransform = function (format) {
    if (/^[ncp](\d+)?$/.test(format)) {
        var type = format[0];
        format = format.substr(1) || '';
        var len = parseInt(format, 10) || 0;
        // 千分位小数
        if (type === 'n') {
            return len === 0 ? '0,0' : '0,0.' + pad(len, '0');
        }
        // 百分比
        if (type === 'p') {
            return len === 0 ? '0%' : '0.' + pad(len, '0') + '%';
        }
        // 货币
        if (type === 'c') {
            return len === 0 ? '$0' : '$0.' + pad(len, '0');
        }
    }
    return format;

    function pad(length, str) {
        if (length === 1) return str;
        return new Array(length + 1).join(str);
    }
};


/**
拖拽基类
    mouse.init:     初始鼠标点击坐标
    mouse.now:      当前鼠标坐标
    events: onStart, onMove, onStop    
*/
mini.emptyFn = function () { };
mini.Drag = function (options) {
    mini.copyTo(this, options);
};
mini.Drag.prototype = {
    onStart: mini.emptyFn,
    onMove: mini.emptyFn,
    onStop: mini.emptyFn,
    capture: false,
    fps: 20,
    event: null,
    delay: 80,

    //调用start的时候,鼠标已经按下去了.	
    start: function (e) {
        
        // start 中阻止默认行为会导致表头点击后无法触发页面其他地方的输入控件的 blur 事件，需移到 move 中去阻止默认行为
        // e.preventDefault();
        if (e) this.event = e;

        this.now = this.init = [this.event.pageX, this.event.pageY];  //初始时的mouse坐标	    

        var bd = document;
        mini.on(bd, 'mousemove', this.move, this);
        mini.on(bd, 'mouseup', this.stop, this);
        mini.on(bd, 'contextmenu', this.contextmenu, this);
        if (this.context) mini.on(this.context, 'contextmenu', this.contextmenu, this);

        this.trigger = e.target; //e.trigger;
        mini.selectable(this.trigger, false);
        mini.selectable(bd.body, false);

        if (this.capture) {//ie下,为true的时候,鼠标指针不能得到界面上的do元素
            if (isIE) this.trigger.setCapture(true);
            else if (document.captureEvents) document.captureEvents(Event.MOUSEMOVE | Event.MOUSEUP | Event.MOUSEDOWN);
        }
        this.started = false;

        //定制一个延迟事件
        this.startTime = new Date();
    },
    contextmenu: function (e) {
        if (this.context) mini.un(this.context, 'contextmenu', this.contextmenu, this);
        mini.un(document, 'contextmenu', this.contextmenu, this);
        e.preventDefault();
        e.stopPropagation();
    },
    move: function (e) {
        e.preventDefault();
        if (this.delay) { //如果有延迟配置,则判断当前是否超过了延迟时间
            if (new Date() - this.startTime < this.delay) return;
        }

        //2)


        //处理!!!        

        var sf = this;

        if (!this.timer) {
            this.timer = setTimeout(function () {

                if (!sf.started) {
                    sf.started = true;
                    sf.onStart(sf);             //在第一次move的时候,才开始onStart	        
                }


                sf.now = [e.pageX, e.pageY]//e.xy.clone();             //移动中的鼠标坐标	  
                sf.event = e;
                sf.onMove(sf);
                sf.timer = null;
            }, 5);
        }
    },
    stop: function (e) {
        
        this.now = [e.pageX, e.pageY]//e.xy.clone();             //移动中的鼠标坐标
        this.event = e;

        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
        var bd = document;

        mini.selectable(this.trigger, true);
        mini.selectable(bd.body, true);

        if (isIE) {
            this.trigger.setCapture(false);
            this.trigger.releaseCapture();
        }
        //        if (this.capture) {
        //            if (isIE) this.trigger.releaseCapture();
        //            else if (document.captureEvents) document.releaseEvents(Event.MOUSEMOVE | Event.MOUSEUP | Event.MOUSEDOWN);
        //        }

        var success = mini.MouseButton.Right != e.button;
        if (success == false) {
            e.preventDefault();

        }

        //if (this.capture == false) {   
        //if (isIE) this.trigger.setCapture(false);            
        //}

        mini.un(bd, 'mousemove', this.move, this);
        mini.un(bd, 'mouseup', this.stop, this);
        var sf = this;
        setTimeout(function () {
            mini.un(document, 'contextmenu', sf.contextmenu, sf);
            if (sf.context) mini.un(sf.context, 'contextmenu', sf.contextmenu, sf);
        }, 1);

        //if (this.started || isIE9) this.onStop(this, success);
        if (this.started) this.onStop(this, success);
    }
};


mini.JSON = new (function () {
    var sb = [];
    var _dateFormat = null;
    var useHasOwn = !!{}.hasOwnProperty,
        replaceString = function (a, b) {

            var c = m[b];
            if (c) {

                //sb[sb.length] = c;
                return c;
            }
            c = b.charCodeAt();
            return "\\u00" + Math.floor(c / 16).toString(16) + (c % 16).toString(16);

        },
        doEncode = function (o, field) {

            if (o === null) {
                sb[sb.length] = "null";
                return;
            }
            var t = typeof o;
            if (t == "undefined") {
                sb[sb.length] = "null";
                return;
            } else if (o.push) {    //array

                sb[sb.length] = '[';
                var b, i, l = o.length, v;
                for (i = 0; i < l; i += 1) {
                    v = o[i];
                    t = typeof v;
                    if (t == "undefined" || t == "function" || t == "unknown") {
                    } else {
                        if (b) {
                            sb[sb.length] = ',';
                        }
                        doEncode(v);

                        b = true;
                    }
                }
                sb[sb.length] = ']';
                return;
            } else if (o.getFullYear) {
                if (_dateFormat) {
                    sb[sb.length] = '"';
                    if (typeof _dateFormat == 'function') {
                        sb[sb.length] = _dateFormat(o, field);
                    } else {
                        sb[sb.length] = mini.formatDate(o, _dateFormat);
                    }
                    sb[sb.length] = '"';
                } else {
                    var n;
                    sb[sb.length] = '"';
                    sb[sb.length] = o.getFullYear();
                    sb[sb.length] = "-";
                    n = o.getMonth() + 1;
                    sb[sb.length] = n < 10 ? "0" + n : n;
                    sb[sb.length] = "-";
                    n = o.getDate();
                    sb[sb.length] = n < 10 ? "0" + n : n;
                    sb[sb.length] = "T"
                    n = o.getHours();
                    sb[sb.length] = n < 10 ? "0" + n : n;
                    sb[sb.length] = ":"
                    n = o.getMinutes();
                    sb[sb.length] = n < 10 ? "0" + n : n;
                    sb[sb.length] = ":"
                    n = o.getSeconds();
                    sb[sb.length] = n < 10 ? "0" + n : n;
                    sb[sb.length] = '"';
                }
                return;
            } else if (t == "string") {
                if (strReg1.test(o)) {
                    sb[sb.length] = '"';

                    sb[sb.length] = o.replace(strReg2, replaceString);
                    sb[sb.length] = '"';
                    return;
                }
                sb[sb.length] = '"' + o + '"';
                return;
            } else if (t == "number") {
                sb[sb.length] = o;
                return;
            } else if (t == "boolean") {
                sb[sb.length] = String(o);
                return;
            } else {    //object
                sb[sb.length] = "{";
                var b, i, v;
                for (i in o) {
                    //if (!useHasOwn || (o.hasOwnProperty && o.hasOwnProperty(i))) {
                    if (!useHasOwn || Object.prototype.hasOwnProperty.call(o, i)) {

                        v = o[i];
                        t = typeof v;
                        if (t == "undefined" || t == "function" || t == "unknown") {
                        } else {
                            if (b) {
                                sb[sb.length] = ',';
                            }
                            doEncode(i);
                            sb[sb.length] = ":";
                            doEncode(v, i)

                            b = true;
                        }
                    }
                }
                sb[sb.length] = "}";
                return;
            }
        },
        m = {
            "\b": '\\b',
            "\t": '\\t',
            "\n": '\\n',
            "\f": '\\f',
            "\r": '\\r',
            '"': '\\"',
            "\\": '\\\\'
        },
        strReg1 = /["\\\x00-\x1f]/,
        strReg2 = /([\x00-\x1f\\"])/g;

    this.encode = function () {

        var ec;
        return function (o, dateFormat) {
            sb = [];

            _dateFormat = dateFormat;
            doEncode(o);

            _dateFormat = null;

            return sb.join("");
        };
    } ();
    this.decode = function () {

        //        var dateRe1 = /(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})/g;
        //        var dateRe2 = new RegExp('\/Date\\(([0-9]+)\\)\/', 'g');
        //var dateRe2 = new RegExp('\/Date\((\d+)\)\/', 'g');


        //"2000-11-12 11:22:33", "2000-05-12 11:22:33", "2008-01-11T12:22:00", "2008-01-11T12:22:00.111Z"


        var dateRe1 = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2}(?:\.*\d*)?)Z*$/;
        //"\/Date(1382101422005)\/", "//Date(1034000000000)//", "/Date(1034000000000+0800)/"
        var dateRe2 = new RegExp('^\/+Date\\((-?[0-9]+)\.*\\)\/+$', 'g');

        var re = /[\"\'](\d{4})-(\d{1,2})-(\d{1,2})[T ](\d{1,2}):(\d{1,2}):(\d{1,2})(\.*\d*)[\"\']/g;

        return function (json, parseDate) {
            if (json === "" || json === null || json === undefined) return json;

            if (typeof json == 'object') {  //不应该序列化，应该遍历处理日期字符串
                json = this.encode(json);
            }

            function evalParse(json) {
                if (parseDate !== false) {

                    //json = json.replace(__js_dateRegEx, "$1new Date($2)");

                    json = json.replace(__js_dateRegEx, "$1new Date($2)");
                    json = json.replace(re, "new Date($1,$2-1,$3,$4,$5,$6)");
                    json = json.replace(__js_dateRegEx2, "new Date($1)");
                }
                return window["ev" + "al"]('(' + json + ')');
            }


            var data = null;


            if (window.JSON && window.JSON.parse) {
                
                var dateReviver = function (key, value) {
                    if (typeof value === 'string' && parseDate !== false) {
                        //dateRe1
                        dateRe1.lastIndex = 0;
                        var a = dateRe1.exec(value);
                        if (a) {
                            value = new Date(a[1], a[2] - 1, a[3], a[4], a[5], a[6]);

                            return value;
                        }
                        //dateRe2
                        dateRe2.lastIndex = 0;
                        var a = dateRe2.exec(value);
                        if (a) {
                            value = new Date(parseInt(a[1]));

                            return value;
                        }
                    }
                    return value;
                };

                try {
                    var json2 = json.replace(__js_dateRegEx, "$1\"\/Date($2)\/\"");
                    data = window.JSON.parse(json2, dateReviver);
                } catch (ex) {
                    data = evalParse(json);
                }

            } else {

                data = evalParse(json);
            }
            return data;
        };

    } ();

})();
__js_dateRegEx = new RegExp('(^|[^\\\\])\\"\\\\/Date\\((-?[0-9]+)(?:[a-zA-Z]|(?:\\+|-)[0-9]{4})?\\)\\\\/\\"', "g");
__js_dateRegEx2 = new RegExp('[\"\']\/Date\\(([0-9]+)\\)\/[\"\']', 'g');
mini.encode = mini.JSON.encode;
mini.decode = mini.JSON.decode;

mini.clone = function (o, _clear) {
    if (o === null || o === undefined) return o;
    var json = mini.encode(o);
    var obj = mini.decode(json);

    function clearProp(arr) {
        for (var i = 0, l = arr.length; i < l; i++) {
            var o = arr[i];
            delete o._state;
            delete o._id;
            delete o._pid;
            delete o._uid;
            for (var p in o) {
                var v = o[p];
                if (v instanceof Array) clearProp(v);
            }
        }
    }
    if (_clear !== false) {
        clearProp(obj instanceof Array ? obj : [obj]);
    }

    return obj;
}



/* Date
-----------------------------------------------------------------------------*/

var DAY_MS = 86400000,
	HOUR_MS = 3600000,
	MINUTE_MS = 60000;

mini.copyTo(mini, {
    clearTime: function (date) {
        if (!date) return null;
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    },
    maxTime: function (date) {
        if (!date) return null;
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59);
    },
    cloneDate: function (date) {
        if (!date) return null;
        return new Date(date.getTime());
    },
    addDate: function (date, num, type) {
        if (!type) type = "D";
        date = new Date(date.getTime());
        switch (type.toUpperCase()) {
            case "Y":
                date.setFullYear(date.getFullYear() + num);
                break;
            case "MO":
                date.setMonth(date.getMonth() + num);
                break;
            case "D":
                date.setDate(date.getDate() + num);
                break;
            case "H":
                date.setHours(date.getHours() + num);
                break;
            case "M":
                date.setMinutes(date.getMinutes() + num);
                break;
            case "S":
                date.setSeconds(date.getSeconds() + num);
                break;
            case "MS":
                date.setMilliseconds(date.getMilliseconds() + num);
                break;
        }
        return date;
    },
    getWeek: function (year, month, day) {
        //month += 1; //use 1-12            //结果不对，代码注释掉了

        var a = Math.floor((14 - (month)) / 12);
        var y = year + 4800 - a;
        var m = (month) + (12 * a) - 3;
        var jd = day + Math.floor(((153 * m) + 2) / 5) +
                     (365 * y) + Math.floor(y / 4) - Math.floor(y / 100) +
                     Math.floor(y / 400) - 32045;

        var d4 = (jd + 31741 - (jd % 7)) % 146097 % 36524 % 1461;
        var L = Math.floor(d4 / 1460);
        var d1 = ((d4 - L) % 365) + L;
        NumberOfWeek = Math.floor(d1 / 7) + 1;
        return NumberOfWeek;
    },
    //获得日期本周第一天的日期
    getWeekStartDate: function (date, weekStartDay) {
        if (!weekStartDay) weekStartDay = 0;
        if (weekStartDay > 6 || weekStartDay < 0) throw new Error("out of weekday");
        var day = date.getDay();
        var num = weekStartDay - day;
        if (day < weekStartDay) {
            num -= 7;
        }
        var d = new Date(date.getFullYear(), date.getMonth(), date.getDate() + num);
        return d;
    },
    getShortWeek: function (week) {
        var weeks = this.dateInfo.daysShort;
        return weeks[week];
    },
    getLongWeek: function (week) {
        var weeks = this.dateInfo.daysLong;
        return weeks[week];
    },
    getShortMonth: function (month) {
        var months = this.dateInfo.monthsShort;
        return months[month];
    },
    getLongMonth: function (month) {
        var months = this.dateInfo.monthsLong;
        return months[month];
    },
    dateInfo: jQuery.extend(true, {}, epoint_local.dateInfo),
    // dateInfo: {
    //     monthsLong: ["January", "Febraury", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    //     monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    //     daysLong: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    //     daysShort: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    //     quarterLong: ['Q1', 'Q2', 'Q3', 'Q4'],
    //     quarterShort: ['Q1', 'Q2', 'Q3', 'Q4'],
    //     halfYearLong: ['first half', 'second half'],
    //     patterns: {
    //         "d": "M/d/yyyy",
    //         "D": "dddd, MMMM dd, yyyy",
    //         "f": "dddd, MMMM dd, yyyy H:mm tt",
    //         "F": "dddd, MMMM dd, yyyy H:mm:ss tt",
    //         "g": "M/d/yyyy H:mm tt",
    //         "G": "M/d/yyyy H:mm:ss tt",
    //         "m": "MMMM dd",
    //         "o": "yyyy-MM-ddTHH:mm:ss.fff",
    //         "s": "yyyy-MM-ddTHH:mm:ss",
    //         "t": "H:mm tt",
    //         "T": "H:mm:ss tt",
    //         "U": "dddd, MMMM dd, yyyy HH:mm:ss tt",
    //         "y": "MMM, yyyy"
    //     },
    //     tt: {
    //         "AM": "AM",
    //         "PM": "PM"
    //     },
    //     ten: {
    //         "Early": "Early",
    //         "Mid": "Mid",
    //         "Late": "Late"
    //     },
    //     today: 'Today',
    //     clockType: 24
    // }
});
Date.prototype.getHalfYear = function () {
    if (!this.getMonth) return null;
    var m = this.getMonth();
    if (m < 6) return 0;
    return 1;
}
Date.prototype.getQuarter = function () {
    if (!this.getMonth) return null;
    var m = this.getMonth();
    if (m < 3) return 0;
    if (m < 6) return 1;
    if (m < 9) return 2;
    return 3;
}


/* Date Format
-----------------------------------------------------------------------------*/


mini.formatDate = function (date, format, locale) {
    if (!date || !date.getFullYear || isNaN(date)) return "";
    var fd = date.toString();

    var dateFormat = mini.dateInfo;
    if (!dateFormat) dateFormat = mini.dateInfo;

    if (typeof (dateFormat) !== "undefined") {
        var pattern = typeof (dateFormat.patterns[format]) !== "undefined" ? dateFormat.patterns[format] : format;

        var year = date.getFullYear();
        var month = date.getMonth();
        var day = date.getDate();

        if (format == "yyyy-MM-dd") { //yyyy-MM-dd
            month = month + 1 < 10 ? "0" + (month + 1) : month + 1;
            day = day < 10 ? "0" + day : day;
            return year + "-" + month + "-" + day;
        }
        if (format == "MM/dd/yyyy") { //MM/dd/yyyy
            month = month + 1 < 10 ? "0" + (month + 1) : month + 1;
            day = day < 10 ? "0" + day : day;
            return month + "/" + day + "/" + year;
        }



        fd = pattern.replace(/yyyy/g, year);
        fd = fd.replace(/yy/g, (year + "").substring(2));

        //
        var halfyear = date.getHalfYear();
        fd = fd.replace(/hy/g, dateFormat.halfYearLong[halfyear]);

        //
        var quarter = date.getQuarter();
        fd = fd.replace(/Q/g, dateFormat.quarterLong[quarter]);
        fd = fd.replace(/q/g, dateFormat.quarterShort[quarter]);


        fd = fd.replace(/MMMM/g, dateFormat.monthsLong[month].escapeDateTimeTokens());
        fd = fd.replace(/MMM/g, dateFormat.monthsShort[month].escapeDateTimeTokens());
        fd = fd.replace(/MM/g, month + 1 < 10 ? "0" + (month + 1) : month + 1);
        fd = fd.replace(/(\\)?M/g, function ($0, $1) { return $1 ? $0 : month + 1; });

        var dayOfWeek = date.getDay();
        fd = fd.replace(/dddd/g, dateFormat.daysLong[dayOfWeek].escapeDateTimeTokens());
        fd = fd.replace(/ddd/g, dateFormat.daysShort[dayOfWeek].escapeDateTimeTokens());


        fd = fd.replace(/dd/g, day < 10 ? "0" + day : day);
        fd = fd.replace(/(\\)?d/g, function ($0, $1) { return $1 ? $0 : day; });

        var hour = date.getHours();
        var halfHour = hour > 12 ? hour - 12 : hour;
        if (dateFormat.clockType == 12) {
            if (hour > 12) {
                hour -= 12;
            }
        }

        //HH
        fd = fd.replace(/HH/g, hour < 10 ? "0" + hour : hour);
        fd = fd.replace(/(\\)?H/g, function ($0, $1) { return $1 ? $0 : hour; });

        //hh        
        fd = fd.replace(/hh/g, halfHour < 10 ? "0" + halfHour : halfHour);
        fd = fd.replace(/(\\)?h/g, function ($0, $1) { return $1 ? $0 : halfHour; });

        var minutes = date.getMinutes();
        fd = fd.replace(/mm/g, minutes < 10 ? "0" + minutes : minutes);
        fd = fd.replace(/(\\)?m/g, function ($0, $1) { return $1 ? $0 : minutes; });

        var seconds = date.getSeconds();
        fd = fd.replace(/ss/g, seconds < 10 ? "0" + seconds : seconds);
        fd = fd.replace(/(\\)?s/g, function ($0, $1) { return $1 ? $0 : seconds; });

        fd = fd.replace(/fff/g, date.getMilliseconds());

        fd = fd.replace(/tt/g, date.getHours() > 12 || date.getHours() == 0 ? dateFormat.tt["PM"] : dateFormat.tt["AM"]);

        //
        var date = date.getDate();
        var tenF = '';
        if (date <= 10) tenF = dateFormat.ten['Early'];
        else if (date <= 20) tenF = dateFormat.ten['Mid'];
        else tenF = dateFormat.ten['Late'];
        fd = fd.replace(/ten/g, tenF);
    }

    return fd.replace(/\\/g, "");
}
String.prototype.escapeDateTimeTokens = function () {
    return this.replace(/([dMyHmsft])/g, "\\$1");
}

/* Date Parsing
-----------------------------------------------------------------------------*/

mini.fixDate = function (d, check) { // force d to be on check's YMD, for daylight savings purposes
    if (+d) { // prevent infinite looping on invalid dates
        while (d.getDate() != check.getDate()) {
            d.setTime(+d + (d < check ? 1 : -1) * HOUR_MS);
        }
    }
}

/*
examples:
2000/12/22 23:23:59
2000/12/22T23:23:59
2000-12-22 23:23:59
2000-12-22T23:23:59
2000-12-22
2000/12/22
12-22-2000
12/22/2000
2010.11.12  
*/



mini.parseDate = function (s, ignoreTimezone) {

    
    try {
        var d = window["ev" + "al"](s);
        if (d && d.getFullYear) return d;
    } catch (ex) {
    }
    //if (isNaN(s)) return null; 
    if (typeof s == 'object') { // already a Date object    
        return isNaN(s) ? null : s;
    }
    if (typeof s == 'number') { // a UNIX timestamp
        //if (new Date(1970, 0, 1).getTime() > parseInt(s)) return null;
        var d = new Date(s);
        if (d.getTime() != s) return null;
        return isNaN(d) ? null : d;
    }
    if (typeof s == 'string') {
        //20101112000000, 20101112, 201011

        m = s.match(/^([0-9]{4})([0-9]{2})([0-9]{0,2})([0-9]{0,2})([0-9]{0,2})([0-9]{0,2})$/);
        if (m) {
            var date = new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1);
            if (m[3]) date.setDate(m[3]);
            if (m[4]) date.setHours(m[4]);
            if (m[5]) date.setMinutes(m[5]);
            if (m[6]) date.setSeconds(m[6]);
            return date;
        }
        
        //2010.11
        m = s.match(/^([0-9]{4}).([0-9]*)$/);
        if (m) {
            var date = new Date(m[1], m[2] - 1);
            return date;
        }

        if (s.match(/^\d+(\.\d+)?$/)) { // a UNIX timestamp
            var d = new Date(parseFloat(s) * 1000);
            if (d.getTime() != s) return null;
            else return d;
        }
        if (ignoreTimezone === undefined) {
            ignoreTimezone = true;
        }
        var d = mini.parseISO8601(s, ignoreTimezone) || (s ? new Date(s) : null);
        return isNaN(d) ? null : d;
    }
    // TODO: never return invalid dates (like from new Date(<string>)), return null instead
    return null;
}
mini.parseISO8601 = function (s, ignoreTimezone) { // ignoreTimezone defaults to false
    // TODO: for a know glitch/feature, read tests/issue_206_parseDate_dst.html
    //var m = s.match(/^([0-9]{4})(-([0-9]{2})(-([0-9]{2})([T ]([0-9]{2}):([0-9]{2})(:([0-9]{2})(\.([0-9]+))?)?(Z|(([-+])([0-9]{2})(:?([0-9]{2}))?))?)?)?)?$/);
    var m = s.match(/^([0-9]{4})([-\/]([0-9]{1,2})([-\/]([0-9]{1,2})([T ]([0-9]{1,2}):([0-9]{1,2})(:([0-9]{1,2})(\.([0-9]+))?)?(Z|(([-+])([0-9]{2})(:?([0-9]{2}))?))?)?)?)?$/);
    if (!m) {
        //2010-11-22 9  小时额外处理下
        m = s.match(/^([0-9]{4})[-\/]([0-9]{2})[-\/]([0-9]{2})[T ]([0-9]{1,2})/);
        if (m) {
            var date = new Date(m[1], m[2] - 1, m[3], m[4]);
            return date;
        }

        //2010.11
        m = s.match(/^([0-9]{4}).([0-9]*)$/);
        if (m) {
            var date = new Date(m[1], m[2] - 1);
            return date;
        }

        //2010.11.22
        m = s.match(/^([0-9]{4}).([0-9]*).([0-9]*)/);
        if (m) {
            var date = new Date(m[1], m[2] - 1, m[3]);
            return date;
        }

        //ff "12-22-2000"
        m = s.match(/^([0-9]{2})-([0-9]{2})-([0-9]{4})$/);
        if (!m) return null;
        else {
            var date = new Date(m[3], m[1] - 1, m[2]);
            return date;
        }
    }
    var date = new Date(m[1], 0, 1);
    if (ignoreTimezone || !m[14]) {
        var check = new Date(m[1], 0, 1, 9, 0);
        if (m[3]) {
            date.setMonth(m[3] - 1);
            check.setMonth(m[3] - 1);
        }
        if (m[5]) {
            date.setDate(m[5]);
            check.setDate(m[5]);
        }
        mini.fixDate(date, check);
        if (m[7]) {
            date.setHours(m[7]);
        }
        if (m[8]) {
            date.setMinutes(m[8]);
        }
        if (m[10]) {
            date.setSeconds(m[10]);
        }
        if (m[12]) {
            date.setMilliseconds(Number("0." + m[12]) * 1000);
        }
        mini.fixDate(date, check);
    } else {
        date.setUTCFullYear(
			m[1],
			m[3] ? m[3] - 1 : 0,
			m[5] || 1
		);
        date.setUTCHours(
			m[7] || 0,
			m[8] || 0,
			m[10] || 0,
			m[12] ? Number("0." + m[12]) * 1000 : 0
		);
        var offset = Number(m[16]) * 60 + (m[18] ? Number(m[18]) : 0);
        offset *= m[15] == '-' ? 1 : -1;
        date = new Date(+date + (offset * 60 * 1000));
    }
    return date;
}


mini.parseTime = function (s, format) {
    if (!s) return null;
    var n = parseInt(s);

    if (n == s && format) {
        d = new Date(0);

        var ch = format.charAt(0);

        if (ch == "H") {
            d.setHours(n);
        } else if (ch == "m") {
            d.setMinutes(n);
        } else if (ch == "s") {
            d.setSeconds(n);
        }
        if (isNaN(d)) d = null;
        return d;
    }

    var d = mini.parseDate(s);
    if (!d) {
        var ss = s.split(":");
        var t1 = parseInt(parseFloat(ss[0]));
        var t2 = parseInt(parseFloat(ss[1]));
        var t3 = parseInt(parseFloat(ss[2]));
        if (!isNaN(t1) && !isNaN(t2) && !isNaN(t3)) {
            d = new Date(0);
            d.setHours(t1);
            d.setMinutes(t2);
            d.setSeconds(t3);
        }
        if (!isNaN(t1) && (format == "H" || format == "HH")) {
            d = new Date(0);
            d.setHours(t1);
        } else if (!isNaN(t1) && !isNaN(t2) && (format == "H:mm" || format == "HH:mm")) {
            d = new Date(0);
            d.setHours(t1);
            d.setMinutes(t2);
        } else if (!isNaN(t1) && !isNaN(t2) && format == "mm:ss") {
            d = new Date(0);
            d.setMinutes(t1);
            d.setSeconds(t2);
        }
    }
    return d;
};



/*
下表列出了可被合并以构造自定义模式的模式
========================================
这些模式是区分大小写的；例如，识别“MM”，但不识别“mm”。如果自定义模式包含空白字符或用单引号括起来的字符，则输出字符串页也将包含这些字符。未定义为格式模式的一部分或未定义为格式字符的字符按其原义复制。

格式模式 说明 ：
d 月中的某一天。一位数的日期没有前导零。
dd 月中的某一天。一位数的日期有一个前导零。
ddd 周中某天的缩写名称，在 AbbreviatedDayNames 中定义。
dddd 周中某天的完整名称，在 DayNames 中定义。
M 月份数字。一位数的月份没有前导零。
MM 月份数字。一位数的月份有一个前导零。
MMM 月份的缩写名称，在 AbbreviatedMonthNames 中定义。
MMMM 月份的完整名称，在 MonthNames 中定义。
y 不包含纪元的年份。如果不包含纪元的年份小于 10，则显示不具有前导零的年份。
yy 不包含纪元的年份。如果不包含纪元的年份小于 10，则显示具有前导零的年份。
yyyy 包括纪元的四位数的年份。
gg 时期或纪元。如果要设置格式的日期不具有关联的时期或纪元字符串，则忽略该模式。
h 12 小时制的小时。一位数的小时数没有前导零。
hh 12 小时制的小时。一位数的小时数有前导零。
H 24 小时制的小时。一位数的小时数没有前导零。
HH 24 小时制的小时。一位数的小时数有前导零。
m 分钟。一位数的分钟数没有前导零。
mm 分钟。一位数的分钟数有一个前导零。
s 秒。一位数的秒数没有前导零。
ss 秒。一位数的秒数有一个前导零。
f 秒的小数精度为一位。其余数字被截断。
ff 秒的小数精度为两位。其余数字被截断。
fff 秒的小数精度为三位。其余数字被截断。
ffff 秒的小数精度为四位。其余数字被截断。
fffff 秒的小数精度为五位。其余数字被截断。
ffffff 秒的小数精度为六位。其余数字被截断。
fffffff 秒的小数精度为七位。其余数字被截断。
t 在 AMDesignator 或 PMDesignator 中定义的 AM/PM 指示项的第一个字符（如果存在）。
tt 在 AMDesignator 或 PMDesignator 中定义的 AM/PM 指示项（如果存在）。
z 时区偏移量（“+”或“-”后面仅跟小时）。一位数的小时数没有前导零。例如，太平洋标准时间是“-8”。
zz 时区偏移量（“+”或“-”后面仅跟小时）。一位数的小时数有前导零。例如，太平洋标准时间是“-08”。
zzz 完整时区偏移量（“+”或“-”后面跟有小时和分钟）。一位数的小时数和分钟数有前导零。例如，太平洋标准时间是“-08:00”。
: 在 TimeSeparator 中定义的默认时间分隔符。
/ 在 DateSeparator 中定义的默认日期分隔符。
% c 其中 c 是格式模式（如果单独使用）。如果格式模式与原义字符或其他格式模式合并，则可以省略“%”字符。
\ c 其中 c 是任意字符。照原义显示字符。若要显示反斜杠字符，请使用“\\”。

只有上面第二个表中列出的格式模式才能用于创建自定义模式；在第一个表中列出的标准格式字符不能用于创建自定义模式。自定义模式的长度至少为两个字符；例如，

DateTime.ToString( "d") 返回 DateTime 值；“d”是标准短日期模式。
DateTime.ToString( "%d") 返回月中的某天；“%d”是自定义模式。
DateTime.ToString( "d ") 返回后面跟有一个空白字符的月中的某天；“d”是自定义模式。

比较方便的是,上面的参数可以随意组合,并且不会出错,多试试,肯定会找到你要的时间格式
如要得到2005年06月 这样格式的时间
可以这样写:
date.ToString("yyyy年MM月", DateTimeFormatInfo.InvariantInfo)
或者
date.ToString("yyyy年MM月")
如此类推.

*/

// mini.dateInfo = {
//     monthsLong: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
//     monthsShort: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
//     daysLong: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
//     daysShort: ["日", "一", "二", "三", "四", "五", "六"],
//     quarterLong: ['一季度', '二季度', '三季度', '四季度'],
//     quarterShort: ['Q1', 'Q2', 'Q2', 'Q4'],
//     halfYearLong: ['上半年', '下半年'],
//     patterns: {
//         "d": "yyyy-M-d",
//         "D": "yyyy年M月d日",
//         "f": "yyyy年M月d日 H:mm",
//         "F": "yyyy年M月d日 H:mm:ss",
//         "g": "yyyy-M-d H:mm",
//         "G": "yyyy-M-d H:mm:ss",
//         "m": "MMMd日",
//         "o": "yyyy-MM-ddTHH:mm:ss.fff",
//         "s": "yyyy-MM-ddTHH:mm:ss",
//         "t": "H:mm",
//         "T": "H:mm:ss",
//         "U": "yyyy年M月d日 HH:mm:ss",
//         "y": "yyyy年MM月"
//     },
//     tt: {
//         "AM": "上午",
//         "PM": "下午"
//     },
//     ten: {
//         "Early": "上旬",
//         "Mid": "中旬",
//         "Late": "下旬"
//     },
//     today: '今天',
//     clockType: 24
// };
//var s = "2000.1.2";
//alert(mini.parseDate(s));
(function (window) {

    var mini = window.mini;
    if (!mini) mini = window.mini = {};


    /////////////////////////////////////////////////////////
    // Culture
    ////////////////////////////////////////////////////////

    var cultures = mini.cultures = {};

    function findCulture(cultureName) {
        return mini.cultures[cultureName];
    }

    function getCulture(cultureName) {
        if (cultureName && cultureName.name) return cultureName;
        return findCulture(cultureName) || mini.cultures.current;
    }

    mini.getCulture = getCulture;

    mini.culture = function (cultureName) {
        if (cultureName !== undefined) {
            mini.cultures.current = findCulture(cultureName);
        } else {
            return cultures.current;
        }
    };

    // i18n 
    mini.cultures[epoint_local.culture.name] = jQuery.extend(true, {}, epoint_local.culture);
    mini.culture(epoint_local.culture.name);


    /////////////////////////////////////////////////////////
    // Number
    ////////////////////////////////////////////////////////
    var STRING = "string",
        NUMBER = "number",
        isArray = function (val) {
            return val && !!val.unshift;
        },
        numberRegExp = {
            2: /^\d{1,2}/,
            4: /^\d{4}/
        };

    function pad(number, digits, end) {
        number = number + "";
        digits = typeof digits == NUMBER ? digits : 2;

        var n = digits - number.length;
        if (n > 0) {
            var zeros = repeat(n, "0");
            return end ? number + zeros : zeros + number;
        }

        return number;
    }
    function repeat(n, c) {
        var s = "";
        while (n) {
            n -= 1;
            s += c;
        }
        return s;
    }

    var numberFormatRegExp = /^(n|c|p)(\d*)$/i,
        eRegExp = /^(e)(\d*)$/i,
        clearRegExp = /[^0#]/g,
        exponentRegExp = /[eE][\-+]?[0-9]+/;


    function doFormatNumber(number, format, options) {   //0,0.0%           0.00
        number = Math.abs(number);



        var isGroup = format.indexOf(",") != -1,
            formats = format.split("."),
            format0 = (formats[0] || "").replace(clearRegExp, ""),
            format1 = (formats[1] || "").replace(clearRegExp, ""),
//            values = String(number).split("."),
//            value0 = values[0],
//            value1 = values[1] || "",
            value = "",
            groupSize = options.groupSize[0],
            decimalsSeparator = options.decimalsSeparator,
            groupSeparator = options.groupSeparator;


        //format0 = format0.substr(format0.indexOf("0")) || "0";

        var index = format0.indexOf("0");
        format0 = index == -1 ? "0" : (format0.substr(index) || "0");


        var decimals = format1.length;                                              //保留小数位
        var decimalPlaces = format1.substr(0, format1.lastIndexOf("0") + 1).length; //补0小数位
        //format1 = format1.substr(0, format1.lastIndexOf("0") + 1);

        //alert(number);

        //先处理小数的四舍五入
        function round2(number, fractionDigits) {
            with (Math) {
                return round(number * pow(10, fractionDigits)) / pow(10, fractionDigits);
            }
        }
        number = round2(number, decimals);

        var values = String(number).split(".");
        value0 = values[0];
        value1 = values[1] || "";

        //alert(decimals + ":" + decimalPlaces);

        //整数
        if (value0) {
            value0 = pad(value0, format0.length);

            if (isGroup) {
                for (var i = 0; i < Math.floor((value0.length - (1 + i)) / 3); i++) {
                    value0 = value0.substring(0, value0.length - (4 * i + 3)) + groupSeparator + value0.substring(value0.length - (4 * i + 3));
                }
            }

            value += value0;
        }

        //小数
        if (decimals > 0) {
            value += decimalsSeparator;

//            var n = parseInt(value1.charAt(decimals));
//            if (!isNaN(n) && n > 4) {
//                var v1s = value1.split("");
//                v1s[decimals - 1] = parseInt(v1s[decimals - 1]) + 1;
//                value1 = v1s.join('');
//            }

            value += pad(value1.substr(0, decimals), decimalPlaces, true);
        }

        return value;
    }

    function transformFormat(format, value, culture, formats) {

        var options = culture.numberFormat.number;

        var map = numberFormatRegExp.exec(format);
        if (map != null) {              //n,c,p     标准设置，替换n,%,$
            var f1 = map[1], f2 = map[2];

            if (f1 == "p") {
                options = culture.numberFormat.percent;
            } else if (f1 == "c") {
                options = culture.numberFormat.currency;
            }

            var decimals = f2 ? parseInt(f2) : options.decimals;
            var pattern = options.pattern[value < 0 ? 1 : 0];
            pattern = pattern.replace("n", "#,#" + (decimals > 0 ? "." + repeat(decimals, "0") : ""));

            format = format.replace(f1 + f2, pattern)
                            .replace("$", culture.numberFormat.currency.symbol)
                            .replace("%", culture.numberFormat.percent.symbol);

        } else {
            if (isNumberFormat(format)) {
                if (value < 0 && !formats[1]) format = "-" + format;
            }
        }

        return format;
    }

    function isNumberFormat(format) {
        return format.indexOf("0") != -1 || format.indexOf("#") != -1;
    }

    function getNumberFormat(format) {  //从"￥#,#.00000 元"中提取"#,#.00000"
        if (!format) return null;
        function getIndexs(format) {
            var begin = format.indexOf("0");
            var begin2 = format.indexOf("#");
            if (begin == -1 || (begin2 != -1 && begin2 < begin)) begin = begin2;

            var end = format.lastIndexOf("0");
            var end2 = format.lastIndexOf("#");
            if (end == -1 || (end2 != -1 && end2 > end)) end = end2;

            return [begin, end];
        }

        var indexs = getIndexs(format);
        var begin = indexs[0], end = indexs[1];


        return begin > -1 ? { begin: begin, end: end, format: format.substring(begin, end + 1)} : null;
    }

    function formatNumber(number, format, culture) {
        if (typeof number != NUMBER) return "";
        if (!format) return String(number);

        var formats = format.split(";");
        format = formats[0];
        if (number < 0 && formats.length >= 2) format = formats[1];
        if (number == 0 && formats.length >= 3) format = formats[2];

        var culture = getCulture(culture),
            numberFormat = culture.numberFormat.number,
            percentFormat = culture.numberFormat.percent,
            currencyFormat = culture.numberFormat.currency,
            format = transformFormat(format, number, culture, formats),
            isCurrency = format.indexOf(currencyFormat.symbol) != -1,
            isPercent = format.indexOf(percentFormat.symbol) != -1,
            isDecimals = format.indexOf(".") != -1,
            isFormat = isNumberFormat(format),
            options = isCurrency ? currencyFormat : (isPercent ? currencyFormat : numberFormat),
            number = isPercent ? number * 100 : number;


        //e,e2,...
        var ms = eRegExp.exec(format);
        if (ms) {
            var decimals = parseInt(ms[2]);
            return isNaN(decimals) ? number.toExponential() : number.toExponential(decimals);
        }

        if (!isFormat) return format;


        var value = "", nf = getNumberFormat(format);
        if (nf != null) {
            value = doFormatNumber(number, nf.format, options);
            value = format.substr(0, nf.begin) + value + format.substr(nf.end + 1);
        } else {
            value = format;
        }

        return value;
    }

    mini.parseInt = function (value, culture, format) {
        var result = mini.parseFloat(value, culture, format);
        if (result) {
            result = result | 0;
        }
        return result;
    }

    mini.parseFloat = function (value, culture, format) {

        if (!value && value !== 0) {
            return null;
        }

        if (typeof value === NUMBER) {
            return value;
        }

        if (format && format.split(";")[2] == value) return 0;

        //handle exponential number
        if (exponentRegExp.test(value)) {
            value = parseFloat(value);
            if (isNaN(value)) {
                value = null;
            }
            return value;
        }

        value = value.toString();
        culture = mini.getCulture(culture);

        var numberFormat = culture.numberFormat,
            number = numberFormat.number,
            percent = numberFormat.percent,
            currency = numberFormat.currency,
            isPercent = value.indexOf(percent.symbol) != -1,
            isCurrency = value.indexOf(currency.symbol) != -1,
            number = isCurrency ? currency : (isPercent ? percent : number),
            pattern = number.pattern[1],
            decimals = number.decimals,
            decimalsSeparator = number.decimalsSeparator,
            groupSeparator = number.groupSeparator,
            negative = value.indexOf("-") > -1;


        function getValue(value, format, _negative) {
            var nf = getNumberFormat(format);
            if (nf) {
                var f1 = format.substr(0, nf.begin), f2 = format.substr(nf.end + 1);
                if (value.indexOf(f1) == 0 && value.indexOf(f2) > -1) {
                    value = value.replace(f1, "").replace(f2, "");
                    negative = _negative;
                }
            }
            return value;
        }

        if (!format) {
            if (negative == false) {
                format = pattern.replace("n", "#,#" + (decimals > 0 ? "." + repeat(decimals, "0") : ""))
                                .replace("$", currency.symbol)
                                .replace("%", percent.symbol);
                value = getValue(value, format, true);
            }
        } else {
            //negative = false;
            var formats = format.split(";");
            if (formats[1]) {
                format = formats[1];
                value = getValue(value, format, true);
            } else {

                format = formats[0];
                var temp = value;
                value = getValue(temp, format, false);
                if (temp == value) {
                    value = getValue(temp, "-" + format, true);
                }
            }


        }


        value = value.split(groupSeparator).join("")
                     .replace(decimalsSeparator, ".");

        var ms = value.match(/([0-9,.]+)/g);
        if (ms == null) return null;
        value = ms[0];


        value = parseFloat(value);

        if (isNaN(value)) {
            value = null;
        } else if (negative) {
            value *= -1;
        }

        if (value && isPercent) {
            value /= 100;
        }

        return value;
    }

    mini.formatNumber = formatNumber;

})(this);


var inBrowser = typeof window !== 'undefined';
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = UA && UA.indexOf('android') > 0;
var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);
var isMobile = isAndroid || isIOS;
mini.isAndroid = isAndroid;
mini.isIOS = isIOS;
mini.isMobile = isMobile;

//key
mini.Keyboard = {
    Left: 37,
    Top: 38,
    Right: 39,
    Bottom: 40,

    PageUp: 33,
    PageDown: 34,
    End: 35,
    Home: 36,

    Enter: 13,
    ESC: 27,
    Space: 32,
    Tab: 9,
    Del: 46,

    F1: 112,
    F2: 113,
    F3: 114,
    F4: 115,
    F5: 116,
    F6: 117,
    F7: 118,
    F8: 119,
    F9: 120,
    F10: 121,
    F11: 122,
    F12: 123
};

var ua = navigator.userAgent.toLowerCase(),
    check = function (regex) {
        return regex.test(ua);
    },
    DOC = document,
    isStrict = document.compatMode == "CSS1Compat",
    version = function (is, regex) {
        var m;
        return (is && (m = regex.exec(ua))) ? parseFloat(m[1]) : 0;
    },
    docMode = document.documentMode,
    isOpera = check(/opera/),
    isOpera10_5 = isOpera && check(/version\/10\.5/),
    isChrome = check(/\bchrome\b/),
    isWebKit = check(/webkit/),
    isSafari = !isChrome && check(/safari/),
    isSafari2 = isSafari && check(/applewebkit\/4/),
    isSafari3 = isSafari && check(/version\/3/),
    isSafari4 = isSafari && check(/version\/4/),
    isSafari5_0 = isSafari && check(/version\/5\.0/),
    isSafari5 = isSafari && check(/version\/5/),
    isIE = !isOpera && check(/msie/),
    isIE7 = isIE && ((check(/msie 7/) && docMode != 8 && docMode != 9 && docMode != 10) || docMode == 7),
    isIE8 = isIE && ((check(/msie 8/) && docMode != 7 && docMode != 9 && docMode != 10) || docMode == 8),
    isIE9 = isIE && ((check(/msie 9/) && docMode != 7 && docMode != 8 && docMode != 10) || docMode == 9),
    isIE10 = isIE && ((check(/msie 10/) && docMode != 7 && docMode != 8 && docMode != 9) || docMode == 10),
    isIE6 = isIE && !isIE7 && !isIE8 && !isIE9 && !isIE10,
    isIE11 = (ua.indexOf("trident") > -1 && ua.indexOf("rv") > -1),
    isIE = isIE || isIE11,
//IE_V = isIE ? parseInt(jQuery.browser.version) : -1,    
    isFirefox = navigator.userAgent.indexOf("Firefox") > 0,
    isGecko = !isWebKit && check(/gecko/),
    isGecko3 = isGecko && check(/rv:1\.9/),
    isGecko4 = isGecko && check(/rv:2\.0/),
    isGecko5 = isGecko && check(/rv:5\./),
    isGecko10 = isGecko && check(/rv:10\./),
    isFF3_0 = isGecko3 && check(/rv:1\.9\.0/),
    isFF3_5 = isGecko3 && check(/rv:1\.9\.1/),
    isFF3_6 = isGecko3 && check(/rv:1\.9\.2/),
    isWindows = check(/windows|win32/),
    isMac = check(/macintosh|mac os x/),
    isAir = check(/adobeair/),
    isLinux = check(/linux/),
    scrollbarSize = null,
    chromeVersion = version(true, /\bchrome\/(\d+\.\d+)/),
    firefoxVersion = version(true, /\bfirefox\/(\d+\.\d+)/),
    ieVersion = version(isIE, /msie (\d+\.\d+)/),
    IE_V = isIE ? parseInt(ieVersion) : -1,
    operaVersion = version(isOpera, /version\/(\d+\.\d+)/),
    safariVersion = version(isSafari, /version\/(\d+\.\d+)/),
    webKitVersion = version(isWebKit, /webkit\/(\d+\.\d+)/),
    isSecure = /^https/i.test(window.location.protocol),
    isBorderBox = isIE && !isStrict;

if (isIE6) {
    try {
        DOC.execCommand("BackgroundImageCache", false, true);
    } catch (e) { }
}
mini.boxModel = !isBorderBox;
mini.isIE = isIE;
mini.isIE6 = isIE6;
mini.isIE7 = isIE7;
mini.isIE8 = isIE8;
mini.isIE9 = isIE9;
mini.isIE10 = isIE10;
mini.isIE11 = isIE11;
mini.IE_V = isIE11 ? 11 : IE_V;
mini.isFirefox = isFirefox;
mini.isOpera = isOpera;
mini.isSafari = isSafari;
mini.isChrome = isChrome;

if (isIE) {
    jQuery(document.documentElement).addClass("ie ie" + mini.IE_V);
}

if (jQuery) jQuery.boxModel = mini.boxModel;

mini.noBorderBox = false;
if (jQuery.boxModel == false && isIE && isIE9 == false) mini.noBorderBox = true;

mini.MouseButton = {
    Left: 0,
    Middle: 1,
    Right: 2
}
if (isIE && !isIE9 && !isIE10) {
    mini.MouseButton = {
        Left: 1,
        Middle: 4,
        Right: 2
    }
}

////////////////////////////////////////////////////////////////////////////////

mini.append = function (to, html) {
    to = mini.byId(to);
    if (!html || !to) return;
    if (typeof html == "string") {
        if (html.charAt(0) == '#') {
            html = mini.byId(html);
            if (!html) return;
            to.appendChild(html);
            return html;
        } else {
            if (html.indexOf("<tr") == 0) {
                return jQuery(to).append(html)[0].lastChild;
                return;
            }

            var d = document.createElement("div");
            d.innerHTML = html;
            html = d.firstChild;
            while (d.firstChild) {
                to.appendChild(d.firstChild);
            }
            return html;
        }
    } else {
        to.appendChild(html);
        return html;
    }

    //return jQuery(to).append(html)[0].lastChild;
}
mini.prepend = function (to, html) {
    if (typeof html == "string") {
        if (html.charAt(0) == '#') {
            html = mini.byId(html);
        } else {
            var d = document.createElement("div");
            d.innerHTML = html;
            html = d.firstChild;
        }
    }
    return jQuery(to).prepend(html)[0].firstChild;
}
mini.after = function (to, html) {
    if (typeof html == "string") {
        if (html.charAt(0) == '#') {
            html = mini.byId(html);
        } else {
            var d = document.createElement("div");
            d.innerHTML = html;
            html = d.firstChild;
        }
    }
    if (!html || !to) return;
    to.nextSibling ? to.parentNode.insertBefore(html, to.nextSibling) : to.parentNode.appendChild(html);
    return html;
}
mini.before = function (to, html) {
    if (typeof html == "string") {
        if (html.charAt(0) == '#') {
            html = mini.byId(html);
        } else {
            var d = document.createElement("div");
            d.innerHTML = html;
            html = d.firstChild;
        }
    }
    if (!html || !to) return;
    to.parentNode.insertBefore(html, to);
    //jQuery(to).before(html);
    return html;
}

mini.__wrap = document.createElement('div');
mini.createElements = function (html) {
    mini.removeChilds(mini.__wrap);
    var isTr = html.indexOf("<tr") == 0;
    if (isTr) {
        html = '<table>' + html + '</table>';
    }
    mini.__wrap.innerHTML = html;
    return isTr ? mini.__wrap.firstChild.rows : mini.__wrap.childNodes;
}

mini_byId = function (id, context) {
    if (typeof id == "string") {
        if (id.charAt(0) == '#') id = id.substr(1);
        var el = document.getElementById(id);
        if (el) return el;
        if (context && !mini.isAncestor(document.body, context)) {
            return context.querySelector('[id="' + id + '"]');
        }
    } else {
        return id;
    }
}
mini_hasClass = function (el, className) {
    el = mini.byId(el);
    if (!el) return;
    if (!el.className) return false;
    var clss = String(el.className).split(" ");
    return clss.indexOf(className) != -1;
}
mini_addClass = function (el, className) {
    if (!className) return;
    if (mini.hasClass(el, className) == false) {
        jQuery(el).addClass(className);
    }
}
mini_removeClass = function (el, className) {
    if (!className) return;
    jQuery(el).removeClass(className);
    //        el = mini.byId(el);
    //        if (!el) return;
    //        el.className = el.className.replace(className, "");
}

var _ceil = function (n) {
    return Math.ceil(parseFloat(n));
}

mini_getMargins = function (el) {
    el = mini.byId(el);
    var jq = jQuery(el);
    return {
        top: _ceil(jq.css("margin-top"), 10) || 0,
        left: _ceil(jq.css("margin-left"), 10) || 0,
        bottom: _ceil(jq.css("margin-bottom"), 10) || 0,
        right: _ceil(jq.css("margin-right"), 10) || 0
    };
}
mini_getBorders = function (el) {
    el = mini.byId(el);
    var jq = jQuery(el);
    return {
        top: _ceil(jq.css("border-top-width"), 10) || 0,
        left: _ceil(jq.css("border-left-width"), 10) || 0,
        bottom: _ceil(jq.css("border-bottom-width"), 10) || 0,
        right: _ceil(jq.css("border-right-width"), 10) || 0
    };
}

mini_getPaddings = function (el) {
    el = mini.byId(el);
    var jq = jQuery(el);
    return {
        top: _ceil(jq.css("padding-top"), 10) || 0,
        left: _ceil(jq.css("padding-left"), 10) || 0,
        bottom: _ceil(jq.css("padding-bottom"), 10) || 0,
        right: _ceil(jq.css("padding-right"), 10) || 0
    };
}
//var ___count = 0;
mini_setWidth = function (el, width) {
    el = mini.byId(el);
    width = parseInt(width);
    if (isNaN(width) || !el) return;
    if (jQuery.boxModel) {
        var p = mini.getPaddings(el);
        var b = mini.getBorders(el);
        width = width - p.left - p.right - b.left - b.right;

        
    }
    //    var m = mini.getMargins(el);
    //    width = width - m.left - m.right;
    if (width < 0) width = 0;
    el.style.width = width + "px";
}
mini_setHeight = function (el, height) {
    el = mini.byId(el);
    height = parseInt(height);
    if (isNaN(height) || !el) return;
    if (jQuery.boxModel) {
        var p = mini.getPaddings(el);
        var b = mini.getBorders(el);
        height = height - p.top - p.bottom - b.top - b.bottom;
        //document.title = ___count++;
        
    }
    //    var m = mini.getMargins(el);
    //    height = height - m.top - m.bottom;
    if (height < 0) height = 0;
    el.style.height = height + "px";
}
mini_getWidth = function (el, content) {
    el = mini.byId(el);
    if (el.style.display == "none" || el.type == "text/javascript") return 0;
    return content ? jQuery(el).width() : jQuery(el).outerWidth();
}
mini_getHeight = function (el, content) {
    el = mini.byId(el);
    if (el.style.display == "none" || el.type == "text/javascript") return 0;
    return content ? jQuery(el).height() : jQuery(el).outerHeight();
}
mini_setBox = function (el, x, y, width, height) {
    if (y === undefined) {
        y = x.y;
        width = x.width;
        height = x.height;
        x = x.x;
    }
    mini.setXY(el, x, y);
    mini.setWidth(el, width);
    mini.setHeight(el, height);
}
mini_getBox = function (el) {
    var xy = mini.getXY(el);
    var box = {
        x: xy[0],
        y: xy[1],
        width: mini.getWidth(el),
        height: mini.getHeight(el)
    };
    box.left = box.x;
    box.top = box.y;
    box.right = box.x + box.width;
    box.bottom = box.y + box.height;
    return box;
}
mini_setStyle = function (el, style) {
    el = mini.byId(el);
    if (!el || typeof style != "string") return;

    var jq = jQuery(el);
    var styles = style.toLowerCase().split(";");
    for (var i = 0, l = styles.length; i < l; i++) {
        var s = styles[i];
        var ss = s.split(":");
        if (ss.length > 1) {
            if (ss.length > 2) {
                var s1 = ss[0].trim();
                ss.removeAt(0);
                var s2 = ss.join(":").trim();
                jq.css(s1, s2);
            } else {
                jq.css(ss[0].trim(), ss[1].trim());
            }
        }
    }
}

mini_getStyle = function () {
    var f = document.defaultView;
    var el = arguments[0];
    var style = arguments[1];
    if(!el || !style) {
        return null;
    }
    // if (style.indexOf('-') > -1) {
    //     style = style.replace(/-(\\w)/g, function (m, a) {
    //         return a.toUpperCase();
    //     });
    // }
    if (style === 'float') {
        style = f ? 'cssFloat' : 'styleFloat';
    }
    return jQuery.css(el, style);
};
mini_isAncestor = function (p, c) {
    var ret = false;
    p = mini.byId(p);
    c = mini.byId(c);
    if (p === c) return true;
    if (p && c) {
        if (p.contains) {
            try {
                return p.contains(c);
            } catch (e) {
                return false;
            }
        } else
            if (p.compareDocumentPosition) {
                return !!(p.compareDocumentPosition(c) & 16);
            } else {
                while (c = c.parentNode) {
                    ret = c == p || ret;
                }
            }
    }
    return ret;
}
mini_findParent = function (p, cls, maxDepth) {
    p = mini.byId(p);
    var b = document.body, depth = 0, stopEl;
    maxDepth = maxDepth || 50;
    if (typeof maxDepth != "number") {
        stopEl = mini.byId(maxDepth);
        maxDepth = 10;
    }
    while (p && p.nodeType == 1 && depth < maxDepth && p != b && p != stopEl) {
        if (mini.hasClass(p, cls)) {
            return p;
        }
        depth++;
        p = p.parentNode;
    }
    return null;
}
mini.copyTo(mini, {
    byId: mini_byId,
    hasClass: mini_hasClass,
    addClass: mini_addClass,
    removeClass: mini_removeClass,

    getMargins: mini_getMargins,
    getBorders: mini_getBorders,
    getPaddings: mini_getPaddings,
    setWidth: mini_setWidth,
    setHeight: mini_setHeight,
    getWidth: mini_getWidth,
    getHeight: mini_getHeight,
    setBox: mini_setBox,
    getBox: mini_getBox,

    setStyle: mini_setStyle,
    getStyle: mini_getStyle,

    repaint: function (el) {
        if (!el) el = document.body;
        mini.addClass(el, "mini-repaint");
        setTimeout(function () {
            mini.removeClass(el, "mini-repaint");
        }, 1);
    },

    getSize: function (el, content) {
        return {
            width: mini.getWidth(el, content),
            height: mini.getHeight(el, content)
        };
    },
    setSize: function (el, width, height) {
        mini.setWidth(el, width);
        mini.setHeight(el, height);
    },
    setX: function (el, x) {
        x = parseInt(x);
        var xy = jQuery(el).offset();
        //var y = xy.top;
        var y = parseInt(xy.top);
        if (y === undefined) y = xy[1];
        mini.setXY(el, x, y);
    },
    setY: function (el, y) {
        y = parseInt(y);
        var xy = jQuery(el).offset();
        var x = parseInt(xy.left);
        if (x === undefined) x = xy[0];
        mini.setXY(el, x, y);
    },
    setXY: function (el, x, y) {

        var xy = {
            left: parseInt(x),
            top: parseInt(y)
        };
        jQuery(el).offset(xy);


        //jQuery(el).offset(xy);      //jquery 1.4 bug

        //        if (jQuery.fn.jquery == "1.4") {
        //            jQuery(el).offset(xy);      //jquery 1.4 bug
        //        }

        if (jQuery.fn.jquery && jQuery.fn.jquery.indexOf("1.4") != -1) {
            jQuery(el).offset(xy);      //jquery 1.4 bug
        }
    },
    getXY: function (el) {

        var xy = jQuery(el).offset();
        //if (!xy) xy = { left: 0, top: 0 };
        return [parseInt(xy.left), parseInt(xy.top)];
    },
    getViewportBox: function () {
        //debugger
        //  var top = jQuery(window).scrollTop();
        var w = jQuery(window).width(), h = jQuery(window).height();
        var x = jQuery(document).scrollLeft(), y = jQuery(document.body).scrollTop();
        if (y == 0 && document.documentElement) y = document.documentElement.scrollTop;

        return {
            x: x, y: y, top: y, left: x, width: w, height: h, right: x + w, bottom: y + h
        };
    },
    showAt: function (options) {
        var $ = jQuery;
        //{ el, left, top, animation, fixed, offset }            
        options = jQuery.extend({
            el: null,
            //container: null,      //没用，自动匹配父元素尺寸定位
            x: 'center',         //left|center|right
            y: 'center',          //top|center|bottom
            offset: [0, 0],
            fixed: false,           //相对于页面整体，而非父元素
            zindex: mini.getMaxZIndex(),
            timeout: 0,
            timeoutHandler: null,
            constrain: false,
            animation: false
        }, options);
        var el = jQuery(options.el)[0],
            x = options.x,
            y = options.y,
            offsetx = options.offset[0],
            offsety = options.offset[1],
            zindex = options.zindex,
            fixed = options.fixed,
            animation = options.animation;
        if (!el) return;

        if (options.timeout) {
            setTimeout(function () {
                if (options.timeoutHandler) options.timeoutHandler();
                //else el.style.display = 'none';
            }, options.timeout);
        }



        var s = ';position:absolute;display:block;left:auto;top:auto;right:auto;bottom:auto;margin:0;z-index:' + zindex + ';';
        mini.setStyle(el, s);
        var s = "";

        if (options && mini.isNumber(x) && mini.isNumber(y)) {
            if (options.fixed && !mini.isIE6) {
                s += ";position:fixed;";
            }
            mini.setStyle(el, s);

            if (options.constrain) {
                var width = jQuery(window).width(),
                    height = jQuery(window).height(),
                    size = mini.getSize(el);

                if (x + size.width > width) x = width - size.width;
                if (x < 0) x = 0;
                if (y + size.height > height) y = height - size.height;
                if (y < 0) y = 0;

            }

            mini.setXY(el, x, y);


            return;
        }


        //x
        if (x == 'left') {
            s += 'left:' + offsetx + 'px;';
        } else if (x == 'right') {
            s += 'right:' + offsetx + 'px;';
        } else {
            var size = mini.getSize(el);
            s += 'left:50%;margin-left:' + (-size.width * 0.5) + 'px;';
        }
        //y
        if (y == 'top') {
            s += 'top:' + offsety + 'px;';
        } else if (y == 'bottom') {
            s += 'bottom:' + offsety + 'px;';
        } else {
            var size = mini.getSize(el);
            s += 'top:50%;margin-top:' + (-size.height * 0.5) + 'px;';
        }

        if (fixed && !mini.isIE6) {
            s += 'position:fixed';
        }



        mini.setStyle(el, s);

    },
    getChildNodes: function (el, all) {
        el = mini.byId(el);
        if (!el) return;
        var nodes = el.childNodes;
        var cs = [];
        for (var i = 0, l = nodes.length; i < l; i++) {
            var c = nodes[i];
            if (c.nodeType == 1 || all === true) {
                cs.push(c);
            }
        }
        return cs;
    },
    //ie需要特殊处理才能正确删除元素，防止内存泄漏
    removeNode: isIE ? function () {
        var d;
        return function (n) {
            if (n && n.tagName != 'BODY') {
                d = d || document.createElement('div');
                d.appendChild(n);
                d.innerHTML = '';
            }
        }
    } () : function (n) {
        if (n && n.parentNode && n.tagName != 'BODY') {
            n.parentNode.removeChild(n);
        }
    },

    removeChilds: function (el, butEl) {
        el = mini.byId(el);
        if (!el) return;
        var cs = mini.getChildNodes(el, true);
        for (var i = 0, l = cs.length; i < l; i++) {
            var c = cs[i];
            if (butEl && c == butEl) {
            } else {
                el.removeChild(cs[i]);
            }
        }
    },
    isAncestor: mini_isAncestor,
    findParent: mini_findParent,
    findChild: function (el, cls) {
        el = mini.byId(el);
        var els = el.getElementsByTagName('*');
        for (var i = 0, l = els.length; i < l; i++) {
            var el = els[i];
            if (mini.hasClass(el, cls)) return el;
        }
    },
    isAncestor: function (p, c) {
        var ret = false;
        p = mini.byId(p);
        c = mini.byId(c);
        if (p === c) return true;
        if (p && c) {
            if (p.contains) {
                try {
                    return p.contains(c);
                } catch (e) { return false }
            } else
                if (p.compareDocumentPosition) {
                    return !!(p.compareDocumentPosition(c) & 16);
                } else {
                    while (c = c.parentNode) {
                        ret = c == p || ret;
                    }
                }
        }
        return ret;
    },
    getOffsetsTo: function (el, target) {
        var o = this.getXY(el), e = this.getXY(target);
        return [o[0] - e[0], o[1] - e[1]];
    },
    scrollIntoView: function (el, container, hscroll, vscroll) {
        var c = mini.byId(container) || document.body,
        	o = this.getOffsetsTo(el, c),
            l = o[0] + c.scrollLeft,
            t = o[1] + c.scrollTop,
            b = t + el.offsetHeight,
            r = l + el.offsetWidth,
        	ch = c.clientHeight,
        	ct = parseInt(c.scrollTop, 10),
        	cl = parseInt(c.scrollLeft, 10),
        	cb = ct + ch,
        	cr = cl + c.clientWidth;

        if (vscroll !== false) {
            if (el.offsetHeight > ch || t < ct) {
                c.scrollTop = t;
            } else if (b > cb) {
                c.scrollTop = b - ch;
            }
            c.scrollTop = c.scrollTop; // corrects IE, other browsers will ignore
        }

        if (hscroll !== false) {
            if (el.offsetWidth > c.clientWidth || l < cl) {
                c.scrollLeft = l;
            } else if (r > cr) {
                c.scrollLeft = r - c.clientWidth;
            }
            c.scrollLeft = c.scrollLeft;
        }
        return this;
    },
    getScrollOffset: function () {
        if (!mini._scrollOffset) {
            var el = document.createElement('div');
            //el.style.cssText = 'width:100px;background:#eee;height:50px;overflow:scroll;padding:1px;position:absolute;left:-1000px;top:0;';
            el.style.cssText = 'width:100px;background:#eee;height:50px;overflow:scroll;padding:1px;position:absolute;left:-1000px;top:0;box-sizing:content-box;-moz-box-sizing: content-box;';

            document.body.appendChild(el);

            mini._scrollOffset = el.offsetWidth - el.clientWidth;

            el.parentNode.removeChild(el);
        }
        return mini._scrollOffset;
    },
    setOpacity: function (el, opacity) {
        jQuery(el).css({
            "opacity": opacity
        });
    },
    selectable: function (el, selected) {
        el = mini.byId(el);
        if (!!selected) {
            jQuery(el).removeClass('mini-unselectable');
            if (isIE) el.unselectable = "off";
            else {
                el.style.MozUserSelect = '';
                el.style.KhtmlUserSelect = '';
                el.style.UserSelect = '';

            }
        } else {
            jQuery(el).addClass('mini-unselectable');
            if (isIE) el.unselectable = 'on';
            else {
                el.style.MozUserSelect = 'none';
                el.style.UserSelect = 'none';
                el.style.KhtmlUserSelect = 'none';
            }
        }
    },
    selectRange: function (el, iStart, iEnd) {
        if (el.createTextRange) {
            var oRange = el.createTextRange();
            oRange.moveStart("character", iStart);
            oRange.moveEnd("character", iEnd - el.value.length);
            oRange.select();
        } else {
            if (el.setSelectionRange) {
                el.setSelectionRange(iStart, iEnd);
            }
        }
        try {
            el.focus();
        } catch (e) {
        }
    },
    getSelectRange: function (el) {
        el = mini.byId(el);
        if (!el) return;
        try {
            el.focus();
        } catch (e) {
        }
        var start = 0, end = 0;
        if (el.createTextRange && document.selection) {
            //start
            var r = document.selection.createRange().duplicate();
            r.moveEnd('character', el.value.length);
            if (r.text === '') {
                start = el.value.length;
            }
            else {
                start = el.value.lastIndexOf(r.text);
            }

            //end
            var r = document.selection.createRange().duplicate();
            r.moveStart('character', -el.value.length);
            end = r.text.length;

        } else {
            start = el.selectionStart;
            end = el.selectionEnd;
        }

        return [start, end];
    }

});
(function () {
    var fixAttr = {
        tabindex: 'tabIndex',
        readonly: 'readOnly',
        'for': 'htmlFor',
        'class': 'className',
        maxlength: 'maxLength',
        cellspacing: 'cellSpacing',
        cellpadding: 'cellPadding',
        rowspan: 'rowSpan',
        colspan: 'colSpan',
        usemap: 'useMap',
        frameborder: 'frameBorder',
        contenteditable: 'contentEditable'
    };

    var div = document.createElement('div');
    div.setAttribute('class', 't');
    var supportSetAttr = div.className === 't';

    mini.setAttr = function (el, name, val) {
        el.setAttribute(supportSetAttr ? name : (fixAttr[name] || name), val);
    }

    mini.getAttr = function (el, name) {
        if(name == "height") return jQuery(el).attr("height");

        if(name == "value" && (isIE6 || isIE7)){
            var a = el.attributes[name]
            return a ? a.value : null;
        }

        if(!el.getAttribute) return null;

        var v = el.getAttribute(supportSetAttr ? name : (fixAttr[name] || name));
        
        if(typeof v == "function" || name == "maxLength"){
            var o = el.attributes[name];
            if(o) v = o.value;
        }

        //onload
        if(!v && name == "onload"){        
            var node = el.getAttributeNode ? el.getAttributeNode(name) : null;
            if(node){
                v = node.nodeValue;
            }
        }

        return v;
    }

})()


/* Html Event 
-----------------------------------------------------------------------------*/
mini_preventDefault = function () {
    if (window.event) {
        window.event.returnValue = false;
    }
}
mini_stopPropogation = function () {
    if (window.event) {
        window.event.cancelBubble = true;
    }
}
mini_onOne = function (el, type, fn, scope) {
    //    mini_on(el, type, fn, scope);
    //    return;
    if (!el) return;
    var name = "on" + type.toLowerCase();
    //el[name] = mini_createOneDelegate(fn, scope);
    el[name] = function (e) {
        e = e || window.event;
        if (!e.target) {
            e.target = e.srcElement;
        }
        if (!e.preventDefault) {
            e.preventDefault = mini_preventDefault;
        }
        if (!e.stopPropogation) {
            e.stopPropogation = mini_stopPropogation;
        }
        var ret = fn.call(scope, e);
        if (ret === false) return false;
    }
}



mini_on = function (el, type, fn, scope) {
    el = mini.byId(el);
    scope = scope || el;
    if (!el || !type || !fn || !scope) return false
    var listener = mini.findListener(el, type, fn, scope);
    if (listener) return false;
    var method = mini.createDelegate(fn, scope);
    mini.listeners.push([el, type, fn, scope, method]);
    if (mini.isFirefox && type == 'mousewheel') type = 'DOMMouseScroll';
    jQuery(el).bind(type, method);
};
mini_un = function (el, type, fn, scope) {
    el = mini.byId(el);
    scope = scope || el;
    if (!el || !type || !fn || !scope) return false
    var listener = mini.findListener(el, type, fn, scope);
    if (!listener) return false;
    if (!mini._destroying) {
        mini.listeners.remove(listener);
    }
    if (mini.isFirefox && type == 'mousewheel') type = 'DOMMouseScroll';
    jQuery(el).unbind(type, listener[4]);
};
mini.copyTo(mini, {
    listeners: [], //[el, type, fn, scope]    
    on: mini_on,
    un: mini_un,
    _getListeners: function () {
        var listeners = mini.listeners;
        return listeners;
    },
    findListener: function (el, type, fn, scope) {
        el = mini.byId(el);
        scope = scope || el;
        if (!el || !type || !fn || !scope) return false
        var listeners = mini._getListeners();

        for (var i = listeners.length - 1; i >= 0; i--) {
            var listener = listeners[i];
            try {
                if (listener[0] == el
                && listener[1] == type
                && listener[2] == fn
                && listener[3] == scope
            ) {
                    return listener;
                }
            } catch (ex) { }

        }
    },
    clearEvent: function (el, type) {
        el = mini.byId(el);
        if (!el) return false;

        if (mini._destroying) {
            jQuery(el).unbind();
            return;
        }

        var listeners = mini._getListeners();
        for (var i = listeners.length - 1; i >= 0; i--) {
            var listener = listeners[i];
            //try {
            if (listener[0] == el) {
                if (!type || type == listener[1]) {
                    mini.un(el, listener[1], listener[2], listener[3]);
                }
            }
            //} catch (ex) { debugger }
        }
        el.onmouseover = el.onmousedown = null;
    }
    //    ,
    //    fireEvent: function (el, type) {
    //        
    //    }
});


//window resize
mini.__windowResizes = [];
mini.onWindowResize = function (fn, scope) {
    mini.__windowResizes.push([fn, scope]);
}
mini.on(window, "resize", function (e) {
    var events = mini.__windowResizes;
    for (var i = 0, l = events.length; i < l; i++) {
        var event = events[i];
        event[0].call(event[1], e);
    }
});


mini.htmlEncode = function (str) {
    if (typeof str !== "string") return str;
    var s = "";
    if (str.length == 0) return "";
    s = str;
    s = s.replace(/&/g, "&amp;");
    s = s.replace(/</g, "&lt;");
    s = s.replace(/>/g, "&gt;");
    s = s.replace(/ /g, "&nbsp;");
    s = s.replace(/\'/g, "&#39;");
    s = s.replace(/\"/g, "&quot;");
    //s = s.replace(/\n/g, "<br>");
    return s;
}

mini.htmlDecode = function (str) {
    if (typeof str !== "string") return str;
    var s = "";
    if (str.length == 0) return "";
    s = str.replace(/&gt;/g, "&");
    s = s.replace(/&lt;/g, "<");
    s = s.replace(/&gt;/g, ">");
    s = s.replace(/&nbsp;/g, " ");
    s = s.replace(/&#39;/g, "\'");
    s = s.replace(/&quot;/g, "\"");
    //s = s.replace(/<br>/g, "\n");
    return s;
}

/* Array 
-----------------------------------------------------------------------------*/
var array_extend = {
    add: function (item) {
        this[this.length] = item;
        return this;
    },
    getRange: function (start, end) {
        var arr = [];
        for (var i = start; i <= end; i++) {
            var o = this[i];
            if (o) {
                arr[arr.length] = o;
            }
        }
        return arr;
    },
    addRange: function (array) {
        for (var i = 0, j = array.length; i < j; i++) this[this.length] = array[i];
        return this;
    },
    clear: function () {
        this.length = 0;
        return this;
    },
    clone: function () {
        if (this.length === 1) {
            return [this[0]];
        }
        else {
            return Array.apply(null, this);
        }
    },
    contains: function (item) {
        return (this.indexOf(item) >= 0);
    },
    dequeue: function () {
        return this.shift();
    },
    insert: function (index, item) {
        this.splice(index, 0, item);
        return this;
    },
    insertRange: function (index, items) {
        for (var i = items.length - 1; i >= 0; i--) {
            var item = items[i];
            this.splice(index, 0, item);

        }
        return this;
    },
    remove: function (item) {
        var index = this.indexOf(item);
        if (index >= 0) {
            this.splice(index, 1);
        }
        return (index >= 0);
    },
    removeAt: function (index) {
        var ritem = this[index];
        this.splice(index, 1);
        return ritem;
    },
    removeRange: function (items) {
        items = items.clone();
        for (var i = 0, l = items.length; i < l; i++) {
            this.remove(items[i]);
        }
    }
};
if (Object.defineProperty && /\[native code\]/.test(Object.defineProperty.toString())) {
    for (var key in array_extend) {
        if (!Object.prototype.hasOwnProperty.call(array_extend, key)) {
            continue;
        }
        Object.defineProperty(Array.prototype, key, {
            value: array_extend[key],
            configurable: true,
            enumerable: false,
            writable: true
        });
    }
    key = null;
} else {
    mini.copyTo(Array.prototype, array_extend);
}
array_extend = null;

//////////////////////////////////////////////////////////

mini.isShowBackdrop = !(mini.isIE && mini.IE_V <= 8);


//Mask

mini._MaskID = 1;
mini._MaskObjects = {};
mini.mask = function (options) {
    //{html, cls, style, opacity, background}

    var el = mini.byId(options);
    if (mini.isElement(el)) options = { el: el };
    else if (typeof options == "string") options = { html: options };

    options = mini.copyTo({
        html: "",
        cls: "",
        style: "",
        //opacity: .3,
        backStyle: ""
    }, options);
    options.el = mini.byId(options.el);
    if (!options.el) options.el = document.body;
    var el = options.el;

    mini["unmask"](options.el);
    el._maskid = mini._MaskID++;
    mini._MaskObjects[el._maskid] = options;

    var maskEl = mini.append(el, '<div class="mini-mask">' +
        '<div class="mini-mask-background" style="' + options.backStyle + '"></div>' +
                        '<div class="mini-mask-msg ' + options.cls + '" style="' + options.style + '">' + options.html + '</div>'
        + '</div>');
    if (el == document.body) mini.addClass(maskEl, 'mini-fixed');

    //if (!mini.isShowBackdrop) {
        //$(maskEl).find('.mini-mask-background').css("display", "none");
    //}

    options.maskEl = maskEl;
    if (!mini.isNull(options.opacity)) {
        mini.setOpacity(maskEl.firstChild, options.opacity);
    }

    function center() {
        msgEl.style.display = "block";
        var size = mini.getSize(msgEl);
        msgEl.style.marginLeft = -size.width / 2 + "px";
        msgEl.style.marginTop = -size.height / 2 + "px";
        msgEl.style.zIndex = mini.getMaxZIndex();
    }
    var msgEl = maskEl.lastChild;
    msgEl.style.display = "none";
    //center();
    setTimeout(function () {
        center();
    }, 0);

}

mini["unmask"] = function (el) {
    el = mini.byId(el);
    if (!el) el = document.body;
    var options = mini._MaskObjects[el._maskid];
    if (!options) return;
    delete mini._MaskObjects[el._maskid];
    var maskEl = options.maskEl;
    options.maskEl = null;
    if (maskEl && maskEl.parentNode) {
        maskEl.parentNode.removeChild(maskEl);
    }
}

mini.showMaskLoading = function (options) {
    options = $.extend({
        el: document.body,
        cls: 'mini-mask-loading',
        html: mini.Control.prototype.loadingMsg || 'Loading...'
    }, options);
    return mini.mask(options);
}

//////////////////////////////////////////
mini.Cookie = {
    get: function (sName) {
        var aCookie = document.cookie.split("; ");
        var lastMatch = null;
        for (var i = 0; i < aCookie.length; i++) {
            var aCrumb = aCookie[i].split("=");
            if (sName == aCrumb[0]) {
                lastMatch = aCrumb;
            }
        }
        if (lastMatch) {
            var v = lastMatch[1];
            if (v === undefined) return v;
            return unescape(v);
        }
        return null;
    },
    set: function (name, value, expires, domain) {
        var LargeExpDate = new Date();
        if (expires != null) {
            //LargeExpDate.setTime(LargeExpDate.getTime() + (expires*1000*3600*24));         

            LargeExpDate = new Date(LargeExpDate.getTime() + (expires * 1000 * 3600 * 24)); //expires天数            
        }

        document.cookie = name + "=" + escape(value) + ((expires == null) ? "" : ("; expires=" + LargeExpDate.toGMTString())) + ";path=/" + (domain ? "; domain=" + domain : "");
    },
    del: function (name, domain) {
        this.set(name, null, -100, domain);
    }
};

//////////////////////////////////////////
mini.copyTo(mini, {
    treeToArray: function (nodes, nodesField, idField, parentIdField, parentId) {
        if (!nodesField) nodesField = 'children';
        var array = [];
        for (var i = 0, l = nodes.length; i < l; i++) {
            var node = nodes[i];
            array[array.length] = node;

            if (parentIdField) node[parentIdField] = parentId;

            var childrenNodes = node[nodesField];
            if (childrenNodes && childrenNodes.length > 0) {
                var id = node[idField];
                var childrenArray = this.treeToArray(childrenNodes, nodesField, idField, parentIdField, id);
                array.addRange(childrenArray);
            }
        }
        return array;
    },
    /*
    数组转树形
    ArrayToTree(array, 'Nodes', '_Id', '_ParentId');
    */
    arrayToTree: function (data, nodesField, idField, parentIdField) {
        if (!nodesField) nodesField = 'children';
        idField = idField || '_id';
        parentIdField = parentIdField || '_pid';

        var nodes = [];

        //建立快速索引
        var idHash = {};
        for (var i = 0, l = data.length; i < l; i++) {
            var o = data[i];
            if (!o) continue;
            //var id = o[idField];
            var id = mini._getMap(idField, o);
            if (id !== null && id !== undefined) {
                idHash[id] = o;
            }
            delete o[nodesField];
        }

        //数组转树形
        for (var i = 0, l = data.length; i < l; i++) {
            var o = data[i];
            var pid = mini._getMap(parentIdField, o);
            var p = idHash[pid];
            if (!p) {
                nodes.push(o);
                continue;
            }
            if (!p[nodesField]) {
                p[nodesField] = [];
            }
            p[nodesField].push(o);
        }
        return nodes;
    }

});
mini.treeToList = mini.treeToArray;
mini.listToTree = mini.arrayToTree;

mini.UUID = function UUID() {
    var s = [], itoh = '0123456789ABCDEF'.split('');
    for (var i = 0; i < 36; i++) s[i] = Math.floor(Math.random() * 0x10);
    s[14] = 4;
    s[19] = (s[19] & 0x3) | 0x8;
    for (var i = 0; i < 36; i++) s[i] = itoh[s[i]];
    s[8] = s[13] = s[18] = s[23] = '-';
    return s.join('');
}


String.format = function (format) {
    var args = Array.prototype.slice.call(arguments, 1);
    format = format || "";
    return format.replace(/\{(\d+)\}/g, function (m, i) {
        return args[i];
    });
}
String.prototype.trim = function () {
    var re = /^\s+|\s+$/g;
    return function () { return this.replace(re, ""); };
} ();



//////////////////////////////////////////
mini.copyTo(mini, {
    measureText: function (el, text, style) {
        if (!this.measureEl) {
            this.measureEl = mini.append(document.body, '<div></div>');
        }

        this.measureEl.style.cssText = "position:absolute;left:-1000px;top:-1000px;visibility:hidden;";
        if (typeof el == "string") {
            this.measureEl.className = el;

        } else {
            this.measureEl.className = "";

            var j1 = jQuery(el);
            var j2 = jQuery(this.measureEl);
            var csses = ['font-size', 'font-style', 'font-weight', 'font-family', 'line-height', 'text-transform', 'letter-spacing'];
            for (var i = 0, l = csses.length; i < l; i++) {
                var css = csses[i];
                j2.css(css, j1.css(css));
            }
        }
        if (style) mini.setStyle(this.measureEl, style);
        this.measureEl.innerHTML = text;
        return mini.getSize(this.measureEl);
    }
});


//////////////////////////////////////////////////////////
if (typeof mini_layoutOnParse == 'undefined') mini_layoutOnParse = true;

mini.enableLayout = true;

mini.autoParse = true;

jQuery(function () {

    // mini.updateDevice();

    if (mini.autoParse) {
        
        //fix: requiredjs
        setTimeout(function () {
            mini.__LastWindowWidth = document.documentElement.clientWidth;
            mini.__LastWindowHeight = document.documentElement.clientHeight;

            mini.isReady = true;
            mini.parse(null, mini_layoutOnParse);
            mini._FireBindEvents();
        }, 1);

    }
});
mini_onload = function (e) {
    //alert(mini_layoutOnParse ? false : true);

    mini.on(window, "resize", mini_onresize);
    //mini.repaint(document.body);    //

    //mini.layout(null);
}
mini.on(window, "load", mini_onload);

mini.__LastWindowWidth = document.documentElement.clientWidth;
mini.__LastWindowHeight = document.documentElement.clientHeight;
mini.doWindowResizeTimer = null;

mini.allowLayout = true;



//var count = 0;
mini_onresize = function (e) {

    // mini.updateDevice();

    //document.title = count++;
    if (mini.doWindowResizeTimer) {
        clearTimeout(mini.doWindowResizeTimer);
    }
    mini.WindowVisible = mini.isWindowDisplay();
    if (mini.WindowVisible == false || mini.allowLayout == false) return;

    if (typeof Ext != "undefined") {
        mini.doWindowResizeTimer = setTimeout(function () {
            var __LastWindowWidth = document.documentElement.clientWidth;
            var __LastWindowHeight = document.documentElement.clientHeight;
            if (mini.__LastWindowWidth == __LastWindowWidth && mini.__LastWindowHeight == __LastWindowHeight) {
            } else {

                mini.__LastWindowWidth = __LastWindowWidth;
                mini.__LastWindowHeight = __LastWindowHeight;

                
                mini.layout(null, false);
            }
            mini.doWindowResizeTimer = null;
        }, 300);
    } else {
        var deferTime = 100;
        try {
            if (parent && parent != window && parent.mini) {
                deferTime = 0;
            }
        } catch (ex) {
        }
        mini.doWindowResizeTimer = setTimeout(function () {
            var __LastWindowWidth = document.documentElement.clientWidth;
            var __LastWindowHeight = document.documentElement.clientHeight;
            //            if (__LastWindowHeight == 0 || __LastWindowHeight == 0) {
            //                mini.doWindowResizeTimer = null;
            //                return;
            //            }
            if (mini.__LastWindowWidth == __LastWindowWidth && mini.__LastWindowHeight == __LastWindowHeight) {
            } else {

                mini.__LastWindowWidth = __LastWindowWidth;
                mini.__LastWindowHeight = __LastWindowHeight;

                
                mini.layout(null, false);
            }
            mini.doWindowResizeTimer = null;
        }, deferTime);
    }
}



//////////////////////////////////////////////////
mini.isDisplay = function (p, body) {
    var doc = body || document.body;
    while (1) {
        if (p == null || !p.style) return false;
        if (p && p.style && p.style.display == "none") return false;
        if (p == doc) return true;

        p = p.parentNode;

    }
    return true;
};


mini.isWindowDisplay = function () {
    try {
        var parentWindow = window.parent;
        var isIFrame = parentWindow != window;

        if (isIFrame) {
            var _iframes = parentWindow.document.getElementsByTagName("iframe");
            var _frames = parentWindow.document.getElementsByTagName("frame");
            var iframes = [];
            for (var i = 0, l = _iframes.length; i < l; i++) {
                iframes.push(_iframes[i]);
            }
            for (var i = 0, l = _frames.length; i < l; i++) {
                iframes.push(_frames[i]);
            }

            var iframe = null;
            for (var i = 0, l = iframes.length; i < l; i++) {
                var el = iframes[i];
                if (el.contentWindow == window) {
                    iframe = el;
                    break;
                }
            }
            if (!iframe) return false;

            return mini.isDisplay(iframe, parentWindow.document.body);


        } else {
            return true;
        }
    } catch (e) {
        return true;
    }
};
/////////////////////////////////////////////////////

mini.WindowVisible = mini.isWindowDisplay();

//以后去除的话，提供一个全局变量
mini.layoutIFrames = function (parentNode) {

    if (!document.body) return;
    if (!parentNode) parentNode = document.body;
    var iframes = parentNode.getElementsByTagName("iframe");

    //alert(iframes.length);

    setTimeout(function () {
        for (var i = 0, l = iframes.length; i < l; i++) {
            var el = iframes[i];
            try {
                if (mini.isDisplay(el) && mini.isAncestor(parentNode, el)) {
                    if (el.contentWindow.mini) {
                        if (el.contentWindow.mini.WindowVisible == false) {
                            el.contentWindow.mini.WindowVisible = el.contentWindow.mini.isWindowDisplay();
                            el.contentWindow.mini.layout();
                        } else {
                            el.contentWindow.mini.layout(null, false);
                        }
                    }
                    el.contentWindow.mini.layoutIFrames();
                }
            } catch (ex) { }
        }
    }, 30);
}


jQuery.ajaxSetup({
    cache: false
})

/////////////
if (isIE) {
    setInterval(function () {     //尝试去掉
        //CollectGarbage();
    }, 20000);
}

mini_unload = function (e) {

    try {
        var win = mini._getTopWindow();
        win[mini._WindowID] = '';
        delete win[mini._WindowID];
    } catch (ex) {

    }

    //iframe
    var iframes = document.body.getElementsByTagName("iframe");
    if (iframes.length > 0) {

        var IFrames = [];
        for (var i = 0, l = iframes.length; i < l; i++) {
            IFrames.push(iframes[i]);
        }

        for (var i = 0, l = IFrames.length; i < l; i++) {
            try {
                var iframe = IFrames[i];
                iframe._ondestroy = null;
                iframe.onload = function () { };
                jQuery(iframe).unbind("load");
                iframe.src = "";
                if (mini.isIE) {
                    try {
                        iframe.contentWindow.document.write("");
                        iframe.contentWindow.document.close();
                    } catch (ex) { }
                }
                if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
            } catch (e) { }
        }
    }

    //========================================================

    mini._destroying = true;

    var cs = mini.getComponents().clone();
    for (var i = 0, l = cs.length; i < l; i++) {
        var control = cs[i];
        if (control.destroyed !== true) {
           
            control.destroy(false);
         
        }
    }



    cs.length = 0;
    cs = null;

    //mini.components = mini.uids = mini.classes = mini.uiClasses = null;

    mini.clearEvent(window);
    mini.clearEvent(document);

    mini.un(window, "unload", mini_unload);
    mini.un(window, "load", mini_onload);
    mini.un(window, "resize", mini_onresize);

    mini.components = {};
    mini.classes = {};
    mini.uiClasses = {};
    mini.uids = {};
    mini.listeners.length = 0;

    mini._topWindow = null;
    window.mini = null;
    window.Owner = null;
    window.CloseOwnerWindow = null;
}
mini.on(window, "unload", mini_unload);
function __BindIFrames() {

}

mini.zIndex = 1000;
mini.zindex = mini.getMaxZIndex = function () {
    return mini.zIndex++;
}

/////////////////////////
function js_isTouchDevice() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}
function js_touchScroll(id) {
    if (js_isTouchDevice()) { //if touch events exist...
        var el = typeof id == "string" ? document.getElementById(id) : id;
        var scrollStartPos = 0;

        el.addEventListener("touchstart", function (event) {
            scrollStartPos = this.scrollTop + event.touches[0].pageY;
            event.preventDefault();
        }, false);

        el.addEventListener("touchmove", function (event) {
            this.scrollTop = scrollStartPos - event.touches[0].pageY;
            event.preventDefault();
        }, false);
    }
}


/////////////////////////////////////
mini._placeholder = function (el) {
    el = mini.byId(el);
    if (!el || !isIE || isIE10 || isIE11) {
        //var text = el.placeholder;
        //el.placeholder = text.replace(/<br(\/)*>/g, "\r\n");
        return;
    }

    function doLabel() {
        var label = el._placeholder_label;

        if (!label) return;

        var placeholder = el.getAttribute("placeholder");
        if (!placeholder) placeholder = el.placeholder;
        //if (!el.value && !el.disabled) {
        if (!el.value) {
            label.innerHTML = placeholder;
            label.style.display = "";
        } else {
            label.style.display = "none";
        }
    }

    if (el._placeholder) {
        doLabel();
        return;
    }
    el._placeholder = true;

    var label = document.createElement("label");
    label.className = "mini-placeholder-label";
    el.parentNode.appendChild(label);
    el._placeholder_label = label;

    label.onmousedown = function () {
        
        try {
            el.focus();
        } catch (e) {
        }
    }

    //ie 专用
    el.onpropertychange = function (e) {
        e = e || window.event;
        if (e.propertyName == "value") {

            doLabel();
        }
    }

    doLabel();

    //events
    mini.on(el, "focus", function (e) {
        if (!el.readOnly) {
            label.style.display = "none";
        }
    });
    mini.on(el, "blur", function (e) {
        doLabel();
    });

}


////////////////////////////////////////////////

mini.ajax = function (options) {
    
    if (!options.dataType) {
        options.dataType = "text";
    }
    //    if (!options.contentType) {
    //        options.dataType = "text";
//    }    
    return window.jQuery.ajax(options);
}
////////////////////////////////////////////////
mini._evalAjaxData = function (ajaxData, scope) {
    var obj = ajaxData;
    var t = typeof ajaxData;
    if (t == "string") {
        obj = window["ev"+"al"]("(" + ajaxData + ")");
        if (typeof obj == "function") {
            obj = obj.call(scope);
        }
    }
    return obj;
}


//jquery兼容处理

var hasOn = !!jQuery.fn.on;

if (!jQuery.fn.on) {
    jQuery.fn.on = function (type, selector, data, fn) {
        //return this.live(type, data, fn, selector);
        //if (typeof selector == "string") {
            return this.delegate(selector, type, data, fn);
//        } else {
//            return this.bind(type, data, fn);
//        }
    }
}


//mini.replaceHtml = function(el, html) {
//    var oldEl = typeof el === "string" ? document.getElementById(el) : el;
//    /*@cc_on // Pure innerHTML is slightly faster in IE
//    oldEl.innerHTML = html;
//    return oldEl;
//    @*/
//    var newEl = oldEl.cloneNode(false);
//    newEl.innerHTML = html;
//    oldEl.parentNode.replaceChild(newEl, oldEl);
//    /* Since we just removed the old element from the DOM, return a reference
//    to the new element, which can be used to restore variable references. */
//    return newEl;
//};


//响应式布局

mini._lastDevice;
mini.updateDevice = function () {
    var cls = "mini-xs",
        width = jQuery(window).width(),
        type = "xs";

    if (width > 768) {
        cls += " mini-sm";
        type = "sm";
    }
    if (width > 992) {
        cls += " mini-md";
        type = "md";
    }
    if (width > 1200) {
        cls += " mini-lg";
        type = "lg";
    }

    cls += ' mini-' + type + "-active";

    if (mini._lastDevice == type) return;

    jQuery(document.documentElement)
        .removeClass("mini-xs mini-sm mini-md mini-lg mini-xs-active mini-sm-active mini-md-active mini-lg-active ")
        .addClass(cls);

    if (mini._lastDevice != type) {

        jQuery(window).triggerHandler("devicechange", type);
    }

    mini._lastDevice = type;
}

mini.getClipboard = function (e) {
    var text = '';
    if (window.clipboardData) {
        text = window.clipboardData.getData("Text");
    } else if (e) {
        text = e.clipboardData.getData("text/plain")
    }
    return text;
}
mini.setClipboard = function (text) {
    if (window.clipboardData) {
        window.clipboardData.setData("Text", text);
    } else {
        var node = jQuery('<textarea style="position:absolute;left:0;top:-1000px;width:100px;z-index:1000;"></textarea>').appendTo('body').val(text)[0];
        node.select();
        node.focus();
        document.execCommand('copy');
        
    }
}


mini.getActiveElement = function () {
    try {
        return document.activeElement;
    } catch (ex) {
    }
}



mini.getScrollOffset = function () {
    if (!mini._scrollOffset) {
//        var el = document.createElement('div');
//        //el.style.cssText = 'width:100px;background:#eee;height:50px;overflow:scroll;padding:1px;position:absolute;left:-1000px;top:0;';
//        el.style.cssText = 'width:100px;background:#eee;height:50px;overflow:scroll;padding:1px;position:absolute;left:-1000px;top:0;box-sizing:content-box;-moz-box-sizing: content-box;';
//        el.innerHTML = '<div style="width:200px;height:200px;"></div>';
//        document.body.appendChild(el);

        var el = document.createElement('div');        
        el.style.cssText = 'z-index:1000;width:100px;background:#eee;height:50px;overflow:auto;position:absolute;left:100px;top:100px;';
        el.innerHTML = '<div style="width:50px;height:200px;"></div>';
        document.body.appendChild(el);

        mini._scrollOffset = el.offsetWidth - el.clientWidth;

        el.parentNode.removeChild(el);
    }
    return mini._scrollOffset;
}

//setTimeout(function () {
//    alert(mini.getScrollOffset());

//    var el = document.createElement('div');
//    //el.style.cssText = 'width:100px;background:#eee;height:50px;overflow:scroll;padding:1px;position:absolute;left:-1000px;top:0;';
//    el.style.cssText = 'z-index:1000;width:100px;background:#eee;height:50px;overflow:auto;position:absolute;left:100px;top:100px;';
//    el.innerHTML = '<div style="width:50px;height:200px;"></div>';
//    document.body.appendChild(el);

//    alert(el.offsetWidth - el.clientWidth);

//}, 1000);
/***************************************************
* loadJS v1.0
*
* License : MIT
*
* Date : 2012/04/01
*
***************************************************/

if (typeof window.rootpath == "undefined") {
    rootpath = "/";
}

mini.loadJS = function (src, callback) {
    if (!src) return;
    if (typeof callback == "function") {
        return mini.loadJS._async(src, callback);
    } else {
        return mini.loadJS._sync(src);
    }
}
mini.loadJS._js = {};
mini.loadJS._async = function (src, callback) {
    var state = mini.loadJS._js[src];
    if (!state) {
        state = mini.loadJS._js[src] = { create: false, loaded: false, callbacks: [] };
    }
    if (state.loaded) {
        setTimeout(function () {
            callback();
        }, 1);
        return;
    } else {
        state.callbacks.push(callback);
        if (state.create) return;
    }

    state.create = true;

    var head = document.getElementsByTagName('head')[0];
    var js = document.createElement('script');
    js.src = src;
    js.type = 'text/javascript';

    function doCallback() {
        for (var i = 0; i < state.callbacks.length; i++) {
            var fn = state.callbacks[i];
            if (fn) fn();
        }
        state.callbacks.length = 0;
    }

    setTimeout(function () {
        if (document.all) {
            js.onreadystatechange = function () {
                if (js.readyState == 'loaded' || js.readyState == 'complete') {
                    doCallback();
                    state.loaded = true;
                }
            }
        } else {
            js.onload = function () {
                doCallback();
                state.loaded = true;
            }
        }
        head.appendChild(js);
    }, 1);
    return js;
}
mini.loadJS._sync = function(src) {
    if (mini.loadJS._js[src]) return;
    mini.loadJS._js[src] = {
        create: true,
        loaded: true,
        callbacks: []
    };

    var head = document.getElementsByTagName('head')[0];
    var js = document.createElement('script');
    js.type = 'text/javascript';
    js.text = mini.loadText(src);
    head.appendChild(js);
    return js;
};

mini.loadText = function (url) {
    var text = "";
    var isLocal = document.all && location.protocol == "file:";


    var xmlhttp = null;
    if (isLocal) {
        xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
    } else {
        if (window.XMLHttpRequest) {        // for all new browsers
            xmlhttp = new XMLHttpRequest();
        }
        else if (window.ActiveXObject) {    // for IE5 and IE6
            xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
        }
    }


    xmlhttp.onreadystatechange = state_Change;
    var t = '000000' + String(Math.floor(Math.random() * 1000000));
    t = t.substring(t.length - 6);

    var d = '_t=' + t;
    if (url.indexOf("?") == -1) d = "?" + d;
    else d = "&" + d;
    url += d;

    xmlhttp.open("GET", url, false);
    xmlhttp.send(null);

    function state_Change() {
        if (xmlhttp.readyState == 4) {
            var statusCode = isLocal ? 0 : 200;
            if (xmlhttp.status == statusCode) {
                text = xmlhttp.responseText;
            }
            else {
                //error
            }
        }
    }
    return text;
}

mini.loadJSON = function (url) {
    var text = loadText(url);
    var o = window["ev" + "al"]("(" + text + ")");
    return o;
}


mini.loadCSS = function(src, id) {
    if (!src) return;
    if (mini.loadCSS._css[src]) return;
    var head = document.getElementsByTagName('head')[0];
    var link = document.createElement('link');
    if (id) link.id = id;
    link.href = src;
    link.rel = 'stylesheet';
    link.type = 'text/css';
    head.appendChild(link);

    mini.loadCSS._css[src] = link;

    return link;
};
mini.loadCSS._css = {};

/* innerHTML */
mini.innerHTML = function (el, html) {
    if (typeof el == 'string') el = document.getElementById(el);
    if (!el) return;
    html = '<div style="display:none">&nbsp;</div>' + html;
    el.innerHTML = html;
    mini.__executeScripts(el);
    var d = el.firstChild;
    //d.parentNode.removeChild(d);
}
mini.__executeScripts = function (d) {
    var scripts = d.getElementsByTagName("script")
    for (var i = 0, l = scripts.length; i < l; i++) {
        var sc = scripts[i];
        var src = sc.src;
        if (src) {
            mini.loadJS(src);
        } else {
            var ns = document.createElement('script');
            ns.type = "text/javascript";
            ns.text = sc.text;
            d.appendChild(ns);
        }
    }
    for (var i = scripts.length - 1; i >= 0; i--) {
        var sc = scripts[i];
        sc.parentNode.removeChild(sc);
    }
}
/**
 * 获取系统参数值
 *
 * @param {string} name 系统参数名称
 * @returns
 */
mini.getF9FrameSysParams = function (name) {
    return window.EpFrameSysParams && window.EpFrameSysParams[name];
};
/**
 * 获取取系统参数之后的控件默认值
 *
 * @param {string} name 系统参数名称
 * @param {any} defaultValue 无系统参数配置时的默认值
 * @returns 如果配置了系统参数且值不为 undefined 则取系统参数，否则取传入的默认值
 */
mini.getCtrDefaultBySysParams = function (name, defaultValue) {
    var c = mini.getF9FrameSysParams(name);
    return c !== undefined ? c : defaultValue;
};
// 还原转义的html
mini.htmlUnescape = function (str) {
    if (str + '' !== str) return str;
    // var div = document.createElement('div');
    // div.innerHTML = str;
    // var t = div.innerText;
    // div = null;
    // return t;
    // 上面方法会出现 未转义的HTML传入时丢掉标签的问题 使用miniui中正则替换的方式实现
    return mini.htmlDecode(str);
};
// html 转义
mini.htmlEscape = function (html) {
    if (html + '' !== html) return html;
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(html));
    var s = div.innerHTML;
    div = null;
    return s;
};
// mini.autoParse = false;
// 是否支持 rem
mini.supportRem = (function () {
    var isSupport = false;
    var s = document.createElement('span');
    try {
        s.style.fontSize = '13rem';
        if (/rem/.test(s.style.fontSize)) {
            isSupport = true;
        }
    } catch (error) {}
    s = null;
    return isSupport;
})();

mini.getFontSizeRatio = function () {
    if (!this._fontSizeRatio) {
        this._fontSizeRatio = parseInt($('html').css('fontSize'), 10) / window.HtmlBaseFontSize || 1;
    }

    return this._fontSizeRatio;
};

mini.setFontSizeRatio = function (ratio) {
    this._fontSizeRatio = ratio;
};
// 后台用UTF-8编码，中文占 3  个字符
mini.getStrLength = function (str, file) {
    var len = 0;
    // 后台用UTF-8编码，中文占 3  个字符，为了与服务端匹配，前端也需要区分处理中英文字符的长度
    if (
        (file && mini.getF9FrameSysParams('security_vtype_length_accurate_enable')) ||
        (!file && mini.getF9FrameSysParams('security_vtype_length_database_enable'))
    ) {
        // eslint-disable-next-line
        len = mini.getStrLengthUft8(str);
    } else {
        len = str.length;
    }

    return len;
};
mini.getStrLengthUft8 = function getStrLengthUft8(str) {
    // eslint-disable-next-line
    return str.replace(/[^\x00-\xff]/g, '012').length;
};
mini.substr = function (str, len) {
    if (!mini.getF9FrameSysParams('security_vtype_length_database_enable')) {
        return str.substr(0, len);
    }

    if (mini.getStrLength(str) <= len) {
        return str;
    }

    var rlen = 0,
        i = 0,
        l = str.length;
    for (; i < l; i++) {
        if ((str.charCodeAt(i) & 0xff00) != 0) {
            rlen += 3;
        } else {
            rlen++;
        }
        if (rlen > len) {
            break;
        }
    }

    return str.substr(0, i);
};

mini.copyTo(mini, {
    overwrite: function (dest, proto) {
        var d;
        if (typeof dest === 'function') {
            d = dest.prototype;
        } else if (typeof dest === 'object') {
            d = dest;
        } else {
            return this;
        }

        // 支持 传递多个 proto
        for (var i = 1, len = arguments.length; i < len; ++i) {
            var prototype = arguments[i];
            for (var c in prototype) {
                d[c] = prototype[c];
            }
        }
        return dest;
    }
});

if (window._rootPath === undefined) {
    window._rootPath = (function () {
        var path = location.pathname;

        if (path.indexOf('/') === 0) {
            path = path.substring(1);
        }

        return '/' + path.split('/')[0];
    })();
}

mini.isDisplay = function (p, body, ignoresFn) {
    if (typeof body === 'function') {
        ignoresFn = body;
        body = undefined;
    }
    var doc = body || document.body;
    /* eslint-disable-next-line */
    while (1) {
        /* eslint-disable-next-line */
        if (p == null || !p.style) return false;
        // 原方法中通过p.style.display 无法获取到通过class设置的值
        // jQuery(p).css('display') 在firefox中也无法获取到class设置的值
        if (
            p &&
            (jQuery(p).css('display') === 'none' ||
                (mini.isFirefox &&
                    p.nodeName === 'IFRAME' &&
                    p.getBoundingClientRect().width === 0 &&
                    p.getBoundingClientRect().height === 0 &&
                    p.getBoundingClientRect().x === 0 &&
                    p.getBoundingClientRect().y === 0))
        ) {
            if (ignoresFn) {
                if (ignoresFn(p) !== true) return false;
            } else {
                return false;
            }
        }
        if (p == doc) return true;

        p = p.parentNode;
    }
    return true;
};

mini.externalSrc = _rootPath + '/frame/fui/js/widgets/';

mini_useShims = true;

mini_debugger = false;

mini.showPageWarning = function (cfg) {
    var $pageWarning = $('#mini-pageWarning');

    if ($pageWarning.length) {
        return;
    }

    $pageWarning = $('<div></div>', {
        id: 'mini-pageWarning',
        style: 'position:fixed;top:30%;left:50%;margin-left:-280px;width:560px;height:40px;color:#dd2727;background:#f2dede;text-align:center;border-radius:3px;line-height:40px;font-size:13px;'
    })
        .html(cfg.html)
        .append(
            // 插入关闭按钮
            $(
                '<span title= "关闭" style= "position: absolute;top:0;right:10px;font-size:18px;line-height:40px;cursor:pointer" onclick= \'$("#mini-pageWarning").remove();\'>×</span>'
            )
        )
        .css('z-index', cfg.zIndex || 9999)
        .appendTo('body');

    setTimeout(function () {
        $pageWarning.remove();
        $pageWarning = null;
    }, cfg.timeout || 15000);
};

var _oGetAttrs = mini.Control.prototype.getAttrs;
mini.overwrite(mini.Control, {
    getAttrs: function (el) {
        var attrs = _oGetAttrs.call(this, el),
            extraAttrs;

        if (this.getExtraAttrs) {
            extraAttrs = this.getExtraAttrs.call(this, el);
            mini.copyTo(attrs, extraAttrs);
        }

        return attrs;
    }
});

// 由于 mini.Container 控件虽然继承于mini.Control，但是它定义中没有重写getAttrs方法，就导致上面 overwrite mini.Control 的 getAttrs 方法不会影响到 mini.Container ，所以需要对其再重写一遍
mini.overwrite(mini.Container, {
    getAttrs: function (el) {
        return mini.Container.superclass.getAttrs.call(this, el);
    }
});

mini.getValidErrorToolTip = function () {
    if (!mini._errorToolTip) {
        mini._errorToolTip = new mini.ToolTip();

        mini._errorToolTip.set({
            selector: '.mini-error[data-tooltip]',
            placement: 'topright',
            trigger: 'focus hover',
            // cls: 'error-tooltip'
            theme: 'error',
            defaultTheme: 'error'
        });

        $(document).on('mousewheel', function () {
            // 为了防止页面滚动时 tooltip 不随页面一起滚动，所以滚动时隐藏掉 tooltip
            // 现在实现还有问题，用户直接通过拖动滚动条无法隐藏，需要进一步优化
            mini._errorToolTip.close();
        });
    }

    return mini._errorToolTip;
};

// 重写验证效果
(function (win, $) {
    var obj = {
        errorMode: mini.getCtrDefaultBySysParams('ui_form_errormode', 'icon'), // text、icon、border、none
        errorTextEl: null,
        getErrorTextEl: function () {
            return this._errorTextEl;
        },
        _RemoveErrorText: function () {},
        __doUpdateValid: function () {
            if (!this.el) return;
            this.removeCls(this._errorCls);
            this.removeCls(this._invalidCls);
            // this.removeCls('mini-errorMode-' + this.errorMode);
            jQuery(this.el).removeClass('mini-errorMode-text mini-errorMode-icon');

            if (this.errorMode == 'border') {
                this.el.title = '';
            }

            if (this._IsValid == false) {
                mini.getValidErrorToolTip();

                switch (this.errorMode) {
                    case 'icon':
                        this._RemoveErrorText();
                        jQuery(this.el).attr('data-tooltip', this.errorText);
                        this.addCls(this._errorCls);
                        jQuery(this.el).addClass('mini-errorMode-icon');
                        var icon = this.getErrorIconEl();
                        // if (icon) {
                        //     icon.title = this.errorText;
                        //     jQuery(icon).attr('data-placement', this.errorTooltipPlacement);
                        // }
                        break;
                    case 'border':
                        jQuery(this.el).attr('data-tooltip', this.errorText);
                        this.addCls(this._invalidCls);
                        this.el.title = this.errorText;
                        this._RemoveErrorIcon();
                        this._RemoveErrorText();
                        break;
                    case 'text':
                        this.addCls(this._errorCls);
                        var text = this.getErrorTextEl();
                        jQuery(this.el).addClass('mini-errorMode-text');
                        if (text) {
                            $(text).text(this.errorText).attr('title', this.errorText);
                        }
                        this._RemoveErrorIcon();
                        break;
                    default:
                        this._RemoveErrorText();
                        this._RemoveErrorIcon();
                        break;
                }
            } else {
                this._RemoveErrorIcon();
                this._RemoveErrorText();
                jQuery(this.el).removeAttr('data-tooltip');
                mini._errorToolTip && mini._errorToolTip.close();
            }
            this.doLayout();
        }
    };
    mini.overwrite(mini.ValidatorBase, obj);
    mini.overwrite(mini.ListControl, obj);
})(this, this.jQuery);

// 重写默认宽度
//IndexColumn
mini.IndexColumn = function (config) {
    return mini.copyTo(
        {
            ignoreCollapseIndex: false,
            width: 56,
            cellCls: '',
            align: 'left',
            draggable: false,
            allowDrag: true,
            hideable: true,
            init: function (grid) {
                grid.on('addrow', this.__OnIndexChanged, this);
                grid.on('removerow', this.__OnIndexChanged, this);
                grid.on('moverow', this.__OnIndexChanged, this);

                //treegrid
                if (grid.isTree) {
                    grid.on('addnode', this.__OnIndexChanged, this);
                    grid.on('removenode', this.__OnIndexChanged, this);
                    grid.on('movenode', this.__OnIndexChanged, this);

                    grid.on('loadnode', this.__OnIndexChanged, this);
                    this._gridUID = grid.uid;
                    this._rowIdField = '_id';
                }
            },
            getNumberId: function (record) {
                return this._gridUID + '$number$' + record[this._rowIdField];
            },
            createNumber: function (grid, rowIndex) {
                if (mini.isNull(grid.pageIndex)) {
                    return rowIndex + 1;
                }
                return grid.pageIndex * grid.pageSize + rowIndex + 1;
            },
            renderer: function (e) {
                var grid = e.sender;
                if (this.draggable) {
                    if (!e.cellStyle) e.cellStyle = '';
                    e.cellStyle += ';cursor:move;';
                }
                var s = '<div id="' + this.getNumberId(e.record) + '">';
                var rowIndex = e.rowIndex;

                if (this.ignoreCollapseIndex) {
                    //rowIndex =
                }

                if (mini.isNull(grid.getPageIndex)) s += rowIndex + 1;
                else s += grid.getPageIndex() * grid.getPageSize() + rowIndex + 1;

                s += '</div>';
                return s;
            },

            __updateRowNumbers: function (grid) {
                var records = grid.getDataView();

                for (var i = 0, l = records.length; i < l; i++) {
                    var record = records[i];
                    var id = this.getNumberId(record);
                    var ck = document.getElementById(id);
                    if (ck) ck.innerHTML = this.createNumber(grid, i);
                }
                //alert(1);
            },
            __OnIndexChanged: function (e) {
                var grid = e.sender;

                //            this.__updateRowNumbers(grid);
                //            return;
                var me = this;
                if (me._toIndex) return;
                me._toIndex = setTimeout(function () {
                    me._toIndex = null;
                    me.__updateRowNumbers(grid);
                }, 10);
            }
        },
        config
    );
};
mini._Columns.indexcolumn = mini.IndexColumn;

//CheckColumn
// 源码中_doCheckState方法实现有问题，某些场景下最后又会update下表头，重新生成表头是会根据_checkedAll来决定是否选中，所以必须同时更新下_checkedAll的值
mini.CheckColumn = function (config) {
    return mini.copyTo(
        {
            width: 40,
            cellCls: 'mini-checkcolumn',
            headerCls: 'mini-checkcolumn',
            hideable: true,
            _multiRowSelect: true, //
            header: function (column) {
                //if(this.multiSelect == false) debugger
                //                var id = this.uid + "checkall";
                //                var s = '<input type="checkbox" id="' + id + '" ' + (column._checkedAll ? 'checked' : '') + '/>';
                //                if (this.multiSelect == false) s = "";
                //                return s;

                var id = this.uid + 'checkall',
                    cls = column._checkedAll ? 'mini-grid-checkbox-checked' : '',
                    isCheckCls = column._unableCheckedAllStatus ? 'mini-disabled' : '',
                    s =
                        '<span class="mini-grid-checkbox mini-icon ' +
                        cls +
                        ' ' +
                        isCheckCls +
                        '" id="' +
                        id +
                        '"></span>';
                if (this.multiSelect == false) s = '';
                return s;
            },
            getCheckId: function (record, column) {
                return this._gridUID + '$checkcolumn$' + record[this._rowIdField] + '$' + column._id;
            },
            init: function (grid) {
                grid.on('_selectchange', this.__OnSelectionChanged, this);
                grid.on('HeaderCellClick', this.__OnHeaderCellClick, this);

                var me = this;
                grid.on('removerow', function () {
                    if (grid.data && grid.data.length == 0) {
                        me._doCheckState(grid);
                    }
                });
                grid.on(
                    'update',
                    function () {
                        // var id = grid.uid + 'checkall';
                        //$("#" + id).removeClass('mini-grid-checkbox-checked');
                        me._doCheckState(grid);
                    },
                    this
                );
            },
            renderer: function (e) {
                var id = this.getCheckId(e.record, e.column);
                var selected = e.sender.isSelected ? e.sender.isSelected(e.record) : false;

                var type = 'checkbox';

                //                var grid = e.sender;
                //                if (grid.getMultiSelect() == false) type = "radio";

                //                var html = '<input type="' + type + '" id="' + id + '" ' + (selected ? "checked" : "") + ' hidefocus style="outline:none;" onclick="return false"/>';
                //                html += '<div class="mini-grid-radio-mask"></div>';
                //                return html;

                var grid = e.sender;
                var html =
                    '<span class="mini-grid-' +
                    (grid.getMultiSelect() ? 'checkbox' : 'radio') +
                    ' mini-icon" id="' +
                    id +
                    '"></span>';
                return html;
            },
            __OnHeaderCellClick: function (e) {
                var grid = e.sender;
                if (e.column != this) return;
                var id = grid.uid + 'checkall';
                var ck = document.getElementById(id);
                var list;
                if (ck) {
                    var checkedCls = 'mini-grid-checkbox-checked',
                        unableCheckedCls = 'mini-disabled',
                        checked = !mini.hasClass(ck, checkedCls),
                        isUnableChecked = mini.hasClass(ck, unableCheckedCls);
                    if (isUnableChecked) {
                        return false;
                    }
                    this._checkedAll = checked;

                    if (grid.getMultiSelect()) {
                        if (checked) {
                            list = grid.getDataView();
                            grid.selects(list);
                            mini.addClass(ck, checkedCls);
                            setTimeout(function () {
                                mini.addClass(ck, checkedCls);
                            }, 30);
                        } else {
                            list = grid.getDataView();
                            grid.deselects(list);
                            mini.removeClass(ck, checkedCls);
                        }
                    } else {
                        grid.deselectAll();
                        if (checked) {
                            grid.select(0);
                            mini.addClass(ck, checkedCls);
                        }
                    }
                    grid.fire('checkall');
                }
            },
            __OnSelectionChanged: function (e) {
                var grid = e.sender;
                var records = grid.toArray();
                var me = this;

                var virtual = grid.isVirtualScroll(),
                    region = grid._viewRegion,
                    start = virtual && region ? region.start : -1,
                    end = region ? region.end : -1,
                    map = {};
                var i, l;
                if (start !== -1) {
                    var data = grid.getVisibleRows();
                    for (i = start, l = end; i < l; i++) {
                        var row = data[i];
                        if (row) map[row._id] = true;
                    }
                }

                for (i = 0, l = records.length; i < l; i++) {
                    var record = records[i];

                    //continue;
                    if (start != -1) {
                        if (!map[record._id]) continue;
                    }

                    //                    var select = grid.isSelected(record);
                    //                    var id = me.getCheckId(record, me); //grid.uid + "$checkcolumn$" + record[grid._rowIdField];
                    //                    var ck = document.getElementById(id);

                    //                    if (ck) ck.checked = select;
                }

                if (!this._timer) {
                    this._timer = setTimeout(function () {
                        me._doCheckState(grid);
                        me._timer = null;
                    }, 10);
                }
            },
            _doCheckState: function (grid) {
                //处理顶部的checkbox
                var id = grid.uid + 'checkall';
                var ck = document.getElementById(id);

                if (ck) {
                    var sels = grid.getSelecteds();
                    //if (sels.length == grid.getData().length) {

                    var len = grid.isTree ? grid.getList().length : grid.getData().length,
                        hiddenLen = 0;

                    // 计算checkbox被隐藏行数量
                    $(grid._rowsViewContentEl)
                        .find('.mini-checkcolumn')
                        .each(function (i, item) {
                            var $cur = $(item);
                            if ($cur.find('.mini-grid-checkbox').length === 0) {
                                hiddenLen++;
                            }
                        });

                    if (sels.length + hiddenLen == len && len != 0 && hiddenLen !== len) {
                        //if (sels.length == len){
                        //ck.checked = true;
                        jQuery(ck).addClass('mini-grid-checkbox-checked');
                        // 源码中实现有问题，某些场景下最后又会update下表头，重新生成表头是会根据_checkedAll来决定是否选中，所以必须同时更新下_checkedAll的值
                        this._checkedAll = true;
                    } else {
                        //ck.checked = false;
                        jQuery(ck).removeClass('mini-grid-checkbox-checked');
                        // 源码中实现有问题，某些场景下最后又会update下表头，重新生成表头是会根据_checkedAll来决定是否选中，所以必须同时更新下_checkedAll的值
                        this._checkedAll = false;
                    }
                    if (hiddenLen == len || len == 0) {
                        this._unableCheckedAllStatus = true;
                        jQuery(ck).addClass('mini-disabled');
                    } else {
                        this._unableCheckedAllStatus = false;
                        jQuery(ck).removeClass('mini-disabled');
                    }
                }

                //                if (ck && grid._getSelectAllCheckState) {

                //                    var state = grid._getSelectAllCheckState();
                //                    if (state == "has") {
                //                        ck.indeterminate = true;
                //                        ck.checked = true;
                //                    } else {
                //                        ck.indeterminate = false;
                //                        ck.checked = state;
                //                    }
                //                }
            }
        },
        config
    );
};
mini._Columns.checkcolumn = mini.CheckColumn;

// 重写 ExpandColumn 解决chrome中点击当成锚点了
mini.ExpandColumn = function (config) {
    return mini.copyTo(
        {
            width: 30,
            headerAlign: 'center',
            align: 'center',
            draggable: false,
            cellStyle: 'padding:0',
            cellCls: 'mini-grid-expandCell',
            hideable: true,
            renderer: function (e) {
                // return '<a class="mini-grid-ecIcon mini-icon" href="javascript:#" onclick="return false"></a>';
                // 改成i标签，解决chrome中点击当成锚点了
                return '<i class="mini-grid-ecIcon mini-icon" ></i>';
            },
            init: function (grid) {
                grid.on('cellclick', this.__OnCellClick, this);
            },
            __OnCellClick: function (e) {
                var grid = e.sender;
                if (e.column == this && grid.isShowRowDetail) {
                    if (mini.findParent(e.htmlEvent.target, 'mini-grid-ecIcon')) {
                        var isShow = grid.isShowRowDetail(e.record);

                        if (!isShow) {
                            e.cancel = false;
                            grid.fire('beforeshowrowdetail', e);
                            if (e.cancel === true) return;
                        } else {
                            e.cancel = false;
                            grid.fire('beforehiderowdetail', e);
                            if (e.cancel === true) return;
                        }

                        if (grid.autoHideRowDetail) {
                            grid.hideAllRowDetail();
                        }
                        if (isShow) {
                            grid.hideRowDetail(e.record);
                        } else {
                            grid.showRowDetail(e.record);
                        }
                    }
                }
            }
        },
        config
    );
};
mini._Columns.expandcolumn = mini.ExpandColumn;

// miniui 中此方法写错了 误将&gt; 替换为 &
mini.htmlDecode = function (str) {
    if (typeof str !== 'string') return str;
    if (str.length == 0) return '';
    var s = str;
    // 先替换 &amp; 会出现以下问题
    // value "&amp;lt;20210331&amp;gt" => "<20210331&gt"
    // 正确的应为 "&amp;lt;20210331&amp;gt" => "&lt;20210331&gt"
    s = s.replace(/&lt;/g, '<');
    s = s.replace(/&gt;/g, '>');
    s = s.replace(/&nbsp;/g, ' ');
    s = s.replace(/&#39;/g, "'");
    s = s.replace(/&quot;/g, '"');
    s = s.replace(/&amp;/g, '&');
    return s;
};

// 某些场景下需要全屏功能，所以要预先设置iframe允许全屏
mini.createIFrame = function (url, onIFrameLoad, cache, method, params) {
    //alert(method + ":" + params);

    /*var iframe = document.createElement('iframe');
    iframe.src = url;
        
    function onload () {
    alert("aaa111");
    }

    if (iframe.attachEvent) {
    iframe.attachEvent('onload', onload);
    } else {
    iframe.onload = onload;
    }
    return iframe;*/

    if (!url) url = '';
    var urls = url.split('#');
    url = urls[0];

    //修改url
    var t = '';
    if (cache !== true) {
        //_t
        t = '000000' + String(Math.floor(Math.random() * 1000000));
        t = t.substring(t.length - 6);
        t = '_t=' + t;
        if (url.indexOf('_t=') == -1) {
            if (url.indexOf('?') == -1) {
                url += '?' + t;
            } else {
                url += '&' + t;
            }
        } else {
            url = url.replace(/_t=(\d+)/, t);
        }
    }

    //_winid
    if (url && url.indexOf('_winid') === -1) {
        t = '_winid=' + mini._WindowID;
        if (url.indexOf('?') === -1) {
            url += '?' + t;
        } else {
            url += '&' + t;
        }
    }

    if (mini.iframeParams) {
        for (var name in mini.iframeParams) {
            url += '&' + name + '=' + mini.iframeParams[name];
        }
    }

    if (urls[1]) {
        url = url + '#' + urls[1];
    }

    var isMHT = url.indexOf('.mht') != -1;
    var src = isMHT ? url : '';

    var iframeName = mini.newId('mini-iframe-');

    //window server版本下，是否用js绑定onload事件会比较好
    // var s = '<iframe name="' + iframeName + '" src="' + (method == 'post' ? '' : src) + '" style="width:100%;height:100%;"  frameborder="0"></iframe>';
    // 添加 allowfullscreen 属性
    var s =
        '<iframe name="' +
        iframeName +
        '" src="' +
        (method == 'post' ? '' : src) +
        '" style="width:100%;height:100%;" allowfullscreen="true" frameborder="0"></iframe>';

    //alert(method == 'post');

    var div = document.createElement('div');
    var iframe = mini.append(div, s);
    //iframe.src = "";
    var canFireLoad = false;
    if (isMHT) {
        canFireLoad = true;
    } else {
        setTimeout(function () {
            if (iframe) {
                if (method !== 'post') {
                    iframe.src = url;
                }
                canFireLoad = true;
            }
        }, 5);
    }

    //iframe.onload = __OnLoad;
    if (iframe.attachEvent) {
        iframe.attachEvent('onload', __OnLoad);
    } else {
        iframe.onload = __OnLoad;
    }

    var destroyed = false;

    //load
    var firstLoad = true;

    function __OnLoad() {
        if (canFireLoad == false || destroyed) return;
        //alert("onload");
        setTimeout(function () {
            if (onIFrameLoad) onIFrameLoad(iframe, firstLoad);
            firstLoad = false;
            //onload = null;
            //iframe.onload = null;
            //
        }, 1);
    }

    //destroy
    iframe._ondestroy = function () {
        //window[fnName] = mini.emptyFn;
        destroyed = true;

        iframe.src = '';
        if (mini.isIE) {
            try {
                iframe.contentWindow.document.write('');
                iframe.contentWindow.document.close();
            } catch (ex) {}
        }
        iframe._ondestroy = null;
        iframe = null;
    };

    //////////////////////////////////////////////////////////////////////

    var form;
    if (method === 'post') {
        form = jQuery('<form />')
            .attr({
                method: 'post',
                action: url,
                enctype: 'multipart/form-data',
                target: iframe.name
            })
            .hide()
            .appendTo('body');

        setTimeout(function () {
            form.submit();
        }, 10);
    }

    return iframe;
};

// 获取滚动条宽度
mini.getScrollBarWidth = function getScrollBarWidth() {
    var div = document.createElement('div');
    var p = document.createElement('p');

    div.style.display = p.style.display = 'block';
    p.style.height = '100px';
    div.style.padding = 0;
    div.style.border = 'none';
    div.style.overflow = 'auto';
    div.style.height = '10px';

    div.appendChild(p);
    document.body.appendChild(div);

    var w = div.offsetWidth - div.clientWidth;
    div.parentNode.removeChild(div);
    div = p = null;
    return w;
};
// mini._scrollBarWidth
(function () {
    var _scrollBarWidth;
    if (Object.defineProperty && !mini.isIE8) {
        Object.defineProperty(mini, '_scrollBarWidth', {
            get: function () {
                if (!_scrollBarWidth) {
                    _scrollBarWidth = mini.getScrollBarWidth();
                }
                return _scrollBarWidth;
            }
        });
    } else {
        jQuery(window).on('load', function () {
            mini._scrollBarWidth = mini.getScrollBarWidth();
        });
    }
})();

// 保留一些 dom 上属性，防止控件解析后属性丢失
(function () {
    // 需要保留属性的正则数组
    mini.reservedAttrsReg = [/title/, /data-*/];

    var oldApply = mini.applyTo;
    mini.applyTo = function (el) {
        el = mini.byId(el);
        // 获取属性
        var savedAttrs = getSavedAttrs(el);
        // 原来的 apply 方法
        var returnValue = oldApply.apply(this, arguments);

        // 还原属性 注意需要将属性加到实例的el上去 而非原来的el
        restoreSavedAttrs(this.el, savedAttrs);

        return returnValue;
    };

    function getSavedAttrs(el) {
        if (el && el.hasAttributes && el.hasAttributes()) {
            var attrs = el.attributes;
            var name;
            var savedAttrs = {};
            var hasAttr = false;
            for (var i = 0, len = attrs.length; i < len; i++) {
                name = attrs[i].name;
                if (isMatch(name)) {
                    hasAttr = true;
                    savedAttrs[name] = attrs[i].value;
                }
            }
            return hasAttr ? savedAttrs : null;
        }
    }

    function restoreSavedAttrs(el, attrs) {
        if (!el || !attrs) return;
        jQuery.map(attrs, function (v, k) {
            if (!(k === 'title' && /mini-panel/.test(el.className))) {
                el.setAttribute(k, v);
            }
        });
    }

    var isMatch = (function () {
        if (Array.prototype.some) {
            return function (name) {
                return (
                    mini.reservedAttrsReg &&
                    mini.reservedAttrsReg.some(function (reg) {
                        return reg.test(name);
                    })
                );
            };
        }
        return function (name) {
            if (!mini.reservedAttrsReg || !mini.reservedAttrsReg.length) return false;

            for (var i = 0, len = mini.reservedAttrsReg.length; i < len; i++) {
                if (mini.reservedAttrsReg[i].test(name)) {
                    return true;
                }
            }
            return false;
        };
    })();
})();

mini._maximumNumber = 2147483647;
mini._minimumNumber = -2147483648;
// 添加通用验证错误提示validateErrorText，并且优先级最高
mini._ValidateVType = function (vtype, value, e, scope) {
    var originVtype = vtype,
        vtypes = originVtype.split(';');
    // int 未自定义范围时 默认范围为 -2147483648/0 ~ 2147483647
    if (vtypes.indexOf('int') > -1 && vtype.indexOf('range') == -1 ) {
        vtypes.push('range:' + mini._minimumNumber + ',' + mini._maximumNumber)
    }
    // decimalLength 默认指 float
    if (vtype.indexOf('decimalLength') > -1 && vtype.indexOf('float') == -1) {
        vtypes.push('float');
    }
    // float 
    // 由于后端处理double类型数据时最大精度为15位数，超过15位就会被截取掉。所以为了保持统一，前端需对浮点数最最大15位长度的限制
    if (vtypes.indexOf('float') > -1 && vtype.indexOf('rangeLength') == -1) {
        vtypes.push('rangeLength:0,16');
    }
    var vTypeMap = {};
    // 逐个调用 vtype 验证
    for (var i = 0, l = vtypes.length; i < l; i++) {
        vtype = vtypes[i].trim();
        var vv = vtype.split(':');
        var vt = vv[0];
        vTypeMap[vt] = true;

        var args = vtype.substr(vt.length + 1, 1000); //vv[1];
        if (args) args = args.split(',');
        else args = [];

        var fn = mini.VTypes[vt];
        if (fn) {
            var isValid = fn(value, args);
            if (isValid !== true) {
                e.isValid = false;
                var vtext = vv[0] + 'ErrorText';
                e.errorText = scope.validateErrorText || scope[vtext] || mini.VTypes[vtext] || '';
                e.errorText = String.format(e.errorText, args[0], args[1], args[2], args[3], args[4]);
                break;
            }
        }
    }
    // 通过的情况下补充其他验证
    if (e.isValid) {
        // 添加对特殊字符的校验
        // eslint-disable-next-line
        if (/[\x00-\x08\x0b-\x0c\x0e-\x1f\x7f]/.test(value)) {
            e.isValid = false;
            e.errorText = '输入的内容中包含非法的特殊字符';
        } else if (
            !vTypeMap['range'] &&
            (vTypeMap['int']  || vTypeMap['float'] ) &&
            Util.getFrameSysParam('security_vtype_positivenum_enable') === 1 &&
            Number(value) < 0 &&
            String(value).trim() !== ''
        ) {
            // 仅在未自定义range时触发
            e.isValid = false;
            e.errorText = epoint_local.VTypes.positiveNumberErrorText;
        }
    }
};

// VTypes的扩展
jQuery.extend(mini.VTypes, {
    decimalLength: function (v, args) {
        if (mini.VTypes.float(v, args) == false) return false;
        if (mini.isNull(v) || v === '') return true;
        var n = parseInt(args);
        if (!v || isNaN(n)) return true;

        v = String(v);
        var s = v.split('.');
        if (s.length == 1) return true;
        if (s[1].length <= n) return true;
        return false;
    },

    mobile: function (v, args) {
        if (mini.isNull(v) || v === '') return true;

        return /^1[3456789]\d{9}$/.test(v);
    },

    tel: function (v, args) {
        if (mini.isNull(v) || v === '') return true;

        return (
            /^0\d{2}-\d{8}(-\d{1,8})?$/.test(v) ||
            /^0\d{3}-\d{7,8}(-\d{1,8})?$/.test(v) ||
            /^\d{7,8}(-\d{1,8})?$/.test(v)
        );
    },

    phone: function (v, args) {
        if (mini.isNull(v) || v === '') return true;

        return (
            /^1[3456789]\d{9}$/.test(v) || /^0\d{2}-\d{8}$/.test(v) || /^0\d{3}-\d{7,8}$/.test(v) || /^\d{7,8}$/.test(v)
        );
    },

    // 更弱的电话号码验证，支持短号码
    phoneWithShortNum: function (v, args) {
        if (mini.isNull(v) || v === '') return true;

        return /^\d[\d-]{2,10}(?!-)$/.test(v);
    },

    postCode: function (v, args) {
        if (mini.isNull(v) || v === '') return true;

        return /^\d{6}$/.test(v);
    },
    orgCode: function (v, args) {
        if (mini.isNull(v) || v === '') {
            return true;
        }

        // 组织机构代码
        if (/^[A-Z0-9]{8}-[A-Z0-9]$/.test(v)) {
            return true;
        }
        //组织机构代码（统一社会信用代码9-17位为组织机构代码，符合该校验规则）
        if (v.length === 9 && /(((?![IOSV])[0-9A-Y]){9})$/.test(v)) {
            return true;
        }
        // 统一社会信用代码
        return mini.VTypes._isCreditCode(v);
    },
    creditCode: function (v, args) {
        if (mini.isNull(v) || v === '') {
            return true;
        }

        return mini.VTypes._isCreditCode(v);
    },
    // 是否为统一社会信用代码
    _isCreditCode: function (v) {
        // 统一社会信用代码
        // var reg = /^([0-9A-Z]{2})([0-9]{6})([0-9A-Z]{10})$/;
        /*
         * 按照电子交易提供的统一社会信用代码规则如下：
         * 统一社会信用代码由18位的阿拉伯数字或大写英文字母(不使用I、O、Z、S、V)组成，
         * 第1位为登记管理部门代码、第2位为机构类别代码、第3-8位为登记管理机关行政区划码、第9-17位为组织机构代码、第18位为校验码。
         * 整理出的正则规则如下：
         * 1、长度18位，由数字或大写字母组成（不能出现I,O,Z,S,V）
         * 2、第1位：数字或大写字母（不能出现I,O,Z,S,V）
         * 3、第2位：必须为数字
         * 4、第3-8位：行政区代码，全数字，大概区间从110000-820000
         * 5、第9-18位：数字或大写字母（不能出现I,O,Z,S,V）
         */
        var reg = /^(?![IOSV])([0-9A-Y])([0-9]{7})(((?![IOSV])[0-9A-Y]){10})$/;
        if (!reg.test(v)) {
            return false;
        }

        var code, //统一社会信用代码的每一个值
            codeWeight, //统一社会信用代码每一个值的权重
            total = 0,
            weightedFactors = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28], //加权因子
            str = '0123456789ABCDEFGHJKLMNPQRTUWXY';

        for (var i = 0; i < v.length - 1; i++) {
            code = v.charAt(i);
            codeWeight = str.indexOf(code);
            total += codeWeight * weightedFactors[i];
            //权重与加权因子相乘之和
        }
        var logicCheckCode = 31 - (total % 31);
        if (logicCheckCode === 31) {
            logicCheckCode = 0;
        }

        logicCheckCode = str.charAt(logicCheckCode);

        if (logicCheckCode !== v.charAt(17)) {
            return false;
        }

        return true;

        /*
         * 该段验证逻辑存在问题，对于一些真实的统一社会信用代码验证不通过，先去掉
        //字符集数组
        var fin_array = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'T', 'U', 'W', 'X', 'Y'];
        //加权数组
        var i_array = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28];
        //结果数组
        var val_array = [];
        //相乘数组
        var ch_array = [];
        //Sigma
        var sigma = 0;

        for (var i = 0; i < 17; i++) {
            //转换成字符集的值
            val_array[i] = fin_array.indexOf(v.charAt(i));
            //生成加权结果
            ch_array[i] = val_array[i] * i_array[i];
            //求出Sigma
            sigma += ch_array[i];
        }
        //求出校验位
        var vali_index = 31 - sigma % 31;
        var vali = fin_array[vali_index == 31 ? 0 : vali_index];
        //查看校验码是否正确
        if (v.charAt(17) !== vali) {
            return false;
        }
        */
    },
    idCard: function (v, args) {
        if (mini.isNull(v) || v === '') return true;

        function validateIdCard(idCard) {
            // 15位和18位身份证号码的正则表达式
            var regIdCard =
                /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[X])$)$/;

            // 如果通过该验证，说明身份证格式正确，但准确性还需计算
            if (regIdCard.test(idCard)) {
                if (idCard.length === 15) {
                    return true;
                }
                if (idCard.length === 18) {
                    var idCardWi = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2); // 将前17位加权因子保存在数组里
                    var idCardY = new Array(1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2); // 这是除以11后，可能产生的11位余数、验证码，也保存成数组
                    var idCardWiSum = 0; // 用来保存前17位各自乖以加权因子后的总和
                    for (var i = 0; i < 17; i++) {
                        idCardWiSum += idCard.substring(i, i + 1) * idCardWi[i];
                    }

                    var idCardMod = idCardWiSum % 11; // 计算出校验码所在数组的位置
                    var idCardLast = idCard.substring(17); // 得到最后一位身份证号码

                    // 如果等于2，则说明校验码是10，身份证号码最后一位应该是X
                    if (idCardMod === 2) {
                        if (idCardLast === 'X') {
                            return true;
                        }
                        return false;
                    }
                    // 用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
                    if (idCardLast == idCardY[idCardMod]) {
                        return true;
                    }
                    return false;
                }
            } else {
                return false;
            }
        }

        return validateIdCard(v) || mini.VTypes._isHkIdCard(v);
    },
    hkIdCard: function (v) {
        if (mini.isNull(v) || v === '') {
            return true;
        }

        return mini.VTypes._isHkIdCard(v);
    },
    _isHkIdCard: function (v) {
        var strValidChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
            // regular expression to check pattern and split
            pattern = /^([A-Z]{1,2})([0-9]{6})[(（]([A0-9])[)）]$/,
            matchArray = v.match(pattern);

        // not match, return false
        if (matchArray === null) {
            return false;
        }

        // the character part, numeric part and check digit part
        var charPart = matchArray[1],
            numPart = matchArray[2],
            checkDigit = matchArray[3],
            // calculate the checksum for character part
            checkSum = 0;
        if (charPart.length === 2) {
            checkSum += 9 * (10 + strValidChars.indexOf(charPart.charAt(0)));
            checkSum += 8 * (10 + strValidChars.indexOf(charPart.charAt(1)));
        } else {
            checkSum += 9 * 36;
            checkSum += 8 * (10 + strValidChars.indexOf(charPart));
        }
        // calculate the checksum for numeric part
        for (var i = 0, j = 7; i < numPart.length; i++, j--) {
            checkSum += j * numPart.charAt(i);
        }

        // verify the check digit
        var remaining = checkSum % 11,
            verify = remaining === 0 ? 0 : 11 - remaining;
        return verify + '' === checkDigit || (verify === 10 && checkDigit === 'A');
    },
    /* 投资项目统一代码
     * 规则为：
     * 代码长度24位;
     * 代码格式：年份代码-地区（部门）代码-行业代码-项目类型代码-流水号
     * 第1-4位：纯数字，值域1900-2099
     * 第5位："-"
     * 第6-11位：纯数字，大概区间从110000-820000
     * 第12位："-"
     * 第13-14位行业代码：2位数字组成，值域01-99
     * 第15位："-"
     * 第16-17位项目类型代码：2位数字组成，值域01-99
     * 第18位："-"
     * 第19-24位流水号：纯数字，值域000001-999999
     */
    projectCode: function (v) {
        if (mini.isNull(v) || v === '') {
            return true;
        }

        return /^(19|20)\d{2}-\d{6}-\d{2}-\d{2}-\d{6}$/.test(v);
    },
    /**
     * 重写 url 验证规则
     * 支持带一部分协议或无协议
     * 支持 ipv4 和 域名 localhost 形式
     * 支持 端口号 验证
     * !不支持 中文域名
     * !不支持 ipv6
     * !不支持 url中带用户名和密码
     * 原来 miniui 中的正则有严重性能问题 输入10位以上的数字基本会直接导致浏览器卡死
     * @param {string} v 待检查字符
     * @author chends
     */
     url: function (v) {
        if (mini.isNull(v) || v === '') return true;
        return isUrl(v);

        function isUrl(url) {
            var u = url.split('?')[0];

            // 存在协议则去掉
            var protocolReg = /^(http|https|ws|wss|ftp|rtsp|mailto|ed2k|thunder):\/\//i;
            var r = protocolReg.exec(u);
            if (r) {
                u = u.substr(r[0].length);
            }

            // ip or 域名处理
            var v4reg = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/;
            var v6reg =
                /^\[((([\dA-Fa-f]{1,4}:){7}([\dA-Fa-f]{1,4}|:))|(([\dA-Fa-f]{1,4}:){6}(:[\dA-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([\dA-Fa-f]{1,4}:){5}(((:[\dA-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([\dA-Fa-f]{1,4}:){4}(((:[\dA-Fa-f]{1,4}){1,3})|((:[\dA-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([\dA-Fa-f]{1,4}:){3}(((:[\dA-Fa-f]{1,4}){1,4})|((:[\dA-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([\dA-Fa-f]{1,4}:){2}(((:[\dA-Fa-f]{1,4}){1,5})|((:[\dA-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([\dA-Fa-f]{1,4}:){1}(((:[\dA-Fa-f]{1,4}){1,6})|((:[\dA-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[\dA-Fa-f]{1,4}){1,7})|((:[\dA-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(.(25[0-5]2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.\+)?\]/;
            var domainReg = /^(?:localhost|([\w-_]+\.(?!\.))+[a-z]{2,})/i;
            var v4, v6, domain;
            v4 = v4reg.exec(u);
            if (v4) {
                u = u.substr(v4[0].length);
            } else if ((v6 = v6reg.exec(u))) {
                u = u.substr(v6[0].length);
            } else {
                domain = domainReg.exec(u);
                if (domain) {
                    u = u.substr(domain[0].length);
                }
            }

            // ip 或 dom 必须满足一个
            if (!v4 && !v6 && !domain) {
                return false;
            }

            // 端口号 0~65535
            var portReg = /^:\d{1,5}/;
            r = portReg.exec(u);
            if (r) {
                u = u.substr(r[0].length);
                var port = parseInt(r[0].substr(1), 10);
                if (port > 65535) {
                    return false;
                }
            }

            if (u.length === 0 || u === '/') {
                return true;
            }
            // pathname
            // 情况太多 / + 直接任意字符
            var pathReg = /^\/[\s\S]+/i;
            return pathReg.test(u);
        }
    },
    /**
     * 重写 maxLength 验证规则
     * 区分中英文，中文占 3 个字符（根据樊志君反馈，后台用UTF-8编码，中文占 3  个字符）
     **/
    maxLength: function (v, args) {
        if (mini.isNull(v) || v === '') return true;

        var n = parseInt(args, 10),
            len;

        if (!v || isNaN(n)) return true;

        len = mini.getStrLength(v);

        if (len <= n) return true;

        return false;
    },
    /**
     * 重写 minLength 验证规则
     * 区分中英文，中文占 3 个字符（根据樊志君反馈，后台用UTF-8编码，中文占 3  个字符）
     **/
    minLength: function (v, args) {
        if (mini.isNull(v) || v === '') return true;
        var n = parseInt(args, 10),
            len;

        if (isNaN(n)) return true;

        // if (v.length >= n) return true;
        len = mini.getStrLength(v);

        if (len >= n) return true;

        return false;
    },
    /**
     * 重写 rangeLength 验证规则
     * 区分中英文，中文占 3 个字符（根据樊志君反馈，后台用UTF-8编码，中文占 3  个字符）
     **/
    rangeLength: function (v, args) {
        if (mini.isNull(v) || v === '') return true;
        if (!v) return false;

        var min = parseFloat(args[0]),
            max = parseFloat(args[1]),
            len;

        if (isNaN(min) || isNaN(max)) return true;

        // if (min <= v.length && v.length <= max) return true;
        len = mini.getStrLength(v);
        if (min <= len && len <= max) return true;

        return false;
    }
});

// 点击弹出框 在滚动位置变化时自动隐藏的实现
// miniui 的源码中实现在popupEdit上 但实际 menu 和 popup 都需要，避免来回重写 单独抽取扩展给menu和popup即可
mini.__mouseWheelHandles = {
    _unDocumentMousewheel: function () {
        mini.un(document, 'mousewheel', this.__OnDocumentMousewheel, this);
        this._mousewheelXY = null;
    },
    _onDocumentMousewheel: function () {
        this._unDocumentMousewheel();

        // 嵌套的菜单未显示的时候 还没有这个属性
        if (!this.popupEl) return;

        this._mousewheelXY = mini.getXY(this.popupEl);
        mini.on(document, 'mousewheel', this.__OnDocumentMousewheel, this);
    },
    __OnDocumentMousewheel: function (e) {
        var that = this;

        function doWheel() {
            if (!that.isPopup) return;
            // 之前的位置
            var box = that._mousewheelXY;
            // 现在的位置 如果不一致 则页面滚动了 隐藏
            var xy = mini.getXY(that.popupEl);
            if (box[0] != xy[0] || box[1] != xy[1]) {
                that.hide();
            } else {
                setTimeout(doWheel, 300);
            }
        }

        setTimeout(doWheel, 300);
    }
};

mini._ParseColumns = function (el) {
    var columns = [];
    var cs = mini.getChildNodes(el);
    for (var i = 0, l = cs.length; i < l; i++) {
        var node = cs[i];
        //var jq = jQuery(node);

        var column = {};

        var editor = null,
            editorEl = null,
            filter = null,
            template = null;

        //sub columns
        var subCs = mini.getChildNodes(node);
        if (subCs) {
            for (var ii = 0, li = subCs.length; ii < li; ii++) {
                var subNode = subCs[ii];
                //var property = jQuery(subNode).attr("property");
                var property = mini.getAttr(subNode, 'property');
                if (!property) continue;
                property = property.toLowerCase();
                if (property == 'columns') {
                    column.columns = mini._ParseColumns(subNode);
                    //jQuery(subNode).remove();
                    if (subNode.parentNode) subNode.parentNode.removeChild(subNode);
                }
                if (property == 'editor' || property == 'filter') {
                    var className = subNode.className;
                    var classes = className.split(' ');
                    for (var i3 = 0, l3 = classes.length; i3 < l3; i3++) {
                        var cls = classes[i3];
                        var clazz = mini.getClassByUICls(cls);
                        if (clazz) {
                            var ui = new clazz();

                            if (property == 'filter') {
                                filter = ui.getAttrs(subNode);
                                filter.type = ui.type;
                            } else {
                                editor = ui.getAttrs(subNode);
                                editor.type = ui.type;
                            }
                            break;
                        }
                    }

                    // 可能是个性化组件，尝试懒解析
                    if (i3 === l3 && property === 'editor') {
                        editorEl = subNode;
                    }

                    //jQuery(subNode).remove();
                    if (subNode.parentNode) subNode.parentNode.removeChild(subNode);
                } else if (property === 'template') {
                    template = jQuery.trim(subNode.innerHTML);
                    if (subNode.parentNode) subNode.parentNode.removeChild(subNode);
                    // 模板需要基于 Mustache 来渲染
                    if (!window.Mustache) {
                        mini.loadJS(mini.externalSrc + 'mustache.min.js');
                    }
                }
            }
        }

        column.header = node.innerHTML;

        // prettier-ignore
        mini._ParseString(node, column,
            // prettier-ignore
            ['name', 'header', 'field', 'editor', 'filter', 'renderer', 'width', 'type', 'renderer', 'beforeRender', 'rendered',
                'headerAlign', 'align', 'headerCls', 'cellCls', 'headerStyle', 'cellStyle', 'displayField', 'dateFormat', 'listFormat', 'mapFormat', 'numberFormat',
                'trueValue', 'falseValue', 'dataType', 'vtype', 'requiredErrorText', 'currencyUnit',
                'summaryType', 'summaryRenderer', 'groupSummaryType', 'groupSummaryRenderer',
                'defaultValue', 'defaultText', 'decimalPlaces', 'data-options', 'sortField', 'sortType',
                'emptyText'
            ]
        );
        // prettier-ignore
        mini._ParseBool(node, column,
            // prettier-ignore
            ['allowCellWrap', 'visible', 'readOnly', 'allowSort', 'allowResize', 'allowMove', 'allowDrag', 'autoShowPopup',
                'unique', 'autoEscape', 'enabled', 'hideable', 'showCellTip', 'valueFromSelect', 'navUpdown'
            ]
        );
        mini._ParseInt(node, column, ['minWidth']);
        if (editor) column.editor = editor;
        if (editorEl) column.editorEl = editorEl;
        if (filter) column.filter = filter;
        if (template) column.template = template;

        if (typeof column.editor === 'string') {
            try {
                column.editor = window['ev' + 'al']('(' + column.editor + ')');
            } catch (e) {}
        }

        if (column.dataType) column.dataType = column.dataType.toLowerCase();

        // 系统参数配置的 列 emptyText
        if (mini.getF9FrameSysParams('gridColumnEmptyText') !== undefined) {
            column.emptyText = mini.getF9FrameSysParams('gridColumnEmptyText');
        }
        // 默认占位为 -- // 系统参数可配置是否启用 列 emptyText
        if (!column.emptyText && mini.getF9FrameSysParams('gridEnableColumnEmptyText') !== false) {
            // 未配置数据类型 或类型不是 ['int','float','date','boolean','currency'] 为 --
            if (
                !column.dataType ||
                jQuery.inArray(column.dataType, ['int', 'float', 'date', 'boolean', 'currency']) === -1
            ) {
                column.emptyText = '--';
            } else if (column.dataType == 'int' || column.dataType == 'float') {
                // 数值类型则默认 0
                column.emptyText = 0;
            }
        }

        if (column.defaultValue === 'true') column.defaultValue = true;
        if (column.defaultValue === 'false') column.defaultValue = false;

        columns.push(column);

        //data-options
        var options = column['data-options'];
        if (options) {
            options = window['ev' + 'al']('(' + options + ')');
            if (options) {
                //attrs["data-options"] = options;
                mini.copyTo(column, options);
            }
        }
    }

    return columns;
};

var _oParseFloat = mini.parseFloat;
mini.parseFloat = function (value, culture, format) {
    if (!value && value !== 0) {
        return null;
    }

    if (typeof value === 'number') {
        return value;
    }

    value = value.toString();

    // 添加对小数位数的处理，避免出现科学计数法的情况
    if (format.indexOf('n') === 0) {
        var dl = parseInt(format.substr(1), 10),
            index = value.indexOf('.');
        if (dl && index > -1) {
            value = value.substr(0, index + dl);
        }
    }

    return _oParseFloat(value, culture, format);
};

// 先做我们的扩展 再注册 css 减少重写成本
(function ($) {
    var old_regClass = window.mini.regClass || window.mini_regClass;
    // 记录所有扩展
    // {
    //     clssName : '一个方法返回扩展对象 或 扩展对象数组'
    // }
    mini._EpointExt = {};
    /**
     * 添加扩展
     *
     * @param {string} name 控件名称
     * @param {() => extObj | extObj[]} fn 扩展方法 返回扩展对象 扩展对象数组
     */
    window.mini.addEpointExt = function (name, fn) {
        name = name.toLowerCase();
        var exts = mini._EpointExt[name];
        if (!exts) {
            exts = mini._EpointExt[name] = [];
        }
        exts.push(fn);
    };

    /**
     * 根据名称获取扩展对象
     * @param {string} name 控件名称
     * @returns 扩展对象数组
     */
    window.mini.getEpointExt = function (name) {
        name = name.toLowerCase();
        var extFns = mini._EpointExt[name];
        delete mini._EpointExt[name];
        if ($.isArray(extFns) && extFns.length) {
            var extArr = [];
            $.each(extFns, function (i, extFn) {
                if (extFn && typeof extFn === 'function') {
                    var ext = extFn();
                    if ($.isArray(ext)) {
                        extArr.push.apply(extArr, ext);
                    } else {
                        extArr.push(ext);
                    }
                }
            });
            return extArr;
        }
        return [];
    };

    window.mini_regClass = window.mini.regClass = function (clazz, className) {
        // do overwrite
        var args = [clazz];
        var exts = mini.getEpointExt(className);
        if ($.isArray(exts) && exts.length) {
            $.each(exts, function (i, ext) {
                args.push(ext);
            });

            mini.overwrite.apply(mini, args);
        }

        return old_regClass.apply(this, arguments);
    };
})(jQuery);

mini.addEpointExt('control', function () {
    return {
        setWidth: function (value) {
            if (!value) {
                return;
            }
            if (parseFloat(value) == value) value += 'px';
            this.width = value;
            this.el.style.width = value;
            this._sizeChanged();
        },
        setHeight: function (value) {
            if (!value) {
                return;
            }
            if (parseFloat(value) == value) value += 'px';
            this.height = value;
            this.el.style.height = value;
            this._sizeChanged();
        }
    };
});

mini.overwrite(mini.ListControl, {
    // 添加 autoLoad 属性
    autoLoad: true,
    getAutoLoad: function () {
        return this.autoLoad;
    },
    setAutoLoad: function (autoLoad) {
        this.autoLoad = autoLoad;
    },
    setUrl: function (url) {
        this.url = url;
        this.autoLoad && this._doLoad({});
    },
    // 解决重新给单选多选赋值数据源时导致已选值丢失的问题
    setData: function (data) {
        if (typeof data === 'string') {
            data = window['ev' + 'al'](data);
        }
        if (!mini.isArray(data)) data = [];
        this.data = data;
        this.doUpdate();

        if (this.value != '') {
            var records = this.findItems(this.value);
            this.deselectAll();
            this.selects(records);
        }
    }
});
/**
 * debounce 大于间隔时间时才触发
 * 连续触发时，仅当时间间隔大于指定时间才触发
 *
 * @param {function} fn 要处理的函数
 * @param {number} delay 间隔时间 单位 ms
 * @param {[object]} ctx 要绑定的上下文
 * @returns debounce 后的新函数
 */
mini.debounce = function (fn, delay, ctx) {
    delay = delay || 17;
    var timer;
    return function () {
        var args = arguments;
        var context = ctx || this;
        clearTimeout(timer);
        timer = setTimeout(function () {
            fn.apply(context, args);
        }, delay);
    };
};

/**
 * throttle 降低触发频率
 * 连续触发时，降低执行频率到指定时间
 *
 * @param {function} fn 要处理的函数
 * @param {number} delay 间隔时间 单位 ms
 * @param {[object]} ctx 要绑定的上下文
 * @returns throttle 后的新函数
 */
mini.throttle = function throttle(fn, delay, ctx) {
    delay = delay || 200;
    var timer,
        prevTime = +new Date();
    return function () {
        clearTimeout(timer);
        var args = arguments;
        var context = ctx || this;
        var pastTime = +new Date() - prevTime;

        if (pastTime >= delay) {
            // 如果过去的时间已经大于间隔时间 则立即执行
            fn.apply(context, args);
            prevTime = +new Date();
        } else {
            // 过去的时间还没到 则等待
            timer = setTimeout(function () {
                fn.apply(context, args);
                prevTime = +new Date();
            }, delay - pastTime);
        }
    };
};

mini.formatAmountToChinese = function (money, decLen) {
    var cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'], //汉字的数字
        cnIntRadices = ['', '拾', '佰', '仟'], //基本单位
        cnIntUnits = ['', '万', '亿', '兆', '京', '垓', '秭'], //对应整数部分扩展单位
        cnDecUnits = ['角', '分', '毫', '厘'], //对应小数部分单位
        cnInteger = '整', //整数金额时后面跟的字符
        cnIntEndUnit = '圆', //整型完以后的单位
        integerNum, //金额整数部分
        decimalNum, //金额小数部分
        chineseStr = '', //输出的中文金额字符串
        parts, //分离金额后用的数组，预定义
        i,
        l,
        num,
        zeroCount;

    money = parseFloat(money);
    if (!mini.isNumber(money) || money < 0) {
        return '';
    }

    if (money === 0) {
        chineseStr = cnNums[0] + cnIntEndUnit + cnInteger;
        return chineseStr;
    }

    decLen = decLen || parseInt(mini.getF9FrameSysParams('ui_money_decimal_length'), 10) || 2;
    money = money.toString(); //转换为字符串
    if (money.indexOf('.') === -1) {
        integerNum = money;
        decimalNum = '';
    } else {
        parts = money.split('.');
        integerNum = parts[0];
        decimalNum = parts[1].substr(0, decLen);
    }
    if (parseInt(integerNum, 10) > 0) {
        //获取整型部分转换
        zeroCount = 0;
        l = integerNum.length;
        for (i = 0; i < l; i++) {
            num = integerNum.substr(i, 1);
            var p = l - i - 1;
            var q = p / 4;
            var m = p % 4;
            if (num === '0') {
                zeroCount++;
            } else {
                if (zeroCount > 0) {
                    chineseStr += cnNums[0];
                }
                zeroCount = 0; //归零
                chineseStr += cnNums[parseInt(num, 10)] + cnIntRadices[m];
            }
            if (m === 0 && zeroCount < 4) {
                chineseStr += cnIntUnits[q];
            }
        }
        chineseStr += cnIntEndUnit;
        //整型部分处理完毕
    }
    if (decimalNum !== '') {
        //小数部分
        l = Math.min(decimalNum.length, 4);
        for (i = 0; i < l; i++) {
            num = decimalNum.substr(i, 1);
            if (num !== '0') {
                chineseStr += cnNums[parseInt(num, 10)] + cnDecUnits[i];
            }
        }
    }
    if (chineseStr === '') {
        chineseStr += cnNums[0] + cnIntEndUnit + cnInteger;
    } else if (decimalNum === '') {
        chineseStr += cnInteger;
    }
    return chineseStr;
};

mini.loadJSWithAMD = function (src, name, callback) {
    if (typeof define === 'function' && define.amd) {
        return require([src], function (module) {
            window[name] = module;
            if (typeof callback === 'function') {
                callback();
            }
        });
    }
    return mini.loadJS(src, callback);
};

mini.numeralUtil = {
    addPrefixFormat: function () {
        if (!window.numeral) {
            console.error('未加载 numeral.js，addPrefixFormat 失败！');
            return;
        }
        // 前缀格式化
        /**
         *
         * -123 "(RMB# 0.00)" => "(RMB 123.00)"
         * 123 "(RMB# 0.00)" => "RMB 123.00"
         * 5000 "人名币#0.00" => "人名币5000.00"
         */
        numeral.register('format', 'prefix', {
            regexps: {
                format: /(#)/,
                unformat: /(#)/
            },
            format: function (value, format, roundingFunction) {
                var space = numeral._.includes(format, '# ') ? ' ' : '',
                    output;

                var prefix = format.replace(/\(?([\s\S]*)#[\s\S]*/, '$1');
                format = format.replace(prefix + '#' + space, '');
                output = numeral._.numberToFormat(value, format, roundingFunction);

                if (numeral._.includes(output, '(')) {
                    output = output.split('');

                    output.splice(1, 0, prefix + space);

                    output = output.join('');
                } else {
                    output = prefix + space + output;
                }

                return output;
            },
            unformat: function (string) {
                return numeral._.stringToNumber(string);
            }
        });
    },
    addSuffixFormat: function () {
        if (!window.numeral) {
            console.error('未加载 numeral.js，addSuffixFormat 失败！');
            return;
        }
        numeral.register('format', 'suffix', {
            regexps: {
                format: /(@)/,
                unformat: /(@)/
            },
            format: function (value, format, roundingFunction) {
                var space = numeral._.includes(format, ' @') ? ' ' : '',
                    output;
                var index = format.indexOf('@'),
                    index2 = format.lastIndexOf(')');
                var suffix = format.substring(index + 1, index2 === -1 ? format.length : index2);
                format = format.replace(space + '@' + suffix, '');
                // output = numeral._.numberToFormat(value, format, roundingFunction);

                output = numeral(value).format(format);
                if (numeral._.includes(output, ')')) {
                    output = output.split('');

                    output.splice(-1, 0, space + suffix);

                    output = output.join('');
                } else {
                    output = output + space + suffix;
                }

                return output;
            },
            unformat: function (string) {
                return numeral._.stringToNumber(string);
            }
        });
    },
    addRmbFormat: function () {
        if (!window.numeral) {
            console.error('未加载 numeral.js，addRmbFormat 失败！');
            return;
        }
        numeral.register('format', 'rmb', {
            regexps: {
                format: /(RMB)/
            },
            format: function (value, format, roundingFunction) {
                var output,
                    decimalLength,
                    intLength,
                    multiple = 1;

                // strip format of spaces and RMB
                format = format.replace(/\s?RMB\s?/, '');

                var match = format.match(/(0*)\.?(0*)/);
                if (match) {
                    intLength = match[1].length;
                    decimalLength = match[2].length;
                    for (var i = 1; i < intLength; i++) {
                        multiple *= 10;
                    }
                }

                output = mini.formatAmountToChinese(mini.accMul(value, multiple), decimalLength);
                return output;
            }
        });
    },
    initNumeral: function (callback) {
        if (!window.numeral) {
            mini.loadJSWithAMD(mini.externalSrc + 'numeral/numeral.js', 'numeral', function () {
                Object.freeze(numeral);
                numeral.nullFormat('');
                if (mini.locale === 'zh_CN') {
                    if (numeral.locales && !numeral.locales.chs) {
                        numeral.register('locale', 'chs', {
                            delimiters: {
                                thousands: ',',
                                decimal: '.'
                            },
                            abbreviations: {
                                thousand: '千',
                                million: '百万',
                                billion: '十亿',
                                trillion: '兆'
                            },
                            ordinal: function (number) {
                                return '.';
                            },
                            currency: {
                                symbol: '¥'
                            }
                        });
                    }
                    numeral.locale('chs');
                }
                if (!numeral.formats.suffix) {
                    mini.numeralUtil.addSuffixFormat();
                }
                if (!numeral.formats.prefix) {
                    mini.numeralUtil.addPrefixFormat();
                }
                if (!numeral.formats.rmb) {
                    mini.numeralUtil.addRmbFormat();
                }

                // 覆写 currency 的 format 方法，支持 000.00 这种用法
                var _o_currency_format = numeral.formats.currency.format;
                if (!_o_currency_format.isOverWrite) {
                    numeral.formats.currency.format = function (value, format, roundingFunction) {
                        var formatN = format.replace(/\s?\$\s?/, ''),
                            match = formatN.match(/(0*)\.?(0*)/),
                            intLength,
                            multiple = 1;
                        if (match) {
                            intLength = match[1].length;
                            for (var i = 1; i < intLength; i++) {
                                multiple *= 10;
                            }
                        }

                        return _o_currency_format(mini.accMul(value, multiple), format, roundingFunction);
                    };
                    numeral.formats.currency.format.isOverWrite = true;
                }
                
                // RMB 关键字会被 bytes 里的 MB 匹配，导致问题，先去除
                if(numeral.formats.bytes) {
                    numeral.formats.bytes = undefined;
                    delete numeral.formats.bytes;
                }

                callback && callback();
            });
        } else {
            numeral.nullFormat('');
            // window.numeral = window.numeral;
        }
    }
};

// 避免乘法丢失精度问题 (原理：将两个数值放大，计算完再缩小)
mini.accMul = function (arg1, arg2) {
    var m = 0,
        s1 = arg1.toString(),
        s2 = arg2.toString();

    try {
        m += s1.split('.')[1].length;
    } catch (e) {}

    try {
        m += s2.split('.')[1].length;
    } catch (e) {}

    return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m);
    
};

/**
 * 依赖检查函数
 * @param {() => boolean} checker 检查函数
 * @param {number} maxCount 最大测试次数
 * @param {number} interval 间隔时间
 */
mini.checkDepend = function checkDepend(checker, maxCount, interval) {
    if (!jQuery.isNumeric(maxCount)) {
        maxCount = 1000;
    }
    if (!jQuery.isNumeric(interval)) {
        maxCount = 100;
    }

    return new Promise(function (resolve, reject) {
        var timer;
        var i = 0;
        go();

        function go() {
            clearTimeout(timer);
            if (checker()) {
                resolve();
                return;
            }
            if (++i >= maxCount) {
                reject();
                return;
            }
            timer = setTimeout(go, interval);
        }
    });
};

mini.addEpointExt('AutoComplete', function() {
    return {
        isLocalData: false,

        setIsLocalData: function(isLocalData) {
            this.isLocalData = isLocalData;

            if(this.isLocalData) {
                this.setRemote(false);
                this.setData(this._getLocalListData());
            }
        },
        _localKey: undefined,
        _getLocalKey: function() {
            if(!this._localKey) {
                this._localKey = this.id + '_local_data';
            }
            return this._localKey;
        },
        _localData: undefined,
        _getLocalData: function() {
            if(!this._localData) {
                this._localData = window.localStorage.getItem(this._getLocalKey()) || '';
            }

            return this._localData;
        },
        _localListData: undefined,
        _getLocalListData: function() {
            var localDataArr,
                listData = [];
            if(!this._localListData) {
                localDataArr = this._getLocalData().split(';');
                for(var i = 0, l = localDataArr.length; i < l; i++) {
                    listData.push({
                        id: localDataArr[i],
                        text: localDataArr[i]
                    });
                }
                this._localListData = listData;
            }

            return this._localListData;
        },

        _updateLocalData: function(val) {
            this._localData = val;
            window.localStorage.setItem(this._getLocalKey(), val);
        },
        _updateLocalListData: function(data) {
            this._localListData = data;
            this.setData(data);
        },
        _addLocalData: function(value) {
            var localData = this._getLocalData(),
                localListData = this._getLocalListData(),
                item = {};
            if(!value || (';' + localData + ';').indexOf(';' + value + ';') > -1) {
                return;
            }
            item[this.textField] = value;
            item[this.valueField] = value;

            localListData.unshift(item);
            localData = value + (localData ? ';' + localData : '');

            if(localListData.length > 10) {
                localListData.length = 10;
                localData = localData.substr(0, localData.lastIndexOf(';'));
            }

            this._updateLocalData(localData);
            this._updateLocalListData(localListData);
        },

        _OnValueChanged: function() {
            mini.AutoComplete.superclass._OnValueChanged.call(this);
            var value = this.getValue();
            if(value && this.isLocalData) {
                this._addLocalData(value);
            }
        },
        getExtraAttrs: function(el) {
            var attrs = {};
            mini._ParseBool(el, attrs, ['isLocalData']);

            return attrs;
        }
    };
});
mini.addEpointExt('button', function() {
    return {
        enableRelatedGridId: '',
        disableMultiClick: mini.getCtrDefaultBySysParams('buttonDisableMultiClick', true),
        iconPosition: 'left',
        size: 'default',
        _sizeList: ['default', 'small'],
        _sizePrefix: 'mini-button-size-',
        _iconOnlyCls: 'mini-button-iconOnly',

        _iconPosCls: {
            left: 'mini-button-iconLeft',
            right: 'mini-button-iconRight',
            top: 'mini-button-iconTop',
            bottom: 'mini-button-iconBottom'
        },

        // ghost: true,
        ghostCls: 'mini-button-ghost',

        // 按钮语义化配置
        state: 'default',
        _statePrefix: 'mini-button-state-',
        _stateList: ['default', 'primary', 'info', 'success', 'warning', 'danger'],
        // 兼容老的 class 转换
        _semantic2state: {
            'mini-btn-primary': 'primary',
            'mini-btn-info': 'info',
            'mini-btn-success': 'success',
            'mini-btn-warning': 'warning',
            'mini-btn-danger': 'danger'
        },

        _loadingSvg: mini.isIE8 || mini.isIE9 ? '' : '<svg class="mini-button-loading-icon" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="128" height="128" fill="currentColor" ><path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path></svg>',

        set: function(kv) {
            if (typeof kv === 'string') {
                return this;
            }

            this._allowUpdate = !(kv.text || kv.iconStyle || kv.iconCls || kv.iconPosition);

            // 兼容 老的 class 配置语义化的支持
            this._applyState(kv);

            // 应用我们独特的 ghost 规则
            this._applyGhost(kv);

            kv.state = kv.state  || this.state;

            mini.Button.superclass.set.call(this, kv);

            if (this._allowUpdate === false) {
                this._allowUpdate = true;
                this.doUpdate();
            }

            return this;
        },

        _create: function() {
            this.el = document.createElement('a');

            this.el.className = 'mini-button mini-corner-all mini-button-state-default';
            this.el.hideFocus = true;
            this.el.href = 'javascript:void(0)';
            this.doUpdate();
        },

        // left|right|top|bottom
        setIconPosition: function(value) {
            this.iconPosition = value;
            this.doUpdate();
        },

        setGhost: function(value) {
            this.ghost = !!value;
            if (this.ghost) {
                this.addCls(this.ghostCls);
            } else {
                this.removeCls(this.ghostCls);
            }
        },
        getGhost: function() {
            return this.ghost;
        },

        // 应用默认的 ghost 规则
        // 未配置时 主要按钮非 ghost 其他按钮全部 ghost
        // 配置时 取配置
        _applyGhost: function(kv) {
            var state = kv.state || this.state;
            if (kv.ghost === undefined) {
                kv.ghost = state === 'primary' ? false : true;
            }
        },

        // 将老的 mini-btn-语义 转换为配置
        _applyState: function(kv) {
            var classList = kv.cls;
            if (!classList) {
                return;
            }
            classList = classList.split(' ');
            var cls = '';
            for (var i = classList.length - 1; i >= 0; i--) {
                cls = classList[i];
                if (/mini-btn-(?:primary|info|success|warning|danger)/.test(cls)) {
                    kv.state = this._semantic2state[cls] || 'default';
                    break;
                }
            }
        },
        setState: function(value) {
            var isValid = jQuery.inArray(value, this._stateList) !== -1;
            if (!isValid) {
                window.console && console.error && console.error(value + '不是有效的state值');
                return this.state;
            }
            // 移除旧的 class 加上新的 class
            this.removeCls(this._statePrefix + this.state);
            this.state = value;
            this.addCls(this._statePrefix + this.state);
            return this.state;
        },
        getState: function() {
            return this.state;
        },

        setSize: function(value) {
            var isValid = jQuery.inArray(value, this._sizeList) !== -1;
            if (!isValid) {
                window.console && console.error && console.error(value + '不是有效的size值');
                return this.size;
            }

            this.removeCls(this._sizePrefix + this.size);
            this.size = value;
            this.addCls(this._sizePrefix + this.size);
            return this.size;
        },
        // 该方法在button实例set属性时反复调用
        doUpdate: function() {
            if (this._allowUpdate === false) return;

            var text = this.text;

            var iconCls = this.iconCls,
                iconStyle = this.iconStyle || '',
                iconPos = this.iconPosition,
                plain = this.plain;

            var hasIcon = iconCls || iconStyle || this.img;

            var btnHtml = [];

            if (text === '') {
                this.addCls(this._iconOnlyCls);
            } else {
                this.removeCls(this._iconOnlyCls);
                // button文本
                btnHtml.push('<span class="mini-button-text">' + text + '</span>');
            }

            if (plain) {
                this.addCls(this._plainCls);
            } else {
                this.removeCls(this._plainCls);
            }

            if (hasIcon) {
                // 由于doUpdate的反复调用，每次iconPos的值可能都不一样
                // 移除之前的iconPos样式
                if (!mini.hasClass(this.el, this._iconOnlyCls)) {
                    if (this.__prevIconPos) {
                        this.removeCls(this._iconPosCls[this.__prevIconPos]);
                    }

                    this.addCls(this._iconPosCls[iconPos]);

                    this.__prevIconPos = iconPos;
                }

                // button图标
                var iconPrev = iconPos == 'top' || iconPos == 'left';
                var styleText = '';
                if (this.img) {
                    styleText += 'background: url(' + this.img + ') center no-repeat;';
                }
                if (iconStyle) {
                    styleText += iconStyle;
                }
                var iconHtml = '<i class="mini-button-icon ' + iconCls + '" ' + styleText + '></i>';

                if (iconPrev) {
                    btnHtml.unshift(iconHtml);
                    btnHtml.unshift(this._loadingSvg);
                } else {
                    btnHtml.push(iconHtml);
                    btnHtml.push(this._loadingSvg);
                }
                this.removeCls('mini-button-textOnly');
            } else {
                this.addCls('mini-button-textOnly');
                btnHtml.unshift(this._loadingSvg);
            }

            if (this.allowCls) {
                btnHtml.push('<span class="mini-button-allow mini-icon ' + this.allowCls + '"></span>');
            }

            this.el.innerHTML = btnHtml.join('');
        },
        setIsLoading: (function() {
            if (mini.isIE8 || mini.isIE9) {
                return function setIsLoading(value) {
                    // if (this.disableMultiClick) {
                    //     this.disableMultiClick = false;
                    // }
                    this.isLoading = !!value;
                    this.setEnabled(!this.isLoading);
                };
            }

            return function setIsLoading(value) {
                if (!this.enabled) return;
                // if (this.disableMultiClick) {
                //     this.disableMultiClick = false;
                // }
                this.isLoading = !!value;
                if (this.isLoading) {
                    this.addCls('mini-btn-loading');
                } else {
                    this.removeCls('mini-btn-loading');
                }
            };
        })(),
        getIsLoading: function() {
            return this.isLoading;
        },
        _enableTimer: undefined,
        _initEvents: function() {
            // 若禁止多次点击 则多绑定一个事件
            // 内部禁用按钮 一秒后再启用
            // 由于在初始化时绑定 可保证在点击时最先触发，一旦点击立即禁用


            var self = this;
            mini._BindEvents(function() {
                mini_onOne(this.el, 'mousedown', this.__OnMouseDown, this);
                // mini_onOne(this.el, "click", this.__OnClick, this);

                mini_onOne(
                    this.el,
                    'click',
                    function(e) {
                        if (self.isLoading) {
                            return;
                        }
                        mini._lastClickedBtn = {
                            id: self.id,
                            text: self.text
                        };
                        self.__OnClick(e);
                        if (self.disableMultiClick && self.enabled) {
                            self.setEnabled(false);

                           self._enableTimer = setTimeout(function() {
                                self.setEnabled(true);
                            }, 1000);
                        }
                        mini._lastClickedBtn = undefined;
                    },
                    this
                );
            }, this);
        },
        setEnabled: function (value) {
            if(this._enableTimer) {
                clearTimeout(this._enableTimer);
            }

            mini.Button.superclass.setEnabled.call(this, value);
        },
        setEnableRelatedGridId: function (id) {
            if(this.enableRelatedGridId) {
                console.warn('按钮的 enableRelatedGridId 已绑定，不可动态更改');
                return;
            }
            this.enableRelatedGridId = id;
            this.disable();

            var self = this;
            setTimeout(function() {
                var grid = mini.get(self.enableRelatedGridId);

                if(!grid) {
                    console.warn('未找到 enableRelatedGridId="' + self.enableRelatedGridId + '" 所绑定的表格');
                    return;
                }

                grid.on('selectionchanged', updateButtonState);
                grid.on('load', updateButtonState);
                grid.on('removerow', updateButtonState);

                function updateButtonState() {
                    if(grid.getSelecteds().length) {
                        self.enable();
                    } else {
                        self.disable();
                    }
                }
            }, 100);
        },
        getExtraAttrs: function(el) {
            var attrs = {};

            mini._ParseBool(el, attrs, ['disableMultiClick', 'isloading', 'ghost']);
            mini._ParseString(el, attrs, ['state', 'size', 'enableRelatedGridId']);

            return attrs;
        }
    };
});

mini.addEpointExt('MenuButton', function() {
    // 弹出面板和按钮留出 2px 间隙
    var yOffset = 2;
    var oldSetMenu = mini.MenuButton.prototype.setMenu;
    var setMenu = function setMenu(value) {
        var returnValue = oldSetMenu.call(this, value);

        this.menu && this.menu.setyOffset && this.menu.setyOffset(this.yOffset);
        return returnValue;
    };
    return {
        yOffset: yOffset,
        setMenu: setMenu,
        disableMultiClick: false
    };
});
// // 弹出面板和按钮留出 2px 间隙
// (function() {
//     var yOffset = 2;
//     var oldSetMenu = mini.MenuButton.prototype.setMenu;
//     var setMenu = function setMenu(value) {
//         var returnValue = oldSetMenu.call(this, value);

//         this.menu && this.menu.setyOffset && this.menu.setyOffset(this.yOffset);
//         return returnValue;
//     };

//     mini.overwrite(mini.MenuButton, {
//         yOffset: yOffset,
//         setMenu: setMenu
//     });
//     mini.overwrite(mini.SplitButton, {
//         yOffset: yOffset,
//         setMenu: setMenu
//     });

//     // tabs menu: ./Tabs.js
//     // textlistbox: ./TextBoxList.js
//     // combobox： './Popup.js'
// })();

mini.addEpointExt('ButtonEdit', function() {
    return {
        autoClear: true,
        errorTextEl: null,
        getErrorTextEl: function () {
            if (!this.errorTextEl) {
                this.errorTextEl = mini.append(this.el, '<span class="mini-errorText"></span>');
            }
            return this.errorTextEl;
        },
        _RemoveErrorText: function () {
            if (this.errorTextEl) {
                var el = this.errorTextEl;
                jQuery(el).remove();
            }
            this.errorTextEl = null;
        }
    };
});

mini.addEpointExt('Calendar', function () {
    var ext = {
        __OnClick: function (e) {
            var viewDate = this.viewDate;
            if (this.enabled == false) return;
            var t = e.target;
            var titleEl = mini.findParent(e.target, 'mini-calendar-title');

            // 添加禁用底部按钮的支持
            if (mini.hasClass(t, 'mini-button-disabled')) {
                return;
            }

            if (mini.findParent(t, 'mini-calendar-monthNext')) {
                viewDate.setDate(1);
                viewDate.setMonth(viewDate.getMonth() + 1);
                this.setViewDate(viewDate);
            } else if (mini.findParent(t, 'mini-calendar-yearNext')) {
                //viewDate.setMonth(0);
                viewDate.setDate(1);
                viewDate.setFullYear(viewDate.getFullYear() + 1);
                this.setViewDate(viewDate);
            } else if (mini.findParent(t, 'mini-calendar-monthPrev')) {
                // 解决 setMonth 方法在当前日期为31，mouth减一后，由于上一个月只有30天，就会自动跳到下一个月的第一天，这种不符合我们预期的行为
                // 需要先把当前日期设置到不会大于上一个月的最大日期
                viewDate.setDate(1);
                viewDate.setMonth(viewDate.getMonth() - 1);
                this.setViewDate(viewDate);
            } else if (mini.findParent(t, 'mini-calendar-yearPrev')) {
                viewDate.setDate(1);
                viewDate.setFullYear(viewDate.getFullYear() - 1);
                this.setViewDate(viewDate);
            } else if (mini.findParent(t, 'mini-calendar-tadayButton')) {
                // var d = mini.clearTime(new Date());
                var isYesterday = !!mini.findParent(t, 'yesterday');

                var d = new Date();
                if (isYesterday) {
                    d.setDate(d.getDate() - 1);
                }
                this.setViewDate(d);
                this.setSelectedDate(d);
                if (this.currentTime) {
                    var td = new Date();
                    this.setTime(td);
                }
                this._OnDateClick(d, 'today');
            } else if (mini.findParent(t, 'mini-calendar-clearButton')) {
                this.setSelectedDate(null);
                this.setTime(null);
                this._OnDateClick(null, 'clear');
            } else if (mini.findParent(t, 'mini-calendar-okButton')) {
                this._OnDateClick(null, 'ok');
                //            this.setSelectedDate(null);
                //            this.setTime(null);
                //            this._OnDateClick(null, "clear");
            } else if (titleEl) {
                this.showMenu();
            }

            var dateEl = mini.findParent(e.target, 'mini-calendar-date');

            if (dateEl && !mini.hasClass(dateEl, 'mini-calendar-disabled')) {
                var ids = dateEl.id.split('$');
                var time = parseInt(ids[ids.length - 1]);
                if (time == -1) return;
                var date = new Date(time);

                this._OnDateClick(date);
            }

            //this.focus();
        },
        enbaleOkButton: function (enabled) {
            if (this.showOkButton) {
                mini[enabled ? 'removeClass' : 'addClass'](this.okButtonEl, 'mini-button-disabled');
            }
        },
        _OnValueChanged: function () {
            if (this.showOkButton) {
                mini[this.getValue() ? 'removeClass' : 'addClass'](this.okButtonEl, 'mini-button-disabled');
            }
            this.fire('valuechanged');
        },
        getShortWeek: function (week) {
            if (week > 6) {
                week = 7 - week;
            }
            return this.daysShort[week];
        },
        getFirstDayOfWeek: function () {
            return this.firstDayOfWeek;
        },
        setFirstDayOfWeek: function (day) {
            if (typeof day !== 'number') {
                day = window.parseInt(day, 10);
            }
            if (day > 6 || day < 0) {
                return;
            }
            this.firstDayOfWeek = day;
            this.doUpdate();
        },
        getExtraAttrs: function (el) {
            var attrs = {};

            mini._ParseInt(el, attrs, ['firstDayOfWeek']);

            return attrs;
        }
    };
    // if (mini.supportRem) {
    //     ext.width = '2.20rem';
    //     ext.height = '1.6rem';
    // }
    ext.width = '';
    ext.height = '';
    return ext;
});

mini.addEpointExt('CheckBoxList', function() {
    return {
        autoLoad: false,
        setUrl: function(url) {
            this.url = url;
            if (this.autoLoad) {
                this._doLoad({});
            }
        },
        repeatLayout: 'flow',
        errorTooltipPlacement: 'topright',
        getErrorTextEl: function() {
            if (!this.errorTextEl) {
                this.errorTextEl = mini.append(this.cellEl, '<span class="mini-errorText"></span>');
            }
            return this.errorTextEl;
        },
        _RemoveErrorText: function() {
            if (this.errorTextEl) {
                var el = this.errorTextEl;
                jQuery(el).remove();
            }
            this.errorTextEl = null;
        }
    };
});

mini.addEpointExt('ComboBox', function() {
    return {
        showClose: (window.EpFrameSysParams && EpFrameSysParams.ui_combobox_showclose) || false,
        autoLoad: true,
        selectData: [],
        __input: function(e) {
            if (document.activeElement == this._textEl && e.which) {
                this._tryQuery();
            }
        },
        _createPopup: function() {
            mini.ComboBox.superclass._createPopup.call(this);

            if (this.multiSelect) {
                this._createLabel();
            }

            this._listbox = new mini.ListBox();
            this.listbox = this._listbox;

            this._listbox.showFilter = this.showFilter;
            this._listbox.delimiter = this.delimiter;
            this._listbox.autoLoad = true;
            this._listbox.setBorderStyle('border:0;');
            this._listbox.setStyle('width:100%;height:auto;');
            this._listbox.render(this.popup._contentEl);

            this._listbox.on('beforeitemclick', this.__OnBeforeItemClick, this);
            this._listbox.on('itemclick', this.__OnItemClick, this);
            this._listbox.on('drawcell', this.__OnItemDrawCell, this);

            var me = this;
            // 给listbox绑定commondto数据处理机制，解决在表格编辑列中设置url后自己请求数据的问题
            this._listbox.on(
                'beforeload',
                function(e) {
                    window.DtoUtils && window.DtoUtils.processBeforeLoad(e);
                    me.fire('beforeload', e);
                    e.data = Util.addReplayAttackData(e.data, e.url);
                },
                this
            );
            this._listbox.on(
                'preload',
                function(e) {
                    me.fire('preload', e);
                },
                this
            );
            this._listbox.on(
                'load',
                function(e) {
                    me.data = e.data;
                    me.fire('load', e);
                },
                this
            );
            this._listbox.on(
                'loaderror',
                function(e) {
                    me.fire('loaderror', e);
                },
                this
            );
            this._listbox.on('afterfilter', function() {
                me._listbox.setValue(me.value);
            }, this);
        },
        showPopup: function() {
            // 若未加载数据则自动加载数据
            if (this.isLoaded == false) {
                this.load();
            }

            var ex = { cancel: false };
            this.fire('beforeshowpopup', ex);
            this._firebeforeshowpopup = false;
            if (ex.cancel == true) return;

            if(this.showFilter) {
                this._listbox.clearFilter();
            }

            this._listbox.setHeight('auto');
            mini.ComboBox.superclass.showPopup.call(this);
            var h = this.popup.el.style.height;
            if (h == '' || h == 'auto') {
                this._listbox.setHeight('auto');
            } else {
                this._listbox.setHeight('100%');
            }

            var me = this;

            if (!me.multiSelect) {
                var jq = jQuery('table .mini-listbox-checkbox', me._listbox.el);

                var display = jq.css('display');
                jq.css('display', 'table-cell');
                jq.css('display', display);
            }

            this._listbox.setValueInCheckOrder(this.valueInCheckOrder);

            this._listbox.setValue(this.value);

            if (this.autoFocusItem && (this.value == '' || mini.isNull(this.value))) {
                this._listbox._focusItem(0);
            }
        },
        _createLabel: function() {
            if (!this._$labelwrap) {
                var _labelwrap = document.createElement('div');
                _labelwrap.className = 'mini-combobox-labelwrap';

                var _labellist = document.createElement('ul');
                _labellist.className = 'mini-combobox-labellist clearfix';

                _labelwrap.appendChild(_labellist);
                mini.after(this._textEl, _labelwrap);

                this._$labelwrap = jQuery(_labelwrap);
                this._$labellist = jQuery(_labellist);
            
                mini.on(_labellist, 'wheel', this.__OnLabelScroll, this);
                mini.on(_labellist, 'click', this.__OnLabelClick, this);
                mini.on(window, 'resize', this._layoutLabel, this);

                this._renderLabel();
            }
        },
        _destroyLabel: function() {
            if (this._$labelwrap) {
                mini.un(this._$labellist, 'wheel', this.__OnLabelScroll, this);
                mini.un(this._$labellist, 'click', this.__OnLabelClick, this);
                mini.un(window, 'resize', this._layoutLabel, this);
                
                this._$labelwrap.remove();
                this._$labelwrap = null;
                this._$labellist = null;
            }
        },
        _afterApply: function() {
            mini.ComboBox.superclass._afterApply.call(this);
            this._doInputLayout(false);
        },
        _renderLabel: function() {
            if (!this.multiSelect) {
                return;
            }
            var self = this;
            var view;
            var LABEL_TPL = '{{#.}}<li class="mini-combobox-label" data-value="{{value}}">{{text}}<span class="mini-combobox-label-close"></span></li>{{/.}}';

            var items = this.getSelecteds();

            view = items.map(function(item) {
                return {
                    value: self._listbox.getItemValue(item),
                    text: self._listbox.getItemText(item)
                };
            });
            this._$labellist.html(Mustache.render(LABEL_TPL, view));
            this._$labelwrap.attr('title', this.text);
            this._layoutLabel();
        },
        _layoutLabel: function() {
            var $labels = this._$labellist.children();
            var wrapWidth = this._$labelwrap.width(),
                width = 0,
                x, minX;

            $labels.each(function(idx, label) {
                width += jQuery(label).outerWidth(true);
            });

            if (wrapWidth >= width) {
                x = 0;
            } else {
                minX = wrapWidth - width;
                x = this._$labellist.data('x') || 0;
                x = Math.max(minX, Math.min(0, x));
            }
            
            this._$labellist.data({x: x, w: width});
            this._labelListStyle();
        },
        _labelListStyle: function() {
            if (this.timer) {
                return;
            }
            var self = this;
            this.timer = setTimeout(function() {
                var data = self._$labellist.data(),
                    x = data.x,
                    w = data.w;

                var translateX = (x || 0) + 'px',
                    width = w ? Math.ceil(w) + 'px' : 'auto';

                self._$labellist.attr('style', 'transform: translateX(' + translateX + '); width: ' + width);
                self.timer = null;
            }, 33);
        },
        __OnLabelScroll: function(evt) {
            var deltaY = evt.originalEvent.deltaY;
            var wrapWidth = this._$labelwrap.width(),
                listWidth = this._$labellist.width();
            var scrollX = Math.min(wrapWidth / 2, 100),
                minX, x;

            if (listWidth <= wrapWidth) {
                return;
            }

            minX = wrapWidth - listWidth;
            x = this._$labellist.data('x') || 0;
            if (deltaY > 0) {
                // 向下滚动
                x -= scrollX;
            } else {
                // 向上滚动
                x += scrollX;
            }
            x = Math.max(minX, Math.min(0, x));
            this._$labellist.data('x', x);
            this._labelListStyle();
        },
        __OnLabelClick: function(evt) {
            var $target = jQuery(evt.target);
            var $label, value;
            if ($target.is('.mini-combobox-label-close')) {
                evt.stopPropagation();
                $label = $target.parent();
                value = $label.data('value') + '';
                this.deselect(value);
                this._OnValueChanged();
            }
        },
        _syncValueText: function () {
            var items = [];

            for (var i = 0; i < this.selectData.length; i++) {
                if (this.selectData[i].selected) {
                    items.push(this.selectData[i]);
                }
            }
            
            var vts = this._listbox.getValueAndText(items);
            this.setValue(vts[0]);
            this.setText(vts[1]);
        },
        selectAll: function () {
            this.selectData = this.data.map(function(item) {
                var newItem = JSON.parse(JSON.stringify(item));
                newItem.selected = true;
                return newItem;
            });
    
            this._listbox.selectAll();
            this._syncValueText();
        },
    
        deselectAll: function () {
            this.selectData = this.data.map(function(item) {
                var newItem = JSON.parse(JSON.stringify(item));
                newItem.selected = false;
                return newItem;
            });
    
            this._listbox.deselectAll();
            this._syncValueText();
        },
    
        deselect: function (item) {
            // item可以是数字也可以id的字符串
            if (typeof item === 'number') {
                this.selectData[item].selected = false;
            } else {
                this.selectData.forEach(function(e) {
                    if (e[self.valueField] === item) {
                        e.selected = false;
                    }
                });
            }
    
            this._listbox.deselect(item);
            this._syncValueText();
        },
    
        // 参数autoLoad用于强制加载数据
        setUrl: function(url, autoLoad) {
            this.getPopup();

            if (!this.autoLoad && !autoLoad) {
                this.url = url;
                this.isLoaded = false;
            } else {
                this._listbox.setUrl(url);
                this.url = this._listbox.url;
                this.data = this._listbox.data;
                this.selectData = this.data.map(function(item) {
                    var newItem = JSON.parse(JSON.stringify(item));
                    newItem.selected = false;
                    return newItem;
                });

                this.doDataChange();
            }
        },

        load: function(data) {
            if (!data) {
                data = this.url;
            }

            if (typeof data === 'string') {
                // 强制加载数据
                this.setUrl(data, true);
            } else {
                this.setData(data);
            }
        },

        setData: function (data) {
            if (typeof data == "string") {
                data = this._eval(data);
                //data = eval('(' + data + ')');
                //data = mini._getMap(data, window);
    
            }
            if (!mini.isArray(data)) data = [];
            this._listbox.setData(data);
            this.data = this._listbox.data;
    
            this.selectData = this.data.map(function(item) {
                var newItem = JSON.parse(JSON.stringify(item));
                newItem.selected = false;
                return newItem;
            });
            //        var v = this._listbox.getValue();
            //        this.setValue(v);
    
            this.doDataChange();
            //        var vts = this._listbox.getValueAndText(this.value);
            //        this.text = this._textEl.value = vts[1];
            //        this.setValue(vts[0]);
        },

        setAutoLoad: function(autoLoad) {
            this.autoLoad = !!autoLoad;
        },
        getAutoLoad: function() {
            return this.autoLoad;
        },

        setValue: function(value) {
            if (mini.isNull(value)) value = '';
            var vts = this._listbox.getValueAndText(value),
                items = this._listbox.findItems(value);
            var v = vts[0],
                text = vts[1];
            if (text === '' || mini.isNull(text)) text = value;

            if (this.valueFromSelect && (v === '' || mini.isNull(v))) {
                if (!this.isLoaded) {
                    this._temporaryValue = value;
                }

                value = text = '';
            } else {
                this._temporaryValue = '';
            }

            this.value = value;
            this._valueEl.value = this.value;
            this.setText(text);

            if (this.multiLabel) {
                this._renderLabel();
            }
            this._listbox.setValue(value);
        },
        setText: function(value) {
            if (value === null || value === undefined) value = '';

            // 安全整改要求，服务端返回数据是对html编码的，但是提交时需要还原成正常的html标签
            value = mini.htmlDecode(value);

            var fire = this.text !== value;
            this.text = value;
            this._textEl.value = value;

            this._doEmpty();
        },
        doDataChange: function() {
            var vts = this._listbox.getValueAndText(this.value || this._temporaryValue);
            var value = vts[0],
                text = vts[1];

            if (value === '' && !this.clearOnLoad) {
                value = this.value;
                text = this.text;

                this.value = null;
            }

            this.text = this._textEl.value = text;
            this.setValue(value);

            this.isLoaded = true;
        },

        getSelecteds: function () {
            var valueArr = this.getValue().split(',');
            var items = [];
    
            if (this.getValue() === '') {
                for (var i = 0; i < this.selectData.length; i++) {
                    this.selectData[i].selected = false;
                }
            } else {
                // 遍历selectData，返回selected为true的项
                for (var i = 0; i < this.selectData.length; i++) {
                    if (this.selectData[i].selected) {
                        items.push(this.selectData[i]);
                    } else {
                        for (var j = 0; j < valueArr.length; j++) {
                            if (this.selectData[i][this.valueField] === valueArr[j]) {
                                this.selectData[i].selected = true;
                                items.push(this.selectData[i]);
                            } else if (!this.selectData[i].hasOwnProperty('selected')) {
                                this.selectData[i].selected = false;
                            } 
                        }
                    } 
                }
            }
            
            return items;
        },
    
        getSelected: function () {
            return this.getSelecteds()[0];
        },
    
        // 返回所有已选择项的value和text的数组，例如['value1,value2', 'text1,text2']
        _getValueAndText: function () {
            var value = [],
                text = [],
                vts = [];
    
            // 遍历selectData，将所有selected为true的项的id和text值进行拼接
            for (var i = 0; i < this.selectData.length; i++) {
                if (this.selectData[i].selected) {
                    value.push(this.selectData[i][this.valueField]);
                    text.push(this.selectData[i][this.textField]);
                }
            }
    
            vts[0] = value.join(',');
            vts[1] = text.join(',');
    
            return vts;
        },

        __OnItemClick: function (e, fire) {

            var ev = { item: e.item, cancel: false };
    
            if (fire !== false) {
                this.fire("beforeitemclick", ev);
                if (ev.cancel) return;
            }
            
            var items = this._listbox.getSelecteds();
    
            var vts = this._listbox.getValueAndText(items);
    
            var listboxData = this._listbox.getData();
    
            var value = this.getValue();
            this._oldValue = value;
    
            // data新增一个selected属性来区分是否勾选
            for (var i = 0; i < this.data.length; i++) {
                if (items.indexOf(this.data[i]) === -1) {
                    if (this.data[i] && listboxData.indexOf(this.data[i]) !== -1) {
                        this.selectData[i] && (this.selectData[i].selected = false);
                    }                
                } else {                
                    this.selectData[i] && (this.selectData[i].selected = true);
                }
            }
    
            // 如果是搜索模式的话，需要将selectData中的选择的数据拼接，否则只需要拼接_listbox中选择的
            if (this._listbox._filterKey) {
                var newVts = this._getValueAndText();
                
                this.setValue(newVts[0]);
                this.setText(newVts[1]);
            } else {
                this.setValue(vts[0]);
                this.setText(vts[1]);
            }
    
            //        if (mini.isFirefox) {   //FF下修改textEl.value，会激发changed...
            //            this.blur();
            //            this.focus();
            //        }
    
            if (e) {
                if (fire !== false) {
                    if (value != this.getValue()) {
                        var sf = this;
                        setTimeout(function () {
                            sf._OnValueChanged();
                        }, 1);
                    }
    
                    if (!this.multiSelect) {
                        this.hidePopup();
                    }
                    if (!isMobile) {
                        this.focus();
                    }
    
    
                    this.fire("itemclick", { item: e.item });
                }
            }
        },
        __OnInputTextChanged: function(e) {
            if (this.isShowPopup()) {
                this._textChanged = true;
                return;
            }

            this._textChanged = false;

            this._oldValue = this.getValue();

            if (this.multiSelect === false) {
                var text = this._textEl.value;
                //valueFromSelect

                //根据text找，必须全部匹配，自动选择
                var data = this.getData();
                var selected = null;
                for (var i = 0, l = data.length; i < l; i++) {
                    var item = data[i];
                    // 由于存在html转义，需用listbox.getItemText方法获取text
                    var itemText = this._listbox.getItemText(item);
                    var itemValue = item[this.valueField];
                    if (itemText == text) {
                        if (mini.isNull(this.value) || this.value === '' || this.value == itemValue) {
                            selected = item;
                            break;
                        }
                    }
                }
                if (selected) {
                    this._listbox.setValue(selected ? selected[this.valueField] : '');

                    var v = this._listbox.getValue();
                    var vts = this._listbox.getValueAndText(v);

                    var value = this.getValue();

                    this.setValue(v);
                    this.setText(vts[1]);
                } else {
                    if (this.valueFromSelect) {
                        this.setValue('');
                        this.setText('');
                    } else {
                        this.setValue(text);
                        this.setText(text);
                    }
                }
                if (value != this.getValue()) {
                    var sf = this;
                    sf._OnValueChanged();
                }
            }

        },
        getExtraAttrs: function(el) {
            var attrs = {};

            mini._ParseBool(el, attrs, ['autoLoad']);

            return attrs;
        }
    };
});

mini.addEpointExt('DataGrid', function () {
    // 功能扩展
    (function ($) {
        var oldFn = mini.GridView.prototype._createPagers;
        //  设置默认分页为  pagination
        mini.overwrite(mini.DataGrid, {
            pagerType: 'pagination',

            _createPagers: function () {
                oldFn.apply(this, arguments);

                if (this.pagerType !== 'pager') {
                    this.setPagerType(this.pagerType);
                }
            }
        });

        // grid-emptyText 位置计算
        var oldCreateRowsHTML = mini.FrozenGridView.prototype._createRowsHTML;
        mini.FrozenGridView.prototype._createRowsHTML = function () {
            var returnValue = oldCreateRowsHTML.apply(this, arguments);

            var h = parseInt($(this.el).find('.mini-grid-rows-view').height(), 10);
            if (h && h > 200) {
                h = (h * 0.3) >> 0;
                var $el = $(returnValue);
                $el.find('.mini-grid-emptyText').css({
                    // 16px + 48px + 8px
                    paddingTop: h + 80,
                    backgroundPosition: 'center ' + h + 'px'
                });
                return $el[0].outerHTML;
            }

            return returnValue;
        };

        // 新 UI 适配边框
        var oldSetShowVGridLines = mini.DataGrid.prototype.setShowVGridLines;
        var oldSetShowHGridLines = mini.DataGrid.prototype.setShowHGridLines;
        mini.DataGrid.prototype.setShowVGridLines = function (show) {
            var returnValue = oldSetShowVGridLines.apply(this, arguments);

            if (show) {
                $(this.el).addClass('mini-grid-showVGridLines');
            } else {
                $(this.el).removeClass('mini-grid-showVGridLines');
            }
            return returnValue;
        };
        mini.DataGrid.prototype.setShowHGridLines = function (show) {
            var returnValue = oldSetShowHGridLines.apply(this, arguments);

            if (show) {
                $(this.el).addClass('mini-grid-showHGridLines');
            } else {
                $(this.el).removeClass('mini-grid-showHGridLines');
            }
            return returnValue;
        };

        // 表格边框配置 应用后 适配 class 直接作为默认值的情况下 不会走上面重写的set方法
        function adaptDefaultGridLines() {
            if (this.showHGridLines) {
                $(this.el).addClass('mini-grid-showHGridLines');
            } else {
                $(this.el).removeClass('mini-grid-showHGridLines');
            }
            if (this.showVGridLines) {
                $(this.el).addClass('mini-grid-showVGridLines');
            } else {
                $(this.el).removeClass('mini-grid-showVGridLines');
            }
        }

        // 去掉 datagrid 上低性能的 CellToolTip 插件
        mini._Grid_CellToolTip.prototype.destroy = function () {
            mini.un(this.owner.el, 'mousemove', this.__OnGridMouseMove, this);
        };

        mini.DataGrid.prototype._afterApply = function () {
            // 表格边框 初始化适配
            adaptDefaultGridLines.apply(this, arguments);
            // 去掉 CellToolTip 插件 使用简单的方式
            if (this._CellToolTip && this._CellToolTip.destroy) {
                this._CellToolTip.destroy();

                var self = this;
                this.on('update', addCellTip, this);
                this.on('updaterow', addCellTip, this);
                this.on('cellbeginedit', addCellTip, this);
                this.on('expand', function (e) {
                    setTimeout(function () {
                        addCellTip.call(self, e);
                    }, 500);
                });
                this.on('collapse', function (e) {
                    setTimeout(function () {
                        addCellTip.call(self, e);
                    }, 500);
                });
            }
        };
        /**
         * 新的...效果
         *
         */
        function addCellTip(e) {
            var self = this;
            if (this.showCellTip !== true) return;
            var target = this._contentEl;
            if (e.record) {
                target = this.getRowEl(e.record);
                // 固定列的需要将固定列也加上
                if (this.isFrozen()) {
                    target = [target, this.getRowEl(e.record, 1)];
                }
            }
            // tree treegrid
            if (this.type === 'treegrid' || this.type == 'pagertree') {
                $(target)
                    .find('.mini-tree-nodetext')
                    .each(function (i, el) {
                        el.title = (el.textContent || el.innerText).replace(/^\s+|\s+$|[\r\n]/gm, '');
                    });
            }
            // datagrid
            $(target)
                .find('.mini-grid-cell-inner')
                .add($(this._columnsEl).find('.mini-grid-headerCell-inner'))
                .each(function (i, el) {
                    if ($(el).parent().hasClass('mini-tree-treecell')) {
                        return;
                    }
                    if ($(el).parent().hasClass('mini-actioncolumn-cell')) {
                        return;
                    }
                    el.title = (el.textContent || el.innerText).replace(/^\s+|\s+$|[\r\n]/gm, '');
                });
            // 排序图标
            $(this._columnsEl)
                .find('.mini-grid-sortIcon:not([title]),.mini-grid-allowsort:not([title])')
                .each(function (i, el) {
                    el.title = epoint_local.click_to_sort_text;
                });
        }

        // miniui grid _errorToolTip
        $(function () {
            mini.grid_error_toolTip = new mini.ToolTip();
            mini.grid_error_toolTip.set({
                selector: '.mini-grid-cell-error',
                placement: 'top',
                trigger: 'hover',
                // cls: 'error-tooltip'
                theme: 'error',
                autoHide: true,
                defaultTheme: 'error',
                onbeforeopen: function (e) {
                    // 获取错误 内容
                    var cellId = e.element.getAttribute('id');
                    var grid = mini.getAndCreate($(e.element).closest('.mini-grid')[0]);
                    if (cellId && grid) {
                        cellId = cellId.replace('$cell$', '$');
                        var error = grid._cellMapErrors && grid._cellMapErrors[cellId];
                        if (error) {
                            e.content = error.errorText;
                            e.cancel = false;
                        }
                    }
                }
            });
        });
    })(window.jQuery);

    // 表头过滤
    (function (win, $) {
        /**
         * 表格列筛选
         *
         * @param {object} options 相关配置
         */
        function HeaderFilter(options) {
            if (!options) {
                throw new Error('options is required');
            }
            var grid = options.grid;
            if (grid + '' === grid) {
                grid = mini.get(grid);
            }
            if (grid && mini.isControl(grid)) {
                this.grid = grid;
            } else {
                throw new Error('必须配置表格');
            }
            this._events = {};
            this.options = $.extend({}, HeaderFilter.defaultOptions, options);
            if (!~['server', 'client'].indexOf(this.options.filterMode)) {
                window.console && console.error(this._logPrefix, '[filterMode] must be one of "server" or "client"');
                this.options.filterMode = 'client';
            }
            this.onFilter = this.options.onFilter;
            delete this.options.onFilter;
            this.init();
        }
        HeaderFilter.defaultOptions = {
            // 翻页 重新加载数据时 是否保留过滤效果
            keepFilter: true,
            // 启用过滤的列
            columns: [],
            // 过滤模式
            filterMode: 'client',
            // 过滤时触发
            onFilter: function () {}
        };
        $.extend(HeaderFilter.prototype, {
            on: mini.Control.prototype.on,
            fire: mini.Control.prototype.fire,
            un: mini.Control.prototype.un,
            findListener: mini.Control.prototype.findListener,
            _logPrefix: '[HeaderFilter]',
            __genderId: (function () {
                var i = 0;
                return function () {
                    return 'HeaderFilter-' + i++;
                };
            })(),
            init: function () {
                if (this.grid.__headerFilter) {
                    try {
                        this.grid.__headerFilter.destroy();
                    } catch (error) {}
                }
                this._id = this.__genderId();
                this._columnControls = [];
                this.setColumns(this.options.columns);

                this.grid.on('headercellclick', this.__handleFilterClick, this);

                this.grid.on('columnschanged', this.__handleGridColumnChanged, this);
                this.grid.on('update', this.__handleGridUpdate, this);

                // setData和翻页加载数据均会触发 在此内部进行再次过滤即可
                this.grid._dataSource.on('loaddata', this.__handleNewData, this);

                this.grid.__headerFilter = this;

                this.fire('init');
            },
            destroy: function () {
                this.clearFilter();
                this.__clearOldColumns();

                $(this.grid.el).find('.mini-datagrid-headerfilter-trigger').remove();

                this.grid.un('headercellclick', this.__handleFilterClick, this);

                this.grid.un('columnschanged', this.__handleGridColumnChanged, this);
                this.grid.un('update', this.__restoreFilterStatus, this);

                // setData和翻页加载数据均会触发 在此内部进行再次过滤即可
                this.grid._dataSource.un('loaddata', this.__handleNewData, this);
                this.grid.__headerFilter = null;
                delete this.grid.__headerFilter;
            },
            /**
             * 处理新数据
             * 如需要过滤 则对新数据也进行处理
             */
            __handleNewData: function () {
                // console.log('loaddata');
                if (!this.options.keepFilter) {
                    this.clearFilter();
                    return this;
                }

                var hasFilter = false;
                var that = this;
                $.each(this.filterColumns, function (i, column) {
                    var col = that.filterColumnCfgMap[column.name];
                    if (col.__filterChecked && col.__filterChecked.length) {
                        hasFilter = true;
                        return false;
                    }
                });

                if (hasFilter) {
                    this.__doFilter();
                }
                return this;
            },
            __handleGridColumnChanged: function () {
                // 列change的时候 dom 还未更新 miniui 源码中 setTimeout 了两次 。。。。
                // 此时更新都是无效的。。。
                // 真是的dom更新最终会导 update 中 此处用变量标记更新是否是由于列改变
                // 由于 setTimeout 的不确定性 可能并不准确
                this.__gridColumnChanged = true;
            },
            __doGridColumnChanged: function () {
                // this.clearFilter();
                // 缓存列筛选值
                var storeMap = {};
                var config = this.filterColumnCfgMap;
                Object.keys(config).forEach(function (key) {
                    storeMap[key] = config[key].__filterChecked;
                });
                this.__clearOldColumns();
                // 清理控件 列筛选创建的控件
                $.map(this._columnControls, function (ctr) {
                    ctr.destroy && ctr.destroy(true);
                });
                this._columnControls = [];

                this.setColumns(this.options.columns);

                // 还原值
                var newConfig = this.filterColumnCfgMap;
                Object.keys(newConfig).forEach(function (key) {
                    if (storeMap[key]) {
                        newConfig[key].__filterChecked = storeMap[key];
                    }
                });
                newConfig = config = null;
            },
            __handleGridUpdate: function (e) {
                if (this.__gridColumnChanged === undefined) {
                    this.__restoreFilterStatus(e);
                    // if (this.options.filterMode === 'client' && this.__gridColumnChanged === undefined) {
                    return;
                }
                // 先处理列变更
                if (this.__gridColumnChanged) {
                    this.__doGridColumnChanged(e);
                    this.__gridColumnChanged = undefined;
                }

                this.__restoreFilterStatus(e);
            },
            __handleFilterClick: function (ev) {
                var e = ev.htmlEvent;
                var $target = $(e.target);
                if ($target.hasClass('mini-datagrid-headerfilter-trigger')) {
                    e.stopPropagation();
                    var column = ev.column;
                    if ($target.hasClass('show')) {
                        $target.removeClass('show');
                        this.hideColumnFilter(column);
                    } else {
                        $target.addClass('show');
                        this.showColumnFilter(column, e.target);
                        // this.showColumnFilter(column, this.__getHeaderElByTrigger(e.target));
                    }
                }
            },
            __getHeaderElByTrigger: function (trigger) {
                return $(trigger).closest('.mini-grid-headerCell')[0];
            },
            setColumns: function (columns) {
                var c = $.isArray(columns) ? columns : [];

                var filterColumns = [];
                var filterColumnMap = {};
                var filterColumnCfgMap = {};
                var grid = this.grid;
                var that = this;
                var filterMode = this.options.filterMode;

                $.each(c, function (i, item) {
                    if (!item || !item.name || (filterMode == 'client' && typeof item.filterMethod !== 'function')) {
                        window.console && console.error(that._logPrefix, item, ' is not a valid filter column');
                        return;
                    }
                    var column = grid.getColumn(item.name);
                    if (column) {
                        if (!/mini-grid-headertxt/.test(column.header)) {
                            column.header =
                                '<span class="mini-grid-headertxt is-existed-filter">' + column.header + '</span>';
                        } else if (!/is-existed-filter/.test(column.header)) {
                            column.header = column.header.replace(
                                'mini-grid-headertxt',
                                'mini-grid-headertxt is-existed-filter'
                            );
                        }
                        if (!/mini-datagrid-headerfilter-trigger/.test(column.header)) {
                            column.header +=
                                '<span class="mini-datagrid-headerfilter-trigger action-icon icon-filter" title="' +
                                epoint_local.click_to_filter_text +
                                '">️</span>';
                        }
                        if (column.inited) {
                            // 初始化过的则需要加元素
                            var headerEl = grid.getHeaderCellEl(column);
                            var $innerEl = $(headerEl).find('.mini-grid-headerCell-inner');
                            var $icon = $(
                                '<span class="mini-datagrid-headerfilter-trigger action-icon icon-filter" title="' +
                                    epoint_local.click_to_filter_text +
                                    '">️</span>'
                            );

                            if (!$innerEl.find('> .mini-datagrid-headerfilter-trigger').length) {
                                if ($innerEl.children().length) {
                                    var $headerTxt = $innerEl.find('.mini-grid-headertxt');
                                    $headerTxt.length > 0 ? $icon.insertAfter($headerTxt) : $icon.insertBefore($innerEl.children().eq(0));
                                } else {
                                    $icon.appendTo($innerEl);
                                }
                            }
                        }
                        // 记录当前过滤的已选值
                        item.__filterChecked = [];
                        filterColumns.push(column);
                        filterColumnMap[column.name] = column;
                        filterColumnCfgMap[column.name] = item;
                    } else {
                        window.console && console.error(that._logPrefix, "can't find column that named " + item.name);
                    }
                });

                this.filterColumns = filterColumns;
                this.filterColumnMap = filterColumnMap;
                this.filterColumnCfgMap = filterColumnCfgMap;

                return this;
            },
            __clearOldColumns: function () {
                // var that = this;
                $.map(this.filterColumnCfgMap, function (col) {
                    col.__filterChecked = [];
                    if (col.popup) {
                        col.popup.destroy && col.popup.destroy();
                        col.popup = null;
                    }
                });
                this.filterColumns = [];
                this.filterColumnMap = {};
                this.filterColumnCfgMap = {};
            },
            showColumnFilter: function (column, el) {
                var filterPopup = this.__renderColumnFilter(column);
                var headerEl = el ? el : this.grid.getHeaderCellEl(column);
                filterPopup.popupEl = headerEl;
                [].some &&
                    mini.getChildControls(filterPopup).some(function (ctr) {
                        if (ctr.type == 'panel') {
                            ctr.setMaxHeight(window.innerHeight - 120);
                            return true;
                        }
                    });
                filterPopup.showAtEl(headerEl);
            },
            hideColumnFilter: function (column) {
                var columnCfg = this.filterColumnCfgMap[column.name];
                columnCfg.popup && columnCfg.popup.hide();
            },
            /**
             * 还原表头的筛选状态  miniui filter 方法
             */
            __restoreFilterStatus: function () {
                var that = this;
                $.map(this.filterColumns, function (column) {
                    var colCfg = that.filterColumnCfgMap[column.name];
                    var $trigger = $(that.grid.getHeaderCellEl(column)).find('.mini-datagrid-headerfilter-trigger');
                    if (colCfg.__filterChecked && colCfg.__filterChecked.length) {
                        $trigger.addClass('active');
                    } else {
                        $trigger.removeClass('active');
                    }
                });
                return this;
            },
            __renderColumnFilter: function (column) {
                var columnCfg = this.filterColumnCfgMap[column.name];

                return this.__createPopupPanel(columnCfg, column);
            },
            __createPopupPanel: function (columnCfg, column) {
                var that = this;
                var filterList = !columnCfg.filterMultiple
                    ? [
                          {
                              id: '',
                              text: epoint_local.all_text
                          }
                      ].concat(columnCfg.filters)
                    : columnCfg.filters;

                if (columnCfg.popup) {
                    return columnCfg.popup;
                }

                var maxChatCount = Math.min(
                    12,
                    Math.max.apply(
                        Math,
                        $.map(filterList, function (item) {
                            return (item.text || item.id).length;
                        })
                    )
                );
                // 筛选列表
                var listBox = (columnCfg.listBox = new mini.ListBox());
                this._columnControls.push(listBox);
                listBox.set({
                    showCheckBox: columnCfg.filterMultiple,
                    multiSelect: columnCfg.filterMultiple,
                    data: filterList
                });
                $(listBox._borderEl).css({
                    borderWidth: 0
                });

                var ratio = mini.getFontSizeRatio() || 1;
                var minWidth = Math.ceil((16 * 2 * ratio + 14 * 2 * ratio + 2) * 2 + 16 * ratio + 20);

                if (minWidth < 160) {
                    minWidth = 160;
                }

                // popup
                var popup = (columnCfg.popup = new mini.Popup());
                // popup.set({ maxHeight: window.innerHeight - 120});
                this._columnControls.push(popup);
                popup.addCls('mini-datagrid-headerfilter-popup');

                var panel = new mini.Panel();
                this._columnControls.push(panel);

                // 取字符和列宽的较大值
                var panelW = Math.max(maxChatCount * 20, column.pxWidth);
                if (columnCfg.filterMultiple && panelW < minWidth) {
                    panelW = minWidth;
                }
                panel.set({
                    // width: column.pxWidth && column.pxWidth > 50 ? column.pxWidth : 50,
                    // minWidth: 50,
                    maxWidth: 400,
                    width: panelW,
                    showToolbar: false,
                    showFooter: columnCfg.filterMultiple,
                    showHeader: false,
                    maxHeight: window.innerHeight - 120
                });
                if (columnCfg.filterMultiple) {
                    panel.set({
                        minWidth: minWidth
                    });
                }
                popup.on('Open', function () {
                    var checked = columnCfg.__filterChecked;
                    var value = checked.join(',');
                    listBox.setValue(value);
                    if (!columnCfg.filterMultiple && !value) {
                        listBox.setSelected(listBox.data[0]);
                    }
                });
                popup.on('close', function () {
                    that.clearFilterState(column, 'show');
                });
                columnCfg.popup.render(document.body);
                panel.render(columnCfg.popup.el);
                listBox.render(panel._bodyEl);

                if (columnCfg.filterMultiple) {
                    // 按钮
                    var okBtn = new mini.Button();
                    var cancelBtn = new mini.Button();
                    this._columnControls.push(okBtn, cancelBtn);
                    okBtn.set({
                        text: epoint_local.search_text,
                        disableMultiClick: false,
                        onclick: function () {
                            that.doFilter(listBox.getValue(), column);
                            popup.hide();
                        }
                    });
                    okBtn.addCls('mini-btn-primary');

                    cancelBtn.set({
                        text: epoint_local.reset_text,
                        disableMultiClick: false,
                        onclick: function () {
                            listBox.setValue('');
                            that.clearFilter(column);
                            popup.hide();
                        }
                    });
                    okBtn.render(panel._footerEl);
                    cancelBtn.render(panel._footerEl);
                    $(panel._footerEl).css('text-align', 'center');
                } else {
                    // 单选时 就无需确定之类的按钮了直接在点击时进行搜索即可
                    listBox.on('itemclick', function (e) {
                        if (e.item.id === '') {
                            that.clearFilter(column);
                        } else {
                            that.doFilter(listBox.getValue(), column);
                        }
                        popup.hide();
                    });
                }

                return columnCfg.popup;
            },
            __buildFilterParams: function () {
                var p = {};
                var e = {
                    sender: this,
                    grid: this.grid,
                    condition: p
                };
                for (var name in this.filterColumnCfgMap) {
                    if (Object.prototype.hasOwnProperty.call(this.filterColumnCfgMap, name)) {
                        var columnCfg = this.filterColumnCfgMap[name];
                        if (columnCfg.__filterChecked && columnCfg.__filterChecked.length) {
                            p[name] = columnCfg.__filterChecked.join(',');
                        }
                    }
                }
                return e;
            },
            /**
             * 对某列进行 过滤
             *
             * @param {string|string []} value 过滤已选值（列表）
             * @param {mini.DataGrid.Column} column 表格列
             * @returns
             */
            doFilter: function (value, column) {
                if (value) {
                    var columnCfg = this.filterColumnCfgMap[column.name];
                    columnCfg.__filterChecked = $.isArray(value) ? value : value.split(',');
                    var headerCellEl = this.grid.getHeaderCellEl(column);
                    var $trigger = $(headerCellEl).find('.mini-datagrid-headerfilter-trigger');
                    if (columnCfg.__filterChecked.length) {
                        $trigger.addClass('active');
                    } else {
                        $trigger.removeClass('active');
                    }
                    this.__doFilter();

                    var e = this.__buildFilterParams();
                    this.onFilter(e);
                    this.fire('filter', e);
                    return this;
                } else {
                    this.clearFilter(column);
                }
            },
            __doFilter: function () {
                if (this.options.filterMode !== 'client') {
                    return this;
                }
                var filterColumns = this.filterColumns;
                var me = this;

                this.grid.filter(function (record) {
                    // 当前行中进行检查 仅当每一列都符合时 此条记录才符合
                    return filterColumns.every(function (column) {
                        // 不可见则直接条件无效 全为true
                        if (!column.visible) return true;

                        var cfg = me.filterColumnCfgMap[column.name];
                        // 配置的过滤方法
                        var filterFn = cfg.filterMethod;

                        var checkedArr = cfg.__filterChecked;
                        if (!checkedArr || !checkedArr.length) return true;

                        var isMatch = false;
                        // 遍历当前列的每个选中 任意一个选中即可
                        for (var i = 0, len = checkedArr.length; i < len; i++) {
                            isMatch = filterFn.apply(me, [checkedArr[i], record, column, me.grid, me]);
                            if (isMatch) break;
                        }

                        return isMatch;
                    });
                });
            },
            /**
             * 清空（全部/某列）上的 filter 效果 和状态
             *
             * @param {mini.DataGrid.Column} column 表格列
             * @returns
             */
            clearFilter: function (column) {
                this.clearFilterState(column);
                var that = this;

                if (!column) {
                    $.each(this.filterColumns, function (i, c) {
                        var colCfg = that.filterColumnCfgMap[c.name];
                        colCfg.__filterChecked = [];
                    });
                    this.grid.clearFilter();

                    var e = this.__buildFilterParams();
                    this.onFilter(e);
                    this.fire('filter', e);

                    return this;
                }

                this.doFilter([], column);
                return this;
            },
            /**
             * 清除表格头部的过滤dom状态
             *
             * @param {undefined|mini.DataGrid.Column|mini.DataGrid.Column []} column 指定的表格列
             * @param {undefined|string} cls 要清除的 class
             */
            clearFilterState: function (column, cls) {
                var columns;
                if (!column) {
                    columns = this.filterColumns;
                } else if ($.isArray(column)) {
                    columns = column;
                } else {
                    columns = [column];
                }
                var that = this;
                $.map(columns, function (col) {
                    that.__clearFilterState(col, cls);
                });

                return this;
            },
            __clearFilterState: function (column, cls) {
                var colCfg = this.filterColumnCfgMap[column.name];
                if (colCfg.popup && colCfg.popup.isPopup) {
                    colCfg.popup.hide();
                }
                var headerCellEl = this.grid.getHeaderCellEl(column);
                $(headerCellEl)
                    .find('.mini-datagrid-headerfilter-trigger')
                    .removeClass(cls ? cls : 'show active');
                return this;
            }
        });

        mini.DataGrid.HeaderFilter = HeaderFilter;
    })(window, window.jQuery);

    // 列显隐
    (function (win, $) {
        function obj2arr(obj) {
            var hasOwnProperty = Object.prototype.hasOwnProperty;
            var arr = [];
            for (var k in obj) {
                if (hasOwnProperty.call(obj, k)) {
                    arr.push([k, obj[k]]);
                }
            }
            return arr;
        }
        /**
         *    @type savedColumn = {
         *        visible: boolean;
         *        field?: string;
         *        type?: string;
         *    };
         */

        /**
         * 表格列显隐插件
         * 1、 获取表格列
         * 2、 取本地存储
         * 3、 有本地的记录 则更新表格显示隐藏
         * 4、 无本地记录则 无需处理
         * @param {
         *  {
         *      grid: string | mini.dataGrd, // 表格id dom 或 对象
         *      trigger: undefined | string | HTMLElement | jQueryObject, // 按钮元素 可为选择器、 dom对象或 jq对象 不配置的情况下，若 autoCreate 开启会自动创建
         *      autoCreate: boolean,
         *      showButton: true,  // 是否显示确定重置按钮
         *      disabledColumns: [] // 禁止用户操作的列
         *  }
         * } options 配置对象
         */
        function GridColumnsHide(options) {
            var opt = $.extend({}, GridColumnsHide.defaultOptions, options);
            this.options = opt;
            var grid = opt.grid;
            if (grid + '' === grid) {
                grid = mini.get(grid);
            }
            if (!grid) {
                throw new Error('必须配置表格！');
            }
            this.grid = grid;

            var trigger = opt.autoCreate ? this.__autoCreateBtn() : $(opt.trigger)[0];

            if (!trigger) {
                window.console && console.warn && console.warn('无法获取触发按钮, 只能通过api显示隐藏');
            }

            this.triggerEl = trigger;

            this._saveKey = 'GRID_COLUMN_VISIBLE-' + this.grid._id + '-' + location.pathname;
            this._id = this.__genderId();

            // 插件所创建的控件
            this.__createControls = [];
            // 表格原始的列状态
            this._originColumns = [];
            // 表格所有列（包括表头、树状结构）
            this._allTreeColumns = [];
            // 表格所有列（包括表头）
            this._allColumns = [];
            // 表格所有列（不包括表头）
            this._allBottomColumns = [];
            // 插件记录的已选列name值或者索引值
            this.checkedArr = [];
            // 插件记录的已选节点（不包括父节点）
            this.checkedNodesArr = [];
            // 插件保存的数据
            this.data = [];
            this.init();
        }
        GridColumnsHide.defaultOptions = {
            // 按钮元素
            trigger: '',
            // 表格id 或表格对象
            grid: '',
            // 自动创建按钮 插入到 fui-toolbar 最后 未配置按钮时生效
            autoCreate: true,
            // 是否显示确定重置按钮
            showButton: true,
            // 禁止用户操作的列
            disabledColumns: [
                {
                    type: 'indexcolumn'
                },
                {
                    type: 'checkcolumn'
                },
                {
                    type: 'checkcolumn'
                }
                // 配置格式 支持如下几个属性 同一个对象内的条件为且 全部符合才会被禁用
                // {
                //     type: '列类型',
                //     index: '列索引',
                //     field: '列字段',
                //     name: '列名称'
                // }
            ],
            // 不会出现在插件中的列
            hiddenColumns: [],
            // 更新表格列触发的事件
            onUpdateGrid: function () {}
        };
        $.extend(GridColumnsHide.prototype, {
            __genderId: (function () {
                var i = 0;
                return function () {
                    return 'GridColumnsHide-' + i++;
                };
            })(),
            popupCls: 'mini-button-popup',
            /**
             * 自动创建一个按钮插入在框架布局的toolbar中
             */
            __autoCreateBtn: function () {
                var $toolbar = $('.fui-toolbar').eq(0);
                if (!$toolbar.length) return false;

                var btn = new mini.Button();
                btn.set({
                    iconCls: 'icon-gear',
                    disableMultiClick: false
                });
                btn.addCls('r');
                btn.render($toolbar[0]);
                var $btn = $(btn.el);
                var $r = $toolbar.find('> .r');
                if ($r.length) {
                    $btn.insertBefore($r);
                } else {
                    $btn.appendTo($toolbar);
                }
                return btn.el;
            },
            init: function () {
                var grid = this.grid;
                this._allTreeColumns = grid.getColumns();
                this._allColumns = mini.treeToArray(this._allTreeColumns, 'columns');
                this._allBottomColumns = grid.getBottomColumns();
                this.__rememberOrigin();
                this.restoreLocal(undefined, true);
                this.__syncCheckColumns();

                var that = this;
                var $trigger = $(this.triggerEl);
                $trigger.on('click.' + this._id, function () {
                    if (!$trigger.hasClass(that.popupCls)) {
                        $trigger.addClass(that.popupCls);
                        that.showPanel();
                    } else {
                        that.hidePanel();
                    }
                });
            },
            destroy: function () {
                $(this.triggerEl).off('click.' + this._id);
                $.each(this.__createControls, function (i, ctr) {
                    ctr.destroy && ctr.destroy(true);
                });
            },
            /**
             * 记住表格的初始状态
             */
            __rememberOrigin: function () {
                var originColumns = [];

                $.each(this._allColumns, function (i, col) {
                    if (!col.columns) {
                        originColumns.push({
                            visible: col.visible,
                            name: col.name
                        });
                    }
                });

                this._originColumns = originColumns;
            },
            /**
             * 还原表格的初始状态
             */
            __restoreOrigin: function () {
                var grid = this.grid;
                var originColumns = this._originColumns;

                $.each(originColumns, function (i, c) {
                    if (c.name) {
                        grid.updateColumn(c.name, c);
                    } else {
                        grid.updateColumn(i, c);
                    }
                });

                // 更新插件记录
                this.setData([]);
                this.__syncCheckColumns();

                this.options.onUpdateGrid();
            },

            /**
             * 从表格上同步列的勾选状态
             * 用于下拉列表中显示勾选状态
             */
            __syncCheckColumns: function () {
                var checkedArr = [];

                $.each(this._allBottomColumns, function (i, col) {
                    if (col.name && col.visible) {
                        checkedArr.push(col.name);
                    } else if (!col.name && col.visible) {
                        checkedArr.push(i);
                    }
                });

                this.checkedArr = checkedArr;
            },
            getLocalData: function () {
                var s = localStorage.getItem(this._saveKey);
                if (!s) return [];
                var data = JSON.parse(s);
                if ($.isPlainObject(data)) {
                    return data;
                }
                return [];
            },
            getData: function () {
                if (!this._listBox) return [];

                var checkedArr = this.checkedArr;
                var data = [];

                $.each(this._allBottomColumns, function (i, col) {
                    var visible = $.inArray(col.name, checkedArr) !== -1 || $.inArray(i, checkedArr) !== -1;
                    var item = {
                        visible: visible
                    };
                    if (col.field) item.field = col.field;
                    if (col.type) item.type = col.type;
                    if (col.name) item.name = col.name;
                    data.push(item);
                });

                return data;
            },
            setData: function (data, formEvent) {
                this.data = $.isArray(data) ? data : [];

                if (formEvent) {
                    var checkedArr = [];
                    $.each(this.data, function (i, c) {
                        if (c.visible) {
                            checkedArr.push(c);
                        }
                    });
                    this.checkedArr = checkedArr;
                }

                if ($.isArray(data) && data.length === 0) {
                    if (!this.popup) {
                        this.__createPopup();
                    }
                    this._listBox.checkAllNodes();
                    this.checkedNodesArr = this._listBox.getCheckedNodes();
                }

                var params = { columnArr: data, checkNodesArr: this.checkedNodesArr };

                localStorage.setItem(this._saveKey, JSON.stringify(params));

                this.restoreLocal(data);
            },
            /**
             * 检查本地存储的列的有效性
             * 表格列除name之外无法唯一缺的，插件以列索引进行纯属
             * 有效性借助 列数目 + 对应列类型 + 对应列字段判断
             *
             * @param {savedColumn []} localData 插件本地存储列
             * @param {mini.DataGrid.Column []} columns 表格列
             * @returns
             */
            __checkColumnsChanged: function (localData, columns) {
                if (!$.isArray(localData) || !$.isArray(columns) || localData.length !== columns.length) {
                    return true;
                }
                var res = false;
                var l, c;

                for (var i = 0, len = localData.length; i < len; i++) {
                    l = localData[i];
                    c = columns[i];
                    if (l.field != c.field || l.type != c.type) {
                        res = true;
                        break;
                    }
                }

                return res;
            },
            /**
             * 还原本地的存储
             *
             * @param {savedColumn [] | undefined} data 插件保存的状态数组
             * @param {boolean} isInit  是否是初始化
             * @returns
             */
            restoreLocal: function (data, isInit) {
                var grid = this.grid;
                var localData = (this.data = data || this.getLocalData().columnArr);
                var gridColumns = this._allBottomColumns;
                if (!localData || !localData.length) {
                    return;
                }
                // 列不一样 则忽略 并清空本地存储 仅需初始化还原时检查
                if (isInit && this.__checkColumnsChanged(localData, gridColumns)) {
                    this.setData([]);
                    return;
                }

                $.map(localData, function (c, index) {
                    if (c.name) {
                        grid.updateColumn(c.name, {
                            visible: c.visible
                        });
                    } else {
                        grid.updateColumn(index, {
                            visible: c.visible
                        });
                    }
                });

                this.options.onUpdateGrid();
            },
            __handleSave: function () {
                this.checkedNodesArr = this._listBox.getCheckedNodes();

                var checkedArr = $.map(this.checkedNodesArr, function (item) {
                    if (item.name) {
                        return item.name;
                    }
                    return parseInt(item._index, 10);
                });

                this.checkedArr = checkedArr;
                var data = this.getData();
                this.setData(data, true);
            },
            /**
             * 获取表格列的列表
             *
             * @returns {{text:String, id: number, enabled: boolean } []}
             */
            getColumnListFromGrid: function () {
                var that = this;
                // bottom列索引
                this.columnIndex = 0;
                var data = $.map(this._allColumns, function (column) {
                    var columnData = {
                        text: getHeaderText(column),
                        id: column._id.toString(),
                        pid: column._pid.toString(),
                        checked: true,
                        visible: true,
                        expanded: true,
                        showCheckBox: true,
                        name: column.name
                    };

                    if (!column.columns) {
                        columnData.enabled = that.__getColumnEnable(column, that.columnIndex);
                        columnData.visible = that.__getColumnVisible(column, that.columnIndex);
                        columnData._index = that.columnIndex;
                        that.columnIndex++;
                    }

                    return columnData;
                });

                if (!this.options.hiddenColumns || !this.options.hiddenColumns.length) {
                    return data;
                }

                return data.filter(function (item, index) {
                    return item.visible;
                });
            },
            __getColumnVisible: function (column, columnIndex) {
                if (!column || !this.options.hiddenColumns || !this.options.hiddenColumns.length) return true;
                return !this.options.hiddenColumns.some(function (col) {
                    var conditions = obj2arr(col);
                    return conditions.every(function (condition) {
                        var k = condition[0];
                        var v = condition[1];
                        if (k === 'index') {
                            return v === columnIndex;
                        }
                        return column[k] === v;
                    });
                });
            },
            __getColumnEnable: function (column, columnIndex) {
                if (!column || !this.options.disabledColumns || !this.options.disabledColumns.length) return true;

                // 列的任一条件满足即被禁用
                return !this.options.disabledColumns.some(function (col) {
                    var conditions = obj2arr(col);
                    // 同一个对象内的配置为且 全部满足时才是命中
                    return conditions.every(function (condition) {
                        var k = condition[0];
                        var v = condition[1];
                        if (k === 'index') {
                            return v === columnIndex;
                        }
                        return column[k] === v;
                    });
                });
            },
            __createPopup: function () {
                if (this.popup) return this.popup;

                var that = this;
                var list = this.getColumnListFromGrid();
                var listBox = new mini.Tree();
                this._listBox = listBox;
                listBox.setShowTreeIcon(false);
                listBox.setShowExpandButtons(false);
                listBox.expandOnDblClick = false;
                listBox.setCheckOnTextClick(true);
                listBox.setExpandOnNodeClick(false);

                listBox.loadList(list, 'id', 'pid');
                this.__createControls.push(listBox);

                var popup = new mini.Popup();
                this.__createControls.push(popup);
                popup.set({
                    minHeight: 15,
                    xAlign: 'right',
                    maxHeight: $('body').height() - 16
                });
                popup.__parent = this;
                popup.el.setAttribute('attached', 'true');
                popup.on('close', function () {
                    $(that.triggerEl).removeClass(that.popupCls);
                });

                // 根据列字符数目计算显示宽度
                var maxCharCount = Math.max.apply(
                    Math,
                    $.map(list, function (item) {
                        return item.text.length;
                    })
                );
                var panelW = Math.max(this.options.showButton ? 180 : 120, 14 * maxCharCount);

                var panel = new mini.Panel();
                this.__createControls.push(panel);
                panel.set({
                    showToolbar: false,
                    showFooter: this.options.showButton,
                    showHeader: false,
                    minWidth: 200,
                    maxWidth: 600,
                    width: panelW,
                    maxHeight: window.innerHeight - 120
                });
                listBox.render(panel._bodyEl);
                panel.render(popup.el);
                // popup.render(document.body);

                if (this.options.showButton) {
                    var okBtn = new mini.Button();
                    var cancelBtn = new mini.Button();
                    this.__createControls.push(okBtn, cancelBtn);
                    okBtn.set({
                        text: epoint_local.save_text,
                        disableMultiClick: false,
                        state: 'primary',
                        onclick: function () {
                            that.__handleSave();
                            popup.hide();
                        }
                    });

                    cancelBtn.set({
                        text: epoint_local.reset_text,
                        disableMultiClick: false,
                        onclick: function () {
                            that.__restoreOrigin();
                            popup.hide();
                        }
                    });
                    okBtn.render(panel._footerEl);
                    cancelBtn.render(panel._footerEl);
                    $(panel._footerEl).css('text-align', 'center');
                } else {
                    // 不显示按钮的情况下 点击直接操作
                    listBox.on(
                        'nodecheck',
                        function () {
                            that.__handleSave();
                            // popup.hide();
                        },
                        this
                    );
                }

                this.popup = popup;

                // 先让其显示，解决初始化时内部 listbox 没有高度而导致的 maxHeight 属性无效问题
                this.popup.showAtPos(-10000, -10000);
                var checkNodesArr = this.getLocalData().checkNodesArr,
                    newCheckNodesArr;

                if (checkNodesArr) {
                    newCheckNodesArr = [];
                    $.each(checkNodesArr, function (i, item) {
                        newCheckNodesArr.push(listBox.getNode(item.id));
                    });
                }

                this.checkedNodesArr = newCheckNodesArr || this._listBox.getCheckedNodes();
            },

            showPanel: function () {
                if (!this.popup) {
                    this.__createPopup();
                    this.popup.popupEl = this.triggerEl;
                }
                this._listBox.uncheckAllNodes();
                this._listBox.checkNodes(this.checkedNodesArr);
                this.popup.showAtEl(this.triggerEl);
            },
            hidePanel: function () {
                if (!this.popup) return;
                this.popup.hide();
            },
            showAtEl: function () {
                if (!this.popup) {
                    this.__createPopup();
                }
                this._listBox.uncheckAllNodes();
                this._listBox.checkNodes(this.checkedNodesArr);
                this.popup.showAtEl.apply(this.popup, arguments);
            },
            showAtPos: function () {
                if (!this.popup) {
                    this.__createPopup();
                }
                this._listBox.uncheckAllNodes();
                this._listBox.checkNodes(this.checkedNodesArr);
                this.popup.showAtPos.apply(this.popup, arguments);
            },
            hide: function () {
                if (!this.popup) return;
                this.popup.hide();
            }
        });

        win.mini.DataGrid.ColumnsHide = GridColumnsHide;

        var headerType2name = {
            indexcolumn: epoint_local.order_text,
            checkcolumn: epoint_local.select_text,
            actioncolumn: epoint_local.operate_text
        };
        var clearEl = document.createElement('div');

        function getHeaderText(column) {
            var h = column.header;
            if (h && typeof h === 'string') {
                clearEl.innerHTML = h;
                return $.trim(clearEl.textContent || clearEl.innerText);
            }
            if (column.type) {
                return headerType2name[column.type] || '';
            }
            return '';
        }
    })(window, window.jQuery);

    // 覆写表头排序点击触发源的判断，解决排序图标点击无反应问题
    mini._Grid_Sorter.prototype.__OnGridHeaderCellClick = function (e) {
        var grid = this.owner;

        var type = e.htmlEvent.type;
        if (type == 'dblclick' && !grid.sortDblClick) return;
        if (type == 'click' && grid.sortDblClick) return;

        if (/mini-grid-headerCell-inner|mini-grid-sortIcon|mini-grid-allowsort/.test(e.htmlEvent.target.className)) {
            if (grid.allowSortColumn && grid.isEditing() == false) {
                var column = e.column;
                if (!column.columns || column.columns.length == 0) {
                    var sortField = column.sortField || column.field;

                    if (sortField && column.allowSort !== false) {
                        if (grid.allowCancelSort && grid.getSortOrder() == 'desc') {
                            grid.clearSort();
                        } else {
                            var sortOrder = 'asc';
                            if (grid.getSortField() == sortField) {
                                sortOrder = grid.getSortOrder() == 'asc' ? 'desc' : 'asc';
                            }

                            grid.sortBy(sortField, sortOrder);
                        }
                    }
                }
            }
        }
    };
    var beginEditRow = mini.DataGrid.prototype.beginEditRow;
    var cancelEditRow = mini.DataGrid.prototype.cancelEditRow;
    return {
        // 表格斑马纹
        allowAlternating: mini.getCtrDefaultBySysParams('gridAllowAlternating', false),
        // 表格水平线
        showHGridLines: mini.getCtrDefaultBySysParams('gridShowHGridLines', true),
        // 表格垂直线
        showVGridLines: mini.getCtrDefaultBySysParams('gridShowVGridLines', false),
        // 表格允许排序
        showSortIcon: mini.getCtrDefaultBySysParams('gridShowSortIcon', true),
        // 表格调整大小
        allowResize: mini.getCtrDefaultBySysParams('gridAllowResize', false),
        // 表格是否显示空白文案
        showEmptyText: mini.getCtrDefaultBySysParams('gridShowEmptyText', true),
        // 表格空白文案文字
        emptyText: mini.getCtrDefaultBySysParams('gridEmptyText', '暂无数据'),
        // 保持选中状态
        holdSelectedStatus: false,
        // 为了使点击某行单元格后不将其他行选中状态清除，将该属性默认设置为true
        // 该问题oa中又希望将其默认值设置为false，所以将该值改为全局配置，在jsboot中进行配置
        allowUnselect: (window.EpFrameSysParams && EpFrameSysParams.grid_allow_unselect) || false,
        selectMaps: {},
        set: function (kv) {
            if (typeof kv == 'string') {
                return this;
            }

            var value = kv.value;
            delete kv.value;
            var url = kv.url;
            delete kv.url;
            var data = kv.data;
            delete kv.data;
            var columns = kv.columns;
            delete kv.columns;
            var sizeList = kv.sizeList;
            delete kv.sizeList;

            var defaultColumnWidth = kv.defaultColumnWidth;
            delete kv.defaultColumnWidth;
            if (defaultColumnWidth) {
                this.setDefaultColumnWidth(defaultColumnWidth);
            }

            if (!mini.isNull(columns)) {
                this.setColumns(columns);
            }

            mini.DataGrid.superclass.set.call(this, kv);

            if (!mini.isNull(data)) {
                this.setData(data);
            }
            if (!mini.isNull(url)) {
                this.setUrl(url);
            }
            if (!mini.isNull(value)) {
                this.setValue(value);
            }

            if (!mini.isNull(sizeList)) {
                this.setSizeList(sizeList);
            }

            return this;
        },

        // 重写  beginEditRow 、 cancelEditRow
        // 修复 __OnMouseDown 中 滚动表格导致静态编辑第一次点击表格滚动，从而编辑无效的问题
        // xxxxx://fdoc.epoint.com.cn/onlinedoc/kfzknowledge/kfzknowledge/kfzknowledge_detail?rowguid=cf8c8dca-2099-496a-80b7-0dcf32a8aa51&ProcessVersionInstanceGuid=1f58eb88-7b96-42d4-864e-521a48036598
        beginEditRow: function (row) {
            var rv = beginEditRow.apply(this, arguments);
            this._editingCell = [row, this.getColumn(0)];
            return rv;
        },
        cancelEditRow: function () {
            var rv = cancelEditRow.apply(this, arguments);
            this._editingCell = null;
            return rv;
        },

        getColumnData: function (filedName) {
            var data = [],
                rows = this.getData(),
                i = 0,
                l = rows.length;

            for (; i < l; i++) {
                data.push(rows[i][filedName]);
            }

            return data;
        },
        // 安全整改 数据 全部转义 保障显示 需在 input 中正常还原
        _OnCellBeginEdit: function (record, column, editor, initEditor) {
            var value = mini._getMap(column.field, record);
            var obj;
            var e = {
                sender: this,
                rowIndex: this.indexOf(record),
                row: record,
                record: record,
                column: column,
                field: column.field,
                editor: editor,
                value: value,
                cancel: false
            };

            this.fire('cellbeginedit', e);

            if (!mini.isNull(column.defaultValue) && (mini.isNull(e.value) || e.value === '')) {
                var defaultValue = column.defaultValue;
                //            try {
                //
                //                defaultValue = eval('('+defaultValue+')');
                //            } catch (ex) { debugger}
                obj = mini.clone({
                    d: defaultValue
                });
                e.value = obj.d;
            }

            editor = e.editor;
            value = e.value;

            if (e.cancel) {
                return false;
            }
            //if (!editor) return false;
            //column.editor = editor;   //!!!不能加

            if (!editor && column.editMode != 'inline') return false;
            if (column.readOnly === true) return false;

            if (initEditor === false) return true;

            //        if (column.editMode != "inline") {
            //                    var canEdit = this.isCellCanEdit(row, column);

            if (column.editMode != 'inline') {
                //value, text初始化
                if (mini.isNull(value)) value = '';
                if (editor.setValue) {
                    // editor.setValue(value);
                    editor.setValue(mini.htmlUnescape(value));
                }
                editor.ownerRowID = record._uid;

                if (column.displayField && editor.setText) {
                    //var text = record[column.displayField];
                    var text = mini._getMap(column.displayField, record);

                    if (!mini.isNull(column.defaultText) && (mini.isNull(text) || text === '')) {
                        obj = mini.clone({
                            d: column.defaultText
                        });
                        text = obj.d;
                    }

                    // editor.setText(text);
                    editor.setText(mini.htmlUnescape(text));
                }

                if (this.allowCellEdit) {
                    this._editingControl = e.editor;
                }
            }

            return true;
        },
        // 编辑器提交前 对编辑器中内容进行转义 防止html
        _OnCellCommitEdit: function (record, column, value, editor) {
            var e = {
                sender: this,
                rowIndex: this.indexOf(record),
                record: record,
                row: record,
                column: column,
                field: column.field,
                editor: editor ? editor : this.getCellEditor(column),
                value: mini.isNull(value) ? '' : value,
                text: '',
                cancel: false
            };

            if (e.editor && e.editor.getValue) {
                try {
                    e.editor.blur();
                } catch (ex) {}
                e.value = e.editor.getValue();

                //alert(e.value);
            }
            if (e.editor && e.editor.getText) {
                e.text = e.editor.getText();
            }

            //document.title = e.value + ":" + e.text + ":" + new Date().getTime();

            //        this.updateRow(record, { NodeId: 1, NodeName: "aaa" });
            //        return;

            var oldValue = mini._getMap(column.field, record),
                newValue = e.value;
            e.oldValue = oldValue;
            if (mini.isEquals(oldValue, newValue)) return e;

            this.fire('cellcommitedit', e);

            if (e.cancel == false) {
                e.value = mini.htmlEscape(e.value);
                e.text = mini.htmlEscape(e.text);
                if (this.allowCellEdit) {
                    var o = {};
                    o[column.field] = e.value;
                    //mini._setMap(column.field, e.value, o);
                    if (column.displayField) {
                        o[column.displayField] = e.text;
                        //mini._setMap(column.displayField, e.text, o);
                    }
                    this.updateRow(record, o);
                }
            }
            return e;
        },

        // 重写解决刷新数据时 pageIndex 大于 totalPage 的情况下序号不对问题
        _initData: function () {
            this.data = this._dataSource.getSource();
            this.pageIndex = this.getPageIndex();
            this.pageSize = this.getPageSize();
            this.totalCount = this.getTotalCount();
            this.totalPage = this.getTotalPage();
            this.sortField = this.getSortField();
            this.sortOrder = this.getSortOrder();
            this.url = this.getUrl();

            // 当 pageIndex > totalPage 时，说明 pageIndex 不对了，并且生成出来的序号就会超过 totalCount
            // 所以需要把 pageIndex 调整回正确的最大值
            if (this.totalPage > 0 && this.pageIndex > this.totalPage - 1) {
                this.setPageIndex(this.totalPage - 1);
            }

            this._mergedCellMaps = {};
            this._mergedCells = {};

            this._cellErrors = [];
            this._cellMapErrors = {};

            if (this.isGrouping()) {
                this.groupBy(this._groupField, this._groupDir);

                if (this.collapseGroupOnLoad) {
                    this.collapseGroups();
                }
            }
        },
        // 单元格编辑 wrap 位置调整 使得恰好覆盖单元格
        _setEditorBox: function (editor, cellBox) {
            if (editor.setHeight && editor.type == 'textarea') {
                var height = cellBox.height - 2;
                editor.minHeight = height;
                editor.setHeight(height);
            }

            if (editor.setWidth) {
                // 占满情况下 左右边距6px
                var width = cellBox.width - 12;
                // 配置了最小 则使用最小 否则占满
                if (editor.minWidth && width < editor.minWidth) {
                    width = editor.minWidth;
                }
                editor.setWidth(width < 20 ? 20 : width);
            }

            var box = cellBox;
            mini.setXY(this._editWrap, box.x + 1, box.y + 1);

            // 内部编辑器垂直居中
            var pt = (box.height - 2 - jQuery(editor.el).outerHeight()) / 2;
            if (pt >= 0) {
                pt += 'px';
            } else {
                pt = '';
            }
            this._editWrap.style.paddingTop = pt;

            // wrap 恰好铺满单元格
            mini.setWidth(this._editWrap, box.width - 2);
            mini.setHeight(this._editWrap, box.height - 2);

            var viewWidth = document.body.scrollWidth;
            if (box.x > viewWidth) {
                mini.setX(this._editWrap, -1000);
            }
        },
        // 数据为空时 取配置的占位字符显示
        _OnDrawCell: function (record, column, rowIndex, columnIndex) {
            var e = mini.DataGrid.superclass._OnDrawCell.apply(this, arguments);

            if (
                column.emptyText &&
                (e.cellHtml === null || e.cellHtml === undefined || e.cellHtml === '' || e.cellHtml == '&nbsp;')
            ) {
                e.cellHtml = column.emptyText;
            }

            return e;
        },
        // 重写解决编辑控件buttonedit的输入框宽度超出了右侧按钮问题
        _OnCellShowingEdit: function (record, column) {
            if (!this._editingControl) return false;

            var cellBox = this.getCellBox(record, column);

            if (cellBox) {
                var viewWidth = document.body.scrollWidth; //mini.getViewportBox().width;
                if (cellBox.right > viewWidth) {
                    cellBox.width = viewWidth - cellBox.left;
                    if (cellBox.width < 10) cellBox.width = 10;
                    cellBox.right = cellBox.left + cellBox.width;
                }
            }

            var e = {
                sender: this,
                rowIndex: this.indexOf(record),
                record: record,
                row: record,
                column: column,
                field: column.field,
                cellBox: cellBox,
                editor: this._editingControl
            };

            this.fire('cellshowingedit', e);

            var editor = e.editor;
            if (editor && editor.setIsValid) {
                editor.setIsValid(true);
            }

            if (cellBox) {
                var editWrap = this._getEditWrap(editor);
                this._editWrap.style.zIndex = mini.getMaxZIndex();

                //        if (editor.setWidth) {
                //            var width = cellBox.width;
                //            if (width < 20) width = 20;
                //            editor.setWidth(width);
                //        }

                //        if (editor.setHeight && editor.type == "textarea") {
                //            var height = cellBox.height - 1;
                //            if (editor.minHeight && height < editor.minHeight) height = editor.minHeight;
                //            editor.setHeight(height);
                //        }
                //        if (editor.setWidth) {
                //            var width = cellBox.width - 1;
                //            if (editor.minWidth && width < editor.minWidth) width = editor.minWidth;
                //            editor.setWidth(width);
                //        }

                this._setEditorBox(editor, cellBox);

                mini.on(document, 'mousedown', this.__OnBodyMouseDown, this);

                if (column.autoShowPopup && editor.showPopup) {
                    editor.showPopup();
                }
            }

            //navEditMode
            if (editor) {
                var value = record[column.field],
                    text = column.displayField ? record[column.displayField] : editor.getText();

                if (this.navEditMode) {
                    editor.keyNavEnabled = !(column.navUpdown !== false);
                }
                editor.setValue(mini.htmlUnescape(value));

                // 懒加载没有对应节点时用 displayField 获取 text
                if (text !== editor.getText()) {
                    editor.setText(text);
                }
                // 解决编辑控件buttonedit的输入框宽度超出了右侧按钮问题
                editor._doInputLayout && editor._doInputLayout();
                //editor.keyNavEnabled = !this.navEditMode && column.navUpdown === false;
            }

            //alert(editor.keyNavEnabled);
        },
        // 重写没有用的 focus
        focus: function () {},

        _tryUpdateScroll: function () {
            //设置一个布尔值，reload成功后取消
            var doUpdate = this._canVirtualUpdate();
            // 对于固定列的情况，为了左右滚动同步，滚动后必须要更新视图
            if (doUpdate || this.isFrozen()) {
                if (this._scrollPaging) {
                    var me = this;
                    //this._doGetScrollPaging = true;
                    this.reload(null, null, function (e) {
                        //me._doGetScrollPaging = false;
                    });
                } else {
                    var sss = new Date();

                    var scrollLeft = this._rowsViewEl.scrollLeft;

                    this._doRemoveRowContent();
                    this.doUpdateRows(); //30条，55ms
                    this.deferLayout(50);

                    //this.doUpdate();
                    //                alert(new Date() - sss);
                    //document.title = scrollLeft;
                    //this._rowsViewEl.scrollLeft = scrollLeft;
                    this._syncScrollOffset(scrollLeft);
                }
            } else {
                //this._doUpdateTopBottom();
            }
        },
        refreshRow: function (row, params) {
            row = row || this.getSelected();
            if (typeof row !== 'object') {
                row = this.getRow(row);
            }
            params = params || {};
            if (!row) {
                console.warn('DataGrid 控件的 refreshRow 方法必须传 row 参数！');
                return;
            }

            var guid = row[this.idField];
            params.refreshRowGuid = guid;

            var self = this;
            this._dataSource._doLoadAjax(params, '', '', '', function (data) {
                var rows = data.data || data,
                    oldRow = self.getRow(guid),
                    newRow;
                for (var i = 0, l = rows.length; i < l; i++) {
                    if (rows[i][self.idField] === guid) {
                        newRow = rows[i];
                        break;
                    }
                }

                if (newRow) {
                    self.updateRow(oldRow, newRow);
                } else {
                    console.warn('DataGrid 控件的 refreshRow 方法返回数据中没有新数据！');
                }
                self.unmask();
            });
        },

        setHoldSelectedStatus: function (holdSelectedStatus) {
            this.holdSelectedStatus = holdSelectedStatus;

            if (this.holdSelectedStatus && !this.isInitHold) {
                var me = this;

                this.on('load', function (e) {
                    if (this.multiSelect) {
                        for (var id in me.selectMaps) {
                            me.select(me.selectMaps[id]);
                        }
                    }
                });

                this.isInitHold = true;
            }
        },
        __OnSelectionChanged: function (e) {
            if (e.fireEvent !== false) {
                if (e.select) {
                    this.fire('rowselect', e);
                } else {
                    this.fire('rowdeselect', e);
                }
            }

            // 保持选中状态时，需要处理selectMaps
            // 移到__OnSelectionChanged的原因是：
            // 在勾选一行记录时表格会触发两次SelectionChanged事件，而SelectionChanged是有setTimeout的，第二次会把第一次的冲掉。
            // 而第二次的事件中e._records为空了。
            // 使用e._records是因为在beforeselect事件中阻止选中后，e.records中任有被阻止掉的记录，而e._records里面是不包含被阻止掉的记录的。
            if (this.holdSelectedStatus) {
                var records = e._records,
                    i = 0,
                    len = records.length;

                if (e.select) {
                    for (; i < len; i++) {
                        this.selectMaps[records[i][this.idField]] = records[i];
                    }
                } else {
                    for (; i < len; i++) {
                        this.selectMaps[records[i][this.idField]] = undefined;
                        delete this.selectMaps[records[i][this.idField]];
                    }
                }
            }

            var me = this;
            if (this._selectionTimer) {
                clearTimeout(this._selectionTimer);
                this._selectionTimer = null;
            }
            this._selectionTimer = setTimeout(function () {
                me._selectionTimer = null;

                if (e.fireEvent !== false) {
                    me.fire('SelectionChanged', e);
                }

                me.fire('_selectchange', e);
            }, 1);

            this._doRowSelect(e._records, e.select);
        },
        // 清空选择状态
        clearSelectedStatus: function () {
            if (this.holdSelectedStatus) {
                this.selectMaps = {};
            }
            this.clearSelect();
        },

        getAllSelecteds: function () {
            var rows = [];

            if (this.holdSelectedStatus && this.multiSelect) {
                for (var id in this.selectMaps) {
                    rows.push(this.selectMaps[id]);
                }
            } else {
                rows = this.getSelecteds();
            }

            return rows;
        },

        // 用于获取表格选中行的id数组
        getSelectedIds: function () {
            var rows = this.getSelecteds();

            var ids = [];
            for (var i = 0, l = rows.length; i < l; i++) {
                var r = rows[i];
                ids.push(r[this.idField]);
            }

            return ids;
        },

        // 用于通用场景下的删除表格记录
        // ajax发送的数据格式：{ids: 'id1,id2'}
        // url为ajax请求地址
        // callback为回调方法，参数为ajax的返回结果data。如果该方法返回false，则会阻止默认的回调处理
        // params为传入的额外参数
        deleteRows: function (options) {
            var self = this;
            if (typeof options === 'string') {
                options = {
                    url: options
                };
            }
            var url = options.url,
                notSelectedTip = options.notSelectedTip || epoint_local.DataGrid.notSelectedTip,
                confirmTip = options.confirmTip || epoint_local.DataGrid.confirmDeleteTip,
                confirmTitle = options.confirmTitle || epoint_local.DataGrid.confirmTitle,
                params = options.params || {},
                callback = options.callback;

            var datagrid = this;
            // 获取选中行id集合
            var ids = this.getSelectedIds();

            if (ids.length > 0) {
                mini.confirm(confirmTip, confirmTitle, function (action) {
                    if (action == 'ok') {
                        datagrid.loading(epoint_local.DataGrid.waitingText);
                        if (Util.getRightUrl) {
                            url = Util.getRightUrl(url);
                        }

                        params.ids = ids.join(',');
                        jQuery
                            .ajax({
                                url: url,
                                type: 'post',
                                dataType: 'json',
                                data: params
                            })
                            .done(function (data) {
                                if (callback && callback.call(datagrid, data) === false) {
                                    return;
                                }

                                if (data.success) {
                                    mini.alert(data.msg || epoint_local.DataGrid.deleteSuccessfulText);
                                } else {
                                    mini.alert(data.msg || epoint_local.DataGrid.deleteFailedText);
                                }

                                if (datagrid.url) {
                                    datagrid.reload();
                                }
                            })
                            .fail(function (jqXHR, textStatus, errorThrown) {
                                mini.alert(jqXHR.responseText);
                                datagrid.unmask();
                            });
                    }
                });
            } else {
                mini.alert(notSelectedTip);
            }
        },

        removeNewRow: function () {
            var selects = this.getAllSelecteds(),
                isAllNew = true;
            for (var i = 0, l = selects.length; i < l; i++) {
                if (selects[i][this.idField]) {
                    isAllNew = false;
                    break;
                }
            }

            if (isAllNew) {
                this.removeRows(selects);
            }
            return isAllNew;
        },

        // 100% 列宽适配 加一个最小值
        _autoColumnWidth: function () {
            var $trs = $(this.el).find('.datagrid-columns-width-tr');
            $.each($trs, function (_, tr) {
                var $tr = $(tr);
                var autoCell = null;
                var subWidth = [].slice.call($tr.children()).reduce(function (t, cell) {
                    if (/datagrid-autowidth-column/.test(cell.className)) {
                        autoCell = cell;
                        return t;
                    }
                    t += cell.getBoundingClientRect().width;
                    return t;
                }, 0);
                if (!autoCell) {
                    return;
                }
                var width = $tr.width();
                var delta = width - subWidth;
                var winWidth = parseInt(autoCell.getAttribute('data-min-width'), 10) || 100;
                if (delta > winWidth) {
                    autoCell.style.width = '100%';
                } else {
                    autoCell.style.width = winWidth + 'px';
                }
            });
        }
    };
});

mini.addEpointExt('FrozenGridView', function () {
    return {
        doUpdateRows: function () {
            var data = this.getVisibleRows();

            var columns1 = this.getFrozenColumns();
            var columns2 = this.getUnFrozenColumns();
            var columns3 = this.getFrozenRightColumns();
            var lockHtml, lockRightHtml, html;

            if (this.isGrouping()) {
                lockHtml = this._createGroupingHTML(columns1, 1);
                lockRightHtml = this._createGroupingHTML(columns3, 3);
                html = this._createGroupingHTML(columns2, 2);

                this._rowsLockContentEl.innerHTML = lockHtml;
                this._rowsRightLockContentEl.innerHTML = lockRightHtml;
                this._rowsViewContentEl.innerHTML = html;
            } else {
                //if (data.length > 1) data.length = 1;
                lockHtml = this._createRowsHTML(columns1, 1, this.isFrozen() ? data : []);
                lockRightHtml = this._createRowsHTML(columns3, 3, this.isFrozenRight() ? data : []);
                html = this._createRowsHTML(columns2, 2, data);

                //            mini.removeChilds(this._rowsLockContentEl);
                //            mini.removeChilds(this._rowsViewContentEl);

                //            jQuery(this._rowsLockContentEl).empty();
                //            jQuery(this._rowsViewContentEl).empty();

                this._rowsLockContentEl.innerHTML = lockHtml;
                this._rowsRightLockContentEl.innerHTML = lockRightHtml;
                this._rowsViewContentEl.innerHTML = html;
            }
            var lockTable = this._rowsLockContentEl.firstChild;
            var lockRightTable = this._rowsRightLockContentEl.firstChild;
            lockTable.style.width = '0px';
            lockRightTable.style.width = '0px';

            var scrollTop = this.getScrollTop(),
                scrollLeft = this._columnsViewEl.scrollLeft;
            if (this._rowsViewEl.scrollTop !== scrollTop || this._rowsViewEl.scrollLeft !== scrollLeft) {
                //this._rowsViewEl.scrollTop = scrollTop;

                this._syncScrollOffset(scrollLeft, scrollTop);
            }

            //this._syncRowsHeight();
        }
    };
});

mini.ActionColumn = function(config) {
    return mini.copyTo(
        {
            width: 32 * 4 + 24,
            cellCls: 'mini-actioncolumn mini-actioncolumn-cell',
            headerCls: 'mini-actioncolumn',
            hideable: true,
            allowDrag: true,
            // header: function(column) {
            //     // 列里面写了内容  header 就不会调用了
            // },
            minWidth: 32 * 2 + 24,
            iconWidth: 16,
            textWidth: 54,
            itemGap: 16,
            asText: false,
            plain: false,
            defaultShowItems: 4,
            calcWidth: function(count) {
                var len = Math.min(count, this.defaultShowItems);
                var unit = this.asText ? this.textWidth : this.iconWidth;
                return Math.max(this.minWidth, unit * len + this.itemGap * (len - 1) + 24) + 'px';
            },
            renderer: function(e) {
                var that = this;
                var grid = e.sender;
                var record = e.record;

                var column = e.column;
                var icons = column.__actions;
                if (!icons || !icons.length) return '';

                var iconsHtml = '';

                var columnId = column._id;
                var iconsState = {};

                if (!column.__hasIconRender) {
                    // 无控制 直接渲染前四个即可
                    iconsHtml = $.map(icons.slice(0, that.defaultShowItems), function(item) {
                        return renderIcon(item);
                    }).join('');
                } else {
                    // 调用 图标 renderer
                    $.each(icons, function(i, icon) {
                        if (icon.renderer + '' === icon.renderer) {
                            icon.renderer = that.__getFun(icon.renderer, true);
                        }
                        if (icon && $.type(icon.renderer) === 'function') {
                            var ev = {
                                sender: grid,
                                record: record,
                                row: e.row,
                                column: column,
                                icon: {
                                    icon: icon.icon
                                }
                            };
                            var rtv = icon.renderer.call(grid, ev);
                            if ($.type(rtv) === 'string' && rtv.length) {
                                window.console && console.warn && console.warn('图标渲染内容不可自定义，仅可通过e.icon.disabled 和 e.icon.visible 控制图标按钮的禁用和显示状态');
                            }
                            iconsState[icon._id] = {
                                disabled: ev.icon.disabled === true ? true : false,
                                visible: ev.icon.visible === false ? false : true
                            };
                        } else {
                            iconsState[icon._id] = {
                                disabled: false,
                                visible: true
                            };
                        }
                    });

                    // 可见的
                    var visibleIcons = $.grep(icons, function(icon) {
                        return iconsState[icon._id].visible;
                    });
                    var isOver = visibleIcons.length > that.defaultShowItems;
                    if (isOver) {
                        // 渲染前三个可见的 + ext
                        iconsHtml = $.map(visibleIcons.slice(0, that.defaultShowItems - 1), function(item) {
                            var isDisabled = iconsState[item._id].disabled;
                            return renderIcon(item, isDisabled);
                        }).join('');

                        // 其他图标
                        var overIconIds = [],
                            disabledIds = [];
                        $.map(visibleIcons.slice(that.defaultShowItems - 1), function(item) {
                            overIconIds.push(item._id);
                            if (iconsState[item._id].disabled) {
                                disabledIds.push(item._id);
                            }
                        }).join(',');

                        iconsHtml += renderIcon(column.__actionsMap.showMore, false, overIconIds.join(','), disabledIds.join(','));
                    } else {
                        iconsHtml = $.map(visibleIcons, function(item) {
                            var isDisabled = iconsState[item._id].disabled;
                            return renderIcon(item, isDisabled);
                        }).join('');
                    }
                }

                return '<div class="mini-actioncolumn-wrap" data-column-id="' + columnId + '" data-record-id="' + record._uid + '">' + iconsHtml + '</div>';

                function renderIcon(item, isDisabled, overIds, disabledIds) {
                    var html =
                        '<i class="action-icon ' +
                        (that.asText ? '' : item.icon) +
                        (isDisabled ? ' mini-disabled' : '') +
                        '" data-tooltip="' +
                        item.title +
                        '" data-column-id="' +
                        columnId +
                        '" data-icon-id="' +
                        item._id +
                        '" data-record-id="' +
                        record._uid +
                        '" ' +
                        (overIds ? 'data-over-ids="' + overIds + '"' : '') +
                        (disabledIds ? ' data-disabled-ids="' + disabledIds + '"' : '') +
                        '></i>';

                    if (that.asText) {
                        var $icon = $(html);
                        $icon
                            .removeClass('action-icon')
                            .addClass('action-text')
                            .addClass('text-' + (item.state || 'primary'))
                            .text($icon.attr('data-tooltip'))
                            .css('width', that.textWidth);
                        if (!that.plain) {
                            $icon.addClass('asBtn');
                        }
                        return $icon[0].outerHTML;
                    }

                    return html;
                }
            },

            __onCellMouseUp: function(e) {
                // 可能存在多列 只处理自己的点击事件
                if (e.column._id !== this._id) {
                    return;
                }
                var targetEL = e.htmlEvent.target;
                var iconId = targetEL.getAttribute('data-icon-id');

                var icon = e.column.__actionsMap[iconId];
                if (!icon || !icon.handle || $(targetEL).hasClass('mini-disabled')) return;

                this.__callHandle(icon.handle, e.record, e.sender, targetEL);
            },
            /**
             * 调用处理函数
             *
             * @param {any} fn 配置的处理函数
             * @param {object} record 当前行数据
             * @param {mini.DataGrid} grid 当前表格对象
             * @param {HTMLElement | undefined} el 当前图标dom
             * @returns
             */
            __callHandle: function(fn, record, grid, el) {
                var type = $.type(fn);
                if (type === 'function') {
                    return fn.call(grid, record, el);
                }
                if (type === 'string') {
                    var isCall = /\(.*\)/.test(fn);

                    if (isCall) {
                        // 如果本身就是 fnName(xxx) 这种调用则直接执行
                        eval(fn);
                    } else {
                        // 如果没带括号调用 则传参调用
                        eval(fn)(record, el);
                    }

                    return;
                }
            },

            /**
             * 获取 function
             *
             * @param {string} fnName 函数名字符串
             * @param {boolean} forceFn 是否只查找fn
             * @returns
             */
            __getFun: function(fnName, forceFn) {
                if (window[fnName] && $.type(window[fnName]) === 'function') {
                    return window[fnName];
                }
                return forceFn ? false : fnName;
            },

            init: function(grid) {
                var actioncolumn = this;
                var $h = $('<div></div>').html(actioncolumn.header);

                var noHandleArr = [];

                // 是否有图标的 renderer 如果有 需要很多额外工作
                actioncolumn.__hasIconRender = false;

                var iconsMap = {};
                var icons = [];
                var $icons = $h.find('[type="action"]').remove();
                // 优先从 buttons 属性取 按钮 没有从dom获取
                if ($.isArray(actioncolumn.buttons) && actioncolumn.buttons.length) {
                    icons = actioncolumn.buttons.map(function(item, i) {
                        var icon = {
                            id: item.id || i + 1,
                            _id: i + 1,
                            icon: item.icon,
                            title: item.text,
                            handle: item.onclick,
                            renderer: item.renderer,
                            state: item.state
                        };

                        if (!icon.handle) {
                            noHandleArr.push(icon);
                        }
                        iconsMap[icon._id] = icon;
                        if (icon.renderer) {
                            actioncolumn.__hasIconRender = true;
                        }
                        return icon;
                    });
                } else {
                    icons = $.map($icons, function(el, i) {
                        var icon = {
                            id: el.getAttribute('id') || i + 1,
                            _id: i + 1,
                            icon: el.getAttribute('icon'),
                            state: el.getAttribute('state'),
                            title: el.textContent || el.innerText || el.getAttribute('title'),
                            //
                            // handle: getHandle(el.getAttribute('onclick')),
                            // renderer: getHandle(el.getAttribute('renderer'), true)
                            handle: el.getAttribute('onclick'),
                            renderer: el.getAttribute('renderer')
                        };

                        if (!icon.handle) {
                            noHandleArr.push(icon);
                        }
                        iconsMap[icon._id] = icon;
                        if (icon.renderer) {
                            actioncolumn.__hasIconRender = true;
                        }
                        return icon;
                    });
                }

                $h.find('>*').remove();
                actioncolumn.header = $.trim($h.text()) || epoint_local.operate_text;
                actioncolumn.__actions = icons;
                actioncolumn.__actionsMap = iconsMap;
                actioncolumn.width = actioncolumn.calcWidth(icons.length);

                // 长度 大于 4 则插入一个
                if (icons.length > this.defaultShowItems) {
                    var showMoreIcon = {
                        _id: 'showMore',
                        icon: 'icon-omit',
                        title: epoint_local.more_text,
                        handle: __showMoreActions
                    };
                    iconsMap[showMoreIcon._id] = showMoreIcon;

                    // 无控制 则初始化创建即可 否则需在单元格 renderer 时动态控制
                    if (!actioncolumn.__hasIconRender) {
                        icons.splice(actioncolumn.defaultShowItems - 1, 0, showMoreIcon);
                        this.__createExtMenu(grid);
                        this.__extMenu.setItems(
                            $.map(this.__actions.slice(actioncolumn.defaultShowItems), function(icon) {
                                return {
                                    id: icon._id,
                                    text: icon.title,
                                    iconCls: icon.icon
                                };
                            })
                        );
                    }
                }

                if (noHandleArr.length) {
                    $.each(noHandleArr, function(i, icon) {
                        console && console.warn && console.warn(actioncolumn.header + '列的【' + icon.icon + '】未配置点击事件！！！');
                    });
                }
                noHandleArr = null;

                grid.on('cellMouseUp', this.__onCellMouseUp, this);
                actioncolumn.__inited = true;

                function __showMoreActions(record, el) {
                    if (!actioncolumn.__extMenu) {
                        actioncolumn.__createExtMenu(grid);
                    }

                    // 记录当前行id
                    actioncolumn.__extMenu.__currentRecordId = record._uid;
                    // 如果有图标的 render 需要在此获取状态
                    if (actioncolumn.__hasIconRender) {
                        var overIds = (el.getAttribute('data-over-ids') || '').split(',');
                        var disabledIds = (el.getAttribute('data-disabled-ids') || '').split(',');
                        actioncolumn.__extMenu.setItems(
                            $.map(overIds, function(id) {
                                var targetIcon = actioncolumn.__actionsMap[id];
                                return {
                                    id: id,
                                    text: targetIcon.title,
                                    iconCls: targetIcon.icon,
                                    enabled: disabledIds.indexOf(id) !== -1 ? false : true
                                };
                            })
                        );
                    }

                    actioncolumn.__extMenu.popupEl = el;
                    actioncolumn.__extMenu.showAtEl(el);
                    $(el).addClass('active');
                }
            },
            __createExtMenu: function(grid) {
                var that = this;
                if (!this.__extMenuInited) {
                    var extMenu = new mini.Menu();
                    extMenu.set({
                        minWidth: 50,
                        yOffset: 4
                    });

                    extMenu.on('itemclick', function(e) {
                        var id = e.item.id;
                        var icon = that.__actionsMap[id];
                        var rid = extMenu.__currentRecordId;
                        var record = grid.getRowByUID(rid);
                        if (icon && icon.handle) {
                            that.__callHandle(icon.handle, record, grid);
                        }
                    });
                    var oldHide = extMenu.hide;
                    extMenu.hide = function() {
                        oldHide.apply(this, arguments);
                        $('[data-icon-id="showMore"]').removeClass('active');
                        // $(grid._rowsEl).off('scroll', hideMenu);
                        // grid._rowsEl.onscroll = null;
                        grid._rowsEl.removeEventListener && grid._rowsEl.removeEventListener('scroll', hideMenu, true);
                    };

                    this.__extMenu = extMenu;
                    this.__extMenuInited = true;
                    /* eslint-disable-next-line */
                    function hideMenu() {
                        extMenu.hide();
                    }
                    grid._rowsEl.addEventListener &&
                        extMenu.on('open', function() {
                            //    grid._rowsEl.onscroll = hideMenu;
                            //    $(grid._rowsEl).on('scroll', hideMenu);
                            grid._rowsEl.addEventListener('scroll', hideMenu, true);
                        });
                }
                return this.__extMenu;
            }
        },
        config
    );
};
mini._Columns.actioncolumn = mini.ActionColumn;

mini.addEpointExt('ListBox', function() {
    // listbox checkbox 美化
    (function($) {
        if (mini.isIE8) return;

        var markerCls = 'check-beauty';
        var labelCls = 'mini-listbox-checkbox-icon';

        var doUpdate = mini.ListBox.prototype.doUpdate;

        mini.ListBox.prototype.doUpdate = function() {
            var returnValue = doUpdate.apply(this, arguments);

            var $contentTable = $(this._viewEl).find('.mini-listbox-items');
            doAddTitle($contentTable);

            if (!this.showCheckBox) {
                return returnValue;
            }
            var $headerTable = $(this._headerEl).find('.mini-listbox-headerInner');

            doAddLabel($contentTable);
            doAddLabel($headerTable);

            return returnValue;
        };

        function doAddTitle($table) {
            $table.find('td').each(function (i, td) {
                var $td = $(td);
                if ($td.hasClass('.mini-listbox-checkbox')) {
                    return;
                }
                $td.attr('title', $td.text());
            });
        }

        function doAddLabel($table) {
            var $checkboxTds = $table.find('.mini-listbox-checkbox');
            if ($table.hasClass(markerCls) || !$checkboxTds.find('input[type="checkbox"]').length) return;
            $.map($checkboxTds, function(td) {
                var checkbox = $(td).find('input[type="checkbox"]')[0];
                if(!checkbox) return;

                var checkerId = checkbox.id;
                if (!checkerId) return;
                $('<label class="' + labelCls + '" for="' + checkerId + '"></label>').appendTo(td);
            });
            $table.addClass(markerCls);
        }
    })(window.jQuery);

    return {
        getItemText: function(item) {
            var t = mini._getMap(this.textField, item);
            // 安全整改要求，服务端返回数据是对html编码的，但是提交时需要还原成正常的html标签
            return mini.isNull(t) ? '' : mini.htmlDecode(String(t));
        },
        _OnDrawCell: function(record, index, column) {
            var value = column ? mini._getMap(column.field, record) : this.getItemText(record);
            var e = {
                sender: this,
                index: index,
                rowIndex: index,
                record: record,
                item: record,
                column: column,
                field: column ? column.field : null,
                value: value,
                cellHtml: value,
                rowCls: null,
                cellCls: column ? column.cellCls || '' : '',
                rowStyle: null,
                cellStyle: column ? column.cellStyle || '' : ''
            };

            var hasColumns = this.columns && this.columns.length > 0;
            if (!hasColumns) {
                if (index === 0 && this.showNullItem) {
                    e.cellHtml = this.nullItemText;
                }
            }

            // 由于安全整改后，提交数据中是允许有html标签的，而在渲染时不能解析html标签
            // 所以在返回数据时，服务端已对html标签做转义，在提交时再重新还原回来
            // 所以修改了listbox的getItemText方法，把转义的html还原回来
            // 所以此处需要重新将html转义下
            // if (e.autoEscape == true) {
            //     e.cellHtml = mini.htmlEncode(e.cellHtml);
            // }
            e.cellHtml = mini.htmlEncode(e.cellHtml);

            if (column) {
                if (column.dateFormat) {
                    if (mini.isDate(e.value)) e.cellHtml = mini.formatDate(value, column.dateFormat);
                    else e.cellHtml = value;
                }
                var renderer = column.renderer;
                if (renderer) {
                    var fn = typeof renderer === 'function' ? renderer : window[renderer];
                    if (fn) {
                        e.cellHtml = fn.call(column, e);
                    }
                }
            }

            this.fire('drawcell', e);

            if (e.cellHtml === null || e.cellHtml === undefined || e.cellHtml === '') e.cellHtml = '&nbsp;';

            return e;
        }
    };
});

mini.addEpointExt('Menu', function() {
    var oldCreate = mini.Menu.prototype._create;
    return [
        {
            _create: function() {
                var r = oldCreate.apply(this, arguments);

                // 避免不必要的重写 直接在应用之后加入新事件的绑定即可
                this.on('open', this._onDocumentMousewheel, this);
                this.on('close', this._unDocumentMousewheel, this);
                return r;
            }
        },
        mini.__mouseWheelHandles
    ];
});

mini.addEpointExt('Pager', function() {
    return {
        set: function (kv) {
            if (typeof kv == 'string') {
                return this;
            }
    
            var pageIndex = kv.pageIndex;
            delete kv.pageIndex;
            var sizeList = kv.sizeList;
            delete kv.sizeList;
    
            mini.Pager.superclass.set.call(this, kv);
    
            if (!mini.isNull(pageIndex)) {
                this.setPageIndex(pageIndex);
            }
            if (!mini.isNull(sizeList)) {
                this.setSizeList(sizeList);
            }
            return this;
        },
        // 参数 total 在 showTotalCount 为 false 时用 Boolean 表示是否已到最后一页
        update: function(index, size, total) {
            if (mini.isNumber(index)) this.pageIndex = parseInt(index, 10);
            if (mini.isNumber(size)) this.pageSize = parseInt(size, 10);
            if (mini.isNumber(total)) this.totalCount = parseInt(total, 10);

            if (this.showTotalCount) {
                this.totalPage = parseInt(this.totalCount / this.pageSize, 10) + 1;
                if ((this.totalPage - 1) * this.pageSize === this.totalCount) {
                    this.totalPage -= 1;
                }
                if (this.totalCount === 0) this.totalPage = 0;

                if (this.totalCount >= 0) {
                    if (this.pageIndex > this.totalPage - 1) {
                        this.pageIndex = this.totalPage - 1;
                    }
                }
                if (this.pageIndex <= 0) this.pageIndex = 0;
                if (this.totalPage <= 0) this.totalPage = 0;
            }

            this.firstButton.enable();
            this.prevButton.enable();
            this.nextButton.enable();
            this.lastButton.enable();

            if (this.pageIndex === 0) {
                this.firstButton.disable();
                this.prevButton.disable();
            }
            if (this.showTotalCount && this.pageIndex >= this.totalPage - 1) {
                this.nextButton.disable();
                this.lastButton.disable();
            }

            var pageIndex = this.pageIndex > -1 ? this.pageIndex + 1 : 0;
            if (this.showTotalCount && this.totalCount == 0) pageIndex = 0;

            this.numInput.value = pageIndex;
            this.pagesLabel.innerHTML = '/ ' + this.totalPage;

            var sizeList = this.sizeList.clone();
            if (sizeList.indexOf(this.pageSize) === -1) {
                sizeList.push(this.pageSize);
                sizeList = sizeList.sort(function(a, b) {
                    return a - b;
                });

                this.sizeList = sizeList;
            }
            var sizes = [];
            for (var i = 0, l = sizeList.length; i < l; i++) {
                var num = sizeList[i];
                var option = {};
                option.text = num;
                option.id = num;
                sizes.push(option);
            }
            this.sizeCombo.setData(sizes);
            this.sizeCombo.setValue(this.pageSize);

            this.sizeTextEl.innerHTML = this.sizeText;
            this.sizeTextEl.style.display = this.sizeText ? '' : 'none';

            var firstText = this.firstText,
                prevText = this.prevText,
                nextText = this.nextText,
                lastText = this.lastText,
                reloadText = this.reloadText;
            if (this.showButtonText == false) {
                firstText = prevText = nextText = lastText = reloadText = '';
            }
            this.firstButton.setText(firstText);
            this.prevButton.setText(prevText);
            this.nextButton.setText(nextText);
            this.lastButton.setText(lastText);
            this.reloadButton.setText(reloadText);

            this.firstButton.setIconCls(this.showButtonIcon ? 'mini-pager-first' : '');
            this.prevButton.setIconCls(this.showButtonIcon ? 'mini-pager-prev' : '');
            this.nextButton.setIconCls(this.showButtonIcon ? 'mini-pager-next' : '');
            this.lastButton.setIconCls(this.showButtonIcon ? 'mini-pager-last' : '');
            this.reloadButton.setIconCls(this.showButtonIcon ? 'mini-pager-reload' : '');
            this.reloadButton.setVisible(this.showReloadButton);

            var s = this.reloadButton.el.previousSibling;
            if (s) {
                s.style.display = this.showReloadButton ? '' : 'none';
            }

            this._rightEl.innerHTML = String.format(this.pageInfoText, this.pageSize, this.totalCount);

            this.indexEl.style.display = this.showPageIndex ? '' : 'none';
            this.sizeEl.style.display = this.showPageSize ? '' : 'none';
            this._rightEl.style.display = this.showPageInfo && this.showTotalCount ? '' : 'none';

            this.pagesLabel.style.display = this.showTotalCount ? '' : 'none';

            if (this.showTotalCount) {
                //@新增：用于处理 totalPage < 0 的场合
                this.firstButton.setVisible(this.totalCount >= 0);
                this.lastButton.setVisible(this.totalCount >= 0);

                if (this.totalCount < 0) {
                    this.firstButton.enable();
                    this.nextButton.enable();
                    if (this.pageIndex == 0) {
                        this.firstButton.disable();
                    }
                    //this.indexEl.style.display = "none";
                }
            } else {
                this.firstButton.setVisible(false);
                this.lastButton.setVisible(false);
            }
        },
        _OnPageChanged: function(index, size) {
            var e = {
                pageIndex: mini.isNumber(index) ? index : this.pageIndex,
                pageSize: mini.isNumber(size) ? size : this.pageSize,
                cancel: false
            };

            if (this.showTotalCount && this.totalCount >= 0) {
                if (e.pageIndex > this.totalPage - 1) {
                    e.pageIndex = this.totalPage - 1;
                }
            }
            if (e.pageIndex < 0) e.pageIndex = 0;

            this.fire('beforepagechanged', e);
            if (e.cancel == true) {
                return;
            }

            this.fire('pagechanged', e);
            this.update(e.pageIndex, e.pageSize);
        },
        // 重新解决ie下手动输入页码回车加载数据后，点击页面会再次触发加载数据的问题
        _initEvents: function() {
            mini.Pager.superclass._initEvents.call(this);

            this.firstButton
                .set({
                    disableMultiClick: false
                })
                .on(
                    'click',
                    function() {
                        this._OnPageChanged(0);
                    },
                    this
                );
            this.prevButton
                .set({
                    disableMultiClick: false
                })
                .on(
                    'click',
                    function() {
                        this._OnPageChanged(this.pageIndex - 1);
                    },
                    this
                );
            this.nextButton
                .set({
                    disableMultiClick: false
                })
                .on(
                    'click',
                    function() {
                        this._OnPageChanged(this.pageIndex + 1);
                    },
                    this
                );
            this.lastButton
                .set({
                    disableMultiClick: false
                })
                .on(
                    'click',
                    function() {
                        this._OnPageChanged(this.totalPage);
                    },
                    this
                );
            this.reloadButton.on(
                'click',
                function() {
                    this._OnPageChanged();
                },
                this
            );

            function doPage() {
                if (changing) return;
                changing = true;
                var index = parseInt(this.numInput.value);
                if (isNaN(index)) {
                    this.update();
                    // update后，pageindex变成了1
                    oIndex = 1;
                } else {
                    // ie下回车不会触发change事件，导致回车刷新数据后，点击页面任意地方会再次触发change事件。
                    // 为解决该问题需记录下上一个index和当前的比较
                    if (oIndex != index) {
                        this._OnPageChanged(index - 1);
                        oIndex = index;
                    }
                }
                setTimeout(function() {
                    changing = false;
                }, 100);
            }

            var changing = false;
            var oIndex = parseInt(this.numInput.value, 10);
            mini.on(
                this.numInput,
                'change',
                function() {
                    doPage.call(this);
                },
                this
            );

            mini.on(
                this.numInput,
                'keydown',
                function(e) {
                    if (e.keyCode === 13) {
                        doPage.call(this);
                        e.stopPropagation();
                    }
                },
                this
            );

            //mini.on(this.pageSelect, "change", this.__OnPageSelectChanged, this);
            this.sizeCombo.on('valuechanged', this.__OnPageSelectChanged, this);
        }
    };
});

mini.addEpointExt('Panel', function() {
    return {
        _doTitle: function() {
            var title = this.title == '' ? '&nbsp' : this.title;
            this._titleEl.innerHTML = title;
            // 给panel标题添加title，解决由代办打开的dialog标题过长时无法显示全的问题
            this._titleEl.title = mini.htmlUnescape(title);

            this._iconEl.style.display = this.iconCls || this.iconStyle ? 'inline' : 'none';
            this._iconEl.className = 'mini-panel-icon mini-icon mini-iconfont ' + this.iconCls;

            mini.setStyle(this._iconEl, this.iconStyle);
        },
        hide: function () {
            var rt = mini.Panel.superclass.hide.apply(this, arguments);
            this.fire('close');
            return rt;
        },
        /**
         * 其他地方的 miniui maxHeight 都是写在实例上 显示前 height 和 maxHeight 比对 使用合适的 height
         * 但 panel 中居然是从 dom 上取 maxHeight 从而配置无效，为避免大改源码，maxHeight写入到dom上
         */
        setMaxHeight: function(v) {
            v = parseInt(v, 10);
            if (v) {
                this.maxHeight = v;
                jQuery(this.el).css('max-height', v);
            }
        }
    };
});

mini.addEpointExt('Popup', function() {
    return [
        {
            yOffset: 2,
            _getWindowOffset: function() {
                return [0, 2];
            },
            _create: function() {
                var el = (this.el = document.createElement('div'));
                this.el.className = 'mini-popup';
                this._contentEl = this.el;

                // 避免不必要的重写 直接在应用之后加入新事件的绑定即可
                this.on('open', this._onDocumentMousewheel, this);
                this.on('close', this._unDocumentMousewheel, this);
            }
        },
        mini.__mouseWheelHandles
    ];
});

// ;(function() {
//     var _createHeaderMenu = mini.Tabs.prototype._createHeaderMenu;
//     var yOffset = 2;
//     mini.Tabs.prototype._createHeaderMenu = function() {
//         var r = _createHeaderMenu.apply(this, arguments);
//         var menuBtn = this._headerMenuEl;
//         this._headerMenu && this._headerMenu.setyOffset && this._headerMenu.setyOffset(yOffset);
//         if (this._headerMenu && menuBtn) {
//             this._headerMenu.on('open', function() {
//                 $(menuBtn).addClass('popup');
//             });
//             this._headerMenu.on('close', function() {
//                 $(menuBtn).removeClass('popup');
//             });
//         }
//         return r;
//     };
// })();
mini.addEpointExt('Tabs', function() {
    var _createHeaderMenu = mini.Tabs.prototype._createHeaderMenu;
    var yOffset = 2;

    var ext = {
        _createHeaderMenu: function() {
            var r = _createHeaderMenu.apply(this, arguments);
            var menuBtn = this._headerMenuEl;
            this._headerMenu && this._headerMenu.setyOffset && this._headerMenu.setyOffset(yOffset);
            if (this._headerMenu && menuBtn) {
                this._headerMenu.on('open', function() {
                    $(menuBtn).addClass('popup');
                });
                this._headerMenu.on('close', function() {
                    $(menuBtn).removeClass('popup');
                });
            }
            return r;
        }
    };
    // linux环境（国产化）下，object 元素不能隐藏掉，需要用 position 位置来隐藏
    if(window.isLinux) {
        $.extend(ext, {
            setActiveIndex: function (value, load) {

            var tab = this.getTab(value);
    
            var acTab = this.getTab(this.activeIndex);
    
            //
    
            var fire = tab != acTab;
    
            var el = this.getTabBodyEl(this.activeIndex);
            // if (el) el.style.display = "none";
            if (el) {
                jQuery(el).css({
                    position: 'absolute',
                    width: '100%',
                    left: '-200%'
                });
            }
            if (tab) {
                this.activeIndex = this.tabs.indexOf(tab);
            } else {
                this.activeIndex = -1;
            }
            el = this.getTabBodyEl(this.activeIndex);
            // if (el) el.style.display = "";
            if (el) {
                jQuery(el).css({
                    position: 'relative',
                    width: '100%',
                    left: '0'
                });
            }
    
            el = this.getTabEl(acTab);
            if (el) mini.removeClass(el, this._tabActiveCls);
    
            el = this.getTabEl(tab);
            if (el) mini.addClass(el, this._tabActiveCls);

            var tb,td;
            if (el && fire) {
                if (this.tabPosition === 'bottom') {
                    tb = mini.findParent(el, 'mini-tabs-header');
                    if (tb) {
                        jQuery(this._headerEl).prepend(tb);
                    }
                } else if (this.tabPosition == 'left') {
                    td = mini.findParent(el, 'mini-tabs-header').parentNode;
                    if (td) {
                        td.parentNode.appendChild(td);
                    }
                } else if (this.tabPosition == 'right') {
                    td = mini.findParent(el, 'mini-tabs-header').parentNode;
                    if (td) {
                        jQuery(td.parentNode).prepend(td);
                    }
                } else {
    
                    //                var tb = mini.findParent(el, "mini-tabs-header");
                    //                if (tb) {
                    //                    this._headerEl.appendChild(tb);
                    //                }
    
                    tb = mini.findParent(el, 'mini-tabs-header');
                    if (tb && this.allowClickWrap) {
                        this._headerEl.appendChild(tb);
                    }
                }
                // var scrollLeft = this._headerEl.scrollLeft;
    
    
                acTab = this.getTab(this.activeIndex);
                var canLayout = acTab ? !acTab._layouted : false;
                var autoHeight = this.isAutoHeight();
    
                //alert(1);
    
                if (autoHeight || canLayout) {
                    if (acTab) acTab._layouted = true;
                    this.doLayout();
                    if (acTab) acTab._layouted = false;
                }
    
                //alert(2);
    
                var rows = this.getTabRows();
                if (rows.length > 1) {
    
                } else {
                    this._scrollToTab(this.activeIndex);
                    //                if (this.tabPosition == "top") {
                    //                    this._headerEl.scrollLeft = scrollLeft;
                    //                    var tabEl = this.getTabEl(this.activeIndex);
                    //                    if (tabEl) {
                    //                        var sf = this;
                    //                        var tabBox = mini.getBox(tabEl);
                    //                        var scrollBox = mini.getBox(sf._headerEl);
    
                    //                        if (tabBox.x < scrollBox.x) {
                    //                            sf._headerEl.scrollLeft -= (scrollBox.x - tabBox.x);
                    //                        } else if (tabBox.right > scrollBox.right) {
                    //                            sf._headerEl.scrollLeft += (tabBox.right - scrollBox.right);
                    //                        }
                    //                    }
                    //                }
                    this._doScrollButton();
                }
    
                for (var i = 0, l = this.tabs.length; i < l; i++) {
                    var tabEl = this.getTabEl(this.tabs[i]);
                    if (tabEl) {
                        mini.removeClass(tabEl, this._tabHoverCls);
                    }
                }
    
    
            }
            var me = this;
            if (fire) {
                var e = {
                    tab: tab,
                    index: this.tabs.indexOf(tab),
                    name: tab ? tab.name : ''
                };
    
                setTimeout(function () {    //延迟激发，这样确保UI都被继续创建后
    
    
                    me.fire('ActiveChanged', e);
    
                }, 1);
            }
    
            //iframe load
            this._cancelLoadTabs(tab);
            if (load !== false) {
                if (tab && tab.url && !tab.loadedUrl) {
                    
    
                    //setTimeout(function () {
                    me.loadTab(tab.url, tab);
                    //}, 1);
                }
            } else {
                //if (this.maskOnLoad) this.loading();
            }
    
            if (tab) {
                if (mini.isChrome) {
                    var iframe = this.getTabIFrameEl(tab);
                    if (iframe) {
                        //mini.repaint(iframe);
    
                        iframe.style.position = 'relative';     //fix chrome iframe scroll 
                        iframe.style.left = '1px';
    
                        iframe.offsetWidth;
    
                        iframe.style.left = '0px';
    
                        //alert('repaint');
                    }
                }
            }
    
            if (me.canLayout()) {
                try {
                    mini.layoutIFrames(me.el);
                } catch (err) {}
            }
            },
            addTab: function (tab, index) {
                if (typeof tab === 'string') {
                    tab = { title: tab };
                }
                tab = this.createTab(tab);
                if (!tab.name) tab.name = '';
        
                //保持activeIndex序号正确
                var activeTab = this.getActiveTab();
        
                if (typeof index !== 'number') index = this.tabs.length;
                this.tabs.insert(index, tab);
        
                //保持activeIndex序号正确
                if (activeTab) this.activeIndex = this.tabs.indexOf(activeTab);
        
                //body
                var bodyId = this._createTabBodyId(tab);
                // var s = '<div id="' + bodyId + '" class="mini-tabs-body ' + tab.bodyCls + '" style="' + tab.bodyStyle + ';display:none;"></div>';
                var s = '<div id="' + bodyId + '" class="mini-tabs-body ' + tab.bodyCls + '" style="' + tab.bodyStyle + ';position:absolute;left:-200%;width:100%;"></div>';
                mini.append(this._bodyEl, s);
        
                var el = this.getTabBodyEl(tab);
        
                //body
                var cs = tab.body;
                delete tab.body;
                if (cs) {
        
                    if (!mini.isArray(cs)) cs = [cs];
                    for (var i = 0, l = cs.length; i < l; i++) {
                        mini.append(el, cs[i]);
                    }
                }
        
                //bodyParent
                if (tab.bodyParent) {
                    var p = tab.bodyParent;
        
                    while (p.firstChild) {
                        if (p.firstChild.nodeType == 8) {
                            p.removeChild(p.firstChild);
                        } else {
                            el.appendChild(p.firstChild);
                        }
                    }
                }
                delete tab.bodyParent;
        
                //controls
                if (tab.controls) {
                    this.setTabControls(tab, tab.controls);
                    delete tab.controls;
                }
        
                this.doUpdate();
                return tab;
            }
        });
    }
    return ext;
});

mini.addEpointExt('TextBox', function () {
    return {
        // 新规范中数字类型的不需要靠右了
        // setVtype: function(value) {
        //     // 数字类型的输入框提供默认的范围验证,并默认居右
        //     if (value.indexOf('int') > -1 || value.indexOf('float') > -1 || value.indexOf('decimalLength') > -1) {
        //         // if(value.indexOf('range') == -1) {
        //         //     value += ';range:0,999999999';
        //         // }
        //         if (!this.inputStyle) {
        //             this.setInputStyle('text-align: right;');
        //         }
        //     }
        //     this.vtype = value;
        // },
        // 是否脱敏
        isDesensitization: false,
        showCount: true,
        __OnBlur: function (e) {
            if (this.isDesensitization && this.desensitizationValue && !this._textEl.value) {
                this._textEl.value = this.desensitizationValue;
            }

            this._focused = false;
            var sf = this;
            setTimeout(function () {
                if (sf._focused === false) {
                    sf.removeCls(sf._focusCls);
                }
            }, 2);

            //        if (this.emptyText && this._textEl.value == "") {
            //            this._textEl.value = this.emptyText;
            //            mini.addClass(this.el, this._emptyCls);
            //        }

            //        if (!this._inputChangedTime || new Date() - this._inputChangedTime < 50) {
            //            this.__OnInputTextChanged();
            //        }
            //        this._inputChangedTime = null;

            // 解决ie下通过鼠标把输入框的内容拖拽出去后值不变的bug
            // if (mini.isIE) {
            this.__OnInputTextChanged();
            // }

            this.fire('blur', {
                htmlEvent: e
            });

            if (this.validateOnLeave && this.isEditable()) {
                this._tryValidate();
            }
        },
        __OnFocus: function (e) {
            if (this.isDesensitization && this.value === this.desensitizationValue) {
                this._textEl.value = '';
            }

            //e.preventDefault();
            this.doUpdate();
            //if (this.isReadOnly() || this.allowInput == false) return;
            if (this.isReadOnly()) {
                return;
            }
            this._focused = true;
            this.addCls(this._focusCls);
            this._initInputEvents();

            //        mini.removeClass(this.el, this._emptyCls);
            //        if (this.emptyText && this._textEl.value == this.emptyText) {
            //            this._textEl.value = "";
            //            this._textEl.select();
            //        }

            if (this.selectOnFocus) {
                var me = this;
                setTimeout(function () {
                    me.selectText();
                }, 1);
            }

            this.fire('focus', {
                htmlEvent: e
            });
        },

        __OnInputTextChanged: function (e, valid) {
            //this._inputChangedTime = new Date();
            if (this.isDesensitization && this.desensitizationValue !== this._textEl.value) {
                this.desensitizationValue = '';
            }
            var value = this.value;
            this._oldValue = value;
            this.setValue(this._textEl.value);

            if (value !== this.getValue() || valid === true) {
                this._OnValueChanged();
            }
        },
        setValue: function (value, isDesensitization) {
            if (value === null || value === undefined) value = '';
            value = String(value);
            if (mini.getStrLength(value) > this.maxLength) {
                value = mini.substr(value, this.maxLength);
            }
            //if (this.value !== value) {
            this.value = value;
            this._valueEl.value = this._textEl.value = value;
            this._doEmpty();
            //}
            //        else {
            //            this._textEl.value = value;
            //        }

            if (isDesensitization) {
                this.isDesensitization = true;
                this.desensitizationValue = value;
            }

            if (this._maxLengthInfo) {
                this._maxLengthInfo.innerText = mini.getStrLength(this.value) + '/' + this.maxLength;
            }
        },

        __OnValidation: function (e) {
            if (e.isValid === false) return;
            // 脱敏状态不进行验证
            if (this.isDesensitization && this.desensitizationValue) return;

            mini._ValidateVType(this.vtype, e.value, e, this);
        },
        showClose: false,
        _closeCls: 'mini-textbox-close',
        setShowClose: function (value) {
            this.showClose = value;
            this._closeEl ||
                (this._closeEl = mini.after(this._valueEl, '<span class="mini-textbox-close mini-icon"></span>'));
            this._closeEl.style.display = this.showClose ? 'inline-block' : 'none';
            this._doInputLayout();
        },
        getShowClose: function () {
            return this.showClose;
        },
        _doInputLayout: function () {
            var pl = 0;
            if (this._InputType !== 'textarea' && this._initMaxLengthInfo) {
                pl += mini.getWidth(this._maxLengthInfo) + 8;
            }
            if (this.showClose) {
                pl += mini.getWidth(this._closeEl);
            }
            if (pl > 0) {
                mini.setStyle(this._textEl, 'width:calc(100% - ' + pl / 100 + 'rem);');
            }
        },
        __OnMouseDown: function (e) {
            var sf = this;
            if (mini.findParent(e.target, this._closeCls)) {
                this.__OnInputTextChanged();
                if (this.value !== '') {
                    this._oldValue = this.value;
                    this.setValue('');
                    this.setText('');
                    this._OnValueChanged();
                }
            }

            // 解决ie下有时点击后光标没有在输入框中的bug
            sf._textEl.focus();

            //加这行代码
            // if (this._InputType == 'textarea') return;

            //this.fire("click", {htmlEvent: e});

            if (!mini.isAncestor(this._textEl, e.target)) {
                setTimeout(function () {
                    sf.focus();
                    mini.selectRange(sf._textEl, 10000, 10000);
                }, 1);
            }
        },
        errorTextEl: null,
        getErrorTextEl: function () {
            if (!this.errorTextEl) {
                this.errorTextEl = mini.append(this.el, '<span class="mini-errorText"></span>');
            }
            return this.errorTextEl;
        },
        _RemoveErrorText: function () {
            if (this.errorTextEl) {
                var el = this.errorTextEl;
                jQuery(el).remove();
            }
            this.errorTextEl = null;
        },
        setMaxLength: function (value) {
            this.maxLength = value;
            //
            mini.setAttr(this._textEl, 'maxLength', value);

            if (this._InputType === 'textarea' && mini.isIE) {
                mini.on(this._textEl, 'keyup', this.__OnMaxLengthKeyUp, this);
                mini.on(this._textEl, 'keypress', this.__OnMaxLengthKeyUp, this);
                mini.on(this._textEl, 'paste', this.__OnPaste, this);
            }
            if (this.showCount) {
                this._maxLengthInfo.style.display = '';
                this._bindMaxLengthInfo();
                this._updateMaxLengthInfo(this.value);
            } else {
                this._maxLengthInfo.style.display = 'none';
            }

            this._doInputLayout();
        },
        __OnPaste: function (e) {
            var sf = this;

            setTimeout(function () {
                var value = sf._textEl.value;

                // if (value.length > sf.maxLength) {
                //     sf._textEl.value = value.substring(0, sf.maxLength);

                // }
                sf._textEl.value = mini.substr(value, sf.maxLength);

                //sf._OnValueChanged();

                sf.__OnInputTextChanged();
            }, 0);
        },
        __OnMaxLengthKeyUp: function (e) {
            // if (this._textEl.value.length >= this.maxLength) {
            if (mini.getStrLength(this._textEl.value) >= this.maxLength) {
                this.__OnPaste(e);
                e.preventDefault();
            }
        },
        _initMaxLengthInfo: false,
        _bindMaxLengthInfo: function () {
            var me = this,
                isCN;
            if (!this._initMaxLengthInfo) {
                mini.on(
                    this._textEl,
                    'input',
                    function () {
                        // 忽略一切非直接输入，不做逻辑处理
                        if (mini.getStrLength(me._textEl.value) > me.maxLength && !isCN) {
                            me._textEl.value = mini.substr(me._textEl.value, me.maxLength);
                        }
                        me._updateMaxLengthInfo(me._textEl.value);
                    },
                    this
                );
                mini.on(
                    this._textEl,
                    'compositionstart',
                    function () {
                        isCN = true;
                    },
                    this
                );
                mini.on(
                    this._textEl,
                    'compositionend',
                    function (e) {
                        isCN = false;
                        // 组合输入结束时需要判断下字符长度
                        if (mini.getStrLength(e.target.value) > me.maxLength) {
                            e.target.value = mini.substr(e.target.value, me.maxLength);
                            me._updateMaxLengthInfo(e.target.value);
                        }
                    },
                    this
                );
                this._initMaxLengthInfo = true;
            }
        },
        _updateMaxLengthInfo: function (val) {
            this._maxLengthInfo.innerText = mini.getStrLength(val) + '/' + this.maxLength;
            this._doInputLayout();
        },
        setShowCount: function (val) {
            this.showCount = !!val;

            if (this.showCount) {
                this._maxLengthInfo.style.display = '';
                this._bindMaxLengthInfo();
            } else {
                this._maxLengthInfo.style.display = 'none';
            }

            this._doInputLayout();
        },
        getShowCount: function () {
            return this.showCount;
        },
        getExtraAttrs: function (el) {
            var attrs = {};
            mini._ParseString(el, attrs, [
                'mobileErrorText',
                'telErrorText',
                'phoneErrorText',
                'postCodeErrorText',
                'orgCodeErrorText',
                'idCardErrorText',
                'validateErrorText',
                'decimalLengthErroeText'
            ]);
            mini._ParseBool(el, attrs, ['showClose', 'showCount']);
            return attrs;
        }
    };
});

mini.addEpointExt('TextArea', function () {
    return {
        minHeight: 62,
        maxHeight: 0, // 0 - 无限制
        autoSize: false,
        // __OnMouseDown: function(e) {
        //     var sf = this;
        //     // 解决ie下有时点击后光标没有在输入框中的bug
        //     sf._textEl.focus();

        //     //this.fire("click", {htmlEvent: e});

        //     if (!mini.isAncestor(this._textEl, e.target)) {
        //         setTimeout(function() {
        //             sf.focus();
        //             mini.selectRange(sf._textEl, 1000, 1000);
        //         }, 1);
        //     }
        // },
        setHeight: function (value) {
            if (parseFloat(value) === value) value += 'px';
            this.height = value;
            if (this._InputType === 'textarea') {
                // this.el.style.height = value;
                this.doLayout();
            }
        },
        setAutoSize: function (value) {
            this.autoSize = !!value;
            this.doLayout();
        },
        getAutoSize: function () {
            return this.autoSize;
        },
        setValue: function (value) {
            mini.TextArea.superclass.setValue.call(this, value);
            if (this.autoSize) {
                this.doLayout();
            }
        },
        setText: function (value) {
            mini.TextArea.superclass.setText.call(this, value);
            if (this.autoSize) {
                this.doLayout();
            }
        },
        __OnInput: function (e) {
            this.fire('input', { htmlEvent: e });
            if (this.autoSize) {
                this.doLayout();
            }
        },
        _initEvents: function () {
            mini._BindEvents(function () {
                window.mini_onOne(this._textEl, 'drop', this.__OnDropText, this);
                window.mini_onOne(this._textEl, 'change', this.__OnInputTextChanged, this);
                window.mini_onOne(this._textEl, 'focus', this.__OnFocus, this);
                window.mini_onOne(this.el, 'mousedown', this.__OnMouseDown, this);
                window.mini_onOne(this._textEl, 'input', this.__OnInput, this);

                //                        mini.on(this._textEl, "drop", this.__OnDropText, this);
                //                        mini.on(this._textEl, "change", this.__OnInputTextChanged, this);
                //                        mini.on(this._textEl, "focus", this.__OnFocus, this);
                //                        mini.on(this.el, "mousedown", this.__OnMouseDown, this);

                var v = this.value;
                this.value = null;
                if (this.el) {
                    this.setValue(v);
                }
            }, this);
            this.on('validation', this.__OnValidation, this); //一定要放这里
        },
        doLayout: function () {
            if (!this.canLayout()) return;
            mini.TextArea.superclass.doLayout.call(this);

            var h,
                minHeight = this.minHeight || 0,
                maxHeight = this.maxHeight || Number.MAX_VALUE;
            if (this.autoSize) {
                h = this.calcTextareaHeight(this._textEl, minHeight, maxHeight);
            } else {
                h = this.height;
                if (h + '' === h) {
                    if (h.indexOf('%') > -1) {
                        this.el.style.height = h;
                        h = mini.getHeight(this.el);
                        this.el.style.height = h + 'px';
                    }
                    h = parseInt(h, 10) || 0;
                }
                // 在 minHeigth 和 maxHeight 之间；减去边框 2px；大于 0
                h = Math.max(Math.max(minHeight, Math.min(maxHeight, h)) - 2, 0);
            }
            this._textEl.style.height = h + 'px';
        },
        // from element-ui
        // 计算 textarea 自适应高度，单位 px
        calcTextareaHeight: function (targetElement, minHeight, maxHeight) {
            var hiddenTextarea = document.createElement('textarea');
            document.body.appendChild(hiddenTextarea);

            var HIDDEN_STYLE = '\
                height:0 !important;\
                visibility:hidden !important;\
                overflow:hidden !important;\
                position:absolute !important;\
                z-index:-1000 !important;\
                top:0 !important;\
                right:0 !important\
            ';

            var CONTEXT_STYLE = [
                'letter-spacing',
                'line-height',
                'padding-top',
                'padding-bottom',
                'font-family',
                'font-weight',
                'font-size',
                'text-rendering',
                'text-transform',
                'width',
                'text-indent',
                'padding-left',
                'padding-right',
                'border-width',
                'box-sizing'
            ];

            var nodeStyling = calculateNodeStyling(targetElement),
                paddingSize = nodeStyling.paddingSize,
                borderSize = nodeStyling.borderSize,
                boxSizing = nodeStyling.boxSizing,
                contextStyle = nodeStyling.contextStyle;

            hiddenTextarea.setAttribute('style', contextStyle + ';' + HIDDEN_STYLE);
            hiddenTextarea.value = targetElement.value || targetElement.placeholder || '';

            var height = hiddenTextarea.scrollHeight;

            if (boxSizing === 'border-box') {
                height = height + borderSize;
            } else if (boxSizing === 'content-box') {
                height = height - paddingSize;
            }

            // 不使用最小最大行数，用最小最大高度
            // hiddenTextarea.value = '';
            // let singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;

            // if (minRows !== null) {
            //     let minHeight = singleRowHeight * minRows;
            //     if (boxSizing === 'border-box') {
            //         minHeight = minHeight + paddingSize + borderSize;
            //     }
            //     height = Math.max(minHeight, height);
            //     result.minHeight = `${minHeight}px`;
            // }
            // if (maxRows !== null) {
            //     let maxHeight = singleRowHeight * maxRows;
            //     if (boxSizing === 'border-box') {
            //         maxHeight = maxHeight + paddingSize + borderSize;
            //     }
            //     height = Math.min(maxHeight, height);
            // }
            height = Math.max(minHeight, Math.min(maxHeight, height));

            hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
            hiddenTextarea = null;
            return height;

            function calculateNodeStyling(targetElement) {
                var style = window.getComputedStyle(targetElement);

                var boxSizing = style.getPropertyValue('box-sizing');

                var paddingSize =
                    parseFloat(style.getPropertyValue('padding-bottom')) +
                    parseFloat(style.getPropertyValue('padding-top'));

                var borderSize =
                    parseFloat(style.getPropertyValue('border-bottom-width')) +
                    parseFloat(style.getPropertyValue('border-top-width'));

                var contextStyle = CONTEXT_STYLE.map(function (name) {
                    return name + ':' + style.getPropertyValue(name);
                }).join(';');

                return {
                    contextStyle: contextStyle,
                    paddingSize: paddingSize,
                    borderSize: borderSize,
                    boxSizing: boxSizing
                };
            }
        },
        getExtraAttrs: function (el) {
            var attrs = mini.TextArea.superclass.getExtraAttrs ? mini.TextArea.superclass.getExtraAttrs.call(this, el) :  {};
            mini._ParseBool(el, attrs, ['autoSize']);
            mini._ParseInt(el, attrs, ['maxHeight']);
            return attrs;
        }
    };
});

// 为弹出的 listBox 新增 Y 方向间隙
mini.addEpointExt('TextBoxList', function() {
    return {
        popupYOffset: 2,
        showPopup: function(action) {
            if (this.isDisplay() == false) return;
            this.isShowPopup = true;

            var popup = this._createPopup();

            popup.el.style.zIndex = mini.getMaxZIndex();
            var control = this._listbox;
            control.emptyText = this.popupEmptyText;

            //action = "loading";
            if (action == 'loading') {
                control.emptyText = this.popupLoadingText;
                this._listbox.setData([]);
            } else if (action == 'error') {
                control.emptyText = this.popupLoadingText;
                this._listbox.setData([]);
            }
            this._listbox.doUpdate();

            var box = this.getBox();
            var x = box.x,
                y = box.y + box.height;

            this.popup.el.style.display = 'block';
            mini.setXY(popup.el, -1000, -1000);
            this.popup.setWidth(box.width);

            this.popup.setHeight(this.popupHeight);

            var h = this.popup.getHeight();

            if (h > this.popupMaxHeight) {
                this.popup.setHeight(this.popupMaxHeight);
            }
            if (h < this.popupMinHeight) {
                this.popup.setHeight(this.popupMinHeight);
            }
            mini.setXY(popup.el, x, y + this.popupYOffset);
        },
        errorTextEl: null,
        getErrorTextEl: function () {
            if (!this.errorTextEl) {
                this.errorTextEl = mini.append(this.el, '<span class="mini-errorText"></span>');
            }
            return this.errorTextEl;
        },
        _RemoveErrorText: function () {
            if (this.errorTextEl) {
                var el = this.errorTextEl;
                jQuery(el).remove();
            }
            this.errorTextEl = null;
        }
    };
});

mini.addEpointExt('TimeSpinner', function() {
    return {
        timeType: 'hours',
        _timeType: 'hours',
        setTimeType: function(timeType){
            this.timeType = this._timeType = timeType;
        },
        increment: 1,
        setIncrement: function (value) {
            value = parseFloat(value);
            if (isNaN(value)) return;
            if (this.increment != value) {
                this.increment = value;
            }
        },
        __OnButtonMouseDown: function (e) {
            this._DownValue = this.getFormValue();
            // this._timeType = "hours";
            if (e.spinType == "up") {
                this._StartSpin(this.increment, 230, 2);
            } else {
                this._StartSpin(-this.increment, 230, 2);
            }
        },
        _ChangeValue: function (increment, timeType) {
            var value = this.getValue(),
                newValue;
            if (value) {
                switch (timeType) {
                    default:
                    case 'hours':
                        newValue = mini.addDate(value, increment, 'H');
                        break;
                    case 'minutes':
                        newValue = mini.addDate(value, increment, 'M');
                        break;
                    case 'seconds':
                        newValue = mini.addDate(value, increment, 'S');
                        break;
                }
                if(newValue.getDate() > 1) {
                    newValue = value;
                } else {
                    value = newValue;
                }
            } else {
                value = '00:00:00';
            }
    
            this.setValue(value);
            //this._OnValueChanged();
        },
        getExtraAttrs: function (el) {
            var attrs = {};

            mini._ParseString(el, attrs, ['timeType', 'increment']);

            return attrs;
        }
    };
});
mini.addEpointExt('ToolTip', function() {
    return {
        autoHide: true,
        theme: 'dark',
        defaultTheme: 'dark',
        setTheme: function(theme) {
            if (!theme) return;
            this.theme = theme;
            // mini-tooltip-theme-*
            var themePrefix = 'mini-tooltip-theme-';

            var oldThemeCls = jQuery
                .grep(this.el.className.split(' '), function(cls) {
                    return cls.indexOf(themePrefix) != -1 ? true : false;
                })
                .join(' ');

            jQuery(this.el)
                .removeClass(oldThemeCls)
                .addClass(themePrefix + theme);
        },
        getTheme: function() {
            return this.theme;
        },
        applyTheme: function() {
            if (!this._target) return;
            var theme = jQuery(this._target).attr('data-theme');

            this.setTheme(theme || this.defaultTheme);
        },
        setContent: function(value) {
            this.$element.children('.mini-tooltip-inner').html(value || '&nbsp;');
            this.applyPlacement();
            this.applyTheme();
        },
        open: function(target) {
            target = jQuery(target)[0] || this.target;
            var content = this.getContent(target);

            var e = { element: target, content: content, cancel: false };

            // 若无内容 或 目标元素不可见 默认不会显示
            if (!content || !jQuery(target).is(':visible')) {
                e.cancel = true;
            }

            this.fire('beforeopen', e);
            if (e.cancel) return;

            this.$element.css('z-index', mini.getMaxZIndex()).show();

            this._target = target;

            try {
                this.setContent(e.content);
            } catch (ex) {}

            this.fire('open', { element: target });
        },
        // 增加对autoHide的判断
        _bindTooltip: function() {
            var jq = jQuery(this.scope || document),
                selector = this.selector,
                type = 'tooltip-' + this.uid;
            this.setTheme(this.theme);

            jq.unbind('.' + type);

            var triggers = this.trigger.split(' ');

            for (var i = triggers.length; i--;) {
                var trigger = triggers[i];

                if (trigger == 'click') {
                    jq.on('click.' + type, selector, jQuery.proxy(this._toggle, this));
                } else if (trigger != 'manual') {
                    var eventIn = trigger == 'hover' ? 'mouseenter' : 'focus';
                    var eventOut = trigger == 'hover' ? 'mouseleave' : 'blur';

                    jq.on(eventIn + '.' + type, selector, jQuery.proxy(this._enter, this));

                    // for 招投标
                    // 如果autoHide不为true，则不添加eventOut时的自动隐藏，而通过close方法来隐藏。
                    if (this.autoHide) {
                        jq.on(eventOut + '.' + type, selector, jQuery.proxy(this._leave, this));
                    }
                }
            }
        },
        // 源码中有问题，_getTip、enter、leave这三个方法都没有
        // 这里重新实现
        _toggle: function(e) {
            // if (this._getTip().css("display") == 'none') {
            //     this.enter(e);
            // } else {
            //     this.leave(e);
            // }

            if (this.$element.css('display') == 'none') {
                this._enter(e);
            } else {
                this._leave(e);
            }
        },
        // 源码中边界处理不完善，这里补充所有上下边界的情况
        applyPlacement: function() {
            if (!this._target) return;
            if (this.$element.css('display') == 'none') return;
            var target = this._target,
                jq = jQuery(target),
                placement = jq.attr('data-placement') || this.placement,
                tip = this.$element;

            if (!target || !tip[0]) return;

            tip.show().css({
                left: '-2000px',
                top: '-2000px'
            });

            function applyCls(placement) {
                tip.removeClass(
                    'mini-tooltip-left mini-tooltip-top mini-tooltip-right mini-tooltip-bottom mini-tooltip-bottomleft mini-tooltip-topleft mini-tooltip-bottomright mini-tooltip-topright'
                ).addClass('mini-tooltip-' + placement);
            }

            function applyPos(pos) {
                tip.offset(pos);
            }

            //
            var box = mini.getBox(target);
            var vbox = mini.getViewportBox();
            var topspace = box.top - vbox.top,
                bottomspace = vbox.height - box.bottom,
                leftspace = box.left - vbox.left,
                rightspace = vbox.right - box.right;

            applyCls(placement);

            var tipbox = mini.getBox(tip[0]);
            var pos = mini.getCalculatedOffset(placement, box, tipbox.width, tipbox.height);

            //边界处理
            // if (placement == "left") {
            // } else if (placement == "right") {
            // } else if (placement == "top") {
            // } else if (placement == "bottom") {

            // } else if (placement == "bottomleft" && topspace > bottomspace) {

            //     if (pos.top + tipbox.height > vbox.bottom) {
            //         placement = "topleft";
            //     }
            // } else if (placement == "topleft") {

            // }

            if (placement.indexOf('bottom') === 0) {
                if (topspace > bottomspace && pos.top + tipbox.height > vbox.height) {
                    placement = placement.replace('bottom', 'top');
                }
            } else if (placement.indexOf('top') === 0) {
                if (topspace < bottomspace && pos.top < vbox.top) {
                    placement = placement.replace('top', 'bottom');
                }
            }

            if (placement.indexOf('left') !== -1) {
                // 左边空白多 且显示不下 则让箭头由左边变成右边，让内容出现在左边。
                if (leftspace > rightspace && tipbox.width + pos.left > vbox.width) {
                    placement = placement.replace('left', 'right');
                }
            } else if (placement.indexOf('right') !== -1) {
                // 右边空白多 且 （ 位置不可见 或 左边显示下 ） 则箭头变左边，内容出现在右边
                if (leftspace < rightspace && (pos.left < 0 || box.left + box.width < tipbox.wihth)) {
                    placement = placement.replace('right', 'left');
                }
            }

            // 只指定上下，还需考虑左右是否显示得下
            if (placement === 'bottom' || placement === 'top') {
                // 左边空白多 且显示不下 则让箭头由左边变成右边，让内容出现在左边。
                if (leftspace > rightspace && tipbox.width + pos.left > vbox.width) {
                    placement += 'right';
                } else if (leftspace < rightspace && (pos.left < 0 || box.left + box.width < tipbox.wihth)) {
                    placement += 'left';
                }
            }

            applyCls(placement);
            pos = mini.getCalculatedOffset(placement, box, tipbox.width, tipbox.height);

            if (pos.left < 8) {
                pos.left = 8;
            }

            if (placement == 'right' || placement == 'left') {
                var arrow = $(tip).children('.mini-tooltip-arrow');
                arrow.css('top', '');
                /* eslint-disable-next-line */
                function centerArrow() {
                    var top = box.top + box.height / 2 - arrow.height() / 2;

                    var y = top - pos.top;
                    arrow.css('top', y);
                }

                vbox = mini.getViewportBox();
                if (pos.top < vbox.y) {
                    pos.top = vbox.y;
                    centerArrow();
                } else if (pos.top + tipbox.height > vbox.bottom) {
                    pos.top = vbox.bottom - tipbox.height;
                    centerArrow();
                }
            }

            applyPos(pos);

            tipbox = mini.getBox(tip[0]);
            if (placement.indexOf('bottom') === 0) {
                if (tipbox.height + pos.top >= vbox.height) {
                    tip.css('bottom', '8px');
                }
            } else if (placement.indexOf('top') === 0) {
                if (tipbox.height + pos.bottom >= vbox.height) {
                    tip.css('top', '8px');
                }
            }
        },
        setAutoHide: function(value) {
            if (this.autoHide != value) {
                this.autoHide = value;
                this._bindTooltip();
            }
        },
        getAutoHide: function() {
            return this.autoHide;
        },
        getExtraAttrs: function(el) {
            var attrs = {};

            mini._ParseString(el, attrs, ['theme']);
            mini._ParseBool(el, attrs, ['autoHide']);

            return attrs;
        }
    };
});
mini.addEpointExt('Tree', function() {
    return {
        autoLoad: false
    };
});

mini.addEpointExt('TreeGrid', function() {
    return {
        showHGridLines: true,
        showVGridLines: false,
        showSortIcon: true,
        dataField: 'data',
        autoLoad: false,
        resultAsTree: false,
        _setEditorBox: function(editor, cellBox) {
            mini.DataGrid.prototype._setEditorBox.call(this, editor, cellBox);
        },
        getAllSelecteds: function () {
            return this.getSelecteds();
        }
    };
});

// tree
mini.addEpointExt('DataTree', function() {
    return {
        loadNode: function(node, expand) {
            this._loadingNode = node;
            var e = { 
                node: node,
                cancel: false
            };
            this.fire('beforeloadnode', e);
            //
            // 添加外部可以自己实现展开节点请求数据的逻辑
            if(e.cancel === true) {
                return;
            }
            var time = new Date();

            var me = this;
            me._doLoadAjax(
                me.loadParams,
                null,
                null,
                null,
                function(e) {
                    var t = new Date() - time;
                    if (t < 60) t = 60 - t;

                    setTimeout(function() {
                        //success
                        e.node = node;
                        me._OnPreLoad(e);

                        //e.node = me._loadingNode;
                        me._loadingNode = null;
                        if (me.loadParams) delete me.loadParams[me.idField];

                        var oldNodes = node[me.nodesField];
                        me.removeNodes(oldNodes);

                        var nodes = e.data;
                        if (nodes && nodes.length > 0) {
                            me.collapse(node); //addNodes之前    优化！！！

                            me.addNodes(nodes, node);

                            //清楚新增痕迹
                            var all = me.getAllChildNodes(node);
                            for (var i = 0, l = all.length; i < l; i++) {
                                var treeNode = all[i];
                                //me.acceptRecord(treeNode);
                                delete treeNode._state; //优化！！！
                            }

                            if (expand !== false) {
                                me.expand(node, true);
                            } else {
                                me.collapse(node, true);
                            }
                        } else {
                            delete node[me.leafField];
                            me.expand(node, true);
                        }

                        me.fire('loadnode', e);
                        me.fire('load', e);
                        // }, t);
                        // 上面的t不知miniui的用意，但是会造成如果ajax请求时间比较长的话，t会很大，造成延迟执行的时间也很长
                    }, 10);
                },
                true
            );
        }
    };
});

mini.addEpointExt('Tree', function() {
    // 树的 loading 实现优化
    (function(win, $) {
        // svg 动画 IE 89 不支持 不用优化
        if (mini.isIE8 || mini.isIE9) {
            return;
        }
        // 展开loading
        var loadingSvg = '<svg class="mini-tree-loading-icon" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" width="128" height="128" fill="currentColor" ><path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path></svg>';
        var oldCreateTreeColumn = mini.TreeGrid.prototype._createTreeColumn;
        // miniui 源码中 tree 和 treeGrid 在一个文件中 因此都需要修改
        mini.Tree.prototype._createTreeColumn = mini.TreeGrid.prototype._createTreeColumn = function(e) {
            var returnValue = oldCreateTreeColumn.apply(this, arguments);
            // 注入loading
            var $cell = $(e.cellHtml);
            if ($cell.hasClass('mini-tree-parentNode')) {
                $cell.find('>.mini-tree-node-ecicon').append(loadingSvg);
                e.cellHtml = $cell[0].outerHTML;
            }
            // title实现
            if(this.showCellTip === true) {
                var $text = $cell.find('.mini-tree-nodetext');
                $text.attr('title', jQuery.trim($text.text()));
                e.cellHtml = $cell[0].outerHTML;
            }
            return returnValue;
        };

        mini.Tree.prototype.__OnBeforeLoadNode = mini.TreeGrid.prototype.__OnBeforeLoadNode = function(e) {
            this.__showLoading = this.showLoading;
            this.showLoading = false;
            // 加载速度很快就不用出现loading了
            clearTimeout(this.__loadingTimer);
            var that = this;
            this.__loadingTimer = setTimeout(function() {
                that.addNodeCls(e.node, 'mini-tree-loading');
            }, 100);
            // this.addNodeCls(e.node, "mini-tree-loading");
            this.fire('beforeloadnode', e);
        };
        mini.Tree.prototype.__OnLoadNode = mini.TreeGrid.prototype.__OnLoadNode = function(e) {
            clearTimeout(this.__loadingTimer);
            this.showLoading = this.__showLoading;
            this.removeNodeCls(e.node, 'mini-tree-loading');
            this.fire('loadnode', e);
        };
    })(window, window.jQuery);

    return {
        showTreeLines: false,
        showFullPath: false,
        fullPathDelimiter: '-',
        includeRootNode: false,
        allowAlternating: false,
        // _afterApply: function() {
        //     this.on(
        //         'update',
        //         function() {
        //             // 为树节点上加入 title
        //             if (this.showCellTip !== true) return;
        //             jQuery(this._contentEl)
        //                 .find('.mini-tree-nodetext')
        //                 .each(function(i, el) {
        //                     if (el.title) return;
        //                     el.title = jQuery.trim(el.textContent || el.innerText);
        //                 });
        //         },
        //         this
        //     );
        // },
        setShowFullPath: function (v) {
            this.showFullPath = !!v;
        },
        getShowFullPath: function () {
            return this.showFullPath;  
        },
        replaceNodes: function(nodes, node) {
            var oldNodes = node[this.nodesField];
            this.removeNodes(oldNodes);

            this.addNodes(nodes, node);
        },
        _OnDrawCell: function(record, column, rowIndex, columnIndex) {
            var e = mini.TreeGrid.superclass._OnDrawCell.call(this, record, column, rowIndex, columnIndex);

            if (this._treeColumn && this._treeColumn == column.name) {
                var node = e.node;

                if (node.ckr === false) {
                    e.showCheckBox = false;
                    e.showRadioButton = false;
                }
                this.fire('drawnode', e);
                if (e.nodeStyle) {
                    e.cellStyle = e.nodeStyle;
                }
                if (e.nodeCls) {
                    e.cellCls = e.nodeCls;
                }
                if (e.nodeHtml) {
                    e.cellHtml = e.nodeHtml;
                } else if (node.textCls) {
                    e.cellHtml = '<span class="' + node.textCls + '">' + e.cellHtml + '</span>';
                }

                this._createTreeColumn(e);
            }
            return e;
        },

        getValueAndText: function(records, delimiter) {
            if (mini.isNull(records)) records = [];
            delimiter = delimiter || this.delimiter;

            if (typeof records === 'string' || typeof records === 'number') {
                records = this._dataSource.getsByIds(records);
            } else if (!mini.isArray(records)) {
                records = [records];
            }
            var values = [];
            var texts = [];
            for (var i = 0, l = records.length; i < l; i++) {
                var record = records[i];
                if (record) {
                    values.push(this.getItemValue(record));
                    texts.push(this.getItemText(record));
                }
            }

            return [values.join(delimiter), texts.join(delimiter)];
        },

        getItemValue: function(item) {
            if (!item) return '';
            var t = mini._getMap(this.idField, item);
            return mini.isNull(t) ? '' : String(t);
        },

        getItemText: function(item) {
            if (!item) return '';
            var t = '';
            //var t = item[this.textField];
            if (this.showFullPath) {
                t = this.getFullPath(item);
            } else {
                t = mini._getMap(this.textField, item);
            }

            return mini.isNull(t) ? '' : String(t).replace(/<\/?.+?>/g, '');
        },
        getFullPath: function(item) {
            if (item.fullPath) {
                return item.fullPath;
            }

            var parents = this.getAncestors(item),
                fullPath = '';

            for (var i = 0, l = parents.length; i < l; i++) {
                // 不包含根节点的跳过根节点
                if (i == 0 && !this.includeRootNode) {
                    continue;
                }

                fullPath += mini._getMap(this.textField, parents[i]) + this.fullPathDelimiter;
            }

            item.fullPath = fullPath = fullPath + mini._getMap(this.textField, item);

            return fullPath;
        },
        getText: function(mode) {
            var nodes = [];
            var node;
            if (this.showCheckBox) {
                if (mode === false || !this.canCheckParent) mode = 'leaf';
                nodes = this.getCheckedNodes(mode);
            } else {
                node = this.getSelectedNode();
                if (node) nodes.push(node);
            }

            var sb = [],
                textField = this.getTextField();
            for (var i = 0, l = nodes.length; i < l; i++) {
                node = nodes[i];
                // 去除可能存在的搜索高亮的html标签
                sb.push(node[textField].replace(/<\/?.+?>/g, ''));
            }

            return sb.join(',');
        },
        getExtraAttrs: function (el) {
            var attrs = {};
            mini._ParseString(el, attrs, ['fullPathDelimiter']);

            return attrs;
        }
    };
});

mini.addEpointExt('Window', function() {
    var setVisible = mini.Window.prototype.setVisible;
    var destroy = mini.Window.prototype.destroy;
    var ext = {
        setVisible: function(visible) {
            if (this.lockScroll) {
                if (visible) {
                    $('html,body').addClass('mini-window-lock-scroll');
                } else {
                    $('html,body').removeClass('mini-window-lock-scroll');
                }
            }
            return setVisible.apply(this, arguments);
        },
        destroy: function() {
            $('html,body').removeClass('mini-window-lock-scroll');
            return destroy.apply(this, arguments);
        }
    };

    return ext;
});


mini.Hidden = function () {
    mini.Hidden.superclass.constructor.apply(this, arguments);

}
mini.extend(mini.Hidden, mini.Control, {
    _clearBorder: false,
    formField: true,
    value: "",

    uiCls: "mini-hidden",
    _create: function () {
        this.el = document.createElement("input");
        this.el.type = "hidden";
        this.el.className = "mini-hidden";
    },
    setName: function (value) {

        this.name = value;
        this.el.name = value;
    },
    setValue: function (value) {
        if (value === null || value === undefined) value = "";
        this.value = value;
        if (mini.isDate(value)) {
            var y = value.getFullYear();
            var m = value.getMonth() + 1;
            var d = value.getDate();
            m = m < 10 ? "0" + m : m;
            d = d < 10 ? "0" + d : d;
            this.el.value = y + "-" + m + "-" + d;
        } else {
            this.el.value = value;
        }
    },
    getValue: function () {
        return this.value;
    },
    getFormValue: function () {
        return this.el.value;
    }
});

mini.regClass(mini.Hidden, "hidden");

mini.Popup = function () {
    mini.Popup.superclass.constructor.apply(this, arguments);

    this.setVisible(false);
    this.setAllowDrag(this.allowDrag);
    this.setAllowResize(this.allowResize);
}
mini.extend(mini.Popup, mini.Container, {
    alwaysView: true,
    _clearBorder: false,

    uiCls: "mini-popup",
    _create: function () {
        var el = this.el = document.createElement("div");
        this.el.className = "mini-popup";
        this._contentEl = this.el;
    },

    _initEvents: function () {
        mini._BindEvents(function () {
            mini_onOne(this.el, "mouseover", this.__OnMouseOver, this);

            //mini.on(this.el, "mouseover", this.__OnMouseOver, this);

        }, this);

    },
    doLayout: function () {
        if (!this.canLayout()) return;
        mini.Popup.superclass.doLayout.call(this);

        //mini.layout(this.el);
        var cs = this.el.childNodes;
        if (cs) {
            for (var i = 0, l = cs.length; i < l; i++) {
                var cel = cs[i];
                mini.layout(cel);
            }
        }
    },
    destroy: function (removeEl) {
        if (this.el) {
            this.el.onmouseover = null;
        }

        if (!mini._destroying) {
            mini.un(document, "mousedown", this.__OnBodyMouseDown, this);
            mini.un(window, "resize", this.__OnWindowResize, this);
        }

        if (removeEl !== false) {
            if (this._modalEl) {
                jQuery(this._modalEl).remove();
            }
            if (this.shadowEl) {
                jQuery(this.shadowEl).remove();

            }
            if (this._shimEl) {
                jQuery(this._shimEl).remove();

            }
        }
        this._modalEl = null;
        this.shadowEl = null;
        this._shimEl = null;
        mini.Popup.superclass.destroy.call(this, removeEl);
    },

    setWidth: function (value) {
        if (parseFloat(value) == value) value += "px";
        this.width = value;

        if (value.indexOf("px") != -1) {
            mini.setWidth(this.el, value);
        } else {
            this.el.style.width = value;
        }
        this._sizeChanged();
    },
    setHeight: function (value) {
        if (parseFloat(value) == value) value += "px";
        this.height = value;
        if (value.indexOf("px") != -1) {
            mini.setHeight(this.el, value);
        } else {
            this.el.style.height = value;
        }
        this._sizeChanged();
    },
    setBody: function (value) {
        if (!value) return;
        if (!mini.isArray(value)) value = [value];
        for (var i = 0, l = value.length; i < l; i++) {
            mini.append(this._contentEl, value[i]);
        }
    },
    getAttrs: function (el) {
        var attrs = mini.Popup.superclass.getAttrs.call(this, el);

        mini._ParseString(el, attrs,
            ["popupEl", "popupCls", "showAction", "hideAction", "xAlign", "yAlign", "modalStyle",
            "onbeforeopen", "open", "onbeforeclose", "onclose"
                ]
        );
        mini._ParseBool(el, attrs,
            ["showModal", "showShadow", "allowDrag", "allowResize"
                ]
        );
        mini._ParseInt(el, attrs,
            ["showDelay", "hideDelay", "xOffset", "yOffset",
            "minWidth", "minHeight", "maxWidth", "maxHeight"
                ]
        );
        var cs = mini.getChildNodes(el, true);
        attrs.body = cs;
        return attrs;
    }

});
mini.regClass(mini.Popup, "popup");

///////////////////////////////////////////
mini.Popup_prototype = {
    //_displayStyle: "block",
    isPopup: false, //是否弹出显示

    popupEl: null,
    popupCls: "",

    showAction: "mouseover", //none, leftclick, rightclick, mouseover
    hideAction: "outerclick", //none, outerclick, mouseout
    showDelay: 300,     //针对mouseover
    hideDelay: 500,     //针对mouseout

    xAlign: "left", //none,outleft,left,center,right,outright
    yAlign: "below", //none,above, top, middle, bottom, below
    xOffset: 0,
    yOffset: 0,

    minWidth: 50,
    minHeight: 25,
    maxWidth: 2000,
    maxHeight: 2000,

    showModal: false,
    showShadow: true,

    modalStyle: "opacity:0.2",

    _dragCls: "mini-popup-drag",
    _resizeCls: "mini-popup-resize",
    allowDrag: false,
    allowResize: false,

    _unbindPopupEl: function () {
        if (!this.popupEl) return;
        mini.un(this.popupEl, "click", this.__OnLeftClick, this);
        mini.un(this.popupEl, "contextmenu", this.__OnRightClick, this);
        mini.un(this.popupEl, "mouseover", this.__OnMouseOver, this);

    },
    _bindPopupEl: function () {
        if (!this.popupEl) return;
        mini.on(this.popupEl, "click", this.__OnLeftClick, this);
        mini.on(this.popupEl, "contextmenu", this.__OnRightClick, this);
        mini.on(this.popupEl, "mouseover", this.__OnMouseOver, this);
    },
    doShow: function (e) {
        var ev = {
            popupEl: this.popupEl,
            htmlEvent: e,
            cancel: false
        };

        this.fire("BeforeOpen", ev);
        if (ev.cancel == true) return;

        this.fire("opening", ev);
        if (ev.cancel == true) return;

        if (!this.popupEl) {
            this.show();
        } else {
            var options = {};
            if (e) options.xy = [e.pageX, e.pageY];
            this.showAtEl(this.popupEl, options);
        }
    },
    doHide: function (e) {
        var ev = {
            popupEl: this.popupEl,
            htmlEvent: e,
            cancel: false
        };
        this.fire("BeforeClose", ev);
        if (ev.cancel == true) return;
        this.close();
    },

    show: function (left, top) {

        this.showAtPos(left, top);
    },
    showAtPos: function (x, y) {
        //this._popupEl = null;

        if (!this.isRender()) {
            this.render(document.body);
        }
        if (!x && x !== 0) x = "center";
        if (!y && y !== 0) y = "middle";

        this.el.style.position = "absolute";
        this.el.style.left = "-2000px";
        this.el.style.top = "-2000px";
        this.el.style.display = "";
        // 初次创建popup时，没有执行dolayout方法，导致popup的高度获取不对，此处先执行doLayout
        this.doLayout();
        this._measureSize();

        var vbox = mini.getViewportBox();
        var box = mini.getBox(this.el);


        //x, y的获取        
        if (x == "left") x = 0;
        if (x == 'center') x = vbox.width / 2 - box.width / 2;
        if (x == "right") x = vbox.width - box.width;

        if (y == "top") y = 0;
        if (y == "middle") y = vbox.y + vbox.height / 2 - box.height / 2;
        if (y == "bottom") y = vbox.height - box.height;

        if (x + box.width > vbox.right) x = vbox.right - box.width;
        if (y + box.height > vbox.bottom) y = vbox.bottom - box.height - 2;

        this._Show(x, y);
    },

    _doModal: function () {
        jQuery(this._modalEl).remove();
        if (!this.showModal) return;
        if (this.visible == false) return;

        var dd = document.documentElement;
        var scrollWidth = parseInt(Math.max(document.body.scrollWidth, dd ? dd.scrollWidth : 0));
        var scrollHeight = parseInt(Math.max(document.body.scrollHeight, dd ? dd.scrollHeight : 0));

        var vbox = mini.getViewportBox();
        var height = vbox.height;
        if (height < scrollHeight) height = scrollHeight;

        var width = vbox.width;
        if (width < scrollWidth) width = scrollWidth;

        this._modalEl = mini.append(document.body, '<div class="mini-modal"></div>');
        this._modalEl.style.height = height + "px";
        this._modalEl.style.width = width + "px";
        this._modalEl.style.zIndex = this._zIndex - 1;
        mini.setStyle(this._modalEl, this.modalStyle);
    },
    _doShim: function () {
        //if (!mini.isIE || !mini_useShims) return;
        if (!mini_useShims) return;
        if (!this._shimEl) {
            var iframe = "<iframe frameborder='0' style='position: absolute; z-index: -1; width: 0; height: 0; top: 0;left:0;scrolling:no;'></iframe>";
            this._shimEl = mini.append(document.body, iframe);
        }
        function doShim() {
            this._shimEl.style.display = "";
            var box = mini.getBox(this.el);
            var s = this._shimEl.style;
            s.width = box.width + "px";
            s.height = box.height + "px";
            s.left = box.x + "px";
            s.top = box.y + "px";

            var zindex = jQuery(this.el).css('zIndex');
            if (!isNaN(zindex)) {
                this._shimEl.style.zIndex = zindex - 3;
            }
        }
        this._shimEl.style.display = "none";
        if (this._doShimTimer) {
            clearTimeout(this._doShimTimer);
            this._doShimTimer = null;
        }
        var me = this;
        this._doShimTimer = setTimeout(function () {
            me._doShimTimer = null;
            doShim.call(me);
        }, 20);
    },
    _doShadow: function () {
    },
    _measureSize: function () {
        this.el.style.display = "";
        var box = mini.getBox(this.el);
        //min, max
        if (box.width > this.maxWidth) {
            mini.setWidth(this.el, this.maxWidth);
            box = mini.getBox(this.el);
        }
        if (box.height > this.maxHeight) {
            mini.setHeight(this.el, this.maxHeight);
            box = mini.getBox(this.el);
        }
        if (box.width < this.minWidth) {
            mini.setWidth(this.el, this.minWidth);
            box = mini.getBox(this.el);
        }
        if (box.height < this.minHeight) {
            mini.setHeight(this.el, this.minHeight);
            box = mini.getBox(this.el);
        }
    },
    _getWindowOffset: function (options) {
        return [0, 0];
    },
    showAtEl: function (el, options) {
        
        el = mini.byId(el);
        if (!el) return;
        if (!this.isRender() || this.el.parentNode != document.body) {
            this.render(document.body);
        }

        var c = {
            atEl: el,
            popupEl: this.el,
            xAlign: this.xAlign,
            yAlign: this.yAlign,
            xOffset: this.xOffset,
            yOffset: this.yOffset,
            popupCls: this.popupCls,
            alwaysView: this.alwaysView,
            outXAlign: this.outXAlign,
            outYAlign: this.outYAlign
        };
        mini.copyTo(c, options);

        mini.addClass(el, c.popupCls);
        el.popupCls = c.popupCls;
        this._popupEl = el;
        
        this.el.style.position = "absolute";
        this.el.style.left = "-2000px";
        this.el.style.top = "-2000px";
        this.el.style.display = "";

        this.doLayout();
        this._measureSize();

        var vbox = mini.getViewportBox();
        var box = mini.getBox(this.el);
        var pbox = mini.getBox(el);
        var xy = c.xy;
        var h = c.xAlign, v = c.yAlign;

        var x = vbox.width / 2 - box.width / 2, y = 0;
        if (xy) {
            x = xy[0];
            y = xy[1];
        }

        switch (c.xAlign) {
            case "outleft":
                x = pbox.x - box.width;
                break;
            case "left":
                x = pbox.x;
                break;
            case "center":
                x = pbox.x + pbox.width / 2 - box.width / 2;
                break;
            case "right":
                x = pbox.right - box.width;
                break;
            case "outright":
                x = pbox.right;
                break;
            default:

                break;
        }

        switch (c.yAlign) {
            case "above":
                y = pbox.y - box.height;
                break;
            case "top":
                y = pbox.y;
                break;
            case "middle":
                y = pbox.y + pbox.height / 2 - box.height / 2;
                break;
            case "bottom":
                y = pbox.bottom - box.height;
                break;
            case "below":
                y = pbox.bottom;
                break;
            default:

                break;
        }
        x = parseInt(x);
        y = parseInt(y);

        var winOffset = this._getWindowOffset(options);

        if (c.outYAlign || c.outXAlign) {
            if (c.outYAlign == "above") {
                if (y + box.height > vbox.height) {
                    y = pbox.y - box.height;
                    c.yOffset = -c.yOffset;
                }
                // if (y + box.height > vbox.bottom) {
                //     var top = pbox.y - vbox.y;
                //     var bottom = vbox.bottom - pbox.bottom;
                //     if (top > bottom) {
                //         y = pbox.y - box.height;
                //     }
                // }
            }

            if (c.outYAlign == "below") {
                if (y < 0) {
                    y = pbox.bottom;
                    c.yOffset = -c.yOffset;
                }
                // if (y + box.height > vbox.bottom) {
                //     var top = pbox.y - vbox.y;
                //     var bottom = vbox.bottom - pbox.bottom;
                //     if (top > bottom) {

                //         //y = pbox.y + pbox.height - box.height;        //old
                //         y = pbox.y - box.height;                       //fkq fixed!
                //     }
                // }
            }
            if (c.outXAlign == "outleft") {
                if (x + box.width > vbox.right) {
                    var left = pbox.x - vbox.x;
                    var right = vbox.right - pbox.right;
                    if (left > right) {
                        x = pbox.x - box.width;
                        c.yOffset = -c.yOffset;
                    }
                }
            }
            if (c.outXAlign == "outright") {
                if (x < 0) {
                    var left = pbox.x - vbox.x;
                    var right = vbox.right - pbox.right;
                    if (left < right) {
                        x = pbox.right;
                        c.xOffset = -c.xOffset;
                    }
                }
            }

            if (c.alwaysView) {

                if (y < 0) y = 0;

                if (y + box.height > vbox.height) y = vbox.height - box.height;

                if (x < 0) x = 0;

                if (x + box.width > vbox.right) x = vbox.right - box.width;
            }

            this._Show(x + c.xOffset + winOffset[0], y + c.yOffset + winOffset[1]);
        } else {
            this.showAtPos(x + c.xOffset + winOffset[0], y + c.yOffset + winOffset[1]);
        }
    },
    _Show: function (x, y) {
        this.el.style.display = "";
        this.el.style.zIndex = this._zIndex = mini.getMaxZIndex();
        mini.setX(this.el, x);
        mini.setY(this.el, y);

        this.setVisible(true);

        if (this.hideAction == "mouseout") {
            mini.on(document, "mousemove", this.__OnBodyMouseMove, this);
        }
        var sf = this;

        this._doModal();

        //_shim
        this._doShim();

        mini.layoutIFrames(this.el);
        //mini.repaint(this.el);
        this.isPopup = true;

        //mini.on(document, "topmousedown", this.__OnBodyMouseDown, this);

        mini.on(document, "mousedown", this.__OnBodyMouseDown, this);
        //mini.on(document, "mousewheel", this.__OnBodyMouseWheel, this);
        mini.on(window, "resize", this.__OnWindowResize, this);

        this.fire("Open");
    },
    open: function () {
        this.show();
    },
    close: function () {
        this.hide();
    },
    hide: function () {

        if (!this.el) return;
        if (this.popupEl) mini.removeClass(this.popupEl, this.popupEl.popupCls);
        if (this._popupEl) mini.removeClass(this._popupEl, this._popupEl.popupCls);
        this._popupEl = null;
        jQuery(this._modalEl).remove();
        //jQuery(this.shadowEl).remove();
        if (this.shadowEl) this.shadowEl.style.display = "none";
        if (this._shimEl) this._shimEl.style.display = "none";
        mini.un(document, "mousemove", this.__OnBodyMouseMove, this);
        mini.un(document, "mousedown", this.__OnBodyMouseDown, this);
        //mini.un(document, "topmousedown", this.__OnBodyMouseDown, this);
        mini.un(window, "resize", this.__OnWindowResize, this);

        this.setVisible(false);

        this.isPopup = false;


        this.fire("Close");
    },

    setPopupEl: function (el) {
        el = mini.byId(el);
        if (!el) return;
        this._unbindPopupEl();
        this.popupEl = el;
        this._bindPopupEl();
    },

    setPopupCls: function (value) {
        this.popupCls = value;
    },
    setShowAction: function (value) {
        this.showAction = value;
    },
    setHideAction: function (value) {
        this.hideAction = value;
    },
    setShowDelay: function (value) {
        this.showDelay = value;
    },
    setHideDelay: function (value) {
        this.hideDelay = value;
    },

    setXAlign: function (value) {
        this.xAlign = value;
    },
    setYAlign: function (value) {
        this.yAlign = value;
    },
    setxOffset: function (value) {
        value = parseInt(value);
        if (isNaN(value)) value = 0;
        this.xOffset = value;
    },
    setyOffset: function (value) {
        value = parseInt(value);
        if (isNaN(value)) value = 0;
        this.yOffset = value;
    },

    setShowModal: function (value) {
        this.showModal = value;
    },
    setShowShadow: function (value) {

        this.showShadow = value;
    },

    setMinWidth: function (value) {
        if (isNaN(value)) return;
        this.minWidth = value;
    },
    setMinHeight: function (value) {
        if (isNaN(value)) return;
        this.minHeight = value;
    },
    setMaxWidth: function (value) {
        if (isNaN(value)) return;
        this.maxWidth = value;
    },
    setMaxHeight: function (value) {
        if (isNaN(value)) return;
        this.maxHeight = value;
    },

    setAllowDrag: function (value) {
        this.allowDrag = value;
        mini.removeClass(this.el, this._dragCls);
        if (value) {
            mini.addClass(this.el, this._dragCls);
        }
    },
    setAllowResize: function (value) {
        this.allowResize = value;
        mini.removeClass(this.el, this._resizeCls);
        if (value) {
            mini.addClass(this.el, this._resizeCls);
        }
    },
    /////////////////////////////////

    __OnLeftClick: function (e) {
        if (this._inAniming) return;
        if (this.showAction != "leftclick") return;
        var allowPopup = jQuery(this.popupEl).attr("allowPopup");
        if (String(allowPopup) == "false") return;
        this.doShow(e);
    },
    __OnRightClick: function (e) {
        if (this._inAniming) return;
        if (this.showAction != "rightclick") return;
        var allowPopup = jQuery(this.popupEl).attr("allowPopup");
        if (String(allowPopup) == "false") return;

        e.preventDefault();
        this.doShow(e);

    },
    __OnMouseOver: function (e) {
        if (this._inAniming) return;
        if (this.showAction != "mouseover") return;
        var allowPopup = jQuery(this.popupEl).attr("allowPopup");
        if (String(allowPopup) == "false") return;

        clearTimeout(this._hideTimer);
        this._hideTimer = null;


        if (this.isPopup) return;


        var sf = this;
        this._showTimer = setTimeout(function () {
            sf.doShow(e);
        }, this.showDelay);
    },
    __OnBodyMouseMove: function (e) {
        if (this.hideAction != "mouseout") return;
        this._tryHide(e);
    },

    __OnBodyMouseDown: function (e) {
        if (this.hideAction != "outerclick") return;
        if (!this.isPopup) return;

        //return;
        if (jQuery(e.target).closest(this.el)[0]) return;

        if (this.within(e)
        //if (mini.isAncestor(this.el, e.target)
            || (this.popupEl && mini.isAncestor(this.popupEl, e.target))
        ) {
        } else {
            this.doHide(e);
        }
    },
    _tryHide: function (e) {
        if (mini.isAncestor(this.el, e.target)
            || (this.popupEl && mini.isAncestor(this.popupEl, e.target))
        ) {
        } else {
            clearTimeout(this._showTimer);
            this._showTimer = null;
            if (this._hideTimer) return;

            var sf = this;
            this._hideTimer = setTimeout(function () {
                sf.doHide(e);
            }, this.hideDelay);

        }
    },
    __OnWindowResize: function (e) {
        if (this.isDisplay() && !mini.isIE6) {
            this._doModal();
        }
    },
    within: function (e) {
        if (mini.isAncestor(this.el, e.target)) return true;
        var controls = mini.getChildControls(this);

        for (var i = 0, l = controls.length; i < l; i++) {
            var c = controls[i];
            //if (mini.isAncestor(c.el, e.target)) return true;
            if (c.within(e)) return true;
        }

        return false;
    }
};

mini.copyTo(mini.Popup.prototype, mini.Popup_prototype);


/////////////////////////////////////////////////////////////////////////////////////////////////////

//function hideAllPopup() {
//    var jq = $(".mini-popup, .mini-menu");
//    jq.each(function () {
//    
//        var popup = mini.get(this);
//        if (popup && popup.visible) popup.hide();
//    });
//}

//if (hasOn) {
//    var topWin = mini.getTopWindow();
//    if (topWin) {
//        jQuery(topWin.document).on("topmousedown", function (event, doc) {

//            ///if(location.href.indexOf("menubar.html") != -1) alert(123)

//            //if(location.href.indexOf("menubar") != -1) debugger
//            //hideAllPopup();

//            if (doc == document) {
//                //if (location.href.indexOf("menubar.html") != -1) alert(123)
//            } else {
//                //if (location.href.indexOf("menubar.html") != -1) alert(222)
//                jQuery(document).trigger("mousedown");
//            }
//        });
//        jQuery(document).on("mousedown", function (event) {
//            //try{
//            var $ = topWin.jQuery;
//            if ($) {
//                $(topWin.document).trigger("topmousedown", [document]);
//            }
//        });
//    }

//}

(function () {
if (hasOn) {
    var topWin = mini.getTopWindow();
    if (topWin) {
        function _topmousedown(event, doc) {
            if (doc == document) {
            } else {
                jQuery(document).trigger("mousedown");
            }
        }
        jQuery(topWin.document).on("topmousedown", _topmousedown);

        function _mousedown(event) {
            var $ = topWin.jQuery;
            if ($) {
                $(topWin.document).trigger("topmousedown", [document]);
            }
        }
        jQuery(document).on("mousedown", _mousedown);


        jQuery(window).on("unload", function () {
            jQuery(topWin.document).off("topmousedown", _topmousedown);
            jQuery(document).off("mousedown", _mousedown);
        });
    }
}

})();


//mini.Button = mini.Control.extend({
//    type: 'button',
//    tag: '',
//    init: function () {
//        
//    }
//});

mini.Button = function () {
    
    mini.Button.superclass.constructor.apply(this, arguments);

}

mini.extend(mini.Button, mini.Control, {
    //_tagName: "a",

    text: "",
    iconCls: "",
    iconStyle: "",
    plain: false,

    checkOnClick: false,
    checked: false,
    groupName: "",

    img: "",

    _plainCls: "mini-button-plain",
    _hoverCls: "mini-button-hover",
    _pressedCls: "mini-button-pressed",
    _checkedCls: "mini-button-checked",
    _disabledCls: "mini-button-disabled",

    allowCls: "",

    _clearBorder: false,

    set: function (kv) {
        if (typeof kv == 'string') {
            return this;
        }

        this._allowUpdate = kv.text || kv.iconStyle || kv.iconCls || kv.iconPosition;

        mini.Button.superclass.set.call(this, kv);

        if (this._allowUpdate === false) {
            this._allowUpdate = true;
            this.doUpdate();
        }

        return this;
    },
    uiCls: "mini-button",
    _create: function () {
        this.el = document.createElement("a");

        this.el.className = "mini-button mini-state-default mini-corner-all";
        this.el.hideFocus = true;
        this.el.href = "javascript:void(0)";
        //this.el.onclick = function () { return false; };

        this.doUpdate();
    },
    _initEvents: function () {
        mini._BindEvents(function () {
            mini_onOne(this.el, "mousedown", this.__OnMouseDown, this);
            mini_onOne(this.el, "click", this.__OnClick, this);

            //            mini.on(this.el, "mousedown", this.__OnMouseDown, this);
            //            mini.on(this.el, "click", this.__OnClick, this);

            //            var jq = jQuery(this.el);
            //            jq.hover(function () {
            //                jq.addClass("mini-state-hover");
            //            },
            //            function () {
            //                jq.addClass("mini-state-hover");
            //            });
        }, this);
    },

    //    init: function () {
    //        var me = this;
    //        if (me.plain) me.setPlain(true);
    //    },

    destroy: function (removeEl) {
        if (this.el) {
            this.el.onclick = null;
            this.el.onmousedown = null;
        }
        if (this.menu) this.menu.owner = null;
        this.menu = null;

        //$(this.el).off();
        //$(this.el).remove();
        //this.el = null;
        //        this.destroyed = true;

        mini.Button.superclass.destroy.call(this, removeEl);
    },

    doUpdate: function () {
        if (this._allowUpdate === false) return;
        //var jq = jQuery(this.el);

        var cls = "", text = this.text;
        var hasIcon = this.iconStyle || this.iconCls || this.img;

        if (hasIcon && text) {
            cls = " mini-button-icon-text ";
        } else if (hasIcon && text === "") {
            cls = " mini-button-icon-only ";
            text = "&nbsp;";
        } else {
            if (text == "") text = "&nbsp;";
        }

        var iconStyle = this.iconStyle || "";
        if (!iconStyle && this.img) iconStyle = 'background-image:url(' + this.img + ')';

        //icon作为独立span加入到mini-button-text内
        var iconHtml = '';
        if (hasIcon) {
            iconHtml = '<span class="mini-button-icon mini-icon mini-iconfont ' + this.iconCls + '" style="' + iconStyle + '"></span>';
        }

        //iconHtml = "";

        text = '<span class="mini-button-text">' + text + '</span>';
        var s = '<span class="mini-button-inner ' + cls + '">' + iconHtml + text + '</span>';
        //var s = '<span class="mini-button-text ' + cls + '">' + text + '</span>' + iconHtml;

        if (this.allowCls) {
            s = s + '<span class="mini-button-allow mini-icon ' + this.allowCls + '"></span>';
        }
        //this.el.innerHTML = '<i></i>' + s;
        this.el.innerHTML = s;

    },
    href: "",
    setHref: function (value) {
        this.href = value;
        this.el.href = value;
        var el = this.el;
        setTimeout(function () {
            el.onclick = null;
        }, 100);
    },
    getHref: function () {
        return this.href;
    },
    target: "",
    setTarget: function (value) {
        this.target = value;
        this.el.target = value;
    },
    getTarget: function () {
        return this.target;
    },
    setText: function (value) {
        if (this.text != value) {
            this.text = value;
            this.doUpdate();
        }
    },
    getText: function () {
        return this.text;
    },
    setIconCls: function (value) {
        this.iconCls = value;
        this.doUpdate();
    },
    getIconCls: function () {
        return this.iconCls;
    },
    setIconStyle: function (value) {
        this.iconStyle = value;
        this.doUpdate();
    },
    getIconStyle: function () {
        return this.iconStyle;
    },

    setImg: function (value) {
        this.img = value;
        this.doUpdate();
    },
    getImg: function () {
        return this.img;
    },
    setIconPosition: function (value) {
        this.iconPosition = "left";
        this.doUpdate();
    },
    getIconPosition: function () {
        return this.iconPosition;
    },

    setPlain: function (value) {
        this.plain = value;
        if (value) this.addCls(this._plainCls);
        else this.removeCls(this._plainCls);
    },
    getPlain: function () {
        return this.plain;
    },
    setGroupName: function (value) {
        this.groupName = value;
    },
    getGroupName: function () {
        return this.groupName;
    },
    setCheckOnClick: function (value) {
        this.checkOnClick = value;
    },
    getCheckOnClick: function () {
        return this.checkOnClick;
    },
    setChecked: function (value) {

        var fire = this.checked != value;
        this.checked = value;
        if (value) this.addCls(this._checkedCls);
        else this.removeCls(this._checkedCls);
        if (fire) {
            this.fire("CheckedChanged");
        }
    },
    getChecked: function () {
        return this.checked;
    },
    doClick: function () {
        this.__OnClick(null);
    },
    /////////////////////////
    __OnClick: function (e) {
        if (!this.href && e) {
            e.preventDefault();
        }
        if (this.readOnly || this.enabled == false) return;
        this.focus();
        if (this.checkOnClick) {
            if (this.groupName) {
                var groupName = this.groupName;
                var buttons = mini.findControls(function (control) {
                    if (control.type == "button" && control.groupName == groupName) return true;
                });
                if (buttons.length > 0) {
                    for (var i = 0, l = buttons.length; i < l; i++) {
                        var button = buttons[i];
                        if (button != this) button.setChecked(false);
                    }
                    this.setChecked(true);
                } else {
                    this.setChecked(!this.checked);
                }
            } else {
                this.setChecked(!this.checked);
            }
        }

        this.fire("click", {
            htmlEvent: e
        });
        //return false;
    },
    __OnMouseDown: function (e) {
        if (this.isReadOnly()) return;

        this.addCls(this._pressedCls);
        mini.on(document, "mouseup", this.__OnDocMouseUp, this);
    },
    __OnDocMouseUp: function (e) {
        this.removeCls(this._pressedCls);
        mini.un(document, "mouseup", this.__OnDocMouseUp, this);
    },
    onClick: function (fn, scope) {
        this.on("click", fn, scope);
    },
    ////////////////////////////////
    getAttrs: function (el) {
        var attrs = mini.Button.superclass.getAttrs.call(this, el);
        //return attrs;
        attrs.text = el.innerHTML;
        mini._ParseString(el, attrs,
            ["text", "href", "iconCls", "iconStyle", "iconPosition", "groupName", "menu",
                "onclick", "oncheckedchanged", "target", "img"
             ]
        );
        mini._ParseBool(el, attrs,
            ["plain", "checkOnClick", "checked"
             ]
        );
        return attrs;
    }
});
mini.regClass(mini.Button, "button");

/* MenuButton 
-----------------------------------------------------------------------------*/

mini.MenuButton = function () {

    mini.MenuButton.superclass.constructor.apply(this, arguments);
}
mini.extend(mini.MenuButton, mini.Button, {
    uiCls: "mini-menubutton",
    allowCls: "mini-button-menu",
    setMenu: function (value) {

        if (mini.isArray(value)) {
            value = {
                type: "menu",
                items: value
            };
        }
        if (typeof value == "string") {
            var el = mini.byId(value);
            if (!el) return;

            mini.parse(value);
            value = mini.get(value);
        }

        if (this.menu !== value) {
            this.menu = mini.getAndCreate(value);
            this.menu.setPopupEl(this.el);
            this.menu.setPopupCls("mini-button-popup");
            this.menu.setShowAction("leftclick");
            this.menu.setHideAction("outerclick");
            this.menu.setXAlign("left");
            this.menu.setYAlign("below");
            this.menu.outYAlign = "above";
            
            this.menu.hide();
            this.menu.owner = this;

            this.menu.addCls("mini-menu-open");

            var me = this;
            this.menu.on("BeforeOpen", function (e) {     
                       
                if (me.split && !jQuery(e.htmlEvent.target).closest('.mini-button-split')[0]) {
                    e.cancel = true;
                }
            });
        }
    },
    setEnabled: function (value) {
        this.enabled = value;
        if (value) {
            this.removeCls(this._disabledCls);
        } else {
            this.addCls(this._disabledCls);
        }
        //this.el.allowPopup = !!value;
        jQuery(this.el).attr("allowPopup", !!value)
    }
});
mini.regClass(mini.MenuButton, "menubutton");

/* SplitButton 
-----------------------------------------------------------------------------*/

mini.SplitButton = function () {
    mini.SplitButton.superclass.constructor.apply(this, arguments);
}
mini.extend(mini.SplitButton, mini.MenuButton, {
    split: true,
    uiCls: "mini-splitbutton",
    allowCls: "mini-button-split",

    __OnClick: function (e) {
        var me = this;
        if (me.split && jQuery(e.target).closest('.mini-button-split')[0]) {
            return;
        }
        me.menu.hide();
        mini.SplitButton.superclass.__OnClick.call(this, e);
    }
});
mini.regClass(mini.SplitButton, "splitbutton");

mini.CheckBox = function () {
    mini.CheckBox.superclass.constructor.apply(this, arguments);

}
mini.extend(mini.CheckBox, mini.Control, {
    formField: true,
    _clearText: false, //form.reset/clear的时候，是否自动清除文本

    text: "",
    checked: false,
    defaultValue: false,

    trueValue: true,
    falseValue: false,

    checkedCls: "mini-checkbox-checked",

    set: function (kv) {
        if (typeof kv == 'string') {
            return this;
        }
        var me = this;

        if (!mini.isNull(kv.trueValue)) {
            me.setTrueValue(kv.trueValue);
            delete kv.trueValue;
        }
        if (!mini.isNull(kv.falseValue)) {
            me.setFalseValue(kv.falseValue);
            delete kv.falseValue;
        }

        mini.CheckBox.superclass.set.call(this, kv);


        return this;
    },

    uiCls: "mini-checkbox",
    _create: function () {
        var ckid = this.uid + "$check";
        this.el = document.createElement("span");
        //this.el.tabIndex = 0;
        this.el.className = "mini-checkbox";
        this.el.innerHTML = '<input id="' + ckid + '" name="' + this.id + '" type="checkbox" class="mini-checkbox-check"><span class="mini-checkbox-icon mini-icon" tabIndex="0"></span><label for="' + ckid + '" onclick="return false;">' + this.text + '</label>';

        this._checkEl = this.el.firstChild;
        this._labelEl = this.el.lastChild;
        //this._iconEl = this.el.childNodes[1];
    },
    destroy: function (removeEl) {
        if (this._checkEl) {
            this._checkEl.onmouseup = null;
            this._checkEl.onclick = null;
            this._checkEl = null;
        }
        mini.CheckBox.superclass.destroy.call(this, removeEl);
    },
    _initEvents: function () {
        mini._BindEvents(function () {
            if (!this.el) this._create();
            mini.on(this.el, "click", this.__onClick, this);

            var me = this;
            mini.on(this.el, "keyup", function (event) {
                if (event.keyCode == 32) {
                    jQuery(event.target).click();
                }
            });

            this._checkEl.onmouseup = function () { return false; }
            var sf = this;
            this._checkEl.onclick = function () { if (sf.isReadOnly()) return false }

            this._checkEl.checked = this.checked;

        }, this);

    },
    setName: function (value) {
        this.name = value;
        mini.setAttr(this._checkEl, "name", this.name);
    },
    setText: function (value) {
        if (this.text !== value) {
            this.text = value;

            this._labelEl.innerHTML = value;
        }
    },
    getText: function () {
        return this.text;
    },
    setChecked: function (value) {
        if (value === true) value = true;
        //else if (value === this.trueValue) value = true;
        else if (String(value) == String(this.trueValue)) value = true;
        else if (value == "true") value = true;
        else if (value == "True") value = true;
        else if (String(value) === "1") value = true;
        else if (value == "Y") value = true;
        else value = false;

        if (this.checked !== value) {
            this.checked = !!value;
            this._checkEl.checked = this.checked;

            this.value = this.getValue();
        }

        var el = jQuery(this.el);
        if (this.checked) {
            el.addClass(this.checkedCls);
        } else {
            el.removeClass(this.checkedCls);
        }

    },
    getChecked: function () {
        return this.checked;
    },
    setValue: function (value) {

        if (this.checked !== value) {
            this.setChecked(value);
            this.value = this.getValue();
        }
    },
    getValue: function () {
        return String(this.checked == true ? this.trueValue : this.falseValue);
    },
    getFormValue: function () {
        return this.getValue();
    },
    setTrueValue: function (value) {
        this._checkEl.value = value;
        this.trueValue = value;
    },
    getTrueValue: function () {
        return this.trueValue;
    },
    setFalseValue: function (value) {
        this.falseValue = value;
    },
    getFalseValue: function () {
        return this.falseValue;
    },
    /////////////////////////////
    __onClick: function (e) {

        if (this.isReadOnly()) return;

        this.setChecked(!this.checked);

        this.fire("checkedchanged", { checked: this.checked });
        this.fire("valuechanged", { value: this.getValue() });

        this.fire("click", e, this);

    },
    ////////////////////////////////
    getAttrs: function (el) {
        var attrs = mini.CheckBox.superclass.getAttrs.call(this, el);
        var jq = jQuery(el);

        attrs.text = el.innerHTML;
        mini._ParseString(el, attrs,
            ["text", "oncheckedchanged", "onclick", "onvaluechanged"
             ]
        );

        mini._ParseBool(el, attrs,
            ["enabled"
             ]
        );

        var checked = mini.getAttr(el, "checked");

        if (checked) {
            attrs.checked = (checked == "true" || checked == "checked") ? true : false;
        }

        var trueValue = jq.attr("trueValue");
        if (trueValue) {
            attrs.trueValue = trueValue;
            trueValue = parseInt(trueValue);
            if (!isNaN(trueValue)) {
                attrs.trueValue = trueValue;
            }
        }
        var falseValue = jq.attr("falseValue");
        if (falseValue) {
            attrs.falseValue = falseValue;
            falseValue = parseInt(falseValue);
            if (!isNaN(falseValue)) {
                attrs.falseValue = falseValue;
            }
        }

        return attrs;
    }
});

mini.regClass(mini.CheckBox, "checkbox");

//fix： 360 用户名、密码打开页面时重置BUG
jQuery(function () {
    setTimeout(function () {
        var comps = mini.getComponents();
        for (var i = 0, l = comps.length; i < l; i++) {
            var comp = comps[i];
            if (comp instanceof mini.TextBox) {
                var val = comp.getTextEl().value;
                if (comp.value !== val) {
                    comp.value = val;
                }
            }
        }
    }, 300);
});

mini.TextBox = function () {
    mini.TextBox.superclass.constructor.apply(this, arguments);

    //this._textEl.maxLenght = this.maxLength;
}
mini.extend(mini.TextBox, mini.ValidatorBase, {
    name: "",
    formField: true,

    selectOnFocus: false,

    allowInput: true,

    minWidth: 10,
    minHeight: 15,

    maxLength: 5000,

    emptyText: "",

    text: "",
    value: "",
    defaultValue: "",

    //width: 125,
    height: 21,

    _emptyCls: "mini-textbox-empty",
    _focusCls: "mini-textbox-focus",
    _disabledCls: "mini-textbox-disabled",

    uiCls: "mini-textbox",
    _InputType: "text",
    _create: function () {
        var html = '<input  type="' + this._InputType + '" class="mini-textbox-input" autocomplete="off"/>';
        if (this._InputType == "textarea") {
            html = '<textarea  class="mini-textbox-input" autocomplete="off"/></textarea>';
        }
        html = '<span class="mini-textbox-border mini-corner-all">' + html + '</span>';
        html += '<input type="hidden"/>';

        this.el = document.createElement("span");
        this.el.className = "mini-textbox";
        this.el.innerHTML = html;


        this._borderEl = this.el.firstChild;
        this._textEl = this._borderEl.firstChild;
        this._valueEl = this._borderEl.lastChild;
        // this._maxLengthInfo = mini.append(this._borderEl, '<span class="mini-maxlength-info" ' + (this.showCount ? 'style="display:none;"' : '') + '></span>');
        this._maxLengthInfo = mini.append(this._borderEl, '<span class="mini-maxlength-info" style="display:none;"></span>');

        //        var me = this;
        //        //alert(me._textEl.value);
        //        setTimeout(function () {
        //            alert(me._textEl.value);
        //        }, 1);

        //        me._textEl.value = "";
        this._doEmpty();

        //        $(this.el).on("click", function () {
        //            this.fire("aaa");
        //        });

        //        $(this.el).find(".mini-textbox-input").on("blur", function (event) {
        //            this.value = this.value.replace(/[0-9]+/g, '');
        //        });
    },
    _initEvents: function () {

        mini._BindEvents(function () {

            mini_onOne(this._textEl, "drop", this.__OnDropText, this);
            mini_onOne(this._textEl, "change", this.__OnInputTextChanged, this);
            mini_onOne(this._textEl, "focus", this.__OnFocus, this);
            mini_onOne(this.el, "mousedown", this.__OnMouseDown, this);

            //                        mini.on(this._textEl, "drop", this.__OnDropText, this);
            //                        mini.on(this._textEl, "change", this.__OnInputTextChanged, this);
            //                        mini.on(this._textEl, "focus", this.__OnFocus, this);
            //                        mini.on(this.el, "mousedown", this.__OnMouseDown, this);

            var v = this.value;
            this.value = null;
            if (this.el) {
                this.setValue(v);
            }


        }, this);
        this.on("validation", this.__OnValidation, this); //一定要放这里
    },
    _inputEventsInited: false,
    _initInputEvents: function () {
        if (this._inputEventsInited) return;
        this._inputEventsInited = true;

        //出于优化考虑：将blur, change, keydown, keyup, keypress等时间，在focus的时候，才进行绑定
        //在_initEvents的时候，只绑定focus就可以了
        mini.on(this._textEl, "blur", this.__OnBlur, this);
        mini.on(this._textEl, "keydown", this.__OnInputKeyDown, this);
        mini.on(this._textEl, "keyup", this.__OnInputKeyUp, this);
        mini.on(this._textEl, "keypress", this.__OnInputKeyPress, this);

        mini_onOne(this.el, "click", this.__OnClick, this);
    },
    destroy: function (removeEl) {
        if (this.el) {

            this.el.onmousedown = null;
        }
        if (this._textEl) {
            var textEl = this._textEl;

            if (textEl._placeholder_label) {
                textEl._placeholder_label.onmousedown = null;
                textEl._placeholder_label = null;
            }

            textEl.onpropertychange = textEl.ondrop = textEl.onchange = textEl.onfocus = null;
            mini.clearEvent(textEl);
            this._textEl = null;
        }
        if (this._valueEl) {
            mini.clearEvent(this._valueEl);
            this._valueEl = null;
        }
        mini.TextBox.superclass.destroy.call(this, removeEl);
    },

    doLayout: function () {
        if (this._doLabelLayout) {
            this._labelLayout();
        }
    },

    setHeight: function (value) {
        if (parseFloat(value) == value) value += "px";
        this.height = value;
        if (this._InputType == "textarea") {
            this.el.style.height = value;
            this.doLayout();
        }
    },

    setName: function (value) {
        if (this.name != value) {
            this.name = value;
            //this._valueEl.name = value;
            if (this._valueEl) mini.setAttr(this._valueEl, "name", this.name);
        }
    },
    setValue: function (value) {
        if (value === null || value === undefined) value = "";
        value = String(value);
        if (mini.getStrLength(value) > this.maxLength) {
            value = mini.substr(value, this.maxLength);
        }
        //if (this.value !== value) {
        this.value = value;
        this._valueEl.value = this._textEl.value = value;
        this._doEmpty();
        //}
        //        else {
        //            this._textEl.value = value;
        //        }
    },
    getValue: function () {
        //return this._textEl.value;
        return this.value;
    },
    setText: function (val) {
        if (mini.isNull(val)) val = "";
        this._textEl.value = val;
    },
    getText: function () {
        return this._textEl.value;
    },
    getFormValue: function () {
        var value = this.value;
        if (value === null || value === undefined) value = "";
        return String(value);
    },
    setAllowInput: function (value) {
        if (this.allowInput != value) {
            this.allowInput = value;
            this.doUpdate();
        }
    },
    getAllowInput: function () {
        return this.allowInput;
    },
    _doEmpty: function () {
        this._textEl.placeholder = this.emptyText;
        if (this.emptyText) {
            mini._placeholder(this._textEl);
        }

        //        if (this._focused) return;
        //        if (this.value == "" && this.emptyText) {
        //            this._textEl.value = this.emptyText;
        //            mini.addClass(this.el, this._emptyCls);
        //        } else {
        //            mini.removeClass(this.el, this._emptyCls);
        //        }
    },
    setEmptyText: function (value) {
        if (this.emptyText != value) {
            this.emptyText = value;
            this._doEmpty();
        }
    },
    getEmptyText: function () {
        return this.emptyText;
    },
    setMaxLength: function (value) {

        this.maxLength = value;
        //
        mini.setAttr(this._textEl, "maxLength", value);

        if (this._InputType == "textarea" && mini.isIE) {
            mini.on(this._textEl, "keyup", this.__OnMaxLengthKeyUp, this);
            mini.on(this._textEl, "keypress", this.__OnMaxLengthKeyUp, this);
            mini.on(this._textEl, "paste", this.__OnPaste, this);
        }
    },
    __OnPaste: function (e) {
        var sf = this;

        setTimeout(function () {

            var value = sf._textEl.value;
            if (mini.getStrLength(value) > sf.maxLength) {
                sf._textEl.value = mini.substr(value, sf.maxLength);

            }
            //sf._OnValueChanged();

            sf.__OnInputTextChanged();

        }, 0)
    },
    __OnMaxLengthKeyUp: function (e) {

        if (mini.getStrLength(this._textEl.value) >= this.maxLength) {

            this.__OnPaste(e);
            e.preventDefault();

        }
    },
    getMaxLength: function () {
        return this.maxLength;
    },
    setReadOnly: function (value) {
        if (this.readOnly != value) {
            this.readOnly = value;
            this.doUpdate();
        }
    },
    setEnabled: function (value) {
        if (this.enabled != value) {
            this.enabled = value;
            this.doUpdate();
            //this._tryValidate();
        }
    },
    doUpdate: function () {
        if (this.enabled) {
            this.removeCls(this._disabledCls);
        } else {
            this.addCls(this._disabledCls);
        }
        if (this.isReadOnly() || this.allowInput == false) {
            this._textEl.readOnly = true;
            mini.addClass(this.el, "mini-textbox-readOnly");
        } else {

            this._textEl.readOnly = false;
            mini.removeClass(this.el, "mini-textbox-readOnly");
        }
        if (this.required) {
            this.addCls(this._requiredCls);
        } else {
            this.removeCls(this._requiredCls);
        }

        if (this.enabled) {
            this._textEl.disabled = false;
        } else {
            this._textEl.disabled = true;
        }
    },
    focus: function () {

        var that = this;
        setTimeout(function () {
            try {
                that._textEl.focus();

                if (mini.isIE) {
                    var o = that._textEl.createTextRange();
                    o.collapse(false);
                    o.select();
                }
            } catch (e) {
            }
        }, 10);
    },
    blur: function () {
        try {
            this._textEl.blur();
        } catch (e) {
        }
    },
    selectText: function () {

        var me = this;
        function doSelect() {
            try {
                me._textEl.select();
            } catch (ex) { }
        }
        doSelect();
        //        setTimeout(function () {
        //            doSelect();
        //        }, 30);
    },
    getTextEl: function () {
        return this._textEl;
    },
    getInputText: function () {
        return this._textEl.value;
    },
    setSelectOnFocus: function (value) {
        this.selectOnFocus = value;
    },
    getSelectOnFocus: function (value) {
        return this.selectOnFocus;
    },
    ///////////////////////////////////////////////
    _errorIconEl: null,
    getErrorIconEl: function () {
        if (!this._errorIconEl) {
            this._errorIconEl = mini.append(this.el, '<span class="mini-errorIcon"></span>');
        }
        return this._errorIconEl;
    },
    _RemoveErrorIcon: function () {
        if (this._errorIconEl) {
            var el = this._errorIconEl;
            jQuery(el).remove();
        }
        this._errorIconEl = null;
    },
    ///////////////////////////////////////////////
    __OnClick: function (e) {
        if (!this.enabled) return;
        this.fire("click", { htmlEvent: e });
    },
    __OnMouseDown: function (e) {

        var sf = this;

        //加这行代码
        if (this._InputType == "textarea") return;

        if (!mini.isAncestor(this._textEl, e.target)) {
            setTimeout(function () {
                sf.focus();
                mini.selectRange(sf._textEl, 10000, 10000);
            }, 1);
        } else {
            setTimeout(function () {
                try {
                    sf._textEl.focus();
                } catch (ex) { }
            }, 1);
        }
    },
    __OnInputTextChanged: function (e, valid) {
        //this._inputChangedTime = new Date();

        var value = this.value;
        this._oldValue = value;
        this.setValue(this._textEl.value);

        if (value !== this.getValue() || valid === true) {
            this._OnValueChanged();
        }
    },
    __OnDropText: function (e) {
        var me = this;
        setTimeout(function () {
            me.__OnInputTextChanged(e);
        }, 0);
    },
    __OnInputKeyDown: function (e) {
        var ex = { htmlEvent: e };
        this.fire("keydown", ex);

        if (e.keyCode == 8 && (this.isReadOnly() || this.allowInput == false)) {
            return false;
        }
        if (e.keyCode == 27 || e.keyCode == 13 || e.keyCode == 9) {
            //if (e.keyCode == 13 || e.keyCode == 9) {
            if (this._InputType == "textarea" && e.keyCode == 13) {    //不影响textarea换行
            }
            else {
                //this.__OnInputTextChanged(null, true);
                this.__OnInputTextChanged(null);

                this._textEl.blur();
                this._textEl.focus();

                if (e.keyCode == 13) {
                    //e.preventDefault();

                    var me = this;
                    //setTimeout(function () {
                    me.fire("enter", ex);
                    //}, 10);
                }
            }

        }
        if (e.keyCode == 27) {
            e.preventDefault();
        }
        //        if (e.keyCode == 13 && this._InputType == "textarea") {
        //            if (e.ctrlKey == false) {
        //                e.stopPropagation();
        //            } else {
        //                this.__OnInputTextChanged();
        //            }
        //        }
    },
    __OnInputKeyUp: function (e) {
        if (this.validateOnInput) {
            var value = this.value;
            this._oldValue = value;
            this.setValue(this._textEl.value);
            this._tryValidate();
        }
        this.fire("keyup", { htmlEvent: e });
    },
    __OnInputKeyPress: function (e) {
        this.fire("keypress", { htmlEvent: e });
    },
    __OnFocus: function (e) {
        //e.preventDefault();
        this.doUpdate();
        //if (this.isReadOnly() || this.allowInput == false) return;        
        if (this.isReadOnly()) {
            return;
        }
        this._focused = true;
        this.addCls(this._focusCls);
        this._initInputEvents();

        //        mini.removeClass(this.el, this._emptyCls);
        //        if (this.emptyText && this._textEl.value == this.emptyText) {
        //            this._textEl.value = "";
        //            this._textEl.select();
        //        }

        if (this.selectOnFocus) {
            var me = this;
            setTimeout(function () {
                me.selectText();
            }, 1);
        }

        this.fire("focus", { htmlEvent: e });
    },
    __OnBlur: function (e) {
        this._focused = false;
        var sf = this;
        setTimeout(function () {
            if (sf._focused == false) {
                sf.removeCls(sf._focusCls);
            }
        }, 2);

        //        if (this.emptyText && this._textEl.value == "") {
        //            this._textEl.value = this.emptyText;
        //            mini.addClass(this.el, this._emptyCls);
        //        }

        //        if (!this._inputChangedTime || new Date() - this._inputChangedTime < 50) {
        //            this.__OnInputTextChanged();
        //        }
        //        this._inputChangedTime = null;

        this.fire("blur", { htmlEvent: e });


        if (this.validateOnLeave && this.isEditable()) {
            this._tryValidate();
        }
    },
    inputStyle: "",
    setInputStyle: function (value) {
        this.inputStyle = value;
        mini.setStyle(this._textEl, value);
    },
    ///////////////////////////////////////////////
    getAttrs: function (el) {
        var attrs = mini.TextBox.superclass.getAttrs.call(this, el);
        var jq = jQuery(el);

        mini._ParseString(el, attrs,
            ["value", "text", "emptyText", "inputStyle",
            "onenter", "onkeydown", "onkeyup", "onkeypress", "onclick",
            "maxLengthErrorText", "minLengthErrorText", "onfocus", "onblur",

            "vtype",
            "emailErrorText", "urlErrorText", "floatErrorText", "intErrorText", "dateErrorText",
            "minErrorText", "maxErrorText", "rangeLengthErrorText", "rangeErrorText", "rangeCharErrorText"
             ]
        );
        mini._ParseBool(el, attrs,
            ["allowInput", "selectOnFocus"
             ]
        );
        mini._ParseInt(el, attrs,
            ["maxLength", "minLength", "minHeight", "minWidth"
             ]
        );

        //alert(attrs.maxLength);



        return attrs;
    },
    ///////////////////////////////////////
    vtype: "",  //email;url;float;int;date:yyyy-MM-dd;max:20,min:10,maxLength:100,minLength:5;rangeLength:0,5;range:0,5
    setVtype: function (value) {
        this.vtype = value;
    },
    getVtype: function () {
        return this.vtype;
    },
    __OnValidation: function (e) {

        if (e.isValid == false) return;

        mini._ValidateVType(this.vtype, e.value, e, this);
        //        var vtypes = this.vtype.split(";");
        //        for (var i = 0, l = vtypes.length; i < l; i++) {
        //            var vtype = vtypes[i].trim();
        //            var vv = vtype.split(":");
        //            var vt = vv[0];
        //            var args = vv[1];
        //            if (args) args = args.split(",");
        //            else args = [];

        //            var fn = mini.VTypes[vt]; //this["__" + vt];
        //            if (fn) {
        //                var isValid = fn(e.value, args);
        //                if (isValid !== true) {
        //                    e.isValid = false;
        //                    var vtext = vv[0] + "ErrorText";
        //                    e.errorText = this[vtext] || mini.VTypes[vtext] || "";
        //                    e.errorText = String.format(e.errorText, args[0], args[1], args[2], args[3], args[4]);
        //                    break;
        //                }
        //            }
        //        }
    },
    setEmailErrorText: function (value) {
        this.emailErrorText = value;
    },
    getEmailErrorText: function () {
        return this.emailErrorText;
    },
    setUrlErrorText: function (value) {
        this.urlErrorText = value;
    },
    getUrlErrorText: function () {
        return this.urlErrorText;
    },
    setFloatErrorText: function (value) {
        this.floatErrorText = value;
    },
    getFloatErrorText: function () {
        return this.floatErrorText;
    },
    setIntErrorText: function (value) {
        this.intErrorText = value;
    },
    getIntErrorText: function () {
        return this.intErrorText;
    },
    setDateErrorText: function (value) {
        this.dateErrorText = value;
    },
    getDateErrorText: function () {
        return this.dateErrorText;
    },
    setMaxLengthErrorText: function (value) {
        this.maxLengthErrorText = value;
    },
    getMaxLengthErrorText: function () {
        return this.maxLengthErrorText;
    },
    setMinLengthErrorText: function (value) {
        this.minLengthErrorText = value;
    },
    getMinLengthErrorText: function () {
        return this.minLengthErrorText;
    },
    setMaxErrorText: function (value) {
        this.maxErrorText = value;
    },
    getMaxErrorText: function () {
        return this.maxErrorText;
    },
    setMinErrorText: function (value) {
        this.minErrorText = value;
    },
    getMinErrorText: function () {
        return this.minErrorText;
    },
    setRangeLengthErrorText: function (value) {
        this.rangeLengthErrorText = value;
    },
    getRangeLengthErrorText: function () {
        return this.rangeLengthErrorText;
    },
    setRangeCharErrorText: function (value) {
        this.rangeCharErrorText = value;
    },
    getRangeCharErrorText: function () {
        return this.rangeCharErrorText;
    },
    setRangeErrorText: function (value) {
        this.rangeErrorText = value;
    },
    getRangeErrorText: function () {
        return this.rangeErrorText;
    }

});

mini.regClass(mini.TextBox, 'textbox');


mini.Password = function () {
    mini.Password.superclass.constructor.apply(this, arguments);
}
mini.extend(mini.Password, mini.TextBox, {
    uiCls: "mini-password",
    _InputType: "password",
//    setEmptyText: function (value) {
//        this.emptyText = "";
//    },
    getValue: function () {
        return this._textEl.value;
    }
});
mini.regClass(mini.Password, 'password');


mini.TextArea = function () {
    mini.TextArea.superclass.constructor.apply(this, arguments);
}
mini.extend(mini.TextArea, mini.TextBox, {
    maxLength: 10000000,

    //width: 180,
    //height: 50,
    height: '',
    minHeight: 50,
    _InputType: "textarea",
    uiCls: "mini-textarea",
    doLayout: function () {
        if (!this.canLayout()) return;
        mini.TextArea.superclass.doLayout.call(this);

        var h = mini.getHeight(this.el);

        //if (mini.isIE6 || mini.isIE) {
        if (mini.isIE6) {
            mini.setHeight(this._borderEl, h);
        }
        h -= 2;
        if (h < 0) h = 0;
        this._textEl.style.height = h + "px";
    }
});
mini.regClass(mini.TextArea, 'textarea');



mini.ButtonEdit = function () {
    
    mini.ButtonEdit.superclass.constructor.apply(this, arguments);
    //this.addCls("mini-buttonedit");

    var isReadOnly = this.isReadOnly();
    if (isReadOnly || this.allowInput == false) {
        this._textEl.readOnly = true;
    }
    if (this.enabled == false) {
        this.addCls(this._disabledCls);
    }
    if (isReadOnly) {
        this.addCls(this._readOnlyCls);
    }
    if (this.required) {
        this.addCls(this._requiredCls);
    }
}
mini.extend(mini.ButtonEdit, mini.ValidatorBase, {
    name: "",
    formField: true,

    selectOnFocus: false,

    showButton: true,

    buttonToolTip: "",
    closeToolTip: "",

    showClose: false,

    emptyText: "",

    defaultValue: "",
    defaultText: "",
    value: "",
    text: "",

    maxLength: 1000,
    minLength: 0,

    //width: 125,
    height: 21,

    inputAsValue: true,    //输入内容作为value

    allowInput: true,   //区别于readOnly
    _noInputCls: "mini-buttonedit-noInput",
    _readOnlyCls: "mini-buttonedit-readOnly",
    _disabledCls: "mini-buttonedit-disabled",

    _emptyCls: "mini-buttonedit-empty",
    _focusCls: "mini-buttonedit-focus",

    //_buttonDisabledCls: "mini-buttonedit-button-disabled",
    _buttonCls: "mini-buttonedit-button",
    _buttonHoverCls: "mini-buttonedit-button-hover",
    _buttonPressedCls: "mini-buttonedit-button-pressed",

    _closeCls: "mini-buttonedit-close",

    set: function (kv) {
        if (typeof kv == 'string') {
            return this;
        }

        var value = kv.value;
        delete kv.value;
        var text = kv.text;
        delete kv.text;

        this._allowUpdate = !(kv.enabled == false || kv.allowInput == false || kv.readOnly);

        mini.ButtonEdit.superclass.set.call(this, kv);

        if (this._allowUpdate === false) {
            this._allowUpdate = true;
            this.doUpdate();
        }

        if (!mini.isNull(text)) {
            this.setText(text);
        }
        if (!mini.isNull(value)) {
            this.setValue(value);
        }
        return this;
    },
    uiCls: "mini-buttonedit",

    //    addButton: function (button) {
    //        
    //    },

    //    removeButton: function (button) {
    //        
    //    },

    setButtons: function (val) {
        var me = this;

        jQuery(".mini-buttonedit-button:not(.mini-buttonedit-trigger)", this.el).remove();

        me.buttons = val || [];

        var html = '';

        function createButton(button) {
            html += me._createButtonHtml(button.name, button.iconCls, button.tooltip);
        }

        for (var i = 0, l = me.buttons.length; i < l; i++) {
            var button = me.buttons[i];
            if (!button.name) button.name = "button" + i;
            createButton(button);
        }

        mini.append(me._buttonsEl, html);

        me._doInputLayout(false);

    },

    getButtons: function () {
        return this.buttons || [];
    },

    getButtonByName: function (name) {
        var buttons = this.getButtons();
        for (var i = 0, l = buttons.length; i < l; i++) {
            var o = buttons[i];
            if (o.name && o.name == name) return o;
        }
        return null;
    },

    _createButtonHtml: function (name, iconCls, tooltip) {
        name = name || "";
        iconCls = iconCls || "";
        tooltip = tooltip || '';
        var hover = 'onmouseover="mini.addClass(this, \'' + this._buttonHoverCls + '\');" '
                        + 'onmouseout="mini.removeClass(this, \'' + this._buttonHoverCls + '\');"';
        return '<span title="' + tooltip + '" name="' + name + '" class="mini-buttonedit-button mini-buttonedit-' + name + '" ' + hover + '><span class="mini-buttonedit-icon mini-icon mini-iconfont ' + iconCls + '"></span></span>';
    },

    _getButtonsHTML: function () {

        var s = '<span class="mini-buttonedit-close mini-icon" name="close"></span>' + this._getButtonHtml('trigger', '', this.buttonToolTip);
        return '<span class="mini-buttonedit-buttons">' + s + '</span>';
    },

    _getButtonHtml: function (name, iconCls, tooltip) {
        return this._createButtonHtml(name, iconCls, tooltip);
    },

    _create: function () {
        this.el = document.createElement("span");
        this.el.className = "mini-buttonedit";

        var s = this._getButtonsHTML();
        this.el.innerHTML = '<span class="mini-buttonedit-border mini-corner-all"><input type="text" class="mini-buttonedit-input" autocomplete="off"/>'
                            + s + '</span><input name="' + this.name + '" type="hidden"/>'

        this._borderEl = this.el.firstChild;
        this._textEl = this._borderEl.firstChild;
        this._valueEl = this.el.lastChild;

        this._buttonsEl = this._borderEl.lastChild;
        this._buttonEl = this._buttonsEl.lastChild;
        this._closeEl = this._buttonEl.previousSibling;

        this._doEmpty();
    },
    destroy: function (removeEl) {

        if (this._textEl) {
            this._textEl.onchange = this._textEl.onfocus = null;
            mini.clearEvent(this._textEl);
            //jQuery(this._textEl).remove();
            this._textEl = null;
        }

        this._borderEl = this._buttonsEl = this._buttonEl = this._closeEl = this._valueEl = null;

        mini.ButtonEdit.superclass.destroy.call(this, removeEl);
    },
    _deferSetText: true,
    _initEvents: function () {
        mini._BindEvents(function () {
            mini_onOne(this.el, "mousedown", this.__OnMouseDown, this);
            mini_onOne(this._textEl, "focus", this.__OnFocus, this);
            mini_onOne(this._textEl, "change", this.__OnInputTextChanged, this);


            //            mini.on(this.el, "mousedown", this.__OnMouseDown, this);
            //            mini.on(this._textEl, "focus", this.__OnFocus, this);
            //            mini.on(this._textEl, "change", this.__OnInputTextChanged, this);

            var v = this.text;
            this.text = null;
            if (this.el) {
                if (this._deferSetText) {
                    this.setText(v);
                }
            }


            if (mini.isIE) {

                mini.on(this._textEl, "input", this.__input, this);
            }


        }, this);

    },
    __input: function () { },


    _inputEventsInited: false,
    _initInputEvents: function () {
        if (this._inputEventsInited) return;
        this._inputEventsInited = true;

        mini.on(this.el, "click", this.__OnClick, this);
        mini.on(this._textEl, "blur", this.__OnBlur, this);
        mini.on(this._textEl, "keydown", this.__OnInputKeyDown, this);
        mini.on(this._textEl, 'input', this.__OnInput, this);
        mini.on(this._textEl, "keyup", this.__OnInputKeyUp, this);
        mini.on(this._textEl, "keypress", this.__OnInputKeyPress, this);
    },
    _buttonWidth: 20,
    _closeWidth: 20,
    _doInputLayout: function (doLayout) {

        this._buttonEl.style.display = this.showButton ? "inline-block" : "none";
        this._buttonEl.title = this.buttonToolTip;

        if (this._closeEl) {
            this._closeEl.style.display = this.showClose ? "inline-block" : "none";
            this._closeEl.title = this.closeToolTip;
        }

        if (mini.isNull(mini.ButtonEdit._paddingOffset)) {
            var padding = mini.getPaddings(this._borderEl);
            mini.ButtonEdit._paddingOffset = padding.left;
            //alert(mini.ButtonEdit._paddingOffset)
        }

        var buttonsWidth = this._buttonsEl.offsetWidth;

        var w = buttonsWidth + (buttonsWidth > 0 ? 0 : mini.ButtonEdit._paddingOffset);
        // 隐藏的时候应该是0 表示之后 doLayout 的时候要重新计算一下
        if (w == 0) {
            this._noLayout = true;
        } else {
            this._noLayout = false;
        }
        this._borderEl.style["paddingRight"] = w + "px";
        if (doLayout !== false) {
            this.doLayout();
        }
    },
    doLayout: function () {
        //        if (this.id == "xxx") {
        //            //alert(1);
        //            debugger
        //        }

        if (this._noLayout) {
            this._doInputLayout(false);
        }
        if (this._doLabelLayout) {
            this._labelLayout();
        }

    },
    setHeight: function (value) {
        if (parseFloat(value) == value) value += "px";
        this.height = value;

    },
    focus: function () {
        try {
            this._textEl.focus();
            var sf = this;
            setTimeout(function () {
                if (sf._focused) {
                    sf._textEl.focus();
                }
                //sf._doEmpty();
            }, 10);
        } catch (e) {
        }
    },
    blur: function () {
        try {
            this._textEl.blur();
            //sf._doEmpty();
        } catch (e) {
        }
    },
    selectText: function () {
        this._textEl.select();
    },

    getTextEl: function () {
        return this._textEl;
    },
    setName: function (value) {
        this.name = value;
        //this._valueEl.name = value;
        if (this._valueEl) mini.setAttr(this._valueEl, "name", this.name);
    },
    setText: function (value) {

        if (value === null || value === undefined) value = "";
        var fire = this.text !== value;
        this.text = value;
        this._textEl.value = value;

        this._doEmpty();
    },
    getText: function () {
        var text = this._textEl.value;
        return text;
        //return text != this.emptyText ? text : "";
    },
    //value是类型值，formattedValue是字符串
    setValue: function (value) {
        if (value === null || value === undefined) value = "";
        var fire = this.value !== value;
        this.value = value;
        this._valueEl.value = this.getFormValue();
        //this._doEmpty();
    },
    getValue: function () {
        return this.value;
    },
    getFormValue: function () {
        var value = this.value;
        if (value === null || value === undefined) value = "";
        return String(value);
    },

    _doEmpty: function () {
        this._textEl.placeholder = this.emptyText;
        if (this.emptyText) {
            mini._placeholder(this._textEl);
        }
        //        mini.removeClass(this.el, this._emptyCls);
        //        if (this._focused) {
        //            if (this._textEl.value == this.emptyText) {
        //                this._textEl.value = "";
        //            }
        //        } else {
        //            if (this._textEl.value == "") {
        //                this._textEl.value = this.emptyText;
        //                mini.addClass(this.el, this._emptyCls);
        //            }
        //        }
    },
    setEmptyText: function (value) {
        if (this.emptyText != value) {
            this.emptyText = value;
            this._doEmpty();
        }
    },
    getEmptyText: function () {
        return this.emptyText;
    },

    setMaxLength: function (value) {
        value = parseInt(value);
        if (isNaN(value)) return;
        this.maxLength = value;
        this._textEl.maxLength = value;
    },
    getMaxLength: function () {
        return this.maxLength;
    },
    setMinLength: function (value) {
        value = parseInt(value);
        if (isNaN(value)) return;
        this.minLength = value;
    },
    getMinLength: function () {
        return this.minLength;
    },
    setEnabled: function (value) {
        mini.ButtonEdit.superclass.setEnabled.call(this, value);

        //this._tryValidate();
    },
    _doReadOnly: function () {
        var readOnly = this.isReadOnly();
        if (readOnly || this.allowInput == false) {
            this._textEl.readOnly = true;
        } else {
            this._textEl.readOnly = false;
        }
        if (readOnly) {
            this.addCls(this._readOnlyCls);
        } else {
            this.removeCls(this._readOnlyCls);
        }
        if (this.allowInput) {
            this.removeCls(this._noInputCls);
        } else {
            this.addCls(this._noInputCls);
        }

        if (this.enabled) {
            this._textEl.disabled = false;
        } else {
            this._textEl.disabled = true;
        }
    },
    setAllowInput: function (value) {
        this.allowInput = value;
        this._doReadOnly();
    },
    getAllowInput: function () {
        return this.allowInput;
    },
    setInputAsValue: function (value) {
        this.inputAsValue = value;
    },
    getInputAsValue: function () {
        return this.inputAsValue;
    },

    autoClear: false,
    setAutoClear: function (value) {
        this.autoClear = value;
    },
    getAutoClear: function () {
        return this.autoClear;
    },

    setButtonToolTip: function (value) {
        this.buttonToolTip = value;
    },
    getButtonToolTip: function () {
        return this.buttonToolTip;
    },

    ////////////////////////////////////   
    //    _errorCls: "mini-buttonedit-error",
    //    _invalidCls: "mini-buttonedit-invalid", //当none时，加上_errorCls，比如红色边框，黄色背景
    _errorIconEl: null,
    getErrorIconEl: function () {
        if (!this._errorIconEl) {
            this._errorIconEl = mini.append(this.el, '<span class="mini-errorIcon"></span>');
        }
        return this._errorIconEl;
    },
    _RemoveErrorIcon: function () {
        if (this._errorIconEl) {
            var el = this._errorIconEl;
            jQuery(el).remove();
        }
        this._errorIconEl = null;
    },
    ///////////////////////////////////////////
    __OnClick: function (e) {

        if (this.enabled == false) return;
        this.fire("click", { htmlEvent: e });

        if (this.isReadOnly()) return;

        if (!mini.isAncestor(this._borderEl, e.target)) return;

        var t = new Date();

        if (mini.isAncestor(this._buttonEl, e.target)) {
            this._OnButtonClick(e);
        }


        if (mini.findParent(e.target, this._closeCls)) {


            if (this.autoClear) {

                if ((this.value && this.value !== 0) || this.text !== "") {
                    this._oldValue = this.value;
                    this.setValue("");
                    this.setText("");
                    this._OnValueChanged();
                    //this.focus();
                }
            }

            this.fire("closeclick", { htmlEvent: e });
        }

        //        t = new Date() - t;
        //        if (t > 500) {
        //            var me = this;
        //            me.blur();
        //            setTimeout(function () {
        //                me.blur();
        //            }, 10);
        //        }
        //this._doEmpty();

        //处理新增的buttons
        this._handlerButtonElClick(e);

    },

    _handlerButtonElClick: function (e) {
        var btnEl = mini.findParent(e.target, "mini-buttonedit-button")
        if (btnEl && btnEl != this._buttonEl && btnEl != this._closeEl) {
            var name = jQuery(btnEl).attr("name");
            var button = this.getButtonByName(name);
            //alert(button.name);

            var event = { sender: this, button: button, htmlEvent: e };
            if (button.handler) button.handler(event);
            //if (button.handler) button.handler.call(this, event);            
        }
    },

    __OnMouseDown: function (e) {
        //this._doEmpty();
        if (this.isReadOnly() || this.enabled == false) return;

        if (!mini.isAncestor(this._borderEl, e.target)) return;

        if (!mini.isAncestor(this._textEl, e.target)) {
            this._clickTarget = e.target;
            var sf = this;
            setTimeout(function () {
                sf.focus();
                mini.selectRange(sf._textEl, 1000, 1000);
            }, 1);
            if (mini.isAncestor(this._buttonEl, e.target)) {
                var up = mini.findParent(e.target, "mini-buttonedit-up");
                var down = mini.findParent(e.target, "mini-buttonedit-down");
                if (up) {
                    mini.addClass(up, this._buttonPressedCls);
                    this._OnButtonMouseDown(e, "up");
                }
                else if (down) {
                    mini.addClass(down, this._buttonPressedCls);
                    this._OnButtonMouseDown(e, "down");
                } else {
                    mini.addClass(this._buttonEl, this._buttonPressedCls);
                    this._OnButtonMouseDown(e);
                }
            }
            mini.on(document, "mouseup", this.__OnDocMouseUp, this);

            var btnEl = mini.findParent(e.target, "mini-buttonedit-button")
            if (btnEl) {
                mini.addClass(btnEl, this._buttonPressedCls);
            }

        }
    },
    __OnDocMouseUp: function (e) {

        this._clickTarget = null;
        //        var tds = this._innerEl.firstChild.rows[0].cells;
        //        var sf = this;
        //        setTimeout(function () {
        //            for (var i = 0, l = tds.length; i < l; i++) {
        //                var td = tds[i];
        //                mini.removeClass(td, sf._buttonPressedCls);
        //                var button = sf.getButton(parseInt(td.id));
        //                if (button && button.type == "spin") {
        //                    mini.removeClass(td.firstChild.firstChild, sf._buttonPressedCls);
        //                    mini.removeClass(td.firstChild.lastChild, sf._buttonPressedCls);
        //                }
        //            }
        //            mini.removeClass(sf.el, sf._pressedCls);
        //        }, 80);
        var me = this;
        setTimeout(function () {
            var doms = me._buttonEl.getElementsByTagName("*");
            for (var i = 0, l = doms.length; i < l; i++) {
                mini.removeClass(doms[i], me._buttonPressedCls);
            }
            mini.removeClass(me._buttonEl, me._buttonPressedCls);
            mini.removeClass(me.el, me._pressedCls);

            jQuery(".mini-buttonedit-button", me._buttonsEl).removeClass(me._buttonPressedCls);

        }, 80);
        mini.un(document, "mouseup", this.__OnDocMouseUp, this);
    },
    __OnFocus: function (e) {

        this.doUpdate();
        this._initInputEvents();
        if (this.isReadOnly()) return;
        //if (this.isReadOnly() || this.allowInput == false) return;
        this._focused = true;
        this.addCls(this._focusCls);

        //this._doEmpty();

        if (this.selectOnFocus) {
            this.selectText();
        }
        this.fire("focus", { htmlEvent: e });
    },
    __doFocusCls: function () {
        if (this._focused == false) {
            this.removeCls(this._focusCls);
        }
    },
    __fireBlur: function (e) {

        //if (this._clickTarget) return;

        var sf = this;

        function f() {
            if (sf._focused == false) {
                sf.removeCls(sf._focusCls);

                if (sf.validateOnLeave && sf.isEditable()) {
                    //if (sf.validateOnLeave) {
                    sf._tryValidate();
                }

                this.fire("blur", { htmlEvent: e });
            }
            //this._doEmpty();
        }
        setTimeout(function () {
            f.call(sf);
        }, 2);

    },
    __OnBlur: function (e) {

        var me = this;

        me._focused = false;
        setTimeout(function () {
            me.__fireBlur(e);

        }, 10);


    },
    __OnInputKeyDown: function (e) {
        var ex = { htmlEvent: e };
        this.fire("keydown", ex);
        if (e.keyCode == 8 && (this.isReadOnly() || this.allowInput == false)) {
            return false;
        }
        //if (e.keyCode == 13 || e.keyCode == 9) {
        if (e.keyCode == 27 || e.keyCode == 13 || e.keyCode == 9) {
            var sf = this;
            sf.__OnInputTextChanged(null);
            if (e.keyCode == 13) {
                var me = this;
                //setTimeout(function () {
                me.fire("enter", ex);
                //}, 10);
            }
        }
        if (e.keyCode == 27) {
            e.preventDefault();
        }
    },
    __OnInputTextChanged: function () {

        var v = this._textEl.value;
        if (v == this.text) return;
        var value = this.getValue();
        //if (this.inputAsValue) {
        
        this._oldValue = value;

        this.setText(v);
        if (this.inputAsValue) {
            this.setValue(v);
            if (value !== this.getFormValue()) {
                this._OnValueChanged();
            }
        }
        //}
    },
    __OnInput: function(e) {
        var v = this._textEl.value;
        this.fire('input', {
            htmlEvent: e,
            text: v
        });
    },
    __OnInputKeyUp: function (e) {
        this.fire("keyup", { htmlEvent: e });
    },
    __OnInputKeyPress: function (e) {
        this.fire("keypress", { htmlEvent: e });
    },
    ////////////////////////////////////////////     
    _OnButtonClick: function (htmlEvent) {
        var e = {
            htmlEvent: htmlEvent,
            cancel: false
        };
        this.fire("beforebuttonclick", e);
        if (e.cancel == true) return;

        this.fire("buttonclick", e);
    },
    _OnButtonMouseDown: function (htmlEvent, spinType) {
        this.focus();
        this.addCls(this._focusCls);

        this.fire("buttonmousedown", {
            htmlEvent: htmlEvent,
            spinType: spinType
        });
    },

    onButtonClick: function (fn, scope) {
        this.on("buttonclick", fn, scope);
    },
    onButtonMouseDown: function (fn, scope) {
        this.on("buttonmousedown", fn, scope);
    },
    onTextChanged: function (fn, scope) {
        this.on("textchanged", fn, scope);
    },

    textName: "",
    setTextName: function (value) {
        this.textName = value;
        if (this._textEl) mini.setAttr(this._textEl, "name", this.textName);
    },
    getTextName: function () {
        return this.textName;
    },

    setSelectOnFocus: function (value) {
        this.selectOnFocus = value;
    },
    getSelectOnFocus: function (value) {
        return this.selectOnFocus;
    },
    setShowClose: function (value) {
        this.showClose = value;
        this._doInputLayout();
    },
    getShowClose: function (value) {
        return this.showClose;
    },

    setShowButton: function (value) {
        this.showButton = value;
        this._doInputLayout();
    },
    getShowButton: function () {
        return this.showButton;
    },

    inputStyle: "",
    setInputStyle: function (value) {
        this.inputStyle = value;
        mini.setStyle(this._textEl, value);
    },

    getAttrs: function (el) {
        var attrs = mini.ButtonEdit.superclass.getAttrs.call(this, el);
        var jq = jQuery(el);

        mini._ParseString(el, attrs,
            ["value", "text", "textName", "emptyText", "inputStyle", "defaultText",
            "onenter", "onkeydown", "onkeyup", "onkeypress",
            "onbuttonclick", "onbuttonmousedown", "ontextchanged", "onfocus", "onblur",
            "oncloseclick", "onclick", "buttons", "buttonToolTip"
             ]
        );
        mini._ParseBool(el, attrs,
            ["allowInput", "inputAsValue", "selectOnFocus", "showClose", "showButton", "autoClear"
             ]
        );
        mini._ParseInt(el, attrs,
            ["maxLength", "minLength"
             ]
        );


        //buttons
        var buttons = attrs["buttons"];
        if (buttons) {
            buttons = window["ev" + "al"]("(" + buttons + ")");
            attrs.buttons = buttons || null;
            //attrs.buttons = null;
        }

        return attrs;
    }
});
mini.regClass(mini.ButtonEdit, 'buttonedit');





mini.PopupEdit = function() {
    mini.PopupEdit.superclass.constructor.apply(this, arguments);
    this._createPopup();

    this.el.className += ' mini-popupedit';
};
mini.extend(mini.PopupEdit, mini.ButtonEdit, {
    uiCls: 'mini-popupedit',
    popup: null,

    popupCls: 'mini-buttonedit-popup',

    _hoverCls: 'mini-buttonedit-hover',
    _pressedCls: 'mini-buttonedit-pressed',

    _destroyPopup: true,
    destroy: function(removeEl) {
        if (this.isShowPopup()) {
            this.hidePopup();
        }
        if (this.popup) {
            if (this._destroyPopup) {
                this.popup.destroy();
            }
            this.popup = null;
        }
        if (this._popupInner) {
            this._popupInner.owner = null;
            this._popupInner = null;
        }

        if (this.el) {
            this.el.onmouseover = this.el.onmouseout = null;
        }

        this._listbox = this.tree = null;

        mini.PopupEdit.superclass.destroy.call(this, removeEl);
    },
    _initEvents: function() {
        mini.PopupEdit.superclass._initEvents.call(this);

        mini._BindEvents(function() {
            mini_onOne(this.el, 'mouseover', this.__OnMouseOver, this);
            mini_onOne(this.el, 'mouseout', this.__OnMouseOut, this);

            //            mini.on(this.el, "mouseover", this.__OnMouseOver, this);
            //            mini.on(this.el, "mouseout", this.__OnMouseOut, this);
        }, this);
    },
    //    _initButtons: function () {
    //        this.buttons = [];

    //        var button = this.createButton({ cls: "mini-buttonedit-popup", iconCls: "mini-buttonedit-icons-popup", name: "popup" });
    //        this.buttons.push(button);
    //    },
    __OnBlur: function(e) {
        //debugger
        this._focused = false;
        if (this._clickTarget && mini.isAncestor(this.el, this._clickTarget)) return;
        if (this.isShowPopup()) return;
        mini.PopupEdit.superclass.__OnBlur.call(this, e);
    },
    __OnMouseOver: function(e) {
        if (this.isReadOnly() || this.allowInput) return;
        if (mini.findParent(e.target, 'mini-buttonedit-border')) {
            var btnEl = mini.findParent(e.target, 'mini-buttonedit-button');
            if (btnEl && btnEl != this._buttonEl) {
            } else {
                this.addCls(this._hoverCls);
            }
        }
    },
    __OnMouseOut: function(e) {
        if (this.isReadOnly() || this.allowInput) return;
        this.removeCls(this._hoverCls);
    },
    __OnMouseDown: function(e) {
        if (this.isReadOnly()) return;
        mini.PopupEdit.superclass.__OnMouseDown.call(this, e);
        if (this.allowInput == false && mini.findParent(e.target, 'mini-buttonedit-border')) {
            mini.addClass(this.el, this._pressedCls);

            mini.on(document, 'mouseup', this.__OnDocMouseUp, this);
        }
    },
    __OnInputKeyDown: function(e) {
        this.fire('keydown', { htmlEvent: e });
        if (e.keyCode == 8 && (this.isReadOnly() || this.allowInput == false)) {
            return false;
        }
        if (e.keyCode == 9) {
            this.hidePopup();
            return;
        }
        if (e.keyCode == 27) {
            this.hidePopup();
            return;
        }
        if (e.keyCode == 13) {
            this.fire('enter');
        }

        if (this.isShowPopup()) {
            if (e.keyCode == 13 || e.keyCode == 27) {
                e.stopPropagation();
            }
        }
    },

    __OnInputTextChanged: function(e) {
        if (this.isShowPopup()) {
            this._textChanged = true;
        } else {
            this._textChanged = false;
            mini.PopupEdit.superclass.__OnInputTextChanged.call(this, e);
        }
    },

    ///////////////////////////////////////////////////
    within: function(e) {
        if (mini.isAncestor(this.el, e.target)) return true;
        if (this.popup.within(e)) return true;
        return false;
    },

    popupWidth: '100%', //"","100%", 200
    popupMinWidth: 50,
    popupMaxWidth: 2000,

    popupHeight: '', // "", 30
    popupMinHeight: 30,
    popupMaxHeight: 2000,

    showPopupOnClick: false, //不管是否可编辑，true的时候点击就showPopup

    setPopup: function(value) {
        if (typeof value == 'string') {
            mini.parse(value);
            value = mini.get(value);
        }
        var p = mini.getAndCreate(value);
        if (!p) return;
        p.setVisible(false);
        //p.render(this.popup._contentEl);
        this._popupInner = p;

        p.owner = this;

        p.on('beforebuttonclick', this.__OnPopupButtonClick, this);
    },

    getPopup: function() {
        if (!this.popup) {
            this._createPopup();
        }
        return this.popup;
    },

    _createPopup: function() {
        this.popup = new mini.Popup();
        this.popup.setShowAction('none');
        this.popup.setHideAction('outerclick');
        this.popup.setPopupEl(this.el);
        this.popup.__parent = this;
        this.popup.el.setAttribute('attached', 'true');

        this.popup.on('BeforeClose', this.__OnPopupBeforeClose, this);
        this.popup.on('close', this.__OnPopupClose, this);
        mini.on(this.popup.el, 'keydown', this.__OnPopupKeyDown, this);
    },

    __OnPopupClose: function(e) {},

    __OnPopupBeforeClose: function(e) {
        if (this.within(e.htmlEvent)) e.cancel = true;
        else {
            this._unDocumentMousewheel();
        }
    },

    __OnPopupKeyDown: function(e) {},

    showPopup: function() {
        var ex = { cancel: false };
        if (this._firebeforeshowpopup !== false) {
            this.fire('beforeshowpopup', ex);
            if (ex.cancel == true) return false;
        }

        var popup = this.getPopup();

        //if (this.id == "cityCombo") debugger
        this._syncShowPopup();

        popup.on('Close', this.__OnPopupHide, this);

        this._onDocumentMousewheel();

        this.fire('showpopup');
    },
    _unDocumentMousewheel: function() {
        mini.un(document, 'mousewheel', this.__OnDocumentMousewheel, this);
        this._mousewheelXY = null;
    },
    _onDocumentMousewheel: function() {
        this._unDocumentMousewheel();

        this._mousewheelXY = mini.getXY(this.el);
        mini.on(document, 'mousewheel', this.__OnDocumentMousewheel, this);
    },
    __OnDocumentMousewheel: function(e) {
        var that = this;

        function doWheel() {
            if (!that.isShowPopup()) return;
            var box = that._mousewheelXY;
            var xy = mini.getXY(that.el);
            if (box[0] != xy[0] || box[1] != xy[1]) {
                that.hidePopup();
            } else {
                setTimeout(doWheel, 300);
            }
            //document.title = new Date().getTime();
        }

        setTimeout(doWheel, 300);
    },

    //    doLayout: function () {
    //        //if(this.id == 'lookup2') debugger
    //        mini.PopupEdit.superclass.doLayout.call(this);
    //        if (this.isShowPopup()) {
    //            //this._syncShowPopup();
    //        }
    //    },

    _syncShowPopup: function() {
        var popup = this.getPopup();

        if (this._popupInner && this._popupInner.el.parentNode != this.popup._contentEl) {
            this.popup._contentEl.appendChild(this._popupInner.el);
            this._popupInner.setVisible(true);
        }

        var box = mini.getBox(this._borderEl); //this.getBox();

        var w = this.popupWidth;
        if (this.popupWidth == '100%') w = box.width;

        //        popup.el.style.left = "-1000px";
        //        popup.el.style.top = "-1000px";

        popup.show(-1000, -1000);

        popup.setWidth(w);

        var h = parseInt(this.popupHeight);
        if (!isNaN(h)) {
            popup.setHeight(h);
        } else {
            popup.setHeight('auto');
        }

        popup.setMinWidth(this.popupMinWidth);
        popup.setMinHeight(this.popupMinHeight);
        popup.setMaxWidth(this.popupMaxWidth);
        popup.setMaxHeight(this.popupMaxHeight);

        var options = {
            xAlign: 'left',
            yAlign: 'below',
            outYAlign: 'above',
            outXAlign: 'right',
            popupCls: this.popupCls,
            alwaysView: this.alwaysView
        };

        this._doShowAtEl(this._borderEl, options);
    },
    _doShowAtEl: function(el, options) {
        var popup = this.getPopup();
        popup.showAtEl(el, options);
    },
    __OnPopupHide: function(e) {
        if (this._textChanged) {
            this._textChanged = false;

            this.__OnInputTextChanged();
        }
        this.__doFocusCls();
        this.fire('hidepopup');
    },
    hidePopup: function() {
        if (this.isShowPopup()) {
            var popup = this.getPopup();

            popup.close();

            if (this._autoBlur !== false) {
                this.blur();
            }

            //this.fire("hidepopup");
        }
    },
    isShowPopup: function() {
        if (this.popup && this.popup.isDisplay()) return true;
        else return false;
    },

    alwaysView: true,
    setAlwaysView: function(value) {
        this.alwaysView = value;
    },
    getAlwaysView: function() {
        return this.alwaysView;
    },

    setPopupWidth: function(value) {
        this.popupWidth = value;
    },
    setPopupMaxWidth: function(value) {
        this.popupMaxWidth = value;
    },
    setPopupMinWidth: function(value) {
        this.popupMinWidth = value;
    },
    getPopupWidth: function(value) {
        return this.popupWidth;
    },
    getPopupMaxWidth: function(value) {
        return this.popupMaxWidth;
    },
    getPopupMinWidth: function(value) {
        return this.popupMinWidth;
    },
    setPopupHeight: function(value) {
        this.popupHeight = value;
    },
    setPopupMaxHeight: function(value) {
        this.popupMaxHeight = value;
    },
    setPopupMinHeight: function(value) {
        this.popupMinHeight = value;
    },
    getPopupHeight: function(value) {
        return this.popupHeight;
    },
    getPopupMaxHeight: function(value) {
        return this.popupMaxHeight;
    },
    getPopupMinHeight: function(value) {
        return this.popupMinHeight;
    },
    setShowPopupOnClick: function(value) {
        this.showPopupOnClick = value;
    },
    getShowPopupOnClick: function(value) {
        return this.showPopupOnClick;
    },

    __OnClick: function(e) {
        if (this.enabled == false) return;
        this.fire('click', { htmlEvent: e });

        if (this.isReadOnly()) return;

        if (mini.isAncestor(this._buttonEl, e.target)) {
            this._OnButtonClick(e);
        }
        if (mini.findParent(e.target, this._closeCls)) {
            if (this.isShowPopup()) {
                this.hidePopup();
            }

            //            if (this.autoClear) {
            //                this.setValue("");
            //                this.setText("");
            //                //this.focus();
            //            }

            if (this.autoClear) {
                if ((this.value && this.value !== 0) || this.text !== '') {
                    this.setValue('');
                    this.setText('');
                    this._OnValueChanged();
                    //this.focus();
                }
            }

            this.fire('closeclick', { htmlEvent: e });
            return;
        }

        if (this.allowInput == false || mini.isAncestor(this._buttonEl, e.target) || this.showPopupOnClick) {
            var btnEl = mini.findParent(e.target, 'mini-buttonedit-button');
            if (btnEl && btnEl != this._buttonEl) {
                //如果点击buttons里面的按钮，则不showPopup
            } else {
                if (this.isShowPopup()) {
                    this.hidePopup();
                    this.focus();
                } else {
                    var sf = this;
                    setTimeout(function() {
                        sf.showPopup();
                    }, 1);
                }
            }
        }

        //处理新增的buttons
        this._handlerButtonElClick(e);
    },
    __OnPopupButtonClick: function(e) {
        if (e.name == 'close') {
            this.hidePopup();
        }
        e.cancel = true;
    },

    setText: function(value) {
        if (value === null || value === undefined) value = '';

        // 安全整改要求，服务端返回数据是对html编码的，但是提交时需要还原成正常的html标签
        value = mini.htmlDecode(value);

        // var fire = this.text !== value;
        this.text = value;
        this._textEl.value = value;

        this._doEmpty();
    },

    getAttrs: function(el) {
        var attrs = mini.PopupEdit.superclass.getAttrs.call(this, el);

        mini._ParseString(el, attrs, ['popupWidth', 'popupHeight', 'popup', 'onshowpopup', 'onhidepopup', 'onbeforeshowpopup']);
        mini._ParseInt(el, attrs, ['popupMinWidth', 'popupMaxWidth', 'popupMinHeight', 'popupMaxHeight']);

        mini._ParseBool(el, attrs, ['showPopupOnClick', 'alwaysView']);

        return attrs;
    }
});
mini.regClass(mini.PopupEdit, 'popupedit');


mini.ComboBox = function () {
    this.data = [];
    this.columns = [];
    mini.ComboBox.superclass.constructor.apply(this, arguments);

    this._initInput();
}
mini.extend(mini.ComboBox, mini.PopupEdit, {
    _initInput: function () {
        var me = this;
        if (isFirefox) {
            this._textEl.oninput = function () {
                me._tryQuery();
            }
        }
    },

    __input: function () {

        if (document.activeElement == this._textEl) {

            this._tryQuery();
        }
    },

    text: '',
    value: '',

    valueField: "id",
    textField: "text",
    dataField: "",
    groupField: 'group',

    delimiter: ',',
    enableGroup: false,
    multiSelect: false,
    multiLabel: false,
    data: [],
    url: "",

    valueInCheckOrder: true,

    columns: [],

    allowInput: false,
    showFilter: false,

    valueFromSelect: false, //值是否只能来自下拉数据

    popupMaxHeight: 200,

    setDelimiter: function (value) {
        this.delimiter = value;
        if (this._listbox) this._listbox.delimiter = value;
    },
    getDelimiter: function () {
        return this.delimiter;
    },

    autoFocusItem: false,
    setAutoFocusItem: function (value) {
        this.autoFocusItem = value;
    },
    getAutoFocusItem: function () {
        return this.autoFocusItem;
    },

    //    config: {
    //        autoFocusItem: false
    //    },


    set: function (kv) {
        if (typeof kv == 'string') {
            return this;
        }

        var text = kv.text;
        delete kv.text;
        var value = kv.value;
        delete kv.value;
        var url = kv.url;
        delete kv.url;
        var data = kv.data;
        delete kv.data;

        mini.ComboBox.superclass.set.call(this, kv);

        if (!mini.isNull(data)) {
            this.setData(data);

            kv.data = data;
        }
        if (!mini.isNull(url)) {
            this.setUrl(url);

            kv.url = url;
        }
        if (!mini.isNull(value)) {
            this.setValue(value);

            kv.value = value;
        }

        if (!mini.isNull(text)) {
            this.setText(text);
        }


        return this;
    },


    uiCls: "mini-combobox",


    _createPopup: function () {
        mini.ComboBox.superclass._createPopup.call(this);

        this._listbox = new mini.ListBox();

        this.listbox = this._listbox;

        this._listbox.showFilter = this.showFilter;
        this._listbox.delimiter = this.delimiter;
        this._listbox.setBorderStyle("border:0;");
        this._listbox.setStyle("width:100%;height:auto;");
        this._listbox.setEnableGroup(this.enableGroup);
        this._listbox.setGroupField(this.groupField);
        this._listbox.render(this.popup._contentEl);

        this._listbox.on("beforeitemclick", this.__OnBeforeItemClick, this);
        this._listbox.on("itemclick", this.__OnItemClick, this);
        this._listbox.on("drawcell", this.__OnItemDrawCell, this);

        var me = this;
        this._listbox.on("beforeload", function (e) {
            me.fire("beforeload", e);
        }, this);
        this._listbox.on("preload", function (e) {
            me.fire("preload", e);
        }, this);
        this._listbox.on("load", function (e) {
            me.data = e.data;
            me.fire("load", e);
        }, this);
        this._listbox.on("loaderror", function (e) {
            me.fire("loaderror", e);
        }, this);
    },
    showPopup: function () {
        var ex = { cancel: false };
        this.fire("beforeshowpopup", ex);
        this._firebeforeshowpopup = false;
        if (ex.cancel == true) return;

        if (this.showFilter) {
            this._listbox.clearFilter();
        }
        
        this._listbox.setHeight("auto");
        mini.ComboBox.superclass.showPopup.call(this);
        var h = this.popup.el.style.height;
        if (h == "" || h == "auto") {
            this._listbox.setHeight("auto");
        } else {
            this._listbox.setHeight("100%");
        }

        var me = this;

        if (!me.multiSelect) {
            var jq = jQuery("table .mini-listbox-checkbox", me._listbox.el);

            var display = jq.css("display");
            jq.css("display", "table-cell");
            jq.css("display", display);
            //alert(1);
        }


        this._listbox.setValueInCheckOrder(this.valueInCheckOrder);

        this._listbox.setValue(this.value);

        //        var sf = this;
        //        setTimeout(function () {
        //            mini.repaint(sf._listbox.el);
        //        }, 100);

        if (this.autoFocusItem && (this.value == "" || mini.isNull(this.value))) {
            this._listbox._focusItem(0);
        }
    },

    changeOnSelectMethod: false,

    isSelected: function (record) {
        return this._listbox.isSelected(record);
    },

    _syncValueText: function () {
        var items = this._listbox.getSelecteds();
        var vts = this._listbox.getValueAndText(items);
        this.setValue(vts[0]);
        this.setText(vts[1]);
    },

    selectAll: function () {
        this._listbox.selectAll();
        this._syncValueText();
    },

    deselectAll: function () {
        this._listbox.deselectAll();
        this._syncValueText();
    },

    deselect: function (item) {
        this._listbox.deselect(item);
        this._syncValueText();
        //        var items = this._listbox.getSelecteds();
        //        var vts = this._listbox.getValueAndText(items);
        //        this.setValue(vts[0]);
        //        this.setText(vts[1]);
    },

    select: function (item) {
        this._listbox.deselectAll();
        item = this.getItem(item);
        if (item) {

            this._oldValue = this.getValue();

            this._listbox.select(item);
            this.__OnItemClick({ item: item }, false);

            if (this.changeOnSelectMethod) {
                this._OnValueChanged();
            }
        }
    },
    selects: function (items) {
        if (!items) return;
        var vts = this._listbox.getValueAndText(items);
        this.setValue(vts[0]);

        this._listbox.setValue(this.value);
    },
    getItem: function (item) {
        return typeof item == "object" ? item : this.data[item];
    },
    indexOf: function (item) {
        return this.data.indexOf(item);
    },
    getAt: function (index) {
        return this.data[index];
    },
    load: function (data) {

        if (typeof data == "string") {
            this.setUrl(data);
        } else {
            this.setData(data);
        }
    },
    _eval: function (_) {
        return window["ev" + "al"]('(' + _ + ')');
    },
    setData: function (data) {

        if (typeof data == "string") {
            data = this._eval(data);
            //data = eval('(' + data + ')');
            //data = mini._getMap(data, window);

        }
        if (!mini.isArray(data)) data = [];
        this._listbox.setData(data);
        this.data = this._listbox.data;
        //        var v = this._listbox.getValue();
        //        this.setValue(v);

        this.doDataChange();
        //        var vts = this._listbox.getValueAndText(this.value);
        //        this.text = this._textEl.value = vts[1];
        //        this.setValue(vts[0]);
    },
    getData: function () {
        return this.data;
    },

    clearOnLoad: true,      //当加载时，如果value跟新数据不匹配，则清空

    setClearOnLoad: function (value) {
        this.clearOnLoad = value;
    },
    getClearOnLoad: function () {
        return this.clearOnLoad
    },

    doDataChange: function () {
        var vts = this._listbox.getValueAndText(this.value);
        var value = vts[0],
            text = vts[1];

        if (value === "" && !this.clearOnLoad) {
            value = this.value;
            text = this.text;

            this.value = null;
        }

        this.text = this._textEl.value = text;
        this.setValue(value);
    },

    setUrl: function (url) {
        this.getPopup();

        this._listbox.setUrl(url);
        this.url = this._listbox.url;
        this.data = this._listbox.data;

        this.doDataChange();
    },
    getUrl: function () {
        return this.url;
    },
    setValueField: function (valueField) {
        this.valueField = valueField;
        if (this._listbox) {
            this._listbox.setValueField(valueField);
        }
    },
    getValueField: function () {
        return this.valueField;
    },
    setTextField: function (value) {
        if (this._listbox) this._listbox.setTextField(value);
        this.textField = value;
    },
    getTextField: function () {
        return this.textField;
    },

    pinyinField: "tag",
    setPinyinField: function (value) {
        //if (this._listbox) this._listbox.setPhoneticField(value);
        this.pinyinField = value;
    },
    getPinyinField: function () {
        return this.pinyinField;
    },

    setDisplayField: function (value) {
        this.setTextField(value);
    },
    setDataField: function (value) {
        if (this._listbox) this._listbox.setDataField(value);
        this.dataField = value;
    },
    getDataField: function () {
        return this.dataField;
    },
    setEnableGroup: function(enableGroup) {
        this._listbox.setEnableGroup(enableGroup);
        this.enableGroup = enableGroup;
    },
    getEnableGroup: function() {
        return this.enableGroup;
    },
    setGroupField: function(groupField) {
        this._listbox.setGroupField(groupField);
        this.groupField = groupField;
    },
    getGroupField: function() {
        return this.groupField;
    },
    setValueInCheckOrder: function (value) {
        this.valueInCheckOrder = value;
        this._listbox.valueInCheckOrder = value;
    },
    getValueInCheckOrder: function () {
        return this.valueInCheckOrder;
    },

    //////////////////////////

    //valueFromSelect默认是false，当setValue("aaa")不存在数据中时，value="aaa", text="aaa"
    //valueFromSelect设置为true时，以上情况 value = "", text = ""

    setValue: function (value) {
        if (mini.isNull(value)) value = "";
        //if (this.value !== value) {
        var vts = this._listbox.getValueAndText(value);
        var v = vts[0], text = vts[1];
        if (text === "" || mini.isNull(text)) text = value;

        if (this.valueFromSelect && (v === "" || mini.isNull(v))) {
            value = text = "";
        }

        //		if (!this.valueFromSelect && v == "") {
        //			value = text = "";
        //		}

        this.value = value;

        this._valueEl.value = this.value;
        this.text = this._textEl.value = text;

        this._doEmpty();


        //        } else {
        //            var vts = this._listbox.getValueAndText(value);
        //            this.text = this._textEl.value = vts[1];
        //        }
    },
    setMultiSelect: function (value) {
        if (this.multiSelect != value) {
            this.multiSelect = value;
            if (this._listbox) {
                this._listbox.setMultiSelect(value);
                this._listbox.setShowCheckBox(value);
            }
        }
    },
    getMultiSelect: function () {
        return this.multiSelect;
    },
    setMultiLabel: function(value) {
        if (this.multiLabel !== !!value) {
            this.multiLabel = !!value;
            if (this.multiLabel) {
                this._createLabel();
                this.el.classList.add('mini-combobox-multilabel');
            } else {
                this._destroyLabel();
                this.el.classList.remove('mini-combobox-multilabel');
            }
        }
    },
    getMultiLabel: function() {
        return this.multiLabel;
    },
    setColumns: function (value) {
        if (!mini.isArray(value)) value = [];
        this.columns = value;
        this._listbox.setColumns(value);
    },
    getColumns: function () {
        return this.columns;
    },
    showNullItem: false,
    setShowNullItem: function (value) {
        if (this.showNullItem != value) {
            this.showNullItem = value;
            this._listbox.setShowNullItem(value);
        }
    },
    getShowNullItem: function () {
        return this.showNullItem;
    },
    setNullItemText: function (value) {
        if (this.nullItemText != value) {
            this.nullItemText = value;
            this._listbox.setNullItemText(value);
        }
    },
    getNullItemText: function () {
        return this.nullItemText;
    },
    setValueFromSelect: function (value) {
        this.valueFromSelect = value;
    },
    getValueFromSelect: function () {
        return this.valueFromSelect;
    },

    _OnValueChanged: function () {
        if (this.validateOnChanged) {
            this._tryValidate();
        }
        var sf = this;

        function changed() {
            var value = sf.getValue();
            var selecteds = sf.getSelecteds();
            var selected = selecteds[0];
            sf.fire("valuechanged", { value: value, selecteds: selecteds, selected: selected, oldValue: sf._oldValue });
        }
        setTimeout(function () {
            changed();
        }, 50);

    },
    getSelecteds: function () {
        return this._listbox.findItems(this.value);
    },
    getSelected: function () {
        return this.getSelecteds()[0];
    },
    __OnItemDrawCell: function (e) {

        this.fire("drawcell", e);
    },

    __OnBeforeItemClick: function (e) {
        var ev = { item: e.item, cancel: false };
        this.fire("beforeitemclick", ev);
        if (ev.cancel) e.cancel = true;
    },

    __OnItemClick: function (e, fire) {

        var ev = { item: e.item, cancel: false };

        if (fire !== false) {
            this.fire("beforeitemclick", ev);
            if (ev.cancel) return;
        }
        //        var v = this._listbox.getValue();
        //        var vts = this._listbox.getValueAndText(v);
        //return;
        var items = this._listbox.getSelecteds();

        var vts = this._listbox.getValueAndText(items);


        //this._stopTextChanged = true;//
        var value = this.getValue();
        this.setValue(vts[0]);
        this.setText(vts[1]);

        this._oldValue = value;

        //        if (mini.isFirefox) {   //FF下修改textEl.value，会激发changed...
        //            this.blur();
        //            this.focus();
        //        }

        if (e) {
            if (fire !== false) {
                if (value != this.getValue()) {
                    var sf = this;
                    setTimeout(function () {
                        sf._OnValueChanged();
                    }, 1);
                }

                if (!this.multiSelect) {
                    this.hidePopup();
                }
                if (!isMobile) {
                    this.focus();
                }


                this.fire("itemclick", { item: e.item });
            }
        }
    },
    __OnInputKeyDown: function (e, userOldText) {
        var ex = { htmlEvent: e };
        this.fire("keydown", ex);


        if (e.keyCode == 8 && (this.isReadOnly() || this.allowInput == false)) {
            return false;
        }

        if (e.keyCode == 9) {   //tab
            if (this.isShowPopup()) {
                this._autoBlur = false;
                this.hidePopup();
                delete this._autoBlur
            }
            return;
        }

        if (this.isReadOnly()) return;


        switch (e.keyCode) {
            case 27:        //esc
                e.preventDefault();
                if (this.isShowPopup()) {
                    e.stopPropagation();
                }

                this.hidePopup();
                this.focus();
                break;
            case 13:     //enter                
                if (this.isShowPopup()) {
                    e.preventDefault();
                    e.stopPropagation();

                    var index = this._listbox.getFocusedIndex();
                    var item = this._listbox.getAt(index);
                    if (item && item.enabled !== false) {
                        if (index != -1) {
                            var ev = { item: item, cancel: false };
                            this.fire("beforeitemclick", ev);
                            if (ev.cancel == false) {

                                this._oldValue = this.getValue();

                                if (this.multiSelect) {
                                    //this._listbox.select(item);
                                } else {
                                    this._listbox.deselectAll();
                                    this._listbox.select(item);
                                }
                                var items = this._listbox.getSelecteds();
                                var vts = this._listbox.getValueAndText(items);
                                this.setValue(vts[0]);
                                this.setText(vts[1]);
                                this._OnValueChanged();
                            }
                        }

                    }
                    this.hidePopup();
                    this.focus();
                } else {
                    this.fire("enter", ex);
                }
                break;
            case 37:    //left
                break;
            case 38:    //top      
                e.preventDefault();
                var index = this._listbox.getFocusedIndex();
                if (index == -1) {
                    index = 0;
                    if (!this.multiSelect) {
                        var item = this._listbox.findItems(this.value)[0];
                        if (item) {
                            index = this._listbox.indexOf(item);
                        }
                    }
                }
                if (this.isShowPopup()) {
                    if (!this.multiSelect) {
                        index -= 1;
                        if (index < 0) index = 0;
                        this._listbox._focusItem(index, true);
                    }
                }
                break;
            case 39:    //right
                break;
            case 40:    //bottom               
                e.preventDefault();

                var index = this._listbox.getFocusedIndex();
                if (index == -1) {
                    index = -1;
                    if (!this.multiSelect) {
                        var item = this._listbox.findItems(this.value)[0];
                        if (item) {
                            index = this._listbox.indexOf(item);
                        }
                    }
                }
                if (this.isShowPopup()) {
                    if (!this.multiSelect) {
                        index += 1;
                        if (index > this._listbox.getCount() - 1) index = this._listbox.getCount() - 1;
                        this._listbox._focusItem(index, true);
                    }
                } else {
                    if (this.keyNavEnabled) {
                        this.showPopup();
                        if (!this.multiSelect) {
                            this._listbox._focusItem(index, true);
                        }
                    }
                }
                break;
            default:
                if (this.allowInput == false) {
                } else {
                    this._tryQuery(this._textEl.value);
                }
                break;
        }
    },
    __OnInputKeyUp: function (e) {
        this.fire("keyup", { htmlEvent: e });

        //this.__OnInputKeyDown(e, false);
    },
    __OnInputKeyPress: function (e) {
        this.fire("keypress", { htmlEvent: e });
    },
    _tryQuery: function (oldText) {

        var sf = this;
        setTimeout(function () {
            var text = sf._textEl.value;
            if (text != oldText) {
                sf._doQuery(text);
                //document.title = new Date();
            }
        }, 10);
    },
    _doQuery: function (key) {
        if (!this.autoFilter) return;
        if (this.multiSelect == true) return;
        var view = [];
        //        for (var i = 0, l = this.data.length; i < l; i++) {
        //            var o = this.data[i];
        //            var text = mini._getMap(this.textField, o);
        //            if (typeof text == "string") {
        //                text = text.toUpperCase();
        //                key = key.toUpperCase();
        //                if (text.indexOf(key) != -1) {
        //                    view.push(o);
        //                }
        //            }
        //        }
        key = $.trim(key.toUpperCase());
        for (var i = 0, l = this.data.length; i < l; i++) {
            var o = this.data[i];
            var text = mini._getMap(this.textField, o);
            var pinyin = mini._getMap(this.pinyinField, o);

            text = text ? String(text).toUpperCase() : "";
            pinyin = pinyin ? String(pinyin).toUpperCase() : "";
            if (text.indexOf(key) != -1 || pinyin.indexOf(key) != -1) {
                view.push(o);
            }
        }
        this._listbox.setData(view);
        this._filtered = true;
        if (key !== "" || this.isShowPopup()) {
            this.showPopup();

            //获取第一条，并focus
            //index = this._listbox.getCount() - 1;
            var index = 0;
            //if(this.getText() == "美") debugger
            if (this._listbox.getShowNullItem()) index = 1;
            var me = this;
            //setTimeout(function () {
            me._listbox._focusItem(index, true);
            //}, 10);
        }
    },
    __OnPopupHide: function (e) {
        //alert(this.focused);

        //this.__OnInputTextChanged();          //谨慎

        //document.title = this._focused + ":" + new Date().getTime();

        if (this.valueFromSelect || this._textChanged) {         //@@

            this._textChanged = false;
            this.__OnInputTextChanged();
        }

        //if (this._textEl.value == "") this._listbox._focusedItem = null;    //隐藏下拉框时，如果没有值，则清空掉焦点项
        if (this._textEl.value == "") this._listbox._blurItem();

        if (this._filtered) {
            this._filtered = false;
            if (this._listbox.el) {
                this._listbox.setData(this.data);
            }
        }
        this.__doFocusCls();
        this.fire("hidepopup");
    },
    //    hidePopup: function () {
    //        var popup = this.getPopup();
    //        popup.close();

    //    },
    findItems: function (value) {
        return this._listbox.findItems(value);
    },
    __OnInputTextChanged: function (e) {

        if (this.isShowPopup()) {
            this._textChanged = true;
            return;
        }

        this._textChanged = false;

        this._oldValue = this.getValue();

        if (this.multiSelect == false) {

            var text = this._textEl.value;
            //valueFromSelect

            //根据text找，必须全部匹配，自动选择
            var data = this.getData();
            var selected = null;
            for (var i = 0, l = data.length; i < l; i++) {
                var item = data[i];
                var itemText = this.listbox.getItemText(item);
                var itemValue = this.listbox.getItemValue(item);
                if (itemText == text) {
                    if (mini.isNull(this.value) || this.value === "" || this.value == itemValue) {
                        selected = item;
                        break;
                    }
                }
            }
            if (selected) {
                this._listbox.setValue(selected ? selected[this.valueField] : "");

                var v = this._listbox.getValue();
                var vts = this._listbox.getValueAndText(v);

                var value = this.getValue();

                this.setValue(v);
                this.setText(vts[1]);
            } else {
                if (this.valueFromSelect) {
                    this.setValue("");
                    this.setText("");
                } else {
                    this.setValue(text);
                    this.setText(text);
                }
            }
            if (value != this.getValue()) {
                var sf = this;
                //setTimeout(function () {
                sf._OnValueChanged();
                //}, 1);
            }


        }
        //}

        //        if (this.multiSelect) {
        //        } else {
        //            if (this._textEl.value == "" && !this.value) {
        //                this.setValue("");
        //                this._OnValueChanged();
        //            }
        //            //            var _value = this.value;
        //            //            var vts = this._listbox.getValueAndText(this.value);
        //            //            if (this._textEl.value != vts[1]) {
        //            //                this.setValue("");
        //            //            }
        //            //            if (_value != this.value) {
        //            //                this._OnValueChanged();
        //            //            }
        //        }
    },
    setAjaxData: function (value) {
        this.ajaxData = value;
        this._listbox.setAjaxData(value);
    },
    setAjaxType: function (value) {
        this.ajaxType = value;
        this._listbox.setAjaxType(value);
    },
    setAjaxOptions: function (value) {
        this.ajaxOptions = value;
        this._listbox.setAjaxOptions(value);
    },

    autoFilter: true,
    setAutoFilter: function (value) {
        this.autoFilter = value;
    },
    getAutoFilter: function () {
        return this.autoFilter;
    },
    setShowFilter: function (value) {
        this.showFilter = value;
        this._listbox.showFilter = value;
    },
    getAttrs: function (el) {

        var attrs = mini.ComboBox.superclass.getAttrs.call(this, el);

        mini._ParseString(el, attrs, [
            'url',
            'data',
            'textField',
            'valueField',
            'displayField',
            'groupField',
            'nullItemText',
            'pinyinField',
            'delimiter',
            'ondrawcell',
            'onbeforeload',
            'onpreload',
            'onload',
            'onloaderror',
            'onitemclick',
            'onbeforeitemclick'
        ]);
        mini._ParseBool(el, attrs, [
            'multiSelect',
            'showNullItem',
            'valueFromSelect',
            'valueInCheckOrder',
            'clearOnLoad',
            'autoFilter',
            'autoFocusItem',
            'enableGroup',
            'multiLabel',
            'showFilter'
        ]);

        if (attrs.displayField) attrs.textField = attrs.displayField;

        var valueField = attrs.valueField || this.valueField;
        var textField = attrs.textField || this.textField;
        if (el.nodeName.toLowerCase() == "select") {

            var data = [];
            for (var i = 0, l = el.length; i < l; i++) {
                var op = el.options[i];
                var o = {};
                o[textField] = op.text;
                o[valueField] = op.value;

                data.push(o);
            }
            if (data.length > 0) {
                attrs.data = data;
            }
        } else {
            var cs = mini.getChildNodes(el);
            for (var i = 0, l = cs.length; i < l; i++) {
                var node = cs[i];
                var property = jQuery(node).attr("property");
                if (!property) continue;
                property = property.toLowerCase();
                if (property == "columns") {
                    attrs.columns = mini._ParseColumns(node);
                } else if (property == "data") {
                    attrs.data = node.innerHTML;
                }
            }
        }
        return attrs;
    }
});
mini.regClass(mini.ComboBox, 'combobox');

mini.Calendar = function () {
    this.viewDate = new Date();
    this._selectedDates = [];
    mini.Calendar.superclass.constructor.apply(this, arguments);
}
mini.extend(mini.Calendar, mini.Control, {
    width: 220,
    height: 160,

    monthPicker: false,

    _clearBorder: false,

    viewDate: null,
    _selectedDate: "",
    _selectedDates: [],              //先放置，后续完善
    multiSelect: false,

    firstDayOfWeek: epoint_local.Calendar.firstDayOfWeek,
    yesterdayText: epoint_local.Calendar.yesterdayText,
    todayText: epoint_local.Calendar.todayText,
    clearText: epoint_local.Calendar.clearText,
    okText: epoint_local.Calendar.okText,
    cancelText: epoint_local.Calendar.cancelText,
    daysShort: epoint_local.Calendar.daysShort.slice(),
    format: epoint_local.Calendar.format,

    timeFormat: epoint_local.Calendar.timeFormat,

    showTime: false,
    currentTime: true,    //点击"今天"按钮时，是否将Time设置为当前小时

    rows: 1,
    columns: 1,

    headerCls: "",
    bodyCls: "",
    footerCls: "",

    _todayCls: "mini-calendar-today",
    _weekendCls: "mini-calendar-weekend",
    _otherMonthCls: "mini-calendar-othermonth",
    _selectedDateCls: "mini-calendar-selected",

    showHeader: true,
    showFooter: true,
    showWeekNumber: false,
    showDaysHeader: true,
    showMonthButtons: true,
    showYearButtons: true,
    showTodayButton: true,
    showClearButton: true,
    showOkButton: false,

    showYesterdayButton: false,

    isWeekend: function (date) {
        var day = date.getDay();
        return day == 0 || day == 6;
    },
    getFirstDateOfMonth: function (date) {
        //first day of month
        var date = new Date(date.getFullYear(), date.getMonth(), 1);
        //获得当前周的第一天 
        return mini.getWeekStartDate(date, this.firstDayOfWeek);
    },
    getShortWeek: function (week) {
        return this.daysShort[week];
    },

    uiCls: "mini-calendar",
    _create: function () {
        var s = '<tr style="width:100%;"><td style="width:100%;"></td></tr>';
        s += '<tr ><td><div class="mini-calendar-footer">'
                    + '<span class="mini-calendar-footer-time" style="display:inline-block;"><input name="time" class="mini-timespinner mini-calendar-timespinner" format="' + this.timeFormat + '"/>'
                    + '<span class="mini-calendar-footerSpace"></span></span>'
                    + '<span class="mini-calendar-tadayButton mini-calendar-button mini-corner-all">' + this.todayText + '</span>'

                    + '<span class="mini-calendar-footerSpace"></span>'
                    + '<span class="mini-calendar-clearButton mini-calendar-button mini-corner-all">' + this.clearText + '</span>'
                    + '<span class="mini-calendar-okButton mini-calendar-button mini-corner-all">' + this.okText + '</span>'
                    + '<a href="#" class="mini-calendar-focus" style="position:absolute;left:-10px;top:-10px;width:0px;height:0px;outline:none" hideFocus></a>'
                    + '</div></td></tr>';

        var html = '<table class="mini-calendar" cellpadding="0" cellspacing="0">' + s + '</table>';

        var d = document.createElement("div");
        d.innerHTML = html;
        this.el = d.firstChild;

        var trs = this.el.getElementsByTagName("tr");
        var tds = this.el.getElementsByTagName("td");

        this._innerEl = tds[0];
        this._footerEl = mini.byClass("mini-calendar-footer", this.el);

        this.timeWrapEl = this._footerEl.childNodes[0];
        this.todayButtonEl = this._footerEl.childNodes[1];
        this.footerSpaceEl = this._footerEl.childNodes[2];
        this.closeButtonEl = this._footerEl.childNodes[3];
        this.okButtonEl = this._footerEl.childNodes[4];
        this._focusEl = this._footerEl.lastChild;

        //
        //debugger
        this.yesterdayButtonEl = mini.after(this.todayButtonEl, '<span class="mini-calendar-tadayButton yesterday mini-calendar-button mini-corner-all">' + this.yesterdayText + '</span>');


        mini.parse(this._footerEl);
        this.timeSpinner = mini.getbyName('time', this.el);
        this.doUpdate();
    },
    focus: function () {
        try {
            this._focusEl.focus();
        } catch (e) { }
    },
    destroy: function (removeEl) {

        if (this.timeSpinner) {
            this.timeSpinner.destroy();
            this.timeSpinner = null;
        }

        this._innerEl = this._footerEl = this.timeWrapEl = this.todayButtonEl = this.footerSpaceEl = this.closeButtonEl = null;

        this._focusEl = this.okButtonEl = this.yesterdayButtonEl = null;

        this.timeSpinner = null;

        mini.Calendar.superclass.destroy.call(this, removeEl);
    },
    _initEvents: function () {
        if (this.timeSpinner) this.timeSpinner.on("valuechanged", this.__OnTimeChanged, this);
        mini._BindEvents(function () {
            //            mini_onOne(this.el, "click", this.__OnClick, this);
            //            mini_onOne(this.el, "mousedown", this.__OnMouseDown, this);
            //            mini_onOne(this.el, "keydown", this.__OnKeyDown, this);


            mini.on(this.el, "click", this.__OnClick, this);
            mini.on(this.el, "mousedown", this.__OnMouseDown, this);
            mini.on(this.el, "keydown", this.__OnKeyDown, this);

        }, this);


        //        var self = this;
        //        setInterval(function () {
        //            if (self.menuEl) {
        //                if (!self.isDisplay()) {
        //                    self.hideMenu();
        //                }
        //            }
        //        }, 50);
    },
    getDateEl: function (date) {
        if (!date) return null;
        var id = this.uid + "$" + mini.clearTime(date).getTime();
        return document.getElementById(id);
    },
    within: function (e) {
        if (mini.isAncestor(this.el, e.target)) return true;
        if (this.menuEl && mini.isAncestor(this.menuEl, e.target)) return true;
        return false;
    },
    //    setHeaderCls: function (value) {
    //        this.headerCls = value;
    //        this.doUpdate();
    //    },
    //    getHeaderCls: function () {
    //        return this.headerCls;
    //    },
    //    setBodyCls: function (value) {
    //        this.bodyCls = value;
    //        this.doUpdate();
    //    },
    //    getBodyCls: function () {
    //        return this.bodyCls;
    //    },
    //    setFooterCls: function (value) {
    //        this.footerCls = value;
    //        this.doUpdate();
    //    },
    //    getFooterCls: function () {
    //        return this.footerCls;
    //    },
    //    set_todayCls: function (value) {
    //        this._todayCls = value;
    //        this.doUpdate();
    //    },
    //    get_todayCls: function () {
    //        return this._todayCls;
    //    },
    //    set_otherMonthCls: function (value) {
    //        this._otherMonthCls = value;
    //        this.doUpdate();
    //    },
    //    get_otherMonthCls: function () {
    //        return this._otherMonthCls;
    //    },
    //    set_weekendCls: function (value) {
    //        this._weekendCls = value;
    //        this.doUpdate();
    //    },
    //    get_weekendCls: function () {
    //        return this._weekendCls;
    //    },
    //    setShowClearButton: function (value) {
    //        this.showClearButton = value;
    //        debugger
    //        var button = this.getButton("clear");
    //        if (button) {
    //            this.doUpdate();
    //        }
    //    },
    //    getShowClearButton: function () {
    //        return this.showClearButton;
    //    },
    setShowHeader: function (value) {
        this.showHeader = value;
        this.doUpdate();
    },
    getShowHeader: function () {
        return this.showHeader;
    },
    setShowFooter: function (value) {
        this.showFooter = value;
        this.doUpdate();
    },
    getShowFooter: function () {
        return this.showFooter;
    },
    setShowWeekNumber: function (value) {
        this.showWeekNumber = value;
        this.doUpdate();
    },
    getShowWeekNumber: function () {
        return this.showWeekNumber;
    },
    setShowDaysHeader: function (value) {
        this.showDaysHeader = value;
        this.doUpdate();
    },
    getShowDaysHeader: function () {
        return this.showDaysHeader;
    },
    setShowMonthButtons: function (value) {
        this.showMonthButtons = value;
        this.doUpdate();
    },
    getShowMonthButtons: function () {
        return this.showMonthButtons;
    },
    setShowYearButtons: function (value) {
        this.showYearButtons = value;
        this.doUpdate();
    },
    getShowYearButtons: function () {
        return this.showYearButtons;
    },
    setShowTodayButton: function (value) {
        this.showTodayButton = value;
        this.todayButtonEl.style.display = this.showTodayButton ? "" : "none";
        this.doUpdate();
    },
    getShowTodayButton: function () {
        return this.showTodayButton;
    },
    setShowYesterdayButton: function (value) {
        this.showYesterdayButton = value;
        this.yesterdayButtonEl.style.display = this.showYesterdayButton ? "" : "none";
        this.doUpdate();
    },
    getShowYesterdayButton: function () {
        return this.showYesterdayButton;
    },
    setShowClearButton: function (value) {
        this.showClearButton = value;
        this.closeButtonEl.style.display = this.showClearButton ? "" : "none";
        this.doUpdate();
    },
    getShowClearButton: function () {
        return this.showClearButton;
    },
    setShowOkButton: function (value) {
        this.showOkButton = value;
        this.okButtonEl.style.display = this.showOkButton ? "" : "none";
        this.doUpdate();
    },
    getShowOkButton: function () {
        return this.showOkButton;
    },

    setViewDate: function (value) {
        value = mini.parseDate(value);
        if (!value) value = new Date();
        if (mini.isDate(value)) value = new Date(value.getTime());
        this.viewDate = value;
        this.doUpdate();
    },
    getViewDate: function () {
        return this.viewDate;
    },
    setSelectedDate: function (value) {
        value = mini.parseDate(value);
        if (!mini.isDate(value)) value = "";
        else value = new Date(value.getTime());

        var dateEl = this.getDateEl(this._selectedDate);
        if (dateEl) mini.removeClass(dateEl, this._selectedDateCls);


        this._selectedDate = value;
        if (this._selectedDate) this._selectedDate = mini.cloneDate(this._selectedDate);

        var dateEl = this.getDateEl(this._selectedDate);
        if (dateEl) mini.addClass(dateEl, this._selectedDateCls);

        this.fire("datechanged");

    },
    setSelectedDates: function (value) {
        if (!mini.isArray(value)) value = [];
        this._selectedDates = value;
        this.doUpdate();
    },
    getSelectedDate: function () {
        return this._selectedDate ? this._selectedDate : "";
    },
    setTime: function (time) {
        this.timeSpinner.setValue(time);
    },
    getTime: function () {
        return this.timeSpinner.getFormValue();
    },
    setValue: function (value) {
        this.setSelectedDate(value);
        if (!value) {
            value = new Date();
        }
        this.setTime(value);
    },
    getValue: function () {
        var d = this._selectedDate;
        if (d) {
            d = mini.clearTime(d);
            if (this.showTime) {

                var d2 = this.timeSpinner.getValue();

                if (d2) {
                    d.setHours(d2.getHours());
                    d.setMinutes(d2.getMinutes());
                    d.setSeconds(d2.getSeconds());
                }
            }
        }
        return d ? d : "";
    },
    getFormValue: function () {
        var d = this.getValue();
        if (d) return mini.formatDate(d, 'yyyy-MM-dd HH:mm:ss');
        return "";
    },
    isSelectedDate: function (date) {
        if (!date || !this._selectedDate) return false;
        return mini.clearTime(date).getTime()
                == mini.clearTime(this._selectedDate).getTime();
    },
    setMultiSelect: function (value) {
        this.multiSelect = value;
        this.doUpdate();
    },
    getMultiSelect: function () {
        return this.multiSelect;
    },
    setRows: function (value) {
        if (isNaN(value)) return;
        if (value < 1) value = 1;
        this.rows = value;
        this.doUpdate();
    },
    getRows: function () {
        return this.rows;
    },
    setColumns: function (value) {
        if (isNaN(value)) return;
        if (value < 1) value = 1;
        this.columns = value;
        this.doUpdate();
    },
    getColumns: function () {
        return this.columns;
    },
    setShowTime: function (value) {
        if (this.showTime != value) {
            this.showTime = value;
            this.timeWrapEl.style.display = this.showTime ? '' : "none";

            jQuery(this._footerEl).toggleClass("mini-calendar-hastime", this.showTime);
            this.doLayout();
        }
    },
    getShowTime: function () {
        return this.showTime;
    },
    setTimeFormat: function (value) {
        if (this.timeFormat != value) {

            this.timeSpinner.setFormat(value);
            this.timeFormat = this.timeSpinner.format;
        }
    },
    getTimeFormat: function () {
        return this.timeFormat;
    },
    doLayout: function () {

        if (!this.canLayout()) return;

        this.timeWrapEl.style.display = this.showTime ? '' : "none";
        this.todayButtonEl.style.display = this.showTodayButton ? "" : "none";
        this.closeButtonEl.style.display = this.showClearButton ? "" : "none";


        this.yesterdayButtonEl.style.display = this.showYesterdayButton ? "" : "none";


        this.okButtonEl.style.display = this.showOkButton ? "" : "none";
        this.footerSpaceEl.style.display = (this.showClearButton && this.showTodayButton) ? "" : "none";

        this._footerEl.style.display = this.showFooter ? "" : "none";

        var views = this._innerEl.firstChild;

        var autoHeight = this.isAutoHeight();
        if (!autoHeight) {

            views.parentNode.style.height = "100px";
            h = jQuery(this.el).height();
            //views.style.display = "";

            h -= jQuery(this._footerEl).outerHeight()

            views.parentNode.style.height = h + "px";
        } else {
            views.parentNode.style.height = "";
        }

        mini.layout(this._footerEl);


        if (this.monthPicker) this._tryShowMenu();
    },
    doUpdate: function () {
        if (!this._allowUpdate) return;

        var viewDate = new Date(this.viewDate.getTime());
        var isOne = this.rows == 1 && this.columns == 1;
        var h = 100 / this.rows;
        var s = '<table class="mini-calendar-views" border="0" cellpadding="0" cellspacing="0">';
        for (var i = 0, l = this.rows; i < l; i++) {
            s += '<tr >';
            for (var j = 0, k = this.columns; j < k; j++) {
                s += '<td style="height:' + h + '%">';

                s += this._CreateView(viewDate, i, j);

                s += '</td>';

                viewDate = new Date(viewDate.getFullYear(), viewDate.getMonth() + 1, 1);
            }
            s += '</tr>';
        }

        s += '</table>';
        this._innerEl.innerHTML = s;

        var el = this.el;
        setTimeout(function () {
            mini.repaint(el);
        }, 100);

        this.doLayout();
    },
    _CreateView: function (viewDate, row, column) {
        var month = viewDate.getMonth();
        var date = this.getFirstDateOfMonth(viewDate);
        var firstDateOfWeek = new Date(date.getTime());
        var todayTime = mini.clearTime(new Date()).getTime();
        var selectedTime = this.value ? mini.clearTime(this.value).getTime() : -1;

        var multiView = this.rows > 1 || this.columns > 1;

        var s = '';
        s += '<table class="mini-calendar-view" border="0" cellpadding="0" cellspacing="0">';
        //header
        if (this.showHeader) {
            s += '<tr ><td colSpan="10" class="mini-calendar-header"><div class="mini-calendar-headerInner">';
            if (row == 0 && column == 0) {
                s += '<div class="mini-calendar-prev mini-icon">';
                if (this.showYearButtons) s += '<span class="mini-calendar-yearPrev mini-icon"></span>';
                if (this.showMonthButtons) s += '<span class="mini-calendar-monthPrev mini-icon"></span>';
                s += '</div>';
            }
            if (row == 0 && column == this.columns - 1) {
                s += '<div class="mini-calendar-next mini-icon">';
                if (this.showMonthButtons) s += '<span class="mini-calendar-monthNext mini-icon"></span>';
                if (this.showYearButtons) s += '<span class="mini-calendar-yearNext mini-icon"></span>';
                s += '</div>';
            }
            s += '<span class="mini-calendar-title">' + mini.formatDate(viewDate, this.format); +'</span>';
            s += '</div></td></tr>';
        }

        //daysHeader
        if (this.showDaysHeader) {
            s += '<tr class="mini-calendar-daysheader"><td class="mini-calendar-space"></td>';
            if (this.showWeekNumber) {
                s += '<td sclass="mini-calendar-weeknumber"></td>';
            }

            for (var j = this.firstDayOfWeek, k = j + 7; j < k; j++) {
                var name = this.getShortWeek(j);
                s += '<td yAlign="middle">';
                s += name;
                s += '</td>';
                date = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
            }
            s += '<td class="mini-calendar-space"></td></tr>';
        }

        //days
        date = firstDateOfWeek;
        for (var i = 0; i <= 5; i++) {
            s += '<tr class="mini-calendar-days"><td class="mini-calendar-space"></td>';
            if (this.showWeekNumber) {
                var num = mini.getWeek(date.getFullYear(), date.getMonth() + 1, date.getDate());
                if (String(num).length == 1) num = "0" + num;
                s += '<td class="mini-calendar-weeknumber" yAlign="middle">' + num + '</td>';
            }
            for (var j = this.firstDayOfWeek, k = j + 7; j < k; j++) {
                var weekend = this.isWeekend(date);
                var clearTime = mini.clearTime(date).getTime();
                var isToday = clearTime == todayTime;
                var isSelected = this.isSelectedDate(date);

                if (month != date.getMonth() && multiView) {
                    clearTime = -1;
                }

                var e = this._OnDrawDate(date);

                s += '<td yAlign="middle" id="';
                s += this.uid + "$" + clearTime;
                s += '" class="mini-calendar-date ';
                if (weekend) {
                    s += ' mini-calendar-weekend '
                }
                if (e.allowSelect == false) {
                    s += ' mini-calendar-disabled '
                }

                if (month != date.getMonth() && multiView) {
                } else {
                    if (isSelected) {
                        s += ' ' + this._selectedDateCls + ' ';
                    }
                    if (isToday) {
                        s += ' mini-calendar-today '
                    }
                }
                if (month != date.getMonth()) {
                    s += ' mini-calendar-othermonth ';
                }

                if (e.dateCls) s += ' ' + e.dateCls;

                s += '" style="';
                if (e.dateStyle) s += e.dateStyle;
                s += '">';

                if (month != date.getMonth() && multiView) {
                } else {

                    s += e.dateHtml;
                }
                s += '</td>';

                date = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
            }
            s += '<td class="mini-calendar-space"></td></tr>';
        }
        s += '<tr class="mini-calendar-bottom" colSpan="10"><td ></td></tr>';

        s += '</table>';
        return s;
    },
    _OnDrawDate: function (date) {
        var e = {
            date: date,
            dateCls: "",
            dateStyle: "",
            dateHtml: date.getDate(),
            allowSelect: true

        };
        this.fire("drawdate", e);
        return e;
    },
    _OnDateClick: function (date, action) {


        var e = { date: date, action: action };
        this.fire("dateclick", e);

        this._OnValueChanged();

        this.hideMenu();
    },
    /////////////////////////////////////////////
    menuEl: null,
    menuYear: null,
    menuSelectMonth: null,
    menuSelectYear: null,
    _tryShowMenu: function () {
        if (!this.menuEl) {
            var that = this;

            setTimeout(function () {
                that.showMenu();
            }, 1);
        }
    },
    showMenu: function () {

        this.hideMenu();

        this.menuYear = parseInt(this.viewDate.getFullYear() / 10) * 10;
        this._menuselectMonth = this.viewDate.getMonth();
        this._menuselectYear = this.viewDate.getFullYear();

        var s = '<div class="mini-calendar-menu"></div>';
        this.menuEl = mini.append(document.body, s);
        this.updateMenu(this.viewDate);

        var box = this.getBox();
        //        box.x += 1;
        //        box.y += 1;
        //        box.width -= 2;
        //        box.height -= 2;

        //        var border = mini.getBorders(this.el);
        //        debugger
        if (this.el.style.borderWidth == "0px") {
            this.menuEl.style.border = "0";
        }
        mini.setBox(this.menuEl, box);

        //        var elBox = mini.getBox(el);
        //        var x = elBox.x, y = elBox.y;

        //        mini.setX(this.menuEl, x);
        //        mini.setY(this.menuEl, y);

        mini.on(this.menuEl, "click", this.__OnMenuClick, this);
        mini.on(this.menuEl, "dblclick", this.__OnMenuDblClick, this);
        mini.on(document, "mousedown", this.__OnBodyMenuMouseDown, this);
    },
    //        hide: function () {debugger
    //            mini.Calendar.superclass.hide.call(this);
    //            this.hideMenu();
    //        },
    hideMenu: function () {

        if (this.menuEl) {
            mini.un(this.menuEl, "click", this.__OnMenuClick, this);
            mini.un(document, "mousedown", this.__OnBodyMenuMouseDown, this);
            jQuery(this.menuEl).remove();
            this.menuEl = null;
        }
    },
    updateMenu: function () {
        if (!this.menuEl) return;
        var s = '<div class="mini-calendar-menu-months">';
        for (var i = 0, l = 12; i < l; i++) {
            var text = mini.getShortMonth(i);
            var cls = "";
            if (this._menuselectMonth == i) cls = "mini-calendar-menu-selected";
            s += '<a id="' + i + '" class="mini-calendar-menu-month ' + cls + '" href="javascript:void(0);" hideFocus onclick="return false">' + text + '</a>';
        }
        s += '<div style="clear:both;"></div></div>';

        s += '<div class="mini-calendar-menu-years">';
        for (var i = this.menuYear, l = this.menuYear + 10; i < l; i++) {
            var text = i;
            var cls = "";
            if (this._menuselectYear == i) cls = "mini-calendar-menu-selected";
            s += '<a id="' + i + '" class="mini-calendar-menu-year ' + cls + '" href="javascript:void(0);" hideFocus onclick="return false">' + text + '</a>';
        }
        s += '<div class="mini-calendar-menu-prevYear mini-icon"></div><div class="mini-calendar-menu-nextYear mini-icon"></div><div style="clear:both;"></div></div>';

        s += '<div class="mini-calendar-footer">'
            + '<span class="mini-calendar-okButton mini-calendar-button mini-corner-all">' + this.okText + '</span>'
            + '<span class="mini-calendar-footerSpace"></span>'
            + '<span class="mini-calendar-cancelButton mini-calendar-button mini-corner-all">' + this.cancelText + '</span>'
            + '</div><div style="clear:both;"></div>';

        this.menuEl.innerHTML = s;
    },
    __OnMenuClick: function (e) {

        var me = this,
            t = e.target,
            monthCls = "mini-calendar-menu-month",
            yearCls = "mini-calendar-menu-year",
            selCls = "mini-calendar-menu-selected";


        function updateMenu() {
            setTimeout(function () {
                me.updateMenu();
            }, 30);
        }

        var monthEl = mini.findParent(t, monthCls);
        var yearEl = mini.findParent(t, yearCls);

        if (monthEl) {
            this._menuselectMonth = parseInt(monthEl.id);
            //updateMenu();

            jQuery("." + monthCls, me.menuEl).removeClass(selCls);
            jQuery(t).parent().find("#" + this._menuselectMonth).addClass(selCls);

        }
        else if (yearEl) {
            this._menuselectYear = parseInt(yearEl.id);
            //updateMenu();

            jQuery("." + yearCls, me.menuEl).removeClass(selCls);
            jQuery(t).parent().find("#" + this._menuselectYear).addClass(selCls);
        }
        else if (mini.findParent(t, "mini-calendar-menu-prevYear")) {
            this.menuYear = this.menuYear - 1;
            this.menuYear = parseInt(this.menuYear / 10) * 10;
            updateMenu();
        }
        else if (mini.findParent(t, "mini-calendar-menu-nextYear")) {
            this.menuYear = this.menuYear + 11;
            this.menuYear = parseInt(this.menuYear / 10) * 10;
            updateMenu();
        }
        else if (mini.findParent(t, "mini-calendar-okButton")) {
            this.__getMonthYear();
        }
        else if (mini.findParent(t, "mini-calendar-cancelButton")) {
            if (this.monthPicker) {

                this._OnDateClick(null, "cancel");
            } else {
                this.hideMenu();
            }
        }
    },
    __OnMenuDblClick: function (e) {

        var yearEl = mini.findParent(e.target, "mini-calendar-menu-year");
        var monthEl = mini.findParent(e.target, "mini-calendar-menu-month");
        var dateEl = mini.findParent(e.target, "mini-calendar-date ");

        if (!yearEl && !monthEl && !dateEl) return;

        if (this.monthPicker) {

            if (!monthEl && !yearEl) return;
        }

        this.__getMonthYear();

    },
    __getMonthYear: function () {
        var date = new Date(this._menuselectYear, this._menuselectMonth, 1);
        if (this.monthPicker) {
            this.setViewDate(date);
            this.setSelectedDate(date);
            this._OnDateClick(date);
        } else {
            this.setViewDate(date);
            this.hideMenu();
        }
    },
    __OnBodyMenuMouseDown: function (e) {
        if (!mini.findParent(e.target, "mini-calendar-menu")) {
            if (!mini.findParent(e.target, "mini-monthpicker")) {
                //if (!this.monthPicker) {
                this.hideMenu();
                //}

            }
        }
    },
    ///////////////////////////////////////////////
    __OnClick: function (e) {
        var viewDate = this.viewDate;
        if (this.enabled == false) return;
        var t = e.target;
        var titleEl = mini.findParent(e.target, "mini-calendar-title");

        if (mini.findParent(t, "mini-calendar-monthNext")) {
            viewDate.setDate(1);
            viewDate.setMonth(viewDate.getMonth() + 1);
            this.setViewDate(viewDate);
        }
        else if (mini.findParent(t, "mini-calendar-yearNext")) {
            //viewDate.setMonth(0);
            viewDate.setDate(1);
            viewDate.setFullYear(viewDate.getFullYear() + 1);
            this.setViewDate(viewDate);
        }
        else if (mini.findParent(t, "mini-calendar-monthPrev")) {
            viewDate.setMonth(viewDate.getMonth() - 1);
            this.setViewDate(viewDate);
        }
        else if (mini.findParent(t, "mini-calendar-yearPrev")) {
            viewDate.setFullYear(viewDate.getFullYear() - 1);
            this.setViewDate(viewDate);
        }
        else if (mini.findParent(t, "mini-calendar-tadayButton")) {

            // var d = mini.clearTime(new Date());
            var isYesterday = !!mini.findParent(t, "yesterday");

            var d = new Date();
            if (isYesterday) {
                d.setDate(d.getDate() - 1);
            }
            this.setViewDate(d);
            this.setSelectedDate(d);
            if (this.currentTime) {
                var td = new Date();
                this.setTime(td);
            }
            this._OnDateClick(d, "today");
        }
        else if (mini.findParent(t, "mini-calendar-clearButton")) {
            this.setSelectedDate(null);
            this.setTime(null);
            this._OnDateClick(null, "clear");
        } else if (mini.findParent(t, "mini-calendar-okButton")) {
            this._OnDateClick(null, "ok");
            //            this.setSelectedDate(null);
            //            this.setTime(null);
            //            this._OnDateClick(null, "clear");
        } else if (titleEl) {
            this.showMenu();
        }

        var dateEl = mini.findParent(e.target, "mini-calendar-date");

        if (dateEl && !mini.hasClass(dateEl, "mini-calendar-disabled")) {
            var ids = dateEl.id.split("$");
            var time = parseInt(ids[ids.length - 1]);
            if (time == -1) return;
            var date = new Date(time);

            this._OnDateClick(date);
        }

        //this.focus();
    },
    __OnMouseDown: function (e) {
        if (this.enabled == false) return;
        var dateEl = mini.findParent(e.target, "mini-calendar-date");
        if (dateEl && !mini.hasClass(dateEl, "mini-calendar-disabled")) {
            var ids = dateEl.id.split("$");
            var time = parseInt(ids[ids.length - 1]);
            if (time == -1) return;
            var date = new Date(time);
            this.setSelectedDate(date);
        }
    },
    __OnTimeChanged: function (e) {
        this.fire("timechanged");
        this._OnValueChanged();
    },

    __OnKeyDown: function (e) {
        if (this.enabled == false) return;
        //
        //alert(1);
        var date = this.getSelectedDate();
        if (!date) date = new Date(this.viewDate.getTime());
        switch (e.keyCode) {
            case 27:        //esc

                break;
            case 13:     //enter
                if (date) {
                    //e.stopPropagation();
                    this._OnDateClick(date);
                }
                return;
                break;
            case 37:    //left
                date = mini.addDate(date, -1, 'D');
                break;
            case 38:    //top      
                date = mini.addDate(date, -7, 'D');
                break;
            case 39:    //right
                date = mini.addDate(date, 1, 'D');
                break;
            case 40:    //bottom                   
                date = mini.addDate(date, 7, 'D');
                break;
            default:
                break;
        }
        var me = this;


        if (date.getMonth() != me.viewDate.getMonth()) {
            me.setViewDate(mini.cloneDate(date));
            me.focus();
        }

        var dateEl = this.getDateEl(date);
        if (dateEl && mini.hasClass(dateEl, "mini-calendar-disabled")) {
            return;
        }

        me.setSelectedDate(date);

        if (e.keyCode == 37 || e.keyCode == 38 || e.keyCode == 39 || e.keyCode == 40) {
            e.preventDefault();
        }

    },

    _OnValueChanged: function () {
        this.fire("valuechanged");
    },
    ////////////////////////////////
    getAttrs: function (el) {
        var attrs = mini.Calendar.superclass.getAttrs.call(this, el);

        mini._ParseString(el, attrs,
            ["viewDate", "rows", "columns",
                "ondateclick", "ondrawdate", "ondatechanged", "timeFormat", "ontimechanged", "onvaluechanged"
             ]
        );
        mini._ParseBool(el, attrs,
            ["multiSelect", "showHeader", "showFooter", "showWeekNumber", "showDaysHeader",
            "showMonthButtons", "showYearButtons", "showTodayButton", "showClearButton", "showYesterdayButton",
            "showTime", "showOkButton"
             ]
        );

        return attrs;
    }
});
mini.regClass(mini.Calendar, "calendar");


/*
    setSelectedDate     只设置Date
    setTime             只设置Time
    setValue            同时设置Date和Time
                        getValue同理

    1.点击日期格子，只修改Date
    2.clearButton       清除Date和Time
    3.todayButton       1）不修改Time；2）将Time设置为当前日期currentTime=true
                        这个不需要。
                        实现方式：监听DateClick事件，让用户来设置小时

    事件：
        valuechanged
        datechanged
        timechanged

*/

mini.ListBox = function () {
    mini.ListBox.superclass.constructor.apply(this, arguments);
}
mini.extend(mini.ListBox, mini.ListControl, {
    formField: true,

    groupField: 'group',
    enableGroup: false,

    //width: 200,
    columns: null,
    columnWidth: 80,

    showNullItem: false,
    nullItemText: "",

    showEmpty: false,
    emptyText: epoint_local.FilterTree.emptyText,

    showCheckBox: false,
    showAllCheckBox: true,
    multiSelect: false,

    showFilter: false,

    _itemCls: "mini-listbox-item",
    _itemHoverCls: "mini-listbox-item-hover",
    _itemSelectedCls: "mini-listbox-item-selected",

    uiCls: "mini-listbox",
    _create: function () {
        this.el = document.createElement("div");
        this.el.className = "mini-listbox";

        this.el.innerHTML = '<div class="mini-listbox-border"><div class="mini-listbox-header"></div><div class="mini-listbox-view"></div><input type="hidden"/></div><div class="mini-errorIcon"></div>';

        this._borderEl = this.el.firstChild;
        this._headerEl = this._borderEl.firstChild;
        this._viewEl = this._borderEl.childNodes[1];
        this._valueEl = this._borderEl.childNodes[2];

        this._errorIconEl = this.el.lastChild;

        this._scrollViewEl = this._viewEl;


        this._viewEl.innerHTML = '<div class="mini-grid-rows-content"></div>';

        this._contentEl = this._viewEl.firstChild;
    },
    _initEvents: function () {
        mini.ListBox.superclass._initEvents.call(this);
        mini._BindEvents(function () {
            mini_onOne(this._viewEl, "scroll", this.__OnScroll, this);

            //mini.on(this._viewEl, "scroll", this.__OnScroll, this);
        }, this);

    },
    destroy: function (removeEl) {
        if (this._viewEl) {
            this._viewEl.onscroll = null;
            mini.clearEvent(this._viewEl);
            this._viewEl = null;
        }
        this._borderEl = this._headerEl = this._viewEl = this._valueEl = this._errorIconEl = this._scrollViewEl = this._contentEl = null;
        mini.ListBox.superclass.destroy.call(this, removeEl);
    },
    setColumns: function (value) {
        //{name, visible, header, field，width, headerAlign, align, headerCls, cellCls, headerStyle, cellStyle}
        if (!mini.isArray(value)) value = [];
        this.columns = value;

        for (var i = 0, l = this.columns.length; i < l; i++) {
            var column = this.columns[i];

            if (column.type) {
                if (!mini.isNull(column.header) && typeof column.header !== "function") {
                    if (column.header.trim() == "") {
                        delete column.header;
                    }
                }
                var col = mini._getColumn(column.type);
                if (col) {
                    var _column = mini.copyTo({}, column);
                    mini.copyTo(column, col);
                    mini.copyTo(column, _column);
                }
            }

            var width = parseInt(column.width);
            if (mini.isNumber(width) && String(width) == column.width) column.width = width + "px";
            if (mini.isNull(column.width)) column.width = this.columnWidth + "px";
        }

        this.doUpdate();
    },

    isVisibleColumn: function (column) {
        column = this.getColumn(column);
        if (column.visible == false) return false;
        return true;
    },
    getColumn: function (index) {
        var t = typeof index;
        if (t == "number") return this.columns[index];
        else if (t == "object") return index;
        else {
            for (var i = 0, l = this.columns.length; i < l; i++) {
                var col = this.columns[i];
                if (col.name == index) {
                    return col;
                }
            }
            return null;
            //return this._nameColumns[index];
        }
    },
    hideColumn: function (column) {
        column = this.getColumn(column);
        if (!column) return;

        column.visible = false;

        //        for (var i = 0, l = this.columns.length; i < l; i++) {
        //            var col = this.columns[i];
        //            if (col.name == column.name) {
        //                col.visible = false;
        //            }
        //        }
        //this.setColumns(this.columns);

        this.doUpdate();
    },
    showColumn: function (column) {

        column = this.getColumn(column);
        if (!column) return;
        column.visible = true;
        //        for (var i = 0, l = this.columns.length; i < l; i++) {
        //            var col = this.columns[i];
        //            if (col.name == column.name) {
        //                col.visible = true;
        //            }
        //        }
        //this.setColumns(this.columns);

        this.doUpdate();
    },


    getColumns: function () {
        return this.columns;
    },
    doUpdate: function () {
        var self = this;
        if (this._allowUpdate === false) return;
        var hasColumns = this.columns && this.columns.length > 0;

        if (hasColumns) {
            mini.addClass(this.el, "mini-listbox-showColumns");
        } else {
            mini.removeClass(this.el, "mini-listbox-showColumns");
        }
        this._headerEl.style.display = hasColumns ? "" : "none";

        var sb = [];
        if (hasColumns) {
            sb[sb.length] = '<table class="mini-listbox-headerInner" cellspacing="0" cellpadding="0"><tr>';
            var ckAllId = this.uid + "$ck$all";
            if (this.showCheckBox) {
                sb[sb.length] = '<td class="mini-listbox-checkbox"><input type="checkbox" id="' + ckAllId + '"></td>';
            }
            for (var j = 0, k = this.columns.length; j < k; j++) {
                var column = this.columns[j];

                if (column.visible === false) {
                    continue;
                }

                var header = column.header;
                if (mini.isNull(header)) header = '&nbsp;';

                var w = column.width;
                if (mini.isNumber(w)) w = w + "px";

                sb[sb.length] = '<td class="';
                if (column.headerCls) sb[sb.length] = column.headerCls;
                sb[sb.length] = '" style="';
                if (column.headerStyle) sb[sb.length] = column.headerStyle + ";";
                if (w) {
                    sb[sb.length] = 'width:' + w + ';';
                }
                if (column.headerAlign) {
                    sb[sb.length] = 'text-align:' + column.headerAlign + ';';
                }


                sb[sb.length] = '">';
                sb[sb.length] = header;
                sb[sb.length] = '</td>';
            }
            sb[sb.length] = '</tr></table>';
            this._headerEl.innerHTML = sb.join('');
        }else if(this.showFilter) {    // 多列不支持搜索
            this._headerEl.style.display = '';
            mini.addClass(this._headerEl, 'show-filter');
            if(!this.filterInput) {
                
                this._headerEl.innerHTML = '';
                var filter = new mini.ButtonEdit();
                filter.setWidth('100%');
                filter.setCls('mini-listbox-filter');
                filter.setEmptyText(this.emptyText);
                filter.on('enter', this._handleFilter, this);
                filter.on('buttonclick', this._handleFilter, this);
    
                this.filterInput = filter;
    
                filter.render(this._headerEl);
            }
            
            
        }

        var sb = [];
        var data = this.data;

        if (this.showEmpty && data.length == 0) {
            sb[sb.length] = '<table class="mini-listbox-items" cellspacing="0" cellpadding="0">';
            sb[sb.length] = '<tr><td colspan="20">' + this.emptyText + '</td></tr>';
            sb[sb.length] = '</table>';
        } else {
            this._doNullItem();

            var opts = [];
            if (this.enableGroup && !hasColumns) {  // 多列不考虑分组
                var optGroup = {},  // 分组
                    optGroupList = [],
                    idx = 0;

                // 显示空选项时，提前取出
                if (this.showNullItem) {
                    idx = 1;
                    sb.push('<table class="mini-listbox-items" cellspacing="0" cellpadding="0">');
                    _assembleTr(sb, [{
                        index: 0,
                        record: data[0]
                    }]);
                    sb.push('</table>');
                }

                for (var l = data.length; idx < l; idx++) {
                    var record = data[idx];
                    var group = record[this.groupField];
                    if (group) {
                        if (optGroup[group]) {
                            optGroup[group].push({
                                index: idx,
                                record: record
                            });
                        } else {
                            optGroup[group] = [{
                                index: idx,
                                record: record
                            }];
                            optGroupList.push(optGroup[group]);
                        }
                    } else {
                        opts.push({
                            index: idx,
                            record: record
                        });
                    }
                }

                optGroupList.forEach(function(optGroup) {
                    var group = optGroup[0].record[self.groupField];
                    sb.push('<div class="mini-listbox-group-title">' + group + '</div>')
                    sb.push('<table class="mini-listbox-items mini-listbox-group" cellspacing="0" cellpadding="0">');
                    _assembleTr(sb, optGroup, group);
                    sb.push('</table>');
                });
            } else {
                opts = data.map(function(record, idx) { return { index: idx, record: record }; });
            }

            if (opts.length > 0) {
                sb.push('<table class="mini-listbox-items" cellspacing="0" cellpadding="0">');
                _assembleTr(sb, opts);
                sb.push('</table>');
            }
        }


        var innerHTML = sb.join("");

        this._viewEl.firstChild.innerHTML = innerHTML;

        this._doSelects();

        this.doLayout();

        /**
         * 拼装表格行 html
         * @param {Array} sb html
         * @param {Array} data
         * @param {string} group 组名
         */
        function _assembleTr(sb, data, group) {
            for (var i = 0, l = data.length; i < l; i++) {
                var item = data[i].record;
                var idx = data[i].index;

                var rowClsIndex = -1;
                var rowCls = " ";
                var rowStyleIndex = -1;
                var rowStyle = " ";

                sb[sb.length] = '<tr id="';
                sb[sb.length] = self._createItemId(idx);
                sb[sb.length] = '" index="';
                sb[sb.length] = idx;
                sb[sb.length] = '" class="mini-listbox-item ';

                if (item.enabled === false) {
                    sb[sb.length] = ' mini-disabled ';
                }

                rowClsIndex = sb.length;
                sb[sb.length] = rowCls;
                sb[sb.length] = '" style="';
                rowStyleIndex = sb.length;
                sb[sb.length] = rowStyle;
                sb[sb.length] = '">';

                var ckid = self._createCheckId(idx);
                var ckName = self.name;
                var ckValue = self.getItemValue(item);

                var disable = '';
                if (item.enabled === false) {
                    disable = 'disabled';
                }

                if (group) {
                    sb[sb.length] = '<td class="mini-listbox-placeholder"></td>';
                }

                if (self.showCheckBox) {
                    if (item.__NullItem === true) {
                        sb[sb.length] = '<td class="mini-listbox-checkbox"></td>';
                    } else {
                        sb[sb.length] = '<td class="mini-listbox-checkbox"><input ' + disable + ' id="' + ckid + '" type="checkbox" ></td>';
                    }
                }

                //sb[sb.length] = '<td class="mini-listbox-checkbox"><input ' + disable + ' id="' + ckid + '" type="checkbox" ></td>';

                if (hasColumns) {
                    for (var j = 0, k = self.columns.length; j < k; j++) {
                        var column = self.columns[j];

                        if (column.visible === false) {
                            continue;
                        }

                        var e = self._OnDrawCell(item, idx, column);

                        var w = column.width;
                        if (typeof w == "number") w = w + "px";

                        sb[sb.length] = '<td class="';
                        if (e.cellCls) sb[sb.length] = e.cellCls;
                        sb[sb.length] = '" style="';
                        if (e.cellStyle) sb[sb.length] = e.cellStyle + ";";
                        if (w) {
                            sb[sb.length] = 'width:' + w + ';';
                        }
                        if (column.align) {
                            sb[sb.length] = 'text-align:' + column.align + ';';
                        }
                        sb[sb.length] = '">';
                        sb[sb.length] = e.cellHtml;
                        sb[sb.length] = '</td>';

                        if (e.rowCls) rowCls = e.rowCls;
                        if (e.rowStyle) rowStyle = e.rowStyle;
                    }
                } else {
                    var e = self._OnDrawCell(item, idx, null);
                    sb[sb.length] = '<td class="';
                    if (e.cellCls) sb[sb.length] = e.cellCls;
                    sb[sb.length] = '" style="';
                    if (e.cellStyle) sb[sb.length] = e.cellStyle;
                    sb[sb.length] = '">';
                    sb[sb.length] = e.cellHtml;
                    sb[sb.length] = '</td>';

                    if (e.rowCls) rowCls = e.rowCls;
                    if (e.rowStyle) rowStyle = e.rowStyle;
                }

                sb[rowClsIndex] = rowCls;
                sb[rowStyleIndex] = rowStyle;

                sb[sb.length] = '</tr>';
            }
        }
    },
    _handleFilter: function(e) {
        var key = e.sender.value.toUpperCase();
        
        if(key === this._filterKey) {
            return;
        }
        this._filterKey = key;

        if(key === '') {
            this.clearFilter();
            return;
        }

        var view = [];
        var data = this._initialData;
        
        for (var i = 0, l = data.length; i < l; i++) {
            var o = data[i];
            var text = mini._getMap(this.textField, o);
            var pinyin = mini._getMap(this.pinyinField, o);

            text = text ? String(text).toUpperCase() : "";
            pinyin = pinyin ? String(pinyin).toUpperCase() : "";
            if (text.indexOf(key) != -1 || pinyin.indexOf(key) != -1) {
                view.push(o);
            }
        }
        this.setData(view, true);
        
        this.fire('afterfilter');
    },
    setData: function(data, isFilter) {
        !isFilter && (this._initialData = data);

        mini.ListBox.superclass.setData.call(this, data);
    },
    clearFilter: function() {
        this._filterKey = '';
        this.filterInput && this.filterInput.setValue(''), this.filterInput.setText('');
        this.setData(this._initialData, true);
        
        this.fire('afterfilter');
    },
    doLayout: function (isValid) {

        //if (!this.canLayout()) return;
        if (this.columns && this.columns.length > 0) {
            // if (this.columns && this.columns.length > 0) {
            mini.addClass(this.el, "mini-listbox-showcolumns");
        } else {
            mini.removeClass(this.el, "mini-listbox-showcolumns");
        }
        if (this.showCheckBox) {
            mini.removeClass(this.el, "mini-listbox-hideCheckBox");
        } else {
            mini.addClass(this.el, "mini-listbox-hideCheckBox");
        }

        var ckAllId = this.uid + "$ck$all";
        var ck = document.getElementById(ckAllId);
        if (ck) ck.style.display = this.showAllCheckBox ? "" : "none";

        var viewEl = this._viewEl;
        var autoHeight = this.isAutoHeight();

        if (autoHeight) viewEl.style.height = "auto";

        var h = this.getHeight(true);
        //w = this.getWidth(true);
        var w = mini.getWidth(this._borderEl, true);
        var elWidth = w;



        //不处理宽度
        if (!mini.isIE6) viewEl.style.width = w + "px";


        ///////////////////////////////////////新处理


        var h2 = mini.getHeight(this._headerEl);
        h = h - h2;
        if (h < 0) h = 0;
        viewEl.style.height = h + "px";     //setHeight();


        ////////////////////////////////////

        //某些ie9下高度有问题，用以上代码替换
        //        if (!autoHeight) {


        //            //            if (jQuery.boxModel) {
        //            //                var padding = mini.getPaddings(this._bodyEl);
        //            //                var border = mini.getBorders(this._bodyEl);
        //            //            }
        //            //            var margin = mini.getMargins(this._bodyEl);
        //            var h2 = mini.getHeight(this._headerEl);
        //            h = h - h2;
        //            viewEl.style.height = h + "px";
        //        } else {
        //            viewEl.style.height = "auto";
        //        }



        if (isIE) {

            var table1 = this._headerEl.firstChild, table2 = this._viewEl.firstChild.firstChild;
            if (this._viewEl.offsetHeight >= this._viewEl.scrollHeight) {
                if (table2) table2.style.width = "100%";
                if (table1) table1.style.width = "100%";
            } else {
                //var w = parseInt(table2.parentNode.offsetWidth - 17) + 'px'
                var w = parseInt(table2.parentNode.offsetWidth) + 'px'
                //table2.style.width = w;
                if (table1) table1.style.width = w;
            }
        }
        if (this._viewEl.offsetHeight < this._viewEl.scrollHeight) {

            //this._headerEl.style.width = (elWidth - 17) + "px";

            //fix: 某浏览器下滚动条宽度可以设置变化

            var scrollBarWidth = jQuery(this._viewEl).innerWidth() - jQuery(this._contentEl).width();

            var w = elWidth - scrollBarWidth;
            if (w < 0) w = 0;
            this._headerEl.style.width = w + "px";

        } else {
            this._headerEl.style.width = "100%";
        }
        //mini.repaint(this._viewEl);

        //                this._innerEl.firstChild.style.width = w + "px";     

        //this._headerEl.firstChild.style.width = jQuery(this._viewEl.firstChild).outerHeight() + "px";        
    },
    setShowCheckBox: function (value) {
        this.showCheckBox = value;
        this.doUpdate();
        //this.doLayout();
    },
    getShowCheckBox: function () {
        return this.showCheckBox;
    },
    setShowAllCheckBox: function (value) {
        this.showAllCheckBox = value;
        this.doLayout();
    },
    getShowAllCheckBox: function () {
        return this.showAllCheckBox;
    },
    setShowNullItem: function (value) {
        if (this.showNullItem != value) {
            this.showNullItem = value;

            this._doNullItem();

            this.doUpdate();
        }
    },
    getShowNullItem: function () {
        return this.showNullItem;
    },
    setNullItemText: function (value) {

        if (this.nullItemText != value) {
            this.nullItemText = value;

            this._doNullItem();

            this.doUpdate();
        }
    },
    getNullItemText: function () {
        return this.nullItemText;
    },
    setGroupField: function (groupField) {
        this.groupField = groupField;
    },
    getGroupField: function() {
        return this.groupField;
    },
    setEnableGroup: function(enableGroup) {
        this.enableGroup = !!enableGroup;
        this.doUpdate();
    },
    getEnableGroup: function() {
        return this.enableGroup;
    },

    _doNullItem: function () {
        for (var i = 0, l = this.data.length; i < l; i++) {
            var item = this.data[i];
            if (item.__NullItem) {
                this.data.removeAt(i);
                break;
            }
        }
        if (this.showNullItem) {
            var item = { __NullItem: true };
            item[this.textField] = ""; // this.nullItemText;
            item[this.valueField] = "";
            this.data.insert(0, item);
        }
    },
    ///////////////////////////////////////////////////

    //    moveItems: function (items, index) {
    //        if (!mini.isArray(items) || !mini.isNumber(index)) return;
    //        var target = this.data[index];

    //        this._allowUpdate = false;
    //        for (var i = 0, l = items.length; i < l; i++) {
    //            var item = items[i];
    //            this.moveItem(index);
    //        }
    //        this._allowUpdate = true;
    //        this.doUpdate();
    //    },
    ///////////////////////////////////////////////////

    
    // _createCheckId: function (index, gIndex) {
    //     return this.uid + '$ck$' + (gIndex == null ? '' : (gIndex + '-')) + index;
    // },
    // _createItemId: function (index, gIndex) {
    //     return this.uid + "$" + (gIndex == null ? '' : (gIndex + '-')) + index;
    // },
    _OnDrawCell: function (record, index, column) {
        var value = column ? mini._getMap(column.field, record) : this.getItemText(record);
        var e = {
            sender: this,
            index: index,
            rowIndex: index,
            record: record,
            item: record,
            column: column,
            field: column ? column.field : null,
            value: value,
            cellHtml: value,
            rowCls: null,
            cellCls: column ? (column.cellCls || '') : "",
            rowStyle: null,
            cellStyle: column ? (column.cellStyle || '') : ""
        };

        var hasColumns = this.columns && this.columns.length > 0;
        if (!hasColumns) {
            if (index == 0 && this.showNullItem) {
                e.cellHtml = this.nullItemText;
            }
        }
        if (e.autoEscape == true) {
            e.cellHtml = mini.htmlEncode(e.cellHtml);
        }

        if (column) {
            if (column.dateFormat) {
                if (mini.isDate(e.value)) e.cellHtml = mini.formatDate(value, column.dateFormat);
                else e.cellHtml = value;
            }
            var renderer = column.renderer;
            if (renderer) {
                fn = typeof renderer == "function" ? renderer : window[renderer];
                if (fn) {
                    e.cellHtml = fn.call(column, e);
                }
            }
        }

        this.fire("drawcell", e);

        if (e.cellHtml === null || e.cellHtml === undefined || e.cellHtml === "") e.cellHtml = "&nbsp;";

        return e;
    },
    __OnScroll: function (e) {
        this._headerEl.scrollLeft = this._viewEl.scrollLeft;
    },
    __OnClick: function (e) {

        var ckAllId = this.uid + "$ck$all";
        if (e.target.id == ckAllId) {
            var ck = document.getElementById(ckAllId);
            if (ck) {
                var checked = ck.checked;

                var value = this.getValue();
                this._oldValue = value;

                if (checked) {
                    this.selectAll();
                } else {
                    this.deselectAll();
                }
                this._OnSelectionChanged();

                if (value != this.getValue()) {
                    this._OnValueChanged();

                    this.fire("itemclick", { htmlEvent: e });
                }
            }
            return;
        }

        this._fireEvent(e, 'Click');
    },

    setValue: function (value) {
        mini.ListBox.superclass.setValue.call(this, value);

        this._doCheckState();
    },

    _doCheckState: function () {
        //alert(1);
        var ckAllId = this.uid + "$ck$all";
        var ck = jQuery(document.getElementById(ckAllId));
        if (this._isSelectedAll() && this.getSelecteds().length != 0) {
            //ck.attr("checked", true)
            if (ck.prop) {
                ck.prop("checked", true);
            } else {
                ck.attr("checked", true)
            }

        } else {
            //ck.attr("checked", false)            
            if (ck.prop) {
                ck.prop("checked", false);
            } else {
                ck.attr("checked", false)
            }
        }
    },

    _OnValueChanged: function (e) {
        mini.ListBox.superclass._OnValueChanged.call(this);

        this._doCheckState();
    },
    ////////////////////////////////
    getAttrs: function (el) {
        var attrs = mini.ListBox.superclass.getAttrs.call(this, el);

        mini._ParseString(el, attrs, [ 'nullItemText', 'ondrawcell', 'groupField']);
        mini._ParseBool(el, attrs, ['showCheckBox', 'showAllCheckBox', 'showNullItem', 'enableGroup', 'showFilter']);

        if (el.nodeName.toLowerCase() != "select") {
            var cs = mini.getChildNodes(el);
            for (var i = 0, l = cs.length; i < l; i++) {
                var node = cs[i];
                var property = jQuery(node).attr("property");
                if (!property) continue;
                property = property.toLowerCase();
                if (property == "columns") {
                    attrs.columns = mini._ParseColumns(node);
                } else if (property == "data") {
                    attrs.data = node.innerHTML;
                }
            }
        }

        return attrs;
    }
});
mini.regClass(mini.ListBox, "listbox");

mini.CheckBoxList = function () {
    mini.CheckBoxList.superclass.constructor.apply(this, arguments);
}
mini.extend(mini.CheckBoxList, mini.ListControl, {
    formField: true,
    _labelFieldCls: 'mini-labelfield-checkboxlist',

    multiSelect: true,
    repeatItems: 0,
    repeatLayout: "none", //none, flow, table
    repeatDirection: "horizontal",  //vertical, horizontal

    _itemCls: "mini-checkboxlist-item",
    _itemHoverCls: "mini-checkboxlist-item-hover",
    _itemSelectedCls: "mini-checkboxlist-item-selected",

    _tableCls: "mini-checkboxlist-table",
    _tdCls: "mini-checkboxlist-td",
    _checkType: "checkbox",

    uiCls: "mini-checkboxlist",
    _create: function () {
        var el = this.el = document.createElement("div");
        this.el.className = this.uiCls;

        this.el.innerHTML = '<table cellpadding="0" border="0" cellspacing="0" style="display:table;"><tr><td><div class="mini-list-inner"></div><div class="mini-errorIcon"></div><input type="hidden" /></td></tr></table>';
        //this.cellEl = this.el.firstChild.rows[0].cells[0];
        this.cellEl = el.getElementsByTagName("td")[0]; // this.el.firstChild.rows[0].cells[0];
        this._innerEl = this.cellEl.firstChild;
        this._valueEl = this.cellEl.lastChild;
        this._errorIconEl = this.cellEl.childNodes[1];

        this._borderEl = this.el.firstChild;

        var me = this;
        mini.on(this.el, "keyup", function (event) {
            if (event.keyCode == 32) {
                $(event.target).click();
            }
        });
    },
    //    _initEvents: function () {
    //        mini.CheckBoxList.superclass._initEvents.call(this);
    //        mini.on(this._viewEl, "scroll", this.__OnScroll, this);
    //    },
    _getRepeatTable: function () {
        var table = [];
        if (this.repeatItems > 0) {
            if (this.repeatDirection == "horizontal") {
                var row = [];
                for (var i = 0, l = this.data.length; i < l; i++) {
                    var item = this.data[i];
                    if (row.length == this.repeatItems) {
                        table.push(row);
                        row = [];
                    }
                    row.push(item);
                }
                table.push(row);
            } else {
                var len = this.repeatItems > this.data.length ? this.data.length : this.repeatItems;
                for (var i = 0, l = len; i < l; i++) {
                    table.push([]);
                }
                for (var i = 0, l = this.data.length; i < l; i++) {
                    var item = this.data[i];
                    var index = i % this.repeatItems;
                    table[index].push(item);
                }
            }
        } else {
            table = [this.data.clone()];
        }
        return table;
    },
    doUpdate: function () {
        var data = this.data;
        var s = "";

        for (var i = 0, l = data.length; i < l; i++) {
            var item = data[i];
            item._i = i;
        }

        if (this.repeatLayout == "flow") {

            var table = this._getRepeatTable();
            for (var i = 0, l = table.length; i < l; i++) {
                var row = table[i];
                for (var j = 0, k = row.length; j < k; j++) {
                    var item = row[j];
                    s += this._createItemHtml(item, item._i);
                }
                if (i != l - 1) {
                    s += '<br/>';
                }
            }


        } else if (this.repeatLayout == "table") {
            var table = this._getRepeatTable();
            s += '<table class="' + this._tableCls + '" cellpadding="0" cellspacing="1">';
            for (var i = 0, l = table.length; i < l; i++) {
                var row = table[i];
                s += '<tr>';
                for (var j = 0, k = row.length; j < k; j++) {
                    var item = row[j];
                    s += '<td class="' + this._tdCls + '">';
                    s += this._createItemHtml(item, item._i);
                    s += '</td>';
                }
                s += '</tr>';
            }
            s += '</table>';
        } else {
            for (var i = 0, l = data.length; i < l; i++) {
                var item = data[i];
                s += this._createItemHtml(item, i);
            }
        }
        this._innerEl.innerHTML = s;

        for (var i = 0, l = data.length; i < l; i++) {
            var item = data[i];
            delete item._i;
        }
    },
    _createItemHtml: function (item, index) {
        var e = this._OnDrawItem(item, index);
        var id = this._createItemId(index);
        var ckId = this._createCheckId(index);
        var ckValue = this.getItemValue(item);

        var disable = '';

        var s = '<div id="' + id + '" index="' + index + '" class="' + this._itemCls + ' ';
        if (item.enabled === false) {
            s += ' mini-disabled ';
            disable = 'disabled';
        }

        var onclick = 'onclick="return false"';
        //if (isChrome) {
        onclick = 'onmousedown="this._checked = this.checked;" onclick="this.checked = this._checked"';
        //}

        s += e.itemCls + '" style="' + e.itemStyle + '"><span tabIndex="0" class="mini-list-icon mini-icon"></span><input style="display:none;" ' + onclick + ' ' + disable + ' value="' + ckValue + '" id="' + ckId + '" type="' + this._checkType + '" /><label for="' + ckId + '" onclick="return false;">';
        s += e.itemHtml + '</label></div>';
        return s;
    },
    _OnDrawItem: function (item, index) {
        var value = this.getItemText(item);
        var e = {
            index: index,
            item: item,
            itemHtml: value,
            itemCls: "",
            itemStyle: ""
        };
        this.fire("drawitem", e);

        if (e.itemHtml === null || e.itemHtml === undefined) e.itemHtml = "";

        return e;
    },

    setRepeatItems: function (value) {
        value = parseInt(value);
        if (isNaN(value)) value = 0;
        if (this.repeatItems != value) {
            this.repeatItems = value;
            this.doUpdate();
        }
    },
    getRepeatItems: function () {
        return this.repeatItems;
    },
    setRepeatLayout: function (value) {
        if (value != "flow" && value != "table") value = "none";
        if (this.repeatLayout != value) {
            this.repeatLayout = value;
            this.doUpdate();
        }
    },
    getRepeatLayout: function () {
        return this.repeatLayout;
    },
    setRepeatDirection: function (value) {
        if (value != "vertical") value = "horizontal";
        if (this.repeatDirection != value) {
            this.repeatDirection = value;
            this.doUpdate();
        }
    },
    getRepeatDirection: function () {
        return this.repeatDirection;
    },
    ///////////////////////////////////////////////
    getAttrs: function (el) {
        var attrs = mini.CheckBoxList.superclass.getAttrs.call(this, el);
        var jq = jQuery(el);

        mini._ParseString(el, attrs,
            [
                "ondrawitem"
             ]
        );
        
        mini._ParseBool(el, attrs,
            [
                "autoLoad"
             ]
        );
    

        var repeatItems = parseInt(jq.attr("repeatItems"));
        if (!isNaN(repeatItems)) {
            attrs.repeatItems = repeatItems;
        }
        var repeatLayout = jq.attr("repeatLayout");
        if (repeatLayout) {
            attrs.repeatLayout = repeatLayout;
        }
        var repeatDirection = jq.attr("repeatDirection");
        if (repeatDirection) {
            attrs.repeatDirection = repeatDirection;
        }
        return attrs;
    }
});
mini.regClass(mini.CheckBoxList, "checkboxlist");

mini.RadioButtonList = function () {
    mini.RadioButtonList.superclass.constructor.apply(this, arguments);
}
mini.extend(mini.RadioButtonList, mini.CheckBoxList, {
    multiSelect: false,

    _itemCls: "mini-radiobuttonlist-item",
    _itemHoverCls: "mini-radiobuttonlist-item-hover",
    _itemSelectedCls: "mini-radiobuttonlist-item-selected",

    _tableCls: "mini-radiobuttonlist-table",
    _tdCls: "mini-radiobuttonlist-td",
    _checkType: "radio",

    uiCls: "mini-radiobuttonlist"
});
mini.regClass(mini.RadioButtonList, "radiobuttonlist");

mini.TimeSpinner = function () {
    mini.TimeSpinner.superclass.constructor.apply(this, arguments);
    
    this.setValue("00:00:00");
}
mini.extend(mini.TimeSpinner, mini.ButtonEdit, {

    value: null,
    format: 'H:mm:ss', //(当前只处理一个格式，以后处理更多格式，先满足国内习惯，后满足国际习惯，如h:mm:ss tt）
    formValueWithDate: window.EpFrameSysParams ? (EpFrameSysParams.timespinner_value_with_date === undefined ? false : EpFrameSysParams.timespinner_value_with_date) : false, //  返回的值是否包含年月日

    uiCls: "mini-timespinner",
    _getButtonHtml: function () {
        var hover = 'onmouseover="mini.addClass(this, \'' + this._buttonHoverCls + '\');" '
                        + 'onmouseout="mini.removeClass(this, \'' + this._buttonHoverCls + '\');"';
        return '<span class="mini-buttonedit-button" ' + hover + '><span class="mini-buttonedit-up"><span class="mini-icon"></span></span><span class="mini-buttonedit-down"><span class="mini-icon"></span></span></span>';
    },
    _initEvents: function () {
        mini.TimeSpinner.superclass._initEvents.call(this);

        mini._BindEvents(function () {
            this.on("buttonmousedown", this.__OnButtonMouseDown, this);
            mini.on(this.el, "mousewheel", this.__OnMousewheel, this);
            mini.on(this._textEl, "keydown", this.__OnKeyDown, this);
        }, this);

    },
    setFormat: function (value) {
        if (typeof value != "string") return;
        var formats = ['H:mm:ss', 'HH:mm:ss', 'H:mm', 'HH:mm', 'H', 'HH', 'mm:ss'];
        //if (formats.indexOf(value) == -1) return;

        if (this.format != value) {
            this.format = value;
            this.text = this._textEl.value = this.getFormattedValue();
        }
    },
    getFormat: function () {
        return this.format;
    },
    setValue: function (value) {

        
        value = mini.parseTime(value, this.format);
        if (!value) value = null; //mini.parseTime("00:00:00", this.format);

        if (mini.isDate(value)) value = new Date(value.getTime());

        //if (mini.formatDate(this.value, "H:mm:ss") != mini.formatDate(value, "H:mm:ss")) {
        this.value = value;
        this.text = this._textEl.value = this.getFormattedValue();
        this._valueEl.value = this.getFormValue();
        //}
    },
    getValue: function () {
        return this.value == null ? null : new Date(this.value.getTime());
    },
    getFormValue: function (format) {
        if (!this.value) return "";
        format = format || this.format;
        return mini.formatDate(this.value, format);
    },
    getFormattedValue: function () {
        if (!this.value) return "";
        return mini.formatDate(this.value, this.format);
    },
    _ChangeValue: function (Increment, timeType) {
        var value = this.getValue();
        if (value) {
            switch (timeType) {
                case "hours":
                    var hours = value.getHours() + Increment;
                    if (hours > 23) hours = 23;
                    if (hours < 0) hours = 0;
                    value.setHours(hours);
                    break;
                case "minutes":
                    var minutes = value.getMinutes() + Increment;
                    if (minutes > 59) minutes = 59;
                    if (minutes < 0) minutes = 0;
                    value.setMinutes(minutes);
                    break;
                case "seconds":
                    var seconds = value.getSeconds() + Increment;
                    if (seconds > 59) seconds = 59;
                    if (seconds < 0) seconds = 0;
                    value.setSeconds(seconds);
                    break;
            }
        } else {
            value = "00:00:00";
        }

        this.setValue(value);
        //this._OnValueChanged();
    },
    ////////////////////////////////////////////////    
    _SpinTimer: null,
    _StartSpin: function (Increment, time, count) {
        this._StopSpin();

        this._ChangeValue(Increment, this._timeType);
        //        this.setValue(this.value + Increment);
        //        this._OnValueChanged();

        var sf = this;
        var sourceCount = count;
        var now = new Date();
        this._SpinTimer = setInterval(function () {

            sf._ChangeValue(Increment, sf._timeType);

            count--;
            if (count == 0 && time > 50) {
                sf._StartSpin(Increment, time - 100, sourceCount + 3);

            }

            //防止alert
            var now2 = new Date();
            if (now2 - now > 500) sf._StopSpin();
            now = now2;
        }, time);
        mini.on(document, "mouseup", this._OnDocumentMouseUp, this);
        //document.title = time +":"+count;
    },
    _StopSpin: function () {
        clearInterval(this._SpinTimer);
        this._SpinTimer = null;
        //this._timeType = null;
    },
    __OnButtonMouseDown: function (e) {
        this._DownValue = this.getFormValue();
        this._timeType = "hours";
        if (e.spinType == "up") {
            this._StartSpin(1, 230, 2);
        } else {
            this._StartSpin(-1, 230, 2);
        }
    },
    //    __OnKeyDown: function (e) {
    //        var KEY = mini.Keyboard;
    //        switch (e.keyCode) {
    //            case KEY.Top:
    //                this.setValue(this.value + 1);
    //                this._OnValueChanged();
    //                break;
    //            case KEY.Bottom:
    //                this.setValue(this.value - 1);
    //                this._OnValueChanged();
    //                break;
    //        }
    //    },
    //    __OnMousewheel: function (e) {
    //        var wheelDelta = e.wheelDelta;
    //        if (mini.isNull(wheelDelta)) wheelDelta = -e.detail * 24;
    //        var increment = this.increment;
    //        if (wheelDelta < 0) increment = -increment;
    //        this.setValue(this.value + increment);
    //        this._OnValueChanged();
    //        return false;
    //    },
    _OnDocumentMouseUp: function (e) {
        this._StopSpin();
        mini.un(document, "mouseup", this._OnDocumentMouseUp, this);

        if (this._DownValue != this.getFormValue()) {
            this._OnValueChanged();
        }
    },
    __OnInputTextChanged: function (e) {
        
        var _value = this.getFormValue();

        this.setValue(this._textEl.value);

        if (_value != this.getFormValue()) {
            this._OnValueChanged();
        }
    },
    ////////////////////////////
    getAttrs: function (el) {
        var attrs = mini.TimeSpinner.superclass.getAttrs.call(this, el);

        mini._ParseString(el, attrs,
            ["format"
                ]
        );
        mini._ParseBool(el, attrs, ['formValueWithDate']);

        return attrs;
    }

});
mini.regClass(mini.TimeSpinner, 'timespinner');

mini.Lookup = function () {
    this.data = [];
    mini.Lookup.superclass.constructor.apply(this, arguments);

    mini.on(this._textEl, "mouseup", this.__OnMouseUp, this);

    this.on("showpopup", this.__OnShowPopup, this);
    
}
mini.extend(mini.Lookup, mini.PopupEdit, {
    allowInput: true,

    valueField: "id",
    textField: "text",
    delimiter: ',',
    setDelimiter: function (del) {
        this.delimiter = del;
    },
    getDelimiter: function () {
        return this.delimiter;
    },

    multiSelect: false,

    data: [],

    grid: null,
    _destroyPopup: false,




    uiCls: "mini-lookup",
    destroy: function (removeEl) {

        if (this.grid) {
            //this.grid.el.parentNode.removeChild(this.grid.el);

            this.grid.un("rowclick", this.__OnGridRowClickChanged, this);
            this.grid.un("load", this.__OnGridLoad, this);
            this.grid.un("checkall", this.__OnGridRowClickChanged, this);
            this.grid = null;


        }
        mini.Lookup.superclass.destroy.call(this, removeEl);
    },
    setMultiSelect: function (value) {
        this.multiSelect = value;

        if (this.grid) this.grid.setMultiSelect(value);
    },
    setGrid: function (value) {

        if (typeof value == "string") {
            mini.parse(value);
            value = mini.get(value);
        }
        this.grid = mini.getAndCreate(value);
        if (this.grid) {
            this.grid.setMultiSelect(this.multiSelect);
            this.grid.setCheckSelectOnLoad(false);
            this.grid.on("rowclick", this.__OnGridRowClickChanged, this);
            this.grid.on("load", this.__OnGridLoad, this);
            this.grid.on("checkall", this.__OnGridRowClickChanged, this);

        }
    },
    getGrid: function () {
        return this.grid;
    },
    setValueField: function (valueField) {
        this.valueField = valueField;
        //        if (this._listbox) {
        //            this._listbox.setValueField(valueField);
        //        }
    },
    getValueField: function () {
        return this.valueField;
    },
    setTextField: function (value) {
        //if (this._listbox) this._listbox.setTextField(value);
        this.textField = value;
    },
    getTextField: function () {
        return this.textField;
    },
    deselectAll: function () {
        this.data = [];
        this.setValue("");
        this.setText("");
        if (this.grid) this.grid.deselectAll();
    },
    ///////////////////////////////////////////////////
    getItemValue: function (item) {
        return String(item[this.valueField]);
    },
    getItemText: function (item) {
        var t = item[this.textField];
        return mini.isNull(t) ? '' : String(t);
    },
    getValueAndText: function (records) {
        if (mini.isNull(records)) records = [];

        var values = [];
        var texts = [];
        for (var i = 0, l = records.length; i < l; i++) {
            var record = records[i];
            if (record) {
                values.push(this.getItemValue(record));
                texts.push(this.getItemText(record));
            }
        }
        return [values.join(this.delimiter), texts.join(this.delimiter)];
    },
    _createData: function () {
        this.value = mini.isNull(this.value) ? "" : String(this.value);
        this.text = mini.isNull(this.text) ? "" : String(this.text);
        //        if (typeof this.value != "string") this.value = "";
        //        if (typeof this.text != "string") this.text = "";

        var data = [];
        var values = this.value.split(this.delimiter);
        var texts = this.text.split(this.delimiter);
        var len = values.length;
        //if (len < values.length) len = values.length;
        if (this.value) {
            for (var i = 0, l = len; i < l; i++) {
                var row = {};
                var id = values[i];
                var text = texts[i];
                row[this.valueField] = id ? id : "";
                row[this.textField] = text ? text : "";
                data.push(row);
            }
        }
        this.data = data;

    },
    _getValueMaps: function (rows) {

        var vs = {};
        for (var i = 0, l = rows.length; i < l; i++) {
            var row = rows[i];
            var id = row[this.valueField];
            vs[id] = row;
        }
        return vs;
    },
    setValue: function (value) {

        mini.Lookup.superclass.setValue.call(this, value);
        this._createData();
    },
    setText: function (value) {
        mini.Lookup.superclass.setText.call(this, value);
        this._createData();
    },
    __OnGridRowClickChanged: function (e) {
        var me = this,
            grid = me.grid;

        //var rows = this._getValueMaps(this.grid.getData());         //当前页行
        var rows = this._getValueMaps(grid.getList());         //当前页行
        var sels = this._getValueMaps(grid.getSelecteds());    //当前页选中
        var vs = this._getValueMaps(this.data);                     //所有选中

        if (this.multiSelect == false) {
            vs = {};
            this.data = [];
        }

        //处理删除
        var removes = {};
        for (var id in vs) {
            var o = vs[id];
            if (rows[id]) {         //如果在当前页
                if (sels[id]) {     //如果被选中

                } else {            //否则去除掉
                    removes[id] = o;
                }
            }
        }

        for (var i = this.data.length - 1; i >= 0; i--) {
            var o = this.data[i];
            var id = o[this.valueField];
            if (removes[id]) this.data.removeAt(i);
        }


        //        //处理增加
        //        for (var id in sels) {
        //            var o = sels[id];
        //            if (!vs[id]) this.data.push(o);
        //        }


        //处理增加
        var adds = [];
        for (var id in sels) {
            var o = sels[id];
            if (!vs[id]) adds.push(o);
        }

        adds.sort(function (a, b) {
            var index1 = grid.indexOf(a),
                index2 = grid.indexOf(b);
            if (index1 < index2) return -1;
            if (index1 == index2) return 0;
            return 1;
        });

        this.data.addRange(adds);

        /////////////////////////////////////////




        var vts = this.getValueAndText(this.data);

        this.setValue(vts[0]);
        this.setText(vts[1]);

        this._OnValueChanged();
    },
    __OnGridLoad: function (e) {
        this.__OnShowPopup(e);
    },
    __OnShowPopup: function (e) {

        var vsb = String(this.value).split(this.delimiter);
        var vs = {};
        for (var i = 0, l = vsb.length; i < l; i++) {
            var v = vsb[i];
            vs[v] = 1;
        }

        var rows = this.grid.getData();
        //var vs = this._getValueMaps(this.data);                     //所有选中

        var sels = [];
        for (var i = 0, l = rows.length; i < l; i++) {
            var row = rows[i];
            var id = row[this.valueField];
            if (vs[id]) sels.push(row);
        }

        this.grid.selects(sels);
    },
    //////////////////////////////////////////////

    //禁止输入，光标可操作
    doUpdate: function () {
        mini.Lookup.superclass.doUpdate.call(this);
        this._textEl.readOnly = true;
        this.el.style.cursor = "default";
        //this.addCls(this._readOnlyCls);
    },
    __OnInputKeyDown: function (e) {
        mini.Lookup.superclass.__OnInputKeyDown.call(this, e);
        //e.preventDefault();
        switch (e.keyCode) {
            case 46:    //del
            case 8:    //backspace

                break;
            case 37:    //left

                break;
            case 39:    //right

                break;
        }
        //        this.fire("keydown", { htmlEvent: e });
        //        if (e.keyCode == 8 && (this.isReadOnly() || this.allowInput == false)) {
        //            return false;
        //        }
        //        if (e.keyCode == 13) {
        //            this.fire("enter");
        //        }
    },
    __OnMouseUp: function (e) {
        if (this.isReadOnly()) return;
        //mini.Lookup.superclass.__OnMouseUp.call(this, e);

        var rg = mini.getSelectRange(this._textEl);
        var start = rg[0], end = rg[1];

        //alert(rg[0] + ":" + rg[1]);
        var index = this._findTextIndex(start);
        //document.title = index;
        //暂时不做。。。
    },
    _findTextIndex: function (rgIndex) {
        var index = -1;
        if (this.text == "") return index;

        var texts = String(this.text).split(this.delimiter);
        var len = 0;
        for (var i = 0, l = texts.length; i < l; i++) {
            var text = texts[i];
            if (len < rgIndex && rgIndex <= len + text.length) {
                index = i;
                break;
            }
            len = len + text.length + 1;
        }
        return index;
    },

    /////////////////////////////////////////////
    getAttrs: function (el) {
        var attrs = mini.Lookup.superclass.getAttrs.call(this, el);

        mini._ParseString(el, attrs,
            ["grid", "valueField", "textField", "delimiter"
             ]
        );
        mini._ParseBool(el, attrs,
            ["multiSelect"
             ]
        );

        return attrs;
    }
});

mini.regClass(mini.Lookup, 'lookup');

/*
    目的：多选/单选数据，标准使用。复杂使用，可以做一个弹出表格选择面板示例。
        本地
        远程数据

    另外，弹出面板的表格数据选择，做成一个独立示例。
*/

/*
1.当setValue,setText的时候，自动生成data，然后刷新refresh
2.界面操作：
删除
增加
都从DOM级别修改
3.导航
4.输入下拉        
*/

mini.TextBoxList = function (el) {
    mini.TextBoxList.superclass.constructor.call(this, null);

    this.data = [];
    this.selecteds = []; //selecteds
    this.doUpdate();    

    //this._createPopup();
    if (el) mini.applyTo.call(this, el);
}
mini.extend(mini.TextBoxList, mini.ValidatorBase, {
    formField: true,

    remote: true,       //url, data

    value: "",
    text: "",
    valueField: "id",
    textField: "text",
    selecteds: null,

    data: null,

    url: "",
    delay: 150,

    allowInput: true,

    editIndex: 0,

    _focusCls: "mini-textboxlist-focus",
    _itemHoverClass: "mini-textboxlist-item-hover",
    _itemSelectedClass: "mini-textboxlist-item-selected",
    _closeHoverClass: "mini-textboxlist-close-hover",

    textName: "",
    setTextName: function (value) {
        this.textName = value;
        //if (this._textEl) mini.setAttr(this._textEl, "name", this.textName);
    },
    getTextName: function () {
        return this.textName;
    },

    getData: function () {
        return this.data;
    },

    setData: function (data) {
        this.data = data;
    },

    getRemote: function () {
        return this.remote;
    },

    setRemote: function (remote) {
        this.remote = remote;
    },

    ////////////////////////////////////////////
    uiCls: "mini-textboxlist",
    _create: function () {

        var html = '<table class="mini-textboxlist mini-corner-all" cellpadding="0" cellspacing="0"><tr ><td class="mini-textboxlist-border mini-corner-all"><ul></ul><a href="#"></a><input type="hidden"/></td></tr></table>';
        var d = document.createElement("div");
        d.innerHTML = html;
        this.el = d.firstChild;

        var td = this.el.getElementsByTagName("td")[0];
        this.ulEl = td.firstChild;
        this._valueEl = td.lastChild;
        this.focusEl = td.childNodes[1];
    },
    destroy: function (removeEl) {
        if (this.isShowPopup) {
            this.hidePopup();
        }
        if (this._inputEl) {
            mini.clearEvent(this._inputEl);
            this._inputEl.onkeyup = null;
            this._inputEl.onfocus = null;
            this._inputEl.onblur = null;
        }
        mini.un(document, "mousedown", this.__OnDocMouseDown, this);
        mini.TextBoxList.superclass.destroy.call(this, removeEl);
    },
    _initEvents: function () {
        mini.TextBoxList.superclass._initEvents.call(this);

        mini.on(this.el, "mousemove", this.__OnMouseMove, this);
        mini.on(this.el, "mouseout", this.__OnMouseOut, this);
        mini.on(this.el, "mousedown", this.__OnMouseDown, this);
        mini.on(this.el, "click", this.__OnClick, this);
        mini.on(this.el, "keydown", this.__OnKeyDown, this);

        mini.on(document, "mousedown", this.__OnDocMouseDown, this);
    },
    __OnDocMouseDown: function (e) {

        if (this.isReadOnly()) return;
        if (this.isShowPopup) {
            if (!mini.isAncestor(this.popup.el, e.target)) {
                this.hidePopup();
            }
        }
        var sf = this;
        if (this._focused) {
            if (this.within(e) == false) {


                clearInterval(this._ValueChangeTimer);

                this.select(null, false);
                //this.showInput(false);
                setTimeout(function () {
                    sf.showInput(false);
                }, 100);

                this.removeCls(this._focusCls);
                this._focused = false;

                //alert(this._inputEl.onblur);
            }

        }
    },
    ///////////////////////////////////////////////
    errorIconEl: null,
    getErrorIconEl: function () {
        if (!this._errorIconEl) {
            var tr = this.el.rows[0];
            var td = tr.insertCell(1);
            td.style.cssText = 'width:18px;vertical-align:top;';
            td.innerHTML = '<div class="mini-errorIcon"></div>';
            this._errorIconEl = td.firstChild;
        }
        return this._errorIconEl;
    },
    _RemoveErrorIcon: function () {
        if (this._errorIconEl) {
            jQuery(this._errorIconEl.parentNode).remove();
        }
        this._errorIconEl = null;
    },
    ///////////////////////////////////////////////
    doLayout: function () {
        if (this.canLayout() == false) return;
        mini.TextBoxList.superclass.doLayout.call(this);

        this.doReadOnly();
    },

    doReadOnly: function () {
        if (this.isReadOnly() || this.allowInput == false) {
            this._inputEl.readOnly = true;
        } else {
            this._inputEl.readOnly = false;
        }
    },

    doUpdate: function () {
        if (this._ValueChangeTimer) clearInterval(this._ValueChangeTimer);
        if (this._inputEl) mini.un(this._inputEl, "keydown", this.__OnInputKeyDown, this);

        var sb = [];
        var id = this.uid;
        for (var i = 0, l = this.selecteds.length; i < l; i++) {
            var o = this.selecteds[i];   //selecteds
            var li_id = id + "$text$" + i;
            var text = mini._getMap(this.textField, o); //o[this.textField];
            if (mini.isNull(text)) text = "";
            sb[sb.length] = '<li id="' + li_id + '" class="mini-textboxlist-item">';
            sb[sb.length] = text;
            sb[sb.length] = '<span class="mini-textboxlist-close"></span></li>';
        }
        var inputid = id + "$input";
        sb[sb.length] = '<li id="' + inputid + '" class="mini-textboxlist-inputLi"><input class="mini-textboxlist-input" type="text" autocomplete="off"></li>';

        this.ulEl.innerHTML = sb.join("");

        this.editIndex = this.selecteds.length;
        if (this.editIndex < 0) this.editIndex = 0;

        this.inputLi = this.ulEl.lastChild;
        this._inputEl = this.inputLi.firstChild;

        this._inputEl.placeholder = this.placeholder;

        mini.on(this._inputEl, "keydown", this.__OnInputKeyDown, this);

        var sf = this;
        this._inputEl.onkeyup = function () {
            sf._syncInputSize();
        }

        sf._ValueChangeTimer = null;
        sf._LastInputText = sf._inputEl.value;
        this._inputEl.onfocus = function () {
            sf._LastInputText = sf._inputEl.value;
            sf._ValueChangeTimer = setInterval(function () {
                //document.title = new Date().getTime();
                if (!sf._focused) {
                    clearInterval(sf._ValueChangeTimer);
                    sf._ValueChangeTimer = null;
                    return;
                }
                if (sf._LastInputText != sf._inputEl.value) {
                    sf._startQuery();
                    sf._LastInputText = sf._inputEl.value;
                }
            }, 10);

            sf.addCls(sf._focusCls);
            sf._focused = true;

            sf.fire("focus");
        }

        this._inputEl.onblur = function () {
            clearInterval(sf._ValueChangeTimer);
            sf._ValueChangeTimer = null;

            sf.fire("blur");
            //alert(1);

            if (sf.validateOnLeave && sf.isEditable()) {
                sf._tryValidate();
            }
        }

        this.doReadOnly();

        //        var inputEvent = "input";
        //        if (isIE) inputEvent = "propertychange";
        //        mini.on(this._inputEl, inputEvent, this.__OnInputTextChange, this);

        //this.select(this._selected);
    },
    getItemByEvent: function (event) {
        var domItem = mini.findParent(event.target, "mini-textboxlist-item");
        if (domItem) {
            var ids = domItem.id.split("$");
            var id = ids[ids.length - 1];
            return this.selecteds[id];
        }
    },
    getItem: function (id) {
        if (typeof id == "number") return this.selecteds[id];
        if (typeof id == "object") return id;
        //        for (var i = 0, l = this.selecteds.length; i < l; i++) {
        //            var o = this.selecteds[i];
        //            if (o._id == id) return o;
        //        }
    },
    getItemEl: function (o) {
        var index = this.selecteds.indexOf(o);
        var li_id = this.uid + "$text$" + index;
        return document.getElementById(li_id);
    },
    hoverItem: function (item, e) {
        if (this.isReadOnly() || this.enabled == false) return;
        this.blurItem();
        var li = this.getItemEl(item);
        mini.addClass(li, this._itemHoverClass);

        if (e && mini.hasClass(e.target, "mini-textboxlist-close")) {
            mini.addClass(e.target, this._closeHoverClass);
        }
    },
    blurItem: function () {
        var len = this.selecteds.length;
        for (var i = 0, l = len; i < l; i++) {
            var o = this.selecteds[i];

            var li = this.getItemEl(o);
            if (li) {
                mini.removeClass(li, this._itemHoverClass);

                mini.removeClass(li.lastChild, this._closeHoverClass);
            }
        }
    },
    showInput: function (index) {
        this.select(null);

        if (mini.isNumber(index)) {
            this.editIndex = index;
        } else {
            this.editIndex = this.selecteds.length;
        }
        if (this.editIndex < 0) this.editIndex = 0;
        if (this.editIndex > this.selecteds.length) this.editIndex = this.selecteds.length;

        var inputLi = this.inputLi;
        inputLi.style.display = "block";

        if (mini.isNumber(index) && index < this.selecteds.length) {
            var item = this.selecteds[index];
            var itemEl = this.getItemEl(item);
            jQuery(itemEl).before(inputLi);
        } else {
            this.ulEl.appendChild(inputLi);
        }
        if (index !== false) {
            setTimeout(function () {
                try {

                    inputLi.firstChild.focus();
                    mini.selectRange(inputLi.firstChild, 100);
                } catch (e) {
                }
            }, 10);
        } else {
            this.lastInputText = "";
            this._inputEl.value = "";
        }
        return inputLi;
    },
    select: function (item) {
        item = this.getItem(item);
        if (this._selected) {
            var itemEl = this.getItemEl(this._selected);
            mini.removeClass(itemEl, this._itemSelectedClass);
        }
        this._selected = item;

        if (this._selected) {
            var itemEl = this.getItemEl(this._selected);
            mini.addClass(itemEl, this._itemSelectedClass);
        }

        var sf = this;

        if (this._selected) {
            this.focusEl.focus();
            var me = this;
            setTimeout(function () {
                try {
                    me.focusEl.focus();
                } catch (ex) { }
            }, 50);
        }

        if (this._selected) {
            sf.addCls(sf._focusCls);
            sf._focused = true;
        }
    },
    ////////////////////////////////////////
    _doInsertInputValue: function () {

        var text = this.getInputText();
        var item = {};
        item[this.textField] = text;
        item[this.valueField] = text;
        var index = this.editIndex;

        this.insertItem(index, item);

    },
    _doInsertSelectValue: function () {

        if (this._listbox.getData().length == 0) return;

        var item = this._listbox.getSelected();
        var index = this.editIndex;

        if (item) {

            item = mini.clone(item);

            this.insertItem(index, item);
        }
    },
    insertItem: function (index, item) {
        this.selecteds.insert(index, item);
        var text = this.getText();
        var value = this.getValue();

        this.setValue(value, false);
        this.setText(text, false);

        this._createSelecteds();

        this.doUpdate();

        this.showInput(index + 1);

        this._OnValueChanged();
    },
    removeItem: function (item) {
        if (!item) return;
        var itemEl = this.getItemEl(item);
        mini.removeNode(itemEl);

        this.selecteds.remove(item);

        var text = this.getText();
        var value = this.getValue();


        this.setValue(value, false);
        this.setText(text, false);

        this._OnValueChanged();
    },
    _createSelecteds: function () {
        var texts = (this.text ? this.text : "").split(",");
        var values = (this.value ? this.value : "").split(",");

        if (values[0] == "") values = [];
        var len = values.length;
        this.selecteds.length = len;

        for (var i = 0, l = len; i < l; i++) {
            var o = this.selecteds[i];
            if (!o) {
                o = {};
                this.selecteds[i] = o;
            }

            //if (!o._id) o._id = this.itemID++;

            var text = !mini.isNull(texts[i]) ? texts[i] : "";
            var value = !mini.isNull(values[i]) ? values[i] : "";

            mini._setMap(this.textField, text, o);
            mini._setMap(this.valueField, value, o);
        }

        this.value = this.getValue();
        this.text = this.getText();
    },
    getInputText: function () {
        return this._inputEl ? this._inputEl.value : "";
    },
    getText: function () {
        var sb = [];
        for (var i = 0, l = this.selecteds.length; i < l; i++) {
            var o = this.selecteds[i];
            var name = mini._getMap(this.textField, o);
            if (mini.isNull(name)) name = "";
            name = name.replace(",", "，");
            sb.push(name);
        }
        return sb.join(",");
    },
    getValue: function () {
        var sb = [];
        for (var i = 0, l = this.selecteds.length; i < l; i++) {
            var o = this.selecteds[i];
            var v = mini._getMap(this.valueField, o);
            sb.push(v);
        }
        return sb.join(",")
    },

    getFormValue: function () {
        var value = this.value;
        if (value === null || value === undefined) value = "";
        return String(value);
    },

    ///////////////////////////////
    setName: function (value) {
        if (this.name != value) {
            this.name = value;
            this._valueEl.name = value;
        }
    },
    setValue: function (value) {

        if (mini.isNull(value)) value = "";

        if (this.value != value) {
            this.value = value;
            this._valueEl.value = value;
            this._createSelecteds();
            this.doUpdate();
        }
    },
    setText: function (value) {
        if (mini.isNull(value)) value = "";
        if (this.text !== value) {
            this.text = value;
            this._createSelecteds();
            this.doUpdate();
        }
    },
    setValueField: function (value) {
        this.valueField = value;
        this._createSelecteds();
    },
    getValueField: function () {
        return this.valueField;
    },
    setTextField: function (value) {
        this.textField = value;
        this._createSelecteds();
    },
    getTextField: function () {
        return this.textField;
    },
    setAllowInput: function (value) {
        this.allowInput = value;
        this.doLayout();
    },
    getAllowInput: function () {
        return this.allowInput;
    },
    setUrl: function (value) {
        this.url = value;
    },
    getUrl: function () {
        return this.url;
    },
    setPopupHeight: function (value) {
        this.popupHeight = value;
    },
    getPopupHeight: function () {
        return this.popupHeight;
    },
    setPopupMinHeight: function (value) {
        this.popupMinHeight = value;
    },
    getPopupMinHeight: function () {
        return this.popupMinHeight;
    },
    setPopupMaxHeight: function (value) {
        this.popupMaxHeight = value;
    },
    getPopupMaxHeight: function () {
        return this.popupMaxHeight;
    },


    valueFromSelect: true,
    setValueFromSelect: function (value) {
        this.valueFromSelect = value;
    },
    getValueFromSelect: function () {
        return this.valueFromSelect;
    },
    ////////////////////////////////////////////////    
    doQuery: function () {
        this._startQuery(true);
    },
    //文本框宽度调整
    _syncInputSize: function () {
        if (this.isDisplay() == false) return;
        var text = this.getInputText();
        var size = mini.measureText(this._inputEl, text);
        var width = size.width > 20 ? size.width + 4 : 20;
        var elWidth = mini.getWidth(this.el, true);
        if (width > elWidth - 15) width = elWidth - 15;
        this._inputEl.style.width = width + "px";
    },

    inputMode: false,
    setIputMode: function (value) {
        this.inputMode = value;
    },
    getIputMode: function () {
        return this.inputMode;
    },


    _startQuery: function (oldText) {
        var sf = this;

        if (this.inputMode) return;

        setTimeout(function () {
            sf._syncInputSize();
        }, 1);

        this.showPopup("loading");

        this._stopQuery();

        this._loading = true;

        this.delayTimer = setTimeout(function () {
            var text = sf._inputEl.value;

            //if (oldText === true || text != oldText) {
            sf._doQuery();
            //}
        }, this.delay);
    },
    ajaxDataType: "text",
    ajaxContentType: "application/x-www-form-urlencoded; charset=UTF-8",

    _getSelectedMap: function () {
        var map = {};
        for (var i = 0, l = this.selecteds.length; i < l; i++) {
            var o = this.selecteds[i];
            map[o[this.valueField]] = o[this.textField];

        }
        return map;
    },

    _getFilterLocalData: function (key) {
        var sf = this,
            data = [],
            map = this._getSelectedMap();

        key = (key || "").toLowerCase();

        for (var i = 0, l = sf.data.length; i < l; i++) {
            var o = sf.data[i];
            var id = o[this.valueField];
            if (!map[id]) {
                var text = o[this.textField];
                if (!key || String(text).toLowerCase().indexOf(key) != -1) {
                    data.push(o);
                }
            }
        }
        return data;
    },

    _doQuery: function () {
        if (this.isDisplay() == false) return;
        var text = this.getInputText();

        var sf = this;

        //local

        if (!sf.remote) {
            var data = this._getFilterLocalData(text);

            sf._listbox.setData(data);
            sf.showPopup();
            sf._listbox._focusItem(0, true);

            sf._loading = false;

            return;
        }


        //remote
        var dataSource = this._listbox.getData();
        var params = {
            //key: text,
            value: this.getValue(),
            text: this.getText()
        };
        params[this.searchField] = text;

        var url = this.url;
        var fn = typeof url == "function" ? url : window[url];
        if (typeof fn == "function") {
            url = fn(this);
        }
        if (!url) return;

        var ajaxMethod = "post";
        if (url) {
            if (url.indexOf(".txt") != -1 || url.indexOf(".json") != -1) {
                ajaxMethod = "get";
            }
        }

        var e = {
            url: url,
            async: true,
            params: params,
            data: params,
            type: this.ajaxType ? this.ajaxType : ajaxMethod,
            cache: false,
            cancel: false
        };

        jQuery.extend(true, e, this.ajaxOptions);

        this.fire("beforeload", e);
        if (e.cancel) return;

        var me = this;
        mini.copyTo(e, {
            success: function (text, textStatus, xhr) {
                delete e.params;
                var obj = { text: text, result: null, sender: me, options: e, xhr: xhr };
                var result = null;
                try {
                    mini_doload(obj);
                    result = obj.result;
                    if (!result) {
                        result = mini.decode(text);
                    }
                } catch (ex) {
                    if (mini_debugger == true) {
                        throw new Error("textboxlist json is error");
                    }
                }
                if (mini.isArray(result)) result = { data: result };

                //var data = mini.decode(text);

                //                if (mini.isNumber(data.error) && data.error != 0) {
                //                    var ex = {};
                //                    ex.stackTrace = data.stackTrace;
                //                    ex.errorMsg = data.errorMsg;
                //                    if (mini_debugger == true) {
                //                        alert(url + "\n" + ex.textStatus + "\n" + ex.stackTrace);
                //                    }
                //                    return;
                //                }

                if (me.dataField) {
                    result.data = mini._getMap(me.dataField, result);
                }
                if (!result.data) result.data = [];

                sf._listbox.setData(result.data);
                sf.showPopup();
                sf._listbox._focusItem(0, true);
                sf.fire("load", { data: result.data, result: result });
                sf._loading = false;

                if (sf._selectOnLoad) {
                    sf.__doSelectValue();
                    sf._selectOnLoad = null;
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                sf.showPopup("error");
            }
        });

        sf._ajaxer = mini.ajax(e);
    },
    _stopQuery: function () {
        if (this.delayTimer) {
            clearTimeout(this.delayTimer);
            this.delayTimer = null;
        }
        if (this._ajaxer) {
            this._ajaxer.abort();
        }
        this._loading = false;
    },

    ////////////////////////////////////////////////
    within: function (e) {
        if (mini.isAncestor(this.el, e.target)) return true;
        if (this.showPopup && this.popup && this.popup.within(e)) return true;
        return false;
    },

    ////////////////////////////////

    placeholder: "",
    setPlaceholder: function (value) {

        this.placeholder = value;
    },
    getPlaceholder: function (value) {
        return this.placeholder;
    },

    emptyText: "No Result",     //emptyDatText
    setEmptyText: function (value) {
        this.popupEmptyText = "<span class='mini-textboxlist-popup-noresult'>" + value + "</span>";
        this.emptyText = value;
    },
    getEmptyText: function (value) {
        return this.emptyText;
    },
    loadingText: "Loading...",
    setLoadingText: function (value) {
        this.popupLoadingText = "<span class='mini-textboxlist-popup-noresult'>" + value + "</span>";
        this.loadingText = value;
    },
    getLoadingText: function (value) {
        return this.loadingText;
    },
    errorText: "Error",
    setErrorText: function (value) {
        this.popupEmptyText = "<span class='mini-textboxlist-popup-noresult'>" + value + "</span>";
        this.errorText = value;
    },
    getErrorText: function (value) {
        return this.errorText;
    },
    ////////////////////////////////

    popupLoadingText: "<span class='mini-textboxlist-popup-loading'>Loading...</span>",
    popupErrorText: "<span class='mini-textboxlist-popup-error'>Error</span>",
    popupEmptyText: "<span class='mini-textboxlist-popup-noresult'>No Result</span>",

    isShowPopup: false,
    popupHeight: "",
    popupMinHeight: 30,
    popupMaxHeight: 150,
    _createPopup: function () {
        if (!this.popup) {
            this.popup = new mini.ListBox();
            this.popup.addCls("mini-textboxlist-popup");
            this.popup.setStyle("position:absolute;left:0;top:0;");
            this.popup.showEmpty = true;
            this.popup.setValueField(this.valueField);
            this.popup.setTextField(this.textField);
            this.popup.render(document.body);

            this.popup.on("itemclick", function (e) {
                this.hidePopup();

                this._doInsertSelectValue();
            }, this);
        }
        this._listbox = this.popup;
        return this.popup;
    },
    showPopup: function (action) {
        if (this.isDisplay() == false) return;
        this.isShowPopup = true;

        var popup = this._createPopup();

        popup.el.style.zIndex = mini.getMaxZIndex();
        var control = this._listbox;
        control.emptyText = this.popupEmptyText;

        //action = "loading";
        if (action == "loading") {
            control.emptyText = this.popupLoadingText;
            this._listbox.setData([]);
        } else if (action == "error") {
            control.emptyText = this.popupLoadingText;
            this._listbox.setData([]);
        }
        this._listbox.doUpdate();

        var box = this.getBox();
        var x = box.x, y = box.y + box.height;

        this.popup.el.style.display = "block";
        mini.setXY(popup.el, -1000, -1000);
        this.popup.setWidth(box.width);

        this.popup.setHeight(this.popupHeight);

        if (this.popup.getHeight() < this.popupMinHeight) {
            this.popup.setHeight(this.popupMinHeight);
        }
        if (this.popup.getHeight() > this.popupMaxHeight) {
            this.popup.setHeight(this.popupMaxHeight);
        }
        mini.setXY(popup.el, x, y);

    },
    hidePopup: function () {
        this.isShowPopup = false;
        if (this.popup) this.popup.el.style.display = "none";
    },
    ////////////////////////////////////////////////
    __OnMouseMove: function (e) {
        if (this.enabled == false) return;
        var item = this.getItemByEvent(e);
        if (!item) {
            this.blurItem();
            return;
        }
        this.hoverItem(item, e);
    },
    __OnMouseOut: function (e) {
        this.blurItem();
    },
    __OnClick: function (e) {
        if (this.isReadOnly() || this.enabled == false) return;
        if (this.enabled == false) return;
        //if (this.isReadOnly()) return;

        var item = this.getItemByEvent(e);
        if (!item) {
            if (mini.findParent(e.target, "mini-textboxlist-input")) {

            } else {
                this.showInput();
            }
            return;
        }
        this.focusEl.focus();
        this.select(item);

        if (e && mini.hasClass(e.target, "mini-textboxlist-close")) {
            this.removeItem(item);

            this.fire("removeitem", { item: item });
        }
    },
    __OnKeyDown: function (e) {


        if (this.isReadOnly() || this.allowInput == false) return false;

        var index = this.selecteds.indexOf(this._selected);

        var sf = this;
        function remove() {
            var item = sf.selecteds[index];
            sf.removeItem(item);

            item = sf.selecteds[index];
            if (!item) item = sf.selecteds[index - 1];
            sf.select(item);
            if (!item) {
                sf.showInput();
            }
        }

        switch (e.keyCode) {
            case 8:     //backspace
                e.preventDefault();
                remove();
                break;
            case 37:    //left
            case 38:    //top      
                this.select(null);
                this.showInput(index);
                break;
            case 39:    //right
            case 40:    //bottom
                index += 1;
                this.select(null);
                this.showInput(index);
                break;
            case 46:    //del
                remove();
                break;
        }
    },
    __doSelectValue: function () {
        var item = this._listbox.getFocusedItem();
        if (item) {
            this._listbox.setSelected(item);


            this.lastInputText = this.text;
            this.hidePopup();

            this._doInsertSelectValue();

        } else if (!this.valueFromSelect) {
            var text = this.getInputText().trim();
            if (text) {
                this._doInsertInputValue();
            }
            //            var item = this._listbox.getFocusedItem();
            //            if (!item && !this.valueFromSelect) {
            //                var value = this._inputEl.value.trim()
            //                if (value != "") {
            //                    //this.selecteds.push({ value: value, text: value })
            //                    this.doUpdate();
            //                    this.showInput()

            //                }

            //            }

        }

        //this._doSetValue();
        //                    var text = this._getValueAndText(this.value)[1];
        //                    this.setText(text, true);


    },
    __OnInputKeyDown: function (e) {

        this._selectOnLoad = null;

        if (this.isReadOnly() || this.allowInput == false) return false;
        
        if (e.keyCode == 13 && !this.isShowPopup) {
            return ;
        }

        e.stopPropagation();

        if (this.isReadOnly() || this.allowInput == false) return;

        var range = mini.getSelectRange(this._inputEl);
        var start = range[0], end = range[1], textLen = this._inputEl.value.length;
        var isFirst = start == end && start == 0;
        var isLast = start == end && end == textLen;


        if (this.isReadOnly() || this.allowInput == false) { //bacjsoace
            e.preventDefault();
        }
        if (e.keyCode == 9) {   //tab            
            this.hidePopup();
            return;
        }
        if (e.keyCode == 16 || e.keyCode == 17 || e.keyCode == 18) return;

        switch (e.keyCode) {

            //            case 13:    //enter                                            

            //                if (this.isShowPopup) {                                            
            //                    e.preventDefault();                                            

            //                    //是否交互中？                                                                
            //                    if (this._loading) {                                            
            //                        this._selectOnLoad = true;                                            
            //                        return;                                            
            //                    }                                            

            //                    //选中                                            
            //                    this.__doSelectValue();                                            

            //                }                                            

            //                break;                                             

            case 13:    //enter

                if (this.inputMode) {
                    var text = this.getInputText().trim();
                    if (text) {
                        this._doInsertInputValue();
                    }
                    return;
                }


                if (this.isShowPopup) {
                    e.preventDefault();

                    //是否交互中？                    
                    if (this._loading) {
                        this._selectOnLoad = true;
                        return;
                    }

                    var item = this._listbox.getFocusedItem();
                    if (item && item.enabled === false) return;

                    //选中
                    this.__doSelectValue();

                    //                    var item = this._listbox.getFocusedItem();
                    //                    if (!item && !this.valueFromSelect) {
                    //                        var value = this._inputEl.value.trim()
                    //                        if (value != "") {
                    //                            //this.selecteds.push({ value: value, text: value })
                    //                            this.doUpdate();
                    //                            this.showInput()
                    //                        }
                    //                    }
                }
                break;

            case 27:    //esc
                e.preventDefault();
                this.hidePopup();
                break;
            case 8:    //backspace

                if (isFirst) {
                    e.preventDefault();
                }
            case 37:    //left
                if (isFirst) {
                    if (this.isShowPopup) {
                        this.hidePopup();
                    } else {
                        if (this.editIndex > 0) {
                            var index = this.editIndex - 1;
                            if (index < 0) index = 0;
                            if (index >= this.selecteds.length) index = this.selecteds.length - 1;

                            this.showInput(false);
                            this.select(index);
                        }
                    }
                }
                break;
            case 39:    //right
                if (isLast) {
                    if (this.isShowPopup) {
                        this.hidePopup();
                    } else {
                        if (this.editIndex <= this.selecteds.length - 1) {

                            var index = this.editIndex;
                            //                        if (index < 0) index = 0;
                            //                        if (index >= this.selecteds.length) index = this.selecteds.length - 1;
                            this.showInput(false);
                            this.select(index);

                        }
                    }
                }
                break;
            case 38: //top
                e.preventDefault();
                if (this.isShowPopup) {
                    var index = -1;
                    var item = this._listbox.getFocusedItem();
                    if (item) index = this._listbox.indexOf(item);
                    index--;
                    if (index < 0) index = 0;
                    this._listbox._focusItem(index, true);

                    //his._doSetValue();
                }
                break;
            case 40: //bottom

                e.preventDefault();
                if (this.isShowPopup) {
                    var index = -1;
                    var item = this._listbox.getFocusedItem();
                    if (item) index = this._listbox.indexOf(item);
                    index++
                    if (index < 0) index = 0;
                    if (index >= this._listbox.getCount()) index = this._listbox.getCount() - 1;
                    this._listbox._focusItem(index, true);

                    //this._doSetValue();
                } else {
                    this._startQuery(true);
                }
                break;
            default:
                //this._startQuery(this._inputEl.value);
                break;
        }
    },
    ////////////////////////////////////////////////
    focus: function () {

        try {
            this._inputEl.focus();
        } catch (e) {
        }
    },
    blur: function () {
        try {
            this._inputEl.blur();
        } catch (e) {
        }
    },
    searchField: "key",
    setSearchField: function (value) {
        this.searchField = value;
    },
    getSearchField: function () {
        return this.searchField;
    },
    getAttrs: function (el) {
        var attrs = mini.TextBox.superclass.getAttrs.call(this, el);
        var jq = jQuery(el);

        mini._ParseString(el, attrs,
            ["value", "text", "valueField", "textField", "url", "popupHeight",
            "textName", "onfocus", "onbeforeload", "onload", "searchField",
            "emptyText", "loadingText", "errorText", "onblur", "onremoveitem", "placeholder"
             ]
        );
        mini._ParseBool(el, attrs,
            ["allowInput", "valueFromSelect", "remote", "inputMode"
             ]
        );

        mini._ParseInt(el, attrs,
            ["popupMinHeight", "popupMaxHeight"
             ]
        );
        return attrs;
    }

});

mini.regClass(mini.TextBoxList, "textboxlist");

mini.AutoComplete = function () {
    mini.AutoComplete.superclass.constructor.apply(this, arguments);

    //this._updateButton("popup", { visible: false });

    var sf = this;
    sf._ValueChangeTimer = null;

    this._textEl.onfocus = function () {
        //sf._NowText = sf._textEl.value;
        sf._LastInputText = sf._textEl.value;
        sf._ValueChangeTimer = setInterval(function () {
            //document.title = new Date().getTime();

            if (sf._LastInputText != sf._textEl.value) {
                //if( sf.minChars

                sf._tryQuery();
                sf._LastInputText = sf._textEl.value;

                if (sf._textEl.value == "" && sf.value != "") {
                    sf.setValue("");
                    sf._OnValueChanged();
                }
            }
        }, 10);

        //sf.addCls(sf._focusCls);
        //sf._focused = true;
    }
    this._textEl.onblur = function () {
        clearInterval(sf._ValueChangeTimer);
        if (!sf.isShowPopup()) {
            if (sf._LastInputText != sf._textEl.value) {
                //alert(1);
                if (sf._textEl.value == "" && sf.value != "") {
                    sf.setValue("");
                    sf._OnValueChanged();
                }
            }
        }
    }

    this._buttonEl.style.display = "none";

    this._doInputLayout();
}
mini.extend(mini.AutoComplete, mini.ComboBox, {
    remote: true,   //false

    url: "",
    allowInput: true,
    delay: 150,

    showButton: false,

    searchField: "key",

    minChars: 0,

    _buttonWidth: 0,

    uiCls: "mini-autocomplete",

    _initInput: function () {
        var me = this;

        if (isFirefox) {
            this._textEl.oninput = function () {
                if (!me.enterQuery) {

                    me._tryQuery();
                }
            }
        }
    },

    getRemote: function () {
        return this.remote;
    },

    setRemote: function (remote) {
        this.remote = remote;
    },

    setUrl: function (value) {
        this.url = value;
        if (!this.remote) {
            mini.AutoComplete.superclass.setUrl.call(this, value);
        }
    },
    setValue: function (value) {
        //if (value == "德国") alert(value);
        if (mini.isNull(value)) value = "";
        if (this.value != value) {
            this.value = value;
            this._valueEl.value = this.value;
        }
        this.__oldText = '';
    },
    setText: function (value) {
        if (mini.isNull(value)) value = "";
        if (this.text != value) {
            this.text = value;
            this._LastInputText = value;
        }
        //fix ff
        //        var _canFire = this._canFire;
        //        this._canFire = false;
        //this._stopTextChanged = true;   //fix ff
        this._textEl.value = this.text;
        //delete this._stopTextChanged;
        //this._canFire = _canFire;
    },

    setMinChars: function (value) {
        this.minChars = value;
    },
    getMinChars: function () {
        return this.minChars;
    },
    setSearchField: function (value) {
        this.searchField = value;
    },
    getSearchField: function () {
        return this.searchField;
    },


    ////////////////////////////////
    popupEmptyText: epoint_local.AutoComplete.popupEmptyText,
    setPopupEmptyText: function (value) {
        this.popupEmptyText = value;
    },
    getPopupEmptyText: function (value) {
        return this.popupEmptyText;
    },
    loadingText: epoint_local.AutoComplete.loadingText,
    setLoadingText: function (value) {
        this.loadingText = value;
    },
    getLoadingText: function (value) {
        return this.loadingText;
    },
    errorText: epoint_local.AutoComplete.errorText,
    setErrorText: function (value) {
        this.errorText = value;
    },
    getErrorText: function (value) {
        return this.errorText;
    },
    ////////////////////////////////

    //    popupLoadingText: "<span class='mini-textboxlist-popup-loading'>Loading...</span>",
    //    popupErrorText: "<span class='mini-textboxlist-popup-error'>Error</span>",
    //    popupEmptyText: "<span class='mini-textboxlist-popup-noresult'>No Result</span>",

    getPopupEmptyHtml: function () {
        return "<span class='mini-textboxlist-popup-noresult'>" + this.popupEmptyText + "</span>";
    },
    getPopupLoadingHtml: function () {
        return "<span class='mini-textboxlist-popup-loading'>" + this.loadingText + "</span>"
    },
    getPopupErrorHtml: function () {
        return "<span class='mini-textboxlist-popup-error'>" + this.errorText + "</span>";
    },

    showPopup: function (action) {

        var popup = this.getPopup();
        var control = this._listbox;
        control.showEmpty = true;
        control.emptyText = this.getPopupEmptyHtml();
        if (action == "loading") {
            control.emptyText = this.getPopupLoadingHtml();
            this._listbox.setData([]);
        } else if (action == "error") {
            control.emptyText = this.getPopupErrorHtml();
            this._listbox.setData([]);
        }
        this._listbox.doUpdate();

        mini.AutoComplete.superclass.showPopup.call(this);


    },
    ///////////////////////////////
    //    __OnInputKeyUp: function (e) {
    //        this.__OnInputKeyDown(e);
    //    },
    __OnInputKeyDown: function (e) {
        var me = this;
        var ex = { htmlEvent: e };
        this.fire("keydown", ex);
        if (e.keyCode == 8 && (this.isReadOnly() || this.allowInput == false)) {
            return false;
        }
        if (e.keyCode == 9) {   //tab
            this.hidePopup();
            return;
        }
        if (e.keyCode == 16 || e.keyCode == 17 || e.keyCode == 18) {
            return;
        }

        if (this.isReadOnly()) return;

        switch (e.keyCode) {
            case 27:        //esc
                if (this.isShowPopup()) {
                    e.stopPropagation();
                }

                this.hidePopup();
                break;
            case 13:     //enter      

                var doSelect = true;

                if (!this.isShowPopup() || this._listbox.getData().length == 0) {

                    //                    if (this.enterQuery) {
                    //                        doSelect = false;
                    //                        this._tryQuery(this._textEl.value);
                    //                    }

                    if (this.enterQuery) {
                        doSelect = false;
                        var searchText = this._textEl.value;
                        if (this._enterSearchText != searchText || !me.loading) {
                            this._enterSearchText = searchText;
                            this._tryQuery(searchText);
                        }
                    }

                }

                if (this.isShowPopup()) {
                    e.preventDefault();
                    e.stopPropagation();

                    if (me._requestSearch !== true) {
                        var index = this._listbox.getFocusedIndex();

                        if (index != -1) {
                            var item = this._listbox.getAt(index);
                            var vts = this._listbox.getValueAndText([item]);
                            var value = vts[0];

                            this.setText(vts[1]);
                            //                        if (mini.isFirefox) {   //FF下修改textEl.value，会激发changed...
                            //                            this.blur();
                            //                            this.focus();
                            //                        }

                            this.setValue(value);

                            this._OnValueChanged();


                            //alert(this.getValue());
                        }
                    }
                } else {

                    this.fire("enter", ex);
                }

                if (doSelect) {
                    this.hidePopup();
                    this.focus();
                }

                break;
            case 37:    //left
                break;
            case 38:    //top      
                var index = this._listbox.getFocusedIndex();
                if (index == -1) {
                    index = 0;
                    if (!this.multiSelect) {
                        var item = this._listbox.findItems(this.value)[0];
                        if (item) {
                            index = this._listbox.indexOf(item);
                        }
                    }
                }
                if (this.isShowPopup()) {
                    if (!this.multiSelect) {
                        index -= 1;
                        if (index < 0) index = 0;
                        this._listbox._focusItem(index, true);
                    }
                }
                break;
            case 39:    //right
                break;
            case 40:    //bottom

                var index = this._listbox.getFocusedIndex();
                if (this.isShowPopup()) {
                    if (!this.multiSelect) {
                        index += 1;
                        if (index > this._listbox.getCount() - 1) index = this._listbox.getCount() - 1;
                        this._listbox._focusItem(index, true);
                    }
                } else {
                    this._tryQuery(this._textEl.value);
                }
                break;
            default:
                if (this.enterQuery == true) {
                    this.hidePopup();
                    this.focus();
                } else {

                    this._keydownQuery();


                }

                break;
        }
    },

    delay: 200,

    _keydownQuery: function () {
        var me = this;

        me._requestSearch = true;       //发起请求

        if (!me.remote) me._requestSearch = false;

        //        var text = me._textEl.value;
        //        me._tryQuery(text);

        //        return;

        if (me._keydownTimer) {
            clearTimeout(me._keydownTimer);
            me._keydownTimer = null;
        }

        me._keydownTimer = setTimeout(function () {

            var text = me._textEl.value;
            if (text != me.__oldText) {
                me._tryQuery(text);


                me.__oldText = text;
            }

        }, me.delay);

    },

    enterQuery: false,
    doQuery: function () {

        this._tryQuery();
    },
    _tryQuery: function (oldText) {
        var sf = this;


        if (this._queryTimer) {
            clearTimeout(this._queryTimer);
            this._queryTimer = null;
        }
        this._queryTimer = setTimeout(function () {
            var text = sf._textEl.value;
            //if (text != oldText) {

            sf._doQuery(text);

            //document.title = text + ":" + new Date().getTime();

            //document.title = new Date();
            //}
        }, this.delay);
        if (sf._tryHide() !== false) {
            this.showPopup("loading");
        }
    },

    _tryHide: function () {
        var me = this;
        if (mini.getActiveElement() != me._textEl && mini.hasClass(me.el, 'mini-buttonedit-focus')) {
            me.hidePopup();
            return false;
        }
    },

    blur: function () {
        var me = this;
        mini.AutoComplete.superclass.blur.apply(this);

        if (me._ajaxer) {
            me._ajaxer.abort();
            me._ajaxer = null;
        }
        if (me._doloadTimer) {
            clearTimeout(me._doloadTimer);
            me._doloadTimer = null;
        }
        if (me._queryTimer) {
            clearTimeout(me._queryTimer);
            me._queryTimer = null;
        }
        if (me._keydownTimer) {
            clearTimeout(me._keydownTimer);
            me._keydownTimer = null;
        }
        if (me.isShowPopup()) {
            me.hidePopup();
        }
        //alert(111);
    },

    _doQuery: function (key) {
        var me = this;
        //if ($(document.activeElement).closest(me.el).length) {
        //        if ($(document.activeElement).closest(me.el).length) {
        //            document.title = new Date().getTime();
        //            me.hidePopup();
        //        }
        if (mini.getActiveElement() != me._textEl) {
            me.hidePopup();
            return;
        }

        if (!this.remote) {
            mini.AutoComplete.superclass._doQuery.apply(this, arguments);
            return;
        }

        //if (!this.url) return;
        if (this._ajaxer) {
            this._ajaxer.abort();
        }

        var url = this.url;
        var ajaxMethod = "post";
        if (url) {
            if (url.indexOf(".txt") != -1 || url.indexOf(".json") != -1) {
                ajaxMethod = "get";
            }
        }

        var params = {};
        params[this.searchField] = key;

        var e = {
            url: url,
            async: true,
            params: params,
            data: params,
            type: this.ajaxType ? this.ajaxType : ajaxMethod,
            cache: false,
            cancel: false
        };

        jQuery.extend(true, e, this.ajaxOptions);

        this.fire("beforeload", e);

        var me = this;
        function doload(data, result) {
            if (!me._focused) return;

            if (me._tryHide() === false) return;
            if (me._doloadTimer) {
                clearTimeout(me._doloadTimer);
                me._doloadTimer = null;
            }
            me._doloadTimer = setTimeout(function () {
                me._doloadTimer = null;
                me._tryHide();
            }, 100);

            me._listbox.setData(data);
            me.showPopup();
            me._listbox._focusItem(0, true);
            me.data = data;
            me.fire("load", { data: data, result: result });
        }

        if (e.cancel) {
            var data = e.result || [];
            doload(data, data);
            return;
        }

        //alert(this.dataField);

        me.loading = true;

        mini.copyTo(e, {
            success: function (text, textStatus, xhr) {
                delete e.params;
                var obj = { text: text, result: null, sender: me, options: e, xhr: xhr };
                var result = null;
                try {
                    mini_doload(obj);
                    result = obj.result;
                    if (!result) {
                        result = mini.decode(text);
                    }
                } catch (ex) {
                    if (mini_debugger == true) {
                        throw new Error("autocomplete json is error");
                    }
                }
                if (mini.isArray(result)) result = { data: result };

                //                if (mini.isNumber(result.error) && result.error != 0) {
                //                    var ex = {};
                //                    ex.stackTrace = result.stackTrace;
                //                    ex.errorMsg = result.errorMsg;
                //                    if (mini_debugger == true) {
                //                        alert(url + "\n" + ex.textStatus + "\n" + ex.stackTrace);
                //                    }
                //                    return;
                //                }

                if (me.dataField) {
                    result.data = mini._getMap(me.dataField, result);
                }
                if (!result.data) result.data = [];

                doload(result.data, result);

                //                if (me._doloadTimer) {
                //                    clearTimeout(me._doloadTimer);
                //                    me._doloadTimer = null;
                //                }
                //                me._doloadTimer = setTimeout(function () {
                //                    doload(result.data, result);
                //                }, 50);

                //                me._listbox.setData(result.data);
                //                me.showPopup();
                //                me._listbox._focusItem(0, true);
                //                me.data = result.data;
                //                me.fire("load", { data: result.data, result: result });

            },
            error: function (jqXHR, textStatus, errorThrown) {
                //                if (textStatus != "abort") {
                //                    me.showPopup("error");
                //                }
            },
            complete: function () {
                me.loading = false;
                me._requestSearch = false;
                me._ajaxer = null;
            }
        });

        this._ajaxer = mini.ajax(e);
    },
    setEnterQuery: function (value) {
        this.enterQuery = value;
    },
    getEnterQuery: function () {
        return this.enterQuery;
    },
    ////////////////////////////////
    getAttrs: function (el) {
        var attrs = mini.AutoComplete.superclass.getAttrs.call(this, el);

        mini._ParseString(el, attrs,
            ["searchField", "popupEmptyText", "loadingText", "errorText"]
        );
        // 将delay属性开放出来
        mini._ParseInt(el, attrs, ["delay"]);
        mini._ParseBool(el, attrs,
            ["enterQuery", "remote"]
        );


        return attrs;
    }
});

mini.regClass(mini.AutoComplete, "autocomplete");

mini.ToolTip = function () {
    mini.ToolTip.superclass.constructor.apply(this, arguments);

    
}
mini.extend(mini.ToolTip, mini.Control, {

    selector: '[title]',
    placement: 'bottom',    //bottomleft, topleft, bottomright, topright
    trigger: 'hover focus',
    delay: 200,

    uiCls: "mini-tooltip",

    _create: function () {
        this.el = jQuery('<div class="mini-tooltip"><div class="mini-tooltip-arrow"></div><div class="mini-tooltip-inner mini-corner-all"></div></div>')[0];
        this.$element = jQuery(this.el);
        this.$element.appendTo(document.body);
    },
    _initEvents: function () {

    },
    _bindTooltip: function () {
        var jq = jQuery(document),
            selector = this.selector,
            type = 'tooltip';

        jq.unbind('.' + type, this);

        var triggers = this.trigger.split(' ');

        for (var i = triggers.length; i--; ) {
            var trigger = triggers[i]

            if (trigger == 'click') {
                jq.on('click.' + type, selector, jQuery.proxy(this._toggle, this))
            } else if (trigger != 'manual') {
                var eventIn = trigger == 'hover' ? 'mouseenter' : 'focus'
                var eventOut = trigger == 'hover' ? 'mouseleave' : 'blur'

                jq.on(eventIn + '.' + type, selector, jQuery.proxy(this._enter, this))
                jq.on(eventOut + '.' + type, selector, jQuery.proxy(this._leave, this))
            }
        }
    },

    setSelector: function (value) {
        this.selector = value;
        this._bindTooltip();
    },
    getSelector: function () {
        return this.selector;
    },
    setPlacement: function (value) {
        this.placement = value;
    },
    getPlacement: function () {
        return this.placement;
    },
    setTrigger: function (value) {
        this.trigger = value;
        this._bindTooltip();
    },
    getTrigger: function () {
        return this.trigger;
    },
    //////////////////////////////////////////////////

    openTimer: null,
    _enter: function (e) {


        var self = this;

        var target = e.currentTarget;
        this.getContent(target);

        clearTimeout(this.openTimer);
        this.openTimer = setTimeout(function () {
            self.openTimer = null;
            self.open(target);
        }, self.delay);
    },
    _leave: function (e) {

        clearTimeout(this.openTimer);

        this.close();
    },
    _toggle: function (e) {
        if (this._getTip().css("display") == 'none') {
            this.enter(e);
        } else {
            this.leave(e);
        }
    },
    /////////////////////////////////////////////////
    open: function (target) {
        var target = jQuery(target)[0] || this.target,
                jq = jQuery(target),
                content = this.getContent(target);

        var e = { element: target, content: content, cancel: !content };
        this.fire("beforeopen", e);
        if (e.cancel) return;

        this.$element.show();

        this._target = target;

        try {
            this.setContent(e.content);
        } catch (ex) { }

        this.fire("open", { element: target });

    },
    close: function () {
        this._target = null;
        this.$element.hide();
    },
    showLoading: function () {
        this.setContent('<div class="mini-tooltip-loading"></div>');
    },
    setContent: function (value) {
        this.$element.children(".mini-tooltip-inner").html(value || '&nbsp;');
        this.applyPlacement();
    },
    getContent: function (element) {
        var content = element.title;
        if (content) {
            jQuery(element).attr("data-tooltip", content).attr("title", "");
        }
        if (!content) {
            content = jQuery(element).attr("data-tooltip");
        }
        return content;
    },
    applyPlacement: function () {
        if (!this._target) return;
        if (this.$element.css("display") == "none") return;
        var target = this._target,
            jq = jQuery(target),
            placement = jq.attr("data-placement") || this.placement,
            tip = this.$element;

        if (!target || !tip[0]) return;

        tip.show().css({ left: "-2000px", top: "-2000px" });

        function applyCls(placement) {

            tip.removeClass("mini-tooltip-left mini-tooltip-top mini-tooltip-right mini-tooltip-bottom mini-tooltip-bottomleft mini-tooltip-topleft mini-tooltip-bottomright mini-tooltip-topright")
                .addClass('mini-tooltip-' + placement);
        }
        function applyPos(pos) {
            tip.offset(pos);
        }

        //
        var box = mini.getBox(target);
        var vbox = mini.getViewportBox();
        var topspace = box.top - vbox.top, bottomspace = vbox.bottom - box.bottom;

        applyCls(placement);

        var tipbox = mini.getBox(tip[0]);
        var pos = mini.getCalculatedOffset(placement, box, tipbox.width, tipbox.height);


        //边界处理
        if (placement == "left") {
        } else if (placement == "right") {
        } else if (placement == "top") {
        } else if (placement == "bottom") {

        } else if (placement == "bottomleft" && topspace > bottomspace) {

            if (pos.top + tipbox.height > vbox.bottom) {
                placement = "topleft";
            }
        } else if (placement == "topleft") {

        }

        applyCls(placement);
        pos = mini.getCalculatedOffset(placement, box, tipbox.width, tipbox.height);



        if (placement == "right" || placement == "left") {

            var arrow = jQuery(tip).children(".mini-tooltip-arrow");
            arrow.css("top", "");

            function centerArrow() {
                var top = box.top + box.height / 2 - arrow.height() / 2;

                var y = top - pos.top;
                arrow.css("top", y);

            }


            var vbox = mini.getViewportBox();
            if (pos.top < vbox.y) {
                pos.top = vbox.y;
                centerArrow();
            } else if (pos.top + tipbox.height > vbox.bottom) {
                pos.top = vbox.bottom - tipbox.height;
                centerArrow();
            }
        }

        applyPos(pos);
    },

    ///////////////////////////////////////////////
    getAttrs: function (el) {
        var attrs = mini.ToolTip.superclass.getAttrs.call(this, el);
        mini._ParseString(el, attrs,
            ['selector', 'placement', "onbeforeopen", "onopen", "onclose"
             ]
        );
        return attrs;
    }
});
mini.regClass(mini.ToolTip, "tooltip");

mini.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    if(placement == 'bottom') return { top: pos.top + pos.height, left: pos.left + pos.width / 2 - actualWidth / 2}; 
    if(placement == 'top') return  { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2};
    if(placement == 'left') return { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth} ;
    //if(placement == 'right') return {top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width };
    if (placement == 'bottomleft') return { top: pos.top + pos.height, left: pos.left };
    if (placement == 'bottomright') return { top: pos.top + pos.height, left: pos.left + pos.width - actualWidth };
    if (placement == 'topleft') return { top: pos.top - actualHeight, left: pos.left };
    if (placement == 'topright') return { top: pos.top - actualHeight, left: pos.left + pos.width - actualWidth };

    return { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width };
}


mini.ProgressBar = function() {
    mini.ProgressBar.superclass.constructor.apply(this, arguments);
    //mini.Button.superclass.constructor.apply(this, arguments);
};

mini.extend(mini.ProgressBar, mini.Control, {
    formField: true,
    uiCls: 'mini-progressbar',

    showText: false,
    textAlign: 'right', // left or center or right
    text: '',
    format: '{0}%', //"百分之{0}"
    value: 0, //0~100
    state: 'loading', //"success" "error" "loading"

    set: function(kv) {
        if (typeof kv == 'string') {
            return this;
        }

        var value = kv.value;
        delete kv.value;

        mini.ProgressBar.superclass.set.call(this, kv);

        if (!mini.isNull(value)) {
            this.setValue(value);
        }

        return this;
    },

    _create: function() {
        this.el = document.createElement('div');
        this.el.className = 'mini-progressbar';

        // prettier-ignore
        var s = '<div class="mini-progressbar-border">' +
                    '<div class="mini-progressbar-bar"><div class="mini-progressbar-bar-current"></div></div>' + 
                    '<div class="mini-progressbar-text"></div>' + 
                    '<div class="mini-progressbar-state action-icon" style="display:none""></div>' + 
                '</div>';

        this.el.innerHTML = s;
        this._borderEl = this.el.firstChild;
        this._barEl = this._borderEl.firstChild.firstChild;
        this._textEl = jQuery(this._borderEl).find('.mini-progressbar-text')[0];
        this._stateEl = this._borderEl.lastChild;

        this.el.setAttribute('mini-text-align', this.textAlign);
        //....
    },

    setText: function(value) {
        this.text = value;
        this._textEl.innerHTML = value;
    },

    setShowText: function(value) {
        this.showText = value;
        this._textEl.style.display = value ? '' : 'none';
    },

    getShowText: function() {
        return this.showText;
    },

    setTextAlign: function(value) {
        this.textAlign = value;
        this._textEl.style.textAlign = value;

        this.el.setAttribute('mini-text-align', this.textAlign);
    },

    getTextAlign: function() {
        return this.textAlign;
    },

    setValue: function(value) {
        value = parseFloat(value);
        if (isNaN(value)) value = 0;

        if (value < 0) value = 0;
        if (value > 100) value = 100;

        this.value = value;

        this._barEl.style.width = value + '%';

        var text = String.format(this.format, value);
        this.setText(text);
    },

    getValue: function() {
        return this.value;
    },
    setState: function(value) {
        if (~['success', 'error', 'loading'].indexOf(value)) {
            this.removeCls('mini-progress-' + this.state);
            this.addCls('mini-progress-' + value);
            if (value === 'success' || value === 'error') {
                this._textEl.style.display = 'none';
                jQuery(this._stateEl)
                    .removeClass('icon-successfill icon-errorfill')
                    .addClass('icon-' + value + 'fill')
                    .show();
            } else {
                this._textEl.style.display = '';
                this._stateEl.style.display = 'none';
            }
        }
    },
    getState: function() {
        return this.state;
    },

    getAttrs: function(el) {
        var attrs = mini.ProgressBar.superclass.getAttrs.call(this, el);

        mini._ParseString(el, attrs, ['text', 'format', 'textAlign', 'state']);

        mini._ParseBool(el, attrs, ['showText']);

        return attrs;
    }
});

mini.regClass(mini.ProgressBar, 'progressbar');


mini.Form = function (el) {
    this.el = mini.byId(el);
    if (!this.el) throw new Error("form element not null");
    
    mini.Form.superclass.constructor.apply(this, arguments);

}
mini.extend(mini.Form, mini.Component, {
    //_FORM: true,
    el: null,

    getFields: function () {
        if (!this.el) return [];
        var controls = mini.findControls(function (control) {
            if (!control.el || control.formField != true) return false;
            if (mini.isAncestor(this.el, control.el)) return true;
            return false;
        }, this);
        return controls;
    },
    getFieldsMap: function () {
        var fields = this.getFields();
        var map = {};
        for (var i = 0, l = fields.length; i < l; i++) {
            var field = fields[i];
            if (field.name) map[field.name] = field;
        }
        return map;
    },
    getField: function (name) {
        if (!this.el) return null;
        return mini.getbyName(name, this.el);
    },

    getData: function (formatted, deep) {
        if (mini.isNull(deep)) deep = true;
        var valueFn = formatted ? "getFormValue" : "getValue";
        var controls = this.getFields();
        var data = {};
        for (var i = 0, l = controls.length; i < l; i++) {
            var control = controls[i];
            var fn = control[valueFn];
            if (!fn) continue;
            if (control.name) {
                if (deep == true) {
                    mini._setMap(control.name, fn.call(control), data);
                } else {
                    data[control.name] = fn.call(control);
                }
            }
            if (control.textName && control.getText) {
                if (deep == true) {
                    mini._setMap(control.textName, control.getText(), data);
                } else {
                    data[control.textName] = control.getText();
                }
            }
        }
        return data;
    },
    setData: function (options, all, deep) {
        if (mini.isNull(deep)) deep = true;
        if (typeof options != "object") options = {};
        var map = this.getFieldsMap();
        for (var name in map) {
            var control = map[name];
            if (!control) continue;
            if (control.setValue) {
                var v = options[name];
                if (deep == true) {
                    v = mini._getMap(name, options);
                }
                if (v === undefined && all === false) continue;
                if (v === null) v = "";
                control.setValue(v);
            }
            if (control.setText && control.textName) {
                var text = options[control.textName];
                if (deep == true) {
                    text = mini._getMap(control.textName, options);
                }
                if (mini.isNull(text)) text = "";
                control.setText(text);
            }
        }
        //mini.repaint(document.body);
    },
    reset: function () {
        var controls = this.getFields();
        for (var i = 0, l = controls.length; i < l; i++) {
            var control = controls[i];
            if (!control.setValue) continue;
            if (control.setText && control._clearText !== false) {
                var text = control.defaultText;
                if (mini.isNull(text)) text = "";
                control.setText(text);
            }
            control.setValue(control.defaultValue);
            if (control.clear) control.clear();
        }
        this.setIsValid(true);
    },
    clear: function () {
        var controls = this.getFields();
        for (var i = 0, l = controls.length; i < l; i++) {
            var control = controls[i];
            if (!control.setValue) continue;
            if (control.setText && control._clearText !== false) {
                control.setText("");
            }
            control.setValue("");
            if (control.clear) control.clear();
        }
        this.setIsValid(true);
    },
    getValidateFields: function (disableValid) {
        function isDisplay(control) {
            return control.isDisplay(function (p) {
                if (mini.hasClass(p, 'mini-tabs-body')) return true;
            });
        }

        var fields = [];
        var controls = this.getFields();
        for (var i = 0, l = controls.length; i < l; i++) {
            var control = controls[i];
            if (!control.validate || !control.isDisplay) continue;
            if (isDisplay(control) || control.forceValidate) { //

                if (control.enabled || disableValid || control.forceValidate) {

                    fields.push(control);
                }
            }
        }
        return fields;
    },
    validate: function (all, disableValid) {
        var controls = this.getValidateFields(disableValid);
        for (var i = 0, l = controls.length; i < l; i++) {
            var control = controls[i];
            var succ = control.validate();
            if (succ == false && all === false) {
                break;
            }
        }
        return this.isValid();
    },
    isValid: function () {
        var controls = this.getValidateFields();
        for (var i = 0, l = controls.length; i < l; i++) {
            var control = controls[i];
            if (control.isValid() == false) return false;
        }
        return true;
    },
    setIsValid: function (isValid) {
        var controls = this.getFields();
        for (var i = 0, l = controls.length; i < l; i++) {
            var control = controls[i];
            if (!control.setIsValid) continue;
            control.setIsValid(isValid);
        }
    },

    getErrorTexts: function () {
        var errorTexts = [];
        var errors = this.getErrors();
        for (var i = 0, l = errors.length; i < l; i++) {
            var control = errors[i];
            errorTexts.push(control.errorText);
        }
        return errorTexts;
    },
    getErrors: function () {
        var errors = [];
        var controls = this.getFields();
        for (var i = 0, l = controls.length; i < l; i++) {
            var control = controls[i];
            if (!control.isValid) continue;
            if (control.isValid() == false) {
                errors.push(control);
            }
        }
        return errors;
    },
    ///////////////////////////////////////////////////////////
    mask: function (options) {
        if (typeof options == "string") options = { html: options };
        options = options || {};
        options.el = this.el;
        if (!options.cls) options.cls = this._maskCls;
        mini.mask(options);
    },
    unmask: function () {
        mini.unmask(this.el);
    },
    _maskCls: "mini-mask-loading",
    loadingMsg: epoint_local.loadingMsg,
    loading: function (msg) {
        this.mask(msg || this.loadingMsg);
    },
    /////////////////////////////////////////////////////////
    __OnValueChanged: function (e) {

        this._changed = true;
    },
    _changed: false,
    setChanged: function (value) {
        this._changed = value;

        var controls = this.getFields();
        for (var i = 0, l = controls.length; i < l; i++) {
            var control = controls[i];

            control.on("valuechanged", this.__OnValueChanged, this);
        }
    },
    isChanged: function () {
        return this._changed;
    },
    //////////////////////////////
    setEnabled: function (value) {
        var controls = this.getFields();
        for (var i = 0, l = controls.length; i < l; i++) {
            var control = controls[i];
            control.setEnabled(value);
        }
    }

});


mini.Fit = function () {
    mini.Fit.superclass.constructor.apply(this, arguments);
}
mini.extend(mini.Fit, mini.Container, {

    style: "",
    _clearBorder: false,

    uiCls: "mini-fit",
    _create: function () {
        this.el = document.createElement("div");
        this.el.className = "mini-fit";
        this._bodyEl = this.el;
    },
    _initEvents: function () {

    },
    isFixedSize: function () {
        return false;
    },
    doLayout: function () {
        if (!this.canLayout()) return;

        var parentNode = this.el.parentNode;
        var childNodes = mini.getChildNodes(parentNode);
        if (parentNode == document.body) {
            this.el.style.height = "0px";
        }
        //        this.el.style.height = "100px";
        //        this.el.style.overFlow = "hidden";
        var height = mini.getHeight(parentNode, true);
        //        var border = mini.getBorders(parentNode);
        //        if (jQuery.boxModel) {
        //            height = height - border.top - border.bottom;
        //        }

        //alert(height + ":" + document.body.clientHeight);
        
        for (var i = 0, l = childNodes.length; i < l; i++) {
            var node = childNodes[i];
            var tagName = node.tagName ? node.tagName.toLowerCase() : "";
            if (node == this.el || (tagName == "style" || tagName == "script" || node.type == "hidden")) continue;
            var pos = jQuery(node).css("position");
            if (pos == "absolute" || pos == "fixed") continue;

            var h = mini.getHeight(node);

            var margin = mini.getMargins(node);
            height = height - h - margin.top - margin.bottom;
        }

        var border = mini.getBorders(this.el);
        var padding = mini.getPaddings(this.el);
        var margin = mini.getMargins(this.el);

        height = height - margin.top - margin.bottom;
        if (jQuery.boxModel) {
            height = height - padding.top - padding.bottom - border.top - border.bottom;
        }
        if (height < 0) height = 0;

        this.el.style.height = height + "px";

        //layout children
        try {
            childNodes = mini.getChildNodes(this.el);
            for (var i = 0, l = childNodes.length; i < l; i++) {
                var node = childNodes[i];
                mini.layout(node);
            }
        } catch (e) { }

    },
    set_bodyParent: function (value) {

        if (!value) return;
        //bodyParent
        var el = this._bodyEl;

        var p = value;
        while (p.firstChild) {
            try {
                el.appendChild(p.firstChild);
            } catch (e) { }
        }
        this.doLayout();
    },

    ///////////////////////////////////////////////
    getAttrs: function (el) {
        var attrs = mini.Fit.superclass.getAttrs.call(this, el);

        attrs._bodyParent = el;

        return attrs;
    }
});
mini.regClass(mini.Fit, "fit");

mini.Panel = function () {
    this._initButtons();
    mini.Panel.superclass.constructor.apply(this, arguments);

    if (this.url) this.setUrl(this.url);

    this._contentEl = this._bodyEl;

    this._doVisibleEls();

    this._Resizer = new mini._Resizer(this);

    this._doTools();
}
mini.extend(mini.Panel, mini.Container, {
    width: 250,
    title: "",
    iconCls: "",
    iconStyle: "",

    allowResize: false,

    url: "",

    refreshOnExpand: false,
    maskOnLoad: true,

    collapseOnTitleClick: false,

    showCollapseButton: false,
    showCloseButton: false,
    closeAction: "display", //"destroy"
    showHeader: true,
    showToolbar: false,
    showFooter: false,

    headerCls: "",
    headerStyle: "",
    bodyCls: "",
    bodyStyle: "",
    footerCls: "",
    footerStyle: "",
    toolbarCls: "",
    toolbarStyle: "",

    minWidth: 180,
    minHeight: 100,
    maxWidth: 5000,
    maxHeight: 3000,

    set: function (kv) {
        if (typeof kv == 'string') {
            return this;
        }

        var _allowLayout = this._allowLayout;
        this._allowLayout = false;

        var toolbar = kv.toolbar;
        delete kv.toolbar;
        var footer = kv.footer;
        delete kv.footer;
        var url = kv.url;
        delete kv.url;

        var buttons = kv.buttons;
        delete kv.buttons;

        mini.Panel.superclass.set.call(this, kv);

        if (buttons) {
            this.setButtons(buttons);
        }
        if (toolbar) {
            this.setToolbar(toolbar);
        }
        if (footer) {
            this.setFooter(footer);
        }
        if (url) {
            this.setUrl(url);
        }

        this._allowLayout = _allowLayout;
        this.doLayout();

        return this;
    },

    uiCls: "mini-panel",
    _create: function () {
        this.el = document.createElement("div");
        this.el.className = "mini-panel";
        this.el.tabIndex = 0;

        var s = '<div class="mini-panel-border">'
            + '<div class="mini-panel-header" ><div class="mini-panel-header-inner" ><span class="mini-panel-icon mini-icon mini-iconfont"></span><div class="mini-panel-title" ></div><div class="mini-tools" ></div></div></div>'
            + '<div class="mini-panel-viewport">'
                + '<div class="mini-panel-toolbar"></div>'
                + '<div class="mini-panel-body" ></div>'
                + '<div class="mini-panel-footer"></div>'
                + '<div class="mini-resizer-trigger"></div>'
            + '</div>'
            + '</div>';
        this.el.innerHTML = s;
        this.el.hideFocus = true;

        this._borderEl = this.el.firstChild;
        this._headerEl = this._borderEl.firstChild;
        this._viewportEl = this._borderEl.lastChild;

        this._toolbarEl = mini.byClass('mini-panel-toolbar', this.el);
        this._bodyEl = mini.byClass('mini-panel-body', this.el);
        this._footerEl = mini.byClass('mini-panel-footer', this.el);
        this._resizeGridEl = mini.byClass('mini-resizer-trigger', this.el);

        var hi = mini.byClass('mini-panel-header-inner', this.el);
        this._iconEl = mini.byClass('mini-panel-icon', this.el);
        this._titleEl = mini.byClass('mini-panel-title', this.el);
        this._toolsEl = mini.byClass('mini-tools', this.el);

        mini.setStyle(this._bodyEl, this.bodyStyle);


        this._doTitle();
    },
    destroy: function (removeEl) {

        this._doRemoveIFrame();
        this._iframeEl = null;

        //        mini.removeChilds(this._toolbarEl);
        //        mini.removeChilds(this._bodyEl);
        //        mini.removeChilds(this._footerEl); 
        this._viewportEl = this._borderEl = this._bodyEl = this._footerEl = this._toolbarEl = null;
        this._toolsEl = this._titleEl = this._iconEl = this._resizeGridEl = null;
        mini.Panel.superclass.destroy.call(this, removeEl);
    },
    _initEvents: function () {
        mini._BindEvents(function () {
            mini.on(this.el, "click", this.__OnClick, this);
        }, this);
    },

    _doVisibleEls: function () {
        this._headerEl.style.display = this.showHeader ? "" : "none";
        this._toolbarEl.style.display = this.showToolbar ? "" : "none";
        this._footerEl.style.display = this.showFooter ? "" : "none";
    },
    _setBodyWidth: true,
    doLayout: function () {
        if (!this.canLayout()) return;

        var autoHeight = this.isAutoHeight();
        var autoWidth = this.isAutoWidth();

        var maxHeight = parseInt(jQuery(this.el).css("max-height"));
        //alert(maxHeight);

        if (autoHeight && maxHeight) {

            this._viewportEl.style.height = "auto";
            this._bodyEl.style.height = "auto";
            var height = this.el.firstChild.offsetHeight;
            if (height > maxHeight) {
                autoHeight = false;
            }
        }

        this._autoHeight = autoHeight;

        var w = this.getWidth(true);

        if (mini.isIE6) {
            mini.setWidth(this._bodyEl, w);
        }
        if (!autoHeight) {

            var vh = this.getViewportHeight();

            mini.setHeight(this._viewportEl, vh);

            var bh = this.getBodyHeight(false);

            mini.setHeight(this._bodyEl, bh);
        } else {
            this._viewportEl.style.height = "auto";
            this._bodyEl.style.height = "auto";
        }

        mini.layout(this._borderEl);

        if (this._resizeGridEl) {
            mini.repaint(this._resizeGridEl);
        }

        this._resizeGridEl.style.display = this.allowResize ? "" : "none";

        this.fire("layout");
    },
    deferLayout: function (time) {
        if (!time) time = 10;
        if (this._layoutTimer) return;
        var me = this;
        this._layoutTimer = setTimeout(function () {
            me._layoutTimer = null;
            me.doLayout();
        }, time);
    },
    _stopLayout: function () {
        clearTimeout(this._layoutTimer);
        this._layoutTimer = null;
    },
    getViewportWidth: function (content) {
        //return mini.getWidth(this._viewportEl, content);
        return this.getWidth(true);
    },
    getViewportHeight: function (content) {
        var h = this.getHeight(true) - this.getHeaderHeight();
        
        if (content) {
            var padding2 = mini.getPaddings(this._viewportEl);
            var border2 = mini.getBorders(this._viewportEl);
            var margin2 = mini.getMargins(this._viewportEl);
            if (jQuery.boxModel) {
                h = h - padding2.top - padding2.bottom - border2.top - border2.bottom;
            }
            h = h - margin2.top - margin2.bottom;
        }
        return h;
    },
    getBodyHeight: function (content) {
        var h = this.getViewportHeight(true);
        var h = h - this.getToolbarHeight() - this.getFooterHeight();
        if (content) {
            var padding = mini.getPaddings(this._bodyEl);
            var border = mini.getBorders(this._bodyEl);
            var margin = mini.getMargins(this._bodyEl);
            if (jQuery.boxModel) {
                h = h - padding.top - padding.bottom - border.top - border.bottom;
            }
            h = h - margin.top - margin.bottom;
        }
        //if (isIE9) h -= 1;
        if (h < 0) h = 0;
        return h;
    },
    getHeaderHeight: function () {
        var h = this.showHeader ? jQuery(this._headerEl).outerHeight() : 0;
        return h;
    },
    getToolbarHeight: function () {
        var h = this.showToolbar ? jQuery(this._toolbarEl).outerHeight() : 0;
        return h;
    },
    getFooterHeight: function () {
        var h = this.showFooter ? jQuery(this._footerEl).outerHeight() : 0;
        return h;
    },

    setHeaderStyle: function (value) {
        this.headerStyle = value;
        mini.setStyle(this._headerEl, value);
        this.doLayout();
    },
    getHeaderStyle: function () {
        return this.headerStyle;
    },
    setBodyStyle: function (value) {
        this.bodyStyle = value;
        mini.setStyle(this._bodyEl, value);
        this.doLayout();
    },
    getBodyStyle: function () {
        return this.bodyStyle;
    },
    setToolbarStyle: function (value) {
        this.toolbarStyle = value;
        mini.setStyle(this._toolbarEl, value);
        this.doLayout();
    },
    getToolbarStyle: function () {
        return this.toolbarStyle;
    },
    setFooterStyle: function (value) {
        this.footerStyle = value;
        mini.setStyle(this._footerEl, value);
        this.doLayout();
    },
    getFooterStyle: function () {
        return this.footerStyle;
    },
    setHeaderCls: function (cls) {
        jQuery(this._headerEl).removeClass(this.headerCls);
        jQuery(this._headerEl).addClass(cls);
        this.headerCls = cls;
        this.doLayout();
    },
    getHeaderCls: function () {
        return this.headerCls;
    },
    setBodyCls: function (cls) {
        jQuery(this._bodyEl).removeClass(this.bodyCls);
        jQuery(this._bodyEl).addClass(cls);
        this.bodyCls = cls;
        this.doLayout();
    },
    getBodyCls: function () {
        return this.bodyCls;
    },
    setToolbarCls: function (cls) {
        jQuery(this._toolbarEl).removeClass(this.toolbarCls);
        jQuery(this._toolbarEl).addClass(cls);
        this.toolbarCls = cls;
        this.doLayout();
    },
    getToolbarCls: function () {
        return this.toolbarCls;
    },
    setFooterCls: function (cls) {
        jQuery(this._footerEl).removeClass(this.footerCls);
        jQuery(this._footerEl).addClass(cls);
        this.footerCls = cls;
        this.doLayout();
    },
    getFooterCls: function () {
        return this.footerCls;
    },

    _doTitle: function () {
        var title = this.title == "" ? "&nbsp" : this.title;
        this._titleEl.innerHTML = title;

        this._iconEl.style.display = (this.iconCls || this.iconStyle) ? "inline" : "none";
        this._iconEl.className = "mini-panel-icon mini-icon mini-iconfont " + this.iconCls;

        mini.setStyle(this._iconEl, this.iconStyle);

    },
    setTitle: function (value) {
        this.title = value;
        this._doTitle();
    },
    getTitle: function () {
        return this.title;
    },
    setIconCls: function (value) {
        this.iconCls = value;
        this._doTitle();
    },
    getIconCls: function () {
        return this.iconCls;
    },
    setIconStyle: function (value) {
        this.iconStyle = value;
        this._doTitle();
    },
    getIconStyle: function () {
        return this.iconStyle;
    },

    //maxButtonCls: "",

    _doTools: function () {
        var s = "";
        for (var i = 0, l = this.buttons.length; i < l; i++) {
            var button = this.buttons[i];
            if (button.html) {
                s += button.html;
            } else {
                s += '<span id="' + i + '" class="mini-icon mini-iconfont fa ' + button.cls + ' '
                + (button.enabled ? "" : "mini-disabled") + '" style="'
                + button.style + ';' + (button.visible ? "" : "display:none;") + '"></span>';
            }
        }
        this._toolsEl.innerHTML = s;
    },
    setShowCloseButton: function (value) {
        this.showCloseButton = value;
        var button = this.getButton("close");
        if (!button) return;
        button.visible = value;
        this._doTools();
    },
    getShowCloseButton: function () {
        return this.showCloseButton;
    },
    setCloseAction: function (value) {
        this.closeAction = value;
    },
    getCloseAction: function () {
        return this.closeAction;
    },
    setShowCollapseButton: function (value) {
        this.showCollapseButton = value;
        var button = this.getButton("collapse");
        if (!button) return;
        button.visible = value;
        this._doTools();
    },
    getShowCollapseButton: function () {
        return this.showCollapseButton;
    },
    setShowHeader: function (value) {
        this.showHeader = value;
        this.showHeader ? this.addCls("mini-panel-showheader") : this.removeCls("mini-panel-showheader");
        this._doVisibleEls();
        this.deferLayout();
    },
    getShowHeader: function () {
        return this.showHeader;
    },
    setShowToolbar: function (value) {
        this.showToolbar = value;
        this._doVisibleEls();
        this.deferLayout();
    },
    getShowToolbar: function () {
        return this.showToolbar;
    },
    setShowFooter: function (value) {
        this.showFooter = value;
        this._doVisibleEls();
        this.deferLayout();
    },
    getShowFooter: function () {
        return this.showFooter;
    },
    ////////////////////////////////////////
    __OnClick: function (e) {

        if (mini.isAncestor(this._headerEl, e.target)) {
            var toolsEl = mini.findParent(e.target, 'mini-tools');
            if (toolsEl) {
                var button = this.getButton(parseInt(e.target.id));
                if (button) {
                    this._OnButtonClick(button, e);
                }
            } else {
                if (this.collapseOnTitleClick) {
                    this.toggle();
                }
            }
        }
    },
    _OnButtonClick: function (button, htmlEvent) {
        var e = {
            button: button,
            index: this.buttons.indexOf(button),
            name: button.name.toLowerCase(),
            htmlEvent: htmlEvent,
            cancel: false
        };
        this.fire("beforebuttonclick", e);

        var ret = true;
        try {
            if (e.name == "close" && this.closeAction == "destroy" && this._iframeEl && this._iframeEl.contentWindow) {

                if (this._iframeEl.contentWindow.CloseWindow) {
                    ret = this._iframeEl.contentWindow.CloseWindow("close");
                } else if (this._iframeEl.contentWindow.CloseOwnerWindow) {
                    ret = this._iframeEl.contentWindow.CloseOwnerWindow("close");
                } else {
                    //如果以上两行无法进入,说明弹出页面是跨域,自己调用
                    ret = this._CloseOwnerWindow("close");
                }

            }
        } catch (ex) {
            //如果有报错，也是跨域
            ret = this._CloseOwnerWindow("close");

        }
        if (ret === false) {
            e.cancel = true;
        }

        if (e.cancel == true) return e;

        this.fire("buttonclick", e);

        if (e.name == "close") {
            if (this.closeAction == "destroy") {
                this.__HideAction = "close";
                this.destroy();
            } else {
                this.hide();
            }
        }
        if (e.name == "collapse") {
            this.toggle();
            if (this.refreshOnExpand && this.expanded && this.url) {
                this.reload();
            }
        }
        return e;
    },
    onButtonClick: function (fn, scope) {
        this.on("buttonclick", fn, scope);
    },

    /*
    buttons: close, max, min, restore, collapse, expand
    */
    _initButtons: function () {
        this.buttons = [];

        var collapse = this.createButton({ name: "collapse", cls: "mini-tools-collapse", visible: this.showCollapseButton });
        this.buttons.push(collapse);

        var close = this.createButton({ name: "close", cls: "mini-tools-close", visible: this.showCloseButton });
        this.buttons.push(close);
    },
    createButton: function (options) {
        var button = mini.copyTo({
            name: "",
            cls: "",
            style: "",
            visible: true,
            enabled: true,
            html: ""
        }, options);
        return button;
    },
    setButtons: function (value) {
        if (typeof value == "string") {
            value = value.split(" ");
        }
        if (!mini.isArray(value)) value = [];
        var btns = [];
        for (var i = 0, l = value.length; i < l; i++) {
            var btn = value[i];
            if (typeof btn == "string") {
                btn = btn.trim();
                if (!btn) continue;
                btn = { name: btn, cls: 'mini-tools-' + btn, html: '' };
            }
            btn = this.createButton(btn);
            btns.push(btn);
        }
        this.buttons = btns;
        this._doTools();
    },
    getButtons: function () {
        return this.buttons;
    },
    addButton: function (button, index) {
        if (typeof button == "string") {
            button = { iconCls: button };
        }
        button = this.createButton(button);
        if (typeof index != "number") index = this.buttons.length;
        this.buttons.insert(index, button);
        this._doTools();
    },
    updateButton: function (index, options) {
        var button = this.getButton(index);
        if (!button) return;
        mini.copyTo(button, options);
        this._doTools();
    },
    removeButton: function (index) {
        var button = this.getButton(index);
        if (!button) return;
        this.buttons.remove(button);
        this._doTools();
    },
    getButton: function (index) {
        if (typeof index == "number") {
            return this.buttons[index];
        } else {
            for (var i = 0, l = this.buttons.length; i < l; i++) {
                var button = this.buttons[i];
                if (button.name == index) return button;
            }
        }
    },
    setBody: function (value) {
        __mini_setControls(value, this._bodyEl, this);
    },
    set_bodyParent: function (value) {

    },
    setToolbar: function (value) {
        __mini_setControls(value, this._toolbarEl, this);
    },
    setFooter: function (value) {
        __mini_setControls(value, this._footerEl, this);
    },
    getHeaderEl: function () {
        return this._headerEl;
    },
    getToolbarEl: function () {
        return this._toolbarEl;
    },
    getBodyEl: function () {
        return this._bodyEl;
    },
    getFooterEl: function () {
        return this._footerEl;
    },
    getIFrameEl: function (index) {
        return this._iframeEl;
    },

    clearTimeStamp: false,
    setClearTimeStamp: function (value) {
        this.clearTimeStamp = value;
    },
    getClearTimeStamp: function () {
        return this.clearTimeStamp;
    },

    ///////////////////////////////////////////////
    _getMaskWrapEl: function () {
        return this._bodyEl;
    },
    _doRemoveIFrame: function (removeAll) {

        if (this._iframeEl) {
            var iframe = this._iframeEl;
            //setTimeout(function () {

            if (iframe._ondestroy) iframe._ondestroy();

            iframe.onload = function () { };
            jQuery(iframe).unbind("load");
            iframe.src = "";

            if (mini.isIE) {
                try {
                    iframe.contentWindow.document.write("");
                    iframe.contentWindow.document.close();
                } catch (ex) { }
            }

            //}, 1);
            try {
                this._iframeEl.parentNode.removeChild(this._iframeEl);
                this._iframeEl.removeNode(true);
            } catch (ex) { }
        }
        this._iframeEl = null;
        //        try {
        //            CollectGarbage();
        //        } catch (e) { }

        //删除bodyEl内所有元素
        if (removeAll === true) {
            mini.removeChilds(this._bodyEl);
        }
    },
    _deferLoadingTime: 80,
    _doLoad: function () {

        if (!this.url) return;
        //if (this.isDisplay() == false) return;
        this._doRemoveIFrame(true);

        var st = new Date();
        var sf = this;
        this.loadedUrl = this.url;
        if (this.maskOnLoad) this.loading();

        jQuery(this._bodyEl).css("overflow", "hidden");

        function CloseOwnerWindow(action) {

            sf.__HideAction = action;

            //__onDestroy
            var ret = true;
            try {
                if (sf.__onDestroy) ret = sf.__onDestroy(action);
            } catch (ex) { 
                console.error(ex);
            }
            if (ret === false) {
                return false;
            }

            var e = {
                iframe: sf._iframeEl,
                action: action
            };

            sf.fire("unload", e);

            setTimeout(function () {
                sf.destroy();
            }, 10);

        }
        sf._CloseOwnerWindow = CloseOwnerWindow;

        var iframe = mini.createIFrame(this.url,
            function (_iframe, firstLoad) {
                if (sf.destroyed) return;

                var t = (st - new Date()) + sf._deferLoadingTime;

                if (t < 0) t = 0;
                setTimeout(function () {
                    sf.unmask();
                }, t);

                //window.close
                try {


                    sf._iframeEl.contentWindow.Owner = sf.Owner;
                    sf._iframeEl.contentWindow.CloseOwnerWindow = CloseOwnerWindow;
                } catch (e) { }

                //firstLoad
                //alert(1);
                if (firstLoad || sf.loadOnRefresh) {
                    if (sf.__onLoad) sf.__onLoad();

                    var e = {
                        iframe: sf._iframeEl
                    };

                    //mini.repaint(sf.el);
                    sf.fire("load", e);
                }
            },
            this.clearTimeStamp
        );
        this._bodyEl.appendChild(iframe);
        this._iframeEl = iframe;

    },

    load: function (url, onload, ondestroy) {
        this.setUrl(url, onload, ondestroy);
    },
    reload: function () {
        this.setUrl(this.url);
    },
    setUrl: function (value, onload, ondestroy) {
        this.url = value;
        this.__onLoad = onload;
        this.__onDestroy = ondestroy;
        if (this.expanded && value) {
            this._doLoad();
        }
    },
    getUrl: function () {
        return this.url;
    },
    setRefreshOnExpand: function (value) {
        this.refreshOnExpand = value;
    },
    getRefreshOnExpand: function () {
        return this.refreshOnExpand;
    },
    setMaskOnLoad: function (value) {
        this.maskOnLoad = value;
    },
    getMaskOnLoad: function (value) {
        return this.maskOnLoad;
    },
    setAllowResize: function (value) {
        if (this.allowResize != value) {
            this.allowResize = value;
            this.doLayout();
        }
    },
    getAllowResize: function () {
        return this.allowResize;
    },
    setLoadOnRefresh: function (value) {
        this.loadOnRefresh = value;
    },
    getLoadOnRefresh: function (value) {
        return this.loadOnRefresh;
    },

    /////////////////////////////////////////
    expanded: true,
    setExpanded: function (value) {
        if (this.expanded != value) {
            this.expanded = value;
            if (this.expanded) {
                this.expand();
            } else {
                this.collapse();
            }
        }
    },
    getExpanded: function () {
        return this.expanded;
    },
    toggle: function () {
        if (this.expanded) {
            this.collapse();
        } else {
            this.expand();
        }
    },
    collapse: function () {
        this.expanded = false;

        if (this.state != "max") {

            this._height = this.el.style.height;
        }
        this.el.style.height = "auto";
        this._viewportEl.style.display = "none";

        mini.addClass(this.el, "mini-panel-collapse");
        this.doLayout();
    },

    expand: function () {
        this.expanded = true;

        if (this._height) {
            this.el.style.height = this._height;
        }
        this._viewportEl.style.display = "block";

        if (this.state != "max") {
            delete this._height;
        }

        mini.removeClass(this.el, "mini-panel-collapse");

        //
        this._expandLoad();

        this.doLayout();
    },

    _expandLoad: function () {
        if (this.url && this.url != this.loadedUrl) {
            this._doLoad();
        }
    },

    //    setVisible: function (value) {
    //        mini.Panel.superclass.setVisible.call(this, value);
    //        if (value) {
    //            if (this.url && this.url != this.loadedUrl) {
    //                this._doLoad();
    //            }
    //        }
    //    },
    setCollapseOnTitleClick: function (value) {
        this.collapseOnTitleClick = value;
        mini.removeClass(this.el, 'mini-panel-titleclick');
        if (value) mini.addClass(this.el, 'mini-panel-titleclick');
    },
    getCollapseOnTitleClick: function () {
        return this.collapseOnTitleClick;
    },
    ///////////////////////////////////////////////
    getAttrs: function (el) {
        var attrs = mini.Panel.superclass.getAttrs.call(this, el);

        mini._ParseString(el, attrs,
            ["title", "iconCls", "iconStyle", "headerCls", "headerStyle", "bodyCls", "bodyStyle",
            "footerCls", "footerStyle", "toolbarCls", "toolbarStyle", "footer", "toolbar",
            "url", "closeAction", "loadingMsg",
            "onbeforebuttonclick", "onbuttonclick", "onload", "buttons"
             ]
        );
        mini._ParseBool(el, attrs,
            ["allowResize", "showCloseButton", "showHeader", "showToolbar", "showFooter", "loadOnRefresh",
            "showCollapseButton", "refreshOnExpand", "maskOnLoad", "expanded", "collapseOnTitleClick", "clearTimeStamp"
             ]
        );

        var cs = mini.getChildNodes(el, true);
        for (var i = cs.length - 1; i >= 0; i--) {
            var node = cs[i];
            //var property = jQuery(node).attr("property");
            var property = mini.getAttr(node, "property");
            if (!property) continue;
            property = property.toLowerCase();
            if (property == "toolbar") {
                attrs.toolbar = node;
            } else if (property == "footer") {
                attrs.footer = node;
            }
        }
        attrs.body = cs;

        return attrs;
    }


});
mini.regClass(mini.Panel, "panel");


//mini._PanelResizer = function (panel) {
//    this.owner = panel;
//    mini.on(panel.el, "mousedown", this.__OnMouseDown, this);
//}
//mini._PanelResizer.prototype = {
//    __OnMouseDown: function (e) {
//        var panel = this.owner;
//        
//        if (mini.isAncestor(panel._resizeGridEl, e.target) && panel.allowResize) {
//            var drag = this._getResizeDrag();
//            drag.start(e);
//        }
//    },
//    _getResizeDrag: function () {
//        if (!this._resizeDragger) {
//            this._resizeDragger = new mini.Drag({
//                capture: true,
//                onStart: mini.createDelegate(this._OnDragStart, this),
//                onMove: mini.createDelegate(this._OnDragMove, this),
//                onStop: mini.createDelegate(this._OnDragStop, this)
//            });
//        }
//        return this._resizeDragger;
//    },
//    _OnDragStart: function (drag) {

//        this.proxy = mini.append(document.body, '<div class="mini-resizer-proxy"></div>');
//        this.proxy.style.cursor = "se-resize";

//        this.elBox = mini.getBox(this.el);
//        mini.setBox(this.proxy, this.elBox);
//    },
//    _OnDragMove: function (drag) {
//        var xOffset = drag.now[0] - drag.init[0];
//        var yOffset = drag.now[1] - drag.init[1];

//        var w = this.elBox.width + xOffset;
//        var h = this.elBox.height + yOffset;
//        if (w < this.minWidth) w = this.minWidth;
//        if (h < this.minHeight) h = this.minHeight;
//        if (w > this.maxWidth) w = this.maxWidth;
//        if (h > this.maxHeight) h = this.maxHeight;

//        mini.setSize(this.proxy, w, h);
//    },
//    _OnDragStop: function (drag) {
//        var box = mini.getBox(this.proxy);

//        jQuery(this.proxy).remove();
//        this.proxy = null;
//        this.elBox = null;

//        this.setWidth(box.width);
//        this.setHeight(box.height);

//        delete this._width;
//        delete this._height;

//        //mini.repaint(this.el);
//    }
//}

mini.Window = function () {
    
    mini.Window.superclass.constructor.apply(this, arguments);

    this.addCls("mini-window");
    
    this.setVisible(false);
    this.setAllowDrag(this.allowDrag);
    this.setAllowResize(this.allowResize);
}

mini.extend(mini.Window, mini.Panel, {
    x: 0,
    y: 0,
    state: "restore", //restore, max

    _dragCls: "mini-window-drag",
    _resizeCls: "mini-window-resize",
    allowDrag: true,
    //allowResize: false,
    showCloseButton: true,
    showMaxButton: false,
    showMinButton: false,
    showCollapseButton: false,

    showModal: true,

    minWidth: 150,
    minHeight: 80,
    maxWidth: 2000,
    maxHeight: 2000,
    showInBody: true,
    
    xOffset: 0,
    yOffset: 0,
    showRefreshButton: false,
    maskOnLoad: false,
    lockScroll: true,

    uiCls: "mini-window",

    _create: function () {
        mini.Window.superclass._create.call(this);

        this.el.className += ' mini-corner-all';
        this.el.firstChild.className += ' mini-corner-all';

        if (mini.isIE && mini_useShims) {
            var iframe = "<iframe frameborder='0' style='position: absolute; z-index: -1; width: 100%; height: 100%; top: 0;left:0;scrolling:no;'></iframe>";
            mini.append(this.el, iframe);
        }
    },
    _initButtons: function() {
        this.buttons = [];

        var collapse = this.createButton({
            name: 'collapse',
            cls: 'mini-tools-collapse',
            visible: this.showCollapseButton
        });
        this.buttons.push(collapse);

        var min = this.createButton({
            name: 'min',
            cls: 'mini-tools-min',
            visible: this.showMinButton
        });
        this.buttons.push(min);

        var max = this.createButton({
            name: 'max',
            cls: 'mini-tools-max',
            visible: this.showMaxButton
        });
        this.buttons.push(max);
        // 添加刷新按钮
        var refresh = this.createButton({
            name: 'refresh',
            cls: 'mini-tools-refresh',
            visible: this.showRefreshButton
        });
        this.buttons.push(refresh);
        var close = this.createButton({
            name: 'close',
            cls: 'mini-tools-close',
            visible: this.showCloseButton
        });
        this.buttons.push(close);
    },
    _initEvents: function () {
        mini.Window.superclass._initEvents.call(this);

        mini._BindEvents(function () {
            //mini.on(document, "mousedown", this.__OnBodyMouseDown, this);
            mini.on(this.el, "mouseover", this.__OnMouseOver, this);
            mini.on(window, "resize", this.__OnWindowResize, this);

            mini.on(this.el, "mousedown", this.__OnWindowMouseDown, this);
        }, this);


    },
    doLayout: function () {
        if (!this.canLayout()) return;

        if (this.state == 'max') {
            var vbox = this.getParentBox();
            this.el.style.left = '10px';
            this.el.style.top = '10px';
            mini.setSize(this.el, vbox.width - 20, vbox.height - 20);
        }

        mini.Window.superclass.doLayout.call(this);

        if (this.allowDrag) {
            mini.addClass(this.el, this._dragCls);
        }
        if (this.state == 'max') {
            this._resizeGridEl.style.display = 'none';
            mini.removeClass(this.el, this._dragCls);
        }
        this._doModal();
    },
    _doModal: function () {

        if (!this.el) {

            if (this._modalEl) mini.removeNode(this._modalEl);
            return;
        }
        var show = this.showModal && this.isDisplay() && this.visible;
        if (!this._modalEl && this.showModal == false) {

            if (this._modalEl) mini.removeNode(this._modalEl);
            return;
        }
        //if (this.showModal && this.visible) show = true;
        //this.el.style.display = "none";
        if (!this._modalEl) {
            var id = '__modal' + this._id;

            var iframe = mini_useShims ? "<iframe frameborder='0' style='position: absolute; z-index: -1; width: 100%; height: 100%; top: 0;left:0;scrolling:no;'></iframe>" : "";
            this._modalEl = mini.append(document.body, '<div id="' + id + '" class="mini-modal mini-widget-content" style="display:none">' + iframe + '</div>');
        }
        if (show) {
            this._modalEl.style.display = "block";
            this._modalEl.style.zIndex = this._zIndex - 1;
        } else {
            this._modalEl.style.display = "none";
        }
    },
    getParentBox: function () {
        var vbox = mini.getViewportBox();
        var containerEl = this._containerEl || document.body;
        if (containerEl != document.body) {
            vbox = mini.getBox(containerEl);
        }
        return vbox;
    },
    ////////////////////////////////////////////////////////
    setShowModal: function (value) {

        this.showModal = value;
    },
    getShowModal: function () {
        return this.showModal;
    },
    setMinWidth: function (value) {
        if (isNaN(value)) return;
        this.minWidth = value;
    },
    getMinWidth: function () {
        return this.minWidth;
    },
    setMinHeight: function (value) {
        if (isNaN(value)) return;
        this.minHeight = value;
    },
    getMinHeight: function () {
        return this.minHeight;
    },
    setMaxWidth: function (value) {
        if (isNaN(value)) return;
        this.maxWidth = value;
    },
    getMaxWidth: function () {
        return this.maxWidth;
    },
    setMaxHeight: function (value) {
        if (isNaN(value)) return;
        this.maxHeight = value;
    },
    getMaxHeight: function () {
        return this.maxHeight;
    },
    setAllowDrag: function (value) {
        this.allowDrag = value;
        mini.removeClass(this.el, this._dragCls);
        if (value) {
            mini.addClass(this.el, this._dragCls);
        }
    },
    getAllowDrag: function () {
        return this.allowDrag;
    },
    setShowMaxButton: function (value) {
        this.showMaxButton = value;
        var button = this.getButton("max");
        if (!button) return;
        button.visible = value;
        this._doTools();
    },
    getShowMaxButton: function () {
        return this.showMaxButton;
    },
    setShowMinButton: function (value) {
        this.showMinButton = value;
        var button = this.getButton("min");
        if (!button) return;
        button.visible = value;
        this._doTools();
    },
    getShowMinButton: function () {
        return this.showMinButton;
    },
    ///////////////////////////////////////////////////
    max: function () {
        this.state = "max";

        //        this.el.style.left = "-10000px";
        //        this.el.style.top = "-10000px";

        this.addCls("mini-window-max");

        this.show();

        var button = this.getButton("max");
        if (button) {
            button.cls = "mini-tools-restore";
            this._doTools();
        }
    },
    refresh: function() {
        this.reload();
        return this;
    },
    restore: function () {

        this.state = 'restore';
        this.show(this.x, this.y);

        var button = this.getButton('max');
        if (button) {
            button.cls = 'mini-tools-max';
            this._doTools();
        }

        this.fire('restore');

    },
    /**
     *
     * function setShowRefreshButton(showRefreshButton)
     * @member mini.Window
     * @param {Boolean} showRefreshButton
     *
     */
    setShowRefreshButton: function(showRefreshButton) {
        this.showRefreshButton = showRefreshButton;
        var btn = this.getButton('refresh');
        if (!btn) {
            return;
        }
        btn.visible = showRefreshButton;
        this._doTools();
    },
    /**
     *
     * function getShowRefreshButton()
     * @member mini.Window
     * @returns {Boolean}
     *
     */
    getShowRefreshButton: function() {
        return this.showRefreshButton;
    },

    setShowInBody: function (value) {
        this.showInBody = value;
    },
    getShowInBody: function () {
        return this.showInBody;
    },
    containerEl: null,
    showAtPos: function (x, y, options) {
        this.show(x, y, options);
    },
    show: function (x, y, options) {
        this._allowLayout = false;

        var containerEl = this._containerEl || document.body;
        if (!this.isRender() || (this.el.parentNode != containerEl && this.showInBody)) {
            this.render(containerEl);
        }
        
        this.el.style.zIndex = this._zIndex = mini.getMaxZIndex();

        this._doShow(x, y);

        this._allowLayout = true;
        this.setVisible(true);

        if (this.state != "max") {
            var box = this.getBox();
            this.x = box.x;
            this.y = box.y;
        }


        //mini.repaint(this.el);

        //this.focus();
        try {
            //this.el.focus();
            document.body.focus();
        } catch (e) { }
    },
    //    focus: function () {
    //        debugger
    //    },
    hide: function () {
        this.fire('close');
        this.setVisible(false);
        this._doModal();
    },
    getWidth: function (content) {
        this._headerEl.style.width = "50px";
        var width = mini.getWidth(this.el);
        this._headerEl.style.width = "auto";

        if (content && this._borderEl) {
            var b2 = mini.getBorders(this._borderEl);
            width = width - b2.left - b2.right;
        }

        return width;
    },
    getBox: function () {
        this._headerEl.style.width = "50px";
        this.el.style.display = "";
        var width = mini.getWidth(this.el);
        this._headerEl.style.width = "auto";
        var box = mini.getBox(this.el);
        box.width = width;
        box.right = box.x + width;
        return box;
    },
    _measureSize: function () {
        this.el.style.display = "";
        var box = this.getBox();
        //min, max
        if (box.width > this.maxWidth) {
            mini.setWidth(this.el, this.maxWidth);
            box = this.getBox();
        }
        if (this.expanded) {
            if (box.height > this.maxHeight) {
                mini.setHeight(this.el, this.maxHeight);
                box = this.getBox();
            }
        }
        if (box.width < this.minWidth) {
            mini.setWidth(this.el, this.minWidth);
            box = this.getBox();
        }

        if (this.expanded) {
            if (box.height < this.minHeight) {
                mini.setHeight(this.el, this.minHeight);
                box = this.getBox();
            }
        }
    },
    _doShow: function (x, y) {
        var vbox = this.getParentBox();
        var box;

        if (this.state == 'max') {

            if (!this._width) {
                box = this.getBox();

                this._width = box.width;

                if (this.expanded) {
                    this._height = box.height;
                }
                this.x = box.x;
                this.y = box.y;
            }

            this.el.style.left = '-10000px';
            this.el.style.top = '-10000px';
        } else {
            if (mini.isNull(x)) x = 'center';
            if (mini.isNull(y)) y = 'middle';

            this.el.style.position = 'absolute';
            this.el.style.left = '-2000px';
            this.el.style.top = '-2000px';
            this.el.style.display = '';

            if (this._width) {
                this.setWidth(this._width);
                this.setHeight(this._height);
                delete this._width;
                delete this._height;
            }
            this._measureSize();

            box = this.getBox();

            //x, y的获取        
            if (x == 'left') x = 0;
            if (x == 'center') x = vbox.width / 2 - box.width / 2;
            if (x == 'right') x = vbox.width - box.width;

            // 修改@2020-09-09 通过offset设置位置，不需要加上滚动偏移了
            if (y == 'top') y = 0;
            if (y == 'middle') y = vbox.height / 2 - box.height / 2;
            if (y == 'bottom') y = vbox.height - box.height;

            if (x + box.width > vbox.right) x = vbox.right - box.width;
            if (y + box.height > vbox.bottom) y = vbox.bottom - box.height;
            if (x < 0) x = 0;
            if (y < 0) y = 0;

            this.el.style.display = '';
            //document.title = x+":"+y;
            // mini.setX(this.el, x);
            // mini.setY(this.el, y);
            // body 已设置成fixed，并且偏移也是基于可视窗口的，不能用offset来设置了
            if ($.isNumeric(this.xOffset)) {
                x += this.xOffset;
            }
            if ($.isNumeric(this.yOffset)) {
                y += this.yOffset;
            }
            this.el.style.left = x + 'px';
            this.el.style.top = y + 'px';
        }
        this.doLayout();
    },
    _OnButtonClick: function(button, htmlEvent) {
        var e = mini.Window.superclass._OnButtonClick.call(this, button, htmlEvent);
        if (e.cancel == true) {
            return e;
        }

        if (e.name == 'max') {
            if (this.state == 'max') {
                this.restore();
            } else {
                this.max();
            }
        } else if (e.name == 'refresh') {
            this.refresh();
        }
        return e;
    },
    __OnWindowResize: function (e) {
        if (this.state == "max") {
            this.doLayout();


        }
        if (!mini.isIE6) {
            this._doModal();
        }
    },
    enableDragProxy: true,
    setEnableDragProxy: function (value) {
        this.enableDragProxy = value;
    },
    getEnableDragProxy: function (value) {
        return this.enableDragProxy;
    },

    allowCrossBottom: true,
    setAllowCrossBottom: function (value) {
        this.allowCrossBottom = value
    },
    getAllowCrossBottom: function () {
        return this.allowCrossBottom;
    },

    __OnWindowMouseDown: function (e) {

        var sf = this;

        //drag
        //if (e.button != mini.MouseButton.Left) return;

        if (this.state != "max" && this.allowDrag && mini.isAncestor(this._headerEl, e.target) && !mini.findParent(e.target, "mini-tools")) {
            var sf = this;
            //this.focus();
            if (this.el) {
                this.el.style.zIndex = this._zIndex =  mini.getMaxZIndex();
            }
            var box = this.getBox();
            var drag = new mini.Drag({
                capture: false,
                onStart: function () {
                    sf._maskProxy = mini.append(document.body, '<div class="mini-resizer-mask" style=""></div>');

                    if (sf.enableDragProxy) {
                        sf._dragProxy = mini.append(document.body, '<div class="mini-drag-proxy"></div>');
                        //sf.el.style.display = "none";

                        sf.el.style.left = "-2000px";
                        sf.el.style.top = "-2000px";

                        //                        var iframe = "<iframe frameborder='0' style='position: absolute; z-index: -1; width: 0; height: 0; top: 0;left:0;scrolling:no;'></iframe>";
                        //                        mini.append(sf._dragProxy, iframe);

                    } else {
                        sf._dragProxy = sf.el;
                    }
                    //sf.el.style.cursor = "move";

                    var mask = mini.append(document.body, '<div class="mini-resizer-mask"></div>');
                    setTimeout(function () {
                        mini.removeNode(mask);
                    }, 300);

                },
                onMove: function (drag) {
                    //document.title = "move" + new Date().getTime();
                    var x = drag.now[0] - drag.init[0], y = drag.now[1] - drag.init[1];

                    x = box.x + x;
                    y = box.y + y;
                    //限制在浏览器范围内
                    var vbox = sf.getParentBox();

                    var right = x + box.width;
                    var bottom = y + box.height;
                    if (right > vbox.width) x = vbox.width - box.width;
                    //if (bottom > vbox.bottom) y = vbox.bottom - box.height;

                    if (!sf.allowCrossBottom) {
                        if (bottom > vbox.height) y = vbox.height - box.height;
                    }


                    if (x < 0) x = 0;
                    if (y < 0) y = 0;

                    //mini.setXY(sf.el, x, y);
                    //                    if (sf.shadowEl) {
                    //                        mini.setXY(sf.shadowEl, x, y);
                    //                    }
                    sf.x = x;
                    sf.y = y;

                    //_dragProxy
                    var dbox = { x: x, y: y, width: box.width, height: box.height };

                    mini.setBox(sf._dragProxy, dbox);

                    this.moved = true;
                },
                onStop: function () {

                    if (sf.el) {
                        sf.el.style.display = "block";
                        //if (!sf._dragProxy) return;
                        if (this.moved) {
                            var box = mini.getBox(sf._dragProxy);
                            //if(box.width < 10) debugger
                            //debugger
                            mini.setBox(sf.el, box);
                        }
                    }

                    jQuery(sf._maskProxy).remove();
                    sf._maskProxy = null;

                    if (sf.enableDragProxy) {
                        jQuery(sf._dragProxy).remove();
                    }
                    sf._dragProxy = null;

                    sf.fire("moveend");
                }
            });
            drag.start(e);


        }
    },
    destroy: function (removeEl) {
        //this._doModal();
        //mini.un(document, "mousedown", this.__OnBodyMouseDown, this);
        mini.un(window, "resize", this.__OnWindowResize, this);


        if (this._modalEl) {
            jQuery(this._modalEl).remove();
            this._modalEl = null;
        }
        if (this.shadowEl) {
            jQuery(this.shadowEl).remove();
            this.shadowEl = null;
        }

        var id = '__modal' + this._id;
        jQuery("[id='" + id + "']").remove();

        mini.Window.superclass.destroy.call(this, removeEl);
    },
    
    getAttrs: function (el) {
        var attrs = mini.Window.superclass.getAttrs.call(this, el);

        mini._ParseString(el, attrs,
            ["modalStyle", "onmoveend" ,'onrestore', 'onclose'
                ]
        );
        mini._ParseBool(el, attrs,
            ["showModal", "showShadow", "allowDrag", "allowResize",
            "showMaxButton", "showMinButton", "showInBody", "enableDragProxy", "allowCrossBottom", 'showRefreshButton', 'lockScroll'
                ]
        );
        mini._ParseInt(el, attrs,
            ["minWidth", "minHeight", "maxWidth", "maxHeight",
                'xOffset', 'yOffset'
                ]
        );

        return attrs;
    },
    ////////////////////////////////////////////
    showAtEl: function (atEl, options) {
        atEl = mini.byId(atEl);
        if (!atEl) return;
        if (!this.isRender() || this.el.parentNode != document.body) {
            this.render(document.body);
        }

        var c = {
            xAlign: this.xAlign,
            yAlign: this.yAlign,
            xOffset: 0,
            yOffset: 0,
            popupCls: this.popupCls
        };
        mini.copyTo(c, options);

        //        mini.addClass(atEl, c.popupCls);
        //        atEl.popupCls = c.popupCls;
        this._popupEl = atEl;

        this.el.style.position = "absolute";
        this.el.style.left = "-2000px";
        this.el.style.top = "-2000px";
        this.el.style.display = "";

        this.doLayout();
        this._measureSize();

        var vbox = mini.getViewportBox();
        var box = this.getBox();
        var pbox = mini.getBox(atEl);
        var xy = c.xy;
        var h = c.xAlign, v = c.yAlign;

        var x = vbox.width / 2 - box.width / 2, y = 0;
        if (xy) {
            x = xy[0];
            y = xy[1];
        }

        switch (c.xAlign) {
            case "outleft":
                x = pbox.x - box.width;
                break;
            case "left":
                x = pbox.x;
                break;
            case "center":
                x = pbox.x + pbox.width / 2 - box.width / 2;
                break;
            case "right":
                x = pbox.right - box.width;
                break;
            case "outright":
                x = pbox.right;
                break;
            default:

                break;
        }

        switch (c.yAlign) {
            case "above":
                y = pbox.y - box.height;
                break;
            case "top":
                y = pbox.y;
                break;
            case "middle":
                y = pbox.y + pbox.height / 2 - box.height / 2;
                break;
            case "bottom":
                y = pbox.bottom - box.height;
                break;
            case "below":
                y = pbox.bottom;
                break;
            default:

                break;
        }
        x = parseInt(x);
        y = parseInt(y);


        if (c.outYAlign || c.outXAlign) {
            if (c.outYAlign == "above") {
                if (y + box.height > vbox.bottom) {
                    var top = pbox.y - vbox.y;
                    var bottom = vbox.bottom - pbox.bottom;
                    if (top > bottom) {
                        y = pbox.y - box.height;
                    }
                }

            }
            if (c.outXAlign == "outleft") {
                if (x + box.width > vbox.right) {
                    var left = pbox.x - vbox.x;
                    var right = vbox.right - pbox.right;
                    if (left > right) {
                        x = pbox.x - box.width;
                    }
                }
            }
            if (c.outXAlign == "right") {
                if (x + box.width > vbox.right) {
                    x = pbox.right - box.width;
                    //                    var right = vbox.right - pbox.right;
                    //                    if (left > right) {
                    //                        x = pbox.x - box.width;
                    //                    }
                }
            }
            this._Show(x, y);
        } else {
            this.showAtPos(x + c.xOffset, y + c.yOffset);
        }
    }
});

mini.regClass(mini.Window, "window");


/* MessageBox
-----------------------------------------------------------------------------*/

//mini.on(document, "keydown", function (e) {
//    // debugger
//    if (e.keyCode == 27) {
//        alert("enter");
//        //        if (callback) callback("close");
//        //        e.cancel = true;

//        //        if (control && control._Buttons) {
//        //            mini.MessageBox.hide(control);
//        //        }
//    }
//});

mini.MessageBox = jQuery.extend(true, {}, epoint_local.MessageBox, {
    //    INFO: 'mini-messagebox-info',
    //    WARNING: 'mini-messagebox-warning',
    //    QUESTION: 'mini-messagebox-question',
    //    ERROR: 'mini-messagebox-error',
    //    WAITING: 'mini-messagebox-waiting',
    autoFocus: true,

    show: function (options) {

        options = mini.copyTo({
            width: "auto",
            height: "auto",
            showModal: true,

            timeout: 0,

            minWidth: 150,
            maxWidth: 800,
            minHeight: 50,
            maxHeight: 350,

            showHeader: true,
            title: "",
            titleIcon: "",
            iconCls: "",
            iconStyle: "",
            message: "",
            html: "",

            spaceStyle: "margin-right:15px",

            showCloseButton: true,
            buttons: null,
            buttonWidth: 58,
            callback: null
        }, options);

        options.message = String(options.message);

        var callback = options.callback;

        var control = new mini.Window();

        control.addCls("mini-messagebox");

        control.setBodyStyle("overflow:hidden");
        control.setShowModal(options.showModal);
        control.setTitle(options.title || "");
        control.setIconCls(options.titleIcon);
        control.setShowHeader(options.showHeader);

        control.setShowCloseButton(options.showCloseButton);

        var id1 = control.uid + "$table", id2 = control.uid + "$content";

        var icon = '<div class="' + options.iconCls + '" style="' + options.iconStyle + '"></div>';
        var s = '<table class="mini-messagebox-table" id="' + id1 + '" style="" cellspacing="0" cellpadding="0"><tr><td>'
                + icon + '</td><td id="' + id2 + '" class="mini-messagebox-content-text">'
                + (options.message || "") + '</td></tr></table>';

        //var s = "";
        //control.setShowHeader(false);

        var ws = '<div class="mini-messagebox-content"></div>'
             + '<div class="mini-messagebox-buttons"></div>';
        control._bodyEl.innerHTML = ws;
        var contentEl = control._bodyEl.firstChild;
        if (options.html) {
            if (typeof options.html == "string") {
                contentEl.innerHTML = options.html;
            } else if (mini.isElement(options.html)) {
                contentEl.appendChild(options.html);
            }
        } else {
            contentEl.innerHTML = s;
        }

        control._Buttons = [];

        var buttonsEl = control._bodyEl.lastChild;
        if (options.buttons && options.buttons.length > 0) {
            for (var i = 0, l = options.buttons.length; i < l; i++) {
                var button = options.buttons[i];
                var text = mini.MessageBox.buttonText[button];
                if (!text) text = button;

                var btn = new mini.Button();
                btn.setText(text);
                btn.setWidth(options.buttonWidth);
                btn.render(buttonsEl);
                btn.action = button;
                btn.on("click", function (e) {
                    var button = e.sender;
                    if (callback) if (callback(button.action) === false) return;
                    mini.MessageBox.hide(control);
                });

                if (i != l - 1) {
                    btn.setStyle(options.spaceStyle);
                }

                control._Buttons.push(btn);
            }
        } else {
            buttonsEl.style.display = "none";
        }

        control.setMinWidth(options.minWidth);
        control.setMinHeight(options.minHeight);
        control.setMaxWidth(options.maxWidth);
        control.setMaxHeight(options.maxHeight);
        control.setWidth(options.width);
        control.setHeight(options.height);
        control.show(options.x, options.y, { animType: options.animType });




        var width = control.getWidth();
        control.setWidth(width);
        var height = control.getHeight();
        control.setHeight(height);

        var tb = document.getElementById(id1);
        if (tb) {
            tb.style.width = "100%";
        }
        var td = document.getElementById(id2);
        if (td) {
            td.style.width = "100%";
        }
        //}

        if (mini.MessageBox.autoFocus) {
            var firstButton = control._Buttons[0];
            if (firstButton) {
                //alert(1);
                firstButton.focus();
            } else {
                //alert(2);
                control.focus();
            }
        }

        control.on("beforebuttonclick", function (e) {
            if (callback) callback("close");
            e.cancel = true;
            mini.MessageBox.hide(control);
        });

        mini.on(control.el, "keydown", function (e) {
            if (e.keyCode == 27) {
                if (callback) callback("close");
                mini.MessageBox.hide(control);
            }
        });

        //

        if (options.timeout) {
            setTimeout(function () {
                mini.MessageBox.hide(control.uid);
            }, options.timeout);
        }

        return control.uid;
    },
    hide: function (id) {
        if (!id) return;
        var control = typeof id == "object" ? id : mini.getbyUID(id);
        if (!control) return;

        //destroy buttons
        for (var i = 0, l = control._Buttons.length; i < l; i++) {
            var button = control._Buttons[i];
            button.destroy();
        }
        control._Buttons = null;

        control.destroy();
    },
    alert: function (message, title, callback) {
        return mini.MessageBox.show({
            minWidth: 250,
            title: title || mini.MessageBox.alertTitle,
            buttons: ["ok"],
            message: message,
            iconCls: "mini-messagebox-warning",
            callback: callback
        });
    },
    confirm: function (message, title, callback) {
        return mini.MessageBox.show({
            minWidth: 250,
            title: title || mini.MessageBox.confirmTitle,
            buttons: ["ok", "cancel"],
            message: message,
            iconCls: "mini-messagebox-question",
            callback: callback
        });
    },
    prompt: function (message, title, callback, multi, value) {
        var id = "prompt$" + new Date().getTime();
        var s = message || mini.MessageBox.promptMessage;



        if (multi) {
            s = s + '<br/><textarea id="' + id + '" style="width:200px;height:60px;margin-top:3px;"></textarea>';
        } else {
            s = s + '<br/><input id="' + id + '" type="text" style="width:200px;margin-top:3px;"/>';
        }
        var uid = mini.MessageBox.show({
            title: title || mini.MessageBox.promptTitle,
            buttons: ["ok", "cancel"],
            width: 250,
            html: '<div style="padding:5px;padding-left:10px;">' + s + '</div>',
            callback: function (action) {
                var input = document.getElementById(id);
                if (callback) return callback(action, input.value);
            }
        });
        var input = document.getElementById(id);
        input.focus();

        if (value == null) value = "";
        input.value = value;

        return uid;
    },
    loading: function (message, title) {
        return mini.MessageBox.show({
            minHeight: 50,
            title: title,
            showCloseButton: false,
            message: message,
            iconCls: "mini-messagebox-waiting"
        });
    },
    showTips: function (options) {
        var $ = jQuery;

        options = jQuery.extend({
            content: '',
            state: '',
            x: 'center',
            y: 'top',
            offset: [10, 10],
            fixed: true,
            timeout: 2000
        }, options);

        var cls = 'mini-tips-' + options.state;
        var html = '<div class="mini-tips ' + cls + '">' + options.content + '</div>';
        var jq = jQuery(html).appendTo(document.body);

        options.el = jq[0];
        options.timeoutHandler = function () {
            jq.slideUp();
            setTimeout(function () {
                jq.remove();
            }, 2000);
        }

        mini.showAt(options);
        jq.hide().slideDown();

    }
});
mini.alert = mini.MessageBox.alert;
mini.confirm = mini.MessageBox.confirm;
mini.prompt = mini.MessageBox.prompt;
mini.loading = mini.MessageBox.loading;
mini.showMessageBox = mini.MessageBox.show;
mini.hideMessageBox = mini.MessageBox.hide;
mini.showTips = mini.MessageBox.showTips;


mini.Tabs = function () {    
    this._initTabs();
    mini.Tabs.superclass.constructor.apply(this, arguments);
}
mini.extend(mini.Tabs, mini.Control, {
    activeIndex: -1,
    tabAlign: "left",   //left/center/right/fit
    tabPosition: "top", //top/right/bottom/left
    showBody: true,
    showHeader: true,

    nameField: "name",
    titleField: "title",
    urlField: "url",

    url: "",
    maskOnLoad: true,

    //showCloseOnHover: true,

    plain: true,
    //    tabHeaderCls: "",
    //    tabHeaderStyle: "",
    //    tabBodyCls: "",
    //    tabBodyStyle: "",

    bodyStyle: "",

    _tabHoverCls: "mini-tab-hover",
    _tabActiveCls: "mini-tab-active",

    loadingMsg: epoint_local.loadingMsg,

    set: function (obj) {
        if (typeof obj == 'string') {
            return this;
        }



        var _allowLayout = this._allowLayout;
        this._allowLayout = false;

        var activeIndex = obj.activeIndex;
        delete obj.activeIndex;

        var url = obj.url;
        delete obj.url;

        mini.Tabs.superclass.set.call(this, obj);

        if (url) {
            this.setUrl(url);
        }
        if (mini.isNumber(activeIndex)) {
            this.setActiveIndex(activeIndex);
        }

        this._allowLayout = _allowLayout;
        this.doLayout();

        return this;
    },

    uiCls: "mini-tabs",
    _create: function () {
        this.el = document.createElement("div");
        this.el.className = "mini-tabs";

        var s = '<table class="mini-tabs-table" cellspacing="0" cellpadding="0"><tr style="width:100%;">'
                    + '<td></td>'
                    + '<td style="text-align:left;vertical-align:top;width:100%;"><div class="mini-tabs-bodys"></div></td>'
                    + '<td></td>'
                + '</tr></table>';
        this.el.innerHTML = s;
        this._tableEl = this.el.firstChild;

        var tds = this.el.getElementsByTagName("td");
        this._td1El = tds[0];
        this._td2El = tds[1];
        this._td3El = tds[2];

        this._bodyEl = this._td2El.firstChild;
        this._borderEl = this._bodyEl;
        this.doUpdate();
    },
    destroy: function (removeEl) {

        if (this.tabs) {
            for (var i = 0, l = this.tabs.length; i < l; i++) {
                var tab = this.tabs[i];
                //this._doRemoveIFrame(tab, true);
                tab._iframeEl = null;
            }
        }

        this._tableEl = this._td1El = this._td2El = this._td3El = null;
        this._bodyEl = this._borderEl = this.headerEl = null;
        this.tabs = null;
        mini.Tabs.superclass.destroy.call(this, removeEl);
    },
    //    destroy: function (removeEl) {
    //        if (this.tabs) {
    //            for (var i = 0, l = this.tabs.length; i < l; i++) {
    //                var tab = this.tabs[i];
    //                this._doRemoveIFrame(tab, true);
    //            }
    //        }
    //        this.tabs = null;
    //        mini.Tabs.superclass.destroy.call(this, removeEl);
    //    },
    _doClearElement: function () {
        mini.removeClass(this._td1El, "mini-tabs-header");
        mini.removeClass(this._td3El, "mini-tabs-header");
        this._td1El.innerHTML = '';
        this._td3El.innerHTML = '';

        mini.removeChilds(this._td2El, this._bodyEl);
    },
    _initEvents: function () {
        mini._BindEvents(function () {
            mini.on(this.el, "mousedown", this.__OnMouseDown, this);
            mini.on(this.el, "click", this.__OnClick, this);
            mini.on(this.el, "mouseover", this.__OnMouseOver, this);
            mini.on(this.el, "mouseout", this.__OnMouseOut, this);
            mini.on(this.el, "dblclick", this.__OnDblClick, this);
        }, this);

    },

    _initTabs: function () {
        this.tabs = [];
    },
    _TabID: 1,

    createTab: function (options) {
        var tab = mini.copyTo({
            _id: this._TabID++,
            name: "",
            title: "",

            newLine: false,

            tooltip: "",

            iconCls: "",
            iconStyle: "",
            headerCls: "",
            headerStyle: "",
            bodyCls: "",
            bodyStyle: "",

            visible: true,
            enabled: true,
            showCloseButton: false,
            active: false,

            url: "",
            loaded: false,
            refreshOnClick: false

        }, options);
        if (options) {
            options = mini.copyTo(options, tab);
            tab = options;
        }
        return tab;
    },
    /////////////////////////////////
    _doLoad: function () {

        var tabs = mini._getResult(this.url, null, null, null, null, this.dataField);

        if (this.dataField && !mini.isArray(tabs)) {
            tabs = mini._getMap(this.dataField, tabs);
        }
        if (!tabs) tabs = [];


        this.setTabs(tabs);
        this.fire("load");
    },

    load: function (url) {
        if (typeof url == "string") {
            this.setUrl(url);
        } else {
            this.setTabs(url);
        }
    },
    //    setShowCloseOnHover: function (value) {
    //        this.showCloseOnHover = value;

    //        if (this.showCloseOnHover) mini.addClass(this.el, "mini-tabs-hoverclose");
    //        else mini.removeClass(this.el, "mini-tabs-hoverclose");

    //    },
    //    getShowCloseOnHover: function (value) {
    //        return this.showCloseOnHover;
    //    },
    setUrl: function (value) {
        this.url = value;

        this._doLoad();
    },
    getUrl: function () {
        return this.url;
    },

    setNameField: function (value) {
        this.nameField = value;
    },
    getNameField: function () {
        return this.nameField;
    },
    setTitleField: function (value) {
        this.titleField = value;
    },
    getTitleField: function () {
        return this.titleField;
    },
    setUrlField: function (value) {
        this.urlField = value;
    },
    getUrlField: function () {
        return this.urlField;
    },

    buttonsAlign: "right",
    setButtonsAlign: function (value) {
        this.buttonsAlign = value;
    },
    getButtonsAlign: function () {
        return this.buttonsAlign;
    },

    setButtons: function (value) {
        this._buttons = mini.byId(value);
        if (this._buttons) {
            var el = mini.byClass('mini-tabs-buttons', this.el);
            if (el) {

                el.appendChild(this._buttons);
                mini.parse(el);
                this.doLayout();
            }
        }
    },
    setTabControls: function (tab, value) {
        var tab = this.getTab(tab);
        if (!tab) return;
        var el = this.getTabBodyEl(tab);
        __mini_setControls(value, el, this);
    },
    setTabs: function (tabs) {
        if (!mini.isArray(tabs)) return;
        this.beginUpdate();

        this.removeAll();

        //转换
        for (var i = 0, l = tabs.length; i < l; i++) {
            var tab = tabs[i];
            tab.title = mini._getMap(this.titleField, tab); //tab[this.titleField];
            tab.url = mini._getMap(this.urlField, tab);     //tab[this.urlField];
            tab.name = mini._getMap(this.nameField, tab);   //tab[this.nameField];
        }

        for (var i = 0, l = tabs.length; i < l; i++) {
            this.addTab(tabs[i]);
        }
        this.setActiveIndex(0);
        this.endUpdate();
    },
    getTabs: function () {
        return this.tabs;
    },
    removeAll: function (butTabs) {
        var activeTab = this.getActiveTab();
        if (mini.isNull(butTabs)) butTabs = [];
        if (!mini.isArray(butTabs)) {
            butTabs = [butTabs];
        }
        for (var i = butTabs.length - 1; i >= 0; i--) {
            var t = this.getTab(butTabs[i]);
            if (!t) butTabs.removeAt(i);
            else butTabs[i] = t;
        }

        var olds = this.tabs;
        for (var i = olds.length - 1; i >= 0; i--) {
            var tab = olds[i];
            if (butTabs.indexOf(tab) == -1) {
                this.removeTab(tab);
            }
        }
        var butTab = butTabs[0];
        if (activeTab != this.getActiveTab()) {
            if (butTab) this.activeTab(butTab);
        }
    },
    addTab: function (tab, index) {
        if (typeof tab == "string") {
            tab = { title: tab };
        }
        tab = this.createTab(tab);
        if (!tab.name) tab.name = "";

        //保持activeIndex序号正确
        var activeTab = this.getActiveTab();

        if (typeof index != "number") index = this.tabs.length;
        this.tabs.insert(index, tab);

        //保持activeIndex序号正确
        if (activeTab) this.activeIndex = this.tabs.indexOf(activeTab);

        //body
        var bodyId = this._createTabBodyId(tab);
        var s = '<div id="' + bodyId + '" class="mini-tabs-body ' + tab.bodyCls + '" style="' + tab.bodyStyle + ';display:none;"></div>';
        mini.append(this._bodyEl, s);

        var el = this.getTabBodyEl(tab);

        //body
        var cs = tab.body;
        delete tab.body;
        if (cs) {

            if (!mini.isArray(cs)) cs = [cs];
            for (var i = 0, l = cs.length; i < l; i++) {
                mini.append(el, cs[i]);
            }
        }

        //bodyParent
        if (tab.bodyParent) {
            var p = tab.bodyParent;

            while (p.firstChild) {
                if (p.firstChild.nodeType == 8) {
                    p.removeChild(p.firstChild);
                } else {
                    el.appendChild(p.firstChild);
                }
            }
        }
        delete tab.bodyParent;

        //controls
        if (tab.controls) {
            this.setTabControls(tab, tab.controls);
            delete tab.controls;
        }

        this.doUpdate();
        return tab;
    },
    removeTab: function (tab) {

        tab = this.getTab(tab);
        if (!tab || this.tabs.indexOf(tab) == -1) return;
        //alert(1);

        var acTab = this.getActiveTab();

        var isActive = tab == acTab;

        var autoActive = this._OnTabDestroy(tab);

        this.tabs.remove(tab);

        //iframe
        this._doRemoveIFrame(tab);

        var el = this.getTabBodyEl(tab);
        if (el) this._bodyEl.removeChild(el);
        //mini.removeNode(el);

        if (autoActive && isActive) {
            for (var i = this.activeIndex; i >= 0; i--) {
                var tab = this.getTab(i);
                if (tab && tab.enabled && tab.visible) {
                    this.activeIndex = i;
                    break;
                }
            }
            this.doUpdate();
            this.setActiveIndex(this.activeIndex);
            this.fire("activechanged");
        } else {
            this.activeIndex = this.tabs.indexOf(acTab);
            this.doUpdate();
        }
        return tab;
    },
    moveTab: function (tab, index) {
        tab = this.getTab(tab);
        if (!tab) return;

        var t = this.tabs[index];
        if (t == tab) return;

        this.tabs.remove(tab);
        var index = this.tabs.indexOf(t);
        if (index == -1) {
            this.tabs.add(tab);
        } else {
            this.tabs.insert(index, tab);
        }
        this.doUpdate();
    },
    updateTab: function (tab, options) {
        tab = this.getTab(tab);
        if (!tab) return;
        mini.copyTo(tab, options);

        if (!tab.visible && this.tabs.indexOf(tab) == this.activeIndex) {
            var activeIndex = -1;
            for (var i = this.activeIndex + 1, l = this.tabs.length; i < l; i++) {
                var item = this.tabs[i];
                if (item.visible) {
                    activeIndex = i;
                    break;
                }
            }
            this.setActiveIndex(activeIndex)
        }

        this.doUpdate();
    },
    ////////////////////////////////////////////
    _getMaskWrapEl: function () {
        return this._bodyEl;
    },
    _doRemoveIFrame: function (tab, removeAll) {

        //return;

        if (tab._iframeEl && tab._iframeEl.parentNode) {
            var iframe = tab._iframeEl;

            iframe.onload = function () { };
            jQuery(iframe).unbind("load");

            iframe.src = "";
            if (mini.isIE) {
                try {
                    iframe.contentWindow.document.write("");
                    iframe.contentWindow.document.close();
                } catch (ex) { }
            }
            if (tab._iframeEl._ondestroy) tab._iframeEl._ondestroy();

            try {
                iframe.parentNode.removeChild(iframe);
                iframe.removeNode(true);
            } catch (ex) { }
        }

        tab._iframeEl = null;
        tab.loadedUrl = null;

        //删除bodyEl内所有元素
        if (removeAll === true) {
            var bodyEl = this.getTabBodyEl(tab);
            if (bodyEl) {
                var cs = mini.getChildNodes(bodyEl, true);
                for (var i = 0, l = cs.length; i < l; i++) {
                    var d = cs[i];
                    if (d && d.parentNode) d.parentNode.removeChild(d);
                    //mini.removeNode(d);
                }
            }
        }
    },
    _deferLoadingTime: 180,
    _cancelLoadTabs: function (tab) {
        //取消所有正在加载中的tab
        var tabs = this.tabs;
        for (var i = 0, l = tabs.length; i < l; i++) {
            var t = tabs[i];
            if (t != tab) {
                if (t._loading && t._iframeEl) {
                    t._loading = false;
                    this._doRemoveIFrame(t, true);
                }
            }
        }
        if (tab && tab == this.getActiveTab() && tab._loading) {
        } else {
            this._loading = false;
            this.unmask();
        }
    },
    _doLoadTab: function (tab) {
        if (!tab || tab != this.getActiveTab()) return;
        var bodyEl = this.getTabBodyEl(tab);
        if (!bodyEl) return;

        this._cancelLoadTabs();

        this._doRemoveIFrame(tab, true);

        this._loading = true;
        tab._loading = true;


        this.unmask();
        if (this.maskOnLoad) this.loading();
        var st = new Date();

        var sf = this;

        //如果页面onload后，给300毫秒初始化时间，防止快速切换导致问题
        sf.isLoading = true;
        //        setTimeout(function () {
        //            sf.isLoading = false;
        //        }, 300);

        var iframe = mini.createIFrame(tab.url,
            function (_iframe, firstLoad) {
                //window.close
                try {
                    tab._iframeEl.contentWindow.Owner = window;
                    tab._iframeEl.contentWindow.CloseOwnerWindow = function (action) {

                        tab.removeAction = action;
                        //tab.ondestroy
                        var ret = true;
                        if (tab.ondestroy) {
                            if (typeof tab.ondestroy == "string") {
                                tab.ondestroy = window[tab.ondestroy];
                            }
                            if (tab.ondestroy) {
                                var e = sf._getTabEvent(tab);
                                e.action = action;
                                ret = tab.ondestroy.call(sf, e);
                            }
                        }

                        if (ret === false) {
                            return false;
                        }

                        setTimeout(function () {
                            sf.removeTab(tab);
                        }, 10);
                    }
                } catch (e) { }

                if (tab._loading != true) return;
                var t = (st - new Date()) + sf._deferLoadingTime;

                tab._loading = false;
                tab.loadedUrl = tab.url;

                if (t < 0) t = 0;
                setTimeout(function () {
                    sf.unmask();
                    sf.doLayout();
                    sf.isLoading = false;
                }, t);

                //firstLoad
                if (firstLoad) {
                    var e = {
                        sender: sf,
                        tab: tab,
                        index: sf.tabs.indexOf(tab),
                        name: tab.name,
                        iframe: tab._iframeEl
                    };
                    if (tab.onload) {
                        if (typeof tab.onload == "string") {
                            tab.onload = window[tab.onload];
                        }
                        if (tab.onload) {
                            tab.onload.call(sf, e);
                        }
                    }
                }
                if (sf.getActiveTab() == tab) {
                    sf.fire("tabload", e);
                }
            },
            this.clearTimeStamp, tab.method, tab.params
        );
        setTimeout(function () {
            if (tab._iframeEl == iframe) {
                bodyEl.appendChild(iframe);
            }
            //iframe.src = tab.url;
        }, 1);
        tab._iframeEl = iframe;
    },
    _getTabEvent: function (tab) {
        var e = {
            sender: this,
            tab: tab,
            index: this.tabs.indexOf(tab),
            name: tab.name,
            iframe: tab._iframeEl,
            autoActive: true
        };
        return e;
    },
    _OnTabDestroy: function (tab) {
        //        var e = {
        //            sender: this,
        //            tab: tab,
        //            index: this.tabs.indexOf(tab),
        //            name: tab.name,
        //            iframe: tab._iframeEl,
        //            autoActive: true
        //        };
        var e = this._getTabEvent(tab);
        this.fire("tabdestroy", e);
        return e.autoActive;
    },
    //loadTab({...});
    loadTab: function (url, tab, onload, ondestroy) {
        if (!url) return;
        tab = this.getTab(tab);
        if (!tab) tab = this.getActiveTab();
        if (!tab) return;

        var el = this.getTabBodyEl(tab);
        if (el) {
            mini.addClass(el, 'mini-tabs-hideOverflow');
        }

        tab.url = url;
        delete tab.loadedUrl;

        if (onload) tab.onload = onload;
        if (ondestroy) tab.ondestroy = ondestroy;

        var me = this;
        clearTimeout(this._loadTabTimer);
        this._loadTabTimer = null;
        this._loadTabTimer = setTimeout(function () {
            me._doLoadTab(tab);
        }, 1);
    },
    reloadTab: function (tab) {
        tab = this.getTab(tab);
        if (!tab) tab = this.getActiveTab();
        if (!tab) return;
        this.loadTab(tab.url, tab);
    },
    ///////////////////////////////////////////
    getTabRows: function () {
        var rows = [];
        var row = [];
        for (var i = 0, l = this.tabs.length; i < l; i++) {
            var tab = this.tabs[i];
            if (i != 0 && tab.newLine) {
                rows.push(row);
                row = [];
            }
            row.push(tab);
        }
        rows.push(row);
        return rows;
    },
    doUpdate: function () {

        if (this._allowUpdate === false) return;

        if (this._buttons && this._buttons.parentNode) {
            this._buttons.parentNode.removeChild(this._buttons);
        }



        mini.removeClass(this.el, "mini-tabs-position-left");
        mini.removeClass(this.el, "mini-tabs-position-top");
        mini.removeClass(this.el, "mini-tabs-position-right");
        mini.removeClass(this.el, "mini-tabs-position-bottom");

        if (this.tabPosition == "bottom") {
            mini.addClass(this.el, "mini-tabs-position-bottom");
            this._doUpdateBottom();
        } else if (this.tabPosition == "right") {
            mini.addClass(this.el, "mini-tabs-position-right");
            this._doUpdateRight();
        } else if (this.tabPosition == "left") {
            mini.addClass(this.el, "mini-tabs-position-left");
            this._doUpdateLeft();
        } else {
            mini.addClass(this.el, "mini-tabs-position-top");
            this._doUpdateTop();
        }

        //header
        var el = this._headerEl, cls = "mini-tabs-header-";
        mini.removeClass(el, cls + "left");
        mini.removeClass(el, cls + "top");
        mini.removeClass(el, cls + "right");
        mini.removeClass(el, cls + "bottom");
        mini.addClass(el, cls + this.tabPosition);

        //body

        var el = this._bodyEl, cls = "mini-tabs-body-";
        mini.removeClass(el, cls + "left");
        mini.removeClass(el, cls + "top");
        mini.removeClass(el, cls + "right");
        mini.removeClass(el, cls + "bottom");
        mini.addClass(el, cls + this.tabPosition);

        //buttons
        if (this._buttons) {
            var el = mini.byClass('mini-tabs-buttons', this.el);
            if (el) {
                el.appendChild(this._buttons);
                mini.parse(el);
            }
        }

        this.doLayout();

        this.setActiveIndex(this.activeIndex, false);
    },
    _handleIFrameOverflow: function () {

        var bodyEl = this.getTabBodyEl(this.activeIndex);
        if (bodyEl) {
            mini.removeClass(bodyEl, 'mini-tabs-hideOverflow');
            var dom = mini.getChildNodes(bodyEl)[0];

            if (dom && dom.tagName && dom.tagName.toUpperCase() == "IFRAME") {
                mini.addClass(bodyEl, 'mini-tabs-hideOverflow');
            }

        }
    },
    doLayout: function () {

        var me = this,
            headerEl = me._headerEl,
            bodyEl = me._bodyEl,
            tabPosition = me.tabPosition;


        if (!this.canLayout()) return;

        headerEl.style.display = this.showHeader ? "" : "none";

        this._handleIFrameOverflow();


        var autoHeight = this.isAutoHeight();

        //headerEl.style.display = "none";

        h = this.getHeight(true);
        w = this.getWidth();
        var elHeight = h;
        var elWidth = w;
        //        headerEl.style.display = "";
        if (this.showBody) {
            bodyEl.style.display = "";
        } else {
            bodyEl.style.display = "none";
        }

        var plainEl = this.el.firstChild;
        if (this.plain) {
            mini.addClass(plainEl, "mini-tabs-plain");
        } else {
            mini.removeClass(plainEl, "mini-tabs-plain");
        }


        if (!autoHeight && this.showBody) {

            var headerHeight = jQuery(headerEl).outerHeight();
            var headerWidth = jQuery(headerEl).outerWidth();
            if (tabPosition == "top" || tabPosition == "bottom") {
                headerHeight = jQuery(headerEl.parentNode).outerHeight();
                //alert(headerHeight);

                headerHeight -= 1;
            }

            if (tabPosition == "left" || tabPosition == "right") {
                w = w - headerWidth;
            } else {
                h = h - headerHeight;
            }

            //alert(jQuery.boxModel);
            // 元素的box为box-sizing: border-box; 高度直接css设置， 此处无须处理
            // if (jQuery.boxModel) {
            //     var padding = mini.getPaddings(bodyEl);
            //     var border = mini.getBorders(bodyEl);

            //     h = h - padding.top - padding.bottom - border.top - border.bottom;
            //     w = w - padding.left - padding.right - border.left - border.right;
            // }
            margin = mini.getMargins(bodyEl);

            h = h - margin.top - margin.bottom;
            w = w - margin.left - margin.right;



            if (h < 0) h = 0;
            if (w < 0) w = 0;

            bodyEl.style.width = w + "px";
            bodyEl.style.height = h + "px";

            //调整header
            if (tabPosition == "left" || tabPosition == "right") {

                //                var tds = headerEl.firstChild.rows[0].cells;
                //                var trs = tds[0].firstChild.rows;

                var tr = headerEl.getElementsByTagName("tr")[0];
                var tds = tr.childNodes;
                var trs = tds[0].getElementsByTagName("tr");

                var first = last = all = 0;
                for (var i = 0, l = trs.length; i < l; i++) {
                    var tr = trs[i];
                    var trH = jQuery(tr).outerHeight();
                    all += trH;
                    if (i == 0) first = trH;
                    if (i == l - 1) last = trH;
                }

                switch (this.tabAlign) {
                    case "center":
                        var halfH = parseInt((elHeight - (all - first - last)) / 2);
                        for (var i = 0, l = tds.length; i < l; i++) {
                            tds[i].firstChild.style.height = elHeight + "px";
                            var tb = tds[i].firstChild;
                            var trs = tb.getElementsByTagName("tr");
                            var tr1 = trs[0], tr2 = trs[trs.length - 1];
                            tr1.style.height = halfH + "px";
                            tr2.style.height = halfH + "px";
                        }
                        break;
                    case "right":
                        for (var i = 0, l = tds.length; i < l; i++) {
                            var tb = tds[i].firstChild;
                            var trs = tb.getElementsByTagName("tr");
                            var tr = trs[0];

                            var size = elHeight - (all - first);
                            if (size >= 0) {
                                tr.style.height = size + "px";
                            }
                        }
                        break;
                    case "fit":
                        for (var i = 0, l = tds.length; i < l; i++) {
                            tds[i].firstChild.style.height = elHeight + "px"; ;
                        }
                        break;
                    default:
                        for (var i = 0, l = tds.length; i < l; i++) {
                            var tb = tds[i].firstChild;
                            var trs = tb.getElementsByTagName("tr");
                            var tr = trs[trs.length - 1];
                            var size = elHeight - (all - last);
                            if (size >= 0) {
                                tr.style.height = size + "px";
                            }
                        }
                        break;
                }
            }
        } else {
            bodyEl.style.width = "auto";
            bodyEl.style.height = "auto";
        }

        //active tab
        var tabBodyEl = this.getTabBodyEl(this.activeIndex);
        if (tabBodyEl) {
            if (!autoHeight && this.showBody) {
                var h = mini.getHeight(bodyEl, true);
                if (jQuery.boxModel) {
                    var padding = mini.getPaddings(tabBodyEl);
                    var border = mini.getBorders(tabBodyEl);
                    h = h - padding.top - padding.bottom - border.top - border.bottom;
                }
                tabBodyEl.style.height = h + "px";
            } else {
                tabBodyEl.style.height = "auto";
            }
        }

        switch (tabPosition) {
            case "bottom":
                var hds = headerEl.childNodes;
                for (var i = 0, l = hds.length; i < l; i++) {
                    var tb = hds[i];
                    mini.removeClass(tb, "mini-tabs-header2");
                    if (l > 1 && i != 0) {

                        mini.addClass(tb, "mini-tabs-header2");
                    }
                }
                break;
            case "left":

                //                var trs = headerEl.firstChild.getElementsByTagName("tr");
                //                var tds = trs[0].getElementsByTagName("td");
                var tds = headerEl.firstChild.rows[0].cells;
                for (var i = 0, l = tds.length; i < l; i++) {
                    var td = tds[i];
                    mini.removeClass(td, "mini-tabs-header2");
                    if (l > 1 && i == 0) {
                        mini.addClass(td, "mini-tabs-header2");
                    }
                }
                break;
            case "right":
                //                var trs = headerEl.firstChild.getElementsByTagName("tr");
                //                var tds = trs[0].getElementsByTagName("td");

                var tds = headerEl.firstChild.rows[0].cells;
                for (var i = 0, l = tds.length; i < l; i++) {
                    var td = tds[i];
                    mini.removeClass(td, "mini-tabs-header2");
                    if (l > 1 && i != 0) {
                        mini.addClass(td, "mini-tabs-header2");
                    }
                }
                break;
            default:
                var hds = headerEl.childNodes;
                for (var i = 0, l = hds.length; i < l; i++) {
                    var tb = hds[i];
                    mini.removeClass(tb, "mini-tabs-header2");
                    if (l > 1 && i == 0) {
                        mini.addClass(tb, "mini-tabs-header2");
                    }
                }
                break;
        }


        //scroll 
        mini.removeClass(this.el, 'mini-tabs-scroll');
        var td = mini.byClass('mini-tabs-lastSpace', this.el);
        var buttons = mini.byClass('mini-tabs-buttons', this.el);
        var ct = headerEl.parentNode;
        ct.style["paddingRight"] = '0px';
        if (this._navEl) this._navEl.style.display = 'none';
        if (this._leftNavEl) this._leftNavEl.style.display = 'none';
        if (buttons) buttons.style.display = 'none';

        var isRightButton = this.buttonsAlign == "right";
        if (!isRightButton) {
            buttons.style.right = 'auto';
            buttons.style.left = '0';
        }

        mini.setWidth(ct, elWidth);

        if ((tabPosition == "top" || tabPosition == "bottom") && (this.tabAlign == "left" || this.tabAlign == "right")) {
            headerEl.style.width = 'auto';
            buttons.style.display = 'block';


            var width = elWidth;

            var tabsWidth = headerEl.firstChild.offsetWidth - td.offsetWidth;
            var buttonsWidth = buttons.firstChild ? buttons.offsetWidth : 0;

            //            this._navEl.style.display = 'none';
            //            this._navEl.style.display = 'none';

            if (tabsWidth + buttonsWidth > width) {
                this._navEl.style.display = 'block';
                var navWidth = this._navEl.offsetWidth;
                //_headerMenuEl
                var headerMenuWidth = 0;

                if (this.showNavMenu) {
                    this._headerMenuEl.style.display = 'inline-block';
                    headerMenuWidth = this._headerMenuEl.offsetWidth;
                    this._headerMenuEl.style.right = buttonsWidth + "px";

                    if (!this._headerMenu) {
                        this._createHeaderMenu();
                    }
                }
                var leftNavWidth = 0;
                if (this.arrowPosition == "side") {
                    this._leftNavEl.style.display = "block";
                    leftNavWidth = this._leftNavEl.offsetWidth;
                    headerEl.style.left = leftNavWidth + "px";
                }
                this._navEl.style.right = (isRightButton ? buttonsWidth : 0) + headerMenuWidth + 'px';
                var w = width - buttonsWidth - navWidth - leftNavWidth - headerMenuWidth;
                mini.setWidth(headerEl, w);
                //alert(1);

                //ct.style["paddingRight"] = (buttonsWidth - navWidth) + "px";

                //mini.addClass(this.el, 'mini-tabs-scroll');
            } else {
                headerEl.style.left = 0 + "px";
            }

            headerEl.style.marginLeft = (isRightButton ? 0 : buttonsWidth) + "px";
        }



        this._scrollToTab(this.activeIndex);
        this._doScrollButton();

        //        if (autoHeight) {
        //        } else {
        //        }

        //alert("layout tab");
        mini.layout(bodyEl);

        var that = this;
        var tab = this.getActiveTab();
        if (tab && tab.repaint && tabBodyEl) {
            var w = tabBodyEl.style.width;
            tabBodyEl.style.width = '0px';
            setTimeout(function () {

                tabBodyEl.style.width = w;
            }, 1);
        }

        this.fire("layout");

    },

    _getTabBy_Id: function (id) {
        for (var i = 0, l = this.tabs.length; i < l; i++) {
            var tab = this.tabs[i];
            if (tab._id == id) return tab;
        }
    },
    _createHeaderMenu: function () {


        this._headerMenu = new mini.Menu();
        this._headerMenu.setIdField("_id");
        this._headerMenu.setTextField("title");
        this._headerMenu.setPopupEl(this._headerMenuEl);
        this._headerMenu.setShowAction("leftclick");
        this._headerMenu.setHideAction("outerclick");
        this._headerMenu.setXAlign("left");
        this._headerMenu.setYAlign("below");
        //jQuery(this._headerMenu.el).addClass("mini-shadow");
        //alert(1);
        mini.addClass(this._headerMenu.el, "mini-menu-open");
        this._headerMenu.on("itemclick", this._doMenuSelectTab, this)

        this._headerMenu.hide();
        this._headerMenu.owner = this._headerMenuEl;

    },
    _setHeaderMenuItems: function () {
        var tabs = this.getTabs();
        var items = [];
        for (var i = 0, l = tabs.length; i < l; i++) {
            var o = tabs[i];
            items.push({
                //id: o[this.nameField],
                id: o._id,
                text: o[this.titleField]
            });
        }

        this._headerMenu.setItems(items);
    },
    _doMenuSelectTab: function (e) {
        var item = e.item;

        var tab = this._getTabBy_Id(item.id);
        this.activeTab(tab);
    },
    setTabAlign: function (value) {
        this.tabAlign = value;
        this.doUpdate();
    },
    setTabPosition: function (value) {
        this.tabPosition = value;
        this.doUpdate();
    },

    allowClickWrap: true,

    setAllowClickWrap: function (value) {
        this.allowClickWrap = value;
    },
    getAllowClickWrap: function () {
        return this.allowClickWrap;
    },

    getTab: function (index) {
        if (typeof index == "object") return index;
        if (typeof index == "number") {
            return this.tabs[index];
        } else {
            for (var i = 0, l = this.tabs.length; i < l; i++) {
                var tab = this.tabs[i];
                if (tab.name == index) return tab;
            }
        }
    },
    getHeaderEl: function () {
        return this._headerEl;
    },
    getBodyEl: function () {
        return this._bodyEl;
    },
    getTabEl: function (index) {
        var tab = this.getTab(index);
        if (!tab) return null;
        var id = this._createTabId(tab);
        var cs = this.el.getElementsByTagName("*");
        for (var i = 0, l = cs.length; i < l; i++) {
            var el = cs[i];
            if (el.id == id) return el;
        }
        return null;
    },
    getTabBodyEl: function (index) {
        var tab = this.getTab(index);
        if (!tab) return null;
        var id = this._createTabBodyId(tab);
        var cs = this._bodyEl.childNodes;
        for (var i = 0, l = cs.length; i < l; i++) {
            var el = cs[i];
            if (el.id == id) return el;
        }
        return null;
    },
    getTabIFrameEl: function (index) {
        var tab = this.getTab(index);
        if (!tab) return null;
        return tab._iframeEl;
    },
    _createTabId: function (tab) {
        return this.uid + "$" + tab._id;
    },
    _createTabBodyId: function (tab) {
        return this.uid + "$body$" + tab._id;
    },
    _doScrollButton: function () {
        if (this.tabPosition == "top" || this.tabPosition == "bottom") {
            mini.removeClass(this._leftButtonEl, "mini-disabled");
            mini.removeClass(this._rightButtonEl, "mini-disabled");
            if (this._headerEl.scrollLeft == 0) {
                mini.addClass(this._leftButtonEl, "mini-disabled");
            }
            var tabEl = this.getTabEl(this.tabs.length - 1);
            if (tabEl) {
                var tabBox = mini.getBox(tabEl);
                var scrollBox = mini.getBox(this._headerEl);
                if (tabBox.right <= scrollBox.right) {
                    mini.addClass(this._rightButtonEl, "mini-disabled");
                }
            }
        }
    },

    setActiveIndex: function (value, load) {

        var tab = this.getTab(value);

        var acTab = this.getTab(this.activeIndex);

        //

        var fire = tab != acTab;

        var el = this.getTabBodyEl(this.activeIndex);
        if (el) el.style.display = "none";
        if (tab) {
            this.activeIndex = this.tabs.indexOf(tab);
        } else {
            this.activeIndex = -1;
        }
        var el = this.getTabBodyEl(this.activeIndex);
        if (el) el.style.display = "";

        var el = this.getTabEl(acTab);
        if (el) mini.removeClass(el, this._tabActiveCls);

        var el = this.getTabEl(tab);
        if (el) mini.addClass(el, this._tabActiveCls);

        if (el && fire) {
            if (this.tabPosition == "bottom") {
                var tb = mini.findParent(el, "mini-tabs-header");
                if (tb) {
                    jQuery(this._headerEl).prepend(tb);
                }
            } else if (this.tabPosition == "left") {
                var td = mini.findParent(el, "mini-tabs-header").parentNode;
                if (td) {
                    td.parentNode.appendChild(td);
                }
            } else if (this.tabPosition == "right") {
                var td = mini.findParent(el, "mini-tabs-header").parentNode;
                if (td) {
                    jQuery(td.parentNode).prepend(td);
                }
            } else {

                //                var tb = mini.findParent(el, "mini-tabs-header");
                //                if (tb) {
                //                    this._headerEl.appendChild(tb);
                //                }

                var tb = mini.findParent(el, "mini-tabs-header");
                if (tb && this.allowClickWrap) {
                    this._headerEl.appendChild(tb);
                }
            }
            var scrollLeft = this._headerEl.scrollLeft;



            var acTab = this.getTab(this.activeIndex);
            var canLayout = acTab ? !acTab._layouted : false;
            var autoHeight = this.isAutoHeight();

            //alert(1);

            if (autoHeight || canLayout) {
                if (acTab) acTab._layouted = true;
                this.doLayout();
                if (acTab) acTab._layouted = false;
            }

            //alert(2);

            var rows = this.getTabRows();
            if (rows.length > 1) {

            } else {
                this._scrollToTab(this.activeIndex);
                //                if (this.tabPosition == "top") {
                //                    this._headerEl.scrollLeft = scrollLeft;
                //                    var tabEl = this.getTabEl(this.activeIndex);
                //                    if (tabEl) {
                //                        var sf = this;
                //                        var tabBox = mini.getBox(tabEl);
                //                        var scrollBox = mini.getBox(sf._headerEl);

                //                        if (tabBox.x < scrollBox.x) {
                //                            sf._headerEl.scrollLeft -= (scrollBox.x - tabBox.x);
                //                        } else if (tabBox.right > scrollBox.right) {
                //                            sf._headerEl.scrollLeft += (tabBox.right - scrollBox.right);
                //                        }
                //                    }
                //                }
                this._doScrollButton();
            }

            for (var i = 0, l = this.tabs.length; i < l; i++) {
                var tabEl = this.getTabEl(this.tabs[i]);
                if (tabEl) {
                    mini.removeClass(tabEl, this._tabHoverCls);
                }
            }


        }
        var me = this;
        if (fire) {
            var e = {
                tab: tab,
                index: this.tabs.indexOf(tab),
                name: tab ? tab.name : ""
            };

            setTimeout(function () {    //延迟激发，这样确保UI都被继续创建后



                me.fire("ActiveChanged", e);

            }, 1);
        }

        //iframe load
        this._cancelLoadTabs(tab);
        if (load !== false) {
            if (tab && tab.url && !tab.loadedUrl) {
                var me = this;

                //setTimeout(function () {
                me.loadTab(tab.url, tab);
                //}, 1);
            }
        } else {
            //if (this.maskOnLoad) this.loading();
        }

        if (tab) {
            if (mini.isChrome) {
                var iframe = this.getTabIFrameEl(tab);
                if (iframe) {
                    //mini.repaint(iframe);

                    iframe.style.position = 'relative';     //fix chrome iframe scroll 
                    iframe.style.left = '1px'

                    iframe.offsetWidth;

                    iframe.style.left = '0px'

                    //alert('repaint');
                }
            }
        }

        if (me.canLayout()) {
            try {
                mini.layoutIFrames(me.el);
            } catch (e) {
            }
        }
    },
    _scrollToTab: function (tab) {
        var scrollLeft = this._headerEl.scrollLeft;

        if (this.tabPosition == "top" || this.tabPosition == "bottom") {
            this._headerEl.scrollLeft = scrollLeft;
            var tabEl = this.getTabEl(tab);
            if (tabEl) {
                var sf = this;
                var tabBox = mini.getBox(tabEl);
                var scrollBox = mini.getBox(sf._headerEl);

                if (tabBox.x < scrollBox.x) {
                    sf._headerEl.scrollLeft -= (scrollBox.x - tabBox.x);
                } else if (tabBox.right > scrollBox.right) {
                    sf._headerEl.scrollLeft += (tabBox.right - scrollBox.right);
                }

                //alert(sf._headerEl.scrollLeft);
            }
        }
    },
    getActiveIndex: function () {
        return this.activeIndex;
    },
    activeTab: function (tab) {
        this.setActiveIndex(tab);
    },
    getActiveTab: function () {
        return this.getTab(this.activeIndex);
    },
    getActiveIndex: function () {
        return this.activeIndex;
    },
    _tryActiveTab: function (tab) {
        tab = this.getTab(tab);
        if (!tab) return;
        var index = this.tabs.indexOf(tab);
        if (this.activeIndex == index) return;
        var e = {
            tab: tab,
            index: index,
            name: tab.name,
            cancel: false
        };
        this.fire("BeforeActiveChanged", e);
        if (e.cancel == false) {
            this.activeTab(tab);
        }
    },

    setShowHeader: function (value) {
        if (this.showHeader != value) {
            this.showHeader = value;
            this.doLayout();
        }
    },
    getShowHeader: function () {
        return this.showHeader;
    },
    setShowBody: function (value) {
        if (this.showBody != value) {
            this.showBody = value;
            this.doLayout();
        }
    },
    getShowBody: function () {
        return this.showBody;
    },
    setBodyStyle: function (value) {
        this.bodyStyle = value;
        mini.setStyle(this._bodyEl, value);
        this.doLayout();
    },
    getBodyStyle: function () {
        return this.bodyStyle;
    },
    setMaskOnLoad: function (value) {
        this.maskOnLoad = value;
    },
    getMaskOnLoad: function () {
        return this.maskOnLoad;
    },
    setPlain: function (value) {
        this.plain = value;
        this.doLayout();
    },
    getPlain: function () {
        return this.plain;
    },

    arrowPosition: "right",         //right, side
    setArrowPosition: function (value) {
        this.arrowPosition = value;
    },
    getArrowPosition: function () {
        return this.arrowPosition;
    },
    showNavMenu: false,
    setShowNavMenu: function (value) {
        this.showNavMenu = value
    },
    getShowNavMenu: function () {
        return this.showNavMenu;
    },


    clearTimeStamp: false,
    setClearTimeStamp: function (value) {
        this.clearTimeStamp = value;
    },
    getClearTimeStamp: function () {
        return this.clearTimeStamp;
    },
    ////////////////////////////////////////
    getTabByEvent: function (e) {
        return this._getTabByEvent(e);
    },
    _getTabByEvent: function (e) {
        var el = mini.findParent(e.target, 'mini-tab');
        if (!el) return null;
        var ids = el.id.split("$");
        if (ids[0] != this.uid) return null;
        var index = parseInt(jQuery(el).attr("index"));
        return this.getTab(index);
    },
    __OnDblClick: function (e) {
        var tab = this._getTabByEvent(e);
        if (!tab) return;
        var e = {
            tab: tab
        }
        this.fire("tabdblclick", e)
    },
    __OnClick: function (e) {
        //if (this.isLoading) return;
        var tab = this._getTabByEvent(e);
        if (!tab) return;

        var close = !!mini.findParent(e.target, "mini-tab-close");
        if (!close && tab == this.getActiveTab() && !tab.refreshOnClick) return;

        if (tab.enabled) {
            var me = this;
            setTimeout(function () {

                if (close) {
                    me._OnCloseButtonClick(tab, e);
                } else {
                    var loadedUrl = tab.loadedUrl;
                    me._tryActiveTab(tab);
                    if (tab.refreshOnClick && tab.url == loadedUrl) {
                        me.reloadTab(tab);
                    }
                }
            }, 10);
        }
    },
    hoverTab: null,
    __OnMouseOver: function (e) {

        var tab = this._getTabByEvent(e);
        if (tab && tab.enabled) {
            var tabEl = this.getTabEl(tab);
            mini.addClass(tabEl, this._tabHoverCls);
            this.hoverTab = tab;
        }
    },
    __OnMouseOut: function (e) {
        if (this.hoverTab) {
            var tabEl = this.getTabEl(this.hoverTab);
            mini.removeClass(tabEl, this._tabHoverCls);
        }
        this.hoverTab = null;

    },
    __OnMouseDown: function (e) {
        clearInterval(this._scrollTimer);
        if (this.tabPosition == "top" || this.tabPosition == "bottom") {
            var sf = this;
            var count = 0, num = 10;
            if (e.target == this._leftButtonEl) {
                this._scrollTimer = setInterval(function () {
                    sf._headerEl.scrollLeft -= num;
                    count++;
                    if (count > 5) num = 18;
                    if (count > 10) num = 25;
                    sf._doScrollButton();
                }, 25);
            } else if (e.target == this._rightButtonEl) {
                this._scrollTimer = setInterval(function () {
                    sf._headerEl.scrollLeft += num;
                    count++;
                    if (count > 5) num = 18;
                    if (count > 10) num = 25;
                    sf._doScrollButton();
                }, 25);
            } else if (e.target == this._headerMenuEl) {
                this._setHeaderMenuItems();
            }
            mini.on(document, "mouseup", this.__OnDocMouseUp, this);
        }
    },
    __OnDocMouseUp: function (e) {
        clearInterval(this._scrollTimer);
        this._scrollTimer = null;
        mini.un(document, "mouseup", this.__OnDocMouseUp, this);
    },

    /////////////////////////////////////
    _doUpdateTop: function () {

        //
        var isTop = this.tabPosition == "top";

        var s = '';
        //if (isTop) {
        s += '<div class="mini-tabs-scrollCt">';
        if (this.arrowPosition == "side") {
            s += '<div class="mini-tabs-leftnav"><a class="mini-tabs-leftButton mini-icon" href="javascript:void(0)" hideFocus onclick="return false"></a></div>';
            s += '<div class="mini-tabs-nav"><a class="mini-tabs-rightButton mini-icon" href="javascript:void(0)" hideFocus onclick="return false"></a></div>';
        } else {
            s += '<div class="mini-tabs-nav"><a class="mini-tabs-leftButton mini-icon" href="javascript:void(0)" hideFocus onclick="return false"></a><a class="mini-tabs-rightButton mini-icon" href="javascript:void(0)" hideFocus onclick="return false"></a></div>';
        }
        if (this.showNavMenu) {
            s += '<a class="mini-tabs-tabmenu mini-icon" href="javascript:void(0)" hideFocus onclick="return false"></a>'
        }

        s += '<div class="mini-tabs-buttons" a=1 style="' + (this.buttonsAlign == "right" ? "" : "right:auto;left:0;") + '"></div>';
        //}
        s += '<div class="mini-tabs-headers">';
        var rows = this.getTabRows();
        for (var j = 0, k = rows.length; j < k; j++) {
            var tabs = rows[j];
            var cls = "";
            s += '<table class="mini-tabs-header" cellspacing="0" cellpadding="0"><tr><td class="mini-tabs-space mini-tabs-firstSpace"><div></div></td>';
            for (var i = 0, l = tabs.length; i < l; i++) {
                var tab = tabs[i];
                var id = this._createTabId(tab);
                if (!tab.visible) continue;
                var index = this.tabs.indexOf(tab);
                var cls = tab.headerCls || "";
                if (tab.enabled == false) {
                    cls += ' mini-disabled';
                }
                s += '<td title="' + tab.tooltip + '" id="' + id + '" index="' + index + '"  class="mini-tab mini-corner-all ' + cls + '" style="' + tab.headerStyle + '">';
                if (tab.iconCls || tab.iconStyle) {
                    s += '<span class="mini-tab-icon mini-iconfont ' + tab.iconCls + '" style="' + tab.iconStyle + '"></span>';
                }
                s += '<span class="mini-tab-text">' + tab.title + '</span>';
                if (tab.showCloseButton) {
                    var ms = "";
                    if (tab.enabled) {
                        ms = 'onmouseover="mini.addClass(this, \'mini-tab-close-hover\')" onmouseout="mini.removeClass(this, \'mini-tab-close-hover\')"'
                    }
                    s += '<span class="mini-tab-close mini-icon" ' + ms + ' ></span>';
                }
                s += '</td>';
                if (i != l - 1) {
                    s += '<td class="mini-tabs-space2"><div></div></td>';
                }

            }
            s += '<td class="mini-tabs-space mini-tabs-lastSpace" ><div></div></td></tr></table>';
        }
        //if (isTop) {
        s += '</div>';
        //}
        s += '</div>';

        this._doClearElement();

        mini.prepend(this._td2El, s);

        var td = this._td2El;

        this._headerEl = td.firstChild.lastChild;

        //alert(this._headerEl.outerHTML);

        //if (isTop) {
        if (this.arrowPosition == "side") {
            this._leftNavEl = td.firstChild.firstChild;
            this._navEl = this._headerEl.parentNode.children[1];
            this._leftButtonEl = this._leftNavEl.firstChild;
            this._rightButtonEl = this._navEl.firstChild;

            if (this.showNavMenu) {
                this._headerMenuEl = this._headerEl.parentNode.children[2];
            }
        } else {
            this._navEl = this._headerEl.parentNode.firstChild;
            this._leftButtonEl = this._navEl.firstChild;
            this._rightButtonEl = this._navEl.childNodes[1];

            if (this.showNavMenu) {
                this._headerMenuEl = this._headerEl.parentNode.children[1];
            }
        }

        if (this.showNavMenu && this._headerMenu) {
            this._headerMenu.setPopupEl(this._headerMenuEl);
        }
        //}
        switch (this.tabAlign) {
            case "center":
                var hds = this._headerEl.childNodes;
                for (var i = 0, l = hds.length; i < l; i++) {
                    var tb = hds[i];
                    var tds = tb.getElementsByTagName("td");
                    tds[0].style.width = "50%";
                    tds[tds.length - 1].style.width = "50%";
                }
                break;
            case "right":
                var hds = this._headerEl.childNodes;
                for (var i = 0, l = hds.length; i < l; i++) {
                    var tb = hds[i];
                    var tds = tb.getElementsByTagName("td");
                    tds[0].style.width = "100%";
                }
                break;
            case "fit":
                break;
            default:
                var hds = this._headerEl.childNodes;
                for (var i = 0, l = hds.length; i < l; i++) {
                    var tb = hds[i];
                    var tds = tb.getElementsByTagName("td");
                    tds[tds.length - 1].style.width = "100%";
                }
                break;
        }



    },
    _doUpdateBottom: function () {
        this._doUpdateTop();
        var td = this._td2El;

        mini.append(td, td.firstChild);

        //this._headerEl = td.lastChild;

        this._headerEl = td.lastChild.lastChild;

        //alert(this._headerEl.outerHTML);
    },
    _doUpdateLeft: function () {
        var s = '<table cellspacing="0" cellpadding="0"><tr>';
        var rows = this.getTabRows();
        for (var j = 0, k = rows.length; j < k; j++) {
            var tabs = rows[j];

            var cls = "";
            if (k > 1 && j != k - 1) {
                cls = "mini-tabs-header2";
            }
            s += '<td class="' + cls + '"><table class="mini-tabs-header" cellspacing="0" cellpadding="0">';
            s += '<tr ><td class="mini-tabs-space mini-tabs-firstSpace" ><div></div></td></tr>';

            for (var i = 0, l = tabs.length; i < l; i++) {
                var tab = tabs[i];
                var id = this._createTabId(tab);
                if (!tab.visible) continue;

                var index = this.tabs.indexOf(tab);

                var cls = tab.headerCls || "";
                if (tab.enabled == false) {
                    cls += ' mini-disabled';
                }
                s += '<tr><td id="' + id + '" index="' + index + '"  class="mini-tab ' + cls + '" style="' + tab.headerStyle + '">';
                if (tab.iconCls || tab.iconStyle) {
                    s += '<span class="mini-tab-icon mini-iconfont ' + tab.iconCls + '" style="' + tab.iconStyle + '"></span>';
                }
                s += '<span class="mini-tab-text">' + tab.title + '</span>';
                if (tab.showCloseButton) {
                    var ms = "";
                    if (tab.enabled) {
                        ms = 'onmouseover="mini.addClass(this, \'mini-tab-close-hover\')" onmouseout="mini.removeClass(this, \'mini-tab-close-hover\')"'
                    }
                    s += '<span class="mini-tab-close mini-icon" ' + ms + '></span>';
                }
                s += '</td></tr>';

                if (i != l - 1) {
                    s += '<tr><td class="mini-tabs-space2"><div></div></td></tr>';
                }

            }

            s += '<tr ><td class="mini-tabs-space mini-tabs-lastSpace" ><div></div></td></tr>';
            s += '</table></td>';
        }

        s += '</tr ></table>';

        this._doClearElement();
        mini.addClass(this._td1El, "mini-tabs-header");
        mini.append(this._td1El, s);
        this._headerEl = this._td1El;

    },
    _doUpdateRight: function () {
        this._doUpdateLeft();

        mini.removeClass(this._td1El, "mini-tabs-header");
        mini.removeClass(this._td3El, "mini-tabs-header");
        mini.append(this._td3El, this._td1El.firstChild);
        this._headerEl = this._td3El;

    },
    ///////////////////////////////////
    _OnCloseButtonClick: function (tab, htmlEvent) {
        var e = {
            tab: tab,
            index: this.tabs.indexOf(tab),
            name: tab.name.toLowerCase(),
            htmlEvent: htmlEvent,
            cancel: false
        };

        this.fire("beforecloseclick", e);

        if (e.cancel == true) return;

        try {
            if (tab._iframeEl && tab._iframeEl.contentWindow) {
                var ret = true;
                if (tab._iframeEl.contentWindow.CloseWindow) {
                    ret = tab._iframeEl.contentWindow.CloseWindow("close");
                } else if (tab._iframeEl.contentWindow.CloseOwnerWindow) {
                    ret = tab._iframeEl.contentWindow.CloseOwnerWindow("close");
                }
                if (ret === false) {
                    e.cancel = true;
                }
            }
        } catch (ex) { }

        if (e.cancel == true) return;

        tab.removeAction = "close";
        this.removeTab(tab);
        this.fire("closeclick", e);
    },
    onBeforeCloseClick: function (fn, scope) {
        this.on("beforecloseclick", fn, scope);
    },
    onCloseClick: function (fn, scope) {
        this.on("closeclick", fn, scope);
    },
    onActiveChanged: function (fn, scope) {
        this.on("activechanged", fn, scope);
    },
    ///////////////////////////////////////////////
    getAttrs: function (el) {
        var attrs = mini.Tabs.superclass.getAttrs.call(this, el);

        mini._ParseString(el, attrs,
            ["tabAlign", "tabPosition", "bodyStyle", "onactivechanged", "onbeforeactivechanged", "url",
                "ontabload", "ontabdestroy", "onbeforecloseclick", "oncloseclick", "ontabdblclick",
                "titleField", "urlField", "nameField", "loadingMsg", "buttons", "arrowPosition", "buttonsAlign"
             ]
        );
        mini._ParseBool(el, attrs,
            ["allowAnim", "showBody", "showHeader", "maskOnLoad", "plain", "allowClickWrap", "showNavMenu", "clearTimeStamp"
             ]
        );
        mini._ParseInt(el, attrs,
            ["activeIndex"
             ]
        );

        var tabs = [];
        var nodes = mini.getChildNodes(el);
        for (var i = 0, l = nodes.length; i < l; i++) {
            var node = nodes[i];

            var o = {};
            tabs.push(o);

            o.style = node.style.cssText;
            mini._ParseString(node, o,
                ["name", "title", "url", "cls", "iconCls", "iconStyle", "headerCls", "headerStyle", "bodyCls", "bodyStyle",
                    "onload", "ondestroy", "data-options", "tooltip"
                 ]
            );
            mini._ParseBool(node, o,
                ["newLine", "visible", "enabled", "showCloseButton", "refreshOnClick"
                 ]
            );

            //            var cs = mini.getChildNodes(node, true);
            //            o.body = cs;
            o.bodyParent = node;

            //data-options
            var options = o["data-options"];
            if (options) {

                options = window["ev" + "al"]("(" + options + ")");
                if (options) {
                    //attrs["data-options"] = options;
                    mini.copyTo(o, options);
                }
            }
        }
        attrs.tabs = tabs;

        return attrs;
    }
});
mini.regClass(mini.Tabs, "tabs");
mini.Menu = function() {
    this.items = [];
    mini.Menu.superclass.constructor.apply(this, arguments);

    //this.el.style.background = "none";
};
mini.extend(mini.Menu, mini.Control);
mini.copyTo(mini.Menu.prototype, mini.Popup_prototype);
var mini_Popup_prototype_hide = mini.Popup_prototype.hide;

mini.copyTo(mini.Menu.prototype, {
    height: 'auto',
    width: 'auto',
    minWidth: 140,
    vertical: true,
    allowSelectItem: false,
    _selectedItem: null,
    _itemSelectedCls: 'mini-menuitem-selected',

    textField: 'text',
    resultAsTree: false,
    idField: 'id',
    parentField: 'pid',
    itemsField: 'children',
    iconClsField: 'iconCls',

    showNavArrow: true,

    imgPath: '',

    overflow: false,

    //autoShowArrow:

    _clearBorder: false,

    showAction: 'none', //none, leftclick, rightclick, mouseover
    hideAction: 'outerclick', //none, outerclick, mouseout

    menuAlign: '', //left, right
    setMenuAlign: function(value) {
        this.menuAlign = value;
        //this.doLayout();
    },
    getMenuAlign: function() {
        return this.menuAlign;
    },

    getbyName: function(name) {
        for (var i = 0, l = this.items.length; i < l; i++) {
            var item = this.items[i];
            if (item.name == name) {
                return item;
            }
            if (item.menu) {
                var control = item.menu.getbyName(name);
                if (control) return control;
            }
        }
        return null;
    },

    set: function(obj) {
        if (typeof obj == 'string') {
            return this;
        }

        var url = obj.url;
        delete obj.url;

        if (obj.imgPath) this.setImgPath(obj.imgPath);
        delete obj.imgPath;

        this.ownerItem = obj.ownerItem;
        delete obj.ownerItem;

        mini.Menu.superclass.set.call(this, obj);

        if (url) {
            this.setUrl(url);
        }

        return this;
    },
    ////////////////////////
    uiCls: 'mini-menu',
    _create: function() {
        this.el = document.createElement('div');
        this.el.className = 'mini-menu';
        this.el.innerHTML =
            '<div class="mini-menu-border"><a class="mini-menu-topArrow mini-icon" href="#" onclick="return false"></a><div class="mini-menu-inner"></div><a class="mini-menu-bottomArrow mini-icon" href="#" onclick="return false"></a></div>';
        this._borderEl = this.el.firstChild;

        this._topArrowEl = this._borderEl.childNodes[0];
        this._bottomArrowEl = this._borderEl.childNodes[2];

        this._innerEl = this._borderEl.childNodes[1];
        this._innerEl.innerHTML = '<div class="mini-menu-float"></div><div class="mini-menu-toolbar"></div><div style="clear:both;max-height: 1px;"></div>';
        this._contentEl = this._innerEl.firstChild;
        this._toolbarEl = this._innerEl.childNodes[1];

        //this._topArrowEl.style.display = this._bottomArrowEl.style.display = "none";

        if (this.isVertical() == false) mini.addClass(this.el, 'mini-menu-horizontal');
    },
    destroy: function(removeEl) {
        if (this.items) {
            for (var i = 0, l = this.items.length; i < l; i++) {
                this.items[i].destroy();
            }
        }

        if (this._topArrowEl) {
            this._topArrowEl.onmousedown = this._bottomArrowEl.onmousedown = null;
        }

        this._popupEl = this.popupEl = this._borderEl = this._innerEl = this._contentEl = this._toolbarEl = null;
        this._topArrowEl = this._bottomArrowEl = null;
        this.owner = null;
        this.window = null;
        mini.un(document, 'mousedown', this.__OnBodyMouseDown, this);
        mini.un(window, 'resize', this.__OnWindowResize, this);

        mini.Menu.superclass.destroy.call(this, removeEl);
    },
    _disableContextMenu: false,
    _initEvents: function() {
        mini._BindEvents(function() {
            mini.on(document, 'mousedown', this.__OnBodyMouseDown, this);
            mini_onOne(this.el, 'mouseover', this.__OnMouseOver, this);
            mini.on(window, 'resize', this.__OnWindowResize, this);
            if (this._disableContextMenu) {
                mini_onOne(
                    this.el,
                    'contextmenu',
                    function(e) {
                        e.preventDefault();
                        //e.stopPropagation();
                    },
                    this
                );
            }

            mini_onOne(this._topArrowEl, 'mousedown', this.__OnTopMouseDown, this);
            mini_onOne(this._bottomArrowEl, 'mousedown', this.__OnBottomMouseDown, this);
        }, this);
    },
    within: function(e) {
        if (mini.isAncestor(this.el, e.target)) return true;
        for (var i = 0, l = this.items.length; i < l; i++) {
            var item = this.items[i];
            if (item.within(e)) return true;
        }
        return false;
    },
    //    _getClearEl: function () {
    //        if (!this._clearEl) {
    //            this._clearEl = mini.append(this._contentEl, '<div style="clear:both;"></div>');
    //        }
    //        return this._clearEl;
    //    },
    setVertical: function(value) {
        this.vertical = value;
        if (!value) {
            mini.addClass(this.el, 'mini-menu-horizontal');
        } else {
            mini.removeClass(this.el, 'mini-menu-horizontal');
        }
        //mini.append(this._contentEl, this._getClearEl());
    },
    getVertical: function() {
        return this.vertical;
    },
    isVertical: function() {
        return this.vertical;
    },

    show: function() {
        this.setVisible(true);
    },
    hide: function() {
        this.hideItems();
        mini_Popup_prototype_hide.call(this);
    },
    hideItems: function() {
        for (var i = 0, l = this.items.length; i < l; i++) {
            var menuitem = this.items[i];
            menuitem.hideMenu();
        }
    },

    showItemMenu: function(item) {
        for (var i = 0, l = this.items.length; i < l; i++) {
            var menuitem = this.items[i];
            if (menuitem == item) {
                menuitem.showMenu();
            } else {
                menuitem.hideMenu();
            }
        }
    },
    hasShowItemMenu: function() {
        for (var i = 0, l = this.items.length; i < l; i++) {
            var menuitem = this.items[i];
            if (menuitem && menuitem.menu && menuitem.menu.isPopup) {
                return true;
            }
        }
        return false;
    },

    setData: function(value) {
        if (!mini.isArray(value)) value = [];
        this.setItems(value);
    },
    getData: function() {
        return this.getItems();
    },
    setItems: function(items) {
        if (!mini.isArray(items)) items = [];

        this.removeAll();

        for (var i = 0, l = items.length; i < l; i++) {
            this.addItem(items[i]);
        }
        this.adaptItemsGap();
    },
    // 适配菜单项目编辑 全无按钮的情况下 无须预留按钮的位置
    adaptItemsGap: function() {
        var hasIcon = this.items.some(function(item) {
            return !!item.iconCls;
        });
        if (hasIcon) {
            this.removeCls('mini-menu-icon-none');
        } else {
            this.addCls('mini-menu-icon-none');
        }
    },
    getItems: function() {
        return this.items;
    },
    _itemType: 'menuitem',
    addItem: function(item) {
        if (item == '-' || item == '|' || item.type == 'separator') {
            //            mini.append(this._contentEl, '<span id="' + item.id + '" name="' + (item.name || "") + '" class="mini-separator"></span>');
            //            return;

            var s = item.id ? 'id="' + item.id + '"' : '';
            mini.append(this._contentEl, '<span ' + s + ' name="' + (item.name || '') + '" class="mini-separator"></span>');
            return;
        }

        if (!mini.isControl(item) && !mini.getClass(item.type)) {
            item.type = this._itemType;
        }

        item.ownerMenu = this;

        item = mini.getAndCreate(item);

        this.items.push(item);
        //if (this.vertical) {
        this._contentEl.appendChild(item.el);
        //}
        item.ownerMenu = this;

        //mini.append(this._contentEl, this._getClearEl());

        this.fire('itemschanged');
    },
    removeItem: function(item) {
        item = mini.get(item);
        if (!item) return;
        this.items.remove(item);
        //if (this.vertical) {
        this._contentEl.removeChild(item.el);
        //}
        this.fire('itemschanged');
    },
    removeItemAt: function(index) {
        var item = this.items[index];
        this.removeItem(item);
    },
    removeAll: function() {
        var items = this.items.clone();
        for (var i = items.length - 1; i >= 0; i--) {
            this.removeItem(items[i]);
        }
        this._contentEl.innerHTML = '';
    },
    getGroupItems: function(name) {
        if (!name) return [];
        var items = [];
        for (var i = 0, l = this.items.length; i < l; i++) {
            var item = this.items[i];
            if (item.groupName == name) items.push(item);
        }
        return items;
    },
    getItem: function(item) {
        if (typeof item == 'number') return this.items[item];
        if (typeof item == 'string') {
            for (var i = 0, l = this.items.length; i < l; i++) {
                var it = this.items[i];
                if (it.id == item) return it;
            }
            return null;
        }
        if (item && this.items.indexOf(item) != -1) return item;
        return null;
    },

    setAllowSelectItem: function(value) {
        this.allowSelectItem = value;
    },
    getAllowSelectItem: function() {
        return this.allowSelectItem;
    },
    setSelectedItem: function(item) {
        item = this.getItem(item);
        this._OnItemSelect(item);
    },
    getSelectedItem: function(item) {
        return this._selectedItem;
    },

    setShowNavArrow: function(value) {
        this.showNavArrow = value;
    },
    getShowNavArrow: function() {
        return this.showNavArrow;
    },
    setTextField: function(value) {
        this.textField = value;
    },
    getTextField: function() {
        return this.textField;
    },
    setResultAsTree: function(value) {
        this.resultAsTree = value;
    },
    getResultAsTree: function() {
        return this.resultAsTree;
    },
    setIdField: function(value) {
        this.idField = value;
    },
    getIdField: function() {
        return this.idField;
    },
    setParentField: function(value) {
        this.parentField = value;
    },
    getParentField: function() {
        return this.parentField;
    },
    setIconClsField: function(value) {
        this.iconClsField = value;
    },
    getIconClsField: function() {
        return this.iconClsField;
    },

    setOverflow: function(value) {
        this.overflow = value;

        if (value) {
            mini.addClass(this.el, 'mini-menu-overflow');
        } else {
            mini.removeClass(this.el, 'mini-menu-overflow');
        }
    },
    getOverflow: function() {
        return this.overflow;
    },

    ////////////////////////////////////////
    doLayout: function() {
        if (!this.canLayout()) return;

        var innerEl = this._innerEl,
            topEl = this._topArrowEl,
            bottomEl = this._bottomArrowEl;

        if (!this.isAutoHeight()) {
            //var height = this.getHeight(true);
            var height = mini.getHeight(this.el, true);

            mini.setHeight(this._borderEl, height);
            topEl.style.display = bottomEl.style.display = 'none';
            //topEl.style.width = "auto";
            this._contentEl.style.height = 'auto';

            //alert(this._borderEl.scrollHeight + "," + this._borderEl.clientHeight);
            if (this.showNavArrow && this._borderEl.scrollHeight > this._borderEl.clientHeight + 2) {
                topEl.style.display = bottomEl.style.display = 'block';
                height = mini.getHeight(this._borderEl, true);
                var th = mini.getHeight(topEl);
                var bh = mini.getHeight(bottomEl);
                var h = height - th - bh;
                if (h < 0) h = 0;
                mini.setHeight(this._contentEl, h);

                //fix ie7
                var width = mini.getWidth(this._borderEl, true);
                mini.setWidth(topEl, width);
                mini.setWidth(bottomEl, width);
            } else {
                this._contentEl.style.height = 'auto';
            }
        } else {
            this._borderEl.style.height = 'auto';
            this._contentEl.style.height = 'auto';
        }

        if (this.overflow) {
            topEl.style.display = bottomEl.style.display = 'none';
            innerEl.style.marginLeft = innerEl.style.marginRight = '0px';

            if (this._getScrollWidth() > this._innerEl.offsetWidth) {
                topEl.style.display = bottomEl.style.display = 'block';
                innerEl.style.marginLeft = innerEl.style.marginRight = '15px';
            } else {
                innerEl.scrollLeft = 0;
            }
        }
    },
    _measureSize: function() {
        if (this.height == 'auto') {
            this.el.style.height = 'auto';
            this._borderEl.style.height = 'auto';
            this._contentEl.style.height = 'auto';
            this._topArrowEl.style.display = this._bottomArrowEl.style.display = 'none';

            var vbox = mini.getViewportBox();
            var box = mini.getBox(this.el);
            this.maxHeight = vbox.height - 2;

            //@ 以下代码删除。
            //            if (this.ownerItem) {
            //                var box = mini.getBox(this.ownerItem.el);
            //                var topH = box.top;
            //                var bottomH = vbox.height - box.bottom;
            //                var maxHeight = topH > bottomH ? topH : bottomH;
            //                maxHeight -= 10;
            //                this.maxHeight = maxHeight;
            //            }

            //@ 2018年代码
            if (this.ownerItem) {
                this.maxHeight = vbox.height - 2;
            }
        }
        //this.maxHeight = 200;
        this.el.style.display = '';
        var box = mini.getBox(this.el);
        //min, max
        if (box.width > this.maxWidth) {
            mini.setWidth(this.el, this.maxWidth);
            box = mini.getBox(this.el);
        }
        if (box.height > this.maxHeight) {
            mini.setHeight(this.el, this.maxHeight);
            box = mini.getBox(this.el);
        }
        if (box.width < this.minWidth) {
            mini.setWidth(this.el, this.minWidth);
            box = mini.getBox(this.el);
        }
        if (box.height < this.minHeight) {
            mini.setHeight(this.el, this.minHeight);
            box = mini.getBox(this.el);
        }
    },
    ////////////////////////////////////////
    url: '',
    _doLoad: function() {
        var items = mini._getResult(this.url, null, null, null, null, this.dataField);
        //var items = mini.getData(this.url);

        if (this.dataField && !mini.isArray(items)) {
            items = mini._getMap(this.dataField, items);
        }
        if (!items) items = [];

        if (this.resultAsTree == false) {
            items = mini.arrayToTree(items, this.itemsField, this.idField, this.parentField);
        }

        var list = mini.treeToArray(items, this.itemsField, this.idField, this.parentField);
        for (var i = 0, l = list.length; i < l; i++) {
            var o = list[i];
            o.text = mini._getMap(this.textField, o);
            o.iconCls = mini._getMap(this.iconClsField, o);
            if (mini.isNull(o.text)) o.text = '';
        }
        var sss = new Date();
        this.setItems(items);
        //alert(new Date() - sss);
        this.fire('load');
    },
    loadList: function(list, idField, parentField) {
        if (!list) return;

        idField = idField || this.idField;
        parentField = parentField || this.parentField;

        for (var i = 0, l = list.length; i < l; i++) {
            var o = list[i];
            o.text = mini._getMap(this.textField, o);
            o.iconCls = mini._getMap(this.iconClsField, o);
            if (mini.isNull(o.text)) o.text = '';
        }

        var tree = mini.arrayToTree(list, this.itemsField, idField, parentField);

        this.load(tree);
    },
    load: function(url) {
        if (typeof url == 'string') {
            this.setUrl(url);
        } else {
            this.setItems(url);
        }
    },
    setUrl: function(value) {
        this.url = value;

        this._doLoad();
    },
    getUrl: function() {
        return this.url;
    },
    hideOnClick: true,
    setHideOnClick: function(value) {
        this.hideOnClick = value;
    },
    getHideOnClick: function() {
        return this.hideOnClick;
    },

    hideOnClick: true,
    setImgPath: function(value) {
        this.imgPath = value;
    },
    getImgPath: function() {
        return this.imgPath;
    },
    ////////////////////////////////////////
    _OnItemClick: function(item, htmlEvent) {
        var e = {
            item: item,
            isLeaf: !item.menu,
            htmlEvent: htmlEvent
        };
        if (this.hideOnClick) {
            if (this.isPopup) {
                this.hide();
            } else {
                if (e.isLeaf) {
                    this.hideItems();
                }
            }
        }

        if (this.allowSelectItem && this._selectedItem != item) {
            this.setSelectedItem(item);
        }

        this.fire('itemclick', e);
        if (this.ownerItem) {
        }
    },
    _OnItemSelect: function(item) {
        if (this._selectedItem) {
            this._selectedItem.removeCls(this._itemSelectedCls);
        }
        this._selectedItem = item;

        if (this._selectedItem) {
            this._selectedItem.addCls(this._itemSelectedCls);
        }

        var e = {
            item: this._selectedItem,
            isLeaf: this._selectedItem ? !this._selectedItem.menu : false
        };
        this.fire('itemselect', e);
    },
    onItemClick: function(fn, scope) {
        this.on('itemclick', fn, scope);
    },
    onItemSelect: function(fn, scope) {
        this.on('itemselect', fn, scope);
    },
    /////////////////////////////////////
    __OnTopMouseDown: function(e) {
        this._startScrollMove(-20);
    },
    __OnBottomMouseDown: function(e) {
        this._startScrollMove(20);
    },

    _getScrollWidth: function() {
        var self = this;
        var width = 0;

        var first = jQuery('.mini-menuitem', self.el).first()[0];
        var last = jQuery('.mini-menuitem', self.el).last()[0];
        if (first && last) {
            var box1 = mini.getBox(first);
            var box2 = mini.getBox(last);
            width = box2.right - box1.left;
        }

        return width;
    },

    _getMaxScrollLeft: function() {
        return parseInt(this._getScrollWidth() - this._innerEl.offsetWidth + 6);
    },

    _startScrollMove: function(value) {
        clearInterval(this._scrollTimer);
        var fn = function() {
            clearInterval(me._scrollTimer);
            mini.un(document, 'mouseup', fn);
        };
        mini.on(document, 'mouseup', fn);

        var scrollWidth = this._getMaxScrollLeft();

        var me = this;
        this._scrollTimer = setInterval(function() {
            if (me.isVertical() == false) {
                var left = me._innerEl.scrollLeft;
                left += value;
                if (left > scrollWidth) left = scrollWidth;
                //me._contentEl.scrollLeft += value;

                me._innerEl.scrollLeft = left;
            } else {
                me._contentEl.scrollTop += value;
            }
            //me._contentEl.scrollTop += value;
            //document.title = new Date().getTime();
        }, 50);
    },
    setToolbar: function(value) {
        __mini_setControls(value, this._toolbarEl, this);
        this._toolbarEl.style.display = 'block';
    },
    ////////////////////////////////////
    parseItems: function(nodes) {
        var data = [];
        for (var i = 0, l = nodes.length; i < l; i++) {
            var node = nodes[i];

            if (node.className == 'separator') {
                var o = { type: 'separator', id: node.id, name: node.name };
                data.add(o);
                continue;
            }

            var cnodes = mini.getChildNodes(node);

            var nodeItem = cnodes[0];
            var nodeChild = cnodes[1];

            var o = new mini.MenuItem();

            if (!nodeChild) {
                //o.applyTo(node);
                mini.applyTo.call(o, node);
                data.add(o);
                continue;
            }
            //o.applyTo(nodeItem);
            mini.applyTo.call(o, nodeItem);
            o.render(document.body);

            var menu = new mini.Menu();
            //menu.applyTo(nodeChild);
            mini.applyTo.call(menu, nodeChild);

            o.setMenu(menu);

            menu.render(document.body);
            //jQuery(node).remove();

            data.add(o);
        }
        return data.clone();
    },
    getAttrs: function(el) {
        var attrs = mini.Menu.superclass.getAttrs.call(this, el);
        var jq = jQuery(el);

        mini._ParseString(el, attrs, [
            'popupEl',
            'popupCls',
            'showAction',
            'hideAction',
            'xAlign',
            'yAlign',
            'modalStyle',
            'onbeforeopen',
            'open',
            'onbeforeclose',
            'onclose',
            'url',
            'onitemclick',
            'onitemselect',
            'textField',
            'idField',
            'parentField',
            'toolbar',
            'imgPath',
            'iconClsField',
            'menuAlign'
        ]);
        mini._ParseInt(el, attrs, ['minWidth']);
        mini._ParseBool(el, attrs, ['resultAsTree', 'hideOnClick', 'showNavArrow', 'showShadow', 'overflow']);

        //toobar
        var nodes = mini.getChildNodes(el);
        for (var i = nodes.length - 1; i >= 0; i--) {
            var node = nodes[i];
            var property = jQuery(node).attr('property');
            if (!property) continue;
            property = property.toLowerCase();
            if (property == 'toolbar') {
                attrs.toolbar = node;
                node.parentNode.removeChild(node);
            }
        }

        var nodes = mini.getChildNodes(el);

        var items = this.parseItems(nodes);
        if (items.length > 0) {
            attrs.items = items;
        }

        var vertical = jq.attr('vertical');
        if (vertical) {
            attrs.vertical = vertical == 'true' ? true : false;
        }
        var allowSelectItem = jq.attr('allowSelectItem');
        if (allowSelectItem) {
            attrs.allowSelectItem = allowSelectItem == 'true' ? true : false;
        }

        return attrs;
    }
});
mini.regClass(mini.Menu, 'menu');

/* MenuBar */
mini.MenuBar = function() {
    mini.MenuBar.superclass.constructor.apply(this, arguments);
};
mini.extend(mini.MenuBar, mini.Menu, {
    uiCls: 'mini-menubar',
    vertical: false,
    setVertical: function(value) {
        this.vertical = false;
    }
});
mini.regClass(mini.MenuBar, 'menubar');

/* ContextMenu */
mini.ContextMenu = function() {
    mini.ContextMenu.superclass.constructor.apply(this, arguments);
};
mini.extend(mini.ContextMenu, mini.Menu, {
    uiCls: 'mini-contextmenu',
    vertical: true,
    visible: false,
    _disableContextMenu: true,
    setVertical: function(value) {
        this.vertical = true;
    }
});
mini.regClass(mini.ContextMenu, 'contextmenu');

/* MenuItem */
mini.MenuItem = function() {
    mini.MenuItem.superclass.constructor.apply(this, arguments);
};
mini.extend(mini.MenuItem, mini.Control, {
    text: '',
    iconCls: '',
    iconStyle: '',
    iconPosition: 'left', //left/top

    img: '',

    showIcon: true,
    showAllow: true,

    checked: false,
    checkOnClick: false,
    groupName: '',

    _hoverCls: 'mini-menuitem-hover',
    _pressedCls: 'mini-menuitem-pressed',
    _checkedCls: 'mini-menuitem-checked',

    _clearBorder: false,

    menu: null,

    set: function(kv) {
        if (typeof kv == 'string') {
            return this;
        }

        this.ownerMenu = kv.ownerMenu;
        delete kv.ownerMenu;

        //        var checked = kv.checked;
        //        delete kv.checked;

        //        if (checked) this.setChecked(checked);

        //this.ownerMenu = kv.ownerMenu;
        //delete kv.ownerMenu;

        mini.MenuItem.superclass.set.call(this, kv);

        return this;
    },

    uiCls: 'mini-menuitem',
    _create: function() {
        var el = (this.el = document.createElement('div'));
        this.el.className = 'mini-menuitem';

        this.el.innerHTML = '<div class="mini-menuitem-inner"><span class="mini-menuitem-icon mini-icon mini-iconfont"></span><div class="mini-menuitem-text"></div><span class="mini-menuitem-allow mini-icon"></span></div>';
        this._innerEl = this.el.firstChild;
        this._iconEl = this._innerEl.firstChild;
        this._textEl = this._innerEl.childNodes[1];
        this.allowEl = this._innerEl.lastChild;
    },
    _initEvents: function() {
        mini_onOne(this.el, 'mouseover', this.__OnMouseOver, this);
    },
    _inputEventsInited: false,
    _initInputEvents: function() {
        if (this._inputEventsInited) return;
        this._inputEventsInited = true;

        mini_onOne(this.el, 'click', this.__OnClick, this);
        mini_onOne(this.el, 'mouseup', this.__OnMouseUp, this);

        mini_onOne(this.el, 'mouseout', this.__OnMouseOut, this);
    },
    destroy: function(removeEl) {
        //        if (this.el) {
        //            this.el.onmouseover = null
        //        }

        if (this.menu) this.menu.destroy();
        this.menu = this._innerEl = this._iconEl = this._textEl = this.allowEl = null;
        mini.MenuItem.superclass.destroy.call(this, removeEl);
    },
    within: function(e) {
        if (mini.isAncestor(this.el, e.target)) return true;
        if (this.menu && this.menu.within(e)) return true;
        return false;
    },
    _getIconImg: function() {
        //return this.img; //暂时不实现
        //if (this.img == 'download.gif') debugger;
        return this.img && this.getTopMenu() ? this.getTopMenu().imgPath + this.img : this.img;
    },
    _doUpdateIcon: function() {
        var img = this._getIconImg();
        var hasIcon = !!(this.iconStyle || this.iconCls || this.checkOnClick || img);
        if (this._iconEl) {
            mini.setStyle(this._iconEl, this.iconStyle);
            mini.addClass(this._iconEl, this.iconCls);

            //if(this.checked) debugger
            //img
            if (img && !this.checked) {
                var style = 'background-image:url(' + img + ')';
                mini.setStyle(this._iconEl, style);
            }

            if (this.checked) jQuery(this._iconEl).css({ 'background-image': '' });

            this._iconEl.style.display = hasIcon ?  'inline-block' : 'none';
        }
        if (this.iconPosition == 'top') {
            mini.addClass(this.el, 'mini-menuitem-icontop');
        } else {
            mini.removeClass(this.el, 'mini-menuitem-icontop');
        }
    },
    _hasChildMenu: function() {
        return this.menu && this.menu.items.length > 0;
    },
    doUpdate: function() {
        if (this._textEl) this._textEl.innerHTML = this.text;
        this._doUpdateIcon();

        if (this.checked) {
            this.iconCls = 'icon-check';
            this._doUpdateIcon();
            mini.addClass(this.el, this._checkedCls);

            //mini.setStyle(this._iconEl, "background-image:''");
            // jQuery(this._iconEl).css({ 'background-image': '' });
        } else {
            this.iconCls = '';
            this._doUpdateIcon();
            mini.removeClass(this.el, this._checkedCls);

        }
        if (this.allowEl) {
            if (this._hasChildMenu()) {
                this.allowEl.style.display = 'inline-block';
            } else {
                this.allowEl.style.display = 'none';
            }
        }
    },
    setText: function(value) {
        this.text = value;
        //this.doUpdate();
        if (this._textEl) this._textEl.innerHTML = this.text;
    },
    getText: function() {
        return this.text;
    },
    setIconCls: function(value) {
        mini.removeClass(this._iconEl, this.iconCls);
        this.iconCls = value;
        //this.doUpdate();
        this._doUpdateIcon();
    },
    getIconCls: function() {
        return this.iconCls;
    },
    setImg: function(value) {
        this.img = value;
        //this.doUpdate();
        this._doUpdateIcon();
    },
    getImg: function() {
        return this.img;
    },
    setIconStyle: function(value) {
        this.iconStyle = value;
        //this.doUpdate();
        this._doUpdateIcon();
    },
    getIconStyle: function() {
        return this.iconStyle;
    },
    setIconPosition: function(value) {
        this.iconPosition = value;
        //this.doUpdate();
        this._doUpdateIcon();
    },
    getIconPosition: function() {
        return this.iconPosition;
    },
    setCheckOnClick: function(value) {
        this.checkOnClick = value;
        if (value) {
            mini.addClass(this.el, 'mini-menuitem-showcheck');
        } else {
            mini.removeClass(this.el, 'mini-menuitem-showcheck');
        }
        this.doUpdate();
    },
    getCheckOnClick: function() {
        return this.checkOnClick;
    },
    setChecked: function(value) {
        if (this.checked != value) {
            this.checked = value;
            this.doUpdate();
            this.fire('checkedchanged');
        }
    },
    getChecked: function() {
        return this.checked;
    },
    setGroupName: function(value) {
        if (this.groupName != value) {
            this.groupName = value;
        }
    },
    getGroupName: function() {
        return this.groupName;
    },
    setChildren: function(value) {
        this.setMenu(value);
    },
    setMenu: function(value) {
        if (mini.isArray(value)) {
            value = {
                type: 'menu',
                items: value
            };
        }
        if (this.menu !== value) {
            value.ownerItem = this;
            this.menu = mini.getAndCreate(value);
            this.menu.hide();
            this.menu.ownerItem = this;
            this.doUpdate();
            this.menu.on('itemschanged', this.__OnItemsChanged, this);
        }
    },
    getMenu: function() {
        return this.menu;
    },

    showMenu: function() {
        if (this.menu && this.menu.isDisplay() == false) {
            this.menu.setHideAction('outerclick');

            var options = {
                xAlign: 'outright',
                yAlign: 'top',
                outXAlign: 'outleft',
                outYAlign: 'below',
                //xOffset: -1,
                popupCls: 'mini-menu-popup'
            };

            options.alwaysView = true;

            if (this.ownerMenu && this.ownerMenu.vertical == false) {
                options.xAlign = this.ownerMenu.menuAlign || 'left';
                options.yAlign = 'below';
                //options.outXAlign = null;
                options.outXAlign = 'right';
            }

            this.menu.showAtEl(this.el, options);

            this.menu.addCls('mini-menu-open');
        }
    },
    hideMenu: function() {
        if (this.menu) {
            this.menu.hide();
        }
    },
    hide: function() {
        this.hideMenu();
        this.setVisible(false);
    },

    __OnItemsChanged: function(e) {
        this.doUpdate();
    },
    getTopMenu: function() {
        if (this.ownerMenu) {
            if (this.ownerMenu.ownerItem) return this.ownerMenu.ownerItem.getTopMenu();
            else return this.ownerMenu;
        }
        return null;
    },
    ///////////////////////////
    __OnClick: function(e) {
        if (this.isReadOnly()) return;

        if (this.checkOnClick) {
            if (this.ownerMenu && this.groupName) {
                var groups = this.ownerMenu.getGroupItems(this.groupName);
                if (groups.length > 0) {
                    if (this.checked == false) {
                        for (var i = 0, l = groups.length; i < l; i++) {
                            var item = groups[i];
                            if (item != this) {
                                item.setChecked(false);
                            }
                        }
                        this.setChecked(true);
                    }
                } else {
                    this.setChecked(!this.checked);
                }
            } else {
                this.setChecked(!this.checked);
            }
        }

        this.fire('click');

        var topMenu = this.getTopMenu();
        if (topMenu) {
            topMenu._OnItemClick(this, e);
        }
    },
    __OnMouseUp: function(e) {
        if (this.isReadOnly()) return;

        if (this.ownerMenu) {
            var me = this;
            setTimeout(function() {
                if (me.isDisplay()) {
                    me.ownerMenu.showItemMenu(me);
                }
            }, 1);
        }
    },
    __OnMouseOver: function(e) {
        //if(this.text == "Ajax") debugger
        if (this.isReadOnly()) return;
        this._initInputEvents();
        mini.addClass(this.el, this._hoverCls);

        this.el.title = this.text;

        if (this._textEl.scrollWidth > this._textEl.clientWidth) {
            this.el.title = this.text;
        } else {
            this.el.title = '';
        }

        if (this.ownerMenu) {
            if (this.ownerMenu.isVertical() == true) {
                this.ownerMenu.showItemMenu(this);
            } else if (this.ownerMenu.hasShowItemMenu()) {
                this.ownerMenu.showItemMenu(this);
            }
        }
    },

    __OnMouseOut: function(e) {
        mini.removeClass(this.el, this._hoverCls);
    },
    onClick: function(fn, scope) {
        this.on('click', fn, scope);
    },
    onCheckedChanged: function(fn, scope) {
        this.on('checkedchanged', fn, scope);
    },
    ////////////////////////////////
    getAttrs: function(el) {
        var attrs = mini.MenuItem.superclass.getAttrs.call(this, el);
        var jq = jQuery(el);

        attrs.text = el.innerHTML;
        mini._ParseString(el, attrs, ['text', 'iconCls', 'iconStyle', 'iconPosition', 'groupName', 'onclick', 'oncheckedchanged']);
        mini._ParseBool(el, attrs, ['checkOnClick', 'checked']);

        return attrs;
    }
});
mini.regClass(mini.MenuItem, 'menuitem');

///////////////////////////////////////////
mini.Separator = function() {
    mini.Separator.superclass.constructor.apply(this, arguments);
};
mini.extend(mini.Separator, mini.Control, {
    _clearBorder: false,
    uiCls: 'mini-separator',
    _create: function() {
        this.el = document.createElement('span');
        this.el.className = 'mini-separator';
    }
});
mini.regClass(mini.Separator, 'separator');


mini.Pager = function () {
    mini.Pager.superclass.constructor.apply(this, arguments);
}
mini.extend(mini.Pager, mini.Control, {
    pageIndex: 0,
    pageSize: 10,
    totalCount: 0,
    totalPage: 0,

    showPageIndex: true,
    showPageSize: true,
    showTotalCount: true,

    showPageInfo: true,
    showReloadButton: true,

    _clearBorder: false,

    showButtonText: false,
    showButtonIcon: true,


    sizeText: '',
    firstText: epoint_local.Pager.firstText,
    prevText: epoint_local.Pager.prevText,
    nextText: epoint_local.Pager.nextText,
    lastText: epoint_local.Pager.lastText,
    reloadText: epoint_local.Pager.reloadText,

    pageInfoText: epoint_local.Pager.pageInfoText,
    sizeList: [10, 20, 50, 100],


    set: function (kv) {
        if (typeof kv == 'string') {
            return this;
        }

        var pageIndex = kv.pageIndex;
        delete kv.pageIndex;

        mini.Pager.superclass.set.call(this, kv);

        if (!mini.isNull(pageIndex)) {
            this.setPageIndex(pageIndex);
        }
        return this;
    },

    uiCls: "mini-pager",
    _create: function () {
        this.el = document.createElement("div");
        this.el.className = "mini-pager";


        var s = '<div class="mini-pager-left"><table cellspacing="0" cellpadding="0" border="0"><tr><td></td><td></td></tr></table></div><div class="mini-pager-right"></div>';

        if (isIE6 || isIE7) {
            s += '<div class="mini-clearfix"></div>';
            mini.addClass(this.el, "mini-clearfix");
        }

        this.el.innerHTML = s;

        this._leftEl = this.el.childNodes[0];
        this._rightEl = this.el.childNodes[1];

        //        this._barEl = this._leftEl.firstChild.rows[0].cells[0];
        //        this._barEl2 = this._leftEl.firstChild.rows[0].cells[1];

        var tds = this._leftEl.getElementsByTagName("td");
        this._barEl = tds[0];
        this._barEl2 = tds[1];


        this.sizeEl = mini.append(this._barEl, '<span class="mini-pager-size"></span>');

        this.sizeTextEl = mini.before(this.sizeEl, '<span class="mini-pager-sizetext"></span>');


        this.sizeCombo = new mini.ComboBox();
        //this.sizeCombo.setName("pagesize");       //name还挺难用的。
        if (this.pageSizeWidth) this.sizeCombo.setWidth(this.pageSizeWidth);
        this.sizeCombo.render(this.sizeEl);
        mini.append(this.sizeEl, '<span class="separator"></span>');

        this.firstButton = new mini.Button();
        this.firstButton.addCls("mini-pager-firstbutton");
        this.firstButton.render(this._barEl);

        this.prevButton = new mini.Button();
        this.prevButton.addCls("mini-pager-prevbutton");
        this.prevButton.render(this._barEl);

        this.indexEl = document.createElement("span");
        this.indexEl.className = 'mini-pager-index';
        this.indexEl.innerHTML = '<input type="text" class="mini-pager-num"/><span class="mini-pager-pages">/ 0</span>';
        this._barEl.appendChild(this.indexEl);

        this.numInput = this.indexEl.firstChild;
        this.pagesLabel = this.indexEl.lastChild;

        this.nextButton = new mini.Button();
        this.nextButton.addCls("mini-pager-nextbutton");
        this.nextButton.render(this._barEl);

        this.lastButton = new mini.Button();
        this.lastButton.addCls("mini-pager-lastbutton");
        this.lastButton.render(this._barEl);

        mini.append(this._barEl, '<span class="separator"></span>');

        this.reloadButton = new mini.Button();
        this.reloadButton.render(this._barEl);

        this.firstButton.setPlain(true);
        this.prevButton.setPlain(true);
        this.nextButton.setPlain(true);
        this.lastButton.setPlain(true);
        this.reloadButton.setPlain(true);


        this.buttonsEl = mini.append(this._barEl2, '<div class="mini-page-buttons"></div>');


        this.update();
    },

    destroy: function (removeEl) {
        if (this.pageSelect) {
            mini.clearEvent(this.pageSelect);
            this.pageSelect = null;
        }
        if (this.numInput) {
            mini.clearEvent(this.numInput);
            this.numInput = null;
        }
        this.sizeEl = this.sizeTextEl = this._barEl = this._barEl2 = this._leftEl = this._rightEl = this.indexEl = this.buttonsEl = null;

        mini.Pager.superclass.destroy.call(this, removeEl);
    },

    setButtons: function (value) {
        __mini_setControls(value, this.buttonsEl, this);
    },
    getButtonsEl: function () {
        return this.buttonsEl;
    },

    _initEvents: function () {

        mini.Pager.superclass._initEvents.call(this);

        this.firstButton.on("click", function (e) {
            this._OnPageChanged(0);
        }, this);
        this.prevButton.on("click", function (e) {
            this._OnPageChanged(this.pageIndex - 1);
        }, this);
        this.nextButton.on("click", function (e) {

            this._OnPageChanged(this.pageIndex + 1);
        }, this);
        this.lastButton.on("click", function (e) {
            this._OnPageChanged(this.totalPage);
        }, this);
        this.reloadButton.on("click", function (e) {
            this._OnPageChanged();
        }, this);


        function doPage() {
            if (changing) return;
            changing = true;
            var index = parseInt(this.numInput.value);
            if (isNaN(index)) {
                this.update();
            } else {
                this._OnPageChanged(index - 1);
            }
            setTimeout(function () {
                changing = false;
            }, 100);
        }

        var changing = false;
        mini.on(this.numInput, "change", function (e) {
            doPage.call(this);
        }, this);

        mini.on(this.numInput, "keydown", function (e) {
            if (e.keyCode == 13) {
                doPage.call(this);
                e.stopPropagation();
            }
        }, this);

        //mini.on(this.pageSelect, "change", this.__OnPageSelectChanged, this);
        this.sizeCombo.on("valuechanged", this.__OnPageSelectChanged, this);
    },
    doLayout: function () {
        if (!this.canLayout()) return;
        mini.layout(this._leftEl);
        mini.layout(this._rightEl);
    },
    setPageIndex: function (value) {
        if (isNaN(value)) return;
        this.pageIndex = value;
        this.update();
    },
    getPageIndex: function () {
        return this.pageIndex;
    },
    setPageSize: function (value) {
        if (isNaN(value)) return;
        this.pageSize = value;
        this.update();
    },
    getPageSize: function () {
        return this.pageSize;
    },
    setTotalCount: function (value) {
        value = parseInt(value);
        if (isNaN(value)) return;
        this.totalCount = value;
        this.update();
    },
    getTotalCount: function () {
        return this.totalCount;
    },
    setSizeList: function (value) {
        if (!mini.isArray(value)) return;
        this.sizeList = value;
        this.update();
    },
    getSizeList: function () {
        return this.sizeList;
    },

    pageSizeWidth: null,
    setPageSizeWidth: function (value) {
        value = parseInt(value);
        if (isNaN(value)) return;
        if (this.pageSizeWidth != value) {
            this.pageSizeWidth = value;
            this.sizeCombo.setWidth(value);
        }
    },
    getPageSizeWidth: function () {
        return this.pageSizeWidth;
    },


    setShowPageSize: function (value) {
        this.showPageSize = value;
        this.update();
    },
    getShowPageSize: function () {
        return this.showPageSize;
    },
    setShowPageIndex: function (value) {
        this.showPageIndex = value;
        this.update();
    },
    getShowPageIndex: function () {
        return this.showPageIndex;
    },
    setShowTotalCount: function (value) {
        this.showTotalCount = value;
        this.update();
    },
    getShowTotalCount: function () {
        return this.showTotalCount;
    },
    setShowPageInfo: function (value) {
        this.showPageInfo = value;
        this.update();
    },
    getShowPageInfo: function () {
        return this.showPageInfo;
    },
    setShowReloadButton: function (value) {
        this.showReloadButton = value;
        this.update();
    },
    getShowReloadButton: function () {
        return this.showReloadButton;
    },


    setShowButtonText: function (value) {
        this.showButtonText = value;
        this.update();
    },
    getShowButtonText: function () {
        return this.showButtonText;
    },
    setShowButtonIcon: function (value) {

        this.showButtonIcon = value;
        this.update();
    },
    getShowButtonIcon: function () {
        return this.showButtonIcon;
    },



    getTotalPage: function () {
        return this.totalPage;
    },
    update: function (index, size, total) {

        if (mini.isNumber(index)) this.pageIndex = parseInt(index);
        if (mini.isNumber(size)) this.pageSize = parseInt(size);
        if (mini.isNumber(total)) this.totalCount = parseInt(total);

        this.totalPage = parseInt(this.totalCount / this.pageSize) + 1;
        if ((this.totalPage - 1) * this.pageSize == this.totalCount) {
            this.totalPage -= 1;
        }
        if (this.totalCount == 0) this.totalPage = 0;

        if (this.totalCount >= 0) {
            if (this.pageIndex > this.totalPage - 1) {
                this.pageIndex = this.totalPage - 1;
            }
        }
        if (this.pageIndex <= 0) this.pageIndex = 0;
        if (this.totalPage <= 0) this.totalPage = 0;

        this.firstButton.enable();
        this.prevButton.enable();
        this.nextButton.enable();
        this.lastButton.enable();

        if (this.pageIndex == 0) {
            this.firstButton.disable();
            this.prevButton.disable();
        }
        if (this.pageIndex >= this.totalPage - 1) {
            this.nextButton.disable();
            this.lastButton.disable();
        }

        var pageIndex = this.pageIndex > -1 ? this.pageIndex + 1 : 0;
        if (this.totalCount == 0) pageIndex = 0;

        this.numInput.value = pageIndex;
        this.pagesLabel.innerHTML = "/ " + this.totalPage;

        var sizeList = this.sizeList.clone();
        if (sizeList.indexOf(this.pageSize) == -1) {
            sizeList.push(this.pageSize);
            sizeList = sizeList.sort(function (a, b) {
                return a > b;
            });
        }
        var sizes = [];
        for (var i = 0, l = sizeList.length; i < l; i++) {
            var num = sizeList[i];
            var option = {};
            option.text = num;
            option.id = num;
            sizes.push(option);
        }
        this.sizeCombo.setData(sizes);
        this.sizeCombo.setValue(this.pageSize);


        this.sizeTextEl.innerHTML = this.sizeText;
        this.sizeTextEl.style.display = this.sizeText ? "" : "none";

        var firstText = this.firstText, prevText = this.prevText, nextText = this.nextText, lastText = this.lastText, reloadText = this.reloadText;
        if (this.showButtonText == false) {
            firstText = prevText = nextText = lastText = reloadText = "";
        }
        this.firstButton.setText(firstText);
        this.prevButton.setText(prevText);
        this.nextButton.setText(nextText);
        this.lastButton.setText(lastText);
        this.reloadButton.setText(reloadText);

        var firstText = this.firstText, prevText = this.prevText, nextText = this.nextText, lastText = this.lastText;
        if (this.showButtonText) {
            this.firstButton.setTooltip(firstText);
            this.prevButton.setTooltip(prevText);
            this.nextButton.setTooltip(nextText);
            this.lastButton.setTooltip(lastText);
            this.reloadButton.setTooltip(reloadText);
        }

        this.firstButton.setIconCls(this.showButtonIcon ? "mini-pager-first" : "");
        this.prevButton.setIconCls(this.showButtonIcon ? "mini-pager-prev" : "");
        this.nextButton.setIconCls(this.showButtonIcon ? "mini-pager-next" : "");
        this.lastButton.setIconCls(this.showButtonIcon ? "mini-pager-last" : "");
        this.reloadButton.setIconCls(this.showButtonIcon ? "mini-pager-reload" : "");
        this.reloadButton.setVisible(this.showReloadButton);

        var s = this.reloadButton.el.previousSibling;
        if (s) {
            s.style.display = this.showReloadButton ? "" : "none";
        }


        this._rightEl.innerHTML = String.format(this.pageInfoText, this.pageSize, this.totalCount);

        this.indexEl.style.display = this.showPageIndex ? "" : "none";
        this.sizeEl.style.display = this.showPageSize ? "" : "none";
        this._rightEl.style.display = this.showPageInfo ? "" : "none";


        //@新增：用于处理 totalPage < 0 的场合
        this.firstButton.setVisible(this.totalCount >= 0);
        this.lastButton.setVisible(this.totalCount >= 0);

        if (this.totalCount < 0) {
            this.firstButton.enable();
            this.nextButton.enable();
            if (this.pageIndex == 0) {
                this.firstButton.disable();
            }
            //this.indexEl.style.display = "none";
        }
    },
    __OnPageSelectChanged: function (e) {
        var size = parseInt(this.sizeCombo.getValue());
        this._OnPageChanged(0, size);
    },
    _OnPageChanged: function (index, size) {

        var e = {
            pageIndex: mini.isNumber(index) ? index : this.pageIndex,
            pageSize: mini.isNumber(size) ? size : this.pageSize,
            cancel: false
        };

        if (this.totalCount >= 0) {
            if (e.pageIndex > this.totalPage - 1) {
                e.pageIndex = this.totalPage - 1;
            }
        }
        if (e.pageIndex < 0) e.pageIndex = 0;

        this.fire("beforepagechanged", e);
        if (e.cancel == true) {
            return;
        }

        this.fire("pagechanged", e);
        this.update(e.pageIndex, e.pageSize);

    },
    onPageChanged: function (fn, scope) {
        this.on("pagechanged", fn, scope);
    },
    getAttrs: function (el) {
        var attrs = mini.Pager.superclass.getAttrs.call(this, el);

        mini._ParseString(el, attrs,
            ["onpagechanged", "sizeList", "onbeforepagechanged", "buttons", "sizeText"
                ]
        );
        mini._ParseBool(el, attrs,
            ["showPageIndex", "showPageSize", "showTotalCount", "showPageInfo", "showReloadButton", "showButtonText", "showButtonIcon"
                ]
        );
        mini._ParseInt(el, attrs,
            ["pageIndex", "pageSize", "totalCount", "pageSizeWidth"
                ]
        );
        //        var cs = mini.getChildNodes(el, true);
        //        attrs.body = cs;

        if (typeof attrs.sizeList == "string") {
            attrs.sizeList = window["ev" + "al"](attrs.sizeList);
        }
        if (attrs.buttons) {
            attrs.buttons = mini.byId(attrs.buttons);

        }



        return attrs;
    }

});
mini.regClass(mini.Pager, "pager");

mini.DataBinding = function () {
    this._bindFields = [];
    this._bindForms = [];
    mini.DataBinding.superclass.constructor.apply(this, arguments);
}
mini.extend(mini.DataBinding, mini.Component, {
    bindField: function (control, source, field, mode, convert) {
        control = mini.get(control);
        source = mini.get(source);
        if (!control || !source || !field) return;
        var bind = { control: control, source: source, field: field, convert: convert, mode: mode };
        this._bindFields.push(bind);

        source.on("currentchanged", this.__OnCurrentChanged, this);
        control.on("valuechanged", this.__OnValueChanged, this);
    },
    bindForm: function (form, source, mode, convert) {
        form = mini.byId(form);
        source = mini.get(source);
        if (!form || !source) return;

        var form = new mini.Form(form);
        var controls = form.getFields();
        for (var i = 0, l = controls.length; i < l; i++) {
            var control = controls[i];
            this.bindField(control, source, control.getName(), mode, convert);
        }
    },
    //////////////////////////////////////////////////
    __OnCurrentChanged: function (e) {
        if (this._doSetting) return;
        this._doSetting = true;

        this._currentRecord = e.record;

        var source = e.sender;
        var record = e.record;

        //field
        for (var i = 0, l = this._bindFields.length; i < l; i++) {
            var bind = this._bindFields[i];
            if (bind.source != source) continue;

            var control = bind.control;
            var field = bind.field;
            if (control.setValue) {
                if (record) {
                    //var value = record[field];
                    var value = mini._getMap(field, record);
                    control.setValue(value);
                } else {
                    control.setValue("");
                }
            }

            if (control.setText && control.textName) {
                if (record) {
                    control.setText(record[control.textName]);
                } else {
                    control.setText("");
                }
            }
        }

        var me = this;
        setTimeout(function () {
            me._doSetting = false;
        }, 10);
    },
    __OnValueChanged: function (e) {

        if (this._doSetting) return;
        this._doSetting = true;

        var control = e.sender;
        var value = control.getValue();


        //field
        for (var i = 0, l = this._bindFields.length; i < l; i++) {
            var bind = this._bindFields[i];

            if (bind.control != control || bind.mode === false) continue;
            var source = bind.source;
            var current = this._currentRecord; //source.getCurrent();
            if (!current) continue;

            var obj = {};
            obj[bind.field] = value;

            if (control.getText && control.textName) {
                obj[control.textName] = control.getText();
            }

            source.updateRow(current, obj);

        }

        var me = this;
        setTimeout(function () {
            me._doSetting = false;
        }, 10);
    }
});
mini.regClass(mini.DataBinding, "databinding");

mini.DataSet = function () {
    this._sources = {};
    this._data = {};
    this._links = [];

    this._originals = {};

    mini.DataSet.superclass.constructor.apply(this, arguments);
}
mini.extend(mini.DataSet, mini.Component, {
    add: function (name, listControl) {
        if (!name || !listControl) return;
        this._sources[name] = listControl;

        this._data[name] = [];

        //自动创建新行id
        listControl._set_autoCreateNewID(true);
        listControl._set_originalIdField(listControl.getIdField());
        listControl._set_clearOriginals(false);

        listControl.on("addrow", this.__OnRowChanged, this);
        listControl.on("updaterow", this.__OnRowChanged, this);
        listControl.on("deleterow", this.__OnRowChanged, this);
        listControl.on("removerow", this.__OnRowChanged, this);
        listControl.on("preload", this.__OnDataPreLoad, this);

        listControl.on("selectionchanged", this.__OnDataSelectionChanged, this);
    },
    addLink: function (name, childName, parentField) {
        if (!name || !childName || !parentField) return;
        if (!this._sources[name] || !this._sources[childName]) return;

        var link = {
            parentName: name,
            childName: childName,
            parentField: parentField
        };
        this._links.push(link);
    },
    clearData: function () {
        this._data = {};
        this._originals = {};
        for (var name in this._sources) {
            this._data = [];
        }
    },
    getData: function () {
        return this._data;
    },
    _getNameByListControl: function (listControl) {
        for (var name in this._sources) {
            var c = this._sources[name];
            if (c == listControl) return name;
        }
    },
    _getRecord: function (name, record, idField) {
        var rows = this._data[name];
        if (!rows) return false;
        for (var i = 0, l = rows.length; i < l; i++) {
            var row = rows[i];
            if (row[idField] == record[idField]) return row;
        }
        return null;
    },
    /////////////////////////////////////
    __OnRowChanged: function (e) {
        var type = e.type;
        var record = e.record;
        var name = this._getNameByListControl(e.sender);

        var oldRow = this._getRecord(name, record, e.sender.getIdField());

        var rows = this._data[name];
        if (oldRow) {
            var rows = this._data[name];
            rows.remove(oldRow);
        }
        //

        //原来的
        //        if (type == "removerow" && record._state == "added") {
        //        } else {
        //            rows.push(record);
        //        }
        
        if (type == "removerow" && record._state == "added") {
        } else {

            if (type == "beforeremove" && record._state == "added") {       //@ 2017-7-12 
            } else {
                rows.push(record);
            }
        }

        //        if (record._state == "added") {
        //            if (!oldRow) {
        //                rows.push(record);
        //            }
        //        }
        //        if (record._state == "modified") {
        //            rows.push(record);
        //        }
        //        if (record._state == "removed") {
        //            rows.push(record);
        //        }
        //        if (record._state == "deleted") {
        //            rows.push(record);
        //        }

        //this._originals[name] = e.sender._originals;
        this._originals[name] = e.sender._get_originals();

        //处理_parent
        if (record._state == "added") {
            var parentSource = this._getParentSource(e.sender);
            if (parentSource) {
                var current = parentSource.getSelected();
                if (current) {
                    record._parentId = current[parentSource.getIdField()];
                } else {
                    rows.remove(record);    //如果有父source，必须有current才能加入
                }
            }
        }
    },
    __OnDataPreLoad: function (e) {
        var source = e.sender;
        var name = this._getNameByListControl(source);
        var idField = e.sender.getIdField();

        var rows = this._data[name];
        var maps = {};
        for (var i = 0, l = rows.length; i < l; i++) {
            var row = rows[i];
            maps[row[idField]] = row;
        }

        //修改的记录：对应ID为idField！
        var ors = this._originals[name]

        if (ors) {

            //source._originals = ors;
            source._set_originals(ors);
        }

        //数据更新: modified, delete, 
        var nowData = e.data || [];
        for (var i = 0, l = nowData.length; i < l; i++) {
            var row = nowData[i];
            var old = maps[row[idField]];
            if (old) {
                delete old._uid;
                mini.copyTo(row, old);
            }
        }

        //added
        var parentSource = this._getParentSource(source);

        if (source.getPageIndex && source.getPageIndex() == 0) {
            var adds = [];
            for (var i = 0, l = rows.length; i < l; i++) {
                var row = rows[i];
                if (row._state == "added") {
                    if (parentSource) {
                        var current = parentSource.getSelected();
                        if (current && current[parentSource.getIdField()] == row._parentId) {
                            adds.push(row);
                        }
                    } else {
                        adds.push(row);
                    }
                }
            }
            adds.reverse();
            nowData.insertRange(0, adds);
        }

        //removed
        var removes = [];
        for (var i = nowData.length - 1; i >= 0; i--) {
            var row = nowData[i];
            var old = maps[row[idField]];
            if (old && old._state == "removed") {
                nowData.removeAt(i);
                removes.push(old);
            }
        }


        //如果source有前置source，则需要根据id来对应记录。。。

    },
    /////////////////////////////////////////
    _getParentSource: function (source) {
        var childName = this._getNameByListControl(source);
        for (var i = 0, l = this._links.length; i < l; i++) {
            var link = this._links[i];
            if (link.childName == childName) {
                return this._sources[link.parentName];
            }
        }
    },
    _getLinks: function (source) {
        var name = this._getNameByListControl(source);
        var links = [];
        for (var i = 0, l = this._links.length; i < l; i++) {
            var link = this._links[i];
            if (link.parentName == name) {
                links.push(link);
            }
        }
        return links;
    },
    __OnDataSelectionChanged: function (e) {
        var grid1 = e.sender;
        var record = grid1.getSelected();

        var links = this._getLinks(grid1);
        for (var i = 0, l = links.length; i < l; i++) {
            var link = links[i];
            var grid2 = this._sources[link.childName];

            if (record) {
                var args = {};
                args[link.parentField] = record[grid1.getIdField()];
                grid2.load(args);
            } else {
                grid2.loadData([]);
            }
        }
    }
});
mini.regClass(mini.DataSet, "dataset");
/*

1.getSource()           原始数据。数据结构：数组、树形。
2.getList()             原始数据。数据结构：数组。（树形转为数组）
3.getDataView()         数据视图。客户端排序、过滤后。数据结构：数组。
4.getVisibleRows()      可视数据视图。在DataView基础上，增加了树折叠处理。

*/

if (typeof mini_doload == "undefined") {
    mini_doload = function(e) {

        //e.result = mini.decode(e.text);

    }
}

mini.DataSource = function() {
    mini.DataSource.superclass.constructor.apply(this, arguments);
    this._init();
};
mini.extend(mini.DataSource, mini.Component, {
    idField: "id",
    textField: "text",

    loaded: false,

    destroy: function() {
        this.source = [];
        this.dataview = [];
        this.visibleRows = null;
        this.list = null;

        this._ids = {};
        this._removeds = [];
        if (this._clearOriginals) {
            this._originals = {};
        }
        this._errors = {};

        this._selected = null;
        this._selecteds = [];
        this._idSelecteds = {};

        this._filterInfo = null;
        this._sortInfo = null;

        this.root = { _id: -1, _level: -1 };
        this.viewNodes = null;
        this.dataview = null;
        this.visibleRows = null;
        this.list = null;

        mini.DataSource.superclass.destroy.call(this);
    },

    _originalIdField: "_id",
    _clearOriginals: true,
    _autoCreateNewID: false,
    _init: function() {
        this.source = [];
        this.dataview = [];
        this.visibleRows = null;
        this.list = null;

        this._ids = {};
        this._removeds = [];
        if (this._clearOriginals) {
            this._originals = {};
        }
        this._errors = {};

        this._selected = null;
        this._selecteds = [];
        this._idSelecteds = {};

        this.__changeCount = 0;
    },
    getSource: function() {
        return this.source;
    },
    getList: function() {
        return this.source.clone();
        //return this.source;
    },
    getDataView: function() {
        return this.dataview.clone();
        //return this.dataview;
    },
    getVisibleRows: function() {
        //可以根据row的_visible，显示或隐藏
        if (!this.visibleRows) {

            this.visibleRows = this.getDataView().clone();
        }
        return this.visibleRows;
    },
    setData: function(data) {
        this.loadData(data);
    },
    loadData: function(data) {
        if (!mini.isArray(data)) data = [];
        //        var e = {
        //            data: data,
        //            cancel: false
        //        };
        //        this.fire("beforeloaddata", e);
        //        if (e.cancel == true) return false;

        this._init();
        this._doLoadData(data);

        this._dataChanged("loaddata");
        this.fire("loaddata");
        return true;
    },
    _doLoadData: function(data) {
        this.source = data;
        this.dataview = data;

        var ds = this.source,
            ids = this._ids;
        for (var i = 0, l = ds.length; i < l; i++) {
            var record = ds[i];
            //if (!record._id) record._id = mini.DataSource.RecordId++;
            record._id = mini.DataSource.RecordId++;
            ids[record._id] = record;

            //历史问题
            record._uid = record._id;
        }
    },
    clearData: function() {
        this._init();
        this._dataChanged();
        this.fire("cleardata");
    },
    clear: function() {
        this.clearData();
    },
    //updateRecord(record, field, value);
    //updateRecord(record, keyValues);
    updateRecord: function(record, field, value) {
        if (mini.isNull(record)) return;
        var getMap = mini._getMap,
            setMap = mini._setMap;

        this.fire("beforeupdate", { record: record });

        if (typeof field == 'string') {
            //var oldValue = record[field];
            var oldValue = getMap(field, record); //record[p];
            if (mini.isEquals(oldValue, value)) {
                //this.endChange(false);
                return false;
            }
            this.beginChange();
            //record[field] = value;
            setMap(field, value, record);
            this._setModified(record, field, oldValue);
            this.endChange();
            //this._dataChanged();
            //this.ValidateCell(record, field);
        } else {
            this.beginChange();
            for (var p in field) {
                var oldValue = getMap(p, record); //record[p];
                var value = field[p];
                if (mini.isEquals(oldValue, value)) continue;
                //record[p] = value;
                setMap(p, value, record);
                this._setModified(record, p, oldValue);
            }
            this.endChange("update");
            //this.ValidateRecord(record);
        }

        this.fire("update", { record: record });
    },
    deleteRecord: function(record) {
        this._setDeleted(record);

        this._dataChanged();
        this.fire("delete", { record: record });
    },
    getby_id: function(id) {
        id = typeof id == "object" ? id._id : id;
        return this._ids[id];
    },
    getbyId: function(id) {
        var t = typeof id;
        if (t == "number") return this.getAt(id);
        if (typeof id == "object") {
            if (this.getby_id(id)) return id;
            id = id[this.idField];
        }
        //!!!
        id = String(id);

        var idMap = this.ids;
        if (!idMap) {
            idMap = this.ids = {};
            var data = this.getList();
            for (var i = 0, l = data.length; i < l; i++) {
                var o = data[i];
                var oid = o[this.idField];
                if (!mini.isNull(oid)) idMap[oid] = o;
            }
        }
        return idMap[id];
    },

    //    getbyId: function (id) {
    //        var t = typeof id;
    //        if (t == "number") return this.getAt(id);
    //        if (typeof id == "object") {
    //            if (this.getby_id(id)) return id;
    //            id = id[this.idField];
    //        }
    //        var data = this.getList();
    //        id = String(id);
    //        for (var i = 0, l = data.length; i < l; i++) {
    //            var o = data[i];
    //            var _id = !mini.isNull(o[this.idField]) ? String(o[this.idField]) : null;
    //            if (_id == id) return o;
    //        }
    //        return null;
    //    },
    getsByIds: function(value) {
        if (mini.isNull(value)) value = "";
        value = String(value);
        var nodes = [];
        var ids = String(value).split(",");
        for (var i = 0, l = ids.length; i < l; i++) {
            var node = this.getbyId(ids[i]);
            if (node) nodes.push(node);
        }
        return nodes;
    },
    getRecord: function(id) {
        if (typeof id == 'object') return id;
        return this.getRow(id);
    },
    getRow: function(index) {
        var t = typeof index;
        if (t == "string") return this.getbyId(index);
        else if (t == "number") return this.getAt(index);
        else if (t == "object") return index;
    },
    delimiter: ",",
    getValueAndText: function(records, delimiter) {
        if (mini.isNull(records)) records = [];
        delimiter = delimiter || this.delimiter;

        if (typeof records == "string" || typeof records == "number") {
            records = this.getsByIds(records);
        } else if (!mini.isArray(records)) {
            records = [records];
        }
        var values = [];
        var texts = [];
        for (var i = 0, l = records.length; i < l; i++) {
            var record = records[i];
            if (record) {
                values.push(this.getItemValue(record));
                texts.push(this.getItemText(record));
            }
        }

        return [values.join(delimiter), texts.join(delimiter)];
    },
    getItemValue: function(item) {
        if (!item) return "";
        var t = mini._getMap(this.idField, item);
        return mini.isNull(t) ? '' : String(t);
    },
    getItemText: function(item) {
        if (!item) return "";
        //var t = item[this.textField];
        var t = mini._getMap(this.textField, item);
        return mini.isNull(t) ? '' : String(t);
    },
    ////////////////////////////
    //getOriginalValue: function(record, field)
    isModified: function(reocrd, field) {
        var or = this._originals[reocrd[this._originalIdField]];
        if (!or) return false;
        if (mini.isNull(field)) return false;
        return or.hasOwnProperty(field);
    },
    hasRecord: function(record) {
        return !!this.getby_id(record);
    },
    findRecords: function(property, value) {
        var ifFn = typeof property == "function";
        var fn = property;
        var scope = value || this;
        var data = this.source;
        var records = [];
        for (var i = 0, l = data.length; i < l; i++) {
            var o = data[i];
            if (ifFn) {
                var ret = fn.call(scope, o);
                if (ret == true) {
                    records[records.length] = o;
                }
                if (ret === 1) break;
            } else {
                if (o[property] == value) {
                    records[records.length] = o;
                }


            }
        }
        return records;
    },
    findRecord: function(property, value) {
        var records = this.findRecords(property, value);
        return records[0];
    },
    each: function(fn, scope) {
        var data = this.getDataView().clone();
        scope = scope || this;
        mini.forEach(data, fn, scope);
    },
    getCount: function() {
        return this.getDataView().length;
        //return this.dataview.length;
    },
    setIdField: function(value) {
        this.idField = value;
    },
    setTextField: function(value) {
        this.textField = value;
    },
    /////////////////////////////////////////////////////
    __changeCount: 0,
    beginChange: function() {
        this.__changeCount++;
    },
    endChange: function(action, raise) {
        this.__changeCount--;
        if (this.__changeCount < 0) this.__changeCount = 0;
        if ((raise !== false && this.__changeCount == 0) || raise == true) {
            this.__changeCount = 0;
            this._dataChanged(action);
        }
    },
    _dataChanged: function(action) {
        this.ids = null; //!!!
        this.visibleRows = null;
        this.list = null;
        if (this.__changeCount == 0) {
            this.fire("datachanged");
        }
    },
    /////////////////////////////////////////////////////
    //记录状态修改
    _setAdded: function(record) {
        record._id = mini.DataSource.RecordId++;

        //自动创建idField
        if (this._autoCreateNewID && !record[this.idField]) {
            record[this.idField] = mini.UUID();
        }

        //历史问题
        record._uid = record._id;

        //if (!record._id) record._id = mini.DataSource.RecordId++;
        record._state = "added";
        this._ids[record._id] = record;
        delete this._originals[record[this._originalIdField]];
    },
    _setModified: function(record, field, oldValue) {
        if (record._state != "added" &&
            record._state != "deleted" &&
            record._state != "removed"
        ) {
            record._state = "modified";
            var or = this._getOriginal(record);
            if (!or.hasOwnProperty(field)) {
                or[field] = oldValue;
            }
        }
    },
    _setDeleted: function(record) {
        if (record._state != "added" &&
            record._state != "deleted" &&
            record._state != "removed"
        ) {
            record._state = "deleted";
        }
    },
    _setRemoved: function(record) {
        delete this._ids[record._id];
        if (record._state != "added" && record._state != "removed") {
            record._state = "removed";
            delete this._originals[record[this._originalIdField]];
            this._removeds.push(record);
        }
    },
    _getOriginal: function(record) {
        var rid = record[this._originalIdField];
        var or = this._originals[rid];
        if (!or) {
            or = this._originals[rid] = {};
        }
        return or;
    },
    /////////////////////////////////////////////////////    
    _selected: null, //current
    _selecteds: [],
    _idSelecteds: null,
    multiSelect: false,
    isSelected: function(id) {
        if (!id) return false;
        if (typeof id != "string") id = id._id;
        return !!this._idSelecteds[id];
    },
    setSelected: function(record) { //@@不开放
        record = this.getby_id(record);
        var selected = this.getSelected();
        if (selected != record) {
            this._selected = record;
            if (record) {
                this.select(record);
            } else {
                this.deselect(this.getSelected());
            }
            //this.fire("currentchanged"); //选择、修改、删除，都是currentchanged
            this._OnCurrentChanged(record);
        }
    },
    getSelected: function() {
        if (this.isSelected(this._selected)) return this._selected;
        return this._selecteds[0];
    },
    setCurrent: function(record) {
        this.setSelected(record);
    },
    getCurrent: function() {
        return this.getSelected();
    },
    getSelecteds: function() {
        return this._selecteds.clone();
    },
    select: function(record, fireEvent) {
        if (mini.isNull(record)) return;
        this.selects([record], fireEvent);
    },
    deselect: function(record, fireEvent) {
        if (mini.isNull(record)) return;

        this.deselects([record], fireEvent);
    },
    selectAll: function(fireEvent) {
        this.selects(this.getList(), fireEvent);
    },
    deselectAll: function(fireEvent) {
        this.deselects(this.getSelecteds(), fireEvent);
    },
    _fireSelect: function(record, name) {
        var e = { record: record, cancel: false };
        this.fire(name, e);
        return !e.cancel;
    },
    selects: function(records, fireEvent) {
        if (!mini.isArray(records)) return;
        records = records.clone();

        //single select
        if (this.multiSelect == false) {
            this.deselects(this.getSelecteds());
            if (records.length > 0) records.length = 1;
            this._selecteds = [];
            this._idSelecteds = {};
        }

        var _records = [];
        for (var i = 0, l = records.length; i < l; i++) {
            var record = this.getbyId(records[i]);
            //var record = records[i];
            if (!record) continue;
            if (!this.isSelected(record)) {

                if (fireEvent !== false) {

                    if (!this._fireSelect(record, 'beforeselect')) continue;
                }

                this._selecteds.push(record);
                this._idSelecteds[record._id] = record;
                _records.push(record);
                if (fireEvent !== false) {
                    this.fire("select", { record: record });
                }
            }
        }
        this._OnSelectionChanged(records, true, _records, fireEvent);
    },
    deselects: function(records, fireEvent) {

        if (!mini.isArray(records)) return;
        records = records.clone();
        var _records = [];
        for (var i = records.length - 1; i >= 0; i--) {
            var record = this.getbyId(records[i]);
            if (!record) continue;
            if (this.isSelected(record)) {
                if (fireEvent !== false) {
                    if (!this._fireSelect(record, 'beforedeselect')) continue;
                }

                //this._selecteds.remove(record);   //优化性能
                delete this._idSelecteds[record._id];
                _records.push(record);

                //                if (fireEvent !== false) {
                //                    this.fire("deselect", { record: record });
                //                }
            }
        }
        //_selecteds
        this._selecteds = [];
        var _idSelecteds = this._idSelecteds;
        for (var i in _idSelecteds) {
            var o = _idSelecteds[i];
            if (o._id) this._selecteds.push(o);
        }

        //deselect在这里激发
        for (var i = records.length - 1; i >= 0; i--) {
            var record = this.getbyId(records[i]);
            if (!record) continue;

            if (fireEvent !== false) {
                this.fire("deselect", { record: record });
            }

        }
        this._OnSelectionChanged(records, false, _records, fireEvent);
    },
    _OnSelectionChanged: function(records, select, _records, fireEvent) {
        var e = {
            fireEvent: fireEvent,
            records: records,
            select: select,
            selected: this.getSelected(),
            selecteds: this.getSelecteds(),
            _records: _records
        };
        this.fire("SelectionChanged", e);

        var current = this._current;
        var now = this.getCurrent();
        if (current != now) {
            this._current = now;
            this._OnCurrentChanged(now);
        }
    },
    _OnCurrentChanged: function(record) {
        if (this._currentTimer) {
            clearTimeout(this._currentTimer);
        }
        var me = this;
        this._currentTimer = setTimeout(function() {
            me._currentTimer = null;
            var e = { record: record };
            me.fire("CurrentChanged", e);
        }, 30);
    },
    _checkSelecteds: function() {
        for (var i = this._selecteds.length - 1; i >= 0; i--) {
            var record = this._selecteds[i];
            var r = this.getby_id(record._id);
            if (!r) {
                this._selecteds.removeAt(i);
                delete this._idSelecteds[record._id];
            }
        }
        if (this._selected && this.getby_id(this._selected._id) == null) {
            this._selected = null;
        }
    },
    setMultiSelect: function(value) {
        if (this.multiSelect != value) {
            this.multiSelect = value;
            if (value == false) {
                //...
            }
        }
    },
    getMultiSelect: function() {
        return this.multiSelect;
    },
    selectPrev: function() {
        var record = this.getSelected();
        if (!record) {
            record = this.getAt(0);
        } else {
            var index = this.indexOf(record);
            record = this.getAt(index - 1);
        }
        if (record) {
            this.deselectAll();
            this.select(record);
            this.setCurrent(record);
        }
    },
    selectNext: function() {
        var record = this.getSelected();
        if (!record) {
            record = this.getAt(0);
        } else {
            var index = this.indexOf(record);
            record = this.getAt(index + 1);
        }
        if (record) {
            this.deselectAll();
            this.select(record);
            this.setCurrent(record);
        }
    },
    selectFirst: function() {
        var record = this.getAt(0);
        if (record) {
            this.deselectAll();
            this.select(record);
            this.setCurrent(record);
        }
    },
    selectLast: function() {
        var data = this.getVisibleRows();
        var record = this.getAt(data.length - 1);
        if (record) {
            this.deselectAll();
            this.select(record);
            this.setCurrent(record);
        }
    },
    getSelectedsId: function(delimiter) {
        var nodes = this.getSelecteds();
        var vts = this.getValueAndText(nodes, delimiter);
        return vts[0];
    },
    getSelectedsText: function(delimiter) {
        var nodes = this.getSelecteds();
        var vts = this.getValueAndText(nodes, delimiter);
        return vts[1];
    },
    ////////////////////////////////////////    
    _filterInfo: null,
    _sortInfo: null,
    filter: function(fn, scope) {

        if (typeof fn != "function") return;
        scope = scope || this;

        this._filterInfo = [fn, scope];
        //alert(this.getVisibleRows().length);
        this._doFilter();
        //alert(this.getVisibleRows().length);
        this._doSort();

        this._dataChanged();

        this.fire("filter");
    },
    clearFilter: function() {
        if (!this._filterInfo) return;
        this._filterInfo = null;
        this._doFilter();
        this._doSort();
        this._dataChanged();
        this.fire("filter");
    },
    sort: function(fn, scope, reverse) {
        if (typeof fn != "function") return;
        scope = scope || this;
        this._sortInfo = [fn, scope, reverse];
        this._doSort();
        this._dataChanged();
        this.fire("sort");
    },
    clearSort: function() {
        this._sortInfo = null;

        this.sortField = this.sortOrder = "";

        this._doFilter();
        this._dataChanged();

        if (this.sortMode == "server") {
            var params = this.getLoadParams();
            params.sortField = "";
            params.sortOrder = "";
            //params.pageIndex = this.pageIndex;
            this.load(params);
        } else {

        }

        this.fire("filter");
    },

    _sortMulti: function(fields) {
        //...
    },

    _doClientSortField: function(sortField, sortOrder, dataType) {

        //        if (!dataType) {
        //            var first = this.getAt(0);
        //            if (first) {
        //                var value = first[sortField];

        //                if (mini.isDate(value)) {
        //                    dataType = "date";
        //                } else if (mini.isNumber(value)) {
        //                    dataType = "float";
        //                } else {
        //                    dataType = "string";
        //                }
        //            }
        //        }

        var sortFn = this._getSortFnByField(sortField, dataType);
        if (!sortFn) return;

        //        this.sortField = sortField;
        //        this.sortOrder = sortOrder;

        //debugger
        var reverse = sortOrder == "desc";
        this.sort(sortFn, this, reverse);
    },
    _getSortFnByField: function(field, sortType) {
        //默认逻辑：从小到大

        if (!field) return null;
        var sortFn = null;
        var typeFn = mini.sortTypes[sortType];
        if (!typeFn) typeFn = mini.sortTypes["string"];

        function sortBy(a, b) {

            var a1 = mini._getMap(field, a),
                b1 = mini._getMap(field, b);

            var nullA = mini.isNull(a1) || a1 === "";
            var nullB = mini.isNull(b1) || b1 === "";
            if (nullA) return 0;
            if (nullB) return 1;

            if (sortType == "chinese") {
                return a1.localeCompare(b1, "zh");
            }

            var v1 = typeFn(a1);
            var v2 = typeFn(b1);
            if (v1 > v2) return 1; //从小到大：前面比后面小，则互换
            else return 0;
            //            else if (v1 == v2) return 0;
            //            else return 0;
        }

        sortFn = sortBy;
        return sortFn;
    },
    ////////////////////////////////////////////////////////////////////
    // Pager Load
    ////////////////////////////////////////////////////////////////////


    ajaxOptions: null,
    autoLoad: false,
    url: "",

    pageSize: 10,
    pageIndex: 0,
    totalCount: 0,
    totalPage: 0,

    sortField: "",
    sortOrder: "",

    loadParams: null,
    getLoadParams: function() {
        return this.loadParams || {};
    },

    //serverSorting: false,
    sortMode: "server", //server,client,none

    pageIndexField: "pageIndex",
    pageSizeField: "pageSize",
    sortFieldField: "sortField",
    sortOrderField: "sortOrder",
    totalField: "total",
    dataField: "data",

    startField: '', //start
    limitField: '', //limit

    errorField: 'error',
    errorMsgField: 'errorMsg',
    stackTraceField: 'stackTrace',

    load: function(params, success, error, complete) {
        if (typeof params == "string") {
            this.setUrl(params);
            return;
        }

        if (this._loadTimer) clearTimeout(this._loadTimer);
        this.loadParams = params || {};
        if (!mini.isNumber(this.loadParams.pageIndex)) this.loadParams.pageIndex = 0;

        if (this._xhr) {
            this._xhr.abort();
        }
        if (this.ajaxAsync && mini_ajaxAsyncInvoke) { //mini_ajaxAsyncInvoke = false，不会异步调用_doLoadAjax方法。
            var me = this;
            this._loadTimer = setTimeout(function() {
                me._doLoadAjax(me.loadParams, success, error, complete);
                me._loadTimer = null;
            }, 1);
        } else {
            this._doLoadAjax(this.loadParams, success, error, complete);
        }
    },
    reload: function(success, error, complete) {

        this.load(this.loadParams, success, error, complete);
    },
    gotoPage: function(index, size) {
        var params = this.loadParams || {};
        if (mini.isNumber(index)) params.pageIndex = index;
        if (mini.isNumber(size)) params.pageSize = size;
        this.load(params);
    },

    sortBy: function(sortField, sortOrder) {
        this.sortField = sortField;
        this.sortOrder = sortOrder == "asc" ? "asc" : "desc";
        if (this.sortMode == "server") {
            var params = this.getLoadParams();
            params.sortField = sortField;
            params.sortOrder = sortOrder;
            params.pageIndex = this.pageIndex;
            this.load(params);
        } else {
            //alert("client sort");
            //this._doClientSort(sortField, sortOrder);
        }
    },

    setSortField: function(value) {
        this.sortField = value;
        if (this.sortMode == "server") {
            var params = this.getLoadParams();
            params.sortField = value;
        }
    },
    setSortOrder: function(value) {
        this.sortOrder = value;
        if (this.sortMode == "server") {
            var params = this.getLoadParams();
            params.sortOrder = value;
        }
    },

    checkSelectOnLoad: true, //重新加载，是否保持原选中记录状态
    selectOnLoad: false,

    ajaxData: null,
    ajaxAsync: true, //表格异步，tree、combobox同步
    ajaxType: '', //get|post    
    //    ajaxDataType: "text",
    //    ajaxContentType: "application/x-www-form-urlencoded; charset=UTF-8",
    _doLoadAjax: function(params, success, errorFn, complete, _successHandler) {

        params = params || {};
        if (mini.isNull(params.pageIndex)) params.pageIndex = this.pageIndex;
        if (mini.isNull(params.pageSize)) params.pageSize = this.pageSize;

        if (params.sortField) this.sortField = params.sortField;
        if (params.sortOrder) this.sortOrder = params.sortOrder;
        params.sortField = this.sortField;
        params.sortOrder = this.sortOrder;

        this.loadParams = params;

        var url = this._evalUrl();
        var type = this._evalType(url);

        var obj = mini._evalAjaxData(this.ajaxData, this);
        //mini.copyTo(params, obj);
        jQuery.extend(true, params, obj);

        var e = { //options
            url: url,
            async: this.ajaxAsync,
            type: type,
            data: params,
            params: params,
            cache: false,
            cancel: false
        };

        //ajaxOptions：async, type, dateType, contentType等都能在beforeload前修改。                

        //mini.copyTo(e, this.ajaxOptions);
        jQuery.extend(true, e, this.ajaxOptions);

        this._OnBeforeLoad(e);
        if (e.cancel == true) {
            params.pageIndex = this.getPageIndex();
            params.pageSize = this.getPageSize();
            return;
        }

        //历史遗留问题：兼容e.params参数
        if (e.data != e.params && e.params != params) {
            e.data = e.params;
        }

        if (e.url != url && e.type == type) {
            e.type = this._evalType(e.url);
        }

        //处理自定义field
        var o = {};
        o[this.pageIndexField] = params.pageIndex;
        o[this.pageSizeField] = params.pageSize;
        if (params.sortField) o[this.sortFieldField] = params.sortField;
        if (params.sortOrder) o[this.sortOrderField] = params.sortOrder;

        if (this.startField && this.limitField) {
            o[this.startField] = params.pageIndex * params.pageSize;
            o[this.limitField] = params.pageSize;
        }

        //        delete params.pageIndex;
        //        delete params.pageSize;
        //        delete params.sortField;
        //        delete params.sortOrder;
        //mini.copyTo(params, o);
        //mini.copyTo(e.data, o);
        jQuery.extend(true, params, o);
        jQuery.extend(true, e.data, o);


        if (this.sortMode == 'client') {
            params[this.sortFieldField] = "";
            params[this.sortOrderField] = "";
        }

        //保存记录值
        //        var selected = this.getSelected();
        //        this._selectedValue = selected ? selected[this.idField] : null;
        //        if (mini.isNumber(this._selectedValue)) this._selectedValue = String(this._selectedValue);

        //保存“当前选中”
        var selected = this.getSelected();
        this._currentSelectValue = selected ? selected[this.idField] : null;;
        if (mini.isNumber(this._currentSelectValue)) this._currentSelectValue = String(this._currentSelectValue);

        //保存“所有选中”
        var selecteds = this.getSelecteds();
        var _selectsArr = [];
        for (var i = 0, l = selecteds.length; i < l; i++) {
            var id = selecteds[i][this.idField];
            if (!mini.isNull(id)) id = String(id);
            _selectsArr.push(id)
        }
        this._selectedValue = _selectsArr.length == 0 ? null : _selectsArr;
        if (mini.isNumber(this._selectedValue)) this._selectedValue = String(this._selectedValue);


        var me = this;
        me._resultObject = null;
        /*
        e.textStatus
        success     交互成功
        error       网络交互失败：404,500
        timeout     交互超时
        abort       交互终止
        servererror 网络交互成功，返回json，但是业务逻辑错误
        e.errorCode     服务端错误码
        e.errorMsg      错误描述信息
        e.stackTrace    错误定位信息
        */

        var async = e.async;
        mini.copyTo(e, {
            success: function(text, textStatus, xhr) {

                //return;
                if (!text || text == "null") {
                    text = '{ total: 0, data: [] }';
                }

                delete e.params;
                var obj = { text: text, result: null, sender: me, options: e, xhr: xhr };
                var result = null;
                try {
                    mini_doload(obj);
                    result = obj.result;
                    if (!result) {
                        result = mini.decode(text);
                    }
                } catch (ex) {
                    if (mini_debugger == true) {
                        alert(url + "\n json is error.");
                    }
                }

                if (result && !mini.isArray(result)) {
                    result.total = parseInt(mini._getMap(me.totalField, result)); //result[me.totalField];
                    result.data = mini._getMap(me.dataField, result); //result[me.dataField];
                } else {
                    if (result == null) {
                        result = {};
                        result.data = [];
                        result.total = 0;
                    } else if (mini.isArray(result)) {
                        var r = {};
                        r.data = result;
                        r.total = result.length;
                        result = r;
                    }
                }
                if (!result.data) result.data = [];
                if (!result.total) result.total = 0;
                me._resultObject = result;

                if (!mini.isArray(result.data)) {
                    result.data = [result.data];
                }

                var ex = {
                    xhr: xhr,
                    text: text,
                    textStatus: textStatus,
                    result: result,
                    total: result.total,
                    data: result.data.clone(),

                    pageIndex: params[me.pageIndexField],
                    pageSize: params[me.pageSizeField]
                };


                var error = mini._getMap(me.errorField, result);
                var errorMsg = mini._getMap(me.errorMsgField, result);
                var stackTrace = mini._getMap(me.stackTraceField, result);

                if (mini.isNumber(error) && error != 0 || error === false) {
                    //server error
                    ex.textStatus = "servererror";
                    ex.errorCode = error;
                    ex.stackTrace = stackTrace || "";
                    ex.errorMsg = errorMsg || "";
                    if (mini_debugger == true) {
                        alert(url + "\n" + ex.textStatus + "\n" + ex.errorMsg + "\n" + ex.stackTrace);
                    }
                    me.fire("loaderror", ex);
                    if (errorFn) errorFn.call(me, ex);
                } else {

                    //if (ex.total >= 0) {
                    //当页码大于0，数据为空
                    if (ex.pageIndex > 0 && ex.data.length == 0) {
                        //me.reload();
                        me.gotoPage(ex.pageIndex - 1);
                        return;
                    }
                    //}

                    if (_successHandler) {
                        _successHandler(ex);
                    } else {



                        //pager
                        me.pageIndex = ex.pageIndex;
                        me.pageSize = ex.pageSize;
                        me.setTotalCount(ex.total);

                        //success
                        me._OnPreLoad(ex);

                        me.loaded = true;

                        var sss = new Date();
                        //data
                        me.setData(ex.data);
                        //alert(new Date() - sss);
                        //                        //checkSelectOnLoad
                        //                        if (me._selectedValue && me.checkSelectOnLoad) {
                        //                            var o = me.getbyId(me._selectedValue);
                        //                            if (o) {
                        //                                me.select(o);
                        //                            }
                        //                        }
                        //checkSelectOnLoad
                        //将之前选中的记录，在加载后，判断并重新选中，达到保持选中的效果
                        if (me._selectedValue && me.checkSelectOnLoad) {
                            var selects = [];
                            var _selects = me._selectedValue;
                            if (_selects.length > 0) {
                                for (var i = 0, l = _selects.length; i < l; i++) {

                                    var o = me.getbyId(_selects[i]);
                                    if (o) {
                                        selects.push(o);
                                    }
                                }

                                // var o = me.getbyId(me._selectedValue);
                                //                            if (o) {
                                //                                me.select(o);
                                //
                                //                            }
                                if (selects.length) me.selects(selects);

                                me._selected = me.getbyId(me._currentSelectValue);

                            }
                        }



                        //selectOnLoad                    
                        if (me.getSelected() == null && me.selectOnLoad && me.getDataView().length > 0) {
                            me.select(0);
                        }
                        me.fire("load", ex);

                        if (success) {
                            if (async) {
                                setTimeout(function() {
                                    success.call(me, ex);
                                }, 20);
                            } else {
                                success.call(me, ex);
                            }
                        }



                    }
                }
            },
            error: function(xhr, textStatus, errorThrown) {
                if (textStatus == "abort") return;

                var ex = {
                    xhr: xhr,
                    text: xhr.responseText,
                    textStatus: textStatus
                };
                ex.errorMsg = xhr.responseText;
                ex.errorCode = xhr.status;


                if (mini_debugger == true) {
                    alert(url + "\n" + ex.errorCode + "\n" + ex.errorMsg);
                }

                me.fire("loaderror", ex);
                if (errorFn) errorFn.call(me, ex);
            },
            complete: function(xhr, textStatus) {
                var ex = {
                    xhr: xhr,
                    text: xhr.responseText,
                    textStatus: textStatus
                };
                me.fire("loadcomplete", ex);
                if (complete) complete.call(me, ex);
                me._xhr = null;
            }
        });
        if (this._xhr) {
            //this._xhr.abort();
        }
        this._xhr = mini.ajax(e);
    },
    _OnBeforeLoad: function(e) {
        this.fire("beforeload", e);
    },
    _OnPreLoad: function(e) {
        this.fire("preload", e); //加载前夕，处理更复杂数据
    },
    _evalUrl: function() {
        var url = this.url;
        if (typeof url == "function") {
            url = url();
        } else {
            try {
                url = window["ev" + "al"](url);
            } catch (ex) {
                url = this.url;
            }
            if (!url) {
                url = this.url;
            }
        }
        return url;
    },
    _evalType: function(url) {
        var type = this.ajaxType;
        if (!type) {
            type = 'post';
            if (url) {
                if (url.indexOf(".txt") != -1 || url.indexOf(".json") != -1) {
                    type = "get";
                }
            } else {
                type = "get";
            }
        }
        return type;
    },
    setSortMode: function(value) {
        this.sortMode = value;
    },
    getSortMode: function() {
        return this.sortMode;
    },
    setAjaxOptions: function(value) {
        this.ajaxOptions = value;
    },
    getAjaxOptions: function() {
        return this.ajaxOptions;
    },
    setAutoLoad: function(value) {
        this.autoLoad = value;
    },
    getAutoLoad: function() {
        return this.autoLoad;
    },
    setUrl: function(value) {
        this.url = value;
        if (this.autoLoad) {
            this.load();
        }
    },
    getUrl: function() {
        return this.url;
    },
    setPageIndex: function(value) {
        this.pageIndex = value;

        var params = this.loadParams || {};
        if (mini.isNumber(value)) params.pageIndex = value;

        this.fire("pageinfochanged");
    },
    getPageIndex: function() {
        return this.pageIndex;
    },
    setPageSize: function(value) {
        this.pageSize = value;

        var params = this.loadParams || {};
        if (mini.isNumber(value)) params.pageSize = value;

        this.fire("pageinfochanged");
    },
    getPageSize: function() {
        return this.pageSize;
    },
    setTotalCount: function(value) {
        this.totalCount = parseInt(value);
        this.fire("pageinfochanged");
    },
    getTotalCount: function() {
        return this.totalCount;
    },
    getTotalPage: function() {
        return this.totalPage;
    },
    setCheckSelectOnLoad: function(value) {
        this.checkSelectOnLoad = value;
    },
    getCheckSelectOnLoad: function() {
        return this.checkSelectOnLoad;
    },
    setSelectOnLoad: function(value) {
        this.selectOnLoad = value;
    },
    getSelectOnLoad: function() {
        return this.selectOnLoad;
    }

});
mini.DataSource.RecordId = 1;






/* DataTable
-----------------------------------------------------------------------------*/

mini.DataTable = function() {
    mini.DataTable.superclass.constructor.apply(this, arguments);
};
mini.extend(mini.DataTable, mini.DataSource, {
    _init: function() {
        mini.DataTable.superclass._init.call(this);
        this._filterInfo = null;
        this._sortInfo = null;
    },
    add: function(record) {
        return this.insert(this.source.length, record);
    },
    addRange: function(records) {
        this.insertRange(this.source.length, records);
    },
    insert: function(index, record) {
        if (!record) return null;

        if (!mini.isNumber(index)) {
            var insertRow = this.getRecord(index);
            if (insertRow) {
                index = this.indexOf(insertRow);
            } else {
                //index = this.getDataView().length;
                index = this.dataview.length;
            }
            //return null;
        }

        var e = {
            index: index,
            record: record
        };

        this.fire("beforeadd", e); //if(this._events.beforeadd) 

        var target = this.dataview[index];
        if (target) {
            this.dataview.insert(index, record);
        } else {
            this.dataview.add(record);
        }

        if (this.dataview != this.source) {
            if (target) {
                var sourceIndex = this.source.indexOf(target);
                this.source.insert(sourceIndex, record);
            } else {
                this.source.add(record);
            }
        }

        this._setAdded(record);

        this._dataChanged();


        this.fire("add", e);
    },
    insertRange: function(index, records) {
        if (!mini.isArray(records)) return;

        //debugger
        if (!mini.isNumber(index)) index = this.dataview.length;

        this.beginChange();
        records = records.clone();
        for (var i = 0, l = records.length; i < l; i++) {
            var record = records[i];
            this.insert(index + i, record);
        }
        this.endChange();
    },
    remove: function(record, autoSelect) {
        var index = this.indexOf(record);
        return this.removeAt(index, autoSelect);
    },
    removeAt: function(index, autoSelect) {
        var record = this.getAt(index);
        if (!record) return null;

        var e = {
            record: record
        };
        this.fire("beforeremove", e);

        var isSelected = this.isSelected(record);

        //this.source.removeAt(index);
        this.source.remove(record);
        if (this.dataview !== this.source) {
            this.dataview.removeAt(index);
        }

        this._setRemoved(record);

        this._checkSelecteds();

        this._dataChanged();

        this.fire("remove", e);

        if (isSelected && autoSelect) {
            var newSelected = this.getAt(index);
            if (!newSelected) newSelected = this.getAt(index - 1);
            this.deselectAll();
            this.select(newSelected);
        }
    },

    removeRange: function(records, autoSelect) {
        if (!mini.isArray(records)) return;
        this.beginChange();
        records = records.clone();

        //debugger
        for (var i = 0, l = records.length; i < l; i++) {
            var o = records[i];
            this.remove(o, autoSelect);
            //this.remove(o, false);
        }


        this._dataChanged();

        this.endChange();
    },
    move: function(record, newIndex) {
        if (!record || !mini.isNumber(newIndex)) return;
        if (newIndex < 0) return;

        var toEnd = newIndex === this.dataview.length;

        if (mini.isArray(record)) {
            this.beginChange();

            var rs = record,
                targetRecord = this.getAt(newIndex);
            var sf = this;
            mini.sort(rs, function(a, b) {
                return sf.indexOf(a) > sf.indexOf(b);
            }, this);
            for (var i = 0, l = rs.length; i < l; i++) {
                var r = rs[i];
                var index = this.indexOf(targetRecord);

                this.move(r, toEnd ? this.dataview.length : index);
            }
            this.endChange();
            return;
        }

        var e = {
            index: newIndex,
            record: record
        };
        this.fire("beforemove", e);

        var target = this.dataview[newIndex];

        this.dataview.remove(record);

        var _index = this.dataview.indexOf(target);
        if (_index != -1) {
            newIndex = _index;
        }
        if (target) {
            this.dataview.insert(newIndex, record);
        } else {
            this.dataview.add(record);
        }

        if (this.dataview != this.source) {
            this.source.remove(record);
            var _index = this.source.indexOf(target);
            if (_index != -1) {
                newIndex = _index;
            }
            if (target) {
                this.source.insert(newIndex, record);
            } else {
                this.source.add(record);
            }
        }

        this._dataChanged();


        this.fire("move", e);
    },
    indexOf: function(record) {
        return this.getVisibleRows().indexOf(record);
    },
    getAt: function(index) {
        //return this.dataview[index];
        return this.getVisibleRows()[index];
    },
    getRange: function(start, end) {
        if (start > end) {
            var t = start;
            start = end;
            end = t;
        }
        var range = [];
        for (var i = start, l = end; i <= l; i++) {
            var o = this.dataview[i];
            range.push(o);
        }
        return range;
    },
    selectRange: function(start, end) {
        if (!mini.isNumber(start)) start = this.indexOf(start);
        if (!mini.isNumber(end)) end = this.indexOf(end);
        if (mini.isNull(start) || mini.isNull(end)) return;

        var rs = this.getRange(start, end);
        this.selects(rs);
    },
    toArray: function() {
        return this.source.clone();
    },
    //////////////////////////////////////////////
    isChanged: function() {
        return this.getChanges().length > 0;
    },
    /*
    使用rowState获得不同状态的行对象数组:
    新增的
    删除的
    修改的
    */
    getChanges: function(rowState, onlyField) {
        var changes = [];
        if (rowState == "removed" || rowState == null) {
            changes.addRange(this._removeds.clone());
        }
        for (var i = 0, l = this.source.length; i < l; i++) {
            var record = this.source[i];
            if (!record._state) continue;
            if (record._state == rowState || rowState == null) {
                changes[changes.length] = record;
            }
        }
        var rows = changes;
        if (onlyField) {
            for (var i = 0, l = rows.length; i < l; i++) {
                var row = rows[i];
                if (row._state == "modified") {
                    var newRow = {};
                    newRow._state = row._state;
                    newRow[this.idField] = row[this.idField];
                    for (var field in row) {
                        var modifed = this.isModified(row, field);
                        if (modifed) {
                            newRow[field] = row[field];
                        }
                    }
                    rows[i] = newRow;
                }
            }
        }
        //按序号排序
        var grid = this;
        mini.sort(changes, function(a, b) {
            var index1 = grid.indexOf(a);
            var index2 = grid.indexOf(b);
            if (index1 > index2) return 1;
            if (index1 < index2) return -1;
            return 0;
        });
        return changes;
    },
    //acceptChanges和rejectChanges都能清空DataTable的增/删/改/错误等标记信息, 但是一个是"提交", 一个是"撤销"处理
    accept: function() {
        this.beginChange();
        for (var i = 0, l = this.source.length; i < l; i++) {
            var record = this.source[i];
            this.acceptRecord(record);
        }
        this._removeds = []; //被删除行集合
        this._originals = {}; //被修改行集合        
        this.endChange();
    },
    reject: function() {
        this.beginChange();
        var data = this.source.clone();
        for (var i = 0, l = data.length; i < l; i++) {
            var record = data[i];
            this.rejectRecord(record);
        }
        this._removeds = []; //被删除行集合
        this._originals = {}; //被修改行集合
        this.endChange();
    },
    acceptRecord: function(node) {
        if (!node._state) return;
        delete this._originals[node[this._originalIdField]];
        if (node._state == "deleted") { //如果是"删除", 则提交修改时, 实现真正移除
            this.remove(node);
        } else {
            delete node._state;
            delete this._originals[node[this._originalIdField]];
            this._dataChanged();
        }
        this.fire("update", { record: node });
    },
    rejectRecord: function(node) {
        if (!node._state) return;
        if (node._state == "added") { //如果是新增撤销, 则删除之                                   
            this.remove(node);
        } else if (node._state == "modified" || node._state == "deleted") {
            var or = this._getOriginal(node);

            //old
            //mini.copyTo(node, or);

            //new
            for (var field in or) {
                var val = or[field];
                mini._setMap(field, val, node);
            }


            delete node._state;
            delete this._originals[node[this._originalIdField]];
            this._dataChanged();
            this.fire("update", { record: node });
        }
    },
    //////////////////////////////////////////////  
    _doFilter: function() {
        if (!this._filterInfo) {
            this.dataview = this.source;
            return;
        }
        var fn = this._filterInfo[0],
            scope = this._filterInfo[1];
        var view = [];
        var data = this.source;
        for (var i = 0, l = data.length; i < l; i++) {
            var r = data[i];
            var add = fn.call(scope, r, i, this);
            if (add !== false) {
                view.push(r);
            }
        }
        this.dataview = view;
    },
    _doSort: function() {
        if (!this._sortInfo) return;
        var fn = this._sortInfo[0],
            scope = this._sortInfo[1],
            reverse = this._sortInfo[2];
        var dv = this.getDataView().clone();
        mini.sort(dv, fn, scope);
        if (reverse) dv.reverse();
        this.dataview = dv;
    }
});
mini.regClass(mini.DataTable, "datatable");

/*
    root == source  :原始树形数据对象。
    viewNodes       :哈希结构，存放“过滤、排序”后的子节点数组。 (Tree控件)
    dataview        :列表数据视图。“过滤、排序、折叠”后的数组。 (SuperTree控件)    
*/

/* DataTree
-----------------------------------------------------------------------------*/

mini.DataTree = function() {
    mini.DataTree.superclass.constructor.apply(this, arguments);
};
mini.extend(mini.DataTree, mini.DataSource, {
    isTree: true,

    expandOnLoad: false, //默认全部收缩

    idField: "id",
    parentField: "pid",
    nodesField: "children",
    checkedField: "checked",
    resultAsTree: false,

    dataField: "",

    checkModel: "cascade", //multiple|single|cascade
    autoCheckParent: false, //1.选子，选父；2.选父，全选子；3.全取消子，取消父
    onlyLeafCheckable: false, //只显示子节点checkbox


    setExpandOnLoad: function(value) {
        this.expandOnLoad = value;
    },
    getExpandOnLoad: function() {
        return this.expandOnLoad;
    },
    setParentField: function(value) {
        this.parentField = value;
    },
    setNodesField: function(value) {
        if (this.nodesField != value) {
            var data = this.root[this.nodesField];
            this.nodesField = value;
            this._doLoadData(data);
        }
    },
    setResultAsTree: function(value) {
        this.resultAsTree = value;
    },
    setCheckRecursive: function(value) {
        this.checkModel = value ? "cascade" : "multiple";
    },
    getCheckRecursive: function() {
        return this.checkModel == "cascade";
    },
    setShowFolderCheckBox: function(value) {
        this.onlyLeafCheckable = !value;
    },
    getShowFolderCheckBox: function() {
        return !this.onlyLeafCheckable;
    },
    _doExpandOnLoad: function(nodes) {
        //expandOnLoad
        var nodesField = this.nodesField;
        var expandOnLoad = this.expandOnLoad;

        function eachNodes(nodes, level) {
            for (var i = 0, l = nodes.length; i < l; i++) {
                var node = nodes[i];

                if (mini.isNull(node.expanded)) {
                    if (expandOnLoad === true ||
                        (mini.isNumber(expandOnLoad) && level <= expandOnLoad)) {
                        node.expanded = true;
                    } else {
                        node.expanded = false;
                    }
                } else {
                    //node.expanded = false;
                }

                var childs = node[nodesField];
                if (childs) {
                    eachNodes(childs, level + 1);
                }
            }
        }
        eachNodes(nodes, 0);
    },
    ///////////////////////////////////////////////////////////

    _OnBeforeLoad: function(e) {
        var node = this._loadingNode || this.root;
        e.node = node;

        if (this._isNodeLoading()) {
            e.async = true;
            e.isRoot = e.node == this.root;
            if (!e.isRoot) {
                e.data[this.idField] = this.getItemValue(e.node);
            }
        }
        this.fire("beforeload", e);
    },
    _OnPreLoad: function(e) {
        //resultAsTree
        if (this.resultAsTree == false) {
            e.data = mini.arrayToTree(e.data, this.nodesField, this.idField, this.parentField)
        }
        this.fire("preload", e);




    },
    _init: function() {
        mini.DataTree.superclass._init.call(this);
        this.root = { _id: -1, _level: -1 };
        this.source = this.root[this.nodesField] = [];
        this.viewNodes = null; //当排序、过滤后，viewNodes才有对象
        this.dataview = null;
        this.visibleRows = null;
        this.list = null;

        this._ids[this.root._id] = this.root;
    },
    _doLoadData: function(data) {
        data = data || [];

        this._doExpandOnLoad(data);

        this.source = this.root[this.nodesField] = data;
        this.viewNodes = null;
        this.dataview = null;
        this.visibleRows = null;
        this.list = null;

        var sss = new Date();

        //处理_id映射
        var ds = mini.treeToArray(data, this.nodesField);


        var ids = this._ids;
        ids[this.root._id] = this.root;

        var RecordId = mini.DataSource.RecordId;
        for (var i = 0, l = ds.length; i < l; i++) {
            var node = ds[i];
            //if (!node._id) node._id = mini.DataSource.RecordId++;
            node._id = RecordId++;
            ids[node._id] = node;

            //历史问题
            node._uid = node._id;
        }
        mini.DataSource.RecordId = RecordId;
        //遍历树形，设置父子关系

        var checkedField = this.checkedField;
        var ds = mini.treeToArray(data, this.nodesField, "_id", "_pid", this.root._id);

        this.list = ds;

        var ids = this._ids,
            node, parentNode, checked;
        for (var i = 0, l = ds.length; i < l; i++) {
            node = ds[i];
            //var parentNode = this.getParentNode(node);
            parentNode = ids[node._pid];
            //node._pid = parentNode._id;
            node._level = parentNode._level + 1;
            if (node._state) delete node._state;


            //node[this.parentField] = parentNode[this.idField];

            checked = node[checkedField];
            if (checked) {
                node.checked = checked;
                if (node.checked) {
                    node.checked = node.checked != 'false';
                }
            }

            //			if (this.isLeafNode(node) == false) {
            //				var cs = node[this.nodesField];
            //				if (cs && cs.length > 0) {
            //					//delete node.isLeaf;
            //				}
            //			}
        }



        //同步checked
        this._doUpdateLoadedCheckedNodes();
        //alert(new Date() - sss);
    },
    _setAdded: function(node) {
        var parentNode = this.getParentNode(node); //设置父节点Id
        node._id = mini.DataSource.RecordId++;

        //自动创建idField
        if (this._autoCreateNewID && !node[this.idField]) {
            node[this.idField] = mini.UUID();
        }

        //历史问题
        node._uid = node._id;

        //if (!node._id) node._id = mini.DataSource.RecordId++;
        node._pid = parentNode._id;
        if (parentNode[this.idField]) {
            node[this.parentField] = parentNode[this.idField];
        }
        node._level = parentNode._level + 1;
        node._state = "added";
        this._ids[node._id] = node;
        delete this._originals[node[this._originalIdField]];
    },
    _createNodes: function(node) {
        var nodes = node[this.nodesField];
        if (!nodes) {
            nodes = node[this.nodesField] = [];

        }
        if (this.viewNodes && !this.viewNodes[node._id]) {
            this.viewNodes[node._id] = [];
        }
        return nodes;
    },
    ///////////////////////////////////////    
    addNode: function(node, parentNode) {
        if (!node) return;
        return this.insertNode(node, -1, parentNode);
    },
    addNodes: function(nodes, parentNode, action) {
        if (!mini.isArray(nodes)) return;
        if (mini.isNull(action)) action = "add";
        for (var i = 0, l = nodes.length; i < l; i++) {
            var node = nodes[i];
            this.insertNode(node, action, parentNode);
        }
    },
    insertNodes: function(nodes, index, parentNode) {
        if (!mini.isNumber(index)) return;
        if (!mini.isArray(nodes)) return;
        if (!parentNode) parentNode = this.root;
        this.beginChange();

        var pnodes = this._createNodes(parentNode);
        if (index < 0 || index > pnodes.length) index = pnodes.length;

        nodes = nodes.clone();
        for (var i = 0, l = nodes.length; i < l; i++) {
            this.insertNode(nodes[i], index + i, parentNode);
        }

        this.endChange();
        return nodes;
    },
    removeNode: function(node) {
        var parentNode = this.getParentNode(node);
        if (!parentNode) return;
        var index = this.indexOfNode(node);
        return this.removeNodeAt(index, parentNode);
    },
    removeNodes: function(nodes) {
        if (!mini.isArray(nodes)) return;
        this.beginChange();
        nodes = nodes.clone();
        for (var i = 0, l = nodes.length; i < l; i++) {
            this.removeNode(nodes[i]);
        }
        this.endChange();
    },
    moveNodes: function(nodes, targetNode, action) {
        if (!nodes || nodes.length == 0 || !targetNode || !action) return;
        this.beginChange();
        var sf = this;
        mini.sort(nodes, function(a, b) {
            return sf.indexOf(a) > sf.indexOf(b);
        }, this);
        for (var i = 0, l = nodes.length; i < l; i++) {
            var node = nodes[i];
            this.moveNode(node, targetNode, action);
            if (i != 0) {
                targetNode = node;
                action = "after";
            }
            //alert(node.Name);
        }
        this.endChange();
    },
    /*
    node: 要移动的节点
    targetNode: 目标节点
    action:
    1.  index   这时候, targetNode作为父节点
    2.  before, after, add/append 移动的方式
    */
    moveNode: function(node, targetNode, action) {
        if (!node || !targetNode || mini.isNull(action)) return;



        //如果有viewNodes，同时也发生变化
        if (this.viewNodes) {
            var parentNode = targetNode;
            var index = action;
            if (index == 'before') {
                parentNode = this.getParentNode(targetNode);
                index = this.indexOfNode(targetNode);
            } else if (index == 'after') {
                parentNode = this.getParentNode(targetNode);
                index = this.indexOfNode(targetNode) + 1;
            } else if (index == 'add' || index == "append") {
                if (!parentNode[this.nodesField]) parentNode[this.nodesField] = [];
                index = parentNode[this.nodesField].length;
            } else if (!mini.isNumber(index)) {
                return;
            }
            if (this.isAncestor(node, parentNode)) { //如果目标父节点, 是节点的子节点, 则不能加入
                return false;
            }

            var childNodes = this.viewNodes[parentNode._id];
            if (!childNodes) childNodes = this.viewNodes[parentNode._id] = [];

            var childNodes = this.getChildNodes(parentNode);
            if (index < 0 || index > childNodes.length) index = childNodes.length;

            //加入新父节点下(假节点)
            var ___node = {};
            childNodes.insert(index, ___node);

            //node从原来的父节点中移除
            var oldParentNode = this.getParentNode(node);
            var oldChildNodes = this.getChildNodes(oldParentNode);
            oldChildNodes.remove(node);

            //真正节点加入
            index = childNodes.indexOf(___node);
            childNodes[index] = node;

        }

        var parentNode = targetNode;
        var index = action;
        var childNodes = this._createNodes(parentNode);

        if (index == 'before') {
            parentNode = this.getParentNode(targetNode);
            childNodes = this._createNodes(parentNode);
            index = childNodes.indexOf(targetNode);
        } else if (index == 'after') {
            parentNode = this.getParentNode(targetNode);
            childNodes = this._createNodes(parentNode);
            index = childNodes.indexOf(targetNode) + 1;
        } else if (index == 'add' || index == "append") {
            index = childNodes.length;
        } else if (!mini.isNumber(index)) {
            return;
        }
        if (this.isAncestor(node, parentNode)) { //如果目标父节点, 是节点的子节点, 则不能加入
            return false;
        }

        if (index < 0 || index > childNodes.length) index = childNodes.length;

        //加入新父节点下(假节点)
        var ___node = {};
        childNodes.insert(index, ___node);

        //node从原来的父节点中移除
        var oldParentNode = this.getParentNode(node);
        oldParentNode[this.nodesField].remove(node);

        //真正节点加入
        index = childNodes.indexOf(___node);
        childNodes[index] = node;

        //_ParentId和_Level会改变
        this._updateParentAndLevel(node, parentNode);

        this._dataChanged();
        var e = {
            oldParentNode: oldParentNode,
            parentNode: parentNode,
            index: index,
            node: node
        };

        this.fire("movenode", e);

        if (oldParentNode[this.nodesField].length === 0) {
            this.expandNode(oldParentNode);
        }
    },
    //insertNode(task, action, targetTask) //action: before, after, append/add
    insertNode: function(node, index, parentNode) {
        if (!node) return;
        if (!parentNode) {
            parentNode = this.root;
            index = "add";
        }
        if (!mini.isNumber(index)) {
            switch (index) {
                case "before":
                    index = this.indexOfNode(parentNode);
                    parentNode = this.getParentNode(parentNode);
                    node = this.insertNode(node, index, parentNode);
                    break;
                case "after":
                    index = this.indexOfNode(parentNode);
                    parentNode = this.getParentNode(parentNode);
                    node = this.insertNode(node, index + 1, parentNode);
                    break;
                case "append":
                case "add":
                    node = this.addNode(node, parentNode);
                    break;
                default:
                    break;
            }
            return node;
        };

        var nodes2 = this._createNodes(parentNode); //原始节点组
        var nodes = this.getChildNodes(parentNode); //视图节点组
        if (index < 0 || index > nodes.length) index = nodes.length;

        nodes.insert(index, node); //view

        //index = nodes.indexOf(node);            //@@@ 2017-01-06

        if (this.viewNodes) {
            var preNode = nodes[index - 1];
            if (preNode) {
                var index2 = nodes2.indexOf(preNode);
                nodes2.insert(index2 + 1, node);
            } else {
                nodes2.insert(0, node);
            }
        }

        node._pid = parentNode._id;
        this._setAdded(node);

        //        if (node[this.nodesField]) {
        //            this.cascadeChild(node, function (n, i, p) {
        //                n._pid = p._id;
        //                this._setAdded(n);
        //            }, this);
        //        }

        var me = this;
        var children = node[this.nodesField];
        if (children) {
            function each(children, p) {
                for (var i = 0, l = children.length; i < l; i++) {
                    var n = children[i];
                    n._pid = p._id;
                    me._setAdded(n);
                    if (n[me.nodesField]) each(n[me.nodesField])
                }
            }
            each(children, node);
        }

        this._dataChanged();
        var e = {
            parentNode: parentNode,
            index: index,
            node: node
        };
        this.fire("addnode", e);
        return node;
    },
    removeNodeAt: function(index, parentNode) {

        if (!parentNode) parentNode = this.root;
        var nodes = this.getChildNodes(parentNode);
        var node = nodes[index];
        if (!node) return null;

        nodes.removeAt(index);
        if (this.viewNodes) {
            var nodes2 = parentNode[this.nodesField];
            nodes2.remove(node);
        }

        this._setRemoved(node);
        this.cascadeChild(node, function(n, i, p) {
            this._setRemoved(n);
        }, this);

        this._checkSelecteds();

        this._dataChanged();
        var e = {
            parentNode: parentNode,
            index: index,
            node: node
        };
        this.fire("removenode", e);

        return node;
    },
    ///////////////////////////////////////////////////////
    //由当前节点开始一直上溯到根节点,对于每个节点应用fn,直到有一个fn返回假为止
    bubbleParent: function(node, fn, scope) {
        scope = scope || this;
        if (node) fn.call(this, node);
        var parentNode = this.getParentNode(node);
        if (parentNode && parentNode != this.root) {
            this.bubbleParent(parentNode, fn, scope);
        }
    },
    //遍历所有层次的子节点, 直到返回false
    cascadeChild: function(node, fn, scope) {
        if (!fn) return;
        if (!node) node = this.root;
        //var nodes = node[this.nodesField];
        var nodes = this.getChildNodes(node);
        if (nodes) {
            nodes = nodes.clone();
            for (var i = 0, l = nodes.length; i < l; i++) {
                var c = nodes[i];
                if (fn.call(scope || this, c, i, node) === false) return;
                this.cascadeChild(c, fn, scope);
            }
        }
    },
    //遍历下一级子节点
    eachChild: function(node, fn, scope) {
        if (!fn || !node) return;
        var nodes = node[this.nodesField];
        if (nodes) {
            var list = nodes.clone();
            for (var i = 0, l = list.length; i < l; i++) {
                var o = list[i];
                if (fn.call(scope || this, o, i, node) === false) break;
            }
        }
    },

    collapse: function(node, deep) {
        node = this.getNode(node);
        if (!node) return;
        this.beginChange();

        node.expanded = false;
        if (deep) {
            this.eachChild(node, function(o) {
                if (o[this.nodesField] != null) {
                    this.collapse(o, deep);
                }
            }, this);
        }

        this.endChange("collapse");

        var e = {
            node: node
        };
        this.fire("collapse", e);
    },
    expand: function(node, deep) {
        node = this.getNode(node);
        if (!node) return;
        this.beginChange();

        node.expanded = true;
        if (deep) {
            this.eachChild(node, function(o) {
                if (o[this.nodesField] != null) {
                    this.expand(o, deep);
                }
            }, this);
        }

        this.endChange("expand");

        var e = {
            node: node
        };
        this.fire("expand", e);
    },
    toggle: function(node) {
        if (this.isExpandedNode(node)) this.collapse(node);
        else this.expand(node);
    },
    expandNode: function(node) {
        this.expand(node);
    },
    collapseNode: function(node) {
        this.collapse(node);
    },
    collapseAll: function() {
        this.collapse(this.root, true);
    },
    expandAll: function() {
        this.expand(this.root, true);
    },
    collapseLevel: function(level, deep) {
        this.beginChange();
        this.each(function(node) {
            var nodeLevel = this.getLevel(node);
            if (level == nodeLevel) {
                this.collapse(node, deep);
            }
        }, this);
        this.endChange();
    },
    expandLevel: function(level, deep) {
        this.beginChange();
        this.each(function(node) {
            var nodeLevel = this.getLevel(node);
            if (level == nodeLevel) {
                this.expand(node, deep);
            }
        }, this);
        this.endChange();
    },
    expandPath: function(node) {
        node = this.getNode(node);
        if (!node) return;
        var ans = this.getAncestors(node);
        for (var i = 0, l = ans.length; i < l; i++) {
            this.expandNode(ans[i]);
        }
    },
    collapsePath: function(node) {
        node = this.getNode(node);
        if (!node) return;
        var ans = this.getAncestors(node);
        for (var i = 0, l = ans.length; i < l; i++) {
            this.collapseNode(ans[i]);
        }
    },
    ///////////////////////////////////////////////////////
    //判断parentNode是否是node的父级节点
    isAncestor: function(parentNode, node) {
        if (parentNode == node) return true;
        if (!parentNode || !node) return false;
        if (parentNode == this.getRootNode()) return true;
        var as = this.getAncestors(node);
        for (var i = 0, l = as.length; i < l; i++) {
            if (as[i] == parentNode) return true;
        }
        return false;
    },
    //获取父级链
    getAncestors: function(node) {
        var as = [];
        while (1) {
            var parentNode = this.getParentNode(node);
            if (!parentNode || parentNode == this.root) break;
            as[as.length] = parentNode;
            node = parentNode;
        }
        as.reverse();
        return as;
    },
    getNode: function(node) {
        if (typeof node == 'object') return node;
        return this.getRecord(node);
    },
    getRootNode: function() {
        return this.root;
    },
    getParentNode: function(node) {
        //if (this.root._id == node._pid) return this.root;
        if (!node) return null;
        return this.getby_id(node._pid);
    },
    getAllChildNodes: function(node, source) {
        return this.getChildNodes(node, true, source);
    },
    getChildNodes: function(node, all, useView) {
        node = this.getNode(node);
        if (!node) node = this.getRootNode();
        var nodes = node[this.nodesField];

        //如果有过滤、排序，则从viewNodes中获取
        if (this.viewNodes && useView !== false) {
            nodes = this.viewNodes[node._id];
        }
        //        else if (nodes) {
        //            nodes = nodes.clone();
        //        }

        if (all === true && nodes) {
            var view = [];
            for (var i = 0, l = nodes.length; i < l; i++) {
                var cnode = nodes[i];
                view[view.length] = cnode;
                var cnodes = this.getChildNodes(cnode, all, useView);
                if (cnodes && cnodes.length > 0) {
                    view.addRange(cnodes);
                }
            }
            nodes = view;
        }
        return nodes || [];
    },
    getChildNodeAt: function(index, node) {
        var nodes = this.getChildNodes(node);
        if (nodes) return nodes[index];
        return null;
    },
    //是否有子节点
    hasChildNodes: function(node) {
        var nodes = this.getChildNodes(node);
        return nodes.length > 0;
    },
    getLevel: function(node) {
        return node._level;
    },

    //是否叶子节点(没有子节点的)
    //注意: 是否有子节点, 跟是否是叶子节点没有必然的关系    一般我们用IsLeaf来显示+-号, 在懒加载的时候管用
    //    _is_true: function (v) {
    //        return v === true || v === 1 || v === 'Y' || v === 'y'
    //    },
    //    _is_false: function (v) {
    //        return v === false || v === 0 || v === 'N' || v === 'n';
    //    },
    _is_true: function(v) {
        return String(v) == "true" || v === 1 || v === 'Y' || v === 'y'
    },
    _is_false: function(v) {
        return String(v) == "false" || v === 0 || v === 'N' || v === 'n';
    },
    leafField: 'isLeaf',
    isLeafNode: function(node) {
        return this.isLeaf(node);
    },
    isLeaf: function(node) {
        if (!node) return false;
        var v = node[this.leafField];
        if (!node || this._is_false(v)) return false;
        var nodes = this.getChildNodes(node, false, false);
        if (nodes.length > 0) return false;
        return true;
    },
    hasChildren: function(node) {
        var subNodes = this.getChildNodes(node);
        return !!(subNodes && subNodes.length > 0);
    },
    isFirstNode: function(node) {
        if (node == this.root) return true;
        var parentNode = this.getParentNode(node);
        if (!parentNode) return false;
        return this.getFirstNode(parentNode) == node;
    },
    isLastNode: function(node) {
        if (node == this.root) return true;
        var parentNode = this.getParentNode(node);
        if (!parentNode) return false;
        return this.getLastNode(parentNode) == node;
    },
    isCheckedNode: function(node) {
        return node.checked === true;
    },
    isExpandedNode: function(node) {
        return node.expanded == true || node.expanded == 1 || mini.isNull(node.expanded);
    },
    isEnabledNode: function(node) {
        return node.enabled !== false;
    },
    isVisibleNode: function(node) { //根据父节点折叠, 判断本节点是否可视
        if (node.visible == false) return false;
        var pnode = this._ids[node._pid];
        if (!pnode || pnode == this.root) return true;
        if (pnode.expanded === false) return false;
        return this.isVisibleNode(pnode);
    },
    getNextNode: function(node) {
        var parentNode = this.getby_id(node._pid);
        if (!parentNode) return null;
        var index = this.indexOfNode(node);
        return this.getChildNodes(parentNode)[index + 1];
    },
    getPrevNode: function(node) {
        var parentNode = this.getby_id(node._pid);
        if (!parentNode) return null;
        var index = this.indexOfNode(node);
        return this.getChildNodes(parentNode)[index - 1];
    },
    getFirstNode: function(parentNode) {
        return this.getChildNodes(parentNode)[0];
    },
    getLastNode: function(parentNode) {
        var nodes = this.getChildNodes(parentNode);
        return nodes[nodes.length - 1];
    },
    indexOfNode: function(node) {
        var parentNode = this.getby_id(node._pid);
        if (parentNode) {
            return this.getChildNodes(parentNode).indexOf(node);
        }
        return -1;
    },
    indexOfList: function(node) {
        return this.getList().indexOf(node);
    },
    getAt: function(index) {
        //return this.getDataView()[index];
        return this.getVisibleRows()[index];
    },
    indexOf: function(record) {
        return this.getVisibleRows().indexOf(record);
    },
    getRange: function(start, end) {
        if (start > end) {
            var t = start;
            start = end;
            end = t;
        }
        var data = this.getChildNodes(this.root, true);
        var range = [];
        for (var i = start, l = end; i <= l; i++) {
            var o = data[i];
            if (o) {
                range.push(o);
            }
        }
        return range;
    },
    selectRange: function(start, end) {
        var data = this.getChildNodes(this.root, true);
        if (!mini.isNumber(start)) start = data.indexOf(start);
        if (!mini.isNumber(end)) end = data.indexOf(end);
        if (mini.isNull(start) || mini.isNull(end)) return;

        var rs = this.getRange(start, end);
        this.selects(rs);
    },
    findRecords: function(property, value) {
        var data = this.toArray();

        var ifFn = typeof property == "function";
        var fn = property;
        var scope = value || this;
        var records = [];

        if (!mini.isNull(value)) value = String(value);

        for (var i = 0, l = data.length; i < l; i++) {
            var o = data[i];

            if (ifFn) {
                var ret = fn.call(scope, o);
                if (ret == true) {
                    records[records.length] = o;
                }
                if (ret === 1) break;
            } else {
                //                if (o[property] == value) {
                //                    records[records.length] = o;
                //                }

                if (value.indexOf(",") != -1) {
                    var vls = value.split(",");
                    for (var j = 0, len = vls.length; j < len; j++) {
                        var v = vls[j];
                        if (o[property] == v) {
                            records[records.length] = o;
                        }
                    }
                } else {
                    if (o[property] == value) {
                        records[records.length] = o;
                    }
                }
            }
        }
        return records;
    },
    ////////////////////////////////////
    _dataChangedCount: 0,
    _dataChanged: function(action) {

        this._dataChangedCount++;
        if (action != "update") {
            this.ids = null; //!!!
            this.dataview = null;
            this.visibleRows = null;

            if (action == "collapse" || action == "expand" || action == "loaddata") {} else {
                this.list = null;
            }

            //document.title = new Date().getTime();
        }
        if (this.__changeCount == 0) {
            this.fire("datachanged");
        }
    },

    //    _createDataView: function () {
    //        //获取所有排序、过滤后的节点列表
    //        var data = this.getChildNodes(this.root, true);
    //        return data;
    //    },
    //    _createVisibleRows: function () {
    //        //获取所有排序、过滤后的节点列表
    //        var data = this.getChildNodes(this.root, true);
    //        //根据isVisibleNode, 再次筛选
    //        var view = [];
    //        for (var i = 0, l = data.length; i < l; i++) {
    //            var node = data[i];
    //            if (this.isVisibleNode(node)) view[view.length] = node;
    //        }
    //        return view;
    //    },

    _createDataView: function() {
        //获取所有排序、过滤后的节点列表
        var data = !this.viewNodes ? this.getList() : this.getChildNodes(this.root, true);
        return data;
    },
    //	_createVisibleRows: function () {
    //		//获取所有排序、过滤后的节点列表
    //		var data = !this.viewNodes ? this.getList() : this.getChildNodes(this.root, true);	  //this.getListView()
    //		//根据isVisibleNode, 再次筛选
    //		var view = [];
    //		for (var i = 0, l = data.length; i < l; i++) {
    //			var node = data[i];
    //			if (this.isVisibleNode(node)) view[view.length] = node;
    //		}
    //		return view;
    //	},
    _createVisibleRows: function() {
        var data = [],
            nodesField = this.nodesField,
            viewNodes = this.viewNodes,
            inView = !!viewNodes,
            node, children;

        function getChildren(node) {
            return inView ? viewNodes[node._id] : node[nodesField];
        }

        function each(nodes) {
            for (var i = 0, l = nodes.length; i < l; i++) {
                node = nodes[i];
                data[data.length] = node;

                if (node.expanded === false) {} else {
                    children = getChildren(node);
                    if (children) each(children);
                }

            }
        }

        each(getChildren(this.root));
        return data;

        //		//获取所有排序、过滤后的节点列表
        //		var data = !this.viewNodes ? this.getList() : this.getChildNodes(this.root, true);   //this.getListView()
        //		//根据isVisibleNode, 再次筛选
        //		var view = [];
        //		for (var i = 0, l = data.length; i < l; i++) {
        //			var node = data[i];
        //			if (this.isVisibleNode(node)) view[view.length] = node;
        //		}
        //		return view;
    },

    //ccc: 0,
    getList: function() {
        //
        if (!this.list) {

            //document.title = this.ccc++;
            this.list = mini.treeToList(this.source, this.nodesField);
        }
        return this.list;


        //return mini.treeToList(this.source, this.nodesField);
    },
    getDataView: function() {

        if (!this.dataview) {

            this.dataview = this._createDataView();
        }
        return this.dataview; //.clone();
    },
    getVisibleRows: function() {
        if (!this.visibleRows) {

            this.visibleRows = this._createVisibleRows();
        }
        return this.visibleRows;
    },
    //过滤、排序，生成viewNodes
    _doFilter: function() {
        if (!this._filterInfo) {
            this.viewNodes = null;
            return;
        }

        var fn = this._filterInfo[0],
            scope = this._filterInfo[1];

        var viewNodes = this.viewNodes = {},
            nodesField = this.nodesField;

        function filter(node) {
            var nodes = node[nodesField];
            if (!nodes) return false;
            var id = node._id;
            var views = viewNodes[id] = [];

            for (var i = 0, l = nodes.length; i < l; i++) {
                var r = nodes[i];
                var cadd = filter(r);
                var add = fn.call(scope, r, i, this);
                if (add === true || cadd) {
                    views.push(r);
                }

            }
            return views.length > 0;
        }
        filter(this.root);
    },
    _doSort: function() {
        if (!this._filterInfo && !this._sortInfo) {
            this.viewNodes = null;
            return;
        }
        if (!this._sortInfo) return;
        var fn = this._sortInfo[0],
            scope = this._sortInfo[1],
            reverse = this._sortInfo[2];


        var nodesField = this.nodesField;
        if (!this.viewNodes) {
            var viewNodes = this.viewNodes = {};
            //如果没有viewNodes，则一一创建
            viewNodes[this.root._id] = this.root[nodesField].clone();
            this.cascadeChild(this.root, function(node, i, p) {
                var nodes = node[nodesField];
                if (nodes) {
                    viewNodes[node._id] = nodes.clone();
                }
            });
        }

        var sf = this;

        function sort(node) {
            var nodes = sf.getChildNodes(node);
            mini.sort(nodes, fn, scope);
            if (reverse) nodes.reverse();
            for (var i = 0, l = nodes.length; i < l; i++) {
                var r = nodes[i];
                sort(r);
            }
        };
        sort(this.root);
    },
    ////////////////////////////////////////////////////////

    toArray: function() {
        //return this.getChildNodes(this.root, true, false);

        if (!this._array || this._dataChangedCount != this._dataChangedCount2) {
            this._dataChangedCount2 = this._dataChangedCount;
            this._array = this.getChildNodes(this.root, true, false);
        }

        //1)节省掉性能开销；2）在大树形数据下，少生成对象，节省内存

        return this._array;
    },
    toTree: function() {
        return this.root[this.nodesField];
    },
    isChanged: function() {
        return this.getChanges().length > 0;
    },
    /*
    使用rowState获得不同状态的行对象数组:
    新增的
    删除的
    修改的
    */
    getChanges: function(rowState, onlyField) {
        var me = this,
            changes = [];
        if (rowState == "removed" || rowState == null) {
            changes.addRange(this._removeds.clone());
        }

        var allNodes = this.getAllChildNodes(this.root, false);

        for (var i = 0, l = allNodes.length; i < l; i++) {
            var record = allNodes[i];
            if (record._state == null || record._state == "") continue;
            if (record._state == rowState || rowState == null) {
                changes[changes.length] = record;
            }
        }

        //        this.cascadeChild(this.root, function (record, i, p) {
        //            if (record._state == null || record._state == "") return;
        //            if (record._state == rowState || rowState == null) {
        //                changes[changes.length] = record;
        //            }
        //        }, this);

        var rows = changes;
        if (onlyField) {
            for (var i = 0, l = rows.length; i < l; i++) {
                var row = rows[i];
                if (row._state == "modified") {
                    var newRow = {};
                    newRow._state = row._state;
                    newRow[this.idField] = row[this.idField];
                    for (var field in row) {
                        var modifed = this.isModified(row, field);
                        if (modifed) {
                            newRow[field] = row[field];
                        }
                    }
                    rows[i] = newRow;
                }
            }
        }
        return changes;
    },
    //acceptChanges和rejectChanges都能清空DataTable的增/删/改/错误等标记信息, 但是一个是"提交", 一个是"撤销"处理
    accept: function(node) {
        node = node || this.root;
        this.beginChange();
        this.cascadeChild(this.root, function(node) {
            this.acceptRecord(node);
        }, this);
        this._removeds = []; //被删除行集合
        this._originals = {}; //被修改行集合
        this.endChange();
    },
    reject: function(node) {
        this.beginChange();
        this.cascadeChild(this.root, function(node) {
            this.rejectRecord(node);
        }, this);
        this._removeds = []; //被删除行集合
        this._originals = {}; //被修改行集合
        this.endChange();
    },
    acceptRecord: function(node) {
        if (!node._state) return;
        delete this._originals[node[this._originalIdField]];
        if (node._state == "deleted") { //如果是"删除", 则提交修改时, 实现真正移除
            this.removeNode(node);
        } else {
            delete node._state;
            delete this._originals[node[this._originalIdField]];
            this._dataChanged();
            this.fire("update", { record: node });
        }

    },
    rejectRecord: function(node) {
        if (!node._state) return;
        if (node._state == "added") { //如果是新增撤销, 则删除之                                   
            this.removeNode(node);
        } else if (node._state == "modified" || node._state == "deleted") {
            var or = this._getOriginal(node);
            mini.copyTo(node, or);
            delete node._state;
            delete this._originals[node[this._originalIdField]];
            this._dataChanged();
            this.fire("update", { record: node });
        }
    },
    ///////////////////////////////////////////////
    ////升级/降级方法, 不公开, 给甘特图用
    upGrade: function(task) {
        var parentTask = this.getParentNode(task);
        if (parentTask == this.root || task == this.root) {
            return false;
        }

        //任务的当前位置
        var pNodes = parentTask[this.nodesField];

        var index = pNodes.indexOf(task);
        var appendIndex = task[this.nodesField] ? task[this.nodesField].length : 0;
        //删除父任务下,index之后的元素,并将删除的元素增加给选中元素
        for (var i = pNodes.length - 1; i >= index; i--) {
            var o = pNodes[i];
            pNodes.removeAt(i);
            if (o != task) {
                if (!task[this.nodesField]) task[this.nodesField] = [];
                task[this.nodesField].insert(appendIndex, o);
            }
        }
        //将task加入到原父任务之后位置
        var pparentTask = this.getParentNode(parentTask);
        var ppNodes = pparentTask[this.nodesField];
        var index = ppNodes.indexOf(parentTask);
        ppNodes.insert(index + 1, task);

        //_ParentId和_Level会改变
        this._updateParentAndLevel(task, pparentTask);

        this._doFilter();

        this._dataChanged();
    },
    downGrade: function(node) {
        //如果node是数组的第一个元素,则不能降级
        if (this.isFirstNode(node)) {
            return false;
        }

        var oldParentNode = this.getParentNode(node);

        var opNodes = oldParentNode[this.nodesField];

        var index = opNodes.indexOf(node);

        var parentNode = opNodes[index - 1];

        //从旧父节点中删除, 并插入到新父节点下
        opNodes.removeAt(index);
        if (!parentNode[this.nodesField]) parentNode[this.nodesField] = [];
        parentNode[this.nodesField].add(node);

        //_ParentId和_Level会改变
        this._updateParentAndLevel(node, parentNode);

        //如果有viewNodes，同时也发生变化

        this._doFilter();

        this._dataChanged();


    },

    _updateParentAndLevel: function(node, parentNode) {
        var that = this;
        node._pid = parentNode._id;
        node._level = parentNode._level + 1;
        node[that.parentField] = parentNode[that.idField];
        if (!node[that.parentField]) node[that.parentField] = parentNode._id;

        this.cascadeChild(node, function(n, i, p) {
            n._pid = p._id;
            n._level = p._level + 1;

            n[that.parentField] = p[that.idField];
        }, this);
        this._setModified(node);
    },
    //////////////////////////////////////////////////////////////
    // Check Node
    //////////////////////////////////////////////////////////////
    setCheckModel: function(value) {
        this.checkModel = value;
    },
    getCheckModel: function() {
        return this.checkModel;
    },
    setOnlyLeafCheckable: function(value) {
        this.onlyLeafCheckable = value;
    },
    getOnlyLeafCheckable: function() {
        return this.onlyLeafCheckable;
    },
    setAutoCheckParent: function(value) {
        this.autoCheckParent = value;
    },
    getAutoCheckParent: function() {
        return this.autoCheckParent;
    },
    _doUpdateLoadedCheckedNodes: function() { //加载后调用，同步checked

        //var nodes = this.getAllChildNodes(this.root);
        var nodes = this.getList();


        for (var i = 0, l = nodes.length; i < l; i++) {
            var node = nodes[i];
            if (node.checked == true) {
                if (this.autoCheckParent == false || !this.hasChildNodes(node)) {
                    this._doUpdateNodeCheckState(node);
                }
            }
        }

    },
    _doUpdateNodeCheckState: function(node) {
        //遍历节点，根据设置，关联选择：checkModel(cascade)，
        //判断：onlyLeafCheckable，node.checkable
        if (!node) return;

        var checked = this.isChecked(node);
        if (this.checkModel == "cascade" || this.autoCheckParent) {
            //反选子节点            
            this.cascadeChild(node, function(cnode) {
                //                var checkable = this.getCheckable(cnode);
                //                if (checkable) {
                this.doCheckNodes(cnode, checked);
                //                }
            }, this);
            //三态父节点
            if (!this.autoCheckParent) {
                var ans = this.getAncestors(node);
                ans.reverse();
                for (var i = 0, l = ans.length; i < l; i++) {
                    var pnode = ans[i];
                    //                    var checkable = this.getCheckable(pnode);
                    //                    if (checkable == false) return;
                    var childNodes = this.getChildNodes(pnode);
                    var checkAll = true;
                    for (var ii = 0, ll = childNodes.length; ii < ll; ii++) {
                        var cnode = childNodes[ii];
                        if (!this.isCheckedNode(cnode)) {
                            checkAll = false;
                        }
                    }
                    if (checkAll) this.doCheckNodes(pnode, true);
                    else {
                        this.doCheckNodes(pnode, false);
                    }
                    //父节点数据不多，激发下
                    this.fire("checkchanged", { nodes: [pnode], _nodes: [pnode] });
                }
            }
        }
        var that = this;
        //if (this.autoCheckParent && checked) {
        function hasCheckedChildNode(pnode) {
            var childNodes = that.getChildNodes(pnode);
            for (var ii = 0, ll = childNodes.length; ii < ll; ii++) {
                var cnode = childNodes[ii];
                if (that.isCheckedNode(cnode)) {
                    return true;
                }
            }
            return false;
        }
        if (this.autoCheckParent) {
            //1)有子节点选中就选中；2)所有子节点都没选中，取消选中
            var ans = this.getAncestors(node);
            ans.reverse();
            for (var i = 0, l = ans.length; i < l; i++) {
                var pnode = ans[i];
                //                var checkable = this.getCheckable(pnode);
                //                if (checkable == false) return;
                pnode.checked = hasCheckedChildNode(pnode);
                this.fire("checkchanged", { nodes: [pnode], _nodes: [pnode] });
            }
        }
    },
    doCheckNodes: function(nodes, checked, cascade) {

        //cascade: 是否关联选择
        if (!nodes) return;
        if (typeof nodes == "string") {
            nodes = nodes.split(",");
        }
        if (!mini.isArray(nodes)) nodes = [nodes];
        nodes = nodes.clone();
        var _nodes = [];
        checked = checked !== false;

        if (cascade === true) {
            if (this.checkModel == "single") {
                this.uncheckAllNodes();
            }
        }
        for (var i = nodes.length - 1; i >= 0; i--) {
            var node = this.getRecord(nodes[i]);
            if (!node ||
                (checked && node.checked === true) ||
                (!checked && node.checked !== true)
            ) {
                if (node) {
                    //if(node.text == 'Base') debugger
                    //if(!checked 
                    if (cascade === true) {
                        this._doUpdateNodeCheckState(node);
                    }
                    if (!checked && !this.isLeaf(node)) {
                        _nodes.push(node);
                    }

                }
                continue;
            }
            if(node.enabled !== false){
                node.checked = checked;
            }
            _nodes.push(node);
            if (cascade === true) {
                this._doUpdateNodeCheckState(node);
            }
            //if (checked) delete node.checkState;
        }

        var me = this;
        setTimeout(function() {
            me.fire("_checkchanged", { nodes: nodes, _nodes: _nodes, checked: checked });
        }, 1);
    },
    checkNode: function(node, cascade) {

        this.doCheckNodes([node], true, cascade !== false);
    },
    uncheckNode: function(node, cascade) {
        this.doCheckNodes([node], false, cascade !== false);
    },
    checkNodes: function(nodes, cascade) {
        if (!mini.isArray(nodes)) nodes = [];
        this.doCheckNodes(nodes, true, cascade !== false);
    },
    uncheckNodes: function(nodes, cascade) {
        if (!mini.isArray(nodes)) nodes = [];
        this.doCheckNodes(nodes, false, cascade !== false);
    },
    checkAllNodes: function() {
        var nodes = this.getList();
        this.doCheckNodes(nodes, true, false);
    },
    uncheckAllNodes: function() {
        var nodes = this.getList();
        this.doCheckNodes(nodes, false, false);
    },

    doGetCheckedNodes: function(sourceNodes, mode) {
        if (mode === false) mode = 'leaf';
        var nodes = [];
        var maps = {};

        for (var j = 0, k = sourceNodes.length; j < k; j++) {
            var node = sourceNodes[j];
            var isLeaf = this.isLeafNode(node);
            if (mode === true) {
                //nodes.push(node);
                if (!maps[node._id]) {
                    maps[node._id] = node;
                    nodes.push(node);
                }
                var ans = this.getAncestors(node);
                for (var i = 0, l = ans.length; i < l; i++) {
                    var anode = ans[i];
                    if (!maps[anode._id]) {
                        maps[anode._id] = anode;
                        nodes.push(anode);
                    }
                }
            } else if (mode === "parent") {
                if (!isLeaf) {
                    //nodes.push(node);
                    if (!maps[node._id]) {
                        maps[node._id] = node;
                        nodes.push(node);
                    }
                }
            } else if (mode === "leaf") {
                if (isLeaf) {
                    //nodes.push(node);
                    if (!maps[node._id]) {
                        maps[node._id] = node;
                        nodes.push(node);
                    }
                }
            } else {
                //nodes.push(node);
                if (!maps[node._id]) {
                    maps[node._id] = node;
                    nodes.push(node);
                }
            }

        }
        return nodes;
    },

    getCheckedNodes: function(mode) { //parent, leaf, true(包含父节点）, 不传递（当前选中）
        var nodes = [];

        this.cascadeChild(this.root, function(node) {
            if (node.checked == true) nodes.push(node);
        });

        nodes = this.doGetCheckedNodes(nodes, mode);

        return nodes;
    },

    //    getCheckedNodes: function (mode) {  //parent, leaf, true(包含父节点）, 不传递（当前选中）
    //        if (mode === false) mode = 'leaf';
    //        var nodes = [];
    //        var maps = {};
    //        this.cascadeChild(this.root, function (node) {
    //            if (node.checked == true) {
    //                var isLeaf = this.isLeafNode(node);
    //                if (mode === true) {
    //                    //nodes.push(node);
    //                    if (!maps[node._id]) {
    //                        maps[node._id] = node;
    //                        nodes.push(node);
    //                    }
    //                    var ans = this.getAncestors(node);
    //                    for (var i = 0, l = ans.length; i < l; i++) {
    //                        var anode = ans[i];
    //                        if (!maps[anode._id]) {
    //                            maps[anode._id] = anode;
    //                            nodes.push(anode);
    //                        }
    //                    }
    //                } else if (mode === "parent") {
    //                    if (!isLeaf) {
    //                        //nodes.push(node);
    //                        if (!maps[node._id]) {
    //                            maps[node._id] = node;
    //                            nodes.push(node);
    //                        }
    //                    }
    //                } else if (mode === "leaf") {
    //                    if (isLeaf) {
    //                        //nodes.push(node);
    //                        if (!maps[node._id]) {
    //                            maps[node._id] = node;
    //                            nodes.push(node);
    //                        }
    //                    }
    //                } else {
    //                    //nodes.push(node);
    //                    if (!maps[node._id]) {
    //                        maps[node._id] = node;
    //                        nodes.push(node);
    //                    }
    //                }
    //            }
    //        }, this);
    //        return nodes;
    //    },
    getCheckedNodesId: function(mode, delimiter) {
        var nodes = this.getCheckedNodes(mode);
        var vts = this.getValueAndText(nodes, delimiter);
        return vts[0];
    },
    getCheckedNodesText: function(mode, delimiter) {
        var nodes = this.getCheckedNodes(mode);
        var vts = this.getValueAndText(nodes, delimiter);
        return vts[1];
    },
    isChecked: function(node) {
        node = this.getRecord(node);
        if (!node) return null;
        return node.checked === true || node.checked === 1;
    },
    getCheckState: function(node) { //更新三态时，只获取父节点

        node = this.getRecord(node);
        if (!node) return null;
        if (node.checked === true) return "checked";
        if (!node[this.nodesField]) return "unchecked";

        if (node.indeterminate) return "indeterminate";

        var children = this.getChildNodes(node, true); //@@@ 要死了
        for (var i = 0, l = children.length; i < l; i++) {
            var node = children[i];
            if (node.checked === true) return "indeterminate";
        }
        return "unchecked";
    },
    getUnCheckableNodes: function() {
        var nodes = [];
        this.cascadeChild(this.root, function(node) {
            var checkable = this.getCheckable(node);
            if (checkable == false) {
                nodes.push(node);
            }
        }, this);
        return nodes;
    },
    setCheckable: function(nodes, checkable) { //disableCheckbox方法就不提供了
        if (!nodes) return;
        if (!mini.isArray(nodes)) nodes = [nodes];
        nodes = nodes.clone();
        checkable = !!checkable;
        for (var i = nodes.length - 1; i >= 0; i--) {
            var node = this.getRecord(nodes[i]);
            if (!node) {
                continue;
            }
            node.checkable = checked;
        }
        //        this.fire("checkchanged", {nodes: [node]);
    },
    getCheckable: function(node) {
        node = this.getRecord(node);
        if (!node) return false;
        if (node.checkable === true) return true;
        if (node.checkable === false) return false;
        return this.isLeafNode(node) ? true : !this.onlyLeafCheckable;
    },
    showNodeCheckbox: function(node, show) {

    },
    ///////////////////////////////////
    reload: function(success, error, complete) {

        this._loadingNode = null;


        this.load(this.loadParams, success, error, complete);
    },
    _isNodeLoading: function() {
        return !!this._loadingNode;
    },
    loadNode: function(node, expand) {

        this._loadingNode = node;
        var e = { node: node };
        this.fire("beforeloadnode", e);
        //

        var time = new Date();

        var me = this;
        me._doLoadAjax(me.loadParams, null, null, null, function(e) {
            var t = new Date() - time;
            if (t < 60) t = 60 - t;

            setTimeout(function() {

                //success
                e.node = node;
                me._OnPreLoad(e);

                //e.node = me._loadingNode;
                me._loadingNode = null;
                if (me.loadParams) delete me.loadParams[me.idField];

                var oldNodes = node[me.nodesField];
                me.removeNodes(oldNodes);

                var nodes = e.data;
                if (nodes && nodes.length > 0) {

                    me.collapse(node); //addNodes之前    优化！！！

                    me.addNodes(nodes, node);

                    //清楚新增痕迹
                    var all = me.getAllChildNodes(node);
                    for (var i = 0, l = all.length; i < l; i++) {
                        var treeNode = all[i];
                        //me.acceptRecord(treeNode);
                        delete treeNode._state; //优化！！！
                    }

                    if (expand !== false) {
                        me.expand(node, true);
                    } else {
                        me.collapse(node, true);
                    }
                } else {
                    delete node[me.leafField];
                    me.expand(node, true);
                }


                me.fire("loadnode", e);
                me.fire("load", e);
            }, t);
        }, true);
    }
});
mini.regClass(mini.DataTree, "datatree");



//==========================================================================
/* DataTable/DateTree Applys
-----------------------------------------------------------------------------*/
mini._DataTableApplys = {
    /////////////////////////////////////////////
    idField: "id",
    textField: "text",
    setAjaxData: function(value) {
        this._dataSource.ajaxData = value;
    },
    getby_id: function(id) {
        return this._dataSource.getby_id(id);
    },
    getValueAndText: function(records, delimiter) {
        return this._dataSource.getValueAndText(records, delimiter);
    },
    setIdField: function(value) {
        this._dataSource.setIdField(value);
        this.idField = value;
    },
    getIdField: function() {
        return this._dataSource.idField;
    },
    setTextField: function(value) {
        this._dataSource.setTextField(value);
        this.textField = value;
    },
    getTextField: function() {
        return this._dataSource.textField;
    },
    //////////////////////////////
    getLoadParams: function() {
        return this._dataSource.loadParams;
    },
    clearData: function() {
        this._dataSource.clearData();
    },
    loadData: function(data) {
        this._dataSource.loadData(data);
    },
    setData: function(data) {
        this._dataSource.loadData(data);
    },
    getData: function() {
        return this._dataSource.getSource().clone();
    },
    getList: function() {
        return this._dataSource.getList();
    },
    getDataView: function() {
        return this._dataSource.getDataView();
    },
    getVisibleRows: function() {
        if (this._useEmptyView) return [];
        return this._dataSource.getVisibleRows();
    },
    toArray: function() {
        return this._dataSource.toArray();
    },
    getRecord: function(id) {
        if (typeof id == 'object') return id;
        return this._dataSource.getRecord(id);
    },
    getRow: function(index) {
        if (typeof index == 'object') return index;
        return this._dataSource.getRow(index);
    },
    getRange: function(start, end) {
        if (mini.isNull(start) || mini.isNull(end)) return;
        return this._dataSource.getRange(start, end);
    },
    getAt: function(index) {
        return this._dataSource.getAt(index);
    },
    indexOf: function(record) {
        return this._dataSource.indexOf(record);
    },
    getRowByUID: function(uid) {
        return this._dataSource.getby_id(uid);
    },
    getRowByUid: function(uid) {
        return this.getRowByUID(uid);
    },
    getRowById: function(id) {
        return this._dataSource.getbyId(id);
    },
    ///////////////////////////////
    clearRows: function() {
        this._dataSource.clearData();
    },
    //    getRows: function () {
    //        return this._dataSource.toArray();
    //    },
    updateRow: function(record, field, value) {
        this._dataSource.updateRecord(record, field, value);
    },
    addRow: function(record, index) {
        var o = this._dataSource.insert(index, record);

        if (this.validateOnAdd) this.validateRow(record);
        return o;
    },
    removeRow: function(record, autoSelect) {

        return this._dataSource.remove(record, autoSelect);
    },
    removeRows: function(records, autoSelect) {
        return this._dataSource.removeRange(records, autoSelect);
    },
    removeSelected: function() {
        var row = this.getSelected();
        if (row) {
            this.removeRow(row, true);
        }
    },
    removeRowAt: function(index, autoSelect) {
        return this._dataSource.removeAt(index, autoSelect);
    },
    moveRow: function(row, index) {
        this._dataSource.move(row, index);
    },
    addRows: function(records, index) {
        return this._dataSource.insertRange(index, records);
    },
    findRows: function(field, value) {
        return this._dataSource.findRecords(field, value);
    },
    findRow: function(field, value) {
        return this._dataSource.findRecord(field, value);
    },
    //    removeSelected: function (select) {
    //        var row = this.getSelected();
    //        var index = this.indexOf(row);
    //        this.removeRecord(row);
    //        if (select !== false) {
    //            row = this.getAt(index);
    //            this.select(row ? index : index - 1);
    //        }
    //    },
    //////////////////////////////////////////////////
    multiSelect: false,
    setMultiSelect: function(value) {
        this._dataSource.setMultiSelect(value);
        this.multiSelect = value;
    },
    getMultiSelect: function() {
        return this._dataSource.getMultiSelect();
    },
    setCurrent: function(record) {
        this._dataSource.setCurrent(record);
    },
    getCurrent: function() {
        return this._dataSource.getCurrent();
    },
    isSelected: function(record) {
        return this._dataSource.isSelected(record);
    },
    setSelected: function(record) {
        this._dataSource.setSelected(record);
    },
    getSelected: function() {
        return this._dataSource.getSelected();
    },
    getSelecteds: function() {
        return this._dataSource.getSelecteds();
    },
    select: function(record, fireEvent) {

        this._dataSource.select(record, fireEvent);
    },
    selects: function(records, fireEvent) {
        this._dataSource.selects(records, fireEvent);
    },
    deselect: function(record, fireEvent) {
        this._dataSource.deselect(record, fireEvent);
    },
    deselects: function(records, fireEvent) {
        this._dataSource.deselects(records, fireEvent);
    },
    selectAll: function(fireEvent) {
        this._dataSource.selectAll(fireEvent);
    },
    deselectAll: function(fireEvent) {
        this._dataSource.deselectAll(fireEvent);
    },
    clearSelect: function(fireEvent) {
        this.deselectAll(fireEvent);
    },
    selectPrev: function() {
        this._dataSource.selectPrev();
    },
    selectNext: function() {
        this._dataSource.selectNext();
    },
    selectFirst: function() {
        this._dataSource.selectFirst();
    },
    selectLast: function() {
        this._dataSource.selectLast();
    },
    selectRange: function(start, end) {
        this._dataSource.selectRange(start, end);
    },
    //////////////////////////////////////////////////
    filter: function(fn, scope) {
        this._dataSource.filter(fn, scope);
    },
    clearFilter: function() {
        this._dataSource.clearFilter();
    },
    sort: function(fn, scope, reverse) {
        this._dataSource.sort(fn, scope, reverse);
    },
    clearSort: function() {
        this._dataSource.clearSort();
    },
    findItems: function(a, b, c) {
        return this._dataSource.findRecords(c, b, c);
    },
    ////////////////////////////////////////
    getResultObject: function() {
        return this._dataSource._resultObject || {};
    },
    isChanged: function() {
        return this._dataSource.isChanged();
    },
    getChanges: function(state, onlyField) {
        return this._dataSource.getChanges(state, onlyField);
    },
    accept: function() {
        this._dataSource.accept();
    },
    reject: function() {
        this._dataSource.reject();
    },
    acceptRecord: function(record) {
        this._dataSource.acceptRecord(record);
    },
    rejectRecord: function(record) {
        this._dataSource.rejectRecord(record);
    }
};


mini._DataTreeApplys = {
    addRow: null,
    removeRow: null,
    removeRows: null,
    removeRowAt: null,
    moveRow: null,

    /////////////////////////////////////////////
    setExpandOnLoad: function(value) {
        this._dataSource.setExpandOnLoad(value);
    },
    getExpandOnLoad: function() {
        return this._dataSource.getExpandOnLoad();
    },
    /////////////////////////////////////////////
    isSelectedNode: function(node) {
        node = this.getNode(node);
        return this.getSelectedNode() === node;
    },
    selectNode: function(node, fireEvent) {
        if (node) {
            this._dataSource.select(node, fireEvent);
        } else {
            this._dataSource.deselect(this.getSelectedNode(), fireEvent);
        }
    },
    getSelectedNode: function() {
        return this.getSelected();
    },
    getSelectedNodes: function() {
        return this.getSelecteds();
    },
    updateNode: function(node, field, value) {
        this._dataSource.updateRecord(node, field, value);
    },
    addNode: function(node, action, parentNode) {
        return this._dataSource.insertNode(node, action, parentNode);
    },
    removeNodeAt: function(index, parentNode) {
        return this._dataSource.removeNodeAt(index, parentNode);
        this._changed = true;
    },
    removeNode: function(node) {
        return this._dataSource.removeNode(node);
    },
    moveNode: function(node, action, targetNode) {
        this._dataSource.moveNode(node, action, targetNode);
    },
    addNodes: function(nodes, parentNode, action) {
        return this._dataSource.addNodes(nodes, parentNode, action);
    },
    insertNodes: function(nodes, index, parentNode) {
        return this._dataSource.insertNodes(index, nodes, parentNode);
    },
    moveNodes: function(nodes, targetNode, action) {
        this._dataSource.moveNodes(nodes, targetNode, action);
    },
    removeNodes: function(nodes) {
        return this._dataSource.removeNodes(nodes);
    },
    ////////////////////////////////////////    

    expandOnLoad: false, //默认全部收缩
    checkRecursive: true,
    autoCheckParent: false,
    showFolderCheckBox: true,

    idField: "id",
    textField: "text",
    parentField: "pid",
    nodesField: "children",
    checkedField: "checked",
    leafField: 'isLeaf',
    resultAsTree: false,

    //    _changed: false,
    //    isChanged: function () {
    //        return this._changed;
    //    },

    setShowFolderCheckBox: function(value) {
        this._dataSource.setShowFolderCheckBox(value);
        if (this.doUpdate) this.doUpdate();
        this.showFolderCheckBox = value;
    },
    getShowFolderCheckBox: function() {
        return this._dataSource.getShowFolderCheckBox();
    },
    setCheckRecursive: function(value) {
        this._dataSource.setCheckRecursive(value);
        this.checkRecursive = value;
    },
    getCheckRecursive: function() {
        return this._dataSource.getCheckRecursive();
    },
    setResultAsTree: function(value) {
        this._dataSource.setResultAsTree(value);
    },
    getResultAsTree: function(value) {
        return this._dataSource.resultAsTree;
    },
    setParentField: function(value) {
        this._dataSource.setParentField(value);
        this.parentField = value;
    },
    getParentField: function() {
        return this._dataSource.parentField;
    },
    setLeafField: function(value) {
        this._dataSource.leafField = value;
        this.leafField = value;
    },
    getLeafField: function() {
        return this._dataSource.leafField;
    },
    setNodesField: function(value) {
        this._dataSource.setNodesField(value);
        this.nodesField = value;
    },
    getNodesField: function() {
        return this._dataSource.nodesField;
    },
    setCheckedField: function(value) {
        this._dataSource.checkedField = value;
        this.checkedField = value;
    },
    getCheckedField: function() {
        return this.checkedField;
    },
    /////////////////////////////
    findNodes: function(field, value) {
        return this._dataSource.findRecords(field, value);
    },
    getLevel: function(node) {
        return this._dataSource.getLevel(node);
    },
    isVisibleNode: function(node) {
        return this._dataSource.isVisibleNode(node);
    },

    isEnabledNode: function(node) {
        return this._dataSource.isEnabledNode(node);
    },
    isExpandedNode: function(node) {
        return this._dataSource.isExpandedNode(node);
    },
    isCheckedNode: function(node) {
        return this._dataSource.isCheckedNode(node);
    },
    isLeaf: function(node) {
        return this._dataSource.isLeafNode(node);
    },
    hasChildren: function(node) {
        return this._dataSource.hasChildren(node);
    },
    isAncestor: function(pnode, node) {
        return this._dataSource.isAncestor(pnode, node);
    },
    getNode: function(node) {
        return this._dataSource.getRecord(node);
    },
    getRootNode: function() {
        return this._dataSource.getRootNode();
    },
    getParentNode: function(node) {
        return this._dataSource.getParentNode.apply(this._dataSource, arguments);
    },
    getAncestors: function(node) {
        return this._dataSource.getAncestors(node);
    },
    getAllChildNodes: function(node) {
        return this._dataSource.getAllChildNodes.apply(this._dataSource, arguments);
    },
    getChildNodes: function(node, all) {
        return this._dataSource.getChildNodes.apply(this._dataSource, arguments);
    },
    getChildNodeAt: function(index, node) {
        return this._dataSource.getChildNodeAt.apply(this._dataSource, arguments);
    },
    indexOfNode: function(node) {
        return this._dataSource.indexOfNode.apply(this._dataSource, arguments);
    },
    hasChildNodes: function(node) {
        return this._dataSource.hasChildNodes.apply(this._dataSource, arguments);
    },
    isFirstNode: function(node) {
        return this._dataSource.isFirstNode.apply(this._dataSource, arguments);
    },
    isLastNode: function(node) {
        return this._dataSource.isLastNode.apply(this._dataSource, arguments);
    },
    getNextNode: function(node) {
        return this._dataSource.getNextNode.apply(this._dataSource, arguments);
    },
    getPrevNode: function(node) {
        return this._dataSource.getPrevNode.apply(this._dataSource, arguments);
    },
    getFirstNode: function(parentNode) {
        return this._dataSource.getFirstNode.apply(this._dataSource, arguments);
    },
    getLastNode: function(parentNode) {
        return this._dataSource.getLastNode.apply(this._dataSource, arguments);
    },

    ///////////////////////////////////
    toggleNode: function(node) {
        this._dataSource.toggle(node);
    },
    collapseNode: function(node, deep) {
        this._dataSource.collapse(node, deep);
    },
    expandNode: function(node, deep) {
        this._dataSource.expand(node, deep);
    },
    collapseAll: function() {
        this.useAnimation = false;
        this._dataSource.collapseAll();
        this.useAnimation = true;
    },
    expandAll: function() {
        this.useAnimation = false;
        this._dataSource.expandAll();
        this.useAnimation = true;
    },
    expandLevel: function(level) {
        this.useAnimation = false;
        this._dataSource.expandLevel(level);
        this.useAnimation = true;
    },
    collapseLevel: function(level) {
        this.useAnimation = false;
        this._dataSource.collapseLevel(level);
        this.useAnimation = true;
    },
    expandPath: function(node) {
        this.useAnimation = false;
        this._dataSource.expandPath(node);
        this.useAnimation = true;
    },
    collapsePath: function(node) {
        this.useAnimation = false;
        this._dataSource.collapsePath(node);
        this.useAnimation = true;
    },
    ////////////////////////////////
    loadNode: function(node, options) {
        this._dataSource.loadNode(node, options);
    },
    ////////////////////////////////
    setCheckModel: function(value) {
        this._dataSource.setCheckModel(value);
    },
    getCheckModel: function() {
        return this._dataSource.getCheckModel();
    },
    setOnlyLeafCheckable: function(value) {
        this._dataSource.setOnlyLeafCheckable(value);
    },
    getOnlyLeafCheckable: function() {
        return this._dataSource.getOnlyLeafCheckable();
    },
    setAutoCheckParent: function(value) {
        this._dataSource.setAutoCheckParent(value);
    },
    getAutoCheckParent: function() {
        return this._dataSource.getAutoCheckParent();
    },
    checkNode: function(node, cascade) {
        this._dataSource.checkNode(node, cascade);
    },
    uncheckNode: function(node, cascade) {
        this._dataSource.uncheckNode(node, cascade);
    },
    checkNodes: function(nodes, cascade) {
        this._dataSource.checkNodes(nodes, cascade);
    },
    uncheckNodes: function(nodes, cascade) {
        this._dataSource.uncheckNodes(nodes, cascade);
    },
    checkAllNodes: function() {
        this._dataSource.checkAllNodes();
    },
    uncheckAllNodes: function() {
        this._dataSource.uncheckAllNodes();
    },
    getCheckedNodes: function() {
        return this._dataSource.getCheckedNodes.apply(this._dataSource, arguments);
    },
    getCheckedNodesId: function() {
        return this._dataSource.getCheckedNodesId.apply(this._dataSource, arguments);
    },
    getCheckedNodesText: function() {
        return this._dataSource.getCheckedNodesText.apply(this._dataSource, arguments);
    },
    getNodesByValue: function(value) {
        if (mini.isNull(value)) value = "";
        value = String(value);
        var nodes = [];
        var ids = String(value).split(",");
        for (var i = 0, l = ids.length; i < l; i++) {
            var node = this.getNode(ids[i]);
            if (node) nodes.push(node);
        }
        return nodes;
    },
    isChecked: function(node) {
        return this._dataSource.isChecked.apply(this._dataSource, arguments);
    },
    getCheckState: function(node) {
        return this._dataSource.getCheckState.apply(this._dataSource, arguments);
    },
    setCheckable: function(nodes, checkable) {
        this._dataSource.setCheckable.apply(this._dataSource, arguments);
    },
    getCheckable: function(node) {
        return this._dataSource.getCheckable.apply(this._dataSource, arguments);
    },
    ///////////////////////////
    bubbleParent: function(node, fn, scope) {
        this._dataSource.bubbleParent.apply(this._dataSource, arguments);
    },
    cascadeChild: function(node, fn, scope) {
        this._dataSource.cascadeChild.apply(this._dataSource, arguments);
    },
    eachChild: function(node, fn, scope) {
        this._dataSource.eachChild.apply(this._dataSource, arguments);
    }
};
/*
    ColumnModel 列模型
        多表头
        隐藏列
        锁定列
        分组列
    事件：columnschanged   :   add/remove/resize/move

    列模型数据：
        原始列：columns
            简单：列数组
            复杂：列属性
        列视图：_columnsRow（多行列）、_visibleColumns显示的单行列。
            隐藏列：减少列，改变_visibleColumnsRow和_visibleColumns
            锁定列：不增加、不减少列，不改变_visibleColumnsRow和_visibleColumns。
                  _frozenStartColumn和_frozenEndColumn，约定一个表格显示的左右列区域。
                  生成表头、行的时候，根据这两个参数来处理下就可以了。
            行号列：创建时自己设置列
            //分组列：在GridView层次增加虚列，与ColumnModel无关
*/
mini.ColumnModel = function (grid) {
    this.owner = grid;
    mini.ColumnModel.superclass.constructor.apply(this, arguments);
    this._init();
}
mini.ColumnModel_ColumnID = 1;
mini.extend(mini.ColumnModel, mini.Component, {

    _defaultColumnWidth: 100,

    _init: function () {
        this.columns = [];                  //原始列（全）

        this._columnsRow = [];              //多表头数组(全）
        this._visibleColumnsRow = [];       //多表头数组（可视，去除隐藏列）

        this._bottomColumns = [];           //底行列数组（全）
        this._visibleColumns = [];          //可视的底行列数组（去除隐藏列）

        this._idColumns = {};
        this._nameColumns = {};
        this._fieldColumns = {};
    },
    getColumns: function () {
        return this.columns;
    },
    getAllColumns: function () {
        var columns = [];
        for (var id in this._idColumns) {
            var column = this._idColumns[id];
            columns.push(column);
        }
        return columns;
    },
    getColumnsRow: function () {
        return this._columnsRow;
    },
    getVisibleColumnsRow: function () {
        return this._visibleColumnsRow;
    },
    getBottomColumns: function () {
        return this._bottomColumns;
    },
    getVisibleColumns: function () {
        return this._visibleColumns;
    },
    _getBottomColumnsByColumn: function (column) {
        //获取某列最底层的列数组
        column = this.getColumn(column);
        var columns = this._bottomColumns;
        var cs = [];
        for (var i = 0, l = columns.length; i < l; i++) {
            var c = columns[i];
            if (this.isAncestorColumn(column, c)) cs.push(c);
        }
        return cs;
    },
    _getVisibleColumnsByColumn: function (column) {
        //获取某列最底层的可视列数组
        column = this.getColumn(column);
        var columns = this._visibleColumns;
        var cs = [];
        for (var i = 0, l = columns.length; i < l; i++) {
            var c = columns[i];
            if (this.isAncestorColumn(column, c)) cs.push(c);
        }
        return cs;
    },
    setColumns: function (columns) {
        if (!mini.isArray(columns)) columns = [];
        this._init();
        this.columns = columns;
        this._columnsChanged();
    },
    _columnsChanged: function () {
        this._updateColumnsView();
        this.fire("columnschanged");
    },

    columnDefaults: {
        allowCellWrap: false
    },

    _updateColumnsView: function () {
        //_id, _pid, _level, 
        this._maxColumnLevel = 0;
        var level = 0;
        function init(column, index, parentColumn) {
            if (column.type) {
                if (!mini.isNull(column.header) && typeof column.header !== "function") {
                    if (column.header.trim() == "") {
                        delete column.header;
                    }
                }
                var col = mini._getColumn(column.type);
                if (col) {
                    var _column = mini.copyTo({}, column);
                    mini.copyTo(column, col);
                    mini.copyTo(column, _column);
                }
            }

            //_id, _pid
            if (!column._id) column._id = mini.ColumnModel_ColumnID++;
            column._pid = parentColumn == this ? -1 : parentColumn._id;
            this._idColumns[column._id] = column;
            if (column.name) this._nameColumns[column.name] = column;

            //level
            column._level = level;
            level += 1;
            this.eachColumns(column, init, this);
            level -= 1;
            if (column._level > this._maxColumnLevel) this._maxColumnLevel = column._level;

            //width
            var width = parseInt(column.width);
            if (mini.isNumber(width) && String(width) == column.width) column.width = width + "px";
            if (mini.isNull(column.width)) column.width = this._defaultColumnWidth + "px";
            if (String(column.width).indexOf('px')) {
                column.pxWidth = parseInt(column.width);
            }

            column.visible = column.visible !== false;
            column.allowResize = column.allowResize !== false;
            column.allowMove = column.allowMove !== false;      //列移动
            column.allowSort = column.allowSort === true;       //列排序
            column.allowDrag = !!column.allowDrag;              //行移动
            column.readOnly = !!column.readOnly;
            //column.autoEscape = column.autoEscape !== false;
            column.autoEscape = !!column.autoEscape;
            column.enabled = column.enabled !== false;

            column.showCellTip = column.showCellTip !== false;

            //if(column.header == '姓名') debugger

            column.valueFromSelect = column.valueFromSelect !== false;

            column.vtype = column.vtype || "";



            //column.allowCellWrap = column.allowCellWrap == true;

            if (column.allowCellWrap == null) column.allowCellWrap = this.columnDefaults.allowCellWrap;


            //editor

            //filter
            if (typeof column.filter == "string") {
                column.filter = window["ev" + "al"]('(' + column.filter + ')');
            }
            if (column.filter && !column.filter.el) {
                column.filter = mini.create(column.filter);
            }

            //init
            if (typeof column.init == "function" && column.inited != true) {
                column.init(this.owner);
            }
            column.inited = true;   //如果移除column，将inited去除，这样到新表格，才正常。一般也不会那么复杂。

            //历史问题
            column._gridUID = this.owner.uid;
            column._rowIdField = this.owner._rowIdField;
        }
        this.eachColumns(this, init, this);

        //多表头行
        this._createColumnsRow();

        //底部显示的列集合
        var index = 0;
        var view = this._visibleColumns = [];
        var bottoms = this._bottomColumns = [];
        this.cascadeColumns(this, function (column) {
            if (!column.columns || column.columns.length == 0) {
                bottoms.push(column);
                if (this.isVisibleColumn(column)) {
                    view.push(column);
                    column._index = index++;
                }
            }
        }, this);

        this._fieldColumns = {};
        var columns = this.getAllColumns();
        for (var i = 0, l = columns.length; i < l; i++) {
            var column = columns[i];
            if (column.field && !this._fieldColumns[column.field]) {
                this._fieldColumns[column.field] = column;
            }
        }

        //计算锁定colspan1、非锁定colspan2
        this._createFrozenColSpan();
    },
    //////////////////////////////////////////////////
    _frozenStartColumn: -1,
    _frozenEndColumn: -1,
    _frozenRightStartColumn: -1,
    _frozenRightEndColumn: -1,
    isFrozen: function () {
        return this._frozenStartColumn >= 0 && this._frozenEndColumn >= this._frozenStartColumn;
    },
    isFrozenRight: function () {
        return this._frozenRightStartColumn >= 0 && this._frozenRightEndColumn >= this._frozenRightStartColumn;
    },
    isFrozenColumn: function (column) {
        if (!this.isFrozen()) return false;
        column = this.getColumn(column);
        if (!column) return false;
        var index = this.getVisibleColumns().indexOf(column);
        return this._frozenStartColumn <= index && index <= this._frozenEndColumn;
    },
    isFrozenRightColumn: function (column) {
        if (!this.isFrozenRight()) return false;
        column = this.getColumn(column);
        if (!column) return false;
        var index = this.getVisibleColumns().indexOf(column);
        return this._frozenRightStartColumn <= index && index <= this._frozenRightEndColumn;
    },
    frozen: function (startColumn, finishColumn) {
        var columns = this.getVisibleColumns();

        startColumn = typeof startColumn === 'number' ? columns[startColumn] : this.getColumn(startColumn);
        finishColumn = typeof finishColumn === 'number' ? columns[finishColumn] : this.getColumn(finishColumn);
        
        this._frozenStartColumn = columns.indexOf(startColumn);
        this._frozenEndColumn = columns.indexOf(finishColumn);

        if (startColumn && finishColumn) {
            this._columnsChanged();
        }
    },
    frozenRight: function (startColumn, finishColumn) {
        var columns = this.getVisibleColumns();

        startColumn = typeof startColumn === 'number' ? columns[startColumn] : this.getColumn(startColumn);
        finishColumn = typeof finishColumn === 'number' ? columns[finishColumn] : this.getColumn(finishColumn);
        
        this._frozenRightStartColumn = columns.indexOf(startColumn);
        this._frozenRightEndColumn = columns.indexOf(finishColumn);

        if (startColumn && finishColumn) {
            this._columnsChanged();
        }
    },
    unFrozen: function () {
        this._frozenStartColumn = -1;
        this._frozenEndColumn = -1;
        this._frozenRightStartColumn = -1;
        this._frozenRightEndColumn = -1;
        this._columnsChanged();
    },
    setFrozenStartColumn: function (value) {
        this.frozen(value, this._frozenEndColumn);
    },
    setFrozenEndColumn: function (value) {
        this.frozen(this._frozenStartColumn, value);
    },
    setFrozenRightStartColumn: function (value) {
        this.frozenRight(value, this._frozenRightEndColumn);
    },
    setFrozenRightEndColumn: function (value) {
        this.frozenRight(this._frozenRightStartColumn, value);
    },
    getFrozenColumns: function () {
        var columns = [], isFrozen = this.isFrozen();
        for (var i = 0, l = this._visibleColumns.length; i < l; i++) {
            if (isFrozen && this._frozenStartColumn <= i && i <= this._frozenEndColumn) {
                columns.push(this._visibleColumns[i]);
            }
        }
        return columns;
    },
    getFrozenRightColumns: function () {
        var columns = [], isFrozenRight = this.isFrozenRight();
        for (var i = 0, l = this._visibleColumns.length; i < l; i++) {
            if (isFrozenRight && this._frozenRightStartColumn <= i && i <= this._frozenRightEndColumn) {
                columns.push(this._visibleColumns[i]);
            }
        }
        return columns;
    },
    getUnFrozenColumns: function () {
        var columns = [],
            isFrozen = this.isFrozen(),
            isFrozenRight = this.isFrozenRight();

        if (!isFrozen && !isFrozenRight) return this._visibleColumns;

        for (var i = 0, l = this._visibleColumns.length; i < l; i++) {
            if (isFrozen && this._frozenStartColumn <= i && i <= this._frozenEndColumn) continue;
            if (isFrozenRight && this._frozenRightStartColumn <= i && i <= this._frozenRightEndColumn) continue;

            columns.push(this._visibleColumns[i]);
        }
        return columns;
    },
    getFrozenColumnsRow: function () {
        return this.isFrozen() ? this._columnsRow1 : [];
    },
    getFrozenRightColumnsRow: function () {
        return this.isFrozenRight() ? this._columnsRow3 : [];
    },
    getUnFrozenColumnsRow: function () {
        return (this.isFrozen() || this.isFrozenRight()) ? this._columnsRow2 : this.getVisibleColumnsRow();
    },
    //////////////////////////////////////////////////
    _createFrozenColSpan: function () {
        //计算锁定前的colspan0、锁定colspan1、非锁定colspan2、右锁定colspan3、右锁定后colspan4：一共有5个区段
        //步骤：从visibleColumns遍历，向上计算父column的colspan
        var me = this;
        var visibleColumns = this.getVisibleColumns();
        var start = this._frozenStartColumn, end = this._frozenEndColumn;
        var start1 = this._frozenRightStartColumn, end1 = this._frozenRightEndColumn;
        var isFrozen = this.isFrozen(), isFrozenRight = this.isFrozenRight();

        function isViewIndex(column, viewIndex) {
            if (me.isBottomColumn(column)) {
                var index = visibleColumns.indexOf(column);
                if (viewIndex == 0 && index < start) return true;
                if (viewIndex == 1 && start <= index && index <= end) return true;
                if (viewIndex == 2) {
                    if(isFrozen && isFrozenRight) {
                        return end < index && index < start1;
                    } else if (!isFrozen && !isFrozenRight) {
                        return true;
                    } else if (isFrozen && !isFrozenRight) {
                        return index > end;
                    } else if(!isFrozen && isFrozenRight) {
                        return index < start1;
                    }
                }
                if (viewIndex == 3 && start1 <= index && index <= end1) return true;
                if (viewIndex == 4 && index > end1 && end1 != -1) return true;
            } else {
                var columns = me._getVisibleColumnsByColumn(column);
                for(var i = 0; i < 5; i++) {
                    if (viewIndex == i) {
                        return columns.some(function(item) {
                            return item['viewIndex' + i] || isViewIndex(item, i);
                        });
                    }
                }
            }
            return false;
        }

        function getColSpan(col, viewIndex) {
            var subColumns = mini.treeToList(col.columns, "columns");
            var colSpan = 0;
            for (var i = 0, l = subColumns.length; i < l; i++) {
                var c = subColumns[i];
                if (me.isVisibleColumn(c) == false || isViewIndex(c, viewIndex) == false) continue;
                if (!c.columns || c.columns.length == 0) {//只处理最底层的列
                    colSpan += 1;
                }
            }
            return colSpan;
        }

        var list = mini.treeToList(this.columns, "columns");
        for (var i = 0, l = list.length; i < l; i++) {
            var column = list[i];
            //if (column.header == 'Order') debugger
            delete column.colspan0;
            delete column.colspan1;
            delete column.colspan2;
            delete column.colspan3;
            delete column.colspan4;

            delete column.viewIndex0;
            delete column.viewIndex1;
            delete column.viewIndex2;
            delete column.viewIndex3;
            delete column.viewIndex4;

            if (this.isFrozen() || this.isFrozenRight()) {
                if (column.columns && column.columns.length > 0) {
                    column.colspan0 = getColSpan(column, 0);
                    column.colspan1 = getColSpan(column, 1);
                    column.colspan2 = getColSpan(column, 2);
                    column.colspan3 = getColSpan(column, 3);
                    column.colspan4 = getColSpan(column, 4);
                } else {
                    column.colspan0 = 1;
                    column.colspan1 = 1;
                    column.colspan2 = 1;
                    column.colspan3 = 1;
                    column.colspan4 = 1;
                }
                //确定列属于什么区域
                if (isViewIndex(column, 0)) {
                    column["viewIndex" + 0] = true;
                }
                if (isViewIndex(column, 1)) {
                    column["viewIndex" + 1] = true;
                }
                if (isViewIndex(column, 2)) {
                    column["viewIndex" + 2] = true;
                }
                if (isViewIndex(column, 3)) {
                    column["viewIndex" + 3] = true;
                }
                if (isViewIndex(column, 4)) {
                    column["viewIndex" + 4] = true;
                }
            }
        }

        //创建锁定列、非锁定列的列行数组
        var maxLevel = this._getMaxColumnLevel();
        this._columnsRow1 = [];
        this._columnsRow2 = [];
        this._columnsRow3 = [];
        for (var i = 0, l = this._visibleColumnsRow.length; i < l; i++) {
            var columns = this._visibleColumnsRow[i];
            var columns1 = [];
            var columns2 = [];
            var columns3 = [];
            this._columnsRow1.push(columns1);
            this._columnsRow2.push(columns2);
            this._columnsRow3.push(columns3);

            for (var j = 0, k = columns.length; j < k; j++) {
                var c = columns[j];
                if (c.viewIndex1) columns1.push(c);
                if (c.viewIndex0 || c.viewIndex2 || c.viewIndex4) columns2.push(c);
                if (c.viewIndex3) columns3.push(c);
            }
        }
    },
    _createColumnsRow: function () {
        //创建列行数组：可视的。
        var maxLevel = this._getMaxColumnLevel();

        var columnsRow = [];
        var visibleColumnsRow = [];
        for (var i = 0, l = maxLevel; i <= l; i++) {
            columnsRow.push([]);
            visibleColumnsRow.push([]);
        }

        var me = this;
        function getColSpan(col) {
            var subColumns = mini.treeToList(col.columns, "columns");
            var colSpan = 0;
            for (var i = 0, l = subColumns.length; i < l; i++) {
                var c = subColumns[i];
                if (me.isVisibleColumn(c) == false) continue;
                if (!c.columns || c.columns.length == 0) {
                    colSpan += 1;
                }
            }
            return colSpan;
        }

        var list = mini.treeToList(this.columns, "columns");

        for (var i = 0, l = list.length; i < l; i++) {
            var column = list[i];
            var cols = columnsRow[column._level];
            var vcols = visibleColumnsRow[column._level];

            delete column.rowspan;
            delete column.colspan;

            if (column.columns && column.columns.length > 0) {
                column.colspan = getColSpan(column);
            }
            if ((!column.columns || column.columns.length == 0) && column._level < maxLevel) {
                column.rowspan = maxLevel - column._level + 1;
            }
            //if (column.header == '工作信息') debugger
            cols.push(column);
            if (this.isVisibleColumn(column)) {
                vcols.push(column);
            }
        }
        //debugger
        this._columnsRow = columnsRow;
        this._visibleColumnsRow = visibleColumnsRow;
    },
    _getMaxColumnLevel: function () {
        return this._maxColumnLevel;
    },
    cascadeColumns: function (node, fn, scope) {
        if (!fn) return;
        var nodes = node.columns;
        if (nodes) {
            nodes = nodes.clone();
            for (var i = 0, l = nodes.length; i < l; i++) {
                var c = nodes[i];
                if (fn.call(scope || this, c, i, node) === false) return;
                this.cascadeColumns(c, fn, scope);
            }
        }
    },
    eachColumns: function (column, fn, scope) {
        var columns = column.columns;
        if (columns) {
            var list = columns.clone();
            for (var i = 0, l = list.length; i < l; i++) {
                var o = list[i];
                if (fn.call(scope, o, i, column) === false) break;
            }
        }
    },
    getColumn: function (index) {
        var t = typeof index;
        if (t == "number") return this._bottomColumns[index];
        else if (t == "object") return index;
        else {
            return this._nameColumns[index];
        }
    },
    getColumnByField: function (field) {
        if (!field) return null;
        return this._fieldColumns[field];
    },
    _getColumnById: function (id) {
        return this._idColumns[id];
    },
    _getDataTypeByField: function (field) {
        var sortType = "string";
        var columns = this.getBottomColumns();
        for (var i = 0, l = columns.length; i < l; i++) {
            var column = columns[i];
            if (column.field == field) {
                if (column.sortType) {
                    sortType = column.sortType.toLowerCase();
                } else if (column.dataType) sortType = column.dataType.toLowerCase();
                break;
            }
        }

        //        var first = 
        //        if(!sortType 

        return sortType;
    },
    getParentColumn: function (column) {
        column = this.getColumn(column);
        var pid = column._pid;
        if (pid == -1) return this;
        return this._idColumns[pid];
    },
    getAncestorColumns: function (node) {
        var as = [node];
        while (1) {
            var parentNode = this.getParentColumn(node);
            if (!parentNode || parentNode == this) break;
            as[as.length] = parentNode;
            node = parentNode;
        }
        as.reverse();
        return as;
    },
    isAncestorColumn: function (parentNode, node) {
        if (parentNode == node) return true;
        if (!parentNode || !node) return false;
        var as = this.getAncestorColumns(node);
        for (var i = 0, l = as.length; i < l; i++) {
            if (as[i] == parentNode) return true;
        }
        return false;
    },
    isVisibleColumn: function (column) {
        column = this.getColumn(column);
        if (column.visible == false) return false;

        var columns = this.getAncestorColumns(column);
        for (var i = 0, l = columns.length; i < l; i++) {
            if (columns[i].visible == false) return false;
        }

        var nodes = column.columns;
        if (nodes) {
            var allHide = true;
            for (var i = 0, l = nodes.length; i < l; i++) {
                var node = nodes[i];
                if (this.isVisibleColumn(node)) {
                    allHide = false;
                    break;
                }
            }
            if (allHide) return false;
        }

        return true;
    },
    isBottomColumn: function (column) {
        column = this.getColumn(column);
        return !(column.columns && column.columns.length > 0);
    },
    ////////////////////////////////
    updateColumn: function (column, options) {
        column = this.getColumn(column);
        if (!column) return;
        mini.copyTo(column, options);
        this._columnsChanged();
    },
    moveColumn: function (column, targetColumn, action) {
        column = this.getColumn(column);
        targetColumn = this.getColumn(targetColumn);
        if (!column || !targetColumn || !action || column == targetColumn) return;

        if (this.isAncestorColumn(column, targetColumn)
            ) {
            return;
        }

        //先删除column
        var pcolumn = this.getParentColumn(column);
        if (pcolumn) {
            pcolumn.columns.remove(column);
        }

        //后加入到新位置
        var parentColumn = targetColumn;
        var index = action;
        if (index == 'before') {
            parentColumn = this.getParentColumn(targetColumn);
            index = parentColumn.columns.indexOf(targetColumn);
        } else if (index == 'after') {
            parentColumn = this.getParentColumn(targetColumn);
            index = parentColumn.columns.indexOf(targetColumn) + 1;
        } else if (index == 'add' || index == "append") {
            if (!parentColumn.columns) parentColumn.columns = [];
            index = parentColumn.columns.length;
        } else if (!mini.isNumber(index)) {
            return;
        }

        parentColumn.columns.insert(index, column);

        this._columnsChanged();
    },
    addColumn: function (column) {
        if (!column) return;
        delete column._id;
        this._columnsChanged();
    },
    removeColumn: function () {
        this._columnsChanged();
    }
});
/*
============================================================
描述：        
1.实现ColumnModal、DataSource
2.实现Pager：客户端分页、服务端分页
3.实现FilterRow、SummaryRow、BottomPager
4.实现TableView渲染视图模式
5.实现FitColumns、FixedColumns两种列宽显示模式
============================================================
GridView（基础表格视图）
->  FrezonGridView（锁定列视图）
->  ScrollGridView（动态表格视图）
->  DataGrid（数据表格）
->  TreeGrid（树形表格）
->  Tree（树控件）
============================================================
1.getData()             原始数据。数据结构：数组、树形。
2.getList()             原始数据。数据结构：数组。（树形转为数组）
3.getDataView()         数据视图。客户端排序、过滤后。数据结构：数组。
4.getVisibleRows()      可视数据视图。在DataView基础上，增加了树折叠处理。（是否加分组处理呢？）
5.getGroupingView()     分组数据视图。[group, group, ...]
*/
mini.GridView = function () {
    this._createTime = new Date(); //控件的创建时间

    //columnModel
    this._createColumnModel();
    this._bindColumnModel();

    //dataSource
    this.data = [];
    this._createSource();
    this._bindSource();

    this._initData();

    mini.GridView.superclass.constructor.apply(this, arguments);

    this._doUpdateFilterRow();
    this._doUpdateSummaryRow();

    this.doUpdate();

    if (mini.isNull(this._paddingTop)) {
        if (mini.isNull(mini.GridView._paddingTop)) {
            var d = jQuery(
                '<div class="mini-grid-cell-inner" style="position:absolute;left:-1000px;top:-1000px;"></div>'
            ).appendTo('body');
            var p = mini.getPaddings(d);
            mini.GridView._paddingTop = p.top;
            mini.GridView._paddingBottom = p.bottom;
        }
        this._paddingTop = mini.GridView._paddingTop;
        this._paddingBottom = mini.GridView._paddingBottom;
    }

    this._rowClsHash = {};
};
mini.extend(mini.GridView, mini.Panel, {
    _displayStyle: 'block',

    _rowIdField: '_id',

    width: '100%',

    showSortIcon: false,

    showColumns: true,
    showFilterRow: false,
    showSummaryRow: false,
    summaryRows: 1,
    showPager: false,

    allowCellWrap: false,
    allowHeaderWrap: false,

    showModified: true,
    showNewRow: true,

    showEmptyText: false,
    emptyText: 'No data returned.',

    showHGridLines: true,
    showVGridLines: true,

    _rowCls: 'mini-grid-row',
    _cellCls: 'mini-grid-cell',
    _headerCellCls: 'mini-grid-headerCell',

    _rowSelectedCls: 'mini-grid-row-selected',
    _rowHoverCls: 'mini-grid-row-hover',

    _cellSelectedCls: 'mini-grid-cell-selected',

    defaultRowHeight: 51,
    fixedRowHeight: false,
    isFixedRowHeight: function () {
        return this.fixedRowHeight;
    },

    fitColumns: true,
    isFitColumns: function () {
        return this.fitColumns;
    },

    allowAlternating: false,
    _alternatingCls: 'mini-grid-row-alt',
    getAllowAlternating: function () {
        return this.allowAlternating;
    },
    setAllowAlternating: function (value) {
        this.allowAlternating = value;
        this.doUpdate();
    },

    showGroupSummary: false,
    getShowGroupSummary: function () {
        return this.showGroupSummary;
    },
    setShowGroupSummary: function (value) {
        this.showGroupSummary = value;
    },

    summaryPosition: 'bottom', //top, flow?
    getSummaryPosition: function () {
        return this.summaryPosition;
    },
    setSummaryPosition: function (value) {
        this.summaryPosition = value;

        //alert(this.summaryPosition);
        if (this.summaryPosition == 'top') {
            mini.before(this._rowsEl, this._summaryEl);
            mini.before(this._summaryViewEl, this._summaryLockEl);
        }

        jQuery(this.el).toggleClass('mini-grid-summary-top', value == 'top');
    },

    uiCls: 'mini-gridview',
    _create: function () {
        mini.GridView.superclass._create.call(this);
        var el = this.el;
        mini.addClass(el, 'mini-grid');
        mini.addClass(this._borderEl, 'mini-grid-border');
        mini.addClass(this._viewportEl, 'mini-grid-viewport');

        var bottomPager = '<div class="mini-grid-pager"></div>';
        var filter =
            '<div class="mini-grid-filterRow"><div class="mini-grid-filterRow-view"></div><div class="mini-grid-scrollHeaderCell"></div></div>';
        var summary =
            '<div class="mini-grid-summaryRow"><div class="mini-grid-summaryRow-view"></div><div class="mini-grid-scrollHeaderCell"></div></div>';
        var columns =
            '<div class="mini-grid-columns"><div class="mini-grid-columns-view"></div><div class="mini-grid-scrollHeaderCell"></div></div>';

        this._columnsEl = mini.after(this._toolbarEl, columns);
        this._filterEl = mini.after(this._columnsEl, filter);
        this._rowsEl = this._bodyEl;
        mini.addClass(this._rowsEl, 'mini-grid-rows');

        this._summaryEl = mini.after(this._rowsEl, summary);

        this._bottomPagerEl = mini.after(this._summaryEl, bottomPager);

        this._columnsViewEl = this._columnsEl.childNodes[0];
        //this._topRightCellEl = this._columnsEl.childNodes[1];

        //内嵌一个div(zoom:1)，消除ie7下横向滚动条BUG
        this._rowsViewEl = mini.append(
            this._rowsEl,
            '<div class="mini-grid-rows-view"><div class="mini-grid-rows-content"></div></div>'
        );
        this._rowsViewContentEl = this._rowsViewEl.firstChild;

        //filter
        this._filterViewEl = this._filterEl.childNodes[0];
        //summary
        this._summaryViewEl = this._summaryEl.childNodes[0];

        var s =
            '<a href="#" class="mini-grid-focus" style="position:absolute;left:0px;top:0px;width:0px;height:0px;outline:none;" hideFocus onclick="return false" ></a>';
        this._focusEl = mini.append(this._borderEl, s);

        //        if (mini.isChrome) {
        //            $(this._focusEl).remove();

        //            var s = '<div tabindex=0 class="mini-grid-focus" style="position:absolute;left:0px;top:0px;width:0px;height:0px;outline:none;" hideFocus onclick="return false" ></div>';
        //            this._focusEl = mini.append(this._borderEl, s);

        //
        //        }

        //this._focusEl.onfocus = function
        //        mini.on(this._focusEl, "focus", function (e) {
        //            e.preventDefault();
        //        });
        var me = this;
        mini.on(this._filterViewEl, 'scroll', function (e) {
            if (me._filterViewEl.scrollLeft > 0) {
                me._filterViewEl.scrollLeft = 0;
            }
        });
    },
    destroy: function (removeEl) {
        this._unbindScrollEvent();
        if (this._dataSource) {
            this._dataSource.destroy();
            this._dataSource = null;
        }
        if (this._columnModel) {
            this._columnModel.destroy();
            this._columnModel = null;
        }
        if (this._pagers) {
            var ps = this._pagers.clone();
            for (var i = 0, l = ps.length; i < l; i++) {
                ps[i].destroy(removeEl);
            }

            this._pagers = null;
        }
        if (this._viewportEl) {
            mini.clearEvent(this._viewportEl);
        }

        if (this._rowsViewEl) {
            mini.clearEvent(this._rowsViewEl);
        }
        if (this._rowsEl) {
            //FrozenGridView
            mini.clearEvent(this._rowsEl);
        }
        if (this._vscrollEl) {
            //ScrollGridView
            mini.clearEvent(this._vscrollEl);
        }

        if (this._headerEl) {
            //_Sorter
            mini.clearEvent(this._headerEl);
        }
        if (this._columnsEl) {
            jQuery(this._columnsEl).unbind('mouseenter'); //_Grid_Select
            jQuery(this._columnsEl).unbind('mouseleave');
        }

        this._columnsEl = this._rowsEl = this._filterEl = this._summaryEl = this._bottomPagerEl = null;
        this._columnsViewEl = this._topRightCellEl = this._rowsViewEl = this._rowsViewContentEl = null;
        this._filterViewEl = this._summaryViewEl = this._focusEl = null;
        this._viewportEl = this._vscrollEl = this._bottomPager = null;

        mini.GridView.superclass.destroy.call(this, removeEl);
    },
    _initEvents: function () {
        mini.GridView.superclass._initEvents.call(this);

        this._bindScrollEvent();

        //this._unbindScrollEvent();
    },

    //    count1: 0,
    //    count2: 0,

    _bindScrollEvent: function () {
        var me = this;

        if (this.isFrozenRight()) {
            me._rowsViewEl.style.overflowX = 'auto';
            me._rowsViewEl.style.overflowY = 'hidden';
            me._rowsLockContentEl.style.padding = '0px';
            me._rowsRightLockContentEl.style.padding = '0px';
            if (this._showVs) {
                me._rowsRightLockEl.style.overflow = 'hidden';
                me._rowsViewEl.style.paddingRight = mini.getScrollOffset() + 'px';
            } else {
                me._rowsRightLockEl.style.overflowX = 'hidden';
                me._rowsRightLockEl.style.overflowY = 'auto';
            }
        } else {
            if (this._showVs) {
                me._rowsViewEl.style.overflowX = 'auto';
                me._rowsViewEl.style.overflowY = 'hidden';
            } else {
                me._rowsViewEl.style.overflow = 'auto';
            }
        }
        this._unbindScrollEvent();
        this._scrollBindTimer = setTimeout(function () {
            //$("#div1").html(me.count1++);
            if (me.isFrozenRight()) {
                mini.on(me._rowsRightLockEl, 'scroll', me.__OnRowViewScroll, me);
            }
            mini.on(me._rowsViewEl, 'scroll', me.__OnRowViewScroll, me);
        }, 100);
    },

    _unbindScrollEvent: function () {
        if (this._scrollBindTimer) {
            clearTimeout(this._scrollBindTimer);
            this._scrollBindTimer = null;
        }
        //$("#div2").html(me.count2++);
        if (this.isFrozenRight()) {
            mini.un(this._rowsRightLockEl, 'scroll', this.__OnRowViewScroll, this);
        } else {
            mini.un(this._rowsViewEl, 'scroll', this.__OnRowViewScroll, this);
        }
    },

    _syncScrollOffset: function (left, top) {
        this._unbindScrollEvent();
        if (left != null) {
            this._rowsViewEl.scrollLeft = left;
        }
        if (top != null) {
            //debugger
            this._rowsViewEl.scrollTop = top;
            if (this._vscrollEl) {
            }
        }
        this._bindScrollEvent();
    },

    //    _sizeChanged: function () {
    //        this.deferLayout();
    //    },
    _sizeChanged: function () {
        mini.GridView.superclass._sizeChanged.call(this);
        /*if (this.isAutoHeight()) {
        mini.addClass(this.el, 'mini-grid-autoheight');
        } else {
        mini.removeClass(this.el, 'mini-grid-autoheight');
        }*/

        var autoHeight = this.isAutoHeight();
        if (mini.isIE) {
            if (autoHeight) {
                mini.addClass(this._rowsViewEl, 'mini-grid-hidden-y');
            } else {
                mini.removeClass(this._rowsViewEl, 'mini-grid-hidden-y');
            }
        }
    },
    _setBodyWidth: false,

    doLayoutCardView: function () {
        var me = this,
            hasVScroll = this._rowsViewEl.scrollHeight > this._rowsViewEl.clientHeight + 1,
            hdTable = this._columnsViewEl.firstChild,
            paddingRight = hasVScroll ? mini.getScrollOffset() : 0;

        hdTable.parentNode.style['paddingRight'] = paddingRight + 'px';
        hdTable.style.width = '100%';
    },

    doLayout: function () {
        var that = this;
        if (!this.canLayout()) return;
        mini.GridView.superclass.doLayout.call(this);

        this._stopLayout();

        if (this.viewType == 'cardview') {
            this.doLayoutCardView();
            return;
        }

        var autoHeight = this._autoHeight; // this.isAutoHeight();

        if (mini.isIE) {
            if (autoHeight) {
                mini.addClass(this._rowsViewEl, 'mini-grid-hidden-y');
            } else {
                mini.removeClass(this._rowsViewEl, 'mini-grid-hidden-y');
            }
        }

        var isFitColumns = this.isFitColumns();
        var isFrozenRight = this.isFrozenRight();

        var hdTable = this._columnsViewEl.firstChild;

        var bdTable = this._rowsViewContentEl.firstChild;

        var filterTable = this._filterViewEl.firstChild;
        var summaryTable = this._summaryViewEl.firstChild;

        // var columnHeight = jQuery(this._columnsViewEl).height();
        var filterRowHeight = filterTable.offsetHeight;

        var hasVScroll = this._rowsViewEl.scrollHeight > this._rowsViewEl.clientHeight + 1;
        // var hasHScroll = this._rowsViewEl.scrollWidth > this._rowsViewEl.clientWidth + 1;

        var bodyWidth = this._rowsViewContentEl.parentNode.offsetWidth;
        var tableWidth = bodyWidth - (hasVScroll ? mini.getScrollOffset() : 0);

        function doLayout(table) {
            //fitColumns
            if (isFitColumns) {
                if (mini.isSafari || mini.isIE6) {
                    table.style.width = tableWidth + 'px';
                } else {
                    if (hasVScroll) {
                        table.style.width = '100%';
                        table.parentNode.style.width = 'auto';

                        if (filterTable != table) {
                            if (isFrozenRight) {
                                table.parentNode.style['paddingRight'] = '0px';
                            } else {
                                table.parentNode.style['paddingRight'] = mini.getScrollOffset() + 'px';
                            }
                        }

                        if (mini.isIE8) mini.removeClass(this._rowsViewEl, 'mini-grid-hidden-y');
                    } else {
                        table.style.width = '100%';
                        table.parentNode.style.width = 'auto';
                        table.parentNode.style['paddingRight'] = '0px';

                        if (mini.isIE8) mini.addClass(this._rowsViewEl, 'mini-grid-hidden-y');
                    }
                }
            } else {
                table.style.width = '0px';
                if (mini.isSafari || mini.isChrome || mini.isIE6) {
                    //hdTable.style.width = bdTable.offsetWidth + "px";
                } else {
                    table.parentNode.style.width = '100%';
                    table.parentNode.style['paddingRight'] = '0px';
                }
            }
        }

        //if(hasVScroll) debugger
        doLayout.call(this, hdTable);
        doLayout.call(this, filterTable);
        doLayout.call(this, summaryTable);

        // layout rows view, row right lock;
        var bdTableWrap = bdTable.parentNode.parentNode; // 多一层 .mini-grid-rows-content
        if (isFitColumns) {
            bdTable.style.width = '100%';
            bdTableWrap.style.width = 'auto';
        }

        this._syncScroll();

        var me = this;
        setTimeout(function () {
            mini.layout(me._filterEl);
            mini.layout(me._summaryEl);
        }, 10);

        if (mini.isIE10) {
            //fix ie10
            setTimeout(function () {
                if (me.isFitColumns()) {
                    hdTable.style.width = 'auto';
                    hdTable.offsetWidth;
                    hdTable.style.width = '100%';
                } else {
                    hdTable.style.width = '0px';
                }
            }, 0);
            mini.repaint(bdTable);
        }

        this._filterViewEl.style.height = filterRowHeight + 'px';

        filterTable.style.width = this.isFitColumns() ? tableWidth + 'px' : '';
    },
    setBody: function () {},
    /////////////////////////
    //------------  Update/Layout -----------//

    //    _hasSpaceTd: function () {
    //        return true;
    //    },

    _createTopRowHTML: function (columns, flag, data) {
        var s = '';
        if (mini.isIE) {
            if (mini.isIE6 || mini.isIE7 || !mini.boxModel) {
                //if (mini.isIE6 || mini.isIE7) {
                s += '<tr class="datagrid-columns-width-tr" style="display:none;height:0px;">';
            } else {
                s += '<tr class="datagrid-columns-width-tr" style="height:0px;">';
            }
            //s += '<tr style="height:0px;">';
        } else {
            if (mini.isChrome && data && data.length == 0) {
                s += '<tr class="datagrid-columns-width-tr" style="height:1px;">';
            } else {
                s += '<tr class="datagrid-columns-width-tr" style="height:0px;">';
            }
        }

        if (this._userEmptyTd !== false) s += '<td style="height:0px;width:0;"></td>';

        for (var i = 0, l = columns.length; i < l; i++) {
            var column = columns[i];
            var width = column.width;
            var id = column._id;
            // 个性化修改 start
            // @old s += '<td id="' + id + '" style="padding:0;border:0;margin:0;height:0px;';
            s += '<td id="' + id + '" ';
            if (column.width === '100%') {
                s +=
                    'class="datagrid-autowidth-column" data-min-width="' +
                    (column.minWidth ? column.minWidth : '100') +
                    '"';
            }
            s += 'style="padding:0;border:0;margin:0;height:0px;';
            // 个性化修改 end

            // 个性化修改 start
            // @old s += 'width:' + column.width;
            if (column.width) {
                var width = column.width;
                if (/px$/.test(column.width)) {
                    var numberWidth = parseInt(column.width, 10) / 100;
                    if (numberWidth) {
                        width += ';width:' + numberWidth + 'rem';
                    }
                }
                s += 'width:' + width;
            }
            // 个性化修改 end

            if (column.minWidth) s += ';min-width:' + column.minWidth + 'px';

            s += '" ></td>';
        }
        s += '<td style="width:0px;"></td>';
        s += '</tr>';
        return s;
    },

    _createColumnsHTML: function (rows, viewIndex, visibleColumns) {
        var visibleColumns = visibleColumns ? visibleColumns : this.getVisibleColumns();
        var sb = ['<table class="mini-grid-table" cellspacing="0" cellpadding="0" border="0">'];
        sb.push(this._createTopRowHTML(visibleColumns));

        var sortField = this.getSortField();
        var sortOrder = this.getSortOrder();

        for (var j = 0, k = rows.length; j < k; j++) {
            var columns = rows[j];
            sb[sb.length] = '<tr>';
            sb[sb.length] = '<td style="width:0;"></td>';
            for (var i = 0, l = columns.length; i < l; i++) {
                var column = columns[i];
                var _sortField = column.sortField || column.field;

                var headerText = this._createHeaderText(column, viewIndex);

                var columnId = this._createHeaderCellId(column, viewIndex);

                //if(column.name == "name1") debugger

                var sortCls = '';
                if (sortField && sortField == _sortField) {
                    sortCls = sortOrder == 'asc' ? 'mini-grid-asc' : 'mini-grid-desc';
                }
                var cls = '';
                if (this.allowHeaderWrap == false) {
                    cls = ' mini-grid-headerCell-nowrap ';
                }

                sb[sb.length] = '<td id="';
                sb[sb.length] = columnId;
                sb[sb.length] = '" class="mini-grid-headerCell ' + sortCls + ' ' + (column.headerCls || '') + ' ';

                var isButtom = !(column.columns && column.columns.length > 0);
                if (isButtom) sb[sb.length] = ' mini-grid-bottomCell ';
                if (i == l - 1) sb[sb.length] = ' mini-grid-rightCell ';

                sb[sb.length] = '" style="';
                if (column.headerStyle) {
                    sb[sb.length] = column.headerStyle + ';';
                }
                if (column.headerAlign) {
                    sb[sb.length] = 'text-align:' + column.headerAlign + ';';
                }

                sb[sb.length] = '" ';

                if (column.rowspan) {
                    sb[sb.length] = 'rowspan="' + column.rowspan + '" ';
                }
                this._createColumnColSpan(column, sb, viewIndex);

                sb[sb.length] =
                    '><div class="mini-grid-headerCell-outer"><div class="mini-grid-headerCell-inner ' + cls + '">';

                headerText = /mini-grid-headertxt/.test(headerText)
                    ? headerText
                    : '<span class="mini-grid-headertxt is-existed-sorticon">' + headerText + '</span>';

                if ((sortCls || (this.showSortIcon && column.allowSort)) && !/is-existed-sorticon/.test(headerText)) {
                    headerText = headerText.replace('mini-grid-headertxt', 'mini-grid-headertxt is-existed-sorticon');
                }
                sb[sb.length] = headerText;

                if (sortCls) {
                    sb[sb.length] = '<span class="mini-grid-sortIcon mini-icon"></span>';
                } else {
                    if (this.showSortIcon) {
                        if (column.allowSort) {
                            sb[sb.length] = '<span class="mini-grid-allowsort mini-icon"></span>';
                        }
                    }
                }

                sb[sb.length] = '</div><div id="' + column._id + '" class="mini-grid-column-splitter"></div>';

                sb[sb.length] = '</div></td>';
            }

            //space column
            if ((this.isFrozen() && viewIndex == 1) || (this.isFrozenRight && viewIndex == 3)) {
                sb[sb.length] =
                    '<td class="mini-grid-headerCell" style="width:0;"><div class="mini-grid-headerCell-inner" style="';

                //sb[sb.length] = '">&nbsp;</div></td>';
                sb[sb.length] = '">0</div></td>';
            }

            sb[sb.length] = '</tr>';
        }
        sb.push('</table>');
        return sb.join('');
    },
    _createHeaderText: function (column, viewIndex) {
        var header = column.header;
        if (typeof header == 'function') header = header.call(this, column);
        if (mini.isNull(header) || header === '') header = '&nbsp;';
        return header;
    },
    _createColumnColSpan: function (column, sb, viewIndex) {
        if (column.colspan) {
            sb[sb.length] = 'colspan="' + column.colspan + '" ';
        }
    },
    doUpdateColumns: function () {
        var scrollLeft = this._columnsViewEl.scrollLeft;

        var columnRows = this.getVisibleColumnsRow();
        var html = this._createColumnsHTML(columnRows, 2);
        var s = '<div class="mini-grid-topRightCell"></div>';
        html += s;
        this._columnsViewEl.innerHTML = html;

        mini[['addClass', 'removeClass'][this._columnModel._maxColumnLevel > 0 ? 0 : 1]](
            this._viewportEl,
            'mini-grid-composite-columns'
        );

        this._columnsViewEl.scrollLeft = scrollLeft;
    },
    doUpdate: function () {
        if (this.canUpdate() == false) return;
        var that = this;

        this._bindScrollEvent();

        //创建组件100毫秒内，rows延迟创建，提升初始化时性能表现（避免了多次setColumns/setData时的重新创建整个表格开销）
        var defer = this._isCreating();

        var sss = new Date();

        this._doUpdateSummaryRow();

        var me = this;

        var scrollLeft = this.getScrollLeft();

        //alert(1);

        function doUpdate() {
            if (!me.el) return;
            me.doUpdateColumns();

            //rows

            if (that.viewType == 'cardview') {
                me.updateCardView();
            } else {
                me.doUpdateRows();
            }

            me.doLayout();
            me._doUpdateTimer = null;
            //alert(new Date() - sss);
        }

        //columns
        me.doUpdateColumns();

        //        if (this._doUpdateTimer) {
        //            this.doLayout();
        //            return;
        //        }

        //EmptyView
        if (defer) {
            this._useEmptyView = true;
        }

        //移除行
        //        if (this._rowsViewContentEl && this._rowsViewContentEl.firstChild) {
        //            this._rowsViewContentEl.removeChild(this._rowsViewContentEl.firstChild);
        //        }
        //        if (this._rowsLockContentEl && this._rowsLockContentEl.firstChild) {
        //            this._rowsLockContentEl.removeChild(this._rowsLockContentEl.firstChild);
        //        }
        this._doRemoveRowContent();

        //var sss = new Date();

        if (that.viewType == 'cardview') {
            me.updateCardView();
        } else {
            me.doUpdateRows();
        }

        //alert(new Date() - sss);

        if (scrollLeft > 0 && me.isVirtualScroll()) {
            //me.setScrollLeft(scrollLeft);
            me._syncScrollOffset(scrollLeft);
        }

        if (defer) {
            this._useEmptyView = false;
        }
        me.doLayout();
        if (defer && !this._doUpdateTimer) {
            this._doUpdateTimer = setTimeout(doUpdate, 15);
        }
        this.unmask();

        if (that._fireUpdateTimer) {
            clearTimeout(that._fireUpdateTimer);
            that._fireUpdateTimer = null;
        }
        that._fireUpdateTimer = setTimeout(function () {
            that._fireUpdateTimer = null;
            that.fire('update');
        }, 100);
    },

    _doRemoveRowContent: function () {
        if (this._rowsViewContentEl && this._rowsViewContentEl.firstChild) {
            this._rowsViewContentEl.removeChild(this._rowsViewContentEl.firstChild);
        }
        if (this._rowsLockContentEl && this._rowsLockContentEl.firstChild) {
            this._rowsLockContentEl.removeChild(this._rowsLockContentEl.firstChild);
        }
    },

    /////////////////////////////////////////
    _isCreating: function () {
        return new Date() - this._createTime < 1000;
    },
    deferUpdate: function (time) {
        if (!time) time = 5;
        if (this._updateTimer || this._doUpdateTimer) return;
        var me = this;
        this._updateTimer = setTimeout(function () {
            me._updateTimer = null;
            me.doUpdate();
        }, time);
    },
    _stopDeferUpdate: function () {
        if (this._updateTimer) {
            clearTimeout(this._updateTimer);
            this._updateTimer = null;
        }
    },
    _pushUpdateCallback: function (fn, scope, args) {
        var time = 0;

        if (this._doUpdateTimer || this._updateTimer) time = 20;
        //alert(time);
        if (time == 0) {
            fn.apply(scope, args);
        } else {
            setTimeout(function () {
                fn.apply(scope, args);
            }, time);
        }
    },
    _updateCount: 0,
    beginUpdate: function () {
        this._updateCount++;
    },
    endUpdate: function (raise) {
        this._updateCount--;
        if (this._updateCount == 0 || raise === true) {
            this._updateCount = 0;
            this.doUpdate();
        }
    },
    canUpdate: function () {
        //return this._updateCount == 0 && this.isRender();
        return this._updateCount == 0;
    },
    /////////////////////////////////////////
    setDefaultRowHeight: function (value) {
        this.defaultRowHeight = value;
    },
    getDefaultRowHeight: function () {
        return this.defaultRowHeight;
    },
    _getRowHeight: function (record) {
        //if(

        var h = this.defaultRowHeight;
        if (record._height) {
            h = parseInt(record._height);
            if (isNaN(parseInt(record._height))) h = rowHeight;
        }
        //h -= 4; //padding-top/padding-bottom

        h = h - this._paddingTop - this._paddingBottom;

        //if (!mini.isOpera) {
        h -= 1;
        //}
        return h;
    },
    _createGroupingHTML: function (columns, viewIndex) {
        var groups = this.getGroupingView();
        var showGroupSummary = this.showGroupSummary;

        var isFrozen = this.isFrozen();

        var rowIndex = 0;
        var me = this;

        function createRows(rows, group) {
            sb.push('<table class="mini-grid-table" cellspacing="0" cellpadding="0" border="0">');
            if (columns.length > 0) {
                sb.push(me._createTopRowHTML(columns));
                for (var j = 0, k = rows.length; j < k; j++) {
                    var row = rows[j];
                    me._createRowHTML(row, rowIndex++, columns, viewIndex, sb);
                }
            }

            sb.push('</table>');
        }

        var groupTitleCollapsible = this.groupTitleCollapsible !== false;

        var sb = ['<table class="mini-grid-table" cellspacing="0" cellpadding="0" border="0">'];
        sb.push(this._createTopRowHTML(columns));

        // 增加GroupView视图缺省图
        var emptyId = me.uid + '$emptytext' + viewIndex;
        if (viewIndex == 2 && (me._dataSource.loaded || me.alwaysShowEmptyText)) {
            var h = parseInt($(me.el).find('.mini-grid-rows-view').height(), 10);
            if (h && h > 200) {
                h = (h * 0.3) >> 0;
            }
            var style = this.showEmptyText && groups.length == 0 ? '' : 'display:none;';
            sb.push(
                '<tr id="' +
                    emptyId +
                    '" style="' +
                    style +
                    '"><td style="width:0"></td><td class="mini-grid-emptyText" style="padding-top:' +
                    (h + 80) +
                    'px;background-position:center ' +
                    h +
                    'px" colspan="' +
                    columns.length +
                    '">' +
                    me.emptyText +
                    '</td></tr>'
            );
        }

        for (var j = 0, k = groups.length; j < k; j++) {
            if (viewIndex == 1 && !this.isFrozen()) continue;

            var group = groups[j];
            var id = this._createRowGroupId(group, viewIndex);
            var rowid = this._createRowGroupRowsId(group, viewIndex);
            var e = this._OnDrawGroup(group);
            var cls = group.expanded ? '' : ' mini-grid-group-collapse ';

            //group header
            sb[sb.length] = '<tr id="';
            sb[sb.length] = id;
            sb[sb.length] = '" class="mini-grid-groupRow';
            sb[sb.length] = cls;
            //sb[sb.length] = '"><td class="mini-grid-groupCell ';
            sb[sb.length] = '"><td style="width:0;"></td><td class="mini-grid-groupCell ';

            sb[sb.length] = e.cls;
            sb[sb.length] = '" style="';
            sb[sb.length] = e.style;
            sb[sb.length] = '" colspan="';
            sb[sb.length] = columns.length;
            //sb[sb.length] = '"><div class="mini-grid-groupHeader">';
            sb[sb.length] = '"><div class="mini-grid-groupHeader ';
            if (groupTitleCollapsible) {
                sb[sb.length] = 'mini-grid-groupHeader-collapsible';
            }
            sb[sb.length] = '">';

            if (!isFrozen || (isFrozen && viewIndex == 1)) {
                sb[sb.length] = '<div class="mini-grid-group-ecicon"></div>';
                sb[sb.length] = '<div class="mini-grid-groupTitle">' + e.cellHtml + '</div>';
            } else {
                sb[sb.length] = '&nbsp;';
            }
            sb[sb.length] = '</div></td></tr>';

            //group.expanded = false;

            var style = group.expanded ? '' : 'display:none';
            sb[sb.length] = '<tr class="mini-grid-groupRows-tr" style="';

            //if (mini.isIE) sb[sb.length] = style;
            //sb[sb.length] = '"><td class="mini-grid-groupRows-td" colspan="';
            sb[sb.length] = '"><td style="width:0;"></td><td class="mini-grid-groupRows-td" colspan="';

            sb[sb.length] = columns.length;
            sb[sb.length] = '"><div id="';
            sb[sb.length] = rowid;
            sb[sb.length] = '" class="mini-grid-groupRows" style="';
            if (mini.isChrome) sb[sb.length] = 'margin-left:-1px;';
            sb[sb.length] = style;
            sb[sb.length] = '">';
            createRows(group.rows, group);
            sb[sb.length] = '</div></td></tr>';

            //分组汇总
            if (showGroupSummary) {
                //sb.push('<table class="mini-grid-table" cellspacing="0" cellpadding="0" border="0">');
                if (columns.length > 0) {
                    //                    sb.push(me._createTopRowHTML(columns));
                    //                    for (var j = 0, k = rows.length; j < k; j++) {
                    //                        var row = rows[j];
                    //                        me._createRowHTML(row, rowIndex++, columns, viewIndex, sb);
                    //                    }

                    sb[sb.length] = '<tr class="mini-grid-groupFooter">';
                    sb[sb.length] = '<td style="width:0;"></td>';
                    for (var i = 0, l = columns.length; i < l; i++) {
                        var column = columns[i];
                        var id = ''; //this._createSummaryCellId(column);

                        //if(column.field == 'age') debugger

                        var e = this._OnDrawSummaryCell(group.rows, column, group);

                        sb[sb.length] = '<td id="';
                        sb[sb.length] = id;
                        sb[sb.length] = '" class="mini-grid-cell ' + e.cellCls + '" style="' + e.cellStyle + ';';
                        sb[sb.length] = '"><div class="mini-grid-cell-inner">';
                        sb[sb.length] = e.cellHtml;
                        sb[sb.length] = '</div></td>';
                    }
                    sb[sb.length] = '</tr>';
                }

                //sb.push('</table>');
            }
        }
        sb.push('</table>');
        return sb.join('');
    },

    _isFastCreating: function () {
        //return false;
        var data = this.getVisibleRows();
        if (data.length > 50) {
            return this._isCreating() || this.getScrollTop() < 50 * this._defaultRowHeight;
        }
        return false;
    },
    isShowRowDetail: function (row) {
        return false;
    },
    isCellValid: function (record, column) {
        return true;
    },

    /////////////////////////////////////////////////////////

    //创建cardview视图
    updateCardView: function () {
        var me = this,
            data = this.getVisibleRows(),
            columns = this.getVisibleColumns(),
            sb = [];

        for (var i = 0, l = data.length; i < l; i++) {
            var record = data[i];
            var meta = { rowCls: '', rowStyle: '' };
            var html = me.itemRenderer(record, i, meta, me);
            sb[sb.length] = '<div class="mini-grid-row ';
            sb[sb.length] = meta.rowCls;
            sb[sb.length] = '" style="';
            sb[sb.length] = meta.rowStyle;
            sb[sb.length] = '" id="';
            sb[sb.length] = me._createRowId(record, 1);
            sb[sb.length] = '">';
            sb[sb.length] = html;
            sb[sb.length] = '</div>';
        }

        me._rowsViewContentEl.innerHTML = sb.join('');
    },

    itemRenderer: function (record, rowIndex, meta, grid) {
        return '';
    },

    /////////////////////////////////////////////////////////

    _createRowHTML: function (record, rowIndex, columns, viewIndex, sb) {
        var isReturn = !sb;
        if (!sb) sb = [];
        var rowHeight = '';
        var isFixedRowHeight = this.isFixedRowHeight();
        if (isFixedRowHeight) {
            rowHeight = this._getRowHeight(record);
        }
        var defaultRowHeight = this.defaultRowHeight - 1;

        var rowClsIndex = -1;
        var rowCls = ' ';
        var rowStyleIndex = -1;
        var rowStyle = ' ';

        sb[sb.length] = '<tr class="mini-grid-row ';

        if (record._state == 'added' && this.showNewRow) sb[sb.length] = 'mini-grid-newRow ';
        if (this.isShowRowDetail(record)) sb[sb.length] = 'mini-grid-expandRow ';

        if (this.allowAlternating && rowIndex % 2 == 1) {
            sb[sb.length] = this._alternatingCls;
            sb[sb.length] = ' ';
        }

        //if (record._id == 1) debugger

        var _rowClsSb = this._rowClsHash[record._id];
        if (_rowClsSb) {
            sb[sb.length] = _rowClsSb.join(' ');
            sb[sb.length] = ' ';
        }

        //选择的样式不在_rowClsHash中处理
        //if (!_rowClsSb || _rowClsSb.indexOf(this._rowSelectedCls) == -1) {
        var isSelected = this._dataSource.isSelected(record);
        if (isSelected) {
            sb[sb.length] = this._rowSelectedCls;
            sb[sb.length] = ' ';
        }
        //}

        rowClsIndex = sb.length;
        sb[sb.length] = rowCls;
        sb[sb.length] = '" style="';
        rowStyleIndex = sb.length;
        sb[sb.length] = rowStyle;

        //@ 2017-11-06 是否不应该修改？
        //        if (record.visible === false) {
        //            sb[sb.length] = ";display:none;";
        //        }

        sb[sb.length] = '" id="';
        sb[sb.length] = this._createRowId(record, viewIndex);
        sb[sb.length] = '">';

        if (this._userEmptyTd !== false) sb[sb.length] = '<td style="width:0;"></td>';

        var _currentCell = this._currentCell;

        for (var i = 0, l = columns.length; i < l; i++) {
            var column = columns[i];
            var cellId = this._createCellId(record, column);

            var cls = '';

            //var e = this._OnDrawCell(record, column, rowIndex, column._index, i, columns.length, isFrozen, viewIndex);
            var e = this._OnDrawCell(record, column, rowIndex, column._index);
            if (e.cellHtml === null || e.cellHtml === undefined || e.cellHtml === '') {
                e.cellHtml = '&nbsp;';
            }

            sb[sb.length] = '<td ';
            if (e.rowSpan) {
                sb[sb.length] = 'rowspan="' + e.rowSpan + '"';
            }
            if (e.colSpan) {
                sb[sb.length] = 'colspan="' + e.colSpan + '"';
            }
            sb[sb.length] = ' id="';
            sb[sb.length] = cellId;

            sb[sb.length] = '" class="mini-grid-cell ';

            if (!this.isCellValid(record, column)) sb[sb.length] = ' mini-grid-cell-error ';

            if (i == l - 1) sb[sb.length] = ' mini-grid-rightCell ';

            if (e.cellCls) sb[sb.length] = ' ' + e.cellCls + ' ';
            if (cls) sb[sb.length] = cls;

            if (_currentCell && _currentCell[0] == record && _currentCell[1] == column) {
                sb[sb.length] = ' ';
                sb[sb.length] = this._cellSelectedCls;
            }

            sb[sb.length] = '" style="';
            if (e.showHGridLines == false) {
                sb[sb.length] = 'border-bottom:0;';
            }
            if (e.showVGridLines == false) {
                sb[sb.length] = 'border-right:0;';
            }

            if (!e.visible) sb[sb.length] = 'display:none;';

            if (column.align) {
                sb[sb.length] = 'text-align:';
                sb[sb.length] = column.align;
                sb[sb.length] = ';';
            }

            if (e.cellStyle) sb[sb.length] = e.cellStyle;

            sb[sb.length] = '">';
            sb[sb.length] = '<div class="mini-grid-cell-inner ';

            var cellWrap = column.allowCellWrap;
            if (!cellWrap) cellWrap = e.allowCellWrap;
            if (!cellWrap) {
                //if (!e.allowCellWrap || !column.allowCellWrap) {
                //if (!e.allowCellWrap) {
                //if (!column.allowCellWrap) {
                sb[sb.length] = ' mini-grid-cell-nowrap ';
            }

            if (e.cellInnerCls) {
                sb[sb.length] = e.cellInnerCls;
            }

            var isModified = column.field ? this._dataSource.isModified(record, column.field) : false;
            if (isModified && this.showModified) {
                sb[sb.length] = ' mini-grid-cell-dirty';
            }

            sb[sb.length] = '" style="';
            if (isFixedRowHeight) {
                sb[sb.length] = 'height:';
                //sb[sb.length] = rowHeight;

                if (!column.name || this._treeColumn !== column.name) {
                    sb[sb.length] = rowHeight;
                } else {
                    sb[sb.length] = defaultRowHeight;
                }

                sb[sb.length] = 'px;';
                sb[sb.length] = 'line-height:';
                //sb[sb.length] = rowHeight;

                if (!column.name || this._treeColumn !== column.name) {
                    sb[sb.length] = rowHeight;
                } else {
                    sb[sb.length] = defaultRowHeight;
                }

                sb[sb.length] = 'px;';
            }
            if (e.cellInnerStyle) {
                sb[sb.length] = e.cellInnerStyle;
            }
            sb[sb.length] = '">';
            sb[sb.length] = e.cellHtml;
            sb[sb.length] = '</div>';
            sb[sb.length] = '</td>';

            if (e.rowCls) rowCls = e.rowCls;
            if (e.rowStyle) rowStyle = e.rowStyle;
        }
        //space column
        if ((this.isFrozen() && viewIndex == 1) || (this.isFrozenRight() && viewIndex == 3)) {
            sb[sb.length] = '<td class="mini-grid-cell" style="width:0;';
            if (this.showHGridLines == false) {
                sb[sb.length] = 'border-bottom:0;';
            }
            sb[sb.length] = '"><div class="mini-grid-cell-inner" style="';
            if (isFixedRowHeight) {
                sb[sb.length] = 'height:';
                sb[sb.length] = rowHeight;
                sb[sb.length] = 'px;';
            }
            //sb[sb.length] = '">&nbsp;</div></td>';
            sb[sb.length] = '">0</div></td>';
        }

        sb[rowClsIndex] = rowCls;
        sb[rowStyleIndex] = rowStyle;

        sb[sb.length] = '</tr>';

        if (isReturn) {
            var s = sb.join('');
            //var reg = /<script[^>]*>.*(?=<\/script(\s)*>)<\/script(\s)*>/gi;
            //var reg = /(<script(.*)<\/script(\s*)>)/i;
            var reg = /(<script(.*)<\/script(\s*)>)/i;
            s = s.replace(reg, '');

            return s;
        }
    },
    _createRowsHTML: function (columns, viewIndex, data, bottomHtml) {
        data = data || this.getVisibleRows();

        var sb = ['<table class="mini-grid-table mini-grid-rowstable" cellspacing="0" cellpadding="0" border="0">'];
        sb.push(this._createTopRowHTML(columns, true, data));

        var emptyId = this.uid + '$emptytext' + viewIndex;
        if (viewIndex == 2 && (this._dataSource.loaded || this.alwaysShowEmptyText)) {
            var style = this.showEmptyText && data.length == 0 ? '' : 'display:none;';
            sb.push(
                '<tr id="' +
                    emptyId +
                    '" style="' +
                    style +
                    '"><td style="width:0"></td><td class="mini-grid-emptyText" colspan="' +
                    columns.length +
                    '">' +
                    this.emptyText +
                    '</td></tr>'
            );
        }

        var startIndex = 0;
        if (data.length > 0) {
            var first = data[0];
            startIndex = this.getVisibleRows().indexOf(first);
        }
        for (var j = 0, k = data.length; j < k; j++) {
            var rowIndex = startIndex + j;
            var record = data[j];
            this._createRowHTML(record, rowIndex, columns, viewIndex, sb);
        }

        if (bottomHtml) {
            sb.push(bottomHtml);
        }

        sb.push('</table>');

        return sb.join('');
    },

    doUpdateRows: function () {
        var data = this.getVisibleRows();

        var sss = new Date();

        var columns = this.getVisibleColumns();
        if (this.isGrouping()) {
            var html = this._createGroupingHTML(columns, 2);
            this._rowsViewContentEl.innerHTML = html;
        } else {
            var html = this._createRowsHTML(columns, 2, data);
            this._rowsViewContentEl.innerHTML = html;
        }
    },

    /////////////////////////////////////////////////////
    _createFilterRowHTML: function (columns, viewIndex) {
        var sb = [
            '<table class="mini-grid-table" cellspacing="0" cellpadding="0" border="0" style="position:absolute;top:0;left:0;height:100%;">'
        ];
        sb.push(this._createTopRowHTML(columns));
        sb[sb.length] = '<tr>';
        sb[sb.length] = '<td style="width:0;"></td>';
        for (var i = 0, l = columns.length; i < l; i++) {
            var column = columns[i];
            var id = this._createFilterCellId(column);
            sb[sb.length] = '<td id="';
            sb[sb.length] = id;
            sb[sb.length] = '" class="mini-grid-filterCell" style="';
            sb[sb.length] = '">&nbsp;</td>';
        }
        sb[sb.length] = '</tr></table><div class="mini-grid-scrollHeaderCell"></div>';
        var s = sb.join('');
        return s;
    },
    _doRenderFilters: function () {
        //遍历columns，如果有filter对象，则render加入
        var columns = this.getVisibleColumns();
        for (var i = 0, l = columns.length; i < l; i++) {
            var column = columns[i];
            if (column.filter) {
                //if (column.field == 'name') debugger
                var cellEl = this.getFilterCellEl(column);
                if (cellEl) {
                    cellEl.innerHTML = '';
                    column.filter.render(cellEl);
                }
            }
        }
    },
    _doUpdateFilterRow: function () {
        if (this._filterViewEl.firstChild) {
            this._filterViewEl.removeChild(this._filterViewEl.firstChild);
        }
        var isFrozen = this.isFrozen();
        var columns = this.getVisibleColumns();

        var html = this._createFilterRowHTML(columns, 2);
        this._filterViewEl.innerHTML = html;

        this._doRenderFilters();
    },
    /////////////////////////////////////////////////////
    _createSummaryRowHTML: function (columns, viewIndex) {
        var records = this.getDataView();

        var sb = ['<table class="mini-grid-table" cellspacing="0" cellpadding="0" border="0">'];
        sb.push(this._createTopRowHTML(columns));

        for (var j = 0, k = this.summaryRows; j < k; j++) {
            sb[sb.length] = '<tr>';
            sb[sb.length] = '<td style="width:0;"></td>';
            for (var i = 0, l = columns.length; i < l; i++) {
                var column = columns[i];
                var id = this._createSummaryCellId(column, j);

                var e = this._OnDrawSummaryCell(records, column, null, j);

                sb[sb.length] = '<td id="';
                sb[sb.length] = id;
                sb[sb.length] = '" class="mini-grid-summaryCell ' + e.cellCls + '" style="' + e.cellStyle + ';';
                sb[sb.length] = '">';
                sb[sb.length] = e.cellHtml;
                sb[sb.length] = '</td>';
            }
            sb[sb.length] = '</tr>';
        }

        sb[sb.length] = '</table><div class="mini-grid-scrollHeaderCell"></div>';
        var s = sb.join('');
        return s;
    },
    _doUpdateSummaryRow: function () {
        if (!this.showSummaryRow) return;
        var columns = this.getVisibleColumns();
        var html = this._createSummaryRowHTML(columns, 2);
        this._summaryViewEl.innerHTML = html;
    },
    /////////////////////////////////////////////////////
    _doSortByField: function (sortField, sortOrder) {
        if (!sortField) return null;
        var dataType = this._columnModel._getDataTypeByField(sortField);
        this._dataSource._doClientSortField(sortField, sortOrder, dataType);
    },
    _expandGroupOnLoad: true,
    _GroupID: 1,
    _groupField: '',
    _groupDir: '',
    groupBy: function (field, dir) {
        if (!field) return;
        this._groupField = field;
        if (typeof dir == 'string') dir = dir.toLowerCase();
        this._groupDir = dir;
        this._createGroupingView();
        this.deferUpdate();
    },
    clearGroup: function () {
        this._groupField = '';
        this._groupDir = '';
        this._groupDataView = null;
        this.deferUpdate();
    },
    setGroupField: function (value) {
        this.groupBy(value);
    },

    getGroupField: function () {
        return this._groupField;
    },

    getGroupDir: function () {
        return this._groupDir;
    },

    setGroupDir: function (value) {
        this._groupDir = field;
        this.groupBy(this._groupField, value);
    },
    isGrouping: function () {
        return this._groupField != '';
    },
    getGroupingView: function () {
        return this._groupDataView;
    },

    enableGroupOrder: true,
    _createGroupingView: function () {
        if (this.isGrouping() == false) return;
        this._groupDataView = null;

        var source = this._dataSource;

        var field = this._groupField,
            dir = this._groupDir;

        //1）分组排序

        if (this.enableGroupOrder || dir) {
            this._doSortByField(field, dir); //分组时应该可以不用排序
        }

        //2）得到分组数据
        var data = this.getVisibleRows();
        var groups = [];
        var groupMaps = {};
        for (var i = 0, l = data.length; i < l; i++) {
            var o = data[i];
            var v = o[field]; //string, number, boolean, date
            var p = mini.isDate(v) ? v.getTime() : v;
            var group = groupMaps[p];
            if (!group) {
                group = groupMaps[p] = {};
                (group.field = field), (group.dir = dir);
                group.value = v;
                group.rows = [];
                groups.push(group);
                group.id = 'g' + this._GroupID++;
                group.expanded = this._expandGroupOnLoad;
            }
            group.rows.push(o);
        }

        //3) groups 排序
        var sortField = source.sortField,
            sortOrder = source.sortOrder;

        if (sortField) {
            var dataType = this._columnModel._getDataTypeByField(sortField);
            var sortFn = source._getSortFnByField(sortField, dataType);
            if (sortFn) {
                var reverse = sortOrder == 'desc';

                for (var i = 0, l = groups.length; i < l; i++) {
                    var group = groups[i];

                    mini.sort(group.rows, sortFn);
                    if (reverse) group.rows.reverse();
                }
                //this.sort(sortFn, this, reverse);
            }
        }

        this._groupDataView = groups;
    },
    _OnDrawGroup: function (group) {
        var e = {
            group: group,
            rows: group.rows,
            field: group.field,
            dir: group.dir,
            value: group.value,
            cls: '',
            style: '',
            cellHtml: group.field + ' (' + group.rows.length + ' Items)'
        };
        this.fire('drawgroup', e);
        return e;
    },
    getRowGroup: function (id) {
        var t = typeof id;
        if (t == 'number') return this.getGroupingView()[id];
        if (t == 'string') return this._getRowGroupById(id);
        return id;
    },
    _getRowGroupByEvent: function (e) {
        var t = mini.findParent(e.target, 'mini-grid-groupRow');
        if (t) {
            var ids = t.id.split('$');
            if (ids[0] != this._id) return null;
            var id = ids[ids.length - 1];
            return this._getRowGroupById(id);
        }
        return null;
    },
    _getRowGroupById: function (id) {
        var groups = this.getGroupingView();
        for (var i = 0, l = groups.length; i < l; i++) {
            var g = groups[i];
            if (g.id == id) return g;
        }
        return null;
    },
    _createRowGroupId: function (group, viewIndex) {
        return this._id + '$group' + viewIndex + '$' + group.id;
    },
    _createRowGroupRowsId: function (group, viewIndex) {
        return this._id + '$grouprows' + viewIndex + '$' + group.id;
    },
    ////////////////////////////////////
    _createRowId: function (row, index) {
        var id = this._id + '$row' + index + '$' + row._id;
        return id;
    },
    _createHeaderCellId: function (column, index) {
        var id = this._id + '$headerCell' + index + '$' + column._id;
        return id;
    },
    _createCellId: function (row, column) {
        var id = row._id + '$cell$' + column._id;
        return id;
    },
    _createFilterCellId: function (column) {
        return this._id + '$filter$' + column._id;
    },
    _createSummaryCellId: function (column, rowIndex) {
        return this._id + '$summary$' + column._id + '_' + rowIndex;
    },
    /////////////////////////
    getFilterCellEl: function (column) {
        column = this.getColumn(column);
        if (!column) return null;
        return document.getElementById(this._createFilterCellId(column));
    },
    getSummaryCellEl: function (column, rowIndex) {
        if (!rowIndex) rowIndex = 0;
        column = this.getColumn(column);
        if (!column) return null;
        return document.getElementById(this._createSummaryCellId(column, rowIndex));
    },
    /////////////////////////
    _doVisibleEls: function () {
        mini.GridView.superclass._doVisibleEls.call(this);
        this._columnsEl.style.display = this.showColumns ? 'block' : 'none';
        this._filterEl.style.display = this.showFilterRow ? 'block' : 'none';
        this._summaryEl.style.display = this.showSummaryRow ? 'block' : 'none';
        this._bottomPagerEl.style.display = this.showPager ? 'block' : 'none';

        //alert(this._summaryEl.offsetHeight);
    },
    setShowColumns: function (value) {
        this.showColumns = value;
        this._doVisibleEls();
        this.deferLayout();
    },
    setShowFilterRow: function (value) {
        this.showFilterRow = value;
        this._doVisibleEls();
        this.deferLayout();
    },
    setShowSummaryRow: function (value) {
        this.showSummaryRow = value;
        this._doVisibleEls();
        this.deferLayout();
    },
    setShowPager: function (value) {
        this.showPager = value;
        this._doVisibleEls();
        this.deferLayout();
    },
    setFitColumns: function (value) {
        this.fitColumns = value;
        mini.removeClass(this.el, 'mini-grid-fixwidth');
        if (this.fitColumns == false) {
            mini.addClass(this.el, 'mini-grid-fixwidth');
        }
        this.deferLayout();
    },
    getBodyHeight: function (content) {
        //if(this.id == "datagrid2") debugger
        var h = mini.GridView.superclass.getBodyHeight.call(this, content);
        h = h - this.getColumnsHeight() - this.getFilterHeight() - this.getSummaryHeight() - this.getPagerHeight();
        return h;
    },
    getColumnsHeight: function () {
        if (!this.showColumns) return 0;
        var h = mini.getHeight(this._columnsEl);
        //        if (this.isFrozen()) {
        //            var h2 = mini.getHeight(this._columnsLockEl);
        //            if (h2 > h) h = h2;
        //        }
        return h;
    },
    getFilterHeight: function () {
        //return this.showFilterRow ? mini.getHeight(this._filterEl) : 0;
        //return this.showFilterRow ? mini.getHeight(this._filterEl.lastChild.lastChild) : 0;
        return this.showFilterRow ? mini.getHeight(this._filterViewEl.firstChild) : 0;
    },
    getSummaryHeight: function () {
        //alert(this._summaryEl.offsetHeight);
        return this.showSummaryRow ? mini.getHeight(this._summaryEl) : 0;
    },
    getPagerHeight: function () {
        return this.showPager ? mini.getHeight(this._bottomPagerEl) : 0;
    },
    getGridViewBox: function (content) {
        var box = mini.getBox(this._columnsEl);
        var bodyBox = mini.getBox(this._bodyEl);
        box.height = bodyBox.bottom - box.top;
        box.bottom = box.top + box.height;
        return box;
    },
    getSortField: function (value) {
        return this._dataSource.sortField;
    },
    getSortOrder: function (value) {
        return this._dataSource.sortOrder;
    },
    ////////////////////////////////////////////////////////////////////////////////////////
    // DataSource
    ////////////////////////////////////////////////////////////////////////////////////////
    _createSource: function () {
        this._dataSource = new mini.DataTable();
    },
    _bindSource: function () {
        var source = this._dataSource;
        //table
        source.on('loaddata', this.__OnSourceLoadData, this);
        source.on('cleardata', this.__OnSourceClearData, this);
    },
    __OnSourceLoadData: function (e) {
        this._initData();

        var grid = this,
            sortField = grid.getSortField(),
            sortOrder = grid.getSortOrder();
        if (grid.sortMode == 'client' && sortField && sortOrder) {
            grid.sortBy(sortField, sortOrder);
        }

        this.doUpdate();

        setTimeout(function () {
            function rerenderCell() {
                var cell, html;
                for (var i = 0, l = grid.data.length; i < l; i++) {
                    cell = grid.getCellEl(i, column);
                    html = rendered.call(grid, {
                        sender: grid,
                        cell: cell,
                        value: grid.data[i][column.field],
                        column: column
                    });

                    if (html) {
                        cell.firstChild.innerHTML = html;
                    }
                    mini.parse(cell);
                }
            }

            var i = 0,
                l = grid._column_rendered.length,
                item,
                rendered,
                beforeRender,
                column;
            for (; i < l; i++) {
                item = grid._column_rendered[i];
                column = grid._getColumnById(item.id);
                rendered = typeof item.rendered == 'function' ? item.rendered : mini._getFunctoin(item.rendered);
                beforeRender = item.beforeRender;

                if (beforeRender) {
                    beforeRender = typeof beforeRender == 'function' ? beforeRender : mini._getFunctoin(beforeRender);
                    beforeRender.call(
                        grid,
                        {
                            sender: grid,
                            column: column
                        },
                        function () {
                            rerenderCell();
                        }
                    );
                } else {
                    rerenderCell();
                }
            }
        }, 100);

        //this.deferUpdate();   //不能做这个，会有影响
    },
    __OnSourceClearData: function (e) {
        this._initData();
        this.doUpdate();
    },
    _initData: function () {},
    ////////////////////////////////////////////////////////////////////////////////////////
    // ColumnModel
    ////////////////////////////////////////////////////////////////////////////////////////
    isFrozen: function () {
        var sc = this._columnModel._frozenStartColumn,
            fc = this._columnModel._frozenEndColumn;
        //return this.isTableView() && !this.isGrouping() && sc >= 0 && fc >= sc;
        return this._columnModel.isFrozen();
    },
    isFrozenRight: function () {
        return this._columnModel.isFrozenRight();
    },
    _createColumnModel: function () {
        this._columnModel = new mini.ColumnModel(this);
    },
    _bindColumnModel: function () {
        this._columnModel.on('columnschanged', this.__OnColumnsChanged, this);
    },
    __OnColumnsChanged: function (e) {
        this.columns = this._columnModel.columns;
        this._doUpdateFilterRow();
        this._doUpdateSummaryRow();

        this.doUpdate();
        this.fire('columnschanged');
    },
    _column_rendered: [],
    _doUpdateRenderCallBack: function () {
        if (!this.getColumns) {
            return;
        }
        var columns = this.getColumns();
        this._column_rendered = [];
        this._recursionColumns(columns, function (column) {
            if (column.rendered) {
                this._column_rendered.push({
                    rendered: column.rendered,
                    beforeRender: column.beforeRender,
                    id: column._id
                });
            }
        });
    },
    _recursionColumns: function (columns, fn) {
        for (var i = 0, l = columns.length; i < l; i++) {
            fn.call(this, columns[i]);
            if (columns[i].columns) {
                this._recursionColumns(columns[i].columns, fn);
            }
        }
    },
    setColumns: function (columns) {
        this._columnModel.setColumns(columns);
        this.columns = this._columnModel.columns;
    },
    getColumns: function () {
        return this._columnModel.getColumns();
    },
    getBottomColumns: function () {
        return this._columnModel.getBottomColumns();
    },
    getVisibleColumnsRow: function () {
        //获取可视列多行数组。多表头时。
        var rows = this._columnModel.getVisibleColumnsRow().clone();
        return rows;
    },
    getVisibleColumns: function () {
        //获取可视列数组。底行。
        var columns = this._columnModel.getVisibleColumns().clone();
        return columns;
    },
    getFrozenColumns: function () {
        //获取锁定列数组。底行。
        var columns = this._columnModel.getFrozenColumns().clone();
        //alert(columns.length);
        return columns;
    },
    getFrozenRightColumns: function () {
        //获取锁定列数组。底行。
        var columns = this._columnModel.getFrozenRightColumns().clone();
        //alert(columns.length);
        return columns;
    },
    getUnFrozenColumns: function () {
        //获取非锁定列数组。底行。
        var columns = this._columnModel.getUnFrozenColumns().clone();
        return columns;
    },
    getColumn: function (name) {
        //根据列的name和index获取列对象
        return this._columnModel.getColumn(name);
    },
    updateColumn: function (column, options) {
        this._columnModel.updateColumn(column, options);
    },
    // displayColumns: function (columns) {
    //     for (var i = 0, l = columns.length; i < l; i++) {
    //         var column = this.getColumn(columns[i]);
    //         if (!column) continue;
    //         column.visible = true;
    //     }
    //     this._columnModel._columnsChanged();
    //     //this.setColumns(this.columns);
    // },
    // hideColumns: function (columns) {
    //     for (var i = 0, l = columns.length; i < l; i++) {
    //         var column = this.getColumn(columns[i]);
    //         if (!column) continue;
    //         column.visible = false;
    //     }
    //     this._columnModel._columnsChanged();
    //     //this.setColumns(this.columns);
    // },
    showColumn: function (column) {
        this.updateColumn(column, { visible: true });
    },
    hideColumn: function (column) {
        this.updateColumn(column, { visible: false });
    },
    moveColumn: function (column, targetColumn, action) {
        this._columnModel.moveColumn(column, targetColumn, action);
    },
    removeColumn: function (column) {
        column = this.getColumn(column);
        if (!column) return;
        var pcolumn = this.getParentColumn(column);
        if (column && pcolumn) {
            pcolumn.columns.remove(column);
            //this.setColumns(this.columns);
            this._columnModel._columnsChanged();
        }
        return column;
    },
    //    insertColumn: function (column) {
    //
    //    },
    setDefaultColumnWidth: function (value) {
        this._columnModel._defaultColumnWidth = value;
    },
    getDefaultColumnWidth: function () {
        return this._columnModel._defaultColumnWidth;
    },
    setColumnWidth: function (column, width) {
        this.updateColumn(column, { width: width });
    },
    getColumnWidth: function (column) {
        var box = this.getColumnBox(column);
        return box.width;
    },
    getParentColumn: function (column) {
        return this._columnModel.getParentColumn(column);
    },
    getMaxColumnLevel: function () {
        return this._columnModel._getMaxColumnLevel();
    },
    /////////////////////////////////////////////////////
    _isCellVisible: function (rowIndex, columnIndex) {
        return true;
    },
    _createDrawCellEvent: function (record, column, rowIndex, columnIndex) {
        //if(rowIndex == 0 && column.field == "Extends.loginname") debugger

        //var field = this.getKeyField(column.field);

        var value = mini._getMap(column.field, record);
        var e = {
            sender: this,
            //rowType: record._rowType,
            rowIndex: rowIndex,
            columnIndex: columnIndex,
            record: record,
            row: record,
            column: column,
            field: column.field,
            value: value,
            cellHtml: value,
            rowCls: '',
            rowStyle: null,
            cellCls: column.cellCls || '',
            cellStyle: column.cellStyle || '',
            allowCellWrap: this.allowCellWrap,
            showHGridLines: this.showHGridLines,
            showVGridLines: this.showVGridLines,
            cellInnerCls: '',
            cellInnnerStyle: '',
            autoEscape: column.autoEscape
        };
        e.visible = this._isCellVisible(rowIndex, columnIndex);
        if (e.visible == true && this._mergedCellMaps) {
            var cell = this._mergedCellMaps[rowIndex + ':' + columnIndex];
            if (cell) {
                e.rowSpan = cell.rowSpan;
                e.colSpan = cell.colSpan;
            }
        }
        return e;
    },

    defaultColumnDateFormat: 'yyyy-MM-dd', //dateType="date"

    _OnDrawCell: function (record, column, rowIndex, columnIndex) {
        var e = this._createDrawCellEvent(record, column, rowIndex, columnIndex);
        var value = e.value;

        var dateFormat = column.dateFormat || (column.dataType == 'date' ? this.defaultColumnDateFormat : '');
        if (dateFormat) {
            if (mini.isDate(e.value)) {
                //日期格式化，有点慢！已经做了特别优化：yyyy-MM-dd, MM/dd/yyyy
                e.cellHtml = mini.formatDate(value, dateFormat);
            } else {
                var tempVal = value && new Date(value);
                if (tempVal && mini.isDate(tempVal) && tempVal.getFullYear()) {
                    e.cellHtml = mini.formatDate(tempVal, dateFormat);
                } else e.cellHtml = value;
            }
        }

        if (column.dataType == 'float') {
            var value = parseFloat(e.value);
            if (!isNaN(value)) {
                decimalPlaces = parseInt(column.decimalPlaces);
                if (isNaN(decimalPlaces)) decimalPlaces = 2;

                e.cellHtml = value.toFixed(decimalPlaces);
            }
        }

        if (column.dataType == 'currency') {
            //dtype, vtype, xtype?
            e.cellHtml = mini.formatCurrency(e.value, column.currencyUnit);
        }

        if (column.displayField) {
            e.cellHtml = mini._getMap(column.displayField, record); //record[column.displayField];
        }
        if (column.numberFormat) {
            var v = e.cellHtml;
            if (window.numeral) {
                formatValue();
            } else {
                mini.numeralUtil.initNumeral(function () {
                    formatValue();
                });
            }
            function formatValue() {
                if (typeof v !== 'number') {
                    v = numeral(v).value();
                }
                var valueData = numeral(v || 0);
                e.cellHtml = valueData.format(mini._oldFormatTransform(column.numberFormat));
            }
        }

        if (column.template) {
            e.cellHtml = Mustache.render(column.template, record);
        }
        if (e.autoEscape == true) {
            //e.htmlEncode = true       代码升级，更新换代
            e.cellHtml = mini.htmlEncode(e.cellHtml);
            //e.cellHtml = 1;
        }

        var renderer = column.renderer;
        if (renderer) {
            //            var fn = null;
            //            if (typeof renderer == "function") {
            //                fn = renderer;
            //            } else {
            //                fn = mini._getFunctoin(renderer);
            //            }
            var fn = typeof renderer == 'function' ? renderer : mini._getFunctoin(renderer);
            if (fn) {
                e.cellHtml = fn.call(column, e);
            }
        }

        //e.cellHtml = e.cellHtml ? String(e.cellHtml).trim() : "";

        //e.cellHtml = (e.cellHtml === 0 || e.cellHtml) ? String(e.cellHtml).trim() : "";

        e.cellHtml = e.cellHtml === 0 || e.cellHtml === false || e.cellHtml ? String(e.cellHtml).trim() : '';

        //e.cellHtml = (e.cellHtml === 0 || !mini.isNull(e.cellHtml)) ? String(e.cellHtml).trim() : "";

        this.fire('drawcell', e);

        if (e.cellHtml && !!e.cellHtml.unshift && e.cellHtml.length == 0) {
            e.cellHtml = '&nbsp;';
        }
        if (e.cellHtml === null || e.cellHtml === undefined || e.cellHtml === '') e.cellHtml = '&nbsp;';

        return e;
    },
    _OnDrawSummaryCell: function (records, column, group, row) {
        var e = {
            row: row,
            group: group,
            result: this.getResultObject(),
            sender: this,
            data: records,
            column: column,
            field: column.field,
            value: '',
            cellHtml: '',
            cellCls: column.cellCls || '',
            cellStyle: column.cellStyle || '',
            allowCellWrap: this.allowCellWrap
        };

        if (column.summaryType) {
            var fn = mini.summaryTypes[column.summaryType];
            if (fn) {
                e.value = fn(records, column.field);
            }
        }

        var value = e.value;
        e.cellHtml = e.value;

        if (e.value && parseInt(e.value) != e.value && e.value.toFixed) {
            decimalPlaces = parseInt(column.decimalPlaces);
            if (isNaN(decimalPlaces)) decimalPlaces = 2;

            e.cellHtml = parseFloat(e.value.toFixed(decimalPlaces));
        }

        if (column.dateFormat) {
            if (mini.isDate(e.value)) {
                //日期格式化，有点慢！已经做了特别优化：yyyy-MM-dd, MM/dd/yyyy
                e.cellHtml = mini.formatDate(value, column.dateFormat);
            } else e.cellHtml = value;
        }
        if (e.cellHtml) {
            if (column.dataType == 'currency') {
                e.cellHtml = mini.formatCurrency(e.cellHtml, column.currencyUnit);
            }
        }

        var renderer = column.summaryRenderer;
        if (renderer) {
            fn = typeof renderer == 'function' ? renderer : window[renderer];
            if (fn) {
                e.cellHtml = fn.call(column, e);
            }
        }
        column.summaryValue = e.value;

        this.fire('drawsummarycell', e);

        if (e.cellHtml === null || e.cellHtml === undefined || e.cellHtml === '') e.cellHtml = '&nbsp;';

        return e;
    },
    /////////////////////////////////////////
    getScrollTop: function () {
        return this._rowsViewEl.scrollTop;
    },
    setScrollTop: function (value) {
        this._rowsViewEl.scrollTop = value;
    },
    getScrollLeft: function () {
        return this._rowsViewEl.scrollLeft;
    },
    setScrollLeft: function (value) {
        this._rowsViewEl.scrollLeft = value;
    },
    _syncScroll: function () {
        var scrollLeft = this._rowsViewEl.scrollLeft;

        //this._filterViewEl.scrollLeft = scrollLeft;
        var filterTable = this._filterViewEl.firstChild;
        filterTable.style.left = -scrollLeft + 'px';

        this._summaryViewEl.scrollLeft = scrollLeft;
        this._columnsViewEl.scrollLeft = scrollLeft;
    },
    __OnRowViewScroll: function (e) {
        this._syncScroll();
    },
    //////////////////////////////////////////////////////////////////////////////////////////
    // Pager
    //////////////////////////////////////////////////////////////////////////////////////////
    pagerType: 'pager',
    getPagerType: function () {
        return this.pagerType;
    },
    setPagerType: function (value) {
        this.pagerType = value;

        var pager = mini.create({ type: this.pagerType });
        if (pager) this._setBottomPager(pager);
    },

    _pagers: [],
    _createPagers: function () {
        this._pagers = [];
        var bottomPager = new mini.Pager();
        this._setBottomPager(bottomPager);
    },

    _setBottomPager: function (pager) {
        pager = mini.create(pager);
        if (!pager) return;
        if (this._bottomPager) {
            this.unbindPager(this._bottomPager);
            this._bottomPagerEl.removeChild(this._bottomPager.el);
        }
        this._bottomPager = pager;
        pager.render(this._bottomPagerEl);
        this.bindPager(pager);
    },

    bindPager: function (pager) {
        this._pagers.add(pager);
    },
    unbindPager: function (pager) {
        this._pagers.remove(pager);
    },
    ////////////////////////////////////////////////////////

    alwaysShowEmptyText: false,
    setAlwaysShowEmptyText: function (value) {
        this.alwaysShowEmptyText = value;
    },
    getAlwaysShowEmptyText: function () {
        return this.alwaysShowEmptyText;
    },

    setShowEmptyText: function (value) {
        this.showEmptyText = value;
        if (this.data.length == 0) this.deferUpdate();
    },
    getShowEmptyText: function () {
        return this.showEmptyText;
    },
    setEmptyText: function (value) {
        this.emptyText = value;
    },
    getEmptyText: function () {
        return this.emptyText;
    },
    setShowModified: function (value) {
        this.showModified = value;
    },
    getShowModified: function () {
        return this.showModified;
    },
    setShowNewRow: function (value) {
        this.showNewRow = value;
    },
    getShowNewRow: function () {
        return this.showNewRow;
    },
    setAllowCellWrap: function (value) {
        this.allowCellWrap = value;
    },
    getAllowCellWrap: function () {
        return this.allowCellWrap;
    },
    setAllowHeaderWrap: function (value) {
        this.allowHeaderWrap = value;
    },
    getAllowHeaderWrap: function () {
        return this.allowHeaderWrap;
    },
    setEnableGroupOrder: function (value) {
        this.enableGroupOrder = value;
    },
    getEnableGroupOrder: function () {
        return this.enableGroupOrder;
    },

    /////////////////////////////////////////////////////////////////////
    //Grid Lines
    /////////////////////////////////////////////////////////////////////
    setShowHGridLines: function (value) {
        if (this.showHGridLines != value) {
            this.showHGridLines = value;
            this.deferUpdate();
        }
    },
    getShowHGridLines: function () {
        return this.showHGridLines;
    },
    setShowVGridLines: function (value) {
        if (this.showVGridLines != value) {
            this.showVGridLines = value;
            this.deferUpdate();
        }
    },
    getShowVGridLines: function () {
        return this.showVGridLines;
    },

    setShowSortIcon: function (value) {
        if (this.showSortIcon != value) {
            this.showSortIcon = value;
            this.deferUpdate();
        }
    },
    getShowSortIcon: function () {
        return this.showSortIcon;
    }
});

mini.copyTo(mini.GridView.prototype, mini._DataTableApplys);

mini.regClass(mini.GridView, 'gridview');

//(function () {
//    var inited = false;
//    function init(){
//        var grid = this;
//        grid.on("drawcell", function(e){
//
//        });
//    }

//    var set = mini.DataGrid.prototype.set;
//    mini.DataGrid.prototype.set = function(){
//        if(!inited){
//            init.call(this);
//            inited = true;
//        }
//        set.apply(this, arguments);
//    }
//})();

/*   
    1.实现锁定列

*/

mini.FrozenGridView = function() {
    mini.FrozenGridView.superclass.constructor.apply(this, arguments);
};
mini.extend(mini.FrozenGridView, mini.GridView, {

    //锁定列后，行高固定
    isFixedRowHeight: function() {
        //return this.fixedRowHeight || this.isFrozen();
        //return this.fixedRowHeight || !this.allowCellWrap;
        return this.fixedRowHeight;
    },

    frozenPosition: 'left',
    isRightFrozen: function() {
        return this.frozenPosition == 'right';
    },
    //    setFrozenPosition: function (value) {
    //        this.frozenPosition = value;
    //        this.deferLayout();
    //    },
    //    getFrozenPosition: function (value) {
    //        return this.frozenPosition;
    //    },

    _create: function() {
        mini.FrozenGridView.superclass._create.call(this);

        // columns
        var lockColumns = '<div class="mini-grid-columns-lock"></div>',
            lockRightColumns = '<div class="mini-grid-columns-lock"></div>';
        this._columnsLockEl = mini.before(this._columnsViewEl, lockColumns);
        this._columnsRightLockEl = mini.after(this._columnsViewEl, lockRightColumns);

        //filter
        var lockFilter = '<div class="mini-grid-filterRow-lock" style="height:100%;"></div>',
            lockRightFilter = '<div class="mini-grid-filterRow-lock" style="height:100%;"></div>';
        this._filterLockEl = mini.before(this._filterViewEl, lockFilter);
        this._filterRightLockEl = mini.after(this._filterViewEl, lockRightFilter);

        // body
        var lockRows = '<div class="mini-grid-rows-lock"><div class="mini-grid-rows-content"></div></div>',
            lockRightRows = '<div class="mini-grid-rows-lock" style="overflow-x: hidden; overflow-y: auto;"><div class="mini-grid-rows-content"></div></div>';
        this._rowsLockEl = mini.before(this._rowsViewEl, lockRows);
        this._rowsRightLockEl = mini.after(this._rowsViewEl, lockRightRows);
        this._rowsLockContentEl = this._rowsLockEl.firstChild;
        this._rowsRightLockContentEl = this._rowsRightLockEl.firstChild;

        //summary
        var lockSummary = '<div class="mini-grid-summaryRow-lock"></div>',
            lockRightSummary = '<div class="mini-grid-summaryRow-lock"></div>';
        this._summaryLockEl = mini.before(this._summaryViewEl, lockSummary);
        this._summaryRightLockEl = mini.after(this._summaryViewEl, lockRightSummary);

    },
    _initEvents: function() {
        mini.FrozenGridView.superclass._initEvents.call(this);

        mini.on(this._rowsEl, "mousewheel", this.__OnMouseWheel, this);

    },
    _createHeaderText: function(column, viewIndex) {
        var header = column.header;
        if (typeof header == "function") header = header.call(this, column);
        if (mini.isNull(header) || header === "") header = "&nbsp;";
        if (this.isFrozen() && viewIndex == 2) {
            if (column.viewIndex1) {
                header = "&nbsp;";
            }
        }
        if (this.isFrozenRight() && viewIndex == 3) {
            if (column.colspan2 && column.columns) {
                header = "&nbsp;"
            }
        }
        return header;
    },
    _createColumnColSpan: function(column, sb, viewIndex) {
        if (this.isFrozen() || this.isFrozenRight()) {
            var colspan = column["colspan" + viewIndex];
            if (colspan) {
                sb[sb.length] = 'colspan="' + colspan + '" ';
            }
        } else {
            if (column.colspan) {
                sb[sb.length] = 'colspan="' + column.colspan + '" ';
            }
        }
    },
    doUpdateColumns: function() {
        var scrollLeft = this._columnsViewEl.scrollLeft;

        var isFrozen = this.isFrozen(),
            isFrozenRight = this.isFrozenRight();

        var frozenColumnsRow = isFrozen ? this.getFrozenColumnsRow() : [];
        var frozenRightColumnsRow = isFrozenRight ? this.getFrozenRightColumnsRow() : [];
        var unFrozenColumnsRow = this.getUnFrozenColumnsRow();

        var frozenColumns = isFrozen ? this.getFrozenColumns() : [];
        var frozenRightColumns = isFrozenRight ? this.getFrozenRightColumns() : [];
        var unfrozenColumns = this.getUnFrozenColumns();


        var lockHtml = this._createColumnsHTML(frozenColumnsRow, 1, frozenColumns);
        var html = this._createColumnsHTML(unFrozenColumnsRow, 2, unfrozenColumns);
        var lockRightHtml = this._createColumnsHTML(frozenRightColumnsRow, 3, frozenRightColumns);
        var s = '<div class="mini-grid-topRightCell"></div>';

        lockHtml += s;
        html += s;
        lockRightHtml += s;

        this._columnsLockEl.innerHTML = lockHtml;
        this._columnsRightLockEl.innerHTML = lockRightHtml;
        this._columnsViewEl.innerHTML = html;

        var lockTable = this._columnsLockEl.firstChild;
        var lockRightTable = this._columnsRightLockEl.firstChild;
        lockTable.style.width = "0px";
        lockRightTable.style.width = "0px";


        this._columnsViewEl.scrollLeft = scrollLeft;

        mini[['addClass', 'removeClass'][this._columnModel._maxColumnLevel > 0 ? 0 : 1]](this._viewportEl, 'mini-grid-composite-columns');
    },
    doUpdateRows: function() {

        var data = this.getVisibleRows();


        var columns1 = this.getFrozenColumns();
        var columns2 = this.getUnFrozenColumns();
        var columns3 = this.getFrozenRightColumns();


        if (this.isGrouping()) {
            var lockHtml = this._createGroupingHTML(columns1, 1);
            var lockRightHtml = this._createGroupingHTML(columns3, 3);
            var html = this._createGroupingHTML(columns2, 2);

            this._rowsLockContentEl.innerHTML = lockHtml;
            this._rowsRightLockContentEl.innerHTML = lockRightHtml;
            this._rowsViewContentEl.innerHTML = html;
        } else {
            //if (data.length > 1) data.length = 1;
            var lockHtml = this._createRowsHTML(columns1, 1, this.isFrozen() ? data : []);
            var html = this._createRowsHTML(columns2, 2, data);
            var lockRightHtml = this._createRowsHTML(columns3, 3, this.isFrozenRight() ? data : []);

            //            mini.removeChilds(this._rowsLockContentEl);
            //            mini.removeChilds(this._rowsViewContentEl);

            //            jQuery(this._rowsLockContentEl).empty();
            //            jQuery(this._rowsViewContentEl).empty();

            this._rowsLockContentEl.innerHTML = lockHtml;
            this._rowsRightLockContentEl.innerHTML = lockRightHtml;
            this._rowsViewContentEl.innerHTML = html;
        }
        var lockTable = this._rowsLockContentEl.firstChild;
        var lockRightTable = this._rowsRightLockContentEl.firstChild;
        lockTable.style.width = "0px";
        lockRightTable.style.width = "0px";

        //this._syncRowsHeight();
    },
    _doUpdateFilterRow: function() {

        if (this._filterLockEl.firstChild) {
            this._filterLockEl.removeChild(this._filterLockEl.firstChild);
        }
        if (this._filterViewEl.firstChild) {
            this._filterViewEl.removeChild(this._filterViewEl.firstChild);
        }
        if (this._filterRightLockEl.firstChild) {
            this._filterRightLockEl.removeChild(this._filterRightLockEl.firstChild);
        }

        var columns1 = this.getFrozenColumns();
        var columns2 = this.getUnFrozenColumns();
        var columns3 = this.getFrozenRightColumns();

        var html1 = this._createFilterRowHTML(columns1, 1);
        var html2 = this._createFilterRowHTML(columns2, 2);
        var html3 = this._createFilterRowHTML(columns3, 3);

        this._filterLockEl.innerHTML = html1;
        this._filterViewEl.innerHTML = html2;
        this._filterRightLockEl.innerHTML = html3;

        this._doRenderFilters();
    },
    _doUpdateSummaryRow: function() {

        var columns1 = this.getFrozenColumns();
        var columns2 = this.getUnFrozenColumns();
        var columns3 = this.getFrozenRightColumns();

        var html1 = this._createSummaryRowHTML(columns1, 1);
        var html2 = this._createSummaryRowHTML(columns2, 2);
        var html3 = this._createSummaryRowHTML(columns3, 3);

        this._summaryLockEl.innerHTML = html1;
        this._summaryViewEl.innerHTML = html2;
        this._summaryRightLockEl.innerHTML = html3;
    },
    _syncRowsHeightTimer: null,
    //只在doUpdateRows方法内调用?

    syncRowDetail: function(row) {
        var row1 = this._getRowDetailEl(row, 1);
        var row2 = this._getRowDetailEl(row, 2);
        if (row1 && row2) this._doSyncRowHeight(row1, row2);
    },

    _doSyncRowHeight: function(row1, row2, row3) {

        //        row1.style.height = row2.style.height = "auto";

        //        var h1 = row1.offsetHeight;
        //        var h2 = row2.offsetHeight;
        //        if (h1 < h2) h1 = h2;

        //        row1.style.height = row2.style.height = h1 + "px";
        var h1 = 0,
            h2 = 0,
            h3 = 0;

        if (row1) {
            row1.style.height = "auto";
            h1 = row1.cells[0].offsetHeight;
        }
        if (row2) {
            row2.style.height = "auto";
            h2 = row2.cells[0].offsetHeight;
        }
        if (row3) {
            row3.style.height = "auto";
            h3 = row3.cells[0].offsetHeight;
        }

        var maxHeight = Math.max(h1, h2, h3);

        if (row1) row1.style.height = maxHeight + "px";
        if (row2) row2.style.height = maxHeight + "px";
        if (row3) row3.style.height = maxHeight + "px";

    },

    _syncRowsHeight: function() {
        //同步锁定区、非锁定区的所有行高。优化方案：在doUpdate的时候调用一次，其他的时候不调用。
        var me = this;
        var isFrozen = this.isFrozen(),
            isFrozenRight = this.isFrozenRight();

        function autoRow(row1, row2, row3) {
            row2.style.height = "auto";
            if (isFrozen) {
                row1.style.height = 'auto';
            }
            if (isFrozenRight) {
                row3.style.height = 'auto';
            }
        }

        function measureRow(row1, row2, row3) {
            var td1, td2 = row2.cells[0],
                td3;
            var h1 = -1,
                h2 = td2.offsetHeight,
                h3 = -1;

            if (isFrozen) {
                td1 = row1.cells[0];
                h1 = td1.offsetHeight;
            }
            if (isFrozenRight) {
                td3 = row3.cells[0];
                h3 = td3.offsetHeight;
            }

            var max = Math.max(h1, h2, h3);

            return max;
        }

        function arrangeRow(row1, row2, row3, height) {
            var h = height + "px";
            row2.style.height = h;
            if (isFrozen) {
                row1.style.height = h;
            }
            if (isFrozenRight) {
                row3.style.height = h;
            }
        }

        function doSync() {
            var sss = new Date();
            //return;
            //优化：1）分2次同步；2）只在doUpdate调用一次
            var d = document;
            var data = me.getDataView();

            //1) auto
            var rowMap = {};
            for (var i = 0, l = data.length; i < l; i++) {
                var row = data[i];
                var row1 = me._getRowEl(row, 1);
                var row2 = me._getRowEl(row, 2);
                var row3 = me._getRowEl(row, 3);

                if (!row2) continue;
                if (!row1 && isFrozen) continue;
                if (!row3 && isFrozenRight) continue;

                autoRow(row1, row2, row3);
                rowMap[i] = { row1: row1, row2: row2, row3: row3 };
            }
            //2) measure
            for (var i = 0, l = data.length; i < l; i++) {
                var row = data[i];
                var map = rowMap[i];
                if (!map) continue;
                map.height = measureRow(map.row1, map.row2, map.row3);
            }
            //2) arrange
            for (var i = 0, l = data.length; i < l; i++) {
                var row = data[i];
                var map = rowMap[i];
                if (!map) continue;
                arrangeRow(map.row1, map.row2, map.row3, map.height);
            }

            me._syncRowsHeightTimer = null;

            //alert(new Date() - sss);
        }

        doSync();
        // if (this.isFrozen() || this.isFrozenRight() && this.isFixedRowHeight() == false) {
        //     if (this._syncRowsHeightTimer) clearTimeout(this._syncRowsHeightTimer);
        //     this._syncRowsHeightTimer = setTimeout(doSync, 2);
        // }
    },
    _syncColumnHeight: function() {

        var lock = this._columnsLockEl,
            lockRight = this._columnsRightLockEl,
            view = this._columnsViewEl;
        lock.style.height = view.style.height = 'auto';
        lockRight.style.height = view.style.height = 'auto';
        if (this.isFrozen()) {
            var h = lock.offsetHeight;
            var h2 = view.offsetHeight;
            h = h > h2 ? h : h2;
            lock.style.height = view.style.height = h + 'px';
        }
        if (this.isFrozenRight()) {
            var h = lockRight.offsetHeight;
            var h2 = view.offsetHeight;
            h = h > h2 ? h : h2;
            lockRight.style.height = view.style.height = h + 'px';
        }

        //summary
        var lock = this._summaryLockEl,
            view = this._summaryViewEl;
        lock.style.height = view.style.height = 'auto';
        if (this.isFrozen()) {
            var h = lock.offsetHeight;
            var h2 = view.offsetHeight;
            h = h > h2 ? h : h2;
            lock.style.height = view.style.height = h + 'px';
        }
    },

    _layoutColumns: function() {
        //if(mini.isChrome) return; //暂不实现
        function getHeight(el) {
            return el.offsetHeight;
        }

        function getTds(tr) {
            var tds = [];
            for (var i = 0, l = tr.cells.length; i < l; i++) {
                var td = tr.cells[i];
                if (td.style.width == "0px") continue;
                tds.push(td);
            }
            return tds;
        }

        function clearHeight(tr) {
            var tds = getTds(tr);
            for (var i = 0, l = tds.length; i < l; i++) {
                var td = tds[i];
                td.style.height = "auto";
            }
        }

        function clearHeights() {
            table1.style.height = table1.style.height = "auto";
            for (var i = 0, l = table1.rows.length; i < l; i++) {
                var row1 = table1.rows[i];
                var row2 = table2.rows[i];
                clearHeight(row1);
                clearHeight(row2);
            }
        }

        function getRowHeight(tr, nospan) {
            var h = 0;
            var tds = getTds(tr);
            for (var i = 0, l = tds.length; i < l; i++) {
                var td = tds[i];
                var rowspan = parseInt(td.rowSpan) > 1;
                if (rowspan && nospan) continue;

                var th = td.offsetHeight;
                if (th > h) h = th;

            }
            return h;
        }


        if (!this.isFrozen() && !this.isFrozenRight()) return;
        var table1 = this._columnsLockEl.firstChild,
            table2 = this._columnsViewEl.firstChild;

        /*
        多表头+换行+锁定列同步高度算法：
        1.首先对比tr的height
        2.然后，设置小的td高度
        3.
        1.先找正常td，设置正常高度
        2.然后找rowspan的td，设置最大高度
        */

        function syncNoRowSpan(tr, tr2) {
            var h = getRowHeight(tr2, true);
            //if (h == 0) return;
            var tds = getTds(tr);
            for (var i = 0, l = tds.length; i < l; i++) {
                var td = tds[i];
                var rowspan = parseInt(td.rowSpan) > 1;
                //if (td.id == "mini-3$headerCell1$25") debugger
                if (rowspan) {

                } else {
                    mini.setHeight(td, h);
                }
            }
        }

        function syncRowSpan(tr, tr2) {
            var h = getRowHeight(tr2);
            //if (h == 0) return;
            var tds = getTds(tr);
            for (var i = 0, l = tds.length; i < l; i++) {
                var td = tds[i];
                var rowspan = parseInt(td.rowSpan) > 1;
                //if(td.id == "mini-3$headerCell1$25") debugger
                if (rowspan) {
                    mini.setHeight(td, h);
                } else {

                }
            }
        }

        clearHeights();

        //处理只有一个单元格的情况

        for (var i = 0, l = table1.rows.length; i < l; i++) {
            var row1 = table1.rows[i];
            var row2 = table2.rows[i];
            var h1 = getRowHeight(row1),
                h2 = getRowHeight(row2);

            if (h1 == h2) {

                //} else if (h1 < h2 || row1.cells.length == 2) {//row1.cells.length == 2 表示只有一列
            } else if (h1 < h2) {
                syncNoRowSpan(row1, row2);
                syncRowSpan(row1, row2);
                //} else if (h1 > h2 || row2.cells.length == 2) {
            } else if (h1 > h2) {
                syncNoRowSpan(row2, row1);
                syncRowSpan(row2, row1);
            }
        }

        //同步下表格高度
        var h1 = getHeight(table1),
            h2 = getHeight(table2);
        if (h1 < h2) {
            mini.setHeight(table1, h2);
        } else if (h1 > h2) {
            mini.setHeight(table2, h1);
        }
    },
    doLayout: function() {
        if (this.canLayout() == false) return;
        this._doLayoutScroll = false;

        // 调整自适应列的列宽最小值;
        this._autoColumnWidth();

        var isFrozen = this.isFrozen(),
            isFrozenRight = this.isFrozenRight();

        var viewportWidth = this.getViewportWidth(true),
            lockedWidth = this.getLockedWidth(),
            lockedRightWidth = this.getLockedRightWidth(),
            viewWidth = viewportWidth - lockedWidth - lockedRightWidth;

        this._doEmptyText();



        var marginStyle = this.isRightFrozen() ? 'marginRight' : 'marginLeft';
        var leftStyle = this.isRightFrozen() ? 'right' : 'left';

        if (isFrozen || isFrozenRight) {
            // 非冻结列 marginLeft, marginRight, width
            var viewMarginLeft = lockedWidth + 'px',
                viewMarginRight = lockedRightWidth + 'px',
                viewWidth = viewWidth + 'px';

            [
                this._columnsViewEl,
                this._filterViewEl,
                this._rowsViewEl,
                this._summaryViewEl
            ].forEach(function(el) {
                el.style.marginLeft = viewMarginLeft;
                el.style.marginRight = viewMarginRight;
                el.style.width = viewWidth;
            });

            // 左侧冻结列 width, left
            [
                this._columnsLockEl,
                this._filterLockEl,
                this._rowsLockEl,
                this._summaryLockEl
            ].forEach(function(el) {
                mini.setWidth(el, lockedWidth);
                el.style.left = '0';
            });

            // 右侧冻结列 width, left, right
            [
                this._columnsRightLockEl,
                this._filterRightLockEl,
                this._rowsRightLockEl,
                this._summaryRightLockEl
            ].forEach(function(el) {
                mini.setWidth(el, lockedRightWidth);
                el.style.left = 'auto';
                el.style.right = '0';
            })


            if (mini.isSafari || mini.isChrome || mini.isIE6) {
                var _rowsViewElParentBorder = mini.getBorders(this._rowsViewEl.parentNode);
                this._rowsViewEl.style["width"] = viewWidth - (_rowsViewElParentBorder.left + _rowsViewElParentBorder.right) + "px";
            }
        } else {
            this._doClearFrozen();
        }

        //处理td的高度
        this._layoutColumns();
        //同步左右两个column高度
        this._syncColumnHeight();


        mini.FrozenGridView.superclass.doLayout.call(this);

        var autoHeight = this._autoHeight;

        if (isFrozen || isFrozenRight) {
            if (mini.isChrome || mini.isIE6) {
                //处理td的高度
                this._layoutColumns();
                //同步左右两个column高度
                this._syncColumnHeight();
                mini.FrozenGridView.superclass.doLayout.call(this);
            }

            this._rowsLockEl.style.height = "100%";
            this._rowsRightLockEl.style.height = "100%";
        }

        this._syncRowsHeight();
    },
    _doEmptyText: function() {
        //        var d1 = document.getElementById(this.uid + "$emptytext" + 1);
        //        var d2 = document.getElementById(this.uid + "$emptytext" + 2);        
        //        if (this.getDataView().length == 0 && this.showEmptyText) {            
        //            d1.style.display = d2.style.display = "";
        //        } else {
        //            d1.style.display = d2.style.display = "none";
        //        }
    },
    //count: 0,
    _getRowEl: function(row, index) {
        row = this.getRecord(row);
        var id = this._createRowId(row, index);
        var el = document.getElementById(id);
        return el;
    },

    ///////////////////////////////////////////////////
    _doClearFrozen: function() {
        // 非冻结列 marginLeft, marginRight, width
        [
            this._columnsViewEl,
            this._filterViewEl,
            this._rowsViewEl,
            this._summaryViewEl
        ].forEach(function(el) {
            el.style.marginLeft = '0';
            el.style.marginRight = '0';
            el.style.width = '100%';
        });

        // 左侧冻结列 width, left
        [
            this._columnsLockEl,
            this._filterLockEl,
            this._rowsLockEl,
            this._summaryLockEl
        ].forEach(function(el) {
            el.style.width = '0';
            el.style.left = '-10px';
        });

        // 右侧冻结列 width, left, right
        [
            this._columnsRightLockEl,
            this._filterRightLockEl,
            this._rowsRightLockEl,
            this._summaryRightLockEl
        ].forEach(function(el) {
            el.style.width = '0';
            el.style.left = 'auto';
            el.style.right = '-10px';
        });
    },
    frozenColumns: function(startColumn, finishColumn) {
        this.frozen(startColumn, finishColumn);
    },
    frozenRightColumns: function(startColumn, finishColumn) {
        this.frozenRight(startColumn, finishColumn);
    },
    unFrozenColumns: function() {
        this.unFrozen();
    },
    frozen: function(startColumn, finishColumn) {
        this._doClearFrozen();
        this._columnModel.frozen(startColumn, finishColumn);
    },
    frozenRight: function(startColumn, finishColumn) {
        this._doClearFrozen();
        this._columnModel.frozenRight(startColumn, finishColumn);
    },
    unFrozen: function() {
        this._doClearFrozen();
        this._columnModel.unFrozen();
    },
    setFrozenStartColumn: function(value) {
        this._columnModel.setFrozenStartColumn(value);
    },
    setFrozenEndColumn: function(value) {
        return this._columnModel.setFrozenEndColumn(value);
    },
    setFrozenRightStartColumn: function(value) {
        this._columnModel.setFrozenRightStartColumn(value);
    },
    setFrozenRightEndColumn: function(value) {
        return this._columnModel.setFrozenRightEndColumn(value);
    },
    getFrozenStartColumn: function(value) {
        return this._columnModel._frozenStartColumn;
    },
    getFrozenEndColumn: function(value) {
        return this._columnModel._frozenEndColumn;
    },
    getFrozenRightStartColumn: function(value) {
        return this._columnModel._frozenRightStartColumn;
    },
    getFrozenRightEndColumn: function(value) {
        return this._columnModel._frozenRightEndColumn;
    },
    getFrozenColumnsRow: function() {
        return this._columnModel.getFrozenColumnsRow();
    },
    getFrozenRightColumnsRow: function() {
        return this._columnModel.getFrozenRightColumnsRow();
    },
    getUnFrozenColumnsRow: function() {
        return this._columnModel.getUnFrozenColumnsRow();
    },
    ////////////////////////////////////////////////////
    getLockedWidth: function() {

        if (!this.isFrozen()) return 0;

        var table = this._rowsLockContentEl.firstChild.firstChild;
        //var table = this._columnsLockEl.firstChild.firstChild;
        var width = table ? table.offsetWidth : 0;
        return width;
    },
    getLockedRightWidth: function() {

        if (!this.isFrozenRight()) return 0;

        var table = this._rowsRightLockContentEl.firstChild.firstChild;
        //var table = this._columnsLockEl.firstChild.firstChild;
        var width = table ? table.offsetWidth : 0;
        return width;
    },
    ////////////////////////////////////////
    _canDeferSyncScroll: function() {
        return this.isFrozen();
    },
    _syncScroll: function() {
        var scrollLeft = this._rowsViewEl.scrollLeft;
        //if(scrollLeft != 0) alert(scrollLeft);

        //this._filterViewEl.scrollLeft = scrollLeft;
        var filterTable = this._filterViewEl.firstChild;
        //        filterTable.style.position = "absolute";
        //        filterTable.style.top = "0px";
        filterTable.style.left = -scrollLeft + "px";

        //        document.title = new Date().getTime();
        //        if (this._filterViewEl.scrollLeft > 0) debugger
        //this._filterViewEl.scrollLeft = 0;

        this._summaryViewEl.scrollLeft = scrollLeft;
        this._columnsViewEl.scrollLeft = scrollLeft;

        var me = this;
        var scrollTop;
        if (this.isFrozenRight()) {
            scrollTop = me._rowsRightLockEl.scrollTop;
            me._rowsLockEl.scrollTop = scrollTop;
            me._rowsViewEl.scrollTop = scrollTop;
        } else {
            scrollTop = me._rowsViewEl.scrollTop;
            me._rowsLockEl.scrollTop = scrollTop;
            me._rowsRightLockEl.scrollTop = scrollTop;
        }

        //document.title = new Date().getTime();

        //@ 2017-11-27  注释掉
        //        if (this._canDeferSyncScroll()) {

        //            setTimeout(function () {
        //                //                if (scrollTop > me._rowsLockEl.scrollTop) {
        //                //                }

        //                //me._rowsViewEl.scrollTop = me._rowsLockEl.scrollTop;
        //                me._syncScrollOffset(null, me._rowsLockEl.scrollTop);  //@ 2017-11-20 

        //                //me._rowsViewEl.scrollTop = me._rowsLockEl.scrollTop = scrollTop;
        //            }, 50);
        //        }
    },
    //    _syncScrollOffset: function () {
    //        var scrollLeft = this._hscrollEl.scrollLeft;
    //        this._rowsViewEl.scrollLeft = scrollLeft;
    //        this._columnsViewEl.scrollLeft = this._rowsViewEl.scrollLeft;

    //        var me = this;
    //        me._rowsLockEl.scrollTop = me._rowsViewEl.scrollTop;
    //        setTimeout(function () {
    //            if (me.isFrozen()) {
    //                me._rowsViewEl.scrollTop = me._rowsLockEl.scrollTop;
    //            }
    //        }, 60);
    //    },
    //    __OnRowsViewScroll: function (e) {
    //        this._syncScrollOffset();
    //    },
    __OnMouseWheel: function(e) {
        var scrollTop = this.getScrollTop() - e.wheelDelta;
        var top = this.getScrollTop();
        this.setScrollTop(scrollTop);
        if (top != this.getScrollTop()) {
            e.preventDefault();
        }
    }


});
mini.regClass(mini.FrozenGridView, "FrozenGridView");
/*
    1.动态刷新表格
*/

mini.ScrollGridView = function () {
    mini.ScrollGridView.superclass.constructor.apply(this, arguments);
};
mini.extend(mini.ScrollGridView, mini.FrozenGridView, {

    virtualScroll: true,
    virtualRows: 25,

    defaultRowHeight: 51,

    virtualColumns: false,

    ///////////////////////////
    _canDeferSyncScroll: function () {
        return this.isFrozen() && !this.isVirtualScroll();
    },
    setVirtualScroll: function (value) {
        this.virtualScroll = value;
        this.doUpdate();
    },
    getVirtualScroll: function (value) {
        return this.virtualScroll;
    },
    isFitColumns: function () {
        return this.fitColumns && !this.virtualColumns;
    },
    setVirtualColumns: function (value) {
        this.virtualColumns = value;
        //mini.addCls(this.el, 'mini-grid-virtualcolumns');
        this.doUpdate();
    },
    getVirtualColumns: function (value) {
        return this.virtualColumns;
    },

    isFixedRowHeight: function () {
        //return this.fixedRowHeight || this.isVirtualScroll() || this.isFrozen();
        //return this.fixedRowHeight || this.isVirtualScroll() || !this.allowCellWrap;
        //return this.fixedRowHeight || this.isVirtualScroll();
        return this.fixedRowHeight || this.virtualScroll;
    },
    isVirtualScroll: function () {
        if (this.virtualScroll) {
            return this.isAutoHeight() == false && this.isGrouping() == false;
        }
        return false;
    },
    _getScrollView: function () {
        var data = this.getVisibleRows();
        return data;
    },
    _getScrollViewCount: function () {
        return this._getScrollView().length;
    },

    //    _getRowHeight: function (row) {
    //        return this._getScrollRowHeight(0, row);
    //    },

    _getScrollRowHeight: function (index, row) {
        if (row && row._height) {
            var h = parseInt(row._height);
            if (!isNaN(h)) return h;
        }
        return this.defaultRowHeight;

        //        var data = this._getScrollView();
        //        var record = data[index];
        //        if (!record) return 0;
        //        var h = parseInt(record._height);
        //        if (isNaN(parseInt(record._height))) h = this.defaultRowHeight;
        //        return h;
    },
    _getRangeHeight: function (start, end) {

        // return (end - start) * this.defaultRowHeight;

        var height = 0;
        var data = this._getScrollView();
        for (var i = start; i < end; i++) {
            var row = data[i];
            var h = this._getScrollRowHeight(i, row);
            height += h;
        }
        return height;
    },
    _getIndexByScrollTop: function (scrollTop) {

        var count = parseInt(scrollTop / this.defaultRowHeight);
        return count;

//        		var height = 0;
//        		var data = this._getScrollView();
//        		var count = this._getScrollViewCount();
//        		for (var i = 0, l = count; i < l; i++) {
//        			var row = data[i];
//        			var h = this._getScrollRowHeight(i, row);
//        			height += h;
//        			if (height >= scrollTop) return i;
//        		}
//        		return count;
    },
    //	_getRangeHeight: function (start, end) {
    //		var height = 0;
    //		var data = this._getScrollView();
    //		for (var i = start; i < end; i++) {
    //			var row = data[i];
    //			var h = this._getScrollRowHeight(i, row);
    //			height += h;
    //		}
    //		return height;
    //	},
    //	_getIndexByScrollTop: function (scrollTop) {
    //		var height = 0;
    //		var data = this._getScrollView();
    //		var count = this._getScrollViewCount();
    //		for (var i = 0, l = count; i < l; i++) {
    //			var row = data[i];
    //			var h = this._getScrollRowHeight(i, row);
    //			height += h;
    //			if (height >= scrollTop) return i;
    //		}
    //		return count;
    //	},
    __getScrollViewRange: function (start, end) {
        var data = this._getScrollView();
        return data.getRange(start, end);
    },

    _getColumnByScrollLeft: function (scrollLeft) {

        var width = 0;
        var columns = this.getUnFrozenColumns();
        var count = columns.length;
        for (var i = 0, l = count; i < l; i++) {
            var col = columns[i];
            var w = col.pxWidth;
            if (!isNaN(w)) {
                width += w;
            }
            if (width >= scrollLeft) return i;
        }
        return count;
    },
    _getRangeWidth: function (start, end) {

        var width = 0;
        var columns = this.getUnFrozenColumns();
        for (var i = start; i < end; i++) {
            var col = columns[i];
            if (col) {
                var w = col.pxWidth;
                if (!isNaN(w)) {
                    width += w;
                }
            }
        }
        return width;
    },
    _getColumnAllWidth: function () {

        var width = 0;
        var columns = this.getUnFrozenColumns();
        var count = columns.length;
        for (var i = 0, l = count; i < l; i++) {
            var col = columns[i];
            var w = col.pxWidth;
            if (!isNaN(w)) {
                width += w;
            }
        }
        return width;
    },

    _getViewRegion: function () {


        //根据virtualRows，返回严格限制的区域范围：start, end
        var data = this._getScrollView();

        if (this.isVirtualScroll() == false) {
            var region = {
                top: 0,
                bottom: 0,
                rows: data,
                start: 0,
                end: 0
            };
            return region;
        }

        var rowHeight = this.defaultRowHeight;

        var nowRegion = this._getViewNowRegion();

        var scrollTop = this.getScrollTop();
        var bodyHeight = this._vscrollEl.offsetHeight;

        var count = this._getScrollViewCount();

        var start = nowRegion.start, end = nowRegion.end;

        for (var i = 0, l = count; i < l; i += this.virtualRows) {
            var i2 = i + this.virtualRows;
            if (i <= start && start < i2) {
                start = i;
            }
            if (i < end && end <= i2) {
                end = i2;
            }
        }
        if (end > count) end = count;
        if (end == 0) end = this.virtualRows;
        //if (start > end) start = end;

        var top = this._getRangeHeight(0, start);
        var bottom = this._getRangeHeight(end, this._getScrollViewCount());
        var data = this.__getScrollViewRange(start, end); //data.getRange(start, end);

        var region = {
            top: top,
            bottom: bottom,
            rows: data,
            start: start,
            end: end,
            viewStart: start,
            viewEnd: end
            //            viewStart: nowRegion.start,
            //            viewEnd: nowRegion.end
        };
        //document.title = start + ":" + end + " (" + region.viewStart + ":" + region.viewEnd + ")";

        region.viewTop = this._getRangeHeight(0, region.viewStart);
        region.viewBottom = this._getRangeHeight(region.viewEnd, this._getScrollViewCount());


        //virtualColumns
        if (this.virtualColumns) {

            var scrollLeft = this.getScrollLeft();
            var bodyWidth = this._rowsViewEl.offsetWidth;
            region.startColumn = this._getColumnByScrollLeft(scrollLeft);
            region.endColumn = this._getColumnByScrollLeft(scrollLeft + bodyWidth);
            region.columns = this.getUnFrozenColumns().slice(region.startColumn, region.endColumn + 1);

            region.right = this._getColumnAllWidth();
            region.viewLeft = this._getRangeWidth(0, region.startColumn); ;
        } else {
            region.columns = this.getUnFrozenColumns();
        }

        return region;
    },
    _getViewNowRegion: function () {
        //根据当前scrllTop和bodyHeight，获取当前的start~end范围
        var rowHeight = this.defaultRowHeight;
        var scrollTop = this.getScrollTop();
        //var bodyHeight = this._vscrollEl.offsetHeight;
        var bodyHeight = this._rowsViewEl.offsetHeight;

        //@@@
        var startRow = this._getIndexByScrollTop(scrollTop); //parseInt(scrollTop / rowHeight);
        var endRow = this._getIndexByScrollTop(scrollTop + bodyHeight + 30);
        //var endRow = parseInt((scrollTop + bodyHeight) / rowHeight) + 1;

        var count = this._getScrollViewCount();
        if (endRow > count) endRow = count;

        var region = { start: startRow, end: endRow };
        return region;
    },
    _canVirtualUpdate: function () {
        if (!this._viewRegion) return true;
        var region = this._getViewNowRegion();

        if (this._viewRegion.start <= region.start && region.end <= this._viewRegion.end) return false;
        return true;
    },
    ////////////////////////////////////////////////////////////
    //    __OnSourceAdd: function (e) {

    //        mini.ScrollGridView.superclass.__OnSourceAdd.call(this, e);
    //        
    //        this._viewRegion = this._getViewRegion();
    //    },
    __OnColumnsChanged: function (e) {
        var that = this;
        //var scrollLeft = this.getScrollLeft();

        this.columns = this._columnModel.columns;
        this._doUpdateFilterRow();
        this._doUpdateSummaryRow();
        this._doUpdateRenderCallBack();
        if (this.getVisibleRows().length == 0) {
            //this.doUpdateColumns();
            this.doUpdate();
        } else {
            this.deferUpdate();
        }
        if (this.isVirtualScroll()) {
            this.__OnVScroll();

            //that.setScrollLeft(scrollLeft);

        }
        this.fire("columnschanged");
    },
    doLayout: function () {
        if (this.canLayout() == false) return;
        //alert(1);
        mini.ScrollGridView.superclass.doLayout.call(this);
        this._layoutScroll();

        //this._scrollTop = this._vscrollEl.scrollTop;
        if (mini.isNumber(this._scrollTop) && this._vscrollEl.scrollTop != this._scrollTop) {
            //alert(1);
            this._vscrollEl.scrollTop = this._scrollTop;
        }
        //alert(this._scrollTop);
    },
    _createRowsHTML: function (columns, viewIndex, data, top, bottom, rowIndex) {
        var isVirtualScroll = this.isVirtualScroll();
        if (!isVirtualScroll) {
            return mini.ScrollGridView.superclass._createRowsHTML.apply(this, arguments);
        }

        //document.title = new Date().getTime();


        //var region = isVirtualScroll ? this._getViewRegion() : null;  _viewRegion
        var region = isVirtualScroll ? this._viewRegion : null;

        var sb = ['<table class="mini-grid-table" cellspacing="0" cellpadding="0" border="0" >'];
        sb.push(this._createTopRowHTML(columns));
        if (this.isVirtualScroll()) {
            var style = top == 0 ? "display:none;" : "";
            sb.push('<tr class="mini-grid-virtualscroll-top" style="padding:0;border:0;' + style + '"><td colspan="' + columns.length + '" style="height:' + top + 'px;padding:0;border:0;' + style + '"></td></tr>');
        }

        var sss = new Date();


        if (viewIndex == 1 && this.isFrozen() == false || viewIndex == 3 && this.isFrozenRight() == false) {
            //如果非锁定，且绘制锁定区域，则不创建

        } else {

            //alert(columns.length);

            for (var j = 0, k = data.length; j < k; j++) {
                //var rowIndex = startIndex + j;            
                var record = data[j];
                //if (!record) continue;//???????????????????????
                this._createRowHTML(record, rowIndex, columns, viewIndex, sb);
                rowIndex++;
            }
        }

        //if (viewIndex == 2) document.title = "a:" + (new Date() - sss);

        if (this.isVirtualScroll()) {
            sb.push('<tr class="mini-grid-virtualscroll-bottom" style="padding:0;border:0;"><td colspan="' + columns.length + '" style="height:' + bottom + 'px;padding:0;border:0;"></td></tr>');
        }
        sb.push('</table>');



        return sb.join('');
    },
    //更优化：先显示view区域，然后在填补top和bottom部分
    doUpdateRows: function () {

        if (this.isVirtualScroll() == false) {
            mini.ScrollGridView.superclass.doUpdateRows.call(this);
            return;
        }

        var region = this._getViewRegion();

        this._viewRegion = region;  //当创建时刻的region，才是viewRegion

        var columns1 = this.getFrozenColumns();
        var columns3 = this.getFrozenRightColumns();
        var columns2 = region.columns; // this.getUnFrozenColumns();

        var rowIndex = region.viewStart;
        var rowIndexTop = region.start;
        var rowIndexBottom = region.viewEnd;
        if (this._scrollPaging) {
            var index = this.getPageIndex() * this.getPageSize();
            rowIndex -= index;
            rowIndexTop -= index;
            rowIndexBottom -= index;
        }
        //var sss = new Date();
        var lockHtml = this._createRowsHTML(columns1, 1, region.rows, region.viewTop, region.viewBottom, rowIndex);
        var lockRightHtml = this._createRowsHTML(columns3, 3, region.rows, region.viewTop, region.viewBottom, rowIndex);

        
        //var sss = new Date();
        var html = this._createRowsHTML(columns2, 2, region.rows, region.viewTop, region.viewBottom, rowIndex);
        //document.title = new Date() - sss;
        //if (this.getVisibleRows().length > 0) alert(new Date() - sss);

        this._rowsLockContentEl.innerHTML = lockHtml;
        this._rowsRightLockContentEl.innerHTML = lockRightHtml;
        this._rowsViewContentEl.innerHTML = html;

        var table = this._rowsViewContentEl.firstChild;
        if (this.virtualColumns) {

            var html = '<div style="position:absolute;top:0px;left:' + region.right + 'px;width:1px;height:1px;overflow:hidden;"></div>';
            jQuery(html).appendTo(this._rowsViewContentEl);

            table.style.width = "0px";
            table.style.position = "absolute";
            table.style.top = "0px";
            table.style.left = region.viewLeft + "px";
        }

        var scrollTop = this.getScrollTop();
        if (this._rowsViewEl.scrollTop != scrollTop) {
            //this._rowsViewEl.scrollTop = scrollTop;

            this._syncScrollOffset(null, scrollTop);
        }


    },

    ////////////////////////////////////////////////////////////
    _create: function () {
        mini.ScrollGridView.superclass._create.call(this);
        //vscroll
        this._vscrollEl = mini.append(this._rowsEl, '<div class="mini-grid-vscroll"><div class="mini-grid-vscroll-content"></div></div>');
        this._vscrollContentEl = this._vscrollEl.firstChild;
    },
    _initEvents: function () {
        mini.ScrollGridView.superclass._initEvents.call(this);

        var me = this;
        mini.on(this._vscrollEl, "scroll", this.__OnVScroll, this);
        mini._onScrollDownUp(this._vscrollEl, function (e) {
            //document.title = 'down:' +new Date().getTime();
            me._VScrollMouseDown = true;
        }, function (e) {
            //document.title = 'up:' + new Date().getTime();
            me._VScrollMouseDown = false;
        });
    },

    _layoutScroll: function () {

        var isVirtualScroll = this.isVirtualScroll();

        if (isVirtualScroll) {

            var scrollHeight = this.getScrollHeight();

            var outHeight = scrollHeight > this._rowsViewEl.offsetHeight;

            if (isVirtualScroll && outHeight) {
                this._vscrollEl.style.display = 'block';
                this._vscrollContentEl.style.height = scrollHeight + "px";
                this._showVs = true;
            } else {
                this._vscrollEl.style.display = 'none';
                this._showVs = false;
            }

            if (this._rowsViewEl.scrollWidth > this._rowsViewEl.clientWidth + 1) {
                var h = this.getBodyHeight(true);
                if (h < 0) h = 0;
                this._vscrollEl.style.height = h + 'px';
            } else {
                this._vscrollEl.style.height = '100%';
            }

            //alert(scrollHeight);

        } else {

            this._vscrollEl.style.display = "none";
        }

    },
    ////////////////////
    getScrollHeight: function () {
        var data = this.getVisibleRows();
        return this._getRangeHeight(0, data.length);
    },
    setScrollTop: function (value) {
        if (this._showVs) {
            this._vscrollEl.scrollTop = value;
        }
        if (this.isFrozenRight()) {
            this._rowsRightLockEl.scrollTop = value;
        } else {
            this._rowsViewEl.scrollTop = value;
        }
    },
    getScrollTop: function () {
        if (this.isVirtualScroll()) {
            return this._vscrollEl.scrollTop;
        } else {
            return this._rowsViewEl.scrollTop;
        }
    },
    __OnVScroll: function (e) {

        //当滚动条滚动，禁止刷新top/bottom
        //this._stopUpdateTableView();

        var isVirtualScroll = this.isVirtualScroll();
        if (isVirtualScroll) {

            this._scrollTop = this._vscrollEl.scrollTop;

            var me = this;
            setTimeout(function () {
                //me._rowsViewEl.scrollTop = me._scrollTop;
                me._syncScrollOffset(null, me._scrollTop);
                me.__scrollTimer = null;
            }, 8);

            if (this._scrollTopTimer) {
                clearTimeout(this._scrollTopTimer);
            }
            this._scrollTopTimer = setTimeout(function () {
                me._scrollTopTimer = null;

                me._tryUpdateScroll();

                //me._rowsViewEl.scrollTop = me._scrollTop;
                me._syncScrollOffset(null, me._scrollTop);
                //document.title = new Date().getTime();
            }, 150);
        }
    },

    wheelIncrement: 0,

    setWheelIncrement: function (val) {
        this.wheelIncrement = val;
    },
    getWheelIncrement: function () {
        return this.wheelIncrement;
    },

    __OnMouseWheel: function (e) {
        var ev = e.wheelDelta ? e : e.originalEvent;
        var detail = ev.wheelDelta || -ev.detail * 40;

        //document.title = detail;
        if (detail > 0) {
            detail = detail + this.wheelIncrement;
        } else {
            detail = detail - this.wheelIncrement;
        }
        //detail = detail - this.wheelIncrement;

        var scrollTop = this.getScrollTop() - detail;

        var top = this.getScrollTop();
        this.setScrollTop(scrollTop);
        this.isVirtualScroll() && this.isFrozen() && this._syncScroll(); // 虚拟滚动固定列情况下 马上更新下固定列的滚动状态，减少固定列滚动的延迟 modify @2021/09/02 by liub
        if (top != this.getScrollTop() || this.isVirtualScroll()) {
            e.preventDefault();
        }
        //e.preventDefault();
    },
    /////////////////////////////////////////
    _tryUpdateScroll: function () {
        //设置一个布尔值，reload成功后取消
        var doUpdate = this._canVirtualUpdate();
        if (doUpdate) {
            if (this._scrollPaging) {
                var me = this;
                //this._doGetScrollPaging = true;
                this.reload(null, null, function (e) {
                    //me._doGetScrollPaging = false;
                });
            } else {

                var sss = new Date();

                var scrollLeft = this._rowsViewEl.scrollLeft;

                this._doRemoveRowContent();
                this.doUpdateRows();         //30条，55ms                
                this.deferLayout(50);

                //this.doUpdate();
                //                alert(new Date() - sss);
                //document.title = scrollLeft;
                //this._rowsViewEl.scrollLeft = scrollLeft;
                this._syncScrollOffset(scrollLeft);
            }
        } else {
            //this._doUpdateTopBottom();
        }
    },
    //////////////////////////////////////////////////////////////

    //立刻刷新scrollTop
    _updateScrollTop: function (top) {
        this._syncScrollOffset(null, top);
        this._tryUpdateScroll();
    },

    //////////////////////////////////////////////////////////////

    __OnRowViewScroll: function (e) {

        this._syncScroll();

        if (this.virtualColumns) {
            this.doVirtualColumns();
        }
    },

    doVirtualColumns: function () {
        //var scrollLeft = this.getScrollLeft();

        var me = this;
        if (me._virtualColumnTimer) {
            clearTimeout(me._virtualColumnTimer);
            me._virtualColumnTimer = null;
        }
        me._virtualColumnTimer = setTimeout(function () {
            me._virtualColumnTimer = null;

            //debugger

            me._doRemoveRowContent();

            me.doUpdateRows();         //30条，55ms                
            me.deferLayout(50);

        }, 500);

    }



});
mini.regClass(mini.ScrollGridView, "ScrollGridView");

mini._onScrollDownUp = function (el, mousedown, mouseup) {
    function onmousedown(e) {
        if (mini.isFirefox) {
            mini.on(document, 'mouseup', onmouseup);
        } else {
            mini.on(document, 'mousemove', onmousemove);
        }
        mousedown(e);
    }
    function onmousemove(e) {
        //no ff
        mini.un(document, 'mousemove', onmousemove);
        mouseup(e);
    }
    function onmouseup(e) {
        //ff
        mini.un(document, 'mouseup', onmouseup);
        mouseup(e);
    }

    mini.on(el, 'mousedown', onmousedown);
}



mini.mousewheelEditable = false;

//Selection
mini._Grid_Select = function (grid) {

    this.owner = grid, el = grid.el;

    //return;

    //row hover        
    grid.on("rowmousemove", this.__OnRowMouseMove, this);
    mini.on(grid._viewportEl, "mouseout", this.__OnMouseOut, this);
    mini.on(grid._viewportEl, "mousewheel", this.__OnMouseWheel, this);

    mini.on(document, "mousewheel", this.__OnMouseWheel, this);


    //cell select/ cell edit

    grid.on("cellmousedown", this.__OnCellMouseDown, this);

    grid.on("cellclick", this.__OnGridCellClick, this);

    grid.on("celldblclick", this.__OnGridCellClick, this);

    mini.on(grid.el, "keydown", this.__OnGridKeyDown, this);

    jQuery(grid._columnsEl).on("mouseenter", ".mini-grid-headerCell", function (e) {
        jQuery(e.currentTarget).addClass("mini-grid-header-over");
    });
    jQuery(grid._columnsEl).on("mouseleave", ".mini-grid-headerCell", function (e) {
        jQuery(e.currentTarget).removeClass("mini-grid-header-over");
    });
    //    jQuery(grid._columnsEl).hover(function () {
    //        jQuery(this).addClass("");
    //    }, function () {
    //        jQuery(this).removeClass("");
    //    });
}
mini._Grid_Select.prototype = {
    __OnGridKeyDown: function (e) {

        var grid = this.owner;

        var p = mini.findParent(e.target, 'mini-grid-detailRow');
        var inGrid = p ? mini.isAncestor(grid.el, p) : false;

        if (mini.isAncestor(grid._filterEl, e.target)
            || mini.isAncestor(grid._summaryEl, e.target)
            || mini.isAncestor(grid._toolbarEl, e.target)
            || mini.isAncestor(grid._footerEl, e.target)
            || (mini.findParent(e.target, 'mini-grid-detailRow') && inGrid)
            || mini.findParent(e.target, 'mini-grid-rowEdit')
            || mini.findParent(e.target, 'mini-tree-editinput')
            ) {
            return;
        }

        var currentCell = grid.getCurrentCell();

        if (e.shiftKey || e.ctrlKey || e.altKey) {
            return;
        }

        if (e.keyCode == 37 || e.keyCode == 38 || e.keyCode == 39 || e.keyCode == 40) {
            e.preventDefault();
        }
        var columns = grid.getVisibleColumns();

        //////////////////////////////////////
        function getAt(index) {
            return grid.getVisibleRows()[index];
        }
        function indexOf(row) {
            return grid.getVisibleRows().indexOf(row);
        }
        function getCount() {
            return grid.getVisibleRows().length;
        }

        var column = currentCell ? currentCell[1] : null,
            record = currentCell ? currentCell[0] : null;
        if (!currentCell) record = grid.getCurrent();
        var columnIndex = columns.indexOf(column);

        var rowIndex = indexOf(record);
        var count = getCount();

        switch (e.keyCode) {
            case 9:     //tab
                if (grid.allowCellEdit && grid.editOnTabKey) {
                    e.preventDefault();
                    grid._beginEditNextCell(e.shiftKey == false, true);
                    return;
                }
                //                if (column) {
                //                    if (columnIndex > 0) {
                //                        columnIndex += 1;
                //                    }
                //                } else {
                //                    columnIndex = 0;
                //                }
                //                e.preventDefault();
                break;
            case 27:        //esc

                break;
            case 13:     //enter
                if (grid.allowCellEdit && grid.editNextOnEnterKey) {
                    if (column) {
                        if (grid.isEditingCell(currentCell) || !column.editor) {
                            grid._beginEditNextCell(e.shiftKey == false);
                            return;
                        }
                    }
                }
                if (grid.allowCellEdit && currentCell && !column.readOnly && !grid.isReadOnly()) {
                    grid.beginEditCell();
                }
                break;
            case 37:    //left
                if (column) {
                    if (columnIndex > 0) {
                        columnIndex -= 1;
                    }
                } else {
                    columnIndex = 0;
                }
                break;
            case 38:    //top      
                if (record) {
                    if (rowIndex > 0) rowIndex -= 1;
                } else {
                    rowIndex = 0;
                }
                if (rowIndex != 0 && grid.isVirtualScroll()) {
                    /* @ 之前的虚拟滚动不支持超过边界，现在可以
                    if (grid._viewRegion.start > rowIndex) {
                        return;
                        //                        grid._bodyEl.scrollTop -= grid.defaultRowHeight;
                        //                        grid._tryUpdateScroll();
                    }
                    */
                }
                break;
            case 39:    //right
                if (column) {
                    if (columnIndex < columns.length - 1) {
                        columnIndex += 1;
                    }
                } else {
                    columnIndex = 0;
                }
                break;
            case 40:    //bottom                   
                if (record) {
                    if (rowIndex < count - 1) rowIndex += 1;
                } else {
                    rowIndex = 0;
                }
                /* @ 之前的虚拟滚动不支持超过边界，现在可以
                if (grid.isVirtualScroll()) {
                    if (grid._viewRegion.end < rowIndex) {
                        return;
                        grid.setScrollTop(grid.getScrollTop() + grid.defaultRowHeight);
                        //                        setTimeout(function () {
                        //                            grid.scrollIntoView(record, column);
                        //                        }, 100);
                        //grid._bodyEl.scrollTop += grid.defaultRowHeight;
                        //grid._tryUpdateScroll();
                    }
                }*/
                break;
            default:
                return;
                break;
        }

        column = columns[columnIndex];

        record = getAt(rowIndex);
        //current cell
        if (column && record && grid.allowCellSelect) {
            var currentCell = [record, column];
            grid.setCurrentCell(currentCell);
            grid.scrollIntoView(record, column, false);
        }


        //current row
        if (!grid.onlyCheckSelection) {
            if (e.keyCode != 37 && e.keyCode != 39) {       //当左右键不执行选中

                if (record && grid.allowRowSelect) {

                    var ex = { record: record, selected: record, cancel: false, htmlEvent: e };
                    if (record) {
                        grid.fire("beforerowselect", ex);
                        grid.fire("beforeselect", ex);
                    }
                    if (ex.cancel) return;


                    grid.deselectAll();
                    grid.setCurrent(record);
                    if (record) {

                        grid.scrollIntoView(record, null, false);
                        //grid.scrollIntoView(record, null);
                    } 
                }
            }
        }
    },
    __OnMouseWheel: function (e) {
        var grid = this.owner;

        //e.preventDefault();
        e.stopPropagation();

        if (mini.mousewheelEditable) return;

        //        var gridEl = mini.findParent(e.target, 'mini-datagrid');
        //        if (gridEl != grid.el) {
        //            e.preventDefault();
        //            return
        //        }




        var editor = grid._editingControl;
        if (editor && editor.within(e)) return;

        if (grid.allowCellEdit) {
            grid.commitEdit();
        }
    },
    __OnGridCellClick: function (e) {
        var grid = this.owner,
            type = e.type;

        if (grid.allowCellEdit == false) return;
        if (grid.cellEditAction != type) return;

        var record = e.record, column = e.column;

        if (!column.readOnly && !grid.isReadOnly()) {
            if (e.htmlEvent.shiftKey || e.htmlEvent.ctrlKey) {
            } else {
                grid.beginEditCell(record, column);
            }
        }
    },
    __OnCellMouseDown: function (e) {
        //return;
        var me = this;

        if (!me.owner.selectOnRightClick) {
            if (e.htmlEvent.which == 3) return;  //阻止右键选中行
        }

        setTimeout(function () {    //!!必须延迟1秒（不能删除）
            me.__doSelect(e);
        }, 1);
    },
    __OnRowMouseMove: function (e) {
        var grid = this.owner;
        var record = e.record;

        if (!grid.enabled || grid.enableHotTrack == false) return;

        grid.focusRow(record);
    },
    __OnMouseOut: function (e) {
        if (this.owner.allowHotTrackOut) {
            this.owner.focusRow(null);
        }
    },
    __doSelect: function (e) {

        //debugger
        //return;

        var record = e.record, column = e.column;
        var grid = this.owner;
        if (record.enabled === false) return;


        //cell select
        if (grid.allowCellSelect) {
            var cell = [record, column];
            grid.setCurrentCell(cell);
        }

        if (grid.onlyCheckSelection && !column._multiRowSelect) return;

        //row select 

        //        function isOnlyCheckSelection() {
        //            return grid.onlyCheckSelection && !column._multiRowSelect;
        //        }

        if (grid.allowRowSelect) {
            var ex = { record: record, selected: record, cancel: false, htmlEvent: e };


            if (record) {
                if (!grid.isSelected(record)) {
                    grid.fire("beforerowselect", ex);
                    grid.fire("beforeselect", ex);
                }
            }

//            if (record) {
//                grid.fire("beforerowselect", ex);
//                grid.fire("beforeselect", ex);
//            }


            if (ex.cancel) return;

            if (grid.getMultiSelect()) {

                grid.el.onselectstart = function () { };

                if (e.htmlEvent.shiftKey) {
                    grid.el.onselectstart = function () { return false };
                    try {
                        e.htmlEvent.preventDefault();
                    } catch (ex) { }

                    var current = grid.getCurrent();
                    if (current) {

                        grid.deselectAll();
                        grid.selectRange(current, record);
                        grid.setCurrent(current);
                    } else {
                        grid.select(record);
                        grid.setCurrent(record);
                    }

                } else {

                    grid.el.onselectstart = function () { };
                    if (e.htmlEvent.ctrlKey) {
                        grid.el.onselectstart = function () { return false };
                        try {
                            e.htmlEvent.preventDefault();
                        } catch (ex) { }
                    }

                    if (e.column._multiRowSelect === true || e.htmlEvent.ctrlKey || grid.allowUnselect) {
                        if (grid.isSelected(record)) {
                            grid.deselect(record);
                        } else {
                            grid.select(record);
                            grid.setCurrent(record);
                        }
                    } else {
                        if (grid.isSelected(record)) {
                            //                            grid.deselectAll();
                            //                            grid.select(record);
                        } else {
                            grid.deselectAll();
                            grid.select(record);
                            grid.setCurrent(record);
                        }
                    }
                }
            } else {
                //alert(grid.isSelected(record));
                //if (grid.isSelected(record)) return;
                if (!grid.isSelected(record)) {
                    grid.deselectAll();
                    grid.select(record);
                } else {
                    if (e.htmlEvent.ctrlKey || grid.allowUnselect) {
                        grid.deselectAll();
                    }
                }
            }
        }
    }
};


/* RowGroup
-----------------------------------------------------------------------------*/

mini._Grid_RowGroup = function (grid) {
    this.owner = grid, el = grid.el;    
    mini.on(grid._bodyEl, "click", this.__OnClick, this);
}
mini._Grid_RowGroup.prototype = {
    __OnClick: function (e) {
        var grid = this.owner;
        var group = grid._getRowGroupByEvent(e);
        if (group) {

            if (!grid.groupTitleCollapsible && !mini.hasClass(e.target, "mini-grid-group-ecicon")) {
                return;
            }


            var ev = { htmlEvent: e, cancel: false, group: group };
            grid.fire("beforegroupclick", ev);
            if (ev.cancel === true) return;

            grid.toggleRowGroup(group);
        }
    }
};


/* ColumnsMenu
-----------------------------------------------------------------------------*/
mini._Grid_ColumnsMenu = function (grid) {
    this.owner = grid;
    this.menu = this.createMenu();
    mini.on(grid.el, "contextmenu", this.__OnContextMenu, this);    
    grid.on("destroy", this.__OnGridDestroy, this);
}
mini._Grid_ColumnsMenu.prototype = {
    __OnGridDestroy: function (e) {
        if (this.menu) this.menu.destroy();
        this.menu = null;
    },
    createMenu: function () {
        var menu = mini.create({ type: "menu", hideOnClick: false });
        menu.on("itemclick", this.__OnItemClick, this);
        jQuery(menu.el).addClass("mini-menu-open");
        return menu;
    },
    updateMenu: function () {
        var grid = this.owner, menu = this.menu;
        var columns = grid.getBottomColumns();
        var items = [];
        for (var i = 0, l = columns.length; i < l; i++) {
            var column = columns[i];
            if (column.hideable) continue;
            var item = {};
            item.checked = column.visible;
            item.checkOnClick = true;
            item.text = grid._createHeaderText(column);
            if (item.text == "&nbsp;") {
                if (column.type == "indexcolumn") item.text = "序号";
                if (column.type == "checkcolumn") item.text = "选择";
            }
            items.push(item);
            //enabled
            item.enabled = column.enabled;

            item._column = column;
        }
        menu.setItems(items);
    },
    __OnContextMenu: function (e) {
        var grid = this.owner;
        if (grid.showColumnsMenu == false) return;
        if (mini.isAncestor(grid._columnsEl, e.target) == false) return;
        this.updateMenu();
        this.menu.showAtPos(e.pageX, e.pageY);
        return false;
    },
    __OnItemClick: function (e) {
        var grid = this.owner, menu = this.menu;
        var columns = grid.getBottomColumns();
        var items = menu.getItems();
        var item = e.item, column = item._column;

        var checkedCount = 0;
        for (var i = 0, l = items.length; i < l; i++) {
            var it = items[i];
            if (it.getChecked()) checkedCount++;
        }
        if (checkedCount < 1) {
            item.setChecked(true);
        }

        var checked = item.getChecked();
        if (checked) grid.showColumn(column);
        else grid.hideColumn(column);
    }
}


/* _CellToolTip
-----------------------------------------------------------------------------*/

mini._Grid_CellToolTip = function (grid) {
    this.owner = grid;
    mini.on(this.owner.el, "mousemove", this.__OnGridMouseMove, this);
};
mini._Grid_CellToolTip.prototype = {
    __OnGridMouseMove: function (e) {
        var grid = this.owner;

        if (mini.hasClass(e.target, "mini-grid-headerCell-inner")) {
            var cellEl = e.target;

            if (cellEl.scrollWidth > cellEl.clientWidth) {
                var s = cellEl.innerText || cellEl.textContent || "";
                cellEl.title = s.trim();
            } else {
                cellEl.title = "";
            }

            return;
        }

        var cell = grid._getCellByEvent(e);

        var cellEl = grid._getCellEl(cell[0], cell[1]);
        //if (cell.record && cell.column && cell.column.vtype) debugger

        var error = grid.getCellError(cell[0], cell[1]);
        if (cellEl) {
            //if(cellEl.id == '3$cell$2') debugger
            if (error) {
                setTimeout(function () {
                    cellEl.title = error.errorText;
                }, 10);
                return;
            }
            setTimeout(function () {
                var innerEl = cellEl;
                if (cellEl.firstChild) {
                    if (mini.hasClass(cellEl.firstChild, "mini-grid-cell-inner")) {
                        innerEl = cellEl.firstChild;
                    }
                    if (mini.hasClass(cellEl.firstChild, "mini-tree-nodetitle")) {
                        innerEl = cellEl.firstChild;
                    }
                }
                if (innerEl.scrollWidth > innerEl.clientWidth && grid.getShowCellTip() && cell[1].showCellTip) {
                    var s = innerEl.innerText || innerEl.textContent || "";
                    cellEl.title = s.trim();
                } else {
                    cellEl.title = "";
                }
            }, 10);
        }
    }
};


/* Sorter
-----------------------------------------------------------------------------*/

mini._Grid_Sorter = function (grid) {

    this.owner = grid;
    this.owner.on("headercellclick", this.__OnGridHeaderCellClick, this);
    this.owner.on("headercelldblclick", this.__OnGridHeaderCellClick, this);
    //this.owner.on("headercellmousedown", this.__OnGridHeaderCellMouseDown, this);

    mini.on(grid._headerEl, "mousemove", this.__OnGridHeaderMouseMove, this);
    mini.on(grid._headerEl, "mouseout", this.__OnGridHeaderMouseOut, this);
};
mini._Grid_Sorter.prototype = {
    __OnGridHeaderMouseOut: function (e) {
        if (this._focusedColumnEl) {
            mini.removeClass(this._focusedColumnEl, "mini-grid-headerCell-hover");
        }
    },
    __OnGridHeaderMouseMove: function (e) {
        var t = mini.findParent(e.target, "mini-grid-headerCell");
        if (t) {
            mini.addClass(t, "mini-grid-headerCell-hover");
            this._focusedColumnEl = t;
        }
    },
    __OnGridHeaderCellClick: function (e) {
        var grid = this.owner;

        var type = e.htmlEvent.type;
        if (type == 'dblclick' && !grid.sortDblClick) return;
        if (type == 'click' && grid.sortDblClick) return;


        //if (!mini.hasClass(e.htmlEvent.target, "mini-grid-column-splitter")) {
        if (mini.hasClass(e.htmlEvent.target, "mini-grid-headerCell-inner")) {
            if (grid.allowSortColumn && grid.isEditing() == false) {

                var column = e.column;
                if (!column.columns || column.columns.length == 0) {
                    var sortField = column.sortField || column.field;

                    if (sortField && column.allowSort !== false) {

                        if (grid.allowCancelSort && grid.getSortOrder() == "desc") {
                            grid.clearSort();
                        } else {
                            var sortOrder = "asc";
                            if (grid.getSortField() == sortField) {
                                sortOrder = grid.getSortOrder() == "asc" ? "desc" : "asc";
                            }

                            grid.sortBy(sortField, sortOrder);
                        }
                    }
                }
            }
        }
    }
};


/* _ColumnMove
-----------------------------------------------------------------------------*/

mini._Grid_ColumnMove = function (grid) {
    this.owner = grid;
    mini.on(this.owner.el, "mousedown", this.__onGridMouseDown, this);
};
mini._Grid_ColumnMove.prototype = {
    __onGridMouseDown: function (e) {

        var grid = this.owner;
        
        if (grid.isEditing()) return;
        if (mini.hasClass(e.target, "mini-grid-column-splitter")) return;

        if (e.button == mini.MouseButton.Right) return;
        var t = mini.findParent(e.target, grid._headerCellCls);
        if (t) {
            this._remove();
            var column = grid._getColumnByEvent(e);
            if (grid.allowMoveColumn && column && column.allowMove) {
                this.dragColumn = column;
                this._columnEl = t;
                this.getDrag().start(e);
            }
        }
    },
    getDrag: function () {
        if (!this.drag) {
            this.drag = new mini.Drag({
                capture: false,
                onStart: mini.createDelegate(this._OnDragStart, this),
                onMove: mini.createDelegate(this._OnDragMove, this),
                onStop: mini.createDelegate(this._OnDragStop, this)
            });
        }
        return this.drag;
    },
    _OnDragStart: function (drag) {
        function createHeaderCell(column) {
            var header = column.header;
            if (typeof header == "function") header = header.call(grid, column);
            if (mini.isNull(header) || header === "") header = "&nbsp;";
            return header;
        }

        var grid = this.owner;
        this._dragProxy = mini.append(document.body, '<div class="mini-grid-columnproxy"></div>');
        this._dragProxy.innerHTML = '<div class="mini-grid-columnproxy-inner" style="height:26px;">' + createHeaderCell(this.dragColumn) + '</div>';
        mini.setXY(this._dragProxy, drag.now[0] + 15, drag.now[1] + 18);
        mini.addClass(this._dragProxy, "mini-grid-no");

        this.moveTop = mini.append(document.body, '<div class="mini-grid-movetop"></div>');
        this.moveBottom = mini.append(document.body, '<div class="mini-grid-movebottom"></div>');
    },
    _OnDragMove: function (drag) {
        var grid = this.owner;
        var x = drag.now[0];

        mini.setXY(this._dragProxy, x + 15, drag.now[1] + 18);

        this.targetColumn = this.insertAction = null;
        var t = mini.findParent(drag.event.target, grid._headerCellCls);
        if (t) {
            var column = grid._getColumnByEvent(drag.event);
            if (column && column != this.dragColumn) {
                var p1 = grid.getParentColumn(this.dragColumn);
                var p2 = grid.getParentColumn(column);
                if (p1 == p2) {

                    this.targetColumn = column;
                    this.insertAction = "before";
                    var columnBox = grid.getColumnBox(this.targetColumn);

                    if (x > columnBox.x + columnBox.width / 2) {

                        this.insertAction = "after";
                    }
                }
            }
        }

        if (this.targetColumn) {

            mini.addClass(this._dragProxy, "mini-grid-ok");
            mini.removeClass(this._dragProxy, "mini-grid-no");

            var box = grid.getColumnBox(this.targetColumn);

            this.moveTop.style.display = 'block';
            this.moveBottom.style.display = 'block';
            if (this.insertAction == "before") {

                mini.setXY(this.moveTop, box.x - 4, box.y - 9);
                mini.setXY(this.moveBottom, box.x - 4, box.bottom);
            } else {

                mini.setXY(this.moveTop, box.right - 4, box.y - 9);
                mini.setXY(this.moveBottom, box.right - 4, box.bottom);
            }
        } else {
            mini.removeClass(this._dragProxy, "mini-grid-ok");
            mini.addClass(this._dragProxy, "mini-grid-no");

            this.moveTop.style.display = 'none';
            this.moveBottom.style.display = 'none';
        }
    },
    _remove: function () {
        var grid = this.owner;
        mini.removeNode(this._dragProxy);
        mini.removeNode(this.moveTop);
        mini.removeNode(this.moveBottom);
        this._dragProxy = this.moveTop = this.moveBottom = this.dragColumn = this.targetColumn = null;
    },
    _OnDragStop: function (drag) {
        var grid = this.owner;
        
        grid.moveColumn(this.dragColumn, this.targetColumn, this.insertAction);
        this._remove();
    }
};



/* _ColumnSplitter
-----------------------------------------------------------------------------*/

mini._Grid_ColumnSplitter = function (grid) {           //ColumnResizable
    this.owner = grid;    
    mini.on(grid.el, "mousedown", this.__OnMouseDown, this);
};
mini._Grid_ColumnSplitter.prototype = {
    __OnMouseDown: function (e) {
        var grid = this.owner;
        var t = e.target;

        if (mini.hasClass(t, "mini-grid-column-splitter")) {
            var column = grid._getColumnById(t.id);
            if (grid.isEditing()) return;
            if (grid.allowResizeColumn && column && column.allowResize) {
                this.splitterColumn = column;
                this.getDrag().start(e);
            }
        }
    },
    getDrag: function () {
        if (!this.drag) {
            this.drag = new mini.Drag({
                capture: true,
                onStart: mini.createDelegate(this._OnDragStart, this),
                onMove: mini.createDelegate(this._OnDragMove, this),
                onStop: mini.createDelegate(this._OnDragStop, this)
            });
        }
        return this.drag;
    },
    _OnDragStart: function (drag) {
        var grid = this.owner;
        var columnBox = grid.getColumnBox(this.splitterColumn);

        this.columnBox = columnBox;
        this._dragProxy = mini.append(document.body, '<div class="mini-grid-proxy"></div>');
        var box = grid.getGridViewBox();
        box.x = columnBox.x;
        box.width = columnBox.width;
        box.right = columnBox.right;
        mini.setBox(this._dragProxy, box);

        grid._ignoreClick = true;
    },
    _OnDragMove: function (drag) {
        var grid = this.owner;
        var box = mini.copyTo({}, this.columnBox);
        var width = box.width + (drag.now[0] - drag.init[0]);
        if (width < grid.columnMinWidth) width = grid.columnMinWidth;
        if (width > grid.columnMaxWidth) width = grid.columnMaxWidth;

        mini.setWidth(this._dragProxy, width);
    },
    _OnDragStop: function (drag) {
        var grid = this.owner;
        var box = mini.getBox(this._dragProxy);
        var sf = this;
        var allowSort = grid.allowSortColumn;
        grid.allowSortColumn = false;
        setTimeout(function () {
            jQuery(sf._dragProxy).remove();
            sf._dragProxy = null;
            grid.allowSortColumn = allowSort;
        }, 10);

        var column = this.splitterColumn;

        var columnWidth = parseInt(column.width);
        if (columnWidth + "%" != column.width) {
            var width = grid.getColumnWidth(column);
            var w = parseInt(columnWidth / width * box.width);
            if (w < grid.columnMinWidth) w = grid.columnMinWidth;
            grid.setColumnWidth(column, w);
        }

        setTimeout(function () {
            grid._ignoreClick = false;
        }, 100);
    }
};


/* DragDrop
-----------------------------------------------------------------------------*/

/*
控制行/节点的拖拽拖放行为    
Grid 行拖拽事件:
    RowDragStart可以控制是否可拖拽此行
    RowDragDrop 可以控制是否执行默认的投放操作(移动)
    从而改成自己的投放行为(调用Project.MoveTask方法)    
*/
mini._Grid_DragDrop = function (grid) {
    this.owner = grid;
    this.owner.on('CellMouseDown', this.__OnGridCellMouseDown, this);
}
mini._Grid_DragDrop.prototype = {
    __OnGridCellMouseDown: function (e) {

        if (e.htmlEvent.button == mini.MouseButton.Right) return;
        var grid = this.owner;
        if (grid._dragging) return;

        this.dropObj = grid;

        if (mini.findParent(e.htmlEvent.target, 'mini-tree-editinput')) return;

        if (grid.isReadOnly() || grid.isAllowDrag(e.record, e.column) == false) return;
        //alert(grid._getDragData().length);

        var ex = grid._OnDragStart(e.record, e.column);
        if (ex.cancel) return;
        this.dragText = ex.dragText;

        var record = e.record;

        this.isTree = !!grid.isTree;

        this.beginRecord = record;
        //alert(grid._getDragData().length);
        var drag = this._getDrag();
        drag.start(e.htmlEvent);
    },
    _OnDragStart: function (drag) {
        var grid = this.owner;
        grid._dragging = true;

        var record = this.beginRecord;
        this.dragData = grid._getDragData();

        if (this.dragData.indexOf(record) == -1) {
            this.dragData.push(record);
        }
        //grid.select(record);

        this.feedbackEl = mini.append(document.body, '<div class="mini-feedback"></div>');
        this.feedbackEl.innerHTML = this.dragText;
        this.lastFeedbackClass = "";

        this.enableHotTrack = grid.getEnableHotTrack();
        grid.setEnableHotTrack(false);
    },
    _getDropTargetObj: function (event) {
        var dom = mini.findParent(event.target, "mini-grid", 500);
        if (dom) {
            return mini.get(dom);
        }
    },
    _OnDragMove: function (drag) {
        var grid = this.owner;
        var dropObj = this._getDropTargetObj(drag.event);
        this.dropObj = dropObj;

        var x = drag.now[0], y = drag.now[1];
        mini.setXY(this.feedbackEl, x + 15, y + 18);

        if (dropObj && dropObj.allowDrop) {
            this.isTree = dropObj.isTree;

            var targetRecord = dropObj._getRecordByEvent(drag.event);
            this.dropRecord = targetRecord;

            if (targetRecord) {
                if (this.isTree) {
                    this.dragAction = this.getFeedback(targetRecord, y, 3);
                } else {
                    this.dragAction = this.getFeedback(targetRecord, y, 2);
                }
            } else {
                this.dragAction = "no";
            }

        } else {
            this.dragAction = "no";
        }

        //empty
        if (dropObj && dropObj.allowDrop && !targetRecord && dropObj.getData().length == 0) {
            this.dragAction = "add";
        }

        this.lastFeedbackClass = "mini-feedback-" + this.dragAction;
        this.feedbackEl.className = "mini-feedback " + this.lastFeedbackClass;
        if (this.dragAction == "no") targetRecord = null;
        this.setRowFeedback(targetRecord, this.dragAction);
    },
    _OnDragStop: function (drag) {

        var grid = this.owner;
        var dropObj = this.dropObj;

        grid._dragging = false;
        mini.removeNode(this.feedbackEl);


        grid.setEnableHotTrack(this.enableHotTrack);

        this.feedbackEl = null;
        this.setRowFeedback(null);

        //如果是树形数据源, 只能选择一个父节点, 子节点去除掉
        if (this.isTree) {
            var dragRecords = [];
            for (var i = 0, l = this.dragData.length; i < l; i++) {
                var dragRecord = this.dragData[i];
                var hasParent = false;
                for (var j = 0, k = this.dragData.length; j < k; j++) {
                    var dr = this.dragData[j];
                    if (dr != dragRecord) {
                        hasParent = grid.isAncestor(dr, dragRecord);
                        if (hasParent) break;
                    }
                }

                if (!hasParent) {
                    dragRecords.push(dragRecord);
                }
            }
            this.dragData = dragRecords;
        }

        if (this.dragAction == 'add' && !this.dropRecord) {
            this.dropRecord = dropObj.getRootNode ? dropObj.getRootNode() : { __root: true };
        }

        //alert(dragRecords[0].Name + ":" + dragRecords[1].Name);
        if (this.dropRecord && dropObj && this.dragAction != "no") {
            //var e = grid._OnDragDrop(this.dragData, this.dropRecord, this.dragAction);
            var e = dropObj._OnDragDrop(this.dragData, this.dropRecord, this.dragAction);       //beforedrop
            if (!e.cancel) {
                var dragRecords = e.dragNodes, targetRecord = e.targetNode, action = e.action;

                if (dropObj.isTree) {

                
                    
                    if (grid == dropObj) {
                        dropObj.moveNodes(dragRecords, targetRecord, action);
                    } else {
                        if (dropObj.dropAction == "move") {
                            grid.removeNodes(dragRecords);
                        } else if (dropObj.dropAction == "copy") {
                            dragRecords = mini.clone(dragRecords);
                        }
                        dropObj.addNodes(dragRecords, targetRecord, action);
                    }

                } else {
                    var index = dropObj.indexOf(targetRecord);
                    if (action == "after") index += 1;

                    if (grid == dropObj) {
                        dropObj.moveRow(dragRecords, index);
                    } else {
                        
                        if (dropObj.dropAction == "move") {
                            grid.removeRows(dragRecords);
                        } else if (dropObj.dropAction == "copy") {
                            dragRecords = mini.clone(dragRecords);
                        }

                        if (this.dragAction == "add") {
                            dropObj.addRows(dragRecords);
                        } else {
                            dropObj.addRows(dragRecords, index);
                        }
                    }
                }

                var e = {
                    dragNode: e.dragNodes[0],
                    dropNode: e.targetNode,
                    dragAction: e.action,

                    dragNodes: e.dragNodes,
                    targetNode: e.targetNode
                };
                dropObj.fire("drop", e);
            }

        }

        this.dropRecord = null;
        this.dragData = null;
    },
    setRowFeedback: function (record, feedback) {
        //        if (this.lastRowFeedback != -1) {
        //            
        //        }
        var grid = this.owner;
        var dropObj = this.dropObj;

        if (this.lastAddDomRow && dropObj) {
            dropObj.removeRowCls(this.lastAddDomRow, "mini-tree-feedback-add");
        }
        if (record == null || this.dragAction == "add") {
            mini.removeNode(this.feedbackLine);
            this.feedbackLine = null;
        }

        this.lastRowFeedback = record;

        if (record != null) {
            if (feedback == "before" || feedback == "after") {
                if (!this.feedbackLine) {
                    this.feedbackLine = mini.append(document.body, "<div class='mini-feedback-line'></div>");
                }
                this.feedbackLine.style.display = "block";
                var rowBox = dropObj.getRowBox(record);
                var x = rowBox.x, y = rowBox.y - 1;
                if (feedback == "after") {
                    y += rowBox.height;
                }
                mini.setXY(this.feedbackLine, x, y);

                var box = dropObj.getBox(true);
                mini.setWidth(this.feedbackLine, box.width);
            } else {
                dropObj.addRowCls(record, "mini-tree-feedback-add");
                this.lastAddDomRow = record;

                //mini.repaint(grid.el);
            }
        }
    },
    getFeedback: function (dropRecord, y, way) {
        //way : 2, 3
        var grid = this.owner;

        var dropObj = this.dropObj;

        var rowBox = dropObj.getRowBox(dropRecord);
        //var rowPoint = grid.PointToViewport({ X: rowBounds.Left, Y: rowBounds.Top });

        var h = rowBox.height;
        var t = y - rowBox.y;

        var effect = null;

        //如果dropRecord属于dragData之一, 则"no"
        if (this.dragData.indexOf(dropRecord) != -1) return "no";
        var IsLeaf = false;
        if (way == 3) {
            IsLeaf = dropObj.isLeaf(dropRecord);

            //遍历DragRecords, dropRecord不能是其子节点
            for (var i = 0, l = this.dragData.length; i < l; i++) {
                var dragRecord = this.dragData[i];

                var isAncestor = dropObj.isAncestor(dragRecord, dropRecord);
                if (isAncestor) {
                    effect = "no";
                    break;
                }
            }
        }
        if (effect == null) {
            if (way == 2) {
                if (t > h / 2) effect = "after";
                else effect = "before";
            } else {
                if (IsLeaf && dropObj.allowLeafDropIn === false) {
                    if (t > h / 2) effect = "after";
                    else effect = "before";
                } else {
                    if (t > (h / 3) * 2) effect = "after";
                    else if (h / 3 <= t && t <= (h / 3 * 2)) effect = "add";
                    else effect = "before";
                }
            }
        }
        var e = dropObj._OnGiveFeedback(effect, this.dragData, dropRecord, grid);
        return e.effect;
    },
    _getDrag: function () {
        if (!this.drag) {
            this.drag = new mini.Drag({
                //capture: false,
                onStart: mini.createDelegate(this._OnDragStart, this),
                onMove: mini.createDelegate(this._OnDragMove, this),
                onStop: mini.createDelegate(this._OnDragStop, this)
            });
        }
        return this.drag;
    }
};


//Events
mini._Grid_Events = function (grid) {
    this.owner = grid, el = grid.el;

    mini.on(el, 'click', this.__OnClick, this);
    mini.on(el, 'dblclick', this.__OnDblClick, this);

    mini.on(el, 'mousedown', this.__OnMouseDown, this);
    mini.on(el, 'mouseup', this.__OnMouseUp, this);
    mini.on(el, 'mousemove', this.__OnMouseMove, this);
    mini.on(el, 'mouseover', this.__OnMouseOver, this);
    mini.on(el, 'mouseout', this.__OnMouseOut, this);

    mini.on(el, 'keydown', this.__OnKeyDown, this);
    mini.on(el, 'keyup', this.__OnKeyUp, this);

    mini.on(el, 'contextmenu', this.__OnContextMenu, this);

    //rowmouseenter, rowmouseout
    grid.on("rowmousemove", this.__OnRowMouseMove, this);


    mini.on(window, "resize", this.__windowResize, this);
}
mini._Grid_Events.prototype = {

    __windowResize: function () {
        var grid = this.owner;

        function layoutEditor() {
            var editor = grid._getEditingControl();
            if (editor) {
                var currentCell = grid.getCurrentCell();
                var cellBox = grid.getCellBox(currentCell[0], currentCell[1]);
                grid._getEditWrap(cellBox, editor);
                grid._setEditorBox(editor, cellBox); //_setEdiorBox
            }
        }

        //if (grid._editWrap) grid._editWrap.style.left = "-10000px";
        setTimeout(function () {
            layoutEditor();
        }, 100);

    },


    _row: null,
    __OnRowMouseMove: function (e) {
        var grid = this.owner;
        var row = e.record;

        if (this._row != row) {
            //            if (this._row) {
            //                e.record = this._row;
            //                e.row = this._row;
            //                grid.fire("rowmouseleave", e);
            //            }
            e.record = row;
            e.row = row;
            grid.fire("rowmouseenter", e);
        }
        this._row = row;
    },


    __OnClick: function (e) {
        if (this.owner._ignoreClick) return;
        this._fireEvent(e, 'Click');
    },
    __OnDblClick: function (e) {
        this._fireEvent(e, 'Dblclick');
    },
    __OnMouseDown: function (e) {
        var grid = this.owner;
        if (mini.findParent(e.target, 'mini-tree-editinput')) return;
        if (mini.findParent(e.target, "mini-tree-node-ecicon")) return;

        this._fireEvent(e, 'MouseDown');

        //if(e.target.tagName
        var timer = 300;
        if (e.target.tagName.toLowerCase() == "a" && e.target.href) {
            timer = 10;
        }

        function fn() {
            var p = mini.findParent(e.target, 'mini-grid-detailRow');
            if (mini.isAncestor(grid.el, p)) return;
            if (!!grid._editingCell) return;

            grid._tryFocus(e);
        }

        //        if (mini.isChrome) {
        //            fn();
        //        } else {
        setTimeout(function () {
            fn();
        }, timer);
        //}
    },
    __OnMouseUp: function (e) {
        if (mini.findParent(e.target, 'mini-tree-editinput')) return;
        if (mini.findParent(e.target, "mini-tree-node-ecicon")) return;
        if (mini.findParent(e.target, "mini-tree-checkbox")) return;

        var grid = this.owner;
        if (mini.isAncestor(grid.el, e.target)) {
            //            setTimeout(function () {
            //                grid._tryFocus(e);
            //            }, 30);
            //this.owner._tryFocus(e);
            this._fireEvent(e, 'MouseUp');
        }
    },
    __OnMouseMove: function (e) {
        this._fireEvent(e, 'MouseMove');
    },
    __OnMouseOver: function (e) {
        this._fireEvent(e, 'MouseOver');
    },
    __OnMouseOut: function (e) {
        this._fireEvent(e, 'MouseOut');
    },
    __OnKeyDown: function (e) {
        this._fireEvent(e, 'KeyDown');
    },
    __OnKeyUp: function (e) {
        this._fireEvent(e, 'KeyUp');
    },
    __OnContextMenu: function (e) {
        this._fireEvent(e, 'ContextMenu');
    },
    _fireEvent: function (e, name) {
        //if (name == "Dblclick") debugger
        //if (!this.enabled) return;

        //if(name == "Click") debugger

        var grid = this.owner;

        var cell = grid._getCellByEvent(e);
        var record = cell[0], column = cell[1];
        if (record) {
            var eve = {
                record: record,
                row: record,
                htmlEvent: e
            };

            var fn = grid['_OnRow' + name];
            if (fn) {
                fn.call(grid, eve);
            } else {
                grid.fire("row" + name, eve);
            }
        }
        if (column) {
            var eve = {
                column: column,
                field: column.field,
                htmlEvent: e
            };

            var fn = grid['_OnColumn' + name];
            if (fn) {
                fn.call(grid, eve);
            } else {
                grid.fire("column" + name, eve);
            }
        }

        if (record && column) {
            var eve = {
                sender: grid,
                record: record,
                row: record,
                column: column,
                field: column.field,
                htmlEvent: e
            };

            var fn = grid['_OnCell' + name];
            if (fn) {
                fn.call(grid, eve);
            } else {
                //if(name == "Click") debugger
                grid.fire("cell" + name, eve);
            }

            if (column["onCell" + name]) {
                column["onCell" + name].call(column, eve);
            }

        }
        if (!record && column && mini.findParent(e.target, 'mini-grid-headerCell')) {
            var eve = {
                column: column,
                htmlEvent: e
            };
            var fn = grid['_OnHeaderCell' + name];
            if (fn) {
                fn.call(grid, eve);
            } else {

                var evName = "onheadercell" + name.toLowerCase();
                if (column[evName]) {
                    eve.sender = grid;
                    column[evName](eve);
                }

                grid.fire("headercell" + name, eve);
            }
        }
    }
}
﻿/*
描述：DataGrid
功能：
选择模型：
行选择
单元格选择
编辑模型：
单元格编辑
行编辑
分页模型：
服务端分页
top/bottom分页
自定义分页
*/

mini.DataGrid = function (el) {
    mini.DataGrid.superclass.constructor.call(this, null);

    this._Events = new mini._Grid_Events(this);
    this._Select = new mini._Grid_Select(this);
    this._DragDrop = new mini._Grid_DragDrop(this);

    this._RowGroup = new mini._Grid_RowGroup(this);

    this._Splitter = new mini._Grid_ColumnSplitter(this);
    this._ColumnMove = new mini._Grid_ColumnMove(this);
    this._Sorter = new mini._Grid_Sorter(this);
    this._CellToolTip = new mini._Grid_CellToolTip(this);
    this._ColumnsMenu = new mini._Grid_ColumnsMenu(this);

    this._createPagers();

    if (el) mini.applyTo.call(this, el);


//    if (mini.isIE || mini.isIE11) {
//    } else {
//        $(this.el).bind('focus', function (e) {
//            e.preventDefault();
//        });
//    }
};
mini.extend(mini.DataGrid, mini.ScrollGridView, {

    uiCls: "mini-datagrid",

    selectOnLoad: false,

    showHeader: false,
    showPager: true,

    validateOnAdd: false,
    getValidateOnAdd: function () {
        return this.validateOnAdd;
    },
    setValidateOnAdd: function (value) {
        this.validateOnAdd = value;
    },

    dropAction: "move",         //move,copy

    onlyCheckSelection: false,  //只运行checkcolumn选择
    _$onlyCheckSelection: true,
    allowUnselect: false,       //单选时点击能取消选择；多选的时候能直接点击多选
    allowRowSelect: true,
    allowCellSelect: false,
    allowCellEdit: false,
    cellEditAction: "cellclick",
    allowCellValid: false,

    allowResizeColumn: true,
    allowSortColumn: true,
    allowMoveColumn: true,

    showColumnsMenu: false,

    virtualScroll: false,
    enableHotTrack: true,       //启动移动高亮显示行
    allowHotTrackOut: true,   //允许高亮显示行移开消失
    showLoading: true,

    columnMinWidth: 8,

    _expandLoad: function () {
    },

    set: function (kv) {
        if (typeof kv == 'string') {
            return this;
        }

        var value = kv.value;
        delete kv.value;
        var url = kv.url;
        delete kv.url;
        var data = kv.data;
        delete kv.data;
        var columns = kv.columns;
        delete kv.columns;


        var defaultColumnWidth = kv.defaultColumnWidth;
        delete kv.defaultColumnWidth;
        if (defaultColumnWidth) {
            this.setDefaultColumnWidth(defaultColumnWidth);
        }

        if (!mini.isNull(columns)) {
            this.setColumns(columns);
        }

        mini.DataGrid.superclass.set.call(this, kv);

        if (!mini.isNull(data)) {
            this.setData(data);
        }
        if (!mini.isNull(url)) {

            this.setUrl(url);
        }
        if (!mini.isNull(value)) {
            this.setValue(value);
        }

        return this;
    },
    doUpdate: function () {
        //return;

        this._destroyEditors();
        mini.DataGrid.superclass.doUpdate.apply(this, arguments);
    },
    _destroyEditors: function () {
        var controls = mini.getChildControls(this);
        var editors = [];
        for (var i = 0, l = controls.length; i < l; i++) {
            var ui = controls[i];
            if (ui.el && mini.findParent(ui.el, this._rowCls)) {
                editors.push(ui);
                ui.destroy();
            }
        }
        //alert(editors.length);
    },
    /////////////////////////////////////////////////
    _OnDrawCell: function () {
        var e = mini.DataGrid.superclass._OnDrawCell.apply(this, arguments);
        //        var error = this.getCellError(e.record, e.column);
        //        if (error) {
        //            if (!e.cellCls) e.cellCls = "";
        //            e.cellCls += " mini-grid-cell-error ";
        //        }

        return e;
    },
    /////////////////////////////////////////////////
    _bindSource: function () {
        var source = this._dataSource;
        //table
        source.on("beforeload", this.__OnSourceBeforeLoad, this);
        source.on("preload", this.__OnSourcePreLoad, this);
        source.on("load", this.__OnSourceLoadSuccess, this);
        source.on("loaderror", this.__OnSourceLoadError, this);


        source.on("loaddata", this.__OnSourceLoadData, this);
        source.on("cleardata", this.__OnSourceClearData, this);
        source.on("sort", this.__OnSourceSort, this);
        source.on("filter", this.__OnSourceFilter, this);

        source.on("pageinfochanged", this.__OnPageInfoChanged, this);
        source.on("selectionchanged", this.__OnSelectionChanged, this);
        source.on("currentchanged", function (e) {
            this.fire("currentchanged", e);
        }, this);

        //
        source.on("add", this.__OnSourceAdd, this);
        source.on("update", this.__OnSourceUpdate, this);
        source.on("remove", this.__OnSourceRemove, this);
        source.on("move", this.__OnSourceMove, this);

        source.on("beforeadd", function (e) {
            this.fire("beforeaddrow", e);
        }, this);
        source.on("beforeupdate", function (e) {
            this.fire("beforeupdaterow", e);
        }, this);
        source.on("beforeremove", function (e) {
            this.fire("beforeremoverow", e);
        }, this);
        source.on("beforemove", function (e) {
            this.fire("beforemoverow", e);
        }, this);

        //select
        source.on("beforeselect", function (e) {
            this.fire("beforeselect", e);
        }, this);


        source.on("beforedeselect", function (e) {

            this.fire("beforedeselect", e);
        }, this);
        source.on("select", function (e) {
            this.fire("select", e);
        }, this);
        source.on("deselect", function (e) {
            this.fire("deselect", e);
        }, this);
    },
    _getMaskWrapEl: function () {
        return this.el;
    },
    _initData: function () {

        this.data = this._dataSource.getSource();
        this.pageIndex = this.getPageIndex();
        this.pageSize = this.getPageSize();
        this.totalCount = this.getTotalCount();
        this.totalPage = this.getTotalPage();
        this.sortField = this.getSortField();
        this.sortOrder = this.getSortOrder();
        this.url = this.getUrl();

        this._mergedCellMaps = {};
        this._mergedCells = {};

        this._cellErrors = [];
        this._cellMapErrors = {};

        if (this.isGrouping()) {
            this.groupBy(this._groupField, this._groupDir);

            if (this.collapseGroupOnLoad) {

                this.collapseGroups();
            }
        }
    },
    __OnSourceBeforeLoad: function (e) {
        this.fire("beforeload", e);
        if (e.cancel == true) {

            return;
        }
        if (this.showLoading) {
            this.loading();
        }
    },
    __OnSourcePreLoad: function (e) {
        this.fire("preload", e);
    },

    __OnSourceLoadSuccess: function (e) {

        this.fire("load", e);
        this.unmask();
    },
    __OnSourceLoadError: function (e) {
        this.fire("loaderror", e);
        this.unmask();
    },

    __OnSourceSort: function (e) {
        this.deferUpdate();
        this.fire("sort", e);
    },
    __OnSourceFilter: function (e) {
        this.deferUpdate();
        this.fire("filter", e);
    },

    __OnSourceAdd: function (e) {

        this._doAddRowEl(e.record, e.index);
        if(this.viewType === 'cardview') {
            this.updateCardView();
        }

        var me = this;
        if (!me._addTimer) {
            me._addTimer = setTimeout(function () {
                me._addTimer = null;

                me._doUpdateSummaryRow();
                me._viewRegion = me._getViewRegion();
            }, 10);
        }


        this.fire("addrow", e);
    },
    __OnSourceUpdate: function (e) {

        this._doUpdateRowEl(e.record);
        this._doUpdateSummaryRow();

        if(this.viewType === 'cardview') {
            this.updateCardView();
        }
        this.fire("updaterow", e);
    },
    __OnSourceRemove: function (e) {
        var me = this;
        this._doRemoveRowEl(e.record);

        if (!me._toSummary) {
            me._toSummary = setTimeout(function () {
                me._toSummary = null;
                me._doUpdateSummaryRow();
                //alert(1);
            }, 10);
        }
        if(this.viewType === 'cardview') {
            this.updateCardView();
        }

        this.fire("removerow", e);

        if (this.isVirtualScroll()) {
            this.deferUpdate();
        }
    },
    __OnSourceMove: function (e) {
        this._doMoveRowEl(e.record, e.index);
        this._doUpdateSummaryRow();
        this.fire("moverow", e);
    },
    __OnSelectionChanged: function (e) {
        //return

        if (e.fireEvent !== false) {
            if (e.select) {
                this.fire("rowselect", e);
            } else {
                this.fire("rowdeselect", e);
            }
        }

        var me = this;
        if (this._selectionTimer) {
            clearTimeout(this._selectionTimer);
            this._selectionTimer = null;
        }
        this._selectionTimer = setTimeout(function () {
            me._selectionTimer = null;

            if (e.fireEvent !== false) {
                me.fire("SelectionChanged", e);
            }

            me.fire("_selectchange", e);

            //            //滚动第一个
            //            var first = me.getSelected();
            //            if(first) 
        }, 1);
        //alert(e.records.length);
        var sss = new Date();

        this._doRowSelect(e._records, e.select);

        //        if (e.select) {
        //            setTimeout(function () {
        //                alert(new Date() - sss);
        //            }, 1);
        //        }
        //this.fire("_SelectionChanged", e);
    },
    __OnPageInfoChanged: function (e) {
        this._updatePagesInfo();
    },
    _updatePagesInfo: function () {
        var pageIndex = this.getPageIndex();
        var pageSize = this.getPageSize();
        var totalCount = this.getTotalCount();
        var totalPages = this.getTotalPage();

        var pagers = this._pagers;
        for (var i = 0, l = pagers.length; i < l; i++) {
            var pager = pagers[i];
            pager.update(pageIndex, pageSize, totalCount);
            this._dataSource.totalPage = pager.totalPage;
        }
    },
    setPagerButtons: function (value) {
        this._bottomPager.setButtons(value);
    },
    setPager: function (value) {
        if (typeof value == "string") {
            var el = mini.byId(value);
            if (!el) return;
            mini.parse(value);
            value = mini.get(value);
        }
        if (value) {
            this.bindPager(value);
        }
    },
    bindPager: function (pager) {
        if (!pager) return;
        this.unbindPager(pager);
        this._pagers.add(pager);
        pager.on("beforepagechanged", this.__OnPageChanged, this);
    },
    unbindPager: function (pager) {
        if (!pager) return;
        this._pagers.remove(pager);
        pager.un("pagechanged", this.__OnPageChanged, this);
    },
    __OnPageChanged: function (e) {
        e.cancel = true;
        var gridEvent = {
            pageIndex: e.pageIndex,
            pageSize: e.pageSize,
            cancel: false
        };
        this.fire("beforepagechanged", gridEvent);
        if (gridEvent.cancel === true) {
            return;
        }
        this.gotoPage(e.pageIndex, e.pageSize);
        //this._dataSource.gotoPage(e.pageIndex, e.pageSize);
    },
    ///////////////////////////////////////////////
    _canUpdateRowEl: true,
    _doUpdateRowEl: function (row) {

        var columns1 = this.getFrozenColumns();
        var columns2 = this.getUnFrozenColumns();
        var columns3 = this.getFrozenRightColumns();

        var rowEl1, rowEl2, rowEl3;

        var rowIndex = this.indexOf(row);

        var s = this._createRowHTML(row, rowIndex, columns2, 2);
        var rowEl = this._getRowEl(row, 2);
        if (!rowEl) return;


        jQuery(rowEl).before(s);
        rowEl1 = rowEl.previousSibling;
        //mini.before(rowEl, s);
        if (rowEl) rowEl.parentNode.removeChild(rowEl);

        if (this.isFrozen()) {
            var s = this._createRowHTML(row, rowIndex, columns1, 1);
            var rowEl = this._getRowEl(row, 1);
            jQuery(rowEl).before(s);
            rowEl2 = rowEl.previousSibling;
            //rowEl.parentNode.removeChild(rowEl);
            jQuery(rowEl).remove();
        }
        if (this.isFrozenRight()) {
            var s = this._createRowHTML(row, rowIndex, columns3, 3);
            var rowEl = this._getRowEl(row, 3);
            jQuery(rowEl).before(s);
            rowEl3 = rowEl.previousSibling;
            //rowEl.parentNode.removeChild(rowEl);
            jQuery(rowEl).remove();
        }

        this.deferLayout();

        if (rowEl1 && rowEl2 || rowEl1 && rowEl3 || rowEl2 && rowEl3) {
            this._doSyncRowHeight(rowEl1, rowEl2, rowEl3);
            //var row
        }
    },
    _doAddRowEl: function (row, index) {

        var columns1 = this.getFrozenColumns();
        var columns2 = this.getUnFrozenColumns();
        var columns3 = this.getFrozenRightColumns();

        var bdTable1 = this._rowsLockContentEl.firstChild;
        var bdTable2 = this._rowsViewContentEl.firstChild;
        var bdTable3 = this._rowsRightLockContentEl.firstChild;

        //var rowIndex = this.indexOf(row);
        var rowIndex = mini.isNumber(index) ? index : this.indexOf(row);
        var insertRow = this.getAt(rowIndex + 1);

        function doAdd(row, viewIndex, columns, bdTable) {
            var s = this._createRowHTML(row, rowIndex, columns, viewIndex);
            if (insertRow) {
                var inertRowEl = this._getRowEl(insertRow, viewIndex);
                jQuery(inertRowEl).before(s);
            } else {
                mini.append(bdTable, s);
            }
        }

        doAdd.call(this, row, 2, columns2, bdTable2);
        if (this.isFrozen()) {
            doAdd.call(this, row, 1, columns1, bdTable1);
        }
        if (this.isFrozenRight()) {
            doAdd.call(this, row, 3, columns3, bdTable3);
        }

        this.deferLayout();

        if (this.showEmptyText) {
            var el = jQuery(".mini-grid-emptyText", this._bodyEl)[0];
            if (el) {
                //mini.removeNode(el.parentNode);           
                el.style.display = "none";
                el.parentNode.style.display = "none";
            }
        }
    },
    _doRemoveRowEl: function (row) {
        var rowEl = this._getRowEl(row, 1);
        var rowEl2 = this._getRowEl(row, 2);
        var rowEl3 = this._getRowEl(row, 3);
        if (rowEl) rowEl.parentNode.removeChild(rowEl);
        if (rowEl2) rowEl2.parentNode.removeChild(rowEl2);
        if (rowEl3) rowEl3.parentNode.removeChild(rowEl3);
        if (!rowEl2) return;

        //详细行
        var tr = this._getRowDetailEl(row, 1);
        var tr2 = this._getRowDetailEl(row, 2);
        var tr3 = this._getRowDetailEl(row, 3);
        if (tr) tr.parentNode.removeChild(tr);
        if (tr2) tr2.parentNode.removeChild(tr2);
        if (tr3) tr3.parentNode.removeChild(tr3);

        this.deferLayout();

        if (this.showEmptyText && this.getVisibleRows().length == 0) {
            var el = jQuery(".mini-grid-emptyText", this._bodyEl)[0];
            if (el) {
                //mini.removeNode(el.parentNode);           
                el.style.display = "";
                el.parentNode.style.display = "";
            }
        }
    },
    _doMoveRowEl: function (row, index) {
        this._doRemoveRowEl(row);
        this._doAddRowEl(row);
    },
    ///////////////////////////////////////////////
    _getRowGroupEl: function (group, index) {
        if (index == 1 && !this.isFrozen()) return null;
        var id = this._createRowGroupId(group, index);
        var el = mini.byId(id, this.el);   //是否优化此方法？
        return el;
    },
    _getRowGroupRowsEl: function (group, index) {
        if (index == 1 && !this.isFrozen()) return null;
        var id = this._createRowGroupRowsId(group, index);
        var el = mini.byId(id, this.el);   //是否优化此方法？
        return el;
    },
    _getRowEl: function (row, index) {
        if (index == null) index = 2;
        if (index == 1 && !this.isFrozen()) return null;
        row = this.getRecord(row);
        var id = this._createRowId(row, index);
        var el = mini.byId(id, this.el);   //是否优化此方法？
        return el;
    },
    _getHeaderCellEl: function (column, index) {
        if (index == null) index = 2;
        if (index == 1 && !this.isFrozen()) return null;
        column = this.getColumn(column);
        var id = this._createHeaderCellId(column, index);
        var el = mini.byId(id, this.el);
        return el;
    },

    getRowEl: function (row, index) {
        return this._getRowEl(row, index);
    },

    getHeaderCellEl: function (column, index) {
        return this._getHeaderCellEl(column, index);
    },

    _getCellEl: function (row, column) {
        row = this.getRecord(row);
        column = this.getColumn(column);
        if (!row || !column) return null;
        var id = this._createCellId(row, column);
        var el = mini.byId(id, this.el);
        return el;
    },
    getCellEl: function (row, column) {
        return this._getCellEl(row, column);
    },
    getRecordByEvent: function (e) {
        return this._getRecordByEvent(e);
    },
    _getRecordByEvent: function (e) {
        var t = mini.findParent(e.target, this._rowCls);
        if (!t) return null;
        var ids = t.id.split("$");
        var uid = ids[ids.length - 1];
        return this._getRowByID(uid);
    },
    getColumnByEvent: function (e) {
        if (!e) return null;
        return this._getColumnByEvent(e);
    },

    _getColumnByEvent: function (e) {
        var t = mini.findParent(e.target, this._cellCls);
        if (!t) t = mini.findParent(e.target, this._headerCellCls);
        if (t) {
            var ids = t.id.split("$");
            var id = ids[ids.length - 1];
            return this._getColumnById(id);
        }
        return null;
    },
    _getCellByEvent: function (e) {
        var record = this._getRecordByEvent(e);
        var column = this._getColumnByEvent(e);
        return [record, column];
    },

    getColumnFromEvent: function (e) {
        if (!e) return null;
        return this._getColumnByEvent(e);
    },
    getCellFromEvent: function (e) {
        return this._getCellByEvent(e);
    },
    getRowFromEvent: function (e) {
        var cell = this._getCellByEvent(e);
        return cell ? cell[0] : null;
    },

    getRowByEvent: function (e) {
        return this.getRowFromEvent(e);
    },
    getColumnByEvent: function (e) {
        return this.getColumnFromEvent(e);
    },
    getCellByEvent: function (e) {
        return this.getCellFromEvent(e);
    },

    _getRowByID: function (id) {
        return this._dataSource.getby_id(id);
    },
    _getColumnById: function (id) {
        return this._columnModel._getColumnById(id);
    },

    //    getRowCls: function (row) {
    //        return row ? this._rowClsHash[row._id] : null;
    //    },

    hasRowCls: function (row, cls) {

        var sb = this._rowClsHash[row._id];
        if (sb) return sb.indexOf(cls) != -1;
        return false;
    },

    addRowCls: function (row, cls, _marked) {

        var d1 = this._getRowEl(row, 1);
        var d2 = this._getRowEl(row, 2);
        var d3 = this._getRowEl(row, 3);
        if (d1) mini.addClass(d1, cls);
        if (d2) mini.addClass(d2, cls);
        if (d3) mini.addClass(d3, cls);

        if (row && _marked !== false) {
            var sb = this._rowClsHash[row._id];
            if (!sb) sb = this._rowClsHash[row._id] = [];
            else sb.remove(cls);
            sb.push(cls);
        }

    },
    removeRowCls: function (row, cls) {
        var d1 = this._getRowEl(row, 1);
        var d2 = this._getRowEl(row, 2);
        var d3 = this._getRowEl(row, 3);
        if (d1) mini.removeClass(d1, cls);
        if (d2) mini.removeClass(d2, cls);
        if (d3) mini.removeClass(d3, cls);

        if (row) {
            var sb = this._rowClsHash[row._id];
            if (sb) {
                sb.remove(cls);
                if (sb.length == 0) delete this._rowClsHash[row._id];
            }
        }
    },
    getCellBox: function (row, column) {
        row = this.getRow(row);
        column = this.getColumn(column);
        if (!row || !column) return null;
        var cellEl = this._getCellEl(row, column);
        if (!cellEl) return null;
        return mini.getBox(cellEl);
    },
    getColumnBox: function (column) {
        var id = this._createHeaderCellId(column, 2);
        var el = document.getElementById(id);
        if (!el) {
            id = this._createHeaderCellId(column, 1);
            el = document.getElementById(id);
        }
        if (el) {
            //if (el.style.display == "none") return null;
            var box = mini.getBox(el);
            box.x -= 1;
            box.left = box.x;
            box.right = box.x + box.width;
            return box;
        }
    },
    getRowBox: function (row) {
        var rowEl = this._getRowEl(row, 1);
        var rowEl2 = this._getRowEl(row, 2);
        if (!rowEl2) return null;
        var box = mini.getBox(rowEl2);
        if (rowEl) {
            var box1 = mini.getBox(rowEl);
            box.x = box.left = box1.left;
            box.width = box.right - box.x;
        }
        return box;
    },
    ///////////////////

    //    _isRenderedRow: function (record) {
    //        
    //    },

    _doRowSelect: function (rows, select) {

        var virtual = this.isVirtualScroll(),
            region = this._viewRegion,
            start = virtual ? region.start : -1,
            end = virtual ? region.end : -1,
            map = {};
        if (start != -1) {
            var data = this.getVisibleRows();
            for (var i = start, l = end; i < l; i++) {
                var row = data[i];
                if (row) map[row._id] = true;
            }
        }

        var sss = new Date();
        for (var i = 0, l = rows.length; i < l; i++) {
            var record = rows[i];

            //continue;
            if (start != -1) {
                if (!map[record._id]) {

                    continue;
                }
            }

            if (select) {
                this.addRowCls(record, this._rowSelectedCls, false);
            } else {
                this.removeRowCls(record, this._rowSelectedCls);
            }
        }
    },
    _tryFocus: function (e) {

        try {
            var tagName = e.target.tagName.toLowerCase();
            if (tagName == "input" || tagName == "textarea" || tagName == "select") return;
            if (mini.hasClass(e.target, 'mini-placeholder-label')) return;

            if (mini.findParent(e.target, 'mini-grid-rows-content')) {

                mini.setXY(this._focusEl, e.pageX, e.pageY);

                this.focus(false);
            }
            //            if (mini.isAncestor(this._filterEl, e.target)
            //            || mini.isAncestor(this._summaryEl, e.target)
            //            || mini.isAncestor(this._footerEl, e.target)
            //            || mini.findParent(e.target, "mini-grid-rowEdit")
            //            || mini.findParent(e.target, "mini-grid-detailRow")
            //            ) {

            //            } else {
            //                var me = this;

            //                //setTimeout(function () {
            //                me.focus();
            //                //}, 100);
            //            }
        } catch (ex) { }
    },
    //    focus: function () {
    //        var that = this;
    //        try {
    //            that.el.focus();

    //            if (mini.isIE) {
    //                var cell = this.getCurrentCell();
    //                if (cell) {
    //                    var el = this._getCellEl(cell[0], cell[1]);
    //                    el.focus();
    //                    var box = this.getCellBox(cell[0], cell[1]);
    //                    mini.setX(this._focusEl, box.x);
    //                }
    //            }

    //        } catch (e) { }
    //    },
    focus: function (_fixFocus) {


        //alert(1);
        try {
            var that = this;
            var cell = this.getCurrentCell();
            if (cell && _fixFocus !== false) {
                var box = this.getCellBox(cell[0], cell[1]);
                mini.setX(this._focusEl, box.x);
            }

            var row = this.getCurrent();
            if (row) {

                var rowEl = this._getRowEl(row, 2);
                if (rowEl) {
                    if (_fixFocus !== false) {
                        var rowBox = mini.getBox(rowEl);
                        mini.setY(that._focusEl, rowBox.top);
                    }
                    if (mini.isIE || mini.isIE11 || mini.isChrome) {
                        if (mini.isChrome) {
                            //that._focusEl.focus();
                            that.el.focus();          //chrome60可能需要修改下。
                            //rowEl.focus();
                        } else {
                            that._focusEl.focus();
                        }
                        //that.el.focus();
                    } else {
                        that.el.focus();
                    }
                }
            } else {
                if (mini.isIE || mini.isIE11 || mini.isChrome) {

                    that._focusEl.focus();
                    //that.el.focus();
                } else {
                    that.el.focus();

                    //that._focusEl.focus();
                }
            }

        } catch (e) { }
    },
    focusRow: function (row) {
        if (this._focusRow == row) return;
        if (this._focusRow) {
            this.removeRowCls(this._focusRow, this._rowHoverCls);
        }
        this._focusRow = row;
        if (row) this.addRowCls(row, this._rowHoverCls, false);

        if (mini.isIE6) mini.repaint();
    },
    scrollIntoView: function (row, column, virtualScroll) {
        row = this.getRow(row);
        if (!row) return;

        var virtualScroll = this.isVirtualScroll()

        try {

            if (column) {

                if (this._columnModel.isFrozenColumn(column) || this._columnModel.isFrozenRightColumn(column)) {
                    column = null;
                }
            }

            if (column) {
                var cellEl = this._getCellEl(row, column);
                mini.scrollIntoView(cellEl, this._rowsViewEl, true, virtualScroll != true);

                this._syncScroll();
            }


            if (this.isVirtualScroll()) {       //@ 虚拟滚动时不处理滚动条偏移调整

                virtualScroll = true;

                var scrollTop = this.getScrollTop(),
                        offsetHeight = this._vscrollEl.offsetHeight;

                //alert(scrollTop);

                //@ 虚拟滚动新方案
                var region = this._getViewRegion();
                var visibleRows = this.getVisibleRows();
                var index = visibleRows.indexOf(row)
                var offset = this._getRangeHeight(0, index),
                        rowHeight = row._height || this.defaultRowHeight,
                        offsetBottom = offset + rowHeight;

                if (offset < scrollTop) {
                    //alert("up");
                    //this._updateScrollTop(offset);

                    //if(index == 49 || index == 50) debugger

                    this.setScrollTop(offset);
                    this._updateScrollTop(offset);      //@立刻更新
                    //document.title = offset;
                } else if (offsetBottom > scrollTop + offsetHeight) {
                    //alert("down");

                    //offsetBottom  - x = scrollTop + offsetHeight + x;

                    offset = scrollTop + offsetBottom - (scrollTop + offsetHeight)

                    this.setScrollTop(offset);
                    this._updateScrollTop(offset);      //@立刻更新
                }


                //this.setScrollTop(offset);

                //                    debugger
                //                    alert(offset);

                //@旧方案先暂搁置
                //                    if (virtualScroll != false) {
                //                        
                //                        var region = this._getViewRegion();
                //                        //var index = this.indexOf(row);

                //                        var visibleRows = this.getVisibleRows();
                //                        var index = visibleRows.indexOf(row)

                //                        //                    if (region.start <= index && index <= region.end) {
                //                        //                    } else {

                //                        var offset = this._getRangeHeight(0, index);
                //                        //判断下间距，决定是否偏移

                //                        this.setScrollTop(offset);

                //                    }
            } else {
                var rowEl = this._getRowEl(row, 2);
                mini.scrollIntoView(rowEl, this._rowsViewEl, false);

                this._syncScroll();
            }

        } catch (e) { }
    },
    /////////////////////////////////////////////////////////////

    setShowLoading: function (value) {
        this.showLoading = value;
    },
    getShowLoading: function () {
        return this.showLoading;
    },
    setEnableHotTrack: function (value) {
        this.enableHotTrack = value;
    },
    getEnableHotTrack: function () {
        return this.enableHotTrack;
    },
    setAllowHotTrackOut: function (value) {
        this.allowHotTrackOut = value;
    },
    getAllowHotTrackOut: function () {
        return this.allowHotTrackOut;
    },

    setOnlyCheckSelection: function (value) {
        this.onlyCheckSelection = value;
    },
    getOnlyCheckSelection: function () {
        return this.onlyCheckSelection;
    },
    setAllowUnselect: function (value) {
        this.allowUnselect = value;
    },
    getAllowUnselect: function () {
        return this.allowUnselect;
    },
    setAllowRowSelect: function (value) {
        this.allowRowSelect = value;
    },
    getAllowRowSelect: function () {
        return this.allowRowSelect;
    },
    setAllowCellSelect: function (value) {
        this.allowCellSelect = value;
    },
    getAllowCellSelect: function () {
        return this.allowCellSelect;
    },
    setAllowCellEdit: function (value) {
        this.allowCellEdit = value;
    },
    getAllowCellEdit: function () {
        return this.allowCellEdit;
    },
    setCellEditAction: function (value) {
        this.cellEditAction = value;
    },
    getCellEditAction: function () {
        return this.cellEditAction;
    },
    setAllowCellValid: function (value) {
        this.allowCellValid = value;
    },
    getAllowCellValid: function () {
        return this.allowCellValid;
    },
    setAllowResizeColumn: function (value) {
        this.allowResizeColumn = value;
        mini.removeClass(this.el, "mini-grid-resizeColumns-no");
        if (!value) {
            mini.addClass(this.el, "mini-grid-resizeColumns-no");
        }
    },
    getAllowResizeColumn: function () {
        return this.allowResizeColumn;
    },
    setAllowSortColumn: function (value) {
        this.allowSortColumn = value;
    },
    getAllowSortColumn: function () {
        return this.allowSortColumn;
    },
    setAllowMoveColumn: function (value) {
        this.allowMoveColumn = value;
    },
    getAllowMoveColumn: function () {
        return this.allowMoveColumn;
    },
    setShowColumnsMenu: function (value) {
        this.showColumnsMenu = value;
    },
    getShowColumnsMenu: function () {
        return this.showColumnsMenu;
    },

    setEditNextRowCell: function (value) {
        this.editNextRowCell = value;
    },
    getEditNextRowCell: function () {
        return this.editNextRowCell;
    },
    setEditNextOnEnterKey: function (value) {
        this.editNextOnEnterKey = value;
    },
    getEditNextOnEnterKey: function () {
        return this.editNextOnEnterKey;
    },
    setEditOnTabKey: function (value) {
        this.editOnTabKey = value;
    },
    getEditOnTabKey: function () {
        return this.editOnTabKey;
    },
    setCreateOnEnter: function (value) {
        this.createOnEnter = value;
    },
    getCreateOnEnter: function () {
        return this.createOnEnter;
    },
    //////////////////////////////////////////////////////////////////////////////////////////
    // CellSelect
    //////////////////////////////////////////////////////////////////////////////////////////
    _currentCell: null,
    _doCurrentCell: function (select) {
        if (this._currentCell) {
            var record = this._currentCell[0], column = this._currentCell[1];
            var cellEl = this._getCellEl(record, column);
            if (cellEl) {
                if (select) {
                    mini.addClass(cellEl, this._cellSelectedCls);
                } else {
                    mini.removeClass(cellEl, this._cellSelectedCls);
                }
            }
        }
    },
    setCurrentCell: function (cell) {



        if (this._currentCell != cell) {
            this._doCurrentCell(false);
            this._currentCell = cell;

            if (cell) {
                var row = this.getRow(cell[0]);
                var column = this.getColumn(cell[1]);
                if (row && column) {
                    this._currentCell = [row, column];
                } else {
                    this._currentCell = null;
                }
            }

            this._doCurrentCell(true);
            if (cell) {
                //不能是合并单元格
                var ac = this._getAnchorCell(cell[0], cell[1]);
                if (!ac) {


                    if (this.isFrozen() || this.isFrozenRight()) {
                        //if (!this.virtualScroll) {
                        this.scrollIntoView(cell[0], null, false);
                        //}
                    } else {
                        //this.scrollIntoView(cell[0]);
                        this.scrollIntoView(cell[0], cell[1], false);
                    }

                }
            }
            this.fire("currentcellchanged");
            //this._blurRow();
        }
    },
    getCurrentCell: function () {
        var cc = this._currentCell;
        if (cc) {
            if (this.indexOf(cc[0]) == -1) {
                this._currentCell = null;
                cc = null;
            }
        }
        return cc;
    },
    //////////////////////////////////////////////////////////////////////////////////////////
    // CellEdit
    //////////////////////////////////////////////////////////////////////////////////////////
    _editingCell: null,
    isEditingCell: function (cell) {
        return this._editingCell && this._editingCell[0] == cell[0] && this._editingCell[1] == cell[1];
    },
    //    isCellCanEdit: function(row, column){
    //    },
    beginEditCell: function (row, column) {

        function beginEdit(row, column) {

            var sss = new Date();

            row = this.getRow(row);
            column = this.getColumn(column);
            var cell = [row, column];
            if (row && column) {
                this.setCurrentCell(cell);
            }

            var cell = this.getCurrentCell();
            if (this._editingCell && cell) {
                if (this._editingCell[0] == cell[0] && this._editingCell[1] == cell[1]) return;
            }

            if (this._editingCell) this.commitEdit();



            if (cell) {
                var row = cell[0], column = cell[1];
                if (column.editMode != "inline") {
                    var canEdit = this._OnCellBeginEdit(row, column, this.getCellEditor(column));

                    //document.title = new Date() - sss;

                    if (canEdit !== false) {
                        this.scrollIntoView(row, column, false);
                        this._editingCell = cell;
                        this._OnCellShowingEdit(row, column);
                    }
                }
            }


        }
        this._pushUpdateCallback(beginEdit, this, [row, column]);
    },
    cancelEdit: function () {

        if (this.allowCellEdit) {
            if (this._editingCell) {
                this._OnCellEndEdit();
            }
        } else {
            if (this.isEditing()) {
                this._allowLayout = false;
                var data = this.getDataView();
                for (var i = 0, l = data.length; i < l; i++) {
                    var row = data[i];
                    if (row._editing == true) this.cancelEditRow(i);
                }
                this._allowLayout = true;
                this.doLayout();
            }
        }
    },
    commitEdit: function () {

        if (this.allowCellEdit) {

            if (this._editingCell) {
                this._OnCellCommitEdit(this._editingCell[0], this._editingCell[1]);

                this._OnCellEndEdit();
            }
        } else {

            if (this.isEditing()) {
                this._allowLayout = false;
                var data = this.getDataView();
                for (var i = 0, l = data.length; i < l; i++) {
                    var row = data[i];
                    if (row._editing == true) this.commitEditRow(row);
                }
                this._allowLayout = true;

                this.doLayout();
            }
        }
    },

    getCellEditor: function (column, row) {

        column = this.getColumn(column);
        if (!column) return;
        if (this.allowCellEdit) {

            var editor = column.__editor;

            if (!editor) {
                if (!column.editor && column.editorEl) {
                    var editorEl = column.editorEl;
                    var className = editorEl.className;
                    var classes = className.split(' ');
                    classes.some(function(cls) {
                        var clazz = mini.getClassByUICls(cls);
                        if (!clazz) return;

                        var ui = new clazz();
                        editor = ui.getAttrs(editorEl);
                        editor.type = ui.type;
                        column.editor = editor;
                        return true;
                    });
                    delete column.editorEl;
                }
                editor = mini.getAndCreate(column.editor);
            }
            if (editor) {
                // 添加通过配置 action 设置 url 的支持
                if(editor.setUrl 
                    && window.epoint && window.epoint.getCache 
                    && window.Util && window.Util.getRightUrl 
                    && window.DtoUtils && window.DtoUtils.bindBeforeLoad
                    && !editor.url && editor.action) {
                    var index = editor.action.indexOf('.'),
                        pageAction = index > -1 ? editor.action.substring(0, index) : epoint.getCache('action'),
                        controlAction = editor.action.substring(index + 1);

                    if(pageAction) {
                        DtoUtils.bindBeforeLoad(editor.el);
                        editor.setUrl(Util.addUrlParams(Util.getRightUrl('rest/' + pageAction + '/' + controlAction), Util.getUrlParams()));
                    }
                }
                column.editor = editor;
                column.__editor = editor;
            }
            return editor;
        } else {
            row = this.getRow(row);
            column = this.getColumn(column);
            if (!row) row = this.getEditingRow();
            if (!row || !column) return null;
            var id = this.uid + "$" + row._uid + "$" + column._id + "$editor";
            return mini.get(id);
        }
    },

    _OnCellBeginEdit: function (record, column, editor, initEditor) {

        var value = mini._getMap(column.field, record);
        var e = {
            sender: this,
            rowIndex: this.indexOf(record),
            row: record,
            record: record,
            column: column,
            field: column.field,
            editor: editor,
            value: value,
            cancel: false
        };

        this.fire("cellbeginedit", e);

        if (!mini.isNull(column.defaultValue) && (mini.isNull(e.value) || e.value === "")) {
            var defaultValue = column.defaultValue;
            //            try {
            //                
            //                defaultValue = eval('('+defaultValue+')');
            //            } catch (ex) { debugger}
            var obj = mini.clone({ d: defaultValue });
            e.value = obj.d;
        }

        var editor = e.editor;
        value = e.value;

        if (e.cancel) {
            return false;
        }
        //if (!editor) return false;
        //column.editor = editor;   //!!!不能加

        if (!editor && column.editMode != "inline") return false;
        if (column.readOnly === true) return false;

        if (initEditor === false) return true;

        //        if (column.editMode != "inline") {
        //                    var canEdit = this.isCellCanEdit(row, column);

        if (column.editMode != "inline") {
            //value, text初始化
            if (mini.isNull(value)) value = "";
            if (editor.setValue) {
                editor.setValue(value);
            }
            editor.ownerRowID = record._uid;

            if (column.displayField && editor.setText) {
                //var text = record[column.displayField];
                var text = mini._getMap(column.displayField, record);

                if (!mini.isNull(column.defaultText) && (mini.isNull(text) || text === "")) {
                    var obj = mini.clone({ d: column.defaultText });
                    text = obj.d;
                }

                editor.setText(text);
            }

            if (this.allowCellEdit) {
                this._editingControl = e.editor;
            }

        }

        return true;
    },
    _OnCellCommitEdit: function (record, column, value, editor) {

        var e = {
            sender: this,
            rowIndex: this.indexOf(record),
            record: record,
            row: record,
            column: column,
            field: column.field,
            editor: editor ? editor : this.getCellEditor(column),
            value: mini.isNull(value) ? "" : value,
            text: "",
            cancel: false
        };

        if (e.editor && e.editor.getValue) {
            try {
                e.editor.blur();
            } catch (ex) {

            }
            e.value = e.editor.getValue();

            //alert(e.value);
        }
        if (e.editor && e.editor.getText) {
            e.text = e.editor.getText();
        }

        //document.title = e.value + ":" + e.text + ":" + new Date().getTime();

        //        this.updateRow(record, { NodeId: 1, NodeName: "aaa" });
        //        return;

        var oldValue = mini._getMap(column.field, record), newValue = e.value;
        e.oldValue = oldValue;
        if (mini.isEquals(oldValue, newValue)) return e;

        this.fire("cellcommitedit", e);

        if (e.cancel == false) {

            if (this.allowCellEdit) {
                var o = {};
                o[column.field] = e.value;
                //mini._setMap(column.field, e.value, o);
                if (column.displayField) {
                    o[column.displayField] = e.text;
                    //mini._setMap(column.displayField, e.text, o);
                }
                this.updateRow(record, o);
            }
        }
        return e;
    },
    _OnCellEndEdit: function (record, column) {
        if (!this._editingCell && !record) return;
        if (!record) record = this._editingCell[0];
        if (!column) column = this._editingCell[1];
        var value = mini._getMap(column.field, record);
        var e = {
            sender: this,
            rowIndex: this.indexOf(record),
            record: record,
            row: record,
            column: column,
            field: column.field,
            editor: this._editingControl,
            //value: record[column.field]
            value: value
        };

        this.fire("cellendedit", e);
        //return;
        if (this.allowCellEdit && e.editor) {
            var editor = e.editor;
            if (editor && editor.setIsValid) {

                editor.setIsValid(true);
            }

            if (this._editWrap) this._editWrap.style.display = 'none';
            var childNodes = this._editWrap.childNodes;
            for (var i = childNodes.length - 1; i >= 0; i--) {
                var el = childNodes[i];
                this._editWrap.removeChild(el);
            }


            if (editor && editor.hidePopup) {
                editor.hidePopup();
            }
            if (editor && editor.setValue) {
                editor.setValue("");
            }

            this._editingControl = null;
            this._editingCell = null;

            if (this.allowCellValid) {
                this.validateCell(record, column);
                //this.validateRow(record);
            }
        }
    },
    _OnCellShowingEdit: function (record, column) {
        if (!this._editingControl) return false;


        var cellBox = this.getCellBox(record, column);

        if (cellBox) {
            var viewWidth = document.body.scrollWidth; //mini.getViewportBox().width;
            if (cellBox.right > viewWidth) {

                cellBox.width = viewWidth - cellBox.left;
                if (cellBox.width < 10) cellBox.width = 10;
                cellBox.right = cellBox.left + cellBox.width;
            }
        }

        var e = {
            sender: this,
            rowIndex: this.indexOf(record),
            record: record,
            row: record,
            column: column,
            field: column.field,
            cellBox: cellBox,
            editor: this._editingControl
        };

        this.fire("cellshowingedit", e);

        var editor = e.editor;
        if (editor && editor.setIsValid) {

            editor.setIsValid(true);
        }

        if (cellBox) {
            var editWrap = this._getEditWrap(editor);
            this._editWrap.style.zIndex = mini.getMaxZIndex();




            //        if (editor.setWidth) {
            //            var width = cellBox.width;
            //            if (width < 20) width = 20;
            //            editor.setWidth(width);
            //        }

            //        if (editor.setHeight && editor.type == "textarea") {
            //            var height = cellBox.height - 1;
            //            if (editor.minHeight && height < editor.minHeight) height = editor.minHeight;
            //            editor.setHeight(height);
            //        }
            //        if (editor.setWidth) {
            //            var width = cellBox.width - 1;
            //            if (editor.minWidth && width < editor.minWidth) width = editor.minWidth;
            //            editor.setWidth(width);
            //        }

            this._setEditorBox(editor, cellBox);

            mini.on(document, 'mousedown', this.__OnBodyMouseDown, this);

            if (column.autoShowPopup && editor.showPopup) {

                editor.showPopup();
            }

        }


        //navEditMode
        if (editor) {
            var value = record[column.field],
                text = column.displayField ? record[column.displayField] : editor.getText();

            if (this.navEditMode) {
                editor.keyNavEnabled = !(column.navUpdown !== false);
            }
            editor.setValue(mini.htmlUnescape(value));

            // 懒加载没有对应节点时用 displayField 获取 text
            if (text !== editor.getText()) {
                editor.setText(text);
            }
            // 解决编辑控件buttonedit的输入框宽度超出了右侧按钮问题
            editor._doInputLayout && editor._doInputLayout();
            //editor.keyNavEnabled = !this.navEditMode && column.navUpdown === false;
        }

        //alert(editor.keyNavEnabled);

    },
    _getEditingControl: function () {
        return this._editingControl;
    },
    _setEditorBox: function (editor, cellBox) {
        if (editor.setWidth) {
            var width = cellBox.width;
            if (width < 20) width = 20;
            editor.setWidth(width);
        }

        if (editor.setHeight && editor.type == "textarea") {
            var height = cellBox.height - 1;
            if (editor.minHeight && height < editor.minHeight) height = editor.minHeight;
            editor.setHeight(height);
        }
        if (editor.setWidth) {
            var width = cellBox.width - 1;
            if (editor.minWidth && width < editor.minWidth) width = editor.minWidth;
            editor.setWidth(width);
        }

        /////////////////////////////////////////////////////////////////////////
        var box = cellBox;
        var editorHeight = editor.getHeight();

        var y = box.y;
        //if (editor.type != "textarea") {

        if (editorHeight < box.height - 2) {
            y = Math.round(box.y + box.height / 2 - editorHeight / 2);
            //y = parseInt(box.y + box.height / 2 - editorHeight / 2);

        }



        mini.setXY(this._editWrap, box.x, y);
        mini.setWidth(this._editWrap, box.width);

        var viewWidth = document.body.scrollWidth; //mini.getViewportBox().width;
        if (box.x > viewWidth) mini.setX(this._editWrap, -1000);
    },
    __OnBodyMouseDown: function (e) {
        if (this._editingControl) {

            var cell = this._getCellByEvent(e);

            if (this._editingCell && cell) {
                if (this._editingCell[0] == cell.record && this._editingCell[1] == cell.column) {
                    return false;
                }
            }

            var within = false;
            if (this._editingControl.within) within = this._editingControl.within(e);
            else within = mini.isAncestor(this._editWrap, e.target);

            if (within == false) {
                var me = this;
                if (mini.isAncestor(this._bodyEl, e.target) == false) {
                    setTimeout(function () {

                        me.commitEdit();

                    }, 1);
                } else {

                    var cell1 = me._editingCell;
                    setTimeout(function () {
                        var cell2 = me._editingCell;
                        if (cell1 == cell2) {
                            me.commitEdit();
                        }
                    }, 70);
                }
                mini.un(document, 'mousedown', this.__OnBodyMouseDown, this);
            }
        }
    },
    getEditWrap: function () {
        return this._editWrap;
    },
    _getEditWrap: function (editor) {
        if (!this._editWrap) {
            this._editWrap = mini.append(this.cellEditorContainer || mini.cellEditorContainer || document.body, '<div class="mini-grid-editwrap" style="position:absolute;"></div>');
            mini.on(this._editWrap, "keydown", this.___OnEditControlKeyDown, this);

            //            mini.on(this._editWrap, "keydown", function (event) {
            //                alert(1);
            //            }, this);
        }
        this._editWrap.style.zIndex = 1000000000;    //
        this._editWrap.style.display = 'block';

        if (editor.render) {
            editor.render(this._editWrap);
            setTimeout(function () {
                editor.focus();
                if (editor.selectText) {
                    setTimeout(function () {
                        editor.selectText();
                    }, 11);
                }
            }, 50);
            if (editor.setVisible) editor.setVisible(true);
        } else if (editor.el) {
            this._editWrap.appendChild(editor.el);
            setTimeout(function () {
                try {
                    editor.el.focus();
                } catch (e) {
                }
            }, 50);
        }

        //        var editorHeight = editor.getHeight();

        //        var y = box.y;
        //        //if (editor.type != "textarea") {

        //        if (editorHeight < box.height) {

        //            y = Math.round(box.y + box.height / 2 - editorHeight / 2);
        //            //y = parseInt(box.y + box.height / 2 - editorHeight / 2);

        //        }


        //        mini.setXY(this._editWrap, box.x, y);
        //        mini.setWidth(this._editWrap, box.width);

        //        var viewWidth = document.body.scrollWidth; //mini.getViewportBox().width;
        //        if (box.x > viewWidth) mini.setX(this._editWrap, -1000);

        return this._editWrap;
    },

    ___OnEditControlKeyDown: function (e) {

        var editor = this._editingControl;


        if (e.keyCode == 13 && editor && editor.type == "textarea") {

            return;
        }
        //        if (e.keyCode == 13 && e.ctrlKey == false && editor && editor.type == "textarea") {
        //            return;
        //        }
        //        if (e.keyCode == 38 || e.keyCode == 40) {
        //            e.preventDefault();
        //        }

        //document.title = 'enter' + new Date().getTime();

        if (e.keyCode == 13) {      //enter

            var time = new Date();
            if (this._enterTimestamp && (time - this._enterTimestamp < 80)) return;
            this._enterTimestamp = time;

            //            document.title = 'enter' + new Date().getTime();

            var cell = this._editingCell;
            if (cell && cell[1] && cell[1].enterCommit === false) return;


            this.commitEdit();
            this.focus();

            if (this.editNextOnEnterKey) {
                this.fire("celleditenter", { record: cell[0], column: cell[1] })

                this._beginEditNextCell(e.shiftKey == false);
            } else {


            }
        } else if (e.keyCode == 27) {   //esc

            this.cancelEdit();

            this.focus();
        } else if (e.keyCode == 9) {    //tab
            this.commitEdit();
            if (this.editOnTabKey) {
                e.preventDefault();
                this.commitEdit();
                this._beginEditNextCell(e.shiftKey == false, true);
            } else {
                //this.cancelEdit();
            }
        }

        //alert(e.keyCode);

        if (this.navEditMode) {

            var cell = this._editingCell;
            if (cell) {
                var column = cell[1];
                if (column && column.navUpdown === false) {
                    if (editor && (e.keyCode == 38 || e.keyCode == 40)) {
                        return;
                    }
                }
            }

            //
            switch (e.keyCode) {
                case 37:            //left
                    this.focus();
                    e.preventDefault();
                    this.commitEdit();
                    this._beginEditNextCell(e.shiftKey !== false);
                    break;
                case 39:            //right
                    this.focus();
                    this.commitEdit();
                    if (this.editOnTabKey) {
                        e.preventDefault();
                        this.commitEdit();
                        this._beginEditNextCell(e.shiftKey == false, true);
                    } else {
                        //this.cancelEdit();
                    }
                    break;
                case 38:                //up
                    this.focus();

                    //spinner内会改动值
                    e.preventDefault();

                    var cell = this._editingCell;
                    this.commitEdit()
                    var record = cell[0];
                    var column = cell[1];

                    if (record) {
                        var rowIndex = this.indexOf(record);
                        if (rowIndex > 0) rowIndex -= 1;
                    } else {
                        return
                    }
                    var newRecord = this.getRow(rowIndex);
                    var newCell = [newRecord, column];
                    this.setCurrentCell(newCell);
                    this.beginEditCell()

                    break;
                case 40:            //down
                    this.focus();
                    //                    e.preventDefault();
                    //                    this.commitEdit();
                    //                    this._beginEditNextCell(e.shiftKey == false);

                    e.preventDefault();

                    var cell = this._editingCell;
                    this.commitEdit()
                    var record = cell[0];
                    var column = cell[1];

                    if (record) {
                        var rowIndex = this.indexOf(record);
                        var length = this.getData().length;
                        if (rowIndex < length - 1) rowIndex += 1;
                    } else {
                        return
                    }
                    var newRecord = this.getRow(rowIndex);
                    var newCell = [newRecord, column];
                    this.setCurrentCell(newCell);
                    this.beginEditCell()

                    break;
            }
        }
    },

    navEditMode: false,
    setNavEditMode: function (value) {
        this.navEditMode = value;
    },
    getNavEditMode: function () {
        return this.navEditMode;
    },

    editNextRowCell: false,
    editNextOnEnterKey: false,
    editOnTabKey: true,
    createOnEnter: false,

    //
    skipReadOnlyCell: false,
    setSkipReadOnlyCell: function (value) {
        this.skipReadOnlyCell = value;
    },
    getSkipReadOnlyCell: function () {
        return this.skipReadOnlyCell;
    },

    isCellCanEdit: function (row, column) {
        var canEdit = this._OnCellBeginEdit(row, column, this.getCellEditor(column), false);
        return canEdit;
    },

    _beginEditNextCell: function (next, tab) {


        var time = new Date();
        if (this._editTimestamp && (time - this._editTimestamp < 80)) return;
        this._editTimestamp = time;

        //document.title = new Date().getTime();


        var grid = this;
        var currentCell = this.getCurrentCell();
        if (!currentCell) return;
        this.focus();
        var columns = grid.getVisibleColumns();

        var column = currentCell ? currentCell[1] : null,
            record = currentCell ? currentCell[0] : null;
        //if (!currentCell) record = grid.getCurrent();

        /////////////////////////////////////
        function getAt(index) {
            return grid.getVisibleRows()[index];
        }
        function indexOf(row) {
            return grid.getVisibleRows().indexOf(row);
        }
        function getCount() {
            return grid.getVisibleRows().length;
        }

        var columnIndex = columns.indexOf(column);
        var rowIndex = indexOf(record);
        var count = getCount();



        if (next === false) {
            if (this.skipReadOnlyCell) {
                var me = this;

                var nextColumn = getPrevCanEditCell();

                function getPrevCanEditCell() {
                    var l = 0;
                    var i = (columnIndex - 1 === 0) ? columns.length : columnIndex - 1;

                    for (; i > l; i--) {
                        column = columns[i];

                        var canEdit = me.isCellCanEdit(record, column);
                        if (canEdit) {
                            return column;
                        }
                    }
                }

                if (!nextColumn || columnIndex == 0) {
                    columnIndex = columns.length;
                    var nextRowColumn = getPrevCanEditCell();
                    setLastRow();
                }
            } else {
                columnIndex -= 1;
                column = columns[columnIndex];
                if (!column) {
                    column = columns[columns.length - 1];
                    setLastRow();
                }
            }

            function setLastRow() {
                record = getAt(rowIndex - 1);
                if (!record) {

                    return;
                }
            }

        } else {

            if (this.editNextRowCell && !tab) {
                if (rowIndex + 1 < count) {
                    record = getAt(rowIndex + 1);
                }
            } else {

                function setNextRow() {
                    record = grid.getAt(rowIndex + 1);
                    if (!record) {
                        if (grid.createOnEnter) {
                            record = {};

                            grid.addRow(record);
                        } else {
                            return;
                        }
                    }
                }

                function getNextCanEditCell() {

                    var i = (columnIndex + 1 == l) ? 0 : (columnIndex + 1);

                    for (; i < l; i++) {
                        column = columns[i];

                        var canEdit = me.isCellCanEdit(record, column);
                        if (canEdit) {
                            return column;
                        }
                    }
                }

                if (this.skipReadOnlyCell) {
                    var me = this;
                    var l = columns.length;

                    var nextColumn = getNextCanEditCell();

                    if (!nextColumn || columnIndex + 1 == l) {
                        columnIndex = 0;
                        var nextRowColumn = getNextCanEditCell();
                        setNextRow();
                    }
                } else {
                    columnIndex += 1;
                    column = columns[columnIndex];
                    if (!column) {
                        column = columns[0];
                        setNextRow();
                    }
                }


            }
        }



        //        if (next === false) {

        //            columnIndex -= 1;
        //            column = columns[columnIndex];
        //            if (!column) {
        //                column = columns[columns.length - 1];
        //                record = getAt(rowIndex - 1);
        //                if (!record) {

        //                    return;
        //                }
        //            }
        //        } else {

        //            if (this.editNextRowCell && !tab) {
        //                if (rowIndex + 1 < count) {
        //                    record = getAt(rowIndex + 1);
        //                }
        //            } else {
        //                columnIndex += 1;
        //                column = columns[columnIndex];
        //                if (!column) {
        //                    column = columns[0];
        //                    record = grid.getAt(rowIndex + 1);
        //                    if (!record) {
        //                        if (this.createOnEnter) {
        //                            record = {};

        //                            this.addRow(record);
        //                        } else {
        //                            return;
        //                        }
        //                    }
        //                }
        //            }
        //        }

        var currentCell = [record, column];

        grid.setCurrentCell(currentCell);

        if (!grid.onlyCheckSelection && grid.allowRowSelect) {
            if (grid.getCurrent() != record) {
                grid.deselectAll();
                grid.setCurrent(record);
            }
        }

        grid.scrollIntoView(record, column, false);

        if (grid.isReadOnly() || column.readOnly) return false;
        grid.beginEditCell();
    },
    //////////////////////////////////////////////////////////////////////////////////////////
    // RowEdit
    //////////////////////////////////////////////////////////////////////////////////////////    
    getEditorOwnerRow: function (editor) {
        var uid = editor.ownerRowID;
        return this.getRowByUID(uid);
    },

    beginEditRow: function (row) {
        if (this.allowCellEdit) return;

        function beginEdit(row) {
            var sss = new Date();

            row = this.getRow(row);
            if (!row) return;
            var rowEl = this._getRowEl(row, 2);
            if (!rowEl) return;


            //if (!this.multiEdit) this.cancelEdit();

            row._editing = true;

            this._doUpdateRowEl(row);
            //        var s = this._createRow(row);
            //        var rowEl = this._getRowEl(row);
            //        jQuery(rowEl).before(s);
            //        rowEl.parentNode.removeChild(rowEl);

            var rowEl = this._getRowEl(row, 2);
            mini.addClass(rowEl, "mini-grid-rowEdit");

            var columns = this.getVisibleColumns();
            for (var i = 0, l = columns.length; i < l; i++) {
                var column = columns[i];
                var cellEl = this._getCellEl(row, column);
                if (!cellEl) continue;

                // 可能是个性化控件，解析表格列时还未注册，此时再次解析一次缓存的 dom 元素
                if (!column.editor && column.editorEl) {
                    var editorEl = column.editorEl;
                    var className = editorEl.className;
                    var classes = className.split(' ');
                    classes.some(function(cls) {
                        var clazz = mini.getClassByUICls(cls);
                        if (!clazz) return;

                        var ui = new clazz();
                        editor = ui.getAttrs(editorEl);
                        editor.type = ui.type;
                        column.editor = editor;
                        return true;
                    });
                    delete column.editorEl;
                }

                if (typeof column.editor == "string") {
                    column.editor = window["ev" + "al"]('(' + column.editor + ')');
                }

                var editorConfig = mini.copyTo({}, column.editor);

                editorConfig.id = this.uid + "$" + row._uid + "$" + column._id + "$editor";
                var editor = mini.create(editorConfig);

                if (this._OnCellBeginEdit(row, column, editor)) {
                    if (editor) {
                        mini.addClass(cellEl, "mini-grid-cellEdit");
                        cellEl.innerHTML = "";
                        cellEl.appendChild(editor.el);
                        mini.addClass(editor.el, "mini-grid-editor");
                        editor.setValue(row[column.field]);
                    }
                }
            }

            this.doLayout();
        }
        this._pushUpdateCallback(beginEdit, this, [row]);
        //alert(new Date() - sss);

    },
    cancelEditRow: function (row) {
        if (this.allowCellEdit) return;

        row = this.getRow(row);
        if (!row || !row._editing) return;
        delete row._editing;

        var rowEl = this._getRowEl(row);

        var columns = this.getVisibleColumns();
        for (var i = 0, l = columns.length; i < l; i++) {
            var column = columns[i];

            var cellId = this._createCellId(row, columns[i]);
            var cellEl = document.getElementById(cellId);
            if (!cellEl) continue;

            var editorEl = cellEl.firstChild;
            var editor = mini.get(editorEl);
            if (!editor) continue;

            editor.destroy();
        }

        this._doUpdateRowEl(row);

        this.doLayout();

    },
    commitEditRow: function (row) {
        if (this.allowCellEdit) return;

        row = this.getRow(row);
        if (!row || !row._editing) return;

        var rowData = this.getEditRowData(row, false, false);

        this._canUpdateRowEl = false;
        this.updateRow(row, rowData);
        this._canUpdateRowEl = true;

        this.cancelEditRow(row);
    },
    isEditing: function () {
        var data = this.getDataView();
        for (var i = 0, l = data.length; i < l; i++) {
            var row = data[i];
            if (row._editing == true) return true;
        }
        return false;
    },
    isEditingRow: function (row) {
        row = this.getRow(row);
        if (!row) return false;
        return !!row._editing;
    },
    isNewRow: function (row) {
        return row._state == "added";
    },
    getEditingRows: function () {
        var rows = [];
        var data = this.getDataView();
        for (var i = 0, l = data.length; i < l; i++) {
            var row = data[i];
            if (row._editing == true) rows.push(row);
        }
        return rows;
    },
    getEditingRow: function () {
        var rows = this.getEditingRows();
        return rows[0];
    },
    //    getEditData: function (all) {
    //        var data = [];
    //        var data = this.getDataView();
    //        for (var i = 0, l = data.length; i < l; i++) {
    //            var row = data[i];
    //            if (row._editing == true) {
    //                var rowData = this.getEditRowData(i, all);
    //                rowData._index = i;

    //                data.push(rowData);
    //            }
    //        }
    //        return data;
    //    },
    getEditData: function (all) {
        var data = [];
        var dataView = this.getDataView();
        for (var i = 0, l = dataView.length; i < l; i++) {
            var row = dataView[i];
            if (row._editing == true) {
                var rowData = this.getEditRowData(i, all);
                data.push(rowData);
            }
        }
        return data;
    },
    getEditRowData: function (row, all, deep) {
        row = this.getRow(row);

        if (!row || !row._editing) return null;

        var idField = this.getIdField();
        var pidField = this.getParentField ? this.getParentField() : null;

        var rowData = {};

        var columns = this.getVisibleColumns();
        for (var i = 0, l = columns.length; i < l; i++) {
            var column = columns[i];
            var cellId = this._createCellId(row, columns[i]);
            var cellEl = document.getElementById(cellId);

            if (!cellEl) continue;

            var e = null;
            if (column.type == "checkboxcolumn" || column.type == "radiobuttoncolumn") {//checkboxcolumn

                var checked = column.isChecked(row, column);
                var value = checked ? column.trueValue : column.falseValue;
                e = this._OnCellCommitEdit(row, column, value);

                //                var ck = column.getCheckBoxEl(row, column);
                //                var value = ck.checked ? column.trueValue : column.falseValue;
                //                e = this._OnCellCommitEdit(row, column, value);
            } else {
                var editorEl = cellEl.firstChild;
                var editor = mini.get(editorEl);
                if (!editor) continue;
                e = this._OnCellCommitEdit(row, column, null, editor);
            }
            if (deep !== false) {
                mini._setMap(column.field, e.value, rowData);
                if (column.displayField) {
                    mini._setMap(column.displayField, e.text, rowData);
                }
            } else {
                rowData[column.field] = e.value;
                if (column.displayField) {
                    rowData[column.displayField] = e.text;
                }
            }
        }

        rowData[idField] = row[idField];
        if (pidField) {
            rowData[pidField] = row[pidField];
        }

        if (all) {
            var o = mini.copyTo({}, row);
            rowData = mini.copyTo(o, rowData);
        }

        return rowData;
    },
    //////////////////////////////////////////////////////////////////////////////////////////
    // RowGroup
    //////////////////////////////////////////////////////////////////////////////////////////
    collapseGroups: function () {
        if (!this.isGrouping()) return;
        this._allowLayout = false;
        var groups = this.getGroupingView();
        for (var i = 0, l = groups.length; i < l; i++) {
            var g = groups[i];
            this.collapseRowGroup(g);
        }
        this._allowLayout = true;
        this.doLayout();
    },
    expandGroups: function () {
        if (!this.isGrouping()) return;
        this._allowLayout = false;
        var groups = this.getGroupingView();
        for (var i = 0, l = groups.length; i < l; i++) {
            var g = groups[i];
            this.expandRowGroup(g);
        }
        this._allowLayout = true;
        this.doLayout();
    },
    toggleRowGroup: function (group) {
        if (group.expanded) {
            this.collapseRowGroup(group);
        } else {
            this.expandRowGroup(group);
        }
    },
    collapseRowGroup: function (group) {

        group = this.getRowGroup(group);
        if (!group) return;
        group.expanded = false;

        var g = this._getRowGroupEl(group, 1);
        var rows = this._getRowGroupRowsEl(group, 1);
        var g2 = this._getRowGroupEl(group, 2);
        var rows2 = this._getRowGroupRowsEl(group, 2);

        if (rows) rows.style.display = "none";
        if (rows2) rows2.style.display = "none";

        if (g) mini.addClass(g, "mini-grid-group-collapse");
        if (g2) mini.addClass(g2, "mini-grid-group-collapse");
        this.doLayout();
    },
    expandRowGroup: function (group) {
        group = this.getRowGroup(group);
        if (!group) return;
        group.expanded = true;

        var g = this._getRowGroupEl(group, 1);
        var rows = this._getRowGroupRowsEl(group, 1);
        var g2 = this._getRowGroupEl(group, 2);
        var rows2 = this._getRowGroupRowsEl(group, 2);

        if (rows) rows.style.display = "";
        if (rows2) rows2.style.display = "";

        if (g) mini.removeClass(g, "mini-grid-group-collapse");
        if (g2) mini.removeClass(g2, "mini-grid-group-collapse");
        this.doLayout();
    },
    //////////////////////////////////////////////////////////////////////////////////////////
    // RowDetail
    //////////////////////////////////////////////////////////////////////////////////////////
    showAllRowDetail: function () {
        this._allowLayout = false;
        var data = this.getDataView();
        for (var i = 0, l = data.length; i < l; i++) {
            var row = data[i];
            this.showRowDetail(row);
        }
        this._allowLayout = true;
        this.doLayout();
    },
    hideAllRowDetail: function () {
        this._allowLayout = false;
        var data = this.getDataView();

        for (var i = 0, l = data.length; i < l; i++) {
            var row = data[i];
            this.hideRowDetail(row);
        }
        this._allowLayout = true;
        this.doLayout();
    },
    isShowRowDetail: function (row) {
        row = typeof row == 'object' ? row : this.getRow(row);
        if (!row) return false;
        return !!row._showDetail;
    },
    toggleRowDetail: function (row) {
        row = this.getRow(row);
        if (!row) return;
        if (grid.isShowRowDetail(row)) {
            grid.hideRowDetail(row);
        } else {
            grid.showRowDetail(row);
        }
    },
    showRowDetail: function (row) {
        row = this.getRow(row);
        if (!row || row._showDetail == true) return;
        row._showDetail = true;


        var tr = this._getRowDetailEl(row, 1, true);
        var tr2 = this._getRowDetailEl(row, 2, true);
        if (tr) tr.style.display = "";
        if (tr2) tr2.style.display = "";

        var rowEl = this._getRowEl(row, 1);
        var rowEl2 = this._getRowEl(row, 2);
        if (rowEl) mini.addClass(rowEl, "mini-grid-expandRow");
        if (rowEl2) mini.addClass(rowEl2, "mini-grid-expandRow");




        this.fire("showrowdetail", { record: row });

        var self = this;
        if (this.isFrozen()) {
            setTimeout(function () {
                self.syncRowDetail(row);
            }, 1);
            //            setTimeout(function () {
            //                self.syncRowDetail(row);
            //            }, 100);
        }

        this.doLayout();
    },
    hideRowDetail: function (row) {
        row = this.getRow(row);
        if (!row || row._showDetail !== true) return;
        row._showDetail = false;

        var tr = this._getRowDetailEl(row, 1);
        var tr2 = this._getRowDetailEl(row, 2);
        if (tr) tr.style.display = "none";
        if (tr2) tr2.style.display = "none";

        var rowEl = this._getRowEl(row, 1);
        var rowEl2 = this._getRowEl(row, 2);
        if (rowEl) mini.removeClass(rowEl, "mini-grid-expandRow");
        if (rowEl2) mini.removeClass(rowEl2, "mini-grid-expandRow");

        this.fire("hiderowdetail", { record: row });

        this.doLayout();
    },
    _getRowDetailEl: function (row, viewIndex, autoCreate) {
        row = this.getRow(row);
        if (!row) return null;
        var id = this._createRowDetailId(row, viewIndex);
        var el = document.getElementById(id);
        if (!el && autoCreate === true) {
            el = this._createRowDetail(row, viewIndex);
        }
        return el;
    },
    _createRowDetail: function (row, viewIndex) {
        var columns1 = this.getFrozenColumns();
        var columns2 = this.getUnFrozenColumns();
        var colspan = columns1.length;
        if (viewIndex == 2) {
            colspan = columns2.length;
        }
        var el = this._getRowEl(row, viewIndex);
        if (!el) return null;
        var id = this._createRowDetailId(row, viewIndex);
        //var s = '<tr id="' + id + '" class="mini-grid-detailRow"><td class="mini-grid-detailCell" colspan="' + colspan + '"></td></tr>';
        var s = '<tr id="' + id + '" class="mini-grid-detailRow"><td style="width:0"></td><td class="mini-grid-detailCell" colspan="' + colspan + '"></td></tr>';
        jQuery(el).after(s);
        return document.getElementById(id);
    },
    _createRowDetailId: function (row, viewIndex) {
        return this._id + "$detail" + viewIndex + "$" + row._id;
    },
    getRowDetailCellEl: function (row, viewIndex) {
        if (!viewIndex) viewIndex = 2;
        var el = this._getRowDetailEl(row, viewIndex);
        if (el) return el.cells[1];
    },
    autoHideRowDetail: true,
    setAutoHideRowDetail: function (value) {
        this.autoHideRowDetail = value;
    },
    getAutoHideRowDetail: function () {
        return this.autoHideRowDetail;
    },
    //////////////////////////////////////////////////////////////////////////////////////////
    // MergerCell
    //////////////////////////////////////////////////////////////////////////////////////////
    mergeColumns: function (columns) {

        if (columns && mini.isArray(columns) == false) columns = [columns];
        //自动合并值相同的单元格：行合并
        var grid = this;
        var bottomColumns = grid.getVisibleColumns();
        if (!columns) columns = bottomColumns;
        var data = grid.getDataView();
        data.push({});

        var __cells = [];

        for (var i = 0, l = columns.length; i < l; i++) {
            var column = columns[i];
            column = grid.getColumn(column);
            if (!column) continue;
            var cells = margeCells(column);
            __cells.addRange(cells);
        }

        function margeCells(column) {
            if (!column.field) return;
            var cells = [];
            var rowIndex = -1, rowSpan = 1, columnIndex = bottomColumns.indexOf(column);
            var cellValue = null;
            for (var i = 0, l = data.length; i < l; i++) {
                var row = data[i];
                //var value = row[column.field];
                var value = mini._getMap(column.field, row);
                //if (rowIndex == -1 || value != cellValue) {
                if (rowIndex == -1 || !mini.isEquals(value, cellValue)) {
                    if (rowSpan > 1) {
                        var cell = { rowIndex: rowIndex, columnIndex: columnIndex, rowSpan: rowSpan, colSpan: 1 };
                        cells.push(cell);
                    }
                    rowIndex = i;
                    rowSpan = 1;
                    cellValue = value;
                } else {
                    rowSpan++;
                }
            }
            return cells;
        }

        grid.mergeCells(__cells);
    },
    mergeCells: function (cells) {
        if (!mini.isArray(cells)) return;
        this._mergedCells = cells;
        //maps
        var _mergedCellMaps = this._mergedCellMaps = {};

        function doMargedCellMaps(rowIndex, columnIndex, rowSpan, colSpan, cell) {
            for (var i = rowIndex, l = rowIndex + rowSpan; i < l; i++) {
                for (var j = columnIndex, k = columnIndex + colSpan; j < k; j++) {
                    if (i == rowIndex && j == columnIndex) {
                        _mergedCellMaps[i + ":" + j] = cell;
                    } else {
                        _mergedCellMaps[i + ":" + j] = true;
                    }
                }
            }
        }
        var cells = this._mergedCells;
        if (cells) {
            for (var i = 0, l = cells.length; i < l; i++) {
                var cell = cells[i];
                if (!cell.rowSpan) cell.rowSpan = 1;
                if (!cell.colSpan) cell.colSpan = 1;
                doMargedCellMaps(cell.rowIndex, cell.columnIndex, cell.rowSpan, cell.colSpan, cell);
            }
        }

        //this.deferUpdate();
        this.doUpdate();
    },
    margeCells: function (cells) {
        this.mergeCells(cells);
    },
    _isCellVisible: function (rowIndex, columnIndex) {
        if (!this._mergedCellMaps) return true;
        var ret = this._mergedCellMaps[rowIndex + ":" + columnIndex];
        return !(ret === true);
    },
    _getAnchorCell: function (row, column) {
        if (!this._mergedCellMaps) return null;
        var rowIndex = this.indexOf(row), columnIndex = this.getBottomColumns().indexOf(column);
        return this._mergedCellMaps[rowIndex + ":" + columnIndex];
    },

    //    _doMargeCells: function () {
    //        function _doMargeCells() {
    //            var cells = this._mergedCells;
    //            if (!cells) return;
    //            for (var i = 0, l = cells.length; i < l; i++) {
    //                var cell = cells[i];
    //                if (!cell.rowSpan) cell.rowSpan = 1;
    //                if (!cell.colSpan) cell.colSpan = 1;
    //                var cellEls = this._getCellEls(cell.rowIndex, cell.columnIndex, cell.rowSpan, cell.colSpan);
    //                for (var j = 0, k = cellEls.length; j < k; j++) {
    //                    var el = cellEls[j];
    //                    if (j != 0) {
    //                        el.style.display = "none";
    //                    } else {
    //                        el.rowSpan = cell.rowSpan;
    //                        el.colSpan = cell.colSpan;
    //                    }
    //                }
    //            }
    //        }
    //        //if (mini.isIE8) {
    //        _doMargeCells.call(this);
    //        //        } else {
    //        //            var me = this;
    //        //            if (this._doMargeCellsTimer) return;
    //        //            this._doMargeCellsTimer = setTimeout(function () {
    //        //                _doMargeCells.call(me);
    //        //                me._doMargeCellsTimer = null;
    //        //            }, 1);
    //        //        }
    //    },
    _getCellEls: function (rowIndex, columnIndex, rowSpan, colSpan) {
        var cells = [];
        if (!mini.isNumber(rowIndex)) return [];
        if (!mini.isNumber(columnIndex)) return [];
        var columns = this.getVisibleColumns();
        var data = this.getDataView();

        for (var i = rowIndex, l = rowIndex + rowSpan; i < l; i++) {
            for (var j = columnIndex, k = columnIndex + colSpan; j < k; j++) {
                var cell = this._getCellEl(i, j);
                if (cell) cells.push(cell);
            }
        }
        return cells;
    },
    //////////////////////////////////////////////////////////////////////////////////////////
    // Row DragDrop
    //////////////////////////////////////////////////////////////////////////////////////////
    _getDragData: function () {
        var data = this.getSelecteds().clone();
        var grid = this;


        //if (data.length == 2) debugger
        mini.sort(data, function (a, b) {
            var index1 = grid.indexOf(a);
            var index2 = grid.indexOf(b);
            if (index1 > index2) return 1;
            if (index1 < index2) return -1;
            return 0;
        }, this);
        //if(data.length == 2) alert(data[0].Name + ":" + data[1].Name);
        return data;
    },
    _getDragText: function (dragNodes) {
        return "Records " + dragNodes.length;
    },
    allowDrag: false,
    allowDrop: false,
    allowLeafDropIn: false,
    setAllowLeafDropIn: function (value) {
        this.allowLeafDropIn = value;
    },
    getAllowLeafDropIn: function () {
        return this.allowLeafDropIn;
    },
    setAllowDrag: function (value) {
        this.allowDrag = value;
    },
    getAllowDrag: function () {
        return this.allowDrag;
    },
    setAllowDrop: function (value) {
        this.allowDrop = value;
    },
    getAllowDrop: function () {
        return this.allowDrop;
    },
    isAllowDrag: function (node, column) {

        if (this.isReadOnly() || this.enabled == false) return false;
        if (!this.allowDrag || !column.allowDrag) return false;
        if (node.allowDrag === false) return false;
        return true;
        //        var e = this._OnDragStart(node, column);
        //        return !e.cancel;
    },
    _OnDragStart: function (node, column) {
        var e = {
            node: node,
            nodes: this._getDragData(),
            column: column,
            cancel: false
        };
        e.record = e.node;
        e.records = e.nodes;
        e.dragText = this._getDragText(e.nodes);

        this.fire("dragstart", e);
        return e;
    },
    _OnGiveFeedback: function (effect, dragNodes, dropNode, from) {
        var e = {};
        e.from = from;

        e.effect = effect;
        e.nodes = dragNodes;
        e.node = e.nodes[0];
        e.targetNode = dropNode;

        e.dragNodes = dragNodes;
        e.dragNode = e.dragNodes[0];
        e.dropNode = e.targetNode;
        e.dragAction = e.action;

        this.fire("givefeedback", e);
        return e;
    },
    _OnDragDrop: function (dragNodes, dropNode, dragAction) {
        dragNodes = dragNodes.clone();
        var e = {
            dragNodes: dragNodes,
            targetNode: dropNode,
            action: dragAction,
            cancel: false
        };

        e.dragNode = e.dragNodes[0];
        e.dropNode = e.targetNode;
        e.dragAction = e.action;

        this.fire("beforedrop", e);
        this.fire("dragdrop", e);
        return e;
    },
    ////////////////////////////
    moveUp: function (items) {
        if (!mini.isArray(items)) return;
        //按序号，从小到大
        var me = this;
        items = items.sort(function (a, b) {
            var i1 = me.indexOf(a);
            var i2 = me.indexOf(b);
            if (i1 > i2) return 1;
            return -1;
        });
        for (var i = 0, l = items.length; i < l; i++) {
            var item = items[i];
            var index = this.indexOf(item);
            this.moveRow(item, index - 1);
        }
    },
    moveDown: function (items) {
        if (!mini.isArray(items)) return;
        //按序号，从大到小
        var me = this;
        items = items.sort(function (a, b) {
            var i1 = me.indexOf(a);
            var i2 = me.indexOf(b);
            if (i1 > i2) return 1;
            return -1;
        });
        items.reverse();
        for (var i = 0, l = items.length; i < l; i++) {
            var item = items[i];
            var index = this.indexOf(item);
            this.moveRow(item, index + 2);
        }
    },
    //////////////////////////////////////////////////////////////////////////////////////////
    // Load Sort Pager
    //////////////////////////////////////////////////////////////////////////////////////////
    pageSize: 20,
    pageIndex: 0,
    totalCount: 0,
    totalPage: 0,

    sortField: "",
    sortOrder: "",
    url: "",

    setAjaxAsync: function (value) {
        this._dataSource.ajaxAsync = value;
        this.ajaxAsync = value;
    },
    getAjaxAsync: function () {
        return this._dataSource.ajaxAsync;
    },
    setAjaxMethod: function (value) {
        this._dataSource.ajaxMethod = value;
        this.ajaxMethod = value;
    },
    getAjaxMethod: function () {
        return this._dataSource.ajaxMethod;
    },
    setAjaxType: function (value) {
        this._dataSource.ajaxType = value;
        this.ajaxType = value;
    },
    getAjaxType: function () {
        return this._dataSource.ajaxType;
    },
    setAjaxOptions: function (value) {
        this._dataSource.setAjaxOptions(value);
    },
    getAjaxOptions: function () {
        return this._dataSource.getAjaxOptions();
    },
    setAutoLoad: function (value) {
        this._dataSource.setAutoLoad(value);
    },
    getAutoLoad: function () {
        return this._dataSource.getAutoLoad();
    },
    setUrl: function (value) {
        this._dataSource.setUrl(value);
        this.url = value;
    },
    getUrl: function () {
        return this._dataSource.getUrl();
    },
    load: function (params, success, error, complete) {
        this._dataSource.load(params, success, error, complete);
    },
    reload: function (success, error, complete) {
        this.accept();
        this._dataSource.reload(success, error, complete);
    },
    gotoPage: function (index, size) {
        this._dataSource.gotoPage(index, size);
    },
    sortBy: function (sortField, sortOrder) {
        if (!sortField) return null;
        var source = this._dataSource;
        this.sortField = source.sortField = sortField;
        this.sortOrder = source.sortOrder = sortOrder;

        if (this._dataSource.sortMode == "server") {
            this._dataSource.sortBy(sortField, sortOrder);
        } else {
            var dataType = this._columnModel._getDataTypeByField(sortField);
            this._dataSource._doClientSortField(sortField, sortOrder, dataType);
        }
    },

    sortDblClick: false,
    setSortDblClick: function (value) {
        this.sortDblClick = value
    },
    getSortDblClick: function () {
        return this.sortDblClick;
    },

    showCellTip: true,

    setShowCellTip: function (value) {
        this.showCellTip = value
    },
    getShowCellTip: function () {
        return this.showCellTip;
    },

    setCheckSelectOnLoad: function (value) {
        this._dataSource.setCheckSelectOnLoad(value);
        this.checkSelectOnLoad = value;
    },
    getCheckSelectOnLoad: function () {
        return this._dataSource.getCheckSelectOnLoad();
    },
    setSelectOnLoad: function (value) {
        this._dataSource.setSelectOnLoad(value);
        this.selectOnLoad = value;
    },
    getSelectOnLoad: function () {
        return this._dataSource.getSelectOnLoad();
    },

    allowCancelSort: false,
    setAllowCancelSort: function (value) {
        this.allowCancelSort = value;
    },
    getAllowCancelSort: function () {
        return this.allowCancelSort;
    },

    setSortMode: function (value) {
        this._dataSource.setSortMode(value);
        this.sortMode = value;
    },
    getSortMode: function () {
        return this._dataSource.getSortMode();
    },
    setPageIndex: function (value) {
        this._dataSource.setPageIndex(value);
        this.pageIndex = value;
    },
    getPageIndex: function () {
        return this._dataSource.getPageIndex();
    },
    setPageSize: function (value) {
        this._dataSource.setPageSize(value);
        this._virtualRows = value;
        this.pageSize = value;
    },
    getPageSize: function () {
        return this._dataSource.getPageSize();
    },
    setTotalCount: function (value) {
        this._dataSource.setTotalCount(value);
        this.totalCount = value;
    },
    getTotalCount: function () {
        return this._dataSource.getTotalCount();
    },
    getTotalPage: function () {
        return this._dataSource.getTotalPage();
    },

    setSortField: function (value) {
        this._dataSource.setSortField(value);
        this.sortField = value;
    },
    getSortField: function () {
        return this._dataSource.sortField;
    },
    setSortOrder: function (value) {
        this._dataSource.setSortOrder(value);
        this.sortOrder = value;
    },
    getSortOrder: function () {
        return this._dataSource.sortOrder;
    },

    setPageIndexField: function (value) {
        this._dataSource.pageIndexField = value;
        this.pageIndexField = value;
    },
    getPageIndexField: function () {
        return this._dataSource.pageIndexField;
    },
    setPageSizeField: function (value) {
        this._dataSource.pageSizeField = value;
        this.pageSizeField = value;
    },
    getPageSizeField: function () {
        return this._dataSource.pageSizeField;
    },

    setStartField: function (value) {
        this._dataSource.startField = value;
        this.startField = value;
    },
    getStartField: function () {
        return this._dataSource.startField;
    },
    setLimitField: function (value) {
        this._dataSource.limitField = value;
        this.limitField = value;
    },
    getLimitField: function () {
        return this._dataSource.limitField;
    },

    setSortFieldField: function (value) {
        this._dataSource.sortFieldField = value;
        this.sortFieldField = value;
    },
    getSortFieldField: function () {
        return this._dataSource.sortFieldField;
    },
    setSortOrderField: function (value) {
        this._dataSource.sortOrderField = value;
        this.sortOrderField = value;
    },
    getSortOrderField: function () {
        return this._dataSource.sortOrderField;
    },
    setTotalField: function (value) {
        this._dataSource.totalField = value;
        this.totalField = value;
    },
    getTotalField: function () {
        return this._dataSource.totalField;
    },
    setDataField: function (value) {
        this._dataSource.dataField = value;
        this.dataField = value;
    },
    getDataField: function () {
        return this._dataSource.dataField;
    },

    setErrorField: function (value) {
        this._dataSource.errorField = value;
        this.errorField = value;
    },
    getErrorField: function () {
        return this._dataSource.errorField;
    },
    setErrorMsgField: function (value) {
        this._dataSource.errorMsgField = value;
        this.errorMsgField = value;
    },
    getErrorMsgField: function () {
        return this._dataSource.errorMsgField;
    },
    setStackTraceField: function (value) {
        this._dataSource.stackTraceField = value;
        this.stackTraceField = value;
    },
    getStackTraceField: function () {
        return this._dataSource.stackTraceField;
    },

    setPageSizeWidth: function (value) {
        this._bottomPager.setPageSizeWidth(value);
    },
    getPageSizeWidth: function () {
        return this._bottomPager.getPageSizeWidth();
    },

    getBottomPager: function () {
        return this._bottomPager;
    },

    sizeText: "",
    setSizeText: function (value) {
        this._bottomPager.sizeText = value;
    },
    getSizeText: function () {
        return this.sizeText;
    },

    showPagerButtonText: false,
    setShowPagerButtonText: function (value) {
        this._bottomPager.setShowButtonText(value);
    },
    getShowPagerButtonText: function () {
        return this.showPagerButtonText;
    },
    showPagerButtonIcon: false,
    setShowPagerButtonIcon: function (value) {
        this._bottomPager.setShowButtonIcon(value);
    },
    getShowPagerButtonIcon: function () {
        return this.showPagerButtonIcon;
    },
    setShowReloadButton: function (value) {
        this._bottomPager.setShowReloadButton(value);
    },
    getShowReloadButton: function () {
        return this._bottomPager.getShowReloadButton();
    },
    setShowPageInfo: function (value) {
        this._bottomPager.setShowPageInfo(value);
    },
    getShowPageInfo: function () {
        return this._bottomPager.getShowPageInfo();
    },
    setSizeList: function (value) {
        if (!mini.isArray(value)) return;
        this._bottomPager.setSizeList(value);
    },
    getSizeList: function () {
        return this._bottomPager.getSizeList();
    },
    setShowPageSize: function (value) {
        this._bottomPager.setShowPageSize(value);
    },
    getShowPageSize: function () {
        return this._bottomPager.getShowPageSize();
    },
    setShowPageIndex: function (value) {
        this.showPageIndex = value;
        this._bottomPager.setShowPageIndex(value);
    },
    getShowPageIndex: function () {
        return this._bottomPager.getShowPageIndex();
    },
    setShowTotalCount: function (value) {

        this._bottomPager.setShowTotalCount(value);
    },
    getShowTotalCount: function () {
        return this._bottomPager.getShowTotalCount();
    },
    setPagerStyle: function (value) {
        this.pagerStyle = value;
        mini.setStyle(this._bottomPager.el, value);
    },
    setPagerCls: function (value) {
        this.pagerCls = value;
        mini.addClass(this._bottomPager.el, value);
    },
    setDropAction: function (value) {
        this.dropAction = value;
    },
    getDropAction: function () {
        return this.dropAction;
    },

    groupTitleCollapsible: true,
    setGroupTitleCollapsible: function (value) {
        this.groupTitleCollapsible = value;
    },
    getGroupTitleCollapsible: function () {
        return this.groupTitleCollapsible;
    },

    allowEmptyContextMenu: false,
    setAllowEmptyContextMenu: function (value) {
        this.allowEmptyContextMenu = value;
    },
    getAllowEmptyContextMenu: function () {
        return this.allowEmptyContextMenu;
    },
    //////////////////////////////////////////////////////////////////////////////////////////
    // ContextMenu
    //////////////////////////////////////////////////////////////////////////////////////////
    _beforeOpenContentMenu: function (menu, e) {
        //var record = this._getRecordByEvent(e.htmlEvent);        
        var can = mini.isAncestor(this._bodyEl, e.htmlEvent.target);
        if (can) {
            menu.fire("BeforeOpen", e);
        } else {
            e.cancel = true;
        }
    },



    __OnHtmlContextMenu: function (e) {
        var ev = {
            popupEl: this.el,
            htmlEvent: e,
            cancel: false
        };

        if (mini.isAncestor(this._columnsEl, e.target)) {
            if (this.headerContextMenu) {
                this.headerContextMenu.fire("BeforeOpen", ev);
                if (ev.cancel == true) return;
                this.headerContextMenu.fire("opening", ev);
                if (ev.cancel == true) return;
                this.headerContextMenu.showAtPos(e.pageX, e.pageY);
                this.headerContextMenu.fire("Open", ev);
            }
        } else {

            var d = mini.findParent(e.target, "mini-grid-detailRow");
            if (d && mini.isAncestor(this.el, d)) return;

            var f = mini.findParent(e.target, "mini-tree-nodeshow");
            //if (!f && this.uiCls == "mini-tree") return

            //            if (!f && this.type == "tree") return
            if (!f && this.type == "tree" && !this.allowEmptyContextMenu) return


            //if ($(e.target).hasClass("mini-grid-rows-view")) return;

            if (!this.allowEmptyContextMenu && !mini.findParent(e.target, "mini-grid-table")) return;

            if (mini.findParent(e.target, "mini-grid-filterRow")) return;
            if (mini.findParent(e.target, "mini-grid-summaryRow")) return;


            if (this.contextMenu) {
                this._beforeOpenContentMenu(this.contextMenu, ev);
                if (ev.cancel == true) return;
                this.contextMenu.fire("opening", ev);
                if (ev.cancel == true) return;
                this.contextMenu.showAtPos(e.pageX, e.pageY);
                this.contextMenu.fire("Open", ev);
            }
        }
        return false;

    },
    headerContextMenu: null,
    setHeaderContextMenu: function (value) {
        var ui = this._getContextMenu(value);
        if (!ui) return;
        if (this.headerContextMenu !== ui) {
            this.headerContextMenu = ui;
            mini.addClass(ui.el, "mini-menu-open");
            this.headerContextMenu.owner = this;
            mini.on(this.el, "contextmenu", this.__OnHtmlContextMenu, this);
        }
    },
    getHeaderContextMenu: function () {
        return this.headerContextMenu;
    },

    selectOnRightClick: true,
    setSelectOnRightClick: function (value) {
        this.selectOnRightClick = value;
    },
    getSelectOnRightClick: function () {
        return this.selectOnRightClick;
    },

    //////////////////////////////////////////////////////////////////////////////////////////
    _get_originals: function () {
        return this._dataSource._originals;
    },
    _set_originals: function (value) {
        this._dataSource._originals = value;
    },
    _set_clearOriginals: function (value) {
        this._dataSource._clearOriginals = value;
    },
    _set_originalIdField: function (value) {
        this._dataSource._originalIdField = value;
    },
    _set_autoCreateNewID: function (value) {
        this._dataSource._autoCreateNewID = value;
    },
    //////////////////////////////////////////////////////////////////////////////////////////
    // HTML Tags
    //////////////////////////////////////////////////////////////////////////////////////////       
    getAttrs: function (el) {
        var attrs = mini.DataGrid.superclass.getAttrs.call(this, el);
        var cs = mini.getChildNodes(el);
        for (var i = 0, l = cs.length; i < l; i++) {
            var node = cs[i];
            //var property = jQuery(node).attr("property");
            var property = mini.getAttr(node, "property");
            if (!property) continue;
            property = property.toLowerCase();
            if (property == "columns") {
                attrs.columns = mini._ParseColumns(node);
                mini.removeNode(node);
            } else if (property == "data") {
                attrs.data = node.innerHTML;
                mini.removeNode(node);
            }
        }

        mini._ParseString(el, attrs,
            [
                "oncelleditenter",
                "onselect", "ondeselect", "onbeforeselect", "onbeforedeselect",
                "url", "sizeList", "bodyCls", "bodyStyle", "footerCls", "footerStyle", "pagerCls", "pagerStyle",
                "onheadercellclick", "onheadercellmousedown", "onheadercellcontextmenu", "onrowdblclick",
                "onrowclick", "onrowmousedown", "onrowcontextmenu",
                "onrowmouseenter", "onrowmouseleave",
                "oncellclick", "oncellmousedown", "oncellcontextmenu", "oncelldblclick",
                "onbeforeload", "onpreload", "onloaderror", "onload",
                "onupdate", "ondrawcell", "oncellbeginedit", "onselectionchanged", "ondrawgroup",
                "onbeforeshowrowdetail", "onbeforehiderowdetail", "onshowrowdetail", "onhiderowdetail", "idField", "valueField",
                "pager", "oncellcommitedit", "oncellendedit",
                "headerContextMenu", "loadingMsg", "emptyText", "cellEditAction",
                "sortMode", "oncellvalidation", "onsort",
                "ondrawsummarycell", "ondrawgroupsummarycell", "onresize", "oncolumnschanged",
                "ajaxMethod", "ajaxOptions",

                "onaddrow", "onupdaterow", "onremoverow", "onmoverow",
                "onbeforeaddrow", "onbeforeupdaterow", "onbeforeremoverow", "onbeforemoverow",

                "pageIndexField", "pageSizeField", "sortFieldField", "sortOrderField",
                "startField", "limitField",
                "totalField", "dataField", "sortField", "sortOrder",
                "stackTraceField", "errorField", "errorMsgField",
                "pagerButtons", "onbeforegroupclick", "dropAction", "sizeText", "pagerType", "viewType", "itemRenderer", "summaryPosition", "ondragstart", "onbeforedrop", "ondrop", "ongivefeedback", "onbeforepagechanged"
             ]
        );

        mini._ParseBool(el, attrs,
            ["showColumns", "showFilterRow", "showSummaryRow", "showPager", "showFooter", "enableGroupOrder", "validateOnAdd",
            "showHGridLines", "showVGridLines", "showSortIcon",
            "allowSortColumn", "allowMoveColumn", "allowResizeColumn",
            "fitColumns", "showLoading", "multiSelect", "allowAlternating", "resultAsData", "allowRowSelect", "allowUnselect",
            "onlyCheckSelection",
            "allowHotTrackOut", "enableHotTrack", "showPageIndex", "showPageSize", "showTotalCount",
            "checkSelectOnLoad", "allowResize", "autoLoad",
            "autoHideRowDetail", "allowCellSelect", "allowCellEdit", "allowCellWrap", "allowHeaderWrap", "selectOnLoad",
            "virtualScroll", "virtualColumns", "collapseGroupOnLoad", "showGroupSummary",
            "showEmptyText", "alwaysShowEmptyText", "allowCellValid", "showModified", "showColumnsMenu", "showPageInfo", "showReloadButton",
            "showNewRow", "editNextOnEnterKey", "createOnEnter", "skipReadOnlyCell",
            "ajaxAsync",
            "allowDrag", "allowDrop", "allowLeafDropIn", "editNextRowCell",
            "fixedRowHeight", "showCellTip", "showPagerButtonText", "showPagerButtonIcon", "groupTitleCollapsible",
            "navEditMode", "selectOnRightClick", "sortDblClick", "allowEmptyContextMenu", "showGroupSummary",
            "allowCancelSort"
             ]
        );

        mini._ParseInt(el, attrs,
            ["frozenStartColumn", "frozenEndColumn","frozenRightStartColumn", "frozenRightEndColumn", "pageSizeWidth",
            "pageIndex", "pageSize", "defaultRowHeight", "defaultColumnWidth", "wheelIncrement", "summaryRows"
             ]
        );

        if (typeof attrs.ajaxOptions == "string") {
            attrs.ajaxOptions = window["ev" + "al"]('(' + attrs.ajaxOptions + ')');
        }
        if (typeof attrs.sizeList == "string") {
            attrs.sizeList = window["ev" + "al"]('(' + attrs.sizeList + ')');
        }
        if (!attrs.idField && attrs.valueField) {
            attrs.idField = attrs.valueField;
        }

        if (attrs.pagerButtons) {
            attrs.pagerButtons = mini.byId(attrs.pagerButtons);
        }

        if (attrs.itemRenderer) attrs.itemRenderer = window[attrs.itemRenderer];

        return attrs;
    }
});
mini.regClass(mini.DataGrid, "datagrid");


/* Cell Validae
-----------------------------------------------------------------------------*/

mini_DataGrid_CellValidator_Prototype = {
    getCellErrors: function () {
        var errors = this._cellErrors.clone();

        //如果errors中的行对象已经被删除，则需要从错误数组中移除
        var source = this._dataSource;
        for (var i = 0, l = errors.length; i < l; i++) {
            var error = errors[i];
            var row = error.record;
            if (!source.getby_id(row._id)) {
                var column = error.column;
                var id = row[this._rowIdField] + "$" + column._id;
                delete this._cellMapErrors[id];
                this._cellErrors.remove(error);
            }
        }

        //        var data = this.getDataView();
        //        for (var i = 0, l = errors.length; i < l; i++) {
        //            var error = errors[i];
        //            var row = error.record;
        //            var column = error.column;
        //            if (data.indexOf(row) == -1) {
        //                var id = row[this._rowIdField] + "$" + column._id;
        //                delete this._cellMapErrors[id];
        //                this._cellErrors.remove(error);
        //            }
        //        }

        return this._cellErrors;
    },
    getCellError: function (row, column) {
        row = this.getNode ? this.getNode(row) : this.getRow(row);
        column = this.getColumn(column);
        if (!row || !column) return;

        var id = row[this._rowIdField] + "$" + column._id;
        return this._cellMapErrors ? this._cellMapErrors[id] : null;
    },
    isValid: function () {
        return this.getCellErrors().length == 0;
    },
    isCellValid: function (record, column) {
        //if(this.indexOf(record) == 0) debugger
        if (!this._cellMapErrors) return true;
        var id = record[this._rowIdField] + "$" + column._id;
        return !this._cellMapErrors[id];
    },
    validate: function (data) {
        data = data || this.getDataView();
        if (!mini.isArray(data)) data = [];
        for (var i = 0, l = data.length; i < l; i++) {
            var row = data[i];
            this.validateRow(row);
        }
    },
    validateRow: function (row) {
        var columns = this.getBottomColumns();
        for (var i = 0, l = columns.length; i < l; i++) {
            var column = columns[i];
            this.validateCell(row, column);
        }
    },
    validateCell: function (row, column) {
        row = this.getNode ? this.getNode(row) : this.getRow(row);
        column = this.getColumn(column);
        if (!row || !column || column.visible == false) return;
        var value = mini._getMap(column.field, row);
        var e = {
            record: row,
            row: row,
            node: row,
            column: column,
            field: column.field,
            value: value,
            isValid: true,
            errorText: ""
        };

        if (column.vtype) {

            mini._ValidateVType(column.vtype, e.value, e, column);
        }
        //唯一列值处理unique：遍历行，满足条件，遍历行
        if (e.isValid == true && column.unique && column.field) {

            var maps = {};
            var data = this.data, field = column.field;
            for (var i = 0, l = data.length; i < l; i++) {
                var o = data[i];
                var v = o[field];
                //if (mini.isNull(v) || v === "") {
                if (mini.isNull(v) || String(v).trim() === "") {
                } else {
                    var old = maps[v];
                    if (old && o == row) {
                        e.isValid = false;
                        e.errorText = mini._getErrorText(column, "uniqueErrorText");

                        //上面的也是
                        this.setCellIsValid(old, column, e.isValid, e.errorText);
                        break;
                    }
                    maps[v] = o;
                }
            }
        }

        this.fire("cellvalidation", e);
        this.setCellIsValid(row, column, e.isValid, e.errorText);
    },

    setIsValid: function (value) {
        if (value) {
            var errors = this._cellErrors.clone();
            for (var i = 0, l = errors.length; i < l; i++) {
                var error = errors[i];
                this.setCellIsValid(error.record, error.column, true);
            }
        }
    },
    _removeRowError: function (row) {
        var columns = this.getColumns();
        for (var i = 0, l = columns.length; i < l; i++) {
            var column = columns[i];
            var id = row[this._rowIdField] + "$" + column._id;
            var error = this._cellMapErrors[id];
            if (error) {
                delete this._cellMapErrors[id];
                this._cellErrors.remove(error);
            }
        }
    },
    setCellIsValid: function (row, column, isValid, errorText) {
        row = this.getRow(row);
        column = this.getColumn(column);
        if (!row || !column) return;
        var id = row[this._rowIdField] + "$" + column._id;
        var cellEl = this._getCellEl(row, column);

        var error = this._cellMapErrors[id];
        delete this._cellMapErrors[id];
        this._cellErrors.remove(error);

        if (isValid === true) {
            if (cellEl && error) {
                mini.removeClass(cellEl, 'mini-grid-cell-error');
            }
        } else {
            error = { record: row, column: column, isValid: isValid, errorText: errorText };
            this._cellMapErrors[id] = error;
            this._cellErrors.add(error);
            if (cellEl) {
                mini.addClass(cellEl, 'mini-grid-cell-error');
            }
        }
    }
}
mini.copyTo(mini.DataGrid.prototype, mini_DataGrid_CellValidator_Prototype);

﻿/*
描述：TreeGrid
节点对象：{ enabled, expanded, checked, checkState, checkable, asyncLoad, isLeaf, children }
    0.checked(true|false), checkState(indeterminate|unchecked|checked)
    1.checkable 决定是否可以选中。设置false，会隐藏checkbox。
    2.enabled 决定是否灰化显示，禁止点击、选择操作
    3.isLeaf 决定是否显示成父节点样子
    4.asyncLoad 决定是否可以懒加载。设置false，展开时不懒加载
            
    node.showCheckBox?
    是否显示checkbox。   也可以在ondrawcell的时候，e.showCheckBox=false;
    node.checkable
    是否禁用checkbox。
    
    1.isLeaf：没有子节点，有isLeaf="true"，也返回true，显示成一个父节点
    2.hasChildren：只判断子节点。
*/

mini.TreeGrid = function () {
    mini.TreeGrid.superclass.constructor.apply(this, arguments);
    mini.addClass(this.el, 'mini-tree');

    this.setAjaxAsync(false);
    this.setAutoLoad(true);

    if (this.showTreeLines == true) {
        mini.addClass(this.el, 'mini-tree-treeLine');
    }

    this._AsyncLoader = new mini._Tree_AsyncLoader(this);
    this._Expander = new mini._Tree_Expander(this);

    this.setShowArrow(this.showArrow);
};
mini.copyTo(mini.TreeGrid.prototype, mini._DataTreeApplys);

mini.extend(mini.TreeGrid, mini.DataGrid, {
    isTree: true,

    uiCls: "mini-treegrid",

    showPager: false,
    showNewRow: false,

    showCheckBox: false,    //checkbox
    showRadioButton: false, //radio
    showTreeIcon: true,     //节点图标    
    showExpandButtons: true,    //+、-号的连线
    showTreeLines: false,        //连线
    showArrow: false,

    expandOnDblClick: true,
    expandOnNodeClick: false,
    loadOnExpand: true,
    // 是否只能选择叶子节点
    canCheckParent: false,
    _checkBoxType: "checkbox",

    iconField: "iconCls",

    _treeColumn: null,

    leafIconCls: "mini-tree-leaf",
    folderIconCls: "mini-tree-folder",

    fixedRowHeight: false,  //固定高度

    _checkBoxCls: "mini-tree-checkbox",
    _expandNodeCls: "mini-tree-expand",
    _collapseNodeCls: "mini-tree-collapse",
    _eciconCls: "mini-tree-node-ecicon",
    _inNodeCls: "mini-tree-nodeshow",


    //    set: function (kv) {
    //        if (typeof kv == 'string') {
    //            return this;
    //        }

    //        var value = kv.showTreeNode;
    //        if (!mini.isNull(value)) {
    //            delete kv.showTreeNode;
    //            this.setShowTreeIcon(value);
    //        }


    //        if (!mini.isNull(columns)) {
    //            this.setColumns(columns);
    //        }

    //        mini.TreeGrid.superclass.set.call(this, kv);

    //       

    //        return this;
    //    },

    isEditingNode: function (node) {
        return this._editingNode == node;
    },

    indexOf: function (record) {
        return this._dataSource.indexOfList(record);
    },

    _getDragText: function (dragNodes) {
        return "Nodes " + dragNodes.length;
    },
    _initEvents: function () {
        mini.TreeGrid.superclass._initEvents.call(this);

        this.on("nodedblclick", this.__OnNodeDblClick, this);
        this.on("nodeclick", this.__OnNodeClick, this);


        //adapter events
        this.on("cellclick", function (e) {
            e.node = e.record;
            e.isLeaf = this.isLeaf(e.node);
            this.fire("nodeclick", e);
        }, this);
        this.on("cellmousedown", function (e) {
            e.node = e.record;
            e.isLeaf = this.isLeaf(e.node);
            this.fire("nodemousedown", e);
        }, this);
        this.on("celldblclick", function (e) {
            e.node = e.record;
            e.isLeaf = this.isLeaf(e.node);
            this.fire("nodedblclick", e);
        }, this);

        this.on("beforerowselect", function (e) {
            e.node = e.selected;
            e.isLeaf = this.isLeaf(e.node);
            this.fire("beforenodeselect", e);
        }, this);
        this.on("rowselect", function (e) {
            e.node = e.selected;
            e.isLeaf = this.isLeaf(e.node);
            this.fire("nodeselect", e);
        }, this);

        // TreeGrid 新增奇偶行展示 和 展开行高亮的扩展
        var tree = this;
        this.on('layout', function() {
            // 未 开启斑马纹则不处理
            if (!tree.allowAlternating) {
                $(tree.el)
                    .find('.mini-grid-row-alt')
                    .removeClass('mini-grid-row-alt');
                return;
            }
            var $tbody = $(tree._contentEl).find('.mini-grid-rows-content > .mini-grid-table > tbody');
            // 增加奇偶行标识
            $tbody.find('> .mini-grid-row').each(function(i, item) {
                if (i % 2 == 1) {
                    $(item).addClass('mini-grid-row-alt');
                }
            });
            // 添加展开行的cls
            $tbody.find('> .mini-tree-nodes-tr').each(function(i, tr) {
                $(tr)
                    .prev()
                    .addClass('mini-treegrid-expandRow');
            });
        });

    },
    setValue: function (value, cascade) {
        if (mini.isNull(value)) value = "";
        value = String(value);
        if (this.getValue() != value) {
            var nodes = this.getCheckedNodes();

            //this.uncheckNodes(nodes, false); //三态的时候，是否会有问题？
            this.uncheckNodes(nodes, this.checkRecursive); //取消选择，也应该引发三态

            this.value = value;
            if (this.showCheckBox) {
                var ids = String(value).split(",");
                this._dataSource.doCheckNodes(ids, true, cascade !== false);
                //                for (var i = 0, l = ids.length; i < l; i++) {
                //                    this.checkNode(ids[i]);
                //                }
            } else {
                this.selectNode(value, false);
            }
        }
    },
    getValue: function (mode) {
        if (this.showCheckBox) {
            if (mode === false || !this.canCheckParent) mode = 'leaf';
            return this._dataSource.getCheckedNodesId(mode);
        } else {
            return this._dataSource.getSelectedsId();
        }
    },
    getText: function () {
        var nodes = [];
        if (this.showCheckBox) {
            nodes = this.getCheckedNodes();
        } else {
            var node = this.getSelectedNode();
            if (node) nodes.push(node);
        }

        var sb = [], textField = this.getTextField();
        for (var i = 0, l = nodes.length; i < l; i++) {
            var node = nodes[i];
            sb.push(node[textField]);
        }

        return sb.join(',');
    },
    //////////////////////////////////////////////////////////
    isGrouping: function () {
        return false;
    },
    _createSource: function () {
        this._dataSource = new mini.DataTree();
    },
    _bindSource: function () {
        mini.TreeGrid.superclass._bindSource.call(this);
        var source = this._dataSource;

        source.on("expand", this.__OnTreeExpand, this);
        source.on("collapse", this.__OnTreeCollapse, this);

        source.on("_checkchanged", this.__OnCheckChanged, this);

        source.on("addnode", this.__OnSourceAddNode, this);
        source.on("removenode", this.__OnSourceRemoveNode, this);
        source.on("movenode", this.__OnSourceMoveNode, this);

        source.on("beforeloadnode", this.__OnBeforeLoadNode, this);
        source.on("loadnode", this.__OnLoadNode, this);
    },
    __OnBeforeLoadNode: function (e) {
        this.__showLoading = this.showLoading;
        this.showLoading = false;
        this.addNodeCls(e.node, "mini-tree-loading");
        this.fire("beforeloadnode", e);
    },
    __OnLoadNode: function (e) {
        this.showLoading = this.__showLoading;
        this.removeNodeCls(e.node, "mini-tree-loading");
        this.fire("loadnode", e);
    },
    _virtualUpdate: function () {
        var that = this;
        if (that._updateNodeTimer) {
            clearTimeout(that._updateNodeTimer);
            that._updateNodeTimer = null;
        }
        that._updateNodeTimer = setTimeout(function () {
            that._updateNodeTimer = null;

            that.doUpdateRows();         //30条，55ms
            //this._stopUpdateTableView();
            that.deferLayout(50);
        }, 5);
    },
    //    __OnSourceAddNode: function (e) {

    //        var visible = this._dataSource.isVisibleNode(e.node);

    //        if (this.isVirtualScroll() == true) {
    //            this._virtualUpdate();
    //        } else {
    //            if (visible) this._doAddNodeEl(e.node);

    //        }
    //        this.fire("addnode", e);
    //    },
    __OnSourceAddNode: function (e) {

        var visible = this._dataSource.isVisibleNode(e.node);

        if (this.isVirtualScroll() == true) {
            this._virtualUpdate();
        } else {
            if (visible) this._doAddNodeEl(e.node);
            else {
                var parentNode = this.getParentNode(e.node);
                if (this._dataSource.isVisibleNode(parentNode)) {
                    this._doUpdateTreeNodeEl(parentNode);
                }

            }

        }
        this.fire("addnode", e);
    },
    __OnSourceRemoveNode: function (e) {
        if (this.isVirtualScroll() == true) {
            this._virtualUpdate();
        } else {
            this._doRemoveNodeEl(e.node);

            //更新父节点        
            var parentNode = this.getParentNode(e.node);
            var nodes = this.getChildNodes(parentNode);
            if (nodes.length == 0) {
                this._doUpdateTreeNodeEl(parentNode);
            }
            else {
                var index = e.index;
                if (index > 1 && index == nodes.length) {
                    this._doUpdateTreeNodeEl(nodes[nodes.length - 1]);
                }
            }
        }

        this.fire("removenode", e);
    },

    __OnSourceMoveNode: function (e) {
        this._doMoveNodeEl(e.node);
        this.fire("movenode", e);

        var oldParentNode = e.oldParentNode;
        var parentNode = e.parentNode;
        if (oldParentNode != parentNode) {
            var nodes = this.getChildNodes(oldParentNode);
            if (nodes) {
                var last = nodes[nodes.length - 1];
                if (last) this._doUpdateTreeNodeEl(last);
            }
        }
    },
    _doAddNodeEl: function (node) {
        var columns1 = this.getFrozenColumns();
        var columns2 = this.getUnFrozenColumns();

        var parentNode = this.getParentNode(node);
        var rowIndex = this.indexOf(node);

        var updateParent = false;
        function doAdd(node, columns, viewIndex) {
            var s = this._createRowHTML(node, rowIndex, columns, viewIndex);

            var index = this.indexOfNode(node) + 1;
            var targetNode = this.getChildNodeAt(index, parentNode);
            if (targetNode) {
                var targetEl = this._getNodeEl(targetNode, viewIndex);
                jQuery(targetEl).before(s);
            } else {
                var nodesEl = this._getNodesEl(parentNode, viewIndex);
                if (nodesEl) {
                    mini.append(nodesEl.firstChild, s);
                } else {
                    updateParent = true;
                }
            }
        }

        doAdd.call(this, node, columns2, 2);
        doAdd.call(this, node, columns1, 1);

        if (updateParent) {
            this._doUpdateTreeNodeEl(parentNode);
        }
    },
    _doRemoveNodeEl: function (node) {
        this._doRemoveRowEl(node);
        var nodesEl = this._getNodesEl(node, 1);
        var nodesEl2 = this._getNodesEl(node, 2);
        if (nodesEl) nodesEl.parentNode.removeChild(nodesEl);
        if (nodesEl2) nodesEl2.parentNode.removeChild(nodesEl2);


    },
    _doMoveNodeEl: function (node) {

        if (this.isVirtualScroll() == true) {
            this._virtualUpdate();
        } else {
            //1）删除节点        
            this._doRemoveNodeEl(node);
            //2）更新父节点

            var parentNode = this.getParentNode(node);
            this._doUpdateTreeNodeEl(parentNode);
        }


    },
    _doUpdateNodeTitle: function (node) {
        this._doUpdateTreeNodeEl(node, false);
    },
    _doUpdateTreeNodeEl: function (node, hasChild) {
        //更新：节点、子节点
        hasChild = hasChild !== false;

        var rootNode = this.getRootNode();
        if (rootNode == node) {
            this.doUpdate();
            return;
        }
        if (!this.isVisibleNode(node)) return;

        var objNode = node;
        var frozenColumns = this.getFrozenColumns();
        var frozenRightColumns = this.getFrozenRightColumns();
        var unfrozenColumns = this.getUnFrozenColumns();

        var lockHtml = this._createNodeHTML(node, frozenColumns, 1, null, hasChild);
        var lockRightHtml = this._createNodeHTML(node, frozenRightColumns, 3, null, hasChild);
        var html = this._createNodeHTML(node, unfrozenColumns, 2, null, hasChild);

        var nodeEl1 = this._getNodeEl(node, 1);
        var nodeEl2 = this._getNodeEl(node, 2);
        var nodeEl3 = this._getNodeEl(node, 3);
        var nodesEl1 = this._getNodesTr(node, 1);
        var nodesEl2 = this._getNodesTr(node, 2);
        var nodesEl3 = this._getNodesTr(node, 3);

        var detail1 = this._getRowDetailEl(node, 1);
        var detail2 = this._getRowDetailEl(node, 2);
        var detail3 = this._getRowDetailEl(node, 3);

        //1）
        var els = mini.createElements(lockHtml);
        var node = els[0];
        var nodes = els[1];
        if (nodeEl1) {
            mini.before(nodeEl1, node);
            if (hasChild) {
                if (detail1) mini.after(detail1, nodes);
                else mini.before(nodeEl1, nodes);
            }

            mini.removeNode(nodeEl1);
            if (hasChild) {
                mini.removeNode(nodesEl1);
            }
        }
        //2）
        var els = mini.createElements(html);
        var node = els[0];
        var nodes = els[1];
        if (nodeEl2) {
            mini.before(nodeEl2, node);

            if (hasChild) {
                if (detail2) mini.after(detail2, nodes);
                else mini.before(nodeEl2, nodes);
            }

            mini.removeNode(nodeEl2);
            if (hasChild) {
                mini.removeNode(nodesEl2);
            }
        }
        //3）
        var els = mini.createElements(lockRightHtml);
        var node = els[0];
        var nodes = els[1];
        if (nodeEl3) {
            mini.before(nodeEl3, node);

            if (hasChild) {
                if (detail3) mini.after(detail3, nodes);
                else mini.before(nodeEl3, nodes);
            }

            mini.removeNode(nodeEl3);
            if (hasChild) {
                mini.removeNode(nodesEl3);
            }
        }

        if (node.checked != true && !this.isLeaf(node)) {
            this._doCheckNodeEl(objNode);
        }
    },
    addNodeCls: function (node, cls) {
        this.addRowCls(node, cls);
    },
    removeNodeCls: function (node, cls) {
        this.removeRowCls(node, cls);
    },
    /////////////////////////////////////////////////////////////////
    doUpdate: function () {

        mini.TreeGrid.superclass.doUpdate.apply(this, arguments);
        //this._doUpdate
    },
    setData: function (data) {
        if (!data) data = [];
        this._dataSource.setData(data);
    },
    loadList: function (list, idField, parentField) {
        idField = idField || this.getIdField();
        parentField = parentField || this.getParentField();
        var tree = mini.listToTree(list, this.getNodesField(), idField, parentField);
        this.setData(tree);
    },
    //    _OnDrawNode: function (e) {
    //        var showCheckBox = this.showCheckBox;
    //        if (showCheckBox && this.hasChildren(node)) {
    //            showCheckBox = this.showFolderCheckBox;
    //        }
    //        var nodeHtml = this.getItemText(node);
    //        var e = {
    //            isLeaf: this.isLeaf(node),
    //            node: node,
    //            nodeHtml: nodeHtml,
    //            nodeCls: '',
    //            nodeStyle: "",
    //            showCheckBox: showCheckBox,
    //            iconCls: this.getNodeIcon(node),
    //            img: node[this.imgField],
    //            showTreeIcon: this.showTreeIcon
    //        };
    //        this.fire("drawnode", e);
    //        if (e.nodeHtml === null || e.nodeHtml === undefined || e.nodeHtml === "") e.nodeHtml = "&nbsp;";
    //        return e;
    //    },
    _createDrawCellEvent: function (record, column, rowIndex, columnIndex) {
        var e = mini.TreeGrid.superclass._createDrawCellEvent.call(this, record, column, rowIndex, columnIndex);
        e.node = e.record;
        e.isLeaf = this.isLeaf(e.node);
        if (this._treeColumn && this._treeColumn == column.name) {
            e.isTreeCell = true;

            e.img = record[this.imgField];
            e.iconCls = this._getNodeIcon(record);
            e.nodeCls = "";
            e.nodeStyle = "";
            e.nodeHtml = "";

            e.showTreeIcon = this.showTreeIcon;
            e.checkBoxType = this._checkBoxType;
            // e.showCheckBox = this.showCheckBox;
            // 如果节点属性存在 优先使用节点的配置而非控件的配置
            if ('showCheckBox' in record) {
                e.showCheckBox = record.showCheckBox;
            } else {
                e.showCheckBox = this.showCheckBox;
            }
            e.showRadioButton = this.showRadioButton;
            if (e.showCheckBox && !e.isLeaf) {
                e.showCheckBox = this.showFolderCheckBox;
            }
            if (e.showRadioButton && !e.isLeaf) {
                e.showRadioButton = this.showFolderCheckBox;
            }
            e.enabled = e.node.enabled !== false;
            e.checkable = this.getCheckable(e.node);
            //            if (this.getOnlyLeafCheckable() && !this.isLeaf(record)) {
            //                e.showCheckBox = false;
            //            }
            //            if (record.checkable === false) {
            //                e.showCheckBox = false;
            //            }
        }
        return e;
    },
    _OnDrawCell: function (record, column, rowIndex, columnIndex) {
        var e = mini.TreeGrid.superclass._OnDrawCell.call(this, record, column, rowIndex, columnIndex);

        if (this._treeColumn && this._treeColumn == column.name) {

            this.fire("drawnode", e);
            if (e.nodeStyle) {
                e.cellStyle = e.nodeStyle;
            }
            if (e.nodeCls) {
                e.cellCls = e.nodeCls;
            }
            if (e.nodeHtml) {
                e.cellHtml = e.nodeHtml;
            }

            this._createTreeColumn(e);
        }
        return e;
    },
    _isViewFirstNode: function (node) {
        if (this._viewNodes) {
            var pnode = this.getParentNode(node);
            var nodes = this._getViewChildNodes(pnode);
            return nodes[0] === node;
        } else {
            return this.isFirstNode(node);
        }
    },
    _isViewLastNode: function (node) {
        if (this._viewNodes) {
            var pnode = this.getParentNode(node);
            var nodes = this._getViewChildNodes(pnode);
            return nodes[nodes.length - 1] === node;
        } else {
            return this.isLastNode(node);
        }
    },
    _isInViewLastNode: function (node, level) {
        if (this._viewNodes) {
            var pnode = null;
            var ans = this.getAncestors(node);
            for (var i = 0, l = ans.length; i < l; i++) {
                var a = ans[i];
                if (this.getLevel(a) == level) {
                    pnode = a;
                }
            }
            if (!pnode || pnode == this.root) return false;
            return this._isViewLastNode(pnode);
        } else {
            return this.isInLastNode(node, level);
        }
    },
    isInLastNode: function (node, level) {
        var pnode = null;
        var ans = this.getAncestors(node);
        for (var i = 0, l = ans.length; i < l; i++) {
            var a = ans[i];
            if (this.getLevel(a) == level) {
                pnode = a;
            }
        }
        if (!pnode || pnode == this.root) return false;
        return this.isLastNode(pnode);
    },
    _createNodeTitle: function (node, sb, e) {
        var isReturn = !sb;
        if (!sb) sb = [];

        var isLeaf = this.isLeaf(node);
        var level = this.getLevel(node);

        var cls = e.nodeCls;

        if (!isLeaf) {
            cls = this.isExpandedNode(node) ? this._expandNodeCls : this._collapseNodeCls;
        }

        if (node.enabled === false) {
            cls += " mini-disabled";
        }
        if (!isLeaf) {
            cls += " mini-tree-parentNode";
        }

        var subNodes = this.getChildNodes(node);
        var hasChilds = subNodes && subNodes.length > 0;

        //sb[sb.length] = '<div class="mini-tree-nodetitle ' + cls + '" style="' + e.nodeStyle + '">';
        sb[sb.length] = '<div class="mini-tree-nodetitle ' + cls + '" >';

        //if (!this.showExpandButtons) level -= 1;

        var parentNode = this.getParentNode(node);
        var ii = 0;
        //if (!this.showExpandButtons && parentNode && !hasChilds) ii = 1;
        for (var i = ii; i <= level; i++) {
            if (i == level) continue;

            if (isLeaf) {
                //if (this.showExpandButtons == false && i >= level - 1) {
                if (i > level - 1) {
                    continue;
                }
            }

            var indentStyle = "";
            if (this._isInViewLastNode(node, i)) {
                indentStyle = "background:none";
            }


            sb[sb.length] = '<span class="mini-tree-indent " style="' + indentStyle + '"></span>';
        }


        var ecCls = "";
        if (this._isViewFirstNode(node) && level == 0) {
            ecCls = "mini-tree-node-ecicon-first";
        } else if (this._isViewLastNode(node)) {
            ecCls = "mini-tree-node-ecicon-last";
        }

        if (this._isViewFirstNode(node) && this._isViewLastNode(node)) {
            ecCls = "mini-tree-node-ecicon-firstAndlast";
            //ecCls = "mini-tree-node-ecicon-last";
            if (parentNode == this.root) {
                ecCls = "mini-tree-node-ecicon-firstLast";
            }
        }

        if (!isLeaf) {
            sb[sb.length] = '<a class="' + this._eciconCls + ' ' + ecCls + '" style="' + (this.showExpandButtons ? "" : "display:none") + '" ' + (mini.isChrome ? "" : 'href="javascript:void(0);"') + ' onclick="return false;" hidefocus></a>';


        } else {
            sb[sb.length] = '<span class="' + this._eciconCls + ' ' + ecCls + '" style="' + (this.showExpandButtons ? "" : "display:none") + '"></span>';
        }


        sb[sb.length] = '<span class="mini-tree-nodeshow mini-corner-all">';
        if (e.showTreeIcon) {
            //if (e.node.id == 'sys') debugger
            if (e.img) {
                var img = this.imgPath + e.img;
                sb[sb.length] = '<span class="mini-tree-icon mini-icon mini-iconfont" style="background-image:url(' + img + ');"></span>';
            } else {
                sb[sb.length] = '<span class="' + e.iconCls + ' mini-tree-icon mini-icon mini-iconfont"></span>';
            }
        }

        if (e.showRadioButton && !e.showCheckBox) {
            sb[sb.length] = '<span class="mini-tree-radio mini-icon" ></span>';
        }

        if (e.showCheckBox) {
            var ckid = this._createCheckNodeId(node);
            var checked = this.isCheckedNode(node);
            var enabled = e.enabled === false ? "disabled" : "";
            if (e.enabled !== false) {
                enabled = e.checkable === false ? "disabled" : "";
            }

            //sb[sb.length] = '<input type="checkbox" id="' + ckid + '" class="' + this._checkBoxCls + '" hidefocus ' + (checked ? "checked" : "") + ' ' + (enabled) + ' onclick="return false;"/>';

            sb[sb.length] = '<span id="' + ckid + '" class="mini-icon ' + this._checkBoxCls + ' ' + (checked ? 'mini-tree-checkbox-checked' : '') + '"></span>';
        }

        sb[sb.length] = '<span class="mini-tree-nodetext">';
        if (this._editingNode == node) {
            var editId = this._id + "$edit$" + node._id;
            var text = e.value;
            sb[sb.length] = '<input id="' + editId + '" type="text" class="mini-tree-editinput" value="' + text + '"/>';
        } else {
            sb[sb.length] = e.cellHtml;
        }

        sb[sb.length] = '</span>';
        sb[sb.length] = '</span>';

        sb[sb.length] = '</div>';


        if (isReturn) return sb.join('');
    },

    _createCheckNodeId: function (node) {
        return this._id + "$checkbox$" + node._id;
    },

    _createTreeColumn: function (e) {
        var node = e.record, column = e.column;

        e.headerCls += ' mini-tree-treecolumn';
        e.cellCls += ' mini-tree-treecell';
        e.cellStyle += ';padding:0;';


        var isLeaf = this.isLeaf(node);


        e.cellHtml = this._createNodeTitle(node, null, e);
        //e.rowCls += ' ' + cls;

        if (node.checked != true && !isLeaf) {//1）父节点；2）没选中
            //		    var checkState = this.getCheckState(node);	 //@@@ 慢死了
            //		    if (checkState == "indeterminate") {

            if (e.showCheckBox) {
                this._renderCheckState(node);
            }
            //}
        }
    },

    //    _createTreeColumn: function (e) {
    //        var node = e.record, column = e.column;

    //        //        if (e.showCheckBox) {
    //        //            node.checkable = true;
    //        //        }        

    //        e.headerCls += ' mini-tree-treecolumn';
    //        e.cellCls += ' mini-tree-treecell';
    //        e.cellStyle += ';padding:0;vertical-align:top;';
    //        //e.cellInnerStyle = 'padding:0px';

    //        var isLeaf = this.isLeaf(node);
    //        var level = this.getLevel(node);

    //        if (!isLeaf) {
    //            e.rowCls += " mini-tree-parentNode";
    //        }

    //        var sb = [];
    //        sb[sb.length] = '<div class="mini-tree-nodetitle" style="padding-left:';
    //        sb[sb.length] = (level + 1) * 18;
    //        sb[sb.length] = 'px;">';
    //        //        e.cellInnerCls = 'mini-tree-nodetitle';
    //        //        e.cellInnerStyle = 'padding-left:' + (level + 1) * 18 + "px";

    //        var left = 0;

    //        for (var i = 0; i <= level; i++) {
    //            if (i == level && !isLeaf) break;
    //            if (this.showTreeLine) {
    //                sb[sb.length] = '<span class="mini-tree-indent " style="left:' + left + 'px;"></span>';
    //            }
    //            left += 18;
    //        }
    //        var cls = "";
    //        if (!isLeaf) {
    //            cls = this.isExpandedNode(node) ? 'mini-tree-expand' : 'mini-tree-collapse';
    //            var _left = mini.isIE6 ? left - 18 * (level+1) : left;
    //            sb[sb.length] = '<span class="mini-tree-ec-icon" style="left:' + (_left) + 'px;"></span>';
    //            left += 18;
    //        }
    //        sb[sb.length] = '<div class="mini-tree-nodeshow">';


    //        if (e.showTreeIcon) {
    //            var icon = e.iconCls;
    //            var _left = mini.isIE6 ? left - 18 * (level+1) : left;
    //            sb[sb.length] = '<div class="' + icon + ' mini-tree-nodeicon" style="left:' + _left + 'px;"></div>';
    //        }
    //        var offset = e.showTreeIcon ? 18 : 0;

    //        if (e.showCheckBox) {
    //            left += 18;
    //            offset += 18;
    //            var id = this._id + "$checkbox$" + node._id;
    //            var checked = node.checked ? "checked" : "";
    //            var checkable = this.getCheckable(node) ? "" : "disabled";
    //            var _left = mini.isIE6 ? left - 18 * (level + 1) : left;
    //            sb[sb.length] = '<input type="' + e.checkBoxType + '" id="' + id + '" ' + checked + ' ' + checkable + ' class="mini-tree-checkbox" style="left:' + _left + 'px;" hideFocus onclick="return false"/>';
    //        }

    //        sb[sb.length] = '<div class="mini-tree-nodetext" style="margin-left:' + offset + 'px;">';
    //        sb[sb.length] = e.cellHtml;
    //        sb[sb.length] = '</div></div></div>';

    //        e.cellHtml = sb.join('');
    //        e.rowCls += ' ' + cls;

    //        if (node.checked != true && !isLeaf) {//1）父节点；2）没选中
    //            var checkState = this.getCheckState(node);
    //            if (checkState == "indeterminate") {
    //                this._renderCheckState(node);
    //            }
    //        }
    //    },
    _renderCheckState: function (node) {
        if (!this._renderCheckStateNodes) this._renderCheckStateNodes = [];
        this._renderCheckStateNodes.push(node);
        if (this._renderCheckStateTimer) return;
        var me = this;
        this._renderCheckStateTimer = setTimeout(function () {

            me._renderCheckStateTimer = null;
            var nodes = me._renderCheckStateNodes;
            me._renderCheckStateNodes = null;
            for (var i = 0, l = nodes.length; i < l; i++) {
                me._doCheckNodeEl(nodes[i]);
            }


        }, 1);
    },
    //创建树形层次HTML：非动态模式时有用
    _createNodeHTML: function (node, columns, viewIndex, sb, hasChild) {
        var isReturn = !sb;
        if (!sb) sb = [];

        var source = this._dataSource;

        //node html
        var rowIndex = source.getDataView().indexOf(node); //数据量大，index有点慢
        this._createRowHTML(node, rowIndex, columns, viewIndex, sb);

        //nodes html
        if (hasChild !== false) {
            var cnodes = source.getChildNodes(node);
            var isVisible = this.isVisibleNode(node);
            if (cnodes && cnodes.length > 0) {
                var isExpand = this.isExpandedNode(node);
                if (isExpand == true) {
                    var style = (isExpand && isVisible) ? "" : "display:none";
                    var nodesId = this._createNodesId(node, viewIndex);
                    sb[sb.length] = '<tr class="mini-tree-nodes-tr" style="';
                    if (mini.isIE) sb[sb.length] = style;
                    //sb[sb.length] = '" ><td style="width:0;"></td><td class="mini-tree-nodes-td" colspan="';
                    sb[sb.length] = '" ><td class="mini-tree-nodes-td" colspan="';
                    sb[sb.length] = columns.length + 1;
                    sb[sb.length] = '" >';

                    sb[sb.length] = '<div class="mini-tree-nodes" id="';
                    sb[sb.length] = nodesId;
                    sb[sb.length] = '" style="';
                    sb[sb.length] = style;
                    sb[sb.length] = '">';
                    this._createNodesHTML(cnodes, columns, viewIndex, sb);
                    sb[sb.length] = '</div>';

                    sb[sb.length] = '</td></tr>';
                }
            }
        }
        if (isReturn) return sb.join('');
    },
    _createNodesHTML: function (nodes, columns, viewIndex, sb) {
        if (!nodes) return '';
        var isReturn = !sb;
        if (!sb) sb = [];

        sb.push('<table class="mini-grid-table" cellspacing="0" cellpadding="0" border="0">');
        sb.push(this._createTopRowHTML(columns, true));

        // 添加 treegrid 空数据效果
        var emptyId = this.uid + "$emptytext" + viewIndex;
        if (viewIndex == 2 && this.type == 'treegrid' && (this._dataSource.loaded || this.alwaysShowEmptyText)) {
            var h = parseInt(
                $(this.el)
                    .find('.mini-grid-rows-view')
                    .height(),
                10
            );
            if (h && h > 200) {
                h = (h * 0.3) >> 0;
            }
            var style = (this.showEmptyText && nodes.length == 0) ? '' : 'display:none;';
            sb.push('<tr id="' + emptyId + '" style="' + style + '"><td style="width:0"></td><td class="mini-grid-emptyText" style="padding-top:' + (h + 80) + 'px;background-position:center ' + h + 'px" colspan="' + columns.length + '">' + this.emptyText + '</td></tr>');
        }
        if (columns.length > 0) {
            for (var j = 0, k = nodes.length; j < k; j++) {
                var node = nodes[j];
                this._createNodeHTML(node, columns, viewIndex, sb);
            }
        }
        sb.push('</table>');
        if (isReturn) return sb.join('');
    },

    _createRowsHTML: function (columns, viewIndex) {
        if (this.isVirtualScroll()) {
            return mini.TreeGrid.superclass._createRowsHTML.apply(this, arguments);
        }

        var source = this._dataSource, me = this;

        var sb = [];

        //第一次进来，不创建节点
        var nodes = [];
        var rootNode = source.getRootNode();
        if (this._useEmptyView !== true) {
            nodes = source.getChildNodes(rootNode);
        }
        //createNodes(nodes);

        var nodesEl = viewIndex == 2 ? this._rowsViewEl.firstChild : this._rowsLockEl.firstChild;
        nodesEl.id = this._createNodesId(rootNode, viewIndex);

        this._createNodesHTML(nodes, columns, viewIndex, sb);

        return sb.join('');
    },
    /////////////////////////////////
    _createNodesId: function (node, viewIndex) {
        var id = this._id + "$nodes" + viewIndex + "$" + node._id;
        return id;
    },
    _getNodeEl: function (node, viewIndex) {
        //if (this.isVisibleNode(node) == false) return null;
        return this._getRowEl(node, viewIndex);
    },
    _getNodesEl: function (node, viewIndex) {
        //if (this.isVisibleNode(node) == false) return null;
        node = this.getNode(node);
        var id = this._createNodesId(node, viewIndex);
        return document.getElementById(id);
    },
    _getNodesTr: function (node, viewIndex) {
        //if (this.isVisibleNode(node) == false) return null;
        var el = this._getNodesEl(node, viewIndex);
        if (el) return el.parentNode.parentNode;
    },
    /////////////////////////////////////////////////

    checkOnTextClick: false,
    setCheckOnTextClick: function (value) {
        this.checkOnTextClick = value;
    },
    getCheckOnTextClick: function () {
        return this.checkOnTextClick;
    },

    setTreeColumn: function (value) {
        this._treeColumn = value;
        this.deferUpdate();
    },
    getTreeColumn: function () {
        return this._treeColumn;
    },
    setShowTreeIcon: function (value) {
        this.showTreeIcon = value;
        this.deferUpdate();
    },
    getShowTreeIcon: function () {
        return this.showTreeIcon;
    },
    setShowCheckBox: function (value) {
        this.showCheckBox = value;
        this.deferUpdate();
    },
    getShowCheckBox: function () {
        return this.showCheckBox;
    },
    setShowRadioButton: function (value) {
        this.showRadioButton = value;
        this.deferUpdate();
    },
    getShowRadioButton: function () {
        return this.showRadioButton;
    },
    setCheckBoxType: function (value) {
        this._checkBoxType = value;
        this._doUpdateCheckState();
    },
    getCheckBoxType: function () {
        return this._checkBoxType;
    },
    setIconsField: function (value) {
        this._iconsField = value;
    },
    getIconsField: function () {
        return this._iconsField;
    },
    //////////////////////////////////
    _getNodeIcon: function (node) {
        var icon = node[this.iconField];
        if (!icon) {
            if (this.isLeaf(node)) icon = this.leafIconCls;
            else icon = this.folderIconCls;
        }
        return icon;
    },
    _getCheckBoxEl: function (node) {
        if (this.isVisibleNode(node) == false) return null;
        var id = this._id + "$checkbox$" + node._id;
        return mini.byId(id, this.el);
    },
    setCanCheckParent: function (canCheckParent) {
        this.canCheckParent = canCheckParent;
        this.setCheckRecursive(!canCheckParent);
    },
    getCanCheckParent: function () {
        return this.canCheckParent;
    },
    //////////////////////////

    //    setRootNodeText: function (value) {
    //        var node = this.getRootNode();
    //        node[this._textField] = value;
    //        this._doUpdateRowEl(node);
    //    },

    //////////////////////////
    useAnimation: true,
    _updateNodeTimer: null,
    _doExpandCollapseNode: function (node) {
        var that = this;
        if (that._updateNodeTimer) {
            clearTimeout(that._updateNodeTimer);
            that._updateNodeTimer = null;
        }

        var sss = new Date();
        if (this.isVirtualScroll() == true) {
            //this._stopDeferUpdate();
            if (!this._updateTimer) {	//不能有deferUpdate,以及吱声
                that._updateNodeTimer = setTimeout(function () {
                    that._updateNodeTimer = null;

                    that.doUpdateRows();         //30条，55ms
                    //this._stopUpdateTableView();
                    that.deferLayout(50);
                }, 5);
            }
            //                    setTimeout(function () {
            //                        alert(new Date() - sss);
            //                    }, 20);
            return;
        }

        //

        function onCallback() {
            this._doUpdateTreeNodeEl(node);
            this.deferLayout(20);
        }

        //this._layoutColumns(30);

        //////////////////////////////////////////////////////////////////////
        //if (this._inAniming) {

        if (false || mini.isIE6 || !this.useAnimation || this.isFrozen()) {        //ie6不显示动画
            onCallback.call(this);
        } else {
            var expanded = this.isExpandedNode(node);
            function doExpandAnim(node, viewIndex, onCallback) {
                var nodesEl = this._getNodesEl(node, viewIndex);
                if (nodesEl) {
                    var h = mini.getHeight(nodesEl);
                    nodesEl.style.overflow = "hidden";
                    nodesEl.style.height = "0px";
                    var config = { height: h + "px" };
                    var sf = this;
                    sf._inAniming = true;

                    //setTimeout(function () {
                    var jq = jQuery(nodesEl);
                    jq.animate(
                            config,
                            250,
                            function () {
                                nodesEl.style.height = "auto";
                                sf._inAniming = false;
                                sf.doLayout();
                                mini.repaint(nodesEl);
                            }
                        );
                    //}, 1);
                } else {
                    //onCallback.call(this);
                }
            }
            function doCollapseAnim(node, viewIndex, onCallback) {
                var nodesEl = this._getNodesEl(node, viewIndex);
                if (nodesEl) {
                    var h = mini.getHeight(nodesEl);
                    var config = { height: 0 + "px" };
                    var sf = this;
                    sf._inAniming = true;
                    var jq = jQuery(nodesEl);
                    jq.animate(
                        config,
                        180,
                        function () {
                            nodesEl.style.height = "auto";
                            sf._inAniming = false;
                            if (onCallback) onCallback.call(sf);
                            sf.doLayout();
                            mini.repaint(nodesEl);

                        }
                    );
                } else {
                    if (onCallback) onCallback.call(this);
                }
            }

            var that = this;
            if (expanded) {
                onCallback.call(this);
                doExpandAnim.call(this, node, 2);
                doExpandAnim.call(this, node, 1);
            } else {
                doCollapseAnim.call(this, node, 2, onCallback);
                doCollapseAnim.call(this, node, 1);
            }
        }
    },
    __OnTreeCollapse: function (e) {
        this._doExpandCollapseNode(e.node);
    },
    __OnTreeExpand: function (e) {
        this._doExpandCollapseNode(e.node);
    },
    _doCheckNodeEl: function (node) {
        //        var ck = this._getCheckBoxEl(node);
        //        if (ck) {
        //            
        //        }
        //alert(1);
        var ck = this._getCheckBoxEl(node);
        if (ck) {
            var checkModel = this.getCheckModel();
            //            ck.checked = node.checked;
            //            ck.indeterminate = false;
            mini.removeClass(ck, "mini-tree-checkbox-indeterminate");

            var isIndeterminate = node.indeterminate && !node.checked;

            if (checkModel == "cascade" || isIndeterminate) {
                var checkState = isIndeterminate ? "indeterminate" : this.getCheckState(node);
                if (checkState == "indeterminate") {
                    //ck.indeterminate = true;
                    mini.addClass(ck, "mini-tree-checkbox-indeterminate");
                } else {
                    //ck.indeterminate = false;
                    mini.removeClass(ck, "mini-tree-checkbox-indeterminate");
                }
            }

            if (node.checked) {
                mini.addClass(ck, "mini-tree-checkbox-checked");
            } else {
                mini.removeClass(ck, "mini-tree-checkbox-checked");
            }

        }

    },
    __OnCheckChanged: function (e) {

        //var checkModel = this.getCheckModel();
        for (var i = 0, l = e._nodes.length; i < l; i++) {
            var node = e._nodes[i];
            this._doCheckNodeEl(node);
            //            var ck = this._getCheckBoxEl(node);
            //            if (ck) {
            //                ck.checked = node.checked;

            //                if (checkModel == "cascade") {
            //                    var checkState = this.getCheckState(node);
            //                    if (checkState == "indeterminate") {
            //                        ck.indeterminate = true;
            //                    } else {
            //                        ck.indeterminate = false;
            //                    }
            //                }
            //            }
        }

        if (this._checkChangedTimer) {
            clearTimeout(this._checkChangedTimer);
            this._checkChangedTimer = null;
        }
        var me = this;
        this._checkChangedTimer = setTimeout(function () {
            me._checkChangedTimer = null;
            //////me.fire("checkchanged", { nodes: e.nodes, checked: e.checked });
            me.fire("_checkchanged");      //@刚注释
        }, 1);

    },
    /////////////////////////////////
    //    _doMoveRowEl: function (row, index) {
    //    debugger
    //        this._doRemoveRowEl(row);
    //        this._doAddRowEl(row);
    //    },
    /////////////////////////////////
    //    _doUpdateCheckState: function () {
    //        //第三态
    //        //autoCheckParent

    //    },
    _tryToggleCheckNode: function (node) {
        if (node.enabled === false) return;

        var checkable = this.getCheckable(node);
        if (checkable == false) return;

        var checked = this.isCheckedNode(node);

        var e = { node: node, cancel: false, checked: checked, isLeaf: this.isLeaf(node) };
        this.fire("beforenodecheck", e);
        if (e.cancel) return;

        this._dataSource.doCheckNodes(node, !checked, true);
        //        if (this.getAutoCheckParent()) {
        //        
        //            this._dataSource.doCheckNodes(node, !checked, true);
        //        } else {
        //            this._dataSource.doCheckNodes(node, !checked, true);
        //        }
        //        this._doUpdateCheckState();
        this.fire("nodecheck", e);
    },
    _tryToggleNode: function (node) {
        var isExpanded = this.isExpandedNode(node);
        var e = { node: node, cancel: false };

        if (isExpanded) {
            this.fire("beforecollapse", e);
            if (e.cancel == true) return;
            this.collapseNode(node);

            e.type = "collapse";
            this.fire("collapse", e);
        } else {
            this.fire("beforeexpand", e);
            if (e.cancel == true) return;
            this.expandNode(node);

            e.type = "expand";
            this.fire("expand", e);
        }
    },
    _OnCellMouseDown: function (e) {
        //if (mini.findParent(e.htmlEvent.target, 'mini-tree-editinput')) return;
        if (mini.findParent(e.htmlEvent.target, this._eciconCls)) {
        } else if (mini.findParent(e.htmlEvent.target, 'mini-tree-checkbox')) {
        } else {
            this.fire("cellmousedown", e);
        }
    },
    _OnCellClick: function (e) {
        //if (mini.findParent(e.htmlEvent.target, 'mini-tree-editinput')) return;
        //        if (mini.findParent(e.htmlEvent.target, this._eciconCls)) {
        //            //this._tryToggleNode(e.record);
        //        } else 
        if (mini.findParent(e.htmlEvent.target, this._eciconCls)) return;


        if (mini.findParent(e.htmlEvent.target, 'mini-tree-checkbox') || mini.findParent(e.htmlEvent.target, 'mini-checkcolumn') || this.checkOnTextClick) {
            this._tryToggleCheckNode(e.record);
        } else {
            this.fire("cellclick", e);
        }
    },
    __OnNodeDblClick: function (e) {
        //        if (this.expandOnDblClick && !e.isLeaf && !this._inAniming) {
        //            this._tryToggleNode(e.node);
        //        }
    },
    __OnNodeClick: function (e) {
        //        if (this.expandOnNodeClick && !e.isLeaf && !this._inAniming) {
        //            this._tryToggleNode(e.node);
        //        }
    },
    ////////////////////////////////////////////////////////////////////
    setNodeText: function (node, text) {
        node = this.getNode(node);
        if (!node) return;
        var obj = {};
        obj[this.getTextField()] = text;
        this.updateNode(node, obj);
        //        node[this.getTextField()] = text;
        //        this._doUpdateNodeTitle(node);
        //this._changed = true;
    },
    setNodeIconCls: function (node, iconCls) {
        node = this.getNode(node);
        if (!node) return;
        var obj = {};
        obj[this.iconField] = iconCls;
        this.updateNode(node, obj);
        //        node[this.iconField] = iconCls;
        //        this._doUpdateNodeTitle(node);
        //this._changed = true;
    },
    setIconField: function (value) {
        this.iconField = value;
    },
    getIconField: function () {
        return this.iconField;
    },
    setAllowSelect: function (value) {
        this.setAllowRowSelect(value);
    },
    getAllowSelect: function () {
        return this.getAllowRowSelect();
    },
    setShowExpandButtons: function (value) {
        if (this.showExpandButtons != value) {
            this.showExpandButtons = value;
            this.doUpdate();
        }
    },
    getShowExpandButtons: function () {
        return this.showExpandButtons;
    },
    setShowTreeLines: function (value) {
        this.showTreeLines = value;
        if (value == true) {
            mini.addClass(this.el, 'mini-tree-treeLine');
        } else {
            mini.removeClass(this.el, 'mini-tree-treeLine');
        }
    },
    getShowTreeLines: function () {
        return this.showTreeLines;
    },
    setShowArrow: function (value) {
        this.showArrow = value;
        if (value == true) {
            mini.addClass(this.el, 'mini-tree-showArrows');
        } else {
            mini.removeClass(this.el, 'mini-tree-showArrows');
        }
    },
    getShowArrow: function () {
        return this.showArrow;
    },
    setLeafIcon: function (value) {
        this.leafIcon = value;
    },
    getLeafIcon: function () {
        return this.leafIcon;
    },
    setFolderIcon: function (value) {
        this.folderIcon = value;
    },
    getFolderIcon: function () {
        return this.folderIcon;
    },
    getExpandOnDblClick: function () {
        return this.expandOnDblClick;
    },
    setExpandOnNodeClick: function (value) {
        this.expandOnNodeClick = value;
        if (value) {
            mini.addClass(this.el, "mini-tree-nodeclick");
        } else {
            mini.removeClass(this.el, "mini-tree-nodeclick");
        }
    },
    getExpandOnNodeClick: function () {
        return this.expandOnNodeClick;
    },
    setLoadOnExpand: function (value) {
        this.loadOnExpand = value;
    },
    getLoadOnExpand: function () {
        return this.loadOnExpand;
    },

    hideNode: function (node) {
        node = this.getNode(node);
        if (!node) return;
        node.visible = false;

        this._doUpdateTreeNodeEl(node);

        var el1 = this._getNodeEl(node, 1);
        var el2 = this._getNodeEl(node, 2);
        var el3 = this._getNodeEl(node, 3);
        if (el1) el1.style.display = "none";
        if (el2) el2.style.display = "none";
        if (el3) el3.style.display = "none";

    },
    showNode: function (node) {

        node = this.getNode(node);
        if (!node) return;
        node.visible = true;

        this._doUpdateTreeNodeEl(node);
        //        var el = this._getNodeEl(node);
        //        el.style.display = "";
    },
    enableNode: function (node) {
        node = this.getNode(node);
        if (!node) return;
        node.enabled = true;

        var el1 = this._getNodeEl(node, 1);
        var el2 = this._getNodeEl(node, 2);
        if (el1) mini.removeClass(el1, "mini-disabled");
        if (el2) mini.removeClass(el2, "mini-disabled");
        var ck = this._getCheckBoxEl(node);
        if (ck) ck.disabled = false;
    },
    disableNode: function (node) {
        node = this.getNode(node);
        if (!node) return;

        node.enabled = false;
        var el1 = this._getNodeEl(node, 1);
        var el2 = this._getNodeEl(node, 2);
        if (el1) mini.addClass(el1, "mini-disabled");
        if (el2) mini.addClass(el2, "mini-disabled");

        var ck = this._getCheckBoxEl(node);
        if (ck) ck.disabled = true;
    },



    imgPath: '',
    setImgPath: function (value) {
        this.imgPath = value;
    },
    getImgPath: function () {
        return this.imgPath;
    },
    imgField: 'img',
    setImgField: function (value) {
        this.imgField = value;
    },
    getImgField: function () {
        return this.imgField;
    },

    ////////////////////////////////////////////////////////////////////
    // HTML Tags
    ////////////////////////////////////////////////////////////////////    
    getAttrs: function (el) {
        var attrs = mini.TreeGrid.superclass.getAttrs.call(this, el);

        mini._ParseString(el, attrs,
            ["value", "url", "idField", "textField", "iconField", "nodesField", "parentField", "valueField", "checkedField",
            "leafIcon", "folderIcon", "leafField",
            "ondrawnode", "onbeforenodeselect", "onnodeselect", "onnodemousedown", "onnodeclick", "onnodedblclick",
                "onbeforenodecheck", "onnodecheck",
                "onbeforeexpand", "onexpand", "onbeforecollapse", "oncollapse",
                "dragGroupName", "dropGroupName", "onendedit",
                "expandOnLoad", "ondragstart", "onbeforedrop", "ondrop", "ongivefeedback",
                "treeColumn", "onaddnode", "onremovenode", "onmovenode", "imgPath", "imgField", "hoverMode"
             ]
        );

        mini._ParseBool(el, attrs,
            ["allowSelect", "showCheckBox", "showRadioButton", "showExpandButtons", "showTreeIcon", "showTreeLines", "checkRecursive",
                "enableHotTrack", "showFolderCheckBox", "resultAsTree",
                "allowDrag", "allowDrop", "showArrow", "expandOnDblClick", "removeOnCollapse",
                "autoCheckParent", "loadOnExpand", "expandOnNodeClick", "useAnimation", "checkOnTextClick", "canCheckParent"
             ]
        );

        if (attrs.expandOnLoad) {
            var level = parseInt(attrs.expandOnLoad);
            if (mini.isNumber(level)) {
                attrs.expandOnLoad = level;
            } else {
                attrs.expandOnLoad = attrs.expandOnLoad == "true" ? true : false;
            }
        }

        var idField = attrs.idField || this.getIdField();
        var textField = attrs.textField || this.getTextField();
        var iconField = attrs.iconField || this.getIconField();
        var nodesField = attrs.nodesField || this.getNodesField();

        function parseNodes(nodes) {
            var data = [];

            for (var i = 0, l = nodes.length; i < l; i++) {
                var node = nodes[i];
                var cnodes = mini.getChildNodes(node);
                var nodeTitle = cnodes[0];
                var nodeChild = cnodes[1];

                if (!nodeTitle || !nodeChild) nodeTitle = node;
                var jqTitle = jQuery(nodeTitle);
                var o = {};
                var id = o[idField] = nodeTitle.getAttribute("value"); //jqTitle.attr("value");

                o[iconField] = jqTitle.attr("iconCls");
                o[textField] = nodeTitle.innerHTML;
                data.add(o);

                //if(nodeTitle.innerHTML == "所有客户") debugger

                var expanded = jqTitle.attr("expanded");
                if (expanded) {
                    o.expanded = expanded == "false" ? false : true;
                }

                var allowSelect = jqTitle.attr("allowSelect");
                if (allowSelect) {
                    o.allowSelect = allowSelect == "false" ? false : true;
                }

                if (!nodeChild) continue;
                var cs = mini.getChildNodes(nodeChild);
                var cdata = parseNodes(cs);
                if (cdata.length > 0) {
                    o[nodesField] = cdata;
                }
            }
            return data;
        }

        var data = parseNodes(mini.getChildNodes(el));
        if (data.length > 0) {
            attrs.data = data;
        }

        if (!attrs.idField && attrs.valueField) {
            attrs.idField = attrs.valueField;
        }
        return attrs;
    }
});

mini.regClass(mini.TreeGrid, "TreeGrid");


//Tree
mini.Tree = function () {
    mini.Tree.superclass.constructor.apply(this, arguments);

    var columns = [
        { name: "node", header: "", field: this.getTextField(), width: 'auto', allowDrag: true,
            //autoEscape: false,
            editor: { type: "textbox" }
        }
    ];
    this._columnModel.setColumns(columns);
    this._column = this._columnModel.getColumn("node");

    mini.removeClass(this.el, 'mini-treegrid');
    mini.addClass(this.el, 'mini-tree-nowrap');
    this.setBorderStyle("border:0"); 
};
mini.extend(mini.Tree, mini.TreeGrid, {

    //    _hasSpaceTd: function () {
    //        return !(mini.isIE6 || mini.isIE7);
    //    },

    _userEmptyTd: (mini.isChrome || mini.isIE6 || mini.isIE7) ? false : true,

    setTextField: function (value) {
        this._dataSource.setTextField(value);
        this._columnModel.updateColumn('node', { field: value });
        this.textField = value;
    },

    uiCls: "mini-tree",

    hoverMode: 'title',

    _rowHoverCls: "mini-tree-node-hover",
    _rowSelectedCls: "mini-tree-selectedNode",
    _getRecordByEvent: function (e, inNodeShow) {
        
        if (this.hoverMode == 'node') inNodeShow = false;

        var row = mini.Tree.superclass._getRecordByEvent.call(this, e);
        if (inNodeShow === false) return row;
        if (row && mini.findParent(e.target, "mini-tree-nodeshow")) {
            return row;
        }
        return null;
    },

    _treeColumn: "node",
    //_fitColumns: false,

    defaultRowHeight: 51,
    _getRowHeight: function (record) {
        var h = this.defaultRowHeight;
        if (record._height) {
            h = parseInt(record._height);
            if (isNaN(parseInt(record._height))) h = rowHeight;
        }
        //        h -= 4; //padding-top/padding-bottom
        //        //if (!mini.isOpera) {
        //        h -= 1;
        //}
        return h;
    },

    showHeader: false,
    showTopbar: false,
    showFooter: false,
    showColumns: false,

    showHGridLines: false,
    showVGridLines: false,

    showTreeLines: true,

    setTreeColumn: null,
    setColumns: null,
    getColumns: null,

    frozen: null,
    unFrozen: null,

    showModified: false,

    /////////////////////////////

    /////////////////////////////
    _OnCellMouseDown: function (e) {
        if (this._editInput) this._editInput.blur();
        this.fire("cellmousedown", e);
    },

    beginEdit: function (node) {
        node = this.getNode(node);
        if (!node) return;

        var column = this.getColumn(0);
        var value = mini._getMap(column.field, node);
        var e = { record: node, node: node, column: column, field: column.field, value: value, cancel: false };
        this.fire("cellbeginedit", e);
        if (e.cancel == true) return;

        this._editingNode = node;
        this._doUpdateNodeTitle(node);


        var that = this;
        function doEdit() {
            var editId = that._id + "$edit$" + node._id;
            that._editInput = document.getElementById(editId);

            that._editInput.focus();

            mini.selectRange(that._editInput, 0, 1000);
            mini.on(that._editInput, "keydown", that.__OnEditInputKeyDown, that);
            mini.on(that._editInput, "blur", that.__OnEditInputBlur, that);
        }
        setTimeout(function () {
            doEdit();
        }, 100);
        doEdit();
    },
    cancelEdit: function (update) {
        var node = this._editingNode;
        this._editingNode = null;
        if (node) {
            if (update !== false) this._doUpdateNodeTitle(node);
            mini.un(this._editInput, "keydown", this.__OnEditInputKeyDown, this);
            mini.un(this._editInput, "blur", this.__OnEditInputBlur, this);
        }
        this._editInput = null;
        //this.fire("endedit", {node: });
    },
    __OnEditInputKeyDown: function (e) {
        if (e.keyCode == 13) {
            var node = this._editingNode;
            var text = this._editInput.value;
            this._editingNode = null;
            this.setNodeText(node, text);
            this.cancelEdit(false);
            this.fire("endedit", { node: node, text: text });
        } else if (e.keyCode == 27) {
            this.cancelEdit();
        }
    },
    __OnEditInputBlur: function (e) {
        //if (mini.findParent(e.target, 'mini-tree-editinput')) return;
        var node = this._editingNode;
        if (node) {
            var text = this._editInput.value;
            this.cancelEdit();
            this.setNodeText(node, text);
            this.fire("endedit", { node: node, text: text });
        }
    },
    /////////////////////////
    //ie6 bug
    addRowCls: function (row, cls) {
        var d1 = this._getRowEl(row, 1);
        var d2 = this._getRowEl(row, 2);
        if (d1) mini.addClass(d1, cls);
        if (d2) mini.addClass(d2, cls);

        //fix ie6/7
        if (d1) mini.addClass(d1.cells[1], cls);
        if (d2) mini.addClass(d2.cells[1], cls);
    },
    removeRowCls: function (row, cls) {
        var d1 = this._getRowEl(row, 1);
        var d2 = this._getRowEl(row, 2);
        if (d1) {
            mini.removeClass(d1, cls);
        }
        if (d2) {
            mini.removeClass(d2, cls);
        }

        //fix ie6/7     hover,seleced 没效果，必须加载td上才可以
        if (d1) mini.removeClass(d1.cells[1], cls);
        if (d2) mini.removeClass(d2.cells[1], cls);
    },
    scrollIntoView: function (node) {
        node = this.getNode(node);
        if (!node) return;

        if (!this.isVisibleNode(node)) {
            this.expandPath(node);
        }
        var that = this;
        setTimeout(function () {
//            var itemEl = that._getNodeEl(node, 2);
//            mini.scrollIntoView(itemEl, that._rowsViewEl, false);
            
            if (that.isVirtualScroll()) {
                mini.Tree.superclass.scrollIntoView.call(that, node);
            } else {

                var itemEl = that._getNodeEl(node, 2);
                mini.scrollIntoView(itemEl, that._rowsViewEl, false);
            }

        }, 10);
    }
});
mini.regClass(mini.Tree, "Tree");

/////////////////////////////////////////
//1)树折叠
mini._Tree_Expander = function (grid) {
    this.owner = grid;

    mini.on(grid.el, "click", this.__OnClick, this);
    mini.on(grid.el, "dblclick", this.__OnDblClick, this);    
}
mini._Tree_Expander.prototype = {
    _canToggle: function () {
        return !this.owner._dataSource._isNodeLoading();
    },
    __OnClick: function (e) {
        var tree = this.owner;
        var node = tree._getRecordByEvent(e, false);
        if (!node || node.enabled === false) return;
        if (mini.findParent(e.target, 'mini-tree-checkbox')) return;

        var isLeaf = tree.isLeaf(node);

        if (mini.findParent(e.target, tree._eciconCls)) {
            if (this._canToggle() == false) return;
            tree._tryToggleNode(node);
        }
        else if (tree.expandOnNodeClick && !isLeaf && !tree._inAniming) {
            if (this._canToggle() == false) return;
            tree._tryToggleNode(node);
        }
    },
    __OnDblClick: function (e) {

        var tree = this.owner;
        var node = tree._getRecordByEvent(e, false);
        if (!node || node.enabled === false) return;

        if (tree.isEditingNode(node)) return

        var isLeaf = tree.isLeaf(node);

        if (tree._inAniming) return;

        if (mini.findParent(e.target, tree._eciconCls)) {
            return;
        }
        if (mini.findParent(e.target, "mini-tree-checkbox")) {
            return;
        }
        if (tree.expandOnNodeClick) {
            return;
        }
        if (tree.expandOnDblClick && !isLeaf) {
            if (this._canToggle() == false) return;
            e.preventDefault();
            tree._tryToggleNode(node);
        }

    }
}
//2)异步加载子节点
mini._Tree_AsyncLoader = function (grid) {
    this.owner = grid;
    //grid.on("beforeexpand", this.__OnBeforeNodeExpand, this);
    grid.on("expand", this.__OnBeforeNodeExpand, this);
}
mini._Tree_AsyncLoader.prototype = {
    __OnBeforeNodeExpand: function (e) {
        var tree = this.owner;
        var node = e.node;
        var isLeaf = tree.isLeaf(node);
        var cs = node[tree.getNodesField()];
        
        if (!isLeaf && (!cs || cs.length == 0)) {
            if (tree.loadOnExpand && node.asyncLoad !== false) {
                e.cancel = true;
                tree.loadNode(node);
            }
        }
    }
}

// 因数据被转义 验证的时候要还原
mini.DataGrid.prototype.validateCell = mini_DataGrid_CellValidator_Prototype.validateCell = function validateCell(
    row,
    column
) {
    row = this.getNode ? this.getNode(row) : this.getRow(row);
    column = this.getColumn(column);
    if (!row || !column || column.visible == false) return;
    var value = mini._getMap(column.field, row);
    var e = {
        record: row,
        row: row,
        node: row,
        column: column,
        field: column.field,
        value: mini.htmlUnescape(value),
        isValid: true,
        errorText: ''
    };

    if (column.vtype) {
        mini._ValidateVType(column.vtype, e.value, e, column);
    }
    //唯一列值处理unique：遍历行，满足条件，遍历行
    if (e.isValid == true && column.unique && column.field) {
        var maps = {};
        var data = this.data,
            field = column.field;
        for (var i = 0, l = data.length; i < l; i++) {
            var o = data[i];
            var v = o[field];
            //if (mini.isNull(v) || v === "") {
            if (mini.isNull(v) || String(v).trim() === '') {} else {
                var old = maps[v];
                if (old && o == row) {
                    e.isValid = false;
                    e.errorText = mini._getErrorText(column, 'uniqueErrorText');

                    //上面的也是
                    this.setCellIsValid(old, column, e.isValid, e.errorText);
                    break;
                }
                maps[v] = o;
            }
        }
    }

    this.fire('cellvalidation', e);
    this.setCellIsValid(row, column, e.isValid, e.errorText);
};

mini.overwrite(mini.DataGrid, {
    pageSize: (window.EpFrameSysParams && EpFrameSysParams.ui_grid_pagesize) || 10,
    getExtraAttrs: function(el) {
        var attrs = {};
        mini._ParseBool(el, attrs, ['holdSelectedStatus']);

        return attrs;
    }
});


// 表格的pageSize是继承于mini.DataTable的，所以必须也要重写mini.DataTable的pageSize
mini.overwrite(mini.DataTable, {
    pageSize: (window.EpFrameSysParams && EpFrameSysParams.ui_grid_pagesize) || 10
});

/**
 * 修复在IE下表格内编辑器首次点击时，弹出位置不对的问题
 * 后续原因定位为在IE下使用jQuery设置offset时，jq方法内部获取浏览器原生的元素计算后样式的对象中存在问题
 * author: chends
 * date: 2017-08-11
 */
(function () {
    // 非IE无需处理
    if (!mini.isIE) return;

    // 记录原来的方法
    var originalFn = mini.DataGrid.prototype._setEditorBox;

    // 加入是否为首次的标识，并重写设置编辑器容器位置的方法
    mini.overwrite(mini.DataGrid, {
        _isInitEditorWrap: true,
        _setEditorBox: function (editor, cellBox) {
            // 如果是首次加载，则调用两次
            if (this._isInitEditorWrap) {
                originalFn.call(this, editor, cellBox);
                originalFn.call(this, editor, cellBox);

                this._isInitEditorWrap = false;
                // 完成后为不必要的判断，再重新将此方法置换为原来的方法
                // mini.DataGrid.prototype._setEditorBox = originalFn; // 不能这么写，直接修改原型会导致一个页面上存在多个表格时，其他表格首次出现不正常
                this._setEditorBox = originalFn; // 换种处理方式 将原来原型上的方法直接加到这个实例对象上，之后访问时优先使用自己的，从而避免不不要的判断。
            } else {
                originalFn.call(this, editor, cellBox);
            }
        }
    });

})();
mini.overwrite(mini.Form, {
    getValidateFields: function(disableValid) {
        function isDisplay(control) {
            return mini.isDisplay(control.el, function(p) {
                // 手风琴布局中隐藏的还是需要验证的
                if (mini.hasClass(p, 'mini-tabs-body') || mini.hasClass(p, 'fui-acc-bd') || mini.hasClass(p, 'invisible')) return true;
            });
        }

        var fields = [];
        var controls = this.getFields();
        for (var i = 0, l = controls.length; i < l; i++) {
            var control = controls[i];
            if (!control.validate || !control.isDisplay) continue;
            if (isDisplay(control) || control.forceValidate) {
                //

                if (control.enabled || disableValid || control.forceValidate) {
                    fields.push(control);
                }
            }
        }
        return fields;
    },
    
    getErrors: function () {
        var errors = [];
        // var controls = this.getFields();
        var controls = this.getValidateFields();
        for (var i = 0, l = controls.length; i < l; i++) {
            var control = controls[i];
            if (!control.isValid) continue;
            if (control.isValid() == false) {
                errors.push(control);
            }
        }
        return errors;
    }
});

mini.overwrite(mini.MessageBox, {
    /**
     * 显示提示框。别名为 {@link mini#showMessageBox}
     *
     *     @example
     *     mini.showMessageBox({
     *         title: "消息提示框",
     *         message: "你好， 这是一个消息提示框中的内容描述。",
     *         buttons: ["ok", "no", "cancel"],
     *         iconCls: "mini-messagebox-question",
     *         callback: function(action){
     *         }
     *     });
     *
     * @param {Object} options 提示框的设置选项
     * @param {Number/String} [options.width="auto"] 宽度。可以是一个数值或百分比，值为数值时，单位为像素
     * @param {Number/String} [options.height="auto"] 高度。可以是一个数值或百分比，值为数值时，单位为像素
     * @param {String} [options.customCls="diyclass"] 类名，整体消息框添加类名，可用于个性化样式
     * @param {Boolean} [options.showModal = true] 是否显示为模态消息框
     * @param {Number} [options.timeout = 0] 值大于 0 时，消息框将在 `timeout` 毫秒后自动关闭
     * @param {Number} [options.minWidth = 150] 最小宽度，单位为像素
     * @param {Number} [options.maxWidth = 800] 最大宽度，单位为像素
     * @param {Number} [options.minHeight = 50] 最小高度，单位为像素
     * @param {Number} [options.maxHeight = 350] 最大高度，单位为像素
     * @param {Boolean} [options.showHeader = true] 是否显示标题栏
     * @param {[number, number]} [options.offset = [0, 0]] 基于对齐位置的水平、垂直方向偏移量
     * @param {String} [options.title = ""] 标题
     * @param {String} [options.titleIcon = ""] 标题栏图标样式类
     * @param {String} [options.iconCls = ""] 消息内容左侧图标的样式类，如：
     *          `"mini-messagebox-info"`、`"mini-messagebox-warning"`、`"mini-messagebox-question"`、`"mini-messagebox-error"`、`"mini-messagebox-download"`、
     * @param {String} [options.iconStyle = ""] 标题栏样式
     * @param {String} [options.message = ""] 消息内容
     * @param {String/HTMLElement} [options.html = ""] HTML 源码形式的消息内容
     * @param {String} [options.spaceStyle = "margin-right:15px"]
     * @param {Boolean} [options.showCloseButton = true] 是不显示关闭按钮
     * @param {Array} [options.buttons = null] 按钮数组，可以是 DOM 节点或 `mini.MessageBox.buttonText.*` 即：`"ok"`、`"cancel"`、`"yes"`、`"no"` 等
     * @param {Object} [options.buttonText = {ok: "确定",cancel: "取消",yes: "是",no: "否"}] 按钮文字 默认值为{ok: "确定",cancel: "取消",yes: "是",no: "否"}
     * @param {Number} [options.buttonWidth =]
     * @param {Function} [options.callback =]
     * @return {String} 消息框的唯一标识符
     * @member mini.MessageBox
     */
    show: function (options) {
        options = mini.copyTo({
                width: '360',
                height: '145',
                customCls: '',
                showModal: true,
                timeout: 0,
                minWidth: 150,
                maxWidth: 800,
                minHeight: 50,
                maxHeight: 350,
                showHeader: true,
                title: '',
                titleIcon: '',
                iconCls: '',
                iconStyle: '',
                message: '',
                html: '',
                spaceStyle: '',
                showCloseButton: true,
                buttons: null,
                buttonWidth: null,
                callback: null,
                // 是否显示"不再提示"选项
                // NOTE: "不再提示"的逻辑通过clickNoTipCheck来实现，而不是放在组件内部，因为与具体业务需求耦合
                showNoTipCheck: false,
                // 点击"不再提示"回调
                clickNoTipCheck: false
            },
            options
        );
        if (!options.buttonText) {
            options.buttonText = {};
        }
        options.buttonText = jQuery.extend({}, mini.MessageBox.buttonText, options.buttonText);
        if (options.autoFocus === undefined) {
            options.autoFocus = mini.MessageBox.autoFocus;
        }
        options.message = String(options.message);
        var callback = options.callback;

        var control = options.control || new mini.Window();
        // 添加自定义 class 样式
        if (options.customCls) {
            control.addCls(options.customCls);
        }

        control.addCls('mini-messagebox');
        control.setBodyStyle('overflow:hidden');
        control.setShowModal(options.showModal);
        control.setTitle(options.title || '');
        control.setIconCls(options.titleIcon);
        control.setShowHeader(options.showHeader);

        control.setShowCloseButton(options.showCloseButton);

        var id1 = control.uid + '$table',
            id2 = control.uid + '$content';

        // var icon = '<div class="' + options.iconCls + '" style="' + options.iconStyle + '"></div>';
        // var s = '<table class="mini-messagebox-table" id="' + id1 + '" style="" cellspacing="0" cellpadding="0"><tr><td>'
        //         + icon + '</td><td id="' + id2 + '" class="mini-messagebox-content-text">'
        //         + (options.message || "") + '</td></tr></table>';

        //var s = "";
        //control.setShowHeader(false);

        // 重写content中的dom结构
        var s =
            '<i class="mini-messagebox-icon mini-iconfont ' +
            options.iconCls +
            '" style="' +
            options.iconStyle +
            '"></i>' +
            '<p class="mini-messagebox-msg">' +
            (options.message || '') +
            '</p>';
        var ws = '<div class="mini-messagebox-content"></div>' + '<div class="mini-messagebox-buttons"></div>';
        control._bodyEl.innerHTML = ws;
        var contentEl = control._bodyEl.firstChild;
        if (options.html) {
            if (typeof options.html === 'string') {
                contentEl.innerHTML = options.html;
            } else if (mini.isElement(options.html)) {
                contentEl.appendChild(options.html);
            }
        } else {
            contentEl.innerHTML = s;

            // 记录下内容元素
            control._content = contentEl.lastChild;
        }
        // 不再提醒
        if (options.showNoTipCheck) {
            var foot = control._bodyEl.lastChild;
            foot.innerHTML = '<label class="mini-messagebox-checkbox"><input type="checkbox">' + epoint_local.no_longer_tips + '</label>';

            mini.on(foot.firstChild, 'click', function () {
                if (options.clickNoTipCheck) {
                    var checked = this.firstChild.checked;

                    options.clickNoTipCheck.apply(this, [checked]);
                }
            });
        }

        control._Buttons = [];

        var buttonsEl = control._bodyEl.lastChild;
        if (options.buttons && options.buttons.length > 0) {
            for (var i = 0, l = options.buttons.length; i < l; i++) {
                var button = options.buttons[i];
                var text = options.buttonText[button];
                if (!text) text = button;

                var btn = new mini.Button();
                btn.setText(text);
                btn.setWidth(options.buttonWidth);
                btn.render(buttonsEl);
                btn.action = button;
                btn.on('click', function (e) {
                    var button = e.sender;
                    if (callback && callback(button.action) === false) {
                        return;
                    }
                    
                    mini.MessageBox.hide(control);
                });

                if (i != l - 1) {
                    btn.setStyle(options.spaceStyle);
                }

                // 给button设置样式
                btn.setCls('mini-messagebox-button');
                // ok的button特殊处理
                if (button == 'ok') {
                    btn.addCls('ok');
                    btn.setState('primary');
                } else {
                    btn.setGhost(true);
                }

                control._Buttons.push(btn);
            }
        } else {
            mini.addClass(control._bodyEl, 'no-btn');
        }
        if (Array.isArray(options.offset) && $.isNumeric(options.offset[0]) && $.isNumeric(options.offset[1])) {
            control.set({
                xOffset: options.offset[0],
                yOffset: options.offset[1]
            });
        }
        control.setMinWidth(options.minWidth);
        control.setMinHeight(options.minHeight);
        control.setMaxWidth(options.maxWidth);
        control.setMaxHeight(options.maxHeight);
        control.setWidth(options.width);
        control.setHeight(options.height);
        mini.parse(contentEl);
        control.show(options.x, options.y, {
            animType: options.animType
        });

        // 调整内容位置以居中
        // if (control._content) {
        //     var height = control._content.clientHeight;
        //     control._content.style.marginTop = (control._contentEl.firstChild.clientHeight - height) / 2 + 'px';
        // }

        var width = control.getWidth();
        control.setWidth(width + 'px');

        // var height = control.getHeight();
        // control.setHeight(height + 'px');

        // 计算高度
        var contentHeight = $(contentEl).css('position', 'relative').outerHeight(true);
        $(contentEl).css('position', '');

        // prettier-ignore
        var height = contentHeight ?
            contentHeight +
            ($(control._headerEl).is(':visible') ? $(control._headerEl).outerHeight(true) : 0) +
            ($(buttonsEl).is(':visible') ? $(buttonsEl).outerHeight(true) : 0) :
            control.getHeight();

        if (height > options.maxHeight) {
            height = options.maxHeight;
            control._content.style.overflow = 'auto';
        }
        control.setHeight(height + 'px');

        var tb = document.getElementById(id1);
        if (tb) {
            tb.style.width = '100%';
        }
        var td = document.getElementById(id2);
        if (td) {
            td.style.width = '100%';
        }
        //}

        // var firstButton = control._Buttons[0];
        // if (firstButton) {
        //     firstButton.focus();
        // } else {
        //     control.focus();
        // }

        if (options.autoFocus) {
            var firstButton = control._Buttons[0];
            if (firstButton) {
                //alert(1);
                firstButton.focus();
            } else {
                //alert(2);
                control.focus();
            }
        }

        control.on('beforebuttonclick', function (e) {
            if (callback) callback('close');
            e.cancel = true;
            mini.MessageBox.hide(control);
        });

        mini.on(control.el, 'keydown', function (e) {
            if (e.keyCode == 27) {
                if (callback) callback('close');
                mini.MessageBox.hide(control);
            }
        });

        //

        if (options.timeout) {
            setTimeout(function () {
                mini.MessageBox.hide(control.uid);
            }, options.timeout);
        }

        window.parent.postMessage(JSON.stringify({
            type: 'openDialog'
        }), '*');

        return control.uid;
    },
    hide: function (id) {
        if (!id) return;
        var control = typeof id === 'object' ? id : mini.getbyUID(id);
        if (!control) return;

        //destroy buttons
        for (var i = 0, l = control._Buttons.length; i < l; i++) {
            var button = control._Buttons[i];
            button.destroy();
        }
        control._Buttons = null;

        window.parent.postMessage(JSON.stringify({
            type: 'closeDialog'
        }), '*');
        control.destroy();
    },

    /**
     * @callback btnCallback
     * @param {string} action 用户点击了`ok`还是`cancel`
     * @param {string} value 输入框中的值
     */

    /**
     * 文本输入提示框。别名为 {@link mini#prompt}
     * @param {String} [message=mini.MessageBox.promptMessage] 消息内容
     * @param {String} [title=mini.MessageBox.promptTitle] 标题
     * @param {btnCallback} callback - 处理按钮点击的回调函数
     * @param {Boolean} [multi=false] 是否允许输入多行（使用 textarea 作为输入框）
     * @param {function} [validation] 验证函数
     * @return {String} 消息框的唯一标识符
     * @member mini.MessageBox
     */
    prompt: function (message, title, callback, multi, validation, options) {
        var control = new mini.Window();
        control.addCls('mini-prompt');
        var uid = control.uid;
        var inputId = uid + '$prompt';
        var s = message || mini.MessageBox.promptMessage;
        if (multi) {
            s =
                '<label class="mini-prompt-label">' +
                s +
                '</label><input id="' +
                inputId +
                '" class="mini-textarea mini-prompt-input" errorMode="text">';
        } else {
            s =
                '<label class="mini-prompt-label">' +
                s +
                '</label><input type="text" id="' +
                inputId +
                '" class="mini-textbox mini-prompt-input" errorMode="text">';
        }
        var iconHtml = options && options.iconCls ? '<span class="mini-messagebox-icon mini-iconfont ' + options.iconCls + '"></span>' : '';
        var opt = jQuery.extend({
                control: control,
                title: title || mini.MessageBox.promptTitle,
                buttons: ['ok', 'cancel'],
                // width: 250,
                html: iconHtml + '<div class="mini-messagebox-prompt" >' + s + '</div>',
                callback: function (action) {
                    var input = mini.get(inputId);
                    if (action === 'ok' && validation && input.validate) {
                        input.validate();
                    }
                    if (callback) {
                        return callback(action, input.getValue());
                    }
                },
                autoFocus: false
            },
            options || {}
        );
        uid = mini.MessageBox.show(opt);
        if (validation) {
            mini.get(inputId).on('validation', validation);
        }
        setTimeout(function () {
            mini.get(inputId).focus();
            // 计算高度
            var contentEl = control._bodyEl.firstChild,
                buttonsEl = control._bodyEl.lastChild,
                contentHeight = $(contentEl).css('position', 'relative').outerHeight(true);
            $(contentEl).css('position', '');

            // prettier-ignore
            var height = contentHeight ?
                contentHeight +
                ($(control._headerEl).is(':visible') ? $(control._headerEl).outerHeight(true) : 0) +
                ($(buttonsEl).is(':visible') ? $(buttonsEl).outerHeight(true) : 0) :
                control.getHeight();

            control.setHeight(height + 'px');
            
        }, 50);
        return uid;
    },
    /**
     * 要求输入确认内容的删除提醒
     * @param {string} content 确认的文字内容
     * @param {*} callback 输入正确的回调函数
     * @param {*} options 配置 {title:'', tpl: '删除后不可恢复，请输入%s确认', selectable: false, onConfirm: function, onCancel: function }
     */
    deletePrompt: function (content, callback, options) {
        options = options || {};
        callback = callback || function () {};
        var opt = $.extend({
                title: epoint_local.MessageBox.deleteConfirmTitle,
                tpl: epoint_local.MessageBox.deleteConfirmTpl 
            },
            options
        );
        var confirmHtml = $('<span class="mini-delete-prompt-content' + (opt.selectable ? ' select' : '') + '"></span>').text(content)[0].outerHTML;
        var contentHtml = opt.tpl.replace(/%s/, confirmHtml);

        var pid = mini.prompt(
            contentHtml,
            opt.title,
            function (action, value) {
                if (action === 'ok') {
                    if (value === content) {
                        callback();
                        if (typeof opt.onConfirm === 'function') {
                            opt.onConfirm.call(null);
                        }
                    } else {
                        return false;
                    }
                } else {
                    if (typeof opt.onCancel === 'function') {
                        opt.onCancel.call(null);
                    }
                }
            },
            false,
            function (e) {
                var v = e.value;
                if (v !== content) {
                    e.errorText = epoint_local.MessageBox.confirmErrorText;
                    e.isValid = false;
                } else {
                    e.errorText = '';
                    e.isValid = true;
                }
            }, {
                buttonText: {
                    ok: epoint_local.MessageBox.buttonText.confirmDelete 
                },
                iconCls: 'mini-messagebox-confirm'
            }
        );
        // 此功能在除chrome之外大多数浏览器下均出现问题，暂去掉
        // var inputId = pid + '$prompt';
        // var input = mini.get(inputId);
        // var button = mini.get(pid)._Buttons.filter(function (ctr) {
        //     return ctr.action === 'ok';
        // })[0];
        // if (input && button) {
        //     button.setEnabled(false);
        //     input.on('keyup', function (e) {
        //         e.sender.setValue(e.sender._textEl.value);
        //         var valid = e.sender.validate();
        //         if (valid !== button.getEnabled()) {
        //             button.setEnabled(valid);
        //         }
        //     });
        // }
        mini.get(pid).addCls('mini-delete-prompt');
        return pid;
    },
    confirm: function (message, title, callback) {
        return mini.MessageBox.show({
            minWidth: 250,
            title: title || mini.MessageBox.confirmTitle,
            buttons: ['ok', 'cancel'],
            message: message,
            iconCls: 'mini-messagebox-question',
            callback: callback
        });
    }
});

/**
 * @method prompt
 * @member mini
 * @alias mini.MessageBox#prompt
 */
mini.prompt = mini.MessageBox.prompt;

/**
 * 要求输入确认内容的删除提醒
 * @param {string} content 确认的文字内容
 * @param {*} callback 输入正确的回调函数
 * @param {*} options 配置 {title:'', tpl: '删除后不可恢复，请输入%s确认', onConfirm: function, onCancel: function }
 */
mini.deletePrompt = mini.MessageBox.deletePrompt;

/**
 * @method showMessageBox
 * @member mini
 * @alias mini.MessageBox#show
 */
mini.showMessageBox = mini.MessageBox.show;
mini.confirm = mini.MessageBox.confirm;

/*
mini.showTips = mini.MessageBox.showTips = function(options) {
    var id = mini.newId('mini-tips-');
    options = jQuery.extend(
        {
            content: '',
            state: 'default',
            showIcon: true,
            x: 'center',
            y: 'top',
            offset: [10, 10],
            fixed: true,
            timeout: 2000
        },
        options
    );

    var cls = 'mini-tips-' + options.state;
    var showIconCls = options.showIcon ? ' mini-tips-showIcon' : '';
    var html = '<div id="' + id + '" class="mini-tips ' + cls + showIconCls + '">' + options.content + '</div>';
    var jq = jQuery(html).appendTo(document.body);

    options.el = jq[0];
    options.timeoutHandler = function() {
        jq.slideUp(function() {
            jq.remove();
        });
    };

    mini.showAt(options);
    jq.hide().slideDown();
    return id;
};

mini.hideTips = mini.MessageBox.hideTips = function(id, immediately) {
    if (!id) return;

    if (immediately) {
        return $(this).remove();
    }
    return jQuery('#' + id).slideUp(function() {
        $(this).remove();
    });
};
*/
/**
 * 显示tips提示 
 * @param {object} options 显示配置项目
 * @param {string} options.content 要显示的消息内容
 * @param {string} options.state tips框语义化状态 default success info warning danger 
 * @param {boolean} options.showIcon 是显示语义化对应的图标
 * @param {string} options.x 水平位置 可选值 center left right
 * @param {string} options.y 垂直位置 可选值 middle top bottom
 * @param {number []} options.offset 偏移位置，如 [10, 10]
 * @param {number} options.timeout 显示多少ms后消失，配置为 0 则不消失
 * @param {boolean} options.showClose 是否显示关闭按钮
 */
mini.showTips = mini.MessageBox.showTips = function (options) {
    var id = mini.newId('mini-tips-');
    options = jQuery.extend({
            content: '',
            state: 'default',
            showIcon: true,
            x: 'center',
            y: 'top',
            offset: [10, 10],
            timeout: 2000,
            showClose: false,
        },
        options
    );
    // offset 必须为整数
    options.offset[0] = options.offset[0] >>> 0;
    options.offset[1] = options.offset[1] >>> 0;

    var cls = 'mini-tips-' + options.state;
    var showIconCls = options.showIcon ? ' mini-tips-showIcon' : '';
    var html = '<div id="' + id + '" class="mini-tips ' + cls + showIconCls + '">' + options.content.replace(/<(script\b[^<]*(?:(?!<\/script>)<[^<]*)*)<(\/script)>/gi, '&lt;$1&lt;$2&gt;') + '</div>';

    var $wrap = getContainer(options);
    var $tips = jQuery(html).appendTo($wrap);

    // if (options.x === 'center') {
    //     $tips.css('transform', 'translateX(-50%)');
    // }
    // if (options.offset[0]) {
    //     $tips.css({ marginLeft: options.offset[0] });
    // }
    // if (options.offset[1]) {
    //     $tips.css({ marginTop: options.offset[1] });
    // }
    if (options.showClose === true) {
        $('<span class="mini-tips-close action-icon icon-remove" onclick="jQuery(this).remove();mini.hideTips(\'' + id + '\')"></span>').appendTo($tips);
    }

    $tips.hide().slideDown();

    if (options.timeout !== 0) {
        var timer = setTimeout(function () {
            $tips.slideUp(function () {
                mini.hideTips(id, true);
            });
        }, options.timeout);
        $tips.data('timer', timer);
    }

    return id;

    function getContainer(opt) {
        var x = opt.x;
        var y = opt.y;
        var pos = x + '-' + y;
        var offset = opt.offset.join('-');
        var cid = 'mini-tips-container_' + pos + '_' + offset;
        var $container = jQuery('#' + cid);
        var topMap = {
            top: {
                top: 0
            },
            center: {
                top: '50%'
            },
            bottom: {
                bottom: '0'
            }
        };
        var leftMap = {
            left: {
                left: 0
            },
            center: {
                left: '50%'
            },
            right: {
                right: '0'
            }
        };

        if (!$container.length) {
            $container = jQuery('<div id="' + cid + '" class="mini-tips-container x-' + x + '"></div>').appendTo(
                'body'
            );
            $container.css(topMap[y]);
            $container.css(leftMap[x]);
            if (opt.offset[0]) {
                if (x === 'right') {
                    $container.css({
                        marginRight: opt.offset[0]
                    });
                } else {
                    $container.css({
                        marginLeft: opt.offset[0]
                    });
                }
            }
            if (opt.offset[1]) {
                if (y === 'bottom') {
                    $container.css({
                        marginBottom: opt.offset[1]
                    });
                } else {
                    $container.css({
                        marginTop: opt.offset[1]
                    });
                }
            }
        }
        $container.css('z-index', mini.getMaxZIndex());
        return $container;
    }
};
mini.hideTips = mini.MessageBox.hideTips = function (id, immediately) {
    if (!id) return;
    var $tips = $('#' + id);
    var timer = $tips.data('timer');
    clearTimeout(timer);
    if (immediately) {
        tryRemoveWrap();
        return $tips.remove();
    }
    return $tips.slideUp(function () {
        tryRemoveWrap();
        $tips.remove();
    });

    function tryRemoveWrap() {
        if (!$tips.siblings().length) {
            $tips.parent().remove();
        }
    }
};
// 所有的 miniui 控件内 如果有 data-tooltip  则自带tooltips 提示
jQuery(function() {
    mini._controlTips = new mini.ToolTip();
    mini._controlTips.set({
        trigger: 'hover click',
        target: document,
        selector: '[class*="mini-"][data-tooltip], [class*="mini-"] [data-tooltip], [class*="uc-"] [data-tooltip]',
        onbeforeopen: function(e) {
            var $elem = jQuery(e.element);
            if ($elem.hasClass('mini-error') || $elem.hasClass('form-tooltip')) {
                e.cancel = true;
            }
        }
    });
});
mini.Avatar = function () {
    mini.Avatar.superclass.constructor.call(this);
};
mini.extend(mini.Avatar, mini.Control, {
    uiCls: 'mini-avatar',
    username: '',
    shortName: '',
    bgColor: '',
    portrait: '',
    _tpl:
        '{{#portrait}}<img class="mini-avatar-img" src="{{portrait}}" >{{/portrait}}{{^portrait}}<span class="mini-avatar-text" style="background:{{avatarBg}}">{{shortName}}</span>{{/portrait}}',
    _create: function () {
        var el = document.createElement('span');

        this._portraitEl = document.createElement('img');
        this._portraitEl.className = 'mini-avatar-img';

        this._textEl = document.createElement('span');
        this._textEl.className = 'mini-avatar-text';

        el.appendChild(this._portraitEl);
        el.appendChild(this._textEl);
        this.el = el;
    },
    _getShortName: function () {
        if (!this.username) return '';

        return this.username.substr(-2);
    },
    setData: function (data) {
        var username = data.username;
        var bgColor = data.bgColor;
        var portrait = data.portrait;

        this.setUsername(username);
        this.setBgColor(bgColor);
        this.setPortrait(portrait);
    },
    getData: function () {
        return {
            username: this.username,
            bgColor: this.bgColor,
            portrait: this.portrait
        };
    },
    setUsername: function (v) {
        this.username = v;
        this._textEl.setAttribute('title', v);
        this._portraitEl.setAttribute('title', v);
        this._textEl.innerText = this._getShortName();
        if (!this.portrait) {
            this.el.setAttribute('mode', '');
        } else {
            this.el.setAttribute('mode', 'img');
        }
    },

    getUsername: function () {
        return this.username;
    },
    setBgColor: function (v) {
        this.bgColor = v;
        this._textEl.style.backgroundColor = v;
    },
    getBgColor: function () {
        return this.bgColor;
    },
    setPortrait: function (v) {
        this.portrait = v;

        if (!this.portrait) {
            this.el.setAttribute('mode', '');
        } else {
            this._portraitEl.setAttribute('src', v);
            this.el.setAttribute('mode', 'img');
        }
    },
    getPortrait: function () {
        return this.portrait;
    },
    getAttrs: function (el) {
        var attrs = mini.Avatar.superclass.getAttrs.call(this, el);
        mini._ParseString(el, attrs, ['username', 'bgColor', 'portrait', 'width', 'height']);
        return attrs;
    },
    setWidth: function (v) {
        $(this.el).add(this._textEl).add(this._portraitEl).css('width', v);
    },
    setHeight: function (v) {
        var n;
        if (typeof v === 'number') {
            n = v + 'px';
        } else if (/px$/.test(v)) {
            n = v;
        } else {
            n = parseInt(v, 10) + 'px';
        }
        $(this.el).add(this._textEl).add(this._portraitEl).css({
            height: v,
            'line-height': n
        });
    }
});
mini.regClass(mini.Avatar, 'avatar');

mini.BaseUploader = function () {
    mini.BaseUploader.superclass.constructor.apply(this, arguments);
};

mini.extend(mini.BaseUploader, mini.Control, {
    required: false,
    formField: true,
    requiredErrorText: epoint_local.ValidatorBase.requiredErrorText,
    showDefaultUI: true,

    // 初始化时服务端返回过来的文件数量
    serverFileNum: 0,
    fileSizeLimit: (window.EpFrameSysParams && EpFrameSysParams.file_limit_size) || 0,

    fileSingleSizeLimit: (window.EpFrameSysParams && EpFrameSysParams.file_single_limit_size) || 0,
    // 允许的文件后缀，不带点，多个用逗号分割
    limitType: (window.EpFrameSysParams && EpFrameSysParams.file_limit_type) || '',
    fileNameLengthLimit: (window.EpFrameSysParams && EpFrameSysParams.file_limit_namelength) || 0,

    needChunkLocal: (window.EpFrameSysParams && EpFrameSysParams.chunk_dispatch_control) || undefined,
    uploadUrl: '',
    fileNumLimit: undefined,
    // 是否多选，根fileNumLimit的值相关联
    multiSelect: false,
    mimeTypes: '',
    auto: true,

    // 第三方资源的路径，默认为全局配置mini.externalSrc的值
    externalSrc: '',

    fileNameLengthErrorText: '选择的文件名称长度过长！</br>文件名最长为{0}个字符',

    fileNameNullErrorText: '文件名称不能为空',

    _needPostData: true,
    postData: '',

    setAction: function (action) {
        this.action = action;

        this.controlData = {
            id: this.id,
            type: this.type,
            mapClass: this.mapClass,
            action: this.action,
            needChunkLocal: this.needChunkLocal,
            showDefaultUI: this.showDefaultUI,
            dataOptions: this['data-options']
        };

        var arr = action.split('.');

        if (arr.length < 2) return;

        var url = Util.getRightUrl('/rest/' + arr[0] + '/' + arr[1] + '?isCommondto=true');

        // 对于action配置为“xxxaction(aaa,bbb)”这种形式的，安全拦截中不允许url上出现“()”，所以需要将“()”里的内容拿下来，放到cmdParams里
        var reg = /\([\w\W]*\)/,
            match = url.match(reg);
        if (match) {
            url = url.replace(reg, '');

            this.cmdParams = match[0].replace('(', '[').replace(')', ']');
        }

        var urlParams = Util.getUrlParams();
        delete urlParams['@epoint_user_loginid'];

        url = Util.addUrlParams(url, urlParams, 'ignore', false);

        this.setUploadUrl(url);
    },
    getFileList: function () {
        return this._fileList;
    },

    setFileNumLimit: function (fileNumLimit) {
        fileNumLimit = parseInt(fileNumLimit) || 0;

        this.fileNumLimit = fileNumLimit;

        if (fileNumLimit === 1) {
            this.multiSelect = false;
        }
    },

    getFileNumLimit: function () {
        return this.fileNumLimit;
    },
    /**
     *
     * function setFileSingleSizeLimit(fileSingleSizeLimit)
     * @member mini.WebUploader
     * @param {int} fileSingleSizeLimit
     *
     */
    setFileSingleSizeLimit: function (fileSingleSizeLimit) {
        this.fileSingleSizeLimit = fileSingleSizeLimit;
    },
    /**
     *
     * function getFileSingleSizeLimit()
     * @member mini.WebUploader
     * @returns {int}
     *
     */
    getFileSingleSizeLimit: function () {
        return this.fileSingleSizeLimit;
    },
    /**
     *
     * function setUploadUrl(uploadUrl)
     * @member mini.WebUploader
     * @param {String} uploadUrl
     *
     */
    setUploadUrl: function (uploadUrl) {
        this.uploadUrl = Util.encryptAjaxUrlParams(uploadUrl);
    },
    getUploadUrl: function () {
        return this.uploadUrl;
    },
    setShowDefaultUI: function (showDefaultUI) {
        this.showDefaultUI = showDefaultUI;
        if (this.controlData) {
            this.controlData.showDefaultUI = showDefaultUI;
        }
    },
    setPostData: function (postData) {
        this.postData = postData;
    },
    getPostData: function () {
        return this.postData;
    },
    /**
     *
     * function getLimitType()
     * @member mini.WebUploader
     * @returns {String}
     *
     */
    getLimitType: function () {
        return this.limitType;
    },
    _getSize: function (size) {
        var unit = 'B';
        while (size > 1024 && unit !== 'T') {
            size = (size / 1024).toFixed(1);
            switch (unit) {
                case 'B':
                    unit = 'KB';
                    break;
                case 'KB':
                    unit = 'M';
                    break;
                case 'M':
                    unit = 'G';
                    break;
                case 'G':
                    unit = 'T';
                    break;
                default:
                    break;
            }
        }
        return size + unit;
    },
    getCommonData: function () {
        if (!this.controlData) {
            this.controlData = {
                id: this.id,
                type: this.type,
                mapClass: this.mapClass,
                action: this.action,
                showDefaultUI: this.showDefaultUI,
                needChunkLocal: this.needChunkLocal,
                dataOptions: this['data-options']
            };
        }
        return [this.controlData, this.getViewdata()];
    },
    getCommonUploadData: function (action, needPostData) {
        var data = {
            commonDto: mini.encode(this.getCommonData())
        };

        if (this.cmdParams) {
            data.cmdParams = this.cmdParams;
        }
        if (action) {
            data[this.id + '_action'] = action;
        }
        if (needPostData) {
            data[this.id + '_postData'] = this.postData;
        }

        return data;
    },
    getViewdata: function () {
        var hidden = mini.get('_common_hidden_viewdata');

        if (!this.viewData) {
            this.viewData = {
                id: '_common_hidden_viewdata',
                type: 'hidden',
                value: ''
            };
        }

        if (hidden) {
            this.viewData.value = hidden.getValue();
        }

        return this.viewData;
    },
    // 通用的验证
    _commonValidateFile: function (file) {
        // Liunx系统中文件名称长度限制在100个字符，需要选文件时就把超过的过滤掉
        // 文件名长度判断 中文算3字符
        var filename = file.name;
        var fileNameLength = mini.getStrLength(filename, true);
        if (fileNameLength === 0) {
            mini.alert(this.fileNameNullErrorText);
            return false;
        }
        if (this.fileNameLengthLimit && fileNameLength > this.fileNameLengthLimit) {
            mini.alert(String.format(this.fileNameLengthErrorText, this.fileNameLengthLimit));
            return false;
        }

        return true;
    },
    setRequired: function(value){
        this.required = value;
    },
    getRequired: function(){
        return this.required;
    },
    setRequiredErrorText: function (value) {
        this.requiredErrorText = value;
    },
    getRequiredErrorText: function () {
        return this.requiredErrorText;
    },
    validate: function(){
        var e = {
            value: $.isEmptyObject(this.serverFiles),
            errorText: "",
            isValid: true
        };

        if (this.required) {
            if (e.value) {
                e.isValid = false;
                e.errorText = this.requiredErrorText;
            }
        }
        
        this.errorText = e.errorText;
        this.setIsValid(e.isValid);
        return this.isValid();
    },
    isValid: function () {
        return this._IsValid;
    },
    setIsValid: function (value) {
        this._IsValid = value;
    },
    getIsValid: function () {
        return this._IsValid;
    }
});

mini.BubbleDialog = {
    positionMap: {
        'left-top': {
            xAlign: 'outleft',
            yAlign: 'top',
            xOffset: -14,
            yOffset: -10
        },
        'left-middle': {
            xAlign: 'outleft',
            yAlign: 'middle',
            xOffset: -14
        },
        'left-bottom': {
            xAlign: 'outleft',
            yAlign: 'bottom',
            xOffset: -14,
            yOffset: 10
        },
        'right-top': {
            xAlign: 'outright',
            yAlign: 'top',
            xOffset: 14,
            yOffset: -10
        },
        'right-middle': {
            xAlign: 'outright',
            yAlign: 'middle',
            xOffset: 14
        },
        'right-bottom': {
            xAlign: 'outright',
            yAlign: 'bottom',
            xOffset: 14,
            yOffset: 10
        },
        'top-left': {
            xAlign: 'left',
            yAlign: 'above',
            xOffset: -10,
            yOffset: -14
        },
        'top-center': {
            xAlign: 'center',
            yAlign: 'above',
            yOffset: -14
        },
        'top-right': {
            xAlign: 'right',
            yAlign: 'above',
            xOffset: 10,
            yOffset: -14
        },
        'bottom-left': {
            xAlign: 'left',
            yAlign: 'below',
            xOffset: -10,
            yOffset: 14
        },
        'bottom-center': {
            xAlign: 'center',
            yAlign: 'below',
            yOffset: 14
        },
        'bottom-right': {
            xAlign: 'right',
            yAlign: 'below',
            xOffset: 10,
            yOffset: 14
        }
    },
    show: function (options) {
        options = mini.copyTo(
            {
                invokerID: '',
                position: 'top-left',
                width: '236',
                height: '110',
                customCls: 'mini-bubbledialog',
                showModal: false,
                timeout: 0,
                minWidth: 150,
                maxWidth: 800,
                minHeight: 50,
                maxHeight: 350,
                showHeader: false,
                title: '',
                titleIcon: '',
                iconCls: '',
                iconStyle: '',
                message: '',
                html: '',
                spaceStyle: '',
                showCloseButton: false,
                buttons: ['cancel', 'ok'],
                buttonWidth: null,
                callback: null,
                // 是否显示"不再提示"选项
                // NOTE: "不再提示"的逻辑通过clickNoTipCheck来实现，而不是放在组件内部，因为与具体业务需求耦合
                showNoTipCheck: false,
                // 点击"不再提示"回调
                clickNoTipCheck: false
            },
            options
        );
        options.message = String(options.message);
        var callback = options.callback;

        var control = options.control || new mini.Window();
        // 添加自定义 class 样式
        if (options.customCls) {
            control.addCls(options.customCls);
        }

        control.addCls('mini-messagebox');
        control.setBodyStyle('overflow:hidden');
        control.setShowModal(options.showModal);
        control.setTitle(options.title || '');
        control.setIconCls(options.titleIcon);
        control.setShowHeader(options.showHeader);

        control.setShowCloseButton(options.showCloseButton);

        var id1 = control.uid + '$table',
            id2 = control.uid + '$content';

        // var icon = '<div class="' + options.iconCls + '" style="' + options.iconStyle + '"></div>';
        // var s = '<table class="mini-messagebox-table" id="' + id1 + '" style="" cellspacing="0" cellpadding="0"><tr><td>'
        //         + icon + '</td><td id="' + id2 + '" class="mini-messagebox-content-text">'
        //         + (options.message || "") + '</td></tr></table>';

        //var s = "";
        //control.setShowHeader(false);

        // 重写content中的dom结构
        var s =
            '<i class="mini-messagebox-icon mini-iconfont ' +
            options.iconCls +
            '" style="' +
            options.iconStyle +
            '"></i>' +
            '<p class="mini-messagebox-msg">' +
            (options.message || '') +
            '</p>';
        var ws = '<div class="mini-messagebox-content"></div>' + '<div class="mini-messagebox-buttons"></div>';
        control._bodyEl.innerHTML = ws;
        var contentEl = control._bodyEl.firstChild;
        if (options.html) {
            if (typeof options.html === 'string') {
                contentEl.innerHTML = options.html;
            } else if (mini.isElement(options.html)) {
                contentEl.appendChild(options.html);
            }
        } else {
            contentEl.innerHTML = s;

            // 记录下内容元素
            control._content = contentEl.lastChild;
        }
        // 不再提醒
        if (options.showNoTipCheck) {
            var foot = control._bodyEl.lastChild;
            foot.innerHTML = '<label class="mini-messagebox-checkbox"><input type="checkbox">' + epoint_local.no_longer_tips +'</label>';

            mini.on(foot.firstChild, 'click', function () {
                if (options.clickNoTipCheck) {
                    var checked = this.firstChild.checked;

                    options.clickNoTipCheck.apply(this, [checked]);
                }
            });
        }

        control._Buttons = [];

        var buttonsEl = control._bodyEl.lastChild;
        if (options.buttons && options.buttons.length > 0) {
            for (var i = 0, l = options.buttons.length; i < l; i++) {
                var button = options.buttons[i];
                var text = mini.MessageBox.buttonText[button];
                if (!text) text = button;

                var btn = new mini.Button();
                btn.setText(text);
                btn.setWidth(options.buttonWidth);
                btn.render(buttonsEl);
                btn.action = button;
                btn.on('click', function (e) {
                    var button1 = e.sender;
                    if (callback) if (callback(button1.action) === false) return;
                    mini.MessageBox.hide(control);
                });

                if (i !== l - 1) {
                    btn.setStyle(options.spaceStyle);
                }

                // 给button设置样式
                btn.setCls('mini-messagebox-button');
                // ok的button特殊处理
                if (button === 'ok') {
                    btn.addCls('ok');
                    btn.setState('primary');
                }

                control._Buttons.push(btn);
            }
        } else {
            mini.addClass(control._bodyEl, 'no-btn');
        }

        control.setMinWidth(options.minWidth);
        control.setMinHeight(options.minHeight);
        control.setMaxWidth(options.maxWidth);
        control.setMaxHeight(options.maxHeight);
        control.setWidth(options.width);
        control.setHeight(options.height);
        mini.parse(contentEl);
        // control.show(options.x, options.y, {
        //     animType: options.animType
        // });

        // 定位
        var align = mini.BubbleDialog.positionMap[options.position];

        $.extend(options, align);

        function relocate() {
            // 展示
            control.showAtEl(options.invokerID, options);
            var $control = $(control.el),
                xControl = parseInt(control.x, 10),
                yControl = parseInt(control.y, 10),
                wControl = parseInt($control.outerWidth(), 10),
                hControl = parseInt($control.outerHeight(), 10),
                $invoker = $('#' + options.invokerID),
                xInvoker = parseInt($invoker.offset().left, 10),
                yInvoker = parseInt($invoker.offset().top, 10),
                wInvoker = parseInt($invoker.outerWidth(), 10),
                hInvoker = parseInt($invoker.outerHeight(), 10);

            // 主要位置参数是上下
            if (options.yAlign === 'above' || options.yAlign === 'below') {
                // 上边超出
                if (options.yAlign === 'above' && yInvoker < yControl + hControl + 10) {
                    options.position = newPosition('bottom-');
                } else if (options.yAlign === 'below' && yControl < yInvoker + hInvoker + 10) {
                    // 下边超出
                    options.position = newPosition('top-');
                }
            } else if (
                // 主要位置参数是左右
                options.xAlign === 'outleft' ||
                options.xAlign === 'outright'
            ) {
                // 左边超出
                if (options.xAlign === 'outleft' && xInvoker < xControl + wControl + 10) {
                    options.position = newPosition('right-');
                } else if (options.xAlign === 'outright' && xControl < xInvoker + wInvoker + 10) {
                    // 右边超出
                    options.position = newPosition('left-');
                }
            }

            control.addCls(options.position);
            // 加箭头
            var $tri = $('<div class="mini-bubbledialog-arrow"></div>');
            $tri.appendTo($(control.el));

            function newPosition(p) {
                var isH = p.indexOf('bottom') === 0 || p.indexOf('top') === 0;

                // 上下超出
                if (isH) {
                    p += options.position.indexOf('left') !== -1 ? 'left' : 'right';
                } else {
                    p += options.position.indexOf('top') !== -1 ? 'top' : 'bottom';
                }

                align = mini.BubbleDialog.positionMap[p];

                $.extend(options, align);
                return p;
            }

            // 展示
            control.showAtEl(options.invokerID, options);
            adjustArrow();
            function adjustArrow() {
                var tl = xInvoker + wInvoker / 2 - control.x - 10,
                    tt = yInvoker + hInvoker / 2 - yControl - 10;

                var direction = options.position.split('-')[0];

                // 调整箭头位置
                if (direction === 'top' || direction === 'bottom') {
                    $tri.css('left', tl + 'px');
                } else {
                    $tri.css('top', tt + 'px');
                }
            }
        }
        relocate();

        var width = control.getWidth();
        control.setWidth(width + 'px');

        // var height = control.getHeight();
        // control.setHeight(height + 'px');

        // 计算高度
        var contentHeight = $(contentEl).css('position', 'relative').outerHeight(true);
        $(contentEl).css('position', '');

        // prettier-ignore
        var height = contentHeight ?
            contentHeight
            + ($(control._headerEl).is(':visible') ? $(control._headerEl).outerHeight(true) : 0)
            + ($(buttonsEl).is(':visible') ? $(buttonsEl).outerHeight(true) : 0)
            : control.getHeight();

        if (height > options.maxHeight) {
            height = options.maxHeight;
            control._content.style.overflow = 'auto';
        }
        control.setHeight(height + 'px');

        var tb = document.getElementById(id1);
        if (tb) {
            tb.style.width = '100%';
        }
        var td = document.getElementById(id2);
        if (td) {
            td.style.width = '100%';
        }
        //}

        // var firstButton = control._Buttons[0];
        // if (firstButton) {
        //     firstButton.focus();
        // } else {
        //     control.focus();
        // }

        if (mini.MessageBox.autoFocus) {
            var firstButton = control._Buttons[0];
            if (firstButton) {
                //alert(1);
                firstButton.focus();
            } else {
                //alert(2);
                control.focus();
            }
        }

        control.on('beforebuttonclick', function (e) {
            if (callback) callback('close');
            e.cancel = true;
            mini.MessageBox.hide(control);
        });

        mini.on(control.el, 'keydown', function (e) {
            if (e.keyCode === 27) {
                if (callback) callback('close');
                mini.MessageBox.hide(control);
            }
        });

        //

        if (options.timeout) {
            setTimeout(function () {
                mini.MessageBox.hide(control.uid);
            }, options.timeout);
        }

        window.parent.postMessage(JSON.stringify({ type: 'openDialog' }), '*');

        return control.uid;
    }
};

mini.showBubbleDialog = mini.BubbleDialog.show;

mini.CatalogImport = function () {
    mini.CatalogImport.superclass.constructor.call(this);
};
mini.extend(mini.CatalogImport, mini.Control, {
    uiCls: 'mini-catalogimport',
    url: '',
    pickerText: epoint_local.CatalogImport.pickerText,
    deleteText: epoint_local.CatalogImport.deleteText,
    uploadingText: epoint_local.CatalogImport.uploadingText,
    validateText: epoint_local.CatalogImport.validateText,
    resultTpl: epoint_local.CatalogImport.resultTpl,
    expandText: epoint_local.CatalogImport.expandText,
    importResultText: epoint_local.CatalogImport.importResultText,
    importErrorText: epoint_local.CatalogImport.importErrorText,
    importSuccessText: epoint_local.CatalogImport.importSuccessText,
    exportText: epoint_local.CatalogImport.exportText,

    _create: function () {
        this.el = document.createElement('div');

        this.uploader = new mini.WebUploader();

        this.uploader.set({
            uploadUrl: this.url,
            pickerText: this.pickerText,
            fileNumLimit: 1,
            limitType: 'xls,xlsx,xlsm',
            showDefaultUI: false,
            auto: false,
            renderTo: this.el
        });

        this.uploader.on('beforefilequeued', this._onBeforeFileQueued, this);
        this.uploader.on('filesqueued', this._onFilesQueued, this);
        this.uploader.on('uploadbeforesend', this._onUploadBeforeSend, this);
        this.uploader.on('uploadprogress', this._onUploadProgress, this);
        this.uploader.on('uploadsuccess', this._onUploadSuccess, this);

        this.uploader._uploadBtn.hide();

        // this.maskEl = document.createElement("div");
        // this.maskEl.className = 'mini-catalogimport-mask';
        // this.maskEl.innerHTML = '<div class="mini-catalogimport-mask-content"></div>';
        // this.maskContent = this.maskEl.firstChild;

        // document.body.appendChild(this.maskEl);

        // this.detailEl = document.createElement("div");
        // this.detailEl.className = 'mini-catalogimport-detail';
        // this.detailEl.innerHTML = '<div class="mini-catalogimport-detail-content"></div><i class="catalogimport-detail-close">X</i>';
        // this.detailContent = this.detailEl.firstChild;

        // document.body.appendChild(this.detailEl);

        this.fileList = document.createElement('div');
        this.fileList.className = 'mini-catalogimport-filelist';

        this.el.appendChild(this.fileList);

        this._bindEvent();
    },

    _bindEvent: function () {
        var self = this;
        // jQuery(this.maskEl).on('click', '.catalogimport-showdetail', function () {
        //     self.showDetailStatus();
        //     return false;
        // }).on('click', '.catalogimport-continue', function () {
        //     self.isContinueImport = true;
        //     self.uploader._uploader.upload();
        // }).on('click', '.catalogimport-restart', function () {
        //     self.uploader._uploader.upload();
        // }).on('click', function () {
        //     if (self.isImportFinished && !self.isDetailShow) {
        //         self.maskEl.style.display = 'none';
        //     }
        // });

        // jQuery(this.detailEl).on('click', '.catalogimport-detail-close', function () {
        //     self.hideDetailStatus();
        // }).on('click', '.catalogimport-status-toggle', function () {
        //     var $this = $(this),
        //         $parent = $this.parent();

        //     if ($parent.hasClass('opened')) {
        //         $this.text('展开详情');
        //         $parent.removeClass('opened');
        //     } else {
        //         $this.text('收起详情');
        //         $parent.addClass('opened');
        //     }
        // });
        
        jQuery(this.fileList).on('click', '.catalogimport-delete', function () {
            var $li = $(this).closest('.mini-catalogimport-item');

            $li.remove();

            self.uploader.clearFile();

        }).on('click', '.catalogimport-export', function(){
            self.fire('exportresult', {
                attachGuid: self._curAttachGuid
            });
        });
    },

    _onFilesQueued: function (event) {
        var files = event.files,
            file = files[0],
            self = this;
        if (!file) {
            return;
        }

        var html = this._generateFileList({
            id: file.id,
            name: file.name,
            size: file.size
        });

        this.isImportFinished = false;

        // this.maskContent.innerHTML = html;
        // this.maskEl.style.display = 'block';

        jQuery(html).appendTo(this.fileList);

        this.uploader._uploader.md5File(file)
            .progress(function (percentage) {

            }).then(function (md5) {
                self._curFileMD5 = md5;
                var data = {
                    fileMD5: md5,
                    fileName: file.name,
                    fileSize: file.size
                };

                data[self.uploader.id + '_action'] = 'queryFileStatus';

                if (self.uploader.getCommonData) {
                    data.commonDto = mini.encode(self.uploader.getCommonData());
                }

                self._onPostFileMd5(data);

                // 与服务端验证
                $.ajax(self.url, {
                    dataType: 'json',
                    data: data,
                    type: 'post',
                    success: function (response) {
                        if (mini.getSecondRequestData) {
                            response = mini.getSecondRequestData(response);
                        }
                        self._onQueryFileStatus(response);
                    }
                });
            });
    },

    _onPostFileMd5: function (data) {
        this.fire('postfilemd5', {
            data: data
        });
    },

    _curFileMD5: '',
    _curAttachGuid: '',
    _onQueryFileStatus: function (data) {
        if (data.msg) {
            mini.alert(data.msg);
        }

        this.setDetailStatus(data.detail);
        this._curAttachGuid = data.attachGuid;
        this._oldAttachGuid = data.attachGuidOld;

        if (data.end) {
            this._onFinished(data.status);
            return;
        }

        if (data.pollingFrequency) {
            this._pollingFrequency = data.pollingFrequency;
        }

        if (data.action == 'importStatus') {
            this.pollingStatus(data);
        } else if (data.action == 'upload') {
            this.uploader._uploader.upload();
        } else {
            // jQuery(this.maskContent).find('.mini-catalogimport-action').removeClass('hidden');
            jQuery(this.fileList).find('.mini-catalogimport-action').removeClass('hidden');
        }

    },

    _onUploadBeforeSend: function (event) {
        if (this.isContinueImport) {
            event.data.attachGuid = this._curAttachGuid;
        }
        event.data.fileMD5 = this._curFileMD5;
    },

    _onUploadProgress: function (event) {
        var file = event.file,
            percentage = event.percentage,
            li = mini.byId(file.id),
            $progressbar = jQuery('.mini-catalogimport-progressbar', li),
            $progresstext = jQuery('.progress-text', $progressbar),
            $progressbody = jQuery('.progress-body', $progressbar),
            width = Math.round(percentage * 100) + '%';

        $progresstext.text(width);
        $progressbody.width(width);
    },

    _generateFileList: function (options) {

        var list = [];
        list.push('<div class="mini-catalogimport-item" id="' + options.id + '">');
        list.push('<span class="mini-catalogimport-info">' + options.name + '</span>');
        list.push('<span class="mini-catalogimport-size">(' + this._getSize(options.size) + ')</span>');
        list.push('<span class="mini-catalogimport-action hidden"><a href="javascript:void(0)" class="catalogimport-delete">' + this.deleteText + '</a></span>');
        list.push('<span class="mini-catalogimport-status">' + this.uploadingText + '</span>');
        list.push('<span class="mini-catalogimport-progressbar"><span class="progress-text">0%</span><div class="progress-body"></div></span>');

        // list.push('<span class="mini-catalogimport-action hidden"><a href="javascript:void(0)" class="catalogimport-continue" title="上次导入中断，修改完后继续导入">继续导入</a><a href="javascript:void(0)" class="catalogimport-restart" title="重新尝试导入这个文件">重新导入</a><a href="javascript:void(0)" class="catalogimport-showdetail hidden">查看详情</a></span>');
        list.push('</div>');

        return list.join('');
    },

    // _generateImportStatus: function (options) {
    //     var list = [];
    //     list.push('<div class="mini-catalogimport-item">');
    //     list.push('<span class="mini-catalogimport-info">' + (options.status || '') + '</span>');
    //     if (options.handlepercent >= 0) {
    //         list.push('<span class="mini-catalogimport-progressbar"><span class="progress-text">' + options.handlepercent + '%</span><div class="progress-body" style="width:' + options.handlepercent + '%;"></div></span>');
    //     }

    //     if (options.end) {
    //         list.push('<span class="mini-catalogimport-action"><a href="javascript:void(0)" class="catalogimport-showdetail">查看详情</a></span>');
    //     }

    //     list.push('</div>');

    //     return list.join('');

    // },

    _onPollingStatus: function(options) {

        if(!options.status) {
            return;
        }
        var li = mini.byId(this._currentFileId),
            $status = jQuery('.mini-catalogimport-status', li),
            $progressbar = jQuery('.mini-catalogimport-progressbar', li),
            $progresstext = jQuery('.progress-text', $progressbar),
            $progressbody = jQuery('.progress-body', $progressbar),
            
            width;

        $status.text(options.status);

        if (options.handlepercent >= 0) {
            width = options.handlepercent + '%';

            $progressbar.removeClass('hidden');
            $progresstext.text(width);
            $progressbody.width(width);
        } else {
            $progressbar.addClass('hidden');
        }
    },

    _generateStatuslist: function (options) {
        var i, len, arr,
            isCheckEnd = true,
            isSaveEnd = true;
        var list = ['<div class="catalogimport-status-item">'];
        list.push('<h3 class="catalogimport-status-title">' + options.sheetName + '</h3>');
        list.push('<h4 class="catalogimport-status-type">' + this.validateText + ':</h4>');
        list.push('<p class="catalogimport-status-count">' + Mustache.render(this.resultTpl, {0: options.checkCount, 1: options.checkSuccessCount, 2: options.checkErrorCount}));
        if ((arr = options.checkMsg) && (len = arr.length)) {
            list.push('<a href="javascript:void(0);" class="catalogimport-status-toggle">' + this.expandText +'</a></p>');
            list.push('<div class="catalogimport-status-detail">');
            for (i = 0; i < len; i++) {
                list.push('<p>' + arr[i] + '</p>');
            }
            list.push('</div>');
        } else {
            isCheckEnd = false;
        }

        if (options.saveCount) {
            if (!isCheckEnd) {
                list.push('</p>');
                isCheckEnd = true;
            }
            list.push('<h4 class="catalogimport-status-type">' + this.importResultText +'：</h4>');
            list.push('<p class="catalogimport-status-count">' + Mustache.render(this.resultTpl, {0: options.saveCount, 1: options.saveSuccessCount, 2: options.saveErrorCount}));

            if ((arr = options.saveMsg) && (len = arr.length)) {
                list.push('<a href="javascript:void(0);" class="catalogimport-status-toggle">' + this.expandText +'</a></p>');
                list.push('<div class="catalogimport-status-detail">');
                for (i = 0; i < len; i++) {
                    list.push('<p>' + arr[i] + '</p>');
                }
                list.push('</div>');
            } else {
                isSaveEnd = false;
            }
        }

        if ((arr = options.taskMsg) && (len = arr.length)) {
            list.push('<a href="javascript:void(0);" class="catalogimport-status-toggle">' + this.expandText + '</a></p>');
            list.push('<div class="catalogimport-status-detail">');
            for (i = 0; i < len; i++) {
                list.push('<p>' + arr[i] + '</p>');
            }
            list.push('</div>');
        } else if (!isCheckEnd || !isSaveEnd) {
            list.push('</p>');
        }

        list.push('</div>');

        return list.join('');
    },

    _getSize: function (size) {
        var K = 1024,
            M = 1048576;
        size = parseInt(size);

        if (size > M) {
            return (size / M).toFixed(2) + 'M';
        } 
            return (size / K).toFixed(2) + 'K';
        
    },

    _pollingFrequency: 1000,
    _oldAttachGuid: '',
    _onUploadSuccess: function (event) {
        var ret = event.ret,
            file = event.file;

        if (mini.getSecondRequestData) {
            ret = mini.getSecondRequestData(ret);
        }

        ret = ret.data || ret;
        ret = ret.extraDatas || ret;

        this._pollingFrequency = ret.pollingFrequency;
        if (ret.action == 'importStatus') {
            this._curAttachGuid = ret.attachGuid;
            this._oldAttachGuid = ret.attachGuidOld;
            ret.fileId = file.id;
            this.pollingStatus(ret);
            return;
        }

        var self = this;
        mini.alert(this.importErrorText, '', function () {
            // self._onFinished(ret.status);

            self._onFinished(ret);

            // self.maskEl.style.display = 'none';
        });


    },

    // _onFinished: function (msg) {
    //     msg = msg || "导入已完成";
    //     this.isImportFinished = true;
    //     this.maskContent.innerHTML = msg + '<a href="javascript:void(0);" class="catalogimport-showdetail">查看详情</a>';

    //     if (this._events["importfinished"]) {
    //         this.fire("importfinished");
    //     }

    //     this.uploader.clearFile();
    // },

    _onFinished: function (data) {
        var msg = data.status || this.importSuccessText,
            isSuccess = data.success;

        this.isImportFinished = true;

        var li = mini.byId(this._currentFileId),
            $status = jQuery('.mini-catalogimport-status', li),
            $progressbar = jQuery('.mini-catalogimport-progressbar', li),
            $action = jQuery('.mini-catalogimport-action', li);

        $status.text(msg);
        $progressbar.addClass('hidden');

        if(isSuccess) {
            setTimeout(function(){
                $status.addClass('hidden');
            }, 1000);
        } else {
            $status.addClass('error');
            $status.append('<a class="catalogimport-export">' + this.exportText + '</a>');
            $action.removeClass('hidden');
        }
        
        if (this._events.importfinished) {
            this.fire('importfinished', data);
        }

    },

    _onBeforeFileQueued: function (event) {
        if (this._events.beforefilequeued) {
            this.fire('beforefilequeued', event);
        }
    },

    _currentFileId: '',
    pollingStatus: function (options) {
        // 由于一次导入过程只会存在一个文件，所以可以用一个变量来保存当前正在上传的文件id
        if(options.fileId) {
            this._currentFileId = options.fileId;
        }
        // this.maskContent.innerHTML = this._generateImportStatus(options);
        this._onPollingStatus(options);

        var self = this,
            data = {
                fileMD5: this._curFileMD5,
                attachGuid: this._curAttachGuid,
                attachGuidOld: this._oldAttachGuid
            };
        data[this.uploader.id + '_action'] = 'importStatus';

        if (this.uploader.getCommonData) {
            data.commonDto = mini.encode(this.uploader.getCommonData());
        }

        this.fire('beforepollingstatus', {
            data: data
        });
        jQuery.ajax({
            url: this.url,
            data: data,
            type: 'POST',
            dataType: 'json'
        }).done(function (data) {
            if (mini.getSecondRequestData) {
                data = mini.getSecondRequestData(data);
            }
            // 有提示信息，则alert
            if (data.msg) {
                mini.alert(data.msg);
            }

            if (data.end) {
                // self._onFinished(data.status);
                self._onFinished(data);
            } else {
                setTimeout(jQuery.proxy(self.pollingStatus, self, data), self._pollingFrequency);
            }

            self.setDetailStatus(data.detail);

        });
    },

    setDetailStatus: function (data) {
        this.detailStatus = data;

        if (this.isDetailShow) {
            this.renderDetailStatus();
        }
    },

    renderDetailStatus: function () {
        var detail = this.detailStatus,
            html = [],
            i = 0,
            l;

        if (detail) {
            for (l = detail.length; i < l; i++) {
                html.push(this._generateStatuslist(detail[i]));
            }

        }

        this.detailContent.innerHTML = html.join('');

    },

    showDetailStatus: function () {
        this.renderDetailStatus();

        this.detailEl.style.display = 'block';

        this.isDetailShow = true;
    },

    hideDetailStatus: function () {
        this.detailEl.style.display = 'none';

        this.isDetailShow = false;
    },

    setUrl: function (url) {
        this.url = url;

        this.uploader && this.uploader.setUploadUrl(url);
    },

    getUrl: function () {
        return this.url;
    },

    setPickerText: function (pickerText) {

    },

    setEnabled: function(enabled) {
        mini.CatalogImport.superclass.setEnabled.call(this, enabled);
        this.uploader && this.uploader.setEnabled(enabled);
    },

    getAttrs: function (el) {
        var attrs = mini.CatalogImport.superclass.getAttrs.call(this, el);
        mini._ParseString(el, attrs, ['url', 'pickerText', 'onbeforefilequeued', 'onpostfilemd5', 'onimportfinished', 'onexportresult']);
        return attrs;
    }

});

mini.regClass(mini.CatalogImport, 'catalogimport');
var ColorPaletteHistory = function() {
    this.notifyList = [];
    this.history = [];
    this.maxHistory = 10;
};
jQuery.extend(ColorPaletteHistory.prototype, {
    record: function(color) {
        var idx = this.history.indexOf(color);
        if (idx >= 0) {
            this.history.splice(idx, 1);
        }
        this.history.unshift(color);
        this.history = this.history.slice(0, this.maxHistory);

        this.notify();
    },
    notify: function() {
        var self = this;
        this.notifyList.forEach(function(control) { control._setHistory(self.history.slice()); });
    },
    sub: function(control) {
        if (this.notifyList.indexOf(control) < 0) {
            this.notifyList.push(control);
            control._setHistory(this.history);
        }
    },
    unSub: function(control) {
        control._setHistory([]);
        var idx = this.notifyList.indexOf(control);
        if (idx >= 0) {
            this.notifyList.splice(idx, 1);
        }
    }
});

mini.ColorPalette = function() {
    mini.ColorPalette.superclass.constructor.call(this);
};

mini.extend(mini.ColorPalette, mini.Control, {
    uiCls: 'mini-colorpalette',

    format: 'hex',
    enableAlpha: true,
    enableHistory: false,
    history: [],
    defaultColorCard: [
        ['#B71C1C', '#C62828', '#D32F2F', '#E53935', '#F44336', '#EF5350', '#E57373', '#EF9A9A', '#FFCDD2', '#FFEBEE'],
        ['#F57F17', '#F9A825', '#FBC02D', '#FDD835', '#FFEB3B', '#FFEE58', '#FFF176', '#FFF59D', '#FFF9C4', '#FFFDE7'],
        ['#004D40', '#00695C', '#00796B', '#00897B', '#009688', '#26A69A', '#4DB6AC', '#80CBC4', '#B2DFDB', '#E0F2F1'],
        ['#0D47A1', '#1565C0', '#1976D2', '#1E88E5', '#2196F3', '#42A5F5', '#64B5F6', '#90CAF9', '#BBDEFB', '#E3F2FD'],
        ['#4A148C', '#6A1B9A', '#7B1FA2', '#8E24AA', '#9C27B0', '#AB47BC', '#BA68C8', '#CE93D8', '#E1BEE7', '#F3E5F5'],
        ['#212121', '#424242', '#616161', '#757575', '#9E9E9E', '#BDBDBD', '#E0E0E0', '#EEEEEE', '#F5F5F5', '#FAFAFA'],
    ],
    colorCard: false,

    h: 0,
    s: 1,
    v: 1,
    a: 1,

    ready: false,

    _create: function() {
        var self = this;
        this.el = document.createElement('div');
        this.el.className = this.uiCls + ' clearfix';
        this.el.innerHTML =
            '<div class="mini-colorpalette-sv"><div class="mini-colorpalette-sv-color"></div><div class="mini-colorpalette-s"></div><div class="mini-colorpalette-v"></div><div class="mini-colorpalette-sv-picker"></div></div><div class="mini-colorpalette-ha l"><div class="mini-colorpalette-h"><div class="mini-colorpalette-h-picker"></div></div><div class="mini-colorpalette-a"><div class="mini-colorpalette-a-color"></div><div class="mini-colorpalette-a-picker"></div></div></div><div class="mini-colorpalette-preview r"><div class="mini-colorpalette-preview-color"></div></div><div class="mini-colorpalette-text l clearfix"><div class="mini-colorpalette-hex-text l"><input type="text" tabindex="1"><span class="mini-colorpalette-text-info">HEX</span></div><div class="mini-colorpalette-a-text r"><input type="text" tabindex="5"><span class="mini-colorpalette-text-info">A</span></div><div class="mini-colorpalette-b-text r"><input type="text" tabindex="4"><span class="mini-colorpalette-text-info">B</span></div><div class="mini-colorpalette-g-text r"><input type="text" tabindex="3"><span class="mini-colorpalette-text-info">G</span></div><div class="mini-colorpalette-r-text r"><input type="text" tabindex="2"><span class="mini-colorpalette-text-info">R</span></div></div><div class="mini-colorpalette-colorcard l hidden"></div><div class="mini-colorpalette-history l hidden"></div>';

        this._$svEl = jQuery('.mini-colorpalette-sv', this.el);
        this._$svColorEl = jQuery('.mini-colorpalette-sv-color', this.el);
        this._$svPickerEl = jQuery('.mini-colorpalette-sv-picker', this.el);

        this._$hEl = jQuery('.mini-colorpalette-h', this.el);
        this._$hPickerEl = jQuery('.mini-colorpalette-h-picker', this.el);

        this._$aEl = jQuery('.mini-colorpalette-a', this.el);
        this._$aColorEl = jQuery('.mini-colorpalette-a-color', this.el);
        this._$aPickerEl = jQuery('.mini-colorpalette-a-picker', this.el);

        this._$previewColorEl = jQuery('.mini-colorpalette-preview-color', this.el);

        this._$hexInput = jQuery('.mini-colorpalette-hex-text > input', this.el);
        this._$aInput = jQuery('.mini-colorpalette-a-text > input', this.el);
        this._$bInput = jQuery('.mini-colorpalette-b-text > input', this.el);
        this._$gInput = jQuery('.mini-colorpalette-g-text > input', this.el);
        this._$rInput = jQuery('.mini-colorpalette-r-text > input', this.el);

        this._$colorCardEl = jQuery('.mini-colorpalette-colorcard', this.el);
        this._$historyEl = jQuery('.mini-colorpalette-history', this.el);

        this._isSvDragging = false;
        this._isHDragging = false;
        this._isADragging = false;

        this.setEnableHistory(this.enableHistory);

        this._afterReady = [];
        this.externalSrc = this.externalSrc || mini.externalSrc;
        if (window.tinycolor) {
            this._init();
        } else {
            // mini.loadJS(this.externalSrc + 'tinycolor/tinycolor.js', function() {
            mini.loadJSWithAMD(this.externalSrc + 'tinycolor/tinycolor.js', 'tinycolor', function() {
                self._init();
            });
        }
    },
    _init: function() {
        this._bindEvents();

        this._syncColor();
        this._renderAlpha();
        this._renderColorCard();

        this.ready = true;
        this._afterReady.forEach(function(fn) { fn(); });
        this._afterReady = [];
        this.fire('ready');
    },
    _bindEvents: function() {
        var self = this;

        mini.on(this._$svEl[0], 'mousedown', this._svDragStart, this);
        mini.on(this._$hEl[0], 'mousedown', this._hDragStart, this);
        mini.on(this._$aEl[0], 'mousedown', this._aDragStart, this);
        mini.on(window, 'mouseup', function() {
            self._svDragEnd();
            self._hDragEnd();
            self._aDragEnd();
        });

        this._$hexInput.on('input', function() {
            var hex = this.value.slice(0, 6);
            this.value = hex;
            if (hex.length === 6) {
                var color = tinycolor(hex);
                if (color.isValid()) {
                    self._setHsv(color.toHsv());
                    self.__OnValueChanged();
                }
            }
        });
        this._$hexInput.on('change', function() {
            self._syncColor();
        });

        this._$rInput.on('input', rgbaChange);
        this._$gInput.on('input', rgbaChange);
        this._$bInput.on('input', rgbaChange);
        this._$aInput.on('input', rgbaChange);

        this._$colorCardEl.on('click', '.mini-colorpalette-colorlump', colorClick);
        this._$historyEl.on('click', '.mini-colorpalette-colorlump', colorClick);

        function colorClick() {
            var color = tinycolor(jQuery(this).data('color'));
            if (color.isValid()) {
                self._setHsva(color.toHsv());
                self.__OnValueChanged();
            }
            self.__OnColorClick();
        }

        function rgbaChange() {
            var color = tinycolor({
                r: self._$rInput.val(),
                g: self._$gInput.val(),
                b: self._$bInput.val(),
                a: self._$aInput.val() / 100
            });
            if (color.isValid()) {
                self._setHsva(color.toHsv());
                self.__OnValueChanged();
            }
        }
    },
    _renderColorCard: function() {
        var self = this;
        var ROWMAX = 10; // 固定宽度；
        if (!this.colorCard) {
            this._$colorCardEl.empty().addClass('hidden');
            return;
        }

        var COLOR_CARD_TPL =
            '{{#rows}}<div class="mini-colorpalette-colorcard-row">{{#colors}}<span class="mini-colorpalette-colorlump" data-color="{{.}}"><span class="mini-colorpalette-colorlump-color" style="background-color: {{.}}"></span></span>{{/colors}}{{#placeholder}}<span class="mini-colorpalette-placeholder"></span>{{/placeholder}}</div>{{/rows}}';
        var rows = [];
        var rowMaxCount = 0;
        var colorCard = [];
        if (Array.isArray(this.colorCard)) {
            colorCard = this.colorCard;
        } else if (this.colorCard) {
            colorCard = this.defaultColorCard;
        }

        if (Array.isArray(colorCard[0])) {
            // 二维数组
            colorCard.forEach(function(row) {
                if (row.length > rowMaxCount) {
                    rowMaxCount = row.length;
                }
                rows.push({
                    colors: self.enableAlpha
                        ? row
                        : row.map(function(color) {
                              return tinycolor(color).toHexString();
                          })
                });
            });
            rowMaxCount = rowMaxCount > ROWMAX ? ROWMAX : rowMaxCount;
        } else {
            // 一维数组
            rows.push({
                colors: this.enableAlpha
                    ? colorCard
                    : colorCard.map(function(color) {
                          return tinycolor(color).toHexString();
                      })
            });
            rowMaxCount = ROWMAX;
        }
        // 每行补充占位块
        rows = rows.map(function(row) {
            var colors = row.colors;
            var placeholderCount = (rowMaxCount - (colors.length % rowMaxCount)) % rowMaxCount;
            var placeholders = [];
            for (var i = 0; i < placeholderCount; i++) {
                placeholders.push('');
            }
            return {
                colors: colors,
                placeholder: placeholders
            };
        });

        this._$colorCardEl
            .empty()
            .removeClass('hidden')
            .append(Mustache.render(COLOR_CARD_TPL, { rows: rows }));
    },
    _setHistory: function(history) {
        this.history = history;
        this._renderHistory();
    },
    _renderHistory: function() {
        var self = this;
        var ROWMAX = 10; // 固定宽度；
        if (this.enableHistory && this.history.length) {
            var HISTORY_TPL = '{{#colors}}<span class="mini-colorpalette-colorlump" data-color="{{.}}"><span class="mini-colorpalette-colorlump-color" style="background-color: {{.}}"></span></span>{{/colors}}{{#placeholder}}<span class="mini-colorpalette-placeholder"></span>{{/placeholder}}';
            var colors = this.history.map(function(color) {
                return self.enableAlpha ? color : tinycolor(color).toHexString();
            });
            // 禁用透明度去重
            if (!this.enableAlpha) {
                colors = colors.filter(function(color, index) {
                    return colors.indexOf(color) === index;
                });
            }
            var placeholderCount = ROWMAX - colors.length;
            var placeholder = [];
            for (var i = 0; i < placeholderCount; i++) {
                placeholder.push('');
            }
            this._$historyEl.empty().removeClass('hidden').append(Mustache.render(HISTORY_TPL, {
                colors: colors,
                placeholder: placeholder
            }));
        } else {
            this._$historyEl.empty().addClass('hidden');
        }
    },
    _renderAlpha: function() {
        this.a = this.enableAlpha ? this.a : 1;
        this._$aEl.toggleClass('hidden', !this.enableAlpha);
        this._$aInput.parent().toggleClass('hidden', !this.enableAlpha);
        this._$hEl.toggleClass('full-height', !this.enableAlpha);
    },
    // #region  饱和，明度
    _svDragStart: function(evt) {
        var svWidth = this._$svEl.width();
        var svHeight = this._$svEl.height();
        var x = evt.pageX - this._$svEl.offset().left;
        var y = evt.pageY - this._$svEl.offset().top;

        this.s = x / svWidth;
        this.v = 1 - y / svHeight;

        this.__OnValueChanged();
        this._isSvDragging = true;
        mini.on(window, 'mousemove', this._svDragging, this);
    },
    _svDragging: function(evt) {
        if (this._isSvDragging) {
            var svWidth = this._$svEl.width();
            var svHeight = this._$svEl.height();
            var x = evt.pageX - this._$svEl.offset().left;
            var y = evt.pageY - this._$svEl.offset().top;

            x = x > svWidth ? svWidth : x < 0 ? 0 : x;
            y = y > svHeight ? svHeight : y < 0 ? 0 : y;

            this.s = x / svWidth;
            this.v = 1 - y / svHeight;

            this.__OnValueChanged();
        }
    },
    _svDragEnd: function() {
        this._isSvDragging = false;
        mini.un(window, 'mousemove', this._svDragging, this);
    },
    // #endregion
    // #region  色相
    _hDragStart: function(evt) {
        var hWidth = this._$hEl.width();
        var x = evt.pageX - this._$hEl.offset().left;

        this.h = (x / hWidth) * 360;

        this.__OnValueChanged();
        this._isHDragging = true;
        mini.on(window, 'mousemove', this._hDragging, this);
    },
    _hDragging: function(evt) {
        if (this._isHDragging) {
            var hWidth = this._$hEl.width();
            var x = evt.pageX - this._$hEl.offset().left;

            x = x > hWidth ? hWidth : x < 0 ? 0 : x;

            this.h = (x / hWidth) * 360;

            this.__OnValueChanged();
        }
    },
    _hDragEnd: function() {
        this._isHDragging = false;
        mini.un(window, 'mousemove', this._hDragging, this);
    },
    // #endregion
    // #region  透明度
    _aDragStart: function(evt) {
        var aWidth = this._$aEl.width();
        var x = evt.pageX - this._$aEl.offset().left;

        this.a = x / aWidth;

        this.__OnValueChanged();
        this._isADragging = true;
        mini.on(window, 'mousemove', this._aDragging, this);
    },
    _aDragging: function(evt) {
        if (this._isADragging) {
            var aWidth = this._$aEl.width();
            var x = evt.pageX - this._$aEl.offset().left;

            x = x > aWidth ? aWidth : x < 0 ? 0 : x;

            this.a = x / aWidth;

            this.__OnValueChanged();
        }
    },
    _aDragEnd: function() {
        this._isADragging = false;
        mini.un(window, 'mousemove', this._aDragging, this);
    },
    // #endregion
    _getHColor: function() {
        return tinycolor({
            h: this.h,
            s: 1,
            v: 1
        });
    },
    _getHsvColor: function() {
        return tinycolor({
            h: this.h,
            s: this.s,
            v: this.v
        });
    },
    _getHsvaColor: function() {
        return tinycolor({
            h: this.h,
            s: this.s,
            v: this.v,
            a: this.a
        });
    },
    _setHsv: function(hsva) {
        this.h = hsva.h;
        this.s = hsva.s;
        this.v = hsva.v;
    },
    _setHsva: function(hsva) {
        this.h = hsva.h;
        this.s = hsva.s;
        this.v = hsva.v;
        this.a = hsva.a;
    },
    _syncColor: function() {
        // sync picker position
        this._syncHPicker();
        this._syncSVPicker();
        if (this.enableAlpha) {
            this._syncAPicker();
        }

        // sync color
        var hColor = this._getHColor();
        var hsvColor = this._getHsvColor();
        var hsvaColor = this._getHsvaColor();

        this._$svColorEl.css('background-color', hColor.toHexString());
        this._$aColorEl.css(
            'background-image',
            'linear-gradient(to right, transparent, ' + hsvColor.toHexString() + ')'
        );
        this._$previewColorEl.css('background-color', hsvaColor.toRgbString());

        // sync input
        var rgba = hsvaColor.toRgb();
        this._$rInput.val(rgba.r);
        this._$gInput.val(rgba.g);
        this._$bInput.val(rgba.b);
        this._$aInput.val(Math.round(rgba.a * 100));
        this._$hexInput.val(hsvaColor.toHex().toUpperCase());
    },
    _syncHPicker: function() {
        var x = (this.h / 360) * 100 + '%';

        this._$hPickerEl.css('left', x);
    },
    _syncSVPicker: function() {
        var x = this.s * 100 + '%';
        var y = (1 - this.v) * 100 + '%';

        this._$svPickerEl.css({
            left: x,
            top: y
        });
    },
    _syncAPicker: function() {
        var x = this.a * 100 + '%';

        this._$aPickerEl.css('left', x);
    },
    __OnValueChanged: function() {
        this._syncColor();
        this.fire('valuechanged', {value: this._getFormattedColor()});
    },
    __OnColorClick: function() {
        this.fire('colorclick', {value: this._getFormattedColor()});
    },
    _getFormattedColor: function() {
        var color = this._getHsvaColor();
        if (this.format === 'hex') {
            return this.a === 1 ? color.toHexString() : color.toHex8String();
        }
        if (this.format === 'rgb') {
            return color.toRgbString();
        }
        if (this.format === 'hsl') {
            return color.toHslString();
        }
        if (this.format === 'hsv') {
            return color.toHsvString();
        }
    },
    getValue: function() {
        var color = this._getHsvaColor();
        if (this.enableHistory) {
            mini.ColorPalette.history.record(color.toHex8String());
        }
        return this._getFormattedColor();
    },
    setValue: function(value) {
        var self = this;
        if (!this.ready) {
            this._afterReady.push(function() {
                self.setValue(value);
            });
            return;
        }
        var color = tinycolor(value);
        if (color.isValid()) {
            var hsva = color.toHsv();
            this.enableAlpha ? this._setHsva(hsva) : this._setHsv(hsva);
            this._syncColor();
        }
    },
    getFormat: function() {
        return this.format;
    },
    setFormat: function(format) {
        if (['hex', 'rgb', 'hsl', 'hsv'].indexOf(format) >= 0) {
            this.format = format;
        }
    },
    getEnableHistory: function() {
        return this.enableHistory;
    },
    setEnableHistory: function(enableHistory) {
        this.enableHistory = enableHistory;
        if (!mini.ColorPalette.history) {
            mini.ColorPalette.history = new ColorPaletteHistory();
        }
        mini.ColorPalette.history[enableHistory ? 'sub' : 'unSub'](this);
    },
    getEnableAlpha: function() {
        return this.enableAlpha;
    },
    setEnableAlpha: function(enableAlpha) {
        var self = this;
        this.enableAlpha = enableAlpha;
        if (!this.ready) {
            this._afterReady.push(function() {
                self.setEnableAlpha(self.enableAlpha);
            });
            return;
        }
        this._renderAlpha();

        // 重新渲染色卡，去掉透明度
        this._renderColorCard();
        this._renderHistory();

        this._syncColor();
    },
    getColorCard: function() {
        return this.colorCard;
    },
    setColorCard: function(colorCard) {
        var self = this;
        if (colorCard === true || colorCard === 'true' || colorCard === '') {
            this.colorCard = true;
        } else {
            try {
                colorCard = mini.decode(colorCard);
                if (Array.isArray(colorCard) && colorCard.length) {
                    this.colorCard = colorCard;
                } else {
                    this.colorCard = false;
                }
            } catch (e) {
                this.colorCard = false;
            }
        }
        if (!this.ready) {
            this._afterReady.push(function() {
                self.setColorCard(self.colorCard);
            });
            return;
        }

        this._renderColorCard();
    },
    setHue: function(hue) {
        var color = tinycolor({
            h: hue,
            s: this.s,
            v: this.v,
            a: this.a
        });
        if (color.isValid()) {
            this.h = color.toHsv().h;
            this._syncColor();
        }
    },
    setSaturation: function(saturation) {
        var color = tinycolor({
            h: this.h,
            s: saturation,
            v: this.v,
            a: this.a
        });
        if (color.isValid()) {
            this.s = color.toHsv().s;
            this._syncColor();
        }
    },
    setBrightness: function(brightness) {
        var color = tinycolor({
            h: this.h,
            s: this.s,
            v: brightness,
            a: this.a
        });
        if (color.isValid()) {
            this.v = color.toHsv().v;
            this._syncColor();
        }
    },
    setAlpha: function(alpha) {
        if (this.enableAlpha) {
            var color = tinycolor({
                h: this.h,
                s: this.s,
                v: this.v,
                a: alpha
            });
            if (color.isValid()) {
                this.a = color.toHsv().a;
                this._syncColor();
            }
        }
    },
    getAttrs: function(el) {
        var attrs = mini.ColorPalette.superclass.getAttrs.call(this, el);
        mini._ParseString(el, attrs, ['format', 'colorCard', 'onValueChanged', 'onColorClick', 'onReady']);
        mini._ParseBool(el, attrs, ['enableHistory', 'enableAlpha']);
        return attrs;
    }
});

mini.regClass(mini.ColorPalette, 'colorpalette');

mini.ColorPicker = function() {
    mini.ColorPicker.superclass.constructor.call(this);
};

mini.extend(mini.ColorPicker, mini.ButtonEdit, {
    uiCls: 'mini-colorpicker',
    value: '#ffffff',
    format: 'hex',
    colorCard: false,
    enableHistory: false,
    enableAlpha: true,
    allowInput: true,
    showColorText: true,

    ready: false,

    _create: function() {
        mini.ColorPicker.superclass._create.call(this);

        this._buttonEl.innerHTML = '<span class="mini-colorpicker-preview"><span class="mini-colorpicker-preview-color"></span></span>';
        this._previewColorEl = this._buttonEl.firstChild.firstChild;
        
        this._colorPalette = new mini.ColorPalette();
        this._colorPalette.setValue(this.value);
        this._colorPalette.setFormat(this.format);
        this._colorPalette.setColorCard(this.colorCard);
        this._colorPalette.setEnableHistory(this.enableHistory);
        this._colorPalette.setEnableAlpha(this.enableAlpha);

        this._popup = new mini.Popup();
        this._popup.setBody(this._colorPalette.el);
        this._popup.setyOffset(8);
        this._popup.__parent = this;
        this._popup.el.setAttribute('attached', 'true');

        this._renderColorText();
        this._syncPreviewColor(this.value);
        mini.ColorPicker.superclass.setText.call(this, this.value);

        this._afterReady = [];
    },
    _initEvents: function() {
        mini.ColorPicker.superclass._initEvents.call(this);

        mini.on(this._textEl, 'input', this.__OnInput, this);
        mini.on(this._textEl, 'blur', this.__OnBlur, this);
        mini.on(this.el, 'click', this.__OnClick, this);
        
        this._colorPalette.on('ready', this.__OnReady, this);
        this._colorPalette.on('valuechanged', handleColorPaletteValueChanged, this);
        this._colorPalette.on('colorclick', handleColorClick, this);
        this._popup.on('close', handlePopupClose, this);

        function handleColorPaletteValueChanged(evt) {
            var color = evt.value;
            mini.ColorPicker.superclass.setText.call(this, color);
            this._syncPreviewColor(color);
        }
        function handlePopupClose() {
            jQuery(this._textEl).trigger('blur');
            var color = this._colorPalette.getValue();
            if (color !== this.value) {
                this._syncFromPalette(color);
                this.__OnValueChanged();
            }
        }
        function handleColorClick() {
            this._popup.hide();
        }
    },
    __OnReady: function() {
        this.ready = true;
        this._afterReady.forEach(function(fn){fn();});
        this._afterReady = [];
        this.fire('ready');
    },
    __OnClick: function(e) {
        this._popup.showAtEl(this.el);

        mini.ColorPicker.superclass.__OnClick.call(this, e);
    },
    __OnInput: function() {
        var value = this._textEl.value;
        this._colorPalette.setValue(value);
        this._syncPreviewColor();
        this.fire('input', {value: value});
    },
    __OnValueChanged: function() {
        this.fire('valuechanged', {value: this.value});
    },
    _syncPreviewColor: function(color) {
        this._previewColorEl.style.backgroundColor = color || this._colorPalette.getValue();
    },
    _syncFromPalette: function(color) {
        var self = this;
        if (!this.ready) {
            this._afterReady.push(function() {
                self._syncFromPalette(color);
            });
            return;
        }
        color = color || this._colorPalette.getValue();
        this._syncPreviewColor(color);
        mini.ColorPicker.superclass.setText.call(this, color);
        mini.ColorPicker.superclass.setValue.call(this, color);
    },
    _renderColorText: function() {
        var _$textEl = jQuery(this._textEl),
            _$el = jQuery(this.el);
        if (this.showColorText) {
            _$textEl.removeClass('hidden');
            _$el.removeClass('no-text');
        } else {
            _$textEl.addClass('hidden');
            _$el.addClass('no-text');
        }
    },
    setValue: function(value) {
        this._colorPalette.setValue(value);
        this._syncFromPalette();
    },
    setFormat: function(format) {
        this._colorPalette.setFormat(format);
        this.format = this._colorPalette.getFormat();
        this._syncFromPalette();
    },
    getFormat: function() {
        return this.format;
    },
    setColorCard: function(colorCard) {
        this._colorPalette.setColorCard(colorCard);
        this.colorCard = this._colorPalette.getColorCard();
    },
    getColorCard: function() {
        return this.colorCard;
    },
    setEnableHistory: function(enableHistory) {
        this._colorPalette.setEnableHistory(enableHistory);
        this.enableHistory = this._colorPalette.getEnableHistory();
    },
    getEnableHistory: function() {
        return this.enableHistory;
    },
    setEnableAlpha: function(enableAlpha) {
        this._colorPalette.setEnableAlpha(enableAlpha);
        this.enableAlpha = this._colorPalette.getEnableAlpha();
        this._syncFromPalette();
    },
    getEnableAlpha: function() {
        return this.enableAlpha;
    },
    setShowColorText: function(showColorText) {
        this.showColorText = showColorText;
        this._renderColorText();
    },
    getShowColorText: function() {
        return this.showColorText;
    },
    showPopup: function() {
        this._popup.showAtEl(this.el);
    },
    hidePopup: function() {
        this._popup.hide();
    },
    getAttrs: function(el) {
        var attrs = mini.ColorPicker.superclass.getAttrs.call(this, el);
        mini._ParseString(el, attrs, ['format', 'colorCard', 'onValueChanged', 'onReady']);
        mini._ParseBool(el, attrs, ['enableHistory', 'enableAlpha', 'showColorText']);

        return attrs;
    }
});

mini.regClass(mini.ColorPicker, 'colorpicker');

/* global Cropper, Webcam */

mini.Cropper = function() {
    mini.Cropper.superclass.constructor.call(this);
};
mini.extend(mini.Cropper, mini.Control, {
    uiCls: 'mini-cropper',
    url: '',
    maxSize: 5242880, // 5M,
    maxSizeStr: '5M',

    title: epoint_local.Cropper.title,
    imageSizeText: epoint_local.Cropper.imageSizeText,
    selectImgText: epoint_local.Cropper.selectImgText,
    onlinePhotoText: epoint_local.Cropper.onlinePhotoText,
    previewText: epoint_local.Cropper.previewText,
    reselectText: epoint_local.Cropper.reselectText,
    finishText: epoint_local.Cropper.finishText,
    cancelText: epoint_local.Cropper.cancelText,
    validateText: epoint_local.Cropper.validateText,
    imageSizeAlertText: epoint_local.Cropper.imageSizeAlertText,
    noImageAlert: epoint_local.Cropper.noImageAlert,

    cropperConfig: {
        dragMode: 'move',
        aspectRatio: 1,
        cropBoxResizable: true,
        viewMode: 2,
        zoomOnWheel: true,
        autoCropArea: 0.9,
        preview: '.image-preview',
        autoCrop: true
    },

    _create: function() {
        var self = this;

        this.cropperConfig = $.extend(true, {}, this.cropperConfig);
        this.el = document.createElement('div');

        this.externalSrc = this.externalSrc || mini.externalSrc;
        if (window.Cropper) {
            this._initCropper();
        } else {
            mini.loadCSS(this.externalSrc + 'cropper/cropper.min.css');
            mini.loadJSWithAMD(this.externalSrc + 'cropper/cropper.min.js', 'Cropper', function() {
                self._initCropper();
            });
        }
        if (window.WebCam) {
            this._initWebCam();
        } else {
            mini.loadJSWithAMD(this.externalSrc + 'webcam/webcam.min.js', 'WebCam', function() {
                self._initWebCam();
            });
        }
    },
    _loadImg: function(dataUri) {
        this.$cropperImg.attr('src', dataUri);
        if (this.cropper) {
            this.cropper.destroy();
        }
        this.cropper = new Cropper(this.$cropperImg[0], this.cropperConfig);
        this.$cropperBody.removeClass('is-empty');
    },
    _initCropper: function() {
        var self = this;

        var bodyEl = document.createElement('div');
        bodyEl.className = 'mini-cropper-container is-empty';
        bodyEl.innerHTML =
            '<input type="file" class="input-image" name="file" accept="image/*"/><p class="info measure">' + this.imageSizeText
            + ': <span class="img-measure"></span></p><div class="img-cropper"><img /><label class="select-img" title="' + this.selectImgText + '">' + this.selectImgText
            + '</label><label class="take-img" title="' + this.onlinePhotoText + '">' + this.onlinePhotoText
            + '</label></div><div class="right"><span class="preview-text">' + this.previewText
            + '</span><div class="image-preview-wrap" style="width: 100px; height: 100px;"><div class="image-preview" style="width: 100%; height: 100%; overflow: hidden"></div></div><span class="info">100*100</span><div class="image-preview-wrap" style="width: 28px; height: 28px;"><div class="image-preview" style="width: 100%; height: 100%; overflow: hidden"></div></div><span class="info">28*28</span></div><div class="re-change"><label class="change-img">' + this.reselectText
            + '</label><label class="re-take-img">' + this.onlinePhotoText + '</label></div><div class="footer"><span class="finish btn">' + this.finishText + '</span><span class="cancel btn">' + this.cancelText + '</span></div>';

        this.$cropperBody = $(bodyEl);
        this.$cropperImg = $('.img-cropper > img', bodyEl);
        this.$imagePreview = $('.image-preview', bodyEl);
        this.$imgMeasure = $('.img-measure', bodyEl);

        var $inputImg = $('.input-image', bodyEl),
            $finishBtn = $('.finish.btn', bodyEl),
            $cancelBtn = $('.cancel.btn', bodyEl),
            $selectImg = $('.select-img, .change-img', bodyEl),
            $takePhoto = $('.take-img, .re-take-img', bodyEl);

        this.$cropperImg.on('crop', function(e) {
            self.__OnCropBoxChange(e);
        });

        $inputImg.on('change', function() {
            var files = this.files;
            var file;
            if (files && files.length) {
                file = files[0];
                if (/^image\/\w+$/.test(file.type)) {
                    var reader = new FileReader();
                    reader.addEventListener(
                        'load',
                        function() {
                            self._loadImg(reader.result);
                            $inputImg.val('');
                        },
                        false
                    );
                    reader.readAsDataURL(file);
                } else {
                    mini.alert(self.validateText);
                }
            }
        });

        $selectImg.on('click', function() {
            $inputImg.trigger('click');
        });

        $takePhoto.on('click', function() {
            self._startWebCam();
        });

        $finishBtn.on('click', function() {
            var imageData = self.getImageData();
            if (imageData) {
                if (self._validateSize(imageData)) {
                    self.__OnCropped(imageData);
                } else {
                    mini.alert(self.imageSizeAlertText + self.maxSizeStr);
                }
            } else {
                mini.alert(self.noImageAlert);
            }
        });

        $cancelBtn.on('click', function() {
            self._cropperWindow.hide();
        });

        this._cropperWindow = new mini.Window();
        this._cropperWindow.setTitle(this.title);
        this._cropperWindow.setBody(bodyEl);
        this._cropperWindow.setWidth(480);
        this._cropperWindow.setHeight(420);
        this._cropperWindow.on('close', function(e) {
            self.__OnClose(e);
            self._webCamWindow.hide();
            self._resetCropper();
        });
    },
    _initWebCam: function() {
        var self = this;

        var bodyEl = document.createElement('div');
        bodyEl.className = 'mini-cropper-webcam';
        bodyEl.innerHTML = '<div class="webcam-container"></div><span class="snap-button"></span>';

        var $snapButton = $('.snap-button', bodyEl);

        this._webCamWindow = new mini.Window();
        this._webCamWindow.setTitle(this.onlinePhotoText);
        this._webCamWindow.setBody(bodyEl);
        this._webCamWindow.setWidth(378);
        this._webCamWindow.setHeight(425);

        this._webCamWindow.on('close', function() {
            self._resetWebCam();
        });

        $snapButton.on('click', function() {
            Webcam.snap(function(data_uri) {
                self._loadImg(data_uri);
                self._webCamWindow.hide();
            });
        });

        Webcam.set({
            // live preview size
            width: 480,
            height: 360,

            // device capture size
            dest_width: 480,
            dest_height: 360,

            // final cropped size
            crop_width: 360,
            crop_height: 360,

            // format and quality
            image_format: 'jpeg',
            jpeg_quality: 90
        });
    },
    _startCropper: function() {
        this._cropperWindow.show();
    },
    _resetCropper: function() {
        if (this.cropper) {
            this.cropper.destroy();
            this.cropper = null;
        }
        this.$cropperBody.addClass('is-empty');
    },
    _startWebCam: function() {
        this._webCamWindow.show();
        Webcam.attach('.mini-cropper-webcam .webcam-container');
    },
    _resetWebCam: function() {
        Webcam.reset();
    },
    _validateSize: function(imgData) {
        var str = imgData.substr(22);
        str = str.replace(/=/g, '');
        var len = str.length;
        var fileSize = len - (len / 8) * 2;
        if (fileSize >= this.maxSize) {
            return false;
        }
        return true;
    },
    __OnCropped: function(imageData) {
        this._cropperWindow.hide();
        this.fire('cropped', {
            data: imageData
        });
        if (this.url) {
            this.__OnBeforeUpload({ data: imageData });
        }
    },
    __OnClose: function(e) {
        this.fire('close', e);
    },
    __OnCropBoxChange: function(e) {
        var width = e.originalEvent.detail.width,
            height = e.originalEvent.detail.height;
        this.$imgMeasure.text(Math.round(width) + 'x' + Math.round(height));

        this.fire('cropboxchange', { htmlEvent: e });
    },
    __OnBeforeUpload: function(e) {
        this.fire('beforeupload', e);
        if (e.cancel) {
            return;
        }
        this._upload(e.data);
    },
    __OnUploaded: function(e) {
        this.fire('uploaded', e);
    },
    _upload: function(imgData) {
        var self = this;
        if (this.url) {
            mini.mask({
                el: document.body,
                cls: 'mini-mask-loading'
            });
            Util.ajax({
                url: this.url,
                data: {
                    imgData: imgData
                }
            })
                .always(function() {
                    mini.unmask(document.body);
                })
                .done(function(data) {
                    self.__OnUploaded({ data: data });
                });
        }
    },
    getImageData: function() {
        if (this.cropper) {
            return this.cropper.getCroppedCanvas().toDataURL();
        }
        return null;
    },
    show: function() {
        this._startCropper();
    },
    hide: function() {
        this._cropperWindow.hide();
    },
    getAttrs: function(el) {
        var attrs = mini.Cropper.superclass.getAttrs.call(this, el);
        mini._ParseString(el, attrs, [
            'oncropped',
            'oncropboxchange',
            'onclose',
            'onbeforeupload',
            'onuploaded',
            'aspectRatio',
            'title',
            'url'
        ]);
        mini._ParseInt(el, attrs, ['maxSize']);
        return attrs;
    },
    setAspectRatio: function(v) {
        var ratio;
        // 匹配除法
        if (/^([1-9][\d]*|0)(\.[\d]+)?\s*\/\s*([1-9][\d]*|0)(\.[\d]+)?$/.test(v)) {
            ratio = Util.safeEval(v);
        } else {
            ratio = +v;
        }

        if (!Number.isNaN(ratio)) {
            this.cropperConfig.aspectRatio = ratio;
            if (this.cropper) {
                this.cropper.setAspectRatio(this.cropperConfig.aspectRatio);
            }
        }
    },
    getAspectRatio: function() {
        return this.cropperConfig.aspectRatio;
    },
    setMaxSize: function(v) {
        var maxSize = parseInt(v, 10);
        if (!Number.isNaN(maxSize)) {
            this.maxSize = maxSize;

            var n = 0;
            var unit = ['B', 'KB', 'MB', 'GB', 'TB'];
            while (maxSize >= 1024) {
                maxSize /= 1024;
                n++;
            }
            this.maxSizeStr = maxSize + unit[n];
        }
    },
    getMaxSize: function() {
        return this.maxSize;
    },
    setTitle: function(v) {
        this.title = v;
        if (this._cropperWindow) {
            this._cropperWindow.setTitle(v);
        }
    },
    getTitle: function() {
        return this.title;
    },
    setUrl: function(v) {
        this.url = v;
    },
    getUrl: function() {
        return this.url;
    }
});

mini.regClass(mini.Cropper, 'cropper');

mini.DataExport = function () {
    mini.DataExport.superclass.constructor.call(this);
};

mini.extend(mini.DataExport, mini.Button, {
    mapClass: 'com.epoint.basic.faces.export.DataExport',
    extraId: '',
    exportAction: '', // 指定后台导出方法
    paramName: 'commonDto',
    // 相关联表格的id
    gridId: '',
    // 导出时请求的后台处理地址
    exportUrl: '',
    // 是否允许用户修改导出文件名
    allowModifyFileName: false,
    // 默认导出文件的文件名
    defaultFileName: '',
    // 导出文件的文件名
    fileName: '',
    // column初始时的位置
    position: 'right',

    uiCls: 'mini-dataexport',

    // 列的值选项
    columnsValue: '',
    // 列的文本选项
    columnsText: '',

    // 是否需要每次展示时都去动态获取一遍columns
    dynamicColumns: false,

    expandText: epoint_local.DataExport.expandText,
    collapseText: epoint_local.DataExport.collapseText,
    exportText: epoint_local.DataExport.expandText,
    // panelTitle: '导出列配置',
    leftListTitle: epoint_local.DataExport.leftListTitle,
    rightListTitle: epoint_local.DataExport.rightListTitle,
    // tipInfo: '不填页码即导出当前页',
    fromText: epoint_local.DataExport.fromText,
    pageNumInfo: epoint_local.DataExport.pageNumInfo,
    pageText: epoint_local.DataExport.pageText,
    exportModelText: epoint_local.DataExport.exportModelText,
    selectExportText: epoint_local.DataExport.selectExportText,
    allExportText: epoint_local.DataExport.allExportText,
    curPageExportText: epoint_local.DataExport.curPageExportText,

    _clearBorder: false,

    showExportModel: false,
    showIcon: false,

    _iconCls: 'icon-upload',

    _create: function () {
        mini.DataExport.superclass._create.apply(this, arguments);
        this.set({
            text: this.collapseText,
            disableMultiClick: false
        });

        if (this.showIcon) {
            this.setIconCls(this._iconCls);
        }
        // this.el = this.el;

        this.popup = new mini.Popup();
        this.popup.__parent = this;
        this.popup.el.setAttribute('attached', 'true');
        this.panel = new mini.Panel();
        this.popup.addCls('mini-dataexport-popup');
        this.panel.addCls('mini-dataexport-panel');
        this.panel.set({
            width: 450,
            showToolbar: false,
            showFooter: false,
            showHeader: false
        });

        this.popup.render(document.body);
        this.panel.render(this.popup.el);

        var bodyArr = [
            '<div class="mini-export-list"><div class="mini-export-left"></div><div class="mini-export-middle"></div><div class="mini-export-right"></div></div>'
        ];
        // bodyArr.push(
        //     '<div class="mini-export-line"><div id="' +
        //     this.id +
        //     '-rbl" class="mini-radiobuttonlist" repeatItems="1" repeatLayout="table" ></div></div>'
        // );
        bodyArr.push('<div class="mini-export-line">');
        bodyArr.push('<div id="' +
            this.id +
            '-rbl" class="mini-radiobuttonlist" repeatItems="1" repeatLayout="table" ></div>');
        bodyArr.push('<div id="' +
            this.id +
            '-model-ck" class="mini-checkbox model-ck" style="display:none" text="' +
            this.exportModelText +
            '"></div>');
        bodyArr.push('</div>');
        bodyArr.push(
            '<a id="' +
            this.id +
            '-action" class="mini-button mini-btn-primary mini-export-btn">' +
            this.exportText +
            '</a>'
        );
        bodyArr.push('<div style="display:none;"></div>');

        this.panel.setBody(bodyArr.join(''));

        mini.parse(this.popup.el);

        this._panel = this.panel.el;

        this._exportBtn = mini.get(this.id + '-action', this._panel);

        var body = this.panel.getBodyEl();
        this._listContent = body.firstChild;
        this._exportRbl = mini.get(this.id + '-rbl', this._panel);
        this._exportRbl.setData([{
            text: this.selectExportText,
            id: '0'
        }, {
            text: this.allExportText,
            id: '1'
        }, {
            text: this.curPageExportText,
            id: '2'
        }, {
            text: this.fromText +
                '<input type="text" class="mini-export-num" id="' +
                this.id +
                '-fromnum"/>' +
                this.pageNumInfo +
                '<input type="text" class="mini-export-num" id="' +
                this.id +
                '-tonum"/>' +
                this.pageText,
            id: '3'
        }]);

        this._radioTrs = this._exportRbl._innerEl.getElementsByTagName('tr');
        this._rowTr = this._radioTrs[0];
        this._curPageTr = this._radioTrs[2];
        this._pageTr = this._radioTrs[3];

        this._fromNumInput = mini.byId(this.id + '-fromnum', this._pageTr);
        this._toNumInput = mini.byId(this.id + '-tonum', this._pageTr);

        this.exportModelCheck = mini.get(this.id + '-model-ck', this._panel);

        this._exportFormWrap = body.lastChild;

        var iframeId = this.id + '-exportIFrame';
        this._exportFormWrap.innerHTML =
            '<form method="post" target="' + iframeId + '"><input type="hidden" name="' +
            this.paramName +
            '" /></form><iframe id="' + iframeId + '" name="' + iframeId + '" style="display:none;"></iframe>';

        this._exportForm = this._exportFormWrap.firstChild;
        this._exportFormField = this._exportForm.firstChild;

        this._exportIframe = this._exportFormWrap.lastChild;

        this._contentL = this._listContent.firstChild;
        this._contentM = this._listContent.childNodes[1];
        this._contentR = this._listContent.lastChild;

        this._contentL.innerHTML =
            '<div class="mini-export-list-header">' +
            this.leftListTitle +
            '</div><div class="mini-export-list-content"></div>';
        this._contentR.innerHTML =
            '<div class="mini-export-list-header">' +
            this.rightListTitle +
            '</div><div class="mini-export-list-content"></div>';

        this.leftListBox = new mini.ListBox();
        this.leftListBox.set({
            height: 170,
            width: 180,
            valueField: 'field',
            showCheckBox: true,
            multiSelect: true
        });
        this.leftListBox.render(this._contentL.lastChild);

        this.rightListBox = new mini.ListBox();
        this.rightListBox.set({
            height: 170,
            width: 180,
            valueField: 'field',
            showCheckBox: true,
            multiSelect: true
        });
        this.rightListBox.render(this._contentR.lastChild);

        this._initButtons();
    },

    _initEvents: function () {
        mini.DataExport.superclass._initEvents.apply(this, arguments);
        var that = this;
        this.on('click', function () {
            if (!mini.hasClass(that.el, 'mini-button-popup')) {
                that.showPanel();
            } else {
                that.hidePanel();
            }
        });

        this._exportBtn.on('click', function (e) {
            if(that.allowModifyFileName){
                mini.prompt("请输入导出文件名：", "请输入",
                    function (action, value) {
                        if (action == "ok") {
    
                            var curVal='';
                            curVal = value ? value : that.defaultFileName;
                            
                            that.setFileName(curVal);
                            
                            that._OnExport(e);
                        } 
                    }
                );
            }else{
                that._OnExport(e);
            }
        });

        // 开始页码输入
        mini.on(this._fromNumInput, 'blur', function () {
            if (that.dataGrid) {
                var pageIndex = that.dataGrid.getPageIndex() + 1,
                    totalPage = that.dataGrid.getTotalPage(),
                    toIndex = parseInt(that._toNumInput.value, 10),
                    value = parseInt(this.value, 10);

                // 无value，则为当前页
                if (!value) {
                    value = pageIndex;
                } else if (value > totalPage) {
                    value = totalPage;
                }
                if (value > toIndex) {
                    value = toIndex;
                }
                if (value < 1) {
                    value = 1;
                }

                this.value = value;
            }
        });

        // 结束页码输入
        mini.on(this._toNumInput, 'blur', function () {
            if (that.dataGrid) {
                var pageIndex = that.dataGrid.getPageIndex() + 1,
                    totalPage = that.dataGrid.getTotalPage(),
                    fromIndex = parseInt(that._fromNumInput.value, 10),
                    value = parseInt(this.value, 10);

                if (!value || value > totalPage) {
                    // 不填 或超出默认为最大页码
                    value = totalPage;
                }

                if (value < fromIndex) {
                    // 不得小于开始页码
                    value = fromIndex;
                }

                this.value = value;
            }
        });

        mini.on(document, 'mouseup', this._OnDocMouseUp, this);

        mini.on(this._exportIframe, 'load', function () {
            that.fire('exportsuccess');
        });
    },

    _getExportData: function () {
        var data = {
            columns: this.rightListBox.data,
            fileName: this.fileName
        };

        // 必须指定文件名
        if (!data.fileName) {
            window.console && window.console.error && console.error('未指定导出文件的filename，导出文件可能不正常！');
        }

        if (this.gridId) {
            if (!this.dataGrid) {
                this.dataGrid = mini.get(this.gridId);
            }
            // 获取用户选中的类型  0：当前行，1：全部页码，2：当前页，3：指定页码
            var exportType = this._exportRbl.value,
                pageSize = this.dataGrid.getPageSize(),
                totalCount = this.dataGrid.getTotalCount(),
                sortField = this.dataGrid.getSortField(),
                sortOrder = this.dataGrid.getSortOrder(),
                maxPageIndex = this.dataGrid.getTotalPage() - 1,
                fromIndex = 0,
                toIndex = 0,
                pageIndex = this.dataGrid.getPageIndex(),
                exportByTemplate = this.exportModelCheck.checked;

            switch (exportType) {
                case '0':
                    // 当前行
                    fromIndex = pageIndex;
                    toIndex = pageIndex;
                    data.idField = this.dataGrid.idField;
                    data.checkedRows = {};
                    data.checkedRows[this.dataGrid.idField] = this._getSelectedGridIds();
                    break;

                case '1':
                    // 全部页码 从0 到最大页码
                    fromIndex = 0;
                    toIndex = maxPageIndex;
                    break;

                case '2':
                    // 当前页码
                    fromIndex = pageIndex;
                    toIndex = pageIndex;
                    break;

                case '3':
                    // 指定页码
                    fromIndex = parseInt(this._fromNumInput.value, 10) - 1;
                    toIndex = parseInt(this._toNumInput.value) - 1;
                    // 不填开始页码则为当前页
                    if (!mini.isNumber(fromIndex)) {
                        fromIndex = pageIndex;
                    }
                    // 不填结束页码 或者填的结束页码小于开始页码 结束页码为总页码
                    if (!mini.isNumber(toIndex) || toIndex < fromIndex) {
                        toIndex = maxPageIndex;
                    }
                    break;

                default:
                    break;
            }

            mini.copyTo(data, {
                fromIndex: fromIndex,
                toIndex: toIndex,
                pageSize: pageSize,
                totalCount: totalCount,
                sortField: sortField,
                sortOrder: sortOrder,
                exportByTemplate: exportByTemplate
            });
        }

        return data;
    },

    _getSelectedGridIds: function () {
        var ids = [];
        var rows = [];
        var idField = this.dataGrid.idField;

        if (this.dataGrid) {
            rows = this.dataGrid.getAllSelecteds();
        }

        for (var i = 0, l = rows.length; i < l; i++) {
            var r = rows[i];
            ids.push(r[idField]);
        }

        return ids.join(',');
    },
    _OnExport: function(event) {
        var data = this._getExportData();

        data.exportUrl = this.exportUrl;

        if (this.dataGrid && this.dataGrid.action) {
            data.gridAction = this.dataGrid.action;
            data.gridColumns = this._getColumns(this.dataGrid.columns);
        }
        var e = {
            htmlEvent: event,
            sender: this,
            data: data,
            cancel: false
        };
        this.fire('beforeexport', e);
        if (e.cancel) {
            return this.hidePanel();
        }

        this._exportFormField.value = typeof e.data === 'string' ? e.data : mini.encode(e.data);

        // 增加对csrf安全拦截的处理
        var csrfcookie = $.cookie(window.CSRF_COOKIE_NAME || '_CSRFCOOKIE');
        if (csrfcookie) {
            if (!this._csrfField) {
                this._csrfField = this._addHiddenToExportForm(window.CSRF_HD_NAME || 'CSRFCOOKIE');
            }

            this._csrfField.value = csrfcookie;
        }

        if (this.cmdParams) {
            if (!this._cmdParams_field) {
                this._cmdParams_field = this._addHiddenToExportForm('cmdParams');
            }
            this._cmdParams_field.value = this.cmdParams;
        }

        var attackData = Util.addReplayAttackData(
            {
                commonDto: this._exportFormField.value,
                cmdParams: this.cmdParams
            },
            this.exportUrl
        );
        if (attackData.reqtime) {
            for (var key in attackData) {
                if (key === 'commonDto' || key === 'cmdParams') {
                    continue;
                }
                if (!this['_' + key + '_field']) {
                    this['_' + key + '_field'] = this._addHiddenToExportForm(key);
                }
                this['_' + key + '_field'].value = attackData[key];
            }
        }

        this._exportForm.submit();

        this.hidePanel();
    },

    _addHiddenToExportForm: function(name) {
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = name;

        this._exportForm.appendChild(hidden);

        return hidden;
    },

    _OnDocMouseUp: function (e) {
        if (!mini.isAncestor(this.popup.el, e.target) && !mini.isAncestor(this.el, e.target)) {
            this.hidePanel();
        }
    },

    _initButtons: function () {
        this._contentM.innerHTML =
            '<button class="mini-export-listbtn mini-icon right" type="button"></button><button class="mini-export-listbtn mini-icon right-all" type="button"></button><button class="mini-export-listbtn mini-icon left" type="button"></button><button class="mini-export-listbtn mini-icon left-all" type="button"></button>';

        var that = this;
        mini.on(this._contentM, 'click', function (e) {
            var target = e.target,
                items;
            if (mini.hasClass(target, 'right')) {
                items = that.leftListBox.getSelecteds();
                that.leftListBox.removeItems(items);
                that.rightListBox.addItems(items);
            } else if (mini.hasClass(target, 'right-all')) {
                items = that.leftListBox.getData();
                that.leftListBox.removeItems(items);
                that.rightListBox.addItems(items);
            } else if (mini.hasClass(target, 'left')) {
                items = that.rightListBox.getSelecteds();
                that.rightListBox.removeItems(items);
                that.leftListBox.addItems(items);
            } else if (mini.hasClass(target, 'left-all')) {
                items = that.rightListBox.getData();
                that.rightListBox.removeItems(items);
                that.leftListBox.addItems(items);
            }

            that._enableExportBtn();
        });
    },

    _enableExportBtn: function() {
        if(this.gridId && this.rightListBox.data.length === 0) {
            this._exportBtn.disable();
        } else {
            this._exportBtn.enable();
        }
    },

    setExportUrl: function(url) {
        // 对于action配置为“xxxaction(aaa,bbb)”这种形式的，安全拦截中不允许url上出现“()”，所以需要将“()”里的内容拿下来，放到cmdParams里
        var reg = /\([\w\W]*\)/,
            match = url.match(reg);
        if (match) {
            url = url.replace(reg, '');

            this.cmdParams = match[0].replace('(', '[').replace(')', ']');
        }
        this.exportUrl = url;
        this._exportForm.action = url;
    },

    getExportUrl: function () {
        return this.exportUrl;
    },

    getGridId: function () {
        return this.gridId;
    },

    setGridId: function (gridId) {
        this.gridId = gridId;
        this.dataGrid = mini.get(gridId);
    },

    showPanel: function () {
        var e = {
            cancel: false
        };
        this.fire('beforeshowpanel', e);

        if(e.cancel) {
            return;
        }
        this._adjustRadioLayout();
        this.setText(this.expandText);
        this.addCls('mini-button-popup');
        if (!this.isInit || this.dynamicColumns) {
            var columns = this.getColumns();

            if (this.position == 'left') {
                this.leftListBox.setData(columns);
                this.rightListBox.setData([]);
            } else {
                this.rightListBox.setData(columns);
                this.leftListBox.setData([]);
            }
            this.isInit = true;
        }
        this._enableExportBtn();
        this.popup.showAtEl(this.el);
        this.fire('showpanel', e);
    },

    _adjustRadioLayout: function () {
        if (!this.dataGrid && this.gridId) {
            this.dataGrid = mini.get(this.gridId);
        }
        if (this.dataGrid) {
            mini.removeClass(this._exportRbl.el, 'hidden');
            if (this.dataGrid.multiSelect && this._getSelectedGridIds()) {
                mini.removeClass(this._rowTr, 'hidden');
                // mini.removeClass(this._pageTrRadio, 'hidden');
                this._exportRbl.setValue('0');
            } else {
                mini.addClass(this._rowTr, 'hidden');
                // mini.addClass(this._pageTrRadio, 'hidden');
                this._exportRbl.setValue('1');

                if (!this.dataGrid.showPager) {
                    mini.addClass(this._curPageTr, 'hidden');
                    mini.addClass(this._pageTr, 'hidden');
                }
                // 设置表格的当前页码作为默认的导出开始页码
                this._fromNumInput.value = this.dataGrid.getPageIndex() + 1;
            }
        } else {
            // 没有datagrid
            mini.addClass(this._exportRbl.el, 'hidden');
        }
    },

    hidePanel: function () {
        this.removeCls('mini-button-popup');
        this.setText(this.collapseText);
        this.popup.hide();

        this.fire('hidepanel');
    },

    getColumns: function () {
        var data = [];

        if (this.columnsData) {
            data = this.columnsData;
        } else if (this.columnsValue) {
            var values = this.columnsValue.split(','),
                texts = this.columnsText.split(','),
                len = values.length,
                i = 0;

            for (; i < len; i++) {
                data.push({
                    text: texts[i] ? texts[i] : values[i],
                    field: values[i]
                });
            }
        } else if (this.gridId) {
            if (!this.dataGrid) {
                this.dataGrid = mini.get(this.gridId);
            }
            if (this.dataGrid) {
                data = this._getColumns(this.dataGrid.columns);
            } else {
                data = [];
            }
        }


        var e = {
            columns: data
        };
        this.fire('beforeupdatecolumn', e);

        data = e.columns;

        this.columnsData = data;
        return data;
    },

    _getColumns: function(columns) {
        var data = [];
        for (var i = 0, len = columns.length; i < len; i++) {
            var column = columns[i];
            if (!column.field) {
                if (column.columns) {
                    var childColumns = this._getColumns(column.columns);
                    data = data.concat(childColumns);
                }
            } else {
                data.push({
                    text: column.header,
                    field: column.field,
                    code: column.code,
                    format: column.format,
                    dataOptions: column['data-options']
                });
            }
        }
        return data;
    },

    setCollapseText: function (collapseText) {
        this.collapseText = collapseText;

        if (this) {
            this.setText(collapseText);
        }
    },

    getFileName: function () {
        return this.fileName;
    },

    setFileName: function (fileName) {
        this.fileName = fileName;
    },

    setShowIcon: function (showIcon) {
        this.showIcon = showIcon;

        this && this.setIconCls(showIcon ? this._iconCls : '');
    },

    setShowExportModel: function(showExportModel) {
        if(this.showExportModel == showExportModel) {
            return;
        }
        
        this.showExportModel = showExportModel;
        if(showExportModel) {
            this.exportModelCheck.show();
        } else {
            this.exportModelCheck.hide();
            this.exportModelCheck.setChecked(false);
        }
    },
    setData: function(columns) {
        if (!this.columnsValue) {
            this.columnsData = columns;
            this.isInit = false;
        }
    },
    getData: function() {
        return this.columnsData || [];
    },

    getExtraId: function() {
        return this.extraId;
    },

    setExtraId: function(extraId) {
        this.extraId = extraId;
    },
    getAttrs: function (el) {
        var attrs = mini.DataExport.superclass.getAttrs.call(this, el);
        mini._ParseString(el, attrs, [
            'gridId',
            'exportUrl',
            'onbeforeexport',
            'fileName',
            'columnsText',
            'columnsValue',
            'position',
            'expandText',
            'collapseText',
            'onbeforeupdatecolumn',
            'onexportsuccess',
            'onbeforeshowpanel',
            'onshowpanel',
            'onhidepanel',
            'exportAction'
        ]);
        mini._ParseBool(el, attrs, ['dynamicColumns', 'showIcon', 'showExportModel', 'allowModifyFileName']);
        attrs.text = attrs.expandText;
        if(!attrs.text) {
            attrs.text = this.expandText;
        }
        return attrs;
    }
});

mini.regClass(mini.DataExport, 'dataexport');
mini.DataImport = function () {
    mini.DataImport.superclass.constructor.call(this);
};
mini.extend(mini.DataImport, mini.Control, {
    uiCls: 'mini-dataimport',
    url: '',

    pickerText: epoint_local.DataImport.pickerText,
    expandText: epoint_local.DataImport.expandText,
    collapseText: epoint_local.DataImport.collapseText,
    continueImportTip: epoint_local.DataImport.continueImportTip,
    continueText: epoint_local.DataImport.continueText,
    retryText: epoint_local.DataImport.retryText,
    retryTip: epoint_local.DataImport.retryTip,
    viewDetailText: epoint_local.DataImport.viewDetailText,
    validateText: epoint_local.DataImport.validateText,
    resultTpl: epoint_local.DataImport.resultTpl,
    importResultText: epoint_local.DataImport.importResultText,
    importFailAlert: epoint_local.DataImport.importFailAlert,
    importSuccessText: epoint_local.DataImport.importSuccessText,

    extraId: '',

    _create: function () {
        this.el = document.createElement('div');

        this.uploader = new mini.WebUploader();

        this.uploader.set({
            uploadUrl: this.url,
            pickerText: this.pickerText,
            fileNumLimit: 1,
            limitType: 'xls,xlsx,xlsm',
            showDefaultUI: false,
            auto: false,
            renderTo: this.el
        });

        this.uploader.on('beforefilequeued', this._onBeforeFileQueued, this);
        this.uploader.on('filesqueued', this._onFilesQueued, this);
        this.uploader.on('uploadbeforesend', this._onUploadBeforeSend, this);
        this.uploader.on('uploadprogress', this._onUploadProgress, this);
        this.uploader.on('uploadsuccess', this._onUploadSuccess, this);

        this.uploader._uploadBtn.hide();

        this.maskEl = document.createElement('div');
        this.maskEl.className = 'mini-dataimport-mask';
        this.maskEl.innerHTML = '<div class="mini-dataimport-mask-content"></div>';
        this.maskContent = this.maskEl.firstChild;

        document.body.appendChild(this.maskEl);

        this.detailEl = document.createElement('div');
        this.detailEl.className = 'mini-dataimport-detail';
        this.detailEl.innerHTML = '<div class="mini-dataimport-detail-content"></div><i class="dataimport-detail-close">X</i>';
        this.detailContent = this.detailEl.firstChild;

        document.body.appendChild(this.detailEl);

        this._bindEvent();
    },

    _bindEvent: function () {
        var self = this;
        jQuery(this.maskEl).on('click', '.dataimport-showdetail', function () {
            self.showDetailStatus();
            return false;
        }).on('click', '.dataimport-continue', function () {
            self.isContinueImport = true;
            self.uploader._uploader.upload();
        }).on('click', '.dataimport-restart', function () {
            self.uploader._uploader.upload();
        }).on('click', function () {
            if (self.isImportFinished && !self.isDetailShow) {
                self.maskEl.style.display = 'none';
            }
        });

        jQuery(this.detailEl).on('click', '.dataimport-detail-close', function () {
            self.hideDetailStatus();
        }).on('click', '.dataimport-status-toggle', function () {
            var $this = $(this),
                $parent = $this.parent();

            if ($parent.hasClass('opened')) {
                $this.text(self.expandText);
                $parent.removeClass('opened');
            } else {
                $this.text(self.collapseText);
                $parent.addClass('opened');
            }
        });
    },

    _onFilesQueued: function (event) {
        var files = event.files,
            file = files[0],
            self = this;
        if (!file) {
            return;
        }

        var html = this._generateFileList({
            id: file.id,
            name: file.name,
            size: file.size
        });

        this.isImportFinished = false;

        this.maskContent.innerHTML = html;
        this.maskEl.style.display = 'block';

        this.uploader._uploader.md5File(file)
            .progress(function (percentage) {

            }).then(function (md5) {
                self._curFileMD5 = md5;
                var data = {
                    fileMD5: md5,
                    fileName: file.name,
                    fileSize: file.size
                };

                data[self.uploader.id + '_action'] = 'queryFileStatus';

                if (self.uploader.getCommonData) {
                    data.commonDto = mini.encode(self.uploader.getCommonData());
                }

                self._onPostFileMd5(data);

                // 与服务端验证
                $.ajax(self.url, {
                    dataType: 'json',
                    data: data,
                    type: 'post',
                    success: function (response) {
                        if (mini.getSecondRequestData) {
                            response = mini.getSecondRequestData(response);
                        }
                        self._onQueryFileStatus(response);
                    }
                });
            });
    },

    _onPostFileMd5: function(data) {
        var extraData,
        uploadData;
        if(this.extraId) {
            extraData = DtoUtils.getCommonDto(this.extraId).getData(true);
            uploadData = this.uploader.getCommonData();
            for(var i in extraData){
                if(Object.prototype.hasOwnProperty.call(extraData, i) && i != '_common_hidden_viewdata') {
                    uploadData.push(extraData[i]);
                }
            }

            data.commonDto = mini.encode(uploadData);

        }
        this.fire('postfilemd5', {
            data: data
        });

        Util.addReplayAttackData(data, this.url);
    },

    _curFileMD5: '',
    _curAttachGuid: '',
    _onQueryFileStatus: function (data) {
        if (data.msg) {
            mini.alert(data.msg);
        }

        this.setDetailStatus(data.detail);
        this._curAttachGuid = data.attachGuid;
        this._oldAttachGuid = data.attachGuidOld;

        if (data.end) {
            this._onFinished(data.status);
            return;
        }

        if (data.pollingFrequency) {
            this._pollingFrequency = data.pollingFrequency;
        }

        if (data.action == 'importStatus') {
            this.pollingStatus(data);
        } else if (data.action == 'upload') {
            this.uploader._uploader.upload();
        } else {
            jQuery(this.maskContent).find('.mini-dataimport-action').removeClass('hidden');
        }

    },

    _onUploadBeforeSend: function (event) {
        if (this.isContinueImport) {
            event.data.attachGuid = this._curAttachGuid;
        }
        event.data.fileMD5 = this._curFileMD5;
    },

    _onUploadProgress: function (event) {
        var file = event.file,
            percentage = event.percentage,
            li = mini.byId(file.id),
            $progressbar = jQuery('.mini-dataimport-progressbar', li),
            $progresstext = jQuery('.progress-text', $progressbar),
            $progressbody = jQuery('.progress-body', $progressbar),
            width = Math.round(percentage * 100) + '%';

        $progresstext.text(width);
        $progressbody.width(width);
    },

    _generateFileList: function (options) {

        var list = [];
        list.push('<div class="mini-dataimport-item">');
        list.push('<span class="mini-dataimport-info">' + options.name + '</span>');
        list.push('<span class="mini-dataimport-size">(' + this._getSize(options.size) + ')</span>');
        list.push('<span class="mini-dataimport-progressbar"><span class="progress-text">0%</span><div class="progress-body"></div></span>');

        list.push('<span class="mini-dataimport-action hidden"><a href="javascript:void(0)" class="dataimport-continue" title="' + this.continueImportTip + '">' + this.continueText + '</a><a href="javascript:void(0)" class="dataimport-restart" title="' + this.retryTip + '">' + this.retryText + '</a><a href="javascript:void(0)" class="dataimport-showdetail hidden">' + this.viewDetailText + '</a></span>');

        list.push('</div>');

        return list.join('');
    },

    _generateImportStatus: function (options) {
        var list = [];
        list.push('<div class="mini-dataimport-item">');
        list.push('<span class="mini-dataimport-info">' + (options.status || '') + '</span>');
        if (options.handlepercent >= 0) {
            list.push('<span class="mini-dataimport-progressbar"><span class="progress-text">' + options.handlepercent + '%</span><div class="progress-body" style="width:' + options.handlepercent + '%;"></div></span>');
        }

        if (options.end) {
            list.push('<span class="mini-dataimport-action"><a href="javascript:void(0)" class="dataimport-showdetail">' + this.viewDetailText + '</a></span>');
        }

        list.push('</div>');

        return list.join('');
    },

    _generateStatuslist: function (options) {
        var i, len, arr,
            isCheckEnd = true,
            isSaveEnd = true;
        var list = ['<div class="dataimport-status-item">'];
        list.push('<h3 class="dataimport-status-title">' + options.sheetName + '</h3>');
        list.push('<h4 class="dataimport-status-type">' + this.validateText + ':</h4>');
        list.push('<p class="dataimport-status-count">' + Mustache.render(this.resultTpl, {0: options.checkCount, 1: options.checkSuccessCount, 2: options.checkErrorCount}));
        if ((arr = options.checkMsg) && (len = arr.length)) {
            list.push('<a href="javascript:void(0);" class="dataimport-status-toggle">' + this.expandText + '</a></p>');
            list.push('<div class="dataimport-status-detail">');
            for (i = 0; i < len; i++) {
                list.push('<p>' + arr[i] + '</p>');
            }
            list.push('</div>');
        } else {
            isCheckEnd = false;
        }

        if (options.saveCount) {
            if (!isCheckEnd) {
                list.push('</p>');
                isCheckEnd = true;
            }
            list.push('<h4 class="dataimport-status-type">' + this.importResultText + ':</h4>');
            list.push('<p class="dataimport-status-count">' + Mustache.render(this.resultTpl, {0: options.saveCount, 1: options.saveSuccessCount, 2: options.saveErrorCount}));

            if ((arr = options.saveMsg) && (len = arr.length)) {
                list.push('<a href="javascript:void(0);" class="dataimport-status-toggle">' + this.expandText + '</a></p>');
                list.push('<div class="dataimport-status-detail">');
                for (i = 0; i < len; i++) {
                    list.push('<p>' + arr[i] + '</p>');
                }
                list.push('</div>');
            } else {
                isSaveEnd = false;
            }
        }

        if ((arr = options.taskMsg) && (len = arr.length)) {
            list.push('<a href="javascript:void(0);" class="dataimport-status-toggle">' + this.expandText + '</a></p>');
            list.push('<div class="dataimport-status-detail">');
            for (i = 0; i < len; i++) {
                list.push('<p>' + arr[i] + '</p>');
            }
            list.push('</div>');
        } else if (!isCheckEnd || !isSaveEnd) {
            list.push('</p>');
        }

        list.push('</div>');

        return list.join('');
    },

    _getSize: function (size) {
        var K = 1024,
            M = 1048576;
        size = parseInt(size);

        if (size > M) {
            return (size / M).toFixed(2) + 'M';
        } 
            return (size / K).toFixed(2) + 'K';
        
    },

    _pollingFrequency: 1000,
    _oldAttachGuid: '',
    _onUploadSuccess: function (event) {
        var ret = event.ret,
            file = event.file;

        if (mini.getSecondRequestData) {
            ret = mini.getSecondRequestData(ret);
        }

        ret = ret.data || ret;
        ret = ret.extraDatas || ret;

        this._pollingFrequency = ret.pollingFrequency;
        if (ret.action == 'importStatus') {
            this._curAttachGuid = ret.attachGuid;
            this._oldAttachGuid = ret.attachGuidOld;
            this.pollingStatus(ret);
            return;
        }

        var self = this;
        mini.alert(this.importFailAlert, '', function () {
            self._onFinished(ret.status);

            self.maskEl.style.display = 'none';
        });


    },

    _onFinished: function (msg) {
        msg = msg || this.importSuccessText;
        this.isImportFinished = true;
        this.maskContent.innerHTML = msg + '<a href="javascript:void(0);" class="dataimport-showdetail">' + this.viewDetailText + '</a>';

        if (this._events.importfinished) {
            this.fire('importfinished');
        }

        this.uploader.clearFile();
    },

    _onBeforeFileQueued: function (event) {
        if (this._events.beforefilequeued) {
            this.fire('beforefilequeued', event);
        }
    },

    pollingStatus: function (options) {
        this.maskContent.innerHTML = this._generateImportStatus(options);
        var self = this,
            data = {
                fileMD5: this._curFileMD5,
                attachGuid: this._curAttachGuid,
                attachGuidOld: this._oldAttachGuid
            };
        data[this.uploader.id + '_action'] = 'importStatus';

        if (this.uploader.getCommonData) {
            data.commonDto = mini.encode(this.uploader.getCommonData());
        }
        
        Util.addReplayAttackData(data, this.url);

        jQuery.ajax({
            url: this.url,
            data: data,
            type: 'POST',
            dataType: 'json'
        }).done(function (data) {
            if (mini.getSecondRequestData) {
                data = mini.getSecondRequestData(data);
            }
            // 有提示信息，则alert
            if (data.msg) {
                mini.alert(data.msg);
            }

            if (data.end) {
                self._onFinished(data.status);
            } else {
                setTimeout(jQuery.proxy(self.pollingStatus, self, data), self._pollingFrequency);
            }

            self.setDetailStatus(data.detail);

        });
    },

    setDetailStatus: function (data) {
        this.detailStatus = data;

        if (this.isDetailShow) {
            this.renderDetailStatus();
        }
    },

    renderDetailStatus: function () {
        var detail = this.detailStatus,
            html = [],
            i = 0,
            l;

        if (detail) {
            for (l = detail.length; i < l; i++) {
                html.push(this._generateStatuslist(detail[i]));
            }

        }

        this.detailContent.innerHTML = html.join('');

    },

    showDetailStatus: function () {
        this.renderDetailStatus();

        this.detailEl.style.display = 'block';

        this.isDetailShow = true;
    },

    hideDetailStatus: function () {
        this.detailEl.style.display = 'none';

        this.isDetailShow = false;
    },

    setUrl: function (url) {
        url = url.indexOf('isCommondto') != -1 ?
                // 已经有isCommondto了 就不处理
                url :
                // 没有isCommondto 根据是否有？ 拼接上 '&' 或 '?' + 'isCommondto=true
                (url + (url.indexOf('?') != -1 ? '&' : '?') + 'isCommondto=true');
                
        this.url = url;

        this.uploader && this.uploader.setUploadUrl(url);
    },

    getUrl: function () {
        return this.url;
    },

    setPickerText: function (pickerText) {
        this.pickerText = pickerText;
        this.uploader.setPickerText(pickerText);
    },

    setEnabled: function(enabled) {
        mini.CatalogImport.superclass.setEnabled.call(this, enabled);
        this.uploader && this.uploader.setEnabled(enabled);
    },
    getAttrs: function (el) {
        var attrs = mini.DataImport.superclass.getAttrs.call(this, el);
        mini._ParseString(el, attrs, ['url', 'extraId', 'pickerText', 'onbeforefilequeued', 'onpostfilemd5', 'onimportfinished']);
        return attrs;
    }

});

mini.regClass(mini.DataImport, 'dataimport');
mini.DatePicker = function () {
    mini.DatePicker.superclass.constructor.apply(this, arguments);
    mini.addClass(this.el, 'mini-datepicker');

    this.on('validation', this.__OnValidation, this);
};

mini.extend(mini.DatePicker, mini.ButtonEdit, {
    valueFormat: '',
    format: 'yyyy-MM-dd', //displayFormat可以是任意的
    //editFormat: 'yyyy-MM-dd',   //固定几个editFormat，这样可以做成JS的优化处理

    maxDate: '9999-12-31',
    minDate: '1753-01-01',

    showTime: false,
    timeFormat: 'H:mm',
    showTimeDirect: false,

    showYesterdayButton: false,
    showTodayButton: true,
    showClearButton: true,
    showOkButton: false,
    firstDayOfWeek: 0,

    valueType: 'date', //date,string
    formField: true,

    allowInput: true,

    uiCls: 'mini-datepicker',

    _create: function () {
        mini.DatePicker.superclass._create.call(this);

        this.externalSrc = this.externalSrc || mini.externalSrc;
        var self = this;
        if (window.laydate) {
            this._init();
        } else {
            mini.loadJSWithAMD(this.externalSrc + 'laydate/laydate.js', 'laydate', function () {
                self._init();
            });
        }
    },

    _init: function () {
        var self = this;

        var cfg = {
            elem: this._textEl,
            format: this._translateToLaydateFormat(this.format),
            readOnly: this.readOnly,
            enabled: this.enabled,
            showTimeDirect: this.showTimeDirect,
            btns: this._getBtns(),
            trigger: 'click',
            lang: mini.locale === 'en-US' ? 'en' : 'cn',
            ready: function (date) {
                self._onLaydateReady(date);
                self.showPopup(true);
            },
            done: function (value, date, endDate) {
                // 由于 laydate 在触发完 done 事件之后还会再执行 setValue
                // 加 setTimeout 是为了解决 laydate 后面执行的 setValue 会把控件设置的值覆盖掉问题
                setTimeout(function () {
                    self._onLaydateDone(value, date, endDate);
                    self._tryValidate();
                }, 10);
            },
            onHide: function () {
                self.hidePopup();
                // laydate 在隐藏时会自动去更新绑定的文本框值，在值超出范围限制时，会导致value和text不一致问题。
                // 所以需要还原一下text的值
                self._textEl.value = self.text;
            },
            drawdate: function (date, dom) {
                var event = {
                    allowSelect: true,
                    date: mini.parseDate(date.year + '-' + date.month + '-' + date.date),
                    dom: dom
                };
                self.fire('drawdate', event);
                if (!event.allowSelect) {
                    mini.addClass(dom, 'laydate-disabled');
                }
            },
            drawmonth: function (date, dom) {
                var event = {
                    allowSelect: true,
                    date: mini.parseDate(date.year + '-' + (date.month + 1)),
                    dom: dom
                };
                self.fire('drawmonth', event);
                if (!event.allowSelect) {
                    mini.addClass(dom, 'laydate-disabled');
                }
            },
            drawyear: function (date, dom) {
                var event = {
                    allowSelect: true,
                    date: mini.parseDate(date.year),
                    dom: dom
                };
                self.fire('drawyear', event);
                if (!event.allowSelect) {
                    mini.addClass(dom, 'laydate-disabled');
                }
            },
            showtime: function (el) {
                // 配置的format不显示分/秒时 也隐藏掉分/秒选择
                var format = self.format,
                    hasSec = /s$/i.test(format),
                    hasMin = /m/.test(format),
                    $list = $(el).find('.laydate-time-list');
                $list.each(function () {
                    var $this = $(this),
                        $timeEles = $this.find('>li'),
                        length = '';
                    $timeEles.show();
                    !hasSec && $timeEles.eq(2).hide();
                    !hasMin && $timeEles.eq(1).hide();
                    length = $this.find('>li:visible').length;
                    $timeEles.css('width', 'calc(100% / ' + length + ')');
                });
            },
            onBtnClick: function (action) {
                setTimeout(function () {
                    var event = {
                        action: action,
                        value: self.value
                    };
                    self.fire('btnclick', event);
                }, 10);
            },
            onViewChanged: function (type, elemHeader, elemCont, index, listYM) {
                self._onLaydateViewChanged(type, elemHeader, elemCont, index, listYM);
            },
            onMonthYearItemClick: function (type, ym, index) {
                self._onLaydateMonthYearItemClick(type, ym, index);
            },
            onBeforeRender: function () {
                self._onLaydateBeforeRender();
            }
        };

        if (this.minDate) {
            cfg.min = mini.formatDate(mini.parseDate(this.minDate), 'yyyy-MM-dd HH:mm:ss');
        }

        if (this.maxDate) {
            cfg.max = mini.formatDate(mini.parseDate(this.maxDate), 'yyyy-MM-dd HH:mm:ss');
        }

        this._beforeLaydateInit(cfg);
        // eslint-disable-next-line no-undef
        this.laydate = laydate.render(cfg);

        this._fixedHoverScroller();
        // this._fixedTimeScrollPos();
    },

    _translateToLaydateFormat: function (format) {
        return format.replace(/(y)\1{1}/g, function (match, g1, index, origin) {
            if (origin.charAt(index - 1) === 'y' || origin.charAt(index + 2) === 'y') {
                return 'yy';
            }
            return 'y';
        });
    },
    _onLaydateReady: function (date) {
        if (!this.value && this.viewDate) {
            var year = this.viewDate.getFullYear(),
                month = this.viewDate.getMonth(),
                date = this.viewDate.getDate(),
                hours = this.viewDate.getHours(),
                minutes = this.viewDate.getMinutes(),
                seconds = this.viewDate.getSeconds();
            if (year) {
                this.laydate.config.dateTime = {
                    year: year,
                    month: month,
                    date: date,
                    hours: hours,
                    minutes: minutes,
                    seconds: seconds
                };
                this.laydate._laydate.calendar();
            }
        }
        this._setSelectedItem(date);
        this._updateOkBtn();
    },
    _updateOkBtn: function () {
        if (!this.laydate) {
            return;
        }
        var $okBtn = $(this.laydate._laydate.footer).find('.laydate-btns-confirm');
        if (this._selectedItem.length === 1) {
            $okBtn.removeClass('laydate-disabled');
        } else {
            $okBtn.addClass('laydate-disabled');
        }
    },
    _onLaydateDone: function (value, date, endDate) {
        // laydate 传递过来的 value 是格式化后的字符串，包含中文时无法正确转化成时间
        if(this.type === 'monthpicker'){
            value = new Date(date.year, date.month - 1);
        }else{
            value = new Date(date.year, date.month - 1, date.date, date.hours, date.minutes, date.seconds);
        }
        
        if (this._oldValue !== value) {
            this.fire('valuechanged', {
                value: value,
                oldValue: this._oldValue
            });
        }

        this.setValue(value);
    },
    _selectedItem: [],
    _setSelectedItem: function (val) {
        if (!val) {
            this._selectedItem = [];
        } else {
            this._selectedItem = [val];
        }
    },
    _beforeLaydateInit: function (cfg) {
        if (this.showTime) {
            cfg.type = 'datetime';

            this.showOkButton = true;
            cfg.btns = this._getBtns();
        }
    },
    _onLaydateBeforeRender: function () {
        this._setSelectedItem(this.value);
    },
    _onLaydateViewChanged: function (type, elemHeader, elemCont, index, listYM) {},
    _onLaydateMonthYearItemClick: function (type, ym, index) {},
    // 本来 是 overflow hidden 在 hover 时 overflow auto
    // 会存在 hover 抖动的问题 此处计算滚动条宽度 来修正此问题
    _fixedHoverScroller: function () {
        var scrollerWidth = mini._scrollBarWidth;

        var id = 'fixed-hover-scroller-for-daterange';
        if (!scrollerWidth || $('#' + id).length) {
            return;
        }
        var text = [
            '.laydate-time-list li ol {margin-right: ' + scrollerWidth + 'px}',
            '.laydate-time-list>li:hover ol{',
            'margin-right:0;}',
            '.laydate-time-list li > p {padding-right: ' + scrollerWidth + 'px}'
        ].join('');
        $('<style id="' + id + '">' + text + '</style>').appendTo('head');
    },
    // laydate 中 时间的滚动是写高度的 会存在滚动位置不正确的问题
    _fixedTimeScrollPos: (function () {
        function scrollIntoView($target) {
            var currentTop = $target.position().top;
            var currentHeight = $target.outerHeight(true);
            var $parent = $target.parent();
            var viewHeight = $parent[0].offsetHeight;

            if (currentTop > 0 && currentTop < viewHeight - currentHeight) {
                // console.log('可见');
            } else {
                // console.log('不可见');
                $parent[0].scrollTop = $parent[0].scrollTop + currentTop;
            }
        }
        // 源码中已经滚动了一次了， 用 requestAnimationFrame 使得两个事件的间隔更可能的小 避免肉眼可见的跳动
        var nextTick =
            window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.oRequestAnimationFrame ||
            window.setTimeout;

        function handle(ev) {
            var $target = $(ev.target || ev.srcElement);
            if ($target.closest('.laydate-time-list > li li').length) {
                // console.log(ev);

                nextTick(function () {
                    scrollIntoView($target);
                });
            }
        }
        // 确保只绑定一次
        return document.addEventListener
            ? function () {
                  document.removeEventListener('click', handle, true);
                  document.addEventListener('click', handle, true);
              }
            : function () {};
    })(),

    showPopup: function (isTrigger) {
        if (!isTrigger) {
            jQuery(this._textEl).trigger('click');
            return;
        }

        var btnEl = jQuery(this.el).find('.mini-buttonedit-button')[0];
        if (btnEl) {
            mini.addClass(btnEl, this._buttonPressedCls);
        }
        // 滚动时隐藏
        var namespace = '.daterange-' + this.id;
        $('html, body, .fui-content').on('scroll' + namespace, function () {
            $('body').trigger('click');
            $('html, body, .fui-content').off('scroll' + namespace);
        });
        this.fire('showPopup');
    },
    hidePopup: function () {
        var btnEl = jQuery(this.el).find('.mini-buttonedit-button')[0];
        if (btnEl) {
            mini.removeClass(btnEl, this._buttonPressedCls);
        }
        this.fire('hidePopup');
    },

    _monthPicker: false,

    within: function (e) {
        if (mini.isAncestor(this.el, e.target)) return true;
        if (mini.isAncestor(this.laydate._laydate.elem, e.target)) return true;
        return false;
    },
    minDateErrorText: '', //'不能小于日期 {0}',
    maxDateErrorText: '', //'不能大于日期 {0}',
    __OnValidation: function (e) {
        if (e.isValid === false) return;
        var date = this.value;

        if (!mini.isDate(date)) return;
        var maxDate = mini.parseDate(this.maxDate);
        var minDate = mini.parseDate(this.minDate);
        var maxDateErrorText = this.maxDateErrorText || mini.VTypes.maxDateErrorText;
        var minDateErrorText = this.minDateErrorText || mini.VTypes.minDateErrorText;
        if (mini.isDate(maxDate)) {
            if (date.getTime() > maxDate.getTime()) {
                e.isValid = false;
                e.errorText = String.format(maxDateErrorText, mini.formatDate(maxDate, this.format));
            }
        }
        if (mini.isDate(minDate)) {
            if (date.getTime() < minDate.getTime()) {
                e.isValid = false;
                e.errorText = String.format(minDateErrorText, mini.formatDate(minDate, this.format));
            }
        }
    },
    setFormat: function (value) {
        if (typeof value !== 'string') return;
        if (this.format !== value) {
            this.format = value;
            this._textEl.value = this.getFormValue();

            this._updateLaydateFormat();
        }
    },
    _updateLaydateFormat: function () {
        var dateType = 'yyyy|y|MM|M|dd|d|HH|H|mm|m|ss|s',
            _laydate;
        if (this.laydate) {
            this.laydate.config.format = this._translateToLaydateFormat(this.format);
            _laydate = this.laydate._laydate;
            _laydate.format = this.laydate.config.format.match(new RegExp(dateType + '|.', 'g')) || [];

            //生成正则表达式
            _laydate.EXP_IF = '';
            _laydate.EXP_SPLIT = '';
            mini.forEach(_laydate.format, function (item, i) {
                var EXP = new RegExp(dateType).test(item)
                    ? '\\d{' +
                      (function () {
                          if (new RegExp(dateType).test(_laydate.format[i === 0 ? i + 1 : i - 1] || '')) {
                              if (/^yyyy|y$/.test(item)) return 4;
                              return item.length;
                          }
                          if (/^yyyy$/.test(item)) return '1,4';
                          if (/^y$/.test(item)) return '1,308';
                          return '1,2';
                      })() +
                      '}'
                    : '\\' + item;
                _laydate.EXP_IF = _laydate.EXP_IF + EXP;
                _laydate.EXP_SPLIT = _laydate.EXP_SPLIT + '(' + EXP + ')';
            });
            _laydate.EXP_IF = new RegExp(
                '^' +
                    (this.delimiter
                        ? _laydate.EXP_IF + '\\s\\' + this.delimiter + '\\s' + _laydate.EXP_IF
                        : _laydate.EXP_IF) +
                    '$'
            );
            _laydate.EXP_SPLIT = new RegExp('^' + _laydate.EXP_SPLIT + '$', '');
        }
    },
    getFormat: function () {
        return this.format;
    },
    setValueFormat: function (value) {
        if (typeof value !== 'string') return;
        if (this.valueFormat !== value) {
            this.valueFormat = value;
        }
    },
    getValueFormat: function () {
        return this.valueFormat;
    },
    _oldValue: '',
    _updateOldValue: function () {
        this._oldValue = this.value;
    },
    setValue: function (value) {
        var me = this;
        if (this.getFormValue() !== value) {
            if (me.valueType === 'date') {
                value = mini.parseDate(value);
            } else {
                if (mini.isDate(value)) value = mini.formatDate(value, me.format);
            }

            if (mini.isNull(value)) value = '';
            if (mini.isDate(value)) {
                value = new Date(value.getTime());
                if (mini.isDate(value) && isNaN(value.getTime())) {
                    value = '';
                }
            }

            this.value = value;
            //this._doEmpty();
        }
        this.text = this.getFormValue();

        this._textEl.value = this.text;
        this._updateOldValue();
    },
    nullValue: '',
    setNullValue: function (value) {
        if (value === 'null') value = null;
        this.nullValue = value;
    },
    getNullValue: function () {
        return this.nullValue;
    },

    getValue: function () {
        if (this.valueType !== 'date') return this.value;
        if (!mini.isDate(this.value)) return this.nullValue;
        var v = this.value;
        if (this.valueFormat) {
            v = mini.formatDate(v, this.valueFormat);
        }
        return v;
    },

    getFormValue: function (format) {
        if (this.valueType !== 'date') return this.value;
        if (!mini.isDate(this.value)) return '';
        format = format || this.format;
        return mini.formatDate(this.value, format);
    },

    setViewDate: function (value) {
        this.viewDate = new Date(value);
    },
    getViewDate: function () {
        return this.viewDate;
    },
    setShowTime: function (value) {
        if (this.showTime !== value) {
            this.showTime = value;

            this._updateLaydateShowTime();
        }
    },
    _updateLaydateShowTime: function () {
        if (!this.laydate) {
            return;
        }

        if (this.showTime) {
            this.laydate.config.type = 'datetime';

            this.showOkButton = true;
            this.laydate.config.btns = this._getBtns();
        } else {
            this.laydate.config.type = 'date';
        }
    },
    getShowTime: function () {
        return this.showTime;
    },
    setShowTimeDirect: function(direct){
        this.showTimeDirect = direct;
        if(this.laydate) {
            this.laydate.config.showTimeDirect = direct;
        }
    },
    getShowTimeDirect: function(){
        return this.showTimeDirect;
    },
    setTimeFormat: function (value) {
        if (this.timeFormat !== value) {
            this.timeFormat = value;
        }
    },
    getTimeFormat: function () {
        return this.timeFormat;
    },

    setShowYesterdayButton: function (value) {
        this.showYesterdayButton = value;
        //this.doUpdate();
    },
    getShowYesterdayButton: function () {
        return this.showYesterdayButton;
    },
    setShowTodayButton: function (value) {
        this.showTodayButton = value;
        this._updateLaydateBtns();
    },
    getShowTodayButton: function () {
        return this.showTodayButton;
    },
    setShowClearButton: function (value) {
        this.showClearButton = value;
        this._updateLaydateBtns();
    },
    getShowClearButton: function () {
        return this.showClearButton;
    },
    setShowOkButton: function (value) {
        this.showOkButton = value;
        this._updateLaydateBtns();
    },
    getShowOkButton: function () {
        return this.showOkButton;
    },
    _getBtns: function () {
        var btns = [];
        if (this.showClearButton) {
            btns.push('clear');
        }
        if (this.showTodayButton) {
            btns.push('now');
        }
        if (this.showOkButton) {
            btns.push('confirm');
        }

        return btns;
    },
    _updateLaydateBtns: function () {
        if (this.laydate) {
            this.laydate.config.btns = this._getBtns();
        }
    },
    setShowWeekNumber: function (value) {
        this.showWeekNumber = value;
    },
    getShowWeekNumber: function () {
        return this.showWeekNumber;
    },
    setMaxDate: function (value) {
        this.maxDate = value;
        if (this.laydate) {
            var date = mini.parseDate(this.maxDate);
            this.laydate.config.max = {
                year: date.getFullYear(),
                month: date.getMonth(),
                date: date.getDate(),
                hours: date.getHours(),
                minutes: date.getMinutes(),
                seconds: date.getSeconds()
            };
        }
    },
    getMaxDate: function () {
        return this.maxDate;
    },
    setMinDate: function (value) {
        this.minDate = value;
        if (this.laydate) {
            var date = mini.parseDate(this.minDate);
            this.laydate.config.min = {
                year: date.getFullYear(),
                month: date.getMonth(),
                date: date.getDate(),
                hours: date.getHours(),
                minutes: date.getMinutes(),
                seconds: date.getSeconds()
            };
        }
    },
    getMinDate: function () {
        return this.minDate;
    },

    setMaxDateErrorText: function (value) {
        this.maxDateErrorText = value;
    },
    getMaxDateErrorText: function () {
        return this.maxDateErrorText;
    },
    setMinDateErrorText: function (value) {
        this.minDateErrorText = value;
    },
    getMinDateErrorText: function () {
        return this.minDateErrorText;
    },
    setEnabled: function (enable) {
        mini.DatePicker.superclass.setEnabled.call(this, enable);
        this.laydate && (this.laydate.config.enabled = enable);
    },
    _OnButtonClick: function (htmlEvent) {
        // 阻止事件冒泡，解决由于laydate绑定在body上的click事件，日期选择面板消失问题
        htmlEvent.stopPropagation();

        var e = {
            htmlEvent: htmlEvent,
            cancel: false
        };
        this.fire('beforebuttonclick', e);
        if (e.cancel == true) return;

        this.fire('buttonclick', e);

        jQuery(this._textEl).trigger('click');
    },
    //////////////////////////////////
    __OnInputTextChanged: function (e) {
        var v = this._textEl.value;

        if (this.valueType == 'date') {
            var d = mini.parseDate(v);

            //if (!d || isNaN(d) || d.getFullYear() == 1970) {
            if (!d || isNaN(d)) {
                d = null;
            }
        }

        this.setValue(v);
    },
    __OnInputKeyDown: function (e) {
        var ex = {
            htmlEvent: e
        };
        this.fire('keydown', ex);
        if (e.keyCode === 8 && (this.isReadOnly() || this.allowInput === false)) {
            return false;
        }

        if (e.keyCode === 9) {
            //tab
            if (this.isShowPopup()) {
                this.hidePopup();
            }
            return;
        }

        if (this.isReadOnly()) return;

        switch (e.keyCode) {
            case 27: //esc
                e.preventDefault();
                if (this.isShowPopup()) {
                    e.stopPropagation();
                }

                this.hidePopup();
                break;
            case 9: //tab
            case 13: //enter
                this.__OnInputTextChanged(null);
                var me = this;
                setTimeout(function () {
                    me.fire('enter', ex);
                }, 10);
                break;
            case 37: //left
                break;
            case 38: //top
                e.preventDefault();
                break;
            case 39: //right
                break;
            case 40: //bottom
                if (this.keyNavEnabled) {
                    e.preventDefault();
                    this.showPopup();
                }
                break;
            default:
                break;
        }
    },
    setReadOnly: function (readOnly) {
        mini.DatePicker.superclass.setReadOnly.call(this, readOnly);

        this.laydate && (this.laydate.config.readOnly = readOnly);
    },
    getAttrs: function (el) {
        var attrs = mini.DatePicker.superclass.getAttrs.call(this, el);

        mini._ParseString(el, attrs, [
            'format',
            'viewDate',
            'timeFormat',
            'ondrawdate',
            'ondrawmonth',
            'ondrawyear',
            'onbtnclick',
            'minDate',
            'maxDate',
            'valueType',
            'valueFormat',
            'nullValue',
            'minDateErrorText',
            'maxDateErrorText'
        ]);
        mini._ParseBool(el, attrs, [
            'showTime',
            'showTimeDirect',
            'showTodayButton',
            'showClearButton',
            'showOkButton',
            'showWeekNumber',
            'showYesterdayButton',
            'allowInput'
        ]);

        return attrs;
    }
});

mini.regClass(mini.DatePicker, 'datepicker');

mini.MonthPicker = function () {
    mini.MonthPicker.superclass.constructor.apply(this, arguments);
};

mini.extend(mini.MonthPicker, mini.DatePicker, {
    uiCls: 'mini-monthpicker',
    valueFormat: '',
    format: 'yyyy-MM',
    _monthPicker: true,
    showOkButton: true,
    formValueWithDay: (window.EpFrameSysParams && EpFrameSysParams.monthpicker_value_with_day) || false,
    _beforeLaydateInit: function (cfg) {
        cfg.type = 'month';
    },
    setMaxDate: function (value) {
        var date = mini.parseDate(value);

        date.setDate(1);
        date.setMonth(date.getMonth() + 1);
        date = mini.addDate(date, -1);

        this.maxDate = mini.formatDate(date, 'yyyy-MM-dd');
        if (this.laydate) {
            this.laydate.config.max = {
                year: date.getFullYear(),
                month: date.getMonth(),
                date: date.getDate(),
                hours: 23,
                minutes: 59,
                seconds: 59
            };
        }
    },
    setMinDate: function (value) {
        var date = mini.parseDate(value);
        date.setDate(1);

        this.minDate = mini.formatDate(date, 'yyyy-MM-dd');

        if (this.laydate) {
            this.laydate.config.min = {
                year: date.getFullYear(),
                month: date.getMonth(),
                date: date.getDate(),
                hours: 0,
                minutes: 0,
                seconds: 0
            };
        }
    },
    getAttrs: function (el) {
        var attrs = mini.MonthPicker.superclass.getAttrs.call(this, el);
        mini._ParseBool(el, attrs, ['formValueWithDay']);

        return attrs;
    }
});
mini.regClass(mini.MonthPicker, 'monthpicker');

mini.DateRangePicker = function () {
    mini.DateRangePicker.superclass.constructor.call(this);
};

mini.extend(mini.DateRangePicker, mini.DatePicker, {
    uiCls: 'mini-daterangepicker',

    rangeType: 'date',
    delimiter: '~',
    showOkButton: true,
    showQuickSelect: false,
    footTipText: epoint_local.DateRangePicker.footTipText,
    quickSelectText: jQuery.extend({}, epoint_local.DateRangePicker.quickSelectText),
    customQuickSelect: [],

    set: function (kv) {
        if (typeof kv === 'string') {
            return this;
        }

        var rangeType = kv.rangeType;
        delete kv.rangeType;
        var format = kv.format;
        delete kv.format;

        if (!mini.isNull(rangeType)) {
            this.setRangeType(rangeType);
        }
        if (!mini.isNull(format)) {
            this.setFormat(format);
        }
        
        mini.DateRangePicker.superclass.set.call(this, kv);

        return this;
    },
    _onLaydateReady: function (date) {
        var $btns = $('.laydate-footer-btns', this.laydate._laydate.footer);
        if ($btns.length) {
            $('<span class="laydate-footer-tips">' + this.footTipText + '</span>').insertBefore($btns);
        }
        if (this.showQuickSelect) {
            this._renderQuickSelect();
        }
        this._onLaydateRender(date);
        this.laydate._laydate.preview(this.value.startDate);
    },
    _onLaydateRender: function (date) {},
    _onLaydateDone: function (value, date, endDate) {
        this.setValue({
            startDate: this._formatDate(date),
            endDate: this._formatDate(endDate)
        });
        if (this.value.startDate != this._oldValue.startDate || this.value.endDate != this._oldValue.endDate) {
            this.fire('valuechanged', {
                value: this.value,
                oldValue: this._oldValue
            });

            this._updateOldValue();
        }
    },
    _beforeLaydateInit: function (cfg) {
        if (this.showTime) {
            cfg.type = 'datetime';
        }
        cfg.range = this.delimiter;
    },
    _formatDate: function (date) {
        function isEmptyObject(obj) {
            for (var key in obj) {
                return false;
            }
            return true;
        }

        if (!date || isEmptyObject(date)) {
            return '';
        }
        if (this.rangeType === 'month') {
            var monthStartDate = new Date(date.year, date.month - 1, 1),
                monthEndDate = new Date(date.year, date.month, 1);
            date.date = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
        }
        var result = this.format.replace(/yyyy/g, date.year);
        result = result.replace(/yy/g, (date.year + '').substring(2));
        result = result.replace(/MM/g, date.month < 10 ? '0' + date.month : date.month);
        result = result.replace(/M/g, date.month);
        result = result.replace(/dd/g, date.date < 10 ? '0' + date.date : date.date);
        result = result.replace(/d/g, date.date);
        result = result.replace(/HH/g, date.hours < 10 ? '0' + date.hours : date.hours);
        result = result.replace(/H/g, date.hours);
        result = result.replace(/mm/g, date.minutes < 10 ? '0' + date.minutes : date.minutes);
        result = result.replace(/m/g, date.minutes);
        result = result.replace(/ss/g, date.seconds < 10 ? '0' + date.seconds : date.seconds);
        result = result.replace(/s/g, date.seconds);

        return result;
    },

    _mergeQuickSelect: function () {
        if (!this.quickSelect) {
            this._initQuickSelect();
        }
        var res = this.quickSelect.slice(0),
            keys = [],
            i,
            l,
            item,
            index;

        for (i = 0, l = res.length; i < l; i++) {
            keys.push(res[i].text);
        }

        for (i = 0, l = this.customQuickSelect.length; i < l; i++) {
            item = this.customQuickSelect[i];
            index = keys.indexOf(item.text);

            if (index > -1) {
                res[index] = item;
            } else {
                res.push(item);
            }
        }

        return res;
    },
    _initQuickSelect: function () {
        this.quickSelect = [
            {
                text: this.quickSelectText.thisWeek,
                start: function () {
                    var now = new Date(),
                        start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - now.getDay() + 1);
                    return start;
                },
                end: function () {
                    var now = new Date(),
                        end = new Date(now.getFullYear(), now.getMonth(), now.getDate() - now.getDay() + 7);
                    return end;
                }
            },
            {
                text: this.quickSelectText.thisMonth,
                start: function () {
                    var now = new Date(),
                        start = new Date(now.getFullYear(), now.getMonth(), 1);
                    return start;
                },
                end: function () {
                    var now = new Date(),
                        end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
                    return end;
                }
            },
            {
                text: this.quickSelectText.thisQuarter,
                start: function () {
                    var now = new Date(),
                        nowMonth = now.getMonth(),
                        quarterStartMonth = 0;
                    if (nowMonth > 2) {
                        if (nowMonth > 5) {
                            if (nowMonth > 8) {
                                quarterStartMonth = 9;
                            } else {
                                quarterStartMonth = 6;
                            }
                        } else {
                            quarterStartMonth = 3;
                        }
                    }

                    return new Date(now.getFullYear(), quarterStartMonth, 1);
                },
                end: function () {
                    var now = new Date(),
                        nowMonth = now.getMonth(),
                        quarterEndMonth = 2;
                    if (nowMonth > 2) {
                        if (nowMonth > 5) {
                            if (nowMonth > 8) {
                                quarterEndMonth = 11;
                            } else {
                                quarterEndMonth = 8;
                            }
                        } else {
                            quarterEndMonth = 5;
                        }
                    }

                    return new Date(now.getFullYear(), quarterEndMonth + 1, 0);
                }
            },
            {
                text: this.quickSelectText.thisYear,
                start: function () {
                    var now = new Date();
                    return new Date(now.getFullYear(), 0, 1);
                },
                end: function () {
                    var now = new Date();
                    return new Date(now.getFullYear(), 11, 31);
                }
            }
        ];
    },

    _renderQuickSelect: function () {
        var el = this.laydate._laydate.elem,
            i = 0,
            l,
            html = ['<div class="daterange-quick-select">'],
            item,
            quickArr = this._mergeQuickSelect(),
            self = this;

        html.push('<ul class="quick-select-list">');
        for (l = quickArr.length; i < l; i++) {
            item = quickArr[i];
            typeof item.start === 'string' && (item.start = mini._getFunctoin(item.start));
            typeof item.end === 'string' && (item.end = mini._getFunctoin(item.end));
            html.push(
                '<li class="quick-select-item" data-start="' +
                    mini.formatDate(item.start(), this.format) +
                    '" data-end="' +
                    mini.formatDate(item.end(), this.format) +
                    '">' +
                    item.text +
                    '</li>'
            );
        }

        html.push('</ul>');
        html.push('</div>');

        // 判断popup下拉框右侧是否超出边界
        var popupWidth = el.offsetWidth,
            popupLeft = el.getBoundingClientRect().x,
            documentWidth = document.documentElement.clientWidth,
            marginLeft = 104;

        if (popupWidth + popupLeft + marginLeft > documentWidth) {
            el.style.left = popupLeft - marginLeft + 'px';
        }

        mini.addClass(el, 'show-quick-select');
        mini.append(el, html.join(''));
        $(el).on('click', '.quick-select-item', function () {
            var $this = $(this),
                start = $this.data('start'),
                end = $this.data('end');

            self.setValue({
                startDate: start,
                endDate: end
            });
            if (self.value.startDate !== self._oldValue.startDate || self.value.endDate !== self._oldValue.endDate) {
                self.fire('valuechanged', {
                    value: self.value,
                    oldValue: self._oldValue
                });

                self._updateOldValue();
            }
            self._tryValidate();
            $('body').trigger('click');
            // var $this = $(this),
            //     start = new Date($this.data('start')),
            //     end = new Date($this.data('end'));

            // self.laydate._laydate.startDate = $.extend(self.laydate._laydate.startDate || {}, {
            //     year: start.getFullYear(),
            //     month: start.getMonth(),
            //     date: start.getDate()
            // });
            // self.laydate._laydate.endDate = $.extend(self.laydate._laydate.endDate || {}, {
            //     year: end.getFullYear(),
            //     month: end.getMonth(),
            //     date: end.getDate()
            // });

            // self.laydate._laydate.calendar();
        });
    },

    setMinDate: function (value) {
        this.minDate = mini.parseDate(value);

        if (this.laydate) {
            this.laydate.config.min = {
                year: this.minDate.getFullYear(),
                month: this.minDate.getMonth(),
                date: this.minDate.getDate(),
                hours: this.minDate.getHours(),
                minutes: this.minDate.getMinutes(),
                seconds: this.minDate.getSeconds()
            };
        }
    },
    setMaxDate: function (value) {
        this.maxDate = mini.parseDate(value);

        if (this.laydate) {
            this.laydate.config.max = {
                year: this.maxDate.getFullYear(),
                month: this.maxDate.getMonth(),
                date: this.maxDate.getDate(),
                hours: this.maxDate.getHours(),
                minutes: this.maxDate.getMinutes(),
                seconds: this.maxDate.getSeconds()
            };
        }
    },

    setRangeType: function (value) {
        this.rangeType = value;
        this.el.setAttribute('range-type', value);

        this.laydate && (this.laydate.config.type = value);

        if (value == 'datetime') {
            this.format = 'yyyy-MM-dd HH:mm';
            this.laydate && this.laydate.updateFormat('yyyy-MM-dd HH:mm');
            this.showTime = true;
        } else {
            this.showTime = false;
        }
    },
    setShowTime: function (value) {
        if (this.showTime !== value) {
            this.showTime = value;

            if (this.showTime) {
                this.rangeType = 'datetime';
            } else {
                this.rangeType = 'date';
            }
        }
    },
    _oldValue: {
        startDate: '',
        endDate: ''
    },
    value: {
        startDate: '',
        endDate: ''
    },
    setValue: function (value) {
        if (mini.isNull(value)) {
            value = {
                startDate: '',
                endDate: ''
            };
        }

        if (typeof value === 'string') {
            value = mini.JSON.decode(value);
        }
        if (!value.startDate || !value.endDate) {
            this.value = {
                startDate: '',
                endDate: ''
            };
            this.text = '';
        } else {
            this.value = {
                startDate: mini.formatDate(mini.parseDate(value.startDate), this.format),
                endDate: mini.formatDate(mini.parseDate(value.endDate), this.format)
            };
            this.text = this.value.startDate + ' ' + this.delimiter + ' ' + this.value.endDate;
        }

        this._textEl.value = this.text;
    },
    getValue: function () {
        return this.value;
    },
    getFormValue: function () {
        return mini.encode(this.value);
    },
    getText: function () {
        return this._textEl.value;
    },
    validate: function () {
        var e = {
            value: this.getValue(),
            errorText: '',
            isValid: true
        };

        if (this.required) {
            // value 是特殊的格式，需要特殊处理
            if (String(e.value.startDate).trim() === '' || String(e.value.endDate).trim() === '') {
                e.isValid = false;
                e.errorText = this.requiredErrorText;
            }
        }

        this.fire('validation', e);

        this.errorText = e.errorText;
        this.setIsValid(e.isValid);
        return this.isValid();
    },
    setQuickSelect: function (cfg) {
        if (typeof cfg === 'string') {
            cfg = mini.decode(cfg);
        }
        if (!mini.isArray(cfg)) {
            cfg = [cfg];
        }

        this.quickSelect = cfg;
    },
    setCustomQuickSelect: function (cfg) {
        if (typeof cfg === 'string') {
            cfg = mini.decode(cfg);
        }
        if (!mini.isArray(cfg)) {
            cfg = [cfg];
        }

        this.customQuickSelect = cfg;
    },
    getAttrs: function (el) {
        var attrs = mini.DateRangePicker.superclass.getAttrs.call(this, el);

        mini._ParseString(el, attrs, [
            'rangeType',
            'format',
            'minDate',
            'maxDate',
            'onvaluechanged',
            'emptyText',
            'onShowPopup',
            'onHidePopup',
            'quickSelect',
            'customQuickSelect'
        ]);
        mini._ParseBool(el, attrs, ['showQuickSelect']);
        return attrs;
    }
});

mini.regClass(mini.DateRangePicker, 'daterangepicker');

/* 
值为空时允许输入，进行搜索，
    出现搜索面板，点击搜索项目进入点击选择面板或者直接结束（点击县区时）此时不在允许输入，出现清空按钮

*/

mini.DistrictPicker = function () {
    mini.DistrictPicker.superclass.constructor.call(this);
};

mini.DistrictPicker.KEY_INDEX = {
    prefix: 0,
    areaCode: 1,
    pprefix: 2,
    text: 3,
    initial: 4, // 首字母 （如：北京为 b）
    pinyin_s: 5, // 拼音首字母 （如：北京为 bj）
    pinyin: 6, // 拼音
    clan: 7, // 附加说明（如：广西壮族自治区 - 壮族）
    level: 8 // 行政级别（如：广西壮族自治区 - 自治区）
};

mini.DistrictPicker.parseData = function parseData(str) {
    var arr = str.split(/\r\n|\n/);
    var result = [];
    var KEY_INDEX = mini.DistrictPicker.KEY_INDEX;
    arr.forEach(function (it) {
        if (!it) return;
        var item = it.split(',');
        result.push({
            id: item[KEY_INDEX.prefix],
            pid: item[KEY_INDEX.pprefix],
            prefix: item[KEY_INDEX.prefix],
            areaCode: item[KEY_INDEX.areaCode],
            pprefix: item[KEY_INDEX.pprefix],
            text: item[KEY_INDEX.text],
            initial: item[KEY_INDEX.initial], // 首字母 （如：北京为 b）
            pinyin_s: item[KEY_INDEX.pinyin_s], // 拼音首字母 （如：北京为 bj）
            pinyin: item[KEY_INDEX.pinyin], // 拼音
            clan: item[KEY_INDEX.clan], // 附加说明（如：广西壮族自治区 - 壮族）
            level: item[KEY_INDEX.level] // 行政级别（如：广西壮族自治区 - 自治区）
        });
    });

    return result;
};

mini.DistrictPicker.arrayToTree = function arrayToTree(arr) {
    var idMap = {};
    arr.forEach(function (item) {
        if (!idMap[item.id]) {
            idMap[item.id] = item;
        }
    });

    var result = [];

    arr.forEach(function (item) {
        var treeNode = item;
        var pid = item.pid;
        if (pid === undefined) {
            result.push(treeNode);
            return;
        }
        var parentNode = idMap[pid];
        if (!parentNode) {
            result.push(treeNode);
            return;
        }
        if (!parentNode.items) parentNode.items = [];
        parentNode.items.push(treeNode);
    });

    return result;
};
mini.DistrictPicker.makeMap = function (arr) {
    var map = {};
    var abnormal = false,
        abnormalMap = {};
    arr.forEach(function (item) {
        if (map[item.id]) {
            abnormal = true;
            abnormalMap[item.id] ? abnormalMap[item.id].push(item) : abnormalMap[item.id] = [map[item.id], item];
        } else {
            map[item.id] = item;
        }
    });

    if (abnormal) {
        console.error('行政代码重复：', abnormalMap);
    }
    return map;
};

mini.extend(mini.DistrictPicker, mini.PopupEdit, {
    uiCls: 'mini-districtpicker',

    data: [],
    listData: [],
    sourceUrl: '',

    province: null,
    city: null,
    district: null,
    selectedLevel: 'district', // 选择到的层次，可选值为 'province', 'city' 和 'district'
    // textMap: {
    //     province: '省份',
    //     city: '城市',
    //     district: '区县'
    // },
    split: '/',
    value: '',
    text: '',
    emptyText: epoint_local.DistrictPicker.emptyText,
    selectText: epoint_local.DistrictPicker.selectText,


    __selectEnd: false,
    __oldValue: '',
    __popupMode: 'select', // 下拉的模式 选择 或 搜索 select search

    popupHeight: 360,
    popupWidth: 420,

    inputAsValue: false,

    _create: function () {
        mini.DistrictPicker.superclass._create.apply(this, arguments);

        // this.on('buttonclick', this._showPopup, this);
        this.on('beforeshowpopup', this.__beforeShowPopup, this);
        this._initInputEvent();
        this._syncInputState();
    },
    _afterApply: function() {
        this.sourceLoaded = false;
        this._requestSource();
    },

    _createPopup: function () {
        mini.DistrictPicker.superclass._createPopup.apply(this, arguments);

        this._panelContentEl = this.popup._contentEl;
        this._panelContentEl.innerHTML =
            '<div class="mini-districtpicker-tabs"><div class="mini-districtpicker-tabs-header clearfix"><span class="mini-districtpicker-tab" data-target="province">' + this.selectText + '</span><span class="mini-districtpicker-tab" data-target="city">' + this.selectText + '</span><span class="mini-districtpicker-tab" data-target="district">' + this.selectText + '</span></div></div><div class="mini-districtpicker-search" style="display:none"><div class="mini-districtpicker-search-list"></div></div>';

        this._tabsEl = this._panelContentEl.firstChild;
        this._tabHeaderEl = this._tabsEl.firstChild;

        var tabBody = document.createElement('div');
        tabBody.className = this.uiCls + '-tabs-body';

        // 省
        var provinceEl = document.createElement('div');
        provinceEl.className = this.uiCls + '-tab-panel';
        provinceEl.setAttribute('data-id', 'province');
        provinceEl.style.display = 'none';
        this._provinceEl = provinceEl;
        tabBody.appendChild(provinceEl);

        // 市
        var cityEl = document.createElement('div');
        cityEl.className = this.uiCls + '-tab-panel';
        cityEl.setAttribute('data-id', 'city');
        cityEl.style.display = 'none';
        this._cityEl = cityEl;
        tabBody.appendChild(cityEl);

        // 区
        var districtEl = document.createElement('div');
        districtEl.className = this.uiCls + '-tab-panel';
        districtEl.setAttribute('data-id', 'district');
        districtEl.style.display = 'none';
        this._districtEl = districtEl;
        tabBody.appendChild(districtEl);

        this._panelContentEl.firstChild.appendChild(tabBody);
        // this._
        this._tabBodyEl = tabBody;

        this._searchWrap = this._panelContentEl.lastChild;
        this._searchList = this._searchWrap.firstChild;

        this._initPopupEvent();
    },
    _initPopupEvent: function () {
        var me = this;
        this.popup.on('close', this.__beforeClosePopup, this);

        jQuery(this.popup.el)
            .on('click', '.mini-districtpicker-tab', function () {
                var target = this.getAttribute('data-target');
                me._activePanel(target);
            })
            // 省份点击
            .on('click', '.mini-districtpicker-province-item', function () {
                jQuery(this).addClass('active').siblings().removeClass('active');
                var id = this.getAttribute('data-id');
                var p = me.dataMap[id];
                if (p) {
                    me.setText(p.text + p.level);
                    me.setProvince(p);
                } else {
                    console.error('something  wrong!');
                }
            })
            // 城市点击
            .on('click', '.mini-districtpicker-city-item', function () {
                jQuery(this).addClass('active').siblings().removeClass('active');
                var id = this.getAttribute('data-id');
                var city = me.dataMap[id];
                if (city) {
                    me.setText(me.province.text + me.province.level + me.split + city.text + city.level);
                    me.setCity(city);
                } else {
                    console.error('something  wrong!');
                }
            })
            // 区域点击
            .on('click', '.mini-districtpicker-district-item', function () {
                jQuery(this).addClass('active').siblings().removeClass('active');
                var id = this.getAttribute('data-id');
                var district = me.dataMap[id];
                if (district) {
                    me.setText(
                        me.province.text +
                            me.province.level +
                            me.split +
                            me.city.text +
                            me.city.level +
                            me.split +
                            district.text +
                            district.level
                    );
                    me.setDistrict(district);
                } else {
                    console.error('something  wrong!');
                }
            })
            // 搜索结果点击
            .on('click', '.mini-districtpicker-search-item', function () {
                var id = this.getAttribute('data-id');
                var currentData = me.dataMap[id];
                if (!currentData) return;
                var path = me._getFullPath(id);
                // 如果点击的是县区一级 直接选择结束
                if (!currentData.items || !currentData.items.length) {
                    if (path.length == 2) {
                        // p c d
                        me.setProvince(path[0]);
                        me.setCity(path[1]);
                        me.setDistrict(currentData);
                    } else if (path.length === 1) {
                        // 直辖市的情况
                        me.setProvince(path[0]);
                        me.setCity(currentData);
                    } else if (path.length === 0) {
                        // 海外的情况
                        me.setProvince(currentData);
                    }
                    me._selectedEnd();
                } else {
                    // 如果点击的是省 市 则切换到对应的选择
                    me.__popupMode = 'select';
                    if (path.length === 1) {
                        me.setProvince(path[0]);

                        me.setCity(currentData);
                        me.setText(me.province.text + me.province.level + me.split + me.city.text + me.city.level);
                        jQuery(me._provinceEl)
                            .find('.mini-districtpicker-province-item[data-id="' + path[0].id + '"]')
                            .addClass('active');
                        jQuery(me._cityEl)
                            .find('.mini-districtpicker-city-item[data-id="' + currentData.id + '"]')
                            .addClass('active');
                        // me._activePanel('city');
                    } else if (path.length === 0) {
                        me.setProvince(currentData);
                        me.setText(me.province.text + me.province.level);
                        jQuery(me._provinceEl)
                            .find('.mini-districtpicker-province-item[data-id="' + path[0].id + '"]')
                            .addClass('active');
                        // me._activePanel('province');
                    } 
                }
            });
    },
    __beforeClosePopup: function () {
        // 非选择完成就被关闭 需还原初始的值
        if (!this.__selectEnd) {
            // 选择被中断 还原之前的 value
            this._setValue(this.__oldValue);
            this._restoreValue();
        }
    },
    _clearPopupContent: function () {
        if (this._tabBodyEl) {
            this._provinceEl.innerHTML = '';
            this._cityEl.innerHTML = '';
            this._districtEl.innerHTML = '';
            var $items = jQuery(this._tabHeaderEl).children().addClass('hidden');
            $items.eq(0).text(this.selectText).removeClass('hidden');
            // $items.eq(1).text('城市');
            // $items.eq(2).text('县区');
        }
    },
    __beforeShowPopup: function () {
        this.__popupMode = 'select';
        this.__oldValue = this.value;
        this.__selectEnd = false;

        // 处理初始状态
        if (!this.province) {
            this._clearPopupContent();
            this._renderProvince();
            this._activePanel('province');
        } else {
            // 还原对应的tab
            var data = this.valueData;
            if (data[0]) {
                this._renderProvince();
                this._activePanel('province');
                this._setSelected('province', data[0]);
                jQuery(this._provinceEl)
                    .find('>[data-id="' + data[0].id + '"]')
                    .addClass('active');
            }
            if (data[1]) {
                this._renderCity();
                this._activePanel('city');
                this._setSelected('city', data[1]);
                jQuery(this._cityEl)
                    .find('>[data-id="' + data[1].id + '"]')
                    .addClass('active');
            }
            if (data[2]) {
                this._renderDistrict();
                this._activePanel('district');
                this._setSelected('district', data[2]);
                jQuery(this._districtEl)
                    .find('>[data-id="' + data[2].id + '"]')
                    .addClass('active');
            }
        }
    },
    _activePanel: function (type) {
        var $search = jQuery(this._searchWrap);
        var $tabs = jQuery(this._tabsEl);

        if (this.__popupMode == 'select') {
            $tabs.show();
            $search.hide();
            var $tabHeader = jQuery(this._tabHeaderEl);
            $tabHeader
                .find('[data-target="' + type + '"]')
                .addClass('active')
                .siblings()
                .removeClass('active');
            jQuery(this._tabBodyEl)
                .find('[data-id="' + type + '"]')
                .show()
                .siblings()
                .hide();
        } else {
            $tabs.hide();
            $search.show();
        }
    },

    _setSelected: function (type, data, hasNext) {
        var $el = jQuery(this._tabHeaderEl).find('[data-target="' + type + '"]');
        $el.attr({
            'data-id': data.id
        })
            .text(data.text)
            .removeClass('hidden');
        $el.nextAll().addClass('hidden');
        if (hasNext) {
            $el.next().text(this.selectText).removeClass('hidden');
        }
        // var text = '';
        // if (type == 'province') {
        //     text = this.textMap['city'];
        // } else if (type == 'city') {
        //     text = this.textMap['district'];
        // }
        // $el.next().text(text).show();
    },

    /**
     * 选择结束 组织控件值
     */
    _selectedEnd: function () {
        this.__selectEnd = true;
        this.popup.hide();
        this.makeValue(true);

        // 选择结束 允许清空 不允许删除
        this._syncInputState();
    },
    makeValue: function (fire) {
        var valueData = [];
        var valueArr = [];
        var textArr = [];
        if (this.province) {
            valueData.push(this.province);
        }
        if (this.city) {
            valueData.push(this.city);
        }
        if (this.district) {
            valueData.push(this.district);
        }

        this.valueData = valueData;

        valueData.forEach(function (item) {
            textArr.push(item.text + item.level);
            valueArr.push(item.id);
        });
        this._setValue(valueArr.join(','));
        this.setText(textArr.join(this.split));
        fire && this.doValueChanged();
    },

    _renderProvince: function () {
        var cls = this.uiCls + '-province-item';
        var html = $.map(this.data, function (item) {
            return '<span class="' + cls + '" data-id="' + item.id + '"><span>' + item.text + '</span></span>';
        }).join('');
        this._provinceEl.innerHTML = html;
    },
    _renderCity: function (province) {
        var p = province || this.province;
        var cls = this.uiCls + '-city-item';
        var html = $.map(p.items, function (item) {
            return '<span class="' + cls + '" data-id="' + item.id + '"><span>' + item.text + '</span></span>';
        }).join('');
        this._cityEl.innerHTML = html;
    },
    _renderDistrict: function (city) {
        var c = city || this.city;
        var cls = this.uiCls + '-district-item';
        var html = $.map(c.items, function (item) {
            return '<span class="' + cls + '" data-id="' + item.id + '"><span>' + item.text + '</span></span>';
        }).join('');
        this._districtEl.innerHTML = html;
    },

    setProvince: function (province) {
        this.province = province;
        this.city = null;
        this.district = null;
        if (this.isShowPopup()) {
            if (this.selectedLevel != 'province' && !(this.selectedLevel == 'city' && province.level == '市') && province.items && province.items.length) {
                this._setSelected('province', province, true);
                this._activePanel('city');
                this._renderCity(province);
            } else {
                // end
                this._setSelected('province', province, false);
                this._selectedEnd();
            }
        }
    },
    getProvince: function () {
        return this.province;
    },
    setCity: function (city) {
        this.city = city;
        this.district = null;
        if (this.isShowPopup()) {
            if (this.selectedLevel != 'city' && city.items && city.items.length) {
                this._setSelected('city', city, true);
                this._renderDistrict(city);
                this._activePanel('district');
            } else {
                // end

                this._setSelected('city', city, false);
                this._selectedEnd();
            }
        }

    },
    getCity: function () {
        return this.city;
    },
    setDistrict: function (district) {
        this.district = district;
        if (this.province && this.city && this.district) {
            this._selectedEnd();
        }
    },
    getDistrict: function () {
        return this.district;
    },
    setSourceUrl: function(sourceUrl) {
        this.sourceUrl = sourceUrl;
    },
    getSourceUrl: function() {
        return this.sourceUrl;
    },
    _setValue: function () {
        mini.DistrictPicker.superclass.setValue.apply(this, arguments);
        this._syncInputState();
    },
    setValue: function(value) {
        this._setValue(value);
        this._restoreValue();
    },
    // 从 字符串的value 还原省市区
    _restoreValue: function () {
        if (!this.sourceLoaded) {
            return;
        }
        var valueArr = this.value.split(',');
        var pid = valueArr[0];
        var province = this.dataMap[pid];
        if (province) {
            this.setProvince(province);
        } else {
            this.setProvince(null);
        }

        var cid = valueArr[1];
        var city = this.dataMap[cid];
        if (city) {
            this.setCity(city);
        } else {
            this.setCity(null);
        }

        var did = valueArr[2];
        var district = this.dataMap[did];
        if (district) {
            this.setDistrict(district);
        } else {
            this.setDistrict(null);
        }
        this.makeValue(false);
    },
    // 重写 button edit 上的 此方法 不要点什么都聚焦
    // __OnMouseDown: function (e) {
    //     if (this.isReadOnly()) return;

    //     if (this.isReadOnly() || this.enabled == false) return;

    //     if (!mini.isAncestor(this._borderEl, e.target)) return;

    //     if (!mini.isAncestor(this._textEl, e.target)) {
    //         this._clickTarget = e.target;
    //         // var sf = this;
    //         // setTimeout(function () {
    //         //     sf.focus();
    //         //     mini.selectRange(sf._textEl, 1000, 1000);
    //         // }, 1);
    //         if (mini.isAncestor(this._buttonEl, e.target)) {
    //             var up = mini.findParent(e.target, "mini-buttonedit-up");
    //             var down = mini.findParent(e.target, "mini-buttonedit-down");
    //             if (up) {
    //                 mini.addClass(up, this._buttonPressedCls);
    //                 this._OnButtonMouseDown(e, "up");
    //             }
    //             else if (down) {
    //                 mini.addClass(down, this._buttonPressedCls);
    //                 this._OnButtonMouseDown(e, "down");
    //             } else {
    //                 mini.addClass(this._buttonEl, this._buttonPressedCls);
    //                 this._OnButtonMouseDown(e);
    //             }
    //         }
    //         mini.on(document, "mouseup", this.__OnDocMouseUp, this);

    //         var btnEl = mini.findParent(e.target, "mini-buttonedit-button")
    //         if (btnEl) {
    //             mini.addClass(btnEl, this._buttonPressedCls);
    //         }

    //     }

    //     if (this.allowInput == false && mini.findParent(e.target, "mini-buttonedit-border")) {
    //         mini.addClass(this.el, this._pressedCls);

    //         mini.on(document, "mouseup", this.__OnDocMouseUp, this);
    //     }
    // },
    // keydown 事件覆盖掉 原来的自动关闭 等不需要
    __OnInputKeyDown: function (e) {
        var ex = { htmlEvent: e };
        this.fire('keydown', ex);
        if (e.keyCode == 13) {
            this.fire('enter', ex);
        }
    },
    // 重写 按钮点击 无需 focus
    _OnButtonMouseDown: function (htmlEvent, spinType) {
        // this.focus();
        this.addCls(this._focusCls);

        this.fire('buttonmousedown', {
            htmlEvent: htmlEvent,
            spinType: spinType
        });
    },
    _doSearch: function (kw) {
        if (!kw) {
            this.__popupMode = 'select';
            this._activePanel('province');
            return;
        }
        this.__popupMode = 'search';
        this._activePanel();
        var isPy = /^\w+$/.test(kw);
        var reg = new RegExp(kw, 'i');
        var result;
        if (isPy) {
            result = this.listData.filter(function (item) {
                return reg.test(item.initial) || reg.test(item.pinyin_s) || reg.test(item.pinyin);
            });
        } else {
            result = this.listData.filter(function (item) {
                return reg.test(item.text);
            });
        }
        this._renderSearch(result, !isPy ? kw : false, reg);
    },
    _renderSearch: function (result, kw, reg) {
        var me = this;
        var html = $.map(result, function (item) {
            var path = me._getFullPathText(item.id);
            var text = kw
                ? item.text.replace(reg, '<span class="mini-districtpicker-search-item-kw">' + kw + '</span>')
                : item.text;
            return (
                '<div class="mini-districtpicker-search-item" data-id="' +
                item.id +
                '" data-issub="">' +
                text +
                (path ? '<span class="mini-districtpicker-search-item-path">' + path + '</span>' : '') +
                '</div>'
            );
        });
        if (!result.length) {
            jQuery(this._searchList).empty().addClass('empty');
        } else {
            jQuery(this._searchList).html(html.join('')).removeClass('empty');
        }
    },
    _getFullPath: function (id) {
        var arr = [];
        var currentNode = typeof id === 'string' ? this.dataMap[id] : id;
        if (!currentNode) return arr;
        var parentNode = this.dataMap[currentNode.pid];
        while (parentNode) {
            if (parentNode.id === parentNode.pid) {
                console.error('数据异常：', parentNode);
                break;
            }
            arr.unshift(parentNode);
            parentNode = this.dataMap[parentNode.pid];
        }
        return arr;
    },
    _getFullPathText: function (id, withSelf) {
        var arr = this._getFullPath(id);
        return arr
            .map(function (item) {
                return item.text + item.level;
            })
            .join(this.split);
    },
    _initInputEvent: function () {
        var me = this;
        jQuery(this._textEl)
            .on('click', function (e) {
                if (me.allowInput && !me.isShowPopup()) me.showPopup();
                // me.__popupMode = 'search';
            })
            .on(
                'keyup',
                mini.throttle(
                    function (e) {
                        if (me.allowInput !== true) return;
                        // var code = e.which;
                        var value = jQuery.trim(e.target.value);
                        this._doSearch(value);
                        // if (code === 13) {
                        //     this._doSearch(value);
                        // } else {
                        // }
                    },
                    100,
                    this
                )
            );

        this.on('closeClick', function () {
            me.value = '';
            me._restoreValue();
        });
    },
    // 同步是否允许输入的状态
    _syncInputState: function () {
        if (this.value) {
            this.setAllowInput(false);
            this.setShowClose(true);
        } else {
            this.setAllowInput(true);
            this.setShowClose(false);
        }
    },
    // 请求加载资源数据
    _requestSource: function () {
        var that = this;
        if (this.sourceUrl) {
            jQuery
                .ajax({
                    url: this.sourceUrl,
                    dataType: 'text'
                    // async: false
                })
                .done(function (str) {
                    that.listData = mini.DistrictPicker.parseData(str);
                    that.data =  mini.DistrictPicker.arrayToTree(that.listData);
                    that.dataMap = mini.DistrictPicker.makeMap(that.listData);
                    that.sourceLoaded = true;
                    that._restoreValue();
                });
        } else if (!mini.DistrictPicker.dataLoader) {
            mini.DistrictPicker.dataLoader = jQuery
                .ajax({
                    url: mini.externalSrc + 'district/district-full.csv',
                    dataType: 'text'
                    // async: false
                })
                .done(function (str) {
                    that.listData = mini.DistrictPicker.listData = mini.DistrictPicker.parseData(str);
                    that.data = mini.DistrictPicker.data = mini.DistrictPicker.arrayToTree(that.listData);
                    that.dataMap = mini.DistrictPicker.dataMap = mini.DistrictPicker.makeMap(that.listData);
                    that.sourceLoaded = true;
                    that._restoreValue();
                });
        } else {
            mini.DistrictPicker.dataLoader.then(function () {
                that.listData = mini.DistrictPicker.listData;
                that.data = mini.DistrictPicker.data;
                that.dataMap = mini.DistrictPicker.dataMap;
                that.sourceLoaded = true;
                that._restoreValue();
            });
        }
    },
    searchByText: function (text) {
        if (!this.sourceLoaded || !(text + '' === text && text !== '')) {
            return null;
        }
        var list = this.listData.filter(function(data) {
            return (data.text + data.clan + data.level).includes(text);
        });
        return mini.clone(list);
    },
    setSelectedLevel: function(level) { 
        if(!['province', 'city', 'district'].contains(level)) {
            level = 'district';
        }

        this.selectedLevel = level;
    },
    getAttrs: function(el) {
        var attrs = mini.DistrictPicker.superclass.getAttrs.call(this, el);
        mini._ParseString(el, attrs, ['sourceUrl', 'selectedLevel']);
        return attrs;
    }
});

mini.regClass(mini.DistrictPicker, 'districtpicker');


mini.Drawer = function () {
    mini.Drawer.superclass.constructor.call(this);
    this.addCls("mini-drawer");
    
    this.setAllowDrag(false);
    this.setAllowResize(false);
};
mini.extend(mini.Drawer, mini.Panel, {
    uiCls: 'mini-drawer',

    placement: 'right',

    showCloseButton: true,
    showModal: true,
    showHeader: false,
    width: '',
    height: '100%',

    _create: function () {
        mini.Drawer.superclass._create.call(this);

        this.el.className += ' right';

        this.$el = jQuery(this.el);
    },

    _afterApply: function(){
        this.$el.css('transform', this._transformDirect[this.placement]);
        this.$el.addClass('initialized');
    },
    setPlacement: function(placement) {
        if(this.placement === placement) {
            return;
        }

        this.$el.removeClass(this.placement);

        this.placement = placement;
        this.$el.addClass(placement);

        switch(placement) {
            case 'top':
            case 'bottom':
                this.height === '100%' && this.setHeight('');
                this.setWidth('100%');
                break;
            case 'right':
            case 'left':
            default:
                this.setHeight('100%');
                this.width === '100%' && this.setWidth('');
                break;
        }
    },

    _transformDirect: {
        left: 'translateX(-200%)',
        right: 'translateX(200%)',
        top: 'translateY(-200%)',
        bottom: 'translateY(200%)'
    },

    setAllowDrag: function(){
        this.allowDrag = false;
    },
    setShowMaxButton: function(){
        this.showMaxButton = false;
    },
    setShowMinButton: function () {
        this.showMinButton = false;
    },
    max: function(){
        this.show();
    },
    restore: function() {
        this.show();
    },
    show: function() {
        var containerEl = this._containerEl || document.body;
        if (!this.isRender() || (this.el.parentNode != containerEl && this.showInBody)) {
            this.setVisible(false);
            this.render(containerEl);
            this.$el.css('transform', this._transformDirect[this.placement]);
            this.$el.addClass('initialized');
            this.setVisible(true);
        }
        var e = {
            cancel: false
        };
        this.fire('beforeopen',e);
        if(e.cancel) {
            return;
        }
        this._zIndex = mini.getMaxZIndex();
        this.$el.css({
            'transform': 'none',
            'z-index': this._zIndex
        });
        this._doModal();

        this.fire('open');
        
    },
    hide: function () {
        var e = {
            cancel: false
        };
        this.fire('beforeclose',e);
        if(e.cancel) {
            return;
        }

        this.$el.css('transform', this._transformDirect[this.placement]);

        this._modalEl && (this._modalEl.style.display = "none");

        this.fire('close');
    },
    _doModal: function () {

        if (!this.el) {

            if (this._modalEl) mini.removeNode(this._modalEl);
            return;
        }
        var show = this.showModal && this.isDisplay() && this.visible;
        if (!this._modalEl && this.showModal == false) {

            if (this._modalEl) mini.removeNode(this._modalEl);
            return;
        }
        //if (this.showModal && this.visible) show = true;
        //this.el.style.display = "none";
        if (!this._modalEl) {
            var id = '__modal' + this._id;
            this._modalEl = mini.append(document.body, '<div id="' + id + '" class="mini-modal mini-widget-content" style="display:none"></div>');

            mini_onOne(this._modalEl, 'click', this.hide, this);
        }
        
        if (show) {
            this._modalEl.style.display = "block";
            this._modalEl.style.zIndex = this._zIndex - 1;
            //            var me = this;

            //            setTimeout(function () {
            //                if (me._modalEl) {
            //                    me._modalEl.style.display = "none";
            //                    resizeModal.call(me);
            //                }
            //            }, 1);
        } else {
            this._modalEl.style.display = "none";
        }
    },
    setTitle: function (title) {
        this.setShowHeader(!!title);
        mini.Drawer.superclass.setTitle.call(this, title);
    },
    destroy: function (removeEl) {
        // destroy的时候也需要有个动画
        this.$el.css('transform', this._transformDirect[this.placement]);

        if (this._modalEl) {
            jQuery(this._modalEl).remove();
            this._modalEl = null;
        }

        var id = '__modal' + this._id;
        jQuery("[id='" + id + "']").remove();

        var self = this;
        setTimeout(function() {
            mini.Drawer.superclass.destroy.call(self, removeEl);
        }, 200);
        
    },
    getAttrs: function (el) {
        var attrs = mini.Drawer.superclass.getAttrs.call(this, el);

        mini._ParseString(el, attrs, ['placement', 'onopen', 'onclose', 'onbeforeopen', 'onbeforeclose']);


        return attrs;
    }
});

mini.regClass(mini.Drawer, 'drawer');

mini.openDrawer = function(options){
    if (typeof options == "string") {
        options = { url: options };
    }

    options = mini.copyTo({
        title: "",
        url: "",
        showCloseButton: true
    }, options);

    options.closeAction = "destroy";

    var onload = options.onload;
    delete options.onload;
    var ondestroy = options.ondestroy;
    delete options.ondestroy;
    var url = options.url;
    delete options.url;

    var drawer = new mini.Drawer();
    drawer.set(options);

    drawer.load(url,
        onload,
        ondestroy
    );
    drawer.show();

    return drawer;
};
/**
 * FilterTree
 * @class
 * @extends mini.Tree
 * @constructor
 */

mini.FilterTree = function() {
    mini.FilterTree.superclass.constructor.call(this);

    this.initComponents();
    this.bindEvents();
};

mini.extend(mini.FilterTree, mini.Tree, {
    // 搜索模式，可取值为'client'、'server'
    filterMode: 'client',

    filterUrl: '',

    height: '100%',

    emptyText: epoint_local.FilterTree.emptyText,

    uiCls: 'mini-filtertree',
    mapClass: '',
    autoLoad: false,
    resultAsTree: false,
    _initialData: [],

    filterOnInput: false,
    // set: function(kv) {
    //     if (typeof kv === 'string') {
    //         return this;
    //     }
    //     mini.FilterTree.superclass.set.call(this, kv);
    //     return this;
    // },

    initComponents: function() {
        var toolbar =
            '<input name="filterInput" class="mini-buttonedit mini-filtertree-filter" emptyText="' +
            this.emptyText +
            '" />';

        this.set({
            showToolbar: true,
            toolbar: toolbar
        });
    },

    _filterKey: '',
    bindEvents: function() {
        this._filterInput = mini.getbyName('filterInput', this);

        // 键盘事件
        this._filterInput.on('enter', this._handleFilter, this);
        // 按钮事件
        this._filterInput.on('buttonclick', this._handleFilter, this);

        this.on('load', function(e) {
            var data = e.data;
            // 只有真正的ajax请求才需要设置_initialData
            // 排查框架 commondto 中 setData 触发的 load 事件
            if (e.xhr && this.filterMode === 'client') {
                if (!this._initialData.length > 0) {
                    this._initialData = mini.clone(data);
                }
            }
        });
    },
    setData: function(data) {
        mini.FilterTree.superclass.setData.call(this, data);

        if (this.filterMode === 'client') {
            this._initialData = mini.clone(data);
        }
    },
    load: function(params, success, error, complete) {
        this._initialData = [];

        mini.FilterTree.superclass.load.call(this, params, success, error, complete);
    },
    _handleFilter: function() {
        var key = this._filterInput._textEl.value;
        this._doFilter(key);
    },
    _doFilter: function(key) {

        var that = this,
            $rowsViewEl = $(that._rowsViewEl);

        // 移除搜索无结果提示
        that._removeFilterEmptyText($rowsViewEl);

        that._filterKey = key;

        if (that.filterMode === 'server') {

            var e = {
                data: {
                    search_condition: key
                },
                url: that.getFilterUrl(),
                sender: that,
                cancel: false
            };

            that.fire('serverfilter', e);
            if (e.cancel) {
                return;
            }

            mini.showMaskLoading();

            that.fire('beforeload', e);
            mini.ajax({
                url: e.url,
                data: e.data,
                type: 'post',
                success: function(text, textStatus, xhr) {
                    if (!text || text == 'null') {
                        text = '{ tatal: 0, data: [] }';
                    }

                    delete e.params;
                    var obj = { text: text, result: null, sender: that, options: e, xhr: xhr };
                    var result = null;
                    try {
                        mini_doload(obj);
                        result = obj.result;
                        if (!result) {
                            result = mini.decode(text);
                        }
                    } catch (err) {
                        if (mini_debugger == true) {
                            alert(url + '\n json is error.');
                        }
                    }
                    if (mini.isArray(result)) {
                        result = { data: result };
                    }
                    if (that.dataField) {
                        result.data = mini._getMap(that.dataField, result);
                    }
                    if (!result.data) result.data = [];

                    var ex = { data: result.data, cancel: false, result: result };
                    that.fire('preload', ex);
                    if (ex.cancel == true) return;

                    if (that.getResultAsTree()) {
                        that.loadData(ex.data);
                    } else {
                        that.loadList(ex.data);
                    }
                    if (that.showRadioButton && that.value) {
                        that.setValue(that.value);
                    }

                    // 添加搜索无结果提示
                    if (result.data.length === 0) {
                        that._addFilterEmptyText($rowsViewEl);
                    }

                    that.fire('filter');
                    // 没有搜索条件时，表示还原到未搜索状态，不需要展开节点
                    if (key !== '') {
                        that.expandAll();
                    }
                },
                complete: function() {
                    mini.unmask();
                }
            });
        } else {
            if (key === '') {
                that.clearFilter();

                that.isFilter = false;
            } else {
                var searchResult = false;
                // 节点的 text 都是 html 转义的，key也需要转义下
                key = mini.htmlEncode(key.toLowerCase());
                that.filter(function(node) {
                    var text = node[that.textField] ? node[that.textField].toLowerCase() : '';
                    if (text.indexOf(key) !== -1) {
                        searchResult = true;
                        return true;
                    }
                });
                that.expandAll();
                that.isFilter = true;

                // 添加搜索无结果提示
                if (!searchResult) {
                    that._addFilterEmptyText($rowsViewEl);
                }

            }
            that.fire('filter');
        }

    },
    _addFilterEmptyText: function($view) {
        $view.append('<div class = "mini-tree-searchEmptyText">无搜索结果</div>');
    },
    _removeFilterEmptyText: function($view) {
        if ($view.find('.mini-tree-searchEmptyText')) {
            $view.find('.mini-tree-searchEmptyText').remove();
        }
    },
    // 把node的text可能包含的html标签去除掉
    _OnCellClick: function(e) {
        //if (mini.findParent(e.htmlEvent.target, 'mini-tree-editinput')) return;
        //        if (mini.findParent(e.htmlEvent.target, this._eciconCls)) {
        //            //this._tryToggleNode(e.record);
        //        } else
        if (mini.findParent(e.htmlEvent.target, this._eciconCls)) return;

        var nodes, text;

        // 有值则说明存在搜索，则节点text中存在HTML标签
        if (this._filterKey) {
            nodes = e.record[this.nodesField];
            if (nodes) {
                for (var i = 0, l = nodes.length; i < l; i++) {
                    text = nodes[i][this.textField];
                    nodes[i][this.textField] = text.replace(/<\/?.+?>/g, '');
                }
            }
        }
        if (mini.findParent(e.htmlEvent.target, 'mini-tree-checkbox') || this.checkOnTextClick) {
            this._tryToggleCheckNode(e.record);
        } else {
            this.fire('cellclick', e);
        }
    },

    // 安全整改后服务端不再返回html，所以搜索关键字高亮效果需要前端来实现了
    _OnDrawCell: function(record, column, rowIndex, columnIndex) {
        var e = mini.TreeGrid.superclass._OnDrawCell.call(this, record, column, rowIndex, columnIndex);

        function dealRegExp(reg) {
            return reg
                .replace(/\\/g, '\\\\')
                .replace(/\$/g, '\\$')
                .replace(/\(/g, '\\(')
                .replace(/\)/g, '\\)')
                .replace(/\*/g, '\\*')
                .replace(/\+/g, '\\+')
                .replace(/\./g, '\\.')
                .replace(/\[/g, '\\[')
                .replace(/\?/g, '\\?')
                .replace(/\^/g, '\\^')
                .replace(/\{/g, '\\{')
                .replace(/\|/g, '\\|')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;');
        }
        if (this._treeColumn && this._treeColumn == column.name) {
            var node = e.node;

            if (node.ckr === false) {
                e.showCheckBox = false;
                e.showRadioButton = false;
            }
            // 需更新下 _filterKey 的值，避免修改后未触发搜索而导致值不一致，从而导致渲染高亮不对问题
            this._filterKey = $.trim(this._filterInput._textEl.value);
            // 加上搜索关键字高亮效果
            if (this._filterKey) {
                var text = record[column.field];
                // 如果text中已经有html了，说明已经关键字高亮了，不需要再做处理
                // 兼容以前服务端实现高亮的情况，以及解决展开收起节点引起的重复drawcell事件
                if (!/<[^>]+>/.test(text)) {
                    e.nodeHtml = text.replace(
                        new RegExp('(' + dealRegExp(this._filterKey) + ')', 'gi'),
                        '<span class="mini-highlight">$1</span>'
                    );
                }
            }
            this.fire('drawnode', e);
            if (e.nodeStyle) {
                e.cellStyle = e.nodeStyle;
            }
            if (e.nodeCls) {
                e.cellCls = e.nodeCls;
            }
            if (e.nodeHtml) {
                e.cellHtml = e.nodeHtml;
            } else if (node.textCls) {
                e.cellHtml = '<span class="' + node.textCls + '">' + e.cellHtml + '</span>';
            }

            this._createTreeColumn(e);
        }
        return e;
    },
    clearFilter: function() {
        if (this._filterKey || this.isFilter) {
            this._filterInput.setValue('');
            this._filterInput.setText('');
            this._filterKey = '';
            // 移除搜索无结果提示
            this._removeFilterEmptyText($(this._rowsViewEl));

            mini.FilterTree.superclass.clearFilter.call(this);

            if (this.filterMode === 'server') {
                this.reload();
            } else {
                this._initialData && this.setData(this._initialData);
            }
        }
    },
    getFilterUrl: function() {
        return this.filterUrl || this.url;
    },

    setFilterUrl: function(filterUrl) {
        this.filterUrl = filterUrl;
    },

    getFilterMode: function() {
        return this.filterMode;
    },

    setFilterMode: function(filterMode) {
        this.filterMode = filterMode;
    },
    setFilterOnInput: function(filterOnInput) {
        this.filterOnInput = !!filterOnInput;
        if (this.filterOnInput) {
            this._filterInput.on('input', this._handleFilter, this);
        } else {
            this._filterInput.un('input', this._handleFilter, this);
        }
    },
    getFilterOnInput: function() {
        return this.filterOnInput;
    },
    /**
     * [setEmptyText 设置搜索树文本框为空时内容]
     * @param {String} value 要设置的值
     */
    setEmptyText: function(value) {
        if (this.emptyText != value) {
            this._filterInput.emptyText = this.emptyText = value;
            this._filterInput._doEmpty();
        }
    },
    /**
     * [getEmptyText 获取搜索树文本框为空时内容提示]
     * @return {String} emptyText
     */
    getEmptyText: function() {
        return this.emptyText;
    },

    getAttrs: function(el) {
        var attrs = mini.FilterTree.superclass.getAttrs.call(this, el);
        mini._ParseString(el, attrs, ['filterMode', 'filterUrl', 'emptyText', 'onserverfilter']);
        mini._ParseBool(el, attrs, ['filterOnInput']);

        if (!attrs.filterUrl) {
            attrs.filterUrl = attrs.url;
        }
        return attrs;
    }
});

mini.regClass(mini.FilterTree, 'filtertree');
mini.Icon = {};
mini.Icon.SVG_CONTENT =
    '<svg><symbol id="icon-trash-svg" viewBox="0 0 400 400"><g><rect x="40.01" y="110.4" fill="#4E5463" width="319.96" height="40" /><rect x="120.16" y="40.53" fill="#4E5463" width="159.72" height="40" /><rect x="146.87" y="190.56" fill="currentColor" width="40" height="90.18" /><rect x="213.39" y="190.56" fill="currentColor" width="40" height="90.18" /><path fill="#4E5463" d="M281.84,360.32H118.21c-20.95,0-38-17.05-38-38V131.26h40v189.06h159.63V131.26h40v191.06 C319.84,343.28,302.8,360.32,281.84,360.32z" /></g></symbol><symbol id="icon-modify-svg" viewBox="0 0 400 400"><g><path fill="#4E5463" d="M301.98,360.57H97.94c-20.95,0-38-17.05-38-38V118.44c0-20.95,17.05-38,38-38h57.1l25.07,40H99.94v200.13 h200.03v-95.49l40-24.68v122.17C339.98,343.52,322.93,360.57,301.98,360.57z" /><rect x="139.43" y="120" transform="matrix(0.6394 -0.7689 0.7689 0.6394 -16.6869 244.4267)" fill="currentColor" width="225.6" height="40" /></g></symbol><symbol id="icon-download-svg" viewBox="0 0 400 400"><g><path fill="#4E5463" d="M60.04,320.4h280.04v39.99H60.04v-20V320.4z" /><path fill="currentColor" d="M219.99,40.4v209.52H180V40.4h20H219.99z" /><polygon fill="currentColor" points="312.84,159.27 298.7,145.13 200,243.83 101.03,144.87 72.75,173.15 171.72,272.11 171.72,272.11 200,300.39 326.98,173.41 " /></g></symbol><symbol id="icon-clouddown-svg" viewBox="0 0 400 400"><g><path fill="currentColor" d="M219.91,190.42v119.54h-39.99V190.42h20H219.91z" /><path fill="currentColor" d="M143.44,237.17L228.28,322L200,350.28l-84.83-84.83l14.14-14.14L143.44,237.17z" /><path fill="currentColor" d="M284.83,265.45L200,350.28L171.72,322l84.83-84.83l14.14,14.14L284.83,265.45z" /><path fill="#4E5463" d="M342.36,171.17c-12.12-12.58-27.07-21.57-43.46-26.33c0.29-2.88,0.44-5.79,0.44-8.71 c0-47.24-38.43-85.67-85.68-85.67c-43.92,0-80.23,33.22-85.11,75.85c-54.97,3.95-98.49,49.94-98.49,105.9 c0,56.45,44.29,102.75,99.94,105.99v-40.11c-33.58-3.15-59.94-31.49-59.94-65.87c0-36.49,29.69-66.18,66.18-66.18 c3.22,0,6.5,0.24,9.75,0.72l27.14,4l-4.49-27.06c-0.42-2.54-0.63-5.08-0.63-7.56c0-25.19,20.49-45.67,45.67-45.67 c25.19,0,45.68,20.49,45.68,45.67c0,5.97-1.14,11.78-3.39,17.27l-10.8,26.4l28.5,1.16c31.58,1.28,56.31,27.05,56.31,58.67 c0,32.39-26.35,58.74-58.74,58.74c-0.41,0-0.81-0.01-1.22-0.02v39.99c0.41,0,0.81,0.03,1.22,0.03 c54.45,0,98.74-44.29,98.74-98.74C369.96,213.97,360.16,189.66,342.36,171.17z" /></g></symbol><symbol id="icon-view-svg" viewBox="0 0 400 400"><g><path fill="currentColor" d="M354.05,326.12l-60.92-60.92c-7.81-7.81-20.47-7.81-28.28,0c-7.81,7.81-7.81,20.47,0,28.28l60.92,60.92 c3.91,3.91,9.02,5.86,14.14,5.86c5.12,0,10.24-1.95,14.14-5.86C361.86,346.6,361.86,333.93,354.05,326.12z" /><path fill="#4E5463" d="M184.8,329c-79.6,0-144.35-64.76-144.35-144.35c0-79.6,64.76-144.35,144.35-144.35 c79.6,0,144.35,64.76,144.35,144.35C329.16,264.24,264.4,329,184.8,329z M184.8,80.29c-57.54,0-104.35,46.81-104.35,104.35 S127.26,289,184.8,289c57.54,0,104.35-46.81,104.35-104.35S242.35,80.29,184.8,80.29z" /><path fill="currentColor" d="M239.81,200.35c-11.05,0-20-8.95-20-20c0-16.58-13.49-30.07-30.07-30.07c-11.05,0-20-8.95-20-20 s8.95-20,20-20c38.64,0,70.07,31.43,70.07,70.07C259.81,191.39,250.85,200.35,239.81,200.35z" /></g></symbol><symbol id="icon-search-svg" viewBox="0 0 400 400"><g><path fill="currentColor" d="M354.05,326.12l-60.92-60.92c-7.81-7.81-20.47-7.81-28.28,0c-7.81,7.81-7.81,20.47,0,28.28l60.92,60.92 c3.91,3.91,9.02,5.86,14.14,5.86c5.12,0,10.24-1.95,14.14-5.86C361.87,346.6,361.87,333.93,354.05,326.12z" /><path fill="#4E5463" d="M184.8,329c-79.6,0-144.35-64.76-144.35-144.35c0-79.6,64.76-144.35,144.35-144.35 c79.6,0,144.35,64.76,144.35,144.35C329.16,264.24,264.4,329,184.8,329z M184.8,80.29c-57.54,0-104.35,46.81-104.35,104.35 S127.26,289,184.8,289c57.54,0,104.35-46.81,104.35-104.35S242.34,80.29,184.8,80.29z" /></g></symbol><symbol id="icon-select-svg" viewBox="0 0 400 400"><g><path fill="currentColor" d="M209.47,210.35v119.99l119.99-119.99H209.47z" /><path fill="#4E5463" d="M169.93,350.34H89.6c-21.77,0-39.48-17.71-39.48-39.48V89.99c0-21.77,17.71-39.48,39.48-39.48h220.77 c21.77,0,39.48,17.71,39.48,39.48v90.4h-40V90.51H90.12v219.83h79.81V350.34z" /><path fill="currentColor" d="M329.46,350.37c-5.12,0-10.24-1.95-14.14-5.86l-79.8-79.8c-7.81-7.81-7.81-20.47,0-28.28 c7.81-7.81,20.47-7.81,28.28,0l79.8,79.8c7.81,7.81,7.81,20.47,0,28.28C339.7,348.41,334.58,350.37,329.46,350.37z" /></g></symbol><symbol id="icon-voice-svg" viewBox="0 0 400 400"><g><path fill="#4E5463" d="M245.37,360.37l-28.78-27.78c34.4-35.63,53.34-82.53,53.34-132.06c0-49.57-18.97-96.5-53.41-132.14 l28.76-27.8c41.69,43.13,64.64,99.93,64.64,159.93C309.93,260.48,287.01,317.24,245.37,360.37z" /><path fill="currentColor" d="M180.71,297.84l-28.75-27.82c18.13-18.74,28.12-43.42,28.12-69.51c0-26.1-10-50.8-28.15-69.54l28.73-27.83 c25.42,26.25,39.42,60.83,39.42,97.37C220.09,237.04,206.1,271.6,180.71,297.84z" /><path fill="currentColor" d="M123.2,242.4c10.52-10.82,17-25.6,17-41.88c0-16.32-6.5-31.12-17.06-41.94l-43.27,41.91L123.2,242.4z" /></g></symbol><symbol id="icon-location-svg" viewBox="0 0 400 400"><g><path fill="currentColor" d="M209.99,231c-33.39,0-60.55-27.16-60.55-60.55c0-33.39,27.16-60.55,60.55-60.55 c33.39,0,60.55,27.16,60.55,60.55C270.55,203.84,243.38,231,209.99,231z M209.99,149.9c-11.33,0-20.55,9.22-20.55,20.55 S198.66,191,209.99,191c11.33,0,20.55-9.22,20.55-20.55S221.33,149.9,209.99,149.9z" /><path fill="#4E5463" d="M209.99,360.44c-5.91,0-11.52-2.62-15.32-7.15l-88.8-105.89c-1.39-1.66-2.74-3.39-4.01-5.15 c-2.08-2.88-3.85-5.64-5.42-8.44c-10.77-19.26-16.46-41.17-16.46-63.36c0-34.6,13.44-67.17,37.84-91.7 c24.39-24.52,56.87-38.13,91.45-38.31c34.79-0.18,67.57,13.27,92.33,37.9c24.76,24.63,38.4,57.34,38.4,92.11 c0,22.1-5.65,43.94-16.35,63.16c-1.59,2.86-3.45,5.77-5.53,8.65c-1.26,1.75-2.61,3.48-4,5.13l-88.81,105.9 C221.52,357.82,215.91,360.44,209.99,360.44z M209.99,80.44c-0.17,0-0.33,0-0.5,0c-49.36,0.27-89.51,40.65-89.51,90.01 c0,15.37,3.93,30.53,11.37,43.84c0.81,1.44,1.76,2.92,2.93,4.53c0.71,0.98,1.46,1.95,2.23,2.87l73.48,87.62l73.49-87.63 c0.77-0.92,1.52-1.88,2.22-2.85c1.18-1.63,2.16-3.17,3.01-4.68c0,0,0,0,0,0c7.39-13.28,11.3-28.39,11.3-43.7 c0-24.04-9.45-46.68-26.61-63.75C256.36,89.75,233.85,80.44,209.99,80.44z" /></g></symbol><symbol id="icon-pause-svg" viewBox="0 0 400 400"><g><path fill="#4E5463" d="M199.91,360.23c-88.16,0-159.88-71.72-159.88-159.88c0-88.16,71.72-159.88,159.88-159.88 c88.16,0,159.88,71.72,159.88,159.88C359.79,288.51,288.07,360.23,199.91,360.23z M199.91,80.46 c-66.1,0-119.88,53.78-119.88,119.88s53.78,119.88,119.88,119.88s119.88-53.78,119.88-119.88S266.01,80.46,199.91,80.46z" /><rect x="146.88" y="140.17" fill="currentColor" width="40" height="120.34" /><rect x="213.39" y="140.17" fill="currentColor" width="40" height="120.34" /></g></symbol><symbol id="icon-play-svg" viewBox="0 0 400 400"><g><path fill="#4E5463" d="M199.91,360.23c-88.16,0-159.88-71.72-159.88-159.88c0-88.16,71.72-159.88,159.88-159.88 c88.16,0,159.88,71.72,159.88,159.88C359.79,288.51,288.07,360.23,199.91,360.23z M199.91,80.46 c-66.1,0-119.88,53.78-119.88,119.88s53.78,119.88,119.88,119.88c66.1,0,119.88-53.78,119.88-119.88S266.01,80.46,199.91,80.46z" /><path fill="currentColor" d="M170.16,270.3c-3.33,0-6.67-0.83-9.69-2.51c-6.36-3.52-10.31-10.22-10.31-17.49v-99.9 c0-7.27,3.95-13.97,10.31-17.49c6.36-3.52,14.13-3.32,20.3,0.54l79.87,49.95c5.84,3.66,9.39,10.06,9.39,16.96 c0,6.89-3.55,13.3-9.39,16.96l-79.87,49.95C177.53,269.28,173.85,270.3,170.16,270.3z M190.16,186.49v27.7l22.15-13.85 L190.16,186.49z" /></g></symbol><symbol id="icon-print-svg" viewBox="0 0 400 400"><g><path fill="#4E5463" d="M289.66,150.27H109.86V40.4h179.81V150.27z M149.86,110.27h99.81V80.4h-99.81V110.27z" /><path fill="currentColor" d="M289.86,359.4h-180V196.07h180V359.4z M149.86,319.4h100v-83.33h-100V319.4z" /><path fill="#4E5463" d="M359.98,290.4h-50.02v-40h10.02V150.27h-240V250.4H90v40H39.98V148.27c0-20.95,17.05-38,38-38h244 c20.95,0,38,17.05,38,38V290.4z" /></g></symbol><symbol id="icon-transform-svg" viewBox="0 0 400 400"><g><path fill="#4E5463" d="M189.95,190.35H39.73V78.52c0-20.95,17.05-38,38-38h112.22V190.35z M79.73,150.35h70.22V80.52H79.73V150.35 z" /><path fill="#4E5463" d="M322.04,360.63H209.82V210.81h150.22v111.83C360.04,343.59,342.99,360.63,322.04,360.63z M249.82,320.63 h70.22v-69.83h-70.22V320.63z" /><polygon fill="currentColor" points="360.04,190.46 320.04,190.46 320.04,120.4 263.32,120.4 263.32,80.4 360.04,80.4 " /><polygon fill="currentColor" points="136.45,320.5 39.73,320.5 39.73,210.43 79.73,210.43 79.73,280.5 136.45,280.5 " /><polygon fill="currentColor" points="289.84,160.41 209.99,100.4 289.84,40.4 " /><polygon fill="currentColor" points="110.09,240.49 189.94,300.5 110.09,360.5 " /></g></symbol><symbol id="icon-export-svg" viewBox="0 0 400 400"><g><path fill="#4E5463" d="M310.34,350.34H89.57c-21.77,0-39.48-17.71-39.48-39.48V89.99c0-21.77,17.71-39.48,39.48-39.48h90.42v40 H90.09v219.83h219.73V210.01h40v100.86C349.81,332.63,332.11,350.34,310.34,350.34z" /><path fill="currentColor" d="M219.95,260.4h-40v-102c0-20.95,17.05-38,38-38h111.96v40H219.95V260.4z" /><path fill="currentColor" d="M329.91,160.4c-5.12,0-10.24-1.95-14.14-5.86l-69.8-69.79c-7.81-7.81-7.81-20.47,0-28.28 c7.81-7.81,20.47-7.81,28.28,0l69.8,69.79c7.81,7.81,7.81,20.47,0,28.28C340.15,158.44,335.03,160.4,329.91,160.4z" /></g></symbol><symbol id="icon-back-svg" viewBox="0 0 400 400"><g><polygon fill="#4E5463" points="296.12,289.87 160.29,289.87 160.29,249.87 266.98,249.87 284.9,170.17 139.86,170.09 139.86,129.54 340.03,129.49" /><polygon fill="currentColor" points="139.86,69.79 50.08,145.89 139.86,230.38" /></g></symbol><symbol id="icon-disband-svg" viewBox="0 0 400 400"><path style="fill: currentColor;" d="M359.9,265.31l-27.92,28.31l27.86,28.49 M359.84,322.11l-28.21,28.35L303.9,322.1l-27.14,27.52l-28.34-28.23 l27.51-27.89l-27.08-27.69l28.21-28.35l26.95,27.56l27.55-27.94l28.34,28.23" /><path style="fill: #4E5463;" d="M230.82,320.42H79.93V293.8l82.88-38.98c10-4.7,14.29-16.62,9.59-26.61l-24.47-51.09v-45.7 c0-28.72,23.28-52,52-52s52,23.28,52,52v46.29l-24.1,50.4c-4.09,8.71-1.35,18.88,6.04,24.45c9.71-22.05,27.65-39.66,49.92-48.94 l8.08-16.64l0.25,0.12v-44.16l-0.19-0.09v-11.44c0-50.81-41.19-92-92-92c-50.81,0-92,41.19-92,92v55.73l0.25-0.12l19.51,40.1 l-87.76,41.28v92.01H257.2C245.25,349.7,236.05,335.97,230.82,320.42z" /></symbol></svg>';
// prettier-ignore
mini.Icon.SVG_MAP = ['icon-trash-svg', 'icon-modify-svg', 'icon-download-svg', 'icon-clouddown-svg', 'icon-view-svg', 'icon-search-svg', 'icon-select-svg', 'icon-voice-svg', 'icon-location-svg', 'icon-pause-svg', 'icon-play-svg', 'icon-print-svg', 'icon-transform-svg', 'icon-export-svg', 'icon-back-svg', 'icon-disband-svg'
].reduce(function (map, item) {
    map[item] = true;
    return map;
}, {});

(function (win, $) {
    function genderSvgContent(icon) {
        return '<svg icon="' + icon + '"><use xlink:href="#' + icon + '"></use></svg>';
    }

    function observer() {
        var observer;
        observer = new MutationObserver(function (mutationsList) {
            mutationsList.forEach(function (mutation) {
                var type = mutation.type;
                switch (type) {
                    case 'childList':
                        handleNodesAdd(mutation.addedNodes);
                        break;
                    case 'attributes':
                        handleAttr(mutation.target);
                        break;
                    default:
                        break;
                }
            });
            observer.takeRecords();
        });
        observer.observe(document.body, {
            childList: true,
            attributes: true,
            attributeOldValue: false,
            characterData: false,
            subtree: true
        });

        // 处理新增节点
        function handleNodesAdd(nodes) {
            var node;
            for (var i = 0, len = nodes.length; i < len; i++) {
                node = nodes[i];
                if (node.nodeType !== Node.ELEMENT_NODE) continue;
                parseIcon(node);
            }
        }

        function parseIcon(node) {
            var cls = node.className;
            var icon;
            if (jQuery(node).hasClass('action-icon')) {
                icon = cls.match(/icon-(\w+)-svg/);
                if (icon) {
                    if (node.firstChild && $(node.firstChild).attr('icon') == icon[0]) return;
                    node.innerHTML = genderSvgContent(icon[0]);
                }
            } else {
                parse(node);
            }
        }

        function handleAttr(target) {
            if (!target) return;
            var svg = target.firstElementChild;
            if (!svg) return;
            var icon = svg.getAttribute('icon');
            if (jQuery(target).hasClass(icon)) return;
            parseIcon(target);
        }
        jQuery(window).on('unload', function () {
            observer.disconnect();
        });
    }
    function interval() {
        parse();
        setTimeout(interval, 500);
    }

    function watch() {
        if (window.MutationObserver) return observer();

        return interval();
    }
    /**
     * 解析 svg 图标 将 svg use 加入到图标的html中以显示svg图标
     * @param {HTMLElement | undefined}  el 要解析的范围，如果传入将在此范围下查找需要处理svg图标（不包含自身） 省略时查询处理页面全部
     */
    function parse(el) {
        var $icons = el ? jQuery(el).find('.action-icon') : jQuery('.action-icon');
        $icons.each(function (i, el) {
            var icon = el.className.match(/icon-(\w+)-svg/);
            icon = icon ? icon[0] : false;
            if (!icon) return;
            if (mini.Icon.SVG_MAP[icon]) {
                if (el.firstChild && $(el.firstChild).attr('icon') === icon) return;
                el.innerHTML = genderSvgContent(icon);
            }
        });
    }

    mini.Icon.parseSVG = parse;

    function init() {
        document.body.insertAdjacentHTML(
            'beforeend',
            '<div class="hidden" style="display:none">' + mini.Icon.SVG_CONTENT + '</div>'
        );
        parse();
        watch();
    }
    jQuery(init);
})(this, this.jQuery);

mini.ImageUploader = function() {
    mini.ImageUploader.superclass.constructor.call(this);
};
// mini.ImageUploader.FILE_ADD_QUEUE = 'FILE_ADD_QUEUE';

/**
 * 1. 删除发请求
 * 2. 替换时加旧图片id 解决删除和顺序问题（需沟通）
 * 3. 进度条问题， 等待 UI
 * 4. 删除图片时 如何个性化提醒
 */
mini.extend(mini.ImageUploader, mini.Control, {
    uiCls: 'mini-imageuploader',
    actionButtons: [
        { icon: 'icon-upload', name: epoint_local.upload_text, role: 'reselect' },
        { icon: 'icon-trash', name: epoint_local.delete_text, role: 'remove' }
    ],
    showButton: true,
    maxBtnNum: 3,

    imageWidth: 80,
    imageHeight: 80,

    limitWidth: NaN, // 要求的图片宽度
    limitHeight: NaN, // 要求的图片高度

    accept: 'image/*',
    limitType: 'gif,jpg,jpeg,bmp,png,webp',
    _limitRegExp: /^(gif|jpg|jpeg|bmp|png|webp)$/i,

    numLimit: undefined,
    sizeLimit: undefined,
    fileNameLengthLimit: window.EpFrameSysParams && EpFrameSysParams.file_limit_namelength,

    multiple: false, // 多图上传
    serverFileNum: 0,
    data: [],
    enableSort: false,

    /**
     * state ： pedding -> uploading -> done
     * state: pedding -> uploading -> fail
     */
    STATE_TEXT: {
        PEDDING: 'pedding',
        UPLOADING: 'UPLOADING',
        DONE: 'done',
        FAIL: 'fail'
    },

    deleteAlert: epoint_local.ImageUploader.deleteAlert,
    deleteAlertTitle: epoint_local.ImageUploader.deleteAlertTitle,
    typeErrorAlert: epoint_local.ImageUploader.typeErrorAlert,
    typeAcceptedText: epoint_local.ImageUploader.typeAcceptedText,
    imageCountAlert: epoint_local.ImageUploader.imageCountAlert,
    imageNameLengthAlert: epoint_local.ImageUploader.imageNameLengthAlert,
    imageSizeAlert: epoint_local.ImageUploader.imageSizeAlert,
    imageWidthAlert: epoint_local.ImageUploader.imageWidthAlert,
    imageHeightAlert: epoint_local.ImageUploader.imageHeightAlert,
    imageMeasureAlert: epoint_local.ImageUploader.imageMeasureAlert,
    fileCountAlert: epoint_local.ImageUploader.fileCountAlert,
    ajaxErrorAlert: epoint_local.ajax_error_text,
    emptyFileErrorText: epoint_local.WebUploader.emptyFileErrorText,

    showTips: function(opt) {
        if (window.epoint) {
            return epoint.showTips(opt.content, opt);
        }
        return mini.showTips(opt);
    },

    setAction: function(action) {
        this.action = action;

        this.controlData = {
            id: this.id,
            type: this.type,
            mapClass: this.mapClass,
            action: this.action
        };

        var arr = action.split('.');
        if (arr.length < 2) return;
        var url = Util.getRightUrl('/rest/' + arr[0] + '/' + arr[1] + '?isCommondto=true');

        // 对于action配置为“xxxaction(aaa,bbb)”这种形式的，安全拦截中不允许url上出现“()”，所以需要将“()”里的内容拿下来，放到cmdParams里
        var reg = /\([\w\W]*\)/,
            match = url.match(reg);
        if (match) {
            url = url.replace(reg, '');

            this.cmdParams = match[0].replace('(', '[').replace(')', ']');
        }

        var urlParams = Util.getUrlParams();

        url = Util.addUrlParams(url, urlParams, 'ignore');

        this.setUploadUrl(url);
    },

    _dealUrl: function(url) {
        var isAbsoluteUrl = /^(http|https|ftp|data:)/g.test(url);

        return isAbsoluteUrl ? url : _rootPath + '/' + url;
    },
    _create: function() {
        this.data = [];
        this.serverFiles = {};
        this.externalSrc = this.externalSrc || mini.externalSrc;
        (this._fileIdPrefix = this.id + '$file$'), (this._fileIndex = 0);

        this._createInput();

        this.el = document.createElement('div');
        this.el.innerHTML = '<div class="mini-imageuploader-list" style="user-select:none"><label class="mini-imageuploader-addbutton"></label></div>';

        this._listEl = this.el.firstChild;

        this.el.appendChild(this._fileInput);

        this._$addBtn = jQuery(this.el).find('.mini-imageuploader-addbutton');
        this._$addBtn
            .css({
                width: this.imageWidth ? this.imageWidth : '',
                height: this.imageHeight ? this.imageHeight : '',
                lineHeight: this.imageHeight ? this.imageHeight + 'px' : ''
            })
            .attr({
                for: this.id + '$file'
            });
        mini.on(this._$addBtn[0], 'click', this.__onAddBtnClick, this);

        this.on('change', this.__onFileChange, this);
    },
    setActionButtons: function(arr) {
        var that = this;
        var MORE_ID = this.id + '$action$more';
        this.actionButtons = arr;
        var map = (this.actionButtonsMap = {});
        jQuery.each(arr, function(i, item) {
            if (!item.id) {
                item.id = that.id + '$action$' + (i + 1);
            }
            map[item.id] = item;
        });

        jQuery(this.el)
            .off('click', '.mini-imageuploader-btn')
            .on('click', '.mini-imageuploader-btn', function(e) {
                var target = e.target;
                var id = target.getAttribute('data-id');
                if (id === MORE_ID) {
                    that._showActionPopup(target);
                    return;
                }
                var action = that.actionButtonsMap[id];
                if (!action) return;
                // 默认的处理逻辑
                var role = action.role;
                if (role) {
                    if (that.readOnly || !that.enabled) {
                        return;
                    }
                    that.handleActionBtnClick(role, that._genderActionBtnEventData(target));
                    return;
                }
                // 用户自定义的处理逻辑
                var handle = action.handle;
                if (typeof handle !== 'function') {
                    handle = window[handle];
                }
                if (typeof handle === 'function') {
                    handle.call(that, that._genderActionBtnEventData(target));
                }
            });

        var isOver = this.actionButtons.length > this.maxBtnNum;
        var html;
        if (!isOver) {
            html = jQuery
                .map(this.actionButtons, function(btn) {
                    return '<span class="mini-imageuploader-btn action-icon ' + btn.icon + '" data-tooltip="' + btn.name + '" data-id="' + btn.id + '" role="' + btn.role + '"></span>';
                })
                .join('');
            this._actionBtnHtml = html;
            return;
        }

        var base = this.actionButtons.slice(0, this.maxBtnNum - 1);
        base.push({ id: MORE_ID, icon: 'icon-omit', handle: this._showActionPopup, name: epoint_local.more_text });
        var ext = this.actionButtons.slice(this.maxBtnNum - 1);
        this._initActonBtnPopup(ext);
        html = jQuery
            .map(base, function(btn) {
                return '<span class="mini-imageuploader-btn action-icon ' + btn.icon + '" data-tooltip="' + btn.name + '" data-id="' + btn.id + '" role="' + btn.role + '"></span>';
            })
            .join('');
        this._actionBtnHtml = html;
    },
    _genderActionBtnEventData: function(target) {
        var $target = jQuery(target);
        var icon = this.actionButtonsMap[$target.attr('data-id')];
        var $file = $target.closest('.mini-imageuploader-item');
        var fileId = $file.attr('file-id');
        var fileGuid = $file.attr('file-guid');
        var fileData = this.data.filter(function(file) {
            return file.id === fileId || file.attachGuid === fileGuid;
        })[0];
        var e = {
            sender: this,
            source: this,
            icon: icon,
            file: fileData,
            fileEl: $file[0]
        };

        return e;
    },
    _initActonBtnPopup: function(ext) {
        if (this.__extMenuInited) return;
        var that = this;
        var extMenu = new mini.Menu();
        extMenu.set({
            minWidth: 50,
            yOffset: 4
        });

        extMenu.setItems(
            $.map(ext, function(item) {
                return {
                    id: item.id,
                    text: item.name,
                    iconCls: item.icon
                };
            })
        );
        extMenu.on('itemclick', function(e) {
            var id = e.item.id;
            var moreTarget = e.sender.popupEl;
            var action = that.actionButtonsMap[id];
            if (!action) return;
            // 默认的处理逻辑
            var role = action.role;
            if (role) {
                if (that.readOnly || !that.enabled) {
                    return;
                }
                that.handleActionBtnClick(role, that._genderActionBtnEventData(moreTarget));
                return;
            }
            var handle = action.handle;
            if (typeof handle !== 'function') {
                handle = window[handle];
            }
            if (typeof handle === 'function') {
                handle.call(that, that._genderActionBtnEventData(moreTarget));
            }
        });
        var oldHide = extMenu.hide;
        extMenu.hide = function() {
            oldHide.apply(this, arguments);
            // 移除 active
            jQuery(that.el)
                .find('.mini-imageuploader-btn')
                .removeClass('active');
        };

        this.__extMenu = extMenu;
        this.__extMenuInited = true;

        this._showActionPopup = function(target) {
            extMenu.popupEl = target;
            extMenu.showAtEl(target);
            jQuery(target).addClass('active');
        };
    },
    handleActionBtnClick: function(role, event) {
        var that = this;
        switch (role) {
            case 'remove':
                mini.confirm(this.deleteAlert, this.deleteAlertTitle, function(action) {
                    if (action === 'ok') {
                        that.removeImage(event.file);
                    }
                });
                break;
            case 'reselect':
                this.reselectImage(event.file);
                break;

            default:
                break;
        }
    },
    /**
     * 根据文件id获取文件对象
     * @param {string} id 文件id
     */
    _getFileData: function(id) {
        var fileItem = null;
        for (var i = 0, len = this.data.length; i < len; i++) {
            var item = this.data[i];
            if (item.id === id) {
                fileItem = item;
                break;
            }
        }
        return fileItem;
    },
    _removeFileData: function(id) {
        var removed = false;
        for (var i = 0, len = this.data.length; i < len; i++) {
            var item = this.data[i];
            if (item.id === id) {
                removed = this.data.splice(i, 1)[0];
                break;
            }
        }
        return removed;
    },
    /**
     * 移除某个图片
     * @param {string | object} file 文件id 或文件数据对象
     */
    removeImage: function(file) {
        var id = typeof file !== 'string' ? file.id : file;
        // 发请求删除文件
        var params = {
            action: 'delete',
            attachGuid: id
        };
        if (window.epoint) {
            params.commonDto = mini.encode(this.getCommonData());
            if (this.cmdParams) {
                params.cmdParams = this.cmdParams;
            }
            params[this.id + '_action'] = 'delete';
            params[this.id + '_attachGuid'] = id;
        }
        var e = {
            type: 'beforeRemove',
            sender: this,
            source: this,
            data: params
        };
        this.fire('beforeRemove', e);
        if (e.cancel === true) {
            return;
        }

        var removed = this._removeFileData(id);

        if (removed) {
            if (this.serverFiles[id]) {
                delete this.serverFiles[id];
                this.serverFileNum--;
            }

            jQuery
                .ajax({
                    url: this.uploadUrl,
                    data: e.data,
                    type: 'POST'
                })
                .done(function() {});

            jQuery(this.el)
                .find('.mini-imageuploader-item[file-id="' + id + '"]')
                .remove();
            if (removed) {
                this._updateAddBtnState();
                this.fire('fileremovesuccess', {
                    type: 'fileremovesuccess',
                    sender: this,
                    source: this,
                    data: params
                });
            }
        }

        return removed;
    },
    /**
     * 重新选择一张图片上传
     * @param {string | WrappedFile} file 要替换吧的文件对象
     */
    reselectImage: function(file) {
        var id = typeof file !== 'string' ? file.id : file;
        var me = this;
        var fileItem = this._getFileData(id);
        var $fileEl = jQuery(this.el).find('.mini-imageuploader-item[file-id="' + id + '"]');

        // 替换文件只能单选
        this._fileInput.removeAttribute('multiple');

        function handleReselect(e) {
            if (me.readOnly || !me.enabled) {
                return;
            }
            // 组织正常逻辑 此处自行完成
            e.cancel = true;
            // 还原正常的状态
            me.setMultiple(me.multiple);
            me.un('selectFile', handleReselect, this);

            //
            var files = e.files;
            if (!files.length) return;

            var file = e.files[0];

            if (!me._checkFileType(file)) return;

            if (files.length > 1) {
                return mini.alert(me.imageCountAlert);
            }

            // 文件名长度判断 中文算3字符
            if (me._checkFileNameLength(file)) return;

            // 空文件提示
            if (file.size === 0) {
                return mini.alert(me.emptyFileErrorText);
            }

            if (me.sizeLimit && file.size > me.sizeLimit * 1024) {
                return mini.alert(Mustache.render(me.imageSizeAlert, { 0: me.sizeLimit }));
            }
            me._validateWidthHeight(file).then(function(wrappedFile) {
                var e = {
                    sender: me,
                    source: me,
                    cancel: false,
                    type: 'beforequeued',
                    file: wrappedFile
                };
                me.fire('beforequeued', e);

                if (e.cancel) {
                    return;
                }
                wrappedFile.fromServer = false;
                wrappedFile.state = me.STATE_TEXT.PEDDING;

                // 加入新文件
                me.data.push(wrappedFile);
                // 开始上传
                var itemEl = me._genderImgEl(wrappedFile, $fileEl[0]);
                me._doUpload(wrappedFile, itemEl, id, $fileEl[0]);
            });
        }

        this.on('selectFile', handleReselect, this);

        var label = document.createElement('label');
        label.setAttribute('for', this._fileInput.id);
        // label.style.cssText = '';
        document.body.appendChild(label);
        label.click();
        document.body.removeChild(label);
    },
    __onAddBtnClick: function(e) {
        if (this.readOnly || !this.enabled) {
            return;
        }
        if (!this.multiple) {
            // 单个的时候检查当前是否已经有文件
            if ((this._fileInput.files && this._fileInput.files.length) || (this.data && this.data.length) || $(this._listEl).find('.mini-imageuploader-item').length) {
                e.preventDefault();
                return;
            }
        }
    },
    _createInput: function() {
        this._fileInput = document.createElement('input');
        this._fileInput.style.cssText = 'display:none';
        this._fileInput.setAttribute('type', 'file');
        this._fileInput.setAttribute('accept', this.accept);
        if (this.multiple) {
            this._fileInput.setAttribute('multiple', '');
        } else {
            this._fileInput.removeAttribute('multiple');
        }

        if (this.readOnly || !this.enabled) {
            this._fileInput.setAttribute('disabled', true);
        } else {
            this._fileInput.removeAttribute('disabled');
        }

        this._fileInput.id = this.id + '$file';

        var me = this;

        function change(e) {
            if (me.readOnly || !me.enabled) {
                return;
            }
            var event = e.originalEvent;
            var files = this.files;
            var ev = {
                files: files,
                cancel: false
            };
            me.fire('selectFile', ev);
            if (!ev.cancel) {
                me.fire('change', ev);
            }

            var clone = event.target.cloneNode(true);
            clone.value = null;
            this.parentNode.replaceChild(clone, this);
            jQuery(me._fileInput).off();

            me._fileInput = clone;
            jQuery(me._fileInput).on('change', change);
        }
        jQuery(this._fileInput).on('change', change);
    },
    _getFileWrapper: function(file) {
        return {
            id: this._fileIdPrefix + ++this._fileIndex,
            name: file.name,
            size: file.size,
            type: file.type,
            ext: file.name.substr(file.name.lastIndexOf('.') + 1),
            file: file
        };
    },
    /**
     * 验证图片文件的尺寸
     * @returns {jQuery.Deferred}
     */
    _validateWidthHeight: function(file) {
        var wrappedFile = this._getFileWrapper(file);
        var dtd = jQuery.Deferred();
        // 无需验证的情况直接给
        if (!this.limitWidth && !this.limitHeight) {
            dtd.resolve(wrappedFile);
            return dtd.promise();
        }
        var that = this;
        var image = new Image();
        var url = URL.createObjectURL(wrappedFile.file);
        image.onload = function() {
            image.onload = null;
            image.onerror = null;
            URL.revokeObjectURL(url);
            wrappedFile.width = image.width;
            wrappedFile.height = image.height;
            var isValid = true;
            var errorType = '';
            if (that.limitWidth) {
                isValid = image.width === that.limitWidth;
            }
            if (!isValid) {
                errorType += Mustache.render(that.imageWidthAlert, { 0: that.limitWidth });
            }
            if (that.limitHeight && isValid) {
                isValid = image.height === that.limitHeight;
            }
            if (that.limitHeight && !isValid) {
                errorType += Mustache.render(that.imageHeightAlert, { 0: that.limitHeight });
            }
            var e = {
                sender: that,
                source: that,
                isValid: isValid,
                width: image.width,
                height: image.height,
                errorText: isValid ? '' : Mustache.render(that.imageMeasureAlert, { 0: errorType })
            };


            that.fire('limitValidation', e);

            if (e.isValid) {
                dtd.resolve(wrappedFile);
            } else {
                that.showTips({ content: e.errorText, state: 'danger' });
                dtd.reject(wrappedFile);
            }
        };
        image.onerror = function(err) {
            image.onload = null;
            image.onerror = null;
            URL.revokeObjectURL(url);
            // wrappedFile.width = NaN;
            // wrappedFile.height = NaN;
            dtd.reject(err);
        };
        image.src = url;

        return dtd.promise();
    },
    _checkFileType: function(file) {
        var idx = file.name.lastIndexOf('.');
        if (!~idx) {
            return false;
        }
        var ext = file.name.substr(idx + 1);

        if (!this._limitRegExp.test(ext)) {
            mini.alert(this.typeErrorAlert + '!</br>' + this.typeAcceptedText + ':' + this.limitType);
        }

        return this._limitRegExp.test(ext);
    },
    _checkFileNameLength: function(file) {

        var filename = file.name;

        var isAbove = this.fileNameLengthLimit && mini.getStrLength(filename, true) > this.fileNameLengthLimit;

        if (isAbove) {
            mini.alert(Mustache.render(this.imageNameLengthAlert, { 0: this.fileNameLengthLimit }));
        }

        return isAbove;

    },

    __onFileChange: function(e) {
        var files = e.files;
        if (!files.length) {
            return;
        }
        // 过滤文件类型
        var limitFiles = [];
        for (var i = 0; i < files.length; i++) {

            var curFile = files[i];

            if (!this._checkFileNameLength(curFile) && this._checkFileType(curFile)) {
                limitFiles.push(curFile);
            }

        }

        // 先检查数目 数目超出 直接结束
        if (limitFiles.length + this.data.length > this.numLimit) {
            mini.alert(Mustache.render(this.fileCountAlert, { 0: this.numLimit }));
            return;
        }
        if (limitFiles.length) {
            this.__doFilesAdd(limitFiles);
        }

        // var me = this;
        // var q1 = jQuery.queue(document.createElement('div'), this._, ['a', 'b', 'c']);
        // var i = 0;
        // function next() {
        //     console.log(i);
        //     if (i < files.length) {
        //         var file = files[i++];
        //         return me.__fileQueue(file).then(next);
        //     }
        // }

        // next();
    },

    // 处理选中文件 准备加入上传队列的情况
    __doFilesAdd: function(files) {
        this._filesQueue = [];
        var me = this;

        if (!this._validateImageSize(files)) {
            return;
        }

        var i = 0;

        function next() {
            if (i < files.length) {
                var file = files[i++];
                return me.__fileQueue(file).then(next);
            }
        }

        next().then(function() {
            // 全部选择的图片入队完成
            var e = {
                sender: me,
                source: me,
                type: 'queued',
                files: me._filesQueue
            };
            me.fire('queued', e);
            // 开始上传
            me.__doFilesUpload();
        });
    },

    _validateImageSize: function(files) {
        // 文件大小的验证
        if (this.sizeLimit) {
            var limit = this.sizeLimit * 1024;
            for (var j = 0, len = files.length; j < len; j++) {
                if (files[j].size > limit) {
                    mini.alert(Mustache.render(this.imageSizeAlert, { 0: this.sizeLimit }));

                    return false;
                }else if (files[j].size === 0) {
                    mini.alert(this.emptyFileErrorText);

                    return false;
                }
            }
        }
        return true;
    },

    /**
     * 单个文件的入队逻辑
     * @param {File} file 原生 file 对象
     * @returns {jQuery.Deferred<undefined>}
     */
    __fileQueue: function(file) {
        var dtd = $.Deferred();
        var that = this;
        this._validateWidthHeight(file).then(
            function(wrappedFile) {
                // 尺寸验证成功加入队列
                var e = {
                    sender: that,
                    source: that,
                    cancel: false,
                    type: 'beforequeued',
                    file: wrappedFile
                };
                that.fire('beforequeued', e);

                if (e.cancel) {
                    return dtd.resolve();
                }
                wrappedFile.fromServer = false;
                wrappedFile.state = that.STATE_TEXT.PEDDING;
                that._filesQueue.push(wrappedFile);
                that.data.push(wrappedFile);

                dtd.resolve();
            },
            function() {
                // 尺寸验证失败
                dtd.resolve();
            }
        );
        return dtd.promise();
    },

    _updateAddBtnState: function() {
        // 只读状态隐藏上传按钮
        if (this.readOnly) {
            this._$addBtn.hide();
            return;
        }
        if (!this.multiple) {
            // 单选
            if ((this._fileInput.files && this._fileInput.files.length) || (this.data && this.data.length) || $(this._listEl).find('.mini-imageuploader-item').length) {
                this._$addBtn.hide();
            } else {
                this._$addBtn.css({
                    display: 'inline-block'
                });
            }
        } else {
            // 多选
            if (this.data.length >= this.numLimit) {
                this._$addBtn.hide();
            } else {
                this._$addBtn.css({
                    display: 'inline-block'
                });
            }
        }
    },

    __doFilesUpload: function() {
        // TODO: 上传还需要一个队列 控制并发上传的数目
        for (var i = 0, len = this._filesQueue.length; i < len; i++) {
            var fileData = this._filesQueue[i];
            this._doUpload(fileData, this._genderImgEl(fileData));
        }
    },
    _genderItemEl: function(fileData) {
        var div = document.createElement('div');
        div.className = 'mini-imageuploader-item';
        jQuery(div).css({
            width: this.imageWidth ? this.imageWidth : '',
            height: this.imageHeight ? this.imageHeight : ''
        });
        // div.innerHTML =
        //     '<div class="mini-imageuploader-progress"><div class="mini-imageuploader-progress-current"></div></div>';

        div.innerHTML = '<div class="mini-imageuploader-btns">' + this._actionBtnHtml + '</div>';

        div.setAttribute('file-id', fileData.id);
        if (fileData.fileGuid) {
            div.setAttribute('file-guid', fileData.fileGuid);
        }
        if (fileData.downloadUrl) {
            var img = document.createElement('img');
            img.className = 'mini-imageuploader-img';
            img.src = this._dealUrl(fileData.downloadUrl);
            div.insertAdjacentElement('afterbegin', img);
        }
        return div;
    },
    /**
     * 生成图片预览 dom
     * @param {WrappedFile} fileData 封装过的file对象
     * @param {HTMLElement | undefined} replaceEl 旧的图片dom
     * @returns {HTMLElement}
     */
    _genderImgEl: function(fileData, replaceEl) {
        var file = fileData.file;
        // var div = document.createElement('div');
        // div.setAttribute('file-name', file.name);
        // div.setAttribute('file-id', fileData.id);
        // div.className = 'mini-imageuploader-item';
        // div.innerHTML =
        //     '<div class="mini-imageuploader-progress"><div class="mini-imageuploader-progress-current"></div></div>';

        var div = this._genderItemEl(fileData);
        var img = document.createElement('img');
        img.className = 'mini-imageuploader-img';
        var url = URL.createObjectURL(file);
        img.onload = function() {
            img.onload = null;
            URL.revokeObjectURL(url);
        };
        img.src = url;
        div.insertAdjacentElement('afterbegin', img);
        return div;
    },
    getCommonData: function() {
        if (!this.controlData) {
            this.controlData = {
                id: this.id,
                type: 'imageuploader',
                mapClass: this.mapClass,
                action: this.action,
                dataOptions: this['data-options']
            };
        }
        return [this.controlData, this.getViewdata()];
    },

    getViewdata: function() {
        var hidden = mini.get('_common_hidden_viewdata');

        if (!this.viewData) {
            this.viewData = {
                id: '_common_hidden_viewdata',
                type: 'hidden',
                value: ''
            };
        }

        if (hidden) {
            this.viewData.value = hidden.getValue();
        }

        return this.viewData;
    },
    _onUploadBeforeSend: function(data) {
        data.commonDto = mini.encode(this.getCommonData());
        if (this.cmdParams) {
            data.cmdParams = this.cmdParams;
        }
        data[this.id + '_action'] = 'upload';
    },
    /**
     * 上传
     * @param {WrappedFile} fileData 上传的文件包裹对象
     * @param {HTMLElement} el 图片占位dom元素
     * @param {string | undefined} replaceFileId 要替换的文件的id
     */
    _doUpload: function(fileData, el, replaceFileId, replaceEl) {
        var file = fileData.file;
        var me = this;
        var data = {};

        if (window.epoint) {
            data.commonDto = mini.encode(this.getCommonData());
            if (this.cmdParams) {
                data.cmdParams = this.cmdParams;
            }
            data[this.id + '_action'] = 'upload';
        } else {
            data.action = 'upload';
        }

        if (replaceFileId) {
            // 标记当前上传为替换
            data.action = 'replace';
            // 将要替换的图片文件的 id
            data.attachGuid = replaceFileId;
        }

        var event = {
            type: 'beforeUpload',
            sender: this,
            source: this,
            data: data
        };

        this.fire('beforeUpload', event);
        var formData = new FormData();
        $.each(event.data, function(k, v) {
            formData.append(k, v);
        });
        formData.append('file', file, file.name || '');

        jQuery
            .ajax({
                method: 'post',
                url: this.uploadUrl,
                // contentType: 'multipart/form-data',
                contentType: false,
                processData: false,
                dataType: 'json',
                data: formData,
                xhr: function() {
                    var xhr = new XMLHttpRequest();
                    xhr.upload.onloadstart = function() {
                        fileData.state = me.STATE_TEXT.UPLOADING;
                    };

                    xhr.upload.onprogress = function(e) {
                        // console.log(e);
                        var progress = e.loaded / e.total;
                        if (progress >= 1) progress = 1;
                        var percent = (progress * 100).toFixed(2) + '%';

                        fileData.progress = progress;

                        me.fire('uploadprogress', {
                            progress: progress,
                            percent: percent,
                            file: fileData,
                            fileEl: el
                        });
                    };
                    return xhr;
                }
            })
            .done(function(res) {
                // 插入图片
                if (replaceEl) {
                    jQuery(replaceEl).replaceWith(el);
                    // 删除旧文件
                    me._removeFileData(replaceFileId);
                } else {
                    jQuery(el).insertBefore(me._$addBtn);
                    // 根据数目调整 add 按钮的可用性
                    me._updateAddBtnState();
                }
                me.__onUploadSuccess(res, fileData, el);
            })
            .fail(function(err) {
                fileData.state = me.STATE_TEXT.FAIL;
                me.fire('uploadError', {
                    type: 'uploadError',
                    sender: me,
                    source: me,
                    file: fileData,
                    fileEl: el
                });
                // 删除失败文件信息
                me._removeFileData(fileData.id);

                var errowMsg;

                try {
                    // 如果返回安全拦截信息此处不弹出提示
                    if (err.responseJSON.error) return;
                    errowMsg = JSON.parse(err.responseText).status.text;
                } catch (e) {
                    errowMsg = me.ajaxErrorAlert;
                }

                if (errowMsg) {
                    mini.alert(errowMsg);
                }

            });
    },
    __onUploadSuccess: function(res, fileData, el) {
        var me = this;
        var data = res ? mini.getSecondRequestData(res) : {};
        data = mini.decode(data.data || data);
        // var data = mini.getSecondRequestData ? mini.getSecondRequestData(res).data : res;
        var img = jQuery(el).find('.mini-imageuploader-img')[0];

        URL.revokeObjectURL(img.src);

        // 成功时 进度确保到了 100% 若没有则再派发一次
        if (fileData.progress < 1) {
            fileData.progress = 1;
            me.fire('uploadprogress', {
                progress: 1,
                percent: '100%',
                file: fileData,
                fileEl: el
            });
        }

        fileData.state = me.STATE_TEXT.DONE;

        // 将响应信息 更新， 如 guid size downloadurl 等
        if (data.attachLength) {
            fileData.size = data.attachLength;
        }
        if (data.width) {
            fileData.width = data.width;
        }
        if (data.height) {
            fileData.height = data.height;
        }
        if (data.uploadDateTime) {
            fileData.date = data.uploadDateTime;
        }
        if (data.downloadUrl) {
            fileData.downloadUrl = data.downloadUrl;
            var imgUrl = window.Util ? window.Util.getRightUrl(data.downloadUrl,true) : data.downloadUrl;
            var t = '000000' + String(Math.floor(Math.random() * 1000000));
            t = t.substring(t.length - 6);
            imgUrl += (/\?/.test(imgUrl) ? '&_t=' : '?_t=') + t;
            img.src = imgUrl;
        }
        if (data.attachGuid) {
            el.setAttribute('file-id', data.attachGuid);
            el.setAttribute('file-guid', data.attachGuid);
            fileData.id = data.attachGuid;
        }
        // 防止图片上传完成后仍然显示tooltip
        jQuery(el).find('.mini-imageuploader-btn').trigger('mouseleave');
        me.fire('uploadSuccess', {
            type: 'uploadSuccess',
            sender: me,
            source: me,
            file: fileData,
            fileEl: el
        });
    },
    getData: function() {
        return this.data || [];
    },

    setData: function(data) {
        if (!jQuery.isArray(data)) {
            return false;
        }
        var arr = $.map(data, function(item) {
            if (Util.browsers.isIE) {
                item.downloadUrl = item.downloadUrl + '&' + Date.now();
            }
            return {
                fromServer: true,
                id: item.attachGuid,
                state: 'success',
                size: item.attachLength,
                width: item.width,
                height: item.height,
                date: item.uploadDateTime,
                fileGuid: item.attachGuid,
                downloadUrl: item.downloadUrl
            };
        });
        var files = (this.data = arr);
        this.serverFileNum = this.data.length;

        // 处理服务端返回的文件
        var fileItem,
            html = document.createDocumentFragment();
        this.serverFiles = {};
        for (var i = 0, len = files.length; i < len; i++) {
            //  加入服务端文件列表
            fileItem = files[i];
            this.serverFiles[fileItem.fileGuid] = fileItem;
            html.appendChild(this._genderItemEl(fileItem));
        }
        this._$addBtn.detach();
        $(this._listEl).empty();
        this._listEl.appendChild(html);
        this._listEl.appendChild(this._$addBtn[0]);

        this._updateAddBtnState();
        this.fire('load', {
            sender: this,
            eventType: 'load',
            data: data
        });
    },
    clearFile: function(clearServer) {
        if (!clearServer) {
            this.setData([]);
            this._updateAddBtnState();
            return;
        }

        var me = this;
        jQuery.each(this.data, function(i, file) {
            me.removeImage(file);
        });
    },

    getMultiple: function() {
        return this.multiple;
    },
    setMultiple: function(v) {
        this.multiple = v === true ? true : false;
        if (this.multiple) {
            this._fileInput.setAttribute('multiple', '');
        } else {
            this._fileInput.removeAttribute('multiple');
        }
    },

    getNumLimit: function() {
        return this.numLimit;
    },
    setNumLimit: function(v) {
        if (jQuery.isNumeric(v)) {
            this.numLimit = v;
        } else {
            return false;
        }
    },
    getSizeLimit: function() {
        return this.sizeLimit;
    },
    setSizeLimit: function(v) {
        if (jQuery.isNumeric(v)) {
            this.sizeLimit = v;
        } else {
            return false;
        }
    },
    getFileNameLengthLimit: function() {
        return this.fileNameLengthLimit;
    },
    setFileNameLengthLimit: function(v) {
        if (jQuery.isNumeric(v)) {
            this.fileNameLengthLimit = v;
        } else {
            return false;
        }
    },
    getImageWidth: function() {
        return this.imageWidth;
    },
    setImageWidth: function(v) {
        if (jQuery.isNumeric(v)) {
            this.imageWidth = v;
            this._$addBtn.css({
                width: this.imageWidth ? this.imageWidth : ''
            });
            jQuery(this.el)
                .find('.mini-imageuploader-item')
                .css({
                    width: this.imageWidth ? this.imageWidth : ''
                });
        } else {
            return false;
        }
    },
    getImageHeight: function() {
        return this.imageHeight;
    },
    setImageHeight: function(v) {
        if (jQuery.isNumeric(v)) {
            this.imageHeight = v;
            this._$addBtn.css({
                height: this.imageHeight ? this.imageHeight : '',
                lineHeight: this.imageHeight ? this.imageHeight + 'px' : ''
            });
            jQuery(this.el)
                .find('.mini-imageuploader-item')
                .css({
                    height: this.imageHeight ? this.imageHeight : ''
                });
        } else {
            return false;
        }
    },
    setUploadUrl: function(url) {
        this.uploadUrl = url;
    },
    getUploadUrl: function() {
        return this.uploadUrl;
    },

    setLimitWidth: function(v) {
        if (typeof v !== 'number') v = parseInt(v, 10);
        this.limitWidth = v;
    },
    getLimitWidth: function() {
        return this.limitWidth;
    },
    setLimitHeight: function(v) {
        if (typeof v !== 'number') v = parseInt(v, 10);
        this.limitHeight = v;
    },
    getLimitHeight: function() {
        return this.limitHeight;
    },
    getAccept: function() {
        return this.accept;
    },
    setAccept: function(v) {
        this.accept = v;
        this._fileInput.setAttribute('accept', v);
    },
    setLimitType: function(v) {
        this.limitType = v;
        var arr = [];
        (v || '').split(',').forEach(function(item) {
            if (item[0] === '.') item = item.substr(1);
            item = jQuery.trim(item);
            if (item) {
                arr.push(item);
            }
        });
        if (arr.length) {
            this._limitRegExp = new RegExp('^(' + arr.join('|') + ')$', 'i');
        } else {
            // 否则构造一个必定成功的正则即可
            this._limitRegExp = /[\s\S]*/i;
        }
    },
    getLimitType: function() {
        return this.limitType;
    },

    setShowButton: function(v) {
        this.showButton = !!v;
        this.showButton ? this.removeCls('mini-imageuploader-hidebtn') : this.addCls('mini-imageuploader-hidebtn');
    },
    getShowButton: function() {
        return this.showButton;
    },

    setEnabled: function(v) {
        mini.ImageUploader.superclass.setEnabled.call(this, v);
        if (this.readOnly || !this.enabled) {
            this._fileInput.setAttribute('disabled', true);
        } else {
            this._fileInput.removeAttribute('disabled');
        }
    },
    setReadOnly: function(v) {
        mini.ImageUploader.superclass.setReadOnly.call(this, v);
        if (this.readOnly || !this.enabled) {
            this._fileInput.setAttribute('disabled', true);
        } else {
            this._fileInput.removeAttribute('disabled');
        }
    },

    setEnableSort: function(v) {
        this.enableSort = v;
        var $list = jQuery(this._listEl);
        var that = this;
        if (this.enableSort) {
            $list.sortable({
                revert: true,
                delay: 150,
                distance: 10,
                items: '>.mini-imageuploader-item',
                update: function() {
                    var newSort = $list.sortable('toArray', {
                        attribute: 'file-guid'
                    });
                    var data = {
                        commonDto: mini.encode(that.getCommonData())
                    };
                    data[that.id + '_action'] = 'saveSort';
                    data.sort = newSort.join(',');
                    // 发请求保存排序
                    Util.ajax({
                        url: that.uploadUrl,
                        dataType: 'json',
                        data: data,
                        type: 'post',
                        success: function() {}
                    });
                }
            });
        } else {
            $list.sortable('destroy');
        }
    },
    getEnableSort: function() {
        return this.enableSort;
    },

    getAttrs: function(el) {
        var attrs = mini.ImageUploader.superclass.getAttrs.call(this, el);

        var $cs = jQuery(el).children('[type="button"]');
        var buttons = [];
        $.each($cs, function(i, item) {
            if (item.getAttribute('type') === 'button') {
                buttons.push({
                    icon: item.getAttribute('icon'),
                    name: item.getAttribute('title') || item.innerText,
                    role: item.getAttribute('role'),
                    handle: item.getAttribute('onclick')
                });
            }
        });
        if (buttons.length) {
            attrs.actionButtons = buttons;
        } else {
            this.setActionButtons(this.actionButtons);
        }

        mini._ParseInt(el, attrs, ['imageWidth', 'imageHeight', 'limitWidth', 'limitHeight', 'numLimit', 'sizeLimit', 'maxBtnNum', 'fileNameLengthLimit']);

        mini._ParseBool(el, attrs, ['multiple', 'showButton', 'enableSort']);

        mini._ParseString(el, attrs, ['accept', 'uploadUrl', 'limitType', 'onLimitValidation', 'onbeforequeued', 'onqueued', 'onbeforeUpload', 'onuploadprogress', 'onuploadsuccess', 'onuploaderror', 'onbeforeremove', 'onfileremovesuccess']);

        return attrs;
    }
});

mini.regClass(mini.ImageUploader, 'imageuploader');

// var q1 = jQuery.queue(document.createElement('div'), 'fileQueue', ['a', 'b', 'c']);
! function(factory) {
    'function' === typeof define && define.amd ? define(['jquery'], factory) : factory('object' === typeof exports ? require('jquery') : jQuery);
}(function($) {
    var caretTimeoutId, ua = navigator.userAgent,
        iPhone = /iphone/i.test(ua),
        chrome = /chrome/i.test(ua),
        android = /android/i.test(ua);
    $.mask = {
        definitions: {
            '9': '[0-9]',
            a: '[A-Za-z]',
            '*': '[A-Za-z0-9]'
        },
        autoclear: !0,
        dataName: 'rawMaskFn',
        placeholder: '_'
    }, $.fn.extend({
        caret: function(begin, end) {
            var range;
            if (0 !== this.length && !this.is(':hidden')) {
return 'number' === typeof begin ? (end = 'number' === typeof end ? end : begin,
                this.each(function() {
                    this.setSelectionRange ? this.setSelectionRange(begin, end) : this.createTextRange && (range = this.createTextRange(),
                        range.collapse(!0), range.moveEnd('character', end), range.moveStart('character', begin),
                        range.select());
                })) : (this[0].setSelectionRange ? (begin = this[0].selectionStart, end = this[0].selectionEnd) : document.selection && document.selection.createRange && (range = document.selection.createRange(),
                begin = 0 - range.duplicate().moveStart('character', -1e5), end = begin + range.text.length), {
                begin: begin,
                end: end
            });
}
        },
        unmask: function() {
            return this.trigger('unmask');
        },
        mask: function(mask, settings) {
            var input, defs, tests, partialPosition, firstNonMaskPos, lastRequiredNonMaskPos, len, oldVal;
            if (!mask && this.length > 0) {
                input = $(this[0]);
                var fn = input.data($.mask.dataName);
                return fn ? fn() : void 0;
            }
            return settings = $.extend({
                    autoclear: $.mask.autoclear,
                    placeholder: $.mask.placeholder,
                    completed: null
                }, settings), defs = $.mask.definitions, tests = [], partialPosition = len = mask.length,
                firstNonMaskPos = null, $.each(mask.split(''), function(i, c) {
                    '?' == c ? (len--, partialPosition = i) : defs[c] ? (tests.push(new RegExp(defs[c])),
                        null === firstNonMaskPos && (firstNonMaskPos = tests.length - 1), partialPosition > i && (lastRequiredNonMaskPos = tests.length - 1)) : tests.push(null);
                }), this.trigger('unmask').each(function() {
                    function tryFireCompleted() {
                        if (settings.completed) {
                            for (var i = firstNonMaskPos; lastRequiredNonMaskPos >= i; i++) {if (tests[i] && buffer[i] === getPlaceholder(i)) return;}
                            settings.completed.call(input);
                        }
                    }

                    function getPlaceholder(i) {
                        return settings.placeholder.charAt(i < settings.placeholder.length ? i : 0);
                    }

                    function seekNext(pos) {
                        for (; ++pos < len && !tests[pos];);
                        return pos;
                    }

                    function seekPrev(pos) {
                        for (; --pos >= 0 && !tests[pos];);
                        return pos;
                    }

                    function shiftL(begin, end) {
                        var i, j;
                        if (!(0 > begin)) {
                            for (i = begin, j = seekNext(end); len > i; i++) {
if (tests[i]) {
                                    if (!(len > j && tests[i].test(buffer[j]))) break;
                                    buffer[i] = buffer[j], buffer[j] = getPlaceholder(j), j = seekNext(j);
                                }
}
                            writeBuffer(), input.caret(Math.max(firstNonMaskPos, begin));
                        }
                    }

                    function shiftR(pos) {
                        var i, c, j, t;
                        for (i = pos, c = getPlaceholder(pos); len > i; i++) {
if (tests[i]) {
                                if (j = seekNext(i), t = buffer[i], buffer[i] = c, !(len > j && tests[j].test(t))) break;
                                c = t;
                            }
}
                    }

                    function androidInputEvent() {
                        var curVal = input.val(),
                            pos = input.caret();
                        if (curVal.length < oldVal.length) {
                            for (checkVal(!0); pos.begin > 0 && !tests[pos.begin - 1];) pos.begin--;
                            if (0 === pos.begin) {for (; pos.begin < firstNonMaskPos && !tests[pos.begin];) pos.begin++;}
                            input.caret(pos.begin, pos.begin);
                        } else {
                            for (checkVal(!0); pos.begin < len && !tests[pos.begin];) pos.begin++;
                            input.caret(pos.begin, pos.begin);
                        }
                        tryFireCompleted();
                    }

                    function blurEvent() {
                        checkVal(), input.val() != focusText && input.change();
                    }

                    function keydownEvent(e) {
                        if (!input.prop('readonly')) {
                            var pos, begin, end, k = e.which || e.keyCode;
                            oldVal = input.val(), 8 === k || 46 === k || iPhone && 127 === k ? (pos = input.caret(),
                                begin = pos.begin, end = pos.end, end - begin === 0 && (begin = 46 !== k ? seekPrev(begin) : end = seekNext(begin - 1),
                                    end = 46 === k ? seekNext(end) : end), clearBuffer(begin, end), shiftL(begin, end - 1),
                                e.preventDefault()) : 13 === k ? blurEvent.call(this, e) : 27 === k && (input.val(focusText),
                                input.caret(0, checkVal()), e.preventDefault());
                        }
                    }

                    function keypressEvent(e) {
                        if (!input.prop('readonly')) {
                            var p, c, next, k = e.which || e.keyCode,
                                pos = input.caret();
                            if (!(e.ctrlKey || e.altKey || e.metaKey || 32 > k) && k && 13 !== k) {
                                if (pos.end - pos.begin !== 0 && (clearBuffer(pos.begin, pos.end), shiftL(pos.begin, pos.end - 1)),
                                    p = seekNext(pos.begin - 1), len > p && (c = String.fromCharCode(k), tests[p].test(c))) {
                                    if (shiftR(p), buffer[p] = c, writeBuffer(), next = seekNext(p), android) {
                                        var proxy = function() {
                                            $.proxy($.fn.caret, input, next)();
                                        };
                                        setTimeout(proxy, 0);
                                    } else input.caret(next);
                                    pos.begin <= lastRequiredNonMaskPos && tryFireCompleted();
                                }
                                e.preventDefault();
                            }
                        }
                    }

                    function clearBuffer(start, end) {
                        var i;
                        for (i = start; end > i && len > i; i++) tests[i] && (buffer[i] = getPlaceholder(i));
                    }

                    function writeBuffer() {
                        input.val(buffer.join(''));
                    }

                    function checkVal(allow) {
                        var i, c, pos, test = input.val(),
                            lastMatch = -1;
                        for (i = 0, pos = 0; len > i; i++) {
if (tests[i]) {
                                for (buffer[i] = getPlaceholder(i); pos++ < test.length;) {
if (c = test.charAt(pos - 1),
                                        tests[i].test(c)) {
                                        buffer[i] = c, lastMatch = i;
                                        break;
                                    }
}
                                if (pos > test.length) {
                                    clearBuffer(i + 1, len);
                                    break;
                                }
                            } else buffer[i] === test.charAt(pos) && pos++, partialPosition > i && (lastMatch = i);
}
                        return allow ? writeBuffer() : partialPosition > lastMatch + 1 ? settings.autoclear || buffer.join('') === defaultBuffer ? (input.val() && input.val(''),
                                clearBuffer(0, len)) : writeBuffer() : (writeBuffer(), input.val(input.val().substring(0, lastMatch + 1))),
                            partialPosition ? i : firstNonMaskPos;
                    }
                    var input = $(this),
                        buffer = $.map(mask.split(''), function(c, i) {
                            return '?' != c ? defs[c] ? getPlaceholder(i) : c : void 0;
                        }),
                        defaultBuffer = buffer.join(''),
                        focusText = input.val();
                    input.data($.mask.dataName, function() {
                            return $.map(buffer, function(c, i) {
                                return tests[i] && c != getPlaceholder(i) ? c : null;
                            }).join('');
                        }), input.one('unmask', function() {
                            input.off('.mask').removeData($.mask.dataName);
                        }).on('focus.mask', function() {
                            if (!input.prop('readonly')) {
                                clearTimeout(caretTimeoutId);
                                var pos;
                                focusText = input.val(), pos = checkVal(), caretTimeoutId = setTimeout(function() {
                                    writeBuffer(), pos == mask.replace('?', '').length ? input.caret(0, pos) : input.caret(pos);
                                }, 10);
                            }
                        }).on('blur.mask', blurEvent).on('keydown.mask', keydownEvent).on('keypress.mask', keypressEvent).on('input.mask paste.mask', function() {
                            input.prop('readonly') || setTimeout(function() {
                                var pos = checkVal(!0);
                                input.caret(pos), tryFireCompleted();
                            }, 0);
                        }), chrome && android && input.off('input.mask').on('input.mask', androidInputEvent),
                        checkVal();
                });
        }
    });
});
mini.InputMask = function() {

    mini.InputMask.superclass.constructor.call(this);

};

mini.extend(mini.InputMask, mini.TextBox, {
    uiCls: 'mini-inputmask',
    mask: '',

    set: function (kv) {
        if (typeof kv === 'string') {
            return this;
        }

        // var placeholder = kv.placeholder;
        // delete kv.placeholder;

        var mask = kv.mask;
        delete kv.mask;

        // var autoclear = kv.autoclear;
        // delete kv.autoclear;

        mini.InputMask.superclass.set.call(this, kv);

        if (mask) {
            this.setMask(mask);
        }


        return this;
    },

    setMask: function(mask) {
        this.mask = mask;

        jQuery(this._textEl).mask(mask);
    },

    getMask: function() {
        return this.mask;
    },

    getAttrs: function(el) {
        var attrs = mini.InputMask.superclass.getAttrs.call(this, el);
        mini._ParseString(el, attrs, ['mask']);

        return attrs;
    }

});

mini.regClass(mini.InputMask, 'inputmask');
mini.JsonEditor = function() {
    mini.JsonEditor.superclass.constructor.call(this);
};
mini.extend(mini.JsonEditor, mini.Control, {
    uiCls: 'mini-jsoneditor',
    width: 400,
    height: 400,
    options: {
        // 配置参考 xxxxs://github.com/josdejong/jsoneditor/blob/master/docs/api.md
        // escapeUnicode: false,
        // sortObjectKeys: false,
        // limitDragging: true,
        // history: true,
        mode: 'tree',
        modes: [],
        // schema: {},
        // schemaRefs: {},
        search: false,
        indentation: 2,
        // templates: {},
        // autocomplete: {...},
        // mainMenuBar: true,
        // navigationBar: true,
        // statusBar: true,
        colorPicker: false,
        timestampTag: false,
        enableSort: false,
        enableTransform: false,
        // maxVisibleChilds: 100,
        enableTrace: false,
        traceIdSeparator: '###',
        showTraceId: false
    },
    value: {},
    
    _create: function() {
        var self = this;

        this.options = jQuery.extend(true, {}, this.options);

        this.el = document.createElement('div');
        
        this.externalSrc = this.externalSrc || mini.externalSrc;
        if (window.JSONEditor) {
            this._init();
        } else {
            mini.loadCSS(this.externalSrc + 'jsoneditor/jsoneditor.min.css');
            mini.loadJSWithAMD(this.externalSrc + 'jsoneditor/jsoneditor.min.js', 'JSONEditor', function() {
                self._init();
            });
        }
    },
    _init: function() {
        // 事件只能在 new 的时候绑定
        this._bindEvents();
        this.editor = new JSONEditor(this.el, this.options);
        this.editor.set(this.value);
        this.value = this.editor.get();
    },
    _bindEvents: function () {
        this.options.onChange = this.__onChange.bind(this);
        this.options.onModeChange = this.__onModeChanged.bind(this);
    },
    __onChange: function() {
        this.__onTextChanged();
        this.__onValueChanged();
    },
    __onValueChanged: function() {
        // 格式不正确时不触发 valuechanged;
        try {
            this.value = this.editor.get();
            this.fire('valuechanged', { value: this.value });
        } catch (error) {
            return;
        }
    },
    __onTextChanged: function() {
        // 格式不正确时也触发
        this.fire('textchanged', { text: this.editor.getText()});
    },
    __onModeChanged: function(newMode, oldMode) {
        this.options.mode = newMode;
        this.fire('modechanged', { newMode: newMode, oldMode: oldMode });
    },
    _reNew: function() {
        // 一些配置只能通过重新创建设置
        if (this.editor) {
            var self = this;
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(function() {
                if (self.editor.destroy) {
                    self.editor.destroy();
                }
                try {
                    self.editor = new JSONEditor(self.el, self.options);
                    self.editor.set(self.value);
                } catch (error) {
                    console.error(error);
                    // 清空创建失败的编辑器 dom
                    while (self.el.firstChild) {
                        self.el.removeChild(self.el.lastChild);
                    }
                }
            }, 17);
        }
    },
    setValue: function(value) {
        if (typeof value === 'string') {
            value = JSON.parse(value);
        }
        this.value = value;
        if (this.editor) {
            this.editor.set(this.value);
            this.value = this.editor.get();
        }
    },
    getValue: function() {
        return this.editor.get();
    },
    setWidth: function(v) {
        this.width = v;
        jQuery(this.el).css('width', v);
    },
    getWidth: function() {
        return this.width;
    },
    setHeight: function(v) {
        this.height = v;
        jQuery(this.el).css('height', v);
    },
    getHeight: function() {
        return this.height;
    },
    setMode: function(mode) {
        this.options.mode = mode; // TODO: 
        if (this.editor) {
            this.editor.setMode(mode);
        }
    },
    getMode: function() {
        return this.options.mode;  
    },
    setModes: function(modes) {
        if (modes) {
            this.options.modes = modes.split(',');
        } else {
            this.options.modes = [];
        }
        this._reNew();
    },
    getModes: function() {
        return this.options.modes.join(',');
    },
    setSearch: function(search) {
        this.options.search = search;
        this._reNew();
    },
    getSearch: function() {
        return this.options.search;
    },
    setIndentation: function(indentation) {
        this.options.indentation = indentation;
        this._reNew();
    },
    getIndentation: function() {
        return this.options.indentation;
    },
    setEnableTrace: function(enableTrace) {
        this.options.enableTrace = enableTrace;
        this._reNew();
    },
    getEnableTrace: function() {
        return this.options.enableTrace;
    },
    setTraceIdSeparator: function(separator) {
        this.options.traceIdSeparator = separator;
        this._reNew();
    },
    getTraceIdSeparator: function() {
        return this.options.traceIdSeparator;
    },
    setShowTraceId: function(show) {
        this.options.showTraceId = show;
        this._reNew();
    },
    getShowTraceId: function() {
        return this.options.showTraceId;
    },
    getAttrs: function(el) {
        var attrs = mini.JsonEditor.superclass.getAttrs.call(this, el);
        mini._ParseString(el, attrs,
            ['onvaluechanged', 'ontextchanged', 'onmodechanged', 'mode', 'modes', 'value',
            'traceIdSeparator']
        );
        mini._ParseInt(el, attrs, ['width', 'height', 'indentation']);
        mini._ParseBool(el, attrs, ['search', 'enableTrace', 'showTraceId']);
        return attrs;
    }
});
mini.regClass(mini.JsonEditor, 'jsoneditor');

mini.LargeFileUploader = function() {
    mini.LargeFileUploader.superclass.constructor.call(this);
};
mini.extend(mini.LargeFileUploader, mini.Control, {
    mapClass: 'com.epoint.basic.faces.fileupload.NTKOUploader',

    uiCls: 'mini-largefileuploader',
    showDefaultUI: true,

    // 初始化时服务端返回过来的文件数量
    serverFileNum: 0,

    fileSizeLimit: (window.EpFrameSysParams && EpFrameSysParams.file_limit_size) || 0,

    fileSingleSizeLimit: (window.EpFrameSysParams && EpFrameSysParams.file_single_limit_size) || 0,
    // 允许的文件后缀，不带点，多个用逗号分割
    limitType: (window.EpFrameSysParams && EpFrameSysParams.file_limit_type) || '',

    chunkSize: (window.EpFrameSysParams && EpFrameSysParams.ntko_file_slice_limit_size) || 5120 * 1024,

    needChunkLocal: false,
    uploadUrl: '',
    fileNumLimit: 1,
    // 是否多选，根fileNumLimit的值相关联
    multiSelect: false,

    auto: true,

    // 第三方资源的路径，默认为全局配置mini.externalSrc的值
    externalSrc: '',
    pickerText: epoint_local.LargeFileUploader.pickerText,
    startText: epoint_local.LargeFileUploader.startText,
    pauseText: epoint_local.LargeFileUploader.pauseText,
    numLimitErrorText: epoint_local.LargeFileUploader.numLimitErrorText,
    sizeLimitErrorText: epoint_local.LargeFileUploader.sizeLimitErrorText,
    typeDeniedErrorText: epoint_local.LargeFileUploader.typeDeniedErrorText,
    sizeErrorText: epoint_local.LargeFileUploader.sizeErrorText,
    emptyFileErrorText: epoint_local.LargeFileUploader.emptyFileErrorText,
    epointUserText: epoint_local.LargeFileUploader.epointUserText,
    ntkoLoadErrorText: epoint_local.LargeFileUploader.ntkoLoadErrorText,
    deleteFileConfirmText: epoint_local.LargeFileUploader.deleteFileConfirmText,
    systemTipText: epoint_local.LargeFileUploader.systemTipText,
    ntkoInitErrorTitle: epoint_local.LargeFileUploader.ntkoInitErrorTitle,
    ntkoInitErrorText: epoint_local.LargeFileUploader.ntkoInitErrorText,
    ntkoErrorCheckBrowserText: epoint_local.LargeFileUploader.ntkoErrorCheckBrowserText,
    analyzingText: epoint_local.LargeFileUploader.analyzingText,
    uploadedText: epoint_local.LargeFileUploader.uploadedText,
    uploadFailedText: epoint_local.LargeFileUploader.uploadFailedText,
    uploadErrorText: epoint_local.LargeFileUploader.uploadErrorText,

    set: function(kv) {
        if (typeof kv === 'string') {
            return this;
        }

        var pickerText = kv.pickerText;
        delete kv.pickerText;

        // 9.3 服务化后需要该属性来控制附件是否落地
        // 该属性需要在每次请求中都传递回后端
        // 由于获取文件状态和上传完成这两个请求无法加额外参数，只能把它加到url上
        var needChunkLocal = kv.needChunkLocal;
        delete kv.needChunkLocal;

        // 必须先设置needChunkLocal
        // 因为之后框架的action以及uploadUrl都是依赖needChunkLocal
        if (needChunkLocal) {
            this.needChunkLocal = needChunkLocal;
        }

        mini.LargeFileUploader.superclass.set.call(this, kv);

        if (pickerText) {
            this._picker.innerHTML = pickerText;
        }
        return this;
    },
    _create: function() {
        this.el = document.createElement('div');
        this.el.innerHTML =
            '<div class="mini-uploader-btns"><div class="mini-ntko-pick">' +
            this.pickerText +
            '</div></div><div class="mini-uploader-list"></div><div class="mini-ntko"></div>';

        this._buttons = this.el.firstChild;
        this._fileList = this.el.children[1];
        this._ntkoContent = this.el.lastChild;

        this._picker = this._buttons.firstChild;

        this._uploadBtn = new mini.Button();
        this._uploadBtn.setText(this.startText);
        this._uploadBtn.render(this._buttons);

        this._ntkoContent.innerHTML =
            '<object id="' +
            this.uid +
            '-ntko" classid="clsid:882C96AC-B79E-4f50-A7A6-6E5E42431A05" codebase="' +
            (this.externalSrc || mini.externalSrc) +
            'ntkoLFUploader/NtkoLFUploader.cab#version=6,1,1,8"><PARAM NAME="FileBlockSize" VALUE="' +
            this.chunkSize +
            '"><PARAM NAME="BackColor" VALUE="16744576"><PARAM NAME="ForeColor" VALUE="16777215"><PARAM NAME="IsUseUTF8Data" VALUE="true"><param name="ProductCaption" value="' +
            (window.NTKO_ProductCaption || '国泰新点用户') +
            '"><param name="ProductKey" value="' +
            (window.NTKO_ProductKey || '3CF3019EA6883730AB34F0D5A8FACDB1CDB2A9EA') +
            '"><PARAM NAME="MakerCaption" VALUE="' +
            (window.NTKO_MakerCaption || '江苏国泰新点软件有限公司') +
            '"><PARAM NAME="MakerKey" VALUE="' +
            (window.NTKO_MakerKey || '39337AFCA7AFD1F882A3BF53CBE1E4AC804C65A6') +
            '"><span style="color: red;">' + this.ntkoLoadErrorText + '.</span></object>';
        this._ntko = this._ntkoContent.firstChild;

        this._errorContent = '';
    },

    _initEvents: function() {
        mini._BindEvents(function() {
            mini_onOne(this._picker, 'click', this.__OnPickerClick, this);
        }, this);

        var that = this,
            ntko = this._ntko;

        // 绑定上传按钮的点击事件
        this._uploadBtn.on('click', function() {
            if (ntko.IsUploading) {
                that.stopUpload();
                that._uploadBtn.setText(that.pauseText);
            } else {
                that.beginUpload();
                that._uploadBtn.setText(that.startText);
            }
        });

        if (this.auto) {
            this._uploadBtn.hide();
        }

        //
        if (ntko.attachEvent) {
            ntko.attachEvent('BeforeFileAdded', function(filePath, fileName, fileSize) {
                ntko.CancelLastCommand = !that._beforeFileQueued(filePath, fileName, fileSize);
            });
            ntko.attachEvent('OnLocalFileAdded', function(filePath, fileName, fileSize) {
                that._onFilesQueued(filePath, fileName, fileSize);
            });
            ntko.attachEvent('OnFileProcessStatusChange', function(file, statusText, isPersent, persentNumber) {
                that._onUploadProgress(file, statusText, isPersent, persentNumber);
            });
            ntko.attachEvent('OnOneFileUploadFinished', function(file, isAllUploaded) {
                that._onFileFinished(file, isAllUploaded);
            });
            ntko.attachEvent('OnSaveToURLFinished', function(isAllSuccess) {
                that._onUploadFinished(isAllSuccess);
            });
        } else {
            var id = this.uid + '-ntko',
                lfu = 'var lfu = mini.getbyUID("' + this.uid + '");',
                text = lfu + 'lfu._ntko.CancelLastCommand = !lfu._beforeFileQueued(filePath, fileName, fileSize);';

            addEvent({
                target: id,
                event: 'BeforeFileAdded(filePath, fileName, fileSize)',
                text: text
            });

            text = lfu + 'lfu._onFilesQueued(filePath, fileName, fileSize);';
            addEvent({
                target: id,
                event: 'OnLocalFileAdded(filePath, fileName, fileSize)',
                text: text
            });

            text = lfu + 'lfu._onUploadProgress(file, statusText, isPersent, persentNumber);';
            addEvent({
                target: id,
                event: 'OnFileProcessStatusChange(file, statusText, isPersent, persentNumber)',
                text: text
            });

            text = lfu + 'lfu._onFileFinished(file, isAllUploaded);';
            addEvent({
                target: id,
                event: 'OnOneFileUploadFinished(file, isAllUploaded)',
                text: text
            });

            text = lfu + 'lfu._onUploadFinished(isAllSuccess);';
            addEvent({
                target: id,
                event: 'OnSaveToURLFinished(isAllSuccess)',
                text: text
            });
        }

        function addEvent(opt) {
            var script = document.createElement('script');
            script.language = 'JScript';
            script.setAttribute('for', opt.target);
            script.event = opt.event;
            script.text = opt.text;
            document.body.appendChild(script);
        }
        if (this.showDefaultUI) {
            jQuery(this._fileList).on('click', '.mini-uploader-remove', function() {
                var $this = jQuery(this),
                    fileId = $this.attr('fileId'),
                    // $item = $this.closest('.mini-uploader-item'),
                    fileGuid = $this.attr('fileGuid');

                mini.confirm(that.deleteFileConfirmText, that.systemTipText, function(action) {
                    if (action == 'ok') {
                        // 两值相等，则表示是初始化时后台给的文件，不在文件列表中，不需要从文件列表中删除
                        if (fileId != fileGuid) {
                            that.removeFile(fileId);
                        } else {
                            jQuery(that._fileList)
                                .find('#' + fileId)
                                .remove();
                            that.serverFileNum--;
                        }

                        // 有fileGuid则表示改文件已上传成功了，需要发ajax告诉服务端文件已删除
                        if (fileGuid) {
                            var data = {
                                commonDto: mini.encode(that.getCommonData())
                            };

                            if (this.cmdParams) {
                                data.cmdParams = this.cmdParams;
                            }
                            data[that.id + '_action'] = 'delete';
                            data[that.id + '_attachGuid'] = fileGuid;

                            // 添加事件删除请求前事件，方便外部个性化请求数据
                            var event = {
                                sender: that,
                                eventType: 'beforefileremove',
                                fileGuid: fileGuid,
                                data: data
                            };
                            that.fire('beforefileremove', event);

                            // 此处不能用Util.ajax
                            // 原因是回调中需要拿到后端返回的控件数据，而Util.ajax是会过滤掉控件数据的
                            var xhr = $.ajax({
                                url: that.uploadUrl,
                                data: event.data,
                                dataType: 'json',
                                type: 'post'
                            });

                            xhr.done(function(data) {
                                data = mini.getSecondRequestData(data);
                                that.fire('fileremovesuccess', {
                                    sender: that,
                                    eventType: 'fileremovesuccess',
                                    fileGuid: fileGuid,
                                    data: data
                                });
                            });
                        }
                    }
                });
            });
        }
    },

    _afterApply: function() {
        // 说明没有初始化成功
        if (this._ntko.StatusCode === undefined) {
            this._buttons.innerHTML =
                '<a class="noflash" title="' + this.ntkoInitErrorTitle + '">' + this.ntkoInitErrorText + '</a>';
            mini.showPageWarning({
                html: this.ntkoErrorCheckBrowserText
            });
        }
    },
    __OnPickerClick: function() {
        var ntko = this._ntko;
        try {
            ntko.AddLocalFile('', this.multiSelect, this._ntkoFileType);
            if (this.auto) {
                this.beginUpload();
            }
        } catch (error) {
            if (ntko.StatusCode == 10) {
                window.console && console.log('用户取消操作');
            } else {
                window.console && console.error('error：' + error.number + ':' + error.description);
            }
        }
    },
    _blocksFileField: 'NTKO_LF_BLOCK',
    beginUpload: function() {
        if (this._onStartUpload()) {
            var ntko = this._ntko;
            ntko.QueryFileStatusURL = this._ntkoQueryFileStatusURL;
            // 上传前就需要把重放攻击的标识带上，来应对秒传的情况
            ntko.FinishedUploadURL = this._ntkoFinishedUploadURL + this.getReAttackParm(this._ntkoFinishedUploadURL);

            var data = {
                data: {}
            };
            this._onUploadBeforeSend(data);

            ntko.BeginSaveToURL(this.uploadUrl + '&query=upload', this._blocksFileField, parseData(data.data));
        }

        function parseData(data) {
            var r = [];
            for (var i in data) {
                r.push(i + '=' + data[i]);
            }

            return r.join('&');
        }
    },

    stopUpload: function() {
        this._ntko.StopSaveToURL();
        this._onStopUpload();
    },

    reset: function() {
        this._ntko.Reset();
        this._onReset();
    },

    removeFile: function(fileId) {
        var ntko = this._ntko,
            index = this._getFileIndex(fileId),
            file;

        if (index > -1) {
            file = ntko.GetFile(index);
            ntko.RemoveFile(index);

            this._fileIds[file.FilePath] = undefined;
            delete this._fileIds[file.FilePath];
            this._onFileDequeued(file);
        }

        if (this.showDefaultUI) {
            var $item = jQuery(this._fileList).find('#' + fileId);

            if ($item.length) {
                $item.remove();
            }
        }
    },
    clearFile: function() {
        for (var i in this._fileIds) {
            this.removeFile(this._fileIds[i].id);
        }
        if (this.showDefaultUI) {
            jQuery(this._fileList).empty();
        }
    },
    _getFileIndex: function(fileId) {
        var index = 0;
        for (var i in this._fileIds) {
            if (this._fileIds[i].id === fileId) {
                return index;
            }
            index++;
        }
        return -1;
    },

    _ntkoFileType: '*.*',
    setLimitType: function(limitType) {
        this.limitType = limitType.toLowerCase();
        this._ntkoFileType = this._getNtkoFileType(limitType);
    },

    getLimitType: function() {
        return this.limitType;
    },
    /**
     *
     * function setAuto(auto)
     * @member mini.WebUploader
     * @param {Boolen} auto
     *
     */
    setAuto: function(auto) {
        if (this.auto != auto) {
            this.auto = auto;
            if (auto) {
                this._uploadBtn.hide();
            } else {
                this._uploadBtn.show();
            }
        }
    },
    /**
     *
     * function getAuto()
     * @member mini.WebUploader
     * @returns {Boolen}
     *
     */
    getAuto: function() {
        return this.auto;
    },
    _getNtkoFileType: function(limitType) {
        if (!limitType) {
            return '*.*';
        }

        var fileTypes = [],
            limitTypes = limitType.split(',');

        for (var i = 0, l = limitTypes.length; i < l; i++) {
            fileTypes.push('*.' + limitTypes[i]);
        }

        return fileTypes.join(';');
    },

    getFileList: function() {
        return this._fileList;
    },

    setFileNumLimit: function(fileNumLimit) {
        fileNumLimit = parseInt(fileNumLimit) || 0;

        this.fileNumLimit = fileNumLimit;

        if (fileNumLimit === 1) {
            this.multiSelect = false;
        }
    },

    getFileNumLimit: function() {
        return this.fileNumLimit;
    },

    setUploadUrl: function (uploadUrl) {
        var urlQuery = window.location.search.substring(1);
        var urldata = {};


        urldata.type = 'ntko';

        if (urlQuery) {
            urlQuery = urlQuery.split('&');
            for (var i = 0, len = urlQuery.length; i < len; i++) {
                var param = urlQuery[i].split('=');
                if (param[0]) {
                    urldata[param[0]] = param[1];
                }
            }
        }

        if (this.needChunkLocal) {
            urldata.needChunkLocal = 1;
        }
        uploadUrl = Util.addUrlParams(uploadUrl, urldata, 'ignore', false);

        this.uploadUrl = uploadUrl;

        this._ntkoQueryFileStatusURL = Util.addUrlParams(uploadUrl, { query: 'getStatus' }, 'ignore', false);
        this._ntkoFinishedUploadURL = Util.addUrlParams(uploadUrl, { query: 'finished' }, 'ignore', false);
    },
    getUploadUrl: function() {
        return this.uploadUrl;
    },
    /**
     *
     * function setFileSingleSizeLimit(fileSingleSizeLimit)
     * @member mini.WebUploader
     * @param {int} fileSingleSizeLimit
     *
     */
    setFileSingleSizeLimit: function(fileSingleSizeLimit) {
        this.fileSingleSizeLimit = fileSingleSizeLimit;
    },
    /**
     *
     * function getFileSingleSizeLimit()
     * @member mini.WebUploader
     * @returns {int}
     *
     */
    getFileSingleSizeLimit: function() {
        return this.fileSingleSizeLimit;
    },

    _validateFile: function(file) {
        var filesCount = this._ntko.FilesCount;
        if (this.fileNumLimit && filesCount >= this.fileNumLimit - this.serverFileNum) {
            this._errorContent = String.format(this.numLimitErrorText, this.fileNumLimit);

            return false;
        }

        if (this.fileSingleSizeLimit && file.size > this.fileSingleSizeLimit * 1024) {
            this._errorContent = String.format(this.sizeErrorText, this.fileSingleSizeLimit);

            return false;
        }

        if (file.size === 0) {
            this._errorContent = this.emptyFileErrorText;

            return false;
        }

        if (this.limitType && (',' + this.limitType + ',').indexOf(',' + file.ext.toLowerCase() + ',') == -1) {
            this._errorContent = String.format(this.typeDeniedErrorText, this.limitType);

            return false;
        }

        return true;
    },

    _parseAttachFile: function(attachFile) {
        var file = {
            path: attachFile.FilePath,
            name: attachFile.FileName,
            size: attachFile.FileSize,
            md5: attachFile.MD5ID
        };
        file.ext = file.name.substr(file.name.lastIndexOf('.') + 1);
        file.id = this._fileIds[file.path].id;

        return file;
    },

    // 当文件被加入队列之前触发，此事件的handler返回值为false，则此文件不会被添加进入队列。
    _beforeFileQueued: function(filePath, fileName, fileSize) {
        var file = {
            path: filePath,
            name: fileName,
            size: fileSize,
            ext: fileName.substr(fileName.lastIndexOf('.') + 1)
        };

        if (this._events.beforefilequeued) {
            var event = {
                source: this,
                sender: this,
                type: 'beforefilequeued',
                file: file,
                cancel: false
            };

            this.fire('beforefilequeued', event);

            if (event.cancel) {
                return false;
            }
        }

        if (this._validateFile(file)) {
            return true;
        }
        if (this._errorContent) {
            mini.alert(this._errorContent);
        }
        this._errorContent = '';
        return false;
    },

    _fileIds: {},
    // 当有文件添加进来的时候
    _onFilesQueued: function(filePath, fileName, fileSize) {
        var file = {
            path: filePath,
            name: fileName,
            size: fileSize,
            ext: fileName.substr(fileName.lastIndexOf('.') + 1),
            id: mini.UUID()
        };

        this._fileIds[file.path] = {
            id: file.id
        };

        if (this.showDefaultUI) {
            var item = this._generateFileList({
                id: file.id,
                name: file.name,
                size: file.size,
                date: mini.formatDate(new Date(), 'yyyy-MM-dd')
            });
            jQuery(this._fileList).append(item);
        }
        if (this._events.filesqueued) {
            this.fire('filesqueued', {
                files: [file]
            });
        }
    },

    _generateFileList: function(options) {
        options.fileGuid = options.fileGuid || '';
        if (options.downloadUrl) {
            // options.downloadUrl = _rootPath + '/' + options.downloadUrl + '?attachGuid=' + options.fileGuid;
            // 根路径 + 返回路径带attachGuid
            // 根路径 + 返回路径不带attachGuid 则判断是否带？ 是则拼接&guid 否则？guid
            options.downloadUrl =
                _rootPath +
                '/' +
                (options.downloadUrl.indexOf('attachGuid') != -1
                    ? // 已经有attachGuid了 就不处理
                      options.downloadUrl
                    : // 没有attachGuid 根据是否有？ 拼接上 '&' 或 '?' + 'attachGuid=' + options.fileGuid
                      options.downloadUrl +
                      (options.downloadUrl.indexOf('?') != -1 ? '&' : '?') +
                      'attachGuid=' +
                      options.fileGuid);
        } else {
            options.downloadUrl = 'javascript:void(0)';
        }

        var list = [];
        list.push(
            '<div id="' + options.id + '" class="mini-uploader-item' + (options.success ? ' success' : '') + '">'
        );
        list.push('<a href="' + options.downloadUrl + '" class="mini-uploader-info">' + options.name + '</a>');
        list.push(
            '<span class="mini-uploader-size">(' +
                this._getSize(options.size) +
                (options.date ? '/' + options.date : '') +
                ')</span>'
        );
        list.push('<span class="mini-uploader-error"></span>');
        list.push(
            '<span class="mini-uploader-progressbar" style="display: none;"><span class="progress-text">0%</span><div class="progress-body"></div></span>'
        );
        if (!options.hideDelete) {
            list.push(
                '<a href="javascript:void(0)" class="mini-uploader-remove" fileId="' +
                    options.id +
                    '" fileGuid="' +
                    options.fileGuid +
                    '">' + epoint_local.delete_text + '</a>'
            );
        }
        list.push('</div>');

        return list.join('');
    },
    _needPostData: true,
    // 当文件被移除队列后触发
    _onFileDequeued: function(file) {
        this.fire('filedequeued', {
            file: file
        });
    },
    // 当某个文件的分块在发送前触发，主要用来询问是否要添加附带参数，大文件在开起分片上传的前提下此事件可能会触发多次
    _onUploadBeforeSend: function(data) {
        data = data.data;
        data.commonDto = mini.encode(this.getCommonData());

        if (this.cmdParams) {
            data.cmdParams = this.cmdParams;
        }
        // 带上页面地址中的参数
        var query = window.location.search.substring(1).split('&');
        var param;
        for (var i = 0, len = query.length; i < len; i++) {
            param = query[i].split('=');
            if (param[0]) {
                data[param[0]] = param[1];
            }
        }

        var event = {
            sender: this,
            data: data
        };

        this.fire('uploadbeforesend', event);

        data.replaynoticeid = event.data.replaynoticeid;
        data.reqtime = event.data.reqtime;
        data.paramsign = event.data.paramsign;
        data.dtosign = event.data.dtosign;
    },
    // 文件上传过程中触发。
    _onUploadProgress: function(file, statusText, isPersent, persentNumber) {
        file = this._parseAttachFile(file);

        var isUploading = false;
        var li = mini.byId(file.id),
            $progressbar = jQuery('.mini-uploader-progressbar', li),
            $progresstext = jQuery('.progress-text', $progressbar),
            $progressbody = jQuery('.progress-body', $progressbar),
            width;
        if (isPersent) {
            if (!isUploading && statusText.indexOf('正在分析文件') === 0) {
                if (this.showDefaultUI) {
                    width = Math.round(persentNumber) + '%';

                    $progresstext.text(this.analyzingText);
                    $progressbody.width(width);
                }

                this.fire('md5progress', {
                    file: file,
                    percentage: persentNumber / 100
                });

                if (persentNumber == 100) {
                    isUploading = true;
                }
            } else {
                if (this.showDefaultUI) {
                    width = Math.round(persentNumber) + '%';

                    $progresstext.text(this.uploadedText + ':' + width);
                    $progressbody.width(width);
                }
                // 重放攻击要求 finished 请求要带上隐藏域
                // this._ntko.FinishedUploadURL = this._ntkoFinishedUploadURL +  this.getReAttackParm();
                this.fire('uploadprogress', {
                    file: file,
                    percentage: persentNumber / 100
                });
            }
        } else if (!this._fileIds[file.path].started) {
            if (this.showDefaultUI) {
                $progressbar.show();
            }

            this.fire('uploadstart', {
                file: file
            });

            this._fileIds[file.path].started = true;
        }
    },

    _onFileFinished: function(file, isAllUploaded) {
        file = this._parseAttachFile(file);
        if (isAllUploaded) {
            this._onUploadSuccess(file);
        } else {
            this._onUploadError(file, this._parseNtkoRet(this._ntko.LastFinishedUploadRetMes));
        }

        this._onUploadComplete(file);
    },
    _onUploadSuccess: function(file) {
        var ret = this._parseNtkoRet(this._ntko.LastFinishedUploadRetMes);
        if (ret.uploadFailed) {
            mini.alert(ret.failedMsg || this.uploadFailedText);
            this.removeFile(file.id);

            return;
        }

        this.fire('uploadaccept', {
            ret: ret,
            object: {
                file: file
            }
        });

        if (this.showDefaultUI) {
            var $item = jQuery('#' + file.id);
            var fileGuid = ret.attachGuid,
                downloadUrl = ret.downloadUrl;

            if (downloadUrl) {
                downloadUrl = decodeURIComponent(downloadUrl);
                downloadUrl =
                    _rootPath +
                    '/' +
                    (downloadUrl.indexOf('attachGuid') != -1
                        ? // 已经有attachGuid了 就不处理
                          downloadUrl
                        : // 没有attachGuid 根据是否有？ 拼接上 '&' 或 '?' + 'attachGuid=' + fileGuid
                          downloadUrl + (downloadUrl.indexOf('?') != -1 ? '&' : '?') + 'attachGuid=' + fileGuid);
            }

            $item.addClass('success');
            $item
                .find('.mini-uploader-error')
                .html('')
                .hide();

            if (fileGuid) {
                $item.find('.mini-uploader-remove').attr('fileGuid', fileGuid);
                if (downloadUrl) {
                    $item.find('.mini-uploader-info').attr('href', downloadUrl);
                }
            }
        }
        this.fire('uploadsuccess', {
            file: file
        });
    },
    _onUploadError: function(file, reason) {
        if (this.showDefaultUI) {
            jQuery('#' + file.id)
                .find('.mini-uploader-error')
                .html(this.uploadErrorText)
                .show();
        }

        this.fire('uploaderror', {
            file: file,
            reason: reason
        });
    },
    _onUploadComplete: function(file) {
        if (this.showDefaultUI) {
            jQuery('#' + file.id)
                .find('.mini-uploader-progressbar')
                .fadeOut();
        }

        this.fire('uploadcomplete', {
            file: file
        });
    },
    _getSize: function(size) {
        var K = 1024,
            M = 1048576;
        size = parseInt(size);

        if (size > M) {
            return (size / M).toFixed(2) + 'M';
        }
        return (size / K).toFixed(2) + 'K';
    },
    getCommonData: function() {
        if (!this.controlData) {
            this.controlData = {
                id: this.id,
                type: 'largeFileUploader',
                mapClass: this.mapClass,
                action: this.action,
                showDefaultUI: this.showDefaultUI,
                needChunkLocal: this.needChunkLocal,
                dataOptions: this['data-options']
            };
        }
        return [this.controlData, this.getViewdata()];
    },

    getViewdata: function() {
        var hidden = mini.get('_common_hidden_viewdata'),
            val,
            cmdParams;

        if (!this.viewData) {
            this.viewData = {
                id: '_common_hidden_viewdata',
                type: 'hidden',
                value: ''
            };
        }
        if (hidden) {
            val = mini.decode(hidden.getValue());
            if (val.pageUrl) {
                val.pageUrl = val.pageUrl.substr(0, val.pageUrl.indexOf('?'));
            }
            if (val.cmdParams) {
                cmdParams = mini.decode(val.cmdParams);
                if (cmdParams.pageUrl) {
                    cmdParams.pageUrl = cmdParams.pageUrl.substr(0, cmdParams.pageUrl.indexOf('?'));
                }

                val.cmdParams = mini.encode(cmdParams);
            }
            this.viewData.value = mini.encode(val);
        }

        return this.viewData;
    },
    getReAttackParm: function(url) {
        var param = '',
            viewData = mini.decode(this.getViewdata().value);
        param += viewData.replayAttack ? '&replayAttack=' + viewData.replayAttack : '';
        param += viewData.pageurl ? '&pageurl=' + viewData.pageurl : '';

        if (window.Util && Util.addReplayAttackData) {
            // var data = Util.addReplayAttackData({});
            // param += data.uid ? ('&uid=' + data.uid) : '';
            // param += data.sign ? ('&sign=' + data.sign) : '';
            var data = Util.addReplayAttackData({}, url + param);

            param += data.replaynoticeid ? '&replaynoticeid=' + data.replaynoticeid : '';
            param += data.reqtime ? '&reqtime=' + data.reqtime : '';
            param += data.paramsign ? '&paramsign=' + data.paramsign : '';
            param += data.dtosign ? '&dtosign=' + data.dtosign : '';
        }

        return param;
    },
    setShowDefaultUI: function(showDefaultUI) {
        this.showDefaultUI = showDefaultUI;
        if (this.controlData) {
            this.controlData.showDefaultUI = showDefaultUI;
        }
    },
    setPostData: function(postData) {
        this.postData = postData;
    },
    getPostData: function() {
        return this.postData;
    },
    // 当开始上传流程时触发
    _onStartUpload: function() {
        if (this.postData && this._needPostData) {
            var me = this;
            var data = {
                commonDto: mini.encode(this.getCommonData())
            };
            if (this.cmdParams) {
                data.cmdParams = this.cmdParams;
            }
            data[this.id + '_incache'] = true;
            data[this.id + '_postData'] = this.postData;
            data[this.id + '_fileCount'] = this._uploader.getFiles().length;
            data[this.id + '_fileLoadedCount'] = this._uploader.getStats().successNum;

            var xhr = Util.ajax({
                url: this.uploadUrl,
                data: data,
                dataType: 'json'
            });

            xhr.done(function(data) {
                me._needPostData = false;
                me.beginUpload();
            });

            return false;
        }
        if (this._events.startupload) {
            var event = {
                source: this,
                sender: this,
                type: 'startupload',
                cancel: false
            };

            this.fire('startupload', event);

            if (event.cancel) {
                return false;
            }
        }

        return true;
    },
    // 当上传流程暂停时触发
    _onStopUpload: function() {
        this.fire('stopupload');
    },
    // 当所有文件上传结束时触发
    _onUploadFinished: function(isAllSuccess) {
        this._uploadBtn.setText(this.startText);
        this._needPostData = true;
        this.fire('uploadfinished', {
            isAllSuccess: isAllSuccess
        });
    },
    // 当 uploader 被重置的时候触发
    _onReset: function() {
        this._fileIds = {};
        this.fire('reset');
    },

    _parseNtkoRet: function(ret) {
        var params = {},
            arr = ret.split('&');

        $.each(arr, function(i, item) {
            var tmp = item.split('='),
                key = tmp[0],
                val = tmp[1];

            if (typeof params[key] === 'undefined') {
                params[key] = val;
            } else if (typeof params[key] === 'string') {
                params[key] = [params[key], val];
            } else {
                params[key].push(val);
            }
        });

        return params;
    },
    setAction: function(action) {
        this.action = action;

        this.controlData = {
            id: this.id,
            type: 'largeFileUploader',
            mapClass: this.mapClass,
            action: this.action,
            showDefaultUI: this.showDefaultUI,
            dataOptions: this['data-options']
        };

        var arr = action.split('.');
        if(arr.length < 2) return;
        var url = Util.getRightUrl('/rest/' + arr[0] + '/' + arr[1] + '?isCommondto=true');

        // 对于action配置为“xxxaction(aaa,bbb)”这种形式的，安全拦截中不允许url上出现“()”，所以需要将“()”里的内容拿下来，放到cmdParams里
        var reg = /\([\w\W]*\)/,
            match = url.match(reg);
        if (match) {
            url = url.replace(reg, '');

            this.cmdParams = match[0].replace('(', '[').replace(')', ']');
        }

        var urlParams = Util.getUrlParams();
        delete urlParams['@epoint_user_loginid'];

        url = Util.addUrlParams(url, urlParams, 'ignore', false);
        this.setUploadUrl(url);
    },
    setData: function(data) {
        // 兼容添加密级功能后的数据格式
        data = data.files || data;
        this.serverFileNum = data.length;

        if (this.showDefaultUI) {
            var item = '',
                html = [];
            // 向文件列表中添加记录
            for (var i = 0, len = data.length; i < len; i++, item = []) {
                item = this._generateFileList({
                    id: data[i].attachGuid,
                    name: data[i].attachFileName,
                    size: data[i].attachLength,
                    date: data[i].uploadDateTime,
                    fileGuid: data[i].attachGuid,
                    downloadUrl: data[i].downloadUrl,
                    hideDelete: data[i].readonly,
                    success: true
                });

                html.push(item);
            }
            jQuery(this._fileList).html(html.join(''));
        }

        this.fire('load', {
            sender: this,
            eventType: 'load',
            data: data
        });
    },

    getAttrs: function(el) {
        var attrs = mini.LargeFileUploader.superclass.getAttrs.call(this, el);
        attrs.text = el.innerHTML;
        mini._ParseString(el, attrs, [
            'uploadUrl',
            'limitType',
            'postData',
            'pickerText',
            'onbeforefilequeued',
            'onfilesqueued',
            'onreset',
            'onstartupload',
            'onstopupload',
            'onuploadfinished',
            'onuploadstart',
            'onuploadbeforesend',
            'onuploadaccept',
            'onuploadprogress',
            'onmd5progress',
            'onuploadsuccess',
            'onuploaderror',
            'onuploadcomplete',
            'onfileremovesuccess',
            'onload'
        ]);
        mini._ParseBool(el, attrs, ['auto', 'multiSelect', 'showDefaultUI', 'needChunkLocal']);
        mini._ParseInt(el, attrs, ['fileNumLimit', 'fileSingleSizeLimit']);

        return attrs;
    }
});

mini.regClass(mini.LargeFileUploader, 'largefileuploader');

mini.MonacoEditor = function() {
    mini.MonacoEditor.superclass.constructor.call(this);
    this.options = {};
    this._currentOptions = {};
};
mini.MonacoEditor.__LOADER_ID = 'monaco-editor-loader';
mini.MonacoEditor.__LOADER_CONDIG_ID = 'monaco-loader-config';
// 思路： loader 同步。
// 然后LoadJs方法做调整， 存在 require 时 loaderJs 方法变为require方法加载资源
mini.MonacoEditor.MONACO_PATH = mini.externalSrc + 'monaco-editor';
mini.MonacoEditor.loadMonaco = function loadMonaco() {
    if (window.__MONACO_PROMISE__) {
        return window.__MONACO_PROMISE__;
    }
    var scriptStr = '\
        require.config({\
            paths: {\
                "vs": "${MONACO_PATH}/vs"\
            },\
            "vs/nls" : {\
                availableLanguages: {"*": "zh-cn"}\
            }\
        });\
        require(["vs/editor/editor.main"], function () {\
          window.__monaco_editor__ = monaco;\
        });'.replace(
        /\${MONACO_PATH}/,
        mini.MonacoEditor.MONACO_PATH
    );
    var head = document.getElementsByTagName('head')[0];
    // loader 加载
    if (!$('#' + mini.MonacoEditor.__LOADER_ID).length) {
        var loaderScript = document.createElement('script');
        loaderScript.id = mini.MonacoEditor.__LOADER_ID;
        loaderScript.type = 'text/javascript';
        loaderScript.text = mini.loadText(mini.MonacoEditor.MONACO_PATH + '/vs/loader.js');
        head.appendChild(loaderScript);
    }
    // monaco 加载
    if (!$('#' + mini.MonacoEditor.__LOADER_CONDIG_ID).length) {
        var editorScript = document.createElement('script');
        editorScript.id = mini.MonacoEditor.__LOADER_CONDIG_ID;
        editorScript.text = scriptStr;
        editorScript.onerror = function() {
            console.error('monaco-editor资源加载失败');
        };
        document.body.appendChild(editorScript);
    }

    if (!mini.MonacoEditor.__LOAD_PROMISE) {
        mini.MonacoEditor.__LOAD_PROMISE = new Promise(function(resolve, reject) {
            var timer;
            var count = 0;

            function check() {
                // 已经加载则直接成功
                if (window.__monaco_editor__) {
                    clearTimeout(timer);
                    resolve(window.__monaco_editor__);
                } else {
                    // 否则继续检测 但总次数不超过1000
                    if (count++ < 1000) {
                        setTimeout(check, 30);
                    } else {
                        reject('monaco-editor资源加载失败');
                    }
                }
            }
            check();
        });
    }

    return mini.MonacoEditor.__LOAD_PROMISE;
};

mini.MonacoEditor.Runtime = function() {};

// #region 用 iframe 的方式加载编辑器的实现
mini.MonacoEditor.iframeRuntime = function() {
    $.extend(this, mini.MonacoEditor.iframeRuntime.methods);
    this._createIframe();
};
mini.MonacoEditor.iframeRuntime.methods = {
    _createIframe: function() {
        var iframe = document.createElement('iframe');
        iframe.id = this.uid + '-iframe';
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('scrolling', 'no');
        iframe.setAttribute('allowtransparency', 'true');
        iframe.setAttribute('src', mini.MonacoEditor.MONACO_PATH + '/editor.html?instanceid=' + this.uid);

        this.el.appendChild(iframe);
        this._editorIframe = iframe;
        // 等待编辑器的 iframe 及其内部资源加载完成, 会调用 onIframeReady -> _initEditor
    },
    _initEditor: function() {
        var iframe = this._editorIframe;
        var iframeWin = iframe.contentWindow;
        var iframeDoc = iframe.contentWindow.document;
        var editorEl = iframeDoc.getElementById('editor');

        if (!editorEl) {
            throw new Error('编辑器资源加载失败');
        }

        this._initOptions();
        this._loadJsTypes();

        var monaco = iframeWin.__monaco_editor__;

        this.fire('beforeCreate', {
            monaco: monaco
        });

        editorEl.value = this.value;

        this._editor = monaco.editor.create(editorEl, this._currentOptions);
        this.fire('created', {
            monaco: monaco,
            editor: this._editor
        });
        // mini.checkDepend(function () {
        //     return that.el && that.el.querySelector('.monaco-editor')
        // }).then(function () {
        //     that.fire('created', {
        //         monaco: monaco,
        //         editor: that._editor
        //     });
        // });
    },

    _loadJsTypes: function() {
        if (this.language !== 'javascript') {
            return;
        }
        var iframeWin = this._editorIframe && this._editorIframe.contentWindow;
        if (iframeWin && iframeWin.loadJsTypes) {
            iframeWin.loadJsTypes();
        }
    }
};
mini.MonacoEditor.iframeRuntime.onIframeReady = function(uid) {
    // 可能多个 iframe 编辑器 应用到对应的实例上
    var editor = mini.getbyUID(uid);
    if (editor) {
        editor._initEditor();
    }
};
// #endregion

// #region 在当前页面内加载编辑器资源的实现
mini.MonacoEditor.selfRuntime = function() {
    $.extend(this, mini.MonacoEditor.selfRuntime.methods);
    this._initEditor();
};
mini.MonacoEditor.selfRuntime.methods = {
    _initEditor: function() {
        var that = this;

        mini.MonacoEditor.loadMonaco()
            .then(function(monaco) {
                if (!mini.MonacoEditor.monaco) {
                    mini.MonacoEditor.monaco = monaco;
                }
                that._initOptions();
                that._loadJsTypes();

                that.fire('beforeCreate', {
                    monaco: monaco
                });
                that._editor = monaco.editor.create(that.el, that._currentOptions);

                // that._editor.onDidChangeModelContent(that._onDidChangeModelContent.bind(that));
                // TODO: 这边没有一个真实的初始化事件来支持 xxxxs://github.com/microsoft/monaco-editor/issues/115
                // monaco.editor.onDidCreateEditor(function (a, b, c) {
                //     console.log('onDidCreateEditor', a, b, c);
                //     that.fire('DidCreateEditor');
                // });
                // monaco.editor.onDidCreateModel(function (a, b, c) {
                //     console.log('onDidCreateModel', a, b, c);
                //     that.fire('DidCreateModel');
                // });
                // mini.checkDepend(function () {
                //     return that.el && that.el.querySelector('.monaco-editor') && that.el.querySelector('.editor-scrollable');
                // },1000, 300).then(function () {
                //     setTimeout(function () {
                //         console.log('mini created');
                //         that.fire('created', {
                //             monaco: monaco,
                //             editor: that._editor
                //         }, 1000);
                //     });
                // });

                that.fire('created', {
                    monaco: monaco,
                    editor: that._editor
                });
                // prettier-ignore
            })
            .catch(function(err) {
                console.error(err);
            });
    },
    _loadJsTypes: function() {
        if (this.language !== 'javascript') {
            return;
        }
        if (mini.MonacoEditor.__JsSuggestLoad) {
            return;
        }
        mini.MonacoEditor.__JsSuggestLoad = true;
        ['jquery.d.ts', 'miniui.d.ts', 'epoint.d.ts'].map(function(fileName) {
            $.ajax({
                url: mini.MonacoEditor.MONACO_PATH + '/types/' + fileName,
                dataType: 'text',
                success: function(text) {
                    mini.MonacoEditor.monaco.languages.typescript.javascriptDefaults.addExtraLib(text, fileName);
                },
                error: function(err) {
                    window.console && console.error(err);
                }
            });
        });
    }
};
// #endregion

mini.extend(mini.MonacoEditor, mini.Control, {
    uiCls: 'mini-monacoeditor',
    minHeight: 200,
    width: '',
    height: '',
    _clearBorder: false,
    defaultOptions: {
        lineHeight: 20,
        autoIndent: true,
        formatOnPaste: true,
        lineNumbers: 'on',
        minimap: {
            enabled: true
        },
        tabCompletion: 'on',
        quickSuggestions: {
            comments: true
        },
        snippetSuggestions: 'top',
        accessibilitySupport: 'on',
        suggest: {},
        readOnly: true
    }, // 默认的一些选项
    options: {}, // html 配置传入的选项
    _currentOptions: {}, // 当前实际的选项
    language: '',
    theme: 'vs-dark',
    loadJsSuggest: true,
    runtime: /^(iframe|self)$/.test(window.EpFrameSysParams && EpFrameSysParams.ui_monacoeditor_runtime) ? EpFrameSysParams.ui_monacoeditor_runtime : 'iframe',

    _create: function() {
        this.el = document.createElement('div');
    },
    _installRuntime: function() {
        var runtime = this.runtime;
        var runtimeFn = mini.MonacoEditor[runtime + 'Runtime'];
        if (typeof runtimeFn === 'function') {
            runtimeFn.call(this);
        } else {
            throw new Error('不支持的 runtime: ' + runtime);
        }
    },
    _initOptions: function() {
        var options = $.extend({}, this.defaultOptions, this.options);
        options.readOnly = this.readOnly;
        options.value = this.value;
        options.theme = this.theme;
        options.language = this.language;
        this._currentOptions = options;
    },

    _initEvents: function() {
        this.on('created', this.__onReady, this);
    },
    __onReady: function() {
        var that = this;
        if (this._fnStack) {
            this._fnStack.forEach(function(fn) {
                fn.call(that);
            });
            this._fnStack = null;
        }
    },
    _pushReady: function(callback) {
        if (!this._fnStack) {
            this._fnStack = [];
        }
        this._fnStack.push(callback);
    },

    _onDidChangeModelContent: function(e) {
        // 每个字符输入均会触发 是否存在性能问题？ 等同其他编辑器 暂不触发和同步值
        if (this._events.valuechanged) {
            this.fire('valuechanged', {});
        }
    },

    doLayout: function() {
        if (this._editor) {
            this._editor.layout();
        }
    },
    _afterApply: function() {
        mini.MonacoEditor.superclass._afterApply.apply(this, arguments);
        this._installRuntime();
    },
    setEnabled: function(value) {
        mini.MonacoEditor.superclass.setEnabled.apply(this, arguments);
        var editable = this.enabled && !this.readOnly;
        if (this._editor) {
            this._editor.updateOptions({
                readOnly: !editable
            });
        } else {
            this._pushReady(function() {
                this.setEnabled(value);
            });
        }
    },
    setReadOnly: function(value) {
        mini.MonacoEditor.superclass.setReadOnly.apply(this, arguments);
        var editable = !this.readOnly && this.enabled;
        if (this._editor) {
            this._editor.updateOptions({ readOnly: !editable });
        } else {
            this._pushReady(function() {
                this.setReadOnly(value);
            });
        }
    },
    setTheme: function(theme) {
        this.theme = theme;
        if (this._editor) {
            this._editor.updateOptions({ theme: this.theme });
        } else {
            this._pushReady(function() {
                this.setTheme(theme);
            });
        }
    },
    getTheme: function() {
        return this.theme;
    },
    getFormValue: function() {
        return this.getValue();
    },
    getValue: function() {
        if (this._editor) {
            this.value = this._editor.getValue();
            return this.value;
        }
        return this.value;
    },
    setValue: function(value) {
        this.value = value;
        if (this._editor) {
            this._editor.setValue(this.value);
        }
    },

    insertText: function(text, select) {
        var position = this._editor.getPosition();
        this._editor.executeEdits('', [
            {
                range: {
                    startLineNumber: position.lineNumber,
                    startColumn: position.column,
                    endLineNumber: position.lineNumber,
                    endColumn: position.column
                },
                text: text
            }
        ]);

        if (select) {
            var selection = this.editor.getSelection();
            selection.selectionStartColumn = selection.startColumn = selection.endColumn;
            selection.selectionStartLineNumber = selection.startLineNumber = selection.endLineNumber;

            this._editor.setSelection(selection);
        }

        this._editor.focus();
    },
    format: function() {
        if (this._editor) {
            try {
                this._editor._actions['editor.action.formatDocument'].run();
            } catch (err) {
                console.error(err);
            }
        } else {
            this._pushReady(function() {
                this.format();
            });
        }
    },
    setOptions: function (options) {
        if (typeof options === 'string') {
            options = mini.decode(options);
        }
        if (!$.isPlainObject(options)) {
            console.error('options 必须是一个对象');
            return;
        }
        this.options = options;
        this._initOptions();
    },
    getOptions: function () {
        return this.options;
    },
    getAttrs: function(el) {
        var attrs = mini.MonacoEditor.superclass.getAttrs.call(this, el);
        mini._ParseString(el, attrs, ['runtime', 'options', 'language', 'theme', 'onvaluechanged', 'onbeforeCreate', 'oncreated']);
        mini._ParseInt(el, attrs, ['width', 'height']);
        mini._ParseBool(el, attrs, ['loadJsSuggest']);
        return attrs;
    }
});

mini.regClass(mini.MonacoEditor, 'monacoeditor');

mini.MonthRangePicker = function () {
    mini.MonthRangePicker.superclass.constructor.call(this);
};

mini.extend(mini.MonthRangePicker, mini.DateRangePicker, {
    uiCls: 'mini-monthrangepicker',

    format: 'yyyy-MM',
    delimiter: '~',
    maxDate: '9999-12',
    minDate: '1753-01',
    showClearButton: true,
    showQuickSelect: false,
    footTipText: epoint_local.MonthRangePicker.footTipText,
    quickSelectText: jQuery.extend({}, epoint_local.MonthRangePicker.quickSelectText),
    customQuickSelect: [],

    _beforeLaydateInit: function (cfg) {
        cfg.type = 'month';
        cfg.range = this.delimiter;
    },
    _onLaydateBeforeRender: function () {
        this._setSelectedItems(this.value);
    },
    _onLaydateRender: function () {
        this._updateOkBtn();
    },
    _onLaydateViewChanged: function (type, elemHeader, elemCont, index, listYM) {
        var i = index > 0 ? 0 : 4;
        if (type === 'month') {
            $(elemHeader[i]).hide();
            this._adjustMonthView(elemCont, listYM[0]);
        } else {
            $(elemHeader[i]).show();
        }
    },
    _onLaydateMonthYearItemClick: function (type, ym, index) {
        if (type === 'year') {
            return;
        }
        var date = ym.year + '-' + (ym.month + 1),
            startYear = index === 0 ? ym.year : ym.year - 1;

        this._pushSelectedItems(date);

        this._adjustMonthView(this.laydate._laydate.elemCont[0], startYear);
        this._adjustMonthView(this.laydate._laydate.elemCont[1], startYear + 1);

        this._updateOkBtn();
    },
    _adjustMonthView: function (el, year) {
        var $items = $(el).find('.laydate-month-list > li').removeClass('layui-this laydate-selected'),
            range,
            month,
            $item,
            self = this;

        if (this._selectedItems.length === 1) {
            range = mini.parseDate(this._selectedItems[0]);
            if (range.getFullYear() === year) {
                $items
                    .filter(function (i, item) {
                        return parseInt($(item).attr('lay-ym'), 10) === range.getMonth();
                    })
                    .addClass('layui-this');
            }
            this.laydate._laydate.preview(true, this._selectedItems[0]);
        } else if (this._selectedItems.length === 2) {
            range = this._analyzeSelectedItems();
            $items.each(function (i, item) {
                $item = $(item);
                month = parseInt($item.attr('lay-ym'), 10);

                if (
                    (range.startDate.getFullYear() === year && range.startDate.getMonth() === month) ||
                    (range.endDate.getFullYear() === year && range.endDate.getMonth() === month)
                ) {
                    $item.addClass('layui-this');
                } else if (self._isWithin(range.startDate, range.endDate, new Date(year, month))) {
                    $item.addClass('laydate-selected');
                }
            });
            // laydate源码中的点击事件中由于无法判断是第几次点击，无法正确更新startDate和endDate的值
            this.laydate._laydate.startDate.year = range.startDate.getFullYear();
            this.laydate._laydate.startDate.month = range.startDate.getMonth();
            this.laydate._laydate.endDate.year = range.endDate.getFullYear();
            this.laydate._laydate.endDate.month = range.endDate.getMonth();

            this.laydate._laydate.preview(true, this.laydate._laydate.parse());
        }
    },
    _updateOkBtn: function () {
        if (!this.laydate) {
            return;
        }
        var $okBtn = $(this.laydate._laydate.footer).find('.laydate-btns-confirm');
        if (this._selectedItems.length === 2) {
            $okBtn.removeClass('laydate-disabled');
        } else {
            $okBtn.addClass('laydate-disabled');
        }
    },
    _onLaydateDone: function (value, date, endDate) {
        var range = this._analyzeSelectedItems();
        if (!value) {
            this.setValue('');
        } else if (range) {
            this.setValue({
                startDate: this._formatDate({
                    year: range.startDate.getFullYear(),
                    month: range.startDate.getMonth() + 1
                }),
                endDate: this._formatDate({ year: range.endDate.getFullYear(), month: range.endDate.getMonth() + 1 })
            });
        } else {
            this.setValue('');
        }

        if (this.value.startDate != this._oldValue.startDate || this.value.endDate != this._oldValue.endDate) {
            this.fire('valuechanged', {
                value: this.value,
                oldValue: this._oldValue
            });

            this._oldValue = this.value;
        }
    },
    _selectedItems: [],
    _setSelectedItems: function (val) {
        if (!val || !val.startDate || !val.endDate) {
            this._selectedItems = [];
        } else {
            this._selectedItems = [val.startDate, val.endDate];
        }
    },
    _pushSelectedItems: function (item) {
        if (this._selectedItems.length >= 2) {
            this._selectedItems = [item];
        } else {
            this._selectedItems.push(item);
        }
    },
    _analyzeSelectedItems: function () {
        if (this._selectedItems.length !== 2) {
            return;
        }
        var item1 = mini.parseDate(this._selectedItems[0]),
            item2 = mini.parseDate(this._selectedItems[1]);
        if (item1.getFullYear() < item2.getFullYear()) {
            return {
                startDate: item1,
                endDate: item2
            };
        }
        if (item1.getFullYear() > item2.getFullYear()) {
            return {
                startDate: item2,
                endDate: item1
            };
        }
        if (item1.getMonth() < item2.getMonth()) {
            return {
                startDate: item1,
                endDate: item2
            };
        }
        return {
            startDate: item2,
            endDate: item1
        };
    },
    _isWithin: function (startDate, endDate, cur) {
        if (!startDate || !endDate || !cur) return false;

        if (startDate.getFullYear() > cur.getFullYear()) return false;
        if (endDate.getFullYear() < cur.getFullYear()) return false;

        if (startDate.getFullYear() === cur.getFullYear() && startDate.getMonth() >= cur.getMonth()) return false;
        if (endDate.getFullYear() === cur.getFullYear() && endDate.getMonth() <= cur.getMonth()) return false;

        return true;
    },
    setValue: function (value) {
        mini.MonthRangePicker.superclass.setValue.call(this, value);
        this._setSelectedItems(this.value);
    },
    _mergeQuickSelect: function () {
        if (!this.quickSelect) {
            this._initQuickSelect();
        }
        var res = this.quickSelect.slice(0),
            keys = [],
            i,
            l,
            item,
            index;

        for (i = 0, l = res.length; i < l; i++) {
            keys.push(res[i].text);
        }

        for (i = 0, l = this.customQuickSelect.length; i < l; i++) {
            item = this.customQuickSelect[i];
            index = keys.indexOf(item.text);

            if (index > -1) {
                res[index] = item;
            } else {
                res.push(item);
            }
        }

        return res;
    },
    _initQuickSelect: function () {
        this.quickSelect = [
            {
                text: this.quickSelectText.thisMonth,
                start: function () {
                    var now = new Date(),
                        start = new Date(now.getFullYear(), now.getMonth());
                    return start;
                },
                end: function () {
                    var now = new Date(),
                        end = new Date(now.getFullYear(), now.getMonth());
                    return end;
                }
            },
            {
                text: this.quickSelectText.thisQuarter,
                start: function () {
                    var now = new Date(),
                        nowMonth = now.getMonth(),
                        quarterStartMonth = 0;
                    if (nowMonth > 2) {
                        if (nowMonth > 5) {
                            if (nowMonth > 8) {
                                quarterStartMonth = 9;
                            } else {
                                quarterStartMonth = 6;
                            }
                        } else {
                            quarterStartMonth = 3;
                        }
                    }

                    return new Date(now.getFullYear(), quarterStartMonth);
                },
                end: function () {
                    var now = new Date(),
                        nowMonth = now.getMonth(),
                        quarterEndMonth = 2;
                    if (nowMonth > 2) {
                        if (nowMonth > 5) {
                            if (nowMonth > 8) {
                                quarterEndMonth = 11;
                            } else {
                                quarterEndMonth = 8;
                            }
                        } else {
                            quarterEndMonth = 5;
                        }
                    }

                    return new Date(now.getFullYear(), quarterEndMonth);
                }
            },
            {
                text: this.quickSelectText.thisYear,
                start: function () {
                    var now = new Date();
                    return new Date(now.getFullYear(), 0);
                },
                end: function () {
                    var now = new Date();
                    return new Date(now.getFullYear(), 11);
                }
            }
        ];
    },

    _renderQuickSelect: function () {
        var el = this.laydate._laydate.elem,
            i = 0,
            l,
            html = ['<div class="daterange-quick-select">'],
            item,
            quickArr = this._mergeQuickSelect(),
            self = this;

        html.push('<ul class="quick-select-list">');
        for (l = quickArr.length; i < l; i++) {
            item = quickArr[i];
            typeof item.start === 'string' && (item.start = mini._getFunctoin(item.start));
            typeof item.end === 'string' && (item.end = mini._getFunctoin(item.end));
            html.push(
                '<li class="quick-select-item" data-start="' +
                    mini.formatDate(item.start(), this.format) +
                    '" data-end="' +
                    mini.formatDate(item.end(), this.format) +
                    '">' +
                    item.text +
                    '</li>'
            );
        }

        html.push('</ul>');
        html.push('</div>');

        // 判断popup下拉框右侧是否超出边界
        var popupWidth = el.offsetWidth,
            popupLeft = el.getBoundingClientRect().x,
            documentWidth = document.documentElement.clientWidth,
            marginLeft = 104;

        if (popupWidth + popupLeft + marginLeft > documentWidth) {
            el.style.left = popupLeft - marginLeft + 'px';
        }

        mini.addClass(el, 'show-quick-select');
        mini.append(el, html.join(''));
        $(el).on('click', '.quick-select-item', function () {
            var $this = $(this),
                start = $this.data('start'),
                end = $this.data('end');

            self.setValue({
                startDate: start,
                endDate: end
            });
            if (self.value.startDate != self._oldValue.startDate || self.value.endDate != self._oldValue.endDate) {
                self.fire('valuechanged', {
                    value: self.value,
                    oldValue: self._oldValue
                });

                self._oldValue = self.value;
            }
            self._tryValidate();
            $('body').trigger('click');
        });
    },

    getAttrs: function (el) {
        var attrs = mini.MonthRangePicker.superclass.getAttrs.call(this, el);

        return attrs;
    }
});

mini.regClass(mini.MonthRangePicker, 'monthrangepicker');

/**
 * Notice 单个提醒组件
 * NoticeContainer 提醒组件的容器组件 分四个方向 每个方向单页面中仅一个实例
 */
var __nextTick = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || window.setTimeout;
mini.Notice = function () {
    mini.Notice.superclass.constructor.apply(this, arguments);
};
mini.Notice.buttonText = jQuery.extend({}, epoint_local.Notice.buttonText);
mini.Notice.STATE_STATE_MAP = {
    success: 'icon-success',
    warning: 'icon-warn',
    danger: 'icon-error',
    info: 'icon-info'
};
mini.extend(mini.Notice, mini.Control, {
    uiCls: 'mini-notice',
    _clearBorder: false,
    _transitionShowCls: 'mini-notice-show-tran',
    _transitionHideCls: 'mini-notice-hide-tran',

    _iconCls: 'mini-notice-icon',
    _closeCls: 'mini-notice-close',
    _buttonsElCls: 'mini-notice-buttons',
    _showButtonCls: 'mini-notice-show-buttons',

    _container: null, // 指向所在的容器

    title: '', // 标题
    content: '', // 内容
    icon: '', // 图标
    state: '', // 语义化状态
    timeout: 5000, // 自动关闭时间 单位ms 为0时不自动关闭
    // timeout: 0, // 自动关闭时间 单位ms 为0时不自动关闭

    showClose: true, // 是否显示关闭按钮

    buttons: [], // ['ok', 'cancel', 'yes', 'no']

    _create: function () {
        // 每个实例上必须是全新的 buttons 属性 否则使用原型链上的会存在问题
        this.buttons = [];

        this.el = document.createElement('div');
        this._headerEl = document.createElement('div');
        this._headerEl.className = 'mini-notice-header';

        this._titleEl = document.createElement('div');
        this._titleEl.className = 'mini-notice-title';
        this._titleEl.innerHTML = this.title;

        this._bodyEl = document.createElement('div');
        this._bodyEl.className = 'mini-notice-body';

        this._contentEl = document.createElement('div');
        this._contentEl.className = 'mini-notice-content';
        this._contentEl.innerHTML = this.content;
        this.content ? (this._contentEl.style.display = '') : (this._contentEl.style.display = 'none');

        this._headerEl.appendChild(this._titleEl);
        this._bodyEl.appendChild(this._contentEl);
        this.el.appendChild(this._headerEl);
        this.el.appendChild(this._bodyEl);

        if (this.icon) {
            this.setIcon(this.icon);
        }
        if (this.showClose) {
            this.setShowClose(this.showClose);
        }
    },
    _initEvents: function () {},

    getTitle: function () {
        return this.title;
    },
    setTitle: function (value) {
        this._titleEl.innerHTML = value;
        // TODO: 显示字数是否根据内容自动计算
        if (String(value).length > 16) {
            this._titleEl.title = value;
        } else {
            this._titleEl.title = '';
        }
    },

    getContent: function () {
        return this.content;
    },
    setContent: function (value) {
        this.content = this._contentEl.innerHTML = value;
        if (value) {
            this._contentEl.style.display = '';
        } else {
            this._contentEl.style.display = 'none';
        }
    },

    getShowClose: function () {
        return this.showClose;
    },
    setShowClose: function (value) {
        this.showClose = !!value;
        var me = this;

        jQuery(this._headerEl)
            .find('.' + this._closeCls)
            .remove();
        this._closeEl = null;

        if (this.showClose) {
            this._closeEl = document.createElement('span');
            this._closeEl.className = this._closeCls + ' mini-icon icon-remove';
            this._headerEl.appendChild(this._closeEl);
            this._closeEl.onclick = function () {
                me.close(!!me.group);
            };
        }
    },
    getState: function () {
        return this.state;
    },
    setState: function (state) {
        this.state = state;
        this.el.setAttribute('data-state', this.state);
        if (!this.icon) {
            var icon = mini.Notice.STATE_STATE_MAP[this.state];
            icon && this.setIcon(icon);
        }
    },
    getIcon: function () {
        return this.icon;
    },
    setIcon: function (value) {
        this.icon = value;
        if (value) {
            this._iconEl = document.createElement('span');
            this._iconEl.className = this._iconCls + ' mini-icon ' + value;
            jQuery(this._headerEl)
                .find('.' + this._iconCls)
                .remove();
            jQuery(this._headerEl).prepend(this._iconEl);
        } else {
            jQuery(this._headerEl)
                .find('.' + this._iconCls)
                .remove();
            this._iconEl = null;
        }
    },

    getButtons: function () {
        return this.buttons;
    },
    setButtons: function (value) {
        if (!Array.isArray(value)) {
            value = mini.decode(value);
            if (!Array.isArray(value)) {
                return;
            }
        }
        value.length ? this.addCls(this._showButtonCls) : this.removeCls(this._showButtonCls);
        this._createButtons(value);
    },
    _createButtons: function (buttons) {
        // 之前存在按钮则销毁
        if (this.buttons && this.buttons.length) {
            this.buttons.forEach(function (button) {
                button.destroy();
            });
            this._buttonsEl && this._buttonsEl.parentNode.removeChild(this._buttonsEl);
            this.buttons = [];
        }

        if (!buttons || !buttons.length) {
            this._buttonsEl && this._buttonsEl.parentNode.removeChild(this._buttonsEl);
            this.buttons = [];
            return;
        }

        var me = this;
        var buttonsEl = (this._buttonsEl = document.createElement('div'));
        this._buttonsEl.className = this._buttonsElCls;

        buttons.forEach(function (action) {
            var btn = new mini.Button();
            var text = mini.Notice.buttonText[action];
            btn.setText(text);
            btn.action = action;
            btn.render(buttonsEl);
            btn.on('click', function (e) {
                var button = e.sender;
                var callback = me.callback;
                if (typeof callback === 'function' && callback(button.action) === false) {
                    return;
                }
                me._close();
            });
            me.buttons.push(btn);
        });
        this.el.appendChild(buttonsEl);
        this.buttons[0].setState('primary');
    },

    _bindTransitionEnd: (function () {
        // var el = document.createElement('div');
        // if ('ontransitionend' in el) {
        //     return function(callback) {
        //         this.el.addEventListener(
        //             'transitionend',
        //             function(e) {
        //                 if (e.target === this) callback(e);
        //             },
        //             false
        //         );
        //     };
        // }
        var me = this;
        clearTimeout(this._transitionEndTimer);
        return function (callback) {
            return (me._transitionEndTimer = setTimeout(callback, 300));
        };
    })(),

    show: function (immediate) {
        var me = this;
        if (immediate) {
            if (this.timeout > 0) {
                me._hideTimer = setTimeout(function () {
                    me.close();
                }, me.timeout);
            }
            me.removeCls(me.uiCls + '-hide');
            me.addCls(me.uiCls + '-show');
            me.fire('show');
            return;
        }

        this.removeCls(this._transitionHideCls);
        this.addCls(this._transitionShowCls);

        // 配置了显示事件 则需要在显示完成后指定事件内自动隐藏
        clearTimeout(this._hideTimer);
        if (this.timeout > 0) {
            this._bindTransitionEnd(function () {
                me.removeCls(me._transitionHideCls);
                me.removeCls(me._transitionShowCls);
                me._hideTimer = setTimeout(function () {
                    me.close();
                }, me.timeout);
                me.fire('show');
            });
        } else {
            this._bindTransitionEnd(function () {
                me.removeCls(me._transitionHideCls);
                me.removeCls(me._transitionShowCls);
                me.fire('show');
            });
        }
        __nextTick(function () {
            me.removeCls(me.uiCls + '-hide');
            me.addCls(me.uiCls + '-show');
        });
    },
    hide: function (immediate) {
        return this.close(immediate);
    },
    close: function (immediate) {
        var e = { cancel: false };
        this.fire('beforeClose', e);
        if (e.cancel) {
            return;
        }
        if (typeof this.callback === 'function' && this.callback('close') === false) {
            return;
        }
        this._close(immediate);
    },
    _close: function (immediate) {
        var me = this;
        if (immediate) {
            me.removeCls(me.uiCls + '-show');
            me.addCls(me.uiCls + '-hide');
            me.fire('beforedestroy');
            me.destroy();
            return;
        }
        this.removeCls(this._transitionShowCls);
        this.addCls(this._transitionHideCls);

        // 动画完成后清理自身
        this._bindTransitionEnd(function () {
            me.fire('beforedestroy');
            me.destroy();
        });

        __nextTick(function () {
            me.removeCls(me.uiCls + '-show');
            me.addCls(me.uiCls + '-hide');
        });
    },

    getAttrs: function (el) {
        var attrs = mini.Notice.superclass.getAttrs.call(this, el);

        mini._ParseInt(el, attrs, ['timeout']);
        mini._ParseString(el, attrs, ['icon', 'title', 'content', 'buttons', 'name', 'state', 'onbeforeclose', 'group']);

        mini._ParseBool(el, attrs, ['showClose']);

        return attrs;
    }
});

mini.regClass(mini.Notice, 'notice');

/**
 * 消息提示框容器实例 四个方向+group为key的单例
 */
mini.NoticeContainer = function () {
    mini.NoticeContainer.superclass.constructor.apply(this, arguments);
};
mini.NoticeContainer.POSITION_ARR = ['topleft', 'topright', 'bottomleft', 'bottomright'];
mini.NoticeContainer.cache = {};
mini.extend(mini.NoticeContainer, mini.Control, {
    uiCls: 'mini-notice-container',
    _currentNotice: null,
    _noticeMap: null,
    noticeExpanded: true,
    GAP: 32,
    noticeCount: 0,
    position: 'toptight', // topleft topright bottomleft bottomright
    _create: function () {
        this.noticeCount = 0;
        this._noticeMap = {};
        this._currentNotice = null;
        var el = document.createElement('div');

        el.innerHTML =
            '<div class="mini-notice-container-header"></div><div class="mini-notice-container-body"></div><div class="mini-notice-container-footer" style="display:none"><span class="mini-notice-group-prev action-icon icon-up"></span><span class="mini-notice-group-next action-icon icon-down"></span><span class="mini-notice-group-action"></span></div>';
        el.className = 'mini-notice-container';
        this.el = el;
        this.headerEL = el.firstChild;
        this.bodyEl = el.childNodes[1];
        this.footerEl = el.childNodes[2];

        this.actionEl = this.footerEl.lastChild;

        if (!this.noticeExpanded) {
            jQuery(this.el).removeClass('mini-expanded');
        } else {
            jQuery(this.el).addClass('mini-expanded');
        }
    },
    _initEvents: function () {
        var me = this;

        this.on('noticeShow', function (e) {
            if (!me.group) return;
            var noticeUid = e.noticeUid;
            var notice = mini.getByUid(noticeUid);
            me._updateNoticeGroupBtn();
            me._currentNotice = notice;
        });
        this.on('noticeRemove', function (e) {
            me.noticeCount--;

            var uid = e.noticeUid;
            me._noticeMap[uid] = null;
            delete me._noticeMap[uid];

            if (me.group) {
                me._updateNoticeGroupBtn();
                if (!me.noticeExpanded) {
                    me.showNextNotice(true);
                }
            }

            if (Object.keys(me._noticeMap).length === 0) {
                delete mini.NoticeContainer.cache[me._cacheKey];
                me.destroy();
            }
        });

        // jQuery(window).on('resize.' + this.uid, mini.debounce(this.doLayout, 100));
    },
    /**
     * 添加Notice实例
     * @param {mini.Notice} notice nitice 实例
     */
    addNotice: function (notice) {
        this._noticeMap[notice.uid] = notice;
        var isBottom = !this.position ? false : /bottom/i.test(this.position);
        notice.render(this.bodyEl, isBottom ? 'prepend' : 'append');

        this.noticeCount++;
    },

    getPosition: function () {
        return this.position;
    },
    setPosition: function (pos) {
        if (this.position !== pos && mini.NoticeContainer.POSITION_ARR.indexOf(pos) !== -1) {
            var key = this._cacheKey || this.position;
            //  从缓存中移动自己所在位置
            delete mini.NoticeContainer.cache[key];
            this.position = pos;
            mini.NoticeContainer.cache[key] = this;
            this.doUpdate();
        }
    },
    setGroup: function (group) {
        var me = this;
        this.group = group;
        //
        jQuery(this.footerEl)
            .off('click', '.mini-notice-group-prev')
            .off('click', '.mini-notice-group-next')
            .off('click', '.mini-notice-group-action')
            .on('click', '.mini-notice-group-prev', function () {
                me.showPrevNotice(true);
            })
            .on('click', '.mini-notice-group-next', function () {
                me.showNextNotice(true);
            })
            .on('click', '.mini-notice-group-action', function () {
                if (me.noticeExpanded) {
                    me.collapseNotice();
                } else {
                    me.expandNotice();
                }
                me._updateNoticeGroupBtn();
                me.fire('groupExpandChanged', { expanded: me.noticeExpanded });
            });
        // if (this.group) {
        //     this.footerEl.innerHTML = '';
        // }
    },
    getGroup: function () {
        return this.group;
    },
    _updateNoticeGroupBtn: function () {
        if (this.noticeCount < 2) {
            this.footerEl.style.display = 'none';
            return;
        }
        var text = this.noticeExpanded ? '收起' : '展开';
        this.actionEl.innerHTML = text + '(' + this.noticeCount + ')';
        this.footerEl.style.display = '';
    },
    // _showNoticeByUid: function(uid) {
    //     var notice = this._noticeMap[uid];
    //     if (notice) {

    //     }
    // },
    /**
     * 显示分组内的 Notice
     * @param {mini.Notice} 要显示的 Notice 示例
     */
    showNotice: function (notice) {
        if (this.noticeExpanded || this.noticeCount < 2) {
            notice.el.style.display = '';
            notice.show(true);
        } else {
            if (this._currentNotice) {
                this._currentNotice.el.style.display = 'none';
            }
            this._currentNotice = notice;
            notice.el.style.display = '';
            notice.show(true);
        }
    },
    _showNoticeByEl: function (noticeEl) {
        var notice = mini.get(noticeEl);
        if (notice) {
            this.showNotice(notice);
        }
    },
    /**
     * 显示下一个Notice
     * @param {Boolean} circle 是否循环，即没有下一个循环到第一个
     * @return {Boolean} 是否执行成功
     */
    showNextNotice: function (circle) {
        var notice = this._currentNotice;
        var success = false;
        if (notice && notice.el) {
            var nextEl = notice.el.nextElementSibling;
            var next = mini.get(nextEl);
            if (next && nextEl) {
                success = true;
                notice.el.style.display = 'none';
                nextEl.style.display = 'block';
                this._currentNotice = next;
            }
        }
        if (circle && !success) {
            return this._showNoticeByEl(this.bodyEl.firstChild);
        }
        return success;
    },
    /**
     * 显示上一个Notice
     * @param {Boolean} circle 是否循环，即没有上一个时循环到最后一个
     * @return {Boolean} 是否执行成功
     */
    showPrevNotice: function (circle) {
        var notice = this._currentNotice;
        var success = false;
        if (notice && notice.el) {
            var prevEl = notice.el.previousElementSibling;
            var prev = mini.get(prevEl);
            if (prev && prevEl) {
                success = true;
                notice.el.style.display = 'none';
                prevEl.style.display = 'block';
                this._currentNotice = prev;
            }
        }
        if (circle && !success) {
            return this._showNoticeByEl(this.bodyEl.lastChild);
        }
        return success;
    },
    setNoticeExpanded: function (v) {
        this.noticeExpanded = v;
        if (!this.noticeExpanded) {
            jQuery(this.el).removeClass('mini-expanded');
        } else {
            jQuery(this.el).addClass('mini-expanded');
        }
    },
    collapseNotice: function () {
        this.setNoticeExpanded(false);
        // var notice;
        // for (var uid in this._noticeMap) {
        //     if (Object.prototype.hasOwnProperty.call(this._noticeMap, uid)) {
        //         notice = mini.getByUid(uid);
        //         if (notice && this._currentNotice !== notice) {
        //             notice.el.style.display = 'none';
        //         }
        //     }
        // }
        var me = this;
        this._traverseNotices(function (notice) {
            if (notice && me._currentNotice !== notice) {
                notice.el.style.display = 'none';
            }
        });
    },
    expandNotice: function () {
        this.setNoticeExpanded(true);
        // var notice;
        // for (var uid in this._noticeMap) {
        //     if (Object.prototype.hasOwnProperty.call(this._noticeMap, uid)) {
        //         notice = mini.getByUid(uid);
        //         if (notice) {
        //             notice.el.style.display = '';
        //         }
        //     }
        // }
        this._traverseNotices(function (notice) {
            notice && (notice.el.style.display = '');
        });
    },
    _traverseNotices: function (fn) {
        for (var uid in this._noticeMap) {
            if (Object.prototype.hasOwnProperty.call(this._noticeMap, uid)) {
                fn.call(this, mini.getByUid(uid));
            }
        }
    },
    doUpdate: function () {
        this.el.setAttribute('data-position', this.position);
    },
    doLayout: function () {
        if (!this.group) {
            return;
        }
        var h = window.innerHeight;
        var contentHeight = h - this.GAP - 60;
        this.bodyEl.style.maxHeight = contentHeight + 'px';
    },

    getAttrs: function (el) {
        var attrs = mini.Notice.superclass.getAttrs.call(this, el);

        // mini._ParseInt(el, attrs, ['timeout']);
        mini._ParseString(el, attrs, ['position', 'group', 'onGroupExpandChanged']);

        mini._ParseBool(el, attrs, ['noticeExpanded']);

        // mini._ParseBool(el, attrs, ['showClose']);

        return attrs;
    }
});
mini.regClass(mini.NoticeContainer, 'notice-container');

function _getOrCreateNoticeContainer(position, opt) {
    position = position || 'topright';
    var group = opt && opt.group;

    var cacheKey = group ? position + '_' + group : position;
    var container = mini.NoticeContainer.cache[cacheKey];
    if (!container) {
        container = new mini.NoticeContainer();
        container._cacheKey = cacheKey;
        if (opt) {
            container.set(opt);
        }
        // if (group) {
        //     container.setGroup(group);
        // }
        container.setPosition(position);
        container.render(document.body);
        // 子控件移除后 检查进行清理工作
        // container.on('noticeRemove', function() {
        //     if (jQuery(container.bodyEl).children().length === 0) {
        //         delete mini.NoticeContainer.cache[container._cacheKey];
        //         container.destroy();
        //     }
        // });
        mini.NoticeContainer.cache[cacheKey] = container;
    }

    container.el.style.zIndex = mini.getMaxZIndex();
    return container;
}

mini.Notice.cache = {};
/**
 * 显示消息提醒
 * @param {*} config
 *
 * @returns
 */
mini.Notice.show = function show(config) {
    var group = config.group;
    var container = _getOrCreateNoticeContainer(config.position, {
        group: group,
        position: config.position,
        noticeExpanded: config.noticeExpanded,
        onGroupExpandChanged: config.onGroupExpandChanged
    });

    var notice;
    // 全局唯一的支持
    if (config.name) {
        notice = mini.getByName(config.name, container);
    }

    if (!notice) {
        notice = new mini.Notice();
        notice.set(config);

        notice.on('show', function (e) {
            var ctr = e.sender;
            var parent = ctr._container;
            parent &&
                parent.fire('noticeShow', {
                    noticeUid: ctr.uid
                });
        });
        notice.on('beforedestroy', function (e) {
            var ctr = e.sender;
            var parent = ctr._container;
            parent &&
                parent.fire('noticeRemove', {
                    noticeUid: ctr.uid
                });
            delete mini.Notice.cache[ctr.uid];
        });
        // notice.on('destroy', function (e) {
        //     var ctr = e.sender;
        //     var parent = ctr._container;
        //     parent && parent.fire('noticeRemove');
        //     delete mini.Notice.cache[ctr.uid];
        // });
        mini.Notice.cache[notice.uid] = notice;
        notice._container = container;
        // notice.render(container.bodyEl, isBottom ? 'prepend' : 'append');
        container.addNotice(notice);
        notice.addCls(notice.uiCls + '-hide');
    } else {
        notice.set(config);
    }
    if (config.state && config.icon) {
        notice.setIcon(config.icon);
    }

    // 始终调用show方法，不管是新示例还是复用实例
    // 自动隐藏的逻辑是在show中实现的，唯一实例重复调用的场景下，需要不断重置隐藏的timeout
    // 同一分组内的适配
    if (group) {
        // 有分组的情况下 如何显示交给容器处理
        container.showNotice(notice);
    } else {
        notice.show();
    }
    return notice.uid;
};
mini.Notice.hide = function hide(id) {
    if (id) {
        var ctr = mini.getByUid(id);
        ctr && ctr.close();
        return;
    }
    // 不传参时关闭全部
    for (var uid in mini.Notice.cache) {
        if (Object.prototype.hasOwnProperty.call(mini.Notice.cache, uid)) {
            var notice = mini.Notice.cache[uid];
            notice && notice.close();
        }
    }
};

mini.Output = function() {
    mini.Output.superclass.constructor.apply(this, arguments);
};

mini.extend(mini.Output, mini.Control, {
    url: '',
    async: false,
    escape: false,
    autoLoad: false,

    uiCls: 'mini-output',

    _create: function() {
        this.el = document.createElement('div');
        this.el.className = 'mini-output';
    },

    _initEvents: function() {},

    doLayout: function() {
        if (!this.canLayout()) return;

        var cs = this.el.childNodes;
        if (cs) {
            for (var i = 0, l = cs.length; i < l; i++) {
                var cel = cs[i];
                mini.layout(cel);
            }
        }
    },
    doUpdate: function() {
        var xhr = jQuery.ajax({
            url: this.url,
            async: this.async
        });
        var that = this;
        xhr.done(function(html) {
            that.setValue(html);
        });
    },

    setUrl: function(value) {
        this.url = value;
        if (this.autoLoad) {
            this.doUpdate();
        }
    },
    getUrl: function() {
        return this.url;
    },

    setAutoLoad: function(autoLoad) {
        this.autoLoad = !!autoLoad;
    },
    getAutoLoad: function() {
        return this.autoLoad;
    },

    setEscape: function(escape) {
        this.escape = !!escape;
    },
    getEscape: function() {
        return this.escape;
    },

    setAsync: function(value) {
        this.async = value;
    },
    getAsync: function() {
        return this.async;
    },

    setValue: function(value) {
        // 提供一个外部处理数据的接口，方便“服务端返回数据，前端根据数据渲染html”这种场景的实现
        var e = {
            value: value
        };

        this.fire('valuechanged', e);

        value = e.value;

        if (value === null || value === undefined) value = '';

        if (this.escape) {
            value = mini.htmlEncode(value);
        }
        mini.innerHTML(this.el, value);
        mini.parse(this.el);

        this.doLayout();
    },

    ///////////////////////////////////////////////
    getAttrs: function(el) {
        var attrs = mini.Output.superclass.getAttrs.call(this, el);

        mini._ParseString(el, attrs, ['url', 'onvaluechanged']);

        mini._ParseBool(el, attrs, ['escape', 'async', 'autoLoad']);

        return attrs;
    }
});

mini.regClass(mini.Output, 'output');

mini.OutputText = function () {
    mini.OutputText.superclass.constructor.apply(this, arguments);
    this._init();
};

mini.extend(mini.OutputText, mini.Control, {
    // dateFormat: "",
    maxWidth: '',
    escape: false,
    showTitle: true,
    numFormat: '',
    numToChinese: false,
    uiCls: 'mini-outputtext',

    set: function (kv) {
        if (typeof kv === 'string') {
            return this;
        }

        // var dateFormat = kv.dateFormat;
        // delete kv.dateFormat;

        var maxWidth = kv.maxWidth;
        delete kv.maxWidth;

        var _escape = kv.escape;
        delete kv.escape;

        var showTitle = kv.showTitle;
        delete kv.showTitle;

        var numFormat = kv.numFormat;
        delete kv.numFormat;

        var numToChinese = kv.numToChinese;
        delete kv.numToChinese;

        // if(dateFormat) {
        // 	this.dateFormat = dateFormat;
        // }
        if (maxWidth) {
            this.setMaxWidth(maxWidth);
        }
        if (_escape) {
            this.escape = _escape;
        }
        if(!mini.isNull(showTitle)) {
            this.setShowTitle(showTitle);
        }

        if(numFormat) {
            this.numFormat = numFormat;
        }

        if(numToChinese) {
            this.numToChinese = numToChinese;
        }

        mini.OutputText.superclass.set.call(this, kv);

        return this;
    },

    _create: function () {
        this.el = document.createElement('span');
    },

    _init: function () {
        var that = this;
        mini.numeralUtil.initNumeral(function() {
            that.setValue(that.value);
        });
    },
    setValue: function (value) {
        if (value === null || value === undefined) value = '';
        
        this.value = value;
        // if (this.dateFormat && mini.isDate(mini.parseDate(value)) {
        //            value = mini.formatDate(value, this.dateFormat);
        //    }

        //    if(this.maxLength && value.length > this.maxLength){
        //    	value = value.substr(0, this.maxLength) + '...';
        //    }
        this._updateText(value);
        
    },

    _updateText: function(value) {
        // 添加对数字格式化的处理
        var numValue;
        if(this.numFormat) {
            numValue = parseFloat(value);

            if(mini.isNumber(numValue) && window.numeral) {
                value = numeral(numValue).format(this.numFormat);
            }
        } else if (this.escape === true) {
            value = mini.htmlEncode(value);
            // 恢复换行
            value = value.replace(/\n/g, '<br/>');
        }
        this.el.innerHTML = value;

        var title = jQuery(this.el).text();

        if(this.showTitle) {
            mini.setAttr(this.el, 'title', title);
        }

    },
    setMaxWidth: function (maxWidth) {
        maxWidth = maxWidth.replace(/(^\s*)|(\s*$)/g, '');
        if (maxWidth) {
            if (maxWidth.substr(maxWidth.length - 2) != 'px') {
                maxWidth += 'px';
            }
            mini.addClass(this.el, 'mini-text-ellipsis');
        } else {
            mini.removeClass(this.el, 'mini-text-ellipsis');
        }

        this.el.style.maxWidth = maxWidth;

        this.maxWidth = maxWidth;
    },

    getMaxWidth: function() {
        return this.maxWidth;
    },

    getEscape: function () {
        return this.escape;
    },

    getShowTitle: function() {
        return this.showTitle;
    },

    setShowTitle: function(showTitle) {
        this.showTitle = showTitle;
    },

    setNumFormat: function(numFormat) {
        if(this.numFormat !== numFormat) {
            this.numFormat = numFormat;
            this._updateText(this.value);
        }
        
    },
    _onSyncControlValueChanged: function(e) {
        var value = e.value;
        this.setValue(value);
    },
    setValueSyncId: function(id) {
        if(this.valueSyncId !== id) {
            var control_n = mini.get(id),
                control_o = mini.get(this.valueSyncId);

            if(control_o) {
                control_o.un('valuechanged', this._onSyncControlValueChanged);
            }
            if(control_n) {
                this.setValue(control_n.getValue());
                control_n.on('valuechanged', this._onSyncControlValueChanged, this);
            }

            var self = this;
            setTimeout(function() {
                if(window.epoint && epoint.on) {
                    epoint.on('afterInit', function() {
                        // control_n 可能是自定义控件，解析比较晚，需要在 afterInit 里再做一次判断
                        if(!control_n) {
                            control_n = mini.get(id);
                            if(control_n) {
                                control_n.on('valuechanged', self._onSyncControlValueChanged, self);
                            }
                        }
                        control_n && self.setValue(control_n.getValue());
                    });
                }
            });
            
            this.valueSyncId = id;         
        }
        
    },

    getAttrs: function (el) {
        var attrs = mini.OutputText.superclass.getAttrs.call(this, el);
        // mini._ParseString(el, attrs, ["dateFormat"]);

        mini._ParseString(el, attrs, ['maxWidth', 'numFormat', 'valueSyncId']);

        mini._ParseBool(el, attrs, ['escape', 'showTitle', 'numToChinese']);

        return attrs;
    }

});

mini.regClass(mini.OutputText, 'outputtext');
mini.PagerTree = function() {
    mini.PagerTree.superclass.constructor.call(this);
    mini.addClass(this.el, 'mini-tree');
    mini.addClass(this.el, 'mini-treegrid');

    this._Expander = new mini._PagerTree_Expander(this);
    // 手动收缩节点的集合
    this._collapseNodes = [];
    // 手动展开节点的集合
    this._expandNodes = [];
    this.on('beforeload', this.__OnBeforeLoad, this);
};
mini.extend(mini.PagerTree, mini.DataGrid, {


    uiCls: 'mini-pagertree',
    treeColumn: '',

    idField: 'id',
    parentField: 'pid',

    showTreeIcon: true, //节点图标    
    iconField: 'iconCls',
    imgField: 'img',
    imgPath: '',

    leafIconCls: 'mini-tree-leaf',
    folderIconCls: 'mini-tree-folder',
    _expandNodeCls: 'mini-tree-expand',
    _collapseNodeCls: 'mini-tree-collapse',
    _eciconCls: 'mini-tree-node-ecicon',

    _OnCellMouseDown: function(e) {
        if (mini.findParent(e.htmlEvent.target, this._eciconCls)) {} else if (mini.findParent(e.htmlEvent.target, 'mini-tree-checkbox')) {} else {
            this.fire('cellmousedown', e);
        }
    },
    _OnCellClick: function(e) {
        if (mini.findParent(e.htmlEvent.target, this._eciconCls)) return;

        if (mini.findParent(e.htmlEvent.target, 'mini-tree-checkbox')) {

        } else {
            this.fire('cellclick', e);
        }
    },
    _OnDrawCell: function(record, column, rowIndex, columnIndex) {
        var e = mini.PagerTree.superclass._OnDrawCell.call(this, record, column, rowIndex, columnIndex);
        if (this.treeColumn && this.treeColumn == column.name) {
            e.headerCls += ' mini-tree-treecolumn';
            e.cellCls += ' mini-tree-treecell';
            e.cellStyle += ';padding:0;';

            e.img = record[this.imgField];
            e.iconCls = this._getNodeIcon(record);
            e.showTreeIcon = this.showTreeIcon;
            e.nodeCls = '';
            e.nodeStyle = '';

            this._createTreeCell(e);
        }
        return e;
    },
    _createTreeCell: function(e) {
        var sb = [];
        var node = e.record;

        var isLeaf = this.isLeafNode(node);
        var level = this.getNodeLevel(node);
        var isExpand = this.isExpandedNode(node);

        var cls = e.nodeCls;

        if (!isLeaf) {
            cls = isExpand ? this._expandNodeCls : this._collapseNodeCls;
        }

        if (!isLeaf) {
            cls += ' mini-tree-parentNode';
        }


        sb[sb.length] = '<div class="mini-tree-nodetitle ' + cls + '" style="' + e.nodeStyle + '">';

        //_level
        var ii = 0;
        for (var i = ii; i < level - 1; i++) {
            sb[sb.length] = '<span class="mini-tree-indent " ></span>';
        }

        if (!isLeaf) {
            sb[sb.length] = '<i class="' + this._eciconCls + '"></i>';
        } else {
            sb[sb.length] = '<span class="' + this._eciconCls + '" ></span>';
        }


        sb[sb.length] = '<span class="mini-tree-nodeshow">';
        if (e.showTreeIcon) {
            if (e.img) {
                var img = this.imgPath + e.img;
                sb[sb.length] = '<span class="mini-tree-icon" style="background-image:url(' + img + ');"></span>';
            } else {
                sb[sb.length] = '<span class="' + e.iconCls + ' mini-tree-icon mini-icon"></span>';
            }
        }

        sb[sb.length] = '<span class="mini-tree-nodetext">';

        sb[sb.length] = e.cellHtml;

        sb[sb.length] = '</span>';
        sb[sb.length] = '</span>';

        sb[sb.length] = '</div>';

        e.cellHtml = sb.join('');
    },
    /////////////////////////////////////////////////////////////////////////
    __OnBeforeLoad: function(e) {
        e.data.__ecconfig = this._getEcConfig();
    },
    _getEcConfig: function() {
        var config = { collapseNodes: this._collapseNodes, expandNodes: this._expandNodes };
        return mini.encode(config);
    },
    load: function() {
        this._collapseNodes = [];
        this._expandNodes = [];
        return mini.PagerTree.superclass.load.apply(this, arguments);
    },
    expandNode: function(node) {
        var that = this;
        node = this._dataSource.getbyId(node);
        if (node && !this.isLeafNode(node)) {
            var id = node[this.getIdField()];
            if (id) {
                this._expandNodes.remove(id);
                this._collapseNodes.remove(id);

                this._expandNodes.add(id);
            }
        }
        this.viewElScrollTop = $(this._rowsViewEl).scrollTop();
        this.reload('', '', function() {
            that._rowsViewEl.scrollTop = that.viewElScrollTop || 0;
        });
    },
    collapseNode: function(node) {
        var that = this;
        node = this._dataSource.getbyId(node);
        if (node && !this.isLeafNode(node)) {
            var id = node[this.getIdField()];
            if (id) {
                this._expandNodes.remove(id);
                this._collapseNodes.remove(id);

                this._collapseNodes.add(id);
            }
        }
        this.viewElScrollTop = $(this._rowsViewEl).scrollTop();
        this.reload('', '', function() {
            that._rowsViewEl.scrollTop = that.viewElScrollTop || 0;
        });
    },
    toggleNode: function(node) {
        node = this._dataSource.getbyId(node);
        if (!node) {
            this.reload();
        } else {
            if (this.isExpandedNode(node)) {
                this.collapseNode(node);
            } else {
                this.expandNode(node);
            }
        }
    },
    /////////////////////////////////////////////////////////////////////////
    isExpandedNode: function(node) {
        if (node.expanded === undefined) {
            return true;
        }
        return node.expanded.toString() == 'true';
    },
    isLeafNode: function(node) {
        return node.isLeaf && node.isLeaf.toString() == 'true';
    },
    getNodeLevel: function(node) {
        return node._level;
    },
    _getNodeIcon: function(node) {
        var icon = node[this.iconField];
        if (!icon) {
            if (this.isLeafNode(node)) icon = this.leafIconCls;
            else icon = this.folderIconCls;
        }
        return icon;
    },
    getAttrs: function(el) {
        var attrs = mini.PagerTree.superclass.getAttrs.call(this, el);

        mini._ParseString(el, attrs, ['treeColumn', 'iconField', 'imgField', 'imgPath', 'idField', 'parentField']);

        mini._ParseBool(el, attrs, ['showTreeIcon']);

        return attrs;
    }

});
mini.regClass(mini.PagerTree, 'pagertree');

//分页树折叠插件
mini._PagerTree_Expander = function(grid) {
    this.owner = grid;
    mini.on(grid.el, 'click', this.__OnClick, this);
};
mini._PagerTree_Expander.prototype = {
    __OnClick: function(e) {
        var tree = this.owner;
        var node = tree.getRecordByEvent(e, false);
        if (!node) return;
        var isLeaf = tree.isLeafNode(node);
        if (mini.findParent(e.target, tree._eciconCls)) {
            if (tree.isLeafNode(node)) return;
            tree.toggleNode(node);
        }
    }
};


mini.Pagination = function () {
	mini.Pagination.superclass.constructor.apply(this, arguments);
};

mini.extend(mini.Pagination, mini.Control, {
    pageIndex: 0,
    pageSize: 10,
    totalCount: 0,
    totalPage: 0,
    showTotalCount: true,
    showPageSize: true,
    showPageInfo: true,
    sizeList: [10, 20, 50, 100],
    pageInfoText: epoint_local.Pagination.pageInfoText,
    jumpText: epoint_local.Pagination.jumpText,
    sizeText: epoint_local.Pagination.sizeText,
    set: function (kv) {
        if (typeof kv === 'string') {
            return this;
        }

        var pageIndex = kv.pageIndex;
        delete kv.pageIndex;
        
        var sizeList = kv.sizeList;
        delete kv.sizeList;

        mini.Pagination.superclass.set.call(this, kv);

        if (!mini.isNull(pageIndex)) {
            this.setPageIndex(pageIndex);
        }
        if (!mini.isNull(sizeList)) {
            this.setSizeList(sizeList);
        }
        return this;
    },

    uiCls: 'mini-pagination',
    _create: function () {
        var sf = this;
        sf.el = document.createElement('div');
        // sf.el.className = "mini-pagination";
        this._updatePager();

    },
    _updatePagerButtons: function () {
        var sf = this;
        var pageSize = parseInt(sf.pageSize, 10);
        var pageIndex = parseInt(sf.pageIndex, 10);
        var totalIndex = parseInt(sf.totalCount, 10);
        var buttonCounts = Math.ceil(totalIndex / pageSize);

        var nextEllipsisIndex;

        var sb = [];
        if(this.showTotalCount && totalIndex >= 0) {
            sb.push('<div class="pagination-pagerinfo">' + String.format(this.pageInfoText, totalIndex) + '</div>');
        }
        sb.push('<div class="pagination-buttons">');
        var cls = '',
            item = '',
            i = 0;
        if (pageIndex == 0) {
            cls = 'disabled';
        }
        var prevButton = '<a class="pagination-button pagination-prev mini-icon ' + cls + '" action="prev"></a>';
        sb.push(prevButton);

        if (buttonCounts < 8) {
            for (i = 0; i < buttonCounts; i++) {
                cls = '';
                if (pageIndex == i) {
                    cls = 'pagination-current';
                }
                item = '<a class="pagination-button ' + cls + '">' + (i + 1) + '</a>';

                sb.push(item);
            }
        } else {
            if (pageIndex < 6) {
                for (i = 0; i < 6; i++) {
                    cls = '';
                    if (pageIndex == i) {
                        cls = 'pagination-current';
                    }
                    item = '<a class="pagination-button ' + cls + '">' + (i + 1) + '</a>';

                    sb.push(item);
                }
                nextEllipsisIndex = i + 4 >= buttonCounts ? buttonCounts -1 : i + 4;
                sb.push('<a class="pagination-button pagination-button-ellipsis" action="none" data-index="' + nextEllipsisIndex + '" title="' + nextEllipsisIndex + '">...</a>');
                sb.push('<a class="pagination-button">' + buttonCounts + '</a>');
            } else if (pageIndex > buttonCounts - 6) {
                sb.push('<a class="pagination-button">1</a>');
                sb.push('<a class="pagination-button pagination-button-ellipsis" action="none" data-index="' + (buttonCounts - 6) + '" title="' + (buttonCounts - 6) + '">...</a>');
                for (i = 6; i > 0; i--) {
                    cls = '';
                    if (pageIndex == buttonCounts - i) {
                        cls = 'pagination-current';
                    }
                    sb.push('<a class="pagination-button ' + cls + '">' + (buttonCounts - i + 1) + '</a>');
                }


            } else {
                sb.push('<a class="pagination-button">1</a>');
                sb.push('<a class="pagination-button pagination-button-ellipsis" action="none" data-index="' + (pageIndex - 3) + '" title="' + (pageIndex - 3) + '">...</a>');
                for (i = 0; i < 3; i++) {
                    item = '<a class="pagination-button">' + (pageIndex - (2 - i)) + '</a>';
                    sb.push(item);
                }
                nextEllipsisIndex = pageIndex + 4 >= buttonCounts ? buttonCounts - 1 : pageIndex + 4;
                sb.push('<a class="pagination-button pagination-current">' + (pageIndex + 1) + '</a>');
                sb.push('<a class="pagination-button pagination-button-ellipsis" action="none" data-index="' + nextEllipsisIndex + '" title="' + nextEllipsisIndex + '">...</a>');
                sb.push('<a class="pagination-button">' + buttonCounts + '</a>');
            }
        }

        cls = '';
        if ((pageIndex >= buttonCounts - 1 && totalIndex >= 0) || totalIndex == -9999) {
            cls = 'disabled';
        }
        var nextButton = '<a class="pagination-button pagination-next  mini-icon ' + cls + '" action="next"></a>';

        sb.push(nextButton);
        sb.push('</div>');
        var pageButtonsStr = sb.join(' ');
        sf.el.innerHTML = pageButtonsStr;
    },
    _updatePagerInfo: function () {
        var sf = this;

        var pageSize = parseInt(sf.pageSize, 10);
        var pageIndex = parseInt(sf.pageIndex, 10);

        var sizeList = sf.sizeList;
        var flag = false,
            i = 0,
            l;

        function sortNumber(a, b) {
            return a - b;
        }
    
        //debugger
        if(sf.showPageSize) {
            for (l = sizeList.length; i < l; i++) {
                if (sizeList[i] === pageSize) {
                    flag = true;
                }
            }
            if (!flag) {
                sizeList.push(pageSize);
            }
    
            sizeList.sort(sortNumber);
            var sizeData = [];
            for (i = 0; i < l; i++) {
                sizeData.push({ id: sizeList[i], text: sizeList[i] });
            }
    
            sf.sizeCombo = new mini.ComboBox();
            sf.sizeCombo.setData(sizeData);
            sf.sizeCombo.setValue(pageSize);
            sf.sizeCombo.on('valuechanged', function (e) {
                var value = parseInt(e.value, 10);
                sf._OnPageChanged(0, value);
            });
            sf.sizeCombo.render(sf.el);

            var sizeInfo = document.createElement('span');
            sizeInfo.className = 'pagination-sizeinfo';
            sizeInfo.innerHTML = sf.sizeText;
            sf.sizeCombo._borderEl.appendChild(sizeInfo);
        }
        
        if(sf.totalCount >= 0) {
            var pagerChange = document.createElement('span');
            pagerChange.className = 'pagination-pagerchange';
            var str = String.format(this.jumpText, pageIndex + 1);
            pagerChange.innerHTML = str;
            sf.el.appendChild(pagerChange);
        }
    },
    _updatePager: function () {
        this._updatePagerButtons();
        this._updatePagerInfo();

    },
    _initEvents: function () {
        mini.Pagination.superclass._initEvents.call(this);
        var sf = this;
        //        sf.sizeCombo.on("valuechanged", function (e) {
        //            
        //        })
        setTimeout(function () {
            $(sf.el).on('click', '.pagination-button', function (e) {

                var pageSize = sf.pageSize;
                var pageIndex = sf.pageIndex;
                var totalIndex = sf.totalCount;
                var buttonCounts = Math.ceil(totalIndex / pageSize);
                var action = $(e.target).attr('action');
                var val = '';
                if (action == 'prev') {
                    if (pageIndex != 0) {
                        sf._OnPageChanged(pageIndex - 1);
                    }
                } else if (action == 'next') {
                    if ((pageIndex < buttonCounts - 1 || totalIndex < 0) && totalIndex !== -9999) {
                        sf._OnPageChanged(sf.pageIndex + 1);
                    }
                } else if (action == 'none') {
                    val = parseInt($(e.target).data('index'), 10);
                    if (val > 0) {
                        sf._OnPageChanged(val - 1);
                    }
                } else {
                    if (!$(e.target).hasClass('current')) {
                        val = parseInt($(e.target).text(), 10);
                        if (val > 0) {
                            sf._OnPageChanged(val - 1);
                        }
                    }
                }

            }).on('keyup', '.pagination-number', function (e) {
                if (e.keyCode === 13 && e.target.value !== sf.pageIndex + 1) {
                    dealInput($(e.target));
                    
                }
            }).on('change', '.pagination-number', function (e) {
                dealInput($(e.target));
            });

        }, 100);

        function dealInput($input) {
            var pageSize = sf.pageSize;
            var totalIndex = sf.totalCount;
            var buttonCounts = Math.ceil(totalIndex / pageSize);

            var value = parseInt($input.val());

            if (isNaN(value)) {
                $input.val('');
            } else {
                if (value > buttonCounts) {
                    value = buttonCounts;
                    $input.val(value);
                }
                sf._OnPageChanged(value - 1);
            }
        }

    },

    _OnPageChanged: function (index, size) {
        var e = {
            pageIndex: mini.isNumber(index) ? index : this.pageIndex,
            pageSize: mini.isNumber(size) ? size : this.pageSize,
            cancel: false
        };
        if(this.totalPage > -1) {
            if (e.pageIndex > this.totalPage - 1) {
                e.pageIndex = this.totalPage - 1;
            }
        }
        
        if (e.pageIndex < 0) e.pageIndex = 0;

        this.fire('beforepagechanged', e);
        if (e.cancel == true) {
            return;
        }

        this.fire('pagechanged', e);
        this.update(e.pageIndex, e.pageSize);


    },

    //分页信息变更时激发，用户在此方法内调整分页信息展现
    update: function (index, size, total) {
        var sf = this;
        if (mini.isNumber(index)) sf.pageIndex = parseInt(index);
        if (mini.isNumber(size)) sf.pageSize = parseInt(size);
        if (mini.isNumber(total)) sf.totalCount = parseInt(total);

        sf.totalPage = parseInt(sf.totalCount / sf.pageSize) + 1;
        
        //@新增：用于处理 totalCount < 0 的场合
        if (sf.totalCount < 0) {
            sf.totalPage = -1;
        } else {
            if ((sf.totalPage - 1) * sf.pageSize == sf.totalCount) {
                sf.totalPage -= 1;
            }
            if (sf.totalCount == 0) sf.totalPage = 0;
    
            if (sf.pageIndex > sf.totalPage - 1) {
                sf.pageIndex = sf.totalPage - 1;
            }
            if (sf.totalPage <= 0) sf.totalPage = 0;
        }

        if (sf.pageIndex <= 0) sf.pageIndex = 0;

        this._updatePager();
    },
    setPageIndex: function (value) {
        if (isNaN(value)) return;
        this.pageIndex = value;
        this.update();
    },
    getPageIndex: function () {
        return this.pageIndex;
    },
    setPageSize: function (value) {
        if (isNaN(value)) return;
        this.pageSize = value;
        this.update();
    },
    getPageSize: function () {
        return this.pageSize;
    },
    setTotalCount: function (value) {
        value = parseInt(value);
        if (isNaN(value)) return;
        this.totalCount = value;
        this.update();
    },
    getTotalCount: function () {
        return this.totalCount;
    },
    setSizeList: function (value) {
        if (!mini.isArray(value)) return;
        this.sizeList = value;
        this.update();
    },
    getSizeList: function () {
        return this.sizeList;
    },

    setShowReloadButton: function (value) {

    },
    getShowReloadButton: function () {
        return false;
    },
    setShowTotalCount: function(showTotalCount) {
        if(this.showTotalCount !== showTotalCount) {
            this.showTotalCount = showTotalCount;
            this.update();
        }
    },
    getShowTotalCount: function() {
        return this.showTotalCount;
    },
    setShowPageSize: function(showPageSize) {
        if(this.showPageSize !== showPageSize) {
            this.showPageSize = showPageSize;
            this.update();
        }
    },
    getShowPageSize: function() {
        return this.showPageSize;
    },
    setShowPageInfo: function(showPageInfo) {
        this.showPageInfo = showPageInfo;
        this.setShowTotalCount(showPageInfo);
    },
    getShowPageInfo: function() {
        return this.showPageInfo;
    },
    setShowPagerButtonText: function (value) {
    },
    setShowPagerButtonIcon: function (value) {
    },
    setPageSizeWidth: function (value) {
    },
    setShowPageIndex: function (value) {
    },
    getAttrs: function (el) {
        var attrs = mini.Pager.superclass.getAttrs.call(this, el);

        mini._ParseString(el, attrs,
            ['onpagechanged', 'sizeList', 'onbeforepagechanged', 'buttons', 'sizeText'
                ]
        );
        mini._ParseBool(el, attrs,
            [ 'showPageSize', 'showTotalCount','showPageInfo'
                ]
        );
        mini._ParseInt(el, attrs,
            ['pageIndex', 'pageSize', 'totalCount'
                ]
        );
        //        var cs = mini.getChildNodes(el, true);
        //        attrs.body = cs;

        if (typeof attrs.sizeList === 'string') {
            attrs.sizeList = window['ev' + 'al'](attrs.sizeList);
        }
        if (attrs.buttons) {
            attrs.buttons = mini.byId(attrs.buttons);

        }


        return attrs;
    }

});

mini.regClass(mini.Pagination, 'pagination');
mini.PanelTip = function() {
    mini.PanelTip.superclass.constructor.apply(this, arguments);
};

mini.extend(mini.PanelTip, mini.ToolTip, {

    selector: '.paneltip',
    trigger: 'click',
    uiCls: 'mini-paneltip',
    url: '',
    tplUrl: '',
    tpl: '',
    cssUrl: '',
    defaultTheme: 'light',
    // 第三方资源路径
    externalSrc:  _rootPath + '/frame/fui/js/libs/',

    _create: function() {
        this.el = jQuery('<div class="mini-tooltip mini-paneltip"><div class="mini-tooltip-arrow"></div><i class="mini-paneltip-close"></i><div class="mini-tooltip-inner"></div></div>')[0];
        this.$element = jQuery(this.el);
        this.$close = jQuery('.mini-paneltip-close', this.$element);
        this.$element.appendTo(document.body);

        this.externalSrc = this.externalSrc || mini.externalSrc;
    },

    _initEvents: function() {
        var self = this;
        this.$close.on('click', function() {
            self.close();
        });

        this._bindTooltip();
    },
    _opened: '',
    open: function(target) {
        target = jQuery(target)[0] || this.target;
        var guid = jQuery(target).attr('data-guid');

        var e = { element: target, data: { guid: guid }, cancel: false };

        var self = this;
        this.fire('beforeopen', e);
        if (e.cancel) return;

        this.$element.show();

        this._target = target;

        this._getData(e.data, guid);

        this.fire('open', { element: target });
    },

    _getData: function(params, openedGuid) {
        var self = this;
        this.showLoading();
        // 框架中返回的数据是在custom中的，为了方便处理，改为用框架中的ajax方法
        Util.ajax({
            url: this.url,
            data: params,
            async: true,
            success: function(text) {
                var data = mini.decode(text) || '';

                // 记住当前展示的guid，避免点击同一个时重复请求数据
                self._opened = openedGuid;

                if (!window.Mustache) {
                    mini.loadJS(self.externalSrc + 'mustache.min.js', function() {
                        self._renderContent(data);
                    });
                } else {
                    self._renderContent(data);
                }

            }
        });
    },

    _renderContent: function(data) {
        var html = Mustache.render(this.tpl, data);

        this.setContent(html);

        this.$close.removeClass('hidden');

    },

    _toggle: function(e) {
        if (this._opened) {
            var $target = jQuery(e.currentTarget);
            var guid = $target.attr('data-guid');

            if (guid === this._opened) {
                this.applyPlacement();
                return;
            }
        }

        this.close();
        this._enter(e);
    },
    _leave: function (e) {
        // 鼠标移开时不自动隐藏
        clearTimeout(this.openTimer);
    },

    showLoading: function() {
        this.setContent('<div class="mini-tooltip-loading"></div>');
        this.$close.addClass('hidden');
    },
    close: function() {
        this._target = null;
        this.$element.hide();
        this._opened = '';
    },
    setTplUrl: function(tplUrl) {
        this.tplUrl = tplUrl;

        this.tpl = jQuery.trim(mini.loadText(tplUrl));
    },

    setCssUrl: function(cssUrl) {
        this.cssUrl = cssUrl;

        mini.loadCSS(cssUrl);
    },

    ///////////////////////////////////////////////
    getAttrs: function(el) {
        var attrs = mini.PanelTip.superclass.getAttrs.call(this, el);
        mini._ParseString(el, attrs, ['trigger']);
        return attrs;
    }
});

mini.regClass(mini.PanelTip, 'paneltip');
mini.QuarterPicker = function() {
    mini.QuarterPicker.superclass.constructor.call(this);
};

mini.extend(mini.QuarterPicker, mini.PopupEdit, {
    uiCls: 'mini-quarterpicker',

    showPopupOnClick: true,
    allowInput: false,
    popupHeight: 'auto',
    popupWidth: 'auto',
    maxDate: '9999-q3',
    _maxDate: {
        year: 9999,
        quarter: 3
    },
    minDate: '1753-q0',
    _minDate: {
        year: 1753,
        quarter: 0
    },
    showClearButton: true,
    showOkButton: false,
    itemText: epoint_local.QuarterPicker.itemText.slice(),
    yearText: epoint_local.QuarterPicker.yearText,
    clearText: epoint_local.QuarterPicker.clearText,
    okText: epoint_local.QuarterPicker.okText,
    footTipText: '',

    _createPopup: function() {
        mini.QuarterPicker.superclass._createPopup.call(this);

        this._bindPopupEvents();

    },
    _bindPopupEvents: function() {
        var self = this;
        jQuery(this.popup.el)
            .on('click', '.laydate-prev-y', function(e) {
                var year = parseInt($(this).closest('.layui-laydate-header').data('year'), 10);
                self._updatePopupPanel(year - (self._popupPanelView === 'year' ? self._yearContentCount : 1));
            })
            .on('click', '.laydate-next-y', function(e) {
                var year = parseInt($(this).closest('.layui-laydate-header').data('year'), 10);
                self._updatePopupPanel(year + (self._popupPanelView === 'year' ? self._yearContentCount : 1));
            })
            .on('click', '.laydate-set-ym', function(e) {
                var year = parseInt($(this).closest('.layui-laydate-header').data('year'), 10);
                self._popupPanelView = 'year';
                self._updatePopupPanel(year);
            })
            .on('click', '.laydate-btns-clear', function(e) {
                if(!self._compareValue('')) {
                    self.setValue('');
                    self._OnValueChanged();
                }
                self._onBtnClick('clear');
                self.hidePopup();
            })
            .on('click', '.laydate-btns-confirm', function(e) {
                if($(this).hasClass('laydate-disabled')) {
                    return;
                }
                var value = self._getSelectedValue();

                if(!self._compareValue(value)) {
                    self.setValue(value);
                    self._OnValueChanged();
                }
                self._onBtnClick('confirm');
                self.hidePopup();
            })
            .on('click', '.laydate-quarter-item', function(e) {
                self._onQuarterItemClick($(this));
            })
            .on('click', '.laydate-year-item', function(e) {
                var $this = $(this),
                    year = $this.data('year');

                if($this.hasClass('laydate-disabled')) {
                    return;
                }

                self._popupPanelView = 'quarter';
                self._updatePopupPanel(year);   
            });
    },
    _onQuarterItemClick: function($item) {
        var year = $item.data('year'),
            quarter = $item.data('quarter');

        if($item.hasClass('layui-this') || $item.hasClass('laydate-disabled')) {
            return;
        }
        $item.addClass('layui-this')
            .siblings().removeClass('layui-this');
        
        if(this.showOkButton){
            return;
        }

        this.setValue(this._joinValue(year, quarter));
        this._OnValueChanged();
        
        this.hidePopup();
    },
    _getSelectedValue: function() {
        var $selected = $(this.popup.el).find('.laydate-quarter-item.layui-this'),
            year = $selected.data('year'),
            quarter = $selected.data('quarter'),
            value = this._joinValue(year, quarter);
        return value;
    },
    showPopup: function() {
        var ex = { cancel: false };
        this.fire('beforeshowpopup', ex);
        if (ex.cancel === true) return;

        var year = this._getCurYear();
        this._updatePopupPanel(year);
        mini.QuarterPicker.superclass.showPopup.call(this);
    },
    _getCurYear: function() {
        return this._analyzeValue(this.value).year || new Date().getFullYear();
    },
    hidePopup: function () {
        mini.QuarterPicker.superclass.hidePopup.call(this);
        this._popupPanelView = 'quarter';
    },
    _popupPanelView: 'quarter', // 当前视图，quarter 季度选择，year 年份选择
    _updatePopupPanel: function(year) {
        this.popup && (this.popup._contentEl.innerHTML = this._createPopupPanel(year));
    },
    _yearContentCount: 9,
    _createHeaderYearText: function(year){
        if(this._popupPanelView === 'quarter') {
            return year + this.yearText;
        }
        var half = parseInt(this._yearContentCount / 2, 10),
            mod = this._yearContentCount % 2;
        return (year - half) + this.yearText + ' - ' + (year + half - 1 + mod) + this.yearText;
    },
    _createPopupPanel: function(curYear) {
        var html = [];

        html.push('<div class="layui-laydate">');
        // 左侧面板
        html.push('<div class="layui-laydate-main laydate-main-list-0">');
        // 头部
        html.push('<div class="layui-laydate-header" data-year="' + curYear + '"><i class="layui-icon laydate-icon laydate-prev-y"></i>');
        html.push('<div class="laydate-set-ym"><span>' + this._createHeaderYearText(curYear) + '</span></div>');
        html.push('<i class="layui-icon laydate-icon laydate-next-y"></i></div>');
        // 内容区
        html.push('<div class="layui-laydate-content">' + this._createContent(curYear) + '</div>');

        html.push('</div>');

        // 底部操作区
        html.push(this._createFooter());

        html.push('</div>');

        return html.join('');
    },
    _createContent: function(year) {
        return this._popupPanelView === 'quarter' ? this._createQuarterContent(year) : this._createYearContent(year);
    },
    _createQuarterContent: function (year) {
        var html = ['<ul class="layui-laydate-list laydate-quarter-list">'];
        var quarter,
            isSelected,
            allowSelect,
            event;
        if(this.value) {
            quarter = this._analyzeValue(this.value).quarter || 0;
        } else {
            quarter = Math.floor(new Date().getMonth() / 3);
        }
        for (var i = 0; i < 4; i++) {
            isSelected = quarter === i;
            allowSelect = this._isValueSelectable(year, i);
            event = {
                allowSelect: allowSelect,
                year: year,
                quarter: i,
                value: this._joinValue(year, i),
                text: this._joinText(year, i),
                html: this.itemText[i]
            };
            this.fire('drawquarter', event);

            html.push('<li class="laydate-quarter-item' + (!event.allowSelect ? ' laydate-disabled' : (isSelected ? ' layui-this' : '')) + '" data-year="' + year + '"data-quarter="' + i + '">' + event.html + '</li>');
        }
        html.push('</ul>');
        return html.join('');
    },
    _createYearContent: function (year) {
        var html = ['<ul class="layui-laydate-list laydate-year-list">'],
            curYear,
            allowSelect,
            event,
            half = parseInt(this._yearContentCount / 2, 10),
            mod = this._yearContentCount % 2,
            max = half + mod;
        
        for (var i = -half; i < max; i++) {
            curYear = year + i;
            allowSelect = this._isValueSelectable(curYear);
            event = {
                allowSelect: allowSelect,
                year: curYear,
                html: curYear + this.yearText 
            };
            this.fire('drawyear', event);

            html.push('<li class="laydate-year-item' + (!event.allowSelect ? ' laydate-disabled' : i === 0 ? ' layui-this' : '') + '" data-year="' + curYear + '">' + event.html + '</li>');
        }
        html.push('</ul>');
        return html.join('');
    },
    _createFooter: function() {
        var html = [];

        html.push('<div class="layui-laydate-footer"><span class="laydate-footer-tips">' + this.footTipText + '</span>');
        html.push(
            '<div class="laydate-footer-btns"><span lay-type="clear" class="laydate-btns-clear' + (this.showClearButton ? '' : ' hidden') + '">' + this.clearText + '</span><span lay-type="confirm" class="laydate-btns-confirm' + (this.showOkButton ? '' : ' hidden') + (this._popupPanelView === 'year' ? ' laydate-disabled' : '') + '">' + this.okText + '</span></div>'
        );
        html.push('</div>');

        return html.join('');
    },

    _valueReg: /^(\d{4})-q([0123])$/,
    _analyzeValue: function(value) {
        value = value || '';

        var match = value.match(this._valueReg);

        return {
            year: match ? parseInt(match[1], 10) : '',
            quarter: match ? parseInt(match[2], 10) : ''
        };
    },

    _joinValue: function (year, quarter) {
        if(/^(\d){4}$/.test(year) && /^[0123]$/.test(quarter)) {
            return year + '-q' + quarter;
        }
        return '';
    },
    _joinText: function (year, quarter) {
        if(/^(\d){4}$/.test(year) && /^[0123]$/.test(quarter)) {
            return year + this.yearText + this.itemText[quarter];
        }
        return '';
    },
    _isValueSelectable: function (year, quarter) {
        if(year > this._maxDate.year || year < this._minDate.year) {
            return false;
        }
        if(quarter === undefined) {
            return true;
        }
        if(year === this._maxDate.year && quarter > this._maxDate.quarter) {
            return false;
        }
        if(year === this._minDate.year && quarter < this._minDate.quarter) {
            return false;
        }
        return true;
    },
    _onBtnClick: function(action) {
        var event = {
            action: action,
            value: this.value
        };
        this.fire('btnclick', event);
    },
    validateValueFormat: function(value) {
        if(!this._valueReg.test(value)) {
            console.warn('Invalid value：', value);
           return false; 
        }
        return  true;
    },
    setMinDate: function(value) {
        if(!this.validateValueFormat(value)) {
            return;
        }
        this.minDate = value;

        var v = this._analyzeValue(value);
        this._minDate = {
            year: v.year, 
            quarter: v.quarter
        };
    },
    setMaxDate: function(value) {
        if(!this.validateValueFormat(value)) {
            return;
        }
        this.maxDate = value;

        var v = this._analyzeValue(value);
        this._maxDate = {
            year: v.year, 
            quarter: v.quarter
        };
    },
    _compareValue: function(value) {
        return this.value === value;
    },
    setValue: function(value) {
        if(!value) {
            this.value = this.text = this._textEl.value = this._valueEl.value = '';
            return;
        }

        if(!this.validateValueFormat(value)) {
            return;
        }
        this.value = value;
        
        var analyzeValue = this._analyzeValue(value);
        this.text = this._textEl.value = this._valueEl.value = this._joinText(analyzeValue.year, analyzeValue.quarter);
    },
    getValue: function() {
        return this.value;
    },
    getText: function() {
        return this._textEl.value;
    },
    getAttrs: function(el) {
        var attrs = mini.QuarterPicker.superclass.getAttrs.call(this, el);

        mini._ParseString(el, attrs, ['minDate', 'maxDate', 'onvaluechanged', 'ondrawquarter', 'ondrawyear', 'onbtnclick']);

        mini._ParseBool(el, attrs,
            ['showClearButton', 'showOkButton']
        );
        return attrs;
    }
});

mini.regClass(mini.QuarterPicker, 'quarterpicker');

mini.QuarterRangePicker = function() {
    mini.QuarterRangePicker.superclass.constructor.call(this);
};

mini.extend(mini.QuarterRangePicker, mini.QuarterPicker, {
    uiCls: 'mini-quarterrangepicker',

    delimiter: '~',
    showOkButton: true,
    footTipText: epoint_local.QuarterRangePicker.footTipText,
    
    _getCurYear: function() {
        return this._analyzeValue(this.value.startDate).year || new Date().getFullYear();
    },

    showPopup: function() {
        if(this.value && this.value.startDate && this.value.endDate) {
            var analyzeStart = this._analyzeValue(this.value.startDate),
            analyzeEnd = this._analyzeValue(this.value.endDate);
    
            this._selectedItems = [analyzeStart, analyzeEnd];
        } else {
            this._selectedItems = [];
        }
        mini.QuarterRangePicker.superclass.showPopup.call(this);

        this._updateOkBtn();
    },
    _createPopupPanel: function(curYear) {
        var html = [];

        html.push('<div class="layui-laydate layui-laydate-range">');

        if(this._popupPanelView === 'quarter') {
            // 左侧面板        
            html.push(this._createLeftPanel(curYear));

            // 右侧面板        
            html.push(this._createRightPanel(curYear + 1));
        } else {
            html.push(this._createYearPanel(curYear));
        }        

        // 底部操作区
        html.push(this._createFooter());

        html.push('</div>');

        return html.join('');

    },

    _createLeftPanel: function(year) {
        var html = [];

        html.push('<div class="layui-laydate-main laydate-main-list-0">');
        // 头部
        html.push('<div class="layui-laydate-header" data-year="' + year + '"><i class="layui-icon laydate-icon laydate-prev-y"></i>');
        html.push('<div class="laydate-set-ym"><span>' + this._createHeaderYearText(year) + '</span></div>');
        html.push('<i class="layui-icon laydate-icon laydate-next-y"></i></div>');
        // 内容区
        html.push('<div class="layui-laydate-content">' + this._createQuarterContent(year) + '</div>');

        html.push('</div>');
        return html.join('');
    },

    _createRightPanel: function(year) {
        var html = [];

        html.push('<div class="layui-laydate-main laydate-main-list-1">');
        // 头部
        html.push('<div class="layui-laydate-header" data-year="' + (year - 1) + '"><i class="layui-icon laydate-icon laydate-prev-y"></i>');
        html.push('<div class="laydate-set-ym"><span>' + this._createHeaderYearText(year) + '</span></div>');
        html.push('<i class="layui-icon laydate-icon laydate-next-y"></i></div>');
        // 内容区
        html.push('<div class="layui-laydate-content">' + this._createQuarterContent(year) + '</div>');

        html.push('</div>');

        return html.join('');
    },

    _createQuarterContent: function (year) {
        var html = ['<ul class="layui-laydate-list laydate-quarter-list">'];
        var startDate,
            endDate,
            isSelected,
            isWithin,
            allowSelect,
            event,
            range = this._analyzeSelectedItems();
        if(range) {
            startDate = range.startDate;
            endDate = range.endDate;
        }
        for (var i = 0; i < 4; i++) {
            isSelected = startDate && endDate && ((startDate.year === year && startDate.quarter === i) || (endDate.year === year && endDate.quarter === i));
            isWithin = this._isWithin(startDate, endDate, {year: year, quarter: i});
            allowSelect = this._isValueSelectable(year, i);
            event = {
                allowSelect: allowSelect,
                year: year,
                quarter: i,
                value: this._joinValue(year, i),
                text: this._joinText(year, i),
                html: this.itemText[i]
            };
            this.fire('drawquarter', event);

            html.push('<li class="laydate-quarter-item' + (!event.allowSelect ? ' laydate-disabled' : (isSelected ? ' layui-this' : '')) + (isWithin ? ' laydate-selected': '') + '" data-year="' + year + '"data-quarter="' + i + '">' + event.html + '</li>');
        }
        html.push('</ul>');
        return html.join('');
    },
    _isWithin: function(startDate, endDate, cur) {
        if(!startDate || !endDate || !cur) return false;

        if(startDate.year > cur.year) return false;
        if(endDate.year < cur.year) return false;

        if(startDate.year === cur.year && startDate.quarter >= cur.quarter) return false;
        if(endDate.year === cur.year && endDate.quarter <= cur.quarter) return false;

        return true;
    },
    _yearContentCount: 18,
    _createYearPanel: function(year) {
        var html = [];

        html.push('<div class="layui-laydate-main laydate-main-list">');
        // 头部
        html.push('<div class="layui-laydate-header" data-year="' + year + '"><i class="layui-icon laydate-icon laydate-prev-y"></i>');
        html.push('<div class="laydate-set-ym"><span>' + this._createHeaderYearText(year) + '</span></div>');
        html.push('<i class="layui-icon laydate-icon laydate-next-y"></i></div>');
        // 内容区
        html.push('<div class="layui-laydate-content">' + this._createYearContent(year) + '</div>');

        html.push('</div>');
        return html.join('');
    },
    _selectedItems: [],
    _analyzeSelectedItems: function() {
        if(this._selectedItems.length !== 2) {
            return;
        }
        var item1 = this._selectedItems[0],
            item2 = this._selectedItems[1];
        if(item1.year < item2.year) {
            return {
                startDate: item1,
                endDate: item2
            };
        }
        if(item1.year > item2.year) {
            return {
                startDate: item2,
                endDate: item1
            };
        }
        if(item1.quarter < item2.quarter) {
            return {
                startDate: item1,
                endDate: item2
            };
        }
        return { 
            startDate: item2,
            endDate: item1
        };
    },
    _onQuarterItemClick: function($item) {
        var year = $item.data('year'),
            quarter = $item.data('quarter');

        if($item.hasClass('laydate-disabled')) {
            return;
        }
        if(this._selectedItems.length > 1) {
            this._selectedItems = [];
            $(this.popup.el).find('.laydate-quarter-item.layui-this').removeClass('layui-this');
        }
        this._selectedItems.push({
            year: year,
            quarter: quarter
        });

        $item.addClass('layui-this');

        this._updateQuarterItemState(); 
        this._updateOkBtn();
    },
    _updateQuarterItemState: function() {
        var $items = $(this.popup.el).find('.laydate-quarter-item').removeClass('laydate-selected'),
            $item,
            year,
            quarter,
            range,
            self = this;
        if(this._selectedItems.length === 2) {
            range = this._analyzeSelectedItems();
            $items.each(function(i, item) {
                $item = $(item);
                year = $item.data('year');
                quarter = $item.data('quarter');

                if(self._isWithin(range.startDate, range.endDate, {year: year, quarter: quarter})) {
                    $item.addClass('laydate-selected');
                }
            });
        }
        
    },
    _updateOkBtn: function() {
        var $okBtn = $(this.popup.el).find('.laydate-btns-confirm');
        if(this._selectedItems.length === 2) {
            $okBtn.removeClass('laydate-disabled');
        } else {
            $okBtn.addClass('laydate-disabled');
        }
    },
    _getSelectedValue: function () {
        var range = this._analyzeSelectedItems();

        return {
            startDate: range ? this._joinValue(range.startDate.year, range.startDate.quarter) : '',
            endDate: range ? this._joinValue(range.endDate.year, range.endDate.quarter) : ''
        };
    },
    value: {startDate: '', endDate: ''},
    _oldValue: {startDate: '', endDate: ''},
    setValue: function(value) {
        if(!value) {
            this.value = {startDate: '', endDate: ''};
            this.text = this._textEl.value = '';
            this._selectedItems = [];
        } else {
            if(typeof value === 'string') {
                value = mini.JSON.decode(value);
            }
    
            if(!this.validateValueFormat(value.startDate) || !this.validateValueFormat(value.endDate)) {
                return;
            }
            this.value = {
                startDate: value.startDate,
                endDate: value.endDate
            };
            var analyzeStart = this._analyzeValue(value.startDate),
                analyzeEnd = this._analyzeValue(value.endDate);
    
            this.text = this._textEl.value = this._joinText(analyzeStart.year, analyzeStart.quarter) + ' ' + this.delimiter + ' ' + this._joinText(analyzeEnd.year, analyzeEnd.quarter);
    
            this._selectedItems = [analyzeStart, analyzeEnd];
        }

    },
    getFormValue: function () {
        return mini.encode(this.value);
    },
    _compareValue: function (value) {
        value = value || {startDate: '', endDate: ''};
        if(this.value.startDate === value.startDate && this.value.endDate === value.endDate) {
            return true;
        }
        return false;
    },
    _onValueChanged: function() {
        
        if (this.value.startDate !== this._oldValue.startDate || this.value.endDate !== this._oldValue.endDate) {
            
            this._oldValue = this.value;
            this.fire('valuechanged', {
                value: this.value,
                oldValue: this._oldValue
            });

            this._oldValue = this.value;
        }
    },
    validate: function() {
        var e = {
            value: this.getValue(),
            errorText: '',
            isValid: true
        };

        if (this.required) {
            // value 是特殊的格式，需要特殊处理
            if (String(e.value.startDate).trim() === '' || String(e.value.endDate).trim() === '') {
                e.isValid = false;
                e.errorText = this.requiredErrorText;
            }
        }

        this.fire('validation', e);

        this.errorText = e.errorText;
        this.setIsValid(e.isValid);
        return this.isValid();
    },
    getAttrs: function(el) {
        var attrs = mini.QuarterRangePicker.superclass.getAttrs.call(this, el);

        mini._ParseString(el, attrs, ['delimiter']);

        return attrs;
    }
});


mini.regClass(mini.QuarterRangePicker, 'quarterrangepicker');

mini.Rate = function () {
    mini.Rate.superclass.constructor.call(this);
};
mini.extend(mini.Rate, mini.Control, {
    uiCls: 'mini-rate',

    iconType: 'star',

    size: 'big',

    value: 0,
    maxValue: 5,
    minValue: 0,

    readOnly: true,

    allowHalf: true,

    _create: function () {
        var arr = [];
        this.el = document.createElement('ul');
        this.el.className = 'mini-rate mini-rate-' + this.iconType;

        for (var i = this.minValue; i < this.maxValue; i++) {
            arr.push('<li class="mini-rate-default"></li>');
        }

        this.el.innerHTML = arr.join('');
    },

    _initEvents: function () {
        var _this = this,
            tmpValue = 0,
            $el = $(this.el);

        function handleMouseMove(e) {
            var $target = $(e.target),
                offsetX = e.pageX - $target.offset().left,
                index = $target.index();

            if (offsetX <= 0) {
                tmpValue = index;
            } else if (_this.allowHalf) {
                // todo: 这里的 .width() 是否会有问题
                tmpValue = index + (offsetX > $target.width() / 2 ? 1 : 0.5);
            } else {
                tmpValue = index + 1;
            }

            _this._showValue(tmpValue);
        }

        function handleMouseLeave() {
            _this._showValue(_this.value);
        }

        function handleClick() {
            _this.setValue(tmpValue);
        }

        if (this.readOnly) {
            $el.off('mousemove', 'li', handleMouseMove);
            $el.off('mouseleave', handleMouseLeave);
            $el.off('click', 'li', handleClick);
        } else {
            $el.on('mousemove', 'li', handleMouseMove);
            $el.on('mouseleave', handleMouseLeave);
            $el.on('click', 'li', handleClick);
        }
    },
    _resize: function () {
        var $rate = $(this.el);

        if (this.size === 'big') {
            $rate.removeClass('mini-rate-small');
        } else if (this.size === 'small') {
            $rate.addClass('mini-rate-small');
        }
    },
    _changeType: function () {
        $(this.el)
            .removeClass('mini-rate-star')
            .removeClass('mini-rate-heart')
            .addClass('mini-rate-' + this.iconType);
    },
    _showValue: function (value) {
        var $children = $(this.el).children(),
            intValue = parseInt(value, 10),
            $last = $children.eq(intValue);

        if (intValue === this.maxValue) {
            $children.removeClass('mini-rate-default mini-rate-half').addClass('mini-rate-active');
        } else {
            $last.prevAll().removeClass('mini-rate-half mini-rate-default').addClass('mini-rate-active');

            $last
                .removeClass('mini-rate-default mini-rate-active mini-rate-half')
                .addClass(value > intValue ? 'mini-rate-half' : 'mini-rate-default');

            $last.nextAll().removeClass('mini-rate-half mini-rate-active').addClass('mini-rate-default');
        }
    },

    // setters&getters
    setValue: function (value) {
        value = parseFloat(value, 10);
        if (value > this.maxValue) {
            value = this.maxValue;
        } else if (value < this.minValue) {
            value = this.minValue;
        }
        this.value = value;
        // this.value = value <= this.maxValue ? value : this.maxValue;
        // this.value = value >= this.minValue ? value : this.minValue;
        this._showValue(this.value);
    },
    getValue: function () {
        return this.value;
    },
    setMaxValue: function (max) {
        this.maxValue = max;

        var $children = $(this.el).children();

        $children.remove();

        var fragment = document.createDocumentFragment(),
            $frag = $(fragment);
        for (var i = 0; i < this.maxValue; i++) {
            $('<li class="mini-rate-default"></li>').appendTo($frag);
        }
        $(this.el).append($frag);

        if (this.maxValue < this.minValue) {
            this.minValue = this.maxValue;
            this.value = this.maxValue;
        }

        if (this.maxValue < this.value) {
            this.value = this.maxValue;
        }

        this.setValue(this.value);
    },
    getMaxValue: function () {
        return this.maxValue;
    },
    setMinValue: function (min) {
        this.minValue = min;
        if (this.minValue > this.maxValue) {
            this.maxValue = this.minValue;
        }
        if (this.minValue > this.value) {
            this.value = this.minValue;
        }
        this._showValue(this.value);
    },
    getMinValue: function () {
        return this.minValue;
    },
    setReadOnly: function (b) {
        this.readOnly = b;
        this._initEvents();
    },
    getReadOnly: function () {
        return this.readOnly;
    },
    setIconType: function (type) {
        if (type === 'star' || type === 'heart') {
            this.iconType = type;
            this._changeType();
        }
    },
    getIconType: function () {
        return this.iconType;
    },
    setSize: function (size) {
        if (size === 'big' || size === 'small') {
            this.size = size;
            this._resize();
        }
    },
    getSize: function () {
        return this.size;
    },

    setAllowHalf: function (v) {
        this.allowHalf = !!v;
    },
    getAllowHalf: function () {
        return this.allowHalf;
    },

    getAttrs: function (el) {
        var attrs = mini.Rate.superclass.getAttrs.call(this, el);
        mini._ParseString(el, attrs, ['iconType', 'size', 'value']);
        mini._ParseInt(el, attrs, ['maxValue', 'minValue']);
        mini._ParseBool(el, attrs, ['readOnly', 'allowHalf']);

        return attrs;
    }
});

mini.regClass(mini.Rate, 'rate');

mini.Repeat = function() {
    mini.Repeat.superclass.constructor.call(this);
};

mini.extend(mini.Repeat, mini.ListControl, {
    // 模板选择器
    templateId: '',
    templateUrl: '',
    url: '',
    // 第三方资源的路径，默认为全局配置mini.externalSrc的值
    externalSrc: '',
    uiCls: 'mini-repeat',

    template: '', // 内部模板

    _create: function() {
        this.el = document.createElement('div');

        this.externalSrc = this.externalSrc || mini.externalSrc;
    },

    setTemplateUrl: function(url) {
        this.templateUrl = url;

        var that = this;
        var xhr = jQuery.ajax({
            url: url,
            async: false,
            success: function(html) {
                that.template = jQuery.trim(html);
            },
            error: function() {
                throw new Error('template not found');
            }
        });

        return xhr;
    },

    getTemplateUrl: function() {
        return this.templateUrl;
    },

    setTemplateId: function(id) {
        this.templateId = id;

        var tpl = document.getElementById(id);

        if (tpl) {
            this.template = jQuery.trim(tpl.innerHTML);
        } else {
            throw new Error('template not found');
        }
    },

    getTemplateId: function() {
        return this.templateId;
    },
    /**
     *
     *
     * @param {} data
     */
    setData: function(data) {
        // this.data = data || { template: [], control: [] };
        this.data = data || [];

        if (this.template) {
            var that = this;
            if (!window.Mustache) {
                mini.loadJS(this.externalSrc + 'mustache.min.js', function() {
                    that._renderHtml();
                });
            } else {
                this._renderHtml();
            }
        } else {
            throw new Error('template not init');
        }
    },

    _destroyChild: function() {
        // 旧的控件要destory掉
        var children = mini.getChildControls(this);
        if (!children.length) {
            return;
        }
        this.fire('beforeChildDestroy');
        children.forEach(function(ctr) {
            ctr && ctr.destroy();
        });
    },
    destroy: function() {
        this._destroyChild();

        mini.Repeat.superclass.destroy.call(this);
    },

    _renderHtml: function() {
        var controlData = this.data.control,
            data = this.data.template || this.data;

        var html = [],
            i,
            len;
        for (i = 0, len = data.length; i < len; i++) {
            html.push(Mustache.render(this.template, data[i]));
        }
        this._destroyChild();
        this.el.innerHTML = html.join('');

        var beforeParseEvent = {
            controlData: controlData,
            template: data,
            cancel: false
        };

        this.fire('beforeChildParse', beforeParseEvent);

        if (beforeParseEvent.cancel === true) {
            return;
        }

        mini.parse(this.el);

        if (controlData) {
            if (!mini.isArray(controlData)) controlData = [];
            var item, control;
            for (i = 0, len = controlData.length; i < len; i++) {
                item = controlData[i];

                for (var id in item) {
                    if (!Object.prototype.hasOwnProperty.call(item, id)) {
                        continue;
                    }
                    control = mini.get(id, this.el);
                    if (control && item[id]) {
                        if (item[id].data) {
                            if (control.loadList) {
                                control.loadList(item[id].data);
                            } else if (control.setData) {
                                control.setData(item[id].data);

                                if (item[id].total && control.setTotalCount) {
                                    control.setTotalCount(item[id].total);
                                }
                            }
                        }
                        if (typeof item[id] !== 'object' && control.setValue) {
                            control.setValue(item[id]);
                        }
                        if (item[id].value && control.setValue) {
                            control.setValue(item[id].value);
                        }
                        if (item[id].text && control.setText) {
                            control.setText(item[id].text);
                        }
                    }
                }
            }
        }
    },

    getAttrs: function(el) {
        var attrs = mini.Repeat.superclass.getAttrs.call(this, el);
        mini._ParseString(el, attrs, ['templateId', 'templateUrl', 'onbeforeChildParse', 'onbeforeChildDestroy']);

        var cs = mini.getChildNodes(el);
        for (var i = 0, l = cs.length; i < l; i++) {
            var node = cs[i];
            var property = node.getAttribute('property');
            if (!property) continue;
            property = property.toLowerCase();
            if (property === 'template') {
                this.template = node.innerHTML;
                break;
            }
        }

        return attrs;
    }
});

mini.regClass(mini.Repeat, 'repeat');

mini.SlideWindow = function() {
    mini.SlideWindow.superclass.constructor.apply(this, arguments);

    this.setAllowDrag(false);
    this.setAllowResize(false);
};
mini.extend(mini.SlideWindow, mini.Window, {
    uiCls: 'mini-slidewindow',
    iconCls: '',
    iconStyle: '',
    duration: 200,
    visible: false,

    x: 0,
    y: 0,
    showModal: false,
    allowResize: false,

    // 页面可见性
    pageVisibility: (function() {
        var prefixSupport,
            keyWithPrefix = function(prefix, key) {
                if (prefix !== '') {
                    // 首字母大写
                    return prefix + key.slice(0, 1).toUpperCase() + key.slice(1);
                }
                return key;
            };
        var isPageVisibilitySupport = (function() {
            var support = false;
            if (typeof window.screenX === 'number') {
                ['webkit', 'moz', 'ms', 'o', ''].forEach(function(prefix) {
                    if (support == false && document[keyWithPrefix(prefix, 'hidden')] != undefined) {
                        prefixSupport = prefix;
                        support = true;
                    }
                });
            }
            return support;
        })();

        var isHidden = function() {
            if (isPageVisibilitySupport) {
                return document[keyWithPrefix(prefixSupport, 'hidden')];
            }
            return undefined;
        };

        var visibilityState = function() {
            if (isPageVisibilitySupport) {
                return document[keyWithPrefix(prefixSupport, 'visibilityState')];
            }
            return undefined;
        };

        return {
            isSupport: isPageVisibilitySupport,
            hidden: isHidden(),
            visibilityState: visibilityState(),
            getVisibilityState: visibilityState,
            eventName: isPageVisibilitySupport ? prefixSupport + 'visibilitychange' : '',
            visibilitychange: function(fn, usecapture) {
                usecapture = undefined || false;
                if (isPageVisibilitySupport && typeof fn === 'function') {
                    return document.addEventListener(
                        prefixSupport + 'visibilitychange',
                        function(evt) {
                            this.hidden = isHidden();
                            this.visibilityState = visibilityState();
                            fn.call(this, evt);
                        }.bind(this),
                        usecapture
                    );
                }
                return undefined;
            }
        };
    })(undefined),

    _create: function() {
        mini.SlideWindow.superclass._create.call(this);

        // 右侧没有按钮 去掉边距
        this._titleEl.style.paddingRight = '0';
        // 确保没有 icon
        this.iconCls = this.iconStyle = '';
        this.setDuration(this.duration);
    },
    // 打开url 则关闭对应销毁 应先滑出 再销毁
    destroy: function() {
        var that = this;
        this.hide().then(function() {
            that._destroy();
        });
    },
    _destroy: function() {
        if (this.pageVisibility.isSupport) {
            jQuery(document).off(this.pageVisibility.eventName + '.' + this._id);
        }
        mini.un(this.el, 'mouseover', this.__OnMouseOver, this);
        mini.un(window, 'resize', this.__OnWindowResize, this);
        mini.Window.superclass.destroy.call(this);
    },
    setDuration: function(duration) {
        if (!$.isNumeric(duration)) {
            return false;
        }
        this.duration = duration;
        var t = this.duration / 1000 + 's';
        jQuery(this.el).css({
            '-webkit-transition-duration': t,
            '-moz-transition-duration': t,
            '-ms-transition-duration': t,
            '-o-transition-duration': t,
            'transition-duration': t
        });
    },
    getDuration: function() {
        return this.duration;
    },
    _initEvents: function() {
        var that = this;
        // Window 上 绑定的有的事件不需要 因此直接采用panel上的即可
        mini.Window.superclass._initEvents.call(this);

        mini._BindEvents(function() {
            // container 上的 over
            mini.on(this.el, 'mouseover', this.__OnMouseOver, this);
            // resize 记录窗口大小
            mini.on(window, 'resize', this.__OnWindowResize, this);
        }, this);

        // 支持则在展示时 layout
        if (this.pageVisibility.isSupport) {
            jQuery(document).on(this.pageVisibility.eventName + '.' + this._id, function(e) {
                var state = that.pageVisibility.getVisibilityState();
                if (state === 'visible') {
                    that.doLayout();
                }
            });
        }
    },
    __OnWindowResize: function() {
        var that = this;
        // 页面可见时才需要处理
        if (!this.pageVisibility.isSupport || this.pageVisibility.getVisibilityState() === 'visible') {
            // 页面可见的情况下 resize 记录大小
            this.__showWidth = jQuery(window).width();
            this.__showHeight = jQuery(window).height();

            // 如果在显示则 doLayout
            if (this.isDisplay()) {
                clearTimeout(this.__resizeTimer);
                this.__resizeTimer = setTimeout(function() {
                    that.doLayout();
                }, 20);
            }
        }
    },
    _initButtons: function() {
        this.buttons = [];
        var close = this.createButton({ name: 'close', cls: 'mini-tools-back icon-left', visible: this.showCloseButton });
        this.buttons.push(close);
    },
    doLayout: function() {
        if (!this.canLayout()) return false;

        mini.setSize(this.el, this.__showWidth, this.__showHeight);
        mini.Window.superclass.doLayout.call(this);
    },
    show: function() {
        var containerEl = document.body;
        if (!this.isRender()) {
            this.render(containerEl);
        }
        var w = this.__showWidth || jQuery(window).width();
        var h = this.__showHeight || jQuery(window).height();

        var $el = jQuery(this.el);
        $el.css({
            'z-index': mini.getMaxZIndex(),
            position: 'fixed',
            width: w,
            height: h,
            top: 0,
            left: 0
        }).show();

        this.setVisible(true);
        if (mini.isIE8 || mini.isIE9) {
            this.doLayout();
        } else {
            clearTimeout(this.__hideTimer);
            clearTimeout(this.__showTimer);
            this.__showTimer = setTimeout(function() {
                $el.addClass('show');
            });
        }
    },
    showAtEl: function() {
        this.show();
    },
    showAtPos: function() {
        this.show();
    },
    hide: function() {
        var dtd = $.Deferred();
        var that = this;
        var $el = jQuery(this.el);
        if (mini.isIE8 || mini.isIE9) {
            that.setVisible(false);
            dtd.resolve();
        } else {
            clearTimeout(this.__hideTimer);
            clearTimeout(this.__showTimer);
            $el.removeClass('show');
            this.__hideTimer = setTimeout(function() {
                that.setVisible(false);
                dtd.resolve();
            }, this.duration);
        }
        return dtd.promise();
    },
    max: function() {},
    restore: function() {}
});

mini.regClass(mini.SlideWindow, 'slidewindow');

mini.Slider = function () {
    mini.Slider.superclass.constructor.call(this);
};
mini.extend(mini.Slider, mini.Control, {
    uiCls: 'mini-slider',

    width: '200px',

    formField: true,

    minValue: 0,
    maxValue: 100,
    step: 1,
    precision: 0,
    showTooltip: true,

    showScale: true, // 是否显示刻度
    interval: 25, // 刻度间隔

    set: function (kv) {
        if (typeof kv === 'string') {
            return this;
        }

        var value = kv.value;
        delete kv.value;

        mini.Slider.superclass.set.call(this, kv);

        // setValue 需要其他属性来计算滑块位置，所以必须放在最后
        if (!mini.isNull(value)) {
            this.setValue(value);
        }
    },

    _create: function () {
        this.el = document.createElement('div');
        this.el.className = 'mini-slider';

        this.el.innerHTML =
            '<div class="mini-slider-runway"><div class="mini-slider-bar"></div><div class="mini-slider-pointer"></div></div>';

        this.runway = this.el.firstChild;
        this.bar = this.runway.firstChild;
        this.pointer = this.runway.lastChild;
    },

    _checkDots: function () {
        var $el = $(this.el),
            $dots = $el.find('.scale-dot'),
            $pointer = $el.find('.mini-slider-pointer');

        $dots.each(function (index, dot) {
            var $dot = $(dot),
                dl = $dot.offset().left,
                pl = $pointer.offset().left + 10;
            dl <= pl ? $dot.addClass('active') : $dot.removeClass('active');
        });
    },
    _initEvents: function () {
        var that = this,
            oldValue,
            newValue,
            $el = $(this.el);

        function handleMouseMove() {
            that._checkDots();
        }

        function handleMouseDown() {
            oldValue = that.value;
            $(window).on('mousemove', handleChange);
            $(window).on('mouseup', handleChange);
            $(window).on('mouseup', handleMouseUp);
            that._checkDots();
        }

        function handleMouseUp() {
            newValue = that.value;
            $(window).off('mousemove', handleChange);
            $(window).off('mouseup', handleChange);
            $(window).off('mouseup', handleMouseUp);

            if (oldValue !== newValue) {
                that.fire('valuechanged', {
                    value: newValue,
                    oldValue: oldValue
                });
            }
            that._checkDots();
        }

        if (this.showScale) {
            $(window).on('mousemove', handleMouseMove);
        } else {
            $(window).off('mousemove', handleMouseMove);
        }

        function handleChange(e) {
            that._handleChange(e);
        }
        $el.on('mousedown', handleMouseDown);
    },

    _afterApply: function () {
        if (this.showTooltip) {
            this.toolTip = new mini.ToolTip();

            this.toolTip.set({
                target: document,
                scope: this.el,
                selector: '[data-slidertooltip]',
                placement: 'top'
            });

            this.toolTip.on('beforeopen', this._onBeforeShowToolTip, this);
        }
    },
    _onBeforeShowToolTip: function (e) {
        var event = {
            content: this.value,
            cancel: false
        };
        this.fire('beforeshowtooltip', event);

        e.content = event.content;
        e.cancel = event.cancel;
    },
    _handleChange: function (e) {
        e.preventDefault && e.preventDefault();

        function clamp(value, min, max) {
            var dx = value - min;
            var dy = max - value;
            if (dx >= 0 && dy >= 0) {
                return value;
            }
            if (Math.abs(dx) >= Math.abs(dy)) {
                return max;
            }
            return min;
        }

        var container = this.el;
        var containerWidth = container.clientWidth;
        // var containerHeight = container.clientHeight;

        var rect = container.getBoundingClientRect();
        var xOffset = rect.left + window.pageXOffset;
        // var yOffset = rect.top + window.pageYOffset;
        var pageX = e.pageX || (e.touches ? e.touches[0].pageX : 0);
        // var pageY = e.pageY || (e.touches ? e.touches[0].pageY : 0);
        var left = clamp(pageX - xOffset, 0, containerWidth);
        // var top = clamp(pageY - yOffset, 0, containerHeight);

        var v, percent, lengthPerStep, steps, event;

        if (left <= 0) {
            percent = 0;
            v = this.minValue;
        } else if (left >= containerWidth) {
            percent = 100;
            v = this.maxValue;
        } else {
            percent = (left * 100) / containerWidth;

            lengthPerStep = 100 / ((this.maxValue - this.minValue) / this.step);
            steps = Math.round(percent / lengthPerStep);
            v = steps * lengthPerStep * (this.maxValue - this.minValue) * 0.01 + this.minValue;
            v = parseFloat(v.toFixed(this.precision));
        }
        this.setValue(v, percent);

        if (this.showTooltip) {
            event = {
                content: v
            };
            this.fire('beforeshowtooltip', event);
            this.toolTip.setContent(event.content);
        }
    },
    setPosition: function (percent) {
        this.bar.style.width = percent + '%';
        this.pointer.style.left = percent + '%';
    },

    setValue: function (value, percent) {
        value = parseFloat(value);
        if (isNaN(value)) {
            value = this.minValue;
        }

        if (this.precisions >= 0) {
            value = value.toFixed(this.precisions);
        }

        if (value > this.maxValue) {
            value = this.maxValue;
        } else if (value < this.minValue) {
            value = this.minValue;
        }
        if (this.value !== value) {
            this.value = value;

            percent = mini.isNumber(percent)
                ? percent
                : ((value - this.minValue) / (this.maxValue - this.minValue)) * 100;

            this.setPosition(percent);

            if (this.showTooltip) {
                this.pointer.setAttribute('data-slidertooltip', value);
            }
        }
        this._checkDots();
    },
    getValue: function () {
        return this.value;
    },
    setMaxValue: function (value) {
        value = parseFloat(value);
        if (isNaN(value)) return;
        value = parseFloat(value);
        if (this.maxValue !== value) {
            this.maxValue = value;

            this._ValueLimit();
        }
    },
    getMaxValue: function () {
        return this.maxValue;
    },
    setMinValue: function (value) {
        value = parseFloat(value);
        if (isNaN(value)) return;
        value = parseFloat(value);
        if (this.minValue !== value) {
            this.minValue = value;

            this._ValueLimit();
        }
    },
    getMinValue: function () {
        return this.minValue;
    },
    setStep: function (value) {
        value = parseFloat(value);
        if (isNaN(value)) return;
        if (this.step !== value) {
            this.step = value;

            this._adjustPrecision();
        }
    },
    getStep: function () {
        return this.step;
    },
    setInterval: function (interval) {
        if (isNaN(interval)) interval = 0;
        this.interval = parseInt(interval, 10);

        var $scale = $(this.el).find('.slider-scale'),
            length = parseInt(this.width, 10),
            tmp = this.minValue;

        $scale.empty();

        while (tmp <= this.maxValue) {
            $('<li class="scale-dot"><span class="scale-value">' + tmp + '</span></li>').appendTo($scale);
            tmp += this.interval;
            // console.log(tmp, this.interval, this.maxValue);
        }
        var $dots = $scale.children(),
            num = $dots.length,
            dotWidth = 10,
            margin = length / (num - 1) - dotWidth;
        $dots.css('marginLeft', margin + 'px');
        $dots.eq(0).css('marginLeft', '0px').addClass('active');
        $scale.width(length + dotWidth);
        this._checkDots();
    },
    getInterval: function () {
        return this.interval;
    },
    setShowScale: function (s) {
        this.showScale = s;
        var $el = $(this.el);

        // 是否显示刻度
        if (this.showScale) {
            if ($el.find('ul').length > 0) return;
            $('<ul class="slider-scale"></ul>').appendTo($el);
            this.setInterval(this.interval);
        } else {
            $el.find('.slider-scale').remove();
        }
    },
    getShowScale: function () {
        return this.showScale;
    },

    _ValueLimit: function () {
        if (this.minValue > this.maxValue) {
            this.maxValue = this.minValue + 100;
        }
        if (this.value < this.minValue) {
            this.setValue(this.minValue);
        }
        if (this.value > this.maxValue) {
            this.setValue(this.maxValue);
        }

        this._adjustPrecision();
    },

    _adjustPrecision: function () {
        var precisions = [this.minValue, this.maxValue, this.step].map(function (item) {
            var decimal = ('' + item).split('.')[1];
            return decimal ? decimal.length : 0;
        });
        this.precision = Math.max.apply(null, precisions);
    },
    getAttrs: function (el) {
        var attrs = mini.Slider.superclass.getAttrs.call(this, el);
        mini._ParseString(el, attrs, ['onvaluechanged', 'onbeforeshowtooltip']);
        mini._ParseInt(el, attrs, ['interval', 'maxValue', 'minValue', 'step']);
        mini._ParseBool(el, attrs, ['showScale']);
        return attrs;
    }
});

mini.regClass(mini.Slider, 'slider');

mini.Spinner = function () {
    mini.Spinner.superclass.constructor.apply(this, arguments);
    this._init();
    this.setValue(this.minValue || 0);
};
mini.extend(mini.Spinner, mini.ButtonEdit, {
    uiCls: 'mini-spinner',

    value: 0,
    minValue: NaN, // 最小值
    maxValue: NaN, // 最大值
    increment: 1, // 步长
    decimalPlaces: -1, //保留的小数点位数
    changeOnMousewheel: true, // 开启鼠标滚轮调节
    // allowLimitValue: true, // 允许限制
    allowLoopValue: true, // 允许循环
    allowNull: false, // 允许 null

    format: '',
    showNumChinese: false,
    // numChineseShowType: 'remarks', // 显示形式，取值为 'tooltip' 和 'remarks'
    // _create: function () {
    //     mini.Spinner.superclass._create.call(this);
    //     mini.append(this.el, '<span class="mini-spinner-chinese-remark"></span>');
    //     this.numChineseRemarkEl = this.el.lastChild;
    // },
    _getButtonHtml: function () {
        var hover =
            'onmouseover="mini.addClass(this, \'' +
            this._buttonHoverCls +
            '\');" ' +
            'onmouseout="mini.removeClass(this, \'' +
            this._buttonHoverCls +
            '\');"';
        return (
            '<span name="trigger" class="mini-buttonedit-button mini-buttonedit-trigger" ' +
            hover +
            '><span class="mini-buttonedit-up"><span class="mini-icon"></span></span><span class="mini-buttonedit-down"><span class="mini-icon"></span></span></span>'
        );
    },
    _init: function () {
        var that = this;
        mini.numeralUtil.initNumeral(function () {
            that.fire('_sourceLoad');
            that.un('_sourceLoad');
        });
    },
    _initEvents: function () {
        mini.Spinner.superclass._initEvents.call(this);

        mini._BindEvents(function () {
            this.on('buttonmousedown', this.__OnButtonMouseDown, this);
            mini.on(this.el, 'wheel', this.__OnWheel, this);
        }, this);
    },
    __OnInputTextChanged: function (e) {
        var value = this.getValue();
        this._oldValue = value;
        // 将中文的 '。' 自动转化成英文的 '.'
        // 此处先将字符串转数字
        var textVal = this._textEl.value;
        if (typeof textVal === 'string') {
            textVal = textVal.replace(/\u3002/g, '.');
        }
        var v = numeral(textVal),
            inputVal = v.value();
        if (this.format.indexOf('%') > -1) {
            this.formatDecimalLength && (inputVal = parseFloat(inputVal.toFixed(this.formatDecimalLength + 2)));
        }
        this.setValue(inputVal);
        if (v !== this.getValue()) {
            this._OnValueChanged();
        }
    },
    // 键盘上下
    __OnInputKeyDown: function (e) {
        mini.Spinner.superclass.__OnInputKeyDown.call(this, e);
        var KEY = mini.Keyboard;

        if (this.isReadOnly() || !this.keyNavEnabled) return;

        switch (e.keyCode) {
            case KEY.Top:
                this._oldValue = this.getValue();
                this._doIncrement(true, true);
                break;
            case KEY.Bottom:
                this._oldValue = this.getValue();
                this._doIncrement(false, true);
                break;
            default:
                break;
        }
    },
    _updateValue: function () {
        var spVal = this.value,
            curTxtVal = this._textEl.value;
        if (spVal == curTxtVal) {
            return;
        }
        this.setValue(curTxtVal);
        this._OnValueChanged();
    },
    // 上下箭头点击、和长按
    __OnButtonMouseDown: function (e) {
        this._updateValue();

        // 可能在事件中弹出 iframe 导致 mouseup不触发 因此在 mouseup 再派发事件
        var isAdd = e.spinType === 'up';
        this._oldValue = this.getValue();
        this._doIncrement(isAdd, false);

        // 鼠标长按会一直变化
        var that = this;
        var timer = setInterval(function () {
            that._doIncrement(isAdd, false);
        }, 150);

        var evName = 'mouseup.' + this.id;
        jQuery(document).on(evName, function () {
            clearInterval(timer);
            jQuery(document).off(evName);
            that._OnValueChanged();
        });
    },
    /**
     * 处理递增、递减的逻辑
     * @param {boolean} isAdd 是否为 increase
     * @param {boolean} fireEvent 是否派发事件，默认为true
     */
    _doIncrement: function (isAdd, fireEvent) {
        if (arguments.length < 2) {
            fireEvent = true;
        }
        var next;
        if (isAdd) {
            next = this.valueData.clone().add(this.increment);
        } else {
            next = this.valueData.clone().subtract(this.increment);
        }
        if (this.allowLoopValue) {
            // 范围循环的情况下 仅仅需要处理溢出的情况
            // 规则：
            // min: 0，max: 10，step: 2，current: 10
            // 10 继续新增为 12 允许循环的情况下 应变成 2 （Δ=12-10 ，next=min + Δ = 2）
            /* var delta = numeral(0);
            if (next.value() < this.minValue) {
                delta = numeral(this.minValue).subtract(next.value()).subtract(this.increment);
                next = numeral(this.maxValue).add(delta.value());
            } else if (next.value() > this.maxValue) {
                delta = numeral(next.value()).subtract(this.maxValue);
                next = numeral(this.minValue).add(delta.value());
            }

            // 再次检查范围
            if (next.value() < this.minValue) {
                next.set(this.minValue);
            } else if (next.value() > this.maxValue) {
                next.set(this.maxValue);
            } */

            // 定义为新规则 超出直接设为新一轮的开始
            if (next.value() > this.maxValue) {
                next = numeral(this.minValue);
            } else if (next.value() < this.minValue) {
                next = numeral(this.maxValue);
            }

            this.setValue(next.value());
            fireEvent && this._OnValueChanged();
        } else {
            // 不循环范围的情况下 直接修正范围
            if (next.value() < this.minValue) {
                next.set(this.minValue);
            } else if (next.value() > this.maxValue) {
                next.set(this.maxValue);
            }
            this.setValue(next.value());
            fireEvent && this._OnValueChanged();
        }
    },
    __OnWheel: function (e) {
        if (this.isReadOnly() || this.changeOnMousewheel === false) return;
        e.stopPropagation();
        e.preventDefault();

        this._updateValue();

        this._oldValue = this.getValue();
        if (e.originalEvent.deltaY > 0) {
            this._doIncrement(false);
        } else {
            this._doIncrement(true);
        }
    },
    _setValue: function (v) {
        if (v === '') {
            v = 0;
        }
        if (typeof v !== 'number') {
            // v = parseFloat(v);
            v = numeral(v).value();
        }
        if (isNaN(v) || v === null) {
            if (this.allowNull) {
                v = null;
            } else {
                var defaultValue = parseFloat(this.defaultValue);
                v = isNaN(defaultValue) ? isNaN(this.minValue) ? 0 : this.minValue : defaultValue;
            }
        } else if (this.decimalPlaces >= 0) {
            v = parseFloat(v.toFixed(this.decimalPlaces));
        }
        this.value = v;
        this._valueEl.value = v;
        this._doValueLimit();

        this.valueData = numeral(this.value || 0);
        this.setText(this.getFormatValue());

        if (this.showNumChinese) {
            var chinese = mini.formatAmountToChinese(this.value, this.formatDecimalLength);
            // if(this.numChineseShowType === 'remarks') {
            //     this.numChineseRemarkEl.innerText = chinese;
            // } else {
            $(this._textEl).attr('data-tooltip', chinese);

            if (mini._controlTips && mini._controlTips._target === this._textEl) {
                mini._controlTips.setContent(chinese);
            }
            //     this.numChineseRemarkEl.innerText = '';
            // }
        }
    },

    setValue: function (v) {
        if (window.numeral) {
            this._setValue(v);
        } else {
            this.on(
                '_sourceLoad',
                function () {
                    this._setValue(v);
                },
                this
            );
        }
    },
    // 从value还原用于计算的 valueData
    _restoreValue: function () {},

    getFormatValue: function () {
        if (this.allowNull && mini.isNull(this.value)) {
            return '';
        }
        if (!this.format) {
            return this.value + '';
        }
        return this.valueData.format(this.format);
    },

    setFormat: function (value) {
        if (typeof value !== 'string') return;
        // 旧格式兼容
        value = mini._oldFormatTransform(value);
        if (this.format !== value) {
            this.format = value;
            if (window.numeral) {
                this.setText(this.getFormatValue());
            }
            var match = value.match(/\.(0+)/);
            if (match) {
                this.formatDecimalLength = match[1].length;
            } else {
                this.formatDecimalLength = null;
            }
        }
    },
    /**
     * 旧格式向新格式的转换
     * @param {*} format
     */
    _oldFormatTransform: function (format) {
        if (/^[ncp](\d+)?$/.test(format)) {
            var type = format[0];
            format = format.substr(1) || '';
            var len = parseInt(format, 10) || 0;
            // 千分位小数
            if (type === 'n') {
                return len === 0 ? '0,0' : '0,0.' + pad(len, '0');
            }
            // 百分比
            if (type === 'p') {
                return len === 0 ? '0%' : '0.' + pad(len, '0') + '%';
            }
            // 货币
            if (type === 'c') {
                return len === 0 ? '$0' : '$0.' + pad(len, '0');
            }
        }
        return format;

        function pad(length, str) {
            if (length === 1) return str;
            return new Array(length + 1).join(str);
        }
    },
    getFormat: function () {
        return this.format;
    },
    setMaxValue: function (value) {
        value = parseFloat(value);
        if (this.maxValue !== value) {
            this.maxValue = value;
            this._doValueLimit();
        }
    },
    getMaxValue: function () {
        return this.maxValue;
    },
    setMinValue: function (value) {
        value = parseFloat(value);
        if (this.minValue !== value) {
            this.minValue = value;
            this._doValueLimit();
        }
    },
    _doValueLimit: function () {
        if (mini.isNull(this.value) && this.allowNull) return;
        if (this.value > this.maxValue) {
            this.setValue(this.maxValue);
        } else if (this.value < this.minValue) {
            this.setValue(this.minValue);
        }
    },
    getMinValue: function (value) {
        return this.minValue;
    },
    setIncrement: function (value) {
        value = parseFloat(value);
        if (isNaN(value)) return;
        // 步长不能比范围还大
        if (this.maxValue && this.minValue && value > this.maxValue - this.minValue) return;
        if (this.increment !== value) {
            this.increment = value;
        }
    },
    getIncrement: function (value) {
        return this.increment;
    },
    setDecimalPlaces: function (value) {
        value = parseInt(value, 10);
        if (isNaN(value) || value < 0) return;
        this.decimalPlaces = value;
    },
    getDecimalPlaces: function () {
        return this.decimalPlaces;
    },
    setAllowNull: function (value) {
        this.allowNull = value;
    },
    getAllowNull: function () {
        return this.allowNull;
    },
    // allowLimitValue 属性没有用了 防止之前代码报错 做兼容不做任何处理
    setAllowLimitValue: function () {},
    getAllowLimitValue: function () {},
    setChangeOnMousewheel: function (value) {
        this.changeOnMousewheel = value === true ? true : false;
    },
    getChangeOnMousewheel: function () {
        return this.changeOnMousewheel;
    },
    getAttrs: function (el) {
        var attrs = mini.Spinner.superclass.getAttrs.call(this, el);

        mini._ParseString(el, attrs, ['minValue', 'maxValue', 'increment', 'decimalPlaces', 'format']);

        mini._ParseBool(el, attrs, ['allowNull', 'changeOnMousewheel', 'allowLoopValue', 'showNumChinese']);

        return attrs;
    }
});

mini.regClass(mini.Spinner, 'spinner');

/**
 * TabsTreeSelect
 * @class
 * @extends mini.Control
 * @constructor
 */
mini.TabsTreeSelect = function () {
    mini.TabsTreeSelect.superclass.constructor.call(this);
};

mini.extend(mini.TabsTreeSelect, mini.ValidatorBase, {
    mapClass: '',
    loadChildWhenChecked: false,
    autoLoad: false,
    resultAsTree: false,
    loadWhenChecked: true,
    text: '',
    value: '',
    width: 660,
    initialData: null,
    height: 353,
    expandOnLoad: false,
    expandOnNodeClick: true,
    idField: 'id',
    textField: 'text',
    nodesField: 'children',
    url: '',
    filterUrl: '',
    filterMode: '',
    data: [],
    tabsConfig: [],
    tabKeys: [],
    showTreeIcon: true,
    showTreeLines: true,
    showFolderCheckBox: true,
    parentField: 'pid',
    filterOnInput: false,
    // 是否只能选择叶子节点
    canCheckParent: false,
    checkRecursive: true,
    autoCheckParent: false,
    checkOnTextClick: true,

    // 是否显示已选的计数
    showSelectedCount: true,

    // 是否显示一键排序
    showSort: false,
    allowSort: false,

    selectedPanelTitle: epoint_local.TabsTreeSelect.selectedPanelTitle,

    delimiter: ',',

    showFullPath: false,
    fullPathDelimiter: '-',
    includeRootNode: false,

    showBorder: false,

    virtualScroll: false,

    uiCls: 'mini-tabstreeselect',

    set: function (options) {
        if (typeof options === 'string') {
            return this;
        }

        var value = options.value;
        delete options.value;
        var text = options.text;
        delete options.text;
        var data = options.data;
        delete options.data;
        var showBorder = options.showBorder;
        delete options.showBorder;
        var tabs = options.tabs;
        delete options.tabs;
        var url = options.url;
        delete options.url;
        var filterUrl = options.filterUrl;
        delete options.filterUrl;
        var filterMode = options.filterMode;
        delete options.filterMode;
        var autoLoad = options.autoLoad;
        delete options.autoLoad;
        var showFullPath = options.showFullPath;
        delete options.showFullPath;
        var fullPathDelimiter = options.fullPathDelimiter;
        delete options.fullPathDelimiter;
        var includeRootNode = options.includeRootNode;
        delete options.includeRootNode;
        // var textField = options.textField;
        // delete options.textField;
        // var idField = options.idField;
        // delete options.idField;
        // var nodesField = options.nodesField;
        // delete options.nodesField;

        mini.TabsTreeSelect.superclass.set.call(this, options);

        if (!mini.isNull(autoLoad)) {
            this.setAutoLoad(autoLoad);
        }
        if (!mini.isNull(url)) {
            this.setUrl(url);
        }
        if (!mini.isNull(tabs)) {
            this.setTabs(tabs, this.autoLoad);
        }
        if (!mini.isNull(data)) {
            this.setData(data);
        }
        if (!mini.isNull(value)) {
            this.setValue(value);
        }
        if (!mini.isNull(text)) {
            this.setText(text);
        }
        if (!mini.isNull(filterUrl)) {
            this.setFilterUrl(filterUrl);
        }
        if (!mini.isNull(filterMode)) {
            this.setFilterMode(filterMode);
        }
        if (!mini.isNull(showFullPath)) {
            this.showFullPath = showFullPath;

            this.tree.showFullPath = showFullPath;
        }
        if (!mini.isNull(fullPathDelimiter)) {
            this.fullPathDelimiter = fullPathDelimiter;
            this.tree.fullPathDelimiter = fullPathDelimiter;
        }
        if (!mini.isNull(includeRootNode)) {
            this.includeRootNode = includeRootNode;

            this.tree.includeRootNode = includeRootNode;
        }

        if (showBorder) {
            this.el.style.borderWidth = '1px';
        }

        // if (!mini.isNull(textField)) {
        //     this.setTextField(textField);
        // }
        // if (!mini.isNull(idField)) {
        //     this.setIdField(idField);
        // }
        // if (!mini.isNull(nodesField)) {
        //     this.setNodesField(nodesField);
        // }

        return this;
    },

    // 用于操作的title提示
    actionTitles: jQuery.extend({}, epoint_local.TabsTreeSelect.actionTitles),

    sortTitles: jQuery.extend({}, epoint_local.TabsTreeSelect.sortTitles),

    // 用于生成 上移、下移、全部删除、删除等 操作元素
    _getActionBtn: function (action, disabled) {
        var span = document.createElement('span');

        span.className =
            'mini-tabstreeselect-action mini-icon ' +
            action +
            (action === 'sort' ? ' none' : '') +
            (disabled ? ' disabled' : '');
        if (action === 'removeall') {
            span.className += ' action-icon icon-trash-svg';
        } else if (action === 'recover') {
            span.className += ' action-icon icon-back-svg';
        }
        span.title = this.actionTitles[action];
        span.setAttribute('data-tooltip', this.actionTitles[action]);

        return span;
    },

    _create: function () {
        var that = this;
        this.el = document.createElement('div');
        this.el.className = 'mini-tabstreeselect';
        // this.el.innerHTML = '<div class="mini-tabstreeselect-left"><div class="mini-tabstreeselect-header"></div><div class="mini-tabstreeselect-content"></div></div><div class="mini-tabstreeselect-right"><div class="mini-tabstreeselect-header"><span class="mini-tabstreeselect-header-title">' + this.selectedPanelTitle + '</span></div><div class="mini-tabstreeselect-content"></div></div>';

        this.el.innerHTML =
            '<div class="mini-tabstreeselect-left"><div class="mini-tabstreeselect-header"></div><div class="mini-tabstreeselect-content"></div></div><div class="mini-tabstreeselect-right"><div class="mini-tabstreeselect-header"><div class="mini-tabstreeselect-header-main"><span class="mini-tabstreeselect-header-title">' +
            this.selectedPanelTitle +
            '</span><span class="mini-tabstreeselect-header-count hidden"></span></div></div><div class="mini-tabstreeselect-content"></div></div>';

        this._leftPanel = this.el.firstChild;
        this._rightPanel = this.el.lastChild;

        this._leftHeader = this._leftPanel.firstChild;
        this._rightHeader = this._rightPanel.firstChild.firstChild;
        this._rightTitle = this._rightHeader.firstChild;
        this._rightCount = this._rightHeader.lastChild;

        this._leftHeader.innerHTML = '<ul class="mini-tabstreeselect-tabs clearfix"></ul>';
        this._tabs = this._leftHeader.firstChild;

        this._leftContent = this._leftPanel.lastChild;
        // 新增所有用户筛选功能配置
        this._leftContent.innerHTML =
            '<div class="mini-personalfilter-wrap clearfix" style="padding-bottom:10px;box-sizing:border-box;"></div>';
        this.personalFilterWrap = this._leftContent.firstChild;
        this.personalFilterWrap.style.display = 'none';

        var filterControlStyle = 'width:calc((100% - 62px - 24px)/2);margin-right:12px;',
            personalFilterControls = {
                bars: {
                    //条线
                    name: 'barsFilterButtonEdit',
                    control: new mini.ButtonEdit(),
                    options: {
                        style: filterControlStyle,
                        emptyText: '请选择条线',
                        showClose: true,
                    },
                    onButtonClickEvent: this._onBarsFilterBtnClick
                },
                name: {
                    //单位、人员搜索
                    name: 'nameFilterTextBox',
                    control: new mini.TextBox(),
                    options: {
                        style: filterControlStyle,
                        emptyText: '单位、人员搜索'
                    },
                    onEnterEvent: this._onPersonalFilterClick
                },
                btn: {
                    //查询按钮
                    control: new mini.Button(),
                    name: 'filterQueryBtn',
                    options: {
                        style: 'float:right;',
                        text: '查询',
                        state: 'primary',
                        emptyText: '人员姓名'
                    },
                    onClickEvent: this._onPersonalFilterClick
                }
            };
        Object.keys(personalFilterControls).forEach(function (key) {
            var data = personalFilterControls[key],
                control = data.control;
            control.set(data.options);
            data.onButtonClickEvent && control.on('buttonclick', data.onButtonClickEvent, that);
            data.onClickEvent && control.on('click', data.onClickEvent, that);
            data.onEnterEvent && control.on('enter', data.onEnterEvent, that);
            that[data.name] = control;
            that[data.name].render(that.personalFilterWrap);
        });

        this._rightContent = this._rightPanel.lastChild;

        this.dimensionComboBox = new mini.ComboBox();
        this.dimensionComboBox.on('valuechanged', this.__onDimensionChanged, this);

        this.dimensionComboBox.render(this._leftContent);
        this.dimensionComboBox.hide();

        this.tree = new mini.FilterTree();

        this.tree.setShowTreeIcon(true);
        this.tree.setStyle('border:0;width:100%;height:100%;overflow:hidden;');
        this.tree.setDefaultRowHeight(33);
        this.tree.setResultAsTree(this.resultAsTree);
        this.tree.setCheckRecursive(this.checkRecursive);
        this.tree.setShowCheckBox(true);
        this.tree.setShowFolderCheckBox(this.showFolderCheckBox);
        this.tree.setExpandOnNodeClick(this.expandOnNodeClick);
        this.tree.setCheckOnTextClick(this.checkOnTextClick);
        this.tree.setFilterOnInput(this.filterOnInput);
        this.tree.setAutoLoad(true);
        this.tree.on('load', this.__OnLoad, this);
        this.tree.on('nodeclick', this.__OnNodeClick, this);
        this.tree.on('nodecheck', this.__OnCheckedChanged, this);
        this.tree.on('expand', this.__OnTreeExpand, this);
        this.tree.on('collapse', this.__OnTreeCollapse, this);
        this.tree.on('beforenodecheck', this.__OnTreeBeforeNodeCheck, this);
        this.tree.on('beforenodeselect', this.__OnTreeBeforeNodeSelect, this);
        this.tree.on('drawnode', this.__OnDrawNode, this);
        this.tree.on('loadnode', this.__OnLoadNode, this);
        this.tree.on('beforeload', this.__OnBeforeLoad, this);
        this.tree.on('filter', this.__OnFilter, this);

        this.tree.useAnimation = true;

        this.tree.render(this._leftContent);

        this._rightContent.innerHTML = '<div class="mini-tabstreeselect-buttons"></div>';
        this._buttons = this._rightContent.firstChild;

        this._listItemTempl =
            '<li class="mini-tabstreeselect-item" guid="{{value}}"><span class="item-name" title="{{name}}">{{name}}</span><i class="mini-tabstreeselect-action mini-icon remove" title="' +
            this.actionTitles.remove +
            '"></i></li>';
        this._selectList = this._selectList({
            tabsTreeSelect: this,
            textField: this.textField,
            idField: this.idField,
            virtualScroll: this.virtualScroll
        });
        this._rightContent.appendChild(this._selectList.el);

        // 上移、下移、删除全部 dom
        // this._buttons.appendChild(this.upBtn = this._getActionBtn('up', true));
        // this._buttons.appendChild(this.downBtn = this._getActionBtn('down', true));
        // this._buttons.appendChild(this.removeallBtn = this._getActionBtn('removeall'));
        // this._buttons.appendChild(this.recoverBtn = this._getActionBtn('recover'));

        if (this.allowSort) {
            this._buttons.appendChild((this.sortBtn = this._getActionBtn('sort')));
            this._buttons.appendChild((this.topBtn = this._getActionBtn('top', true)));
            this._buttons.appendChild((this.bottomBtn = this._getActionBtn('bottom', true)));
        } else {
            mini.addClass(this._rightContent, 'disable-sort');
        }
        // 右侧顶部操作按钮
        this._buttons.appendChild((this.recoverBtn = this._getActionBtn('recover')));
        this._buttons.appendChild((this.removeallBtn = this._getActionBtn('removeall')));

        this.selectNodes = {};
        // 右侧头部显示已选人数
        // 更改的地方比较多，容易与实际选择的个数不一致，该参数废除，直接统计右侧列表的个数
        this.selectedCount = 0;

        this.bindEvents();
    },
    _selectList: function (config) {
        var SelectList = function (config) {
            this.tabsTreeSelect = config.tabsTreeSelect;
            this.nodes = [];
            this.nodeIdMap = {};
            this.virtualScroll = config.virtualScroll || false;
            this.textField = config.textField || 'text';
            this.idField = config.idField || 'value';
            this.el = document.createElement('div');
            this.el.className = 'mini-tabstreeselect-list';
            this.$views = jQuery('<div class="mini-tabstreeselect-views"></div>').appendTo(this.el);
            this.viewTpl =
                '<ul class="mini-tabstreeselect-view">{{#.}}' + this.tabsTreeSelect._listItemTempl + '{{/.}}</ul>';

            // 非虚拟滚动
            this.$view = null;

            // 虚拟滚动
            this.$vscroll = null;
        };
        jQuery.extend(SelectList.prototype, {
            initEvents: function () {
                if (this.virtualScroll) {
                    this.vscrollLock = false;
                    this.viewLock = false;

                    mini.on(this.$vscroll[0], 'scroll', this.__OnVscrollScroll, this);
                    mini.on(this.$views[0], 'scroll', this.__OnViewsScroll, this);
                }
            },
            unBindEvents: function () {
                if (this.$vscroll) {
                    this.vscrollLock = null;
                    mini.un(this.$vscroll[0], 'scroll', this.__OnVscrollScroll, this);
                }
                if (this.$views) {
                    this.viewLock = null;
                    mini.un(this.$views[0], 'scroll', this.__OnViewsScroll, this);
                }
            },
            __OnVscrollScroll: function (evt) {
                if (this.vscrollLock) {
                    this.vscrollLock = false;
                    return;
                }
                var scrollTop = evt.currentTarget.scrollTop;
                var realScrollTop = scrollTop / this.ratio;
                var screenNo = Math.floor((realScrollTop + this.halfLine) / this.oneScreenH);
                this._render(screenNo);

                this.viewLock = true;
                this.$views[0].scrollTop = realScrollTop - Math.max((screenNo - 1) * this.oneScreenH, 0);
            },
            __OnViewsScroll: function (evt) {
                if (this.viewLock) {
                    this.viewLock = false;
                    return;
                }
                // rerender
                if (this.$cur.position().top > this.halfLine) {
                    // prev
                    this._render(this.currentScreenNo - 1);
                } else if (this.$next.position().top < this.halfLine) {
                    // next
                    this._render(this.currentScreenNo + 1);
                }

                // sync vscroll
                var invisibleTop = Math.max((this.currentScreenNo - 1) * this.oneScreenN * this.itemH, 0);
                var realScrollTop = invisibleTop + evt.currentTarget.scrollTop;
                this.vscrollLock = true;
                this.$vscroll[0].scrollTop = realScrollTop * this.ratio;
            },
            doUpdate: function (action, data) {
                if (this.virtualScroll) {
                    this.virtualRender(action, data);
                } else {
                    this.normalRender(action, data);
                }
            },
            virtualRender: function (action, data) {
                if (!this.$vscroll) {
                    // init dom
                    this.$vscroll = jQuery(
                        '<div class="mini-tabstreeselect-vscroll"><div class="mini-tabstreeselect-vscroll-content"></div></div>'
                    ).appendTo(this.el);
                    this.$vscrollContent = this.$vscroll.children().first();
                    this.viewsH = this.$views.height();
                    this.halfLine = this.viewsH / 2;

                    // 插入一条，获取高度。
                    if (!this.itemH) {
                        var $oneView = jQuery('<ul class="mini-tabstreeselect-view"></ul>').appendTo(this.$views);
                        var $oneItem = jQuery(this.tabsTreeSelect._listItemTempl)
                            .addClass('mini-tabstreeselect-box-measure')
                            .appendTo($oneView);
                        this.itemH = $oneItem.outerHeight(true);
                        $oneItem.remove();
                        $oneView.remove();
                    }
                    this.oneScreenN = Math.max(Math.ceil(this.viewsH / this.itemH), 10);
                    this.oneScreenH = this.oneScreenN * this.itemH;

                    this.currentScreenNo = 0;
                    this._syncVscrollHeight();
                    this._render(0, true);

                    // bind events;
                    this.initEvents();
                }

                // 判断是否需要 render
                var index, scrollTop, screenNo, count, lastIndex;
                var inViewsFirstIndex = Math.max(this.currentScreenNo - 1, 0) * this.oneScreenN;
                var inViewsLastIndex =
                    this.currentScreenNo === 0 ? this.oneScreenN * 2 - 1 : inViewsFirstIndex + this.oneScreenN * 3 - 1;
                if (action === 'insert') {
                    this._syncVscrollHeight();
                    index = data.index;
                    count = Array.isArray(data.node) ? data.node.length : 1;
                    lastIndex = index + count - 1;
                    if (
                        (index >= inViewsFirstIndex && index <= inViewsLastIndex) ||
                        (lastIndex >= inViewsFirstIndex && lastIndex <= inViewsLastIndex)
                    ) {
                        scrollTop = this.$views[0].scrollTop;
                        this._render(this.currentScreenNo, true);
                        this.$views[0].scrollTop = scrollTop;
                    }
                } else if (action === 'remove') {
                    this._syncVscrollHeight();
                    index = data.index;
                    count = Array.isArray(data.node) ? data.node.length : 1;
                    lastIndex = index + count - 1;
                    if (index < inViewsFirstIndex) {
                        // currentScreenNo change
                        this.$vscroll[0].scrollTop -=
                            this.itemH *
                            this.ratio *
                            (lastIndex < inViewsFirstIndex ? count : inViewsFirstIndex - index);
                        screenNo = Math.ceil(
                            (this.$vscroll[0].scrollTop / this.ratio + this.halfLine) / this.oneScreenH
                        );
                        this._render(screenNo, true);
                        this.$views[0].scrollTop =
                            this.$vscroll[0].scrollTop / this.ratio - Math.max((screenNo - 1) * this.oneScreenH, 0);
                    } else if (index <= inViewsLastIndex) {
                        scrollTop = this.$views[0].scrollTop;
                        this._render(this.currentScreenNo, true);
                        this.$views[0].scrollTop = scrollTop;
                    }
                } else if (action === 'move') {
                    var oldIndex = data.oldIndex;
                    var newIndex = data.newIndex;
                    if (
                        (oldIndex >= inViewsFirstIndex && oldIndex <= inViewsLastIndex) ||
                        (newIndex >= inViewsFirstIndex && newIndex <= inViewsLastIndex)
                    ) {
                        scrollTop = this.$views[0].scrollTop;
                        this._render(this.currentScreenNo, true);
                        this.$views[0].scrollTop = scrollTop;
                    }

                    if (oldIndex < inViewsFirstIndex && newIndex >= inViewsFirstIndex) {
                        this.$vscroll[0].scrollTop -= this.itemH * this.ratio;
                    } else if (newIndex < inViewsFirstIndex && oldIndex >= inViewsFirstIndex) {
                        this.$vscroll[0].scrollTop += this.itemH * this.ratio;
                    }
                } else if (action === 'update') {
                    index = data.index;
                    if (index >= inViewsFirstIndex && index <= inViewsLastIndex) {
                        if (data.field === 'text') {
                            var text = data.value;
                            this.$views
                                .find('[guid="' + data.node[this.idField] + '"] .item-name')
                                .text(text)
                                .attr('title', text);
                        }
                    }
                } else if (action === 'clear') {
                    this.$views.empty();
                    this.currentScreenNo = 0;
                    this._syncVscrollHeight();
                } else if (action === 'refresh') {
                    this._syncVscrollHeight();
                    this.currentScreenNo = 0;
                    this._render(0, true);
                }
            },
            _syncVscrollHeight: function () {
                if (this.$vscrollContent) {
                    var allItemH = this.nodes.length * this.itemH;
                    var vscrollContentH = Math.min(10000000, allItemH);
                    this.ratio = (vscrollContentH - this.viewsH) / (allItemH - this.viewsH);
                    this.$vscrollContent.height(vscrollContentH);
                }
            },
            _render: function (screenNo, force) {
                var self = this;
                var prevView, curView, nextView;
                if (force || Math.abs(screenNo - this.currentScreenNo) > 1) {
                    if (this.$cur) {
                        this.$cur.remove();
                    }
                    if (this.$prev) {
                        this.$prev.remove();
                    }
                    if (this.$next) {
                        this.$next.remove();
                    }
                    // node tpl name value
                    prevView = tplView(this.nodes.slice((screenNo - 1) * this.oneScreenN, screenNo * this.oneScreenN));
                    this.$prev = $(Mustache.render(this.viewTpl, prevView)).appendTo(this.$views);

                    curView = tplView(this.nodes.slice(screenNo * this.oneScreenN, (screenNo + 1) * this.oneScreenN));
                    this.$cur = $(Mustache.render(this.viewTpl, curView)).appendTo(this.$views);

                    nextView = tplView(
                        this.nodes.slice((screenNo + 1) * this.oneScreenN, (screenNo + 2) * this.oneScreenN)
                    );
                    this.$next = $(Mustache.render(this.viewTpl, nextView)).appendTo(this.$views);

                    this.currentScreenNo = screenNo;
                    return;
                }
                if (screenNo === this.currentScreenNo) {
                    return;
                }
                if (screenNo - this.currentScreenNo === -1) {
                    // prev
                    if (this.$next) {
                        this.$next.remove();
                    }
                    this.$next = this.$cur;
                    this.$cur = this.$prev;

                    prevView = tplView(this.nodes.slice((screenNo - 1) * this.oneScreenN, screenNo * this.oneScreenN));
                    this.$prev = $(Mustache.render(this.viewTpl, prevView)).prependTo(this.$views);
                } else if (screenNo - this.currentScreenNo === 1) {
                    // next
                    if (this.$prev) {
                        this.$prev.remove();
                    }
                    this.$prev = this.$cur;
                    this.$cur = this.$next;

                    nextView = tplView(
                        this.nodes.slice(this.oneScreenN * (screenNo + 1), this.oneScreenN * (screenNo + 2))
                    );
                    this.$next = $(Mustache.render(this.viewTpl, nextView)).appendTo(this.$views);
                }
                this.currentScreenNo = screenNo;

                function tplView(nodes) {
                    return nodes.map(function (node) {
                        return {
                            name: node[self.textField],
                            value: node[self.idField]
                        };
                    });
                }
            },
            normalRender: function (action, data) {
                var self = this;
                if (!this.$view) {
                    this.$view = jQuery('<ul class="mini-tabstreeselect-view"></ul>').appendTo(this.$views);

                    // bind events
                }
                var html, nodes, $beforeNode, $toMoveNode, $node;
                if (action === 'insert') {
                    // item tpl
                    html = [];
                    nodes = data.node;
                    if (!Array.isArray(nodes)) {
                        nodes = [nodes];
                    }
                    nodes.forEach(function (node) {
                        html.push(
                            Mustache.render(self.tabsTreeSelect._listItemTempl, {
                                name: node[self.textField],
                                value: node[self.idField]
                            })
                        );
                    });
                    if (data.index === 0) {
                        this.$view.prepend(html.join(''));
                    } else {
                        $beforeNode = this.$view.children().eq(data.index);
                        if ($beforeNode.length) {
                            jQuery(html.join('')).insertBefore($beforeNode);
                        } else {
                            this.$view.append(html.join(''));
                        }
                    }
                    var selectedGuid = this.tabsTreeSelect.selectedListNode ? this.tabsTreeSelect.selectedListNode.attr('guid') : null;
                    if (selectedGuid) {
                        $('.mini-tabstreeselect-item[guid="' + selectedGuid + '"]').addClass('selected');
                    }
                } else if (action === 'remove') {
                    $toMoveNode = jQuery(this.$view.children().eq(data.index));
                    if (Array.isArray(data.node)) {
                        for (var i = 1, len = data.node.length; i < len; i++) {
                            $toMoveNode = $toMoveNode.add(jQuery(this.$view.children().eq(data.index + i)));
                        }
                    }
                    $toMoveNode.remove();
                } else if (action === 'move') {
                    $toMoveNode = jQuery(this.$view.children().eq(data.oldIndex)).remove();
                    $beforeNode = jQuery(this.$view.children().eq(data.newIndex));
                    if ($beforeNode.length) {
                        $beforeNode.before($toMoveNode);
                    } else {
                        this.$view.append($toMoveNode);
                    }
                } else if (action === 'update') {
                    if (data.field === 'text') {
                        $node = jQuery(this.$view.children().eq(data.index));
                        $node.find('.item-name').text(data.value).attr('title', data.value);
                    }
                } else if (action === 'clear') {
                    this.$view.empty();
                } else if (action === 'refresh') {
                    html = [];
                    this.nodes.forEach(function (node) {
                        html.push(
                            Mustache.render(self.tabsTreeSelect._listItemTempl, {
                                name: node[self.textField],
                                value: node[self.idField]
                            })
                        );
                    });
                    this.$view.html(html.join(''));
                }
            },
            doLayout: function () {
                if (this.virtualScroll) {
                    this.viewsH = this.$views.height();
                    this.halfLine = this.viewsH / 2;

                    // 插入一条，获取高度。
                    if (!this.itemH) {
                        var $oneView = jQuery('<ul class="mini-tabstreeselect-view"></ul>').appendTo(this.$views);
                        var $oneItem = jQuery(this.tabsTreeSelect._listItemTempl)
                            .addClass('mini-tabstreeselect-box-measure')
                            .appendTo($oneView);
                        this.itemH = $oneItem.outerHeight();
                        $oneItem.remove();
                        $oneView.remove();
                    }
                    this.oneScreenN = Math.max(Math.ceil(this.viewsH / this.itemH), 10);
                    this.oneScreenH = this.oneScreenN * this.itemH;

                    this.$vscroll[0].scrollTop = 0;
                }
            },
            cloneNode: function (node) {
                var cNode = {};
                cNode[this.idField] = node[this.idField];
                cNode[this.textField] = this.tabsTreeSelect.tree.getItemText(node);
                return cNode;
            },
            append: function (node) {
                var self = this;
                if (Array.isArray(node)) {
                    var cNodes = [];
                    node.forEach(function (n) {
                        if (!self.nodeIdMap[n[self.idField]]) {
                            cNodes.push(self.cloneNode(n));
                        }
                    });
                    cNodes.forEach(function (n) {
                        self.nodes.push(n);
                        self.nodeIdMap[n[self.idField]] = n;
                    });
                    this.doUpdate('insert', {
                        index: this.nodes.length - cNodes.length,
                        node: cNodes
                    });
                } else if (!this.nodeIdMap[node[this.idField]]) {
                    var cNode = this.cloneNode(node);
                    this.nodes.push(cNode);
                    this.nodeIdMap[cNode[this.idField]] = cNode;
                    this.doUpdate('insert', {
                        index: this.nodes.length - 1,
                        node: cNode
                    });
                }
            },
            prepend: function (node) {
                var self = this;
                if (Array.isArray(node)) {
                    var cNodes = [];
                    node.forEach(function (n) {
                        if (!self.nodeIdMap[n[self.idField]]) {
                            cNodes.push(self.cloneNode(n));
                        }
                    });
                    this.nodes = cNodes.concat(this.nodes);
                    cNodes.forEach(function (n) {
                        self.nodeIdMap[n[self.idField]] = n;
                    });
                    this.doUpdate('insert', {
                        index: 0,
                        node: cNodes
                    });
                } else if (!this.nodeIdMap[node[this.idField]]) {
                    var cNode = this.cloneNode(node);
                    this.nodes.unshift(cNode);
                    this.nodeIdMap[cNode[this.idField]] = cNode;
                    this.doUpdate('insert', {
                        index: 0,
                        node: cNode
                    });
                }
            },
            insertAfter: function (node, afterNode) {
                var targetNode = null;
                if (typeof afterNode === 'object') {
                    targetNode = this.nodeIdMap[afterNode[this.idField]];
                } else if (typeof afterNode === 'string') {
                    targetNode = this.nodeIdMap[afterNode];
                }
                if (targetNode) {
                    var targetIdx = null;
                    var insertNode = null;
                    if (typeof node === 'object') {
                        insertNode = this.nodeIdMap[node[this.idField]];
                    } else if (typeof node === 'string') {
                        insertNode = this.nodeIdMap[node];
                    }

                    if (insertNode) {
                        var insertIdx = this.nodes.indexOf(insertNode);
                        this.nodes.splice(insertIdx, 1);
                        targetIdx = this.nodes.indexOf(targetNode);
                        this.nodes.splice(targetIdx + 1, 0, insertNode);
                        this.doUpdate('move', {
                            oldIndex: insertIdx,
                            newIndex: targetIdx + 1,
                            node: insertNode
                        });
                    } else {
                        var cNode = this.cloneNode(node);
                        targetIdx = this.nodes.indexOf(targetNode);
                        this.nodes.splice(targetIdx + 1, 0, cNode);
                        this.nodeIdMap[cNode[this.idField]] = cNode;
                        this.doUpdate('insert', {
                            index: targetIdx + 1,
                            node: cNode
                        });
                    }
                }
            },
            insertBefore: function (node, beforeNode) {
                var targetNode = null;
                if (typeof beforeNode === 'object') {
                    targetNode = this.nodeIdMap[beforeNode[this.idField]];
                } else if (typeof beforeNode === 'string') {
                    targetNode = this.nodeIdMap[beforeNode];
                }
                if (targetNode) {
                    var targetIdx = null;
                    var insertNode = null;
                    if (typeof node !== 'object') {
                        insertNode = this.nodeIdMap[node];
                    } else {
                        insertNode = this.nodeIdMap[node[this.idField]];
                    }

                    if (insertNode) {
                        var insertIdx = this.nodes.indexOf(insertNode);
                        this.nodes.splice(insertIdx, 1);
                        targetIdx = this.nodes.indexOf(targetNode);
                        this.nodes.splice(targetIdx, 0, insertNode);
                        this.doUpdate('move', {
                            oldIndex: insertIdx,
                            newIndex: targetIdx,
                            node: insertNode
                        });
                    } else {
                        var cNode = this.cloneNode(node);
                        targetIdx = this.nodes.indexOf(targetNode);
                        this.nodes.splice(targetIdx, 0, cNode);
                        this.nodeIdMap[cNode[this.idField]] = cNode;
                        this.doUpdate('insert', {
                            index: targetIdx,
                            node: cNode
                        });
                    }
                }
            },
            remove: function (node) {
                var self = this;
                var targetNodes = [];
                var tNode = null;
                if (typeof node === 'string') {
                    tNode = this.nodeIdMap[node];
                    if (tNode) {
                        targetNodes.push({
                            index: this.nodes.indexOf(tNode),
                            node: tNode
                        });
                    }
                } else if (Array.isArray(node)) {
                    node.forEach(function (n) {
                        tNode = self.nodeIdMap[n[self.idField]];
                        if (tNode) {
                            targetNodes.push({
                                index: self.nodes.indexOf(tNode),
                                node: tNode
                            });
                        }
                    });
                } else if (typeof node === 'object') {
                    tNode = this.nodeIdMap[node[this.idField]];
                    if (tNode) {
                        targetNodes.push({
                            index: this.nodes.indexOf(tNode),
                            node: tNode
                        });
                    }
                }

                if (targetNodes.length) {
                    var i;
                    // 连续索引合并，减少 dom 操作频率
                    targetNodes.sort(function (a, b) {
                        return a.index - b.index;
                    });

                    for (i = targetNodes.length - 1; i >= 0; i--) {
                        tNode = targetNodes[i];
                        this.nodes.splice(tNode.index, 1);
                        delete this.nodeIdMap[tNode.node[this.idField]];
                    }

                    tNode = targetNodes[0];
                    var groupStartIndex = tNode.index;
                    var removeGroup = [tNode.node];

                    for (i = 1; i < targetNodes.length; i++) {
                        tNode = targetNodes[i];

                        if (tNode.index !== targetNodes[i - 1].index + 1) {
                            this.doUpdate('remove', {
                                index: groupStartIndex,
                                node: removeGroup
                            });
                            removeGroup = [tNode.node];
                            groupStartIndex = tNode.index;
                        } else {
                            removeGroup.push(tNode.node);
                        }
                    }

                    if (removeGroup.length) {
                        this.doUpdate('remove', {
                            index: groupStartIndex,
                            node: removeGroup
                        });
                    }
                }
            },
            moveTop: function (nodeValue) {
                this.insertBefore(nodeValue, this.nodes[0]);
            },
            canMoveTop: function (nodeValue) {
                var node = this.nodeIdMap[nodeValue];
                var idx = this.nodes.indexOf(node);
                if (idx === 0) {
                    return false;
                }
                return true;
            },
            moveBottom: function (nodeValue) {
                this.insertAfter(nodeValue, this.nodes[this.nodes.length - 1]);
            },
            canMoveBottom: function (nodeValue) {
                var node = this.nodeIdMap[nodeValue];
                var idx = this.nodes.indexOf(node);
                if (idx === this.nodes.length - 1) {
                    return false;
                }
                return true;
            },
            clear: function () {
                this.nodes = [];
                this.nodeIdMap = {};
                this.doUpdate('clear');
            },
            findNode: function (nodeValue) {
                if (nodeValue) {
                    return this.nodeIdMap[nodeValue];
                }
            },
            setNodes: function (nodes) {
                this.clear();
                if (nodes.length > 0) {
                    this.append(nodes);
                }
            },
            getNodes: function () {
                var self = this;
                return this.nodes.map(function (node) {
                    var cloneNode = {};
                    cloneNode[self.idField] = node[self.idField];
                    cloneNode[self.textField] = node[self.textField];
                    return cloneNode;
                });
            },
            getValue: function () {
                var self = this;
                return this.nodes
                    .map(function (node) {
                        return node[self.idField];
                    })
                    .join(',');
            },
            getText: function () {
                var self = this;
                return this.nodes
                    .map(function (node) {
                        return node[self.textField];
                    })
                    .join(',');
            },
            setText: function (node) {
                var targetNode = this.nodeIdMap[node[this.idField]];
                if (targetNode) {
                    var text = node[this.textField];
                    targetNode[this.textField] = text;
                    this.doUpdate('update', {
                        index: this.nodes.indexOf(targetNode),
                        field: 'text',
                        value: text,
                        node: targetNode
                    });
                }
            },
            setVirtualScroll: function (virtualScroll) {
                if (this.virtualScroll !== !!virtualScroll) {
                    this.virtualScroll = !!virtualScroll;
                    if (this.virtualScroll) {
                        this.unBindEvents();
                        this.$views.empty();
                        this.$view = null;
                    } else {
                        this.unBindEvents();
                        this.$views.empty();
                        this.$vscroll.remove();
                        this.$vscroll = null;
                    }
                    this.doUpdate('refresh');
                }
            },
            getCount: function () {
                return this.nodes.length;
            }
        });

        return new SelectList(config);
    },
    __OnDrawNode: function (evt) {
        this.fire('drawnode', evt);
    },
    __OnTreeBeforeNodeCheck: function (evt) {
        evt.tree = evt.sender;
        this.fire('beforenodecheck', evt);
    },
    __OnTreeBeforeNodeSelect: function (evt) {
        evt.tree = evt.sender;
        this.fire('beforenodeselect', evt);
    },
    __OnTreeExpand: function (evt) {
        this.fire('treeexpand', evt);
    },
    __OnTreeCollapse: function (evt) {
        this.fire('treecollapse', evt);
    },
    __OnNodeClick: function (evt) {
        this.fire('nodeclick', {
            node: evt.node
        });
    },
    __OnBeforeLoad: function (evt) {
        this.fire('beforeload', evt);
    },
    __OnCheckedChanged: function (evt) {
        var node = evt.node;

        // var nodesField = this.getNodesField();
        // var cs = node[nodesField];
        // var me = this;

        if (
            this.loadWhenChecked ||
            !(evt.isLeaf || (!this.checkRecursive && this.canCheckParent) || this._getIsLoaded(node))
        ) {
            var data = {
                node: node,
                eventType: 'checkedchanged'
            };

            if (this.showSort) {
                data.direction = this._curAutoSortDirection;
            }

            var e = {
                url: this.treeUrl,
                data: data,
                sender: this
            };

            this.fire('beforecheckload', e);

            this._loadValue(e);
            // // ie 性能太差，需要显示loading效果
            // var maskTimer;
            // // 慢也有可能是请求慢，所以不能只处理ie，其他浏览器也需要遮罩
            // // if (mini.isIE) {

            // //     maskTimer = setTimeout(function () {
            // //         me.mask();
            // //         me.isMask = true;
            // //     }, 100);

            // // }

            // maskTimer = setTimeout(function () {
            //     me.mask();
            //     me.isMask = true;
            // }, 100);

            // jQuery.ajax({
            //     url: e.url,
            //     data: e.data,
            //     type: 'post',
            //     dataType: 'json',
            //     success: function (data) {
            //         data = mini.getSecondRequestData(data);
            //         if (data) {
            //             var value = me.getValue();
            //             var defaultValue = me.value;
            //             var defaultText = me.text;

            //             var valueArr,
            //                 textArr,
            //                 i = 0,
            //                 len = 0,
            //                 node,
            //                 html = [];

            //             // 优化 by liub @2017-12-14
            //             // 当value值有上千个时，ie浏览器会假死
            //             // 原因是setValue方法中对每一个值都会进行dom的append
            //             // console.time('insertHtml');
            //             // me.setValue(data.value, true);
            //             // me.setText(data.text);
            //             // console.timeEnd('insertHtml');

            //             me._selectList.innerHTML = '';
            //             // me.selectedCount = 0;
            //             me.selectNodes = {};

            //             if (data.value) {
            //                 valueArr = data.value.split(',');
            //                 textArr = data.text.split(',');

            //                 for (len = valueArr.length; i < len; i++) {
            //                     node = {};
            //                     node[me.idField] = valueArr[i];
            //                     node[me.textField] = textArr[i];

            //                     me.selectNodes[valueArr[i]] = node;

            //                     html.push(me._getItemHtml(node));

            //                 }

            //                 // mini.append方法有性能问题
            //                 // mini.append(me._selectList, html.join(''));

            //                 me._selectList.insertAdjacentHTML('afterbegin', html.join(''));

            //                 // me.selectedCount = len;

            //             }

            //             if (maskTimer) {
            //                 clearTimeout(maskTimer);
            //             }
            //             if (me.isMask) {
            //                 me.unmask();
            //                 me.isMask = false;
            //             }
            //             me._updateButtons();
            //             me._setSelectedCount(len);

            //             me.value = defaultValue;
            //             me.text = defaultText;

            //             if (value != me.getValue()) {
            //                 me._OnValueChanged();
            //             }

            //         }
            //     }
            // });
        } else {
            if (node.checked) {
                this._addNode(node);
            } else {
                this._removeNode(node);
            }
        }
        //节点选择时触发事件
        this.fire('nodecheck', {
            node: node,
            checked: node.checked,
            isLeaf: node.isLeaf
        });
    },
    _getIsLoaded: function (node) {
        if (this.tree.isLeaf(node)) {
            return true;
        }

        var cs = node[this.tree.getNodesField()],
            isLoaded = true,
            l = cs ? cs.length : 0;

        if (l) {
            for (var i = 0; i < l; i++) {
                isLoaded = this._getIsLoaded(cs[i]);

                if (!isLoaded) {
                    return false;
                }
            }
        } else {
            return false;
        }

        return true;
    },

    __OnLoadNode: function (evt) {
        var node = evt.node,
            idField = this.idField,
            tree = this.tree,
            selectNodes = this.selectNodes;

        tree.eachChild(node, function (child) {
            if (selectNodes[child[idField]]) {
                tree.checkNode(child);
            } else {
                if (child.checked && !child.isLeaf) {
                    tree.checkNode(child);
                } else {
                    tree.uncheckNode(child);
                }
            }
        });

        // 解决懒加载下，展开节点后，父节点由于有子节点勾选而被勾选问题
        if (node.checked && !this.checkRecursive && !selectNodes[node[idField]]) {
            this.tree.uncheckNode(node);
        }
        // if (node.checked) {
        //     // this._addNode(node);
        //     this.tree._dataSource._doUpdateLoadedCheckedNodes();

        // } else if (!this.canCheckParent && this.checkRecursive) {
        //     var allChildChecked = true;
        //     this.tree.eachChild(node, function (child) {
        //         if (!child.checked) {
        //             allChildChecked = false;
        //             return false;
        //         }
        //     });

        //     allChildChecked && this.tree.checkNode(node);
        // }
    },
    __OnLoad: function (evt) {
        // 记录初次加载数据，用于 "回到初始状态" 按钮
        if (!this.initialData && evt.data) {
            this.initialData = mini.clone(evt.data);
        }

        this.fire('load', evt);
    },

    __OnFilter: function (e) {
        // 搜索时需要记住当前tab的搜索关键字
        // var key = e.sender._filterKey;
        // this.tabsConfig[this._activeTabIndex].filterKey = key;
        // 后台已调整确保数据中的checked状态准确，且由于懒加载，前端自己处理节点选中状态也是不能保证准确的
        // // 由于后台返回的数据中check状态可能不准，需要前台自己重新处理一遍树节点的check状态
        // this.tree.uncheckAllNodes();
        // var valueArr = this.getValue().split(',');
        // for (var i = 0, len = valueArr.length; i < len; i++) {
        //     var node = this.tree.getNode(valueArr[i]);
        //     if (node) {
        //         this.tree.checkNode(node);
        //     }
        // }
    },
    __onDimensionChanged: function (e) {
        var activeTabCfg = this.tabsConfig[this._activeTabIndex],
            activeTabKey = this.tabKeys[this._activeTabIndex],
            url = activeTabCfg.url + ('&dimension=' + e.value),
            filterUrl = activeTabCfg.filterUrl,
            filterKey = this.tree._filterInput.getValue();

        if (filterUrl) {
            this.tree.setFilterUrl(filterUrl + ('&dimension=' + e.value));
        }

        this._setLastDimensionValue(activeTabKey, e.value);

        var needFilter = filterKey && this.tree.filterMode === 'server';

        if (needFilter) {
            this.tree.setAutoLoad(false);
            this.tree.setUrl(url);
            this.treeUrl = url;

            this.tree._doFilter(filterKey);
        } else {
            // setUrl方法会先执行this._dataSource.setUrl(value);触发在框架绑定的beforeload事件，在事件中会获取tree的url提交给服务端。
            // 但是此时tree的url还未更改，导致获取出来的是上一次的值
            // 所以这里需要先手动更新下tree的url值
            this.tree.url = url;
            this.tree.setUrl(url);
            this.treeUrl = url;

            if (filterKey) {
                this.tree._doFilter(filterKey);
            }
        }
    },
    // 所有用户新增筛选_点击岗位按钮打开弹窗事件
    _onBarsFilterBtnClick: function (e) {
        var that = this,
            activeTabCfg = this.tabsConfig[this._activeTabIndex],
            title = activeTabCfg.dialogTitle || '选择条线',
            url = activeTabCfg.dialogUrl || '';
        if (url) {
            epoint.openTopDialog(
                title,
                activeTabCfg.dialogUrl,
                function (data) {
                    if (data.status === 'ok') {
                        that.barsFilterButtonEdit.setValue(data.value);
                        that.barsFilterButtonEdit.setText(data.text);
                    }
                    activeTabCfg.onbarsDialogCloseCallback &&
                        mini._getFunctoin(activeTabCfg.onbarsDialogCloseCallback)(data);
                },
                {
                    width: 500,
                    height: 600
                }
            );
        }
    },
    // 所有用户新增筛选_查询按钮点击事件
    _onPersonalFilterClick: function (e) {
        var activeTabCfg = this.tabsConfig[this._activeTabIndex],
            conditionObj = this._getPersonalFilterData(),
            personalFilterData = encodeURI(JSON.stringify(this._getPersonalFilterData())),
            url = activeTabCfg.url + ('&personalFilterData=' + personalFilterData),
            filterUrl = activeTabCfg.filterUrl,
            filterKey = conditionObj.name;
        if (filterUrl) {
            this.tree.setFilterUrl(filterUrl + ('&personalFilterData=' + personalFilterData));
        }
        var needFilter = this.tree.filterMode === 'server';

        if (needFilter) {
            this.tree.setAutoLoad(false);
            this.tree.setUrl(url);
            this.treeUrl = url;

            this.tree._doFilter(filterKey);
        } else {
            // setUrl方法会先执行this._dataSource.setUrl(value);触发在框架绑定的beforeload事件，在事件中会获取tree的url提交给服务端。
            // 但是此时tree的url还未更改，导致获取出来的是上一次的值
            // 所以这里需要先手动更新下tree的url值
            this.tree.url = url;
            this.tree.setUrl(url);
            this.treeUrl = url;

            if (filterKey) {
                this.tree._doFilter(filterKey);
            }
        }
    },
    _addNode: function (node) {
        if (!this._selectList.el.style.height) {
            this._selectList.el.style.height =
                jQuery(this._rightContent).height() - jQuery(this._buttons).outerHeight(true) + 'px';
            this._selectList.doLayout();
        }

        var value = node[this.idField];
        if (this.canCheckParent || (this.tree.isLeaf(node) && !this.selectNodes[value])) {
            this.selectNodes[value] = node;

            if (this._curAutoSortDirection != 'none') {
                this._addNodeByDirection(node, this._curAutoSortDirection);
            } else {
                this._selectList.append(node);
            }

            // 选中后递增
            // this.selectedCount++;
        } else {
            var childs = this.tree.getChildNodes(node);

            if (!childs.length && !this.tree.isLeaf(node)) {
                if (this.loadChildWhenChecked) {
                    this.tree._dataSource.loadParams.needAll = true;
                    this.tree.loadNode(node);
                    this.tree._dataSource.loadParams.needAll = false;
                }
            } else {
                for (var i = 0, len = childs.length; i < len; i++) {
                    this._addNode(childs[i]);
                }
            }
        }

        // 更新右侧头部计数
        this._setSelectedCount();
    },

    _addNodeByDirection: function (node, direction) {
        var treeValues = this.tree.getValue().split(','),
            nodeValue = node[this.idField],
            index = 0,
            len = treeValues.length,
            targetNodeValue,
            targetNode;

        for (; index < len; index++) {
            if (treeValues[index] === nodeValue) {
                break;
            }
        }
        if (direction === 'asc') {
            targetNodeValue = treeValues[index - 1];
        } else {
            targetNodeValue = treeValues[index + 1];
        }

        targetNode = this._selectList.findNode(targetNodeValue);
        if (targetNode) {
            this._selectList.insertAfter(node, targetNode);
        } else {
            this._selectList.prepend(node);
        }
    },

    _removeNode: function (node) {
        var self = this;
        var list = this._getTreeNodeAsList(node);
        list.forEach(function (n) {
            var value = n[self.idField];
            delete self.selectNodes[value];
        });

        this._selectList.remove(list);

        // 更新右侧头部计数
        this._setSelectedCount();
    },
    _getTreeNodeAsList: function (node, list) {
        if (!list) {
            list = [];
        }
        list.push(node);
        if (this.checkRecursive && !this.tree.isLeaf(node)) {
            var childs = this.tree.getChildNodes(node);
            for (var i = 0, len = childs.length; i < len; i++) {
                this._getTreeNodeAsList(childs[i], list);
            }
        }
        return list;
    },
    // _getItemHtml: function (node) {
    //     return this._listItemTempl.replace(/{{name}}/g, this.tree.getItemText(node)).replace('{{value}}', node[this.idField]);
    // },

    bindEvents: function () {
        var that = this;

        jQuery(this._tabs).on('click', '> li', function () {
            var $item = jQuery(this),
                index = $item.index();

            if (!$item.hasClass('active')) {
                that.activeTab(index);
            }
        });
        jQuery(this._selectList.el)
            .on('click', '.remove', function (e) {
                e.stopPropagation();
                var $item = jQuery(this.parentNode),
                    value = $item.attr('guid'),
                    node = that.tree.getNode(value);

                if ($item.hasClass('selected')) {
                    that.selectedListNode = null;
                }

                // node不在当前激活的tab树里，则不需要再去操作树
                if (!node) {
                    that._selectList.remove(value);
                    delete that.selectNodes[value];

                    // that.selectedCount--;
                    that._setSelectedCount();
                } else {
                    // $item.remove();
                    // delete that.selectNodes[value];
                    // 统一处理 此处调用_removeNode方法更合适
                    that._removeNode(node);

                    that.tree.uncheckNode(node);
                }

                that._updateButtons();
            })
            .on('mousedown', '.mini-tabstreeselect-item', function (e) {
                if (that.allowSort) {
                    that.dragItem = this;
                    that.getDrag().start(e);
                }
            })
            .on('click', '.mini-tabstreeselect-item', function () {
                var $item = jQuery(this);

                if (!$item.hasClass('selected')) {
                    if (that.selectedListNode) {
                        that.selectedListNode.removeClass('selected');
                    }

                    $item.addClass('selected');
                    that.selectedListNode = $item;

                    that._updateButtons();
                }
            });

        jQuery(this._buttons).on('click', '.mini-tabstreeselect-action', function () {
            if (mini.hasClass(this, 'disabled')) return;

            // 自动排序
            if (mini.hasClass(this, 'sort')) {
                that.toggleAutoSort();
            }

            // 往上移动选中记录
            var value;
            if (mini.hasClass(this, 'top')) {
                value = that.selectedListNode.attr('guid');
                that._selectList.moveTop(value);
                that.toggleAutoSort(true);

                // 往下移动选中记录
            } else if (mini.hasClass(this, 'bottom')) {
                value = that.selectedListNode.attr('guid');
                that._selectList.moveBottom(value);
                that.toggleAutoSort(true);

                // 清楚所有记录
            } else if (mini.hasClass(this, 'removeall')) {
                that.clearAll();

                // 返回到初始状态
            } else if (mini.hasClass(this, 'recover')) {
                that.recover();
            }

            that._updateButtons();
        });
    },

    getDrag: function () {
        if (!this.drag) {
            this.drag = new mini.Drag({
                capture: false,
                onStart: mini.createDelegate(this._OnDragStart, this),
                onMove: mini.createDelegate(this._OnDragMove, this),
                onStop: mini.createDelegate(this._OnDragStop, this)
            });
        }
        return this.drag;
    },
    _OnDragStart: function (drag) {
        this._dragProxy = mini.append(document.body, '<div class="mini-tabstreeselect-proxy"></div>');
        this._dragProxy.innerHTML =
            '<div class="mini-tabstreeselect-proxy-inner">' + this.dragItem.outerHTML + '</div>';
        mini.setXY(this._dragProxy, drag.now[0] + 15, drag.now[1] + 18);

        mini.setWidth(this._dragProxy, mini.getBox(this.dragItem).width);

        this.feedbackLine = mini.append(document.body, "<div class='mini-feedback-line'></div>");

        mini.addClass(this.dragItem, 'dragging');
        // 开始拖拽时触发事件
        this.fire('dragstart', {
            dragValue: this.dragItem.getAttribute('guid') //拖拽的节点guid
        });
    },
    _OnDragMove: function (drag) {
        var x = drag.now[0];
        var y = drag.now[1];

        mini.setXY(this._dragProxy, x + 15, y + 18);

        this.targetItem = this.insertAction = null;
        var t = mini.findParent(drag.event.target, 'mini-tabstreeselect-item');

        if (t) {
            this.targetItem = t;
            this.insertAction = 'before';
            var box = mini.getBox(this.targetItem);

            if (y > box.y + box.height / 2) {
                this.insertAction = 'after';
            }

            this.feedbackLine.style.display = 'block';

            if (this.insertAction == 'after') {
                mini.setXY(this.feedbackLine, box.x, box.y + box.height);
            } else {
                mini.setXY(this.feedbackLine, box.x, box.y);
            }

            mini.setWidth(this.feedbackLine, box.width);
        } else {
            this.feedbackLine.style.display = 'none';
        }
    },
    _removeDrag: function () {
        mini.removeNode(this._dragProxy);
        mini.removeNode(this.feedbackLine);
        this._dragProxy = this.feedbackLine = this.dragItem = this.targetItem = null;
    },
    _OnDragStop: function (drag) {
        if (this.targetItem) {
            var targetValue = this.targetItem.getAttribute('guid');
            var dragValue = this.dragItem.getAttribute('guid');
            if (this.insertAction == 'before') {
                this._selectList.insertBefore(dragValue, targetValue);
            } else {
                this._selectList.insertAfter(dragValue, targetValue);
            }
            //  drop拖拽投放时触发事件
            this.fire('drop', {
                dragValue: dragValue, //拖拽的节点guid
                targetValue: targetValue, //目标投放节点guid
                dragAction: this.insertAction //投放方式：add/after/before
            });
            this.toggleAutoSort(true);
        }

        mini.removeClass(this.dragItem, 'dragging');

        this._removeDrag();
    },

    _curAutoSortDirection: 'none',
    toggleAutoSort: function (clearSort) {
        if (!this.showSort) {
            return;
        }
        var direction = clearSort ? 'none' : this._getNextAutoSortDirection();

        mini.removeClass(this.sortBtn, 'asc desc none');
        mini.addClass(this.sortBtn, direction);
        this.sortBtn.setAttribute('title', this.sortTitles[direction]);

        this._curAutoSortDirection = direction;

        if (direction != 'none') {
            this._serverSort(direction);
        }
    },

    _getNextAutoSortDirection: function () {
        switch (this._curAutoSortDirection) {
            case 'asc':
                return 'desc';
            case 'desc':
            default:
                return 'asc';
        }
    },

    // autoSort: function(direction) {
    //     var treeValue = this.tree.getValue();
    //     var needServerSort = treeValue.split(',').length != this.getValue().split(',').length;

    //     if(needServerSort) {
    //         this._serverSort(direction);
    //     } else {
    //         if(direction === 'asc') {
    //             this.setValue(treeValue);
    //         } else {
    //             this.setValue(treeValue.split(',').reverse().join(','));
    //         }
    //     }
    // },

    _serverSort: function (direction) {
        var value = this.getValue();
        var data = {
            value: value,
            direction: direction,
            eventType: 'sortChanged'
        };

        var e = {
            url: this.treeUrl,
            data: data,
            sender: this
        };

        this.fire('beforesortchanged', e);

        if (value && value.split(',').length > 1) {
            this._loadValue(e);
        }
    },

    _loadValue: function (config) {
        var me = this;

        var maskTimer = setTimeout(function () {
            me.mask();
            me.isMask = true;
        }, 100);

        jQuery.ajax({
            url: config.url,
            data: config.data,
            type: 'post',
            dataType: 'json',
            success: function (data) {
                var e = {
                    data: data
                };
                me.fire('beforeloadvalue', e);
                if (e.cancel) {
                    return;
                }
                if (e.value !== undefined) {
                    data = {
                        value: e.value,
                        text: e.text
                    };
                } else {
                    data = mini.getSecondRequestData(data);
                }
                if (data) {
                    var value = me.getValue();
                    // var defaultValue = me.value;
                    // var defaultText = me.text;

                    var valueArr,
                        textArr,
                        i = 0,
                        len = 0,
                        node,
                        nodes = [];

                    // 优化 by liub @2017-12-14
                    // 当value值有上千个时，ie浏览器会假死
                    // 原因是setValue方法中对每一个值都会进行dom的append
                    // console.time('insertHtml');
                    // me.setValue(data.value, true);
                    // me.setText(data.text);
                    // console.timeEnd('insertHtml');

                    // me.selectedCount = 0;
                    me.selectNodes = {};
                    me.canCheckParent && me.tree.uncheckAllNodes();

                    if (data.value) {
                        valueArr = data.value.split(',');
                        textArr = data.text.split(',');

                        for (len = valueArr.length; i < len; i++) {
                            node = me.tree.getNode(valueArr[i]);

                            if (node) {
                                me.tree.checkNode(node);
                            } else {
                                node = {};
                                node[me.idField] = valueArr[i];
                                node[me.textField] = textArr[i];
                            }

                            me.selectNodes[valueArr[i]] = node;

                            // html.push(me._getItemHtml(node));
                            nodes.push(node);
                        }

                        me._selectList.setNodes(nodes);
                        // me.selectedCount = len;
                    } else {
                        me._selectList.setNodes('');
                    }

                    me._updateButtons();
                    me._setSelectedCount(len);

                    // me.value = defaultValue;
                    // me.text = defaultText;

                    if (value != me.getValue()) {
                        me._OnValueChanged();
                    }
                }
            },
            complete: function () {
                if (maskTimer) {
                    clearTimeout(maskTimer);
                }
                if (me.isMask) {
                    me.unmask();
                    me.isMask = false;
                }
            }
        });
    },

    _updateButtons: function () {
        var enable = function (el) {
            mini.removeClass(el, 'disabled');
        };
        var disable = function (el) {
            mini.addClass(el, 'disabled');
        };

        // 如果没有选中的条目 或 选中条目无兄弟节点，则 上移、下移 失效
        var nodeValue = this.selectedListNode ? this.selectedListNode.attr('guid') : null;
        if (!nodeValue) {
            disable(this.topBtn);
            disable(this.bottomBtn);
            return;
        }

        if (this._selectList.canMoveTop(nodeValue)) {
            enable(this.topBtn);
        } else {
            disable(this.topBtn);
        }

        if (this._selectList.canMoveBottom(nodeValue)) {
            enable(this.bottomBtn);
        } else {
            disable(this.bottomBtn);
        }
    },

    getSelectedNodes: function () {
        // var nodes = [],
        //     selectNodes = this.selectNodes,
        //     textField = this.textField;
        // for (var v in this.selectNodes) {
        //     nodes.push({
        //         value: v,
        //         text: this.selectNodes[v][this.textField]
        //     });
        // }

        // 将方法改为获取的节点为排序后的顺序
        // 修改原因：张剑峰反馈框架中都是用过这个方法来获取选中节点的，
        // 但获取出来是未排序的，如果页面上改成getValue的方法，改动量比较大
        // var nodes = [];
        // jQuery(this._selectList).children('li').each(function (index, item) {
        //     var $item = jQuery(item);

        //     nodes.push({
        //         value: $item.attr('guid'),
        //         text: $item.text()
        //     });
        // });
        // return nodes;

        // 虚拟滚动修改
        var self = this;
        var nodes = this._selectList.getNodes();
        return nodes.map(function (node) {
            return {
                value: node[self.idField],
                text: node[self.textField]
            };
        });
    },

    setSelectedNodes: function (nodes) {
        var selectedNodes = [];
        for (var i = 0, len = nodes.length; i < len; i++) {
            var node = this.tree.getNode(nodes[i].value);

            if (node) {
                this.tree.checkNode(node);
            } else {
                node = {};
                node[this.textField] = nodes[i].text;
                node[this.idField] = nodes[i].value;

                this.selectNodes[nodes[i].value] = node;
            }
            selectedNodes.push(node);
        }
        this._selectList.append(selectedNodes);

        // 更新右侧头部计数
        this._setSelectedCount();
    },

    clearAll: function (notCheckTree) {
        // 已选列表中无内容，do nothing
        // if (!this._selectList.innerHTML) return;

        this._selectList.clear();
        this.selectNodes = {};

        this.selectedListNode = null;

        if (!notCheckTree) {
            this.tree.uncheckAllNodes();
        }

        // 清空已选计数
        this._setSelectedCount(0);

        // this._updateButtons();
    },

    setValue: function (value, notCheckTree) {
        this.value = value;
        var valueArr = value.split(',');

        this.clearAll(notCheckTree);
        if (!value) {
            return;
        }

        var nodes = [];
        for (var i = 0, len = valueArr.length; i < len; i++) {
            var node = this.tree.getNode(valueArr[i]);

            if (node) {
                if (!notCheckTree) {
                    this.tree.checkNode(node);
                }
            } else {
                node = {};
                node[this.textField] = node[this.idField] = valueArr[i];
            }
            this.selectNodes[valueArr[i]] = node;

            nodes.push(node);
        }
        // this.selectedCount = len;
        this._selectList.append(nodes);

        this._updateButtons();
        this._setSelectedCount(len);
    },
    getValue: function () {
        return this._selectList.getValue();
    },
    setText: function (text) {
        this.text = text;
        if (!text) return;
        var textArr = text.split(','),
            valueArr = this.value.split(','),
            i = 0,
            len = valueArr.length,
            node,
            v;

        for (; i < len; i++) {
            v = valueArr[i];
            node = this.selectNodes[v];
            if (node) {
                node[this.textField] = textArr[i];
                this._selectList.setText(node);
            }
        }
    },
    getText: function () {
        return this._selectList.getText();
    },
    recover: function () {
        var tree = this.tree;
        // 移除搜索无结果提示
        tree._removeFilterEmptyText($(tree._rowsViewEl));

        // 清空搜索条件
        var _filterInput = tree._filterInput;
        _filterInput.setValue('');
        _filterInput.setText('');

        if (this.initialData) {
            if (this.resultAsTree) {
                tree.setData(this.initialData);
            } else {
                tree.loadList(this.initialData);
            }
        }

        // 初始化 tab高亮效果
        var $firstLi = $(this._tabs).find('li').eq(0);
        $firstLi.addClass('active').siblings().removeClass('active');

        this.setValue(this.value);
        this.setText(this.text);
    },
    setSelectedPanelTitle: function (title) {
        this.selectedPanelTitle = title;
        // this._rightHeader.innerHTML = title;

        // revise by chendongshun at 2017.05.09
        // cause : 设置右侧头部标题后样式错误
        // _rightHeader.innerHTML 为 '<span class="mini-tabstreeselect-header-title">已选人员</span>' 应只设置其内部
        // 准确地来说应该使用firstElementChild。
        // 但考虑需要兼容ie8，同时控件内部的html是代码直接书写的，不存在空文本节点，直接使用firstChild。
        // this._rightHeader.firstChild.innerHTML = title;
        this._rightTitle.innerHTML = title;
    },

    _setSelectedCount: function (count) {
        // if (count !== undefined) {
        //     this.selectedCount = count;
        // }
        // if (this.showSelectedCount) {
        //     if (this.selectedCount !== 0) {
        //         mini.removeClass(this._rightCount, 'hidden');
        //     } else {
        //         mini.addClass(this._rightCount, 'hidden');
        //     }
        //     // 直接赋值数字 括号用css实现
        //     this._rightCount.innerHTML = this.selectedCount;
        // }

        // 直接获取右侧列表的个数
        if (this.showSelectedCount) {
            count = count >= 0 ? count : this._selectList.getCount();

            if (count !== 0) {
                mini.removeClass(this._rightCount, 'hidden');
            } else {
                mini.addClass(this._rightCount, 'hidden');
            }
            // 直接赋值数字 括号用css实现
            this._rightCount.innerHTML = count;
        }
    },

    setShowSelectedCount: function (show) {
        this.showSelectedCount = show === true ? true : false;

        if (this.showSelectedCount) {
            mini.removeClass(this._rightCount, 'hidden');
        } else {
            mini.addClass(this._rightCount, 'hidden');
        }
    },
    getShowSelectedCount: function () {
        return this.showSelectedCount;
    },

    doLayout: function () {
        var h = jQuery(this.el).height();
        this._leftPanel.style.height = h + 'px';
        this._rightPanel.style.height = h + 'px';

        var s_h = jQuery(this._rightContent).height() - jQuery(this._buttons).outerHeight(true);
        this._selectList.el.style.height = (s_h >= 0 ? s_h : 0) + 'px';
        this._selectList.doLayout();
        this.tree.doLayout();
    },

    setTabs: function (tabs, updateTree) {
        var i,
            len,
            tabArr = [],
            hasParam = this.url.indexOf('?') > 0;

        this.tabsConfig = [];
        this.tabKeys = [];
        for (i = 0, len = tabs.length; i < len; i++) {
            tabArr.push('<li>' + tabs[i].tabText + '</li>');
            var key = (hasParam ? '&' : '?') + 'tabKey=' + tabs[i].tabKey;
            this._addTabConfig(tabs[i], key);
            this.tabKeys.push(tabs[i].tabKey);

            if (tabs[i].showDimension) {
                this.showDimension = true;
            }
            if (tabs[i].showPersonalFilter) {
                this.showPersonalFilter = true;
            }
        }
        this._tabs.innerHTML = tabArr.join('');

        this.doLayout();
        this._doUpdateTabs();
        this.activeTab(0, updateTree);
    },
    _addTabConfig: function(tab, key) {
        this.tabsConfig.push({
            url: this.url + key,
            filterMode: tab.filterMode,
            filterUrl: this.filterUrl ? this.filterUrl + key : undefined,
            showDimension: tab.showDimension,
            showPersonalFilter: tab.showPersonalFilter,
            dialogUrl: tab.dialogUrl,
            dialogTitle: tab.dialogTitle,
            onbarsDialogCloseCallback: tab.onbarsDialogCloseCallback,
            barsFilterEmptyText: tab.barsFilterEmptyText,
            nameFilterEmptyText: tab.nameFilterEmptyText
        });
    },

    addTab: function (tab, updateTree) {
        var hasParam = this.url.indexOf('?') > 0;

        var key = (hasParam ? '&' : '?') + 'tabKey=' + tab.tabKey;
        this._addTabConfig(tab, key);
        this.tabKeys.push(tab.tabKey);

        jQuery('<li>' + tab.tabText + '</li>').appendTo(this._tabs);

        this.doLayout();
        this._doUpdateTabs();
        if (updateTree !== false) {
            this.activeTab(this.tabsConfig.length - 1, true);
        }
    },
    _moveStep: 22,
    _totalMove: 0,
    _tabSpace: 0,
    _tabsHeaderWidth: '',
    _tabsWidth: '',
    _buttonNavWidth: '',
    _doUpdateTabs: function () {
        var $leftHeader = $(this._leftHeader),
            headerHeight = $leftHeader.outerHeight(),
            $leftTabs = $(this._tabs),
            me = this;

        me._tabsHeaderWidth = $leftHeader.outerWidth();
        me._tabsWidth = 'auto';
        $leftTabs.css({ width: 'auto', height: 'auto' });

        var tabsHeight = $leftTabs.outerHeight(),
            tabsWidth = $leftTabs.outerWidth(),
            $aleardyNav = $leftHeader.find('.mini-tabstreeselect-nav');

        // 重置movebox并移除切换按钮
        if ($aleardyNav.length > 0) {
            $leftTabs.css('left', 0);
            me._totalMove = 0;
            me._tabSpace = 0;
            $aleardyNav.remove();
        }

        if (tabsHeight > headerHeight || tabsWidth > me._tabsHeaderWidth) {
            var navDom =
                    '<div class="mini-tabstreeselect-nav"><span class="mini-tabstreeselect-leftButton mini-icon mini-disabled"></span><span class="mini-tabstreeselect-rightButton mini-icon"></span></div>',
                totalLength = 0,
                $tabItems = $leftTabs.find('li');

            $leftHeader.append(navDom);
            $tabItems.each(function (i, item) {
                var $curItem = $(item);
                if (i === 1) {
                    me._tabSpace = parseInt($curItem.css('margin-left'));
                }
                totalLength = totalLength + Math.ceil($curItem.outerWidth());
            });

            totalLength = totalLength + me._tabSpace * ($tabItems.length - 1);
            $leftTabs.css('width', totalLength);
            me._tabsWidth = totalLength;

            // 绑定点击事件
            var tabsMoveStep = this._moveStep,
                $buttonNav = $leftHeader.find('.mini-tabstreeselect-nav'),
                $leftButton = $leftHeader.find('.mini-tabstreeselect-leftButton'),
                $rightButton = $leftHeader.find('.mini-tabstreeselect-rightButton');

            me._buttonNavWidth = $buttonNav.outerWidth();

            $leftButton
                .off('mousedown')
                .on('mousedown', function () {
                    if ($leftButton.hasClass('mini-disabled')) return;
                    if ($rightButton.hasClass('mini-disabled')) {
                        $rightButton.removeClass('mini-disabled');
                    }

                    me._scrollTimer = setInterval(function () {
                        me._totalMove = me._totalMove - tabsMoveStep;
                        me.changeNavBtnState();
                        var curMove = -me._totalMove + 'px';
                        $leftTabs.css('left', curMove);
                    }, 25);
                })
                .off('mouseup')
                .on('mouseup', function () {
                    me._clearScrollTimer();
                });

            $rightButton
                .off('mousedown')
                .on('mousedown', function () {
                    if ($rightButton.hasClass('mini-disabled')) return;
                    if ($leftButton.hasClass('mini-disabled')) {
                        $leftButton.removeClass('mini-disabled');
                    }

                    me._scrollTimer = setInterval(function () {
                        me._totalMove = me._totalMove + tabsMoveStep;
                        me.changeNavBtnState();
                        var curMove = -me._totalMove + 'px';
                        $leftTabs.css('left', curMove);
                    }, 25);
                })
                .off('mouseup')
                .on('mouseup', function () {
                    me._clearScrollTimer();
                });
        }
    },
    changeNavBtnState: function () {
        var $leftHeader = $(this._leftHeader),
            $leftButton = $leftHeader.find('.mini-tabstreeselect-leftButton'),
            $rightButton = $leftHeader.find('.mini-tabstreeselect-rightButton');

        if (this._totalMove === 0) {
            $leftButton.addClass('mini-disabled');
            $rightButton.removeClass('mini-disabled');
            this._clearScrollTimer();
        } else if (this._totalMove > this._tabsWidth - this._tabsHeaderWidth + this._buttonNavWidth) {
            $rightButton.addClass('mini-disabled');
            $leftButton.removeClass('mini-disabled');
            this._clearScrollTimer();
        }
    },
    _clearScrollTimer: function () {
        clearInterval(this._scrollTimer);
        this._scrollTimer = null;
    },

    _getDimensionKey: function (tabKey) {
        return this.id + '_' + tabKey;
    },
    _getLastDimensionValue: function (tabKey) {
        var key = this._getDimensionKey(tabKey),
            val = mini.Cookie.get(key);

        return val;
    },
    _setLastDimensionValue: function (tabKey, val) {
        document.cookie = this._getDimensionKey(tabKey) + '=' + escape(val) + ';path=' + window.location.pathname;
    },
    // 所有用户筛选功能_获取key值
    _getPersonalFiltersKey: function (tabKey) {
        return this.id + '_filters_' + tabKey;
    },
    // 所有用户筛选功能_筛选条件控件设置值
    _setPersonalFilterData: function (obj) {
        this.barsFilterButtonEdit.setValue(obj.bar);
        this.barsFilterButtonEdit.setText(obj.barText);
        this.nameFilterTextBox.setValue(obj.name);
    },
    // 所有用户筛选功能_获取筛选条件值
    _getPersonalFilterData: function () {
        return {
            bar: this.barsFilterButtonEdit.value,
            barText: this.barsFilterButtonEdit.text,
            name: this.nameFilterTextBox.value
        };
    },

    moveToActiveTab: function () {
        if (this._tabSpace > 0) {
            var activeIndex = this._activeTabIndex,
                $leftTabs = $(this._tabs),
                $tabItems = $leftTabs.find('li'),
                activeWidth = 0,
                activeMoveWidth = 0;

            if (activeIndex !== 0) {
                $tabItems.each(function (i, item) {
                    if (i <= activeIndex) {
                        activeWidth = activeWidth + $(item).outerWidth();
                    }
                });

                activeWidth = activeWidth + this._tabSpace * activeIndex;

                if (activeWidth > this._tabsHeaderWidth) {
                    var moveWidth = activeWidth - this._tabsHeaderWidth + this._buttonNavWidth,
                        activeMoveStep = Math.ceil(moveWidth / this._moveStep),
                        activeMoveWidth;

                    this._totalMove = activeMoveStep * this._moveStep;
                    activeMoveWidth = -this._totalMove + 'px';
                } else {
                    this._totalMove = 0;
                }
            }

            // 切换按钮状态
            this.changeNavBtnState();
            $leftTabs.css('left', activeMoveWidth);
        }
    },
    _activeTabIndex: 0,
    activeTab: function (index, updateTree) {
        var config = this.tabsConfig[index],
            $tab = jQuery(this._tabs).children().eq(index),
            dimension,
            url,
            filterUrl;

        if (config) {
            if (!$tab.hasClass('active')) {
                $tab.siblings('.active').removeClass('active');
                $tab.addClass('active');
            }

            this._activeTabIndex = index;
            this.moveToActiveTab();

            // 移除搜索无结果提示
            this.tree._removeFilterEmptyText($(this.tree._rowsViewEl));

            var filterKey = this.tree._filterInput.getValue();
            this.tree._filterKey = filterKey;

            url = config.url;
            filterUrl = config.filterUrl;

            if (config.showDimension) {
                dimension = this._getLastDimensionValue(this.tabKeys[index]);
                if (dimension) {
                    this.dimensionComboBox.setValue(dimension);
                } else {
                    dimension = this.dimensionComboBox.getValue();
                }
                url += '&dimension=' + dimension;

                filterUrl && (filterUrl += '&dimension=' + dimension);

                this.dimensionComboBox.show();
                this.tree.setHeight($(this._leftContent).height() - this.dimensionComboBox.getHeight() - 5);
            } else {
                this.dimensionComboBox.hide();
                this.tree.setHeight('100%');
            }
            // 所有用户新增条件筛选
            if (config.showPersonalFilter) {
                personalFilterStringifyData = encodeURI(JSON.stringify(this._getPersonalFilterData()));
                
                url += '&personalFilterData=' + personalFilterStringifyData;
                filterUrl && (filterUrl += '&personalFilterData=' + personalFilterStringifyData);
                this.personalFilterWrap.style.display = 'block';
                this.tree.setHeight($(this._leftContent).height() - this.personalFilterWrap.offsetHeight - 5);
                this.tree._filterInput.hide();
                filterKey = this.nameFilterTextBox.getValue();
                this.tree._filterKey = filterKey;
                config.barsFilterEmptyText && this.barsFilterButtonEdit.setEmptyText(config.barsFilterEmptyText);
                config.nameFilterEmptyText && this.nameFilterTextBox.setEmptyText(config.nameFilterEmptyText);

            } else {
                this.personalFilterWrap.style.display = 'none';
                this.tree.setHeight('100%');
                this.tree._filterInput.show();
            }

            if (config.filterMode) {
                this.tree.setFilterMode(config.filterMode);
            }
            if (filterUrl) {
                this.tree.setFilterUrl(filterUrl);
            }

            var needFilter = filterKey && this.tree.filterMode === 'server';

            if (!this.url) {
                return;
            }
            if (needFilter) {
                this.tree.setAutoLoad(false);
                this.tree.setUrl(url);
                this.treeUrl = url;

                this.tree._doFilter(filterKey);
            } else {
                if (updateTree === false) {
                    this.tree.setAutoLoad(false);
                } else {
                    this.tree.setAutoLoad(true);
                }

                this.tree._dataSource.ajaxData = {
                    activeTab: true
                };

                this.tree.setUrl(url);

                // 加载后把activeTab标识清空
                this.tree._dataSource.ajaxData = null;

                if (this.tree._dataSource.loadParams) {
                    this.tree._dataSource.loadParams.activeTab = false;
                }

                this.treeUrl = url;

                if (needFilter || updateTree === false) {
                    this.tree.setAutoLoad(true);
                }

                if (filterKey) {
                    this.tree._doFilter(filterKey);
                }
            }
        }
    },

    /**
     *
     * function setData(data)
     * @member mini.TabsTreeSelect
     * @param {Array} data
     *
     */
    setData: function (data) {
        if (typeof data === 'string') {
            data = eval('(' + data + ')');
        }

        var treeData = data.tree || data,
            dimensionData = data.dimension,
            barsFilterData = data.barsFilterData;

        if (!mini.isArray(treeData)) {
            treeData = [];
        }

        if (!this.initialData && treeData) {
            this.initialData = mini.clone(treeData);
        }
        if (this.resultAsTree) {
            this.tree.setData(treeData);
        } else {
            this.tree.loadList(treeData);
        }

        if (!mini.isArray(dimensionData)) {
            dimensionData = [];
        }
        this.dimensionComboBox.setData(dimensionData);
        this.data = data;
    },

    /**
     *
     * function getData()
     * @member mini.TabsTreeSelect
     * @returns {Array}
     *
     */
    getData: function () {
        return this.data;
    },

    /**
     *
     * function setUrl(url)
     * @member mini.TabsTreeSelect
     * @param {String} url
     *
     */
    setUrl: function (url) {
        this.url = url;
        this._updateTabsUrl();
    },
    /**
     *
     * function getUrl()
     * @member mini.TabsTreeSelect
     * @returns {String}
     *
     */
    getUrl: function () {
        return this.url;
    },

    getAutoLoad: function () {
        return this.autoLoad;
    },
    setAutoLoad: function (autoLoad) {
        this.autoLoad = autoLoad;
    },

    setTabKeys: function (keys) {
        this.tabKeys = keys;
        this._updateTabsUrl();
    },

    _updateTabsUrl: function () {
        var i,
            len = Math.min(this.tabKeys.length, this.tabsConfig.length),
            hasParam = this.url.indexOf('?') > 0;

        if (len > 0) {
            for (i = 0; i < len; i++) {
                var key = (hasParam ? '&' : '?') + 'tabKey=' + this.tabKeys[i];
                this.tabsConfig[i].url = this.url + key;
                this.tabsConfig[i].filterUrl = this.filterUrl ? this.filterUrl + key : undefined;
            }

            this.activeTab(0, this.autoLoad);
        }
    },

    load: function () {
        this.tree.load();
    },
    /**
     *
     * function setResultAsTree(resultAsTree)
     * @member mini.TabsTreeSelect
     * @param {Boolean} resultAsTree
     *
     */
    setResultAsTree: function (resultAsTree) {
        this.resultAsTree = resultAsTree;
        if (this.tree) {
            this.tree.setResultAsTree(resultAsTree);
        }
    },
    /**
     *
     * function getResultAsTree()
     * @member mini.TabsTreeSelect
     * @returns {Boolean}
     *
     */
    getResultAsTree: function () {
        return this.resultAsTree;
    },
    /**
     *
     * function setParentField(parentField)
     * @member mini.TabsTreeSelect
     * @param {String} parentField
     *
     */
    setParentField: function (parentField) {
        this.parentField = parentField;
        if (this.tree) {
            this.tree.setParentField(parentField);
        }
    },
    /**
     *
     * function getParentField()
     * @member mini.TabsTreeSelect
     * @returns {String}
     *
     */
    getParentField: function () {
        return this.parentField;
    },
    setDataField: function (dataField) {
        this.dataField = dataField;
        if (this.tree) {
            this.tree.setDataField(dataField);
        }
    },
    /**
     *
     * function getDataField()
     * @member mini.TabsTreeSelect
     * @returns {String}
     *
     */
    getDataField: function () {
        return this.dataField;
    },
    /**
     *
     * function setIdField(idField)
     * @member mini.TabsTreeSelect
     * @param {String} idField
     *
     */
    setIdField: function (idField) {
        if (this.tree) {
            this.tree.setIdField(idField);
        }
        this.idField = idField;
    },
    /**
     *
     * function getIdField()
     * @member mini.TabsTreeSelect
     * @returns {String}
     *
     */
    getIdField: function () {
        return this.idField;
    },

    getTextField: function () {
        return this.textField;
    },
    setTextField: function (textField) {
        this.textField = textField;
        if (this.tree) {
            this.tree.setTextField(textField);
        }
    },

    getNodesField: function () {
        return this.nodesField;
    },
    setNodesField: function (nodesField) {
        this.nodesField = nodesField;
        if (this.tree) {
            this.tree.setNodeField(nodesField);
        }
    },
    /**
     *
     * function setShowTreeIcon(showTreeIcon)
     * @member mini.TabsTreeSelect
     * @param {Boolean} showTreeIcon
     *
     */
    setShowTreeIcon: function (showTreeIcon) {
        this.showTreeIcon = showTreeIcon;
        if (this.tree) {
            this.tree.setShowTreeIcon(showTreeIcon);
        }
    },
    /**
     *
     * function getShowTreeIcon()
     * @member mini.TabsTreeSelect
     * @returns {Boolean}
     *
     */
    getShowTreeIcon: function () {
        return this.showTreeIcon;
    },
    /**
     *
     * function setShowTreeLines(showTreeLines)
     * @member mini.TabsTreeSelect
     * @param {Boolean} showTreeLines
     *
     */
    setShowTreeLines: function (showTreeLines) {
        this.showTreeLines = showTreeLines;
        if (this.tree) {
            this.tree.setShowTreeLines(showTreeLines);
        }
    },
    /**
     *
     * function getShowTreeLines()
     * @member mini.TabsTreeSelect
     * @returns {Boolean}
     *
     */
    getShowTreeLines: function () {
        return this.showTreeLines;
    },
    setShowFolderCheckBox: function (showFolderCheckBox) {
        this.showFolderCheckBox = showFolderCheckBox;
        if (this.tree) {
            this.tree.setShowFolderCheckBox(showFolderCheckBox);
        }
    },
    getShowFolderCheckBox: function () {
        return this.showFolderCheckBox;
    },
    setFilterUrl: function (url) {
        this.filterUrl = url;
        if (this.tree) {
            this.tree.setFilterUrl(url);
        }
    },
    getFilterUrl: function () {
        return this.filterUrl;
    },
    setFilterMode: function (filterMode) {
        this.filterMode = filterMode;
        if (this.tree) {
            this.tree.setFilterMode(filterMode);
        }
    },
    getFilterMode: function () {
        return this.filterMode;
    },
    setFilterOnInput: function (filterOnInput) {
        this.filterOnInput = !!filterOnInput;
        if (this.tree) {
            this.tree.setFilterOnInput(filterOnInput);
        }
    },
    getFilterOnInput: function () {
        return this.filterOnInput;
    },
    setCanCheckParent: function (canCheckParent) {
        this.canCheckParent = canCheckParent;
        this.checkRecursive = !canCheckParent;
        if (this.tree) {
            this.tree.setCheckRecursive(!canCheckParent);
        }
    },
    getCanCheckParent: function () {
        return this.canCheckParent;
    },
    setCheckRecursive: function (checkRecursive) {
        this.checkRecursive = checkRecursive;
        this.canCheckParent = !checkRecursive;
        if (this.tree) {
            this.tree.setCheckRecursive(checkRecursive);
        }
    },
    getCheckRecursive: function () {
        return this.checkRecursive;
    },
    setAutoCheckParent: function (autoCheckParent) {
        this.autoCheckParent = autoCheckParent;
        if (this.tree) {
            this.tree.setAutoCheckParent(autoCheckParent);
        }
    },
    getAutoCheckParent: function () {
        return this.AutoCheckParent;
    },
    setExpandOnLoad: function (expandOnLoad) {
        this.expandOnLoad = expandOnLoad;
        if (this.tree) {
            this.tree.setExpandOnLoad(expandOnLoad);
        }
    },
    getExpandOnLoad: function () {
        return this.expandOnLoad;
    },

    setCheckOnTextClick: function (checkOnTextClick) {
        this.checkOnTextClick = checkOnTextClick;
        if (this.tree) {
            this.tree.setCheckOnTextClick(checkOnTextClick);
        }
    },

    setExpandOnNodeClick: function (expandOnNodeClick) {
        this.expandOnNodeClick = expandOnNodeClick;
        if (this.tree) {
            this.tree.setExpandOnNodeClick(expandOnNodeClick);
        }
    },

    getShowFullPath: function () {
        return this.showFullPath;
    },

    getFullPathDelimiter: function () {
        return this.fullPathDelimiter;
    },

    getVirtualScroll: function () {
        return this.virtualScroll;
    },
    setVirtualScroll: function (virtualScroll) {
        if (this.virtualScroll !== !!virtualScroll) {
            this.virtualScroll = !!virtualScroll;
            jQuery(this._selectList.el)[(this.virtualScroll ? 'add' : 'remove') + 'Class'](
                'mini-tabstreeselect-virtual-scroll'
            );
            this._selectList.setVirtualScroll(this.virtualScroll);
            this.tree.setVirtualScroll(this.virtualScroll);
        }
    },

    setAllowSort: function (allowSort) {
        if (this.allowSort !== !!allowSort) {
            this.allowSort = !!allowSort;
            if (this.allowSort) {
                mini.removeClass(this._rightContent, 'disable-sort');
                if (this.showSort) {
                    this._buttons.appendChild((this.sortBtn = this._getActionBtn('sort')));
                }
                this._buttons.appendChild((this.topBtn = this._getActionBtn('top', true)));
                this._buttons.appendChild((this.bottomBtn = this._getActionBtn('bottom', true)));

                this._updateButtons();
            } else {
                mini.addClass(this._rightContent, 'disable-sort');
                if (this.sortBtn) {
                    this._buttons.removeChild(this.sortBtn);
                    this.sortBtn = null;
                }
                this._buttons.removeChild(this.topBtn);
                this.topBtn = null;
                this._buttons.removeChild(this.bottomBtn);
                this.bottomBtn = null;
            }
        }
    },
    getAllowSort: function () {
        return this.allowSort;
    },
    setShowSort: function (showSort) {
        if (this.showSort !== !!showSort) {
            this.showSort = !!showSort;
            if (this.showSort && this.allowSort) {
                this._buttons.insertBefore((this.sortBtn = this._getActionBtn('sort')), this._buttons.firstChild);
            } else if (this.sortBtn) {
                this._buttons.removeChild(this.sortBtn);
                this.sortBtn = null;
            }
        }
    },
    getShowSort: function () {
        return this.showSort;
    },

    getAttrs: function (el) {
        var attrs = mini.TabsTreeSelect.superclass.getAttrs.call(this, el);
        mini._ParseString(el, attrs, [
            'data',
            'textField',
            'pinyinField',
            'idField',
            'nodesField',
            'parentField',
            'dataField',
            'onbeforenodecheck',
            'onbeforenodeselect',
            'onnodeclick',
            'url',
            'filterUrl',
            'filterMode',
            'onbeforeload',
            'onload',
            'ontreeexpand',
            'ontreecollapse',
            'ondrawnode',
            'onbeforeloadvalue',
            'selectedPanelTitle',
            'fullPathDelimiter',
            'onnodecheck',
            'ondragstart',
            'ondrop',
            'onbeforesortchanged'
        ]);
        mini._ParseBool(el, attrs, [
            'expandOnNodeClick',
            'expandOnLoad',
            'resultAsTree',
            'showTreeIcon',
            'virtualScroll',
            'showTreeLines',
            'showFolderCheckBox',
            'canCheckParent',
            'showBorder',
            'loadChildWhenChecked',
            'autoLoad',
            'filterOnInput',
            'checkRecursive',
            'autoCheckParent',
            'showFullPath',
            'includeRootNode',
            'checkOnTextClick',
            'showSelectedCount',
            'showSort',
            'allowSort',
            'loadWhenChecked'
        ]);

        var tabs = [],
            nodes = mini.getChildNodes(el),
            tabAttr = null,
            i,
            len;

        for (i = 0, len = nodes.length; i < len; i++) {
            tabAttr = {};
            mini._ParseString(nodes[i], tabAttr, [
                'tabText',
                'tabKey',
                'filterMode',
                'showDimension',
                'showPersonalFilter',
                'dialogTitle',
                'dialogUrl',
                'onbarsDialogCloseCallback',
                'barsFilterEmptyText',
                'nameFilterEmptyText'

            ]);
            tabs.push(tabAttr);
        }

        attrs.tabs = tabs;
        return attrs;
    }
});

mini.regClass(mini.TabsTreeSelect, 'tabstreeselect');



mini.TreeSelect = function() {
    this.data = [];
    mini.TreeSelect.superclass.constructor.apply(this, arguments);
};
mini.extend(mini.TreeSelect, mini.PopupEdit, {
    loadWhenChecked: false,
    valueFromSelect: false,

    text: '',
    value: '',

    autoCheckParent: false,
    expandOnLoad: false,

    valueField: 'id',
    textField: 'text',
    nodesField: 'children',
    dataField: '',
    delimiter: ',',

    multiSelect: false,
    data: [],
    url: '',

    allowInput: false,

    showTreeIcon: false,
    showTreeLines: true,

    resultAsTree: false,
    parentField: 'pid',
    // 是否只能选择叶子节点
    canCheckParent: true,
    checkRecursive: false,
    showFolderCheckBox: false,
    showRadioButton: false, //radio

    showFilter: false,
    filterOnInput: false,

    // 搜索模式，可取值为'client'、'server'
    filterMode: 'client',

    filterUrl: '',

    showFullPath: false,
    includeRootNode: false,

    popupHeight: 200,
    popupWidth: '100%',
    popupMaxHeight: 250,
    popupMinWidth: 100,

    setAjaxData: function (value) {
        this.ajaxData = value;
        this.tree.setAjaxData(value);
    },
    setAjaxType: function (value) {
        this.ajaxType = value;
        this.tree.setAjaxType(value);
    },
    setAjaxOptions: function (value) {
        this.ajaxOptions = value;
        this.tree.setAjaxOptions(value);
    },

    set: function(kv) {
        if (typeof kv === 'string') {
            return this;
        }

        var value = kv.value;
        delete kv.value;
        var text = kv.text;
        delete kv.text;
        var url = kv.url;
        delete kv.url;
        var data = kv.data;
        delete kv.data;
        var showFullPath = kv.showFullPath;
        delete kv.showFullPath;
        var fullPathDelimiter = kv.fullPathDelimiter;
        delete kv.fullPathDelimiter;
        var includeRootNode = kv.includeRootNode;
        delete kv.includeRootNode;
        var autoLoad = kv.autoLoad;
        delete kv.autoLoad;

        mini.TreeSelect.superclass.set.call(this, kv);

        if (!mini.isNull(data)) {
            this.setData(data);
        }
        if(!mini.isNull(autoLoad)) {
            this.autoLoad = autoLoad;
            if(this.tree) {
                this.tree.setAutoLoad(autoLoad);
            }
        }
        if (!mini.isNull(url)) {
            this.setUrl(url);
        }
        if (!mini.isNull(value)) {
            this.setValue(value);
        }
        if (!mini.isNull(text)) {
            this.setText(text);
        }
        if (!mini.isNull(showFullPath)) {
            this.showFullPath = showFullPath;

            this.tree.showFullPath = showFullPath;
        }
        if (!mini.isNull(fullPathDelimiter)) {
            this.fullPathDelimiter = fullPathDelimiter;
            this.tree.fullPathDelimiter = fullPathDelimiter;
        }
        if (!mini.isNull(includeRootNode)) {
            this.includeRootNode = includeRootNode;

            this.tree.includeRootNode = includeRootNode;
        }
        return this;
    },

    uiCls: 'mini-treeselect',
    _createPopup: function() {
        mini.TreeSelect.superclass._createPopup.call(this);

        this.tree = new mini.FilterTree();
        this.tree.setShowTreeIcon(true);
        this.tree.setStyle('border:0;width:100%;height:100%;overflow:hidden;');
        this.tree.setResultAsTree(this.resultAsTree);
        this.tree.render(this.popup._contentEl);
        this.tree.setCheckRecursive(this.checkRecursive);
        this.tree.setShowFolderCheckBox(this.showFolderCheckBox);
        this.tree.setShowRadioButton(this.showRadioButton);
        this.tree.setExpandOnNodeClick(this.expandOnNodeClick);
        this.tree.setFilterOnInput(this.filterOnInput);
        if(this.autoLoad !== undefined) {
            this.tree.setAutoLoad(this.autoLoad);
        }
        if (!mini.isNull(this.defaultRowHeight)) this.tree.defaultRowHeight = this.defaultRowHeight;


        // this.tree.on("nodeclick", this.__OnNodeClick, this);
        var me = this;
        this.tree.on('nodeclick', function (e) {
            setTimeout(function () {
                me.__OnNodeClick(e);
            }, 10);
        }, this);

        this.tree.on('nodecheck', this.__OnCheckedChanged, this);
        this.tree.on('expand', this.__OnTreeExpand, this);
        this.tree.on('collapse', this.__OnTreeCollapse, this);
        this.tree.on('beforenodecheck', this.__OnTreeBeforeNodeCheck, this);
        this.tree.on('beforenodeselect', this.__OnTreeBeforeNodeSelect, this);
        this.tree.on('drawnode', this.__OnDrawNode, this);
        this.tree.useAnimation = false;

        this.tree.set({
            showToolbar: this.showFilter,
            filterMode: this.filterMode,
            filterUrl: this.filterUrl
        });
        // 添加过滤后事件处理，解决过滤后树的选中状态与控件值不对应问题
        this.tree.on('filter', this.__OnFilter, this);
        //
        //this.tree.setVirtualScroll(true);

        this.tree.on('beforeload', function(e) {
            me.fire('beforeload', e);
        }, this);
        this.tree.on('load', function(e) {
            me.fire('load', e);
        }, this);
        this.tree.on('loaderror', function(e) {
            me.fire('loaderror', e);
        }, this);

        this.tree.on('loadnode', this.__OnLoadNode, this);
    },
    __OnLoadNode: function (e) {
        // load 节点的时候，服务端已处理好节点的勾选状态，不需要再前端处理
        // 解决懒加载问题
        // if (this.value && this.tree) {
        //     this.tree.setValue(this.value);
        // }
        this.fire('loadnode', e);
    },
    _getIsLoaded: function(node) {
        if (this.tree.isLeaf(node)) {
            return true;
        }

        var cs = this.tree.getChildNodes(node),
            isLoaded = true,
            l = cs.length;

        if (l) {
            for (var i = 0; i < l; i++) {
                isLoaded = this._getIsLoaded(cs[i]);

                if (!isLoaded) {
                    return false;
                }
            }
        } else {
            return false;
        }

        return true;
    },
    __OnDrawNode: function(e) {
        var node = e.node;

        if (node.ckr === false) {
            e.showCheckBox = false;
            e.showRadioButton = false;
        }
        this.fire('drawnode', e);
    },
    __OnTreeBeforeNodeCheck: function(e) {
        e.tree = e.sender;
        this.fire('beforenodecheck', e);
    },
    __OnTreeBeforeNodeSelect: function(e) {

        e.tree = e.sender;
        this.fire('beforenodeselect', e);
        if (e.cancel) {
            this._nohide = true;
        }
    },
    __OnTreeExpand: function(e) {
        if(!this.multiSelect) {
            this.tree.setValue(this.value, false);
        }
        
        //this.showPopup();
    },
    __OnTreeCollapse: function(e) {
        //this.showPopup();
    },
    __OnFilter: function() {
        this.tree.setValue(this.value);
    },

    findItems: function(value) {
        return this.tree.findNodes(this.tree.getIdField(), value);
    },
    //    getNodesByValue: function (value) {
    //        return this.tree.getNodesByValue(this.value); 
    //    },
    findNodes: function(value) {
        return this.tree.getNodesByValue(value);
    },
    getSelectedNode: function() {
        //return this.tree.getSelectedNode();
        //return this.tree._dataSource.getNodesByValue(this.value)[0];
        return this.getSelectedNodes()[0];
    },

    //null:原始节点;true包含父节点;false不包含父节点
    getCheckedNodes: function(hasParent) {
        //return this.tree.getCheckedNodes(hasParent);
        //return this.tree.getNodesByValue(this.value);


        var nodes = this.tree.getNodesByValue(this.value);

        if (hasParent === false) hasParent = 'leaf';
        nodes = this.tree._dataSource.doGetCheckedNodes(nodes, hasParent);

        return nodes;

    },
    getSelectedNodes: function() {
        //return this.tree.getSelectedNodes()
        return this.tree.getNodesByValue(this.value);
    },
    getParentNode: function(node) {
        return this.tree.getParentNode(node);
    },
    getChildNodes: function(node) {
        return this.tree.getChildNodes(node);
    },
    //    _OnValueChanged: function () {
    //        if (this.validateOnChanged) {
    //            this.validate();
    //        }
    //        var e = { value: this.getValue() };
    //        if (this.multiSelect == false) {
    //            e.node = this.tree.getSelectedNode();
    //            e.isLeaf = this.tree.isLeaf(e.node);
    //        }
    //        this.fire("valuechanged", e);
    //        
    //    },
    showPopup: function() {
        //        var ex = { cancel: false };
        //        this.fire("beforeshowpopup", ex);
        //        if (ex.cancel == true) return;

        //this.tree.setHeight("auto");


        var ex = { cancel: false };
        this.fire('beforeshowpopup', ex);
        this._firebeforeshowpopup = false;
        if (ex.cancel == true) return;


        var h = this.popup.el.style.height;
        //        if (h == "" || h == "auto") {
        //            this.tree.setHeight("auto");
        //        } else {
        //            //this.tree.setHeight("100%");
        //        }

        mini.TreeSelect.superclass.showPopup.call(this);
        
        this.tree.setValue(this.value, false);

        if (this.expandOnPopup) {
            this.tree.expandPath(this.value);
        }

        this._nohide = false;
    },
    expandOnPopup: false,
    setExpandOnPopup: function(value) {
        this.expandOnPopup = value;
    },
    getExpandOnPopup: function() {
        return this.expandOnPopup;
    },

    //    hidePopup: function () {
    //        this.tree.clearFilter();
    //        mini.TreeSelect.superclass.hidePopup.call(this);
    //    },
    __OnPopupHide: function(e) {
        this.__doFocusCls();
        this.tree.clearFilter();
        this.fire('hidepopup');
    },
    getItem: function(item) {
        return typeof item === 'object' ? item : this.data[item];
    },
    indexOf: function(item) {
        return this.data.indexOf(item);
    },
    getAt: function(index) {
        return this.data[index];
    },
    loadList: function(list, idField, parentField) {
        this.tree.loadList(list, idField, parentField);
        this.data = this.tree.getData();
        this._getCheckedValue();
    },
    getList: function() {
        return this.tree.getList();
    },
    load: function(data) {
        this.tree.load(data);
        this.data = this.tree.data;
        this._getCheckedValue();
    },
    _eval: function(_) {
        return eval('(' + _ + ')');
    },
    setData: function(data) {
        if (typeof data === 'string') {
            data = this._eval(data);
        }
        if (!mini.isArray(data)) data = [];
        this.tree.setData(data);
        this.data = this.tree.data;
        this._getCheckedValue();
    },
    getData: function() {
        return this.data;
    },
    _getCheckedValue: function() {
        var value = this.tree.getValue();
        this.setValue(value);
    },
    setUrl: function(url) {
        this.getPopup();

        this.tree.setUrl(url);
        this.url = this.tree.url;
        this.data = this.tree.data;
        // this._getCheckedValue();
    },

    getUrl: function() {
        return this.url;
    },
    virtualScroll: false,
    setVirtualScroll: function(value) {
        if (this.tree) this.tree.setVirtualScroll(value);
        this.virtualScroll = value;
    },
    getVirtualScroll: function() {
        return this.virtualScroll;
    },

    defaultRowHeight: 32,
    setDefaultRowHeight: function(value) {
        if (this.tree) this.tree.defaultRowHeight = value;
        this.defaultRowHeight = value;
    },
    getDefaultRowHeight: function() {
        return this.defaultRowHeight;
    },

    pinyinField: 'tag',
    setPinyinField: function(value) {
        //if (this._listbox) this._listbox.setPhoneticField(value);
        this.pinyinField = value;
    },
    getPinyinField: function() {
        return this.pinyinField;
    },

    setTextField: function(value) {
        if (this.tree) this.tree.setTextField(value);
        this.textField = value;
    },
    getTextField: function() {
        return this.textField;
    },
    setNodesField: function(value) {
        if (this.tree) this.tree.setNodesField(value);
        this.nodesField = value;
    },
    getNodesField: function() {
        return this.nodesField;
    },
    setDataField: function(value) {
        if (this.tree) this.tree.setDataField(value);
        this.dataField = value;
    },
    getDataField: function() {
        return this.dataField;
    },
    ///////////
    getValue: function() {
        var value = mini.TreeSelect.superclass.getValue.call(this);
        if (this.valueFromSelect && value && this.findItems(value).length == 0) {
            return '';
        }
        return value;
    },
    setValue: function(value, notUpdateTree) {
        if (mini.isNull(value)) value = '';

        var vts = this.tree.getValueAndText(value);
        if (vts[1] == '' && !this.valueFromSelect) {
            vts[0] = value;
            vts[1] = value;
        }
        this.value = value;

        this._valueEl.value = value;

        !notUpdateTree && this.tree && this.tree.setValue(value);
        
        // 安全整改要求，服务端返回数据是对html编码的，但是提交时需要还原成正常的html标签
        this.text = this._textEl.value = mini.htmlDecode(vts[1]);

        this._doEmpty();
    },
    setMultiSelect: function(value) {
        if (this.multiSelect != value) {
            this.multiSelect = value;
            this.tree.setShowCheckBox(value);
            this.tree.setAllowSelect(!value);
            this.tree.setEnableHotTrack(!value);
        }
    },
    getMultiSelect: function() {
        return this.multiSelect;
    },
    __OnNodeClick: function(e) {

        if (this.multiSelect) return;

        var node = this.tree.getSelectedNode();
        var vts = this.tree.getValueAndText(node);
        var v = vts[0];

        // v为空，可能是懒加载树，对应节点未加载，不改变值
        if (v) {
            var value = this.getValue();
            this.setValue(v);
            if (value !== this.getValue()) {
                this._OnValueChanged();
            }
        }


        if (this._nohide !== true) {
            this.hidePopup();
            this.focus();
        }
        this._nohide = false;
        this.fire('nodeclick', { node: e.node });
    },
    __OnCheckedChanged: function(evt) {
        var node = evt.node;
       
        var me = this;
        if (this.loadWhenChecked || !(evt.isLeaf || (!this.checkRecursive && this.canCheckParent) || this._getIsLoaded(node))) {
            var evData = {
                node: node,
                eventType: 'checkedchanged'
            };

            var e = {
                url: this.url,
                data: evData,
                sender: this
            };

            this.fire('beforecheckload', e);
            jQuery.ajax({
                url: e.url,
                data: e.data,
                type: 'post',
                dataType: 'json',
                success: function(data) {
                    data = mini.getSecondRequestData(data);

                    if (data) {

                        var value = me.getValue();

                        me.setValue(data.value, true);
                        me.setText(data.text);

                        if (value !== me.getValue()) {
                            me._OnValueChanged();
                        }
                        me.focus();
                    }
                }
            });
        } else {
            if (node.checked) {
                this._addNode(node);
            } else {
                this._removeNode(node);
            }
            this._OnValueChanged();
            this.focus();
        }
    },
    _addNode: function(node, notCascade) {
        var v = node[this.valueField],
            t = this.tree.getItemText(node),
            value = this.getValue(),
            text = this.getText(),
            tree = this.tree,
            i,
            len;

        if (this.canCheckParent || (!node.cantChecked && tree.isLeaf(node))) {
            if (!value) {
                this.setValue(v);
                this.setText(t);
            } else if ((',' + value + ',').indexOf(',' + v + ',') < 0) {
                this.setValue(value + ',' + v);
                this.setText(text + ',' + t);
            }
        }

        if ((!this.canCheckParent || this.checkRecursive) && !notCascade) {
            if(!tree.isLeaf(node)) {
                var childs = tree.getChildNodes(node);
                for (i = 0, len = childs.length; i < len; i++) {
                    this._addNode(childs[i]);
                }
            }
            var ans = tree.getAncestors(node);
            ans.reverse();
            for (i = 0, len = ans.length; i < len; i++) {
                var pnode = ans[i];
                //                var checkable = this.getCheckable(pnode);
                //                if (checkable == false) return;
                pnode.checked = hasAllCheckedChildNode(pnode);
                
                if(pnode.checked) {
                    this._addNode(pnode, true);
                }
            }
        }
        
        function hasAllCheckedChildNode(pnode) {
            var childNodes = tree.getChildNodes(pnode);
            for (var ii = 0, ll = childNodes.length; ii < ll; ii++) {
                var cnode = childNodes[ii];
                if (!tree.isCheckedNode(cnode)) {
                    return false;
                }
            }
            return true;
        }

    },
    _removeNode: function(node, notCascade) {
        var v = ',' + node[this.valueField] + ',',
            value = ',' + this.getValue() + ',',
            textArr = this.getText().split(','),
            text,
            index = value.indexOf(v),
            i,
            len;

        if (index >= 0) {
            // 由于搜索时，返回的节点 text 可能会拼接上父节点的文本，导致与已选的不一致，从而会导致无法对 text 进行字符串的替换
            // 只能改用通过 value 来定位到要删除节点的序号，再通过序号去删除 text
            index = value.substring(0, index).split(',').length - 1;

            value = value.replace(v, ',');
            value = value.substring(1, (value.length - 1) || 1);

            textArr.splice(index, 1);
            text = textArr.join(',');

            this.setValue(value);
            this.setText(text);

        }

        if ((!this.canCheckParent || this.checkRecursive) && !notCascade) {
            var childs = this.tree.getChildNodes(node);
            for (i = 0, len = childs.length; i < len; i++) {
                this._removeNode(childs[i]);
            }

            var ans = this.tree.getAncestors(node);
            ans.reverse();
            for (i = 0, len = ans.length; i < len; i++) {
                this._removeNode(ans[i], true);
            }
        }
        
    },
    __OnInputKeyDown: function(e) {
        var ex = { htmlEvent: e };
        this.fire('keydown', ex);
        if (e.keyCode == 8 && (this.isReadOnly() || this.allowInput == false)) {
            return false;
        }

        if (e.keyCode == 9) { //tab
            if (this.isShowPopup()) {
                this.hidePopup();
            }
            return;
        }

        if (this.isReadOnly()) return;
        var me = this;
        switch (e.keyCode) {
            case 27: //esc
                if (this.isShowPopup()) {
                    e.stopPropagation();
                }

                this.hidePopup();
                break;
            case 13: //enter                
                setTimeout(function() {
                    me.fire('enter', ex);
                }, 10);
                break;
            case 37: //left
                break;
            case 38: //top
                e.preventDefault();
                break;
            case 39: //right
                break;
            case 40: //bottom
                e.preventDefault();
                this.showPopup();
                break;
            default:
                if (this.allowInput == false) {} else {
                    setTimeout(function() {
                        me._doQuery();
                    }, 10);
                }
                break;
        }
    },
    _doQuery: function() {
        if (this.multiSelect) return;
        var field = this.textField,
            pinyinField = this.pinyinField;
        var value = this._textEl.value.toLowerCase();
        this.tree.filter(function(node) {
            var text = String(node[field] ? node[field] : '').toLowerCase();
            var pinyin = String(node[pinyinField] ? node[pinyinField] : '').toLowerCase();

            if (text.indexOf(value) != -1 || pinyin.indexOf(value) != -1) {
                return true;
            } return false;
        });
        this.tree.expandAll();
        this.showPopup();
    },
    ////////////////////////////////////

    setCheckRecursive: function(value) {
        this.checkRecursive = value;
        this.canCheckParent = !value;
        if (this.tree) {
            this.tree.setCheckRecursive(value);
        }
    },
    getCheckRecursive: function() {
        return this.checkRecursive;
    },
    setResultAsTree: function(value) {
        this.resultAsTree = value;
        if (this.tree) this.tree.setResultAsTree(value);
    },
    getResultAsTree: function() {
        return this.resultAsTree;
    },
    setParentField: function(value) {
        this.parentField = value;
        if (this.tree) this.tree.setParentField(value);
    },
    getParentField: function() {
        return this.parentField;
    },
    setValueField: function(valueField) {

        if (this.tree) this.tree.setIdField(valueField);
        this.valueField = valueField;
    },
    getValueField: function() {
        return this.valueField;
    },
    setShowTreeIcon: function(value) {
        this.showTreeIcon = value;
        if (this.tree) this.tree.setShowTreeIcon(value);
    },
    getShowTreeIcon: function() {
        return this.showTreeIcon;
    },
    setShowTreeLines: function(value) {
        this.showTreeLines = value;
        if (this.tree) this.tree.setShowTreeLines(value);
    },
    getShowTreeLines: function() {
        return this.showTreeLines;
    },
    setShowFolderCheckBox: function(value) {

        this.showFolderCheckBox = value;
        if (this.tree) this.tree.setShowFolderCheckBox(value);
    },
    getShowFolderCheckBox: function() {
        return this.showFolderCheckBox;
    },
    setShowRadioButton: function(value) {

        this.showRadioButton = value;
        if (this.tree) this.tree.setShowRadioButton(value);
    },
    getShowRadioButton: function() {
        return this.showRadioButton;
    },

    setAutoCheckParent: function(value) {

        this.autoCheckParent = value;
        if (this.tree) this.tree.setAutoCheckParent(value);
    },
    getAutoCheckParent: function() {
        return this.autoCheckParent;
    },
    setExpandOnLoad: function(value) {

        this.expandOnLoad = value;
        if (this.tree) this.tree.setExpandOnLoad(value);
    },
    getExpandOnLoad: function() {
        return this.expandOnLoad;
    },
    setValueFromSelect: function(value) {
        this.valueFromSelect = value;
    },
    getValueFromSelect: function() {
        return this.valueFromSelect;
    },

    expandOnNodeClick: false,
    setExpandOnNodeClick: function(value) {
        this.expandOnNodeClick = value;
        if (this.tree) this.tree.setExpandOnNodeClick(value);
    },
    getExpandOnNodeClick: function() {
        return this.expandOnNodeClick;
    },

    getFilterUrl: function() {
        return this.filterUrl || this.url;
    },

    getShowFilter: function() {
        return this.showFilter;
    },

    setShowFilter: function(showFilter) {
        this.showFilter = showFilter;
        this.tree.set({
            showToolbar: showFilter
        });
    },
    setFilterOnInput: function(filterOnInput) {
        this.filterOnInput = !!filterOnInput;
        this.tree.setFilterOnInput(this.filterOnInput);
    },
    getFilterOnInput: function() {
        return this.filterOnInput;
    },

    setFilterUrl: function(filterUrl) {
        this.filterUrl = filterUrl;
        this.tree.setFilterUrl(filterUrl);
    },

    getFilterMode: function() {
        return this.filterMode;
    },

    setFilterMode: function(filterMode) {
        this.filterMode = filterMode;
        this.tree.setFilterMode(filterMode);
    },
    
    clear: function() {
        this.tree._filterInput.setValue('');
        this.tree._filterInput.setText('');
        this.tree._doFilter('');
    },
    getShowFullPath: function () {
        return this.showFullPath;  
    },
    getFullPathDelimiter: function () {
        return this.fullPathDelimiter;
    },
    setCanCheckParent: function (canCheckParent) {
        this.canCheckParent = canCheckParent;
        this.checkRecursive = !canCheckParent;
        if (this.tree) {
            this.tree.setCheckRecursive(!canCheckParent);
        }
    },
    getCanCheckParent: function () {
        return this.canCheckParent;
    },

    getAttrs: function(el) {
        var attrs = mini.TreeSelect.superclass.getAttrs.call(this, el);

        mini._ParseString(el, attrs, ['url', 'data', 'textField', 'pinyinField', 'valueField', 'nodesField', 'parentField', 'onbeforenodecheck', 'onbeforenodeselect',
            'expandOnLoad', 'onnodeclick', 'onbeforeload', 'onload', 'onloaderror', 'ondrawnode', 'filterMode', 'filterUrl', 'fullPathDelimiter'
        ]);
        mini._ParseBool(el, attrs, ['expandOnNodeClick', 'multiSelect', 'resultAsTree', 'checkRecursive', 'showTreeIcon', 'showTreeLines',
            'showFolderCheckBox', 'showRadioButton', 'autoLoad',
            'autoCheckParent', 'valueFromSelect', 'virtualScroll', 'expandOnPopup', 'showFilter', 'filterOnInput', 'showFullPath', 'includeRootNode', 'loadWhenChecked', "canCheckParent"
        ]);
        mini._ParseInt(el, attrs, ['defaultRowHeight']);

        if (attrs.expandOnLoad) {
            var level = parseInt(attrs.expandOnLoad);
            if (mini.isNumber(level)) {
                attrs.expandOnLoad = level;
            } else {
                attrs.expandOnLoad = attrs.expandOnLoad == 'true' ? true : false;
            }
        }

        return attrs;
    }
});
mini.regClass(mini.TreeSelect, 'TreeSelect');

// jQuery(function () {
//     setTimeout(function () {
//         try {
//             var activeElement = mini.getActiveElement();
//             if (activeElement) {
//                 var jq = jQuery(activeElement).closest('.mini-buttonedit, .mini-textbox');
//                 if (jq.length) {
//                     var o = mini.get(jq[0]);
//                     if (o) {
//                         o.blur();
//                         o.focus();
//                     }
//                 }
//             }
//         } catch (ex) {
            
//         }
//     }, 100);
// });


/* eslint strict : ["off", "global"] */
mini.UserControl = function () {
    mini.UserControl.superclass.constructor.call(this);
};

mini.extend(mini.UserControl, mini.Control, {
    // 如果要用commonDto则必须设置value属性
    value: '',

    // 模板的地址
    tplUrl: '',

    // css文件资源路径
    cssUrl: '',

    isUserControl: true,

    _create: function () {
        this.el = document.createElement('div');
        var that = this;

        if (this.cssUrl && !document.getElementById(this.uiCls + '-style')) {
            var head = document.getElementsByTagName('head')[0];
            var link = document.createElement('link');
            link.href = (_rootPath + '/' + this.cssUrl);
            link.rel = 'stylesheet';
            link.type = 'text/css';
            link.id = this.uiCls + '-style';
            link.onload = function(){
                that._doLayoutChild();
                that._afterCssLoaded();
            };
            head.appendChild(link);
        }
    },

    // 在该方法中进行自定义控件模板的加载解析，以及一些真正的初始化工作
    _afterApply: function () {
        this.parseTpl();

    },

    init: function () {

    },
    
    _doLayoutChild: function () {
        mini.getChildControls(this.el).forEach(function (ctr) {            
            ctr.doLayout && ctr.doLayout();
        });
    },

    _afterCssLoaded: function(){

    },
    
    parseTpl: function () {
        var that = this;
        var cls = mini.uiClasses[this.uiCls];

        function parse(text) {
            cls._tplHTML = text;
            var M = Mustache,
                templ = $.trim(text);

            // 解析模板，将模板中的id替换为以控件id为前缀，以避免页面同时有多个控件时id冲突。
            // 模板中的控件设置id是为了方便下面的获取
            // 模板中必须使用完整的html结构
            // 如<div role="control" label="标段(包)名称" starred="true"></div>这种需要通过commonjs来解析的html是不允许的，因为commonjs是不会解析的
            var html = M.render(templ, that.tplData);

            // 将解析好的html塞到页面中
            that.el.innerHTML = html;

            // 解析控件html中的miniui控件
            mini.parse(that.el);

            // 其他的一些初始化工作
            // 把后面会用到内部控件缓存起来
            that.controls = {};

            that.init();

            // 处理二次请求的控件
            if (window.DtoUtils) {
                DtoUtils.bindBeforeLoad(that.el);
            }

        }

        this.setTplData();

        if (this._tplHTML) {
            parse(this._tplHTML);
        }   else {

            // 通过ajax获取控件的模板
            jQuery.ajax({
                url: (_rootPath + '/' + this.getTplUrl()),
                // 必须为同步请求
                async: false,
                type: "post",
                dataType: 'html',
                success: parse
            });
        }
    },

    getTplUrl: function(){
        var lan = mini.Cookie.get('epoint_local');

        if(typeof this.tplUrl === 'string'){
            return this.tplUrl;
        }
        
        return this.tplUrl[lan] || this.tplUrl.zh_CN;

    },

    setTplData: function () {
        this.tplData = {
            controlId: this.id
        };
    },

    // 设置内部控件的值以及一些根据后台返回数据来控制显隐等操作
    // commonDto中初始化时会调用
    // 具体的数据结构根据控件自己的特点来确定
    // 本控件的数据结构如dbworkflow.json
    setData: function (data) {

        for (var i in data) {
            if (this.controls[i] && data[i]) {
                if (typeof data[i] !== 'object' && this.controls[i].setValue) {
                    this.controls[i].setValue(data[i]);
                }
                if (data[i].value && this.controls[i].setValue) {
                    this.controls[i].setValue(data[i].value);
                }
                if (data[i].data) {
                    if (this.controls[i].loadList) {
                        this.controls[i].loadList(data[i].data);
                    } else if (this.controls[i].setData) {
                        this.controls[i].setData(data[i].data);

                        if (data[i].total && this.controls[i].setTotalCount) {
                            this.controls[i].setTotalCount(data[i].total);
                        }
                    }
                }
            }
        }
    },

    // 返回控件的数据
    // commonDto中表单提交 时会调用
    // 具体的数据结构根据控件自己的特点来确定
    getValue: function () {
        var data = {};
        for (var i in this.controls) {
            if (this.controls[i].getValue) {
                data[i] = this.controls[i].getValue();
            }
        }

        return data;
    },

    setValue: function (value) {
        this.value = value;
    }
});
mini.VerifyCode = function() {
    mini.VerifyCode.superclass.constructor.apply(this, arguments);
};

mini.extend(mini.VerifyCode, mini.Control, {
    mapClass: 'com.epoint.basic.faces.verifycode.VerifyCode',
    autoLoad: false,

    ignorecase: true,
    url: '',

    width: 78,
    height: 32,
    charLength: 4,

    changeAnotherText: epoint_local.VerifyCode.changeAnotherText,

    uiCls: 'mini-verifycode',

    set: function(kv) {
        if (typeof kv === 'string') {
            return this;
        }

        var url = kv.url;
        delete kv.url;

        mini.VerifyCode.superclass.set.call(this, kv);

        if (url) {
            this.setUrl(url);
        }

        return this;
    },

    _create: function() {
        this.el = document.createElement('div');

        this.el.innerHTML = '<img title="' + this.changeAnotherText +'"></img>';

        this._img = this.el.firstChild;
    },

    _initEvents: function() {
        var me = this;
        mini.on(this._img, 'click', function() {
            me._doLoad({
                width: parseInt(this.width),
                height: parseInt(this.height),
                charLength: me.charLength
            });
        });
    },

    setData: function(data) {
        this.value = data.value;
        this._img.src = /^data:image/.test(data.src) ? data.src : Util.getRightUrl(data.src);
        this.uuid = data.uuid;
    },

    setUrl: function(url) {
        this.url = url;

        if (this.autoLoad) {
            this._doLoad({
                width: parseInt(this.width),
                height: parseInt(this.height),
                charLength: this.charLength
            });
        }
    },

    getUrl: function() {
        return this.url;
    },

    _doLoad: function(params) {
        params = params || {};
        var e = {
            url: this.url,
            async: false,
            type: this.ajaxType ? this.ajaxType : 'post',
            data: params,
            params: params,
            cache: false,
            cancel: false
        };
        this.fire('beforeload', e);
        if (e.data != e.params && e.params != params) {
            e.data = e.params;
        }
        if (e.cancel == true) return;

        var sf = (me = this);
        var url = e.url;
        mini.copyTo(e, {
            success: function(text, textStatus, xhr) {
                delete e.params;
                var obj = {
                    text: text,
                    result: null,
                    sender: me,
                    options: e,
                    xhr: xhr
                };
                var result = null;
                try {
                    mini_doload(obj);
                    result = obj.result;
                    if (!result) {
                        result = mini.decode(text);
                    }
                } catch (err) {
                    if (mini_debugger == true) {
                        alert(url + '\njson is error.');
                    }
                }
                result = {
                    data: result
                };

                var ex = {
                    data: result.data,
                    cancel: false,
                    result: result
                };
                sf.fire('preload', ex);
                if (ex.cancel == true) return;

                sf.setData(ex.data);

                delete ex.cancel;
                sf.fire('load', ex);
            },
            error: function(xhr, textStatus) {
                var e = {
                    xhr: xhr,
                    text: xhr.responseText,
                    textStatus: textStatus,
                    errorMsg: xhr.responseText,
                    errorCode: xhr.status
                };
                if (mini_debugger == true) {
                    alert(url + '\n' + e.errorCode + '\n' + e.errorMsg);
                }
                sf.fire('loaderror', e);
            }
        });

        this._ajaxer = mini.ajax(e);
    },

    getAttrs: function(el) {
        var attrs = mini.VerifyCode.superclass.getAttrs.call(this, el);
        mini._ParseString(el, attrs, ['url', 'data', 'onbeforeload', 'onload', 'onloaderror', 'onpreload']);
        mini._ParseBool(el, attrs, ['autoLoad', 'ignorecase']);

        mini._ParseInt(el, attrs, ['charLength']);
        return attrs;
    }
});

mini.regClass(mini.VerifyCode, 'verifycode');

/**
 * 富文本编辑器
 * @class
 * @extends mini.ValidatorBase
 * @requires mini.TextArea
 * @requires eWebEditor
 * 
 */
mini.WebEditor = function() {
    mini.WebEditor.superclass.constructor.call(this);
};
mini.extend(mini.WebEditor, mini.ValidatorBase, {
    mapClass: '',

    width: '100%',
    height: '350px',
    readOnly: false,
    // ewebeditor使用的样式名
    editstyle: 'coolblue',
    // ewebeditor使用的皮肤名
    editSkin: 'flat10',
    value: '',
    uiCls: 'mini-webeditor',
    formField: true,
    // _editorModel: window.mini_editor_model || 'ewebeditor',
    _editorModel: (window.EpFrameSysParams && EpFrameSysParams.editor_model) || 'ewebeditor',
    // 扩展的 UEditor 配置
    extraUEditorConfig: {},
    /**
     * 创建实例
     * @private
     * @member mini.WebEditor
     */
    _create: function() {
        this.el = document.createElement('div');
        this.el.innerHTML = '<textarea style="display:none"></textarea>';
        this._fromEditor = this.el.firstChild;
        this._editor = new mini.TextArea();
        this._editor.setVisible(false);
        this._editor.render(this.el);
        var that = this;

        this.externalSrc = this.externalSrc || mini.externalSrc;

        if (this._editorModel === 'ewebeditor') {
            if (!window.EWEBEDITOR) {
                mini.loadJS(this.externalSrc + 'ewebeditor/ewebeditor.js', function() {
                    that._initEditor();
                });
            } else {
                this._initEditor();
            }
        } else {
            if (!window.UE) {
                mini.loadJS(this.externalSrc + 'ueditor/ueditor.config.js', function() {
                    mini.loadJS(that.externalSrc + 'ueditor/ueditor.all.js', function() {
                        that._initEditor();
                    });
                });
            } else {
                this._initEditor();
            }
        }

    },
    /**
     * @inheritdoc
     * @member mini.WebEditor
     */
    render: function(el) {
        mini.WebEditor.superclass.constructor.call(this, el);
    },
    /**
     * 初始化富文本编辑器
     * @private
     * @member mini.WebEditor
     */
    _initEditor: function() {
        var that = this;
        setTimeout(function() {
            that._doInitEditor();
        }, 1);
    },
    /**
     * 执行真正的初始化操作
     * @private
     * @member mini.WebEditor
     * @fires initeditor
     */
    _doInitEditor: function() {
        if (this.isRender() === false) {
            return;
        }
        if (this.editor) {
            return;
        }
        var that = this;
        this._editor.set({
            name: this.id,
            id: this.id + '_editor'
        });
        this._fromEditor.id = this.id + '_fromEditor';

        if (this._editorModel === 'ewebeditor') {
            this.editor = EWEBEDITOR.Replace(this._fromEditor.id, {
                width: this.width.replace('px', ''),
                height: this.height.replace('px', ''),
                readonly: this.readOnly ? '2' : '',
                style: this.editstyle,
                skin: this.editSkin
            });

            var _o_EWEBEDITOR_EVENT = window.EWEBEDITOR_EVENT;
            window.EWEBEDITOR_EVENT =function(ev) {
                if(ev.flag === 'LoadComplete'){
                    if(that.readOnlyChanged) {
                        that.editor.setReadOnly(that.readOnly ? '2' : '');
                    }
                    that._loadComplete = true;
                    
                    that.fire('init', {
                        sender: that,
                        type: 'init'
                    });
                }

                _o_EWEBEDITOR_EVENT && _o_EWEBEDITOR_EVENT(ev);

            };

        } else {
            this.editor = UE.getEditor(this._fromEditor.id, $.extend({
                initialFrameWidth: this.width.replace('px', ''),
                readonly: this.readOnly,
                // 只读就不用自己保存的
                enableAutoSave: !this.readOnly
            }, this.extraUEditorConfig || {}));

            this.editor.ready(function() {

                // 由于textarea是隐藏的，生成出来的编辑器也会自动隐藏，需要让编辑器显示出来
                that.editor.container.parentElement.style.display = '';

                // 由于ready是异步的，就有可能在调用setValue方法前已进行初始化，但在调用setValue方法时还未ready，就会造成value没有设置到编辑器上
                that.value && that.editor.setContent(that.value);

                that._$toolbar = jQuery(that.editor.container).find('.edui-editor-toolbarbox');
                that._$footer = jQuery(that.editor.container).find('.edui-editor-bottomContainer');

                that.setHeight(that.height);

                that.fire('init', {
                    sender: that,
                    type: 'init'
                });
            });
        }
    },

    getEditor: function() {

        return this.editor;
    },
        /**
     * 获取内部原生editor
     * @param {Fucntion/undefined} callback 获取成功的触发的回调函数，参数为获取到的editor
     * @return {Promise} jQuery模拟的Promise
     */
    getEditorPromise: function (callback) {
        var that = this,
            dtd = jQuery.Deferred(),
            reGetCount = 0;

        function _getEditor() {
            // 超时直接判定初始化失败 暂定50次 即一秒
            if (reGetCount++ > 50) return dtd.reject(new Error('富文本控件初始化超时！'));
            
            var editor = that.editor;
            // 已经存在则成功 否则20ms后重试
            if (editor) {
                setTimeout(function () {
                    dtd.resolve(editor);
                    if (typeof callback === 'function') {
                        callback(editor);
                    }
                });
            } else {
                setTimeout(_getEditor, 20);
            }
        }

        _getEditor();

        return dtd.promise();
    },
    /**
     * 设置富文本编辑器的值
     * @param {String} value 要设置的值
     * @member mini.WebEditor
     */
    setValue: function(value) {
        this.value = this._fromEditor.value = value;

        if (this._editorModel === 'ewebeditor') {
            // 异步调用setHTML方法
            // 防止ewebeditor未初始化好就调用setValue导致值未赋值上去
            window.EWEBEDITOR && EWEBEDITOR.SetHtmlAsync(this._fromEditor.id, value);
        } else {
            if (this.editor && this.editor.isReady) {
                this.editor.setContent(value);
            }
        }

    },

    /**
     * 获取富文本编辑器的值
     * @return {String} 富文本编辑器的值
     * @member mini.WebEditor
     */
    getValue: function() {
        if (this._editorModel === 'ewebeditor') {
            if (this.editor && this.editor.getHTML) {
                return this.editor.getHTML();
            }
        } else {
            if (this.editor && this.editor.isReady) {
                return this.editor.getContent();
            }
        }
        return this.value;
    },

    /**
     * 设置富文本编辑器实际提交的数据
     * @member mini.Richtext
     */
    setSubmitData: function() {
        if (this._editor) {
            this._editor.setValue(this.getValue());
        }
    },

    /**
     * 获取富文本编辑器实际提交的数据
     * @return {String} 富文本编辑器实际提交的数据
     * @member mini.Richtext
     */
    getSubmitData: function() {
        if (this._editor) {
            return this._editor.getValue();
        }
        return this.getValue();
    },

    /**
     * 设置富文本编辑器的只读属性
     * @param {Boolean} readonly `true` 表示只读， `false` 表示非只读
     * @member mini.WebEditor
     */
    setReadOnly: function(readonly) {
        if (this.editor) {
            if (this._editorModel === 'ewebeditor') {
                if(this._loadComplete) {
                    this.editor.setReadOnly(readonly ? '2' : '');
                } else {
                    this.readOnlyChanged = true;
                }
            } else {

                if (this.editor.isReady) {
                    if (readonly) {
                        this.editor.setDisabled('fullscreen');
                    } else {
                        this.editor.setEnabled();
                    }
                }
            }
        }
        this.readOnly = readonly;
    },

    /**
     * 获取富文本编辑器的只读属性
     * @return {Boolean} 如果当前为只读状态，则返回 `true`，否则返回 `false`
     * @member mini.WebEditor
     */
    getReadOnly: function() {
        return this.readOnly;
    },

    setHeight: function(height) {
        // ewebeditor没有提供调整高度的方法，所以不提供动态调整
        if (this._editorModel === 'ueditor') {
            if(height == '100%') {
                height = jQuery(this.el.parentElement).height();
            } else {
                height = parseInt(height);

            }
            
            if(height) {
                this.height = height;
                if(this.editor && this.editor.isReady) {

                    this.editor.setHeight(height - this._$toolbar.height() - this._$footer.height());
                }
            }
        }
        
    },
    setExtraUEditorConfig: function (config) {
        if (typeof config === 'object') {
            this.extraUEditorConfig = config;
        } else if (config + '' === config) {
            this.extraUEditorConfig = window["ev" + "al"]("(" + config + ")");
        }
    },
    getExtraUEditorConfig: function () {
        return this.extraUEditorConfig;
    },

    getAttrs: function(el) {
        var attrs = mini.WebEditor.superclass.getAttrs.call(this, el);
        attrs.text = el.innerHTML;
        mini._ParseString(el, attrs, ['value', 'text', 'editstyle', 'editSkin', 'oninit', 'extraUEditorConfig']);
        mini._ParseBool(el, attrs, ['readOnly']);

        return attrs;
    }
});
mini.regClass(mini.WebEditor, 'webeditor');

mini.WebUploader = function () {
    mini.WebUploader.superclass.constructor.call(this);
};
/* global WebUploader */
mini.extend(mini.WebUploader, mini.Control, {
    required: false,
    formField: true,
    requiredErrorText: epoint_local.ValidatorBase.requiredErrorText,
    uiCls: 'mini-webuploader',
    mapClass: 'com.epoint.basic.faces.fileupload.WebUploader',

    // 是否用于数据导入
    dataImport: false,

    showDefaultUI: true,

    uiType: 'oa',

    needChunkLocal: (window.EpFrameSysParams && EpFrameSysParams.chunk_dispatch_control) || undefined,
    // 小状态
    _minSize: false,
    minSizeCls: 'min-size',
    // 初始化时服务端返回过来的文件数量
    serverFileNum: 0,
    // 服务端返回文件
    serverFiles: undefined,

    fileSizeLimit: window.EpFrameSysParams && EpFrameSysParams.file_limit_size,
    fileSingleSizeLimit: window.EpFrameSysParams && EpFrameSysParams.file_single_limit_size,
    // 允许的文件后缀，不带点，多个用逗号分割
    limitType: window.EpFrameSysParams && EpFrameSysParams.file_limit_type,

    fileNameLengthLimit: (window.EpFrameSysParams && EpFrameSysParams.file_limit_namelength) || 0,

    fileNameLengthErrorText: '选择的文件名称长度过长！</br>文件名最长为{0}个字符',

    fileNameNullErrorText: '文件名称不能为空',

    specialCharacterErrorText: '文件名称中不能包含特殊字符！',

    showSecrecyLevel: false,
    previewUrl: window.EpFrameSysParams ? EpFrameSysParams.upload_preview_url : '',
    previewExt: window.EpFrameSysParams ? EpFrameSysParams.upload_preview_text : '',
    batchDownloadUrl: window.EpFrameSysParams ? EpFrameSysParams.upload_batch_download_url : '',
    // 编辑地址
    editUrl: '',
    // 可编辑文件的扩展名 不带. 多个以逗号分隔
    editExt: '',

    defaultSecrecyLevel:
        (window.EpFrameSysParams && EpFrameSysParams.defaultSecrecyLevel) === undefined
            ? undefined
            : EpFrameSysParams.defaultSecrecyLevel,
    uploadUrl: '',

    mimeTypes: '',
    auto: true,
    fileNumLimit: undefined,

    chunked: false,
    chunkSize: 5120,
    chunkRetry: 2,
    // duplicate {Boolean} [可选] [默认值：undefined] 去重， 根据文件名字、文件大小和最后修改时间来生成hash Key.
    duplicate: undefined,

    needMD5: false,
    // 全量计算MD5的最大文件大小
    maxFullMD5Size: window.EpFrameSysParams ? EpFrameSysParams.upload_max_full_md5_size || 10240 : 10240,
    // 分片是否需要计算MD5
    needChunkMD5: window.EpFrameSysParams ? EpFrameSysParams.upload_need_chunk_md5 : false,

    btnState: 'default',

    // 上传按钮是否显示图标
    showIcon: true,

    // 压缩
    compress: false,

    // 请求超时
    timeout: 120000,
    // 上传并发数。允许同时最大上传进程数。
    threads: 3,

    // 第三方资源的路径，默认为全局配置mini.externalSrc的值
    externalSrc: '',
    // 上传状态
    state: 'pending',

    enableDnd: false,
    // 关联的拖拽容器的 选择器
    dnd: '',

    showBatchDownloadBtn: false,

    pickerText: epoint_local.WebUploader.pickerText,
    startText: epoint_local.WebUploader.startText,
    pauseText: epoint_local.WebUploader.pauseText,
    batchDownloadText: epoint_local.WebUploader.batchDownloadText,
    tipText: '',
    numLimitErrorText: epoint_local.WebUploader.numLimitErrorText,
    sizeLimitErrorText: epoint_local.WebUploader.sizeLimitErrorText,
    typeDeniedErrorText: epoint_local.WebUploader.typeDeniedErrorText,
    sizeErrorText: epoint_local.WebUploader.sizeErrorText,
    emptyFileErrorText: epoint_local.WebUploader.emptyFileErrorText,
    duplicateErrorText: epoint_local.WebUploader.duplicateErrorText,
    uploadErrorText: epoint_local.WebUploader.uploadErrorText,
    secrecyLevelSaveErrorText: epoint_local.WebUploader.secrecyLevelSaveErrorText,
    noflashInnerHTML: epoint_local.WebUploader.noflashInnerHTML,
    noflashPageWarning: epoint_local.WebUploader.noflashPageWarning,
    dndPlaceholderText: epoint_local.WebUploader.dndPlaceholderText || '此区域可拖拽放置上传',

    getUiType: function () {
        return this.uiType;
    },
    setUiType: function (uiType) {
        if (this.uiType !== uiType) {
            this.uiType = uiType;
            this.uiFun = mini.WebUploaderUI[this.uiType];

            this._unbindDefaultUIEvents();
            this._bindDefaultUIEvents();
        }
    },
    setAction: function (action) {
        this.action = action;

        this.controlData = {
            id: this.id,
            type: 'webuploader',
            mapClass: this.mapClass,
            action: this.action,
            needChunkLocal: this.needChunkLocal,
            showDefaultUI: this.showDefaultUI,
            dataOptions: this['data-options']
        };

        var arr = action.split('.');

        if (arr.length < 2) return;

        var url = Util.getRightUrl('/rest/' + arr[0] + '/' + arr[1] + '?isCommondto=true');

        // 对于action配置为“xxxaction(aaa,bbb)”这种形式的，安全拦截中不允许url上出现“()”，所以需要将“()”里的内容拿下来，放到cmdParams里
        var reg = /\([\w\W]*\)/,
            match = url.match(reg);
        if (match) {
            url = url.replace(reg, '');

            this.cmdParams = match[0].replace('(', '[').replace(')', ']');
        }

        var urlParams = Util.getUrlParams();

        url = Util.addUrlParams(url, urlParams, 'ignore');

        this.setUploadUrl(url);
    },
    _afterApply: function () {
        this._initUIEvents();
    },
    setData: function (data) {
        // 重置内部的上传控件，将上传文件队列清空，避免setdata后 一个文件既是服务端返回文件，又在上传控件的文件中
        this._uploader && this._uploader.reset();

        var files = data.files || data;
        var secrecyLevels = data.secrecyLevels,
            clientGuid = data.clientGuid;

        this.serverFileNum = files.length;
        this.setFileNumLimit(this.fileNumLimit);

        clientGuid && (this._clientGuid = clientGuid);

        if (secrecyLevels && secrecyLevels.levels && secrecyLevels.levels.length) {
            this.setShowSecrecyLevel(true);
            this.setSecrecyLevels(secrecyLevels);
        }

        // 处理服务端返回的文件
        var fileItem,
            html = [];
        this.serverFiles = {};
        for (var i = 0, len = files.length; i < len; i++) {
            if (!files[i].attachFileName) {
                files[i].attachFileName = '';
            }
            //  加入服务端文件列表
            fileItem = {
                id: files[i].attachGuid,
                name: files[i].attachFileName,
                ext: files[i].attachFileName.substr(files[i].attachFileName.lastIndexOf('.') + 1),
                size: files[i].attachLength,
                date: files[i].uploadDateTime,
                fileGuid: files[i].attachGuid,
                downloadUrl: files[i].downloadUrl,
                // 预览参数值
                preparams: files[i].preparams || files[i].downloadUrl,
                hideDelete: files[i].readonly,
                secrecyLevel: files[i].secrecyLevel,
                uploadDate: files[i].uploadDate,
                success: true
            };
            this.serverFiles[fileItem.fileGuid] = fileItem;

            // 默认ui下渲染文件列表
            if (this.showDefaultUI) {
                html.push(this._generateFileList(fileItem));
            }
        }

        // 默认ui下加入页面
        if (this.showDefaultUI) {
            jQuery(html.join('')).appendTo(jQuery(this._fileList).empty());
        }

        this.adjustBatchDownloadBtnVisibility();

        this.fire('load', {
            sender: this,
            eventType: 'load',
            data: data
        });
    },

    _getUIFun: function (funName) {
        if (!this.uiFun) {
            this.uiFun = mini.WebUploaderUI[this.uiType];
        }
        return this.uiFun[funName] || function () {};
    },
    removeFile: function (file, clearServer) {
        var fileId = file.id || file,
            fileGuid = file.guid || file.fileGuid,
            self = this;
        // 两值相等，则表示是初始化时后台给的文件，不在上传控件的文件列表中，不需要从文件列表中删除
        if (fileId !== fileGuid) {
            this._uploader.removeFile(fileId, true);
        } else {
            this.serverFileNum--;
            this._uploader.option('fileNumLimit', this.fileNumLimit - this.serverFileNum);
            this.serverFiles[fileGuid] = null;
            delete this.serverFiles[fileGuid];
        }

        if (this.showDefaultUI) {
            jQuery(this._fileList)
                .find('#' + fileId)
                .remove();
            mini._controlTips && mini._controlTips.hide();
        }

        // 之前的removeFile方法是不会发请求给后端的，为了兼容之前的代码，新增一个clearServer参数，为true是才去服务端删除
        // 有fileGuid则表示改文件已上传成功了，需要发ajax告诉服务端文件已删除
        if (fileGuid && clearServer) {
            var data = {
                commonDto: mini.encode(this.getCommonData())
            };
            if (this.cmdParams) {
                data.cmdParams = this.cmdParams;
            }
            data[this.id + '_action'] = 'delete';
            data[this.id + '_attachGuid'] = fileGuid;
            if (this.dataImport) {
                data[this.id + '_import'] = true;
            }

            // 添加事件删除请求前事件，方便外部个性化请求数据
            var event = {
                sender: this,
                eventType: 'beforefileremove',
                fileGuid: fileGuid,
                data: data
            };
            this.fire('beforefileremove', event);

            // 此处不能用Util.ajax
            // 原因是回调中需要拿到后端返回的控件数据，而Util.ajax是会过滤掉控件数据的
            var xhr = $.ajax({
                url: this.uploadUrl,
                data: event.data,
                dataType: 'json',
                type: 'post'
            });

            xhr.done(function (data) {
                data = mini.getSecondRequestData(data);
                self.fire('fileremovesuccess', {
                    sender: self,
                    eventType: 'fileremovesuccess',
                    fileGuid: fileGuid,
                    data: data
                });
            });
        }

        this.adjustBatchDownloadBtnVisibility();
    },
    clearFile: function (clearServer) {
        if (this.showDefaultUI) {
            this._getUIFun('clearFile').call(this, clearServer);
        } else {
            // 清空input 清空控件的服务端文件和服务端文件数目
            // 真正的dom和文件删除操作需要自行完成
            this._uploader && this._uploader.reset();
            this.serverFiles = {};
            this.serverFileNum = 0;

            // serverFileNum改变后需要重新设置下fileNumLimit
            this.setFileNumLimit(this.fileNumLimit);
            // eslint-disable-next-line
            console && console.warn && console.warn('非默认UI下使用此方法需要自行完成文件的删除操作');
        }
        this.adjustBatchDownloadBtnVisibility();
    },

    setFileNumLimit: function (fileNumLimit) {
        this.fileNumLimit = fileNumLimit;
        if (!fileNumLimit) {
            return;
        }
        var that = this;
        if (that._uploader) {
            that._uploader.option('fileNumLimit', fileNumLimit - that.serverFileNum);
        } else {
            this.getUploaderPromise().then(function () {
                that._uploader.option('fileNumLimit', fileNumLimit - that.serverFileNum);
            });
        }
    },

    _initEvents: function () {},
    _initUIEvents: function () {
        if (this.showDefaultUI) {
            mini.addClass(this.el, 'mini-uploader-ui-' + this.uiType);
            this._bindDefaultUIEvents();
        }
    },

    _bindDefaultUIEvents: function () {
        // 已绑定过，直接跳过，避免重复绑定
        if (this._isBindDefaultUIEvent) {
            return;
        }

        this._getUIFun('bindEvents').call(this);
        if (this.enableSort) {
            this._getUIFun('bindEnableSort').call(this);
        }

        // 记录是否已绑定过，以避免重复绑定
        this._isBindDefaultUIEvent = true;
    },
    _unbindDefaultUIEvents: function () {
        var $fileList = jQuery(this._fileList);
        $fileList
            .off('click', '.mini-uploader-remove')
            .off('click', '.mini-uploader-retry')
            .off('click', '.mini-uploader-secrecy');
        jQuery('body').off('mousedown.secrecyLevelList' + this.uid);

        $fileList.sortable('instance') && $fileList.sortable('destroy');

        this._isBindDefaultUIEvent = false;
    },

    _isBindSecrecyEvent: false,
    _bindSecrecyEvents: function () {
        // 已绑定过，直接跳过，避免重复绑定
        if (this._isBindSecrecyEvent) {
            return;
        }
        var that = this;
        jQuery(this._fileList).on('click', '.mini-uploader-secrecy', function () {
            var $this = jQuery(this),
                canEdit = $this.attr('canEdit'),
                $removeItem = $this.siblings('.mini-uploader-remove'),
                fileGuid = $removeItem.attr('fileGuid');
            if (canEdit === 'true') {
                that.showSecrecyLevelList($this, fileGuid);
            }
        });

        jQuery('body').on('mousedown.secrecyLevelList' + this.uid, function (e) {
            if (
                !$(e.target).hasClass('mini-uploader-secrecy') &&
                !$(e.target).closest('.mini-secrecylevel-list').length
            ) {
                that.hideSecrecyLevelList();
            }
        });

        // 页面滚动时，隐藏密级列表，避免其位置不对
        jQuery(document).on('mousewheel', function () {
            that.hideSecrecyLevelList();
        });
        this._isBindSecrecyEvent = true;
    },

    _queuedNum: 0,
    // 当文件被加入队列之前触发，此事件的handler返回值为false，则此文件不会被添加进入队列。
    _beforeFileQueued: function (file) {
        if (this.serverFileNum + this._queuedNum > this.fileNumLimit) {
            this._uploader.trigger('error', 'Q_EXCEED_NUM_LIMIT', this.fileNumLimit, file);
            return false;
        }
        // 对于后缀为中文的情况webuploader识别不了，会直接放过。
        // 这是webuploder的一个漏洞，只要把后缀改成中文的，就可以绕过limitType的限制
        // 为解决该问题需在文件加入队列前把后缀为中文这种不合法情况阻止掉
        if (/[\u4e00-\u9fa5]/.test(file.ext)) {
            this._uploader.trigger('error', 'Q_TYPE_DENIED', this.limitType, file);
            return false;
        }

        // Liunx系统中文件名称长度限制在100个字符，需要选文件时就把超过的过滤掉
        // 文件名长度判断 中文算3字符
        var filename = file.name;
        var fileNameLength = mini.getStrLength(filename, true);
        if (fileNameLength === 0) {
            mini.alert(this.fileNameNullErrorText);
            return false;
        }
        if (this.fileNameLengthLimit && fileNameLength > this.fileNameLengthLimit) {
            mini.alert(String.format(this.fileNameLengthErrorText, this.fileNameLengthLimit));
            return false;
        }

        // var specialReg = /^(?!\.)[^\\\/:\*\?"<>\|\%\;]{1,225}$/;
        // if(specialReg.test(file.name)) {
        //     mini.alert(this.specialCharacterErrorText);
        //     return false;
        // }

        // 是否将文件扩展名转化为小写
        if(mini.getF9FrameSysParams('webUploader_toLowerCase_ext')){
            var dotLength = filename.lastIndexOf('.'),
                ext = filename.substr(dotLength).toLowerCase(),
                partName = filename.substring(0, dotLength);
            file.name = partName + ext;
        }

        if (this._events.beforefilequeued) {
            var event = {
                source: this,
                sender: this,
                type: 'beforefilequeued',
                file: file,
                cancel: false
            };

            this.fire('beforefilequeued', event);

            if (event.cancel) {
                return false;
            }

            return true;
        }
    },
    _onFileQueued: function (file) {
        this._queuedNum++;
        // console.log('_fileQueued', file);
        this.fire('filequeued', { file: file });
    },

    // 当有文件添加进来的时候
    _onFilesQueued: function (files) {
        var event = {
            source: this,
            sender: this,
            type: 'onfilesqueued',
            files: files,
            errorContent: this._errorContent
        };

        if (this.showDefaultUI) {
            var item = '',
                html = [];
            // 向文件列表中添加记录
            for (var i = 0, len = files.length; i < len; i++, item = []) {
                item = this._generateFileList({
                    id: files[i].id,
                    name: files[i].name,
                    ext: files[i].ext,
                    size: files[i].size,
                    date: mini.formatDate(new Date(), 'yyyy-MM-dd')
                });

                html.push(item);
            }
            jQuery(this._fileList).append(html.join(''));
        }
        if (this._events.filesqueued) {
            this.fire('filesqueued', event);
        }

        // 如果有出错信息，则显示
        if (this._errorContent) {
            mini.alert(this._errorContent);
        }
        this._errorContent = '';

        this._queuedNum = 0;
    },

    _generateFileList: function (options) {
        options.fileGuid = options.fileGuid || '';
        // if (options.downloadUrl) {
        //     options.downloadUrl = _rootPath + '/' + options.downloadUrl;
        // } else {
        //     options.downloadUrl = 'javascript:void(0)';
        // }

        return this._getUIFun('generateFileList').call(this, options);
    },

    // 当文件被移除队列后触发
    _onFileDequeued: function (file) {
        this.fire('filedequeued', {
            file: file
        });
    },
    // 当 uploader 被重置的时候触发
    _onReset: function () {
        this.fire('reset');
    },

    _needPostData: true,
    // 当开始上传流程时触发
    _onStartUpload: function () {
        if (this.postData && this._needPostData) {
            this._uploader.stop();

            var me = this;
            var data = {
                commonDto: mini.encode(this.getCommonData())
            };

            if (this.cmdParams) {
                data.cmdParams = this.cmdParams;
            }
            data[this.id + '_incache'] = true;
            data[this.id + '_postData'] = this.postData;
            data[this.id + '_fileCount'] = this._uploader.getFiles().length;
            data[this.id + '_fileLoadedCount'] = this._uploader.getStats().successNum;

            var xhr = Util.ajax({
                url: this.uploadUrl,
                data: data,
                dataType: 'json'
            });

            xhr.done(function () {
                me._needPostData = false;
                me._uploader.upload();
            });
        }
        this.fire('startupload');
    },
    // 当上传流程暂停时触发
    _onStopUpload: function () {
        this.fire('stopupload');
    },
    // 当所有文件上传结束时触发
    _onUploadFinished: function () {
        this._needPostData = true;
        this.fire('uploadfinished');
    },
    // 某个文件开始上传前触发
    _onUploadStart: function (file) {
        if (this._events.uploadstart) {
            this.fire('uploadstart', {
                file: file
            });
        } else if (this.showDefaultUI) {
            this._getUIFun('onUploadStart').call(this, file);
        }
    },
    // 当某个文件的分块在发送前触发，主要用来询问是否要添加附带参数，大文件在开起分片上传的前提下此事件可能会触发多次
    _onUploadBeforeSend: function (object, data, headers) {
        data.commonDto = mini.encode(this.getCommonData());

        if (this.cmdParams) {
            data.cmdParams = this.cmdParams;
        }
        if (this.chunked) {
            data[this.id + '_action'] = 'chunk';

            var file = object.file;

            data.uploadGuid = file.uuid;
            data.fileMD5 = this._fileMD5[file.id];
            data.chunkSize = this.chunkSize * 1024;
            if(this.needChunkLocal !== undefined) {
                data.needChunkLocal = this.needChunkLocal;
            }
        } else {
            data[this.id + '_action'] = 'upload';

            // 非分片并且指定needMD5的，上传参数中需加文件的MD5值
            if (this.needMD5) {
                data.fileMD5 = this._fileMD5[data.id];
                delete this._fileMD5[data.id];
            }
        }
        if (this.dataImport) {
            data[this.id + '_import'] = true;
        }

        data[this.id + '_postData'] = this.postData;
        data[this.id + '_fileCount'] = this._uploader.getFiles().length;
        data[this.id + '_fileLoadedCount'] = this._uploader.getStats().successNum;

        // // 带上页面地址中的参数
        // var query = window.location.search.substring(1).split('&');
        // var param;
        // for (var i = 0, len = query.length; i < len; i++) {
        //     param = query[i].split('=');
        //     if (param[0]) {
        //         data[param[0]] = param[1];
        //     }
        // }
        if (typeof data.lastModifiedDate === 'object') {
            data.lastModifiedDate = data.lastModifiedDate.toISOString();
        } else if (!data.lastModifiedDate) {
            data.lastModifiedDate = object.file.lastModifiedDate.toISOString();
        }
        var event = {
            sender: this,
            object: object,
            data: data,
            headers: headers
        };

        // 添加框架的请求头
        if (window.Util && window.Util._buildFrameXhrHeaders) {
            $.extend(headers, window.Util._buildFrameXhrHeaders());
        }

        this.fire('uploadbeforesend', event);

        data = jQuery.extend(data, event.data);
    },
    // 当某个文件上传到服务端响应后，会派送此事件来询问服务端响应是否有效。如果此事件handler返回值为false, 则此文件将派送server类型的uploadError事件。
    _onUploadAccept: function (object, ret) {
        ret = mini.getSecondRequestData(ret);

        // 当返回数据中没有控件信息时，表明服务端出现了错误，则应返回false，告诉控件上传失败
        if (!ret) {
            return false;
        }
        ret = mini.decode(ret.data || ret);
        if (this.showDefaultUI && !this.chunked) {
            this._getUIFun('onUploadAccept').call(this, object, ret);
        }
        if (this._events.uploadaccept) {
            var event = {
                source: this,
                sender: this,
                type: 'uploadaccept',
                object: object,
                ret: ret
            };
            this.fire('uploadaccept', event);

            if (event.cancel) {
                return false;
            }
        }
        this.fire('filesuccess', {
            source: this,
            sender: this,
            type: 'filesuccess',
            file: object.file,
            data: ret
        });

        return true;
    },
    // 文件上传过程中触发。
    _onUploadProgress: function (file, percentage) {
        if (this.showDefaultUI) {
            this._getUIFun('onUploadProgress').call(this, file, percentage);
        }
        if (this._events.uploadprogress) {
            this.fire('uploadprogress', {
                file: file,
                percentage: percentage
            });
        }
    },
    _onUploadSuccess: function (file, ret) {
        // 秒传功能下只有一次查询附件状态的请求，所以成功事件中不会有后台返回的值，需要兼容
        var data = ret ? mini.getSecondRequestData(ret) : {};

        if (data.uploadFailed) {
            mini.alert(data.failedMsg || this.uploadErrorText);
            this.removeFile(file);

            return;
        }
        if (this.showDefaultUI) {
            this._getUIFun('onUploadSuccess').call(this, file, ret);
        }

        data = mini.decode(data.data || data);

        this.serverFiles[data.attachGuid] = {
            id: data.attachGuid,
            name: data.attachFileName,
            ext: data.attachFileName && data.attachFileName.substr(data.attachFileName.lastIndexOf('.') + 1),
            size: data.attachLength,
            date: data.uploadDateTime,
            fileGuid: data.attachGuid,
            downloadUrl: data.downloadUrl,
            // 预览参数值
            preparams: data.preparams || data.downloadUrl,
            hideDelete: data.readonly,
            secrecyLevel: data.secrecyLevel,
            uploadDate: data.uploadDate,
            success: true
        };

        if (this._events.uploadsuccess) {
            this.fire('uploadsuccess', {
                file: file,
                ret: ret
            });
        }
    },
    _onUploadError: function (file, reason) {
        if (this.showDefaultUI) {
            this._getUIFun('onUploadError').call(this, file, reason);
        }
        if (this._events.uploaderror) {
            this.fire('uploaderror', {
                file: file,
                reason: reason
            });
        }
    },
    _onUploadComplete: function (file) {
        if (this.showDefaultUI) {
            this._getUIFun('onUploadComplete').call(this, file);
        }
        if (this._events.uploadcomplete) {
            this.fire('uploadcomplete', {
                file: file
            });
        }

        this.adjustBatchDownloadBtnVisibility();
    },

    // 大文件上传时，在向服务端发送文件MD5校验码前触发
    _onBeforeMd5File: function (e) {
        e.data.commonDto = mini.encode(this.getCommonData());

        if (this.cmdParams) {
            e.data.cmdParams = this.cmdParams;
        }
        e.data[this.id + '_action'] = 'queryFileStatus';
        e.data[this.id + '_postData'] = this.postData;

        this.fire('beforemd5file', e);
    },

    // 大文件上传时，服务端校验MD5成功后触发的回调
    _onMd5File: function (response, file) {
        response = mini.getSecondRequestData(response);
        // '1'表示请求处理成功
        if (response.status === '1') {
            var result = response.result;
            // 已经上传过
            if (result.fileFinished) {
                this._uploader.skipFile(file);

                // 已上传过的应该直接将附件项设置为上传完成的状态，而不是把附件项删除
                if (this.showDefaultUI) {
                    this._getUIFun('onMd5FileFinished').call(this, result, file);
                }
            } else {
                this._existFileParts = result.existFileParts || '';
                this._existFileParts = ',' + this._existFileParts + ',';
            }
        }
    },
    // 大文件上传时，在文件上传完成时向服务端发送上传完成信息前触发
    _onBeforeMd5FileFinished: function (e) {
        e.data.commonDto = mini.encode(this.getCommonData());

        if (this.cmdParams) {
            e.data.cmdParams = this.cmdParams;
        }
        e.data[this.id + '_action'] = 'finishUpload';
        e.data[this.id + '_postData'] = this.postData;

        this.fire('beforemd5filefinished', e);
    },

    // 大文件上传时，文件上传成功后触发的回调
    _onMd5FileFinished: function (response, file) {
        var data = mini.getSecondRequestData(response);

        if (data.uploadFailed) {
            mini.alert(data.failedMsg || this.uploadErrorText);
            this.removeFile(file);

            return;
        }

        data = data.result || data;

        if (this.showDefaultUI) {
            this._getUIFun('onMd5FileFinished').call(this, data, file);
        }
        this.fire('finishedmd5file', {
            source: this,
            sender: this,
            type: 'finishedmd5file',
            file: file,
            data: data
        });
    },

    _getSize: function (size) {
        var unit = 'B';
        while (size > 1024 && unit !== 'T') {
            size = (size / 1024).toFixed(1);
            switch (unit) {
                case 'B':
                    unit = 'KB';
                    break;
                case 'KB':
                    unit = 'M';
                    break;
                case 'M':
                    unit = 'G';
                    break;
                case 'G':
                    unit = 'T';
                    break;
                default:
                    break;
            }
        }
        return size + unit;
    },

    getCommonData: function () {
        if (!this.controlData) {
            this.controlData = {
                id: this.id,
                type: 'webuploader',
                mapClass: this.mapClass,
                action: this.action,
                showDefaultUI: this.showDefaultUI,
                needChunkLocal: this.needChunkLocal,
                dataOptions: this['data-options']
            };
        }
        return [this.controlData, this.getViewdata()];
    },

    getViewdata: function () {
        var hidden = mini.get('_common_hidden_viewdata');

        if (!this.viewData) {
            this.viewData = {
                id: '_common_hidden_viewdata',
                type: 'hidden',
                value: ''
            };
        }

        if (hidden) {
            this.viewData.value = hidden.getValue();
        }

        return this.viewData;
    },

    setShowDefaultUI: function (showDefaultUI) {
        this.showDefaultUI = showDefaultUI;
        if (this.controlData) {
            this.controlData.showDefaultUI = showDefaultUI;
        }
        if (!showDefaultUI) {
            mini.removeClass(this.el, 'oa');
        }
    },

    setPostData: function (postData) {
        this.postData = postData;
    },

    secrecyLevelItems: [],
    _generateSecrecyLevelList: function () {
        var id = this.id + '-secrecylevel-popup';
        var html = [
                '<div class="mini-popup" id="' +
                    id +
                    '"><ul class="mini-secrecylevel-list" style="position: static;display: block;">'
            ],
            item;

        for (var i = 0, l = this.secrecyLevelItems.length; i < l; i++) {
            item = this.secrecyLevelItems[i];
            html.push('<li guid="' + item.id + '">' + item.text + '</li>');
        }

        html.push('</ul></div>');

        this._$secrecyLevelList = jQuery(html.join('')).appendTo('body');
        mini.parse(this._$secrecyLevelList[0]);
        this._$secrecyLevelList = $('#' + id);

        var self = this;
        this._$secrecyLevelList.on('click', 'li', function () {
            var $this = $(this),
                guid = $this.attr('guid'),
                text = $this.text(),
                attachGuid = self._$secrecyLevelList.attr('guid');
            self._onSecrecyLevelChange(guid, text, attachGuid);
        });
    },

    showSecrecyLevelList: function ($target, fileGuid) {
        if (!this.showSecrecyLevel) {
            return;
        }
        if (!this._$secrecyLevelList) {
            this._generateSecrecyLevelList();
        }

        this._$currentSecrecyLevel = $target;

        // var box = mini.getBox($target[0]);

        // this._$secrecyLevelList.css({
        //     top: box.top + box.height,
        //     left: box.left - 20,
        //     display: 'block'
        // }).attr('guid', fileGuid);
        this._$secrecyLevelList.attr('guid', fileGuid);
        var popup = mini.get(this._$secrecyLevelList[0]);
        if (popup) {
            popup.showAtEl($target[0]);
        }
    },

    hideSecrecyLevelList: function () {
        // this._$secrecyLevelList && this._$secrecyLevelList.hide();
        var popup = this._$secrecyLevelList && mini.get(this._$secrecyLevelList[0]);
        popup && popup.hide();
    },

    _onSecrecyLevelChange: function (guid, text, attachGuid) {
        var self = this;
        var data = {
            commonDto: mini.encode(this.getCommonData())
        };
        data[this.id + '_action'] = 'updateSecrecyLevel';
        data[this.id + '_attachGuid'] = attachGuid;

        data[this.id + '_secrecyLevel'] = guid;
        // 此处不能用Util.ajax
        // 原因是回调中需要拿到后端返回的控件数据，而Util.ajax是会过滤掉控件数据的
        var xhr = $.ajax({
            url: this.uploadUrl,
            data: data,
            dataType: 'json',
            type: 'post'
        });

        xhr.done(function (data) {
            data = mini.getSecondRequestData(data);
            if (data.success) {
                self._$currentSecrecyLevel.text(text).attr('guid', guid);

                self.fire('secrecylevelchanged', {
                    sender: self,
                    eventType: 'secrecylevelchanged',
                    fileGuid: attachGuid,
                    data: data
                });
            } else {
                var msg = data.msg || self.secrecyLevelSaveErrorText;
                mini.showTips({
                    content: msg,
                    state: 'warning',
                    y: 'center'
                });
            }
        }).always(function () {
            self.hideSecrecyLevelList();
        });
    },

    setSecrecyLevels: function (data) {
        this.secrecyLevelItems = data.levels;

        if (this.defaultSecrecyLevel === undefined) {
            this.defaultSecrecyLevel = data.default;
        }

        // 清空之前生成的下拉列表，防止data更新后，对应下拉列表没有更新
        if (this._$secrecyLevelList) {
            this._$secrecyLevelList.remove();
            this._$secrecyLevelList = undefined;
        }

        // 将之前计算出来的最高密级重置
        this._highestSecrecyLevel = undefined;
    },

    setShowSecrecyLevel: function (show) {
        this.showSecrecyLevel = show;

        if (show && !this._isBindSecrecyEvent) {
            this._bindSecrecyEvents();
        }
    },

    getHighestSecrecyLevel: function () {
        if (this._highestSecrecyLevel) {
            return this._highestSecrecyLevel;
        }

        if (!this.secrecyLevelItems || !this.secrecyLevelItems.length) {
            return {};
        }

        var item = this.secrecyLevelItems[0],
            i = 1,
            l = this.secrecyLevelItems.length;
        for (; i < l; i++) {
            if (this.secrecyLevelItems[i].id > item.id) {
                item = this.secrecyLevelItems[i];
            }
        }

        this._highestSecrecyLevel = item;

        return item;
    },

    setEnableSort: function (enableSort) {
        this.enableSort = enableSort;

        if (enableSort) {
            this._getUIFun('bindEnableSort').call(this);
        }
    },
    setFileMoreActionsMenu: function (menu) {
        this.fileMoreActionsMenu = menu;
        var el = mini.byId(menu);
        if (!el) return;

        mini.parse(menu);
        el = mini.get(menu);
        this._fileMoreActionsMenu = mini.getAndCreate(el);
    },
    // 设置是否显示为小尺寸
    setMinSize: function (value) {
        if (value !== true) {
            value = false;
        }
        this._minSize = value;
        jQuery(this._fileList)[value ? 'addClass' : 'removeClass'](this.minSizeCls);
    },
    getMinSize: function () {
        return this._minSize;
    },
    // 设置按钮显示隐藏
    _setFunBtnVisable: function (fileIndex, btnName, show) {
        var $files = jQuery(this._fileList).find('.mini-uploader-item'),
            $btns = null;

        show = show === true ? true : false;

        if (typeof fileIndex === 'number') {
            $btns = $files.eq(fileIndex).find('.file-func');
        } else {
            $btns = $files.find('.file-func');
        }

        $btns = $btns.find('.' + btnName + '-file');

        $btns[show ? 'removeClass' : 'addClass']('hidden');
    },
    setEditBtnVisable: function (fileIndex, show) {
        this._setFunBtnVisable(fileIndex, 'edit', show);
    },
    setPreviewBtnVisable: function (fileIndex, show) {
        this._setFunBtnVisable(fileIndex, 'preview', show);
    },
    setDeleteBtnVisable: function (fileIndex, show) {
        this._setFunBtnVisable(fileIndex, 'delete', show);
    },
    // 设置上传按钮是否显示
    setUploadBtnVisable: function (show) {
        show = show === true ? true : false;
        jQuery(this._uploadButtons)[show ? 'removeClass' : 'addClass']('hidden');
    },
    getUploadBtnVisable: function () {
        return jQuery(this._uploadButtons).hasClass('hidden');
    },
    // 设置和获取fileItemWidth
    setFileItemWidth: function (w) {
        this.fileItemWidth = w;
        jQuery(this._fileList).find('> .mini-uploader-item').css('width', w);
    },
    getFileItemWidth: function () {
        return this.fileItemWidth;
    },
    setShowAsFileList: function (value) {
        if (value === true) {
            // 隐藏上传按钮 隐藏文件列表中的编辑、删除按钮 通过文件列表上的一个列类控制，单独进行样式控制会有冲突
            this.showAsFileList = true;
            jQuery(this._buttons).addClass('hidden');
            jQuery(this._fileList).addClass('readonly');
        } else {
            this.showAsFileList = false;
            jQuery(this._buttons).removeClass('hidden');
            jQuery(this._fileList).removeClass('readonly');
        }
    },
    getShowAsFileList: function () {
        return this.showAsFileList;
    },
    set: function (kv) {
        if (typeof kv === 'string') {
            return this;
        }

        var pickerText = kv.pickerText;
        delete kv.pickerText;

        // 有下拉菜单
        if (kv.menu && jQuery(kv.menu).length) {
            this._showSplit = true;
            this.menu = kv.menu;

            delete kv.menu;
        }
        // 自己指定附件列表容器
        if (kv.fileList && jQuery(kv.fileList).length) {
            this.setFileList(jQuery(kv.fileList)[0]);

            delete kv.fileList;
        }
        // 未手动配置是否显示按钮时 根据是否在工具栏中进行适配 工具栏默认不显示 其他位置显示
        if (!('showIcon' in kv) && this.el) {
            kv.showIcon = jQuery(this.el).closest('.fui-toolbar, .fui-toolbat-bottom').length ? false : true;
        }
        if(kv.dnd) {
            this.dnd = kv.dnd;
            delete kv.dnd;
        }
        if(kv.enableDnd) {
            this.enableDnd = true;
            this._initDnd();

            delete kv.enableDnd;
        }
        mini.WebUploader.superclass.set.call(this, kv);

        if (pickerText) {
            this.pickerText = pickerText;
            this._pickerText.innerHTML = pickerText;
        }

        this._initUploader();

        return this;
    },
    /**
     * 创建实例
     * @private
     * @member mini.WebUploader
     */
    _create: function () {
        this.serverFiles = {};
        this.el = document.createElement('div');

        this.el.innerHTML =
            '<div class="mini-uploader-btns"><div class="mini-uploader-btn-upload"><label class="mini-btn-pick"><i class="mini-button-icon icon-upload"></i><span class="mini-btn-pick-text">' +
            this.pickerText +
            '</span></label></div>' +
            '<div class="mini-uploader-btn-download" style="display: none;"></div></div>' +
            '<div class="mini-uploader-tips">' +
            (this.tipText || '') +
            '</div>' +
            '<div class="mini-uploader-list"></div>';

        this._buttons = this.el.firstChild;
        this._tipsEl = this.el.childNodes[1];
        this._fileList = this.el.lastChild;
        this._$fileList = jQuery(this._fileList);

        this._uploadButtons = this._buttons.firstChild;
        this._picker = this._uploadButtons.firstChild;
        this._pickerText = this._picker.lastChild;

        this._uploadBtn = new mini.Button();
        this._uploadBtn.setText(this.startText);
        // this._editor.setVisible(false);
        this._uploadBtn.render(this._uploadButtons);

        this._downloadButtons = this._buttons.lastChild;
        this._batchDownloadBtn = new mini.Button();
        this._batchDownloadBtn.set({
            text: this.batchDownloadText,
            cls: 'mini-uploader-batch-download'
        });
        this._batchDownloadBtn.render(this._downloadButtons);

        if (this.showIcon) {
            mini.addClass(this._buttons, 'show-icon');
        }

        this._errorContent = '';

        // 隐藏控件的显示，防止控件初始化时的页面闪烁
        this._buttons.style.visibility = 'hidden';

        this.on('render', this._initUploader, this);
    },
    _isDndInit: false,
    _initDnd: function() {
        if(this._isDndInit) {
            return;
        }

        if(!this.dnd) {
            this.dnd = document.createElement('div');
            this.dnd.className = 'mini-webuploader-drop-area';
            this.dnd.innerText = this.dndPlaceholderText;

            this.el.insertBefore(this.dnd, this._tipsEl);

            mini.on(this.dnd, 'click', function(){
                $(this._picker).click();
            }, this)
        }

        this.setUploadBtnVisable(false);
        this._isDndInit = true;
    },
    /**
     * 根据文件返回计算MD5的范围
     * 10MB 以下全量计算 否则取前10KB
     * @param {File}  file 浏览器选取得到的文件对象
     * @returns {[File [, number [, number]]]}
     */
    getMD5Summary: function (file) {
        // 10M 以下全量计算
        if (file.size < this.maxFullMD5Size * 1024) {
            return [file];
        }
        // 否则取前 10KB
        return [file, 0, 10240];
    },

    _isInit: false,
    _initUploader: function () {
        var that = this;
        if (!this.isInit) {
            this.externalSrc = this.externalSrc || mini.externalSrc;

            if (!window.WebUploader) {
                // eslint-disable-next-line
                if (typeof define === 'function' && define.amd) {
                    // eslint-disable-next-line no-undef
                    define('jquery', function () {
                        return window.jQuery;
                    });
                }
                mini.loadJSWithAMD(this.externalSrc + 'webuploader/webuploader.js', 'WebUploader', function () {
                    that._createUploader();
                });
            } else {
                this._createUploader();
            }

            // 加载右侧下拉菜单
            if (this._showSplit) {
                this._splitBtn = new mini.MenuButton();
                this._splitBtn.setMenu(this.menu);
                this._splitBtn.render(jQuery(this.el).find('.mini-btn-pick')[0], 'after');

                mini.addClass(this._buttons, 'dropdown-menu');
                if (this.btnState === 'primary') {
                    this._splitBtn.setState('primary');
                }
            }

            this.isInit = true;
        }
    },

    _createUploader: function () {
        var accept = null,
            that = this;
        if (this.limitType) {
            accept = {
                extensions: this.limitType,
                mimeTypes: this.mimeTypes
            };
        }

        this._fileMD5 = {};
        if (this.chunked && !this._isInit) {
            this._hasFinishedList = {};

            // 注册事件是全局的，只需要注册一次
            // if (!window.isRegWebUploader) {
            WebUploader.Uploader.register(
                {
                    'before-send-file': 'preupload',
                    'before-send': 'checkchunk',
                    'after-send-file': 'finished'
                },
                {
                    preupload: function (file) {
                        if (this.owner !== that._uploader) return;
                        var me = this,
                            owner = this.owner,
                            server = me.options.server,
                            deferred = WebUploader.Deferred(),
                            // 通过file获取到触发上传的上传控件
                            $refer = $(file.source._refer),
                            $upload = $refer.closest('.mini-webuploader');

                        that = mini.getAndCreate($upload[0]);

                        if (that.chunked) {
                            // owner.md5File(file.source)
                            var md5Args = that.getMD5Summary(file.source);
                            owner.md5File
                                .apply(owner, md5Args)

                                // 如果读取出错了，则通过reject告诉webuploader文件上传出错。
                                .fail(function () {
                                    deferred.reject();
                                })

                                // md5值计算完成
                                .then(function (md5) {
                                    // 记录下文件的md5，以备上传完成时使用。
                                    that._fileMD5[file.id] = md5;

                                    // 在分片情况下生成一个唯一id，以方便后端管理临时文件
                                    file.uuid = mini.UUID();

                                    var e = {
                                        url: server,
                                        data: {
                                            fileMD5: md5,
                                            fileName: file.name,
                                            fileSize: file.size,
                                            lastModifiedDate: file.lastModifiedDate.toISOString(),
                                            uploadGuid: file.uuid
                                        }
                                    };
                                    if (md5Args[1] !== undefined) {
                                        e.data.fileMD5Start = md5Args[1];
                                        file.md5Start = md5Args[1];
                                    }
                                    if (md5Args[2] !== undefined) {
                                        e.data.fileMD5End = md5Args[2];
                                        file.md5End = md5Args[2];
                                    }

                                    that._onBeforeMd5File(e);

                                    // 与服务端验证
                                    $.ajax(e.url, {
                                        dataType: 'json',
                                        data: e.data,
                                        type: 'post',
                                        success: function (response) {
                                            that._onMd5File(response, file);

                                            // 接受此promise, webuploader接着往下走。
                                            deferred.resolve();
                                        },
                                        error: function () {
                                            deferred.reject();
                                            if ($.ajaxSettings.error) {
                                                $.ajaxSettings.error.apply(this, arguments);
                                            }
                                        }
                                    });
                                });

                            return deferred.promise();
                        }
                    },

                    checkchunk: function (block) {
                        if (this.owner !== that._uploader) return;
                        if (that.chunked) {
                            var chunkIndex = ',' + block.chunk + ',',
                                deferred = $.Deferred();

                            if (that._existFileParts.indexOf(chunkIndex) > -1) {
                                deferred.reject();
                            } else {
                                deferred.resolve();
                            }

                            return deferred.promise();
                        }
                    },

                    finished: function (file) {
                        if (this.owner !== that._uploader) return;
                        var deferred = WebUploader.Deferred();

                        if (that.chunked) {
                            // 之前已上传完成的不用再发已完成请求了
                            if (that._hasFinishedList[file.id]) {
                                that._hasFinishedList[file.id] = false;
                                delete that._hasFinishedList[file.id];

                                return;
                            }
                            var e = {
                                url: that.uploadUrl,
                                data: {
                                    fileMD5: that._fileMD5[file.id],
                                    fileName: file.name,
                                    fileSize: file.size,
                                    lastModifiedDate: file.lastModifiedDate.toISOString(),
                                    fileMD5Start: file.md5Start,
                                    fileMD5End: file.md5End,
                                    uploadGuid: file.uuid,
                                    contentType: file.type
                                }
                            };
                            that._onBeforeMd5FileFinished(e);

                            // 告诉服务端验文件已发完
                            $.ajax(e.url, {
                                dataType: 'json',
                                data: e.data,
                                type: 'post',
                                success: function (response) {
                                    that._onMd5FileFinished(response, file);

                                    delete that._fileMD5[file.id];
                                },
                                error: function () {
                                    deferred.reject();
                                    if ($.ajaxSettings.error) {
                                        $.ajaxSettings.error.apply(this, arguments);
                                    }
                                }
                            });
                        }
                    }
                }
            );

            // window.isRegWebUploader = true;
            // }
        } else if (this.needMD5) {
            WebUploader.Uploader.register(
                {
                    'before-send-file': 'preupload'
                },
                {
                    preupload: function (file) {
                        if (this.owner !== that._uploader) return;
                        var me = this,
                            owner = this.owner,
                            deferred = WebUploader.Deferred();

                        // owner.md5File(file.source)
                        var md5Args = that.getMD5Summary(file.source);
                        if (md5Args[1] !== undefined) {
                            file.md5Start = md5Args[1];
                        }
                        if (md5Args[2] !== undefined) {
                            file.md5End = md5Args[2];
                        }
                        owner.md5File
                            .apply(owner, md5Args)

                            // 如果读取出错了，则通过reject告诉webuploader文件上传出错。
                            .fail(function () {
                                deferred.reject();
                            })

                            // md5值计算完成
                            .then(function (md5) {
                                // 记录下文件的md5，以备上传完成时使用。
                                that._fileMD5[file.id] = md5;

                                // 接受此promise, webuploader接着往下走。
                                deferred.resolve();
                            });

                        return deferred.promise();
                    }
                }
            );
        }
        // 防止配置错误导致无法解析
        if (this.dnd && !jQuery(this.dnd).length) {
            window.console &&
                window.console.error &&
                console.error('配置的上传拖拽元素选择器无效，无法找到 ' + this.dnd + ' 这个元素');
            this.dnd = '';
        }
        // 对未安装flash的IE9及以下浏览器给出安装flash的提示
        try {
            this._uploader = WebUploader.create({
                // swf文件路径
                swf: this.externalSrc + 'webuploader/Uploader.swf',

                // 文件接收服务端。
                server: this.uploadUrl,

                // 选择文件的按钮。
                // pick: this._picker,
                // fileNumLimit为1时，应该设置其不能多选
                pick: {
                    id: this._picker,
                    multiple: this.fileNumLimit == 1 ? false : true
                },
                dnd: this.dnd,

                // 是否自动上传
                auto: this.auto,

                // 最大文件总数量
                fileNumLimit: this.fileNumLimit,

                // 最大文件总大小
                fileSizeLimit: this.fileSizeLimit * 1024,

                // 单个文件最大大小
                fileSingleSizeLimit: this.fileSingleSizeLimit * 1024,

                // 可接受的文件类型
                accept: accept,

                // 是否要分片处理大文件上传
                chunked: this.chunked,

                // 如果要分片，分多大一片
                chunkSize: this.chunkSize * 1024,

                // 如果某个分片由于网络问题出错，允许自动重传多少次
                chunkRetry: this.chunkRetry,

                // 分片是否需要计算 MD5
                needChunkMD5: this.needChunkMD5 && this.chunked,
                // 压缩
                compress: this.compress,

                //  是否不去重，默认为undefined，即不可上传文件名字、文件大小和最后修改时间来生成hash Key相同的文件
                //                              为true时表示可上传相同文件。
                duplicate: this.duplicate,

                timeout: this.timeout,

                threads: this.threads
            });
        } catch (e) {
            if (e.message == 'Runtime Error') {
                // IE9以下，且未安装FLASH时，提示用户下载安装
                if (mini.isIE9 || mini.isIE8 || mini.isIE7 || mini.isIE6) {
                    try {
                        new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
                    } catch (err) {
                        that.el.innerHTML = that.noflashInnerHTML;
                        mini.showPageWarning({
                            html: that.noflashPageWarning
                        });
                    }
                }
            } else {
                throw e;
            }
            return;
        }
        // END

        this._uploader
            .on('beforeFileQueued', function (file) {
                return that._beforeFileQueued(file);
            })
            .on('fileQueued', function (file) {
                that._onFileQueued(file);
            })
            .on('filesQueued', function (files) {
                that._onFilesQueued(files);
            })
            .on('fileDequeued', function (file) {
                that._onFileDequeued(file);
            })
            .on('dndAccept', function (files) {
                return that._onDndAccept(files);
            })
            .on('reset', function () {
                that._onReset();
            })
            .on('startUpload', function () {
                that._onStartUpload();
            })
            .on('stopUpload', function () {
                that._onStopUpload();
            })
            .on('uploadFinished', function () {
                that._onUploadFinished();
            })
            .on('uploadStart', function (file) {
                that._onUploadStart(file);
            })
            .on('uploadBeforeSend', function (object, data, headers) {
                // 当某个文件的分块在发送前触发，主要用来询问是否要添加附带参数，大文件在开起分片上传的前提下此事件可能会触发多次。
                // object {Object}
                // data {Object}默认的上传参数，可以扩展此对象来控制上传参数。
                // headers {Object}可以扩展此对象来控制上传头部。
                that._onUploadBeforeSend(object, data, headers);
            })
            .on('uploadAccept', function (object, ret) {
                // 当某个文件上传到服务端响应后，会派送此事件来询问服务端响应是否有效。如果此事件handler返回值为false, 则此文件将派送server类型的uploadError事件。
                // object {Object}
                // ret {Object}服务端的返回数据，json格式，如果服务端不是json格式，从ret._raw中取数据，自行解析。
                return that._onUploadAccept(object, ret);
            })
            .on('uploadProgress', function (file, percentage) {
                that._onUploadProgress(file, percentage);
            })
            .on('uploadSuccess', function (file, response) {
                that._onUploadSuccess(file, response);
            })
            .on('uploadError', function (file, reason) {
                that._onUploadError(file, reason);
            })
            .on('uploadComplete', function (file) {
                that._onUploadComplete(file);
            })
            .on('all', function (type) {
                // 控制状态
                if (type === 'startUpload') {
                    that.state = 'uploading';
                } else if (type === 'stopUpload') {
                    that.state = 'paused';
                } else if (type === 'uploadFinished') {
                    that.state = 'done';
                }

                // 非自动上传，根据状态调整上传按钮的显示文字
                if (!that.auto && that.state === 'uploading') {
                    that._uploadBtn.setText(that.pauseText);
                } else {
                    that._uploadBtn.setText(that.startText);
                }
            })
            .on('error', function (type) {
                that._onFilePickError(type);
            })
            .on('ready', function () {
                that._uploaderPick = that._picker.lastChild;
                // webuploader内部会将_pickerText 包裹一遍，需要重新获取一次
                that._pickerText = jQuery(that._picker).find('.mini-btn-pick-text')[0];
                if (!that.enabled) {
                    that._uploader.disable();
                    jQuery(that._uploaderPick).detach();
                }
                that.fire('init', {
                    sender: that,
                    type: 'init'
                });
            });

        // 非自动上传，绑定上传按钮的点击事件
        if (!this.auto) {
            this._uploadBtn.on('click', function () {
                if (that.state === 'uploading') {
                    that._uploader.stop(true);
                } else {
                    that._uploader.upload();
                }
            });
        } else {
            // 自动上传，隐藏上传按钮
            this._uploadBtn.hide();
        }
        if (this.showBatchDownloadBtn) {
            this._batchDownloadBtn.on('click', function () {
                that.batchDownload();
            });
        }

        // 初始化完，显示控件
        this._buttons.style.visibility = 'visible';
        this._isInit = true;
    },

    getFileList: function () {
        return this._fileList;
    },
    setFileList: function (fileList) {
        if (fileList && this._fileList != fileList) {
            this._fileList = fileList;
            this._$fileList = jQuery(fileList).addClass('mini-uploader-list');
            this._unbindDefaultUIEvents && this._unbindDefaultUIEvents();
            this._initUIEvents && this._initUIEvents();
        }
    },

    getUploader: function () {
        // 由于初始化可能是异步的，this._uploader不确定什么时候初始化完成
        // 这里先暂时用等待1秒
        // Ugly code 待优化
        /**
         * 下面这段代码没有任何实际意义只是跑了1s的死循环而已
         * 因为这段代码执行中一致占据进程，如果调用的时候初始化未完成，则永远是未完成状态
         */
        // if (!this._uploader) {
        //     var start = Date.now(),
        //         diff = 0;
        //     while (!this._uploader && diff < 1) {
        //         diff = new Date(Date.now() - start).getSeconds();
        //     }
        // }
        return this._uploader;
    },
    /**
     * 获取内部原生uploader
     * @param {Fucntion/undefined} callback 获取成功的触发的回调函数，参数为获取到的uploader
     * @return {Promise} jQuery模拟的Promise
     */
    getUploaderPromise: function (callback) {
        var that = this,
            dtd = jQuery.Deferred(),
            reGetCount = 0;

        function _getUploader() {
            // 超时直接判定初始化失败 暂定50次 即一秒
            if (reGetCount++ > 50) return dtd.reject(new Error('上传控件初始化超时！'));

            var uploader = that._uploader;
            // 已经存在则成功 否则20ms后重试
            if (uploader) {
                setTimeout(function () {
                    dtd.resolve(uploader);
                    if (typeof callback === 'function') {
                        callback(uploader);
                    }
                });
            } else {
                setTimeout(_getUploader, 20);
            }
        }

        _getUploader();

        return dtd.promise();
    },

    retry: function (file) {
        this._uploader.retry(file);
    },

    refresh: function () {
        this._uploader && this._uploader.refresh();
    },

    /**
     * 当选择文件过程出错时触发
     * @param {String} type
     */
    _onFilePickError: function (type) {
        // 构建出错信息
        switch (type) {
            case 'Q_EXCEED_NUM_LIMIT':
                this._errorContent = String.format(this.numLimitErrorText, this.fileNumLimit);
                break;
            case 'Q_EXCEED_SIZE_LIMIT':
                this._errorContent = String.format(this.sizeLimitErrorText, this.fileSizeLimit);
                break;
            case 'Q_TYPE_DENIED':
                this._errorContent = String.format(this.typeDeniedErrorText, this.limitType);
                break;
            case 'F_EXCEED_SIZE':
                this._errorContent = String.format(this.sizeErrorText, this.fileSingleSizeLimit);
                break;
            case 'Q_EMPTY_FILE':
                this._errorContent = this.emptyFileErrorText;
                break;
            case 'F_DUPLICATE':
                this._errorContent = this.duplicateErrorText;
                break;
            default:
                break;
        }
        // 如果有出错信息，则显示
        if (this._errorContent) {
            mini.alert(this._errorContent);
        }
        this._errorContent = '';
    },
    // 当 uploader 被重置的时候触发
    _onDndAccept: function (files) {
        var e = {
            sender: this,
            files: files,
            cancel: false
        };
        this.fire('dndAccept', e);
        if (e.cancel === true) {
            this._uploader.reset();
            return false;
        }
    },

    _existFileParts: '',

    /**
     *
     * function setUploadUrl(uploadUrl)
     * @member mini.WebUploader
     * @param {String} uploadUrl
     *
     */
    setUploadUrl: function (uploadUrl) {
        this.uploadUrl = uploadUrl;
        if (this._uploader) {
            this._uploader.option('server', uploadUrl);
        }
    },
    /**
     *
     * function getUploadUrl()
     * @member mini.WebUploader
     * @returns {String}
     *
     */
    getUploadUrl: function () {
        return this.uploadUrl;
    },
    /**
     *
     * function setAuto(auto)
     * @member mini.WebUploader
     * @param {Boolen} auto
     *
     */
    setAuto: function (auto) {
        this.auto = auto;
        if (this._uploader) {
            this._uploader.option('auto', auto);
        }
    },
    /**
     *
     * function getAuto()
     * @member mini.WebUploader
     * @returns {Boolen}
     *
     */
    getAuto: function () {
        return this.auto;
    },
    /**
     * defaultCompres 默认压缩配置
     * @type {Object}
     */
    defaultCompres: {
        width: 1600,
        height: 1600,

        // 图片质量，只有type为`image/jpeg`的时候才有效。
        quality: 90,

        // 是否允许放大，如果想要生成小图的时候不失真，此选项应该设置为false.
        allowMagnify: false,

        // 是否允许裁剪。
        crop: false,

        // 是否保留头部meta信息。
        preserveHeaders: true,

        // 如果发现压缩后文件大小比原来还大，则使用原来图片
        // 此属性可能会影响图片自动纠正功能
        noCompressIfLarger: false,

        // 单位字节，如果图片大小小于此值，不会采用压缩。
        compressSize: 0
    },
    /**
     * function setCompress(compress) 设置是否压缩
     * @param {Boolea]} compress
     */
    setCompress: function (compress) {
        this.compress = compress ? this.defaultCompres : false;

        if (this._uploader) {
            this._uploader.option('compress', this.compress);
        }
    },
    /**
     * function getCompress ()
     * @return {Boolean} [description]
     */
    getCompress: function () {
        return this.compress ? true : false;
    },

    /**
     *
     * function getFileNumLimit()
     * @member mini.WebUploader
     * @returns {int}
     *
     */
    getFileNumLimit: function () {
        return this.fileNumLimit;
    },
    /**
     *
     * function setFileSizeLimit(fileSizeLimit)
     * @member mini.WebUploader
     * @param {int} fileSizeLimit
     *
     */
    setFileSizeLimit: function (fileSizeLimit) {
        this.fileSizeLimit = fileSizeLimit;
        if (this._uploader) {
            this._uploader.option('fileSizeLimit', fileSizeLimit * 1024);
        }
    },
    /**
     *
     * function getFileSizeLimit()
     * @member mini.WebUploader
     * @returns {int}
     *
     */
    getFileSizeLimit: function () {
        return this.fileSizeLimit;
    },
    /**
     *
     * function setFileSingleSizeLimit(fileSingleSizeLimit)
     * @member mini.WebUploader
     * @param {int} fileSingleSizeLimit
     *
     */
    setFileSingleSizeLimit: function (fileSingleSizeLimit) {
        this.fileSingleSizeLimit = fileSingleSizeLimit;
        if (this._uploader) {
            this._uploader.option('fileSingleSizeLimit', fileSingleSizeLimit * 1024);
        }
    },
    /**
     *
     * function getFileSingleSizeLimit()
     * @member mini.WebUploader
     * @returns {int}
     *
     */
    getFileSingleSizeLimit: function () {
        return this.fileSingleSizeLimit;
    },
    // /**
    //  *
    //  * function setLimitType(limitType)
    //  * @member mini.WebUploader
    //  * @param {String} limitType
    //  *
    //  */
    // setLimitType: function(limitType) {
    //     this.limitType = limitType;
    //     if (this._uploader) {
    //         this._uploader.option("accept", {
    //             extensions: this.limitType
    //         });
    //     }
    // },
    /**
     *
     * function getLimitType()
     * @member mini.WebUploader
     * @returns {String}
     *
     */
    getLimitType: function () {
        return this.limitType;
    },

    setLimitType: function (limitType) {
        if (this.limitType != limitType) {
            this.limitType = limitType;

            if (this._uploader) {
                if (!this._uploader.options.accept) {
                    this._uploader.options.accept = [{}];
                }
                this._uploader.options.accept[0].extensions = this.limitType;

                // webuploader的设置accept属性存在bug，必须要执行下面这句
                this._uploader._init({
                    accept: this._uploader.options.accept
                });

                // // flash版本下设置limitType是无效的，必须要重新生成一遍
                // if (this._uploader.predictRuntimeType() == "flash") {
                //     var options = this._uploader.options;
                //     this._uploader.destroy();
                //     this._picker.innerHTML = this.pickerText;
                //     this._createUploader();
                // } else {

                //     // webuploader的设置accept属性存在bug，必须要执行下面这句
                //     this._uploader._init({
                //         accept: this._uploader.options.accept
                //     });
                // }
            }
        }
    },
    /**
     *
     * function getMimeTypes()
     * @member mini.WebUploader
     * @returns {String}
     *
     */
    getMimeTypes: function () {
        return this.mimeTypes;
    },
    setMimeTypes: function (mimeTypes) {
        var _uploader = this._uploader;
        function setAccept(accept) {
            var $input = jQuery(_uploader.options.pick.id).find('input[type="file"]');

            if ($input.length) {
                $input.attr('accept', accept);
            } else {
                setTimeout(function () {
                    setAccept(accept);
                }, 100);
            }
        }
        if (this.mimeTypes !== mimeTypes) {
            this.mimeTypes = mimeTypes;

            if (this._uploader) {
                if (!this._uploader.options.accept) {
                    this._uploader.options.accept = [{}];
                }
                this._uploader.options.accept[0].mimeTypes = this.mimeTypes;
                // 非flash模式下，需要额外设置input的accept属性才能生效
                if (this._uploader.predictRuntimeType() != 'flash') {
                    setAccept(this.mimeTypes);
                }
            }
        }
    },
    setVisible: function (value) {
        this.visible = value;
        // ie8/9下直接隐藏会导致上传报错
        if (this.el) {
            if (value) {
                mini.removeClass(this.el, 'invisible');
                mini.removeClass(this._buttons, 'webuploader-element-invisible');
            } else {
                mini.addClass(this.el, 'invisible');
                mini.addClass(this._buttons, 'webuploader-element-invisible');
            }
        }
    },
    setEnabled: function (value) {
        this.enabled = value;
        if (this.enabled) {
            this.removeCls(this._disabledCls);
            this._$fileList.removeClass(this._disabledCls);
            jQuery(this._uploaderPick).appendTo(this._picker);
            if (this._uploader) {
                this._uploader.enable();
            }
            this._uploadBtn && this._uploadBtn.enable();
        } else {
            this.addCls(this._disabledCls);
            this._$fileList.addClass(this._disabledCls);
            if (this._uploader) {
                this._uploader.disable();
            }
            this._uploadBtn && this._uploadBtn.disable();
            jQuery(this._uploaderPick).detach();
        }
        this._doReadOnly();
    },
    /**
     * [getDuplicate 获取是否不去重]
     * @return {[type]} [是否不去重]
     */
    getDuplicate: function () {
        return this.duplicate;
    },
    /**
     * [setDuplicate 设置是否不去重]
     * @param {[Boolean]} duplicate [是否不去重，]
     * 此属性只能初始化时一次指定，设置无效，因此暂时注释掉
     */
    // setDuplicate: function(duplicate) {
    //     this.duplicate = duplicate;
    //     if (this._uploader) {
    //         this._uploader.option('duplicate', this.duplicate);
    //     }
    // },
    setPickerText: function (text) {
        this.pickerText = text;
        this._pickerText.innerHTML = text;
    },
    getPickerText: function () {
        return this.pickerText;
    },

    setShowIcon: function (showIcon) {
        this.showIcon = showIcon;
        showIcon ? mini.addClass(this._buttons, 'show-icon') : mini.removeClass(this._buttons, 'show-icon');
    },
    getShowIcon: function () {
        return this.showIcon;
    },

    setTipText: function (text) {
        this.tipText = text;
        this._tipsEl && (this._tipsEl.innerText = text);
    },
    getTipText: function () {
        return this.tipText;
    },
    setBtnState: function (state) {
        this.btnState = state;
        if (state === 'primary') {
            mini.addClass(this._buttons, 'mini-uploader-btns-primary');
            this._splitBtn && this._splitBtn.setState('primary');
        } else {
            mini.removeClass(this._buttons, 'mini-uploader-btns-primary');
            this._splitBtn && this._splitBtn.setState('default');
        }
    },
    setShowBatchDownloadBtn: function (show) {
        this.showBatchDownloadBtn = show;
        this.adjustBatchDownloadBtnVisibility();
    },
    getShowBatchDownloadBtn: function () {
        return this.showBatchDownloadBtn;
    },
    batchDownload: function () {
        if (this.batchDownloadUrl) {
            var query;
            if (this._clientGuid) {
                query = 'clientGuid=' + this._clientGuid;
            } else {
                query = 'attachGuid=';
                for (var i in this.serverFiles) {
                    query += i + ';';
                }
            }
            var url = this.batchDownloadUrl,
                index = url.indexOf('?');
            url += (index > -1 ? '&' : '?') + query;
            window.open(_rootPath + '/' + url, '_blank');
        }
    },
    adjustBatchDownloadBtnVisibility: function () {
        var num = this.serverFileNum,
            stats;
        if (this.showBatchDownloadBtn && this.batchDownloadUrl) {
            if (this._uploader) {
                stats = this._uploader.getStats();
                num = num + stats.successNum - stats.cancelNum;
            }

            if (num > 1) {
                jQuery(this._downloadButtons).show();
            } else {
                jQuery(this._downloadButtons).hide();
            }
        } else {
            jQuery(this._downloadButtons).hide();
        }
    },
    setRequired: function(value){
        this.required = value;
    },
    getRequired: function(){
        return this.required;
    },
    setRequiredErrorText: function (value) {
        this.requiredErrorText = value;
    },
    getRequiredErrorText: function () {
        return this.requiredErrorText;
    },
    validate: function(){
        var e = {
            value: $.isEmptyObject(this.serverFiles),
            errorText: "",
            isValid: true
        };

        if (this.required) {
            if (e.value) {
                e.isValid = false;
                e.errorText = this.requiredErrorText;
            }
        }
        
        this.errorText = e.errorText;
        this.setIsValid(e.isValid);
        return this.isValid();
    },
    isValid: function () {
        return this._IsValid;
    },
    setIsValid: function (value) {
        this._IsValid = value;
    },
    getIsValid: function () {
        return this._IsValid;
    },
    getAttrs: function (el) {
        var attrs = mini.WebUploader.superclass.getAttrs.call(this, el);
        attrs.text = el.innerHTML;
        mini._ParseString(el, attrs, [
            'uploadUrl',
            'limitType',
            'mimeTypes',
            'onbeforefilequeued',
            'onfilequeued',
            'onfilesqueued',
            'onfiledequeued',
            'onreset',
            'onstartupload',
            'onstopupload',
            'onuploadfinished',
            'onuploadstart',
            'onuploadbeforesend',
            'onuploadaccept',
            'onuploadprogress',
            'onuploadsuccess',
            'onuploaderror',
            'onuploadcomplete',
            'pickerText',
            'tipText',
            'onbeforemd5file',
            'onbeforemd5filefinished',
            'oninit',
            'dnd',
            'ondndAccept',
            'editurl',
            'editext',
            'previewurl',
            'previewext',
            'menu',
            'fileList',
            'btnState',
            'batchDownloadText',
            'tipText'
        ]);
        mini._ParseBool(el, attrs, [
            'required',
            'auto',
            'chunked',
            'compress',
            'needMD5',
            'duplicate',
            'showIcon',
            'showBatchDownloadBtn',
            'needChunkMD5'
        ]);
        mini._ParseInt(el, attrs, [
            'fileNumLimit',
            'fileSizeLimit',
            'fileSingleSizeLimit',
            'chunkSize',
            'chunkRetry',
            'timeout',
            'threads',
            'maxFullMD5Size'
        ]);

        return attrs;
    },
    getExtraAttrs: function (el) {
        var attrs = {};
        mini._ParseString(el, attrs, [
            'onfinishedmd5file',
            'onfilesuccess',
            'onbeforefileremove',
            'onfileremovesuccess',
            'onfilesortsuccess',
            'postData',
            'onload',
            'onfileremove',
            'onsecrecylevelchanged',
            'previewUrl',
            'previewExt',
            'editUrl',
            'editExt',
            'fileMoreActionsMenu',
            'menu',
            'uiType',
            'fileItemWidth',
            'onbeforepreview',
            'onbeforeedit',
            'clientGuidBind'
        ]);
        mini._ParseBool(el, attrs, [
            'dataImport',
            'showDefaultUI',
            'needChunkLocal',
            'enableSort',
            'minSize',
            'showAsFileList',
            'enableDnd'
        ]);
        mini._ParseInt(el, attrs, ['fileNameLengthLimit']);
        return attrs;
    }
});
mini.regClass(mini.WebUploader, 'webuploader');

// 早期UI的实现
var defaultUI = {
    generateFileList: function (options) {
        var canDownload = true;

        if (options.downloadUrl) {
            options.downloadUrl =Util.getRightUrl(options.downloadUrl.indexOf('attachGuid') !== -1
                    ? // 已经有attachGuid了 就不处理
                      options.downloadUrl
                    : // 没有attachGuid 根据是否有？ 拼接上 '&' 或 '?' + 'attachGuid=' + options.fileGuid
                      options.downloadUrl +
                      (options.downloadUrl.indexOf('?') !== -1 ? '&' : '?') +
                      'attachGuid=' +
                      options.fileGuid);
        } else {
            options.downloadUrl = 'javascript:void(0);';
            canDownload = false;
        }

        var list = [];
        list.push(
            '<div id="' + options.id + '" class="mini-uploader-item' + (options.success ? ' success' : '') + '">'
        );
        list.push(
            '<a href="' +
                options.downloadUrl +
                (canDownload ? '" target="_blank" class="mini-uploader-info">' : '" class="mini-uploader-info">') +
                options.name +
                '</a>'
        );
        if (options.size) {
            list.push(
                '<span class="mini-uploader-size">(' +
                    this._getSize(options.size) +
                    (options.date ? '/' + options.date : '') +
                    ')</span>'
            );
        }

        list.push('<span class="mini-uploader-error"></span>');

        if (this.showSecrecyLevel) {
            // 添加附件密级设置
            var secrecyLevel = options.secrecyLevel === undefined ? this.defaultSecrecyLevel : options.secrecyLevel,
                secrecyLevelText = (function (secrecyLevelItems) {
                    for (var i = 0, l = secrecyLevelItems.length; i < l; i++) {
                        if (secrecyLevelItems[i].id === secrecyLevel) {
                            return secrecyLevelItems[i].text;
                        }
                    }
                    return '';
                })(this.secrecyLevelItems);

            if (!secrecyLevelText) {
                secrecyLevel = this.getHighestSecrecyLevel().id;
                secrecyLevelText = this.getHighestSecrecyLevel().text;
            }
            list.push(
                '<span class="mini-uploader-secrecy" canEdit="' +
                    !options.hideDelete +
                    '" guid="' +
                    secrecyLevel +
                    '">' +
                    secrecyLevelText +
                    '</span>'
            );
        }

        list.push('<span class="mini-uploader-progressbar" style="display: none;"></span>');
        if (this.enabled && !options.hideDelete) {
            list.push(
                '<a href="javascript:void(0)" class="mini-uploader-remove" fileId="' +
                    options.id +
                    '" fileGuid="' +
                    options.fileGuid +
                    '">' +
                    epoint_local.delete_text +
                    '</a>'
            );
        }
        list.push('</div>');

        return list.join('');
    },
    clearFile: function (clearServer) {
        // 遍历删除
        if (this._uploader) {
            var $fileItems = jQuery(this._fileList).find('.mini-uploader-item');

            if (!$fileItems.length) {
                return;
            }
            // 从文件列表中遍历进行处理
            for (var i = $fileItems.length - 1; i >= 0; --i) {
                var $file = $fileItems.eq(i).find('.mini-uploader-remove'),
                    id = $file.attr('fileId'),
                    guid = $file.attr('fileguid');
                this.removeFile(
                    {
                        id: id,
                        guid: guid
                    },
                    clearServer
                );
            }
        }
        // 清空dom
        jQuery(this._fileList).empty();
    },
    bindEvents: function () {
        var that = this,
            $fileList = jQuery(this._fileList);
        $fileList
            .on('click', '.mini-uploader-remove', function () {
                // 禁用状态下不允许删除
                if ($fileList.hasClass('mini-disabled')) {
                    return;
                }
                var $this = jQuery(this),
                    fileId = $this.attr('fileId'),
                    fileGuid = $this.attr('fileGuid');

                // 新增removefile事件
                // 以方便外部在点击删除按钮时做个性化处理，比如做提示，阻止删除等
                if (that._events.fileremove) {
                    var event = {
                        source: that,
                        sender: that,
                        type: 'fileremove',
                        file: {
                            id: fileId,
                            guid: fileGuid
                        }
                    };

                    that.fire('fileremove', event);
                } else {
                    that.removeFile(
                        {
                            id: fileId,
                            guid: fileGuid
                        },
                        true
                    );
                }
            })
            .on('click', '.mini-uploader-retry', function () {
                var fileId = jQuery(this).attr('fileId');

                // 重新上传
                that.retry(fileId);
            });
    },
    onUploadStart: function (file) {
        var li = mini.byId(file.id),
            $progressbar = jQuery('.mini-uploader-progressbar', li),
            progressbar = new mini.ProgressBar();

        progressbar.set({
            id: file.id + '_pb',
            width: '100%',
            value: 0
        });
        progressbar.render($progressbar[0]);

        $progressbar.show();
    },
    onUploadAccept: function (object, ret) {
        var fileGuid = ret.attachGuid,
            downloadUrl = ret.downloadUrl;

        if (fileGuid) {
            jQuery('#' + object.file.id + ' > .mini-uploader-remove').attr('fileGuid', fileGuid);
            if (downloadUrl) {
                jQuery('#' + object.file.id + ' > .mini-uploader-info')
                    .attr('href', Util.getRightUrl(downloadUrl))
                    .attr('target', '_blank');
            }
        }
    },
    onUploadProgress: function (file, percentage) {
        var li = mini.byId(file.id),
            $progressbar = jQuery('.mini-uploader-progressbar', li),
            progressbar = mini.get(file.id + '_pb');

        if (!progressbar) {
            progressbar = new mini.ProgressBar();
            progressbar.set({
                id: file.id + '_pb',
                width: '100%',
                value: 0
            });
            progressbar.render($progressbar[0]);
        }
        progressbar.setValue((percentage * 100).toFixed(2));
    },
    // eslint-disable-next-line
    onUploadSuccess: function (file, ret) {
        var $item = jQuery('#' + file.id);
        $item.addClass('success');
        $item.find('.mini-uploader-error').html('').hide();
    },
    // eslint-disable-next-line
    onUploadError: function (file, reason) {
        jQuery('#' + file.id)
            .find('.mini-uploader-error')
            .html(
                epoint_local.WebUploaderUI.uploadErrorText +
                    '<a href="#" class="mini-uploader-retry" fileId="' +
                    file.id +
                    '">' +
                    epoint_local.retry_text +
                    '</a>'
            )
            .show();
    },
    onUploadComplete: function (file) {
        jQuery('#' + file.id)
            .find('.mini-uploader-progressbar')
            .fadeOut();
    },
    onMd5FileFinished: function (data, file) {
        var fileGuid = data.attachGuid,
            downloadUrl = data.downloadUrl;

        if (fileGuid) {
            jQuery('#' + file.id + ' > .mini-uploader-remove').attr('fileGuid', fileGuid);
            if (downloadUrl) {
                jQuery('#' + file.id + ' > .mini-uploader-info').attr('href', Util.getRightUrl(downloadUrl));
            }
        }
    }
};

// oaUploader UI 的实现
var oaUI = {
    generateFileList: function (options) {
        var canDownload = true;
        var list = [],
            ext = (options.ext || '').toLowerCase(),
            link;
        if (options.downloadUrl) {
            options.downloadUrl = Util.getRightUrl(options.downloadUrl.indexOf('attachGuid') !== -1
                    ? // 已经有attachGuid了 就不处理
                      options.downloadUrl
                    : // 没有attachGuid 根据是否有？ 拼接上 '&' 或 '?' + 'attachGuid=' + options.fileGuid
                      options.downloadUrl +
                      (options.downloadUrl.indexOf('?') !== -1 ? '&' : '?') +
                      'attachGuid=' +
                      options.fileGuid);
        } else {
            options.downloadUrl = 'javascript:void(0);';
            canDownload = false;
        }
        var style = this.fileItemWidth ? 'style="width:' + this.fileItemWidth + '"' : '',
            className = 'mini-uploader-item mini-uploader-ui-oa' + (this.fileItemWidth ? ' inline' : '');
        list.push(
            '<div id="' +
                options.id +
                '" fileId="' +
                options.id +
                '" fileGuid="' +
                options.fileGuid +
                '" class="' +
                className +
                (options.success ? ' success' : '') +
                '"' +
                style +
                '>'
        );

        list.push('<b class="file-type ' + oaUI._typeToTypecls(ext) + '"></b>');
        list.push('<div class="file-info">');
        list.push(
            '<a title="' +
                options.name +
                '" href="' +
                options.downloadUrl +
                (canDownload ? '" target="_blank" class="mini-uploader-info">' : '" class="mini-uploader-info">') +
                options.name +
                '</a>'
        );
        if (options.size) {
            list.push('<span class="mini-uploader-size">' + this._getSize(options.size) + '</span>');
        }

        list.push('<span class="mini-uploader-date">' + (options.uploadDate ? options.uploadDate : '') + '</span>');

        list.push('<span class="mini-uploader-error"></span>');
        list.push('<span class="mini-uploader-progressbar" style="display: none;"></span>');

        list.push('<div class="file-func clearfix">');

        // 处理预览 有地址、可预览并且后端返回了参宿才能预览 后端始终会返回 预览参数值 preparams
        link = this.previewUrl && this.previewExt.indexOf(ext) !== -1 && options.preparams ? '' : ' hidden';
        list.push(
            '<span class="preview-file action-icon icon-view-svg ' +
                link +
                '" data-preparams="' +
                (options.preparams ? options.preparams : '') +
                '" title="' +
                epoint_local.preview_text +
                '"  data-tooltip="' +
                epoint_local.preview_text +
                '">' +
                epoint_local.preview_text +
                '</span>'
        );

        // 处理是否显示编辑按钮 非文件列表 有编辑地址且后缀在列表中
        link = this.editUrl && this.editExt.indexOf(ext) !== -1 ? '' : ' hidden';

        list.push(
            '<span class="edit-file action-icon icon-modify-svg ' +
                link +
                '" title="' +
                epoint_local.edit_text +
                '" data-tooltip="' +
                epoint_local.edit_text +
                '">' +
                epoint_local.edit_text +
                '</span>'
        );

        if (!options.hideDelete) {
            list.push(
                '<span class="delete-file action-icon icon-trash-svg" fileId="' +
                    options.id +
                    '" fileGuid="' +
                    options.fileGuid +
                    '" title="' +
                    epoint_local.delete_text +
                    '" data-tooltip="' +
                    epoint_local.delete_text +
                    '">' +
                    epoint_local.delete_text +
                    '</span>'
            );
        }

        if (this._fileMoreActionsMenu) {
            list.push('<span class="more-action action-icon icon-omit"></span>');
        }

        list.push('</div>');
        list.push('</div>');

        list.push('</div>');

        return list.join('');
    },
    clearFile: function (clearServer) {
        // 遍历删除
        if (this._uploader) {
            var $fileItems = jQuery(this._fileList).find('.mini-uploader-item');

            if (!$fileItems.length) {
                return;
            }
            // 从文件列表中遍历进行处理
            for (var i = $fileItems.length - 1; i >= 0; --i) {
                var $file = $fileItems.eq(i),
                    id = $file.attr('fileId'),
                    guid = $file.attr('fileguid');
                this.removeFile(
                    {
                        id: id,
                        guid: guid
                    },
                    clearServer
                );
            }
        }
        // 清空dom
        jQuery(this._fileList).empty();
    },
    bindEvents: function () {
        var that = this,
            $fileList = jQuery(this._fileList);
        $fileList
            .on('click', '.delete-file', function () {
                // 禁用状态下不允许删除
                if ($fileList.hasClass('mini-disabled')) {
                    return;
                }
                var $this = jQuery(this),
                    $item = $this.closest('.mini-uploader-item'),
                    fileId = $item.attr('fileId'),
                    fileGuid = $item.attr('fileGuid');

                // 新增removefile事件
                // 以方便外部在点击删除按钮时做个性化处理，比如做提示，阻止删除等
                if (that._events.fileremove) {
                    var event = {
                        source: that,
                        sender: that,
                        type: 'fileremove',
                        file: {
                            id: fileId,
                            guid: fileGuid
                        }
                    };

                    that.fire('fileremove', event);
                } else {
                    that.removeFile(
                        {
                            id: fileId,
                            guid: fileGuid
                        },
                        true
                    );
                }
            })
            // 文件预览
            .on('click', '.preview-file', function (e) {
                e.stopPropagation();

                if (!that.previewUrl) {
                    return;
                }

                var $this = $(this),
                    param = $this.data('preparams');

                if (!param) {
                    mini.alert(epoint_local.WebUploaderUI.cantPreviewAlert);

                    return;
                }

                var $file = $this.closest('.mini-uploader-item'),
                    fileName = $file.find('.mini-uploader-info').text(),
                    fileGuid = $file.attr('fileGuid'),
                    url = that.previewUrl;

                // 新加入一个参数 格式为 fname=文件guid + 文件扩展名
                if (fileGuid) {
                    var lidx = fileName.lastIndexOf('.');
                    // 文件不带扩展名则不拼接
                    url += '?fname=' + fileGuid + (lidx === -1 ? '' : fileName.substr(lidx));
                }

                url += (fileGuid ? '&' : '?') + param;

                // 新增 beforepreview 事件
                var event = {
                    source: that,
                    sender: that,
                    type: 'beforepreview',
                    cancel: false,
                    file: {
                        name: fileName,
                        guid: fileGuid,
                        previewUrl: url
                    }
                };

                that.fire('beforepreview', event);

                if (event.cancel) {
                    return;
                }
                epoint.openTopDialog(epoint_local.WebUploaderUI.filePreviewTitle, url);
            })
            // 文件编辑
            .on('click', '.edit-file', function (e) {
                e.stopPropagation();

                if (!that.editUrl) {
                    return;
                }

                var $this = $(this),
                    $file = $this.closest('.mini-uploader-item'),
                    id = $file.attr('fileGuid'),
                    fileName = $file.find('.mini-uploader-info').text();

                if (!id) {
                    mini.alert(epoint_local.WebUploaderUI.cantEditAlert);

                    return;
                }
                // var editurl = self.getEditurl() + id;
                var editurl = Util.getRootPath() + that.editUrl;

                if (that.editUrl.indexOf('attachGuid=') !== -1) {
                    editurl += id;
                } else {
                    editurl += (that.editUrl.indexOf('?') !== -1 ? '&' : '?') + 'attachGuid=' + id;
                }
                // 新增 beforeedit 事件
                var event = {
                    source: that,
                    sender: that,
                    type: 'beforeedit',
                    cancel: false,
                    file: {
                        name: fileName,
                        guid: id,
                        editUrl: editurl
                    }
                };

                that.fire('beforeedit', event);

                if (event.cancel) {
                    return;
                }
                epoint.openTopDialog(epoint_local.WebUploaderUI.fileEditTitle, editurl);
            })
            .on('click', '.more-action', function () {
                var $this = $(this),
                    pos = $this.offset(),
                    $file = $this.closest('.mini-uploader-item');

                that._fileMoreActionsMenu.$targetFile = $file;
                that._fileMoreActionsMenu.showAtPos(pos.left, pos.top + $this.height() - 10);
            })
            .on('click', '.mini-uploader-retry', function () {
                var fileId = jQuery(this).attr('fileId');

                // 重新上传
                that.retry(fileId);
            });
    },
    bindEnableSort: function () {
        var that = this,
            $fileList = jQuery(this._fileList);
        if (this.enableSort) {
            $fileList.sortable({
                revert: false,
                handle: '.file-type',
                update: function () {
                    var newSort = $fileList.sortable('toArray', {
                        attribute: 'fileGuid'
                    });
                    var data = {
                        commonDto: mini.encode(that.getCommonData())
                    };
                    data[that.id + '_action'] = 'saveSort';
                    data.sort = newSort.join(',');
                    // 发请求保存排序
                    Util.ajax({
                        url: that.uploadUrl,
                        dataType: 'json',
                        data: data,
                        type: 'post',
                        success: function (ret) {
                            that.fire('filesortsuccess', {
                                source: that,
                                sender: that,
                                type: 'filesortsuccess',
                                data: ret
                            });
                        }
                    });
                }
            });
        }
    },
    onUploadStart: function (file) {
        var li = mini.byId(file.id),
            $progressbar = jQuery('.mini-uploader-progressbar', li),
            progressbar = mini.get(file.id + '_pb'),
            $error = jQuery('.mini-uploader-error', li);

        mini.addClass(li, 'progressing');

        if (!progressbar) {
            progressbar = new mini.ProgressBar();
            progressbar.set({
                id: file.id + '_pb',
                width: '100%',
                value: 0
            });
            progressbar.render($progressbar[0]);
        } else {
            progressbar.setValue(0);
        }

        $error.html('').hide();
        $progressbar.show();
    },
    onUploadAccept: function (object, ret) {
        var fileGuid = ret.attachGuid,
            downloadUrl = ret.downloadUrl,
            preparams = ret.preparams || ret.downloadUrl,
            uploadDate = ret.uploadDate,
            // 扩展名
            ext = '',
            file = object.file,
            // 最后的.索引
            lastIndexPoint = file.name.lastIndexOf('.');

        if (lastIndexPoint !== -1) {
            ext = file.name.substr(lastIndexPoint + 1).toLowerCase();
        }

        if (fileGuid) {
            var $fileItem = jQuery('#' + object.file.id);
            $fileItem.attr('fileGuid', fileGuid);
            if (downloadUrl) {
                $fileItem
                    .find('.mini-uploader-info')
                    .attr('href', Util.getRightUrl(downloadUrl))
                    .attr('target', '_blank');
            }
            // 设置预览参数
            if (this.previewUrl && ext && this.previewExt.indexOf(ext) !== -1 && preparams) {
                $fileItem.find('.preview-file').data('preparams', preparams).removeClass('hidden');
            }
            if (uploadDate) {
                $fileItem.removeClass('progressing').find('.mini-uploader-progressbar').hide();
                $fileItem.find('.mini-uploader-date').text(uploadDate);
            }
        }
    },
    onUploadProgress: function (file, percentage) {
        var li = mini.byId(file.id),
            $progressbar = jQuery('.mini-uploader-progressbar', li),
            progressbar = mini.get(file.id + '_pb');

        if (!progressbar) {
            progressbar = new mini.ProgressBar();
            progressbar.set({
                id: file.id + '_pb',
                width: '100%',
                value: 0
            });
            progressbar.render($progressbar[0]);
        }
        progressbar.setValue((percentage * 100).toFixed(2));
    },
    // eslint-disable-next-line
    onUploadSuccess: function (file, ret) {
        var $item = jQuery('#' + file.id);
        $item.addClass('success').removeClass('error');
    },
    // eslint-disable-next-line
    onUploadError: function (file, reason) {
        jQuery('#' + file.id)
            .addClass('error')
            .find('.mini-uploader-error')
            .html(
                epoint_local.WebUploaderUI.uploadErrorText +
                    '<a href="#" class="mini-uploader-retry" fileId="' +
                    file.id +
                    '">' +
                    epoint_local.retry_text +
                    '</a>'
            )
            .show();
    },
    onUploadComplete: function (file) {
        jQuery('#' + file.id)
            .removeClass('progressing')
            .find('.mini-uploader-progressbar')
            .hide();
    },
    onMd5FileFinished: function (data, file) {
        var fileGuid = data.attachGuid,
            downloadUrl = data.downloadUrl,
            uploadDate = data.uploadDate;

        if (fileGuid) {
            jQuery('#' + file.id).attr('fileGuid', fileGuid);
            if (downloadUrl) {
                jQuery('#' + file.id + ' .mini-uploader-info').attr('href', Util.getRightUrl(downloadUrl));
            }
            if (uploadDate) {
                // $fileItem.find('.mini-uploader-date').text(uploadDate);
                jQuery('#' + file.id)
                    .find('.mini-uploader-date')
                    .text(uploadDate);
            }
        }
    },

    _typeToTypecls: function (type) {
        var typeCls = type.charAt(0) === '.' ? type.substring(1) : type.toLowerCase();
        // 有些类型是数字开头的，比如压缩文件 .7z，而 css 类是不允许数字开头的，需要在前面加一个字母
        return /^\d/.test(typeCls) ? 'e' + typeCls : typeCls;
    }
};

// 链接上传控件UI实现
var linkUI = $.extend({}, oaUI, {
    init: function () {
        var that = this,
            id = this.id,
            html,
            isAbleToPaste = that.enablePatse && Util.browsers.isIE == false;
        html =
            '<div class="mini-linkuploader-item mini-linkuploader-additem" id="mini-addfileitem-' +
            id +
            '"  ' +
            (isAbleToPaste ? 'contenteditable="true"' : '') +
            '>' +
            '  <div class="mini-linkuploader-content">' +
            '   <span class="action-icon icon-upload"></span>' +
            '   <div class="mini-linkuploader-tip">' +
            '  将文件' +
            '<span class="show-paste ' +
            (isAbleToPaste ? '' : 'hidden') +
            '">粘贴或</span>拖到此处</div>' +
            '</div>' +
            '<div class="mini-linkuploader-btns">' +
            '    <span class="mini-linkuploader-selectfilebutton item-btn"' +
            '    ><label class="mini-btn-pick">选择文件</label></span' +
            '  >' +
            ' <span class="item-unit">或</span> ' +
            '  <span class="mini-linkuploader-addlinkbtn item-btn">插入链接</span>' +
            ' </div>' +
            '</div>';
        this._$linkfileList = jQuery(this._fileList);
        if (this._$linkfileList.find('.mini-linkuploader-additem').length < 1) {
            this._$linkfileList.before(html);
            //判断是否有标题
            setTimeout(function(){
                if(that.tipText.length === 0){
                    $('#mini-addfileitem-'+id).css({top:0})
                }
            },50)
        }
        that.dnd = '#mini-addfileitem-' + id; //设置拖拽区域
        that._$linkUploadAddBtnWrap = this._$linkfileList.parent().find('#mini-addfileitem-' + id);
        that._$fileLinkBtn = that._$linkUploadAddBtnWrap.find('.mini-linkuploader-addlinkbtn')[0];
        that._$fileSelectBtn = that._$linkUploadAddBtnWrap.find('.mini-linkuploader-selectfilebutton')[0];
        var itemWidth = that.linkFileItemWidth,
            itemHeight = that.linkFileItemHeight;
        that._$linkUploadAddBtnWrap.css({
            width: itemWidth >= 148 ? itemWidth : 148,
            height: itemHeight >= 148 ? itemHeight : 148
        });
        //添加链接按钮点击事件
        mini.on(
            that._$fileLinkBtn,
            'click',
            function () {
                if (!that._linkDialog) {
                    that.uiFun.createDialog.call(that, id);
                }
                if (that._linkDialog) {
                    epoint.clear(that._linkDialog.id);
                    that._linkDialog.show();
                }
            },
            this
        );
        // 添加选择文件按钮点击事件
        mini.on(
            that._$fileSelectBtn,
            'click',
            function () {
                if (that._uploaderPick) {
                    that._uploaderPick.click();
                } else {
                    $(that.el).find('input[type="file"]').trigger('click');
                }
            },
            this
        );
        // 粘贴上传相关事件定义
        this._$linkUploadAddBtnWrap[0].addEventListener('paste', function (e) {
            var data = e.clipboardData,
                files = data.files;
            if (!that.enabled || that.readOnly) {
                e.preventDefault();
                return false;
            }
            if (files && files.length > 0) {
                that._uploader.addFiles(files);
            } else {
                mini.showTips({
                    content: '当前剪贴板无可粘贴的文件内容！',
                    state: 'warning',
                    x: 'center',
                    y: 'center'
                });
            }
            e.preventDefault();
            return false;
        });
        mini.on(
            this._$linkUploadAddBtnWrap,
            'input',
            function (e) {
                e.preventDefault();
                return false;
            },
            this
        );
        mini.on(
            this._$linkUploadAddBtnWrap,
            'keydown',
            function (e) {
                if (!(e.ctrlKey === true && e.keyCode === 86)) {
                    e.preventDefault();
                    return false;
                }
            },
            this
        );
        //
        var linkMap = {};
        this.on('beforeFileQueued', function (e) {
            var curData = e.file,
                file = curData.source.source,
                ext = curData.ext;
            if (that.__uploadLink) {
                curData.uploadType = 'link';
                curData.link = file.url;
                linkMap[curData.id] = curData;
            } else if (
                ext === 'png' ||
                ext === 'jpg' ||
                ext === 'jpeg' ||
                ext === 'gif' ||
                ext === 'bmp' ||
                ext === 'webp'
            ) {
                curData.uploadType = 'img';
            } else {
                curData.uploadType = 'file';
            }
        });
        this.on('uploadbeforesend', function (e) {
            // 是插入链接 则在请求中加入额外的参数
            if (linkMap[e.data.id]) {
                e.data.uploadType = 'link';
                e.uploadType = 'link';
            }
        });
    },
    uploadLink: function () {
        if (!this._linkForm.validate()) {
            return;
        }
        var data = this._linkForm.getData(),
            // 构造一个名字固定 内容是链接信息的文件去上传
            file = '';
        if (Util.browsers.isIE) {
            file = new Blob([data.link], { type: 'text/plain;charset=utf-8' });
            file.name = data.title + '.txt';
            file.lastModified = new Date().getTime();
            file.lastModifiedDate = new Date();
        } else {
            file = new File([data.link], data.title + '.txt', {
                type: 'text/plain'
            });
        }
        file.url = data.link;
        this.__uploadLink = true;
        this._uploader.addFiles(file);
        delete this.__uploadLink;
    },
    createDialog: function (id) {
        var that = this;
        // todo: js 创建重构
        var fileNameVtype = that.fileNameLengthLimit ? 'vtype="maxLength="' + that.fileNameLengthLimit + '"' : '',
            dialogId = id + '-link-dialog',
            text = '';
        text =
            '<div class="mini-window  mini-addlink-dialog" width="400" title="插入链接" id="' +
            dialogId +
            '">' +
            '<div class="fui-form  ">' +
            '<div  role="form"   id="' +
            id +
            '-link-form">' +
            '<div role="row"  >' +
            ' <div role="control" label="地址" starred="true"  >' +
            '   <input name="link" type="text" class="mini-textbox"  vtype="url" required="true">' +
            ' </div> ' +
            ' </div>' +
            '<div role="row"  >' +
            ' <div role="control" label="标题" starred="true"  >' +
            '<input name="title"  required="true"  ' +
            fileNameVtype +
            '  type="text" class="mini-textbox" >' +
            ' </div>  ' +
            ' </div> ' +
            ' </div> ' +
            '</div>' +
            ' <div  class="link-dialog-btns clearfix" >' +
            ' <div class="dialog-btns-wrap r">' +
            ' <span class="mini-button mr10" state="primary" id="' +
            id +
            '-dialog-ok">确定</span>' +
            '<span class="mini-button" id="' +
            id +
            '-dialog-cancel">取消</span> ' +
            ' </div>' +
            '  </div>' +
            ' </div>';
        $(text).appendTo('body');
        if (Util.form && Util.form.parse) {
            Util.form.parse($('#' + dialogId));
        } else {
            parseFormEvent($('#' + dialogId));
        }

        mini.parse(dialogId);
        var dialog = mini.get(dialogId);
        this._linkDialog = dialog;
        this._linkForm = new mini.Form(id + '-link-form');
        mini.get(id + '-dialog-ok').on('click', function () {
            that._linkForm.validate();
            if (that._linkForm.isValid()) {
                dialog.hide();
                that.uiFun.uploadLink.call(that);
            }
        });
        mini.get(id + '-dialog-cancel').on('click', function () {
            dialog.hide();
        });
    },
    deleteAlert: '确定删除此文件？',
    deleteAlertTitle: '删除提醒',
    generateFileList: function (options) {
        var uploadType = options.uploadType,
            name = options.name,
            itemWidth = this.linkFileItemWidth,
            itemHeight = this.linkFileItemHeight,
            html = '',
            str = '',
            url = options.imgUrl || options.downloadUrl,
            title = name;
        switch (uploadType) {
            case 'link':
                str = '<span class="action-icon icon-link" ></span>';
                name = name.replace('.txt', '');
                title = '<a href="' + url + '" target="_blank">' + name + '</a>';
                break;
            case 'img':
                str = '<img class="mini-linkuploader-img" src="' + url + '"></img>';
                break;
            default:
                str = ' <span class="file-type ' + this.uiFun._typeToTypecls(options.ext) + '"></span>';
                break;
        }
        html =
            '<div  class="mini-linkuploader-fileitem file-item"  data-filetype="' +
            uploadType +
            '"  id="' +
            options.id +
            '"  data-file-id="' +
            options.id +
            '"  data-file-guid="' +
            options.fileGuid +
            '" data-preview-url="' +
            url +
            '">' +
            '<div class="file-content-wrap" style="width:' +
            itemWidth +
            'px;height:' +
            itemHeight +
            'px;"> ' +
            str +
            '  <div class="file-btns-wrap">' +
            this._linkActionBtnHtml +
            '</div>  ' +
            ' </div>' +
            ' <div class="file-title"   style="width:' +
            itemWidth +
            'px" title="' +
            name +
            '">' +
            title +
            '</div>' +
            '</div>';
        return html;
    },
    onUploadAccept: function (object, ret) {
        var fileGuid = ret.attachGuid,
            downloadUrl = ret.downloadUrl,
            preparams = ret.preparams || ret.downloadUrl,
            // 扩展名
            ext = '',
            file = object.file,
            // 最后的.索引
            lastIndexPoint = file.name.lastIndexOf('.');

        if (lastIndexPoint !== -1) {
            ext = file.name.substr(lastIndexPoint + 1).toLowerCase();
        }

        if (fileGuid) {
            var $fileItem = jQuery('#' + object.file.id);
            $fileItem.attr({
                'data-file-guid': fileGuid
            });
            if (downloadUrl) {
                downloadUrl = this._dealUrlEvent(downloadUrl);
                $fileItem.attr('data-preview-url', downloadUrl);
                $fileItem.find('.mini-linkuploader-img').attr('src', downloadUrl);
                $fileItem.find('a').attr('href', downloadUrl);
            }
            // 设置预览参数
            if (this.previewUrl && ext && this.previewExt.indexOf(ext) !== -1 && preparams) {
                // $fileItem.find('.preview-file').data('preparams', preparams).removeClass('hidden');
            }
        }
    },
    onUploadError: function (file, reason) {
        jQuery('#' + file.id).remove();
    },
    bindEvents: function () {
        var that = this,
            $fileList = jQuery(this._fileList);
        $fileList.on('click', '.mini-uploader-retry', function () {
            var fileId = jQuery(this).attr('fileId');

            // 重新上传
            that.retry(fileId);
        });
    },
    clearFile: function (clearServer) {
        // 遍历删除
        if (this._uploader) {
            var $fileItems = jQuery(this._fileList).find('.mini-linkuploader-fileitem');

            if (!$fileItems.length) {
                return;
            }
            // 从文件列表中遍历进行处理
            for (var i = $fileItems.length - 1; i >= 0; --i) {
                var $file = $fileItems.eq(i),
                    id = $file.attr('data-file-id'),
                    guid = $file.attr('data-file-guid');
                this.removeFile(
                    {
                        id: id,
                        guid: guid
                    },
                    clearServer
                );
            }
        }
        // 清空dom
        jQuery(this._fileList).find('.mini-linkuploader-fileitem').remove();
    }
});

mini.WebUploaderUI = {
    default: defaultUI,
    oa: oaUI,
    link: linkUI
};

/* eslint strict : ["off", "global"] */
mini.externalSrc = _rootPath + '/frame/fui/js/widgets/';

mini.regHtmlAttr('action');
mini.regHtmlAttr('bind');
mini.regHtmlAttr('extraId');

// 处理控件的二次请求数据格式
(function(win) {
    win.mini_doload = function(e) {
        var data = mini.decode(e.text, false),
            custom,
            len,
            viewData,
            hidden_viewdata;

        if (data[Util.BODY_ENCRYPT_PARAM_NAME]) {
            data = Util.decrypt(data[Util.BODY_ENCRYPT_PARAM_NAME]);
            data = mini.decode(data);
        }

        custom = data.custom;
        data = data.controls || data;

        if (mini.isArray(data) && data[0] && data[0].id) {
            len = data.length;
            viewData = data[len - 1];

            if (viewData.id === '_common_hidden_viewdata') {
                hidden_viewdata = mini.get('_common_hidden_viewdata');
                if (!hidden_viewdata) {
                    hidden_viewdata = new mini.Hidden();

                    hidden_viewdata.setId('_common_hidden_viewdata');

                    hidden_viewdata.render(document.body);
                }
                hidden_viewdata.setValue(viewData.value);
            }
            if (data[0].total !== undefined) {
                data = data[0];
            } else {
                data = data[0].data;
            }
        }
        if ((!data || (mini.isArray(data) && data.length === 0)) && custom) {
            data = custom;
        }
        e.result = data;
    };

    mini.copyTo(mini, {
        getSecondRequestData: function(data) {
            if (data[Util.BODY_ENCRYPT_PARAM_NAME]) {
                data = Util.decrypt(data[Util.BODY_ENCRYPT_PARAM_NAME]);
                data = mini.decode(data);
            }
            // 返回数据不符合规范，可能是服务端出错了，直接返回空
            if (!data || !data.status) {
                return [];
            }

            var status = data.status,
                code = parseInt(status.code, 10),
                text = status.text,
                url = status.url,
                state = status.state || 'error',
                title = state === 'warning' ? epoint_local.warning_tip : epoint_local.error_tip,
                viewData,
                hidden_viewdata;

            if (code >= 300) {
                if (url) {
                    if (url.indexOf('http') !== 0) {
                        url = _rootPath + '/' + url;
                    }
                    var aimWindow = status.top ? top : window;
                    if (aimWindow.Util && aimWindow.Util.getSafeLocation) {
                        aimWindow.Util.getSafeLocation().setHref(url);
                    } else {
                        aimWindow.location.href = url;
                    }
                    return;
                }
                if (text) {
                    mini.showMessageBox({
                        title: title,
                        buttons: ['ok'],
                        message: text,
                        iconCls: 'mini-messagebox-' + state
                    });
                }
            } else {
                data = data.controls || data;

                if (mini.isArray(data) && data[0] && data[0].id) {
                    var len = data.length;
                    // 有的请求可能只有一个 _common_hidden_viewdata （比如上传控件的附件删除请求），也需要更新
                    // 所以把判断去掉 modify at 2019-06-27
                    // if (len > 1) {
                    viewData = data[len - 1];

                    if (viewData.id === '_common_hidden_viewdata') {
                        hidden_viewdata = mini.get('_common_hidden_viewdata');
                        if (!hidden_viewdata) {
                            hidden_viewdata = new mini.Hidden();

                            hidden_viewdata.setId('_common_hidden_viewdata');

                            hidden_viewdata.render(document.body);
                        }
                        hidden_viewdata.setValue(viewData.value);
                    }
                    // }
                    data = data[0];
                }
                return data;
            }
        }
    });
})(window, jQuery);

// 框架中重放攻击防御会对url参数做前后端签名对比，get请求会改变url参数值，不能使用
mini.ListControl.ajaxType = 'post';

mini.ajax = function(options) {
    if (!options.dataType) {
        options.dataType = 'text';
    }

    options.data = Util.encryptAjaxParams(options.url, options.data);
    return window.jQuery.ajax(options);
};

if (window.EpFrameSysParams && EpFrameSysParams.security_vtype_positivenum_enable === 1) {
    mini._minimumNumber = 0;
}

(function () {
    /**
     * 为了防止代码中未移除的console在IE8\9下可能报错的问题，对没有console的情况进行了处理
     */
    if (!window.console) {
        window.console = {
            log: function () {},
            dir: function () {},
            dirxml: function () {},
            info: function () {},
            warn: function () {
                // var str = '【警告】\n原警告参数依次为：\n';
                // for (var i = 0, l = arguments.length; i < l; ++i) {
                //     str += String(arguments[i]) + '\n';
                // }
                // window.alert(arguments.length ? str : '【警告】');
            },
            error: function () {
                // var str = '【错误】\n原错误参数依次为：\n';
                // for (var i = 0, l = arguments.length; i < l; ++i) {
                //     str += String(arguments[i]) +'\n';
                // }
                // window.alert(arguments.length ? str : '【错误】');
            }
        };
    }

    // 绑定事件
    function on(el, type, fn) {
        if (el.addEventListener) {
            el.addEventListener(type, fn, false);
        } else if (el.attachEvent) {
            el.attachEvent('on' + type, fn);
        }
    }
    // 对象合并
    function assign() {
        var target = arguments[0];
        var i = 1,
            len = arguments.length,
            key = '',
            obj = null,
            hasOwnProperty = Object.prototype.hasOwnProperty;

        for (; i < len; i++) {
            obj = arguments[i];
            for (key in obj) {
                if (hasOwnProperty.call(obj, key)) {
                    target[key] = obj[key];
                }
            }
        }

        return target;
    }
    // 类型判断
    var class2type = { '[object Boolean]': 'boolean', '[object Number]': 'number', '[object String]': 'string', '[object Function]': 'function', '[object Array]': 'array', '[object Date]': 'date', '[object RegExp]': 'regexp', '[object Object]': 'object', '[object Error]': 'error', '[object Symbol]': 'symbol' };
    function getType(obj) {
        // eslint-disable-next-line
        if (obj == null) {
            return obj + '';
        }

        var str = Object.prototype.toString.call(obj);
        return typeof obj === 'object' || typeof obj === 'function' ? 
            class2type[str] || 'object' : typeof obj;
    }

    // 一天的毫秒数目
    var DAY_MILLISECONDS = 1000 * 60 * 60 * 24;

    // 统一的cookie配置
    var DEFAULT_COOKIE_OPTIONS = {
        // 过期时间 单位天
        // expires: 30,
        path: window._rootPath ? (window._rootPath + '/') : '/',
        // domain: '',
        // secure: false
    };
    // 设置cookie的默认配置
    var setCookieDefaultOption = function (opt) {
        for (var k in opt) {
            if (Object.prototype.hasOwnProperty.call(opt, k)) {
                DEFAULT_COOKIE_OPTIONS[k] = opt[k];
            }
        }
    };

    /**
     * 写入cookie
     *
     * @param {string} key cookie 名称
     * @param {string} value cookie 值
     * @param {object | undefined} options 当前cookie的配置 { expires,path,domain,secure }
     * @returns {string} 写入的cookie
     */
    var writeCookie = function (key, value, options) {
        if (!options || getType(options) != 'object') {
            options = assign({}, DEFAULT_COOKIE_OPTIONS, options || {});
        }

        // 过期时间
        if (getType(options.expires) == 'number') {
            var d = options.expires;
            options.expires = new Date();
            options.expires.setMilliseconds(options.expires.getMilliseconds() + d * DAY_MILLISECONDS);
        }
        return (document.cookie = [encodeURIComponent(key), '=', value,
            options.expires ? '; expires=' + options.expires.toUTCString() : '',
            options.path ? '; path=' + options.path : '',
            options.domain ? '; domain=' + options.domain : '',
            options.secure ? '; secure' : ''
        ].join(''));
    };

    /**
     * 读取cookie
     *
     * @param {string} key cookie 名称
     * @returns 读取到的cookie值
     */
    var readCookie = function (key) {
        var result = key ? undefined : {},
            cookies = document.cookie ? document.cookie.split('; ') : [],
            i = 0,
            l = cookies.length;
        for (; i < l; i++) {
            var parts = cookies[i].split('='),
                name = decodeURIComponent(parts.shift()),
                v = parts.join('=');

            if (key === name) {
                result = v;
                break;
            }

            if (!key && v !== undefined) {
                result[name] = v;
            }
        }
        return result;
    };

    /**
     * 移除一个cookie
     *
     * @param {string} key cookie名称
     * @param {object} options cookie配置
     * @returns
     */
    var removeCookie = function (key, options) {
        options = options || {};
        options.expires = -1;
        writeCookie(key, '', options);
        return !readCookie(key);
    };

    /**
     * 安全Location对象的封装 IE9+ 可保障表现和location一样 IE8赋值需使用对应set方法
     */
    function SafeLocation() {
        var that = this;
        // this.protocol = location.protocol;
        // this.host = location.host;
        // this.hostname = location.hostname;
        // this.port = location.port;
        // this.pathname = location.pathname;
        // this.search = location.search;
        // this.username = location.username;
        // this.password = location.password;
        this.origin = location.origin;

        this._writeProps = ['protocol', 'host', 'hostname', 'port', 'pathname', 'search', 'username', 'password'];
        this._isSupportDescriptor = !!Object.defineProperties;

        // 需要额外处理的 这两个属性会随时变化 需要不同的时候来获取
        // hash href
        var hash;
        if (this._isSupportDescriptor) {
            Object.defineProperties(this, {
                protocol: {
                    get: function () {
                        return location.protocol;
                    },
                    set: function (v) {
                        location.protocol = v;
                    }
                },
                host: {
                    get: function () {
                        return location.host;
                    },
                    set: function (v) {
                        location.host = v;
                    }
                },
                hostname: {
                    get: function () {
                        return location.hostname;
                    },
                    set: function (v) {
                        location.hostname = v;
                    }
                },
                port: {
                    get: function () {
                        return location.port;
                    },
                    set: function (v) {
                        location.port = v;
                    }
                },
                pathname: {
                    get: function () {
                        return location.pathname;
                    },
                    set: function (v) {
                        location.pathname = v;
                    }
                },
                search: {
                    get: function () {
                        return location.search;
                    },
                    set: function (v) {
                        location.search = v;
                    }
                },
                username: {
                    get: function () {
                        return location.username;
                    },
                    set: function (v) {
                        location.username = v;
                    }
                },
                password: {
                    get: function () {
                        return location.password;
                    },
                    set: function (v) {
                        location.password = v;
                    }
                },
                href: {
                    get: function () {
                        return location.href;
                    },
                    set: function (v) {
                        // TODO 安全过滤
                        location.href = v;
                    }
                },
                hash: {
                    get: function () {
                        hash = location.hash;
                        return hash;
                    },
                    set: function (v) {
                        if ((v || '')[0] != '#') {
                            v = '#' + v;
                        }
                        // TODO 安全过滤
                        hash = location.hash = v;
                    }
                }
            });
        } else {
            // 监听变化事件进行更新
            on(window, 'hashchange', function () {
                that.href = location.href;
                that.hash = location.hash;
            });
        }

        var props = this._writeProps.concat(['href', 'hash']);
        for (var i = 0, len = props.length; i < len; i++) {
            // 属性
            var p = props[i];
            // 对应方法
            var fnName = p[0].toUpperCase() + p.substr(1);
            (function (p, fnName) {
                // 支持描述符 则直接赋值
                if (that._isSupportDescriptor) {
                    that['set' + fnName] = function (v) {
                        that[p] = v;
                    };
                } else {
                    that[p] = location[p];
                    // 否则需要方法处理
                    that['set' + fnName] = function (v) {
                        that[p] = location[p] = v;
                    };
                }

                that['get' + fnName] = function () {
                    return that[p];
                };
            })(p, fnName);
        }

        // IE8 下检测 直接赋值的更新
        if (!this._isSupportDescriptor) {
            setInterval(function () {
                for (var i = 0, l = props.length; i < l; i++) {
                    var p = props[i];
                    if (that[p] != location[p]) {
                        location[p] = that[p];
                    }
                }
            }, 50);
        }
    }

    SafeLocation.prototype.replace = function (url) {
        // TODO 安全过滤
        location.replace(url);
    };

    SafeLocation.prototype.reload = function () {
        location.reload();
    };
    SafeLocation.prototype.assign = function (url) {
        // TODO 安全过滤
        location.assign(url);
    };
    SafeLocation.prototype.toString = function () {
        return this.href;
    };

    /**
     * html 转义
     *
     * @param {string} html 要处理的字符串
     * @returns 经过html转义的字符串
     */
    function htmlEscape(html) {
        var div = document.createElement('div');
        div.appendChild(document.createTextNode(html));
        var s = div.innerHTML;
        div = null;
        return s;
    }
    /**
     * html 还原转义
     */
    function htmlUnescape(str) {
        // var div = document.createElement('div');
        // div.innerHTML = str;
        // var t = div.innerText;
        // div = null;
        // return t;
        // 上面方法会出现 未转义的HTML传入时丢掉标签的问题
        if (typeof str !== 'string') return str;
        if (str.length === 0) return '';
        var s = str;
        // 先替换 &amp; 会出现以下问题
        // value "&amp;lt;20210331&amp;gt" => "<20210331&gt"
        // 正确的应为 "&amp;lt;20210331&amp;gt" => "&lt;20210331&gt"
        s = s.replace(/&lt;/g, '<');
        s = s.replace(/&gt;/g, '>');
        s = s.replace(/&nbsp;/g, ' ');
        s = s.replace(/&#39;/g, '\'');
        s = s.replace(/&quot;/g, '"');
        s = s.replace(/&amp;/g, '&');
        return s;
    }

    /**
     * html XSS过滤
     * TODO: html XSS 注入的可能情况
     * 1、 script标签
     * 2、 style 样式中 url 发请求
     * 3、 资源型标签 src 触发
     * 4、 html行内事件，如onclick onmouseover等
     * @param {string} html 要处理的字符串
     * @returns 经过安全过滤html字符串
     */
    function getSafeHtml(html) {
        if (!html) return;
        // TODO
        // script 处理
        // html = html.replace(/<script(.*?)>/gi, '&lt;script$1&gt;').replace(/<\/script>/gi, '&lt;/script&gt;');
        html = html.replace(/<script(.*?)>/gi, '<noscript$1>').replace(/<\/script>/gi, '</noscript>');

        // createDocumentFragment 存在注入可能 $.parseHTML 存在相同问题
        // 测试代码：SafeUtil.getSafeHtml(`<div class="qm-item" id="qm-48ecf37e-b134-401c-b757-15dcd7bc0416" data-id="48ecf37e-b134-401c-b757-15dcd7bc0416" title="CBM" data-url="xxxxs://oa.epoint.com.cn/EpointCBM/login.aspx" data-hassub="" data-opentype="blank" style="width:20%"><div class="qm-item-inner" style="background:#5d73e0;"><span class="qm-item-icon modicon-77"></span><span class="qm-item-name ">CBM</span><img src="abc.png" onerror="alert(1)"/></div></div>`)
        // var doc = document.createDocumentFragment();
        // var wrap = document.createElement('div');
        // wrap.innerHTML = html;
        // doc.appendChild(wrap);

        // var parser = new DOMParser();
        // var wrap = parser.parseFromString(html, 'text/html');

        // var nodes = wrap.childNodes;
        // if (nodes.length) {
        //     filterNode(nodes);
        // }

        // function filterNode(nodeList) {
        //     for (var i = 0; i < nodeList.length; i++) {
        //         var node = nodeList[i];
        //         var type = node.nodeType;
        //         // 文本和注释
        //         if (type === 3 || type === 8) {
        //             continue;
        //         }
        //         if (node.getAttribute('src')) {
        //             console.warn('匹配到src', node);
        //             // todo
        //         }
        //         if (node.getAttribute('style')) {
        //             console.warn('匹配到style', node);
        //             // todo
        //         }
        //         if (node.childNodes && node.childNodes.length) {
        //             filterNode(node.childNodes);
        //         }
        //     }
        // }

        return html;
    }

    /**
     * 安全 eval
     * TODO: eval 本身就是风险非常大的，
     * 目前暂无内部过滤方案暂时统一使用，以便后期修改
     * @param {string} code
     * @returns eval 结果
     */
    function safeEval(code) {
        // TODO 暂时以关键字过滤处理 不过存在误伤可能性
        // function
        // => 箭头函数
        // delete
        if (/function/.test(code)) {
            console.warn('eval [function] 关键字');
        }
        // if (/=>/.test(code)) {
        //     console.warn('eval 潜在箭头函数');
        // }
        // if (/delete/.test(code)) {
        //     console.warn('eval [delete] 关键字');
        // }

        return eval(code);
    }

    var SafeUtil = {
        writeCookie: writeCookie,
        readCookie: readCookie,
        removeCookie: removeCookie,
        setCookieDefaultOption: setCookieDefaultOption,
        location: new SafeLocation(),
        htmlEscape: htmlEscape,
        htmlUnescape: htmlUnescape,
        getSafeHtml: getSafeHtml,
        safeEval: safeEval
    };
    SafeUtil.getSafeLocation = function () {
        return SafeUtil.location;
    };
    // window.SafeUtil = SafeUtil;
    if (!window.Util) {
        window.Util = {};
    }

    assign(Util, SafeUtil);
})();
/*!
 * Util工具类
 */
(function(win, $) {
    // 国际化多语言支持
    if (!win.epoint_local) {
        win.epoint_local = {};
    }

    var $win = $(win),
        $bd = $('body'),
        $doc = $(document);

    // minimum z-index for popups
    var CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');

    // 是否存在activeX控件：object标签
    // var hasObjectTag = !!document.getElementsByTagName('object').length;
    // 由于存在iframe嵌套的情况，在当前页判断并不可靠，始终置为true
    var hasObjectTag = true;

    // 实现一个自定义事件
    function UserEvent() {
        // 必须使用new命令
        if (!(this instanceof UserEvent)) return new UserEvent();
        this.__events = {};
    }
    UserEvent.installTo = function(obj) {
        if (typeof obj !== 'object') {
            throw new TypeError('obj must be an object');
        }
        if (obj.__events !== undefined) {
            throw new Error('此对象已经存在 __events 属性了。');
        }
        if (typeof Object.defineProperty === 'function') {
            Object.defineProperty(obj, '__events', {
                value: {},
                configurable: true,
                enumerable: false,
                writable: true
            });
            ['on', 'off', 'fire', 'one'].forEach(function(key) {
                Object.defineProperty(obj, key, {
                    value: UserEvent.prototype[key],
                    configurable: true,
                    enumerable: false,
                    writable: true
                });
            });
        } else {
            obj.__events = {};
            obj.on = UserEvent.prototype.on;
            obj.off = UserEvent.prototype.off;
            obj.fire = UserEvent.prototype.fire;
            obj.one = UserEvent.prototype.one;
        }
        return obj;
    };
    $.extend(UserEvent.prototype, {
        on: function(type, fn) {
            if (Util._getType(type) !== 'string') {
                console.error('The Event name must be a string');
                return this;
            }
            if (Util._getType(fn) !== 'function') {
                console.error('The Event handler must be a function');
                return this;
            }
            type = type.toLowerCase();
            if (!this.__events[type]) {
                this.__events[type] = [];
            }
            this.__events[type].push(fn);
            return this;
        },
        fire: function(type, data, context) {
            if (Util._getType(type) !== 'string') {
                console.error('The Event name must be a string');
                return this;
            }
            type = type.toLowerCase();
            var eventArr = this.__events[type];
            if (!eventArr || !eventArr.length) return;
            for (var i = 0, l = eventArr.length; i < l; ++i) {
                eventArr[i].call(context || this, {
                    type: type,
                    target: this,
                    data: data
                });
            }
            return this;
        },
        off: function(type, fn) {
            if (Util._getType(type) !== 'string') {
                console.error('The Event name must be a string');
                return this;
            }
            type = type.toLowerCase();
            var eventArr = this.__events[type];
            if (!eventArr || !eventArr.length) return;

            if (!fn) {
                this.__events[type] = eventArr = [];
            } else {
                for (var i = 0; i < eventArr.length; ++i) {
                    if (fn === eventArr[i]) {
                        eventArr.splice(i, 1);
                        --i;
                    }
                }
            }
            return this;
        },
        one: function(type, fn) {
            var that = this;

            function nfn() {
                // 执行时 先取消绑定
                that.off(type, nfn);
                // 再执行函数
                fn.apply(this || that, arguments);
            }

            this.on(type, nfn);

            return this;
        }
    });

    if (!win.Util) {
        win.Util = {};
    }

    var $pageLoading = $('body > .page-loading');

    $.extend(Util, {
        hidePageLoading: function() {
            if (!$pageLoading.length) return;

            $pageLoading.fadeOut(300, function() {
                $pageLoading.remove();
            });
        },
        // client size
        getWinSize: function() {
            return {
                width: $win.width(),
                height: $win.height()
            };
        },

        // body size
        getBdSize: function() {
            return {
                width: $bd.width(),
                height: $bd.height()
            };
        },

        // html size
        getDocSize: function() {
            return {
                width: $doc.width(),
                height: $doc.height()
            };
        },

        // scroll size
        getScrollSize: function() {
            return {
                left: document.body.scrollLeft || document.documentElement.scrollLeft,
                top: document.body.scrollTop || document.documentElement.scrollTop
            };
        },

        // 加密部分进行了重写优化
        // get query parameters of url
        // getUrlParams: function (prop) {
        //     var params = {},
        //         query = win.location.search.substring(1),
        //         arr = query.split('&'),
        //         rt;
        //     if (!query) {
        //         return prop ? undefined : {};
        //     }

        //     $.each(arr, function (i, item) {
        //         var tmp = item.split('='),
        //             key = tmp[0],
        //             val = tmp[1];

        //         if (typeof params[key] == 'undefined') {
        //             params[key] = val;
        //         } else if (typeof params[key] == 'string') {
        //             params[key] = [params[key], val];
        //         } else {
        //             params[key].push(val);
        //         }
        //     });

        //     rt = prop ? params[prop] : params;

        //     return rt;
        // },

        getZIndex: function() {
            // var curr = zIndex;
            // zIndex = curr + 2;
            // return curr;
            return mini.getMaxZIndex();
        },

        // generate random widget id
        uuid: function(len, radix) {
            var chars = CHARS,
                uuid = [],
                i;
            radix = radix || chars.length;

            if (len) {
                for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
            } else {
                var r;

                uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
                uuid[14] = '4';

                for (i = 0; i < 36; i++) {
                    if (!uuid[i]) {
                        r = 0 | (Math.random() * 16);
                        uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
                    }
                }
            }

            return uuid.join('');
        },

        // modal dialog cover
        // 用于F8中的EpDialog、TipDialog打开的蒙版
        getModalCover: function(prefix) {
            var $cover = $('<div></div>', {
                id: prefix + '-cover'
            }).addClass('modal-dialog-cover hidden');

            // 此iframe用于覆盖activeX
            if (hasObjectTag) {
                var iframe = document.createElement('iframe');
                iframe.width = '100%';
                iframe.height = '100%';
                iframe.scrolling = 'no';
                iframe.frameBorder = 0;
                iframe.src = 'about:blank';

                $(iframe).appendTo($cover);
            }

            return $cover;
        },

        // 返回完整的WebContent根路径
        getRootPath: function() {
            var loc = window.Util.getSafeLocation(),
                host = loc.hostname,
                protocol = loc.protocol,
                port = loc.port ? ':' + loc.port : '',
                path = (_rootPath !== undefined ? _rootPath : '/' + loc.pathname.split('/')[1]) + '/';
            if (/^(http|https|ftp|data:)/g.test(path)) {
                return path;
            }

            var rootPath = protocol + '//' + host + port + path;

            return rootPath;
        },
        /**
         * 获取 Url 上的 hash
         *
         * @param {string} url url值
         * @returns hash
         */
        getHash: function(url) {
            var idx = (url || location.href).indexOf('#');
            return idx === -1 ? '' : url.substr(idx);
        },
        /**
         * 移除 url 上的hash
         *
         * @param {string} url url值
         * @returns 移除 hash 后的 url值
         */
        removeHash: function(url) {
            var idx = url.indexOf('#');
            return idx === -1 ? url : url.substring(0, idx);
        },
        // 返回适合的url
        // 1.url为全路径，则返回自身
        // 2.url为，则返回自身
        // 3.url为WebContent开始的路径，则补全为完整的路径
        getRightUrl: function(url, noEncrypt) {
            if (!url) return '';

            var curUrl = Util.removeHash(Util.getSafeLocation().href),
                queryIndex = curUrl.indexOf('?');

            // 截取url参数前的路径
            if (queryIndex !== -1) {
                curUrl = curUrl.substr(0, queryIndex);
            }

            // 是否是相对路径
            var isRelative = url.indexOf('./') !== -1 || url.indexOf('../') !== -1;

            // 全路径、相对路径直接返回
            if (/^(http|https|ftp|data:)/g.test(url)) {
                // url = url;
                // 相对路径
            } else if (isRelative) {
                url = curUrl.substr(0, curUrl.lastIndexOf('/') + 1) + url;

                // WebContent开始路径
            } else {
                // 去除最前面的 '/' ，避免拼出来后变成两个 '//'
                if (url.substring(0, 1) === '/') {
                    url = url.substring(1);
                }
                url = Util.getRootPath() + url;
            }

            // 如果不需要加密
            if (noEncrypt) {
                return url;
            }

            return Util.encryptUrlParams ? Util.encryptUrlParams(url) : url;
        },

        // browser detect
        browsers: {
            isIE67: '\v' === 'v',
            isIE8: !!document.all && document.querySelector && !document.addEventListener,
            isIE9: !!document.all && document.addEventListener && !window.atob,
            isIE10: !!document.all && window.atob,
            isIE11: '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style,
            // IE6~11
            isIE: (!!document.all && document.compatMode) || ('-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style),
            isWebkit: 'WebkitAppearance' in document.documentElement.style,
            isFirefox: !!navigator.userAgent.match(/firefox/i),
            isEdge: /Edge\/([\d.]+)/.test(navigator.userAgent)
        },

        toInt: function(val) {
            var r = parseInt(val, 10);
            return r ? r : 0;
        },

        openSelfWin: function(url) {
            // win.location = url;
            win.Util.getSafeLocation().setHref(url);
        },

        // 记录已经加载过的js，以避免多次加载
        _loadedJs: {},
        // 动态加载js
        loadJs: (function () {
            function loadOne(url, callback) {
                if (Util._loadedJs[url]) {
                    if (typeof callback === 'function') {
                        if (Util._loadedJs[url].loaded) {
                            callback();
                        } else {
                            Util._loadedJs[url].callbacks.push(callback);
                        }
                    }
                    return;
                }
    
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.onload = function() {
                    executeCallback();
                    script.onload = null;
                };
    
                function executeCallback() {
                    Util._loadedJs[url].loaded = true;
    
                    var callbacks = Util._loadedJs[url].callbacks;
                    if (callbacks) {
                        for (var i = 0, l = callbacks.length; i < l; i++) {
                            callbacks[i]();
                        }
                        Util._loadedJs[url].callbacks = [];
                    }
                }
    
                Util._loadedJs[url] = {
                    loaded: false,
                    callbacks: []
                };
                if (typeof callback === 'function') {
                    Util._loadedJs[url].callbacks.push(callback);
                }
    
                script.src = win.SrcBoot ? SrcBoot.handleResPath(url) : Util.getRightUrl(url);
                // append to head
                document.getElementsByTagName('head')[0].appendChild(script);
            }

            function loadOneByOne(urls, callback) {
                var url = urls.shift();
                // todo: 假设一个某个资源加载失败，闭包将一直无法释放，可能长期占用内存
                if (url) {
                    loadOne(url, function() {
                        loadOneByOne(urls, callback);
                    });
                } else {
                    if (typeof callback === 'function') {
                        callback();
                    }
                }
            }

            return function loadJs(urls, callback) {
                if (Array.isArray(urls)) {
                    return loadOneByOne(urls, callback);
                }
                return loadOne(urls, callback);
            }
        })(),

        // 页面预留的 懒加载的 style 标签
        _lazyLoadStyle: document.getElementById('lazy-load-style'),

        /**
         * 动态加载css
         *
         * @param {String} url css 路径 webapp目录开始写起的全路径或相对路径
         * @param {String/HTMLElement/jQueryObject} target 插入判断的位置元素
         * @param {String} pos 相对目标元素的前后位置 可选值 ['Before', 'After']
         * @param {Boolean} importToStyle 是否以@import的形式插入 占位的懒加载元素中 仅在IE下且 存在占位元素才有效
         * @returns
         */
        loadCss: function(url, target, pos, importToStyle) {
            if (importToStyle === undefined) importToStyle = true;
            if (Util.browsers.isIE && importToStyle && this._lazyLoadStyle) {
                var addExtraStyle = '@import "' + (win.SrcBoot ? SrcBoot.handleResPath(url) : Util.getRightUrl(url)) + '";';
                if ('styleSheet' in this._lazyLoadStyle) {
                    return (this._lazyLoadStyle.styleSheet.cssText += addExtraStyle);
                }
                return $(this._lazyLoadStyle).text($(this._lazyLoadStyle).text() + addExtraStyle);
            }
            var $link = $('<link/>', {
                href: win.SrcBoot ? SrcBoot.handleResPath(url) : Util.getRightUrl(url),
                rel: 'stylesheet',
                type: 'text/css'
            });

            if (!target || !$(target).length) {
                target = document.getElementsByTagName('head')[0];
                $link.appendTo(target);
            } else {
                if (!pos) pos = 'After';
                $link['insert' + pos](target);
            }
        },

        // 动态加载模板页面功能模块
        loadPageModule: function(path) {
            $.ajax({
                type: 'get',
                dataType: 'html',
                url: win.SrcBoot ? SrcBoot.handleResPath(path.templ) : this.getRightUrl(path.templ),
                data: {},
                beforeSend: function(XMLHttpRequest) {
                    path.css && Util.loadCss(path.css, document.getElementById('common-skin'), 'Before', true);
                    $.ajaxSettings.beforeSend(XMLHttpRequest);
                },
                success: function(html) {
                    $(html).appendTo('body');

                    path.js &&
                        Util.loadJs(path.js, function() {
                            if (path.callback) {
                                path.callback();
                            }
                        });
                }
            });
        },

        // 去除html标签中的换行符和空格
        clearHtml: function(html) {
            return html
                .replace(/(\r\n|\n|\r)/g, '')
                .replace(/[\t ]+</g, '<')
                .replace(/>[\t ]+</g, '><')
                .replace(/>[\t ]+$/g, '>');
        },

        _ajaxErr: function(jqXHR, textStatus, errorThrown) {
            console.error('status: %s, error: %s', textStatus, errorThrown);
            console.error('%c后台返回的数据：' + jqXHR.responseText, 'font-size: 16px;');

            // 由于安全模块拦截返回的的http code 是不确定的，所以把安全模块错误信息的处理移到了这边
            var data = jqXHR.responseJSON;
            if (data && data[Util.BODY_ENCRYPT_PARAM_NAME]) {
                data = Util.decrypt(data[Util.BODY_ENCRYPT_PARAM_NAME]);

                data = mini.decode(data);
            }
            if (data && data.status && data.status.text) {
                mini.showMessageBox({
                    title: epoint_local.error_tip,
                    buttons: ['ok'],
                    message: data.status.text,
                    iconCls: 'mini-messagebox-error'
                });
            } else if ([400, 401, 403, 404, 429, 500, 503].join(';').indexOf(jqXHR.status) === -1) {
                mini.showMessageBox({
                    title: epoint_local.error_tip,
                    buttons: ['ok'],
                    message: epoint_local.ajax_error_text,
                    iconCls: 'mini-messagebox-error'
                });
            }
        },
        //处理statusCode
        _handleStatusCode: function(xhr) {
            var showMessage = function(xhr, msg) {
                var data = xhr.responseJSON,
                    error = msg,
                    stack = null,
                    viewData;

                if(!data) {
                    try {
                        data = mini.decode(xhr.responseText);
                    } catch (e) {}
                }
                if (data && data[Util.BODY_ENCRYPT_PARAM_NAME]) {
                    data = Util.decrypt(data[Util.BODY_ENCRYPT_PARAM_NAME]);
    
                    data = mini.decode(data);
                }
                if(data && data.status && data.status.text) {
                    // _ajaxErr 中已弹出提示，不需要重复处理
                    return;
                }

                // 异常返回的数据可能会被第三方设备拦截修改掉，我们需要保证出现异常时一定会有提示
                if (typeof data === 'string') {
                    error = data;
                } else if (data) {
                    error = data.error;
                    stack = data.stackError;
                    viewData = data._common_hidden_viewdata;
                }
                if (!error) {
                    error = epoint_local.ajax_error_text;
                }

                viewData && Util.setCommonViewData(viewData);

                if (win.epoint && win.epoint.onAjaxStatusError && win.epoint.onAjaxStatusError(error, stack, xhr.status, xhr)) {
                    return;
                }

                // 先把loading效果去掉,不然弹出框会被loading层遮住
                // page loading 的层级已调低，不再需要隐藏
                // Util.hidePageLoading();

                if (!stack) {
                    mini.showMessageBox({
                        title: epoint_local.error_tip,
                        buttons: ['ok'],
                        message: error,
                        iconCls: 'mini-messagebox-error',
                        callback: function(action) {
                            if (win.epoint && win.epoint.ajaxStatusErrorAlertCallback) {
                                win.epoint.ajaxStatusErrorAlertCallback(action);
                            }
                        }
                    });
                } else {
                    mini.showMessageBox({
                        title: epoint_local.error_tip,
                        buttons: ['ok'],
                        iconCls: 'mini-messagebox-error',
                        message: error + '<a class="messagebox-error-detail" href="javascript:;">' + epoint_local.detail_text + '...</a>'
                    });

                    $('body')
                        .on('click', '.messagebox-error-detail', function() {
                            var _zIndex = Util.getZIndex();

                            var detailStr =
                                '<div id="message-dialog-detail" style="display:none;padding: 0 20px; position: fixed;width: 80%;left:10%;top: 5%;height: 90%;z-index:' +
                                _zIndex +
                                ';background-color:#fff;border:1px solid #ccc;"><div class="messagebox-close-btn" style="width: 20px;height:20px;position:absolute;right: -10px;top: -10px;border-radius:50%;background-color:rgba(0,0,0,.7);color:#fff;line-height: 18px;text-align:center;cursor:pointer;">&times;</div><div style="width:100%;height:100%;overflow-y:auto;">' +
                                stack +
                                '</div></div>';
                            $('#message-dialog-detail').remove();
                            $('body').append(detailStr);
                            $('#message-dialog-detail').show();
                        })
                        .on('click', '.messagebox-close-btn', function() {
                            $('#message-dialog-detail').remove();
                        });
                }
            };

            return {
                //安全框架拦截
                400: function(xhr) {
                    showMessage(xhr);
                },
                //未登录的权限拦截
                401: function(xhr) {
                    var data = xhr.responseJSON || mini.decode(xhr.responseText),
                        url = '';

                    // 如果返回数据中带了url，则表示不需要弹出快捷登录（可能登录逻辑是个性化的，快捷登录无效），直接跳转到返回的 url 页面
                    if (data && (url = data.url)) {
                        if (url.indexOf('http') !== 0) {
                            url = Util.getRootPath() + url;
                            // 加上'.html'后缀
                            url = Util.addHtmlToUrl(url);
                        }
                        if (top.Util && top.Util.getSafeLocation) {
                            top.Util.getSafeLocation().replace(url);
                        } else {
                            top.location.replace(url);
                        }
                        return;
                    }

                    var viewData = data ? data._common_hidden_viewdata : undefined;
                    viewData && Util.setCommonViewData(viewData);

                    //弹出小登录框
                    //win.location.href = _rootPath + '/index.html';
                    if (top.window.quickLogin !== undefined) {
                        top.quickLogin.show();
                    } else {
                        top.Util.loadPageModule({
                            templ: 'frame/fui/js/widgets/quicklogin/quicklogin.tpl',
                            css: 'frame/fui/js/widgets/quicklogin/quicklogin.min.css',
                            js: 'frame/fui/js/widgets/quicklogin/quicklogin.js',
                            callback: function() {
                                top.quickLogin.show();
                            }
                        });
                    }
                },
                //功能权限拦截
                403: function(xhr) {
                    showMessage(xhr);
                },
                //404拦截
                404: function(xhr) {
                    showMessage(xhr, epoint_local.ajax_error_text);
                },
                //报错类拦截
                500: function(xhr) {
                    showMessage(xhr);
                },
                // 用于被安全模块拦截后返回503的处理
                503: function(xhr) {
                    showMessage(xhr, epoint_local.service_error_text);
                },
                429: function(xhr) {
                    var data = xhr.responseJSON || mini.decode(xhr.responseText);

                    var viewData = data ? data._common_hidden_viewdata : undefined;
                    viewData && Util.setCommonViewData(viewData);

                    if (window.showInterceptTips !== undefined) {
                        showInterceptTips(data);
                    } else {
                        Util.loadCss('frame/fui/js/widgets/intercepttips/intercepttips.css');
                        Util.loadJs('frame/fui/js/widgets/intercepttips/intercepttips.js', function() {
                            showInterceptTips(data);
                        });
                    }
                }
            };
        },
        // 简单封装ajax
        ajax: function(options) {
            // add主界面要自动带上themeid
            var themeMatch = Util.getSafeLocation().href.match(/^https?:\/\/.*\/fui\/pages\/themes\/(\w+)\/\1/i),
                themeId = themeMatch && themeMatch[1],
                isDtoRequest = Util._getUrlParams(options.url, 'isCommondto') === 'true';

            var viewData = mini.get('_common_hidden_viewdata');

            options = $.extend(
                {},
                {
                    type: 'POST',
                    dataType: 'json',
                    error: Util._ajaxErr
                    // statusCode: Util._handleStatusCode()
                },
                options
            );

            options.url = Util.getRightUrl(options.url, options.noEncryption);
            options.data = options.data || {};

            // 如果是主界面 data中加上themeId
            if (themeId) {
                options.data = $.extend(
                    {
                        themeId: themeId,
                        pageId: Util.getUrlParams('pageId') || themeId
                    },
                    options.data
                );
            }
            // 自动带上通用隐藏域，实现重放攻击防御
            if (isDtoRequest && !options.data.commonDto && viewData) {
                options.data.commonDto = mini.encode([
                    {
                        id: '_common_hidden_viewdata',
                        type: 'hidden',
                        value: viewData.getValue()
                    }
                ]);
            }

            // options.data = Util.addReplayAttackData(options.data);
            options.data = Util.addReplayAttackData(options.data, options.url);

            // 自动携带当前页面的url参数过去
            options.data = $.extend(Util.getUrlParams(), options.data);

            // 如果需要加密 替换为加密格式
            if (!options.noEncryption) {
                options.data = Util.encryptAjaxParams(options.url, options.data);
            }
            // success 触发太早，防止对业务的影响 先去掉
            var okCb = options.success;
            if (okCb) {
                options.success = null;
                delete options.success;
            }
            var successHandle = function(data) {
                if (data[Util.BODY_ENCRYPT_PARAM_NAME]) {
                    data = Util.decrypt(data[Util.BODY_ENCRYPT_PARAM_NAME]);

                    data = mini.decode(data);
                }
                var status = data.status,
                    controls = data.controls;

                // 添加对通用隐藏域的处理
                // 解决快捷登录在主界面中需要获取通用隐藏域中存放的当前用户的loginid，实现快捷登录用其他账户登录时要刷新页面的需求
                if (controls && controls.length) {
                    viewData = controls[controls.length - 1];
                    if (viewData.id === '_common_hidden_viewdata') {
                        Util.setCommonViewData(viewData.value);
                    }
                }
                data = data.custom === undefined ? data : data.custom;
                if (data && typeof data !== 'object' && options.dataType.toLowerCase() === 'json') {
                    data = JSON.parse(data);
                }

                if (status) {
                    var code = parseInt(status.code, 10),
                        text = status.text || '',
                        url = status.url,
                        tipTxt = code === 1 || code === 200 ? epoint_local.success_text : epoint_local.failed_text,
                        tipType = code === 1 || code === 200 ? 'success' : 'danger';

                    if (url) {
                        if (url.indexOf('http') !== 0) {
                            url = Util.getRootPath() + url;
                            // 加上'.html'后缀
                            url = Util.addHtmlToUrl(url);
                        }
                        var aimWindow = status.top ? top : window;
                        if (aimWindow.Util && aimWindow.Util.getSafeLocation) {
                            aimWindow.Util.getSafeLocation().replace(url);
                        } else {
                            aimWindow.location.replace(url);
                        }
                        return;
                    }
                    if (text) {
                        mini.showTips({
                            content: '<b>' + tipTxt + '</b> <br/>' + text,
                            state: tipType,
                            x: 'center',
                            y: 'top',
                            timeout: 3000
                        });
                    }

                    // 处理成功回调
                    if (code === 1 || code === 200) {
                        if (okCb) {
                            okCb.apply(this, [data, arguments[1], arguments[2]]);
                            okCb = null;
                        }
                    } else {
                        if (options.fail) {
                            options.fail.call(this, text, status);
                        }
                    }
                } else {
                    // 没有status 表示不符合规范，也需要执行sussess
                    if (okCb) {
                        okCb.apply(this, [data, arguments[1], arguments[2]]);
                        okCb = null;
                    }
                }
                return data;
            };

            // jQuery 3 的 ajax 是promise的 标准实现 会变成异步的 如果是同步请求需要先调用
            if (options.async === false) {
                options.success = successHandle;
            }

            var _jqXhr = $.ajax(options);
            var _ajax = _jqXhr.then(successHandle);

            // then 返回的是新规范的promise 没有以下内容 兼容处理一下
            _ajax.success = _ajax.done;
            _ajax.error = _ajax.fail;
            _ajax.complete = _ajax.always;
            _ajax.abort = _jqXhr.abort;
            if (options.async === false) {
                var done = _ajax.done;
                _ajax.done = function() {
                    console.error('[Ajax Tips]:您正在使用同步请求，回调应通过配置项的 success 进行配置。\ndone then 回调中已经是异步，可能导致您的业务逻辑受到影响');
                    return done.apply(_ajax, arguments);
                };
            }
            return _ajax;
        },

        // 释放iframe所占内存，并从dom树中移除
        clearIframe: function($iframe) {
            var iframe = $iframe[0];

            iframe.src = 'about:blank';

            // 跨域时无法获取iframe的contentWindow
            try {
                iframe.contentWindow.document.write('');
                iframe.contentWindow.document.close();
            } catch (e) {}

            // 移除iframe
            try {
                iframe.parentNode.removeChild(iframe);
            } catch (e) {
                $iframe.remove();
            }
        },

        // empty function
        noop: function() {},

        // 调整content区域表格的布局
        _layoutDatagridInContent: function() {
            var grid = mini.get('datagrid');

            if (grid && grid.doLayout) {
                grid.doLayout();
            }
        },

        // 分时分批处理
        timeChunk: function(arr, fn, count, interval, callback) {
            var obj, t;

            var start = function() {
                var i = 0;
                for (; i < Math.min(count || 1, arr.length); i++) {
                    obj = arr.shift();
                    fn(obj);
                }
            };

            return function() {
                t = setInterval(function() {
                    if (!arr.length) {
                        clearInterval(t);

                        if (callback) {
                            callback();
                        }
                    }

                    start();
                }, interval || 100);
            };
        },

        // Force IE8 to redraw :before/:after pseudo elements
        redrawPseudoEl: function(el) {
            if (this.browsers.isIE8) {
                var $el = $(el);

                $el.addClass('content-empty');

                setTimeout(function() {
                    $el.removeClass('content-empty');
                }, 0);
            }
        },

        // get module properties from dom
        // for classicframe
        getModuleProps: function(el) {
            var data = {
                url: $.trim(el.getAttribute('modurl')),
                name: el.getAttribute('modname'),
                code: el.getAttribute('modcode'),
                isBlank: el.getAttribute('isblank') === 'true'
            };

            return data;
        },
        // 自定义事件
        UserEvent: UserEvent,
        // 框架更新了参数配置页面，重新对系统参数进行了规划，调整了参数名，考虑到对以前代码的兼容，需维护一个新老名字的映射关系
        _sysParamNameMapping: {
            fileSizeLimit: 'file_limit_size',
            fileLimitType: 'file_limit_type',
            uploadPreviewUrl: 'upload_preview_url',
            uploadPreviewText: 'upload_preview_text',
            enableCustomSort: 'ui_customsort_enable',
            noUseTabsNav: 'ui_use_tabsnav',
            gridPageSize: 'ui_grid_pagesize',
            fileNameLengthLimit: 'attach_filename_limitlength',
            gridAllowUnselect: 'grid_allow_unselect',
            adjustGridPageSize: 'grid_adjust_pagesize',
            editorModel: 'editor_model',
            alertToTips: 'alert_to_tips',
            messageSound: 'message_sound'
        },
        // 获取框架系统参数的值
        // 使用前提：页面jsboot.js的引用路径为后端返回系统参数的动态接口地址
        getFrameSysParam: function(name) {
            if (!win.EpFrameSysParams) {
                return;
            }

            if (win.EpFrameSysParams[name] === undefined) {
                name = Util._sysParamNameMapping[name];
                return name === 'ui_use_tabsnav' ? !win.EpFrameSysParams[name] : win.EpFrameSysParams[name];
            }

            return win.EpFrameSysParams[name];

            // return win.EpFrameSysParams ? EpFrameSysParams[name] : undefined;
        },

        getThemeName: function() {
            return Util.readCookie('_theme_');
        },

        getSkinName: function() {
            var themeName = this.getThemeName();

            return Util.readCookie('_' + themeName + '_skin_') || 'default';
        },
        // 查找第一个可滚动的父元素
        getFirstScrollEl: function(obj) {
            if (obj.scrollHeight > obj.clientHeight) {
                return obj;
            }

            if (obj.parentElement) {
                return this.getFirstScrollEl(obj.parentElement);
            }

            return null;
        },

        // Windows没有完整地支持IPv6，在UNC路径中，需使用破折号代替冒号，并在地址的末尾 加上.ipv6-literal.net后缀
        // 用于处理websocket地址
        getRightIPv6Url: function(url) {
            var location = Util.getSafeLocation(),
                hostname = location.hostname;
            // 判断是否是ipv6地址
            // 当前判断还不够精确，需优化
            if (Util.browsers.isIE && /:/.test(hostname)) {
                // 是否是相对路径
                var isRelative = url.indexOf('./') != -1 || url.indexOf('../') != -1;
                var curUrl =
                    location.protocol +
                    '//' +
                    hostname
                        .replace(/:/g, '-')
                        .replace(/%/g, 's')
                        .replace(/\[/g, '')
                        .replace(/\]/g, '') +
                    '.ipv6-literal.net' +
                    (location.port ? ':' + location.port : '');
                // 全路径、相对路径直接返回
                if (/^(http|https|ftp|data:)/g.test(url)) {
                    // url = url;
                    // 相对路径
                } else if (isRelative) {
                    url = curUrl + location.pathname.substr(0, location.pathname.lastIndexOf('/') + 1) + url;

                    // WebContent开始路径
                } else {
                    // 去除最前面的 '/' ，避免拼出来后变成两个 '//'
                    if (url.substring(0, 1) === '/') {
                        url = url.substring(1);
                    }
                    url = curUrl + (_rootPath !== undefined ? _rootPath : '/' + location.pathname.split('/')[1]) + '/' + url;
                }

                return url;
            }

            return Util.getRightUrl(url);
        },
        /**
         * 获取目标的类型
         * @param {any} obj 要获取类型的任意内容
         * @returns {String} 目标的类型 如 string 、boolean、number、array、function等
         */
        _getType: function(obj) {
            return $.type(obj);
        },
        setCommonViewData: function(value) {
            var viewData = mini.get('_common_hidden_viewdata');
            if (!viewData) {
                viewData = new mini.Hidden();
                viewData.setId('_common_hidden_viewdata');
                viewData.render(document.body);
            }
            viewData.setValue(value);
        },
        addReplayAttackData: function(data, url) {
            // var viewData = mini.get('_common_hidden_viewdata'),
            //     uid = Util.uuid(8),
            //     key = '';
            // if(viewData) {
            //     key = mini.decode(viewData.getValue()).replayAttack;
            //     if(key) {
            //         data = $.extend({},{
            //             uid: uid,
            //             sign: Util.encryptSM2(uid + ';' + key.substr(0, 32))
            //         }, data);
            //     }
            // }

            // return data;

            function getUrlParams(url) {
                url = Util.removeHash(url);
                var idx = url.indexOf('?');
                if (idx === -1) {
                    return '';
                }
                var query = url.substr(idx + 1);

                if (!query.length) {
                    return '';
                }
                // 有加密的情况只取加密的部分
                if (query.indexOf(Util.URL_ENCRYPT_PARAM_NAME) > -1) {
                    query = query.substr(query.indexOf(Util.URL_ENCRYPT_PARAM_NAME) + Util.URL_ENCRYPT_PARAM_NAME.length + 1);
                    if (query.indexOf('&') > -1) {
                        query = query.substr(0, query.indexOf('&'));
                    }
                }
                return query;
            }

            function encodeStr(str) {
                return encodeURIComponent(str)
                    .replace(/'/g, '%27')
                    .replace(/!/g, '%21')
                    .replace(/~/g, '%7E')
                    .replace(/\(/g, '%28')
                    .replace(/\)/g, '%29');
            }

            var uid = Util.uuid(),
                reqTime = Date.now(),
                urlParam = getUrlParams(url),
                dto = data.commonDto || '',
                cmdParams = data.cmdParams || '';

            if (dto.length > 10240) {
                dto = dto.length + '';
            }

            $.extend(data, {
                replaynoticeid: uid,
                reqtime: reqTime,
                paramsign: Util.encryptSM(uid + ';' + reqTime + ';' + encodeStr(urlParam)),
                dtosign: Util.encryptSM(uid + ';' + reqTime + ';' + encodeStr(dto) + ';' + encodeStr(cmdParams))
            });
            return data;
        },
        /**
         * 缓存页面数据
         * @param {String/Object} data 要保存的数据
         * @param {String} key 数据保存到的字段名称，不传默认为当前页面的路径
         */
        cachePageData: function(data, key) {
            key = key || window.location.pathname;
            if (typeof data === 'object') {
                data = JSON.stringify(data);
            }

            localStorage.setItem(key, data);
        },
        /**
         * 获取页面缓存数据
         * @param {String} key 要获取的数据字段名称，不传默认为当前页面的路径
         */
        getPageData: function(key) {
            key = key || window.location.pathname;
            var data = localStorage.getItem(key);

            try {
                data = JSON.parse(data);
            } catch (e) {}

            return data;
        },
        /**
         * 清除页面缓存数据
         * @param {String/Boolen} key 要清除的数据字段名称，不传默认为当前页面的路径。当传 true 时，表示清空当前域名下的所有缓存数据。
         */
        clearPageData: function(key) {
            if (key === true) {
                localStorage.clear();
            } else {
                key = key || window.location.pathname;

                localStorage.removeItem(key);
            }
        },
        /**
         * 给页面url自动添加'.html'后缀
         * @param {String} url
         */
        addHtmlToUrl: function(url) {
            // 加上'.html'后缀
            if (parseInt(Util.getFrameSysParam('dto_with_suffix'), 10) === 1 && url.indexOf('.html') < 0) {
                var i = url.indexOf('?');
                if (i < 0) {
                    url += '.html';
                } else {
                    url = url.substr(0, i) + '.html' + url.substr(i);
                }
            }
            return url;
        },
        adjustRequestContextCmd: function(url) {
            var alias = Util.getFrameSysParam('requestcontext_cmd_alias');
            if (alias) {
                url = url.replace('?cmd=', '?' + alias + '=');
            }

            return url;
        },
        /**
         * rsa加密
         */
        encryptRSA: function(str, publicExponent, modulus) {
            if (!publicExponent) {
                publicExponent = Util.getFrameSysParam('rsa_publicExponent');

                if (!publicExponent) {
                    throw new Error('the second param [publicExponent] can not be empty');
                }
                publicExponent = publicExponent.substring(1);
            }

            modulus = modulus || Util.getFrameSysParam('rsa_modulus');
            if (!modulus) {
                throw new Error('the third param [modulus] can not be empty');
            }

            var rsaKey = RSAUtils.getKeyPair(publicExponent, '', modulus);
            str = RSAUtils.encryptedString(rsaKey, str);
            return str;
        },

        /**
         * sm2加密
         */
        encryptSM2: function(str, sm2PubKey) {
            sm2PubKey = sm2PubKey || Util.getFrameSysParam('security_sm2encode_pubk');
            if (!sm2PubKey) {
                throw new Error('the second param [sm2PubKey] can not be empty');
            }

            str = sm2Encrypt(str, sm2PubKey, 0);
            return str;
        },
        encryptSM: function(str, type) {
            if (type === 'sm2') {
                return Util.encryptSM2(str);
            }

            return sm3Encrypt(str);
        },
        /**
         * Mustache 模板渲染
         * @param {String} tpl 模板，可以是模板字符串，也可以是定义模板的父元素的 id 选择器，即形如 "#tplid"
         * @param {Object} data 模板数据
         * @param {String} target 可选参数。要渲染到的目标对象，可以是目标对象的 jQuery 选择器，也可以是 dom 对象。如果不传该参数，则模板不会自动渲染。
         * @returns {String} 生成的模板字符串
         */
        render: function(tpl, data, target) {
            var html = '';
            if (tpl.indexOf('#') === 0) {
                tpl = Util.clearHtml($(tpl).html());
            }

            html = Mustache.render(tpl, data);

            if (target) {
                $(target).html(html);
            }
            return html;
        },
        /**
         * 初始化页面 pager 控件
         * @param {String} pagerId pager 控件的 id
         * @param {Object} opts 需要设置的属性
         */
        renderPager: function(pagerId, opts) {
            var pager = mini.get(pagerId);

            if (!pager || !opts) {
                return;
            }

            if (typeof opts.callback === 'function') {
                pager.__F9_RENDER_PAGER = opts.callback;
                pager.on('pagechanged', function(e) {
                    pager.__F9_RENDER_PAGER(e.pageIndex, e.pageSize);
                });

                delete opts.callback;
            }

            pager.set(opts);
        },
        /**
         * debounce 大于间隔时间时才触发
         * 连续触发时，仅当时间间隔大于指定时间才触发
         *
         * @param {function} fn 要处理的函数
         * @param {number} delay 间隔时间 单位 ms
         * @param {[object]} ctx 要绑定的上下文
         * @returns debounce 后的新函数
         */
        debounce: function(fn, delay, ctx) {
            delay = delay || 17;
            var timer;
            return function() {
                var args = arguments;
                var context = ctx || this;
                clearTimeout(timer);
                timer = setTimeout(function() {
                    fn.apply(context, args);
                }, delay);
            };
        },
        /**
         * throttle 降低触发频率
         * 连续触发时，降低执行频率到指定时间
         *
         * @param {function} fn 要处理的函数
         * @param {number} delay 间隔时间 单位 ms
         * @param {[object]} ctx 要绑定的上下文
         * @returns throttle 后的新函数
         */
        throttle: function throttle(fn, delay, ctx) {
            delay = delay || 200;
            var timer,
                prevTime = +new Date();
            return function() {
                clearTimeout(timer);
                var args = arguments;
                var context = ctx || this;
                var pastTime = +new Date() - prevTime;

                if (pastTime >= delay) {
                    // 如果过去的时间已经大于间隔时间 则立即执行
                    fn.apply(context, args);
                    prevTime = +new Date();
                } else {
                    // 过去的时间还没到 则等待
                    timer = setTimeout(function() {
                        fn.apply(context, args);
                        prevTime = +new Date();
                    }, delay - pastTime);
                }
            };
        }
    });
    // 动画支持检测和动画时间名称
    function testAnimate() {
        var el = document.createElement('div');
        var isSupportTransition = false;
        var isSupportAnimation = false;
        var transitionend = null;
        var animationend = null,
            animationiteration = null,
            animationstart = null;

        // transition
        // transition 标准事件只有结束的end， firefox下还有开始、运行中、取消等，但非标准，此处不处理
        if ('transition' in el.style) {
            isSupportTransition = true;
            transitionend = 'transitionend';
        } else if ('-webkit-transition' in el.style) {
            isSupportTransition = true;
            transitionend = 'webkitTransitionEnd';
        } else if ('-moz-transition' in el.style) {
            isSupportTransition = true;
            transitionend = 'mozTransitionEnd';
        } else if ('-o-transition' in el.style) {
            isSupportTransition = true;
            transitionend = 'oTransitionEnd';
        }

        // animation
        // animation 标准事件有 开始、运行中、结束， firefox下还有取消，但非标准，此处不处理
        if ('animation' in el.style || '-moz-animation' in el.style) {
            isSupportAnimation = true;
            animationend = 'animationend';
            animationiteration = 'animationiteration';
            animationstart = 'animationstart';
        } else if ('-webkit-animation' in el.style) {
            isSupportAnimation = true;
            animationend = 'webkitAnimationEnd';
            animationiteration = 'webkitAnimationIteration';
            animationstart = 'webkitAnimationStart';
        }
        el = null;
        return {
            isSupportTransition: isSupportTransition,
            isSupportAnimation: isSupportAnimation,
            animationend: animationend,
            animationiteration: animationiteration,
            animationstart: animationstart,
            transitionend: transitionend
        };
    }
    $.extend(Util.browsers, testAnimate());

    // edge 常常需要和IE相同的处理 也需要进行标记
    if (Util.browsers.isEdge) {
        $('body').addClass('edge');
    }

    // 用于F8框架，套用jsf模板的页面
    // iframe scrolling为no的情况下, 框架页面可以正常出现滚动条
    // 以后可能会删除
    Util.fixIframeNoScroll = function() {
        $('body')
            .add('html')
            .css({
                height: '100%',
                overflow: 'hidden'
            });

        $('form:eq(0)').css({
            height: '100%',
            overflow: 'auto'
        });
    };
    Util._fixIframeNoScroll = Util.fixIframeNoScroll;

    // 别名，适配代码中可能存在的老用法
    Util._clearIframe = Util.clearIframe;
    Util._loadPageModule = Util.loadPageModule;

    // getRightUrl的别名，参考.net的方法名
    Util.getAbsoluteUrl = Util.getRightUrl;
})(this, jQuery);

// 全屏扩展
(function(win, $) {
    var p = Element.prototype;
    var requestFn = '';
    var exitFn = '';
    if (typeof p.requestFullscreen === 'function') {
        requestFn = 'requestFullscreen';
        exitFn = 'exitFullscreen';
    } else {
        ['webkit', 'moz', 'ms', 'o'].forEach(function(p) {
            var fn = p + 'RequestFullscreen';
            if (typeof fn[p] === 'function') {
                requestFn = p + 'RequestFullScreen';
                exitFn = p + 'ExitFullscreen';
            }
        });
    }

    var fullscreen = {
        requestFullscreen: requestFn
            ? function(el, options) {
                  if (!el) {
                      el = document.documentElement;
                  }
                  var r = arguments.length > 1 ? el[requestFn](options) : el[requestFn]();
                  if (r && r.then) {
                      return r;
                  }
                  // IE msRequestFullscreen 返回的是 undefined 。。。
                  return Promise.resolve();
              }
            : function() {
                  return Promise.reject(new Error('requestFullscreen is not supported'));
              },
        exitFullscreen: exitFn
            ? function() {
                  var r = document[exitFn]();
                  if (r && r.then) {
                      return r;
                  }
                  return Promise.resolve();
              }
            : function() {
                  return Promise.reject(new Error('exitFullscreen is not supported'));
              },
        createFullScreenToggle: function(el, callback, options) {
            if (!requestFn) {
                console.error('requestFullscreen is not supported');
                return;
            }
            if (!el) {
                el = document.documentElement;
            }
            var current = {
                enter: function() {
                    return fullscreen.requestFullscreen(el, options);
                },
                exit: function() {
                    return fullscreen.exitFullscreen();
                },
                toggle: function() {
                    current.fullscreenState ? current.exit() : current.enter();
                },
                onchange: typeof callback === 'function' ? callback : function() {}
            };

            el.addEventListener('fullscreenchange', function() {
                current.fullscreenState = !!document.fullscreenElement;
                current.onchange(current.fullscreenState);
            });
            return current;
        }
    };
    $.extend(win.Util, fullscreen);

})(this, this.jQuery);


// 皮肤切换
(function(win, $) {
    var skinSwitcher = {
        _timer: null,
        updateSkin: function(skin) {
            var self = this;
            if (this._timer) {
                clearTimeout(this._timer);
            }
            $('[name="fui-ui-style"][data-name="' + skin + '"]').prop('disabled', false);
            $('[name="fui-theme-style"][data-name="' + skin + '"]').prop('disabled', false);

            // 避免切换过快，导致样式丢失，可能会触发元素 resize，此时计算的宽高不正确。
            this._timer = setTimeout(function() {
                $('[name="fui-ui-style"]').not('[data-name="' + skin +'"]').prop('disabled', true);
                $('[name="fui-theme-style"]').not('[data-name="' + skin + '"]').prop('disabled', true);
                self._timer = null;
            }, 200);
        },
        postToChild: function(skin, hasSelf) {
            var iframes = document.getElementsByTagName('iframe');
            var that = this;
            if (hasSelf) {
                setTimeout(function() {
                    that._postMessage(win, skin);
                });
            }
            try {
                $.each(iframes, function(i, ifr) {
                    setTimeout(function() {
                        that._postMessage(ifr.contentWindow, skin);
                    });
                });
            } catch (error) {
                console.error(error);
                iframes = null;
            }
            iframes = null;
        },
        _postMessage: function(aimWin, skin) {
            aimWin.postMessage(
                JSON.stringify({
                    type: 'skinChange',
                    skin: skin
                }),
                '*'
            );
        },
        init: function() {
            var that = this;
            $(win).on('message', function(event) {
                event = event.originalEvent;
                if (!event.data) return;
                try {
                    var data = JSON.parse(event.data);
                    if (data.type === 'skinChange' && data.skin) {
                        that.updateSkin(data.skin);
                        that.postToChild(data.skin);
                    }
                } catch (error) {}
            });
        }
    };
    skinSwitcher.init();
    Util.skinSwitcher = skinSwitcher;
})(this, jQuery);

// 字体大小切换
(function(win, $) {
    var htmlBase = win.HtmlBaseFontSize || 100;
    var bodyBase = win.BodyBaseFontSize || 14;

    function calcFontSize(base, ratio) {
        return (base * ratio).toFixed(6) + 'px';
    }
    var fontSizeSwitcher = {
        doUpdateFontSize: function(ratio) {
            if (!ratio || isNaN(parseFloat(ratio, 10))) {
                return;
            }
            document.documentElement.style.fontSize = calcFontSize(htmlBase, ratio);
            document.body.style.fontSize = calcFontSize(bodyBase, ratio);
            setTimeout(function() {
                $(win).trigger('resize');
            }, 200);
        },
        updateFontSize: function(ratio) {
            ratio = ratio.ratio || ratio;
            this.doUpdateFontSize(ratio);
            this.postToChild(
                JSON.stringify({
                    ratio: ratio,
                    type: 'fontSizeChange'
                })
            );
        },
        postToChild: function(data) {
            [].slice.call(document.getElementsByTagName('iframe')).forEach(function(ifr) {
                ifr.contentWindow.postMessage(data, '*');
            });
        },
        saveFontSizeRatio: function(ratio) {
            ratio = parseFloat(ratio, 10);
            if (!ratio || isNaN(ratio)) {
                return;
            }
            Util.writeCookie('_font_size_ratio_', ratio, {
                expires: 365,
                path: window._rootPath ? window._rootPath + '/' : '/'
            });
            this.updateFontSize(ratio);
        },
        init: function() {
            var that = this;
            win.addEventListener('message', function(ev) {
                var data = ev.data;
                try {
                    if (data && data + '' === data) {
                        data = JSON.parse(data);
                    }
                    if (data.type === 'fontSizeChange') {
                        that.updateFontSize(data);
                    }
                } catch (error) {}
            });
        }
    };

    win.addEventListener && fontSizeSwitcher.init();
    win.Util.fontSizeSwitcher = fontSizeSwitcher;
})(this, jQuery);

(function(win, $) {
    var layoutInstance = {
        onToggle: Util.noop,
        toggleTop: Util.noop,
        toggleLeft: Util.noop,
        toggleRight: Util.noop,
        toggleBottom: Util.noop,
        /**
         * 切换目标区域
         * @param {string} region 切换到目标区域
         * @param {boolean | undefined} 要切换到的状态 不传表示切换 true表示打开 false 表示收起
         */
        toggle: function (region, show) {
            var targetMethod = 'toggle' + region[0].toUpperCase() + region.substr(1);
            this[targetMethod] && this[targetMethod](show);
        }
    };
    var $body = $('body');
    var defaultResizeOptions = {
        animate: false, // 我们有css动画
        autoHide: true,
        delay: 20,
        ghost: false // 不要在resize的时候复制内容
    };

    var MIN_WIDTH = 150;
    var MIN_HEIGHT = 49;
    var DEFAULT_WIDTH = 211;
    var DEFAULT_TOP_HEIGHT = 49;
    var DEFAULT_BOTTOM_HEIGHT = 80;

    var EVENT_NAMESPACE = '.f9-layout';
    var isIE8 = Util.browsers.isIE8;
    var isIE9 = Util.browsers.isIE9;

    Util.UserEvent.installTo(layoutInstance);

    function parse() {
        var $top = $('.fui-top');
        var $left = $('.fui-left');
        var $main = $('.fui-main, .fui-right');
        var $right = $('.fui-rightbar');
        var $bottom = $('.fui-bottom');
        var $layoutRegion = $top
            .add($left)
            .add($main)
            .add($right)
            .add($bottom);

        // 切换或reseize需要调整宽度的集合
        var needUpdateTopArr = [];
        var needUpdateBottomArr = [];
        var needUpdateLeftArr = [];
        var needUpdateRightArr = [];

        if (!check()) {
            return;
        }
        layoutInstance.fire('beforeParse');
        var hasPageLoading = $('.page-loading').length;
        var $pageLoading = $.fn;
        if (!hasPageLoading && $layoutRegion.length) {
            $pageLoading = $('<div class="page-loading"></div>').appendTo('body');
            $pageLoading.css('height');
        }

        adaptInitCls();

        $.each([$top, $left, $right, $bottom], function(i, $el) {
            addToggleBtn($el);
        });

        parseView($left);
        parseView($right);

        initTopEvent();
        initLeftEvent();
        initRightEvent();
        initBottomEvent();

        // 只要有拖动就为fui-main添加遮罩 避免 ifr 导致无法拖拽的问题
        if ($layoutRegion.filter(function (i, el) {
            var $el = $(el);
            return !$el.hasClass('fui-main') && $el.attr('resize') !== 'false';
        }).length) {
            $('<div class="fui-layout-cover"></div>').appendTo($main);
        }

        if (!hasPageLoading) {
            $pageLoading.fadeOut(function() {
                $pageLoading.remove();
            });
        }
        setTimeout(function() {
            $layoutRegion.addClass('fui-layout-tran');
        }, 1000);

        layoutInstance.fire('parse');
        layoutInstance.fire('afterParse');

        var resizeTimerMap = {};
        function afterResize(type) {
            // resize end
            // layoutInstance.fire('afterResize', {
            //     region: type
            // });
            // resize 之后 调整动画为 css 涉及区域多，处理复杂 直接 setTimeout
            if (isIE8 || isIE9) {
                return layoutInstance.fire('afterResize', {
                    region: type
                });
            }
            clearTimeout(resizeTimerMap[type]);
            resizeTimerMap[type] = setTimeout(function() {
                layoutInstance.fire('afterResize', {
                    region: type
                });
            }, 200);
        }

        /**
         * 检查是否符合使用规范
         *
         * @returns {boolean}
         */
        function check() {
            var rt = true;
            $.each([$top, $left, $main, $right, $bottom], function(i, $el) {
                if ($el.length > 1) {
                    rt = false;
                    // eslint-disable-next-line
                    console.error($el[0], '布局区域重复， 一个区域仅能出现一次');
                    return false;
                }
            });
            rt &&
                $layoutRegion.each(function(i, el) {
                    if ($(el).parent()[0] !== document.body) {
                        rt = false;
                        // eslint-disable-next-line
                        console.error(el, '不在body下，布局结构错误！！！');
                        return false;
                    }
                });
            return rt;
        }
        /**
         * 多种布情形下的 cls fix
         *
         */
        function adaptInitCls() {
            var hasTop = $top.length === 1,
                hasBottom = $bottom.length === 1,
                topInset,
                bottomInset;

            if (hasTop) {
                if ($top.attr('inset') === 'true') {
                    topInset = true;
                    $body.addClass('with-fui-top-inset');
                    needUpdateTopArr = [$main];
                } else {
                    $body.addClass('with-fui-top');
                    needUpdateTopArr = [$left, $main, $right];
                }
            } else {
                needUpdateTopArr = [];
            }
            if (hasBottom) {
                if ($bottom.attr('inset') === 'true') {
                    bottomInset = true;
                    $body.addClass('with-fui-bottom-inset');
                    needUpdateBottomArr = [$main];
                } else {
                    $body.addClass('with-fui-bottom');
                    needUpdateBottomArr = [$left, $main, $right];
                }
            } else {
                needUpdateBottomArr = [];
            }

            if ($left.length) {
                $body.addClass('with-fui-left');
                needUpdateLeftArr = [$main];
                if (hasTop && topInset) {
                    needUpdateLeftArr.push($top);
                }
                if (hasBottom && bottomInset) {
                    needUpdateLeftArr.push($bottom);
                }
            } else {
                needUpdateLeftArr = [];
            }

            if ($right.length) {
                $body.addClass('with-fui-right');
                needUpdateRightArr = [$main];
                if (hasTop && topInset) {
                    needUpdateRightArr.push($top);
                }
                if (hasBottom && bottomInset) {
                    needUpdateRightArr.push($bottom);
                }
            } else {
                needUpdateRightArr = [];
            }

            // 之前的 fui-right 自动兼容为 fui-main
            if ($main.hasClass('fui-right')) {
                $main.addClass('fui-main');
            }
        }
        /**
         * 插入切换按钮
         */
        function addToggleBtn($container) {
            if (!$container.length) return;
            if ($container.attr('toggle') !== 'false') {
                var $icon = $('<span class="fui-layout-toggle"></span>').appendTo($container);
                $container[0].removeAttribute('toggle');
                if ($container.hasClass('fui-top')) {
                    $icon.addClass('icon-totop');
                }
                if ($container.hasClass('fui-bottom')) {
                    $icon.addClass('icon-tobottom');
                }
                if ($container.hasClass('fui-left')) {
                    $icon.addClass('icon-toleft');
                }
                if ($container.hasClass('fui-rightbar')) {
                    $icon.addClass('icon-toright');
                }
            }
        }

        function initTopEvent() {
            if (!$top.length) return;

            var defaultClose = $top.attr('closed') === 'true';
            $top.off('click' + EVENT_NAMESPACE, '.fui-layout-toggle').on('click' + EVENT_NAMESPACE, '.fui-layout-toggle', function() {
                var toClose = !$top.hasClass('closed');
                if (toClose) {
                    toggle(false);
                } else {
                    toggle(true);
                }
            });

            function toggle(show) {
                if (show) {
                    $top.removeClass('closed');
                    updateTop($top.data('height') || $top.outerHeight(true));
                } else {
                    $top.addClass('closed');
                    updateTop(0);
                }
                layoutInstance.fire('_toggle', {
                    region: 'top',
                    state: show ?  'opened' : 'closed'
                });
            }

            layoutInstance.toggleTop = function (show) {
                var targetState = show !== undefined ?  !!show : $top.hasClass('closed');
                toggle(targetState);
            };

            if (defaultClose) {
                $top.find('.fui-layout-toggle').trigger('click');
            }

            function updateTop(h) {
                $.each(needUpdateTopArr, function(i, $el) {
                    $el.css('top', h);
                });
            }

            var min_h = parseInt($top.attr('min-height'), 10) || MIN_HEIGHT;
            var max_h = parseInt($top.attr('max-height'), 10);
            var default_h = parseInt($top.attr('default-height'), 10) || DEFAULT_TOP_HEIGHT;

            // 还原
            var defaultHeight = makeInRange(default_h, min_h, max_h);
            var h = getLocalSize('top') || defaultHeight || 0;
            if (h && h !== DEFAULT_TOP_HEIGHT) {
                $top.css('height', h);
                !defaultClose && updateTop(h);
            }
            // 拖拽
            if ($top.attr('resize') === 'false') {
                return;
            }
            $('<div class="fui-layout-resizebar"></div>').appendTo($top);
            var startWidth = 0;
            $top.resizable(
                $.extend({}, defaultResizeOptions, {
                    maxHeight: max_h || getMaxLimit('top'),
                    minHeight: min_h,
                    helper: 'fui-top-resize-helper',
                    handles: {
                        s: '.fui-top > .fui-layout-resizebar'
                    },
                    start: function() {
                        $body.addClass('row-resizing');
                        startWidth = $top.outerWidth(true);
                    },
                    resize: function(ev, ui) {
                        ui.helper.css('width', startWidth);
                    },
                    stop: function(ev, ui) {
                        $body.removeClass('row-resizing');
                        var h = Math.round(ui.size.height);
                        $top.css({
                            width: '',
                            height: h
                        }).data('height', h);
                        updateTop(h);
                        setLocalSize('top', h);
                        afterResize('top');
                    }
                })
            );

            !max_h &&
                $(window).on('resize' + EVENT_NAMESPACE + 'top', function() {
                    $top.resizable('option', 'maxHeight', getMaxLimit('top'));
                });
        }

        function initLeftEvent() {
            if (!$left.length) return;
            var defaultClose = $left.attr('closed') === 'true';
            $left.off('click' + EVENT_NAMESPACE, '.fui-layout-toggle').on('click' + EVENT_NAMESPACE, '.fui-layout-toggle', function() {
                var toClose = !$left.hasClass('closed');
                if (toClose) {
                    toggle(false);
                } else {
                    toggle(true);
                }
            });
            function toggle(show) {
                if (show) {
                    $left.removeClass('closed');
                    updateLeft($left.data('width') || $left.outerWidth(true));
                } else {
                    $left.addClass('closed');
                    updateLeft(0);
                }

                layoutInstance.fire('_toggle', {
                    region: 'left',
                    state: show ?  'opened' : 'closed'
                });
            }
            layoutInstance.toggleLeft = function (show) {
                var targetState = show !== undefined ?  !!show : $left.hasClass('closed');
                toggle(targetState);
            };

            if (defaultClose) {
                $left.find('.fui-layout-toggle').trigger('click');
            }

            function updateLeft(w) {
                $.each(needUpdateLeftArr, function(i, $el) {
                    $el.css('left', w);
                });
            }

            var min_w = parseInt($left.attr('min-width'), 10) || MIN_HEIGHT;
            var max_w = parseInt($left.attr('max-width'), 10);
            var default_w = parseInt($left.attr('default-width'), 10) || DEFAULT_WIDTH;

            // 还原
            var defaultWidth = makeInRange(default_w, min_w, max_w);
            var w = getLocalSize('left') || defaultWidth || 0;
            if (w && w !== DEFAULT_WIDTH) {
                $left.css('width', w);
                !defaultClose && updateLeft(w);
            }
            // 拖拽
            if ($left.attr('resize') === 'false') {
                return;
            }
            $('<div class="fui-layout-resizebar"></div>').appendTo($left);
            var startHeight = 0;
            $left.resizable(
                $.extend({}, defaultResizeOptions, {
                    maxWidth: max_w || getMaxLimit('left'),
                    minWidth: min_w,
                    helper: 'fui-left-resize-helper',
                    handles: {
                        e: '.fui-left > .fui-layout-resizebar'
                    },
                    start: function() {
                        $body.addClass('col-resizing');
                        startHeight = $left.outerHeight(true);
                    },
                    resize: function(ev, ui) {
                        ui.helper.css('height', startHeight);
                    },
                    stop: function(ev, ui) {
                        $body.removeClass('col-resizing');
                        // console.log('stop', ev, ui);
                        var w = Math.round(ui.size.width);
                        $left
                            .css({
                                width: w,
                                height: ''
                            })
                            .data('width', w);
                        updateLeft(w);
                        setLocalSize('left', w);

                        afterResize('left');
                    }
                })
            );

            !max_w &&
                $(window).on('resize' + EVENT_NAMESPACE + 'left', function() {
                    $left.resizable('option', 'maxWidth', getMaxLimit('left'));
                });
        }

        function initRightEvent() {
            if (!$right.length) return;

            $right.off('click' + EVENT_NAMESPACE, '.fui-layout-toggle').on('click' + EVENT_NAMESPACE, '.fui-layout-toggle', function() {
                var toClose = !$right.hasClass('closed');
                if (toClose) {
                    toggle(false);
                } else {
                    toggle(true);
                }
            });

            function toggle(show) {
                if (show) {
                    $right.removeClass('closed');
                    updateRight($right.data('width') || $right.outerWidth(true));
                } else {
                    $right.addClass('closed');
                    updateRight(0);
                }

                layoutInstance.fire('_toggle', {
                    region: 'rightbar',
                    state: show ?  'opened' :  'closed'
                });
            }
            layoutInstance.toggleRight = function (show) {
                var targetState = show !== undefined ?  !!show : $right.hasClass('closed');
                toggle(targetState);
            };

            var defaultClose = $right.attr('closed') === 'true';
            if (defaultClose) {
                $right.find('.fui-layout-toggle').trigger('click');
            }

            function updateRight(w) {
                $.each(needUpdateRightArr, function(i, $el) {
                    $el.css('right', w);
                });
            }

            var min_w = parseInt($right.attr('min-width'), 10) || MIN_HEIGHT;
            var max_w = parseInt($right.attr('max-width'), 10);
            var default_w = parseInt($right.attr('default-width'), 10) || DEFAULT_WIDTH;

            // 还原
            var defaultWidth = makeInRange(default_w, min_w, max_w);
            var w = getLocalSize('rightbar') || defaultWidth || 0;
            if (w && w !== DEFAULT_WIDTH) {
                $right.css('width', w);
                !defaultClose && updateRight(w);
            }

            // 拖拽
            if ($right.attr('resize') === 'false') {
                return;
            }
            $('<div class="fui-layout-resizebar"></div>').appendTo($right);
            var startTop = 0;
            var startBottom = 0;
            var maxLimit = getMaxLimit('rightbar');
            var actualW = 0;
            $right.resizable(
                $.extend({}, defaultResizeOptions, {
                    // maxWidth: getMaxLimit('rightbar'),
                    // minWidth: MIN_WIDTH,
                    helper: 'fui-rightbar-resize-helper',
                    handles: {
                        e: '.fui-rightbar > .fui-layout-resizebar'
                    },
                    start: function() {
                        $body.addClass('col-resizing');
                        maxLimit = max_w || getMaxLimit('rightbar');
                        startTop = parseInt($right.css('top'), 10) || 0;
                        startBottom = parseInt($right.css('bottom'), 10) || 0;
                    },
                    resize: function(ev, ui) {
                        var delta = ui.size.width - ui.originalSize.width;
                        actualW = ui.originalSize.width - delta;
                        actualW = makeInRange(actualW, min_w, maxLimit);
                        ui.helper.css({
                            left: 'auto',
                            right: 0,
                            top: startTop,
                            bottom: startBottom,
                            width: actualW,
                            height: ''
                        });
                    },
                    stop: function() {
                        $body.removeClass('col-resizing');
                        // console.log('stop', ev, ui);
                        $right
                            .css({
                                left: '',
                                width: actualW,
                                height: ''
                            })
                            .data('width', actualW);
                        updateRight(actualW);
                        setLocalSize('rightbar', actualW);

                        afterResize('rightbar');
                    }
                })
            );
        }

        function initBottomEvent() {
            if (!$bottom.length) return;

            $bottom.off('click' + EVENT_NAMESPACE, '.fui-layout-toggle').on('click' + EVENT_NAMESPACE, '.fui-layout-toggle', function() {
                var toClose = !$bottom.hasClass('closed');
                if (toClose) {
                    toggle(false);
                } else {
                    toggle(true);
                }
            });

            function toggle(show) {
                if (show) {
                    $bottom.removeClass('closed');
                    updateBottom($bottom.data('height') || $bottom.outerHeight(true));
                } else {
                    $bottom.addClass('closed');
                    updateBottom(0);
                }
                layoutInstance.fire('_toggle', {
                    region: 'bottom',
                    state: show ?  'opened' : 'closed'
                });
            }
            layoutInstance.toggleBottom = function (show) {
                var targetState = show !== undefined ?  !!show : $bottom.hasClass('closed');
                toggle(targetState);
            };

            var defaultClose = $bottom.attr('closed') === 'true';
            if (defaultClose) {
                $bottom.find('.fui-layout-toggle').trigger('click');
            }

            function updateBottom(h) {
                $.each(needUpdateBottomArr, function(i, $el) {
                    $el.css('bottom', h);
                });
            }

            var min_h = parseInt($bottom.attr('min-height'), 10) || MIN_HEIGHT;
            var max_h = parseInt($bottom.attr('max-height'), 10);
            var default_h = parseInt($bottom.attr('default-height'), 10) || DEFAULT_BOTTOM_HEIGHT;

            // 还原
            var defaultHeight = makeInRange(default_h, min_h, max_h);
            var h = getLocalSize('bottom') || defaultHeight || 0;
            if (h && h !== DEFAULT_BOTTOM_HEIGHT) {
                $bottom.css('height', h);
                !defaultClose && updateBottom(h);
            }
            // 拖拽
            if ($bottom.attr('resize') === 'false') {
                return;
            }
            $('<div class="fui-layout-resizebar"></div>').appendTo($bottom);
            var startRight = 0;
            var startLeft = 0;
            var maxLimit = getMaxLimit('bottom');
            var actualH = 0;
            $bottom.resizable(
                $.extend({}, defaultResizeOptions, {
                    // maxHeight: getMaxLimit('bottom'),
                    // minHeight: MIN_HEIGHT,
                    helper: 'fui-bottom-resize-helper',
                    handles: {
                        s: '.fui-bottom > .fui-layout-resizebar'
                    },
                    start: function() {
                        $body.addClass('row-resizing');
                        maxLimit = max_h || getMaxLimit('bottom');
                        startRight = parseInt($bottom.css('right'), 10) || 0;
                        startLeft = parseInt($bottom.css('left'), 10) || 0;
                    },
                    resize: function(ev, ui) {
                        var delta = ui.size.height - ui.originalSize.height;
                        actualH = ui.originalSize.height - delta;

                        actualH = makeInRange(actualH, min_h, maxLimit);
                        ui.helper.css({
                            left: startLeft,
                            right: startRight,
                            top: 'auto',
                            bottom: 0,
                            width: '',
                            height: actualH
                        });
                    },
                    stop: function() {
                        $body.removeClass('row-resizing');
                        $bottom
                            .css({
                                top: '',
                                width: '',
                                height: actualH
                            })
                            .data('height', actualH);
                        updateBottom(actualH);
                        setLocalSize('bottom', actualH);
                        afterResize('bottom');
                    }
                })
            );
        }
    }

    /**
     * 获取本地存储的宽/高度
     */
    function getLocalSize(type) {
        var saveKey = 'FRAME_LAYOUT_SIZE_' + type + '-' + location.pathname;

        var localSize = parseInt(localStorage.getItem(saveKey), 10);
        if (type === 'top' || type === 'bottom') {
            if (localSize < MIN_HEIGHT) return MIN_HEIGHT;
            var max = getMaxLimit(type);
            if (localSize > max) return max;
            return localSize;
        } else if (type === 'left' || type === 'rightbar') {
            if (localSize < MIN_WIDTH) return MIN_WIDTH;
            var maxW = getMaxLimit(type);
            if (localSize > maxW) return maxW;
            return localSize;
        }
        return 0;
    }

    function setLocalSize(type, value) {
        var saveKey = 'FRAME_LAYOUT_SIZE_' + type + '-' + location.pathname;

        localStorage.setItem(saveKey, value);
    }

    /**
     * 四舍五入取整 10
     * @param {number} num
     */
    function roundToD(num) {
        return Math.round(num / 10) * 10;
    }
    function makeInRange(num, min, max) {
        if (!$.isNumeric(num)) return NaN;
        if ($.isNumeric(min) && num < min) return min;
        if ($.isNumeric(max) && num > max) return max;

        return num;
    }

    function getMaxLimit(type) {
        if (type === 'left' || type === 'rightbar') {
            // 最大限制宽度 取窗口的40%
            var w = window.innerWidth;
            var lw = roundToD(w * 0.4);
            // 页面可能是隐藏状态，计算出来的值为 0 ，会导致直接使用 MIN_WIDTH 的值，而不是本地localStorage记录的值
            return lw > 0 ? lw < MIN_WIDTH ? MIN_WIDTH : lw : NaN;
        }
        if (type === 'top' || type === 'bottom') {
            // 最大限制高度 取窗口的30%
            var h = window.innerHeight;
            var lh = Math.round(h * 0.3);
            return lh > 0 ? lh < MIN_HEIGHT ? MIN_HEIGHT : lh : NaN;
        }
    }

    function parseView($el) {
        if (!$el.length) return;
        var $hd = $el.find('> [role="head"]'),
            title = $hd.attr('title');

        var $bd = $el.find('> [role="body"]');
        var type = $el.hasClass('fui-left') ? 'left' : 'rightbar';
        if ($hd.length) {
            $hd.addClass('fui-' + type + '-hd')
                .append(getTitleHtml(title, type))
                .removeAttr('role');
        }

        if ($bd.length) {
            $bd.addClass('fui-' + type + '-bd').removeAttr('role');
        }
    }

    function getTitleHtml(title, type) {
        return title ? '<h4 class="fui-' + type + '-title">' + title + '</h4>' : '';
    }

    /*
    function autoAdjustLeft() {
        var $children = $('.fui-left > *, .fui-left > .fui-left-bd > *');
        $children.each(function(i, el) {
            var ctr = mini.getAndCreate(el);
            ctr && ctr.doLayout && ctr.doLayout();
        });
    } */

    function adjustGrid() {
        win.Util._layoutDatagridInContent && Util._layoutDatagridInContent();
    }

    // 事件 hook
    // resize 之后尺寸变化完成
    layoutInstance.on('afterResize', function() {
        $(window).trigger('resize');
        adjustGrid();
    });

    var toggleTimerMap = {};
    function afterToggle(type, data) {
        if (isIE8 || isIE9) {
            layoutInstance.fire('toggle' + type, data);
            layoutInstance.fire('toggle', data);
            return;
        }
        clearTimeout(toggleTimerMap[type]);
        toggleTimerMap[type] = setTimeout(function() {
            layoutInstance.fire('toggle' + type, data);
            layoutInstance.fire('toggle', data);
        }, 200);
    }

    // 切换
    layoutInstance.on('_toggle', function(e) {
        var data = e.data;
        var type = data.region;

        afterToggle(type, data);
    });
    layoutInstance.on('toggle', function(e) {
        var data = e.data;
        var region = data.region;
        if (region === 'left') {
            Util.leftRight.onToggle();
        }
        win.adjustContentHeight && win.adjustContentHeight();
        adjustGrid();
        layoutInstance.onToggle(region, data.state);
    });

    // 对外处理
    $.extend(layoutInstance, {
        parse: parse
    });
    Util.layoutInstance = layoutInstance;
    if (!Util.leftRight) {
        Util.leftRight = {};
    }
    if (!Util.leftRight.onToggle) {
        Util.leftRight.onToggle = Util.noop;
    }
    if (!Util.leftRight.parse) {
        Util.leftRight.parse = parse;
    }
    // auto parse
    // $(function() {
        parse();
    // });
})(this, this.jQuery);

/*!
 * 解析表单布局
 */
(function(win, $) {
    var $forms = $('.fui-form');

    var span2percent = {
        span1: '33.3333%',
        span2: '50%',
        span3: '66.6667%',
        span4: '83.3333%',
        span5: '100%'
    };

    var getLblHtml = function(label, required, opt) {
        var html = [];

        // 如果label为空，或配置为不显示 则不需要冒号了
        if (label !== '' && opt && opt.showColon) {
            label += '：';
        }

        html.push('<label class="form-label');
        if (required) html.push(' required');
        html.push('">' + label + '</label>');

        return html.join('');
    };

    // 解析表单行
    var parseRow = function($row, opt) {
        var $controls = $row.find('[role="control"]'),
            // 2列 = label + control
            cols = $controls.length * 2,
            newsection = $row.data('newsection');

        $row.addClass('form-row');
        if ($row.data('inline') === true) {
            $row.addClass('inline');
            opt.inline = true;
        }

        if (newsection) {
            $row.addClass('newsection');
        }

        for (var i = 0, len = $controls.length; i < len; i++) {
            parseControl($controls.eq(i), cols, opt);
        }
    };

    var horizontalSpanMap = {
        2: 5,
        4: 2,
        6: 1
    };
    var verticalSpanMap = {
        2: 6,
        4: 3,
        6: 2
    };

    // 解析控件容器
    var parseControl = function($control, cols, opt) {
        var span;
        // 不用jquery attr，算是稍微提高点效率
        var required = $control[0].getAttribute('starred') === 'true',
            label = $control[0].getAttribute('label'),
            hasLabel = $control[0].hasAttribute('label');

        // 生成label html，label可以不配置
        var lblhtml = hasLabel ? getLblHtml(label ? label : '', required, opt) : '';

        var helptext = $control.data('tooltip');
        if (helptext) {
            $control.data('tooltip', '').removeAttr('data-tooltip');
        }

        if (opt.isVertical) {
            // 根据列配置，决定组件容器的跨度
            span = parseInt($control[0].getAttribute('span'), 10);
            if (span) {
                span = span > 6 ? 6 : span < 1 ? 1 : span;
            } else {
                span = verticalSpanMap[cols + ''];
            }

            if (helptext) {
                var tiphtml =
                    '<span class="form-tooltip action-icon icon-confirm" data-tooltip="' + helptext + '"></span>';
                if (!opt.inline) {
                    tiphtml += '<br>';
                }
                $control.prepend(tiphtml);
            } else if (!opt.inline) {
                lblhtml += '<br>';
            }
            $control
                .addClass('form-control')
                .addClass('span' + span)
                .prepend(lblhtml)
                // 清理role，防止重复parse
                .removeAttr('role');
        } else {
            // 根据列配置，决定组件容器的跨度
            span = parseInt($control[0].getAttribute('span'), 10);
            if (span) {
                span = span > 6 ? 6 : span < 2 ? 2 : span;
                span = span - 1;
            } else {
                span = horizontalSpanMap[cols + ''];
            }
            $control
                .addClass('form-control')
                .addClass('span' + span)
                .before(lblhtml)
                // 清理role，防止重复parse
                .removeAttr('role');
            if (helptext) {
                var $tip = $('<span class="form-tooltip action-icon icon-confirm"></span>').attr(
                    'data-tooltip',
                    helptext
                );
                $tip.appendTo($control);
                adaptControlWidth($tip);
            }
        }
    };

    function adaptControlWidth($tip) {
        var $ctr = $tip.prev();
        var w = $ctr[0].style.width;
        var w2 = '';
        if (/px$/.test(w)) {
            w2 = parseInt(w, 10) - 30;
        }
        if (!w2) {
            w2 = 'calc( ' + (w || '100%') + ' - ' + '30px )';
        }
        // console.log(w, w2);
        $ctr.css('width', w2);
    }
    // 初始化tooltips
    var formTip;

    var parse = function($forms) {
        if (!formTip) {
            $(function () {
                formTip = new mini.ToolTip();
                formTip.set({
                    target: document,
                    trigger: 'hover',
                    selector: '.form-tooltip',
                    placement: 'top',
                    autoHide: true
                });
            });
        }
        // 系统参数配置的方向 'vertical' 'horizontal'
        var systemDirection = Util.getFrameSysParam('ui_form_arrangement');
        // 是否显示 label 后面的 ：
        var systemShowColon = Util.getFrameSysParam('ui_form_showcolon');
        $forms.each(function(i, form) {
            var $form = $(form);
            var isVertical;
            if (form.hasAttribute('vertical') || form.hasAttribute('data-vertical')) {
                isVertical = $form.data('vertical') || $form.attr('vertical') == 'true';
            } else {
                isVertical = systemDirection === 'vertical';
                // 搜索区域中忽略系统参数配置的垂直
                if (isVertical && $form.closest('.fui-search,.fui-condition').length) {
                    isVertical = false;
                }
            }

            var showColon;
            if (form.hasAttribute('showcolon')) {
                showColon = $form.attr('showcolon') === 'true';
            } else if (form.hasAttribute('data-showcolon')) {
                showColon = $form.data('showcolon');
            } else {
                showColon = systemShowColon !== undefined ? systemShowColon : true;
            }
            // 将配置记录下来
            $form.data('showcolon', showColon);
            if (isVertical) {
                $form.addClass('vertical');
            }

            var $inners = $form.find('[role="form"]'),
                $rows = $form.find('[role="row"]');

            // 先hidden需要解析的forms
            // 判断原先是否有hidden的class
            var hiddenFlag = false;
            if ($form.hasClass('hidden')) {
                hiddenFlag = true;
            } else {
                $form.addClass('hidden');
            }

            $inners.addClass('form-inner');

            for (var j = 0, len = $rows.length; j < len; j++) {
                parseRow($rows.eq(j), {
                    isVertical: isVertical,
                    showColon: showColon
                });
            }

            // 清理role，防止重复parse
            $inners.removeAttr('role');
            $rows.removeAttr('role');

            // label-width 支持
            setLabelWidth($form);

            // ErrorMode
            setCtrErrorMode($form);

            // 解析结束，显示forms
            if (!hiddenFlag) {
                $form.removeClass('hidden');
            }
        });
    };

    function setCtrErrorMode($forms) {
        if (!$forms.length) return;
        $.each($forms, function(i, form) {
            var $form = $(form);
            var errorMode = $form.data('errormode');
            if (!errorMode) return;
            errorMode = errorMode.toLowerCase();
            $form.find('.form-control > [class*="mini-"]').each(function(j, el) {
                var $el = $(el);
                if (!$el.attr('errormode')) {
                    $el.attr('errormode', errorMode);
                }
            });
        });
    }

    /**
     * 读取 label-width 为 form 设置 label宽度
     * add by chends
     * @param {jQueryObject} $forms
     * @returns
     */
    function setLabelWidth($forms) {
        if (!$forms.length) return;
        $.each($forms, function(i, form) {
            var $form = $(form);
            var w = $form.attr('label-width');
            if (!w) return;
            var width = parseInt(w, 10) || 0;
            if (!width) return;
            if (Util.browsers.isIE8) {
                window.console && console.error('您的浏览器不支持label-width的配置');
                return;
            }
            if ($form.hasClass('vertical')) {
                window.console && console.error('vertical 下不支持label-width的配置');
                return;
            }
            $form.find('.form-row').each(function(i, row) {
                var $children = $(row).children();
                $children.each(function(j, span) {
                    var $span = $(span);
                    // label 直接设置
                    if ($span.hasClass('form-label')) {
                        $span.css('width', width);
                        return;
                    }
                    // ctr 则 calc - w
                    if ($span.hasClass('form-control')) {
                        var span_n = (span.className.match(/span\d/) || [])[0];
                        if (!span_n) return;

                        var p = span2percent[span_n];

                        p && $span.css('width', 'calc(' + p + ' - ' + width + 'px)');
                    }
                });
            });
        });
    }

    function getControl(el) {
        var control = mini.getChildControls(el);

        return control[0];
    }

    /**
     * 调整行布局，自定义比例的不变，其他按解析时的规则调整
     * @param {Element|jQuery} row .form-row 元素
     */
    function autoLayoutRow(row) {
        var $row = $(row);
        if ($row.length && $row.is('.form-row')) {
            var allSpanCls = 'span1 span2 span3 span4 span5 span6';
            var isVertical = $row.closest('.fui-form').hasClass('vertical');
            var $controls = $row.children('.form-control').not('.hidden');

            if ($controls.length === 0) {
                $row.addClass('hidden');
            } else {
                $row.removeClass('hidden');
            }

            var span;
            var autoSpanList = [];
            $controls.each(function(i, el) {
                span = parseInt(el.getAttribute('span'), 10);
                if (!span) {
                    autoSpanList.push(el);
                }
            });
            if (autoSpanList.length) {
                var col = $controls.length * 2;
                span = isVertical ? verticalSpanMap[col + ''] : horizontalSpanMap[col + ''];

                autoSpanList.forEach(function(el) {
                    $(el).removeClass(allSpanCls).addClass('span' + span);
                });
            }
        }
    }

    Util.form = {
        parse: function($form) {
            if (!$form.length) {
                return;
            }
            return parse($form);
        },
        /**
         * 设置表单的label宽度
         *
         * @param {string | number} width 表单label 的宽度 支持数值和xxpx两种形式
         * @param {HTMLElement | jQueryObject | undefined} form 为哪个表单设置label宽度，支持dom，jq对象等； 省略则应用于全部表格。
         * @returns
         */
        setLabelWidth: function(width, form) {
            var $forms = form ? $(form) : $('.fui-form');
            if (/^\d+(px)?$/.test(width)) {
                $forms.attr('label-width', width);
                setLabelWidth($forms);
            } else {
                window.console && console.error('label宽度配置仅支持数值或 xxpx 的形式');
                return;
            }
        },
        // 根据指定div[role="control"]隐藏表单域
        showField: function(id) {
            var $control = $(id),
                vertical = $control.closest('.fui-form.vertical').length,
                $label = $control.prev('label'),
                control = getControl($control[0]),
                $row = $control.closest('.form-row');

            if (vertical) {
                $control.removeClass('hidden');
            } else {
                $control.add($label).removeClass('hidden');
            }
            // 显示时需要将隐藏时的禁用操作还原回来
            if (control && control.originEnabled) {
                control.setEnabled(true);
            }

            autoLayoutRow($row);
        },
        // 根据指定div[role="control"] 表单项目是否比必填。
        setRequired: function(id, required) {
            var $ctr = $(id);
            var vertical = $ctr.closest('.fui-form.vertical').length;
            var $label = vertical ? $ctr.find('>.form-label') : $ctr.prev();
            var ctr = null;
            var $miniControls = $ctr.find('>[class*="mini-"]');
            if ($miniControls.length === 1) {
                ctr = mini.getAndCreate($miniControls[0]);
            }

            if (required) {
                $label.addClass('required');
                ctr && ctr.setRequired && ctr.setRequired(true);
            } else {
                $label.removeClass('required');
                ctr && ctr.setRequired && ctr.setRequired(false);
            }
        },

        // 根据指定div[role="control"]显示表单域
        hideField: function(id) {
            var $control = $(id),
                vertical = $control.closest('.fui-form.vertical').length,
                $label = $control.prev('label'),
                control = getControl($control[0]),
                $row = $control.closest('.form-row');

            if (vertical) {
                $control.addClass('hidden');
            } else {
                $control.add($label).addClass('hidden');
            }

            // mini对于invisible的元素还是会进行验证
            // 为了跳过于invisible的元素验证，需将其禁用
            if (control && control.enabled) {
                control.setEnabled(false);
                control.originEnabled = true;
            }

            autoLayoutRow($row);
        },
        // 设置控件前面的label
        setLabel: function(id, label) {
            var $control = $(id);
            var $label;
            if ($control.find('> .form-label').length) {
                $label = $control.find('> .form-label');
            } else {
                $label = $control.prev('label');
            }

            $control.attr('label', label);
            var showcolon = $control.closest('.fui-form').data('showcolon');
            if (showcolon && label) {
                label += '：';
            }

            $label.text(label);
        }
    };

    parse($forms);
})(this, jQuery);

// 标题区域和tab
(function(win, $) {
    // #region tab实现
    function parse($tabs) {
        var $tabWrap = $tabs || $('.fui-tabs');

        // 若存在 tab 则其中有 iframe fui-content 无须边距
        if ($tabWrap.length) {
            $('.fui-content').css('padding', 0);
        }

        $tabWrap.each(function(i, tabs) {
            var $wrap = $(tabs);
            if ($wrap.data('fui-tab-parse')) return;
            var target = $wrap.attr('target');
            if (!target) {
                return console.error('fui-tabs必须配置容器');
            }
            var iframe = $(target)[0];
            if (!iframe) {
                return console.error('fui-tabs必须配置容器');
            }
            // var iframe = document.createElement('iframe');
            // iframe.setAttribute('width', '100%');
            // iframe.setAttribute('height', '100%');
            // iframe.setAttribute('frameborder', '0');
            // $(iframe).appendTo($iframeContainer);

            $wrap.on('click', '.fui-tab', function() {
                $(this).addClass('active').siblings().removeClass('active');

                var url = this.getAttribute('url');
                if (url) {
                    iframe.src = Util.getRightUrl(url);
                }
                var onactivechanged = getFun($wrap.attr('onactivechanged'));
                if (onactivechanged && typeof onactivechanged.fun === 'function') {
                    onactivechanged.fun.call(onactivechanged.scope, {
                        index: $(this).index(),
                        name: this.textContent || this.innerText,
                        url: url,
                        tab: this
                    });
                }
                onactivechanged = null;
            });

            // 激活默认的
            var activeIndex = parseInt($wrap.attr('activeIndex'), 10) || 0;
            if (activeIndex < 0 || activeIndex > $wrap.find('>.fui-tab').length) {
                activeIndex = 0;
            }
            $wrap.find('>.fui-tab:eq(' + activeIndex + ')').trigger('click');

            $wrap.data('fui-tab-parse', true);
        });
    }

    function getFun(str) {
        if (!str) return null;
        // 如果是 window.alert(a) 这样的 获取参数a
        // 太难处理先不兼容了, 若参数还带点 还需要再取对应值 太过复杂
        // var arg = '';
        // if (/\(.*\);?$/.test(str)) {
        //     arg = str.match(/\((.*)\);?$/)[1];
        //     arg = arg.split(',');
        //     if (arg.length) {
        //         arg.forEach(function (_, i) {
        //             arg[i] = $.trim(arg[i]);
        //         });
        //     }
        //     str = str.replace(/\(.*\);?$/, '');
        // }
        var names = str.split('.');

        var fun = window[names[0]],
            scope = window;
        var i = 1,
            len = names.length;

        while (fun && i < len) {
            scope = fun;
            fun = fun[names[i]];
            i++;
        }
        return { fun: fun, scope: scope };
    }
    var tabInterface = {
        parse: parse,
        activeTab: function(index, $tabs) {
            var $wrap = $tabs || $('.fui-tabs');
            $wrap.find('>.fui-tab:eq(' + index + ')').trigger('click');
        },
        setTabName: function(tabId, name) {
            if (!tabId) return;
            if (tabId[0] != '#') tabId = '#' + tabId;
            var $tab = $(tabId);
            var $num = $tab.find('>.fui-tab-num');
            $tab.text(name);
            if ($num.length) {
                $tab.appendTo($tab);
            }
        },
        setTabUrl: function(tabId, url) {
            if (!tabId) return;
            if (tabId[0] != '#') tabId = '#' + tabId;
            var $tab = $(tabId);
            $tab.attr('url', url);
            if ($tab.hasClass('active')) {
                $tab.removeClass('active').trigger('click');
            }
        },
        setTabNum: function(tabId, num) {
            if (!tabId) return;
            if (tabId[0] != '#') tabId = '#' + tabId;
            var $tab = $(tabId);
            if (num + '' === num) num = parseInt(num, 10) || 0;

            var $num = $tab.find('>.fui-tab-num');
            if (num <= 0) {
                $num.remove();
                return;
            }
            num = num > 99 ? '99+' : num;
            if ($num.length) {
                $num.text(num);
            } else {
                $('<span class="fui-tab-num"></span>').text(num).appendTo($tab);
            }
        }
    };

    Util.tab = tabInterface;

    parse();
    // #endregion

    // #region 标题区域在dialog中自适应处理
    // 规则：除帮助按钮外全部隐藏
    function adjustTitle() {
        if (isInDialog()) {
            var $title = $('.fui-title');
            $title.addClass('hidden');

            // title 放在 fui-top 中，并且 fui-top 中没有其他元素时，需要将 fui-top 一起隐藏
            if ($title.parent().hasClass('fui-top') && !$title.siblings().length) {
                Util.layoutInstance.toggleTop(false);
            }
            if ($('.fui-notice').length && !$('.fui-toolbar a[role="helper"], .fui-toolbar-bottom a[role="helper"]').length) {
                var $toolbar = $('.fui-toolbar');
                var $toolbarBottom = $('.fui-toolbar-bottom');
                if ($toolbar.length && !$toolbar.find('a[role="helper"]').length) {
                    $('<a role="helper">' + epoint_local.helper_text + '</a>').appendTo($toolbar);
                } else if ($toolbarBottom.length && !$toolbarBottom.find('a[role="helper"]').length) {
                    $('<a role="helper">' + epoint_local.helper_text + '</a>').appendTo($toolbarBottom);
                }
                $toolbar = $toolbarBottom = null;
            }
        }
    }

    function isInDialog() {
        if (window.top === window) {
            return false;
        } else if (/_winid=/.test(location.search)) {
            return true;
        }
        return false;
    }
    adjustTitle();

    function getPageTitle() {
        var $title = $('.fui-title .fui-title-text');
        if (!$title.length) return;
        if (!$title.attr('bind')) {
            $title.attr('bind', 'getPageTitleByUrl');
        }
        if (!$title.hasClass('mini-outputtext')) {
            $title.addClass('mini-outputtext');
        }
        if ($title.text()) {
            $title.attr('value', $title.text());
        }
        // var url = location.pathname.replace(window._rootPath, '');
        // if (url[0] === '/') {
        //     url = url.substr(1);
        // }
        // Util.ajax({
        //     url: epoint.dealRestfulUrl('module/modulename'),
        //     data: {
        //         moduleurl: url
        //     }
        // }).done(function (data) {
        //     if (data && data.modulename) {
        //         $title.text(data.modulename).attr('title', data.modulename);
        //     }
        // });
    }
    getPageTitle();
    Util.Title = {
        handles: {
            share: function() {},
            help: function() {},
            refresh: function() {
                location.reload();
            }
        }
    };

    $('.fui-title').on('mousedown', '.mini-button', function() {
        var btn = mini.get(this);
        if (btn && !btn.getEnabled()) return;
        var role = $(this).data('role');
        if (!role) return;
        var fn = Util.Title.handles[role];
        if (typeof fn === 'function') {
            fn.call(this);
        }
    });
    // #endregion
})(this, this.jQuery);
/*!
 * contentpage结构content区域计算
 */
(function (win, $) {
    var $title = $('.fui-title'),
        $toolbar = $('.fui-toolbar'),
        $condition = $('.fui-condition'),
        $notice = $('.fui-notice'),
        $content = $('.fui-content'),
        $toolbarbottom = $('.fui-toolbar-bottom');

    win.adjustContentHeight = Util.noop;

    if (!$content.length) return;

    var getHeight = function ($el) {
        var h = 0;

        if ($el.length && !$el.hasClass('hidden') && !~['fixed', 'absolute'].indexOf($el.css('position'))) {
            h = $el.outerHeight(true);
        }
        return h;
    };

    var _adjustHeight = function () {
        var win_h = $content.parent().innerHeight() || $(win).height();
        var inner_h = 0;
        if ($content.parent()[0].tagName !== 'BODY') {
            $.each($content.siblings(), function (i, el) {
                inner_h += getHeight($(el));
            });
        } else {
            inner_h += getHeight($title);
            inner_h += getHeight($toolbar);
            inner_h += getHeight($condition);
            inner_h += getHeight($notice);
            inner_h += getHeight($toolbarbottom);
        }

        $content.css('height', win_h - inner_h);

        // content区域高度调整后，调整表格布局
        Util._layoutDatagridInContent();
    };

    var timer = 0;

    var adjustHeight = function () {
        timer && clearTimeout(timer);

        timer = setTimeout(_adjustHeight, 50);
    };

    $(win).on('resize.contentPage', function () {
        adjustHeight();
        [].slice.call(document.getElementsByTagName('iframe')).forEach(function (ifr) {
            try {
                ifr.contentWindow.$('body').trigger('resize');
            } catch (e) {}
        });
    });

    win.adjustContentHeight = _adjustHeight;

    $(_adjustHeight);

    // 调整toolbar里的上传控件，没有个性化指定 filelist 的自动加上defaultUI="false"
    $toolbar.add($toolbarbottom).find('.mini-webuploader').each(function(i, item){
        var $item = $(item);
        if(!$item.attr('filelist') && $item.attr('showdefaultui') !== false) {
            $item.attr('showdefaultui', false);
            console.warn('toolbar 中的上传控件必须自己实现 UI，或者将 fileList 指定到页面其他 dom 容器中！');
        }
    });

}(this, jQuery));
/*!
 * contentpage条件区域condition交互与视图解析
 */
(function(win, $) {
    var $condition = $('.fui-condition'),
        conditionShowNum = $condition.attr('data-shownum') || 1; //默认fui-condition查询条件中表单区域展示行数
    conditionShowNum = (conditionShowNum < 1) ? 1 : conditionShowNum;
    if (!$condition.length) return;

    var btnHtml = [];
    // 搜索按钮
    // win.epoint_local.search_text 用来支撑国际化，暂时配置在miniui的local文件里
    btnHtml.push('<span class="cond-srh-btn-text l">' + win.epoint_local.search_text + '</span>');
    // 展开更多条件
    btnHtml.push('<i class="cond-srh-btn-toggle l" title="' + win.epoint_local.search_title + '"></i>');

    // var autoHeightFix = function () {
    //     var fixed = $condition.data('fixed');

    //     if (!fixed) {
    //         $condition.css({
    //             height: 'auto',
    //             overflow: 'auto'
    //         }).data('fixed', true);
    //     }
    // };

    var $no1stRows = null;

    var init = function() {
        var $form = $condition.find('.fui-form');

        // 没有查询条件，不予处理
        if (!$form.length) return;

        var $btn = $condition.find('[role="searcher"]'),
            // 搜索回调
            cbName = $btn.attr('callback');

        var $rows = $form.find('.form-row'),
            // 搜索条件行数
            line = $rows.length,
            isMultiLine = (line > conditionShowNum);

        var toggleCondition = function(opened) {
            // 为解决第一行中放多行checkboxlist控件下面行被遮住问题，初始既是自适应，不用再调整
            // 恢复condition的高度自适应，以便显示更多条件
            // autoHeightFix();

            $no1stRows.toggleClass('hidden', opened);
            $btn.length && $btn.toggleClass('opened', !opened);

            window.adjustContentHeight();
        };

        // 初始化搜索按钮
        if ($btn.length) {
            $btn.addClass('cond-srh-btn clearfix')
                .removeAttr('role');

            $(btnHtml[0]).appendTo($btn);

            // 缓存回调 不必每次点击都向上查找
            var cbCaChe;

            $btn.on('click', '.cond-srh-btn-text', function(event) {
                if (!cbCaChe) {
                    cbCaChe = (function() {
                        var fun = '',
                            scope;
                        if (cbName) {
                            var names = cbName.split('.');
                            fun = win[names[0]];
                            scope = win;
                            var i = 1,
                                len = names.length;

                            while (fun && i < len) {
                                scope = fun;
                                fun = fun[names[i]];
                                i++;
                            }

                        }
                        return {
                            fun: fun,
                            scope: scope
                        };
                    })();
                }
                // 执行回调
                var fun = cbCaChe.fun,
                    scope = cbCaChe.scope;
                if (fun && typeof fun === 'function') {
                    fun.call(scope, event);
                }
            });

            if (isMultiLine) {
                // 多行条件，搜索按钮增加下拉
                $btn.length && $(btnHtml[1]).appendTo($btn);
                $btn.addClass('multi');

                $btn.on('click', '.cond-srh-btn-toggle', function(event) {
                    event.preventDefault();

                    var opened = $btn.hasClass('opened');

                    toggleCondition(opened);
                });
            }
            // 回车搜索
            var handleEnterSearch;
            if (Util.browsers.isIE) {
                // 解决IE下中文输入法先触发了搜索的问题
                handleEnterSearch = function() {
                    var activeEl = document.activeElement;
                    activeEl && activeEl.blur();
                    $btn.find('.cond-srh-btn-text').trigger('click');
                    activeEl && activeEl.focus();
                };
            } else {
                handleEnterSearch = function() {
                    $btn.find('.cond-srh-btn-text').trigger('click');
                };
            }
            $condition.on('keyup', function(e) {
                var keyCode = e.which;
                if (keyCode === 13) handleEnterSearch();
            });
        }

        // 初始化条件行的显示、隐藏
        if (isMultiLine) {
            var isDefaultOpen = $condition.attr('opened') === 'true';
            // 非第一行的条件
            $no1stRows = $rows.filter(function(i) {
                if (i > (conditionShowNum - 1)) {
                    !isDefaultOpen && $rows.eq(i).addClass('hidden');
                    return true;
                }
            });
            if (isDefaultOpen) {
                $condition.removeAttr('opened');
                $(function() {
                    toggleCondition(false);
                });
            }
        }
    };


    Util.condition = {
        // 隐藏下拉按钮
        hideToggleBtn: function() {
            var $toggleBtn = $condition.find('.cond-srh-btn-toggle');

            $toggleBtn.addClass('hidden');
        },
        // 显示下拉按钮
        showToggleBtn: function() {
            var $toggleBtn = $condition.find('.cond-srh-btn-toggle');

            $toggleBtn.removeClass('hidden');
        }
    };

    // 为了给由epoint.form生成的动态表单在生成完fui-form内容之后重新初始化fui-condition区域
    // 主要是为了绑定按钮事件
    win.initCondition = init;
    init();

}(this, jQuery));
// contentpage信息提示notice区域交互
(function (win, $) {
    var $notice = $('.fui-notice');

    if (!$notice.length) return;

    var $toolbar = $('.fui-toolbar:not(.bottom)'),
        $toolbarBottom = $('.fui-toolbar-bottom'),
        $helper = $toolbar.add($toolbarBottom).find('[role="helper"]');

    if (!$helper.length) {
        $helper = $('.fui-title [data-role="help"]');
        if ($helper.length) {
            mini.parse($helper[0]);
            $helper = $('.fui-title [data-role="help"]');
        }
    }

    if (!$helper.length) {
        // eslint-disable-next-line
        console.error('当前页面存在 【.fui-notice】 区域，但工具栏中不存在【[role="helper"]】按钮， 帮助提示功能无法正常使用');
        return;
    }
    
    // 需要排除掉 在 fui-title 中的情况
    if (!$helper.hasClass('mini-button')) {
        $helper.addClass('fui-toolbar-helper').attr('title', $helper.text() ).empty();
        if ($helper.parent('.fui-toolbar').length) {
            // 如果是在顶部工具栏中 则在最后即可
            $helper.addClass('r');
            var $lr = $toolbar.find('> .r').eq(0);
            $lr.length ? $helper.insertBefore($lr) : $helper.appendTo($toolbar);
        } else {
            // 否则需要 fixed 到顶部
            $helper.addClass('fixed').appendTo('body');
        }
    }
    // right
    // var $floatRight = $toolbar.find('.r');
    // if ($floatRight.length) {
    //     $floatRight.eq(0).before($helper);
    // } else {
    //     $helper.appendTo($toolbar);
    // }

    var showAsTooltip = $helper[0].getAttribute('showtype') || $helper[0].getAttribute('data-showtype') === 'tooltip' ? true : false;

    // 创建关闭按钮
    var $close = $('<span class="notice-close-btn"></span>').appendTo($notice);

    // tooltip 格式
    if (showAsTooltip) {
        var contentHtml = $notice[0].innerHTML,
            tip = new mini.ToolTip();

        tip.set({
            target: document,
            // scope: $toolbar[0],
            trigger: 'click',
            selector: '.fui-toolbar-helper, .mini-button[data-role="help"]',
            placement: 'bottom',
            autoHide: false,
            theme: 'light',
            defaultTheme: 'light',
            onbeforeopen: function (e) {
                $helper.addClass('active');
                if ($helper.hasClass('fixed')) {
                    $(tip.el).css('margin-right', 5);
                }
                e.content = contentHtml;
                e.cancel = false;
            }
        });
        tip.addCls('fui-toolbar-tooltip');

        $(window).on('resize', function () {
            $helper.removeClass('active');
            tip.close();
        });

        // 点击空白区域时自动隐藏
        $(window).on('mousedown', function(e){
            if(!$(e.target).closest('.fui-toolbar-tooltip,.mini-button[data-role="help"]').length) {
                $helper.removeClass('active');
                tip.close();
            }
        });
        // 点击按钮关闭
        $('.fui-toolbar-tooltip').on('click', '.notice-close-btn', function () {
            $helper.removeClass('active');
            tip.close();
        });
    } else {
        // 默认格式
        var wrapHtml = '<div class="fui-notice-inner"></div>';

        $notice.wrapInner(wrapHtml);
        $helper.toggleClass('active hidden', !$notice.hasClass('hidden'));

        $helper.on('click', function () {
            $notice.toggleClass('hidden', !$notice.hasClass('hidden'));
            $helper.toggleClass('active', !$notice.hasClass('hidden'));

            if ($helper.hasClass('fixed') && $helper.hasClass('active')) {
                $helper.addClass('hidden');
            } else {
                $helper.removeClass('hidden');
            }
            if ($helper.hasClass('mini-button') && !$notice.hasClass('hidden')) {
                $notice.css({
                    'position': 'absolute',
                    left: '0',
                    right: '0',
                    top: $('.fui-title')[0].getBoundingClientRect().bottom
                });
                
            }

            window.adjustContentHeight();
        });

        $close.on('click', function () {
            $helper.trigger('click');
        });

    }

}(this, jQuery));
/*!
 * 高级搜索布局
 */
(function (win, $) {
    var $title = $('.fui-title'),
        $condition = $('.fui-search'),
        $toolbar = $('.fui-toolbar:eq(0)'),
        $notice = $('.fui-notice'),
        $content = $('.fui-content'),
        $toolbarbottom = $('.fui-toolbar-bottom'),
        type = $condition.data('type');

    if (!$condition.length) return;
    if (!$toolbar.length) return;

    // 是否默认为展开
    var opened = $condition.attr('opened') === 'true' ? true : false;

    // 创建trigger 和遮罩
    var $trigger,
        $cover,
        // 关联控件的id
        primaryId,
        // 工具栏上的输入框
        toolbarSearch;

    // opeded无需trigger 无需遮罩
    if (!opened) {
        $trigger = $('<i></i>', {
            'data-status': 'close'
        }).addClass('fui-search-trigger r');
        if (window.epoint_local && epoint_local.search_trigger) {
            $trigger.text(epoint_local.search_trigger);
        }
        // OA 个性化了高级搜索触发按钮样式
        if (type) {
            $trigger.addClass(type);
        }
        // right
        var $floatRight = $toolbar.find('.r');
        if ($floatRight.length) {
            if ($floatRight.eq(0).hasClass('fui-toolbar-helper')) {
                $floatRight.eq(0).after($trigger);
            } else {
                $floatRight.eq(0).before($trigger);
            }
        } else {
            $trigger.appendTo($toolbar);
        }

        $cover = $('<div class="fui-search-cover hidden"></div>');
        $content.css('position', 'relative').append($cover);

        // 工具栏插入一个输入框
        var insertInput = function () {
            primaryId = $condition[0].getAttribute('primaryControl');
            if (!primaryId) return;

            // 可能是个性化控件，主动解析一次
            mini.parse(primaryId);
            var connectedControl = mini.get(primaryId);

            // 没有时不响应
            if (!connectedControl) return;

            // 类型不是textbox时不响应|20220114 新增支持 combobox 控件
            var isTextBox = mini.isInstanceOf(connectedControl, mini.TextBox);
            var isComboBox = mini.isInstanceOf(connectedControl, mini.ComboBox);
            if (!isTextBox && !isComboBox) return;

            var width = $condition[0].getAttribute('primaryWidth');

            if (isTextBox) {
                $trigger.after('<input type="text" id="toolbar-search-' + primaryId + '" emptyText="' + (window.epoint_local.empty_beginning_text + $(connectedControl.el).parent().prev().text().slice(0, -1)) + '" class="mini-buttonedit fui-primary-search r" style="' + (width ? 'width:' + width + 'px' : '') + '">');
            } else if (isComboBox) {
                $trigger.after('<input id="toolbar-search-' + primaryId + '" emptyText="' + (window.epoint_local.empty_beginning_text + $(connectedControl.el).parent().prev().text().slice(0, -1)) + (connectedControl.bind ? '" bind="' + connectedControl.bind : '') + (connectedControl.action ? '" action="' + connectedControl.action : '') + '" class="mini-combobox fui-primary-search r" style="' + (width ? 'width:' + width + 'px' : '') + '">');
            }

            mini.parse($toolbar[0]);

            toolbarSearch = mini.get('toolbar-search-' + primaryId);

            // 给两个控件绑定事件
            toolbarSearch.on('valuechanged', function () {
                var value = this.value;
                connectedControl.setValue(value);
                if (isComboBox) {
                    connectedControl.setText(this.text);
                    $searchBtn.trigger('click');
                } else if (isTextBox) {
                    connectedControl.setText(value);
                }
            });
            connectedControl.on('valuechanged', function (e) {
                var value = e.value;
                toolbarSearch.setValue(value);

                if (isComboBox) {
                    toolbarSearch.setText(e.selected.text);
                } else if (isTextBox) {
                    toolbarSearch.setText(value);
                }
            });

            // 回车搜索
            var handleEnterSearch;
            if (Util.browsers.isIE) {
                handleEnterSearch = function () {
                    var activeEl = document.activeElement;
                    activeEl && activeEl.blur();
                    $searchBtn.trigger('click');
                    activeEl && activeEl.focus();
                };
            } else {
                handleEnterSearch = function () {
                    $searchBtn.trigger('click');
                };
            }
            toolbarSearch.on('enter', handleEnterSearch);

            // 点击搜索
            if (isTextBox) {
                toolbarSearch.on('buttonclick', function () {
                    $searchBtn.trigger('click');
                });
            }
        };

        // 与 toolbar 区域的普通输入框联动 （OA需求）
        var linkWithToolbar = function () {
            var toolbar_form = $('.fui-toolbar-search', $toolbar)[0],
                controls,
                control;
            if (toolbar_form) {
                // 可能存在个性化控件，主动解析一次
                mini.parse(toolbar_form);
                controls = mini.getChildControls(toolbar_form);

                for (var i = 0, l = controls.length; i < l; i++) {
                    control = controls[i];
                    if (control.relatedSearchId && control.relatedSearchId !== primaryId) {
                        bindRelationship(control);
                    }
                }
            }
        };

        var bindRelationship = function (control) {
            var relatedControl = mini.get(control.relatedSearchId);

            if (relatedControl) {
                // 给两个控件绑定事件
                control.on('valuechanged', function (e) {
                    var value = e.value;
                    relatedControl.setValue(value);
                    relatedControl._updateOldValue && relatedControl._updateOldValue();
                });
                relatedControl.on('valuechanged', function (e) {
                    var value = e.value;
                    control.setValue(value);
                    control._updateOldValue && control._updateOldValue();
                });
            }
        };

        $(function () {
            insertInput();
            linkWithToolbar();
        });
    }

    // 按钮处理
    var $searchBtn = $condition.find('[role="searcher"]'),
        $resetBtn = $condition.find('[role="reset"]'),
        $closeBtn = $condition.find('[role="close"]');

    var $footer = $('<div class="fui-search-footer"></div>');

    // 按钮文本
    var btnHtml = [];
    btnHtml.push('<span class="fui-search-srh-btn ">' + win.epoint_local.search_text + '</span>');
    btnHtml.push('<span class="fui-search-reset-btn ">' + win.epoint_local.reset_text + '</span>');
    btnHtml.push('<span class="fui-search-close-btn ">' + win.epoint_local.close_text + '</span>');

    $searchBtn.length && $(btnHtml[0]).appendTo($searchBtn);
    $resetBtn.length && $(btnHtml[1]).appendTo($resetBtn);
    !opened && $closeBtn.length && $(btnHtml[2]).appendTo($closeBtn);

    btnHtml = null;

    // 按钮插入到页面
    $footer.append($searchBtn).append($resetBtn).append($closeBtn).appendTo($condition);

    // 搜索后的标签列表
    var $searchCondition = $('<div class="fui-search-result hidden clearfix"><span class="l fui-search-desc">' + window.epoint_local.selected_text + '：</span><div class="l fui-search-list-wrap"><ul class="fui-search-list  clearfix"></ul></div><div class="fui-search-result-btns r"><span class="fui-search-l l invisible"></span><span class="fui-search-r l invisible"></span><span class="fui-search-removeall l" title="' + epoint_local.remove_all_text + '"></span></div></div>').appendTo($condition),
        // 标签列表
        $tagListWrap = $searchCondition.find('.fui-search-list-wrap'),
        $tagList = $tagListWrap.find('.fui-search-list'),
        // 左右按钮
        $scrollLeft = $searchCondition.find('.fui-search-l'),
        $scrollRight = $scrollLeft.next();

    // 按钮点击切换方法
    var cilckSwitch = {
        searcher: function () {
            switchStatus('open');
        },
        close: function () {
            switchStatus('open');
        },
        open: function () {
            if ($tagList.children().length) {
                switchStatus('searcher');
            } else {
                switchStatus('close');
            }
        }
    };
    // 切换按钮点击
    !opened &&
        $trigger.on('click', function (e) {
            // e.stopPropagation();
            var status = $trigger.data('status');

            cilckSwitch[status]();
        });

    // 缓存三个按钮的回调函数名称
    // 主要是考虑回调中直接写epoint.refresh这样的方法，需要一层一层将其上下文找出，此处缓存可避免每次点击都遍历取出
    // 在第一次点击的时候再去取
    var cbCaChe,
        getCbCaChe = function () {
            var cbNames = {
                    searcher: $searchBtn.length ? $searchBtn.attr('callback') : '',
                    reset: $resetBtn.length ? $resetBtn.attr('callback') : '',
                    close: $closeBtn.length ? $closeBtn.attr('callback') : ''
                },
                cache = {};
            for (var key in cbNames) {
                if (!Object.prototype.hasOwnProperty.call(cbNames, key)) {
                    continue;
                }
                var names = cbNames[key].split('.');

                var fun = win[names[0]],
                    scope = win;
                var i = 1,
                    len = names.length;

                while (fun && i < len) {
                    scope = fun;
                    fun = fun[names[i]];
                    i++;
                }

                cache[key] = {
                    fun: fun,
                    scope: scope
                };
            }
            return cache;
        };

    // 按钮事件
    $condition.on('click', 'a', function (e) {
        // e.stopPropagation();
        var $a = $(this),
            role = $a.attr('role');
        // 取回调并缓存
        if (!cbCaChe) {
            cbCaChe = getCbCaChe();
        }

        // 触发指定的回调
        doCallback(role, e);

        // 按钮应实现的功能
        if (role === 'reset') {
            // 重置值 清空标签 隐藏条目区域
            clearSearch(e);
        } else {
            switchStatus(role);
        }
    });

    // 获取所有控件
    var _$condForm = $condition.find('.fui-form');
    var _getControls = function () {
        if (!_$condForm.length) return [];
        var controls = mini.getChildControls(_$condForm[0]);
        if (controls.length > 1) {
            var prevControl = controls[0];
            for (var i = 1, l = controls.length; i < l; i++) {
                // 当前控件是上一个控件的父控件，说明上一个控件是当前控件的内部控件，去除上一个控件
                if (mini.isAncestor(controls[i].el, prevControl.el)) {
                    controls.splice(i - 1, 1);

                    i--;
                    l--;
                } else if (mini.isAncestor(prevControl.el, controls[i].el)) {
                    // 上一个控件是当前控件的父控件，说明当前控件是上一个控件的内部控件，去除当前控件
                    controls.splice(i, 1);

                    i--;
                    l--;
                }
                prevControl = controls[i];
            }
        }

        return controls;
    };

    // 重置控件值
    var _resetValue = function () {
        var arr = _getControls(),
            valueChangedArr = [],
            i = 0,
            l = arr.length;
        for (; i < l; ++i) {
            // 同步修改 隐藏域的值不能被重置
            // cause：项目管理9.3功能测试bug 后台管理-组织架构-用户管理：先选择部门，然后通过检索弹出界面的字段进行检索，检索后页面中显示部门guid检索条件。
            // modify by chendongshun at 2017.05.22
            if (arr[i].type === 'hidden') continue;

            // checkbox的setText方法是用来设置label的，不能清空
            arr[i].setText && arr[i]._clearText !== false && arr[i].setText('');
            arr[i].setValue(arr[i].defaultValue || '');

            arr[i].doValueChanged &&
                valueChangedArr.push({
                    doValueChanged: arr[i].doValueChanged,
                    control: arr[i]
                });

            // // 需要同步清除toolbar上的
            // if (arr[i].id === primaryId) {
            //     if (toolbarSearch) {
            //         toolbarSearch.setValue('');
            //         toolbarSearch.setText('');
            //     }
            // }
        }

        for (i = 0, l = valueChangedArr.length; i < l; i++) {
            valueChangedArr[i].doValueChanged.call(valueChangedArr[i].control);
        }
    };

    // 清空搜索
    var clearSearch = function (e) {
        _resetValue();
        $tagList.empty();
        $searchCondition.addClass('hidden');

        // 重新搜索
        var cb = cbCaChe && cbCaChe.searcher;
        if (cb && typeof cb.fun === 'function') {
            setTimeout(function(){
                cb.fun.call(cb.scope, e);
            },50);
        }
        _isSearch = false;
    };
    var _isSearch = false;
    // 触发指定的回调
    var doCallback = function (role, e) {
        var cb = cbCaChe[role];
        if (cb && typeof cb.fun === 'function') {
            cb.fun.call(cb.scope, e);
        }
    };
    var TAG_TPL = '<li class="fui-search-item l"><span class="fui-search-item-label l">{{label}}</span><span class="fui-search-item-text l" title="{{text}}">{{text}}</span><span class="fui-search-item-remove l" title="' + epoint_local.remove_text + '" {{#value}} data-value="{{value}}" {{/value}} data-id="{{id}}"></span></li>';
    // 渲染标签
    var _renderTag = function (obj) {
        return Mustache.render(TAG_TPL, obj);
    };

    // 渲染标签
    var renderTags = function () {
        // 记录是否有值，无值则不需要渲染标签
        var hasValue = false;
        var controls = _getControls();
        var html = [];
        for (var i = 0, l = controls.length; i < l; i++) {
            var control = controls[i];
            var label;

            // 隐藏域不用渲染出来
            // cause：项目管理9.3功能测试bug 后台管理-组织架构-用户管理：先选择部门，然后通过检索弹出界面的字段进行检索，检索后页面中显示部门guid检索条件。
            // modify by chendongshun at 2017.05.22
            if (control.type === 'hidden') continue;

            var text = control.getText ? control.getText() : control.getValue();

            // 单个的checkbox text一直有值，不能直接渲染 需要进一步判断
            text = control._clearText !== false ? text : control.checked ? text : '';

            if (!text) {
                continue;
            } else {
                hasValue = true;
            }

            label = $(control.el).parent().attr('label') || '';
            if (label) {
                label += '：';
            }

            // 新增关于checkboxlist显示为多值的处理
            if (control.type === 'checkboxlist') {
                var values = control.getValue().split(',');

                text = text.split(',');
                for (var j = 0, len = values.length; j < len; ++j) {
                    html.push(
                        _renderTag({
                            label: label,
                            value: values[j],
                            text: text[j],
                            id: control.id
                        })
                    );
                }
            } else {
                html.push(
                    _renderTag({
                        label: label,
                        text: text,
                        id: control.id
                    })
                );
            }
        }
        $tagList.empty();
        hasValue && $(html.join('')).appendTo($tagList);

        return (_isSearch = hasValue);
    };

    // 用于checkboxlist的value中移除一个
    var getNewVal = function (oldVal, currVal) {
        // 如果为中间的 去掉多余的"，"
        // 如果为第一个还要去掉最前的","
        // 如果为最后的 替换掉最后的"，"
        return (',' + oldVal + ',').replace(',' + currVal + ',', ',').replace(/^,|,$/g, '');
    };

    // 搜索标签删除按钮点击
    $searchCondition
        .on('click', '.fui-search-item-remove', function (e) {
            var $this = $(this),
                id = $this.data('id');
            // 清空控件值
            if (id) {
                var control = mini.get(id);
                if (!control) return;

                if (control.type === 'checkboxlist') {
                    // checkboxlist 值需要单独处理
                    var oldVal = control.getValue(),
                        currVal = $this.data('value'),
                        // 移除当前值
                        newVal = getNewVal(oldVal, currVal);
                    // 赋值为新值
                    control.setValue(newVal);
                } else {
                    control.setValue('');
                    // checkbox的setText方法是用来设置label的，不能清空
                    control.setText && control._clearText !== false && control.setText('');
                }
                control.doValueChanged && control.doValueChanged();
            }

            // // id为绑定的id 则要清除工具栏上的
            // if (id === primaryId) {
            //     if (toolbarSearch) {
            //         toolbarSearch.setValue('');
            //         toolbarSearch.setText('');
            //     }
            // }
            // 移除元素
            $this.parent('.fui-search-item').remove();

            _adjustWidth();

            // 检查长度
            $tagList.find('.fui-search-item').length === 0 && ((_isSearch = false), switchStatus('close'));

            // 触发搜索的回调
            doCallback('searcher', e);
        })
        // 移除全部
        .on('click', '.fui-search-removeall', function (e) {
            clearSearch(e);
            switchStatus('close');
        })
        // 激活当前
        .on('click', '.fui-search-item', function (e) {
            e.stopPropagation();
            $(this).addClass('active').siblings().removeClass('active');
        });
    // 其他地方点击
    $('body')
        .on('click', function () {
            $tagList.children().removeClass('active');
        })
        .on('keyup', function (e) {
            // esc 关闭
            var code = e.which;
            // console.log(code);
            code === 27 && switchStatus('close');
        });

    function doLayoutControl() {
        mini.getChildControls($condition[0]).forEach(function (ctr) {
            ctr.doLayout();
        });
    }

    /**
     * 切换表单和标签状态
     * @param {string} state searcher open close
     */
    var switchStatus = function (state) {
        if (state === 'searcher') {
            // 如果是默认展开 不需要显示标签
            if (opened) return;
            $condition.css({
                top: ''
            });
            // 搜索则要显示标签
            var hasValue = renderTags();
            if (hasValue) {
                $toolbar.removeClass('searchopen');
                $searchCondition.removeClass('hidden');
                $condition.removeClass('hidden').removeClass('open').addClass('searcher');
                doLayoutControl();
                $trigger.data('status', 'searcher').removeClass('close');
                $cover.addClass('hidden');
            } else {
                $toolbar.removeClass('searchopen');
                $condition.addClass('hidden').removeClass('open').removeClass('searcher');
                $trigger.data('status', 'close').removeClass('close');
                $searchCondition.addClass('hidden');
                $cover.addClass('hidden');
            }
            _adjustWidth();
        } else if (state === 'close') {
            if (_isSearch) {
                $condition.removeClass('hidden').removeClass('open').addClass('searcher');
                $searchCondition.removeClass('hidden');
            } else {
                $condition.addClass('hidden').removeClass('open').removeClass('searcher');
                $searchCondition.addClass('hidden');
            }
            $condition.css({
                top: ''
            });
            $toolbar.removeClass('searchopen');
            $trigger.data('status', 'close').removeClass('close');
            $cover.addClass('hidden');
        } else if (state === 'open') {
            $toolbar.addClass('searchopen');
            $condition.removeClass('hidden').removeClass('searcher').addClass('open');
            doLayoutControl();
            $condition.css({
                // top: $toolbar[0].getBoundingClientRect().bottom
                top: $toolbar.position().top + $toolbar.outerHeight()
            });
            $trigger.data('status', 'open').addClass('close');
            $searchCondition.addClass('hidden');
            $cover.removeClass('hidden');

            // 初始化时搜索区域的控件是隐藏的，导致控件的一些布局计算不对，在显示的时候需要再重新处理一遍布局
            var controls = _getControls();
            for (var i = 0, l = controls.length; i < l; i++) {
                controls[i]._doInputLayout && controls[i]._doInputLayout();
            }
        }

        _adjustHeight();
    };

    // 只有非默认打开时 计算和绑定事件
    if (!opened) {
        // 左右侧保留宽度
        var HOLD_WIDTH,
            // 一次滚动距离
            STEP_WIDTH = 100,
            cond_width,
            view_width,
            list_width = 0,
            scroll_width = 0;

        var _calculateWidth = function () {
            if (!$searchCondition.is(':visible')) return;
            if (!HOLD_WIDTH) {
                HOLD_WIDTH = $searchCondition.find('.fui-search-desc').outerWidth() + $searchCondition.find('.fui-search-result-btns').outerWidth();
            }

            cond_width = $searchCondition.width();

            view_width = cond_width - HOLD_WIDTH - 10;

            $tagListWrap.css('width', view_width);

            list_width = 0;
            $tagList.find('.fui-search-item').each(function (i, item) {
                list_width += $(item).outerWidth() + 10;
            });

            scroll_width = (list_width - view_width) >> 0;
        };

        var _adjustWidth = function () {
            _calculateWidth();
            if (scroll_width > 0) {
                $scrollLeft.removeClass('invisible');
                $scrollRight.removeClass('invisible');
                $tagList.animate({
                    marginLeft: -scroll_width
                });
            } else {
                $scrollLeft.addClass('invisible');
                $scrollRight.addClass('invisible');
                $tagList.animate({
                    marginLeft: 0
                });
            }
        };
        $scrollRight.on('click', function () {
            var ml = -parseInt($tagList.css('margin-left'), 10),
                // 最多滚到可滚动距离
                range = Math.min(STEP_WIDTH, scroll_width - ml);
            if ($tagList.is(':animated') || ml >= scroll_width) {
                return;
            }
            $tagList.animate({
                marginLeft: '-=' + range + 'px'
            });
        });
        $scrollLeft.on('click', function () {
            var ml = -parseInt($tagList.css('margin-left'), 10),
                //  最多滚到0
                range = Math.min(STEP_WIDTH, ml);
            if ($tagList.is(':animated') || ml < 0) {
                return;
            }
            $tagList.animate({
                marginLeft: '+=' + range + 'px'
            });
        });
        $(win).on('resize', function () {
            _adjustWidth();
        });
    }
    //
    $(win)
        .off('resize.contentPage')
        .on('resize', function () {
            _adjustHeight();
            [].slice.call(document.getElementsByTagName('iframe')).forEach(function (ifr) {
                try {
                    ifr.contentWindow.$('body').trigger('resize');
                } catch (e) {}
            });
        });

    // 计算高度 不能直接使用 content区域计算中的方法
    var getHeight = function ($el) {
        var h = 0;

        if ($el.length && !$el.hasClass('hidden') && !~['fixed', 'absolute'].indexOf($el.css('position'))) {
            h = $el.outerHeight(true);
        }
        return h;
    };

    // 切换状态后调整content高度
    var _adjustHeight = function () {
        var win_h = $content.parent().innerHeight() || $(win).height();
        var inner_h = 0;
        if ($content.parent()[0].tagName !== 'BODY') {
            $.each($content.siblings(), function (i, el) {
                inner_h += getHeight($(el));
            });
        } else {
            (inner_h += getHeight($title)), (inner_h += getHeight($toolbar)), (inner_h += getHeight($condition)), (inner_h += getHeight($notice)), (inner_h += getHeight($toolbarbottom));
        }

        $content.css('height', win_h - inner_h);

        // content区域高度调整后，调整表格布局
        Util._layoutDatagridInContent();
    };
    // 重写调整高度的方法
    win.adjustContentHeight = _adjustHeight;

    // 默认打开时
    if (opened) {
        $condition.css({
            position: 'relative',
            top: '0',
            'box-shadow': 'none'
        });
        $closeBtn.addClass('hidden');
        $condition.addClass('open');
        $(function () {
            setTimeout(_adjustHeight, 60);
        });
    } else {
        $condition.addClass('hidden');
    }
    Util.advanceSearch = {
        _isHide: false,
        hide: function () {
            if (this._isHide) {
                return;
            }
            if (!opened) {
                $trigger.addClass('hidden');
                toolbarSearch.hide();

                $cover.addClass('hidden');
            }
            $condition.addClass('hidden');
            _isSearch && clearSearch();
            _adjustHeight();
            this._isHide = true;
        },
        show: function () {
            if (!this._isHide) {
                return;
            }
            if (!opened) {
                $trigger.removeClass('hidden');
                toolbarSearch.show();
            } else {
                $condition.removeClass('hidden');
                _adjustHeight();
            }
            this._isHide = false;
        }
    };
})(window, jQuery);

/**
 * 手风琴布局实现
 */
(function (win, $) {
    var $fuiContent = $('.fui-content');
    // 是否阻止滚动事件
    var ignoreScrollEvents = false;

    function Accordion() {
        this.parse();
    }
    Accordion.parse = function () {
        Util.accordion = new Accordion();
    };

    $.extend(Accordion.prototype, {
        parse: function () {
            var $wrap = $('.fui-accordions');
            if (!$wrap.length) {
                return;
            }
            this.$accsWrap = $wrap;
            this._accs = this.$accsWrap.find('[role="accordion"]');
            this._parse();
            this._initEvent();
        },
        _parse: function () {
            this.showNav = $fuiContent.length > 0 && this.$accsWrap.attr('showNav');
            if (this.showNav === undefined) {
                this.showNav = Util.getFrameSysParam('showAccordionsNav');
            } else {
                this.showNav = this.showNav === 'true';
            }

            var $accs = this.$accsWrap.find('[role="accordion"]');

            $.each($accs, function (i, acc) {
                var $acc = $(acc),
                    $hd = $acc.find('[role="head"]'),
                    $bd = $acc.find('[role="body"]');
                // 已经处理过了则跳过
                if ($acc.data('accordion')) {
                    return;
                }
                $acc.data('accordion', true);

                var opened = $acc.attr('opened') !== 'false',
                    title = $hd.attr('title');

                $acc.addClass('fui-accordion');
                $hd.addClass('fui-acc-hd');
                $bd.addClass('fui-acc-bd');

                opened ? $acc.addClass('opened') : $acc.addClass('closed');
                opened ? $bd.show() : $bd.hide();

                // 填充head默认内容
                $(getAccHdHtml(i + 1, title)).prependTo($hd);
            });

            if (this.showNav) {
                this._buildNav();
            } else {
                $fuiContent.removeClass('accordions-shownav');
                this.$accsWrap.removeClass('shownav');
                $('.fui-acc-return').remove();
                $('.fui-acc-menu').remove();
            }
        },
        _buildNav: function () {
            var $accs = this.$accsWrap.find('[role="accordion"]'),
                navHtml = [];
            var that = this;
            $.each($accs, function (i, acc) {
                var $acc = $(acc),
                    $hd = $acc.find('[role="head"]');

                var title = $hd.attr('title');

                var id;
                // 配置个性化的手风琴 且 没有配置showNav
                if (that.showNav) {
                    id = acc.id ? acc.id : (acc.id = 'accordion_' + i);

                    navHtml.push(getNavItemHtml(id, title));
                }
            });
            this.$accNav = $('.fui-acc-menu');
            var oldActiveIndex = 0;
            if (this.$accNav.length) {
                oldActiveIndex = this.$accNav.find('.acc-menu-item.active').index();
                this.$accNav.remove();
            }
            this.$accNav = $(getNavHtml(navHtml.join('')));
            this.$accNav.appendTo(document.body);
            // 返回顶部按钮
            $('.fui-acc-return').remove();
            this.$accReturn = $(
                '<div class="fui-acc-return" title="' + epoint_local.back_to_top_text + '" style="display:none;"></div>'
            ).appendTo(document.body);

            $fuiContent.addClass('accordions-shownav');
            this.$accsWrap.addClass('shownav');
            this.$accNav.find('.acc-menu-item').eq(oldActiveIndex).addClass('active');
            this._setNavPos();
            this._adjustNavDisplay();
        },
        _setNavPos: function () {
            if (!this.showNav) {
                return;
            }
            var scrollContainerWidth = $fuiContent.width(),
                accWrapWidth = this.$accsWrap.outerWidth();

            var right = (scrollContainerWidth - accWrapWidth) / 2;

            // 避免导航区域遮住滚动条
            if (right < 17) {
                right = 17;
            }

            this.$accNav.css('right', right);
            this.$accNav.css('top', this.$accsWrap[0].offsetTop);

            this.$accReturn.css('right', right);
        },
        _adjustNavDisplay: function () {
            if (!this.showNav) {
                return;
            }
            var len = this.$accsWrap.find('[role="accordion"]').filter(function (i, el) {
                return !$(el).hasClass('hidden');
            }).length;

            if (len > 2) {
                $fuiContent.addClass('accordions-shownav');
                this.$accsWrap.addClass('shownav');
                this.$accNav.removeClass('hidden');
                this.$accReturn.removeClass('hidden');
            } else {
                $fuiContent.removeClass('accordions-shownav');
                this.$accsWrap.removeClass('shownav');
                this.$accNav.addClass('hidden');
                this.$accReturn.addClass('hidden');
            }
        },
        _initEvent: function () {
            var that = this;
            this.$accsWrap
                .off('click.fui-accordion', '.fui-acc-toggle')
                .on('click.fui-accordion', '.fui-acc-toggle', function (e) {
                    var $el = $(this),
                        $acc = $el.closest('.fui-accordion'),
                        opened = $acc.hasClass('opened'),
                        ontoggle = $acc.attr('ontoggle');

                    $acc.toggleClass('closed', opened).toggleClass('opened', !opened);
                    $acc.find('>.fui-acc-bd').stop(true)[opened ? 'slideUp' : 'slideDown'](200);

                    if (ontoggle && win[ontoggle]) {
                        win[ontoggle](opened ? 'closed' : 'opened');
                    }
                    e.stopPropagation();
                });

            var timer;
            // 默认滚动区域为fui-content，滚动时激活对应导航item
            $fuiContent.off('scroll.fui-accordion').on('scroll.fui-accordion', function () {
                var ignore = ignoreScrollEvents;

                ignoreScrollEvents = false;
                // 判断是否阻止滚动事件
                if (ignore) return false;

                var $items = $('.fui-accordion:not(.hidden)'),
                    $navItems = $('.acc-menu-item:not(.hidden)');

                clearTimeout(timer);

                timer = setTimeout(function () {
                    $items.each(function (i, el) {
                        var top = $(el).offset().top;

                        if (top >= 0) {
                            $navItems.eq(i).addClass('active').siblings().removeClass('active');

                            return false;
                        }
                    });
                    var top = $items.eq(0).offset().top;
                    if (that.showNav) {
                        if (top <= -100) {
                            that.$accReturn.show();
                        } else {
                            that.$accReturn.hide();
                        }
                    }
                }, 200);
            });
            $(win)
                .off('resize.fui-accordion')
                .on('resize.fui-accordion', function () {
                    that._setNavPos();
                });

            if (this.showNav) {
                $('body')
                    .off('click.fui-accordion')
                    .on('click.fui-accordion', function (e) {
                        var $target = $(e.target),
                            ref = $target.data('ref');

                        var $scrollEl = $(Util.getFirstScrollEl(that.$accsWrap.find('.fui-accordion')[0]));

                        if ($target.closest(that.$accNav).length) {
                            if ($target.hasClass('acc-nav-trigger')) {
                                that.$accNav.toggleClass('active');
                            } else if ($target.hasClass('acc-menu-item')) {
                                if ($('#' + ref).hasClass('closed')) {
                                    $('#' + ref)
                                        .find('.fui-acc-toggle')
                                        .trigger('click');
                                }
                                scroll($target, $scrollEl);
                            }
                        } else {
                            that.$accNav.removeClass('active');
                        }

                        if ($target.hasClass('fui-acc-return')) {
                            scrollTopTo(0, $scrollEl);
                            $(that.$accNav)
                                .find('.acc-menu-item:eq(0)')
                                .addClass('active')
                                .siblings()
                                .removeClass('active');
                            $target[0].style.display = 'none';
                        }
                    });

                // 重写调整高度的方法，在高度调整时，需要同时调整导航的位置
                var _adjustHeight = win.adjustContentHeight;
                win.adjustContentHeight = function () {
                    _adjustHeight();
                    that._setNavPos();
                };
            }
        },
        _accTpl:
            '<div role="accordion" class="fui-accordion {{status}}"><div class="fui-acc-hd" role="head" title="{{title}}"><span class="fui-acc-order">{{order}}</span><i class="fui-acc-toggle"></i><h4 class="fui-acc-title">{{title}}</h4></div><div class="fui-acc-bd" role="body"><iframe frameborder="0" width="100%" height="{{contentHeight}}" src="{{url}}"></iframe></div></div>',
        // 显示手风琴项
        showItem: function (index) {
            var $acc = this._getAccItem(index);

            if ($acc.length && $acc.hasClass('hidden')) {
                $acc.removeClass('hidden');
                this._updateOrders();
            }

            if (this.showNav && $acc.length) {
                var $navItem = this._getAccNavs().eq($acc.index());

                if ($navItem.length && $navItem.hasClass('hidden')) {
                    $navItem.removeClass('hidden');
                }
                this._adjustNavDisplay();
                $fuiContent.trigger('scroll');
            }
        }, // 隐藏手风琴项
        hideItem: function (index) {
            var $acc = this._getAccItem(index);

            if ($acc.length && !$acc.hasClass('hidden')) {
                $acc.addClass('hidden');
                this._updateOrders();
            }
            if (this.showNav && $acc.length) {
                var $navItem = this._getAccNavs().eq($acc.index());

                if ($navItem.length && !$navItem.hasClass('hidden')) {
                    $navItem.addClass('hidden');
                }

                this._adjustNavDisplay();
                $fuiContent.trigger('scroll');
            }
        },
        hideNav: function () {
            if (this.showNav) {
                this.showNav = false;
                this.$accNav.addClass('hidden');
                this.$accReturn.addClass('hidden');
                this.$accsWrap.removeClass('shownav');
                $fuiContent.removeClass('accordions-shownav');
            }
        },

        // 展开手风琴
        expandItem: function (index) {
            var $acc = this._getAccItem(index);
            if ($acc.length && !$acc.hasClass('hidden')) {
                $acc.removeClass('closed').addClass('opened');
                $acc.find('>.fui-acc-bd').stop(true).slideDown(200);
            }
        },
        // 收起手风琴
        collapseItem: function (index) {
            var $acc = this._getAccItem(index);
            if ($acc.length && !$acc.hasClass('hidden')) {
                $acc.removeClass('opened').addClass('closed');
                $acc.find('>.fui-acc-bd').stop(true).slideUp(200);
            }
        },

        // 设置手风琴标题
        setTitle: function (title, index) {
            var $acc = this._getAccItem(index);
            if ($acc.length) {
                var $header = $acc.find('[role="head"]').attr('title', title);

                $header.find('.fui-acc-title').html(title);
            }

            if (this.showNav) {
                var $navItem = this._getAccNavs().eq($acc.index());

                if ($navItem.length) {
                    $navItem.html(title).attr('title', title);
                }
            }
        },

        // 动态添加手风琴项
        addItem: function (title, url, opened, contentHeight) {
            var html = Mustache.render(this._accTpl, {
                title: title,
                url: url,
                status: opened ? 'opened' : 'closed',
                contentHeight: contentHeight || '100%'
            });

            $(html).appendTo(this.$accsWrap).data('accordion', true);

            this._accs = this.$accsWrap.find('[role="accordion"]');

            this._updateOrders();

            if (this.showNav) {
                var index = this._accs.length - 1,
                    acc = this._accs[index],
                    id = acc.id ? acc.id : (acc.id = 'accordion_' + index);
                html = getNavItemHtml(id, title);

                $(html).appendTo(this.$accNav.find('.acc-menu-list'));

                this._accNavs = this.$accNav.find('.acc-menu-item');

                this._adjustNavDisplay();
            }
        },
        /**
         * 通过未解析的html新增手风琴项
         * @param {HTMLString} html html字符串如：
         * <div role="accordion" opened="false">
                <div role="head" title="手风琴标题2"></div>
                <div role="body"><div style="height:600px"></div></div>
            </div>
         * @param {number} index 插入到哪个位置 下标位置
         * @param {string} pos 'before' 或 'after'
         * @returns
         */
        addItemHtml: function (html, index, pos) {
            if (arguments.length === 0) return;

            var $item;
            if (arguments.length === 1) {
                $item = $(html).appendTo(this.$accsWrap);
            } else {
                if (pos === 'before') {
                    $item = $(html).insertBefore(this._getAccItem(index));
                } else {
                    $item = $(html).insertAfter(this._getAccItem(index));
                }
            }

            // 重新解析
            Accordion.parse(this.$accsWrap);
            // 更新序号
            Util.accordion._updateOrders();
            try {
                mini.parse($item[0]);
                $item = null;
            } catch (error) {}
        },
        /**
         * 自动显隐手风琴项
         * 1. 手风琴项中只有 fui-form ，且表单所有控件都隐藏时，
         *    隐藏手风琴项，否则显示手风琴项。
         * 2. 手风琴项为空时，自动隐藏。
         */
        autoToggleItemVisible: function () {
            var self = this;
            var $accs = this.$accsWrap.find('[role="accordion"]');
            $accs.each(function (index, acc) {
                var $acc = $(acc),
                    closed = $acc.is('.closed'),
                    $bd = $acc.find('[role="body"]');

                if ($bd.children().length === 0) {
                    self.hideItem(index);
                    return;
                } else {
                    self.showItem(index);
                    $bd.show();
                }

                if ($bd.children().not('.fui-form').length === 0) {
                    var $form = $bd.children('.fui-form'),
                        hasVisibleFormControl = false;
                    $form.find('.form-control').each(function (idx, el) {
                        if ($(el).is(':visible') && el.innerHTML.trim()) {
                            hasVisibleFormControl = true;
                            return false;
                        }
                    });

                    if (closed) {
                        $bd.hide();
                    }
                    if (!hasVisibleFormControl) {
                        self.hideItem(index);
                    }
                }
            });
        },
        // 显示|隐藏后需要更新下序号
        _updateOrders: function () {
            var order = 0;

            $.each(this._accs, function (i, acc) {
                var $acc = $(acc),
                    $order = $acc.find('.fui-acc-order');

                if (!$acc.hasClass('hidden')) {
                    $order.html(getOrder(++order));
                }
            });
        },

        _getAccNavs: function () {
            if (!this._accNavs) {
                this._accNavs = this.$accNav ? this.$accNav.find('.acc-menu-item') : undefined;
            }

            return this._accNavs;
        },
        _getAccItem: function (id) {
            if (typeof id === 'number') {
                return this._accs.eq(id);
            }

            return this._accs.filter(id);
        }
    });

    function getOrder(order) {
        if (order < 10) {
            order = '0' + order;
        }
        return order;
    }

    function getAccHdHtml(order, title) {
        var html = [];

        html.push('<span class="fui-acc-order">' + getOrder(order) + '</span>');
        html.push('<i class="fui-acc-toggle"></i>');
        html.push('<h4 class="fui-acc-title">' + title + '</h4>');

        return html.join('');
    }

    function getNavItemHtml(id, title) {
        return '<li class="acc-menu-item" data-ref="' + id + '" title="' + title + '">' + title + '</li>';
    }

    function getNavHtml(itemHtml) {
        var html = [];

        html.push('<div class="fui-acc-menu">');
        html.push('<ul class="acc-menu-list">');
        html.push(itemHtml);
        html.push('</ul>');
        html.push('</div>');

        return html.join('');
    }

    function scroll(el, $scrollEl) {
        var id = el.data('ref'),
            $accItem = $('#' + id);

        if ($scrollEl && $scrollEl.length) {
            // 解决滚动区域不具有定位属性时，计算offsetTop值不准确问题
            var _opos = $scrollEl[0].style.position;
            $scrollEl[0].style.position = 'relative';
            scrollTopTo($accItem[0].offsetTop, $scrollEl);
            $scrollEl[0].style.position = _opos;
        }

        el.addClass('active').siblings().removeClass('active');
    }

    var scrollTopTo = Util.browsers.isIE
        ? function (scrollTop, $scrollEl) {
              // 点击时应阻止滚动事件
              ignoreScrollEvents = true;
              $scrollEl.stop(true).animate(
                  {
                      scrollTop: scrollTop
                  },
                  500
              );
          }
        : function (scrollTop, $scrollEl) {
              // 点击时应阻止滚动事件
              ignoreScrollEvents = true;
              $scrollEl[0].scrollTop = scrollTop;
          };

    var $accsWrap = $('.fui-accordions');
    if ($accsWrap.length) {
        Util.accordion = new Accordion($accsWrap);
    } else {
        Util.accordion = {
            parse: Accordion.parse
        };
    }
})(this, jQuery);

// toolbar overflow 支持
(function(win, $) {
    function ToolbarOverflow(el) {
        this.$el = $(el);

        if (!this.$el.length || this.$el.children().length < 2) {
            return;
        }
        if (this.$el[0].getAttribute(this.ATTRIBUTE_PREFIX + 'init') === 'true') {
            var target = ToolbarOverflow.instances[this.$el[0].getAttribute(this.ATTRIBUTE_PREFIX + 'uid')];
            if (!target) {
                return;
            }
            target.update();
            return target;
        }

        this.eventNamespace = ToolbarOverflow.name + '-' + this.uid;
        this.$el[0].setAttribute(this.ATTRIBUTE_PREFIX + 'init', 'true');

        this.uid = Util.uuid();
        this.$el[0].setAttribute(this.ATTRIBUTE_PREFIX + 'uid', this.uid);
        ToolbarOverflow.instances[this.uid] = this;

        this.$el.css('position', 'relative');
        this.isOver = false;
        this.$extArea = $('<div class="toolbar-ext-area"></div>').appendTo(this.$el);
        if (this.$el.hasClass('fui-toolbar-bottom')) {
            this.$extArea.css('bottom', '100%');
        } else {
            this.$extArea.css({ top: '100%' });
        }
        this.limit_w = this.$el.width();

        // 记录 toolbar 中最后一个非右浮动的元素
        this.$lastNormalChild = null;
        // 记录 toolbar 中第一个右浮动的元素（排除忽略的）
        this.$firstRightChild = null;

        this._insertToggleBtn();
        this.calcLimited();

        this.initEvent();
        this.update();
    }
    // 记录所有实例
    ToolbarOverflow.instances = {};
    // 获取单个实例
    ToolbarOverflow.getInstance = function(el) {
        if (!el) return null;
        return ToolbarOverflow.instances[$(el).attr(ToolbarOverflow.prototype.ATTRIBUTE_PREFIX + 'uid')];
    };

    $.extend(ToolbarOverflow.prototype, {
        // 属性前缀
        ATTRIBUTE_PREFIX: 'overflow-',
        /**
         * 在移动时需要忽略掉的选择器
         * 帮助按钮、高级搜索展开按钮、高级搜索主要搜索框、toolbar溢出的触发按钮和额外区域
         */
        ignoreSelectors: ['.fui-toolbar-helper', '.fui-search-trigger', '.fui-primary-search', '.fui-toolbar-search', '.fui-toolbar-over-trigger', '.toolbar-ext-area'].join(','),

        /**
         * 更新状态
         *
         */
        update: function() {
            var inner_w = this.calcInnerWidth();
            // 如果按钮已经是展示的 则无需加上宽度 否则要加上 避免出现本来能显示下 显示按钮后恰好展示不下了
            var trigger_w = this.$trigger.is(':visible') ? 0 : this.$trigger.outerWidth(true);
            if (inner_w > this.limit_w) {
                this.isOver = true;
                this.$trigger.removeClass('hidden');
                this.moveToExtArea(inner_w + trigger_w);
            } else {
                this.restoreToToolbar(inner_w);
            }
            return this;
        },

        /**
         * 计算容器的限制宽度
         */
        calcLimited: function() {
            this.limit_w = this.$el.width();
        },
        initEvent: function() {
            var that = this;
            this.$trigger.on('click.' + this.eventNamespace, function() {
                that.toggle();
            });

            $(win).on(
                'resize.' + this.eventNamespace,
                Util.throttle(
                    function() {
                        that.calcLimited();
                        that.update();
                    },
                    Util.browsers.isIE ? 100 : 50
                )
            );
            $(win).on('mousedown.' + this.eventNamespace, function(ev) {
                var $target = $(ev.target);
                if ($target.closest(that.$trigger).length) {
                    return;
                }
                // 点击下拉面板时不应该隐藏
                if ($target.closest('.mini-popup').length) {
					return;
				}
                if (!$target.closest(that.$extArea).length) {
                    that.toggle(false);
                }
            });
        },
        /**
         * 执行观察者或脏检查
         * 外部可能修改内容导致宽度变化需进行处理
         * @returns {() => void} 停止观察或脏检查的函数
         */
        watchOrDirtyCheck: function () {
            var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
            var handle = Util.debounce(function () {
                this.calcLimited();
                this.update();
            }, 20, this);

            if (MutationObserver) {
                var observer = new MutationObserver(function() {
                    handle();
                    observer.takeRecords();
                });

                observer.observe(this.$el[0], {
                    childList: true,
                    attributes: true,
                    subtree: true
                });

                return function () {
                    observer.disconnect();
                };
            }
            // 不支持只能进行脏检查
            var timer;
            timer = setInterval(function() {
                handle();
            }, 100);
            return function () {
                clearInterval(timer);
            };
        },

        /**
         * 插入触发按钮
         *
         */
        _insertToggleBtn: function() {
            this.$trigger = $('<i></i>').addClass('fui-toolbar-over-trigger hidden r icon-rightdouble action-icon');
            if (this.$el.hasClass('fui-toolbar-bottom') && !this.$el.hasClass('left')) {
                this.$trigger.prependTo(this.$el);
            } else {
                //  顶部的 toolbar 和 左浮动的toolbar
                var $floatRight = this.$el.find('.r');
                if ($floatRight.length) {
                    $floatRight.eq(0).before(this.$trigger);
                } else {
                    this.$trigger.appendTo(this.$el);
                }
            }
        },

        /**
         * 切换额外区域的显示和隐藏 仅在溢出时生效
         *
         * @param {boolean | undefined} show 传递布尔值时 true 显示， false 隐藏； 不传值时切换状态
         * @returns
         */
        toggle: function(show) {
            if (!this.isOver) {
                return;
            }

            if (show === undefined) {
                this.$trigger.toggleClass('active');
                return this.$extArea.slideToggle(200, setZIndex);
            }
            if (show) {
                this.$trigger.addClass('active');
                this.$extArea.slideDown(200, setZIndex);
            } else {
                this.$trigger.removeClass('active');
                this.$extArea.slideUp(200);
            }
            function setZIndex() {
                var $this = $(this);
                if ($this.is(':visible')) {
                    $this.css('z-index', Util.getZIndex());
                    $(win).trigger('resize');
                }
            }
        },

        /**
         * 计算 toolbar 区域中的元素宽度 并做缓存
         *
         * @returns {number} 计算得出的宽度
         */
        calcInnerWidth: function() {
            var inner_w = 0;
            this.$el.children().each(function(i, el) {
                var $el = $(el);
                if ($el.hasClass('toolbar-ext-area')) {
                    // 扩展区域的 也需要更新一下
                    var ext_w = 0;
                    // 不可见需先调整为可见 计算完成再隐藏
                    var isVisible = $el.is(':visible');
                    if (!isVisible) {
                        $el.addClass('hidden-accessible').show();
                    }
                    $el.css('width', '10000px')
                        .children()
                        .each(function(j, item) {
                            var $item = $(item);
                            var w = $item.is(':hidden') ? 0 : $item.outerWidth(true);
                            $item.data('width', w);
                            ext_w += w;
                        });
                    if (!isVisible) {
                        $el.removeClass('hidden-accessible').hide();
                    }
                    $el.data('width', ext_w).css('width', ext_w + 2);
                    return;
                }
                var w = $el.is(':hidden') ? 0 : ($el.outerWidth(true) + 1); // 由于字体放大后，会产生小数的请求，导致最后计算出来的值偏小
                $el.data('width', w);
                inner_w += w;
            });
            return inner_w; 
        },

        /**
         * 获取 toolbar 中 视觉上的最后一个元素
         * 几个应固定在最右侧的已经排除在外 具体配置在 ignoreSelectors 中
         *
         * @returns
         */
        getToolbarLastChild: function() {
            var $floatRights = this.$el.find('> .r');

            var i = 0,
                len = 0;

            // 优先右浮动的 正序取出 即为最后的
            for (i = 0, len = $floatRights.length; i < len; i++) {
                var $currR = $floatRights.eq(i);
                // 在忽略列表中 则取下一个
                if ($currR.filter(this.ignoreSelectors).length || $currR.is(':hidden')) {
                    continue;
                } else {
                    return $currR;
                }
            }

            // 仍未返回则中最后开始取
            var $children = this.$el.children().filter(function(_, el) {
                var $el = $(el);
                return !$el.hasClass('r') && !$el.is(':hidden');
            });

            for (i = $children.length - 1; i > 0; i--) {
                var $currN = $children.eq(i);
                if ($currN.filter(this.ignoreSelectors).length) {
                    continue;
                } else {
                    return $currN;
                }
            }
        },

        /**
         * 宽度溢出 移动到额外区域
         *
         * @param {number} inner_w 当前 toolbar 中元素的宽度
         */
        moveToExtArea: function(inner_w) {
            if (!inner_w) {
                inner_w = this.calcInnerWidth();
            }
            // 移动导致新增的宽度
            var addedWidth = 0;
            // 记录当前元素的宽度
            var currWidth = 0;
            do {
                var $aim = this.getToolbarLastChild();
                if ($aim && $aim.length) {
                    if ($aim.hasClass('r')) {
                        this.$firstRightChild = $aim.next();
                    } else {
                        this.$lastNormalChild = $aim.prev();
                    }
                    currWidth = $aim.data('width');
                    addedWidth += currWidth;
                    inner_w -= currWidth;
                    $aim.prependTo(this.$extArea);
                } else {
                    this.$firstRightChild = this.$lastNormalChild = null;
                    break;
                }
            } while (inner_w > this.limit_w);

            if (addedWidth) {
                var w = (this.$extArea.data('width') || 0) + addedWidth;
                this.$extArea.css('width', w + 2).data('width', w);
            }
        },
        /**
         * 获取第一个可还原的元素
         *
         * @returns
         */
        getFirstExtraChild: function() {
            return this.$extArea.children(':eq(0)');
        },
        /**
         * 处理某个元素还原到正确的位置
         *
         * @param {jQuery Object} $targetChild 要处理元素
         * @returns
         */
        restoreToRightPos: function($targetChild) {
            // 右浮动的
            if ($targetChild.hasClass('r')) {
                if (this.$firstRightChild && this.$firstRightChild.length) {
                    this.$firstRightChild.before($targetChild);
                    this.$firstRightChild = $targetChild;
                } else {
                    $targetChild.appendTo(this.$targetChild);
                }
                return;
            }

            // 正常的直接插入到正常的最后一个的后面即可
            if (this.$lastNormalChild && this.$lastNormalChild.length) {
                this.$lastNormalChild.after($targetChild);
                // 更新记录
                this.$lastNormalChild = $targetChild;
            } else {
                $targetChild.appendTo(this.$el);
            }
        },
        /**
         * 判断当前元素是否可被还原
         *
         * @param {jQuery Object} $targetChild 要测试能否被还原的元素
         * @param {number} currInner_w 当前 toolbar 中所有元素的宽度
         * @returns
         */
        _restorable: function($targetChild, currInner_w) {
            if (!$targetChild.length) {
                return false;
            }
            return currInner_w + $targetChild.data('width') <= this.limit_w;
        },
        /**
         * 像 toolbar 中还原元素
         * @param {number} currInner_w 开始调整时的 toolbar 内部元素宽度
         * @param {boolean | undefined}  是否强制还原所有元素
         * @returns {undefined}
         * @memberof ToolbarOverflow
         */
        restoreToToolbar: function(currInner_w, force) {
            var $firstChild = this.getFirstExtraChild();

            while ((force && $firstChild.length) || this._restorable($firstChild, currInner_w)) {
                // 还原
                this.restoreToRightPos($firstChild);
                // 更新宽度
                var ext_w = (this.$extArea.data('width') || 0) - $firstChild.data('width');
                this.$extArea.data('width', ext_w);

                currInner_w += $firstChild.data('width');
                $firstChild = this.getFirstExtraChild();
            }

            this.$extArea.css('width', this.$extArea.data('width') + 2);
            // 是否全部还原完了
            if (force || !this.$extArea.children().length) {
                this.allRestore();
            }
        },
        /**
         * 全部还原后的统一调整
         * @returns {undefined}
         * @memberof ToolbarOverflow
         */
        allRestore: function() {
            this.isOver = false;
            this.$trigger
                .addClass('hidden')
                .data('width', 0)
                .removeClass('active');
            this.$extArea.hide();
        },
        /**
         * 实例销毁
         * @returns {undefined}
         * @memberof ToolbarOverflow
         */
        destroy: function() {
            this.$trigger.off('click');
            $(win).off('resize.' + this.eventNamespace);
            $(win).off('mousedown.' + this.eventNamespace);

            this.restoreToToolbar(null, true);

            this.$trigger.remove();
            this.$extArea.remove();
            this.$el[0].removeAttribute(this.ATTRIBUTE_PREFIX + 'uid');
            this.$el[0].removeAttribute(this.ATTRIBUTE_PREFIX + 'init');

            ToolbarOverflow.instances[this.uid] = null;
            delete ToolbarOverflow.instances[this.uid];

            for (var k in this) {
                if (Object.prototype.hasOwnProperty.call(this, k)) {
                    this[k] = null;
                    delete this[k];
                }
            }
        }
    });

    win.ToolbarOverflow = ToolbarOverflow;

    // auto init
    $(function() {
        $('.fui-toolbar:eq(0), .fui-toolbar-bottom:eq(0)').each(function(i, item) {
            // eslint-disable-next-line no-new
            new ToolbarOverflow(item);
        });
    });
})(this, jQuery);

/*
 * 不带标题的轻量化弹窗
 */
(function(win, $){
    var defaultConfig = {
        showModal: true,
        showCloseButton: true,
        width: 600,
        height: 400
    };
    var LightDialog = function(cfg){
        this.cfg = $.extend({},defaultConfig, cfg);

        this.__onDestroy = cfg.ondestroy;
        this.__onLoad = cfg.onload;

        this._init();
    };

    LightDialog.prototype = {
        constructor: LightDialog,

        _init: function(){
            this.$container = $('<div class="lightdialog hidden"><iframe width="100%" height="100%" frameborder="0"></iframe><i class="lightdialog-close hidden"></i></div>');
            this.$iframe = this.$container.children('iframe');

            this.$closeIcon = this.$container.children('.lightdialog-close');

            this.$iframe[0].src = Util.getRightUrl(this.cfg.url);

            var self = this;
            this.$iframe.on('load', function(){
                self._doLoadIframe();
            });

            if(this.cfg.showModal) {
                this.$modal = $('<div class="lightdialog-modal hidden"></div>').appendTo('body');
            }

            if(this.cfg.showCloseButton) {
                this.$closeIcon.removeClass('hidden');
                this.$closeIcon.on('click', function(){
                    var ret = true;
                    try {
                        if (self.__onDestroy) ret = self.__onDestroy('close');
                    } catch (ex) {
                        console.error(ex);
                     }

                    if (ret === false) {
                        return false;
                    }
                    self.close();
                });
            }

            this.$container.appendTo('body');
        },

        _doLoadIframe: function() {
            var self = this;
            function CloseOwnerWindow(action) {
                var ret = true;
                try {
                    if (self.__onDestroy) ret = self.__onDestroy(action);
                } catch (ex) { 
                    console.error(ex);
                }

                if (ret === false) {
                    return false;
                }

                setTimeout(function () {
                    self.close();
                }, 10);
            }

            try {

                this.$iframe[0].contentWindow.Owner = win;
                this.$iframe[0].contentWindow.CloseOwnerWindow = CloseOwnerWindow;
            } catch (e) { }

            if(this.__onLoad) {
                this.__onLoad();
            }
        },

        _doRemoveIFrame: function() {
            if(this.$iframe) {
                if (this.__onDestroy) this.__onDestroy('close');
                Util.clearIframe(this.$iframe);

                this.$iframe = null;
            }
        },

        show: function() {
            var winBox = Util.getWinSize(),
                width = parseInt(this.cfg.width, 10),
                height = parseInt(this.cfg.height),
                left = (winBox.width - width) / 2,
                top = (winBox.height - height) / 2;

            if(this.cfg.showModal) {
                this.$modal.css('z-index', Util.getZIndex()).removeClass('hidden');
            }

            this.$container.css({
                left: left,
                top: top,
                width: width,
                height: height,
                zIndex: Util.getZIndex()
            }).removeClass('hidden');
        },

        close: function(){
            this._doRemoveIFrame();

            this.$container.remove();
            this.$modal && this.$modal.remove();
        },

        getIFrameEl: function() {
            return this.$iframe ? this.$iframe[0] : undefined;
        }
    };

    var topWin;
    function getTopWin(me) {
        try {
            if (me.Util && me.Util.openLightDialog) topWin = me;
            if (me.parent && me.parent != me) {
                getTopWin(me.parent);
            }
        } catch (ex) { }
    }

    $.extend(Util, {
        openLightDialog: function(cfg) {
            var dialog = new LightDialog(cfg);
    
            dialog.show();
    
            return dialog;
        },
        openTopLightDialog: function(cfg) {
            topWin || getTopWin(win);
            return topWin.Util.openLightDialog(cfg);
        }
    });
    
})(this, jQuery);
/*!
 * 通过body master属性动态载入导航模板资源
 */
(function(win, $) {
    // var MASTER_NAMES = ['leftAccNav', 'leftAccTree', 'topWizard', 'leftWizard', 'topTabNav'];

    var $content = $('body > .master-content'),
        master = $content.attr('master'),
        srcdir = $content.attr('srcdir'); // 获取个性化的目录路径

    // 获取路径前半部分，如：fui/js/navpages/name/name
    var getPathPrefix = function(name) {
        var path = 'frame/fui/js/widgets/navpages'; // 默认路径
        if (srcdir) {
            path = srcdir; // 个性化路径
        }
        return path + '/' + name + '/' + name;
    };

    // 初始化模板结构和资源
    var initMaster = function(name) {
        var prefix = getPathPrefix(name);

        $.ajax(Util.getRightUrl(prefix + '_snippet.html')).done(function(tplHtml) {
            $content.replaceWith(tplHtml);
            if ($.inArray(name, ['leftAccNav', 'leftAccTree']) != -1) {
                Util.layoutInstance.parse();
            }

            Util.loadCss(prefix + '.css');
            Util.loadJs(prefix + '.js');
        });
    };

    $(function() {
        $content.length && initMaster(master);
    });
})(this, jQuery);

/**
 * btn group 中按钮显隐变化后的适配
 */
(function(win, $) {
    var observer;
    function markGroupBtn($group) {
        var $visibleBtns = $group.children().filter(function(i, btn) {
            var $btn = $(btn);
            return /(?:mini-button|mini-webuploader)/.test(btn.className) && $btn.is(':visible');
        });

        var lastIndex = $visibleBtns.length - 1;
        $visibleBtns.each(function(i, btn) {
            $(btn).removeClass('mini-btn-group-first mini-btn-group-last');
            // 修改属性会再次触发变化 手动清空待处理队列
            observer && observer.takeRecords();
            if (i === 0) {
                $(btn).addClass('mini-btn-group-first');
                observer && observer.takeRecords();
            }
            if (i === lastIndex) {
                $(btn).addClass('mini-btn-group-last');
                observer && observer.takeRecords();
            }
        });
    }

    /**
     * 适配 mini-btn-group 中的按钮样式
     *
     * @param {undefined|string|jQueryObject|HTMLElement} $targetGroup 要适配的 btngroup 省略时处理页面全部
     */
    function adaptButtonGroup($targetGroup) {
        var $btnGroup = $targetGroup
            ? $($targetGroup)
            : $('.fui-toolbar .mini-btn-group, .fui-toolbar-bottom .mini-btn-group');
        $btnGroup.each(function(i, group) {
            markGroupBtn($(group));
        });
    }
    Util.adaptButtonGroup = adaptButtonGroup;

    $(win).on('load', function() {
        adaptButtonGroup();
        // 如果支持 MutationObserver 则自动观察并适配
        win.MutationObserver && initObserver();
    });

    function initObserver() {
        observer = new MutationObserver(function(mutationsList) {
            mutationsList.forEach(function(mutation) {
                var type = mutation.type;
                switch (type) {
                    case 'childList':
                        handleAddOrRemove(mutation);
                        break;
                    case 'attributes':
                        handleAttributesChange(mutation);
                        break;
                    default:
                        break;
                }
            });
        });

        function handleAddOrRemove(/** @type MutationRecord */ mutation) {
            var $target = $(mutation.target);
            if ($target.hasClass('mini-btn-group')) {
                markGroupBtn($target);
            }
        }

        function handleAttributesChange(/** @type MutationRecord */ mutation) {
            if (mutation.attributeName === 'style' || mutation.attributeName === 'class') {
                markGroupBtn($(mutation.target).closest('.mini-btn-group'));
            }
        }

        $('.fui-toolbar .mini-btn-group, .fui-toolbar-bottom .mini-btn-group').each(function(i, el) {
            observer.observe(el, {
                childList: true,
                attributes: true,
                attributeOldValue: true,
                characterData: false,
                subtree: true
            });
        });
        $(win).on('beforeunload', function() {
            observer.disconnect();
        });
    }
})(this, this.jQuery);

})();